(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d52"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d52"] = parcelRequire;
}
parcelRequire.register("iy00I", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d80b691031b700a6$export$ffb0004e005737fa; }, function (v) { return $d80b691031b700a6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d80b691031b700a6$export$34b9dba7ce09269b; }, function (v) { return $d80b691031b700a6$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d80b691031b700a6$export$25062201e9e25d76; }, function (v) { return $d80b691031b700a6$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d80b691031b700a6$export$ffb0004e005737fa;
var $d80b691031b700a6$export$34b9dba7ce09269b;
var $d80b691031b700a6$export$25062201e9e25d76;
"use strict";

var $kVN77 = parcelRequire("kVN77");
var $d80b691031b700a6$var$k = Symbol.for("react.element"), $d80b691031b700a6$var$l = Symbol.for("react.fragment"), $d80b691031b700a6$var$m = Object.prototype.hasOwnProperty, $d80b691031b700a6$var$n = $kVN77.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d80b691031b700a6$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d80b691031b700a6$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d80b691031b700a6$var$m.call(a, b) && !$d80b691031b700a6$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d80b691031b700a6$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d80b691031b700a6$var$n.current
    };
}
$d80b691031b700a6$export$ffb0004e005737fa = $d80b691031b700a6$var$l;
$d80b691031b700a6$export$34b9dba7ce09269b = $d80b691031b700a6$var$q;
$d80b691031b700a6$export$25062201e9e25d76 = $d80b691031b700a6$var$q;

});
parcelRequire.register("kVN77", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8cIbz"));

});
parcelRequire.register("8cIbz", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $5f91b812a4788ed8$export$dca3b0875bd9a954; }, function (v) { return $5f91b812a4788ed8$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $5f91b812a4788ed8$export$16fa2f45be04daa8; }, function (v) { return $5f91b812a4788ed8$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5f91b812a4788ed8$export$ffb0004e005737fa; }, function (v) { return $5f91b812a4788ed8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $5f91b812a4788ed8$export$e2c29f18771995cb; }, function (v) { return $5f91b812a4788ed8$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $5f91b812a4788ed8$export$221d75b3f55bb0bd; }, function (v) { return $5f91b812a4788ed8$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5f91b812a4788ed8$export$5f8d39834fd61797; }, function (v) { return $5f91b812a4788ed8$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5f91b812a4788ed8$export$74bf444e3cd11ea5; }, function (v) { return $5f91b812a4788ed8$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5f91b812a4788ed8$export$ae55be85d98224ed; }, function (v) { return $5f91b812a4788ed8$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $5f91b812a4788ed8$export$e530037191fcd5d7; }, function (v) { return $5f91b812a4788ed8$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $5f91b812a4788ed8$export$fd42f52fd3ae1109; }, function (v) { return $5f91b812a4788ed8$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $5f91b812a4788ed8$export$c8a8987d4410bf2d; }, function (v) { return $5f91b812a4788ed8$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $5f91b812a4788ed8$export$d38cd72104c1f0e9; }, function (v) { return $5f91b812a4788ed8$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $5f91b812a4788ed8$export$7d1e3a5e95ceca43; }, function (v) { return $5f91b812a4788ed8$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $5f91b812a4788ed8$export$257a8862b851cb5b; }, function (v) { return $5f91b812a4788ed8$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $5f91b812a4788ed8$export$a8257692ac88316c; }, function (v) { return $5f91b812a4788ed8$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $5f91b812a4788ed8$export$488013bae63b21da; }, function (v) { return $5f91b812a4788ed8$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $5f91b812a4788ed8$export$7c73462e0d25e514; }, function (v) { return $5f91b812a4788ed8$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $5f91b812a4788ed8$export$7568632d0d33d16d; }, function (v) { return $5f91b812a4788ed8$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $5f91b812a4788ed8$export$88948ce120ea2619; }, function (v) { return $5f91b812a4788ed8$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $5f91b812a4788ed8$export$35808ee640e87ca7; }, function (v) { return $5f91b812a4788ed8$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $5f91b812a4788ed8$export$fae74005e78b1a27; }, function (v) { return $5f91b812a4788ed8$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $5f91b812a4788ed8$export$dc8fbce3eb94dc1e; }, function (v) { return $5f91b812a4788ed8$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $5f91b812a4788ed8$export$6a7bc4e911dc01cf; }, function (v) { return $5f91b812a4788ed8$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $5f91b812a4788ed8$export$6d9c69b0de29b591; }, function (v) { return $5f91b812a4788ed8$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $5f91b812a4788ed8$export$f680877a34711e37; }, function (v) { return $5f91b812a4788ed8$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $5f91b812a4788ed8$export$d5a552a76deda3c2; }, function (v) { return $5f91b812a4788ed8$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $5f91b812a4788ed8$export$aaabe4eda9ed9969; }, function (v) { return $5f91b812a4788ed8$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $5f91b812a4788ed8$export$e5c5a5f917a5871c; }, function (v) { return $5f91b812a4788ed8$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $5f91b812a4788ed8$export$1538c33de8887b59; }, function (v) { return $5f91b812a4788ed8$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $5f91b812a4788ed8$export$13e3392192263954; }, function (v) { return $5f91b812a4788ed8$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $5f91b812a4788ed8$export$b8f5890fc79d6aca; }, function (v) { return $5f91b812a4788ed8$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $5f91b812a4788ed8$export$60241385465d0a34; }, function (v) { return $5f91b812a4788ed8$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $5f91b812a4788ed8$export$306c0aa65ff9ec16; }, function (v) { return $5f91b812a4788ed8$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $5f91b812a4788ed8$export$7b286972b8d8ccbf; }, function (v) { return $5f91b812a4788ed8$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $5f91b812a4788ed8$export$83d89fbfd8236492; }, function (v) { return $5f91b812a4788ed8$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $3L4GM = parcelRequire("3L4GM");
var $5f91b812a4788ed8$export$dca3b0875bd9a954;
var $5f91b812a4788ed8$export$16fa2f45be04daa8;
var $5f91b812a4788ed8$export$ffb0004e005737fa;
var $5f91b812a4788ed8$export$e2c29f18771995cb;
var $5f91b812a4788ed8$export$221d75b3f55bb0bd;
var $5f91b812a4788ed8$export$5f8d39834fd61797;
var $5f91b812a4788ed8$export$74bf444e3cd11ea5;
var $5f91b812a4788ed8$export$ae55be85d98224ed;
var $5f91b812a4788ed8$export$e530037191fcd5d7;
var $5f91b812a4788ed8$export$fd42f52fd3ae1109;
var $5f91b812a4788ed8$export$c8a8987d4410bf2d;
var $5f91b812a4788ed8$export$d38cd72104c1f0e9;
var $5f91b812a4788ed8$export$7d1e3a5e95ceca43;
var $5f91b812a4788ed8$export$257a8862b851cb5b;
var $5f91b812a4788ed8$export$a8257692ac88316c;
var $5f91b812a4788ed8$export$488013bae63b21da;
var $5f91b812a4788ed8$export$7c73462e0d25e514;
var $5f91b812a4788ed8$export$7568632d0d33d16d;
var $5f91b812a4788ed8$export$88948ce120ea2619;
var $5f91b812a4788ed8$export$35808ee640e87ca7;
var $5f91b812a4788ed8$export$fae74005e78b1a27;
var $5f91b812a4788ed8$export$dc8fbce3eb94dc1e;
var $5f91b812a4788ed8$export$6a7bc4e911dc01cf;
var $5f91b812a4788ed8$export$6d9c69b0de29b591;
var $5f91b812a4788ed8$export$f680877a34711e37;
var $5f91b812a4788ed8$export$d5a552a76deda3c2;
var $5f91b812a4788ed8$export$aaabe4eda9ed9969;
var $5f91b812a4788ed8$export$e5c5a5f917a5871c;
var $5f91b812a4788ed8$export$1538c33de8887b59;
var $5f91b812a4788ed8$export$13e3392192263954;
var $5f91b812a4788ed8$export$b8f5890fc79d6aca;
var $5f91b812a4788ed8$export$60241385465d0a34;
var $5f91b812a4788ed8$export$306c0aa65ff9ec16;
var $5f91b812a4788ed8$export$7b286972b8d8ccbf;
var $5f91b812a4788ed8$export$83d89fbfd8236492;
"use strict";
var $5f91b812a4788ed8$var$l = Symbol.for("react.element"), $5f91b812a4788ed8$var$n = Symbol.for("react.portal"), $5f91b812a4788ed8$var$p = Symbol.for("react.fragment"), $5f91b812a4788ed8$var$q = Symbol.for("react.strict_mode"), $5f91b812a4788ed8$var$r = Symbol.for("react.profiler"), $5f91b812a4788ed8$var$t = Symbol.for("react.provider"), $5f91b812a4788ed8$var$u = Symbol.for("react.context"), $5f91b812a4788ed8$var$v = Symbol.for("react.forward_ref"), $5f91b812a4788ed8$var$w = Symbol.for("react.suspense"), $5f91b812a4788ed8$var$x = Symbol.for("react.memo"), $5f91b812a4788ed8$var$y = Symbol.for("react.lazy"), $5f91b812a4788ed8$var$z = Symbol.iterator;
function $5f91b812a4788ed8$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5f91b812a4788ed8$var$z && a[$5f91b812a4788ed8$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5f91b812a4788ed8$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $5f91b812a4788ed8$var$C = Object.assign, $5f91b812a4788ed8$var$D = {};
function $5f91b812a4788ed8$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5f91b812a4788ed8$var$D;
    this.updater = e || $5f91b812a4788ed8$var$B;
}
$5f91b812a4788ed8$var$E.prototype.isReactComponent = {};
$5f91b812a4788ed8$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$5f91b812a4788ed8$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $5f91b812a4788ed8$var$F() {}
$5f91b812a4788ed8$var$F.prototype = $5f91b812a4788ed8$var$E.prototype;
function $5f91b812a4788ed8$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5f91b812a4788ed8$var$D;
    this.updater = e || $5f91b812a4788ed8$var$B;
}
var $5f91b812a4788ed8$var$H = $5f91b812a4788ed8$var$G.prototype = new $5f91b812a4788ed8$var$F;
$5f91b812a4788ed8$var$H.constructor = $5f91b812a4788ed8$var$G;
$5f91b812a4788ed8$var$C($5f91b812a4788ed8$var$H, $5f91b812a4788ed8$var$E.prototype);
$5f91b812a4788ed8$var$H.isPureReactComponent = !0;
var $5f91b812a4788ed8$var$I = Array.isArray, $5f91b812a4788ed8$var$J = Object.prototype.hasOwnProperty, $5f91b812a4788ed8$var$K = {
    current: null
}, $5f91b812a4788ed8$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5f91b812a4788ed8$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$5f91b812a4788ed8$var$J.call(b, d) && !$5f91b812a4788ed8$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $5f91b812a4788ed8$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $5f91b812a4788ed8$var$K.current
    };
}
function $5f91b812a4788ed8$var$N(a, b) {
    return {
        $$typeof: $5f91b812a4788ed8$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $5f91b812a4788ed8$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5f91b812a4788ed8$var$l;
}
function $5f91b812a4788ed8$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $5f91b812a4788ed8$var$P = /\/+/g;
function $5f91b812a4788ed8$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $5f91b812a4788ed8$var$escape("" + a.key) : b.toString(36);
}
function $5f91b812a4788ed8$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $3L4GM._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $5f91b812a4788ed8$var$l:
                case $5f91b812a4788ed8$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $5f91b812a4788ed8$var$Q(h, 0) : d, $5f91b812a4788ed8$var$I(c) ? (e = "", null != a && (e = a.replace($5f91b812a4788ed8$var$P, "$&/") + "/"), $5f91b812a4788ed8$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($5f91b812a4788ed8$var$O(c) && (c = $5f91b812a4788ed8$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($5f91b812a4788ed8$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($5f91b812a4788ed8$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $5f91b812a4788ed8$var$Q(k, g);
        h += $5f91b812a4788ed8$var$R(k, b, e, f, c);
    }
    else if (f = $5f91b812a4788ed8$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $5f91b812a4788ed8$var$Q(k, g++), h += $5f91b812a4788ed8$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $5f91b812a4788ed8$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $5f91b812a4788ed8$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $5f91b812a4788ed8$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $5f91b812a4788ed8$var$U = {
    current: null
}, $5f91b812a4788ed8$var$V = {
    transition: null
}, $5f91b812a4788ed8$var$W = {
    ReactCurrentDispatcher: $5f91b812a4788ed8$var$U,
    ReactCurrentBatchConfig: $5f91b812a4788ed8$var$V,
    ReactCurrentOwner: $5f91b812a4788ed8$var$K
};
$5f91b812a4788ed8$export$dca3b0875bd9a954 = {
    map: $5f91b812a4788ed8$var$S,
    forEach: function forEach(a, b, e) {
        $5f91b812a4788ed8$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $5f91b812a4788ed8$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $5f91b812a4788ed8$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$5f91b812a4788ed8$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$5f91b812a4788ed8$export$16fa2f45be04daa8 = $5f91b812a4788ed8$var$E;
$5f91b812a4788ed8$export$ffb0004e005737fa = $5f91b812a4788ed8$var$p;
$5f91b812a4788ed8$export$e2c29f18771995cb = $5f91b812a4788ed8$var$r;
$5f91b812a4788ed8$export$221d75b3f55bb0bd = $5f91b812a4788ed8$var$G;
$5f91b812a4788ed8$export$5f8d39834fd61797 = $5f91b812a4788ed8$var$q;
$5f91b812a4788ed8$export$74bf444e3cd11ea5 = $5f91b812a4788ed8$var$w;
$5f91b812a4788ed8$export$ae55be85d98224ed = $5f91b812a4788ed8$var$W;
$5f91b812a4788ed8$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $5f91b812a4788ed8$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $5f91b812a4788ed8$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$5f91b812a4788ed8$var$J.call(b, f) && !$5f91b812a4788ed8$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $5f91b812a4788ed8$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$5f91b812a4788ed8$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $5f91b812a4788ed8$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $5f91b812a4788ed8$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$5f91b812a4788ed8$export$c8a8987d4410bf2d = $5f91b812a4788ed8$var$M;
$5f91b812a4788ed8$export$d38cd72104c1f0e9 = function(a) {
    var b = $5f91b812a4788ed8$var$M.bind(null, a);
    b.type = a;
    return b;
};
$5f91b812a4788ed8$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5f91b812a4788ed8$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $5f91b812a4788ed8$var$v,
        render: a
    };
};
$5f91b812a4788ed8$export$a8257692ac88316c = $5f91b812a4788ed8$var$O;
$5f91b812a4788ed8$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $5f91b812a4788ed8$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $5f91b812a4788ed8$var$T
    };
};
$5f91b812a4788ed8$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $5f91b812a4788ed8$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$5f91b812a4788ed8$export$7568632d0d33d16d = function(a) {
    var b = $5f91b812a4788ed8$var$V.transition;
    $5f91b812a4788ed8$var$V.transition = {};
    try {
        a();
    } finally{
        $5f91b812a4788ed8$var$V.transition = b;
    }
};
$5f91b812a4788ed8$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$5f91b812a4788ed8$export$35808ee640e87ca7 = function(a, b) {
    return $5f91b812a4788ed8$var$U.current.useCallback(a, b);
};
$5f91b812a4788ed8$export$fae74005e78b1a27 = function(a) {
    return $5f91b812a4788ed8$var$U.current.useContext(a);
};
$5f91b812a4788ed8$export$dc8fbce3eb94dc1e = function() {};
$5f91b812a4788ed8$export$6a7bc4e911dc01cf = function(a) {
    return $5f91b812a4788ed8$var$U.current.useDeferredValue(a);
};
$5f91b812a4788ed8$export$6d9c69b0de29b591 = function(a, b) {
    return $5f91b812a4788ed8$var$U.current.useEffect(a, b);
};
$5f91b812a4788ed8$export$f680877a34711e37 = function() {
    return $5f91b812a4788ed8$var$U.current.useId();
};
$5f91b812a4788ed8$export$d5a552a76deda3c2 = function(a, b, e) {
    return $5f91b812a4788ed8$var$U.current.useImperativeHandle(a, b, e);
};
$5f91b812a4788ed8$export$aaabe4eda9ed9969 = function(a, b) {
    return $5f91b812a4788ed8$var$U.current.useInsertionEffect(a, b);
};
$5f91b812a4788ed8$export$e5c5a5f917a5871c = function(a, b) {
    return $5f91b812a4788ed8$var$U.current.useLayoutEffect(a, b);
};
$5f91b812a4788ed8$export$1538c33de8887b59 = function(a, b) {
    return $5f91b812a4788ed8$var$U.current.useMemo(a, b);
};
$5f91b812a4788ed8$export$13e3392192263954 = function(a, b, e) {
    return $5f91b812a4788ed8$var$U.current.useReducer(a, b, e);
};
$5f91b812a4788ed8$export$b8f5890fc79d6aca = function(a) {
    return $5f91b812a4788ed8$var$U.current.useRef(a);
};
$5f91b812a4788ed8$export$60241385465d0a34 = function(a) {
    return $5f91b812a4788ed8$var$U.current.useState(a);
};
$5f91b812a4788ed8$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $5f91b812a4788ed8$var$U.current.useSyncExternalStore(a, b, e);
};
$5f91b812a4788ed8$export$7b286972b8d8ccbf = function() {
    return $5f91b812a4788ed8$var$U.current.useTransition();
};
$5f91b812a4788ed8$export$83d89fbfd8236492 = "18.2.0";

});
parcelRequire.register("3L4GM", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $2bc9660046d127cb$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $2bc9660046d127cb$export$5f0017c582d45a2d; });
function $2bc9660046d127cb$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRequire.register("7J8D6", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5a036e0bbbddc7fb$export$ae55be85d98224ed; }, function (v) { return $5a036e0bbbddc7fb$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $5a036e0bbbddc7fb$export$d39a5bbd09211389; }, function (v) { return $5a036e0bbbddc7fb$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $5a036e0bbbddc7fb$export$882461b6382ed46c; }, function (v) { return $5a036e0bbbddc7fb$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $5a036e0bbbddc7fb$export$466bfc07425424d5; }, function (v) { return $5a036e0bbbddc7fb$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $5a036e0bbbddc7fb$export$cd75ccfd720a3cd4; }, function (v) { return $5a036e0bbbddc7fb$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $5a036e0bbbddc7fb$export$fa8d919ba61d84db; }, function (v) { return $5a036e0bbbddc7fb$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $5a036e0bbbddc7fb$export$757ceba2d55c277e; }, function (v) { return $5a036e0bbbddc7fb$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $5a036e0bbbddc7fb$export$b3890eb0ae9dca99; }, function (v) { return $5a036e0bbbddc7fb$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $5a036e0bbbddc7fb$export$502457920280e6be; }, function (v) { return $5a036e0bbbddc7fb$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $5a036e0bbbddc7fb$export$c78a37762a8d58e1; }, function (v) { return $5a036e0bbbddc7fb$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $5a036e0bbbddc7fb$export$dc54d992c10e8a18; }, function (v) { return $5a036e0bbbddc7fb$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $5a036e0bbbddc7fb$export$83d89fbfd8236492; }, function (v) { return $5a036e0bbbddc7fb$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $3L4GM = parcelRequire("3L4GM");
var $5a036e0bbbddc7fb$export$ae55be85d98224ed;
var $5a036e0bbbddc7fb$export$d39a5bbd09211389;
var $5a036e0bbbddc7fb$export$882461b6382ed46c;
var $5a036e0bbbddc7fb$export$466bfc07425424d5;
var $5a036e0bbbddc7fb$export$cd75ccfd720a3cd4;
var $5a036e0bbbddc7fb$export$fa8d919ba61d84db;
var $5a036e0bbbddc7fb$export$757ceba2d55c277e;
var $5a036e0bbbddc7fb$export$b3890eb0ae9dca99;
var $5a036e0bbbddc7fb$export$502457920280e6be;
var $5a036e0bbbddc7fb$export$c78a37762a8d58e1;
var $5a036e0bbbddc7fb$export$dc54d992c10e8a18;
var $5a036e0bbbddc7fb$export$83d89fbfd8236492;
"use strict";

var $kVN77 = parcelRequire("kVN77");

var $3GiGQ = parcelRequire("3GiGQ");
function $5a036e0bbbddc7fb$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $5a036e0bbbddc7fb$var$da = new Set, $5a036e0bbbddc7fb$var$ea = {};
function $5a036e0bbbddc7fb$var$fa(a, b) {
    $5a036e0bbbddc7fb$var$ha(a, b);
    $5a036e0bbbddc7fb$var$ha(a + "Capture", b);
}
function $5a036e0bbbddc7fb$var$ha(a, b) {
    $5a036e0bbbddc7fb$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$5a036e0bbbddc7fb$var$da.add(b[a]);
}
var $5a036e0bbbddc7fb$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $5a036e0bbbddc7fb$var$ja = Object.prototype.hasOwnProperty, $5a036e0bbbddc7fb$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $5a036e0bbbddc7fb$var$la = {}, $5a036e0bbbddc7fb$var$ma = {};
function $5a036e0bbbddc7fb$var$oa(a) {
    if ($5a036e0bbbddc7fb$var$ja.call($5a036e0bbbddc7fb$var$ma, a)) return !0;
    if ($5a036e0bbbddc7fb$var$ja.call($5a036e0bbbddc7fb$var$la, a)) return !1;
    if ($5a036e0bbbddc7fb$var$ka.test(a)) return $5a036e0bbbddc7fb$var$ma[a] = !0;
    $5a036e0bbbddc7fb$var$la[a] = !0;
    return !1;
}
function $5a036e0bbbddc7fb$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $3L4GM._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $5a036e0bbbddc7fb$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $5a036e0bbbddc7fb$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $5a036e0bbbddc7fb$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $5a036e0bbbddc7fb$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $5a036e0bbbddc7fb$var$z[b] = new $5a036e0bbbddc7fb$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $5a036e0bbbddc7fb$var$ra = /[\-:]([a-z])/g;
function $5a036e0bbbddc7fb$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($5a036e0bbbddc7fb$var$ra, $5a036e0bbbddc7fb$var$sa);
    $5a036e0bbbddc7fb$var$z[b] = new $5a036e0bbbddc7fb$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($5a036e0bbbddc7fb$var$ra, $5a036e0bbbddc7fb$var$sa);
    $5a036e0bbbddc7fb$var$z[b] = new $5a036e0bbbddc7fb$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($5a036e0bbbddc7fb$var$ra, $5a036e0bbbddc7fb$var$sa);
    $5a036e0bbbddc7fb$var$z[b] = new $5a036e0bbbddc7fb$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$5a036e0bbbddc7fb$var$z.xlinkHref = new $5a036e0bbbddc7fb$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $5a036e0bbbddc7fb$var$z[a] = new $5a036e0bbbddc7fb$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $5a036e0bbbddc7fb$var$ta(a, b, c, d) {
    var e = $5a036e0bbbddc7fb$var$z.hasOwnProperty(b) ? $5a036e0bbbddc7fb$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $5a036e0bbbddc7fb$var$qa(b, c, e, d) && (c = null), d || null === e ? $5a036e0bbbddc7fb$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $5a036e0bbbddc7fb$var$ua = $kVN77.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $5a036e0bbbddc7fb$var$va = Symbol.for("react.element"), $5a036e0bbbddc7fb$var$wa = Symbol.for("react.portal"), $5a036e0bbbddc7fb$var$ya = Symbol.for("react.fragment"), $5a036e0bbbddc7fb$var$za = Symbol.for("react.strict_mode"), $5a036e0bbbddc7fb$var$Aa = Symbol.for("react.profiler"), $5a036e0bbbddc7fb$var$Ba = Symbol.for("react.provider"), $5a036e0bbbddc7fb$var$Ca = Symbol.for("react.context"), $5a036e0bbbddc7fb$var$Da = Symbol.for("react.forward_ref"), $5a036e0bbbddc7fb$var$Ea = Symbol.for("react.suspense"), $5a036e0bbbddc7fb$var$Fa = Symbol.for("react.suspense_list"), $5a036e0bbbddc7fb$var$Ga = Symbol.for("react.memo"), $5a036e0bbbddc7fb$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $5a036e0bbbddc7fb$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $5a036e0bbbddc7fb$var$Ja = Symbol.iterator;
function $5a036e0bbbddc7fb$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5a036e0bbbddc7fb$var$Ja && a[$5a036e0bbbddc7fb$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5a036e0bbbddc7fb$var$A = Object.assign, $5a036e0bbbddc7fb$var$La;
function $5a036e0bbbddc7fb$var$Ma(a) {
    if (void 0 === $5a036e0bbbddc7fb$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $5a036e0bbbddc7fb$var$La = b && b[1] || "";
    }
    return "\n" + $5a036e0bbbddc7fb$var$La + a;
}
var $5a036e0bbbddc7fb$var$Na = !1;
function $5a036e0bbbddc7fb$var$Oa(a, b) {
    if (!a || $5a036e0bbbddc7fb$var$Na) return "";
    $5a036e0bbbddc7fb$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $5a036e0bbbddc7fb$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $5a036e0bbbddc7fb$var$Ma(a) : "";
}
function $5a036e0bbbddc7fb$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $5a036e0bbbddc7fb$var$Ma(a.type);
        case 16:
            return $5a036e0bbbddc7fb$var$Ma("Lazy");
        case 13:
            return $5a036e0bbbddc7fb$var$Ma("Suspense");
        case 19:
            return $5a036e0bbbddc7fb$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $5a036e0bbbddc7fb$var$Oa(a.type, !1), a;
        case 11:
            return a = $5a036e0bbbddc7fb$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $5a036e0bbbddc7fb$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $5a036e0bbbddc7fb$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $5a036e0bbbddc7fb$var$ya:
            return "Fragment";
        case $5a036e0bbbddc7fb$var$wa:
            return "Portal";
        case $5a036e0bbbddc7fb$var$Aa:
            return "Profiler";
        case $5a036e0bbbddc7fb$var$za:
            return "StrictMode";
        case $5a036e0bbbddc7fb$var$Ea:
            return "Suspense";
        case $5a036e0bbbddc7fb$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $5a036e0bbbddc7fb$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $5a036e0bbbddc7fb$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $5a036e0bbbddc7fb$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $5a036e0bbbddc7fb$var$Ga:
            return b = a.displayName || null, null !== b ? b : $5a036e0bbbddc7fb$var$Qa(a.type) || "Memo";
        case $5a036e0bbbddc7fb$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $5a036e0bbbddc7fb$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $5a036e0bbbddc7fb$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $5a036e0bbbddc7fb$var$Qa(b);
        case 8:
            return b === $5a036e0bbbddc7fb$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $5a036e0bbbddc7fb$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $3L4GM._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $5a036e0bbbddc7fb$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $5a036e0bbbddc7fb$var$Ua(a) {
    var b = $5a036e0bbbddc7fb$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $5a036e0bbbddc7fb$var$Va(a) {
    a._valueTracker || (a._valueTracker = $5a036e0bbbddc7fb$var$Ua(a));
}
function $5a036e0bbbddc7fb$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $5a036e0bbbddc7fb$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $5a036e0bbbddc7fb$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $5a036e0bbbddc7fb$var$Ya(a, b) {
    var c = b.checked;
    return $5a036e0bbbddc7fb$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $5a036e0bbbddc7fb$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $5a036e0bbbddc7fb$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $5a036e0bbbddc7fb$var$ab(a, b) {
    b = b.checked;
    null != b && $5a036e0bbbddc7fb$var$ta(a, "checked", b, !1);
}
function $5a036e0bbbddc7fb$var$bb(a, b) {
    $5a036e0bbbddc7fb$var$ab(a, b);
    var c = $5a036e0bbbddc7fb$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $5a036e0bbbddc7fb$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $5a036e0bbbddc7fb$var$cb(a, b.type, $5a036e0bbbddc7fb$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $5a036e0bbbddc7fb$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $5a036e0bbbddc7fb$var$cb(a, b, c) {
    if ("number" !== b || $5a036e0bbbddc7fb$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $5a036e0bbbddc7fb$var$eb = Array.isArray;
function $5a036e0bbbddc7fb$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $5a036e0bbbddc7fb$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $5a036e0bbbddc7fb$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($5a036e0bbbddc7fb$var$p(91));
    return $5a036e0bbbddc7fb$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $5a036e0bbbddc7fb$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($5a036e0bbbddc7fb$var$p(92));
            if ($5a036e0bbbddc7fb$var$eb(c)) {
                if (1 < c.length) throw Error($5a036e0bbbddc7fb$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $5a036e0bbbddc7fb$var$Sa(c)
    };
}
function $5a036e0bbbddc7fb$var$ib(a, b) {
    var c = $5a036e0bbbddc7fb$var$Sa(b.value), d = $5a036e0bbbddc7fb$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $5a036e0bbbddc7fb$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $5a036e0bbbddc7fb$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $5a036e0bbbddc7fb$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $5a036e0bbbddc7fb$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $5a036e0bbbddc7fb$var$mb, $5a036e0bbbddc7fb$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $5a036e0bbbddc7fb$var$mb = $5a036e0bbbddc7fb$var$mb || document.createElement("div");
        $5a036e0bbbddc7fb$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $5a036e0bbbddc7fb$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $5a036e0bbbddc7fb$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $5a036e0bbbddc7fb$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $5a036e0bbbddc7fb$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($5a036e0bbbddc7fb$var$pb).forEach(function(a) {
    $5a036e0bbbddc7fb$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $5a036e0bbbddc7fb$var$pb[b] = $5a036e0bbbddc7fb$var$pb[a];
    });
});
function $5a036e0bbbddc7fb$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $5a036e0bbbddc7fb$var$pb.hasOwnProperty(a) && $5a036e0bbbddc7fb$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $5a036e0bbbddc7fb$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $5a036e0bbbddc7fb$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $5a036e0bbbddc7fb$var$tb = $5a036e0bbbddc7fb$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $5a036e0bbbddc7fb$var$ub(a, b) {
    if (b) {
        if ($5a036e0bbbddc7fb$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($5a036e0bbbddc7fb$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($5a036e0bbbddc7fb$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($5a036e0bbbddc7fb$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($5a036e0bbbddc7fb$var$p(62));
    }
}
function $5a036e0bbbddc7fb$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $5a036e0bbbddc7fb$var$wb = null;
function $5a036e0bbbddc7fb$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $5a036e0bbbddc7fb$var$yb = null, $5a036e0bbbddc7fb$var$zb = null, $5a036e0bbbddc7fb$var$Ab = null;
function $5a036e0bbbddc7fb$var$Bb(a) {
    if (a = $5a036e0bbbddc7fb$var$Cb(a)) {
        if ("function" !== typeof $5a036e0bbbddc7fb$var$yb) throw Error($5a036e0bbbddc7fb$var$p(280));
        var b = a.stateNode;
        b && (b = $5a036e0bbbddc7fb$var$Db(b), $5a036e0bbbddc7fb$var$yb(a.stateNode, a.type, b));
    }
}
function $5a036e0bbbddc7fb$var$Eb(a) {
    $5a036e0bbbddc7fb$var$zb ? $5a036e0bbbddc7fb$var$Ab ? $5a036e0bbbddc7fb$var$Ab.push(a) : $5a036e0bbbddc7fb$var$Ab = [
        a
    ] : $5a036e0bbbddc7fb$var$zb = a;
}
function $5a036e0bbbddc7fb$var$Fb() {
    if ($5a036e0bbbddc7fb$var$zb) {
        var a = $5a036e0bbbddc7fb$var$zb, b = $5a036e0bbbddc7fb$var$Ab;
        $5a036e0bbbddc7fb$var$Ab = $5a036e0bbbddc7fb$var$zb = null;
        $5a036e0bbbddc7fb$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$5a036e0bbbddc7fb$var$Bb(b[a]);
    }
}
function $5a036e0bbbddc7fb$var$Gb(a, b) {
    return a(b);
}
function $5a036e0bbbddc7fb$var$Hb() {}
var $5a036e0bbbddc7fb$var$Ib = !1;
function $5a036e0bbbddc7fb$var$Jb(a, b, c) {
    if ($5a036e0bbbddc7fb$var$Ib) return a(b, c);
    $5a036e0bbbddc7fb$var$Ib = !0;
    try {
        return $5a036e0bbbddc7fb$var$Gb(a, b, c);
    } finally{
        if ($5a036e0bbbddc7fb$var$Ib = !1, null !== $5a036e0bbbddc7fb$var$zb || null !== $5a036e0bbbddc7fb$var$Ab) $5a036e0bbbddc7fb$var$Hb(), $5a036e0bbbddc7fb$var$Fb();
    }
}
function $5a036e0bbbddc7fb$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $5a036e0bbbddc7fb$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($5a036e0bbbddc7fb$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $3L4GM._)(c)));
    return c;
}
var $5a036e0bbbddc7fb$var$Lb = !1;
if ($5a036e0bbbddc7fb$var$ia) try {
    var $5a036e0bbbddc7fb$var$Mb = {};
    Object.defineProperty($5a036e0bbbddc7fb$var$Mb, "passive", {
        get: function get() {
            $5a036e0bbbddc7fb$var$Lb = !0;
        }
    });
    window.addEventListener("test", $5a036e0bbbddc7fb$var$Mb, $5a036e0bbbddc7fb$var$Mb);
    window.removeEventListener("test", $5a036e0bbbddc7fb$var$Mb, $5a036e0bbbddc7fb$var$Mb);
} catch (a) {
    $5a036e0bbbddc7fb$var$Lb = !1;
}
function $5a036e0bbbddc7fb$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $5a036e0bbbddc7fb$var$Ob = !1, $5a036e0bbbddc7fb$var$Pb = null, $5a036e0bbbddc7fb$var$Qb = !1, $5a036e0bbbddc7fb$var$Rb = null, $5a036e0bbbddc7fb$var$Sb = {
    onError: function onError(a) {
        $5a036e0bbbddc7fb$var$Ob = !0;
        $5a036e0bbbddc7fb$var$Pb = a;
    }
};
function $5a036e0bbbddc7fb$var$Tb(a, b, c, d, e, f, g, h, k) {
    $5a036e0bbbddc7fb$var$Ob = !1;
    $5a036e0bbbddc7fb$var$Pb = null;
    $5a036e0bbbddc7fb$var$Nb.apply($5a036e0bbbddc7fb$var$Sb, arguments);
}
function $5a036e0bbbddc7fb$var$Ub(a, b, c, d, e, f, g, h, k) {
    $5a036e0bbbddc7fb$var$Tb.apply(this, arguments);
    if ($5a036e0bbbddc7fb$var$Ob) {
        if ($5a036e0bbbddc7fb$var$Ob) {
            var l = $5a036e0bbbddc7fb$var$Pb;
            $5a036e0bbbddc7fb$var$Ob = !1;
            $5a036e0bbbddc7fb$var$Pb = null;
        } else throw Error($5a036e0bbbddc7fb$var$p(198));
        $5a036e0bbbddc7fb$var$Qb || ($5a036e0bbbddc7fb$var$Qb = !0, $5a036e0bbbddc7fb$var$Rb = l);
    }
}
function $5a036e0bbbddc7fb$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $5a036e0bbbddc7fb$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $5a036e0bbbddc7fb$var$Xb(a) {
    if ($5a036e0bbbddc7fb$var$Vb(a) !== a) throw Error($5a036e0bbbddc7fb$var$p(188));
}
function $5a036e0bbbddc7fb$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $5a036e0bbbddc7fb$var$Vb(a);
        if (null === b) throw Error($5a036e0bbbddc7fb$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $5a036e0bbbddc7fb$var$Xb(e), a;
                if (f === d) return $5a036e0bbbddc7fb$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($5a036e0bbbddc7fb$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($5a036e0bbbddc7fb$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($5a036e0bbbddc7fb$var$p(190));
    }
    if (3 !== c.tag) throw Error($5a036e0bbbddc7fb$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $5a036e0bbbddc7fb$var$Zb(a) {
    a = $5a036e0bbbddc7fb$var$Yb(a);
    return null !== a ? $5a036e0bbbddc7fb$var$$b(a) : null;
}
function $5a036e0bbbddc7fb$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $5a036e0bbbddc7fb$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $5a036e0bbbddc7fb$var$ac = $3GiGQ.unstable_scheduleCallback, $5a036e0bbbddc7fb$var$bc = $3GiGQ.unstable_cancelCallback, $5a036e0bbbddc7fb$var$cc = $3GiGQ.unstable_shouldYield, $5a036e0bbbddc7fb$var$dc = $3GiGQ.unstable_requestPaint, $5a036e0bbbddc7fb$var$B = $3GiGQ.unstable_now, $5a036e0bbbddc7fb$var$ec = $3GiGQ.unstable_getCurrentPriorityLevel, $5a036e0bbbddc7fb$var$fc = $3GiGQ.unstable_ImmediatePriority, $5a036e0bbbddc7fb$var$gc = $3GiGQ.unstable_UserBlockingPriority, $5a036e0bbbddc7fb$var$hc = $3GiGQ.unstable_NormalPriority, $5a036e0bbbddc7fb$var$ic = $3GiGQ.unstable_LowPriority, $5a036e0bbbddc7fb$var$jc = $3GiGQ.unstable_IdlePriority, $5a036e0bbbddc7fb$var$kc = null, $5a036e0bbbddc7fb$var$lc = null;
function $5a036e0bbbddc7fb$var$mc(a) {
    if ($5a036e0bbbddc7fb$var$lc && "function" === typeof $5a036e0bbbddc7fb$var$lc.onCommitFiberRoot) try {
        $5a036e0bbbddc7fb$var$lc.onCommitFiberRoot($5a036e0bbbddc7fb$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $5a036e0bbbddc7fb$var$oc = Math.clz32 ? Math.clz32 : $5a036e0bbbddc7fb$var$nc, $5a036e0bbbddc7fb$var$pc = Math.log, $5a036e0bbbddc7fb$var$qc = Math.LN2;
function $5a036e0bbbddc7fb$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($5a036e0bbbddc7fb$var$pc(a) / $5a036e0bbbddc7fb$var$qc | 0) | 0;
}
var $5a036e0bbbddc7fb$var$rc = 64, $5a036e0bbbddc7fb$var$sc = 4194304;
function $5a036e0bbbddc7fb$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $5a036e0bbbddc7fb$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $5a036e0bbbddc7fb$var$tc(h) : (f &= g, 0 !== f && (d = $5a036e0bbbddc7fb$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $5a036e0bbbddc7fb$var$tc(g) : 0 !== f && (d = $5a036e0bbbddc7fb$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $5a036e0bbbddc7fb$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $5a036e0bbbddc7fb$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $5a036e0bbbddc7fb$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $5a036e0bbbddc7fb$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $5a036e0bbbddc7fb$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $5a036e0bbbddc7fb$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $5a036e0bbbddc7fb$var$yc() {
    var a = $5a036e0bbbddc7fb$var$rc;
    $5a036e0bbbddc7fb$var$rc <<= 1;
    0 === ($5a036e0bbbddc7fb$var$rc & 4194240) && ($5a036e0bbbddc7fb$var$rc = 64);
    return a;
}
function $5a036e0bbbddc7fb$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $5a036e0bbbddc7fb$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $5a036e0bbbddc7fb$var$oc(b);
    a[b] = c;
}
function $5a036e0bbbddc7fb$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $5a036e0bbbddc7fb$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $5a036e0bbbddc7fb$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $5a036e0bbbddc7fb$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $5a036e0bbbddc7fb$var$C = 0;
function $5a036e0bbbddc7fb$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $5a036e0bbbddc7fb$var$Ec, $5a036e0bbbddc7fb$var$Fc, $5a036e0bbbddc7fb$var$Gc, $5a036e0bbbddc7fb$var$Hc, $5a036e0bbbddc7fb$var$Ic, $5a036e0bbbddc7fb$var$Jc = !1, $5a036e0bbbddc7fb$var$Kc = [], $5a036e0bbbddc7fb$var$Lc = null, $5a036e0bbbddc7fb$var$Mc = null, $5a036e0bbbddc7fb$var$Nc = null, $5a036e0bbbddc7fb$var$Oc = new Map, $5a036e0bbbddc7fb$var$Pc = new Map, $5a036e0bbbddc7fb$var$Qc = [], $5a036e0bbbddc7fb$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $5a036e0bbbddc7fb$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $5a036e0bbbddc7fb$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $5a036e0bbbddc7fb$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $5a036e0bbbddc7fb$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $5a036e0bbbddc7fb$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $5a036e0bbbddc7fb$var$Pc.delete(b.pointerId);
    }
}
function $5a036e0bbbddc7fb$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $5a036e0bbbddc7fb$var$Cb(b), null !== b && $5a036e0bbbddc7fb$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $5a036e0bbbddc7fb$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $5a036e0bbbddc7fb$var$Lc = $5a036e0bbbddc7fb$var$Tc($5a036e0bbbddc7fb$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $5a036e0bbbddc7fb$var$Mc = $5a036e0bbbddc7fb$var$Tc($5a036e0bbbddc7fb$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $5a036e0bbbddc7fb$var$Nc = $5a036e0bbbddc7fb$var$Tc($5a036e0bbbddc7fb$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $5a036e0bbbddc7fb$var$Oc.set(f, $5a036e0bbbddc7fb$var$Tc($5a036e0bbbddc7fb$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $5a036e0bbbddc7fb$var$Pc.set(f, $5a036e0bbbddc7fb$var$Tc($5a036e0bbbddc7fb$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $5a036e0bbbddc7fb$var$Vc(a) {
    var b = $5a036e0bbbddc7fb$var$Wc(a.target);
    if (null !== b) {
        var c = $5a036e0bbbddc7fb$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $5a036e0bbbddc7fb$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $5a036e0bbbddc7fb$var$Ic(a.priority, function() {
                        $5a036e0bbbddc7fb$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $5a036e0bbbddc7fb$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $5a036e0bbbddc7fb$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $5a036e0bbbddc7fb$var$wb = d;
            c.target.dispatchEvent(d);
            $5a036e0bbbddc7fb$var$wb = null;
        } else return b = $5a036e0bbbddc7fb$var$Cb(c), null !== b && $5a036e0bbbddc7fb$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $5a036e0bbbddc7fb$var$Zc(a, b, c) {
    $5a036e0bbbddc7fb$var$Xc(a) && c.delete(b);
}
function $5a036e0bbbddc7fb$var$$c() {
    $5a036e0bbbddc7fb$var$Jc = !1;
    null !== $5a036e0bbbddc7fb$var$Lc && $5a036e0bbbddc7fb$var$Xc($5a036e0bbbddc7fb$var$Lc) && ($5a036e0bbbddc7fb$var$Lc = null);
    null !== $5a036e0bbbddc7fb$var$Mc && $5a036e0bbbddc7fb$var$Xc($5a036e0bbbddc7fb$var$Mc) && ($5a036e0bbbddc7fb$var$Mc = null);
    null !== $5a036e0bbbddc7fb$var$Nc && $5a036e0bbbddc7fb$var$Xc($5a036e0bbbddc7fb$var$Nc) && ($5a036e0bbbddc7fb$var$Nc = null);
    $5a036e0bbbddc7fb$var$Oc.forEach($5a036e0bbbddc7fb$var$Zc);
    $5a036e0bbbddc7fb$var$Pc.forEach($5a036e0bbbddc7fb$var$Zc);
}
function $5a036e0bbbddc7fb$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $5a036e0bbbddc7fb$var$Jc || ($5a036e0bbbddc7fb$var$Jc = !0, $3GiGQ.unstable_scheduleCallback($3GiGQ.unstable_NormalPriority, $5a036e0bbbddc7fb$var$$c)));
}
function $5a036e0bbbddc7fb$var$bd(a) {
    function b(b) {
        return $5a036e0bbbddc7fb$var$ad(b, a);
    }
    if (0 < $5a036e0bbbddc7fb$var$Kc.length) {
        $5a036e0bbbddc7fb$var$ad($5a036e0bbbddc7fb$var$Kc[0], a);
        for(var c = 1; c < $5a036e0bbbddc7fb$var$Kc.length; c++){
            var d = $5a036e0bbbddc7fb$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $5a036e0bbbddc7fb$var$Lc && $5a036e0bbbddc7fb$var$ad($5a036e0bbbddc7fb$var$Lc, a);
    null !== $5a036e0bbbddc7fb$var$Mc && $5a036e0bbbddc7fb$var$ad($5a036e0bbbddc7fb$var$Mc, a);
    null !== $5a036e0bbbddc7fb$var$Nc && $5a036e0bbbddc7fb$var$ad($5a036e0bbbddc7fb$var$Nc, a);
    $5a036e0bbbddc7fb$var$Oc.forEach(b);
    $5a036e0bbbddc7fb$var$Pc.forEach(b);
    for(c = 0; c < $5a036e0bbbddc7fb$var$Qc.length; c++)d = $5a036e0bbbddc7fb$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $5a036e0bbbddc7fb$var$Qc.length && (c = $5a036e0bbbddc7fb$var$Qc[0], null === c.blockedOn);)$5a036e0bbbddc7fb$var$Vc(c), null === c.blockedOn && $5a036e0bbbddc7fb$var$Qc.shift();
}
var $5a036e0bbbddc7fb$var$cd = $5a036e0bbbddc7fb$var$ua.ReactCurrentBatchConfig, $5a036e0bbbddc7fb$var$dd = !0;
function $5a036e0bbbddc7fb$var$ed(a, b, c, d) {
    var e = $5a036e0bbbddc7fb$var$C, f = $5a036e0bbbddc7fb$var$cd.transition;
    $5a036e0bbbddc7fb$var$cd.transition = null;
    try {
        $5a036e0bbbddc7fb$var$C = 1, $5a036e0bbbddc7fb$var$fd(a, b, c, d);
    } finally{
        $5a036e0bbbddc7fb$var$C = e, $5a036e0bbbddc7fb$var$cd.transition = f;
    }
}
function $5a036e0bbbddc7fb$var$gd(a, b, c, d) {
    var e = $5a036e0bbbddc7fb$var$C, f = $5a036e0bbbddc7fb$var$cd.transition;
    $5a036e0bbbddc7fb$var$cd.transition = null;
    try {
        $5a036e0bbbddc7fb$var$C = 4, $5a036e0bbbddc7fb$var$fd(a, b, c, d);
    } finally{
        $5a036e0bbbddc7fb$var$C = e, $5a036e0bbbddc7fb$var$cd.transition = f;
    }
}
function $5a036e0bbbddc7fb$var$fd(a, b, c, d) {
    if ($5a036e0bbbddc7fb$var$dd) {
        var e = $5a036e0bbbddc7fb$var$Yc(a, b, c, d);
        if (null === e) $5a036e0bbbddc7fb$var$hd(a, b, d, $5a036e0bbbddc7fb$var$id, c), $5a036e0bbbddc7fb$var$Sc(a, d);
        else if ($5a036e0bbbddc7fb$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($5a036e0bbbddc7fb$var$Sc(a, d), b & 4 && -1 < $5a036e0bbbddc7fb$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $5a036e0bbbddc7fb$var$Cb(e);
                null !== f && $5a036e0bbbddc7fb$var$Ec(f);
                f = $5a036e0bbbddc7fb$var$Yc(a, b, c, d);
                null === f && $5a036e0bbbddc7fb$var$hd(a, b, d, $5a036e0bbbddc7fb$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $5a036e0bbbddc7fb$var$hd(a, b, d, null, c);
    }
}
var $5a036e0bbbddc7fb$var$id = null;
function $5a036e0bbbddc7fb$var$Yc(a, b, c, d) {
    $5a036e0bbbddc7fb$var$id = null;
    a = $5a036e0bbbddc7fb$var$xb(d);
    a = $5a036e0bbbddc7fb$var$Wc(a);
    if (null !== a) {
        if (b = $5a036e0bbbddc7fb$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $5a036e0bbbddc7fb$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $5a036e0bbbddc7fb$var$id = a;
    return null;
}
function $5a036e0bbbddc7fb$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($5a036e0bbbddc7fb$var$ec()){
                case $5a036e0bbbddc7fb$var$fc:
                    return 1;
                case $5a036e0bbbddc7fb$var$gc:
                    return 4;
                case $5a036e0bbbddc7fb$var$hc:
                case $5a036e0bbbddc7fb$var$ic:
                    return 16;
                case $5a036e0bbbddc7fb$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $5a036e0bbbddc7fb$var$kd = null, $5a036e0bbbddc7fb$var$ld = null, $5a036e0bbbddc7fb$var$md = null;
function $5a036e0bbbddc7fb$var$nd() {
    if ($5a036e0bbbddc7fb$var$md) return $5a036e0bbbddc7fb$var$md;
    var a, b = $5a036e0bbbddc7fb$var$ld, c = b.length, d, e = "value" in $5a036e0bbbddc7fb$var$kd ? $5a036e0bbbddc7fb$var$kd.value : $5a036e0bbbddc7fb$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $5a036e0bbbddc7fb$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $5a036e0bbbddc7fb$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $5a036e0bbbddc7fb$var$pd() {
    return !0;
}
function $5a036e0bbbddc7fb$var$qd() {
    return !1;
}
function $5a036e0bbbddc7fb$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $5a036e0bbbddc7fb$var$pd : $5a036e0bbbddc7fb$var$qd;
        this.isPropagationStopped = $5a036e0bbbddc7fb$var$qd;
        return this;
    }
    $5a036e0bbbddc7fb$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $3L4GM._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $5a036e0bbbddc7fb$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $3L4GM._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $5a036e0bbbddc7fb$var$pd);
        },
        persist: function persist() {},
        isPersistent: $5a036e0bbbddc7fb$var$pd
    });
    return b;
}
var $5a036e0bbbddc7fb$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $5a036e0bbbddc7fb$var$td = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$sd), $5a036e0bbbddc7fb$var$ud = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$sd, {
    view: 0,
    detail: 0
}), $5a036e0bbbddc7fb$var$vd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$ud), $5a036e0bbbddc7fb$var$wd, $5a036e0bbbddc7fb$var$xd, $5a036e0bbbddc7fb$var$yd, $5a036e0bbbddc7fb$var$Ad = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $5a036e0bbbddc7fb$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $5a036e0bbbddc7fb$var$yd && ($5a036e0bbbddc7fb$var$yd && "mousemove" === a.type ? ($5a036e0bbbddc7fb$var$wd = a.screenX - $5a036e0bbbddc7fb$var$yd.screenX, $5a036e0bbbddc7fb$var$xd = a.screenY - $5a036e0bbbddc7fb$var$yd.screenY) : $5a036e0bbbddc7fb$var$xd = $5a036e0bbbddc7fb$var$wd = 0, $5a036e0bbbddc7fb$var$yd = a);
        return $5a036e0bbbddc7fb$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $5a036e0bbbddc7fb$var$xd;
    }
}), $5a036e0bbbddc7fb$var$Bd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Ad), $5a036e0bbbddc7fb$var$Cd = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$Ad, {
    dataTransfer: 0
}), $5a036e0bbbddc7fb$var$Dd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Cd), $5a036e0bbbddc7fb$var$Ed = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$ud, {
    relatedTarget: 0
}), $5a036e0bbbddc7fb$var$Fd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Ed), $5a036e0bbbddc7fb$var$Gd = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5a036e0bbbddc7fb$var$Hd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Gd), $5a036e0bbbddc7fb$var$Id = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $5a036e0bbbddc7fb$var$Jd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Id), $5a036e0bbbddc7fb$var$Kd = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$sd, {
    data: 0
}), $5a036e0bbbddc7fb$var$Ld = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Kd), $5a036e0bbbddc7fb$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $5a036e0bbbddc7fb$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $5a036e0bbbddc7fb$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $5a036e0bbbddc7fb$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $5a036e0bbbddc7fb$var$Od[a]) ? !!b[a] : !1;
}
function $5a036e0bbbddc7fb$var$zd() {
    return $5a036e0bbbddc7fb$var$Pd;
}
var $5a036e0bbbddc7fb$var$Qd = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $5a036e0bbbddc7fb$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $5a036e0bbbddc7fb$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $5a036e0bbbddc7fb$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $5a036e0bbbddc7fb$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $5a036e0bbbddc7fb$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $5a036e0bbbddc7fb$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $5a036e0bbbddc7fb$var$Rd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Qd), $5a036e0bbbddc7fb$var$Sd = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $5a036e0bbbddc7fb$var$Td = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Sd), $5a036e0bbbddc7fb$var$Ud = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $5a036e0bbbddc7fb$var$zd
}), $5a036e0bbbddc7fb$var$Vd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Ud), $5a036e0bbbddc7fb$var$Wd = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5a036e0bbbddc7fb$var$Xd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Wd), $5a036e0bbbddc7fb$var$Yd = $5a036e0bbbddc7fb$var$A({}, $5a036e0bbbddc7fb$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $5a036e0bbbddc7fb$var$Zd = $5a036e0bbbddc7fb$var$rd($5a036e0bbbddc7fb$var$Yd), $5a036e0bbbddc7fb$var$$d = [
    9,
    13,
    27,
    32
], $5a036e0bbbddc7fb$var$ae = $5a036e0bbbddc7fb$var$ia && "CompositionEvent" in window, $5a036e0bbbddc7fb$var$be = null;
$5a036e0bbbddc7fb$var$ia && "documentMode" in document && ($5a036e0bbbddc7fb$var$be = document.documentMode);
var $5a036e0bbbddc7fb$var$ce = $5a036e0bbbddc7fb$var$ia && "TextEvent" in window && !$5a036e0bbbddc7fb$var$be, $5a036e0bbbddc7fb$var$de = $5a036e0bbbddc7fb$var$ia && (!$5a036e0bbbddc7fb$var$ae || $5a036e0bbbddc7fb$var$be && 8 < $5a036e0bbbddc7fb$var$be && 11 >= $5a036e0bbbddc7fb$var$be), $5a036e0bbbddc7fb$var$ee = String.fromCharCode(32), $5a036e0bbbddc7fb$var$fe = !1;
function $5a036e0bbbddc7fb$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $5a036e0bbbddc7fb$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $5a036e0bbbddc7fb$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $5a036e0bbbddc7fb$var$ie = !1;
function $5a036e0bbbddc7fb$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $5a036e0bbbddc7fb$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $5a036e0bbbddc7fb$var$fe = !0;
            return $5a036e0bbbddc7fb$var$ee;
        case "textInput":
            return a = b.data, a === $5a036e0bbbddc7fb$var$ee && $5a036e0bbbddc7fb$var$fe ? null : a;
        default:
            return null;
    }
}
function $5a036e0bbbddc7fb$var$ke(a, b) {
    if ($5a036e0bbbddc7fb$var$ie) return "compositionend" === a || !$5a036e0bbbddc7fb$var$ae && $5a036e0bbbddc7fb$var$ge(a, b) ? (a = $5a036e0bbbddc7fb$var$nd(), $5a036e0bbbddc7fb$var$md = $5a036e0bbbddc7fb$var$ld = $5a036e0bbbddc7fb$var$kd = null, $5a036e0bbbddc7fb$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $5a036e0bbbddc7fb$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $5a036e0bbbddc7fb$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $5a036e0bbbddc7fb$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$5a036e0bbbddc7fb$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $5a036e0bbbddc7fb$var$ne(a, b, c, d) {
    $5a036e0bbbddc7fb$var$Eb(d);
    b = $5a036e0bbbddc7fb$var$oe(b, "onChange");
    0 < b.length && (c = new $5a036e0bbbddc7fb$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $5a036e0bbbddc7fb$var$pe = null, $5a036e0bbbddc7fb$var$qe = null;
function $5a036e0bbbddc7fb$var$re(a) {
    $5a036e0bbbddc7fb$var$se(a, 0);
}
function $5a036e0bbbddc7fb$var$te(a) {
    var b = $5a036e0bbbddc7fb$var$ue(a);
    if ($5a036e0bbbddc7fb$var$Wa(b)) return a;
}
function $5a036e0bbbddc7fb$var$ve(a, b) {
    if ("change" === a) return b;
}
var $5a036e0bbbddc7fb$var$we = !1;
if ($5a036e0bbbddc7fb$var$ia) {
    var $5a036e0bbbddc7fb$var$xe;
    if ($5a036e0bbbddc7fb$var$ia) {
        var $5a036e0bbbddc7fb$var$ye = "oninput" in document;
        if (!$5a036e0bbbddc7fb$var$ye) {
            var $5a036e0bbbddc7fb$var$ze = document.createElement("div");
            $5a036e0bbbddc7fb$var$ze.setAttribute("oninput", "return;");
            $5a036e0bbbddc7fb$var$ye = "function" === typeof $5a036e0bbbddc7fb$var$ze.oninput;
        }
        $5a036e0bbbddc7fb$var$xe = $5a036e0bbbddc7fb$var$ye;
    } else $5a036e0bbbddc7fb$var$xe = !1;
    $5a036e0bbbddc7fb$var$we = $5a036e0bbbddc7fb$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $5a036e0bbbddc7fb$var$Ae() {
    $5a036e0bbbddc7fb$var$pe && ($5a036e0bbbddc7fb$var$pe.detachEvent("onpropertychange", $5a036e0bbbddc7fb$var$Be), $5a036e0bbbddc7fb$var$qe = $5a036e0bbbddc7fb$var$pe = null);
}
function $5a036e0bbbddc7fb$var$Be(a) {
    if ("value" === a.propertyName && $5a036e0bbbddc7fb$var$te($5a036e0bbbddc7fb$var$qe)) {
        var b = [];
        $5a036e0bbbddc7fb$var$ne(b, $5a036e0bbbddc7fb$var$qe, a, $5a036e0bbbddc7fb$var$xb(a));
        $5a036e0bbbddc7fb$var$Jb($5a036e0bbbddc7fb$var$re, b);
    }
}
function $5a036e0bbbddc7fb$var$Ce(a, b, c) {
    "focusin" === a ? ($5a036e0bbbddc7fb$var$Ae(), $5a036e0bbbddc7fb$var$pe = b, $5a036e0bbbddc7fb$var$qe = c, $5a036e0bbbddc7fb$var$pe.attachEvent("onpropertychange", $5a036e0bbbddc7fb$var$Be)) : "focusout" === a && $5a036e0bbbddc7fb$var$Ae();
}
function $5a036e0bbbddc7fb$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $5a036e0bbbddc7fb$var$te($5a036e0bbbddc7fb$var$qe);
}
function $5a036e0bbbddc7fb$var$Ee(a, b) {
    if ("click" === a) return $5a036e0bbbddc7fb$var$te(b);
}
function $5a036e0bbbddc7fb$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $5a036e0bbbddc7fb$var$te(b);
}
function $5a036e0bbbddc7fb$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5a036e0bbbddc7fb$var$He = "function" === typeof Object.is ? Object.is : $5a036e0bbbddc7fb$var$Ge;
function $5a036e0bbbddc7fb$var$Ie(a, b) {
    if ($5a036e0bbbddc7fb$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$5a036e0bbbddc7fb$var$ja.call(b, e) || !$5a036e0bbbddc7fb$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $5a036e0bbbddc7fb$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $5a036e0bbbddc7fb$var$Ke(a, b) {
    var c = $5a036e0bbbddc7fb$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $5a036e0bbbddc7fb$var$Je(c);
    }
}
function $5a036e0bbbddc7fb$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $5a036e0bbbddc7fb$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $5a036e0bbbddc7fb$var$Me() {
    for(var a = window, b = $5a036e0bbbddc7fb$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $5a036e0bbbddc7fb$var$Xa(a.document);
    }
    return b;
}
function $5a036e0bbbddc7fb$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $5a036e0bbbddc7fb$var$Oe(a) {
    var b = $5a036e0bbbddc7fb$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $5a036e0bbbddc7fb$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $5a036e0bbbddc7fb$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $5a036e0bbbddc7fb$var$Ke(c, f);
                var g = $5a036e0bbbddc7fb$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $5a036e0bbbddc7fb$var$Pe = $5a036e0bbbddc7fb$var$ia && "documentMode" in document && 11 >= document.documentMode, $5a036e0bbbddc7fb$var$Qe = null, $5a036e0bbbddc7fb$var$Re = null, $5a036e0bbbddc7fb$var$Se = null, $5a036e0bbbddc7fb$var$Te = !1;
function $5a036e0bbbddc7fb$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $5a036e0bbbddc7fb$var$Te || null == $5a036e0bbbddc7fb$var$Qe || $5a036e0bbbddc7fb$var$Qe !== $5a036e0bbbddc7fb$var$Xa(d) || (d = $5a036e0bbbddc7fb$var$Qe, "selectionStart" in d && $5a036e0bbbddc7fb$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $5a036e0bbbddc7fb$var$Se && $5a036e0bbbddc7fb$var$Ie($5a036e0bbbddc7fb$var$Se, d) || ($5a036e0bbbddc7fb$var$Se = d, d = $5a036e0bbbddc7fb$var$oe($5a036e0bbbddc7fb$var$Re, "onSelect"), 0 < d.length && (b = new $5a036e0bbbddc7fb$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $5a036e0bbbddc7fb$var$Qe)));
}
function $5a036e0bbbddc7fb$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $5a036e0bbbddc7fb$var$We = {
    animationend: $5a036e0bbbddc7fb$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $5a036e0bbbddc7fb$var$Ve("Animation", "AnimationIteration"),
    animationstart: $5a036e0bbbddc7fb$var$Ve("Animation", "AnimationStart"),
    transitionend: $5a036e0bbbddc7fb$var$Ve("Transition", "TransitionEnd")
}, $5a036e0bbbddc7fb$var$Xe = {}, $5a036e0bbbddc7fb$var$Ye = {};
$5a036e0bbbddc7fb$var$ia && ($5a036e0bbbddc7fb$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $5a036e0bbbddc7fb$var$We.animationend.animation, delete $5a036e0bbbddc7fb$var$We.animationiteration.animation, delete $5a036e0bbbddc7fb$var$We.animationstart.animation), "TransitionEvent" in window || delete $5a036e0bbbddc7fb$var$We.transitionend.transition);
function $5a036e0bbbddc7fb$var$Ze(a) {
    if ($5a036e0bbbddc7fb$var$Xe[a]) return $5a036e0bbbddc7fb$var$Xe[a];
    if (!$5a036e0bbbddc7fb$var$We[a]) return a;
    var b = $5a036e0bbbddc7fb$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $5a036e0bbbddc7fb$var$Ye) return $5a036e0bbbddc7fb$var$Xe[a] = b[c];
    return a;
}
var $5a036e0bbbddc7fb$var$$e = $5a036e0bbbddc7fb$var$Ze("animationend"), $5a036e0bbbddc7fb$var$af = $5a036e0bbbddc7fb$var$Ze("animationiteration"), $5a036e0bbbddc7fb$var$bf = $5a036e0bbbddc7fb$var$Ze("animationstart"), $5a036e0bbbddc7fb$var$cf = $5a036e0bbbddc7fb$var$Ze("transitionend"), $5a036e0bbbddc7fb$var$df = new Map, $5a036e0bbbddc7fb$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $5a036e0bbbddc7fb$var$ff(a, b) {
    $5a036e0bbbddc7fb$var$df.set(a, b);
    $5a036e0bbbddc7fb$var$fa(b, [
        a
    ]);
}
for(var $5a036e0bbbddc7fb$var$gf = 0; $5a036e0bbbddc7fb$var$gf < $5a036e0bbbddc7fb$var$ef.length; $5a036e0bbbddc7fb$var$gf++){
    var $5a036e0bbbddc7fb$var$hf = $5a036e0bbbddc7fb$var$ef[$5a036e0bbbddc7fb$var$gf], $5a036e0bbbddc7fb$var$jf = $5a036e0bbbddc7fb$var$hf.toLowerCase(), $5a036e0bbbddc7fb$var$kf = $5a036e0bbbddc7fb$var$hf[0].toUpperCase() + $5a036e0bbbddc7fb$var$hf.slice(1);
    $5a036e0bbbddc7fb$var$ff($5a036e0bbbddc7fb$var$jf, "on" + $5a036e0bbbddc7fb$var$kf);
}
$5a036e0bbbddc7fb$var$ff($5a036e0bbbddc7fb$var$$e, "onAnimationEnd");
$5a036e0bbbddc7fb$var$ff($5a036e0bbbddc7fb$var$af, "onAnimationIteration");
$5a036e0bbbddc7fb$var$ff($5a036e0bbbddc7fb$var$bf, "onAnimationStart");
$5a036e0bbbddc7fb$var$ff("dblclick", "onDoubleClick");
$5a036e0bbbddc7fb$var$ff("focusin", "onFocus");
$5a036e0bbbddc7fb$var$ff("focusout", "onBlur");
$5a036e0bbbddc7fb$var$ff($5a036e0bbbddc7fb$var$cf, "onTransitionEnd");
$5a036e0bbbddc7fb$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$5a036e0bbbddc7fb$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$5a036e0bbbddc7fb$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$5a036e0bbbddc7fb$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$5a036e0bbbddc7fb$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$5a036e0bbbddc7fb$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$5a036e0bbbddc7fb$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$5a036e0bbbddc7fb$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$5a036e0bbbddc7fb$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$5a036e0bbbddc7fb$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $5a036e0bbbddc7fb$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $5a036e0bbbddc7fb$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($5a036e0bbbddc7fb$var$lf));
function $5a036e0bbbddc7fb$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $5a036e0bbbddc7fb$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $5a036e0bbbddc7fb$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5a036e0bbbddc7fb$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5a036e0bbbddc7fb$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($5a036e0bbbddc7fb$var$Qb) throw a = $5a036e0bbbddc7fb$var$Rb, $5a036e0bbbddc7fb$var$Qb = !1, $5a036e0bbbddc7fb$var$Rb = null, a;
}
function $5a036e0bbbddc7fb$var$D(a, b) {
    var c = b[$5a036e0bbbddc7fb$var$of];
    void 0 === c && (c = b[$5a036e0bbbddc7fb$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($5a036e0bbbddc7fb$var$pf(b, a, 2, !1), c.add(d));
}
function $5a036e0bbbddc7fb$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $5a036e0bbbddc7fb$var$pf(c, a, d, b);
}
var $5a036e0bbbddc7fb$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $5a036e0bbbddc7fb$var$sf(a) {
    if (!a[$5a036e0bbbddc7fb$var$rf]) {
        a[$5a036e0bbbddc7fb$var$rf] = !0;
        $5a036e0bbbddc7fb$var$da.forEach(function(b) {
            "selectionchange" !== b && ($5a036e0bbbddc7fb$var$mf.has(b) || $5a036e0bbbddc7fb$var$qf(b, !1, a), $5a036e0bbbddc7fb$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$5a036e0bbbddc7fb$var$rf] || (b[$5a036e0bbbddc7fb$var$rf] = !0, $5a036e0bbbddc7fb$var$qf("selectionchange", !1, b));
    }
}
function $5a036e0bbbddc7fb$var$pf(a, b, c, d) {
    switch($5a036e0bbbddc7fb$var$jd(b)){
        case 1:
            var e = $5a036e0bbbddc7fb$var$ed;
            break;
        case 4:
            e = $5a036e0bbbddc7fb$var$gd;
            break;
        default:
            e = $5a036e0bbbddc7fb$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$5a036e0bbbddc7fb$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $5a036e0bbbddc7fb$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $5a036e0bbbddc7fb$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $5a036e0bbbddc7fb$var$Jb(function() {
        var _$d = f, _$e = $5a036e0bbbddc7fb$var$xb(c), g = [];
        a: {
            var h = $5a036e0bbbddc7fb$var$df.get(a);
            if (void 0 !== h) {
                var k = $5a036e0bbbddc7fb$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $5a036e0bbbddc7fb$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $5a036e0bbbddc7fb$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $5a036e0bbbddc7fb$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $5a036e0bbbddc7fb$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $5a036e0bbbddc7fb$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $5a036e0bbbddc7fb$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $5a036e0bbbddc7fb$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $5a036e0bbbddc7fb$var$Vd;
                        break;
                    case $5a036e0bbbddc7fb$var$$e:
                    case $5a036e0bbbddc7fb$var$af:
                    case $5a036e0bbbddc7fb$var$bf:
                        k = $5a036e0bbbddc7fb$var$Hd;
                        break;
                    case $5a036e0bbbddc7fb$var$cf:
                        k = $5a036e0bbbddc7fb$var$Xd;
                        break;
                    case "scroll":
                        k = $5a036e0bbbddc7fb$var$vd;
                        break;
                    case "wheel":
                        k = $5a036e0bbbddc7fb$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $5a036e0bbbddc7fb$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $5a036e0bbbddc7fb$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $5a036e0bbbddc7fb$var$Kb(w, x), null != F && t.push($5a036e0bbbddc7fb$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $5a036e0bbbddc7fb$var$wb && (n = c.relatedTarget || c.fromElement) && ($5a036e0bbbddc7fb$var$Wc(n) || n[$5a036e0bbbddc7fb$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $5a036e0bbbddc7fb$var$Wc(n) : null, null !== n && (J = $5a036e0bbbddc7fb$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $5a036e0bbbddc7fb$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $5a036e0bbbddc7fb$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $5a036e0bbbddc7fb$var$ue(k);
                        u = null == n ? h : $5a036e0bbbddc7fb$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $5a036e0bbbddc7fb$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $5a036e0bbbddc7fb$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $5a036e0bbbddc7fb$var$vf(F))u++;
                            for(; 0 < w - u;)t = $5a036e0bbbddc7fb$var$vf(t), w--;
                            for(; 0 < u - w;)x = $5a036e0bbbddc7fb$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $5a036e0bbbddc7fb$var$vf(t);
                                x = $5a036e0bbbddc7fb$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $5a036e0bbbddc7fb$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $5a036e0bbbddc7fb$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $5a036e0bbbddc7fb$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $5a036e0bbbddc7fb$var$ve;
                else if ($5a036e0bbbddc7fb$var$me(h)) {
                    if ($5a036e0bbbddc7fb$var$we) na = $5a036e0bbbddc7fb$var$Fe;
                    else {
                        na = $5a036e0bbbddc7fb$var$De;
                        var xa = $5a036e0bbbddc7fb$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $5a036e0bbbddc7fb$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $5a036e0bbbddc7fb$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $5a036e0bbbddc7fb$var$cb(h, "number", h.value);
            }
            xa = _$d ? $5a036e0bbbddc7fb$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($5a036e0bbbddc7fb$var$me(xa) || "true" === xa.contentEditable) $5a036e0bbbddc7fb$var$Qe = xa, $5a036e0bbbddc7fb$var$Re = _$d, $5a036e0bbbddc7fb$var$Se = null;
                    break;
                case "focusout":
                    $5a036e0bbbddc7fb$var$Se = $5a036e0bbbddc7fb$var$Re = $5a036e0bbbddc7fb$var$Qe = null;
                    break;
                case "mousedown":
                    $5a036e0bbbddc7fb$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $5a036e0bbbddc7fb$var$Te = !1;
                    $5a036e0bbbddc7fb$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($5a036e0bbbddc7fb$var$Pe) break;
                case "keydown":
                case "keyup":
                    $5a036e0bbbddc7fb$var$Ue(g, c, _$e);
            }
            var $a;
            if ($5a036e0bbbddc7fb$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $5a036e0bbbddc7fb$var$ie ? $5a036e0bbbddc7fb$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($5a036e0bbbddc7fb$var$de && "ko" !== c.locale && ($5a036e0bbbddc7fb$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $5a036e0bbbddc7fb$var$ie && ($a = $5a036e0bbbddc7fb$var$nd()) : ($5a036e0bbbddc7fb$var$kd = _$e, $5a036e0bbbddc7fb$var$ld = "value" in $5a036e0bbbddc7fb$var$kd ? $5a036e0bbbddc7fb$var$kd.value : $5a036e0bbbddc7fb$var$kd.textContent, $5a036e0bbbddc7fb$var$ie = !0)), xa = $5a036e0bbbddc7fb$var$oe(_$d, ba), 0 < xa.length && (ba = new $5a036e0bbbddc7fb$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $5a036e0bbbddc7fb$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $5a036e0bbbddc7fb$var$ce ? $5a036e0bbbddc7fb$var$je(a, c) : $5a036e0bbbddc7fb$var$ke(a, c)) _$d = $5a036e0bbbddc7fb$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $5a036e0bbbddc7fb$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $5a036e0bbbddc7fb$var$se(g, b);
    });
}
function $5a036e0bbbddc7fb$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $5a036e0bbbddc7fb$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $5a036e0bbbddc7fb$var$Kb(a, c), null != f && d.unshift($5a036e0bbbddc7fb$var$tf(a, f, e)), f = $5a036e0bbbddc7fb$var$Kb(a, b), null != f && d.push($5a036e0bbbddc7fb$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $5a036e0bbbddc7fb$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $5a036e0bbbddc7fb$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $5a036e0bbbddc7fb$var$Kb(c, f), null != k && g.unshift($5a036e0bbbddc7fb$var$tf(c, k, h))) : e || (k = $5a036e0bbbddc7fb$var$Kb(c, f), null != k && g.push($5a036e0bbbddc7fb$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $5a036e0bbbddc7fb$var$xf = /\r\n?/g, $5a036e0bbbddc7fb$var$yf = /\u0000|\uFFFD/g;
function $5a036e0bbbddc7fb$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($5a036e0bbbddc7fb$var$xf, "\n").replace($5a036e0bbbddc7fb$var$yf, "");
}
function $5a036e0bbbddc7fb$var$Af(a, b, c) {
    b = $5a036e0bbbddc7fb$var$zf(b);
    if ($5a036e0bbbddc7fb$var$zf(a) !== b && c) throw Error($5a036e0bbbddc7fb$var$p(425));
}
function $5a036e0bbbddc7fb$var$Bf() {}
var $5a036e0bbbddc7fb$var$Cf = null, $5a036e0bbbddc7fb$var$Df = null;
function $5a036e0bbbddc7fb$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $5a036e0bbbddc7fb$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $5a036e0bbbddc7fb$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $5a036e0bbbddc7fb$var$Hf = "function" === typeof Promise ? Promise : void 0, $5a036e0bbbddc7fb$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $5a036e0bbbddc7fb$var$Hf ? function Jf(a) {
    return $5a036e0bbbddc7fb$var$Hf.resolve(null).then(a).catch($5a036e0bbbddc7fb$var$If);
} : $5a036e0bbbddc7fb$var$Ff;
function $5a036e0bbbddc7fb$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $5a036e0bbbddc7fb$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $5a036e0bbbddc7fb$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $5a036e0bbbddc7fb$var$bd(b);
}
function $5a036e0bbbddc7fb$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $5a036e0bbbddc7fb$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $5a036e0bbbddc7fb$var$Nf = Math.random().toString(36).slice(2), $5a036e0bbbddc7fb$var$Of = "__reactFiber$" + $5a036e0bbbddc7fb$var$Nf, $5a036e0bbbddc7fb$var$Pf = "__reactProps$" + $5a036e0bbbddc7fb$var$Nf, $5a036e0bbbddc7fb$var$uf = "__reactContainer$" + $5a036e0bbbddc7fb$var$Nf, $5a036e0bbbddc7fb$var$of = "__reactEvents$" + $5a036e0bbbddc7fb$var$Nf, $5a036e0bbbddc7fb$var$Qf = "__reactListeners$" + $5a036e0bbbddc7fb$var$Nf, $5a036e0bbbddc7fb$var$Rf = "__reactHandles$" + $5a036e0bbbddc7fb$var$Nf;
function $5a036e0bbbddc7fb$var$Wc(a) {
    var b = a[$5a036e0bbbddc7fb$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$5a036e0bbbddc7fb$var$uf] || c[$5a036e0bbbddc7fb$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $5a036e0bbbddc7fb$var$Mf(a); null !== a;){
                if (c = a[$5a036e0bbbddc7fb$var$Of]) return c;
                a = $5a036e0bbbddc7fb$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $5a036e0bbbddc7fb$var$Cb(a) {
    a = a[$5a036e0bbbddc7fb$var$Of] || a[$5a036e0bbbddc7fb$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $5a036e0bbbddc7fb$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($5a036e0bbbddc7fb$var$p(33));
}
function $5a036e0bbbddc7fb$var$Db(a) {
    return a[$5a036e0bbbddc7fb$var$Pf] || null;
}
var $5a036e0bbbddc7fb$var$Sf = [], $5a036e0bbbddc7fb$var$Tf = -1;
function $5a036e0bbbddc7fb$var$Uf(a) {
    return {
        current: a
    };
}
function $5a036e0bbbddc7fb$var$E(a) {
    0 > $5a036e0bbbddc7fb$var$Tf || (a.current = $5a036e0bbbddc7fb$var$Sf[$5a036e0bbbddc7fb$var$Tf], $5a036e0bbbddc7fb$var$Sf[$5a036e0bbbddc7fb$var$Tf] = null, $5a036e0bbbddc7fb$var$Tf--);
}
function $5a036e0bbbddc7fb$var$G(a, b) {
    $5a036e0bbbddc7fb$var$Tf++;
    $5a036e0bbbddc7fb$var$Sf[$5a036e0bbbddc7fb$var$Tf] = a.current;
    a.current = b;
}
var $5a036e0bbbddc7fb$var$Vf = {}, $5a036e0bbbddc7fb$var$H = $5a036e0bbbddc7fb$var$Uf($5a036e0bbbddc7fb$var$Vf), $5a036e0bbbddc7fb$var$Wf = $5a036e0bbbddc7fb$var$Uf(!1), $5a036e0bbbddc7fb$var$Xf = $5a036e0bbbddc7fb$var$Vf;
function $5a036e0bbbddc7fb$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $5a036e0bbbddc7fb$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $5a036e0bbbddc7fb$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $5a036e0bbbddc7fb$var$$f() {
    $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Wf);
    $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$H);
}
function $5a036e0bbbddc7fb$var$ag(a, b, c) {
    if ($5a036e0bbbddc7fb$var$H.current !== $5a036e0bbbddc7fb$var$Vf) throw Error($5a036e0bbbddc7fb$var$p(168));
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$H, b);
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Wf, c);
}
function $5a036e0bbbddc7fb$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($5a036e0bbbddc7fb$var$p(108, $5a036e0bbbddc7fb$var$Ra(a) || "Unknown", e));
    return $5a036e0bbbddc7fb$var$A({}, c, d);
}
function $5a036e0bbbddc7fb$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $5a036e0bbbddc7fb$var$Vf;
    $5a036e0bbbddc7fb$var$Xf = $5a036e0bbbddc7fb$var$H.current;
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$H, a);
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Wf, $5a036e0bbbddc7fb$var$Wf.current);
    return !0;
}
function $5a036e0bbbddc7fb$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($5a036e0bbbddc7fb$var$p(169));
    c ? (a = $5a036e0bbbddc7fb$var$bg(a, b, $5a036e0bbbddc7fb$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Wf), $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$H), $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$H, a)) : $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Wf);
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Wf, c);
}
var $5a036e0bbbddc7fb$var$eg = null, $5a036e0bbbddc7fb$var$fg = !1, $5a036e0bbbddc7fb$var$gg = !1;
function $5a036e0bbbddc7fb$var$hg(a) {
    null === $5a036e0bbbddc7fb$var$eg ? $5a036e0bbbddc7fb$var$eg = [
        a
    ] : $5a036e0bbbddc7fb$var$eg.push(a);
}
function $5a036e0bbbddc7fb$var$ig(a) {
    $5a036e0bbbddc7fb$var$fg = !0;
    $5a036e0bbbddc7fb$var$hg(a);
}
function $5a036e0bbbddc7fb$var$jg() {
    if (!$5a036e0bbbddc7fb$var$gg && null !== $5a036e0bbbddc7fb$var$eg) {
        $5a036e0bbbddc7fb$var$gg = !0;
        var a = 0, b = $5a036e0bbbddc7fb$var$C;
        try {
            var c = $5a036e0bbbddc7fb$var$eg;
            for($5a036e0bbbddc7fb$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $5a036e0bbbddc7fb$var$eg = null;
            $5a036e0bbbddc7fb$var$fg = !1;
        } catch (e) {
            throw null !== $5a036e0bbbddc7fb$var$eg && ($5a036e0bbbddc7fb$var$eg = $5a036e0bbbddc7fb$var$eg.slice(a + 1)), $5a036e0bbbddc7fb$var$ac($5a036e0bbbddc7fb$var$fc, $5a036e0bbbddc7fb$var$jg), e;
        } finally{
            $5a036e0bbbddc7fb$var$C = b, $5a036e0bbbddc7fb$var$gg = !1;
        }
    }
    return null;
}
var $5a036e0bbbddc7fb$var$kg = [], $5a036e0bbbddc7fb$var$lg = 0, $5a036e0bbbddc7fb$var$mg = null, $5a036e0bbbddc7fb$var$ng = 0, $5a036e0bbbddc7fb$var$og = [], $5a036e0bbbddc7fb$var$pg = 0, $5a036e0bbbddc7fb$var$qg = null, $5a036e0bbbddc7fb$var$rg = 1, $5a036e0bbbddc7fb$var$sg = "";
function $5a036e0bbbddc7fb$var$tg(a, b) {
    $5a036e0bbbddc7fb$var$kg[$5a036e0bbbddc7fb$var$lg++] = $5a036e0bbbddc7fb$var$ng;
    $5a036e0bbbddc7fb$var$kg[$5a036e0bbbddc7fb$var$lg++] = $5a036e0bbbddc7fb$var$mg;
    $5a036e0bbbddc7fb$var$mg = a;
    $5a036e0bbbddc7fb$var$ng = b;
}
function $5a036e0bbbddc7fb$var$ug(a, b, c) {
    $5a036e0bbbddc7fb$var$og[$5a036e0bbbddc7fb$var$pg++] = $5a036e0bbbddc7fb$var$rg;
    $5a036e0bbbddc7fb$var$og[$5a036e0bbbddc7fb$var$pg++] = $5a036e0bbbddc7fb$var$sg;
    $5a036e0bbbddc7fb$var$og[$5a036e0bbbddc7fb$var$pg++] = $5a036e0bbbddc7fb$var$qg;
    $5a036e0bbbddc7fb$var$qg = a;
    var d = $5a036e0bbbddc7fb$var$rg;
    a = $5a036e0bbbddc7fb$var$sg;
    var e = 32 - $5a036e0bbbddc7fb$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $5a036e0bbbddc7fb$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $5a036e0bbbddc7fb$var$rg = 1 << 32 - $5a036e0bbbddc7fb$var$oc(b) + e | c << e | d;
        $5a036e0bbbddc7fb$var$sg = f + a;
    } else $5a036e0bbbddc7fb$var$rg = 1 << f | c << e | d, $5a036e0bbbddc7fb$var$sg = a;
}
function $5a036e0bbbddc7fb$var$vg(a) {
    null !== a.return && ($5a036e0bbbddc7fb$var$tg(a, 1), $5a036e0bbbddc7fb$var$ug(a, 1, 0));
}
function $5a036e0bbbddc7fb$var$wg(a) {
    for(; a === $5a036e0bbbddc7fb$var$mg;)$5a036e0bbbddc7fb$var$mg = $5a036e0bbbddc7fb$var$kg[--$5a036e0bbbddc7fb$var$lg], $5a036e0bbbddc7fb$var$kg[$5a036e0bbbddc7fb$var$lg] = null, $5a036e0bbbddc7fb$var$ng = $5a036e0bbbddc7fb$var$kg[--$5a036e0bbbddc7fb$var$lg], $5a036e0bbbddc7fb$var$kg[$5a036e0bbbddc7fb$var$lg] = null;
    for(; a === $5a036e0bbbddc7fb$var$qg;)$5a036e0bbbddc7fb$var$qg = $5a036e0bbbddc7fb$var$og[--$5a036e0bbbddc7fb$var$pg], $5a036e0bbbddc7fb$var$og[$5a036e0bbbddc7fb$var$pg] = null, $5a036e0bbbddc7fb$var$sg = $5a036e0bbbddc7fb$var$og[--$5a036e0bbbddc7fb$var$pg], $5a036e0bbbddc7fb$var$og[$5a036e0bbbddc7fb$var$pg] = null, $5a036e0bbbddc7fb$var$rg = $5a036e0bbbddc7fb$var$og[--$5a036e0bbbddc7fb$var$pg], $5a036e0bbbddc7fb$var$og[$5a036e0bbbddc7fb$var$pg] = null;
}
var $5a036e0bbbddc7fb$var$xg = null, $5a036e0bbbddc7fb$var$yg = null, $5a036e0bbbddc7fb$var$I = !1, $5a036e0bbbddc7fb$var$zg = null;
function $5a036e0bbbddc7fb$var$Ag(a, b) {
    var c = $5a036e0bbbddc7fb$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $5a036e0bbbddc7fb$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $5a036e0bbbddc7fb$var$xg = a, $5a036e0bbbddc7fb$var$yg = $5a036e0bbbddc7fb$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $5a036e0bbbddc7fb$var$xg = a, $5a036e0bbbddc7fb$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $5a036e0bbbddc7fb$var$qg ? {
                id: $5a036e0bbbddc7fb$var$rg,
                overflow: $5a036e0bbbddc7fb$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $5a036e0bbbddc7fb$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $5a036e0bbbddc7fb$var$xg = a, $5a036e0bbbddc7fb$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $5a036e0bbbddc7fb$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $5a036e0bbbddc7fb$var$Eg(a) {
    if ($5a036e0bbbddc7fb$var$I) {
        var b = $5a036e0bbbddc7fb$var$yg;
        if (b) {
            var c = b;
            if (!$5a036e0bbbddc7fb$var$Cg(a, b)) {
                if ($5a036e0bbbddc7fb$var$Dg(a)) throw Error($5a036e0bbbddc7fb$var$p(418));
                b = $5a036e0bbbddc7fb$var$Lf(c.nextSibling);
                var d = $5a036e0bbbddc7fb$var$xg;
                b && $5a036e0bbbddc7fb$var$Cg(a, b) ? $5a036e0bbbddc7fb$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $5a036e0bbbddc7fb$var$I = !1, $5a036e0bbbddc7fb$var$xg = a);
            }
        } else {
            if ($5a036e0bbbddc7fb$var$Dg(a)) throw Error($5a036e0bbbddc7fb$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $5a036e0bbbddc7fb$var$I = !1;
            $5a036e0bbbddc7fb$var$xg = a;
        }
    }
}
function $5a036e0bbbddc7fb$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $5a036e0bbbddc7fb$var$xg = a;
}
function $5a036e0bbbddc7fb$var$Gg(a) {
    if (a !== $5a036e0bbbddc7fb$var$xg) return !1;
    if (!$5a036e0bbbddc7fb$var$I) return $5a036e0bbbddc7fb$var$Fg(a), $5a036e0bbbddc7fb$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$5a036e0bbbddc7fb$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $5a036e0bbbddc7fb$var$yg)) {
        if ($5a036e0bbbddc7fb$var$Dg(a)) throw $5a036e0bbbddc7fb$var$Hg(), Error($5a036e0bbbddc7fb$var$p(418));
        for(; b;)$5a036e0bbbddc7fb$var$Ag(a, b), b = $5a036e0bbbddc7fb$var$Lf(b.nextSibling);
    }
    $5a036e0bbbddc7fb$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($5a036e0bbbddc7fb$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $5a036e0bbbddc7fb$var$yg = $5a036e0bbbddc7fb$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $5a036e0bbbddc7fb$var$yg = null;
        }
    } else $5a036e0bbbddc7fb$var$yg = $5a036e0bbbddc7fb$var$xg ? $5a036e0bbbddc7fb$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $5a036e0bbbddc7fb$var$Hg() {
    for(var a = $5a036e0bbbddc7fb$var$yg; a;)a = $5a036e0bbbddc7fb$var$Lf(a.nextSibling);
}
function $5a036e0bbbddc7fb$var$Ig() {
    $5a036e0bbbddc7fb$var$yg = $5a036e0bbbddc7fb$var$xg = null;
    $5a036e0bbbddc7fb$var$I = !1;
}
function $5a036e0bbbddc7fb$var$Jg(a) {
    null === $5a036e0bbbddc7fb$var$zg ? $5a036e0bbbddc7fb$var$zg = [
        a
    ] : $5a036e0bbbddc7fb$var$zg.push(a);
}
var $5a036e0bbbddc7fb$var$Kg = $5a036e0bbbddc7fb$var$ua.ReactCurrentBatchConfig;
function $5a036e0bbbddc7fb$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $5a036e0bbbddc7fb$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $5a036e0bbbddc7fb$var$Mg = $5a036e0bbbddc7fb$var$Uf(null), $5a036e0bbbddc7fb$var$Ng = null, $5a036e0bbbddc7fb$var$Og = null, $5a036e0bbbddc7fb$var$Pg = null;
function $5a036e0bbbddc7fb$var$Qg() {
    $5a036e0bbbddc7fb$var$Pg = $5a036e0bbbddc7fb$var$Og = $5a036e0bbbddc7fb$var$Ng = null;
}
function $5a036e0bbbddc7fb$var$Rg(a) {
    var b = $5a036e0bbbddc7fb$var$Mg.current;
    $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Mg);
    a._currentValue = b;
}
function $5a036e0bbbddc7fb$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $5a036e0bbbddc7fb$var$Tg(a, b) {
    $5a036e0bbbddc7fb$var$Ng = a;
    $5a036e0bbbddc7fb$var$Pg = $5a036e0bbbddc7fb$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($5a036e0bbbddc7fb$var$Ug = !0), a.firstContext = null);
}
function $5a036e0bbbddc7fb$var$Vg(a) {
    var b = a._currentValue;
    if ($5a036e0bbbddc7fb$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $5a036e0bbbddc7fb$var$Og) {
            if (null === $5a036e0bbbddc7fb$var$Ng) throw Error($5a036e0bbbddc7fb$var$p(308));
            $5a036e0bbbddc7fb$var$Og = a;
            $5a036e0bbbddc7fb$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $5a036e0bbbddc7fb$var$Og = $5a036e0bbbddc7fb$var$Og.next = a;
    }
    return b;
}
var $5a036e0bbbddc7fb$var$Wg = null;
function $5a036e0bbbddc7fb$var$Xg(a) {
    null === $5a036e0bbbddc7fb$var$Wg ? $5a036e0bbbddc7fb$var$Wg = [
        a
    ] : $5a036e0bbbddc7fb$var$Wg.push(a);
}
function $5a036e0bbbddc7fb$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $5a036e0bbbddc7fb$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $5a036e0bbbddc7fb$var$Zg(a, d);
}
function $5a036e0bbbddc7fb$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $5a036e0bbbddc7fb$var$$g = !1;
function $5a036e0bbbddc7fb$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $5a036e0bbbddc7fb$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $5a036e0bbbddc7fb$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $5a036e0bbbddc7fb$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($5a036e0bbbddc7fb$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $5a036e0bbbddc7fb$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $5a036e0bbbddc7fb$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $5a036e0bbbddc7fb$var$Zg(a, c);
}
function $5a036e0bbbddc7fb$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5a036e0bbbddc7fb$var$Cc(a, c);
    }
}
function $5a036e0bbbddc7fb$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $5a036e0bbbddc7fb$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $5a036e0bbbddc7fb$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $5a036e0bbbddc7fb$var$A({}, q, r);
                            break a;
                        case 2:
                            $5a036e0bbbddc7fb$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $5a036e0bbbddc7fb$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $5a036e0bbbddc7fb$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($5a036e0bbbddc7fb$var$p(191, e));
            e.call(d);
        }
    }
}
var $5a036e0bbbddc7fb$var$jh = (new $kVN77.Component).refs;
function $5a036e0bbbddc7fb$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $5a036e0bbbddc7fb$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $5a036e0bbbddc7fb$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $5a036e0bbbddc7fb$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $5a036e0bbbddc7fb$var$L(), e = $5a036e0bbbddc7fb$var$lh(a), f = $5a036e0bbbddc7fb$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5a036e0bbbddc7fb$var$dh(a, f, e);
        null !== b && ($5a036e0bbbddc7fb$var$mh(b, a, e, d), $5a036e0bbbddc7fb$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $5a036e0bbbddc7fb$var$L(), e = $5a036e0bbbddc7fb$var$lh(a), f = $5a036e0bbbddc7fb$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5a036e0bbbddc7fb$var$dh(a, f, e);
        null !== b && ($5a036e0bbbddc7fb$var$mh(b, a, e, d), $5a036e0bbbddc7fb$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $5a036e0bbbddc7fb$var$L(), d = $5a036e0bbbddc7fb$var$lh(a), e = $5a036e0bbbddc7fb$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $5a036e0bbbddc7fb$var$dh(a, e, d);
        null !== b && ($5a036e0bbbddc7fb$var$mh(b, a, d, c), $5a036e0bbbddc7fb$var$eh(b, a, d));
    }
};
function $5a036e0bbbddc7fb$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$5a036e0bbbddc7fb$var$Ie(c, d) || !$5a036e0bbbddc7fb$var$Ie(e, f) : !0;
}
function $5a036e0bbbddc7fb$var$ph(a, b, c) {
    var d = !1, e = $5a036e0bbbddc7fb$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $5a036e0bbbddc7fb$var$Vg(f) : (e = $5a036e0bbbddc7fb$var$Zf(b) ? $5a036e0bbbddc7fb$var$Xf : $5a036e0bbbddc7fb$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $5a036e0bbbddc7fb$var$Yf(a, e) : $5a036e0bbbddc7fb$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $5a036e0bbbddc7fb$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $5a036e0bbbddc7fb$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $5a036e0bbbddc7fb$var$nh.enqueueReplaceState(b, b.state, null);
}
function $5a036e0bbbddc7fb$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $5a036e0bbbddc7fb$var$jh;
    $5a036e0bbbddc7fb$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $5a036e0bbbddc7fb$var$Vg(f) : (f = $5a036e0bbbddc7fb$var$Zf(b) ? $5a036e0bbbddc7fb$var$Xf : $5a036e0bbbddc7fb$var$H.current, e.context = $5a036e0bbbddc7fb$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($5a036e0bbbddc7fb$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $5a036e0bbbddc7fb$var$nh.enqueueReplaceState(e, e.state, null), $5a036e0bbbddc7fb$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $5a036e0bbbddc7fb$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($5a036e0bbbddc7fb$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($5a036e0bbbddc7fb$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $5a036e0bbbddc7fb$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($5a036e0bbbddc7fb$var$p(284));
        if (!c._owner) throw Error($5a036e0bbbddc7fb$var$p(290, a));
    }
    return a;
}
function $5a036e0bbbddc7fb$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($5a036e0bbbddc7fb$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $5a036e0bbbddc7fb$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $5a036e0bbbddc7fb$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $5a036e0bbbddc7fb$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $5a036e0bbbddc7fb$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $5a036e0bbbddc7fb$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $5a036e0bbbddc7fb$var$Ha && $5a036e0bbbddc7fb$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $5a036e0bbbddc7fb$var$sh(a, b, c), d.return = a, d;
        d = $5a036e0bbbddc7fb$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $5a036e0bbbddc7fb$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $5a036e0bbbddc7fb$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $5a036e0bbbddc7fb$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $5a036e0bbbddc7fb$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $5a036e0bbbddc7fb$var$va:
                    return c = $5a036e0bbbddc7fb$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $5a036e0bbbddc7fb$var$sh(a, null, b), c.return = a, c;
                case $5a036e0bbbddc7fb$var$wa:
                    return b = $5a036e0bbbddc7fb$var$zh(b, a.mode, c), b.return = a, b;
                case $5a036e0bbbddc7fb$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($5a036e0bbbddc7fb$var$eb(b) || $5a036e0bbbddc7fb$var$Ka(b)) return b = $5a036e0bbbddc7fb$var$Ah(b, a.mode, c, null), b.return = a, b;
            $5a036e0bbbddc7fb$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $5a036e0bbbddc7fb$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $5a036e0bbbddc7fb$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $5a036e0bbbddc7fb$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($5a036e0bbbddc7fb$var$eb(c) || $5a036e0bbbddc7fb$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $5a036e0bbbddc7fb$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $5a036e0bbbddc7fb$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $5a036e0bbbddc7fb$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $5a036e0bbbddc7fb$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($5a036e0bbbddc7fb$var$eb(d) || $5a036e0bbbddc7fb$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $5a036e0bbbddc7fb$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $5a036e0bbbddc7fb$var$I && $5a036e0bbbddc7fb$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $5a036e0bbbddc7fb$var$I && $5a036e0bbbddc7fb$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $5a036e0bbbddc7fb$var$I && $5a036e0bbbddc7fb$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $5a036e0bbbddc7fb$var$Ka(h);
        if ("function" !== typeof l) throw Error($5a036e0bbbddc7fb$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($5a036e0bbbddc7fb$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $5a036e0bbbddc7fb$var$I && $5a036e0bbbddc7fb$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $5a036e0bbbddc7fb$var$I && $5a036e0bbbddc7fb$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $5a036e0bbbddc7fb$var$I && $5a036e0bbbddc7fb$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $5a036e0bbbddc7fb$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $5a036e0bbbddc7fb$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $5a036e0bbbddc7fb$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $5a036e0bbbddc7fb$var$Ha && $5a036e0bbbddc7fb$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $5a036e0bbbddc7fb$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $5a036e0bbbddc7fb$var$ya ? (d = $5a036e0bbbddc7fb$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $5a036e0bbbddc7fb$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $5a036e0bbbddc7fb$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $5a036e0bbbddc7fb$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $5a036e0bbbddc7fb$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $5a036e0bbbddc7fb$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($5a036e0bbbddc7fb$var$eb(f)) return n(a, d, f, h);
            if ($5a036e0bbbddc7fb$var$Ka(f)) return t(a, d, f, h);
            $5a036e0bbbddc7fb$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $5a036e0bbbddc7fb$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $5a036e0bbbddc7fb$var$Bh = $5a036e0bbbddc7fb$var$vh(!0), $5a036e0bbbddc7fb$var$Ch = $5a036e0bbbddc7fb$var$vh(!1), $5a036e0bbbddc7fb$var$Dh = {}, $5a036e0bbbddc7fb$var$Eh = $5a036e0bbbddc7fb$var$Uf($5a036e0bbbddc7fb$var$Dh), $5a036e0bbbddc7fb$var$Fh = $5a036e0bbbddc7fb$var$Uf($5a036e0bbbddc7fb$var$Dh), $5a036e0bbbddc7fb$var$Gh = $5a036e0bbbddc7fb$var$Uf($5a036e0bbbddc7fb$var$Dh);
function $5a036e0bbbddc7fb$var$Hh(a) {
    if (a === $5a036e0bbbddc7fb$var$Dh) throw Error($5a036e0bbbddc7fb$var$p(174));
    return a;
}
function $5a036e0bbbddc7fb$var$Ih(a, b) {
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Gh, b);
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Fh, a);
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Eh, $5a036e0bbbddc7fb$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $5a036e0bbbddc7fb$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $5a036e0bbbddc7fb$var$lb(b, a);
    }
    $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Eh);
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Eh, b);
}
function $5a036e0bbbddc7fb$var$Jh() {
    $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Eh);
    $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Fh);
    $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Gh);
}
function $5a036e0bbbddc7fb$var$Kh(a) {
    $5a036e0bbbddc7fb$var$Hh($5a036e0bbbddc7fb$var$Gh.current);
    var b = $5a036e0bbbddc7fb$var$Hh($5a036e0bbbddc7fb$var$Eh.current);
    var c = $5a036e0bbbddc7fb$var$lb(b, a.type);
    b !== c && ($5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Fh, a), $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Eh, c));
}
function $5a036e0bbbddc7fb$var$Lh(a) {
    $5a036e0bbbddc7fb$var$Fh.current === a && ($5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Eh), $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Fh));
}
var $5a036e0bbbddc7fb$var$M = $5a036e0bbbddc7fb$var$Uf(0);
function $5a036e0bbbddc7fb$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $5a036e0bbbddc7fb$var$Nh = [];
function $5a036e0bbbddc7fb$var$Oh() {
    for(var a = 0; a < $5a036e0bbbddc7fb$var$Nh.length; a++)$5a036e0bbbddc7fb$var$Nh[a]._workInProgressVersionPrimary = null;
    $5a036e0bbbddc7fb$var$Nh.length = 0;
}
var $5a036e0bbbddc7fb$var$Ph = $5a036e0bbbddc7fb$var$ua.ReactCurrentDispatcher, $5a036e0bbbddc7fb$var$Qh = $5a036e0bbbddc7fb$var$ua.ReactCurrentBatchConfig, $5a036e0bbbddc7fb$var$Rh = 0, $5a036e0bbbddc7fb$var$N = null, $5a036e0bbbddc7fb$var$O = null, $5a036e0bbbddc7fb$var$P = null, $5a036e0bbbddc7fb$var$Sh = !1, $5a036e0bbbddc7fb$var$Th = !1, $5a036e0bbbddc7fb$var$Uh = 0, $5a036e0bbbddc7fb$var$Vh = 0;
function $5a036e0bbbddc7fb$var$Q() {
    throw Error($5a036e0bbbddc7fb$var$p(321));
}
function $5a036e0bbbddc7fb$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$5a036e0bbbddc7fb$var$He(a[c], b[c])) return !1;
    return !0;
}
function $5a036e0bbbddc7fb$var$Xh(a, b, c, d, e, f) {
    $5a036e0bbbddc7fb$var$Rh = f;
    $5a036e0bbbddc7fb$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $5a036e0bbbddc7fb$var$Ph.current = null === a || null === a.memoizedState ? $5a036e0bbbddc7fb$var$Yh : $5a036e0bbbddc7fb$var$Zh;
    a = c(d, e);
    if ($5a036e0bbbddc7fb$var$Th) {
        f = 0;
        do {
            $5a036e0bbbddc7fb$var$Th = !1;
            $5a036e0bbbddc7fb$var$Uh = 0;
            if (25 <= f) throw Error($5a036e0bbbddc7fb$var$p(301));
            f += 1;
            $5a036e0bbbddc7fb$var$P = $5a036e0bbbddc7fb$var$O = null;
            b.updateQueue = null;
            $5a036e0bbbddc7fb$var$Ph.current = $5a036e0bbbddc7fb$var$$h;
            a = c(d, e);
        }while ($5a036e0bbbddc7fb$var$Th);
    }
    $5a036e0bbbddc7fb$var$Ph.current = $5a036e0bbbddc7fb$var$ai;
    b = null !== $5a036e0bbbddc7fb$var$O && null !== $5a036e0bbbddc7fb$var$O.next;
    $5a036e0bbbddc7fb$var$Rh = 0;
    $5a036e0bbbddc7fb$var$P = $5a036e0bbbddc7fb$var$O = $5a036e0bbbddc7fb$var$N = null;
    $5a036e0bbbddc7fb$var$Sh = !1;
    if (b) throw Error($5a036e0bbbddc7fb$var$p(300));
    return a;
}
function $5a036e0bbbddc7fb$var$bi() {
    var a = 0 !== $5a036e0bbbddc7fb$var$Uh;
    $5a036e0bbbddc7fb$var$Uh = 0;
    return a;
}
function $5a036e0bbbddc7fb$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $5a036e0bbbddc7fb$var$P ? $5a036e0bbbddc7fb$var$N.memoizedState = $5a036e0bbbddc7fb$var$P = a : $5a036e0bbbddc7fb$var$P = $5a036e0bbbddc7fb$var$P.next = a;
    return $5a036e0bbbddc7fb$var$P;
}
function $5a036e0bbbddc7fb$var$di() {
    if (null === $5a036e0bbbddc7fb$var$O) {
        var a = $5a036e0bbbddc7fb$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $5a036e0bbbddc7fb$var$O.next;
    var b = null === $5a036e0bbbddc7fb$var$P ? $5a036e0bbbddc7fb$var$N.memoizedState : $5a036e0bbbddc7fb$var$P.next;
    if (null !== b) $5a036e0bbbddc7fb$var$P = b, $5a036e0bbbddc7fb$var$O = a;
    else {
        if (null === a) throw Error($5a036e0bbbddc7fb$var$p(310));
        $5a036e0bbbddc7fb$var$O = a;
        a = {
            memoizedState: $5a036e0bbbddc7fb$var$O.memoizedState,
            baseState: $5a036e0bbbddc7fb$var$O.baseState,
            baseQueue: $5a036e0bbbddc7fb$var$O.baseQueue,
            queue: $5a036e0bbbddc7fb$var$O.queue,
            next: null
        };
        null === $5a036e0bbbddc7fb$var$P ? $5a036e0bbbddc7fb$var$N.memoizedState = $5a036e0bbbddc7fb$var$P = a : $5a036e0bbbddc7fb$var$P = $5a036e0bbbddc7fb$var$P.next = a;
    }
    return $5a036e0bbbddc7fb$var$P;
}
function $5a036e0bbbddc7fb$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $5a036e0bbbddc7fb$var$fi(a) {
    var b = $5a036e0bbbddc7fb$var$di(), c = b.queue;
    if (null === c) throw Error($5a036e0bbbddc7fb$var$p(311));
    c.lastRenderedReducer = a;
    var d = $5a036e0bbbddc7fb$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($5a036e0bbbddc7fb$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $5a036e0bbbddc7fb$var$N.lanes |= m;
                $5a036e0bbbddc7fb$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $5a036e0bbbddc7fb$var$He(d, b.memoizedState) || ($5a036e0bbbddc7fb$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $5a036e0bbbddc7fb$var$N.lanes |= f, $5a036e0bbbddc7fb$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $5a036e0bbbddc7fb$var$gi(a) {
    var b = $5a036e0bbbddc7fb$var$di(), c = b.queue;
    if (null === c) throw Error($5a036e0bbbddc7fb$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $5a036e0bbbddc7fb$var$He(f, b.memoizedState) || ($5a036e0bbbddc7fb$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $5a036e0bbbddc7fb$var$hi() {}
function $5a036e0bbbddc7fb$var$ii(a, b) {
    var c = $5a036e0bbbddc7fb$var$N, d = $5a036e0bbbddc7fb$var$di(), e = b(), f = !$5a036e0bbbddc7fb$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $5a036e0bbbddc7fb$var$Ug = !0);
    d = d.queue;
    $5a036e0bbbddc7fb$var$ji($5a036e0bbbddc7fb$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $5a036e0bbbddc7fb$var$P && $5a036e0bbbddc7fb$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $5a036e0bbbddc7fb$var$li(9, $5a036e0bbbddc7fb$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $5a036e0bbbddc7fb$var$R) throw Error($5a036e0bbbddc7fb$var$p(349));
        0 !== ($5a036e0bbbddc7fb$var$Rh & 30) || $5a036e0bbbddc7fb$var$ni(c, b, e);
    }
    return e;
}
function $5a036e0bbbddc7fb$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $5a036e0bbbddc7fb$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5a036e0bbbddc7fb$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $5a036e0bbbddc7fb$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $5a036e0bbbddc7fb$var$oi(b) && $5a036e0bbbddc7fb$var$pi(a);
}
function $5a036e0bbbddc7fb$var$ki(a, b, c) {
    return c(function() {
        $5a036e0bbbddc7fb$var$oi(b) && $5a036e0bbbddc7fb$var$pi(a);
    });
}
function $5a036e0bbbddc7fb$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$5a036e0bbbddc7fb$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $5a036e0bbbddc7fb$var$pi(a) {
    var b = $5a036e0bbbddc7fb$var$Zg(a, 1);
    null !== b && $5a036e0bbbddc7fb$var$mh(b, a, 1, -1);
}
function $5a036e0bbbddc7fb$var$qi(a) {
    var b = $5a036e0bbbddc7fb$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5a036e0bbbddc7fb$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $5a036e0bbbddc7fb$var$ri.bind(null, $5a036e0bbbddc7fb$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $5a036e0bbbddc7fb$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $5a036e0bbbddc7fb$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5a036e0bbbddc7fb$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $5a036e0bbbddc7fb$var$si() {
    return $5a036e0bbbddc7fb$var$di().memoizedState;
}
function $5a036e0bbbddc7fb$var$ti(a, b, c, d) {
    var e = $5a036e0bbbddc7fb$var$ci();
    $5a036e0bbbddc7fb$var$N.flags |= a;
    e.memoizedState = $5a036e0bbbddc7fb$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $5a036e0bbbddc7fb$var$ui(a, b, c, d) {
    var e = $5a036e0bbbddc7fb$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $5a036e0bbbddc7fb$var$O) {
        var g = $5a036e0bbbddc7fb$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $5a036e0bbbddc7fb$var$Wh(d, g.deps)) {
            e.memoizedState = $5a036e0bbbddc7fb$var$li(b, c, f, d);
            return;
        }
    }
    $5a036e0bbbddc7fb$var$N.flags |= a;
    e.memoizedState = $5a036e0bbbddc7fb$var$li(1 | b, c, f, d);
}
function $5a036e0bbbddc7fb$var$vi(a, b) {
    return $5a036e0bbbddc7fb$var$ti(8390656, 8, a, b);
}
function $5a036e0bbbddc7fb$var$ji(a, b) {
    return $5a036e0bbbddc7fb$var$ui(2048, 8, a, b);
}
function $5a036e0bbbddc7fb$var$wi(a, b) {
    return $5a036e0bbbddc7fb$var$ui(4, 2, a, b);
}
function $5a036e0bbbddc7fb$var$xi(a, b) {
    return $5a036e0bbbddc7fb$var$ui(4, 4, a, b);
}
function $5a036e0bbbddc7fb$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $5a036e0bbbddc7fb$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $5a036e0bbbddc7fb$var$ui(4, 4, $5a036e0bbbddc7fb$var$yi.bind(null, b, a), c);
}
function $5a036e0bbbddc7fb$var$Ai() {}
function $5a036e0bbbddc7fb$var$Bi(a, b) {
    var c = $5a036e0bbbddc7fb$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5a036e0bbbddc7fb$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5a036e0bbbddc7fb$var$Ci(a, b) {
    var c = $5a036e0bbbddc7fb$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5a036e0bbbddc7fb$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5a036e0bbbddc7fb$var$Di(a, b, c) {
    if (0 === ($5a036e0bbbddc7fb$var$Rh & 21)) return a.baseState && (a.baseState = !1, $5a036e0bbbddc7fb$var$Ug = !0), a.memoizedState = c;
    $5a036e0bbbddc7fb$var$He(c, b) || (c = $5a036e0bbbddc7fb$var$yc(), $5a036e0bbbddc7fb$var$N.lanes |= c, $5a036e0bbbddc7fb$var$hh |= c, a.baseState = !0);
    return b;
}
function $5a036e0bbbddc7fb$var$Ei(a, b) {
    var c = $5a036e0bbbddc7fb$var$C;
    $5a036e0bbbddc7fb$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $5a036e0bbbddc7fb$var$Qh.transition;
    $5a036e0bbbddc7fb$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $5a036e0bbbddc7fb$var$C = c, $5a036e0bbbddc7fb$var$Qh.transition = d;
    }
}
function $5a036e0bbbddc7fb$var$Fi() {
    return $5a036e0bbbddc7fb$var$di().memoizedState;
}
function $5a036e0bbbddc7fb$var$Gi(a, b, c) {
    var d = $5a036e0bbbddc7fb$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5a036e0bbbddc7fb$var$Hi(a)) $5a036e0bbbddc7fb$var$Ii(b, c);
    else if (c = $5a036e0bbbddc7fb$var$Yg(a, b, c, d), null !== c) {
        var e = $5a036e0bbbddc7fb$var$L();
        $5a036e0bbbddc7fb$var$mh(c, a, d, e);
        $5a036e0bbbddc7fb$var$Ji(c, b, d);
    }
}
function $5a036e0bbbddc7fb$var$ri(a, b, c) {
    var d = $5a036e0bbbddc7fb$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5a036e0bbbddc7fb$var$Hi(a)) $5a036e0bbbddc7fb$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($5a036e0bbbddc7fb$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $5a036e0bbbddc7fb$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $5a036e0bbbddc7fb$var$Yg(a, b, e, d);
        null !== c && (e = $5a036e0bbbddc7fb$var$L(), $5a036e0bbbddc7fb$var$mh(c, a, d, e), $5a036e0bbbddc7fb$var$Ji(c, b, d));
    }
}
function $5a036e0bbbddc7fb$var$Hi(a) {
    var b = a.alternate;
    return a === $5a036e0bbbddc7fb$var$N || null !== b && b === $5a036e0bbbddc7fb$var$N;
}
function $5a036e0bbbddc7fb$var$Ii(a, b) {
    $5a036e0bbbddc7fb$var$Th = $5a036e0bbbddc7fb$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $5a036e0bbbddc7fb$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5a036e0bbbddc7fb$var$Cc(a, c);
    }
}
var $5a036e0bbbddc7fb$var$ai = {
    readContext: $5a036e0bbbddc7fb$var$Vg,
    useCallback: $5a036e0bbbddc7fb$var$Q,
    useContext: $5a036e0bbbddc7fb$var$Q,
    useEffect: $5a036e0bbbddc7fb$var$Q,
    useImperativeHandle: $5a036e0bbbddc7fb$var$Q,
    useInsertionEffect: $5a036e0bbbddc7fb$var$Q,
    useLayoutEffect: $5a036e0bbbddc7fb$var$Q,
    useMemo: $5a036e0bbbddc7fb$var$Q,
    useReducer: $5a036e0bbbddc7fb$var$Q,
    useRef: $5a036e0bbbddc7fb$var$Q,
    useState: $5a036e0bbbddc7fb$var$Q,
    useDebugValue: $5a036e0bbbddc7fb$var$Q,
    useDeferredValue: $5a036e0bbbddc7fb$var$Q,
    useTransition: $5a036e0bbbddc7fb$var$Q,
    useMutableSource: $5a036e0bbbddc7fb$var$Q,
    useSyncExternalStore: $5a036e0bbbddc7fb$var$Q,
    useId: $5a036e0bbbddc7fb$var$Q,
    unstable_isNewReconciler: !1
}, $5a036e0bbbddc7fb$var$Yh = {
    readContext: $5a036e0bbbddc7fb$var$Vg,
    useCallback: function useCallback(a, b) {
        $5a036e0bbbddc7fb$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $5a036e0bbbddc7fb$var$Vg,
    useEffect: $5a036e0bbbddc7fb$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $5a036e0bbbddc7fb$var$ti(4194308, 4, $5a036e0bbbddc7fb$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $5a036e0bbbddc7fb$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $5a036e0bbbddc7fb$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $5a036e0bbbddc7fb$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $5a036e0bbbddc7fb$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $5a036e0bbbddc7fb$var$Gi.bind(null, $5a036e0bbbddc7fb$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $5a036e0bbbddc7fb$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $5a036e0bbbddc7fb$var$qi,
    useDebugValue: $5a036e0bbbddc7fb$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $5a036e0bbbddc7fb$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $5a036e0bbbddc7fb$var$qi(!1), b = a[0];
        a = $5a036e0bbbddc7fb$var$Ei.bind(null, a[1]);
        $5a036e0bbbddc7fb$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $5a036e0bbbddc7fb$var$N, e = $5a036e0bbbddc7fb$var$ci();
        if ($5a036e0bbbddc7fb$var$I) {
            if (void 0 === c) throw Error($5a036e0bbbddc7fb$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $5a036e0bbbddc7fb$var$R) throw Error($5a036e0bbbddc7fb$var$p(349));
            0 !== ($5a036e0bbbddc7fb$var$Rh & 30) || $5a036e0bbbddc7fb$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $5a036e0bbbddc7fb$var$vi($5a036e0bbbddc7fb$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $5a036e0bbbddc7fb$var$li(9, $5a036e0bbbddc7fb$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $5a036e0bbbddc7fb$var$ci(), b = $5a036e0bbbddc7fb$var$R.identifierPrefix;
        if ($5a036e0bbbddc7fb$var$I) {
            var c = $5a036e0bbbddc7fb$var$sg;
            var d = $5a036e0bbbddc7fb$var$rg;
            c = (d & ~(1 << 32 - $5a036e0bbbddc7fb$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $5a036e0bbbddc7fb$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $5a036e0bbbddc7fb$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $5a036e0bbbddc7fb$var$Zh = {
    readContext: $5a036e0bbbddc7fb$var$Vg,
    useCallback: $5a036e0bbbddc7fb$var$Bi,
    useContext: $5a036e0bbbddc7fb$var$Vg,
    useEffect: $5a036e0bbbddc7fb$var$ji,
    useImperativeHandle: $5a036e0bbbddc7fb$var$zi,
    useInsertionEffect: $5a036e0bbbddc7fb$var$wi,
    useLayoutEffect: $5a036e0bbbddc7fb$var$xi,
    useMemo: $5a036e0bbbddc7fb$var$Ci,
    useReducer: $5a036e0bbbddc7fb$var$fi,
    useRef: $5a036e0bbbddc7fb$var$si,
    useState: function useState() {
        return $5a036e0bbbddc7fb$var$fi($5a036e0bbbddc7fb$var$ei);
    },
    useDebugValue: $5a036e0bbbddc7fb$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $5a036e0bbbddc7fb$var$di();
        return $5a036e0bbbddc7fb$var$Di(b, $5a036e0bbbddc7fb$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $5a036e0bbbddc7fb$var$fi($5a036e0bbbddc7fb$var$ei)[0], b = $5a036e0bbbddc7fb$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5a036e0bbbddc7fb$var$hi,
    useSyncExternalStore: $5a036e0bbbddc7fb$var$ii,
    useId: $5a036e0bbbddc7fb$var$Fi,
    unstable_isNewReconciler: !1
}, $5a036e0bbbddc7fb$var$$h = {
    readContext: $5a036e0bbbddc7fb$var$Vg,
    useCallback: $5a036e0bbbddc7fb$var$Bi,
    useContext: $5a036e0bbbddc7fb$var$Vg,
    useEffect: $5a036e0bbbddc7fb$var$ji,
    useImperativeHandle: $5a036e0bbbddc7fb$var$zi,
    useInsertionEffect: $5a036e0bbbddc7fb$var$wi,
    useLayoutEffect: $5a036e0bbbddc7fb$var$xi,
    useMemo: $5a036e0bbbddc7fb$var$Ci,
    useReducer: $5a036e0bbbddc7fb$var$gi,
    useRef: $5a036e0bbbddc7fb$var$si,
    useState: function useState() {
        return $5a036e0bbbddc7fb$var$gi($5a036e0bbbddc7fb$var$ei);
    },
    useDebugValue: $5a036e0bbbddc7fb$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $5a036e0bbbddc7fb$var$di();
        return null === $5a036e0bbbddc7fb$var$O ? b.memoizedState = a : $5a036e0bbbddc7fb$var$Di(b, $5a036e0bbbddc7fb$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $5a036e0bbbddc7fb$var$gi($5a036e0bbbddc7fb$var$ei)[0], b = $5a036e0bbbddc7fb$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5a036e0bbbddc7fb$var$hi,
    useSyncExternalStore: $5a036e0bbbddc7fb$var$ii,
    useId: $5a036e0bbbddc7fb$var$Fi,
    unstable_isNewReconciler: !1
};
function $5a036e0bbbddc7fb$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $5a036e0bbbddc7fb$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $5a036e0bbbddc7fb$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $5a036e0bbbddc7fb$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $5a036e0bbbddc7fb$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $5a036e0bbbddc7fb$var$Oi(a, b, c) {
    c = $5a036e0bbbddc7fb$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $5a036e0bbbddc7fb$var$Pi || ($5a036e0bbbddc7fb$var$Pi = !0, $5a036e0bbbddc7fb$var$Qi = d);
        $5a036e0bbbddc7fb$var$Mi(a, b);
    };
    return c;
}
function $5a036e0bbbddc7fb$var$Ri(a, b, c) {
    c = $5a036e0bbbddc7fb$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $5a036e0bbbddc7fb$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $5a036e0bbbddc7fb$var$Mi(a, b);
        "function" !== typeof d && (null === $5a036e0bbbddc7fb$var$Si ? $5a036e0bbbddc7fb$var$Si = new Set([
            this
        ]) : $5a036e0bbbddc7fb$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $5a036e0bbbddc7fb$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $5a036e0bbbddc7fb$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $5a036e0bbbddc7fb$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $5a036e0bbbddc7fb$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $5a036e0bbbddc7fb$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $5a036e0bbbddc7fb$var$ch(-1, 1), b.tag = 2, $5a036e0bbbddc7fb$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $5a036e0bbbddc7fb$var$Xi = $5a036e0bbbddc7fb$var$ua.ReactCurrentOwner, $5a036e0bbbddc7fb$var$Ug = !1;
function $5a036e0bbbddc7fb$var$Yi(a, b, c, d) {
    b.child = null === a ? $5a036e0bbbddc7fb$var$Ch(b, null, c, d) : $5a036e0bbbddc7fb$var$Bh(b, a.child, c, d);
}
function $5a036e0bbbddc7fb$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $5a036e0bbbddc7fb$var$Tg(b, e);
    d = $5a036e0bbbddc7fb$var$Xh(a, b, c, d, f, e);
    c = $5a036e0bbbddc7fb$var$bi();
    if (null !== a && !$5a036e0bbbddc7fb$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5a036e0bbbddc7fb$var$$i(a, b, e);
    $5a036e0bbbddc7fb$var$I && c && $5a036e0bbbddc7fb$var$vg(b);
    b.flags |= 1;
    $5a036e0bbbddc7fb$var$Yi(a, b, d, e);
    return b.child;
}
function $5a036e0bbbddc7fb$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$5a036e0bbbddc7fb$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $5a036e0bbbddc7fb$var$cj(a, b, f, d, e);
        a = $5a036e0bbbddc7fb$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $5a036e0bbbddc7fb$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $5a036e0bbbddc7fb$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $5a036e0bbbddc7fb$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $5a036e0bbbddc7fb$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($5a036e0bbbddc7fb$var$Ie(f, d) && a.ref === b.ref) {
            if ($5a036e0bbbddc7fb$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($5a036e0bbbddc7fb$var$Ug = !0);
            else return b.lanes = a.lanes, $5a036e0bbbddc7fb$var$$i(a, b, e);
        }
    }
    return $5a036e0bbbddc7fb$var$dj(a, b, c, d, e);
}
function $5a036e0bbbddc7fb$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$fj, $5a036e0bbbddc7fb$var$gj), $5a036e0bbbddc7fb$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$fj, $5a036e0bbbddc7fb$var$gj), $5a036e0bbbddc7fb$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$fj, $5a036e0bbbddc7fb$var$gj);
            $5a036e0bbbddc7fb$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$fj, $5a036e0bbbddc7fb$var$gj), $5a036e0bbbddc7fb$var$gj |= d;
    $5a036e0bbbddc7fb$var$Yi(a, b, e, c);
    return b.child;
}
function $5a036e0bbbddc7fb$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $5a036e0bbbddc7fb$var$dj(a, b, c, d, e) {
    var f = $5a036e0bbbddc7fb$var$Zf(c) ? $5a036e0bbbddc7fb$var$Xf : $5a036e0bbbddc7fb$var$H.current;
    f = $5a036e0bbbddc7fb$var$Yf(b, f);
    $5a036e0bbbddc7fb$var$Tg(b, e);
    c = $5a036e0bbbddc7fb$var$Xh(a, b, c, d, f, e);
    d = $5a036e0bbbddc7fb$var$bi();
    if (null !== a && !$5a036e0bbbddc7fb$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5a036e0bbbddc7fb$var$$i(a, b, e);
    $5a036e0bbbddc7fb$var$I && d && $5a036e0bbbddc7fb$var$vg(b);
    b.flags |= 1;
    $5a036e0bbbddc7fb$var$Yi(a, b, c, e);
    return b.child;
}
function $5a036e0bbbddc7fb$var$ij(a, b, c, d, e) {
    if ($5a036e0bbbddc7fb$var$Zf(c)) {
        var f = !0;
        $5a036e0bbbddc7fb$var$cg(b);
    } else f = !1;
    $5a036e0bbbddc7fb$var$Tg(b, e);
    if (null === b.stateNode) $5a036e0bbbddc7fb$var$jj(a, b), $5a036e0bbbddc7fb$var$ph(b, c, d), $5a036e0bbbddc7fb$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $5a036e0bbbddc7fb$var$Vg(l) : (l = $5a036e0bbbddc7fb$var$Zf(c) ? $5a036e0bbbddc7fb$var$Xf : $5a036e0bbbddc7fb$var$H.current, l = $5a036e0bbbddc7fb$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $5a036e0bbbddc7fb$var$qh(b, g, d, l);
        $5a036e0bbbddc7fb$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $5a036e0bbbddc7fb$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $5a036e0bbbddc7fb$var$Wf.current || $5a036e0bbbddc7fb$var$$g ? ("function" === typeof m && ($5a036e0bbbddc7fb$var$kh(b, c, m, d), k = b.memoizedState), (h = $5a036e0bbbddc7fb$var$$g || $5a036e0bbbddc7fb$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $5a036e0bbbddc7fb$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $5a036e0bbbddc7fb$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $5a036e0bbbddc7fb$var$Vg(k) : (k = $5a036e0bbbddc7fb$var$Zf(c) ? $5a036e0bbbddc7fb$var$Xf : $5a036e0bbbddc7fb$var$H.current, k = $5a036e0bbbddc7fb$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $5a036e0bbbddc7fb$var$qh(b, g, d, k);
        $5a036e0bbbddc7fb$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $5a036e0bbbddc7fb$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $5a036e0bbbddc7fb$var$Wf.current || $5a036e0bbbddc7fb$var$$g ? ("function" === typeof y && ($5a036e0bbbddc7fb$var$kh(b, c, y, d), n = b.memoizedState), (l = $5a036e0bbbddc7fb$var$$g || $5a036e0bbbddc7fb$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $5a036e0bbbddc7fb$var$kj(a, b, c, d, f, e);
}
function $5a036e0bbbddc7fb$var$kj(a, b, c, d, e, f) {
    $5a036e0bbbddc7fb$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $5a036e0bbbddc7fb$var$dg(b, c, !1), $5a036e0bbbddc7fb$var$$i(a, b, f);
    d = b.stateNode;
    $5a036e0bbbddc7fb$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $5a036e0bbbddc7fb$var$Bh(b, a.child, null, f), b.child = $5a036e0bbbddc7fb$var$Bh(b, null, h, f)) : $5a036e0bbbddc7fb$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $5a036e0bbbddc7fb$var$dg(b, c, !0);
    return b.child;
}
function $5a036e0bbbddc7fb$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $5a036e0bbbddc7fb$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $5a036e0bbbddc7fb$var$ag(a, b.context, !1);
    $5a036e0bbbddc7fb$var$Ih(a, b.containerInfo);
}
function $5a036e0bbbddc7fb$var$mj(a, b, c, d, e) {
    $5a036e0bbbddc7fb$var$Ig();
    $5a036e0bbbddc7fb$var$Jg(e);
    b.flags |= 256;
    $5a036e0bbbddc7fb$var$Yi(a, b, c, d);
    return b.child;
}
var $5a036e0bbbddc7fb$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $5a036e0bbbddc7fb$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $5a036e0bbbddc7fb$var$pj(a, b, c) {
    var d = b.pendingProps, e = $5a036e0bbbddc7fb$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$M, e & 1);
    if (null === a) {
        $5a036e0bbbddc7fb$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $5a036e0bbbddc7fb$var$qj(g, d, 0, null), a = $5a036e0bbbddc7fb$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $5a036e0bbbddc7fb$var$oj(c), b.memoizedState = $5a036e0bbbddc7fb$var$nj, a) : $5a036e0bbbddc7fb$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $5a036e0bbbddc7fb$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $5a036e0bbbddc7fb$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $5a036e0bbbddc7fb$var$wh(h, f) : (f = $5a036e0bbbddc7fb$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $5a036e0bbbddc7fb$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $5a036e0bbbddc7fb$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $5a036e0bbbddc7fb$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $5a036e0bbbddc7fb$var$rj(a, b) {
    b = $5a036e0bbbddc7fb$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $5a036e0bbbddc7fb$var$tj(a, b, c, d) {
    null !== d && $5a036e0bbbddc7fb$var$Jg(d);
    $5a036e0bbbddc7fb$var$Bh(b, a.child, null, c);
    a = $5a036e0bbbddc7fb$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $5a036e0bbbddc7fb$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $5a036e0bbbddc7fb$var$Li(Error($5a036e0bbbddc7fb$var$p(422))), $5a036e0bbbddc7fb$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $5a036e0bbbddc7fb$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $5a036e0bbbddc7fb$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $5a036e0bbbddc7fb$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $5a036e0bbbddc7fb$var$oj(g);
        b.memoizedState = $5a036e0bbbddc7fb$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $5a036e0bbbddc7fb$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($5a036e0bbbddc7fb$var$p(419));
        d = $5a036e0bbbddc7fb$var$Li(f, d, void 0);
        return $5a036e0bbbddc7fb$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($5a036e0bbbddc7fb$var$Ug || h) {
        d = $5a036e0bbbddc7fb$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $5a036e0bbbddc7fb$var$Zg(a, e), $5a036e0bbbddc7fb$var$mh(d, a, e, -1));
        }
        $5a036e0bbbddc7fb$var$uj();
        d = $5a036e0bbbddc7fb$var$Li(Error($5a036e0bbbddc7fb$var$p(421)));
        return $5a036e0bbbddc7fb$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $5a036e0bbbddc7fb$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $5a036e0bbbddc7fb$var$yg = $5a036e0bbbddc7fb$var$Lf(e.nextSibling);
    $5a036e0bbbddc7fb$var$xg = b;
    $5a036e0bbbddc7fb$var$I = !0;
    $5a036e0bbbddc7fb$var$zg = null;
    null !== a && ($5a036e0bbbddc7fb$var$og[$5a036e0bbbddc7fb$var$pg++] = $5a036e0bbbddc7fb$var$rg, $5a036e0bbbddc7fb$var$og[$5a036e0bbbddc7fb$var$pg++] = $5a036e0bbbddc7fb$var$sg, $5a036e0bbbddc7fb$var$og[$5a036e0bbbddc7fb$var$pg++] = $5a036e0bbbddc7fb$var$qg, $5a036e0bbbddc7fb$var$rg = a.id, $5a036e0bbbddc7fb$var$sg = a.overflow, $5a036e0bbbddc7fb$var$qg = b);
    b = $5a036e0bbbddc7fb$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $5a036e0bbbddc7fb$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $5a036e0bbbddc7fb$var$Sg(a.return, b, c);
}
function $5a036e0bbbddc7fb$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $5a036e0bbbddc7fb$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $5a036e0bbbddc7fb$var$Yi(a, b, d.children, c);
    d = $5a036e0bbbddc7fb$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $5a036e0bbbddc7fb$var$wj(a, c, b);
            else if (19 === a.tag) $5a036e0bbbddc7fb$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $5a036e0bbbddc7fb$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $5a036e0bbbddc7fb$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $5a036e0bbbddc7fb$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $5a036e0bbbddc7fb$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $5a036e0bbbddc7fb$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $5a036e0bbbddc7fb$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $5a036e0bbbddc7fb$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $5a036e0bbbddc7fb$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($5a036e0bbbddc7fb$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $5a036e0bbbddc7fb$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $5a036e0bbbddc7fb$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $5a036e0bbbddc7fb$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $5a036e0bbbddc7fb$var$lj(b);
            $5a036e0bbbddc7fb$var$Ig();
            break;
        case 5:
            $5a036e0bbbddc7fb$var$Kh(b);
            break;
        case 1:
            $5a036e0bbbddc7fb$var$Zf(b.type) && $5a036e0bbbddc7fb$var$cg(b);
            break;
        case 4:
            $5a036e0bbbddc7fb$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$M, $5a036e0bbbddc7fb$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $5a036e0bbbddc7fb$var$pj(a, b, c);
                $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$M, $5a036e0bbbddc7fb$var$M.current & 1);
                a = $5a036e0bbbddc7fb$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$M, $5a036e0bbbddc7fb$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $5a036e0bbbddc7fb$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$M, $5a036e0bbbddc7fb$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $5a036e0bbbddc7fb$var$ej(a, b, c);
    }
    return $5a036e0bbbddc7fb$var$$i(a, b, c);
}
var $5a036e0bbbddc7fb$var$Aj, $5a036e0bbbddc7fb$var$Bj, $5a036e0bbbddc7fb$var$Cj, $5a036e0bbbddc7fb$var$Dj;
$5a036e0bbbddc7fb$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$5a036e0bbbddc7fb$var$Bj = function Bj() {};
$5a036e0bbbddc7fb$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $5a036e0bbbddc7fb$var$Hh($5a036e0bbbddc7fb$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $5a036e0bbbddc7fb$var$Ya(a, e);
                d = $5a036e0bbbddc7fb$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $5a036e0bbbddc7fb$var$A({}, e, {
                    value: void 0
                });
                d = $5a036e0bbbddc7fb$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $5a036e0bbbddc7fb$var$gb(a, e);
                d = $5a036e0bbbddc7fb$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $5a036e0bbbddc7fb$var$Bf);
        }
        $5a036e0bbbddc7fb$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($5a036e0bbbddc7fb$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($5a036e0bbbddc7fb$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $5a036e0bbbddc7fb$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$5a036e0bbbddc7fb$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $5a036e0bbbddc7fb$var$Ej(a, b) {
    if (!$5a036e0bbbddc7fb$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $5a036e0bbbddc7fb$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $5a036e0bbbddc7fb$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $5a036e0bbbddc7fb$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $5a036e0bbbddc7fb$var$S(b), null;
        case 1:
            return $5a036e0bbbddc7fb$var$Zf(b.type) && $5a036e0bbbddc7fb$var$$f(), $5a036e0bbbddc7fb$var$S(b), null;
        case 3:
            d = b.stateNode;
            $5a036e0bbbddc7fb$var$Jh();
            $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Wf);
            $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$H);
            $5a036e0bbbddc7fb$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $5a036e0bbbddc7fb$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $5a036e0bbbddc7fb$var$zg && ($5a036e0bbbddc7fb$var$Gj($5a036e0bbbddc7fb$var$zg), $5a036e0bbbddc7fb$var$zg = null));
            $5a036e0bbbddc7fb$var$Bj(a, b);
            $5a036e0bbbddc7fb$var$S(b);
            return null;
        case 5:
            $5a036e0bbbddc7fb$var$Lh(b);
            var e = $5a036e0bbbddc7fb$var$Hh($5a036e0bbbddc7fb$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $5a036e0bbbddc7fb$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($5a036e0bbbddc7fb$var$p(166));
                    $5a036e0bbbddc7fb$var$S(b);
                    return null;
                }
                a = $5a036e0bbbddc7fb$var$Hh($5a036e0bbbddc7fb$var$Eh.current);
                if ($5a036e0bbbddc7fb$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$5a036e0bbbddc7fb$var$Of] = b;
                    d[$5a036e0bbbddc7fb$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $5a036e0bbbddc7fb$var$D("cancel", d);
                            $5a036e0bbbddc7fb$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $5a036e0bbbddc7fb$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $5a036e0bbbddc7fb$var$lf.length; e++)$5a036e0bbbddc7fb$var$D($5a036e0bbbddc7fb$var$lf[e], d);
                            break;
                        case "source":
                            $5a036e0bbbddc7fb$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $5a036e0bbbddc7fb$var$D("error", d);
                            $5a036e0bbbddc7fb$var$D("load", d);
                            break;
                        case "details":
                            $5a036e0bbbddc7fb$var$D("toggle", d);
                            break;
                        case "input":
                            $5a036e0bbbddc7fb$var$Za(d, f);
                            $5a036e0bbbddc7fb$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $5a036e0bbbddc7fb$var$D("invalid", d);
                            break;
                        case "textarea":
                            $5a036e0bbbddc7fb$var$hb(d, f), $5a036e0bbbddc7fb$var$D("invalid", d);
                    }
                    $5a036e0bbbddc7fb$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $5a036e0bbbddc7fb$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $5a036e0bbbddc7fb$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $5a036e0bbbddc7fb$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $5a036e0bbbddc7fb$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $5a036e0bbbddc7fb$var$Va(d);
                            $5a036e0bbbddc7fb$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $5a036e0bbbddc7fb$var$Va(d);
                            $5a036e0bbbddc7fb$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $5a036e0bbbddc7fb$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $5a036e0bbbddc7fb$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$5a036e0bbbddc7fb$var$Of] = b;
                    a[$5a036e0bbbddc7fb$var$Pf] = d;
                    $5a036e0bbbddc7fb$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $5a036e0bbbddc7fb$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $5a036e0bbbddc7fb$var$D("cancel", a);
                                $5a036e0bbbddc7fb$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $5a036e0bbbddc7fb$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $5a036e0bbbddc7fb$var$lf.length; e++)$5a036e0bbbddc7fb$var$D($5a036e0bbbddc7fb$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $5a036e0bbbddc7fb$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $5a036e0bbbddc7fb$var$D("error", a);
                                $5a036e0bbbddc7fb$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $5a036e0bbbddc7fb$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $5a036e0bbbddc7fb$var$Za(a, d);
                                e = $5a036e0bbbddc7fb$var$Ya(a, d);
                                $5a036e0bbbddc7fb$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $5a036e0bbbddc7fb$var$A({}, d, {
                                    value: void 0
                                });
                                $5a036e0bbbddc7fb$var$D("invalid", a);
                                break;
                            case "textarea":
                                $5a036e0bbbddc7fb$var$hb(a, d);
                                e = $5a036e0bbbddc7fb$var$gb(a, d);
                                $5a036e0bbbddc7fb$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $5a036e0bbbddc7fb$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $5a036e0bbbddc7fb$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $5a036e0bbbddc7fb$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $5a036e0bbbddc7fb$var$ob(a, k) : "number" === typeof k && $5a036e0bbbddc7fb$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($5a036e0bbbddc7fb$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $5a036e0bbbddc7fb$var$D("scroll", a) : null != k && $5a036e0bbbddc7fb$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $5a036e0bbbddc7fb$var$Va(a);
                                $5a036e0bbbddc7fb$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $5a036e0bbbddc7fb$var$Va(a);
                                $5a036e0bbbddc7fb$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $5a036e0bbbddc7fb$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $5a036e0bbbddc7fb$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $5a036e0bbbddc7fb$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $5a036e0bbbddc7fb$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $5a036e0bbbddc7fb$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $5a036e0bbbddc7fb$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($5a036e0bbbddc7fb$var$p(166));
                c = $5a036e0bbbddc7fb$var$Hh($5a036e0bbbddc7fb$var$Gh.current);
                $5a036e0bbbddc7fb$var$Hh($5a036e0bbbddc7fb$var$Eh.current);
                if ($5a036e0bbbddc7fb$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$5a036e0bbbddc7fb$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $5a036e0bbbddc7fb$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $5a036e0bbbddc7fb$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $5a036e0bbbddc7fb$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$5a036e0bbbddc7fb$var$Of] = b, b.stateNode = d;
            }
            $5a036e0bbbddc7fb$var$S(b);
            return null;
        case 13:
            $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($5a036e0bbbddc7fb$var$I && null !== $5a036e0bbbddc7fb$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $5a036e0bbbddc7fb$var$Hg(), $5a036e0bbbddc7fb$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $5a036e0bbbddc7fb$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($5a036e0bbbddc7fb$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($5a036e0bbbddc7fb$var$p(317));
                        f[$5a036e0bbbddc7fb$var$Of] = b;
                    } else $5a036e0bbbddc7fb$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $5a036e0bbbddc7fb$var$S(b);
                    f = !1;
                } else null !== $5a036e0bbbddc7fb$var$zg && ($5a036e0bbbddc7fb$var$Gj($5a036e0bbbddc7fb$var$zg), $5a036e0bbbddc7fb$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($5a036e0bbbddc7fb$var$M.current & 1) ? 0 === $5a036e0bbbddc7fb$var$T && ($5a036e0bbbddc7fb$var$T = 3) : $5a036e0bbbddc7fb$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $5a036e0bbbddc7fb$var$S(b);
            return null;
        case 4:
            return $5a036e0bbbddc7fb$var$Jh(), $5a036e0bbbddc7fb$var$Bj(a, b), null === a && $5a036e0bbbddc7fb$var$sf(b.stateNode.containerInfo), $5a036e0bbbddc7fb$var$S(b), null;
        case 10:
            return $5a036e0bbbddc7fb$var$Rg(b.type._context), $5a036e0bbbddc7fb$var$S(b), null;
        case 17:
            return $5a036e0bbbddc7fb$var$Zf(b.type) && $5a036e0bbbddc7fb$var$$f(), $5a036e0bbbddc7fb$var$S(b), null;
        case 19:
            $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$M);
            f = b.memoizedState;
            if (null === f) return $5a036e0bbbddc7fb$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $5a036e0bbbddc7fb$var$Ej(f, !1);
                else {
                    if (0 !== $5a036e0bbbddc7fb$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $5a036e0bbbddc7fb$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $5a036e0bbbddc7fb$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$M, $5a036e0bbbddc7fb$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $5a036e0bbbddc7fb$var$B() > $5a036e0bbbddc7fb$var$Hj && (b.flags |= 128, d = !0, $5a036e0bbbddc7fb$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $5a036e0bbbddc7fb$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $5a036e0bbbddc7fb$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$5a036e0bbbddc7fb$var$I) return $5a036e0bbbddc7fb$var$S(b), null;
                    } else 2 * $5a036e0bbbddc7fb$var$B() - f.renderingStartTime > $5a036e0bbbddc7fb$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $5a036e0bbbddc7fb$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $5a036e0bbbddc7fb$var$B(), b.sibling = null, c = $5a036e0bbbddc7fb$var$M.current, $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$M, d ? c & 1 | 2 : c & 1), b;
            $5a036e0bbbddc7fb$var$S(b);
            return null;
        case 22:
        case 23:
            return $5a036e0bbbddc7fb$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($5a036e0bbbddc7fb$var$gj & 1073741824) && ($5a036e0bbbddc7fb$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $5a036e0bbbddc7fb$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($5a036e0bbbddc7fb$var$p(156, b.tag));
}
function $5a036e0bbbddc7fb$var$Jj(a, b) {
    $5a036e0bbbddc7fb$var$wg(b);
    switch(b.tag){
        case 1:
            return $5a036e0bbbddc7fb$var$Zf(b.type) && $5a036e0bbbddc7fb$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $5a036e0bbbddc7fb$var$Jh(), $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Wf), $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$H), $5a036e0bbbddc7fb$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $5a036e0bbbddc7fb$var$Lh(b), null;
        case 13:
            $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($5a036e0bbbddc7fb$var$p(340));
                $5a036e0bbbddc7fb$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$M), null;
        case 4:
            return $5a036e0bbbddc7fb$var$Jh(), null;
        case 10:
            return $5a036e0bbbddc7fb$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $5a036e0bbbddc7fb$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $5a036e0bbbddc7fb$var$Kj = !1, $5a036e0bbbddc7fb$var$U = !1, $5a036e0bbbddc7fb$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $5a036e0bbbddc7fb$var$V = null;
function $5a036e0bbbddc7fb$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $5a036e0bbbddc7fb$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $5a036e0bbbddc7fb$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $5a036e0bbbddc7fb$var$W(a, b, d);
    }
}
var $5a036e0bbbddc7fb$var$Oj = !1;
function $5a036e0bbbddc7fb$var$Pj(a, b) {
    $5a036e0bbbddc7fb$var$Cf = $5a036e0bbbddc7fb$var$dd;
    a = $5a036e0bbbddc7fb$var$Me();
    if ($5a036e0bbbddc7fb$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $5a036e0bbbddc7fb$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $5a036e0bbbddc7fb$var$dd = !1;
    for($5a036e0bbbddc7fb$var$V = b; null !== $5a036e0bbbddc7fb$var$V;)if (b = $5a036e0bbbddc7fb$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $5a036e0bbbddc7fb$var$V = a;
    else for(; null !== $5a036e0bbbddc7fb$var$V;){
        b = $5a036e0bbbddc7fb$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $5a036e0bbbddc7fb$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($5a036e0bbbddc7fb$var$p(163));
            }
        } catch (F) {
            $5a036e0bbbddc7fb$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $5a036e0bbbddc7fb$var$V = a;
            break;
        }
        $5a036e0bbbddc7fb$var$V = b.return;
    }
    n = $5a036e0bbbddc7fb$var$Oj;
    $5a036e0bbbddc7fb$var$Oj = !1;
    return n;
}
function $5a036e0bbbddc7fb$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $5a036e0bbbddc7fb$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $5a036e0bbbddc7fb$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $5a036e0bbbddc7fb$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $5a036e0bbbddc7fb$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $5a036e0bbbddc7fb$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$5a036e0bbbddc7fb$var$Of], delete b[$5a036e0bbbddc7fb$var$Pf], delete b[$5a036e0bbbddc7fb$var$of], delete b[$5a036e0bbbddc7fb$var$Qf], delete b[$5a036e0bbbddc7fb$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $5a036e0bbbddc7fb$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $5a036e0bbbddc7fb$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $5a036e0bbbddc7fb$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $5a036e0bbbddc7fb$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $5a036e0bbbddc7fb$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($5a036e0bbbddc7fb$var$Wj(a, b, c), a = a.sibling; null !== a;)$5a036e0bbbddc7fb$var$Wj(a, b, c), a = a.sibling;
}
function $5a036e0bbbddc7fb$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($5a036e0bbbddc7fb$var$Xj(a, b, c), a = a.sibling; null !== a;)$5a036e0bbbddc7fb$var$Xj(a, b, c), a = a.sibling;
}
var $5a036e0bbbddc7fb$var$X = null, $5a036e0bbbddc7fb$var$Yj = !1;
function $5a036e0bbbddc7fb$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$5a036e0bbbddc7fb$var$ak(a, b, c), c = c.sibling;
}
function $5a036e0bbbddc7fb$var$ak(a, b, c) {
    if ($5a036e0bbbddc7fb$var$lc && "function" === typeof $5a036e0bbbddc7fb$var$lc.onCommitFiberUnmount) try {
        $5a036e0bbbddc7fb$var$lc.onCommitFiberUnmount($5a036e0bbbddc7fb$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $5a036e0bbbddc7fb$var$U || $5a036e0bbbddc7fb$var$Mj(c, b);
        case 6:
            var d = $5a036e0bbbddc7fb$var$X, e = $5a036e0bbbddc7fb$var$Yj;
            $5a036e0bbbddc7fb$var$X = null;
            $5a036e0bbbddc7fb$var$Zj(a, b, c);
            $5a036e0bbbddc7fb$var$X = d;
            $5a036e0bbbddc7fb$var$Yj = e;
            null !== $5a036e0bbbddc7fb$var$X && ($5a036e0bbbddc7fb$var$Yj ? (a = $5a036e0bbbddc7fb$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $5a036e0bbbddc7fb$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $5a036e0bbbddc7fb$var$X && ($5a036e0bbbddc7fb$var$Yj ? (a = $5a036e0bbbddc7fb$var$X, c = c.stateNode, 8 === a.nodeType ? $5a036e0bbbddc7fb$var$Kf(a.parentNode, c) : 1 === a.nodeType && $5a036e0bbbddc7fb$var$Kf(a, c), $5a036e0bbbddc7fb$var$bd(a)) : $5a036e0bbbddc7fb$var$Kf($5a036e0bbbddc7fb$var$X, c.stateNode));
            break;
        case 4:
            d = $5a036e0bbbddc7fb$var$X;
            e = $5a036e0bbbddc7fb$var$Yj;
            $5a036e0bbbddc7fb$var$X = c.stateNode.containerInfo;
            $5a036e0bbbddc7fb$var$Yj = !0;
            $5a036e0bbbddc7fb$var$Zj(a, b, c);
            $5a036e0bbbddc7fb$var$X = d;
            $5a036e0bbbddc7fb$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$5a036e0bbbddc7fb$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $5a036e0bbbddc7fb$var$Nj(c, b, g) : 0 !== (f & 4) && $5a036e0bbbddc7fb$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $5a036e0bbbddc7fb$var$Zj(a, b, c);
            break;
        case 1:
            if (!$5a036e0bbbddc7fb$var$U && ($5a036e0bbbddc7fb$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $5a036e0bbbddc7fb$var$W(c, b, h);
            }
            $5a036e0bbbddc7fb$var$Zj(a, b, c);
            break;
        case 21:
            $5a036e0bbbddc7fb$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($5a036e0bbbddc7fb$var$U = (d = $5a036e0bbbddc7fb$var$U) || null !== c.memoizedState, $5a036e0bbbddc7fb$var$Zj(a, b, c), $5a036e0bbbddc7fb$var$U = d) : $5a036e0bbbddc7fb$var$Zj(a, b, c);
            break;
        default:
            $5a036e0bbbddc7fb$var$Zj(a, b, c);
    }
}
function $5a036e0bbbddc7fb$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $5a036e0bbbddc7fb$var$Lj);
        b.forEach(function(b) {
            var d = $5a036e0bbbddc7fb$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $5a036e0bbbddc7fb$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $5a036e0bbbddc7fb$var$X = h.stateNode;
                        $5a036e0bbbddc7fb$var$Yj = !1;
                        break a;
                    case 3:
                        $5a036e0bbbddc7fb$var$X = h.stateNode.containerInfo;
                        $5a036e0bbbddc7fb$var$Yj = !0;
                        break a;
                    case 4:
                        $5a036e0bbbddc7fb$var$X = h.stateNode.containerInfo;
                        $5a036e0bbbddc7fb$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $5a036e0bbbddc7fb$var$X) throw Error($5a036e0bbbddc7fb$var$p(160));
            $5a036e0bbbddc7fb$var$ak(f, g, e);
            $5a036e0bbbddc7fb$var$X = null;
            $5a036e0bbbddc7fb$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $5a036e0bbbddc7fb$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$5a036e0bbbddc7fb$var$ek(b, a), b = b.sibling;
}
function $5a036e0bbbddc7fb$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $5a036e0bbbddc7fb$var$dk(b, a);
            $5a036e0bbbddc7fb$var$fk(a);
            if (d & 4) {
                try {
                    $5a036e0bbbddc7fb$var$Qj(3, a, a.return), $5a036e0bbbddc7fb$var$Rj(3, a);
                } catch (t) {
                    $5a036e0bbbddc7fb$var$W(a, a.return, t);
                }
                try {
                    $5a036e0bbbddc7fb$var$Qj(5, a, a.return);
                } catch (t) {
                    $5a036e0bbbddc7fb$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $5a036e0bbbddc7fb$var$dk(b, a);
            $5a036e0bbbddc7fb$var$fk(a);
            d & 512 && null !== c && $5a036e0bbbddc7fb$var$Mj(c, c.return);
            break;
        case 5:
            $5a036e0bbbddc7fb$var$dk(b, a);
            $5a036e0bbbddc7fb$var$fk(a);
            d & 512 && null !== c && $5a036e0bbbddc7fb$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $5a036e0bbbddc7fb$var$ob(e, "");
                } catch (t) {
                    $5a036e0bbbddc7fb$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $5a036e0bbbddc7fb$var$ab(e, f);
                    $5a036e0bbbddc7fb$var$vb(h, g);
                    var l = $5a036e0bbbddc7fb$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $5a036e0bbbddc7fb$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $5a036e0bbbddc7fb$var$nb(e, q) : "children" === m ? $5a036e0bbbddc7fb$var$ob(e, q) : $5a036e0bbbddc7fb$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $5a036e0bbbddc7fb$var$bb(e, f);
                            break;
                        case "textarea":
                            $5a036e0bbbddc7fb$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $5a036e0bbbddc7fb$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $5a036e0bbbddc7fb$var$fb(e, !!f.multiple, f.defaultValue, !0) : $5a036e0bbbddc7fb$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$5a036e0bbbddc7fb$var$Pf] = f;
                } catch (t) {
                    $5a036e0bbbddc7fb$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $5a036e0bbbddc7fb$var$dk(b, a);
            $5a036e0bbbddc7fb$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($5a036e0bbbddc7fb$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $5a036e0bbbddc7fb$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $5a036e0bbbddc7fb$var$dk(b, a);
            $5a036e0bbbddc7fb$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $5a036e0bbbddc7fb$var$bd(b.containerInfo);
            } catch (t) {
                $5a036e0bbbddc7fb$var$W(a, a.return, t);
            }
            break;
        case 4:
            $5a036e0bbbddc7fb$var$dk(b, a);
            $5a036e0bbbddc7fb$var$fk(a);
            break;
        case 13:
            $5a036e0bbbddc7fb$var$dk(b, a);
            $5a036e0bbbddc7fb$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($5a036e0bbbddc7fb$var$gk = $5a036e0bbbddc7fb$var$B()));
            d & 4 && $5a036e0bbbddc7fb$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($5a036e0bbbddc7fb$var$U = (l = $5a036e0bbbddc7fb$var$U) || m, $5a036e0bbbddc7fb$var$dk(b, a), $5a036e0bbbddc7fb$var$U = l) : $5a036e0bbbddc7fb$var$dk(b, a);
            $5a036e0bbbddc7fb$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($5a036e0bbbddc7fb$var$V = a, m = a.child; null !== m;){
                    for(q = $5a036e0bbbddc7fb$var$V = m; null !== $5a036e0bbbddc7fb$var$V;){
                        r = $5a036e0bbbddc7fb$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $5a036e0bbbddc7fb$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $5a036e0bbbddc7fb$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $5a036e0bbbddc7fb$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $5a036e0bbbddc7fb$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $5a036e0bbbddc7fb$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $5a036e0bbbddc7fb$var$V = y) : $5a036e0bbbddc7fb$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $5a036e0bbbddc7fb$var$rb("display", g));
                            } catch (t) {
                                $5a036e0bbbddc7fb$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $5a036e0bbbddc7fb$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $5a036e0bbbddc7fb$var$dk(b, a);
            $5a036e0bbbddc7fb$var$fk(a);
            d & 4 && $5a036e0bbbddc7fb$var$bk(a);
            break;
        case 21:
            break;
        default:
            $5a036e0bbbddc7fb$var$dk(b, a), $5a036e0bbbddc7fb$var$fk(a);
    }
}
function $5a036e0bbbddc7fb$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($5a036e0bbbddc7fb$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($5a036e0bbbddc7fb$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($5a036e0bbbddc7fb$var$ob(e, ""), d.flags &= -33);
                    var f = $5a036e0bbbddc7fb$var$Vj(a);
                    $5a036e0bbbddc7fb$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $5a036e0bbbddc7fb$var$Vj(a);
                    $5a036e0bbbddc7fb$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($5a036e0bbbddc7fb$var$p(161));
            }
        } catch (k) {
            $5a036e0bbbddc7fb$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $5a036e0bbbddc7fb$var$ik(a, b, c) {
    $5a036e0bbbddc7fb$var$V = a;
    $5a036e0bbbddc7fb$var$jk(a, b, c);
}
function $5a036e0bbbddc7fb$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $5a036e0bbbddc7fb$var$V;){
        var e = $5a036e0bbbddc7fb$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $5a036e0bbbddc7fb$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $5a036e0bbbddc7fb$var$U;
                h = $5a036e0bbbddc7fb$var$Kj;
                var l = $5a036e0bbbddc7fb$var$U;
                $5a036e0bbbddc7fb$var$Kj = g;
                if (($5a036e0bbbddc7fb$var$U = k) && !l) for($5a036e0bbbddc7fb$var$V = e; null !== $5a036e0bbbddc7fb$var$V;)g = $5a036e0bbbddc7fb$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $5a036e0bbbddc7fb$var$kk(e) : null !== k ? (k.return = g, $5a036e0bbbddc7fb$var$V = k) : $5a036e0bbbddc7fb$var$kk(e);
                for(; null !== f;)$5a036e0bbbddc7fb$var$V = f, $5a036e0bbbddc7fb$var$jk(f, b, c), f = f.sibling;
                $5a036e0bbbddc7fb$var$V = e;
                $5a036e0bbbddc7fb$var$Kj = h;
                $5a036e0bbbddc7fb$var$U = l;
            }
            $5a036e0bbbddc7fb$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $5a036e0bbbddc7fb$var$V = f) : $5a036e0bbbddc7fb$var$lk(a, b, c);
    }
}
function $5a036e0bbbddc7fb$var$lk(a) {
    for(; null !== $5a036e0bbbddc7fb$var$V;){
        var b = $5a036e0bbbddc7fb$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $5a036e0bbbddc7fb$var$U || $5a036e0bbbddc7fb$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$5a036e0bbbddc7fb$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $5a036e0bbbddc7fb$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $5a036e0bbbddc7fb$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $5a036e0bbbddc7fb$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $5a036e0bbbddc7fb$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($5a036e0bbbddc7fb$var$p(163));
                }
                $5a036e0bbbddc7fb$var$U || b.flags & 512 && $5a036e0bbbddc7fb$var$Sj(b);
            } catch (r) {
                $5a036e0bbbddc7fb$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $5a036e0bbbddc7fb$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5a036e0bbbddc7fb$var$V = c;
            break;
        }
        $5a036e0bbbddc7fb$var$V = b.return;
    }
}
function $5a036e0bbbddc7fb$var$hk(a) {
    for(; null !== $5a036e0bbbddc7fb$var$V;){
        var b = $5a036e0bbbddc7fb$var$V;
        if (b === a) {
            $5a036e0bbbddc7fb$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5a036e0bbbddc7fb$var$V = c;
            break;
        }
        $5a036e0bbbddc7fb$var$V = b.return;
    }
}
function $5a036e0bbbddc7fb$var$kk(a) {
    for(; null !== $5a036e0bbbddc7fb$var$V;){
        var b = $5a036e0bbbddc7fb$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $5a036e0bbbddc7fb$var$Rj(4, b);
                    } catch (k) {
                        $5a036e0bbbddc7fb$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $5a036e0bbbddc7fb$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $5a036e0bbbddc7fb$var$Sj(b);
                    } catch (k) {
                        $5a036e0bbbddc7fb$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $5a036e0bbbddc7fb$var$Sj(b);
                    } catch (k) {
                        $5a036e0bbbddc7fb$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $5a036e0bbbddc7fb$var$W(b, b.return, k);
        }
        if (b === a) {
            $5a036e0bbbddc7fb$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $5a036e0bbbddc7fb$var$V = h;
            break;
        }
        $5a036e0bbbddc7fb$var$V = b.return;
    }
}
var $5a036e0bbbddc7fb$var$mk = Math.ceil, $5a036e0bbbddc7fb$var$nk = $5a036e0bbbddc7fb$var$ua.ReactCurrentDispatcher, $5a036e0bbbddc7fb$var$ok = $5a036e0bbbddc7fb$var$ua.ReactCurrentOwner, $5a036e0bbbddc7fb$var$pk = $5a036e0bbbddc7fb$var$ua.ReactCurrentBatchConfig, $5a036e0bbbddc7fb$var$K = 0, $5a036e0bbbddc7fb$var$R = null, $5a036e0bbbddc7fb$var$Y = null, $5a036e0bbbddc7fb$var$Z = 0, $5a036e0bbbddc7fb$var$gj = 0, $5a036e0bbbddc7fb$var$fj = $5a036e0bbbddc7fb$var$Uf(0), $5a036e0bbbddc7fb$var$T = 0, $5a036e0bbbddc7fb$var$qk = null, $5a036e0bbbddc7fb$var$hh = 0, $5a036e0bbbddc7fb$var$rk = 0, $5a036e0bbbddc7fb$var$sk = 0, $5a036e0bbbddc7fb$var$tk = null, $5a036e0bbbddc7fb$var$uk = null, $5a036e0bbbddc7fb$var$gk = 0, $5a036e0bbbddc7fb$var$Hj = Infinity, $5a036e0bbbddc7fb$var$vk = null, $5a036e0bbbddc7fb$var$Pi = !1, $5a036e0bbbddc7fb$var$Qi = null, $5a036e0bbbddc7fb$var$Si = null, $5a036e0bbbddc7fb$var$wk = !1, $5a036e0bbbddc7fb$var$xk = null, $5a036e0bbbddc7fb$var$yk = 0, $5a036e0bbbddc7fb$var$zk = 0, $5a036e0bbbddc7fb$var$Ak = null, $5a036e0bbbddc7fb$var$Bk = -1, $5a036e0bbbddc7fb$var$Ck = 0;
function $5a036e0bbbddc7fb$var$L() {
    return 0 !== ($5a036e0bbbddc7fb$var$K & 6) ? $5a036e0bbbddc7fb$var$B() : -1 !== $5a036e0bbbddc7fb$var$Bk ? $5a036e0bbbddc7fb$var$Bk : $5a036e0bbbddc7fb$var$Bk = $5a036e0bbbddc7fb$var$B();
}
function $5a036e0bbbddc7fb$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($5a036e0bbbddc7fb$var$K & 2) && 0 !== $5a036e0bbbddc7fb$var$Z) return $5a036e0bbbddc7fb$var$Z & -$5a036e0bbbddc7fb$var$Z;
    if (null !== $5a036e0bbbddc7fb$var$Kg.transition) return 0 === $5a036e0bbbddc7fb$var$Ck && ($5a036e0bbbddc7fb$var$Ck = $5a036e0bbbddc7fb$var$yc()), $5a036e0bbbddc7fb$var$Ck;
    a = $5a036e0bbbddc7fb$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $5a036e0bbbddc7fb$var$jd(a.type);
    return a;
}
function $5a036e0bbbddc7fb$var$mh(a, b, c, d) {
    if (50 < $5a036e0bbbddc7fb$var$zk) throw $5a036e0bbbddc7fb$var$zk = 0, $5a036e0bbbddc7fb$var$Ak = null, Error($5a036e0bbbddc7fb$var$p(185));
    $5a036e0bbbddc7fb$var$Ac(a, c, d);
    if (0 === ($5a036e0bbbddc7fb$var$K & 2) || a !== $5a036e0bbbddc7fb$var$R) a === $5a036e0bbbddc7fb$var$R && (0 === ($5a036e0bbbddc7fb$var$K & 2) && ($5a036e0bbbddc7fb$var$rk |= c), 4 === $5a036e0bbbddc7fb$var$T && $5a036e0bbbddc7fb$var$Dk(a, $5a036e0bbbddc7fb$var$Z)), $5a036e0bbbddc7fb$var$Ek(a, d), 1 === c && 0 === $5a036e0bbbddc7fb$var$K && 0 === (b.mode & 1) && ($5a036e0bbbddc7fb$var$Hj = $5a036e0bbbddc7fb$var$B() + 500, $5a036e0bbbddc7fb$var$fg && $5a036e0bbbddc7fb$var$jg());
}
function $5a036e0bbbddc7fb$var$Ek(a, b) {
    var c = a.callbackNode;
    $5a036e0bbbddc7fb$var$wc(a, b);
    var d = $5a036e0bbbddc7fb$var$uc(a, a === $5a036e0bbbddc7fb$var$R ? $5a036e0bbbddc7fb$var$Z : 0);
    if (0 === d) null !== c && $5a036e0bbbddc7fb$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $5a036e0bbbddc7fb$var$bc(c);
        if (1 === b) 0 === a.tag ? $5a036e0bbbddc7fb$var$ig($5a036e0bbbddc7fb$var$Fk.bind(null, a)) : $5a036e0bbbddc7fb$var$hg($5a036e0bbbddc7fb$var$Fk.bind(null, a)), $5a036e0bbbddc7fb$var$Jf(function() {
            0 === ($5a036e0bbbddc7fb$var$K & 6) && $5a036e0bbbddc7fb$var$jg();
        }), c = null;
        else {
            switch($5a036e0bbbddc7fb$var$Dc(d)){
                case 1:
                    c = $5a036e0bbbddc7fb$var$fc;
                    break;
                case 4:
                    c = $5a036e0bbbddc7fb$var$gc;
                    break;
                case 16:
                    c = $5a036e0bbbddc7fb$var$hc;
                    break;
                case 536870912:
                    c = $5a036e0bbbddc7fb$var$jc;
                    break;
                default:
                    c = $5a036e0bbbddc7fb$var$hc;
            }
            c = $5a036e0bbbddc7fb$var$Gk(c, $5a036e0bbbddc7fb$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $5a036e0bbbddc7fb$var$Hk(a, b) {
    $5a036e0bbbddc7fb$var$Bk = -1;
    $5a036e0bbbddc7fb$var$Ck = 0;
    if (0 !== ($5a036e0bbbddc7fb$var$K & 6)) throw Error($5a036e0bbbddc7fb$var$p(327));
    var c = a.callbackNode;
    if ($5a036e0bbbddc7fb$var$Ik() && a.callbackNode !== c) return null;
    var d = $5a036e0bbbddc7fb$var$uc(a, a === $5a036e0bbbddc7fb$var$R ? $5a036e0bbbddc7fb$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $5a036e0bbbddc7fb$var$Jk(a, d);
    else {
        b = d;
        var e = $5a036e0bbbddc7fb$var$K;
        $5a036e0bbbddc7fb$var$K |= 2;
        var f = $5a036e0bbbddc7fb$var$Kk();
        if ($5a036e0bbbddc7fb$var$R !== a || $5a036e0bbbddc7fb$var$Z !== b) $5a036e0bbbddc7fb$var$vk = null, $5a036e0bbbddc7fb$var$Hj = $5a036e0bbbddc7fb$var$B() + 500, $5a036e0bbbddc7fb$var$Lk(a, b);
        for(;;)try {
            $5a036e0bbbddc7fb$var$Mk();
            break;
        } catch (h) {
            $5a036e0bbbddc7fb$var$Nk(a, h);
        }
        $5a036e0bbbddc7fb$var$Qg();
        $5a036e0bbbddc7fb$var$nk.current = f;
        $5a036e0bbbddc7fb$var$K = e;
        null !== $5a036e0bbbddc7fb$var$Y ? b = 0 : ($5a036e0bbbddc7fb$var$R = null, $5a036e0bbbddc7fb$var$Z = 0, b = $5a036e0bbbddc7fb$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $5a036e0bbbddc7fb$var$xc(a), 0 !== e && (d = e, b = $5a036e0bbbddc7fb$var$Ok(a, e)));
        if (1 === b) throw c = $5a036e0bbbddc7fb$var$qk, $5a036e0bbbddc7fb$var$Lk(a, 0), $5a036e0bbbddc7fb$var$Dk(a, d), $5a036e0bbbddc7fb$var$Ek(a, $5a036e0bbbddc7fb$var$B()), c;
        if (6 === b) $5a036e0bbbddc7fb$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$5a036e0bbbddc7fb$var$Pk(e) && (b = $5a036e0bbbddc7fb$var$Jk(a, d), 2 === b && (f = $5a036e0bbbddc7fb$var$xc(a), 0 !== f && (d = f, b = $5a036e0bbbddc7fb$var$Ok(a, f))), 1 === b)) throw c = $5a036e0bbbddc7fb$var$qk, $5a036e0bbbddc7fb$var$Lk(a, 0), $5a036e0bbbddc7fb$var$Dk(a, d), $5a036e0bbbddc7fb$var$Ek(a, $5a036e0bbbddc7fb$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($5a036e0bbbddc7fb$var$p(345));
                case 2:
                    $5a036e0bbbddc7fb$var$Qk(a, $5a036e0bbbddc7fb$var$uk, $5a036e0bbbddc7fb$var$vk);
                    break;
                case 3:
                    $5a036e0bbbddc7fb$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $5a036e0bbbddc7fb$var$gk + 500 - $5a036e0bbbddc7fb$var$B(), 10 < b)) {
                        if (0 !== $5a036e0bbbddc7fb$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $5a036e0bbbddc7fb$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $5a036e0bbbddc7fb$var$Ff($5a036e0bbbddc7fb$var$Qk.bind(null, a, $5a036e0bbbddc7fb$var$uk, $5a036e0bbbddc7fb$var$vk), b);
                        break;
                    }
                    $5a036e0bbbddc7fb$var$Qk(a, $5a036e0bbbddc7fb$var$uk, $5a036e0bbbddc7fb$var$vk);
                    break;
                case 4:
                    $5a036e0bbbddc7fb$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $5a036e0bbbddc7fb$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $5a036e0bbbddc7fb$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $5a036e0bbbddc7fb$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $5a036e0bbbddc7fb$var$Ff($5a036e0bbbddc7fb$var$Qk.bind(null, a, $5a036e0bbbddc7fb$var$uk, $5a036e0bbbddc7fb$var$vk), d);
                        break;
                    }
                    $5a036e0bbbddc7fb$var$Qk(a, $5a036e0bbbddc7fb$var$uk, $5a036e0bbbddc7fb$var$vk);
                    break;
                case 5:
                    $5a036e0bbbddc7fb$var$Qk(a, $5a036e0bbbddc7fb$var$uk, $5a036e0bbbddc7fb$var$vk);
                    break;
                default:
                    throw Error($5a036e0bbbddc7fb$var$p(329));
            }
        }
    }
    $5a036e0bbbddc7fb$var$Ek(a, $5a036e0bbbddc7fb$var$B());
    return a.callbackNode === c ? $5a036e0bbbddc7fb$var$Hk.bind(null, a) : null;
}
function $5a036e0bbbddc7fb$var$Ok(a, b) {
    var c = $5a036e0bbbddc7fb$var$tk;
    a.current.memoizedState.isDehydrated && ($5a036e0bbbddc7fb$var$Lk(a, b).flags |= 256);
    a = $5a036e0bbbddc7fb$var$Jk(a, b);
    2 !== a && (b = $5a036e0bbbddc7fb$var$uk, $5a036e0bbbddc7fb$var$uk = c, null !== b && $5a036e0bbbddc7fb$var$Gj(b));
    return a;
}
function $5a036e0bbbddc7fb$var$Gj(a) {
    null === $5a036e0bbbddc7fb$var$uk ? $5a036e0bbbddc7fb$var$uk = a : $5a036e0bbbddc7fb$var$uk.push.apply($5a036e0bbbddc7fb$var$uk, a);
}
function $5a036e0bbbddc7fb$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$5a036e0bbbddc7fb$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $5a036e0bbbddc7fb$var$Dk(a, b) {
    b &= ~$5a036e0bbbddc7fb$var$sk;
    b &= ~$5a036e0bbbddc7fb$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $5a036e0bbbddc7fb$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $5a036e0bbbddc7fb$var$Fk(a) {
    if (0 !== ($5a036e0bbbddc7fb$var$K & 6)) throw Error($5a036e0bbbddc7fb$var$p(327));
    $5a036e0bbbddc7fb$var$Ik();
    var b = $5a036e0bbbddc7fb$var$uc(a, 0);
    if (0 === (b & 1)) return $5a036e0bbbddc7fb$var$Ek(a, $5a036e0bbbddc7fb$var$B()), null;
    var c = $5a036e0bbbddc7fb$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $5a036e0bbbddc7fb$var$xc(a);
        0 !== d && (b = d, c = $5a036e0bbbddc7fb$var$Ok(a, d));
    }
    if (1 === c) throw c = $5a036e0bbbddc7fb$var$qk, $5a036e0bbbddc7fb$var$Lk(a, 0), $5a036e0bbbddc7fb$var$Dk(a, b), $5a036e0bbbddc7fb$var$Ek(a, $5a036e0bbbddc7fb$var$B()), c;
    if (6 === c) throw Error($5a036e0bbbddc7fb$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $5a036e0bbbddc7fb$var$Qk(a, $5a036e0bbbddc7fb$var$uk, $5a036e0bbbddc7fb$var$vk);
    $5a036e0bbbddc7fb$var$Ek(a, $5a036e0bbbddc7fb$var$B());
    return null;
}
function $5a036e0bbbddc7fb$var$Rk(a, b) {
    var c = $5a036e0bbbddc7fb$var$K;
    $5a036e0bbbddc7fb$var$K |= 1;
    try {
        return a(b);
    } finally{
        $5a036e0bbbddc7fb$var$K = c, 0 === $5a036e0bbbddc7fb$var$K && ($5a036e0bbbddc7fb$var$Hj = $5a036e0bbbddc7fb$var$B() + 500, $5a036e0bbbddc7fb$var$fg && $5a036e0bbbddc7fb$var$jg());
    }
}
function $5a036e0bbbddc7fb$var$Sk(a) {
    null !== $5a036e0bbbddc7fb$var$xk && 0 === $5a036e0bbbddc7fb$var$xk.tag && 0 === ($5a036e0bbbddc7fb$var$K & 6) && $5a036e0bbbddc7fb$var$Ik();
    var b = $5a036e0bbbddc7fb$var$K;
    $5a036e0bbbddc7fb$var$K |= 1;
    var c = $5a036e0bbbddc7fb$var$pk.transition, d = $5a036e0bbbddc7fb$var$C;
    try {
        if ($5a036e0bbbddc7fb$var$pk.transition = null, $5a036e0bbbddc7fb$var$C = 1, a) return a();
    } finally{
        $5a036e0bbbddc7fb$var$C = d, $5a036e0bbbddc7fb$var$pk.transition = c, $5a036e0bbbddc7fb$var$K = b, 0 === ($5a036e0bbbddc7fb$var$K & 6) && $5a036e0bbbddc7fb$var$jg();
    }
}
function $5a036e0bbbddc7fb$var$Ij() {
    $5a036e0bbbddc7fb$var$gj = $5a036e0bbbddc7fb$var$fj.current;
    $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$fj);
}
function $5a036e0bbbddc7fb$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $5a036e0bbbddc7fb$var$Gf(c));
    if (null !== $5a036e0bbbddc7fb$var$Y) for(c = $5a036e0bbbddc7fb$var$Y.return; null !== c;){
        var d = c;
        $5a036e0bbbddc7fb$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $5a036e0bbbddc7fb$var$$f();
                break;
            case 3:
                $5a036e0bbbddc7fb$var$Jh();
                $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$Wf);
                $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$H);
                $5a036e0bbbddc7fb$var$Oh();
                break;
            case 5:
                $5a036e0bbbddc7fb$var$Lh(d);
                break;
            case 4:
                $5a036e0bbbddc7fb$var$Jh();
                break;
            case 13:
                $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$M);
                break;
            case 19:
                $5a036e0bbbddc7fb$var$E($5a036e0bbbddc7fb$var$M);
                break;
            case 10:
                $5a036e0bbbddc7fb$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $5a036e0bbbddc7fb$var$Ij();
        }
        c = c.return;
    }
    $5a036e0bbbddc7fb$var$R = a;
    $5a036e0bbbddc7fb$var$Y = a = $5a036e0bbbddc7fb$var$wh(a.current, null);
    $5a036e0bbbddc7fb$var$Z = $5a036e0bbbddc7fb$var$gj = b;
    $5a036e0bbbddc7fb$var$T = 0;
    $5a036e0bbbddc7fb$var$qk = null;
    $5a036e0bbbddc7fb$var$sk = $5a036e0bbbddc7fb$var$rk = $5a036e0bbbddc7fb$var$hh = 0;
    $5a036e0bbbddc7fb$var$uk = $5a036e0bbbddc7fb$var$tk = null;
    if (null !== $5a036e0bbbddc7fb$var$Wg) {
        for(b = 0; b < $5a036e0bbbddc7fb$var$Wg.length; b++)if (c = $5a036e0bbbddc7fb$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $5a036e0bbbddc7fb$var$Wg = null;
    }
    return a;
}
function $5a036e0bbbddc7fb$var$Nk(a, b) {
    do {
        var c = $5a036e0bbbddc7fb$var$Y;
        try {
            $5a036e0bbbddc7fb$var$Qg();
            $5a036e0bbbddc7fb$var$Ph.current = $5a036e0bbbddc7fb$var$ai;
            if ($5a036e0bbbddc7fb$var$Sh) {
                for(var d = $5a036e0bbbddc7fb$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $5a036e0bbbddc7fb$var$Sh = !1;
            }
            $5a036e0bbbddc7fb$var$Rh = 0;
            $5a036e0bbbddc7fb$var$P = $5a036e0bbbddc7fb$var$O = $5a036e0bbbddc7fb$var$N = null;
            $5a036e0bbbddc7fb$var$Th = !1;
            $5a036e0bbbddc7fb$var$Uh = 0;
            $5a036e0bbbddc7fb$var$ok.current = null;
            if (null === c || null === c.return) {
                $5a036e0bbbddc7fb$var$T = 1;
                $5a036e0bbbddc7fb$var$qk = b;
                $5a036e0bbbddc7fb$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $5a036e0bbbddc7fb$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $5a036e0bbbddc7fb$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $5a036e0bbbddc7fb$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $5a036e0bbbddc7fb$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $5a036e0bbbddc7fb$var$Ti(f, l, b);
                            $5a036e0bbbddc7fb$var$uj();
                            break a;
                        }
                        k = Error($5a036e0bbbddc7fb$var$p(426));
                    }
                } else if ($5a036e0bbbddc7fb$var$I && h.mode & 1) {
                    var J = $5a036e0bbbddc7fb$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $5a036e0bbbddc7fb$var$Wi(J, g, h, f, b);
                        $5a036e0bbbddc7fb$var$Jg($5a036e0bbbddc7fb$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $5a036e0bbbddc7fb$var$Ki(k, h);
                4 !== $5a036e0bbbddc7fb$var$T && ($5a036e0bbbddc7fb$var$T = 2);
                null === $5a036e0bbbddc7fb$var$tk ? $5a036e0bbbddc7fb$var$tk = [
                    f
                ] : $5a036e0bbbddc7fb$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $5a036e0bbbddc7fb$var$Oi(f, k, b);
                            $5a036e0bbbddc7fb$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $5a036e0bbbddc7fb$var$Si || !$5a036e0bbbddc7fb$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $5a036e0bbbddc7fb$var$Ri(f, h, b);
                                $5a036e0bbbddc7fb$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $5a036e0bbbddc7fb$var$Tk(c);
        } catch (na) {
            b = na;
            $5a036e0bbbddc7fb$var$Y === c && null !== c && ($5a036e0bbbddc7fb$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $5a036e0bbbddc7fb$var$Kk() {
    var a = $5a036e0bbbddc7fb$var$nk.current;
    $5a036e0bbbddc7fb$var$nk.current = $5a036e0bbbddc7fb$var$ai;
    return null === a ? $5a036e0bbbddc7fb$var$ai : a;
}
function $5a036e0bbbddc7fb$var$uj() {
    if (0 === $5a036e0bbbddc7fb$var$T || 3 === $5a036e0bbbddc7fb$var$T || 2 === $5a036e0bbbddc7fb$var$T) $5a036e0bbbddc7fb$var$T = 4;
    null === $5a036e0bbbddc7fb$var$R || 0 === ($5a036e0bbbddc7fb$var$hh & 268435455) && 0 === ($5a036e0bbbddc7fb$var$rk & 268435455) || $5a036e0bbbddc7fb$var$Dk($5a036e0bbbddc7fb$var$R, $5a036e0bbbddc7fb$var$Z);
}
function $5a036e0bbbddc7fb$var$Jk(a, b) {
    var c = $5a036e0bbbddc7fb$var$K;
    $5a036e0bbbddc7fb$var$K |= 2;
    var d = $5a036e0bbbddc7fb$var$Kk();
    if ($5a036e0bbbddc7fb$var$R !== a || $5a036e0bbbddc7fb$var$Z !== b) $5a036e0bbbddc7fb$var$vk = null, $5a036e0bbbddc7fb$var$Lk(a, b);
    for(;;)try {
        $5a036e0bbbddc7fb$var$Uk();
        break;
    } catch (e) {
        $5a036e0bbbddc7fb$var$Nk(a, e);
    }
    $5a036e0bbbddc7fb$var$Qg();
    $5a036e0bbbddc7fb$var$K = c;
    $5a036e0bbbddc7fb$var$nk.current = d;
    if (null !== $5a036e0bbbddc7fb$var$Y) throw Error($5a036e0bbbddc7fb$var$p(261));
    $5a036e0bbbddc7fb$var$R = null;
    $5a036e0bbbddc7fb$var$Z = 0;
    return $5a036e0bbbddc7fb$var$T;
}
function $5a036e0bbbddc7fb$var$Uk() {
    for(; null !== $5a036e0bbbddc7fb$var$Y;)$5a036e0bbbddc7fb$var$Vk($5a036e0bbbddc7fb$var$Y);
}
function $5a036e0bbbddc7fb$var$Mk() {
    for(; null !== $5a036e0bbbddc7fb$var$Y && !$5a036e0bbbddc7fb$var$cc();)$5a036e0bbbddc7fb$var$Vk($5a036e0bbbddc7fb$var$Y);
}
function $5a036e0bbbddc7fb$var$Vk(a) {
    var b = $5a036e0bbbddc7fb$var$Wk(a.alternate, a, $5a036e0bbbddc7fb$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $5a036e0bbbddc7fb$var$Tk(a) : $5a036e0bbbddc7fb$var$Y = b;
    $5a036e0bbbddc7fb$var$ok.current = null;
}
function $5a036e0bbbddc7fb$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $5a036e0bbbddc7fb$var$Fj(c, b, $5a036e0bbbddc7fb$var$gj), null !== c) {
                $5a036e0bbbddc7fb$var$Y = c;
                return;
            }
        } else {
            c = $5a036e0bbbddc7fb$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $5a036e0bbbddc7fb$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $5a036e0bbbddc7fb$var$T = 6;
                $5a036e0bbbddc7fb$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $5a036e0bbbddc7fb$var$Y = b;
            return;
        }
        $5a036e0bbbddc7fb$var$Y = b = a;
    }while (null !== b);
    0 === $5a036e0bbbddc7fb$var$T && ($5a036e0bbbddc7fb$var$T = 5);
}
function $5a036e0bbbddc7fb$var$Qk(a, b, c) {
    var d = $5a036e0bbbddc7fb$var$C, e = $5a036e0bbbddc7fb$var$pk.transition;
    try {
        $5a036e0bbbddc7fb$var$pk.transition = null, $5a036e0bbbddc7fb$var$C = 1, $5a036e0bbbddc7fb$var$Xk(a, b, c, d);
    } finally{
        $5a036e0bbbddc7fb$var$pk.transition = e, $5a036e0bbbddc7fb$var$C = d;
    }
    return null;
}
function $5a036e0bbbddc7fb$var$Xk(a, b, c, d) {
    do $5a036e0bbbddc7fb$var$Ik();
    while (null !== $5a036e0bbbddc7fb$var$xk);
    if (0 !== ($5a036e0bbbddc7fb$var$K & 6)) throw Error($5a036e0bbbddc7fb$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($5a036e0bbbddc7fb$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $5a036e0bbbddc7fb$var$Bc(a, f);
    a === $5a036e0bbbddc7fb$var$R && ($5a036e0bbbddc7fb$var$Y = $5a036e0bbbddc7fb$var$R = null, $5a036e0bbbddc7fb$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $5a036e0bbbddc7fb$var$wk || ($5a036e0bbbddc7fb$var$wk = !0, $5a036e0bbbddc7fb$var$Gk($5a036e0bbbddc7fb$var$hc, function() {
        $5a036e0bbbddc7fb$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $5a036e0bbbddc7fb$var$pk.transition;
        $5a036e0bbbddc7fb$var$pk.transition = null;
        var g = $5a036e0bbbddc7fb$var$C;
        $5a036e0bbbddc7fb$var$C = 1;
        var h = $5a036e0bbbddc7fb$var$K;
        $5a036e0bbbddc7fb$var$K |= 4;
        $5a036e0bbbddc7fb$var$ok.current = null;
        $5a036e0bbbddc7fb$var$Pj(a, c);
        $5a036e0bbbddc7fb$var$ek(c, a);
        $5a036e0bbbddc7fb$var$Oe($5a036e0bbbddc7fb$var$Df);
        $5a036e0bbbddc7fb$var$dd = !!$5a036e0bbbddc7fb$var$Cf;
        $5a036e0bbbddc7fb$var$Df = $5a036e0bbbddc7fb$var$Cf = null;
        a.current = c;
        $5a036e0bbbddc7fb$var$ik(c, a, e);
        $5a036e0bbbddc7fb$var$dc();
        $5a036e0bbbddc7fb$var$K = h;
        $5a036e0bbbddc7fb$var$C = g;
        $5a036e0bbbddc7fb$var$pk.transition = f;
    } else a.current = c;
    $5a036e0bbbddc7fb$var$wk && ($5a036e0bbbddc7fb$var$wk = !1, $5a036e0bbbddc7fb$var$xk = a, $5a036e0bbbddc7fb$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($5a036e0bbbddc7fb$var$Si = null);
    $5a036e0bbbddc7fb$var$mc(c.stateNode, d);
    $5a036e0bbbddc7fb$var$Ek(a, $5a036e0bbbddc7fb$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($5a036e0bbbddc7fb$var$Pi) throw $5a036e0bbbddc7fb$var$Pi = !1, a = $5a036e0bbbddc7fb$var$Qi, $5a036e0bbbddc7fb$var$Qi = null, a;
    0 !== ($5a036e0bbbddc7fb$var$yk & 1) && 0 !== a.tag && $5a036e0bbbddc7fb$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $5a036e0bbbddc7fb$var$Ak ? $5a036e0bbbddc7fb$var$zk++ : ($5a036e0bbbddc7fb$var$zk = 0, $5a036e0bbbddc7fb$var$Ak = a) : $5a036e0bbbddc7fb$var$zk = 0;
    $5a036e0bbbddc7fb$var$jg();
    return null;
}
function $5a036e0bbbddc7fb$var$Ik() {
    if (null !== $5a036e0bbbddc7fb$var$xk) {
        var a = $5a036e0bbbddc7fb$var$Dc($5a036e0bbbddc7fb$var$yk), b = $5a036e0bbbddc7fb$var$pk.transition, c = $5a036e0bbbddc7fb$var$C;
        try {
            $5a036e0bbbddc7fb$var$pk.transition = null;
            $5a036e0bbbddc7fb$var$C = 16 > a ? 16 : a;
            if (null === $5a036e0bbbddc7fb$var$xk) var d = !1;
            else {
                a = $5a036e0bbbddc7fb$var$xk;
                $5a036e0bbbddc7fb$var$xk = null;
                $5a036e0bbbddc7fb$var$yk = 0;
                if (0 !== ($5a036e0bbbddc7fb$var$K & 6)) throw Error($5a036e0bbbddc7fb$var$p(331));
                var e = $5a036e0bbbddc7fb$var$K;
                $5a036e0bbbddc7fb$var$K |= 4;
                for($5a036e0bbbddc7fb$var$V = a.current; null !== $5a036e0bbbddc7fb$var$V;){
                    var f = $5a036e0bbbddc7fb$var$V, g = f.child;
                    if (0 !== ($5a036e0bbbddc7fb$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($5a036e0bbbddc7fb$var$V = l; null !== $5a036e0bbbddc7fb$var$V;){
                                    var m = $5a036e0bbbddc7fb$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $5a036e0bbbddc7fb$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $5a036e0bbbddc7fb$var$V = q;
                                    else for(; null !== $5a036e0bbbddc7fb$var$V;){
                                        m = $5a036e0bbbddc7fb$var$V;
                                        var r = m.sibling, y = m.return;
                                        $5a036e0bbbddc7fb$var$Tj(m);
                                        if (m === l) {
                                            $5a036e0bbbddc7fb$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $5a036e0bbbddc7fb$var$V = r;
                                            break;
                                        }
                                        $5a036e0bbbddc7fb$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $5a036e0bbbddc7fb$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $5a036e0bbbddc7fb$var$V = g;
                    else b: for(; null !== $5a036e0bbbddc7fb$var$V;){
                        f = $5a036e0bbbddc7fb$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $5a036e0bbbddc7fb$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $5a036e0bbbddc7fb$var$V = x;
                            break b;
                        }
                        $5a036e0bbbddc7fb$var$V = f.return;
                    }
                }
                var w = a.current;
                for($5a036e0bbbddc7fb$var$V = w; null !== $5a036e0bbbddc7fb$var$V;){
                    g = $5a036e0bbbddc7fb$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $5a036e0bbbddc7fb$var$V = u;
                    else b: for(g = w; null !== $5a036e0bbbddc7fb$var$V;){
                        h = $5a036e0bbbddc7fb$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $5a036e0bbbddc7fb$var$Rj(9, h);
                            }
                        } catch (na) {
                            $5a036e0bbbddc7fb$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $5a036e0bbbddc7fb$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $5a036e0bbbddc7fb$var$V = F;
                            break b;
                        }
                        $5a036e0bbbddc7fb$var$V = h.return;
                    }
                }
                $5a036e0bbbddc7fb$var$K = e;
                $5a036e0bbbddc7fb$var$jg();
                if ($5a036e0bbbddc7fb$var$lc && "function" === typeof $5a036e0bbbddc7fb$var$lc.onPostCommitFiberRoot) try {
                    $5a036e0bbbddc7fb$var$lc.onPostCommitFiberRoot($5a036e0bbbddc7fb$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $5a036e0bbbddc7fb$var$C = c, $5a036e0bbbddc7fb$var$pk.transition = b;
        }
    }
    return !1;
}
function $5a036e0bbbddc7fb$var$Yk(a, b, c) {
    b = $5a036e0bbbddc7fb$var$Ki(c, b);
    b = $5a036e0bbbddc7fb$var$Oi(a, b, 1);
    a = $5a036e0bbbddc7fb$var$dh(a, b, 1);
    b = $5a036e0bbbddc7fb$var$L();
    null !== a && ($5a036e0bbbddc7fb$var$Ac(a, 1, b), $5a036e0bbbddc7fb$var$Ek(a, b));
}
function $5a036e0bbbddc7fb$var$W(a, b, c) {
    if (3 === a.tag) $5a036e0bbbddc7fb$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $5a036e0bbbddc7fb$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $5a036e0bbbddc7fb$var$Si || !$5a036e0bbbddc7fb$var$Si.has(d))) {
                a = $5a036e0bbbddc7fb$var$Ki(c, a);
                a = $5a036e0bbbddc7fb$var$Ri(b, a, 1);
                b = $5a036e0bbbddc7fb$var$dh(b, a, 1);
                a = $5a036e0bbbddc7fb$var$L();
                null !== b && ($5a036e0bbbddc7fb$var$Ac(b, 1, a), $5a036e0bbbddc7fb$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $5a036e0bbbddc7fb$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $5a036e0bbbddc7fb$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $5a036e0bbbddc7fb$var$R === a && ($5a036e0bbbddc7fb$var$Z & c) === c && (4 === $5a036e0bbbddc7fb$var$T || 3 === $5a036e0bbbddc7fb$var$T && ($5a036e0bbbddc7fb$var$Z & 130023424) === $5a036e0bbbddc7fb$var$Z && 500 > $5a036e0bbbddc7fb$var$B() - $5a036e0bbbddc7fb$var$gk ? $5a036e0bbbddc7fb$var$Lk(a, 0) : $5a036e0bbbddc7fb$var$sk |= c);
    $5a036e0bbbddc7fb$var$Ek(a, b);
}
function $5a036e0bbbddc7fb$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $5a036e0bbbddc7fb$var$sc, $5a036e0bbbddc7fb$var$sc <<= 1, 0 === ($5a036e0bbbddc7fb$var$sc & 130023424) && ($5a036e0bbbddc7fb$var$sc = 4194304)));
    var c = $5a036e0bbbddc7fb$var$L();
    a = $5a036e0bbbddc7fb$var$Zg(a, b);
    null !== a && ($5a036e0bbbddc7fb$var$Ac(a, b, c), $5a036e0bbbddc7fb$var$Ek(a, c));
}
function $5a036e0bbbddc7fb$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $5a036e0bbbddc7fb$var$Zk(a, c);
}
function $5a036e0bbbddc7fb$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($5a036e0bbbddc7fb$var$p(314));
    }
    null !== d && d.delete(b);
    $5a036e0bbbddc7fb$var$Zk(a, c);
}
var $5a036e0bbbddc7fb$var$Wk;
$5a036e0bbbddc7fb$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $5a036e0bbbddc7fb$var$Wf.current) $5a036e0bbbddc7fb$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $5a036e0bbbddc7fb$var$Ug = !1, $5a036e0bbbddc7fb$var$zj(a, b, c);
            $5a036e0bbbddc7fb$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $5a036e0bbbddc7fb$var$Ug = !1, $5a036e0bbbddc7fb$var$I && 0 !== (b.flags & 1048576) && $5a036e0bbbddc7fb$var$ug(b, $5a036e0bbbddc7fb$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $5a036e0bbbddc7fb$var$jj(a, b);
            a = b.pendingProps;
            var e = $5a036e0bbbddc7fb$var$Yf(b, $5a036e0bbbddc7fb$var$H.current);
            $5a036e0bbbddc7fb$var$Tg(b, c);
            e = $5a036e0bbbddc7fb$var$Xh(null, b, d, a, e, c);
            var f = $5a036e0bbbddc7fb$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $5a036e0bbbddc7fb$var$Zf(d) ? (f = !0, $5a036e0bbbddc7fb$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $5a036e0bbbddc7fb$var$ah(b), e.updater = $5a036e0bbbddc7fb$var$nh, b.stateNode = e, e._reactInternals = b, $5a036e0bbbddc7fb$var$rh(b, d, a, c), b = $5a036e0bbbddc7fb$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $5a036e0bbbddc7fb$var$I && f && $5a036e0bbbddc7fb$var$vg(b), $5a036e0bbbddc7fb$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $5a036e0bbbddc7fb$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $5a036e0bbbddc7fb$var$$k(d);
                a = $5a036e0bbbddc7fb$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $5a036e0bbbddc7fb$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $5a036e0bbbddc7fb$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $5a036e0bbbddc7fb$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $5a036e0bbbddc7fb$var$aj(null, b, d, $5a036e0bbbddc7fb$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($5a036e0bbbddc7fb$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5a036e0bbbddc7fb$var$Lg(d, e), $5a036e0bbbddc7fb$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5a036e0bbbddc7fb$var$Lg(d, e), $5a036e0bbbddc7fb$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $5a036e0bbbddc7fb$var$lj(b);
                if (null === a) throw Error($5a036e0bbbddc7fb$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $5a036e0bbbddc7fb$var$bh(a, b);
                $5a036e0bbbddc7fb$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $5a036e0bbbddc7fb$var$Ki(Error($5a036e0bbbddc7fb$var$p(423)), b);
                        b = $5a036e0bbbddc7fb$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $5a036e0bbbddc7fb$var$Ki(Error($5a036e0bbbddc7fb$var$p(424)), b);
                        b = $5a036e0bbbddc7fb$var$mj(a, b, d, c, e);
                        break a;
                    } else for($5a036e0bbbddc7fb$var$yg = $5a036e0bbbddc7fb$var$Lf(b.stateNode.containerInfo.firstChild), $5a036e0bbbddc7fb$var$xg = b, $5a036e0bbbddc7fb$var$I = !0, $5a036e0bbbddc7fb$var$zg = null, c = $5a036e0bbbddc7fb$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $5a036e0bbbddc7fb$var$Ig();
                    if (d === e) {
                        b = $5a036e0bbbddc7fb$var$$i(a, b, c);
                        break a;
                    }
                    $5a036e0bbbddc7fb$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $5a036e0bbbddc7fb$var$Kh(b), null === a && $5a036e0bbbddc7fb$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $5a036e0bbbddc7fb$var$Ef(d, e) ? g = null : null !== f && $5a036e0bbbddc7fb$var$Ef(d, f) && (b.flags |= 32), $5a036e0bbbddc7fb$var$hj(a, b), $5a036e0bbbddc7fb$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $5a036e0bbbddc7fb$var$Eg(b), null;
        case 13:
            return $5a036e0bbbddc7fb$var$pj(a, b, c);
        case 4:
            return $5a036e0bbbddc7fb$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $5a036e0bbbddc7fb$var$Bh(b, null, d, c) : $5a036e0bbbddc7fb$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5a036e0bbbddc7fb$var$Lg(d, e), $5a036e0bbbddc7fb$var$Zi(a, b, d, e, c);
        case 7:
            return $5a036e0bbbddc7fb$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $5a036e0bbbddc7fb$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $5a036e0bbbddc7fb$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $5a036e0bbbddc7fb$var$G($5a036e0bbbddc7fb$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($5a036e0bbbddc7fb$var$He(f.value, g)) {
                        if (f.children === e.children && !$5a036e0bbbddc7fb$var$Wf.current) {
                            b = $5a036e0bbbddc7fb$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $5a036e0bbbddc7fb$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $5a036e0bbbddc7fb$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($5a036e0bbbddc7fb$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $5a036e0bbbddc7fb$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $5a036e0bbbddc7fb$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $5a036e0bbbddc7fb$var$Tg(b, c), e = $5a036e0bbbddc7fb$var$Vg(e), d = d(e), b.flags |= 1, $5a036e0bbbddc7fb$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $5a036e0bbbddc7fb$var$Lg(d, b.pendingProps), e = $5a036e0bbbddc7fb$var$Lg(d.type, e), $5a036e0bbbddc7fb$var$aj(a, b, d, e, c);
        case 15:
            return $5a036e0bbbddc7fb$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5a036e0bbbddc7fb$var$Lg(d, e), $5a036e0bbbddc7fb$var$jj(a, b), b.tag = 1, $5a036e0bbbddc7fb$var$Zf(d) ? (a = !0, $5a036e0bbbddc7fb$var$cg(b)) : a = !1, $5a036e0bbbddc7fb$var$Tg(b, c), $5a036e0bbbddc7fb$var$ph(b, d, e), $5a036e0bbbddc7fb$var$rh(b, d, e, c), $5a036e0bbbddc7fb$var$kj(null, b, d, !0, a, c);
        case 19:
            return $5a036e0bbbddc7fb$var$yj(a, b, c);
        case 22:
            return $5a036e0bbbddc7fb$var$ej(a, b, c);
    }
    throw Error($5a036e0bbbddc7fb$var$p(156, b.tag));
};
function $5a036e0bbbddc7fb$var$Gk(a, b) {
    return $5a036e0bbbddc7fb$var$ac(a, b);
}
function $5a036e0bbbddc7fb$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $5a036e0bbbddc7fb$var$Bg(a, b, c, d) {
    return new $5a036e0bbbddc7fb$var$al(a, b, c, d);
}
function $5a036e0bbbddc7fb$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $5a036e0bbbddc7fb$var$$k(a) {
    if ("function" === typeof a) return $5a036e0bbbddc7fb$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $5a036e0bbbddc7fb$var$Da) return 11;
        if (a === $5a036e0bbbddc7fb$var$Ga) return 14;
    }
    return 2;
}
function $5a036e0bbbddc7fb$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $5a036e0bbbddc7fb$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $5a036e0bbbddc7fb$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $5a036e0bbbddc7fb$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $5a036e0bbbddc7fb$var$ya:
            return $5a036e0bbbddc7fb$var$Ah(c.children, e, f, b);
        case $5a036e0bbbddc7fb$var$za:
            g = 8;
            e |= 8;
            break;
        case $5a036e0bbbddc7fb$var$Aa:
            return a = $5a036e0bbbddc7fb$var$Bg(12, c, b, e | 2), a.elementType = $5a036e0bbbddc7fb$var$Aa, a.lanes = f, a;
        case $5a036e0bbbddc7fb$var$Ea:
            return a = $5a036e0bbbddc7fb$var$Bg(13, c, b, e), a.elementType = $5a036e0bbbddc7fb$var$Ea, a.lanes = f, a;
        case $5a036e0bbbddc7fb$var$Fa:
            return a = $5a036e0bbbddc7fb$var$Bg(19, c, b, e), a.elementType = $5a036e0bbbddc7fb$var$Fa, a.lanes = f, a;
        case $5a036e0bbbddc7fb$var$Ia:
            return $5a036e0bbbddc7fb$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $5a036e0bbbddc7fb$var$Ba:
                    g = 10;
                    break a;
                case $5a036e0bbbddc7fb$var$Ca:
                    g = 9;
                    break a;
                case $5a036e0bbbddc7fb$var$Da:
                    g = 11;
                    break a;
                case $5a036e0bbbddc7fb$var$Ga:
                    g = 14;
                    break a;
                case $5a036e0bbbddc7fb$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($5a036e0bbbddc7fb$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $3L4GM._)(a), ""));
    }
    b = $5a036e0bbbddc7fb$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $5a036e0bbbddc7fb$var$Ah(a, b, c, d) {
    a = $5a036e0bbbddc7fb$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $5a036e0bbbddc7fb$var$qj(a, b, c, d) {
    a = $5a036e0bbbddc7fb$var$Bg(22, a, d, b);
    a.elementType = $5a036e0bbbddc7fb$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $5a036e0bbbddc7fb$var$xh(a, b, c) {
    a = $5a036e0bbbddc7fb$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $5a036e0bbbddc7fb$var$zh(a, b, c) {
    b = $5a036e0bbbddc7fb$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $5a036e0bbbddc7fb$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $5a036e0bbbddc7fb$var$zc(0);
    this.expirationTimes = $5a036e0bbbddc7fb$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $5a036e0bbbddc7fb$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $5a036e0bbbddc7fb$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $5a036e0bbbddc7fb$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $5a036e0bbbddc7fb$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $5a036e0bbbddc7fb$var$ah(f);
    return a;
}
function $5a036e0bbbddc7fb$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5a036e0bbbddc7fb$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $5a036e0bbbddc7fb$var$el(a) {
    if (!a) return $5a036e0bbbddc7fb$var$Vf;
    a = a._reactInternals;
    a: {
        if ($5a036e0bbbddc7fb$var$Vb(a) !== a || 1 !== a.tag) throw Error($5a036e0bbbddc7fb$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($5a036e0bbbddc7fb$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($5a036e0bbbddc7fb$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($5a036e0bbbddc7fb$var$Zf(c)) return $5a036e0bbbddc7fb$var$bg(a, c, b);
    }
    return b;
}
function $5a036e0bbbddc7fb$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $5a036e0bbbddc7fb$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $5a036e0bbbddc7fb$var$el(null);
    c = a.current;
    d = $5a036e0bbbddc7fb$var$L();
    e = $5a036e0bbbddc7fb$var$lh(c);
    f = $5a036e0bbbddc7fb$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $5a036e0bbbddc7fb$var$dh(c, f, e);
    a.current.lanes = e;
    $5a036e0bbbddc7fb$var$Ac(a, e, d);
    $5a036e0bbbddc7fb$var$Ek(a, d);
    return a;
}
function $5a036e0bbbddc7fb$var$gl(a, b, c, d) {
    var e = b.current, f = $5a036e0bbbddc7fb$var$L(), g = $5a036e0bbbddc7fb$var$lh(e);
    c = $5a036e0bbbddc7fb$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $5a036e0bbbddc7fb$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $5a036e0bbbddc7fb$var$dh(e, b, g);
    null !== a && ($5a036e0bbbddc7fb$var$mh(a, e, g, f), $5a036e0bbbddc7fb$var$eh(a, e, g));
    return g;
}
function $5a036e0bbbddc7fb$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $5a036e0bbbddc7fb$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $5a036e0bbbddc7fb$var$jl(a, b) {
    $5a036e0bbbddc7fb$var$il(a, b);
    (a = a.alternate) && $5a036e0bbbddc7fb$var$il(a, b);
}
function $5a036e0bbbddc7fb$var$kl() {
    return null;
}
var $5a036e0bbbddc7fb$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $5a036e0bbbddc7fb$var$ml(a) {
    this._internalRoot = a;
}
$5a036e0bbbddc7fb$var$nl.prototype.render = $5a036e0bbbddc7fb$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($5a036e0bbbddc7fb$var$p(409));
    $5a036e0bbbddc7fb$var$gl(a, b, null, null);
};
$5a036e0bbbddc7fb$var$nl.prototype.unmount = $5a036e0bbbddc7fb$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $5a036e0bbbddc7fb$var$Sk(function() {
            $5a036e0bbbddc7fb$var$gl(null, a, null, null);
        });
        b[$5a036e0bbbddc7fb$var$uf] = null;
    }
};
function $5a036e0bbbddc7fb$var$nl(a) {
    this._internalRoot = a;
}
$5a036e0bbbddc7fb$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $5a036e0bbbddc7fb$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $5a036e0bbbddc7fb$var$Qc.length && 0 !== b && b < $5a036e0bbbddc7fb$var$Qc[c].priority; c++);
        $5a036e0bbbddc7fb$var$Qc.splice(c, 0, a);
        0 === c && $5a036e0bbbddc7fb$var$Vc(a);
    }
};
function $5a036e0bbbddc7fb$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $5a036e0bbbddc7fb$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $5a036e0bbbddc7fb$var$ql() {}
function $5a036e0bbbddc7fb$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $5a036e0bbbddc7fb$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $5a036e0bbbddc7fb$var$fl(b, d, a, 0, null, !1, !1, "", $5a036e0bbbddc7fb$var$ql);
        a._reactRootContainer = g;
        a[$5a036e0bbbddc7fb$var$uf] = g.current;
        $5a036e0bbbddc7fb$var$sf(8 === a.nodeType ? a.parentNode : a);
        $5a036e0bbbddc7fb$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $5a036e0bbbddc7fb$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $5a036e0bbbddc7fb$var$cl(a, 0, !1, null, null, !1, !1, "", $5a036e0bbbddc7fb$var$ql);
    a._reactRootContainer = k;
    a[$5a036e0bbbddc7fb$var$uf] = k.current;
    $5a036e0bbbddc7fb$var$sf(8 === a.nodeType ? a.parentNode : a);
    $5a036e0bbbddc7fb$var$Sk(function() {
        $5a036e0bbbddc7fb$var$gl(b, k, c, d);
    });
    return k;
}
function $5a036e0bbbddc7fb$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $5a036e0bbbddc7fb$var$hl(g);
                h.call(_$a);
            };
        }
        $5a036e0bbbddc7fb$var$gl(b, g, a, e);
    } else g = $5a036e0bbbddc7fb$var$rl(c, b, a, e, d);
    return $5a036e0bbbddc7fb$var$hl(g);
}
$5a036e0bbbddc7fb$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $5a036e0bbbddc7fb$var$tc(b.pendingLanes);
                0 !== c && ($5a036e0bbbddc7fb$var$Cc(b, c | 1), $5a036e0bbbddc7fb$var$Ek(b, $5a036e0bbbddc7fb$var$B()), 0 === ($5a036e0bbbddc7fb$var$K & 6) && ($5a036e0bbbddc7fb$var$Hj = $5a036e0bbbddc7fb$var$B() + 500, $5a036e0bbbddc7fb$var$jg()));
            }
            break;
        case 13:
            $5a036e0bbbddc7fb$var$Sk(function() {
                var b = $5a036e0bbbddc7fb$var$Zg(a, 1);
                if (null !== b) {
                    var c = $5a036e0bbbddc7fb$var$L();
                    $5a036e0bbbddc7fb$var$mh(b, a, 1, c);
                }
            }), $5a036e0bbbddc7fb$var$jl(a, 1);
    }
};
$5a036e0bbbddc7fb$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $5a036e0bbbddc7fb$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $5a036e0bbbddc7fb$var$L();
            $5a036e0bbbddc7fb$var$mh(b, a, 134217728, c);
        }
        $5a036e0bbbddc7fb$var$jl(a, 134217728);
    }
};
$5a036e0bbbddc7fb$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $5a036e0bbbddc7fb$var$lh(a), c = $5a036e0bbbddc7fb$var$Zg(a, b);
        if (null !== c) {
            var d = $5a036e0bbbddc7fb$var$L();
            $5a036e0bbbddc7fb$var$mh(c, a, b, d);
        }
        $5a036e0bbbddc7fb$var$jl(a, b);
    }
};
$5a036e0bbbddc7fb$var$Hc = function Hc() {
    return $5a036e0bbbddc7fb$var$C;
};
$5a036e0bbbddc7fb$var$Ic = function Ic(a, b) {
    var c = $5a036e0bbbddc7fb$var$C;
    try {
        return $5a036e0bbbddc7fb$var$C = a, b();
    } finally{
        $5a036e0bbbddc7fb$var$C = c;
    }
};
$5a036e0bbbddc7fb$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $5a036e0bbbddc7fb$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $5a036e0bbbddc7fb$var$Db(d);
                        if (!e) throw Error($5a036e0bbbddc7fb$var$p(90));
                        $5a036e0bbbddc7fb$var$Wa(d);
                        $5a036e0bbbddc7fb$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $5a036e0bbbddc7fb$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $5a036e0bbbddc7fb$var$fb(a, !!c.multiple, b, !1);
    }
};
$5a036e0bbbddc7fb$var$Gb = $5a036e0bbbddc7fb$var$Rk;
$5a036e0bbbddc7fb$var$Hb = $5a036e0bbbddc7fb$var$Sk;
var $5a036e0bbbddc7fb$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $5a036e0bbbddc7fb$var$Cb,
        $5a036e0bbbddc7fb$var$ue,
        $5a036e0bbbddc7fb$var$Db,
        $5a036e0bbbddc7fb$var$Eb,
        $5a036e0bbbddc7fb$var$Fb,
        $5a036e0bbbddc7fb$var$Rk
    ]
}, $5a036e0bbbddc7fb$var$ul = {
    findFiberByHostInstance: $5a036e0bbbddc7fb$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $5a036e0bbbddc7fb$var$vl = {
    bundleType: $5a036e0bbbddc7fb$var$ul.bundleType,
    version: $5a036e0bbbddc7fb$var$ul.version,
    rendererPackageName: $5a036e0bbbddc7fb$var$ul.rendererPackageName,
    rendererConfig: $5a036e0bbbddc7fb$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $5a036e0bbbddc7fb$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $5a036e0bbbddc7fb$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $5a036e0bbbddc7fb$var$ul.findFiberByHostInstance || $5a036e0bbbddc7fb$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $5a036e0bbbddc7fb$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$5a036e0bbbddc7fb$var$wl.isDisabled && $5a036e0bbbddc7fb$var$wl.supportsFiber) try {
        $5a036e0bbbddc7fb$var$kc = $5a036e0bbbddc7fb$var$wl.inject($5a036e0bbbddc7fb$var$vl), $5a036e0bbbddc7fb$var$lc = $5a036e0bbbddc7fb$var$wl;
    } catch (a) {}
}
$5a036e0bbbddc7fb$export$ae55be85d98224ed = $5a036e0bbbddc7fb$var$tl;
$5a036e0bbbddc7fb$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$5a036e0bbbddc7fb$var$ol(b)) throw Error($5a036e0bbbddc7fb$var$p(200));
    return $5a036e0bbbddc7fb$var$dl(a, b, null, c);
};
$5a036e0bbbddc7fb$export$882461b6382ed46c = function(a, b) {
    if (!$5a036e0bbbddc7fb$var$ol(a)) throw Error($5a036e0bbbddc7fb$var$p(299));
    var c = !1, d = "", e = $5a036e0bbbddc7fb$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $5a036e0bbbddc7fb$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$5a036e0bbbddc7fb$var$uf] = b.current;
    $5a036e0bbbddc7fb$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $5a036e0bbbddc7fb$var$ml(b);
};
$5a036e0bbbddc7fb$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($5a036e0bbbddc7fb$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($5a036e0bbbddc7fb$var$p(268, a));
    }
    a = $5a036e0bbbddc7fb$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$5a036e0bbbddc7fb$export$cd75ccfd720a3cd4 = function(a) {
    return $5a036e0bbbddc7fb$var$Sk(a);
};
$5a036e0bbbddc7fb$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$5a036e0bbbddc7fb$var$pl(b)) throw Error($5a036e0bbbddc7fb$var$p(200));
    return $5a036e0bbbddc7fb$var$sl(null, a, b, !0, c);
};
$5a036e0bbbddc7fb$export$757ceba2d55c277e = function(a, b, c) {
    if (!$5a036e0bbbddc7fb$var$ol(a)) throw Error($5a036e0bbbddc7fb$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $5a036e0bbbddc7fb$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $5a036e0bbbddc7fb$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$5a036e0bbbddc7fb$var$uf] = b.current;
    $5a036e0bbbddc7fb$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $5a036e0bbbddc7fb$var$nl(b);
};
$5a036e0bbbddc7fb$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$5a036e0bbbddc7fb$var$pl(b)) throw Error($5a036e0bbbddc7fb$var$p(200));
    return $5a036e0bbbddc7fb$var$sl(null, a, b, !1, c);
};
$5a036e0bbbddc7fb$export$502457920280e6be = function(a) {
    if (!$5a036e0bbbddc7fb$var$pl(a)) throw Error($5a036e0bbbddc7fb$var$p(40));
    return a._reactRootContainer ? ($5a036e0bbbddc7fb$var$Sk(function() {
        $5a036e0bbbddc7fb$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$5a036e0bbbddc7fb$var$uf] = null;
        });
    }), !0) : !1;
};
$5a036e0bbbddc7fb$export$c78a37762a8d58e1 = $5a036e0bbbddc7fb$var$Rk;
$5a036e0bbbddc7fb$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$5a036e0bbbddc7fb$var$pl(c)) throw Error($5a036e0bbbddc7fb$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($5a036e0bbbddc7fb$var$p(38));
    return $5a036e0bbbddc7fb$var$sl(a, b, c, !1, d);
};
$5a036e0bbbddc7fb$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("3GiGQ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3VPVm"));

});
parcelRequire.register("3VPVm", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $2dcef90724314473$export$c4744153514ff05d; }, function (v) { return $2dcef90724314473$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $2dcef90724314473$export$3e506c1ccc9cc1a7; }, function (v) { return $2dcef90724314473$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $2dcef90724314473$export$e26fe2ed2fa76875; }, function (v) { return $2dcef90724314473$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $2dcef90724314473$export$502329bbf4b505b1; }, function (v) { return $2dcef90724314473$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $2dcef90724314473$export$6e3807111c4874c4; }, function (v) { return $2dcef90724314473$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $2dcef90724314473$export$c27134553091fb3a; }, function (v) { return $2dcef90724314473$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $2dcef90724314473$export$33ee1acdc04fd2a2; }, function (v) { return $2dcef90724314473$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $2dcef90724314473$export$b00a404bbd5edef2; }, function (v) { return $2dcef90724314473$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $2dcef90724314473$export$8352ce38b91d0c62; }, function (v) { return $2dcef90724314473$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $2dcef90724314473$export$d66a1c1c77bd778b; }, function (v) { return $2dcef90724314473$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $2dcef90724314473$export$d3dfb8e4810cb555; }, function (v) { return $2dcef90724314473$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $2dcef90724314473$export$839f9183b0465a69; }, function (v) { return $2dcef90724314473$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $2dcef90724314473$export$72fdf0e06517287b; }, function (v) { return $2dcef90724314473$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $2dcef90724314473$export$4b844e58a3e414b4; }, function (v) { return $2dcef90724314473$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $2dcef90724314473$export$816d2913ae6b83b1; }, function (v) { return $2dcef90724314473$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $2dcef90724314473$export$61bcfe829111a1d0; }, function (v) { return $2dcef90724314473$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $2dcef90724314473$export$7ee8c9beb337bc3f; }, function (v) { return $2dcef90724314473$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $2dcef90724314473$export$b5836b71941fa3ed; }, function (v) { return $2dcef90724314473$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $2dcef90724314473$export$cf845f2c119da08a; }, function (v) { return $2dcef90724314473$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2dcef90724314473$export$c4744153514ff05d;
var $2dcef90724314473$export$3e506c1ccc9cc1a7;
var $2dcef90724314473$export$e26fe2ed2fa76875;
var $2dcef90724314473$export$502329bbf4b505b1;
var $2dcef90724314473$export$6e3807111c4874c4;
var $2dcef90724314473$export$c27134553091fb3a;
var $2dcef90724314473$export$33ee1acdc04fd2a2;
var $2dcef90724314473$export$b00a404bbd5edef2;
var $2dcef90724314473$export$8352ce38b91d0c62;
var $2dcef90724314473$export$d66a1c1c77bd778b;
var $2dcef90724314473$export$d3dfb8e4810cb555;
var $2dcef90724314473$export$839f9183b0465a69;
var $2dcef90724314473$export$72fdf0e06517287b;
var $2dcef90724314473$export$4b844e58a3e414b4;
var $2dcef90724314473$export$816d2913ae6b83b1;
var $2dcef90724314473$export$61bcfe829111a1d0;
var $2dcef90724314473$export$7ee8c9beb337bc3f;
var $2dcef90724314473$export$b5836b71941fa3ed;
var $2dcef90724314473$export$cf845f2c119da08a;
"use strict";
function $2dcef90724314473$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $2dcef90724314473$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $2dcef90724314473$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $2dcef90724314473$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $2dcef90724314473$var$g(C, c)) n < e && 0 > $2dcef90724314473$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $2dcef90724314473$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $2dcef90724314473$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $2dcef90724314473$var$l = performance;
    $2dcef90724314473$export$c4744153514ff05d = function() {
        return $2dcef90724314473$var$l.now();
    };
} else {
    var $2dcef90724314473$var$p = Date, $2dcef90724314473$var$q = $2dcef90724314473$var$p.now();
    $2dcef90724314473$export$c4744153514ff05d = function() {
        return $2dcef90724314473$var$p.now() - $2dcef90724314473$var$q;
    };
}
var $2dcef90724314473$var$r = [], $2dcef90724314473$var$t = [], $2dcef90724314473$var$u = 1, $2dcef90724314473$var$v = null, $2dcef90724314473$var$y = 3, $2dcef90724314473$var$z = !1, $2dcef90724314473$var$A = !1, $2dcef90724314473$var$B = !1, $2dcef90724314473$var$D = "function" === typeof setTimeout ? setTimeout : null, $2dcef90724314473$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $2dcef90724314473$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $2dcef90724314473$var$G(a) {
    for(var b = $2dcef90724314473$var$h($2dcef90724314473$var$t); null !== b;){
        if (null === b.callback) $2dcef90724314473$var$k($2dcef90724314473$var$t);
        else if (b.startTime <= a) $2dcef90724314473$var$k($2dcef90724314473$var$t), b.sortIndex = b.expirationTime, $2dcef90724314473$var$f($2dcef90724314473$var$r, b);
        else break;
        b = $2dcef90724314473$var$h($2dcef90724314473$var$t);
    }
}
function $2dcef90724314473$var$H(a) {
    $2dcef90724314473$var$B = !1;
    $2dcef90724314473$var$G(a);
    if (!$2dcef90724314473$var$A) {
        if (null !== $2dcef90724314473$var$h($2dcef90724314473$var$r)) $2dcef90724314473$var$A = !0, $2dcef90724314473$var$I($2dcef90724314473$var$J);
        else {
            var b = $2dcef90724314473$var$h($2dcef90724314473$var$t);
            null !== b && $2dcef90724314473$var$K($2dcef90724314473$var$H, b.startTime - a);
        }
    }
}
function $2dcef90724314473$var$J(a, b) {
    $2dcef90724314473$var$A = !1;
    $2dcef90724314473$var$B && ($2dcef90724314473$var$B = !1, $2dcef90724314473$var$E($2dcef90724314473$var$L), $2dcef90724314473$var$L = -1);
    $2dcef90724314473$var$z = !0;
    var c = $2dcef90724314473$var$y;
    try {
        $2dcef90724314473$var$G(b);
        for($2dcef90724314473$var$v = $2dcef90724314473$var$h($2dcef90724314473$var$r); null !== $2dcef90724314473$var$v && (!($2dcef90724314473$var$v.expirationTime > b) || a && !$2dcef90724314473$var$M());){
            var d = $2dcef90724314473$var$v.callback;
            if ("function" === typeof d) {
                $2dcef90724314473$var$v.callback = null;
                $2dcef90724314473$var$y = $2dcef90724314473$var$v.priorityLevel;
                var e = d($2dcef90724314473$var$v.expirationTime <= b);
                b = $2dcef90724314473$export$c4744153514ff05d();
                "function" === typeof e ? $2dcef90724314473$var$v.callback = e : $2dcef90724314473$var$v === $2dcef90724314473$var$h($2dcef90724314473$var$r) && $2dcef90724314473$var$k($2dcef90724314473$var$r);
                $2dcef90724314473$var$G(b);
            } else $2dcef90724314473$var$k($2dcef90724314473$var$r);
            $2dcef90724314473$var$v = $2dcef90724314473$var$h($2dcef90724314473$var$r);
        }
        if (null !== $2dcef90724314473$var$v) var w = !0;
        else {
            var m = $2dcef90724314473$var$h($2dcef90724314473$var$t);
            null !== m && $2dcef90724314473$var$K($2dcef90724314473$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $2dcef90724314473$var$v = null, $2dcef90724314473$var$y = c, $2dcef90724314473$var$z = !1;
    }
}
var $2dcef90724314473$var$N = !1, $2dcef90724314473$var$O = null, $2dcef90724314473$var$L = -1, $2dcef90724314473$var$P = 5, $2dcef90724314473$var$Q = -1;
function $2dcef90724314473$var$M() {
    return $2dcef90724314473$export$c4744153514ff05d() - $2dcef90724314473$var$Q < $2dcef90724314473$var$P ? !1 : !0;
}
function $2dcef90724314473$var$R() {
    if (null !== $2dcef90724314473$var$O) {
        var a = $2dcef90724314473$export$c4744153514ff05d();
        $2dcef90724314473$var$Q = a;
        var b = !0;
        try {
            b = $2dcef90724314473$var$O(!0, a);
        } finally{
            b ? $2dcef90724314473$var$S() : ($2dcef90724314473$var$N = !1, $2dcef90724314473$var$O = null);
        }
    } else $2dcef90724314473$var$N = !1;
}
var $2dcef90724314473$var$S;
if ("function" === typeof $2dcef90724314473$var$F) $2dcef90724314473$var$S = function S() {
    $2dcef90724314473$var$F($2dcef90724314473$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $2dcef90724314473$var$T = new MessageChannel, $2dcef90724314473$var$U = $2dcef90724314473$var$T.port2;
    $2dcef90724314473$var$T.port1.onmessage = $2dcef90724314473$var$R;
    $2dcef90724314473$var$S = function S() {
        $2dcef90724314473$var$U.postMessage(null);
    };
} else $2dcef90724314473$var$S = function S() {
    $2dcef90724314473$var$D($2dcef90724314473$var$R, 0);
};
function $2dcef90724314473$var$I(a) {
    $2dcef90724314473$var$O = a;
    $2dcef90724314473$var$N || ($2dcef90724314473$var$N = !0, $2dcef90724314473$var$S());
}
function $2dcef90724314473$var$K(a, b) {
    $2dcef90724314473$var$L = $2dcef90724314473$var$D(function() {
        a($2dcef90724314473$export$c4744153514ff05d());
    }, b);
}
$2dcef90724314473$export$3e506c1ccc9cc1a7 = 5;
$2dcef90724314473$export$e26fe2ed2fa76875 = 1;
$2dcef90724314473$export$502329bbf4b505b1 = 4;
$2dcef90724314473$export$6e3807111c4874c4 = 3;
$2dcef90724314473$export$c27134553091fb3a = null;
$2dcef90724314473$export$33ee1acdc04fd2a2 = 2;
$2dcef90724314473$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$2dcef90724314473$export$8352ce38b91d0c62 = function() {
    $2dcef90724314473$var$A || $2dcef90724314473$var$z || ($2dcef90724314473$var$A = !0, $2dcef90724314473$var$I($2dcef90724314473$var$J));
};
$2dcef90724314473$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $2dcef90724314473$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$2dcef90724314473$export$d3dfb8e4810cb555 = function() {
    return $2dcef90724314473$var$y;
};
$2dcef90724314473$export$839f9183b0465a69 = function() {
    return $2dcef90724314473$var$h($2dcef90724314473$var$r);
};
$2dcef90724314473$export$72fdf0e06517287b = function(a) {
    switch($2dcef90724314473$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $2dcef90724314473$var$y;
    }
    var c = $2dcef90724314473$var$y;
    $2dcef90724314473$var$y = b;
    try {
        return a();
    } finally{
        $2dcef90724314473$var$y = c;
    }
};
$2dcef90724314473$export$4b844e58a3e414b4 = function() {};
$2dcef90724314473$export$816d2913ae6b83b1 = function() {};
$2dcef90724314473$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $2dcef90724314473$var$y;
    $2dcef90724314473$var$y = a;
    try {
        return b();
    } finally{
        $2dcef90724314473$var$y = c;
    }
};
$2dcef90724314473$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $2dcef90724314473$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $2dcef90724314473$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $2dcef90724314473$var$f($2dcef90724314473$var$t, a), null === $2dcef90724314473$var$h($2dcef90724314473$var$r) && a === $2dcef90724314473$var$h($2dcef90724314473$var$t) && ($2dcef90724314473$var$B ? ($2dcef90724314473$var$E($2dcef90724314473$var$L), $2dcef90724314473$var$L = -1) : $2dcef90724314473$var$B = !0, $2dcef90724314473$var$K($2dcef90724314473$var$H, c - d))) : (a.sortIndex = e, $2dcef90724314473$var$f($2dcef90724314473$var$r, a), $2dcef90724314473$var$A || $2dcef90724314473$var$z || ($2dcef90724314473$var$A = !0, $2dcef90724314473$var$I($2dcef90724314473$var$J)));
    return a;
};
$2dcef90724314473$export$b5836b71941fa3ed = $2dcef90724314473$var$M;
$2dcef90724314473$export$cf845f2c119da08a = function(a) {
    var b = $2dcef90724314473$var$y;
    return function() {
        var c = $2dcef90724314473$var$y;
        $2dcef90724314473$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $2dcef90724314473$var$y = c;
        }
    };
};

});



parcelRequire.register("cx8MC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $3PPDi = parcelRequire("3PPDi");
function $91ff613b9d0f7ca8$var$emptyFunction() {}
function $91ff613b9d0f7ca8$var$emptyFunctionWithReset() {}
$91ff613b9d0f7ca8$var$emptyFunctionWithReset.resetWarningCache = $91ff613b9d0f7ca8$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $3PPDi) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $91ff613b9d0f7ca8$var$emptyFunctionWithReset,
        resetWarningCache: $91ff613b9d0f7ca8$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("3PPDi", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $2cae2fbc67ae0f28$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $2cae2fbc67ae0f28$var$ReactPropTypesSecret;

});


parcelRequire.register("lxN42", function(module, exports) {

var $3L4GM = parcelRequire("3L4GM");
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined1) {
    "use strict";
    var LIBVERSION = "1.0.37", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function extend(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function enumerize(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function has(str1, str2) {
        return (typeof str1 === "undefined" ? "undefined" : (0, $3L4GM._)(str1)) === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function lowerize(str) {
        return str.toLowerCase();
    }, majorize = function majorize(version) {
        return (typeof version === "undefined" ? "undefined" : (0, $3L4GM._)(version)) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined1;
    }, trim = function trim(str, len) {
        if ((typeof str === "undefined" ? "undefined" : (0, $3L4GM._)(str)) === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return (typeof len === "undefined" ? "undefined" : (0, $3L4GM._)(len)) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function rgxMapper(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if ((typeof q === "undefined" ? "undefined" : (0, $3L4GM._)(q)) === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if ((0, $3L4GM._)(q[1]) == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if ((0, $3L4GM._)(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined1;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined1;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined1;
                    } else this[q] = match ? match : undefined1;
                }
            }
            i += 2;
        }
    }, strMapper = function strMapper(str, map) {
        for(var i in map){
            if ((0, $3L4GM._)(map[i]) === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined1 : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined1 : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function UAParser1(ua, extensions) {
        if ((typeof ua === "undefined" ? "undefined" : (0, $3L4GM._)(ua)) === OBJ_TYPE) {
            extensions = ua;
            ua = undefined1;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = (typeof window1 === "undefined" ? "undefined" : (0, $3L4GM._)(window1)) !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined1;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined1;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined1;
            _browser[VERSION] = undefined1;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && (0, $3L4GM._)(_navigator.brave.isBrave) == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined1;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined1;
            _device[MODEL] = undefined1;
            _device[TYPE] = undefined1;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && (0, $3L4GM._)(_navigator.standalone) !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined1;
            _engine[VERSION] = undefined1;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined1;
            _os[VERSION] = undefined1;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = (typeof ua === "undefined" ? "undefined" : (0, $3L4GM._)(ua)) === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if ((typeof define === "undefined" ? "undefined" : (0, $3L4GM._)(define)) === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if ((typeof window1 === "undefined" ? "undefined" : (0, $3L4GM._)(window1)) !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = (typeof window1 === "undefined" ? "undefined" : (0, $3L4GM._)(window1)) !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : undefined);

});

parcelRequire.register("3aHpZ", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $24f3fc3605d68da5$export$bdfd709ae4826697; }, function (v) { return $24f3fc3605d68da5$export$bdfd709ae4826697 = v; });
var $24f3fc3605d68da5$export$bdfd709ae4826697;
var $24f3fc3605d68da5$export$c9e73fbda7da57b6;
var $24f3fc3605d68da5$export$5a759dc7a1cfb72a;
"use strict";
var $24f3fc3605d68da5$var$bundleURL = {};
function $24f3fc3605d68da5$var$getBundleURLCached(id) {
    var value = $24f3fc3605d68da5$var$bundleURL[id];
    if (!value) {
        value = $24f3fc3605d68da5$var$getBundleURL();
        $24f3fc3605d68da5$var$bundleURL[id] = value;
    }
    return value;
}
function $24f3fc3605d68da5$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $24f3fc3605d68da5$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $24f3fc3605d68da5$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $24f3fc3605d68da5$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$24f3fc3605d68da5$export$bdfd709ae4826697 = $24f3fc3605d68da5$var$getBundleURLCached;
$24f3fc3605d68da5$export$c9e73fbda7da57b6 = $24f3fc3605d68da5$var$getBaseURL;
$24f3fc3605d68da5$export$5a759dc7a1cfb72a = $24f3fc3605d68da5$var$getOrigin;

});

/* eslint-disable-next-line import/no-unassigned-import, unicorn/no-unnecessary-polyfills -- polyfill by design */ "use strict";
"use strict";
var $d4b8e88525a1c695$exports = {};

var $3L4GM = parcelRequire("3L4GM");
"use strict";
var $0f4ea948f6673103$exports = {};
"use strict";
var $0f4ea948f6673103$var$check = function check(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$0f4ea948f6673103$exports = // eslint-disable-next-line es/no-global-this -- safe
$0f4ea948f6673103$var$check(typeof globalThis == "object" && globalThis) || $0f4ea948f6673103$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$0f4ea948f6673103$var$check(typeof self == "object" && self) || $0f4ea948f6673103$var$check(typeof $parcel$global == "object" && $parcel$global) || $0f4ea948f6673103$var$check(typeof $0f4ea948f6673103$exports == "object" && $0f4ea948f6673103$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $003023ef435958c5$export$2d1720544b23b823;
"use strict";
var $40260b59b65c2e4c$exports = {};
"use strict";
var $7bdc373729e45e27$exports = {};
"use strict";
$7bdc373729e45e27$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$40260b59b65c2e4c$exports = !$7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] !== 7;
});


var $4b3fe34719193049$exports = {};
"use strict";
var $e206ebbecedd2bde$exports = {};
"use strict";

$e206ebbecedd2bde$exports = !$7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $4b3fe34719193049$var$call = Function.prototype.call;
$4b3fe34719193049$exports = $e206ebbecedd2bde$exports ? $4b3fe34719193049$var$call.bind($4b3fe34719193049$var$call) : function() {
    return $4b3fe34719193049$var$call.apply($4b3fe34719193049$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $11de82002a093be1$export$2d1720544b23b823;
"use strict";
var $11de82002a093be1$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $11de82002a093be1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $11de82002a093be1$var$NASHORN_BUG = $11de82002a093be1$var$getOwnPropertyDescriptor && !$11de82002a093be1$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$11de82002a093be1$export$2d1720544b23b823 = $11de82002a093be1$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $11de82002a093be1$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $11de82002a093be1$var$$propertyIsEnumerable;


var $ca4a4ced04e4a412$exports = {};
"use strict";
$ca4a4ced04e4a412$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $44022b55b2d2b203$exports = {};
"use strict";
var $20eeb1af973ba55b$exports = {};
"use strict";
var $23a00ee3e029ff58$exports = {};
"use strict";

var $23a00ee3e029ff58$var$FunctionPrototype = Function.prototype;
var $23a00ee3e029ff58$var$call = $23a00ee3e029ff58$var$FunctionPrototype.call;
var $23a00ee3e029ff58$var$uncurryThisWithBind = $e206ebbecedd2bde$exports && $23a00ee3e029ff58$var$FunctionPrototype.bind.bind($23a00ee3e029ff58$var$call, $23a00ee3e029ff58$var$call);
$23a00ee3e029ff58$exports = $e206ebbecedd2bde$exports ? $23a00ee3e029ff58$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $23a00ee3e029ff58$var$call.apply(fn, arguments);
    };
};



var $4cba9a2acb4bdb16$exports = {};
"use strict";

var $4cba9a2acb4bdb16$var$toString = $23a00ee3e029ff58$exports({}.toString);
var $4cba9a2acb4bdb16$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
$4cba9a2acb4bdb16$exports = function(it) {
    return $4cba9a2acb4bdb16$var$stringSlice($4cba9a2acb4bdb16$var$toString(it), 8, -1);
};


var $20eeb1af973ba55b$var$$Object = Object;
var $20eeb1af973ba55b$var$split = $23a00ee3e029ff58$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$20eeb1af973ba55b$exports = $7bdc373729e45e27$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$20eeb1af973ba55b$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $4cba9a2acb4bdb16$exports(it) === "String" ? $20eeb1af973ba55b$var$split(it, "") : $20eeb1af973ba55b$var$$Object(it);
} : $20eeb1af973ba55b$var$$Object;


var $ddbaa5896e5ed636$exports = {};
"use strict";
var $76135a25443d684f$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$76135a25443d684f$exports = function(it) {
    return it === null || it === undefined;
};


var $ddbaa5896e5ed636$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$ddbaa5896e5ed636$exports = function(it) {
    if ($76135a25443d684f$exports(it)) throw new $ddbaa5896e5ed636$var$$TypeError("Can't call method on " + it);
    return it;
};


$44022b55b2d2b203$exports = function(it) {
    return $20eeb1af973ba55b$exports($ddbaa5896e5ed636$exports(it));
};


var $8bc65e9087e8d1e0$exports = {};
"use strict";
var $cd38c3644f9f1332$exports = {};
"use strict";

var $b1a75f6ed3e2d50f$exports = {};
"use strict";
var $64c802885f841370$exports = {};
"use strict";
var $6a3d61f4b677ead8$exports = {};
"use strict";
var $6a3d61f4b677ead8$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $6a3d61f4b677ead8$var$IS_HTMLDDA = typeof $6a3d61f4b677ead8$var$documentAll == "undefined" && $6a3d61f4b677ead8$var$documentAll !== undefined;
$6a3d61f4b677ead8$exports = {
    all: $6a3d61f4b677ead8$var$documentAll,
    IS_HTMLDDA: $6a3d61f4b677ead8$var$IS_HTMLDDA
};


var $64c802885f841370$var$documentAll = $6a3d61f4b677ead8$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$64c802885f841370$exports = $6a3d61f4b677ead8$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $64c802885f841370$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};



var $b1a75f6ed3e2d50f$var$documentAll = $6a3d61f4b677ead8$exports.all;
$b1a75f6ed3e2d50f$exports = $6a3d61f4b677ead8$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $64c802885f841370$exports(it) || it === $b1a75f6ed3e2d50f$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $64c802885f841370$exports(it);
};


var $368e2561dee205ff$exports = {};

var $3L4GM = parcelRequire("3L4GM");
"use strict";
var $db85f9884fa161d0$exports = {};
"use strict";


var $db85f9884fa161d0$var$aFunction = function aFunction(argument) {
    return $64c802885f841370$exports(argument) ? argument : undefined;
};
$db85f9884fa161d0$exports = function(namespace, method) {
    return arguments.length < 2 ? $db85f9884fa161d0$var$aFunction($0f4ea948f6673103$exports[namespace]) : $0f4ea948f6673103$exports[namespace] && $0f4ea948f6673103$exports[namespace][method];
};



var $372efcd1340d8495$exports = {};
"use strict";

$372efcd1340d8495$exports = $23a00ee3e029ff58$exports({}.isPrototypeOf);


var $4dc9e14bdeddabf6$exports = {};

var $3L4GM = parcelRequire("3L4GM");
"use strict";
var $cf352a9ea0f218c2$exports = {};
"use strict";
var $d478a9aa1d363d00$exports = {};
"use strict";

var $4e05041f80099315$exports = {};
"use strict";
$4e05041f80099315$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $d478a9aa1d363d00$var$process = $0f4ea948f6673103$exports.process;
var $d478a9aa1d363d00$var$Deno = $0f4ea948f6673103$exports.Deno;
var $d478a9aa1d363d00$var$versions = $d478a9aa1d363d00$var$process && $d478a9aa1d363d00$var$process.versions || $d478a9aa1d363d00$var$Deno && $d478a9aa1d363d00$var$Deno.version;
var $d478a9aa1d363d00$var$v8 = $d478a9aa1d363d00$var$versions && $d478a9aa1d363d00$var$versions.v8;
var $d478a9aa1d363d00$var$match, $d478a9aa1d363d00$var$version;
if ($d478a9aa1d363d00$var$v8) {
    $d478a9aa1d363d00$var$match = $d478a9aa1d363d00$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $d478a9aa1d363d00$var$version = $d478a9aa1d363d00$var$match[0] > 0 && $d478a9aa1d363d00$var$match[0] < 4 ? 1 : +($d478a9aa1d363d00$var$match[0] + $d478a9aa1d363d00$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$d478a9aa1d363d00$var$version && $4e05041f80099315$exports) {
    $d478a9aa1d363d00$var$match = $4e05041f80099315$exports.match(/Edge\/(\d+)/);
    if (!$d478a9aa1d363d00$var$match || $d478a9aa1d363d00$var$match[1] >= 74) {
        $d478a9aa1d363d00$var$match = $4e05041f80099315$exports.match(/Chrome\/(\d+)/);
        if ($d478a9aa1d363d00$var$match) $d478a9aa1d363d00$var$version = +$d478a9aa1d363d00$var$match[1];
    }
}
$d478a9aa1d363d00$exports = $d478a9aa1d363d00$var$version;




var $cf352a9ea0f218c2$var$$String = $0f4ea948f6673103$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$cf352a9ea0f218c2$exports = !!Object.getOwnPropertySymbols && !$7bdc373729e45e27$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$cf352a9ea0f218c2$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $d478a9aa1d363d00$exports && $d478a9aa1d363d00$exports < 41;
});


$4dc9e14bdeddabf6$exports = $cf352a9ea0f218c2$exports && !Symbol.sham && (0, $3L4GM._)(Symbol.iterator) == "symbol";


var $368e2561dee205ff$var$$Object = Object;
$368e2561dee205ff$exports = $4dc9e14bdeddabf6$exports ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $3L4GM._)(it)) == "symbol";
} : function(it) {
    var $Symbol = $db85f9884fa161d0$exports("Symbol");
    return $64c802885f841370$exports($Symbol) && $372efcd1340d8495$exports($Symbol.prototype, $368e2561dee205ff$var$$Object(it));
};


var $f29b070ab2fd2ce7$exports = {};
"use strict";
var $8b3f43e1fb85f635$exports = {};
"use strict";

var $815d6e8656bb616c$exports = {};
"use strict";
var $815d6e8656bb616c$var$$String = String;
$815d6e8656bb616c$exports = function(argument) {
    try {
        return $815d6e8656bb616c$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $8b3f43e1fb85f635$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$8b3f43e1fb85f635$exports = function(argument) {
    if ($64c802885f841370$exports(argument)) return argument;
    throw new $8b3f43e1fb85f635$var$$TypeError($815d6e8656bb616c$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$f29b070ab2fd2ce7$exports = function(V, P) {
    var func = V[P];
    return $76135a25443d684f$exports(func) ? undefined : $8b3f43e1fb85f635$exports(func);
};


var $35f9ffdabde9ad75$exports = {};
"use strict";



var $35f9ffdabde9ad75$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$35f9ffdabde9ad75$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $64c802885f841370$exports(fn = input.toString) && !$b1a75f6ed3e2d50f$exports(val = $4b3fe34719193049$exports(fn, input))) return val;
    if ($64c802885f841370$exports(fn = input.valueOf) && !$b1a75f6ed3e2d50f$exports(val = $4b3fe34719193049$exports(fn, input))) return val;
    if (pref !== "string" && $64c802885f841370$exports(fn = input.toString) && !$b1a75f6ed3e2d50f$exports(val = $4b3fe34719193049$exports(fn, input))) return val;
    throw new $35f9ffdabde9ad75$var$$TypeError("Can't convert object to primitive value");
};


var $6c5fb57dad6dd350$exports = {};
"use strict";

var $7ecb1b65119c8ef8$exports = {};
"use strict";
var $bad8555d514b807c$exports = {};
"use strict";
$bad8555d514b807c$exports = false;


var $43da9f3786677be0$exports = {};
"use strict";

var $82fc479f9361f11e$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $82fc479f9361f11e$var$defineProperty = Object.defineProperty;
$82fc479f9361f11e$exports = function(key, value) {
    try {
        $82fc479f9361f11e$var$defineProperty($0f4ea948f6673103$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $0f4ea948f6673103$exports[key] = value;
    }
    return value;
};


var $43da9f3786677be0$var$SHARED = "__core-js_shared__";
var $43da9f3786677be0$var$store = $0f4ea948f6673103$exports[$43da9f3786677be0$var$SHARED] || $82fc479f9361f11e$exports($43da9f3786677be0$var$SHARED, {});
$43da9f3786677be0$exports = $43da9f3786677be0$var$store;


($7ecb1b65119c8ef8$exports = function(key, value) {
    return $43da9f3786677be0$exports[key] || ($43da9f3786677be0$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.34.0",
    mode: $bad8555d514b807c$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.34.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $5f4f8ca39500aba6$exports = {};
"use strict";

var $7d5785aa2fc2b3e1$exports = {};
"use strict";

var $7d5785aa2fc2b3e1$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$7d5785aa2fc2b3e1$exports = function(argument) {
    return $7d5785aa2fc2b3e1$var$$Object($ddbaa5896e5ed636$exports(argument));
};


var $5f4f8ca39500aba6$var$hasOwnProperty = $23a00ee3e029ff58$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$5f4f8ca39500aba6$exports = Object.hasOwn || function hasOwn(it, key) {
    return $5f4f8ca39500aba6$var$hasOwnProperty($7d5785aa2fc2b3e1$exports(it), key);
};


var $3139b6d9415fe2b9$exports = {};
"use strict";

var $3139b6d9415fe2b9$var$id = 0;
var $3139b6d9415fe2b9$var$postfix = Math.random();
var $3139b6d9415fe2b9$var$toString = $23a00ee3e029ff58$exports(1.0.toString);
$3139b6d9415fe2b9$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $3139b6d9415fe2b9$var$toString(++$3139b6d9415fe2b9$var$id + $3139b6d9415fe2b9$var$postfix, 36);
};




var $6c5fb57dad6dd350$var$Symbol = $0f4ea948f6673103$exports.Symbol;
var $6c5fb57dad6dd350$var$WellKnownSymbolsStore = $7ecb1b65119c8ef8$exports("wks");
var $6c5fb57dad6dd350$var$createWellKnownSymbol = $4dc9e14bdeddabf6$exports ? $6c5fb57dad6dd350$var$Symbol["for"] || $6c5fb57dad6dd350$var$Symbol : $6c5fb57dad6dd350$var$Symbol && $6c5fb57dad6dd350$var$Symbol.withoutSetter || $3139b6d9415fe2b9$exports;
$6c5fb57dad6dd350$exports = function(name) {
    if (!$5f4f8ca39500aba6$exports($6c5fb57dad6dd350$var$WellKnownSymbolsStore, name)) $6c5fb57dad6dd350$var$WellKnownSymbolsStore[name] = $cf352a9ea0f218c2$exports && $5f4f8ca39500aba6$exports($6c5fb57dad6dd350$var$Symbol, name) ? $6c5fb57dad6dd350$var$Symbol[name] : $6c5fb57dad6dd350$var$createWellKnownSymbol("Symbol." + name);
    return $6c5fb57dad6dd350$var$WellKnownSymbolsStore[name];
};


var $cd38c3644f9f1332$var$$TypeError = TypeError;
var $cd38c3644f9f1332$var$TO_PRIMITIVE = $6c5fb57dad6dd350$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$cd38c3644f9f1332$exports = function(input, pref) {
    if (!$b1a75f6ed3e2d50f$exports(input) || $368e2561dee205ff$exports(input)) return input;
    var exoticToPrim = $f29b070ab2fd2ce7$exports(input, $cd38c3644f9f1332$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $4b3fe34719193049$exports(exoticToPrim, input, pref);
        if (!$b1a75f6ed3e2d50f$exports(result) || $368e2561dee205ff$exports(result)) return result;
        throw new $cd38c3644f9f1332$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $35f9ffdabde9ad75$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$8bc65e9087e8d1e0$exports = function(argument) {
    var key = $cd38c3644f9f1332$exports(argument, "string");
    return $368e2561dee205ff$exports(key) ? key : key + "";
};



var $a22cca1e4988c37f$exports = {};
"use strict";


var $ef80f2f49f1eda1a$exports = {};
"use strict";


var $ef80f2f49f1eda1a$var$document = $0f4ea948f6673103$exports.document;
// typeof document.createElement is 'object' in old IE
var $ef80f2f49f1eda1a$var$EXISTS = $b1a75f6ed3e2d50f$exports($ef80f2f49f1eda1a$var$document) && $b1a75f6ed3e2d50f$exports($ef80f2f49f1eda1a$var$document.createElement);
$ef80f2f49f1eda1a$exports = function(it) {
    return $ef80f2f49f1eda1a$var$EXISTS ? $ef80f2f49f1eda1a$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$a22cca1e4988c37f$exports = !$40260b59b65c2e4c$exports && !$7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($ef80f2f49f1eda1a$exports("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $003023ef435958c5$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$003023ef435958c5$export$2d1720544b23b823 = $40260b59b65c2e4c$exports ? $003023ef435958c5$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $44022b55b2d2b203$exports(O);
    P = $8bc65e9087e8d1e0$exports(P);
    if ($a22cca1e4988c37f$exports) try {
        return $003023ef435958c5$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($5f4f8ca39500aba6$exports(O, P)) return $ca4a4ced04e4a412$exports(!$4b3fe34719193049$exports($11de82002a093be1$export$2d1720544b23b823, O, P), O[P]);
};


var $d4b8e88525a1c695$require$getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;
var $4bc121b672cbfd84$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $18b1ebdefa97b93b$export$2d1720544b23b823;
"use strict";


var $4e111cce4b7683fc$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$4e111cce4b7683fc$exports = $40260b59b65c2e4c$exports && $7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c894fc907eeec831$exports = {};
"use strict";

var $c894fc907eeec831$var$$String = String;
var $c894fc907eeec831$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c894fc907eeec831$exports = function(argument) {
    if ($b1a75f6ed3e2d50f$exports(argument)) return argument;
    throw new $c894fc907eeec831$var$$TypeError($c894fc907eeec831$var$$String(argument) + " is not an object");
};



var $18b1ebdefa97b93b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $18b1ebdefa97b93b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $18b1ebdefa97b93b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $18b1ebdefa97b93b$var$ENUMERABLE = "enumerable";
var $18b1ebdefa97b93b$var$CONFIGURABLE = "configurable";
var $18b1ebdefa97b93b$var$WRITABLE = "writable";
$18b1ebdefa97b93b$export$2d1720544b23b823 = $40260b59b65c2e4c$exports ? $4e111cce4b7683fc$exports ? function defineProperty(O, P, Attributes) {
    $c894fc907eeec831$exports(O);
    P = $8bc65e9087e8d1e0$exports(P);
    $c894fc907eeec831$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $18b1ebdefa97b93b$var$WRITABLE in Attributes && !Attributes[$18b1ebdefa97b93b$var$WRITABLE]) {
        var current = $18b1ebdefa97b93b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$18b1ebdefa97b93b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $18b1ebdefa97b93b$var$CONFIGURABLE in Attributes ? Attributes[$18b1ebdefa97b93b$var$CONFIGURABLE] : current[$18b1ebdefa97b93b$var$CONFIGURABLE],
                enumerable: $18b1ebdefa97b93b$var$ENUMERABLE in Attributes ? Attributes[$18b1ebdefa97b93b$var$ENUMERABLE] : current[$18b1ebdefa97b93b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $18b1ebdefa97b93b$var$$defineProperty(O, P, Attributes);
} : $18b1ebdefa97b93b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c894fc907eeec831$exports(O);
    P = $8bc65e9087e8d1e0$exports(P);
    $c894fc907eeec831$exports(Attributes);
    if ($a22cca1e4988c37f$exports) try {
        return $18b1ebdefa97b93b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $18b1ebdefa97b93b$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$4bc121b672cbfd84$exports = $40260b59b65c2e4c$exports ? function(object, key, value) {
    return $18b1ebdefa97b93b$export$2d1720544b23b823(object, key, $ca4a4ced04e4a412$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $f488b1cc13335fff$exports = {};
"use strict";


var $79af1eca4f325743$exports = {};
"use strict";





var $b7b4004231446e90$exports = {};
"use strict";


var $b7b4004231446e90$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b7b4004231446e90$var$getDescriptor = $40260b59b65c2e4c$exports && Object.getOwnPropertyDescriptor;
var $b7b4004231446e90$var$EXISTS = $5f4f8ca39500aba6$exports($b7b4004231446e90$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $b7b4004231446e90$var$PROPER = $b7b4004231446e90$var$EXISTS && (function something() {}).name === "something";
var $b7b4004231446e90$var$CONFIGURABLE = $b7b4004231446e90$var$EXISTS && (!$40260b59b65c2e4c$exports || $40260b59b65c2e4c$exports && $b7b4004231446e90$var$getDescriptor($b7b4004231446e90$var$FunctionPrototype, "name").configurable);
$b7b4004231446e90$exports = {
    EXISTS: $b7b4004231446e90$var$EXISTS,
    PROPER: $b7b4004231446e90$var$PROPER,
    CONFIGURABLE: $b7b4004231446e90$var$CONFIGURABLE
};


var $79af1eca4f325743$require$CONFIGURABLE_FUNCTION_NAME = $b7b4004231446e90$exports.CONFIGURABLE;
var $6b4a072d19c2902d$exports = {};
"use strict";



var $6b4a072d19c2902d$var$functionToString = $23a00ee3e029ff58$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$64c802885f841370$exports($43da9f3786677be0$exports.inspectSource)) $43da9f3786677be0$exports.inspectSource = function(it) {
    return $6b4a072d19c2902d$var$functionToString(it);
};
$6b4a072d19c2902d$exports = $43da9f3786677be0$exports.inspectSource;


var $c70ec777954e7cbe$exports = {};
"use strict";
var $c8f8e42caa16fad5$exports = {};
"use strict";


var $c8f8e42caa16fad5$var$WeakMap = $0f4ea948f6673103$exports.WeakMap;
$c8f8e42caa16fad5$exports = $64c802885f841370$exports($c8f8e42caa16fad5$var$WeakMap) && /native code/.test(String($c8f8e42caa16fad5$var$WeakMap));







var $67028cac70b02c6c$exports = {};
"use strict";


var $67028cac70b02c6c$var$keys = $7ecb1b65119c8ef8$exports("keys");
$67028cac70b02c6c$exports = function(key) {
    return $67028cac70b02c6c$var$keys[key] || ($67028cac70b02c6c$var$keys[key] = $3139b6d9415fe2b9$exports(key));
};


var $76695f3a4d4ba903$exports = {};
"use strict";
$76695f3a4d4ba903$exports = {};


var $c70ec777954e7cbe$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $c70ec777954e7cbe$var$TypeError = $0f4ea948f6673103$exports.TypeError;
var $c70ec777954e7cbe$var$WeakMap = $0f4ea948f6673103$exports.WeakMap;
var $c70ec777954e7cbe$var$set, $c70ec777954e7cbe$var$get, $c70ec777954e7cbe$var$has;
var $c70ec777954e7cbe$var$enforce = function enforce(it) {
    return $c70ec777954e7cbe$var$has(it) ? $c70ec777954e7cbe$var$get(it) : $c70ec777954e7cbe$var$set(it, {});
};
var $c70ec777954e7cbe$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$b1a75f6ed3e2d50f$exports(it) || (state = $c70ec777954e7cbe$var$get(it)).type !== TYPE) throw new $c70ec777954e7cbe$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($c8f8e42caa16fad5$exports || $43da9f3786677be0$exports.state) {
    var $c70ec777954e7cbe$var$store = $43da9f3786677be0$exports.state || ($43da9f3786677be0$exports.state = new $c70ec777954e7cbe$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $c70ec777954e7cbe$var$store.get = $c70ec777954e7cbe$var$store.get;
    $c70ec777954e7cbe$var$store.has = $c70ec777954e7cbe$var$store.has;
    $c70ec777954e7cbe$var$store.set = $c70ec777954e7cbe$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $c70ec777954e7cbe$var$set = function set(it, metadata) {
        if ($c70ec777954e7cbe$var$store.has(it)) throw new $c70ec777954e7cbe$var$TypeError($c70ec777954e7cbe$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $c70ec777954e7cbe$var$store.set(it, metadata);
        return metadata;
    };
    $c70ec777954e7cbe$var$get = function get(it) {
        return $c70ec777954e7cbe$var$store.get(it) || {};
    };
    $c70ec777954e7cbe$var$has = function has(it) {
        return $c70ec777954e7cbe$var$store.has(it);
    };
} else {
    var $c70ec777954e7cbe$var$STATE = $67028cac70b02c6c$exports("state");
    $76695f3a4d4ba903$exports[$c70ec777954e7cbe$var$STATE] = true;
    $c70ec777954e7cbe$var$set = function set(it, metadata) {
        if ($5f4f8ca39500aba6$exports(it, $c70ec777954e7cbe$var$STATE)) throw new $c70ec777954e7cbe$var$TypeError($c70ec777954e7cbe$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $4bc121b672cbfd84$exports(it, $c70ec777954e7cbe$var$STATE, metadata);
        return metadata;
    };
    $c70ec777954e7cbe$var$get = function get(it) {
        return $5f4f8ca39500aba6$exports(it, $c70ec777954e7cbe$var$STATE) ? it[$c70ec777954e7cbe$var$STATE] : {};
    };
    $c70ec777954e7cbe$var$has = function has(it) {
        return $5f4f8ca39500aba6$exports(it, $c70ec777954e7cbe$var$STATE);
    };
}
$c70ec777954e7cbe$exports = {
    set: $c70ec777954e7cbe$var$set,
    get: $c70ec777954e7cbe$var$get,
    has: $c70ec777954e7cbe$var$has,
    enforce: $c70ec777954e7cbe$var$enforce,
    getterFor: $c70ec777954e7cbe$var$getterFor
};


var $79af1eca4f325743$var$enforceInternalState = $c70ec777954e7cbe$exports.enforce;
var $79af1eca4f325743$var$getInternalState = $c70ec777954e7cbe$exports.get;
var $79af1eca4f325743$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $79af1eca4f325743$var$defineProperty = Object.defineProperty;
var $79af1eca4f325743$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $79af1eca4f325743$var$replace = $23a00ee3e029ff58$exports("".replace);
var $79af1eca4f325743$var$join = $23a00ee3e029ff58$exports([].join);
var $79af1eca4f325743$var$CONFIGURABLE_LENGTH = $40260b59b65c2e4c$exports && !$7bdc373729e45e27$exports(function() {
    return $79af1eca4f325743$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $79af1eca4f325743$var$TEMPLATE = String(String).split("String");
var $79af1eca4f325743$var$makeBuiltIn = $79af1eca4f325743$exports = function makeBuiltIn(value, name, options) {
    if ($79af1eca4f325743$var$stringSlice($79af1eca4f325743$var$$String(name), 0, 7) === "Symbol(") name = "[" + $79af1eca4f325743$var$replace($79af1eca4f325743$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$5f4f8ca39500aba6$exports(value, "name") || $79af1eca4f325743$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($40260b59b65c2e4c$exports) $79af1eca4f325743$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($79af1eca4f325743$var$CONFIGURABLE_LENGTH && options && $5f4f8ca39500aba6$exports(options, "arity") && value.length !== options.arity) $79af1eca4f325743$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $5f4f8ca39500aba6$exports(options, "constructor") && options.constructor) {
            if ($40260b59b65c2e4c$exports) $79af1eca4f325743$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $79af1eca4f325743$var$enforceInternalState(value);
    if (!$5f4f8ca39500aba6$exports(state, "source")) state.source = $79af1eca4f325743$var$join($79af1eca4f325743$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $79af1eca4f325743$var$makeBuiltIn(function toString() {
    return $64c802885f841370$exports(this) && $79af1eca4f325743$var$getInternalState(this).source || $6b4a072d19c2902d$exports(this);
}, "toString");



$f488b1cc13335fff$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($64c802885f841370$exports(value)) $79af1eca4f325743$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $82fc479f9361f11e$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $18b1ebdefa97b93b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $bc7f39059f462d6d$exports = {};
"use strict";

var $3bb4a02eb78e659e$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $a329b85dee9c6785$export$2d1720544b23b823;
"use strict";
var $b9c2b2fb5462efc9$exports = {};
"use strict";



var $426db30bef2424d6$exports = {};
"use strict";

var $4c10e2bcec3cf322$exports = {};
"use strict";
var $5e45f07a290dfff0$exports = {};
"use strict";
var $2f39dbb70845f716$exports = {};
"use strict";
var $2f39dbb70845f716$var$ceil = Math.ceil;
var $2f39dbb70845f716$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$2f39dbb70845f716$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $2f39dbb70845f716$var$floor : $2f39dbb70845f716$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$5e45f07a290dfff0$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $2f39dbb70845f716$exports(number);
};


var $4c10e2bcec3cf322$var$max = Math.max;
var $4c10e2bcec3cf322$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$4c10e2bcec3cf322$exports = function(index, length) {
    var integer = $5e45f07a290dfff0$exports(index);
    return integer < 0 ? $4c10e2bcec3cf322$var$max(integer + length, 0) : $4c10e2bcec3cf322$var$min(integer, length);
};


var $027f7f84b95594e7$exports = {};
"use strict";
var $8beae9420c83acf0$exports = {};
"use strict";

var $8beae9420c83acf0$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$8beae9420c83acf0$exports = function(argument) {
    return argument > 0 ? $8beae9420c83acf0$var$min($5e45f07a290dfff0$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$027f7f84b95594e7$exports = function(obj) {
    return $8beae9420c83acf0$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $426db30bef2424d6$var$createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $44022b55b2d2b203$exports($this);
        var length = $027f7f84b95594e7$exports(O);
        var index = $4c10e2bcec3cf322$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$426db30bef2424d6$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $426db30bef2424d6$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $426db30bef2424d6$var$createMethod(false)
};


var $b9c2b2fb5462efc9$require$indexOf = $426db30bef2424d6$exports.indexOf;

var $b9c2b2fb5462efc9$var$push = $23a00ee3e029ff58$exports([].push);
$b9c2b2fb5462efc9$exports = function(object, names) {
    var O = $44022b55b2d2b203$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$5f4f8ca39500aba6$exports($76695f3a4d4ba903$exports, key) && $5f4f8ca39500aba6$exports(O, key) && $b9c2b2fb5462efc9$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($5f4f8ca39500aba6$exports(O, key = names[i++])) ~$b9c2b2fb5462efc9$require$indexOf(result, key) || $b9c2b2fb5462efc9$var$push(result, key);
    return result;
};


var $d11d5102e358c21d$exports = {};
"use strict";
// IE8- don't enum bug keys
$d11d5102e358c21d$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $a329b85dee9c6785$var$hiddenKeys = $d11d5102e358c21d$exports.concat("length", "prototype");
$a329b85dee9c6785$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $b9c2b2fb5462efc9$exports(O, $a329b85dee9c6785$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $813bfc4ba50d6281$export$2d1720544b23b823;
"use strict";
$813bfc4ba50d6281$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $3bb4a02eb78e659e$var$concat = $23a00ee3e029ff58$exports([].concat);
// all object keys, includes non-enumerable and symbols
$3bb4a02eb78e659e$exports = $db85f9884fa161d0$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $a329b85dee9c6785$export$2d1720544b23b823($c894fc907eeec831$exports(it));
    var getOwnPropertySymbols = $813bfc4ba50d6281$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $3bb4a02eb78e659e$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$bc7f39059f462d6d$exports = function(target, source, exceptions) {
    var keys = $3bb4a02eb78e659e$exports(source);
    var defineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$5f4f8ca39500aba6$exports(target, key) && !(exceptions && $5f4f8ca39500aba6$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $0fb365768ae0f3c7$exports = {};
"use strict";


var $0fb365768ae0f3c7$var$replacement = /#|\.prototype\./;
var $0fb365768ae0f3c7$var$isForced = function isForced(feature, detection) {
    var value = $0fb365768ae0f3c7$var$data[$0fb365768ae0f3c7$var$normalize(feature)];
    return value === $0fb365768ae0f3c7$var$POLYFILL ? true : value === $0fb365768ae0f3c7$var$NATIVE ? false : $64c802885f841370$exports(detection) ? $7bdc373729e45e27$exports(detection) : !!detection;
};
var $0fb365768ae0f3c7$var$normalize = $0fb365768ae0f3c7$var$isForced.normalize = function normalize(string) {
    return String(string).replace($0fb365768ae0f3c7$var$replacement, ".").toLowerCase();
};
var $0fb365768ae0f3c7$var$data = $0fb365768ae0f3c7$var$isForced.data = {};
var $0fb365768ae0f3c7$var$NATIVE = $0fb365768ae0f3c7$var$isForced.NATIVE = "N";
var $0fb365768ae0f3c7$var$POLYFILL = $0fb365768ae0f3c7$var$isForced.POLYFILL = "P";
$0fb365768ae0f3c7$exports = $0fb365768ae0f3c7$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $d4b8e88525a1c695$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $0f4ea948f6673103$exports;
    else if (STATIC) target = $0f4ea948f6673103$exports[TARGET] || $82fc479f9361f11e$exports(TARGET, {});
    else target = ($0f4ea948f6673103$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $d4b8e88525a1c695$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $0fb365768ae0f3c7$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $3L4GM._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $3L4GM._)(targetProperty))) continue;
            $bc7f39059f462d6d$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $4bc121b672cbfd84$exports(sourceProperty, "sham", true);
        $f488b1cc13335fff$exports(target, key, sourceProperty, options);
    }
};














var $dd666817fb19c24c$exports = {};
"use strict";
var $19a284f0ad8e7bd9$exports = {};
"use strict";
var $9b7720140eeedd4d$exports = {};
"use strict";

var $9b7720140eeedd4d$var$TO_STRING_TAG = $6c5fb57dad6dd350$exports("toStringTag");
var $9b7720140eeedd4d$var$test = {};
$9b7720140eeedd4d$var$test[$9b7720140eeedd4d$var$TO_STRING_TAG] = "z";
$9b7720140eeedd4d$exports = String($9b7720140eeedd4d$var$test) === "[object z]";





var $19a284f0ad8e7bd9$var$TO_STRING_TAG = $6c5fb57dad6dd350$exports("toStringTag");
var $19a284f0ad8e7bd9$var$$Object = Object;
// ES3 wrong here
var $19a284f0ad8e7bd9$var$CORRECT_ARGUMENTS = $4cba9a2acb4bdb16$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $19a284f0ad8e7bd9$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$19a284f0ad8e7bd9$exports = $9b7720140eeedd4d$exports ? $4cba9a2acb4bdb16$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $19a284f0ad8e7bd9$var$tryGet(O = $19a284f0ad8e7bd9$var$$Object(it), $19a284f0ad8e7bd9$var$TO_STRING_TAG)) == "string" ? tag : $19a284f0ad8e7bd9$var$CORRECT_ARGUMENTS ? $4cba9a2acb4bdb16$exports(O) : (result = $4cba9a2acb4bdb16$exports(O)) === "Object" && $64c802885f841370$exports(O.callee) ? "Arguments" : result;
};


var $dd666817fb19c24c$var$$String = String;
$dd666817fb19c24c$exports = function(argument) {
    if ($19a284f0ad8e7bd9$exports(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $dd666817fb19c24c$var$$String(argument);
};



var $9959f3fdced32995$exports = {};
"use strict";

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $4c725e6f88c33573$export$2d1720544b23b823;
"use strict";





var $122382a0c203e2f5$exports = {};
"use strict";


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$122382a0c203e2f5$exports = Object.keys || function keys(O) {
    return $b9c2b2fb5462efc9$exports(O, $d11d5102e358c21d$exports);
};


$4c725e6f88c33573$export$2d1720544b23b823 = $40260b59b65c2e4c$exports && !$4e111cce4b7683fc$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $c894fc907eeec831$exports(O);
    var props = $44022b55b2d2b203$exports(Properties);
    var keys = $122382a0c203e2f5$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$18b1ebdefa97b93b$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $77a46ce9205fbe16$exports = {};
"use strict";

$77a46ce9205fbe16$exports = $db85f9884fa161d0$exports("document", "documentElement");




var $9959f3fdced32995$var$GT = ">";
var $9959f3fdced32995$var$LT = "<";
var $9959f3fdced32995$var$PROTOTYPE = "prototype";
var $9959f3fdced32995$var$SCRIPT = "script";
var $9959f3fdced32995$var$IE_PROTO = $67028cac70b02c6c$exports("IE_PROTO");
var $9959f3fdced32995$var$EmptyConstructor = function EmptyConstructor() {};
var $9959f3fdced32995$var$scriptTag = function scriptTag(content) {
    return $9959f3fdced32995$var$LT + $9959f3fdced32995$var$SCRIPT + $9959f3fdced32995$var$GT + content + $9959f3fdced32995$var$LT + "/" + $9959f3fdced32995$var$SCRIPT + $9959f3fdced32995$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $9959f3fdced32995$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($9959f3fdced32995$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $9959f3fdced32995$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $ef80f2f49f1eda1a$exports("iframe");
    var JS = "java" + $9959f3fdced32995$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $77a46ce9205fbe16$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($9959f3fdced32995$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $9959f3fdced32995$var$activeXDocument;
var $9959f3fdced32995$var$NullProtoObject = function NullProtoObject1() {
    try {
        $9959f3fdced32995$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $9959f3fdced32995$var$NullProtoObject = typeof document != "undefined" ? document.domain && $9959f3fdced32995$var$activeXDocument ? $9959f3fdced32995$var$NullProtoObjectViaActiveX($9959f3fdced32995$var$activeXDocument) // old IE
     : $9959f3fdced32995$var$NullProtoObjectViaIFrame() : $9959f3fdced32995$var$NullProtoObjectViaActiveX($9959f3fdced32995$var$activeXDocument); // WSH
    var length = $d11d5102e358c21d$exports.length;
    while(length--)delete $9959f3fdced32995$var$NullProtoObject[$9959f3fdced32995$var$PROTOTYPE][$d11d5102e358c21d$exports[length]];
    return $9959f3fdced32995$var$NullProtoObject();
};
$76695f3a4d4ba903$exports[$9959f3fdced32995$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$9959f3fdced32995$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $9959f3fdced32995$var$EmptyConstructor[$9959f3fdced32995$var$PROTOTYPE] = $c894fc907eeec831$exports(O);
        result = new $9959f3fdced32995$var$EmptyConstructor();
        $9959f3fdced32995$var$EmptyConstructor[$9959f3fdced32995$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$9959f3fdced32995$var$IE_PROTO] = O;
    } else result = $9959f3fdced32995$var$NullProtoObject();
    return Properties === undefined ? result : $4c725e6f88c33573$export$2d1720544b23b823(result, Properties);
};




// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $310e8a5d08b7fb31$export$2d1720544b23b823;
"use strict";



var $310e8a5d08b7fb31$require$$getOwnPropertyNames = $a329b85dee9c6785$export$2d1720544b23b823;
var $ad61b3a319da2150$exports = {};
"use strict";


var $2ac89df48719a8b2$exports = {};
"use strict";



$2ac89df48719a8b2$exports = function(object, key, value) {
    var propertyKey = $8bc65e9087e8d1e0$exports(key);
    if (propertyKey in object) $18b1ebdefa97b93b$export$2d1720544b23b823(object, propertyKey, $ca4a4ced04e4a412$exports(0, value));
    else object[propertyKey] = value;
};


var $ad61b3a319da2150$var$$Array = Array;
var $ad61b3a319da2150$var$max = Math.max;
$ad61b3a319da2150$exports = function(O, start, end) {
    var length = $027f7f84b95594e7$exports(O);
    var k = $4c10e2bcec3cf322$exports(start, length);
    var fin = $4c10e2bcec3cf322$exports(end === undefined ? length : end, length);
    var result = $ad61b3a319da2150$var$$Array($ad61b3a319da2150$var$max(fin - k, 0));
    var n = 0;
    for(; k < fin; k++, n++)$2ac89df48719a8b2$exports(result, n, O[k]);
    result.length = n;
    return result;
};


var $310e8a5d08b7fb31$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $310e8a5d08b7fb31$var$getWindowNames = function getWindowNames(it) {
    try {
        return $310e8a5d08b7fb31$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $ad61b3a319da2150$exports($310e8a5d08b7fb31$var$windowNames);
    }
};
$310e8a5d08b7fb31$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $310e8a5d08b7fb31$var$windowNames && $4cba9a2acb4bdb16$exports(it) === "Window" ? $310e8a5d08b7fb31$var$getWindowNames(it) : $310e8a5d08b7fb31$require$$getOwnPropertyNames($44022b55b2d2b203$exports(it));
};








var $d235cf6ad826c1e5$exports = {};
"use strict";


$d235cf6ad826c1e5$exports = function(target, name, descriptor) {
    if (descriptor.get) $79af1eca4f325743$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $79af1eca4f325743$exports(descriptor.set, name, {
        setter: true
    });
    return $18b1ebdefa97b93b$export$2d1720544b23b823(target, name, descriptor);
};







var $601639e97de2062d$export$2d1720544b23b823;
"use strict";

$601639e97de2062d$export$2d1720544b23b823 = $6c5fb57dad6dd350$exports;


var $b00a4c7565f1ee0f$exports = {};
"use strict";
var $0a6d052471fbbec7$exports = {};
"use strict";

$0a6d052471fbbec7$exports = $0f4ea948f6673103$exports;





var $b00a4c7565f1ee0f$require$defineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;
$b00a4c7565f1ee0f$exports = function(NAME) {
    var Symbol = $0a6d052471fbbec7$exports.Symbol || ($0a6d052471fbbec7$exports.Symbol = {});
    if (!$5f4f8ca39500aba6$exports(Symbol, NAME)) $b00a4c7565f1ee0f$require$defineProperty(Symbol, NAME, {
        value: $601639e97de2062d$export$2d1720544b23b823(NAME)
    });
};


var $9107b5a50a1cb0c9$exports = {};
"use strict";




$9107b5a50a1cb0c9$exports = function() {
    var Symbol = $db85f9884fa161d0$exports("Symbol");
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $6c5fb57dad6dd350$exports("toPrimitive");
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $f488b1cc13335fff$exports(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $4b3fe34719193049$exports(valueOf, this);
    }, {
        arity: 1
    });
};


var $0590ceb3c9c577a7$exports = {};
"use strict";

var $0590ceb3c9c577a7$require$defineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;


var $0590ceb3c9c577a7$var$TO_STRING_TAG = $6c5fb57dad6dd350$exports("toStringTag");
$0590ceb3c9c577a7$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$5f4f8ca39500aba6$exports(target, $0590ceb3c9c577a7$var$TO_STRING_TAG)) $0590ceb3c9c577a7$require$defineProperty(target, $0590ceb3c9c577a7$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $d32fb3bde149eb49$exports = {};
"use strict";
var $042f91ff50d30f11$exports = {};
"use strict";
var $92ca88fbf3cbbcaa$exports = {};
"use strict";


$92ca88fbf3cbbcaa$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($4cba9a2acb4bdb16$exports(fn) === "Function") return $23a00ee3e029ff58$exports(fn);
};




var $042f91ff50d30f11$var$bind = $92ca88fbf3cbbcaa$exports($92ca88fbf3cbbcaa$exports.bind);
// optional / simple context binding
$042f91ff50d30f11$exports = function(fn, that) {
    $8b3f43e1fb85f635$exports(fn);
    return that === undefined ? fn : $e206ebbecedd2bde$exports ? $042f91ff50d30f11$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};






var $e32f0fc064471ecf$exports = {};
"use strict";
var $c1338805bfa8c834$exports = {};
"use strict";
var $84765aa0c0d1e084$exports = {};
"use strict";

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$84765aa0c0d1e084$exports = Array.isArray || function isArray(argument) {
    return $4cba9a2acb4bdb16$exports(argument) === "Array";
};


var $0518088af72f3297$exports = {};
"use strict";






var $0518088af72f3297$var$noop = function noop() {};
var $0518088af72f3297$var$empty = [];
var $0518088af72f3297$var$construct = $db85f9884fa161d0$exports("Reflect", "construct");
var $0518088af72f3297$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $0518088af72f3297$var$exec = $23a00ee3e029ff58$exports($0518088af72f3297$var$constructorRegExp.exec);
var $0518088af72f3297$var$INCORRECT_TO_STRING = !$0518088af72f3297$var$constructorRegExp.test($0518088af72f3297$var$noop);
var $0518088af72f3297$var$isConstructorModern = function isConstructor(argument) {
    if (!$64c802885f841370$exports(argument)) return false;
    try {
        $0518088af72f3297$var$construct($0518088af72f3297$var$noop, $0518088af72f3297$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $0518088af72f3297$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$64c802885f841370$exports(argument)) return false;
    switch($19a284f0ad8e7bd9$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $0518088af72f3297$var$INCORRECT_TO_STRING || !!$0518088af72f3297$var$exec($0518088af72f3297$var$constructorRegExp, $6b4a072d19c2902d$exports(argument));
    } catch (error) {
        return true;
    }
};
$0518088af72f3297$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$0518088af72f3297$exports = !$0518088af72f3297$var$construct || $7bdc373729e45e27$exports(function() {
    var called;
    return $0518088af72f3297$var$isConstructorModern($0518088af72f3297$var$isConstructorModern.call) || !$0518088af72f3297$var$isConstructorModern(Object) || !$0518088af72f3297$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $0518088af72f3297$var$isConstructorLegacy : $0518088af72f3297$var$isConstructorModern;




var $c1338805bfa8c834$var$SPECIES = $6c5fb57dad6dd350$exports("species");
var $c1338805bfa8c834$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$c1338805bfa8c834$exports = function(originalArray) {
    var C;
    if ($84765aa0c0d1e084$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($0518088af72f3297$exports(C) && (C === $c1338805bfa8c834$var$$Array || $84765aa0c0d1e084$exports(C.prototype))) C = undefined;
        else if ($b1a75f6ed3e2d50f$exports(C)) {
            C = C[$c1338805bfa8c834$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $c1338805bfa8c834$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$e32f0fc064471ecf$exports = function(originalArray, length) {
    return new ($c1338805bfa8c834$exports(originalArray))(length === 0 ? 0 : length);
};


var $d32fb3bde149eb49$var$push = $23a00ee3e029ff58$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $d32fb3bde149eb49$var$createMethod = function createMethod(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $7d5785aa2fc2b3e1$exports($this);
        var self = $20eeb1af973ba55b$exports(O);
        var length = $027f7f84b95594e7$exports(self);
        var boundFunction = $042f91ff50d30f11$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $e32f0fc064471ecf$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $d32fb3bde149eb49$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $d32fb3bde149eb49$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$d32fb3bde149eb49$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $d32fb3bde149eb49$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $d32fb3bde149eb49$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $d32fb3bde149eb49$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $d32fb3bde149eb49$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $d32fb3bde149eb49$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $d32fb3bde149eb49$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $d32fb3bde149eb49$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $d32fb3bde149eb49$var$createMethod(7)
};


var $5f51d59e7f91094c$require$$forEach = $d32fb3bde149eb49$exports.forEach;
var $5f51d59e7f91094c$var$HIDDEN = $67028cac70b02c6c$exports("hidden");
var $5f51d59e7f91094c$var$SYMBOL = "Symbol";
var $5f51d59e7f91094c$var$PROTOTYPE = "prototype";
var $5f51d59e7f91094c$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $5f51d59e7f91094c$var$getInternalState = $c70ec777954e7cbe$exports.getterFor($5f51d59e7f91094c$var$SYMBOL);
var $5f51d59e7f91094c$var$ObjectPrototype = Object[$5f51d59e7f91094c$var$PROTOTYPE];
var $5f51d59e7f91094c$var$$Symbol = $0f4ea948f6673103$exports.Symbol;
var $5f51d59e7f91094c$var$SymbolPrototype = $5f51d59e7f91094c$var$$Symbol && $5f51d59e7f91094c$var$$Symbol[$5f51d59e7f91094c$var$PROTOTYPE];
var $5f51d59e7f91094c$var$RangeError = $0f4ea948f6673103$exports.RangeError;
var $5f51d59e7f91094c$var$TypeError = $0f4ea948f6673103$exports.TypeError;
var $5f51d59e7f91094c$var$QObject = $0f4ea948f6673103$exports.QObject;
var $5f51d59e7f91094c$var$nativeGetOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;
var $5f51d59e7f91094c$var$nativeDefineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;
var $5f51d59e7f91094c$var$nativeGetOwnPropertyNames = $310e8a5d08b7fb31$export$2d1720544b23b823;
var $5f51d59e7f91094c$var$nativePropertyIsEnumerable = $11de82002a093be1$export$2d1720544b23b823;
var $5f51d59e7f91094c$var$push = $23a00ee3e029ff58$exports([].push);
var $5f51d59e7f91094c$var$AllSymbols = $7ecb1b65119c8ef8$exports("symbols");
var $5f51d59e7f91094c$var$ObjectPrototypeSymbols = $7ecb1b65119c8ef8$exports("op-symbols");
var $5f51d59e7f91094c$var$WellKnownSymbolsStore = $7ecb1b65119c8ef8$exports("wks");
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $5f51d59e7f91094c$var$USE_SETTER = !$5f51d59e7f91094c$var$QObject || !$5f51d59e7f91094c$var$QObject[$5f51d59e7f91094c$var$PROTOTYPE] || !$5f51d59e7f91094c$var$QObject[$5f51d59e7f91094c$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $5f51d59e7f91094c$var$fallbackDefineProperty = function fallbackDefineProperty(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $5f51d59e7f91094c$var$nativeGetOwnPropertyDescriptor($5f51d59e7f91094c$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $5f51d59e7f91094c$var$ObjectPrototype[P];
    $5f51d59e7f91094c$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $5f51d59e7f91094c$var$ObjectPrototype) $5f51d59e7f91094c$var$nativeDefineProperty($5f51d59e7f91094c$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
};
var $5f51d59e7f91094c$var$setSymbolDescriptor = $40260b59b65c2e4c$exports && $7bdc373729e45e27$exports(function() {
    return $9959f3fdced32995$exports($5f51d59e7f91094c$var$nativeDefineProperty({}, "a", {
        get: function get() {
            return $5f51d59e7f91094c$var$nativeDefineProperty(this, "a", {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? $5f51d59e7f91094c$var$fallbackDefineProperty : $5f51d59e7f91094c$var$nativeDefineProperty;
var $5f51d59e7f91094c$var$wrap = function wrap(tag, description) {
    var symbol = $5f51d59e7f91094c$var$AllSymbols[tag] = $9959f3fdced32995$exports($5f51d59e7f91094c$var$SymbolPrototype);
    $5f51d59e7f91094c$var$setInternalState(symbol, {
        type: $5f51d59e7f91094c$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$40260b59b65c2e4c$exports) symbol.description = description;
    return symbol;
};
var $5f51d59e7f91094c$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $5f51d59e7f91094c$var$ObjectPrototype) $5f51d59e7f91094c$var$$defineProperty($5f51d59e7f91094c$var$ObjectPrototypeSymbols, P, Attributes);
    $c894fc907eeec831$exports(O);
    var key = $8bc65e9087e8d1e0$exports(P);
    $c894fc907eeec831$exports(Attributes);
    if ($5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$5f4f8ca39500aba6$exports(O, $5f51d59e7f91094c$var$HIDDEN)) $5f51d59e7f91094c$var$nativeDefineProperty(O, $5f51d59e7f91094c$var$HIDDEN, $ca4a4ced04e4a412$exports(1, {}));
            O[$5f51d59e7f91094c$var$HIDDEN][key] = true;
        } else {
            if ($5f4f8ca39500aba6$exports(O, $5f51d59e7f91094c$var$HIDDEN) && O[$5f51d59e7f91094c$var$HIDDEN][key]) O[$5f51d59e7f91094c$var$HIDDEN][key] = false;
            Attributes = $9959f3fdced32995$exports(Attributes, {
                enumerable: $ca4a4ced04e4a412$exports(0, false)
            });
        }
        return $5f51d59e7f91094c$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $5f51d59e7f91094c$var$nativeDefineProperty(O, key, Attributes);
};
var $5f51d59e7f91094c$var$$defineProperties = function defineProperties(O, Properties) {
    $c894fc907eeec831$exports(O);
    var properties = $44022b55b2d2b203$exports(Properties);
    var keys = $122382a0c203e2f5$exports(properties).concat($5f51d59e7f91094c$var$$getOwnPropertySymbols(properties));
    $5f51d59e7f91094c$require$$forEach(keys, function(key) {
        if (!$40260b59b65c2e4c$exports || $4b3fe34719193049$exports($5f51d59e7f91094c$var$$propertyIsEnumerable, properties, key)) $5f51d59e7f91094c$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $5f51d59e7f91094c$var$$create = function create(O, Properties) {
    return Properties === undefined ? $9959f3fdced32995$exports(O) : $5f51d59e7f91094c$var$$defineProperties($9959f3fdced32995$exports(O), Properties);
};
var $5f51d59e7f91094c$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $8bc65e9087e8d1e0$exports(V);
    var enumerable = $4b3fe34719193049$exports($5f51d59e7f91094c$var$nativePropertyIsEnumerable, this, P);
    if (this === $5f51d59e7f91094c$var$ObjectPrototype && $5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$AllSymbols, P) && !$5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$5f4f8ca39500aba6$exports(this, P) || !$5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$AllSymbols, P) || $5f4f8ca39500aba6$exports(this, $5f51d59e7f91094c$var$HIDDEN) && this[$5f51d59e7f91094c$var$HIDDEN][P] ? enumerable : true;
};
var $5f51d59e7f91094c$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $44022b55b2d2b203$exports(O);
    var key = $8bc65e9087e8d1e0$exports(P);
    if (it === $5f51d59e7f91094c$var$ObjectPrototype && $5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$AllSymbols, key) && !$5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $5f51d59e7f91094c$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$AllSymbols, key) && !($5f4f8ca39500aba6$exports(it, $5f51d59e7f91094c$var$HIDDEN) && it[$5f51d59e7f91094c$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $5f51d59e7f91094c$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $5f51d59e7f91094c$var$nativeGetOwnPropertyNames($44022b55b2d2b203$exports(O));
    var result = [];
    $5f51d59e7f91094c$require$$forEach(names, function(key) {
        if (!$5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$AllSymbols, key) && !$5f4f8ca39500aba6$exports($76695f3a4d4ba903$exports, key)) $5f51d59e7f91094c$var$push(result, key);
    });
    return result;
};
var $5f51d59e7f91094c$var$$getOwnPropertySymbols = function $getOwnPropertySymbols(O) {
    var IS_OBJECT_PROTOTYPE = O === $5f51d59e7f91094c$var$ObjectPrototype;
    var names = $5f51d59e7f91094c$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $5f51d59e7f91094c$var$ObjectPrototypeSymbols : $44022b55b2d2b203$exports(O));
    var result = [];
    $5f51d59e7f91094c$require$$forEach(names, function(key) {
        if ($5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $5f4f8ca39500aba6$exports($5f51d59e7f91094c$var$ObjectPrototype, key))) $5f51d59e7f91094c$var$push(result, $5f51d59e7f91094c$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$cf352a9ea0f218c2$exports) {
    $5f51d59e7f91094c$var$$Symbol = function Symbol() {
        if ($372efcd1340d8495$exports($5f51d59e7f91094c$var$SymbolPrototype, this)) throw new $5f51d59e7f91094c$var$TypeError("Symbol is not a constructor");
        var description = !arguments.length || arguments[0] === undefined ? undefined : $dd666817fb19c24c$exports(arguments[0]);
        var tag = $3139b6d9415fe2b9$exports(description);
        var setter = function setter1(value) {
            var $this = this === undefined ? $0f4ea948f6673103$exports : this;
            if ($this === $5f51d59e7f91094c$var$ObjectPrototype) $4b3fe34719193049$exports(setter, $5f51d59e7f91094c$var$ObjectPrototypeSymbols, value);
            if ($5f4f8ca39500aba6$exports($this, $5f51d59e7f91094c$var$HIDDEN) && $5f4f8ca39500aba6$exports($this[$5f51d59e7f91094c$var$HIDDEN], tag)) $this[$5f51d59e7f91094c$var$HIDDEN][tag] = false;
            var descriptor = $ca4a4ced04e4a412$exports(1, value);
            try {
                $5f51d59e7f91094c$var$setSymbolDescriptor($this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof $5f51d59e7f91094c$var$RangeError)) throw error;
                $5f51d59e7f91094c$var$fallbackDefineProperty($this, tag, descriptor);
            }
        };
        if ($40260b59b65c2e4c$exports && $5f51d59e7f91094c$var$USE_SETTER) $5f51d59e7f91094c$var$setSymbolDescriptor($5f51d59e7f91094c$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $5f51d59e7f91094c$var$wrap(tag, description);
    };
    $5f51d59e7f91094c$var$SymbolPrototype = $5f51d59e7f91094c$var$$Symbol[$5f51d59e7f91094c$var$PROTOTYPE];
    $f488b1cc13335fff$exports($5f51d59e7f91094c$var$SymbolPrototype, "toString", function toString() {
        return $5f51d59e7f91094c$var$getInternalState(this).tag;
    });
    $f488b1cc13335fff$exports($5f51d59e7f91094c$var$$Symbol, "withoutSetter", function(description) {
        return $5f51d59e7f91094c$var$wrap($3139b6d9415fe2b9$exports(description), description);
    });
    $11de82002a093be1$export$2d1720544b23b823 = $5f51d59e7f91094c$var$$propertyIsEnumerable;
    $18b1ebdefa97b93b$export$2d1720544b23b823 = $5f51d59e7f91094c$var$$defineProperty;
    $4c725e6f88c33573$export$2d1720544b23b823 = $5f51d59e7f91094c$var$$defineProperties;
    $003023ef435958c5$export$2d1720544b23b823 = $5f51d59e7f91094c$var$$getOwnPropertyDescriptor;
    $a329b85dee9c6785$export$2d1720544b23b823 = $310e8a5d08b7fb31$export$2d1720544b23b823 = $5f51d59e7f91094c$var$$getOwnPropertyNames;
    $813bfc4ba50d6281$export$2d1720544b23b823 = $5f51d59e7f91094c$var$$getOwnPropertySymbols;
    $601639e97de2062d$export$2d1720544b23b823 = function(name) {
        return $5f51d59e7f91094c$var$wrap($6c5fb57dad6dd350$exports(name), name);
    };
    if ($40260b59b65c2e4c$exports) {
        // https://github.com/tc39/proposal-Symbol-description
        $d235cf6ad826c1e5$exports($5f51d59e7f91094c$var$SymbolPrototype, "description", {
            configurable: true,
            get: function description() {
                return $5f51d59e7f91094c$var$getInternalState(this).description;
            }
        });
        if (!$bad8555d514b807c$exports) $f488b1cc13335fff$exports($5f51d59e7f91094c$var$ObjectPrototype, "propertyIsEnumerable", $5f51d59e7f91094c$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$d4b8e88525a1c695$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$cf352a9ea0f218c2$exports,
    sham: !$cf352a9ea0f218c2$exports
}, {
    Symbol: $5f51d59e7f91094c$var$$Symbol
});
$5f51d59e7f91094c$require$$forEach($122382a0c203e2f5$exports($5f51d59e7f91094c$var$WellKnownSymbolsStore), function(name) {
    $b00a4c7565f1ee0f$exports(name);
});
$d4b8e88525a1c695$exports({
    target: $5f51d59e7f91094c$var$SYMBOL,
    stat: true,
    forced: !$cf352a9ea0f218c2$exports
}, {
    useSetter: function useSetter() {
        $5f51d59e7f91094c$var$USE_SETTER = true;
    },
    useSimple: function useSimple() {
        $5f51d59e7f91094c$var$USE_SETTER = false;
    }
});
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: !$cf352a9ea0f218c2$exports,
    sham: !$40260b59b65c2e4c$exports
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $5f51d59e7f91094c$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $5f51d59e7f91094c$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $5f51d59e7f91094c$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $5f51d59e7f91094c$var$$getOwnPropertyDescriptor
});
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: !$cf352a9ea0f218c2$exports
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $5f51d59e7f91094c$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$9107b5a50a1cb0c9$exports();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$0590ceb3c9c577a7$exports($5f51d59e7f91094c$var$$Symbol, $5f51d59e7f91094c$var$SYMBOL);
$76695f3a4d4ba903$exports[$5f51d59e7f91094c$var$HIDDEN] = true;


"use strict";





var $78adf6425ab362cf$exports = {};
"use strict";

/* eslint-disable es/no-symbol -- safe */ $78adf6425ab362cf$exports = $cf352a9ea0f218c2$exports && !!Symbol["for"] && !!Symbol.keyFor;


var $d0bb7c74b02c4025$var$StringToSymbolRegistry = $7ecb1b65119c8ef8$exports("string-to-symbol-registry");
var $d0bb7c74b02c4025$var$SymbolToStringRegistry = $7ecb1b65119c8ef8$exports("symbol-to-string-registry");
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$d4b8e88525a1c695$exports({
    target: "Symbol",
    stat: true,
    forced: !$78adf6425ab362cf$exports
}, {
    "for": function(key) {
        var string = $dd666817fb19c24c$exports(key);
        if ($5f4f8ca39500aba6$exports($d0bb7c74b02c4025$var$StringToSymbolRegistry, string)) return $d0bb7c74b02c4025$var$StringToSymbolRegistry[string];
        var symbol = $db85f9884fa161d0$exports("Symbol")(string);
        $d0bb7c74b02c4025$var$StringToSymbolRegistry[string] = symbol;
        $d0bb7c74b02c4025$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});


"use strict";






var $5d34bbc4ad85cd06$var$SymbolToStringRegistry = $7ecb1b65119c8ef8$exports("symbol-to-string-registry");
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$d4b8e88525a1c695$exports({
    target: "Symbol",
    stat: true,
    forced: !$78adf6425ab362cf$exports
}, {
    keyFor: function keyFor(sym) {
        if (!$368e2561dee205ff$exports(sym)) throw new TypeError($815d6e8656bb616c$exports(sym) + " is not a symbol");
        if ($5f4f8ca39500aba6$exports($5d34bbc4ad85cd06$var$SymbolToStringRegistry, sym)) return $5d34bbc4ad85cd06$var$SymbolToStringRegistry[sym];
    }
});


"use strict";


var $f275acb1973d253b$exports = {};
"use strict";

var $f275acb1973d253b$var$FunctionPrototype = Function.prototype;
var $f275acb1973d253b$var$apply = $f275acb1973d253b$var$FunctionPrototype.apply;
var $f275acb1973d253b$var$call = $f275acb1973d253b$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$f275acb1973d253b$exports = typeof Reflect == "object" && Reflect.apply || ($e206ebbecedd2bde$exports ? $f275acb1973d253b$var$call.bind($f275acb1973d253b$var$apply) : function() {
    return $f275acb1973d253b$var$call.apply($f275acb1973d253b$var$apply, arguments);
});







var $043da047ce6f37e9$exports = {};
"use strict";

$043da047ce6f37e9$exports = $23a00ee3e029ff58$exports([].slice);


var $7830eb981e5a46e6$exports = {};
"use strict";





var $7830eb981e5a46e6$var$push = $23a00ee3e029ff58$exports([].push);
$7830eb981e5a46e6$exports = function(replacer) {
    if ($64c802885f841370$exports(replacer)) return replacer;
    if (!$84765aa0c0d1e084$exports(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == "string") $7830eb981e5a46e6$var$push(keys, element);
        else if (typeof element == "number" || $4cba9a2acb4bdb16$exports(element) === "Number" || $4cba9a2acb4bdb16$exports(element) === "String") $7830eb981e5a46e6$var$push(keys, $dd666817fb19c24c$exports(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($84765aa0c0d1e084$exports(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};



var $70e7db5e7d48fa02$var$$String = String;
var $70e7db5e7d48fa02$var$$stringify = $db85f9884fa161d0$exports("JSON", "stringify");
var $70e7db5e7d48fa02$var$exec = $23a00ee3e029ff58$exports(/./.exec);
var $70e7db5e7d48fa02$var$charAt = $23a00ee3e029ff58$exports("".charAt);
var $70e7db5e7d48fa02$var$charCodeAt = $23a00ee3e029ff58$exports("".charCodeAt);
var $70e7db5e7d48fa02$var$replace = $23a00ee3e029ff58$exports("".replace);
var $70e7db5e7d48fa02$var$numberToString = $23a00ee3e029ff58$exports(1.0.toString);
var $70e7db5e7d48fa02$var$tester = /[\uD800-\uDFFF]/g;
var $70e7db5e7d48fa02$var$low = /^[\uD800-\uDBFF]$/;
var $70e7db5e7d48fa02$var$hi = /^[\uDC00-\uDFFF]$/;
var $70e7db5e7d48fa02$var$WRONG_SYMBOLS_CONVERSION = !$cf352a9ea0f218c2$exports || $7bdc373729e45e27$exports(function() {
    var symbol = $db85f9884fa161d0$exports("Symbol")("stringify detection");
    // MS Edge converts symbol values to JSON as {}
    return $70e7db5e7d48fa02$var$$stringify([
        symbol
    ]) !== "[null]" || $70e7db5e7d48fa02$var$$stringify({
        a: symbol
    }) !== "{}" || $70e7db5e7d48fa02$var$$stringify(Object(symbol)) !== "{}";
});
// https://github.com/tc39/proposal-well-formed-stringify
var $70e7db5e7d48fa02$var$ILL_FORMED_UNICODE = $7bdc373729e45e27$exports(function() {
    return $70e7db5e7d48fa02$var$$stringify("\uDF06\uD834") !== '"\udf06\ud834"' || $70e7db5e7d48fa02$var$$stringify("\uDEAD") !== '"\udead"';
});
var $70e7db5e7d48fa02$var$stringifyWithSymbolsFix = function stringifyWithSymbolsFix(it, replacer) {
    var args = $043da047ce6f37e9$exports(arguments);
    var $replacer = $7830eb981e5a46e6$exports(replacer);
    if (!$64c802885f841370$exports($replacer) && (it === undefined || $368e2561dee205ff$exports(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($64c802885f841370$exports($replacer)) value = $4b3fe34719193049$exports($replacer, this, $70e7db5e7d48fa02$var$$String(key), value);
        if (!$368e2561dee205ff$exports(value)) return value;
    };
    return $f275acb1973d253b$exports($70e7db5e7d48fa02$var$$stringify, null, args);
};
var $70e7db5e7d48fa02$var$fixIllFormed = function fixIllFormed(match, offset, string) {
    var prev = $70e7db5e7d48fa02$var$charAt(string, offset - 1);
    var next = $70e7db5e7d48fa02$var$charAt(string, offset + 1);
    if ($70e7db5e7d48fa02$var$exec($70e7db5e7d48fa02$var$low, match) && !$70e7db5e7d48fa02$var$exec($70e7db5e7d48fa02$var$hi, next) || $70e7db5e7d48fa02$var$exec($70e7db5e7d48fa02$var$hi, match) && !$70e7db5e7d48fa02$var$exec($70e7db5e7d48fa02$var$low, prev)) return "\\u" + $70e7db5e7d48fa02$var$numberToString($70e7db5e7d48fa02$var$charCodeAt(match, 0), 16);
    return match;
};
if ($70e7db5e7d48fa02$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$d4b8e88525a1c695$exports({
    target: "JSON",
    stat: true,
    arity: 3,
    forced: $70e7db5e7d48fa02$var$WRONG_SYMBOLS_CONVERSION || $70e7db5e7d48fa02$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $043da047ce6f37e9$exports(arguments);
        var result = $f275acb1973d253b$exports($70e7db5e7d48fa02$var$WRONG_SYMBOLS_CONVERSION ? $70e7db5e7d48fa02$var$stringifyWithSymbolsFix : $70e7db5e7d48fa02$var$$stringify, null, args);
        return $70e7db5e7d48fa02$var$ILL_FORMED_UNICODE && typeof result == "string" ? $70e7db5e7d48fa02$var$replace(result, $70e7db5e7d48fa02$var$tester, $70e7db5e7d48fa02$var$fixIllFormed) : result;
    }
});


"use strict";





// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $d639352baf52558e$var$FORCED = !$cf352a9ea0f218c2$exports || $7bdc373729e45e27$exports(function() {
    $813bfc4ba50d6281$export$2d1720544b23b823(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $d639352baf52558e$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $813bfc4ba50d6281$export$2d1720544b23b823;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($7d5785aa2fc2b3e1$exports(it)) : [];
    }
});




// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
"use strict";










var $acb2e2fbd3fb013e$var$NativeSymbol = $0f4ea948f6673103$exports.Symbol;
var $acb2e2fbd3fb013e$var$SymbolPrototype = $acb2e2fbd3fb013e$var$NativeSymbol && $acb2e2fbd3fb013e$var$NativeSymbol.prototype;
if ($40260b59b65c2e4c$exports && $64c802885f841370$exports($acb2e2fbd3fb013e$var$NativeSymbol) && (!("description" in $acb2e2fbd3fb013e$var$SymbolPrototype) || // Safari 12 bug
$acb2e2fbd3fb013e$var$NativeSymbol().description !== undefined)) {
    var $acb2e2fbd3fb013e$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $acb2e2fbd3fb013e$var$SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $dd666817fb19c24c$exports(arguments[0]);
        var result = $372efcd1340d8495$exports($acb2e2fbd3fb013e$var$SymbolPrototype, this) ? new $acb2e2fbd3fb013e$var$NativeSymbol(description) : description === undefined ? $acb2e2fbd3fb013e$var$NativeSymbol() : $acb2e2fbd3fb013e$var$NativeSymbol(description);
        if (description === "") $acb2e2fbd3fb013e$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $bc7f39059f462d6d$exports($acb2e2fbd3fb013e$var$SymbolWrapper, $acb2e2fbd3fb013e$var$NativeSymbol);
    $acb2e2fbd3fb013e$var$SymbolWrapper.prototype = $acb2e2fbd3fb013e$var$SymbolPrototype;
    $acb2e2fbd3fb013e$var$SymbolPrototype.constructor = $acb2e2fbd3fb013e$var$SymbolWrapper;
    var $acb2e2fbd3fb013e$var$NATIVE_SYMBOL = String($acb2e2fbd3fb013e$var$NativeSymbol("description detection")) === "Symbol(description detection)";
    var $acb2e2fbd3fb013e$var$thisSymbolValue = $23a00ee3e029ff58$exports($acb2e2fbd3fb013e$var$SymbolPrototype.valueOf);
    var $acb2e2fbd3fb013e$var$symbolDescriptiveString = $23a00ee3e029ff58$exports($acb2e2fbd3fb013e$var$SymbolPrototype.toString);
    var $acb2e2fbd3fb013e$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $acb2e2fbd3fb013e$var$replace = $23a00ee3e029ff58$exports("".replace);
    var $acb2e2fbd3fb013e$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
    $d235cf6ad826c1e5$exports($acb2e2fbd3fb013e$var$SymbolPrototype, "description", {
        configurable: true,
        get: function description() {
            var symbol = $acb2e2fbd3fb013e$var$thisSymbolValue(this);
            if ($5f4f8ca39500aba6$exports($acb2e2fbd3fb013e$var$EmptyStringDescriptionStore, symbol)) return "";
            var string = $acb2e2fbd3fb013e$var$symbolDescriptiveString(symbol);
            var desc = $acb2e2fbd3fb013e$var$NATIVE_SYMBOL ? $acb2e2fbd3fb013e$var$stringSlice(string, 7, -1) : $acb2e2fbd3fb013e$var$replace(string, $acb2e2fbd3fb013e$var$regexp, "$1");
            return desc === "" ? undefined : desc;
        }
    });
    $d4b8e88525a1c695$exports({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $acb2e2fbd3fb013e$var$SymbolWrapper
    });
}


"use strict";

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$b00a4c7565f1ee0f$exports("asyncIterator");


"use strict";

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$b00a4c7565f1ee0f$exports("hasInstance");


"use strict";

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$b00a4c7565f1ee0f$exports("isConcatSpreadable");


"use strict";

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$b00a4c7565f1ee0f$exports("iterator");


"use strict";

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$b00a4c7565f1ee0f$exports("match");


"use strict";

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$b00a4c7565f1ee0f$exports("replace");


"use strict";

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$b00a4c7565f1ee0f$exports("search");


"use strict";

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$b00a4c7565f1ee0f$exports("species");


"use strict";

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$b00a4c7565f1ee0f$exports("split");


"use strict";


// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$b00a4c7565f1ee0f$exports("toPrimitive");
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$9107b5a50a1cb0c9$exports();


"use strict";



// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$b00a4c7565f1ee0f$exports("toStringTag");
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$0590ceb3c9c577a7$exports($db85f9884fa161d0$exports("Symbol"), "Symbol");


"use strict";

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$b00a4c7565f1ee0f$exports("unscopables");


"use strict";






var $9dbbb26ed323b85d$exports = {};
"use strict";
var $9dbbb26ed323b85d$var$$TypeError = TypeError;
var $9dbbb26ed323b85d$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
$9dbbb26ed323b85d$exports = function(it) {
    if (it > $9dbbb26ed323b85d$var$MAX_SAFE_INTEGER) throw $9dbbb26ed323b85d$var$$TypeError("Maximum allowed index exceeded");
    return it;
};




var $2088ff0e00858956$exports = {};
"use strict";



var $2088ff0e00858956$var$SPECIES = $6c5fb57dad6dd350$exports("species");
$2088ff0e00858956$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $d478a9aa1d363d00$exports >= 51 || !$7bdc373729e45e27$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$2088ff0e00858956$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};




var $a1ae1aeff8a7c17d$var$IS_CONCAT_SPREADABLE = $6c5fb57dad6dd350$exports("isConcatSpreadable");
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $a1ae1aeff8a7c17d$var$IS_CONCAT_SPREADABLE_SUPPORT = $d478a9aa1d363d00$exports >= 51 || !$7bdc373729e45e27$exports(function() {
    var array = [];
    array[$a1ae1aeff8a7c17d$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $a1ae1aeff8a7c17d$var$isConcatSpreadable = function isConcatSpreadable(O) {
    if (!$b1a75f6ed3e2d50f$exports(O)) return false;
    var spreadable = O[$a1ae1aeff8a7c17d$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $84765aa0c0d1e084$exports(O);
};
var $a1ae1aeff8a7c17d$var$FORCED = !$a1ae1aeff8a7c17d$var$IS_CONCAT_SPREADABLE_SUPPORT || !$2088ff0e00858956$exports("concat");
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    arity: 1,
    forced: $a1ae1aeff8a7c17d$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $7d5785aa2fc2b3e1$exports(this);
        var A = $e32f0fc064471ecf$exports(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($a1ae1aeff8a7c17d$var$isConcatSpreadable(E)) {
                len = $027f7f84b95594e7$exports(E);
                $9dbbb26ed323b85d$exports(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $2ac89df48719a8b2$exports(A, n, E[k]);
            } else {
                $9dbbb26ed323b85d$exports(n + 1);
                $2ac89df48719a8b2$exports(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});


"use strict";

var $222a224d577f6108$exports = {};
"use strict";



var $1613aa7d617d950d$exports = {};
"use strict";

var $1613aa7d617d950d$var$$TypeError = TypeError;
$1613aa7d617d950d$exports = function(O, P) {
    if (!delete O[P]) throw new $1613aa7d617d950d$var$$TypeError("Cannot delete property " + $815d6e8656bb616c$exports(P) + " of " + $815d6e8656bb616c$exports(O));
};


var $222a224d577f6108$var$min = Math.min;
// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
$222a224d577f6108$exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = $7d5785aa2fc2b3e1$exports(this);
    var len = $027f7f84b95594e7$exports(O);
    var to = $4c10e2bcec3cf322$exports(target, len);
    var from = $4c10e2bcec3cf322$exports(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = $222a224d577f6108$var$min((end === undefined ? len : $4c10e2bcec3cf322$exports(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else $1613aa7d617d950d$exports(O, to);
        to += inc;
        from += inc;
    }
    return O;
};


var $b64e56242aa7106c$exports = {};
"use strict";



var $b64e56242aa7106c$require$defineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;
var $b64e56242aa7106c$var$UNSCOPABLES = $6c5fb57dad6dd350$exports("unscopables");
var $b64e56242aa7106c$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($b64e56242aa7106c$var$ArrayPrototype[$b64e56242aa7106c$var$UNSCOPABLES] === undefined) $b64e56242aa7106c$require$defineProperty($b64e56242aa7106c$var$ArrayPrototype, $b64e56242aa7106c$var$UNSCOPABLES, {
    configurable: true,
    value: $9959f3fdced32995$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$b64e56242aa7106c$exports = function(key) {
    $b64e56242aa7106c$var$ArrayPrototype[$b64e56242aa7106c$var$UNSCOPABLES][key] = true;
};


// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true
}, {
    copyWithin: $222a224d577f6108$exports
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$b64e56242aa7106c$exports("copyWithin");


"use strict";

var $e7bfcf8076f14c00$exports = {};
"use strict";



// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
$e7bfcf8076f14c00$exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $7d5785aa2fc2b3e1$exports(this);
    var length = $027f7f84b95594e7$exports(O);
    var argumentsLength = arguments.length;
    var index = $4c10e2bcec3cf322$exports(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $4c10e2bcec3cf322$exports(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};



// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true
}, {
    fill: $e7bfcf8076f14c00$exports
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$b64e56242aa7106c$exports("fill");


"use strict";


var $831d6444c950eb51$require$$filter = $d32fb3bde149eb49$exports.filter;

var $831d6444c950eb51$var$HAS_SPECIES_SUPPORT = $2088ff0e00858956$exports("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: !$831d6444c950eb51$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $831d6444c950eb51$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";


var $086b9156b9864175$require$$find = $d32fb3bde149eb49$exports.find;

var $086b9156b9864175$var$FIND = "find";
var $086b9156b9864175$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if ($086b9156b9864175$var$FIND in []) Array(1)[$086b9156b9864175$var$FIND](function() {
    $086b9156b9864175$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: $086b9156b9864175$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $086b9156b9864175$require$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$b64e56242aa7106c$exports($086b9156b9864175$var$FIND);


"use strict";


var $9b817e70b285e7ce$require$$findIndex = $d32fb3bde149eb49$exports.findIndex;

var $9b817e70b285e7ce$var$FIND_INDEX = "findIndex";
var $9b817e70b285e7ce$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if ($9b817e70b285e7ce$var$FIND_INDEX in []) Array(1)[$9b817e70b285e7ce$var$FIND_INDEX](function() {
    $9b817e70b285e7ce$var$SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: $9b817e70b285e7ce$var$SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $9b817e70b285e7ce$require$$findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$b64e56242aa7106c$exports($9b817e70b285e7ce$var$FIND_INDEX);


"use strict";

var $a39173f3979fd155$exports = {};
"use strict";




// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var $a39173f3979fd155$var$flattenIntoArray = function flattenIntoArray1(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $042f91ff50d30f11$exports(mapper, thisArg) : false;
    var element, elementLen;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && $84765aa0c0d1e084$exports(element)) {
                elementLen = $027f7f84b95594e7$exports(element);
                targetIndex = $a39173f3979fd155$var$flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
                $9dbbb26ed323b85d$exports(targetIndex + 1);
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
$a39173f3979fd155$exports = $a39173f3979fd155$var$flattenIntoArray;






// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true
}, {
    flat: function flat() {
        var depthArg = arguments.length ? arguments[0] : undefined;
        var O = $7d5785aa2fc2b3e1$exports(this);
        var sourceLen = $027f7f84b95594e7$exports(O);
        var A = $e32f0fc064471ecf$exports(O, 0);
        A.length = $a39173f3979fd155$exports(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : $5e45f07a290dfff0$exports(depthArg));
        return A;
    }
});


"use strict";






// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true
}, {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $7d5785aa2fc2b3e1$exports(this);
        var sourceLen = $027f7f84b95594e7$exports(O);
        var A;
        $8b3f43e1fb85f635$exports(callbackfn);
        A = $e32f0fc064471ecf$exports(O, 0);
        A.length = $a39173f3979fd155$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return A;
    }
});


"use strict";

var $c598bb3b06504746$exports = {};
"use strict";



var $9a09f2b388d01cda$exports = {};
"use strict";

var $bef2dd76087b2a5e$exports = {};
"use strict";



$bef2dd76087b2a5e$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c894fc907eeec831$exports(iterator);
    try {
        innerResult = $f29b070ab2fd2ce7$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $4b3fe34719193049$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $c894fc907eeec831$exports(innerResult);
    return value;
};


// call something on iterator step with safe closing on error
$9a09f2b388d01cda$exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($c894fc907eeec831$exports(value)[0], value[1]) : fn(value);
    } catch (error) {
        $bef2dd76087b2a5e$exports(iterator, "throw", error);
    }
};


var $4ea30f210c56f492$exports = {};
"use strict";

var $4f50057f45e1d695$exports = {};
"use strict";
$4f50057f45e1d695$exports = {};


var $4ea30f210c56f492$var$ITERATOR = $6c5fb57dad6dd350$exports("iterator");
var $4ea30f210c56f492$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$4ea30f210c56f492$exports = function(it) {
    return it !== undefined && ($4f50057f45e1d695$exports.Array === it || $4ea30f210c56f492$var$ArrayPrototype[$4ea30f210c56f492$var$ITERATOR] === it);
};





var $246adf013c49aea4$exports = {};
"use strict";




var $1ffb58790ca29df3$exports = {};
"use strict";





var $1ffb58790ca29df3$var$ITERATOR = $6c5fb57dad6dd350$exports("iterator");
$1ffb58790ca29df3$exports = function(it) {
    if (!$76135a25443d684f$exports(it)) return $f29b070ab2fd2ce7$exports(it, $1ffb58790ca29df3$var$ITERATOR) || $f29b070ab2fd2ce7$exports(it, "@@iterator") || $4f50057f45e1d695$exports[$19a284f0ad8e7bd9$exports(it)];
};


var $246adf013c49aea4$var$$TypeError = TypeError;
$246adf013c49aea4$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $1ffb58790ca29df3$exports(argument) : usingIterator;
    if ($8b3f43e1fb85f635$exports(iteratorMethod)) return $c894fc907eeec831$exports($4b3fe34719193049$exports(iteratorMethod, argument));
    throw new $246adf013c49aea4$var$$TypeError($815d6e8656bb616c$exports(argument) + " is not iterable");
};



var $c598bb3b06504746$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
$c598bb3b06504746$exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $7d5785aa2fc2b3e1$exports(arrayLike);
    var IS_CONSTRUCTOR = $0518088af72f3297$exports(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $042f91ff50d30f11$exports(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $1ffb58790ca29df3$exports(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $c598bb3b06504746$var$$Array && $4ea30f210c56f492$exports(iteratorMethod))) {
        iterator = $246adf013c49aea4$exports(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $4b3fe34719193049$exports(next, iterator)).done; index++){
            value = mapping ? $9a09f2b388d01cda$exports(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $2ac89df48719a8b2$exports(result, index, value);
        }
    } else {
        length = $027f7f84b95594e7$exports(O);
        result = IS_CONSTRUCTOR ? new this(length) : $c598bb3b06504746$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $2ac89df48719a8b2$exports(result, index, value);
        }
    }
    result.length = index;
    return result;
};


var $14b7679ddc3bba0f$exports = {};
"use strict";

var $14b7679ddc3bba0f$var$ITERATOR = $6c5fb57dad6dd350$exports("iterator");
var $14b7679ddc3bba0f$var$SAFE_CLOSING = false;
try {
    var $14b7679ddc3bba0f$var$called = 0;
    var $14b7679ddc3bba0f$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$14b7679ddc3bba0f$var$called++
            };
        },
        "return": function() {
            $14b7679ddc3bba0f$var$SAFE_CLOSING = true;
        }
    };
    $14b7679ddc3bba0f$var$iteratorWithReturn[$14b7679ddc3bba0f$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($14b7679ddc3bba0f$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$14b7679ddc3bba0f$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$14b7679ddc3bba0f$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$14b7679ddc3bba0f$var$ITERATOR] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $b087071c9e6dc287$var$INCORRECT_ITERATION = !$14b7679ddc3bba0f$exports(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$d4b8e88525a1c695$exports({
    target: "Array",
    stat: true,
    forced: $b087071c9e6dc287$var$INCORRECT_ITERATION
}, {
    from: $c598bb3b06504746$exports
});


"use strict";


var $206ae045960184f5$require$$includes = $426db30bef2424d6$exports.includes;


// FF99+ bug
var $206ae045960184f5$var$BROKEN_ON_SPARSE = $7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: $206ae045960184f5$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $206ae045960184f5$require$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$b64e56242aa7106c$exports("includes");


"use strict";



var $7067485d42a3e500$require$$indexOf = $426db30bef2424d6$exports.indexOf;
var $bbbf81a67afd4255$exports = {};
"use strict";

$bbbf81a67afd4255$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $7bdc373729e45e27$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};


var $7067485d42a3e500$var$nativeIndexOf = $92ca88fbf3cbbcaa$exports([].indexOf);
var $7067485d42a3e500$var$NEGATIVE_ZERO = !!$7067485d42a3e500$var$nativeIndexOf && 1 / $7067485d42a3e500$var$nativeIndexOf([
    1
], 1, -0) < 0;
var $7067485d42a3e500$var$FORCED = $7067485d42a3e500$var$NEGATIVE_ZERO || !$bbbf81a67afd4255$exports("indexOf");
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: $7067485d42a3e500$var$FORCED
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return $7067485d42a3e500$var$NEGATIVE_ZERO ? $7067485d42a3e500$var$nativeIndexOf(this, searchElement, fromIndex) || 0 : $7067485d42a3e500$require$$indexOf(this, searchElement, fromIndex);
    }
});


var $c9b08ac37bf7fbb5$exports = {};
"use strict";





var $c9b08ac37bf7fbb5$require$defineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;
var $34aff3def5c5238a$exports = {};
"use strict";





var $4377040e1fda8d6a$exports = {};
"use strict";
var $fd184ff3309fc796$exports = {};
"use strict";




var $7acbb54af94d406d$exports = {};
"use strict";




var $d3799bfda0fa7a49$exports = {};
"use strict";

$d3799bfda0fa7a49$exports = !$7bdc373729e45e27$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $7acbb54af94d406d$var$IE_PROTO = $67028cac70b02c6c$exports("IE_PROTO");
var $7acbb54af94d406d$var$$Object = Object;
var $7acbb54af94d406d$var$ObjectPrototype = $7acbb54af94d406d$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$7acbb54af94d406d$exports = $d3799bfda0fa7a49$exports ? $7acbb54af94d406d$var$$Object.getPrototypeOf : function(O) {
    var object = $7d5785aa2fc2b3e1$exports(O);
    if ($5f4f8ca39500aba6$exports(object, $7acbb54af94d406d$var$IE_PROTO)) return object[$7acbb54af94d406d$var$IE_PROTO];
    var constructor = object.constructor;
    if ($64c802885f841370$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $7acbb54af94d406d$var$$Object ? $7acbb54af94d406d$var$ObjectPrototype : null;
};





var $fd184ff3309fc796$var$ITERATOR = $6c5fb57dad6dd350$exports("iterator");
var $fd184ff3309fc796$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $fd184ff3309fc796$var$IteratorPrototype, $fd184ff3309fc796$var$PrototypeOfArrayIteratorPrototype, $fd184ff3309fc796$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $fd184ff3309fc796$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $fd184ff3309fc796$var$arrayIterator)) $fd184ff3309fc796$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $fd184ff3309fc796$var$PrototypeOfArrayIteratorPrototype = $7acbb54af94d406d$exports($7acbb54af94d406d$exports($fd184ff3309fc796$var$arrayIterator));
        if ($fd184ff3309fc796$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $fd184ff3309fc796$var$IteratorPrototype = $fd184ff3309fc796$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $fd184ff3309fc796$var$NEW_ITERATOR_PROTOTYPE = !$b1a75f6ed3e2d50f$exports($fd184ff3309fc796$var$IteratorPrototype) || $7bdc373729e45e27$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $fd184ff3309fc796$var$IteratorPrototype[$fd184ff3309fc796$var$ITERATOR].call(test) !== test;
});
if ($fd184ff3309fc796$var$NEW_ITERATOR_PROTOTYPE) $fd184ff3309fc796$var$IteratorPrototype = {};
else if ($bad8555d514b807c$exports) $fd184ff3309fc796$var$IteratorPrototype = $9959f3fdced32995$exports($fd184ff3309fc796$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$64c802885f841370$exports($fd184ff3309fc796$var$IteratorPrototype[$fd184ff3309fc796$var$ITERATOR])) $f488b1cc13335fff$exports($fd184ff3309fc796$var$IteratorPrototype, $fd184ff3309fc796$var$ITERATOR, function() {
    return this;
});
$fd184ff3309fc796$exports = {
    IteratorPrototype: $fd184ff3309fc796$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $fd184ff3309fc796$var$BUGGY_SAFARI_ITERATORS
};


var $4377040e1fda8d6a$require$IteratorPrototype = $fd184ff3309fc796$exports.IteratorPrototype;




var $4377040e1fda8d6a$var$returnThis = function returnThis() {
    return this;
};
$4377040e1fda8d6a$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $9959f3fdced32995$exports($4377040e1fda8d6a$require$IteratorPrototype, {
        next: $ca4a4ced04e4a412$exports(+!ENUMERABLE_NEXT, next)
    });
    $0590ceb3c9c577a7$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $4f50057f45e1d695$exports[TO_STRING_TAG] = $4377040e1fda8d6a$var$returnThis;
    return IteratorConstructor;
};



var $5f3130f6ca40c617$exports = {};
"use strict";
var $b4d2a368e7306ed4$exports = {};
"use strict";


$b4d2a368e7306ed4$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $23a00ee3e029ff58$exports($8b3f43e1fb85f635$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $3d753879cbb1080a$exports = {};
"use strict";

var $3d753879cbb1080a$var$$String = String;
var $3d753879cbb1080a$var$$TypeError = TypeError;
$3d753879cbb1080a$exports = function(argument) {
    if (typeof argument == "object" || $64c802885f841370$exports(argument)) return argument;
    throw new $3d753879cbb1080a$var$$TypeError("Can't set " + $3d753879cbb1080a$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$5f3130f6ca40c617$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $b4d2a368e7306ed4$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $c894fc907eeec831$exports(O);
        $3d753879cbb1080a$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $34aff3def5c5238a$var$PROPER_FUNCTION_NAME = $b7b4004231446e90$exports.PROPER;
var $34aff3def5c5238a$var$CONFIGURABLE_FUNCTION_NAME = $b7b4004231446e90$exports.CONFIGURABLE;
var $34aff3def5c5238a$var$IteratorPrototype = $fd184ff3309fc796$exports.IteratorPrototype;
var $34aff3def5c5238a$var$BUGGY_SAFARI_ITERATORS = $fd184ff3309fc796$exports.BUGGY_SAFARI_ITERATORS;
var $34aff3def5c5238a$var$ITERATOR = $6c5fb57dad6dd350$exports("iterator");
var $34aff3def5c5238a$var$KEYS = "keys";
var $34aff3def5c5238a$var$VALUES = "values";
var $34aff3def5c5238a$var$ENTRIES = "entries";
var $34aff3def5c5238a$var$returnThis = function returnThis() {
    return this;
};
$34aff3def5c5238a$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $4377040e1fda8d6a$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$34aff3def5c5238a$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $34aff3def5c5238a$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $34aff3def5c5238a$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $34aff3def5c5238a$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$34aff3def5c5238a$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$34aff3def5c5238a$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $7acbb54af94d406d$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$bad8555d514b807c$exports && $7acbb54af94d406d$exports(CurrentIteratorPrototype) !== $34aff3def5c5238a$var$IteratorPrototype) {
                if ($5f3130f6ca40c617$exports) $5f3130f6ca40c617$exports(CurrentIteratorPrototype, $34aff3def5c5238a$var$IteratorPrototype);
                else if (!$64c802885f841370$exports(CurrentIteratorPrototype[$34aff3def5c5238a$var$ITERATOR])) $f488b1cc13335fff$exports(CurrentIteratorPrototype, $34aff3def5c5238a$var$ITERATOR, $34aff3def5c5238a$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $0590ceb3c9c577a7$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($bad8555d514b807c$exports) $4f50057f45e1d695$exports[TO_STRING_TAG] = $34aff3def5c5238a$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($34aff3def5c5238a$var$PROPER_FUNCTION_NAME && DEFAULT === $34aff3def5c5238a$var$VALUES && nativeIterator && nativeIterator.name !== $34aff3def5c5238a$var$VALUES) {
        if (!$bad8555d514b807c$exports && $34aff3def5c5238a$var$CONFIGURABLE_FUNCTION_NAME) $4bc121b672cbfd84$exports(IterablePrototype, "name", $34aff3def5c5238a$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $4b3fe34719193049$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($34aff3def5c5238a$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($34aff3def5c5238a$var$KEYS),
            entries: getIterationMethod($34aff3def5c5238a$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($34aff3def5c5238a$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $f488b1cc13335fff$exports(IterablePrototype, KEY, methods[KEY]);
        } else $d4b8e88525a1c695$exports({
            target: NAME,
            proto: true,
            forced: $34aff3def5c5238a$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$bad8555d514b807c$exports || FORCED) && IterablePrototype[$34aff3def5c5238a$var$ITERATOR] !== defaultIterator) $f488b1cc13335fff$exports(IterablePrototype, $34aff3def5c5238a$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $4f50057f45e1d695$exports[NAME] = defaultIterator;
    return methods;
};


var $ecc47fe671ebbad0$exports = {};
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$ecc47fe671ebbad0$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $c9b08ac37bf7fbb5$var$ARRAY_ITERATOR = "Array Iterator";
var $c9b08ac37bf7fbb5$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $c9b08ac37bf7fbb5$var$getInternalState = $c70ec777954e7cbe$exports.getterFor($c9b08ac37bf7fbb5$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$c9b08ac37bf7fbb5$exports = $34aff3def5c5238a$exports(Array, "Array", function(iterated, kind) {
    $c9b08ac37bf7fbb5$var$setInternalState(this, {
        type: $c9b08ac37bf7fbb5$var$ARRAY_ITERATOR,
        target: $44022b55b2d2b203$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $c9b08ac37bf7fbb5$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $ecc47fe671ebbad0$exports(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return $ecc47fe671ebbad0$exports(index, false);
        case "values":
            return $ecc47fe671ebbad0$exports(target[index], false);
    }
    return $ecc47fe671ebbad0$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $c9b08ac37bf7fbb5$var$values = $4f50057f45e1d695$exports.Arguments = $4f50057f45e1d695$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$b64e56242aa7106c$exports("keys");
$b64e56242aa7106c$exports("values");
$b64e56242aa7106c$exports("entries");
// V8 ~ Chrome 45- bug
if (!$bad8555d514b807c$exports && $40260b59b65c2e4c$exports && $c9b08ac37bf7fbb5$var$values.name !== "values") try {
    $c9b08ac37bf7fbb5$require$defineProperty($c9b08ac37bf7fbb5$var$values, "name", {
        value: "values"
    });
} catch (error) {}


"use strict";





var $266df6697050f3d3$var$nativeJoin = $23a00ee3e029ff58$exports([].join);
var $266df6697050f3d3$var$ES3_STRINGS = $20eeb1af973ba55b$exports !== Object;
var $266df6697050f3d3$var$FORCED = $266df6697050f3d3$var$ES3_STRINGS || !$bbbf81a67afd4255$exports("join", ",");
// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: $266df6697050f3d3$var$FORCED
}, {
    join: function join(separator) {
        return $266df6697050f3d3$var$nativeJoin($44022b55b2d2b203$exports(this), separator === undefined ? "," : separator);
    }
});


"use strict";

var $c0b33fd547546697$exports = {};
"use strict";





var $c0b33fd547546697$var$min = Math.min;
var $c0b33fd547546697$var$$lastIndexOf = [].lastIndexOf;
var $c0b33fd547546697$var$NEGATIVE_ZERO = !!$c0b33fd547546697$var$$lastIndexOf && 1 / [
    1
].lastIndexOf(1, -0) < 0;
var $c0b33fd547546697$var$STRICT_METHOD = $bbbf81a67afd4255$exports("lastIndexOf");
var $c0b33fd547546697$var$FORCED = $c0b33fd547546697$var$NEGATIVE_ZERO || !$c0b33fd547546697$var$STRICT_METHOD;
// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
$c0b33fd547546697$exports = $c0b33fd547546697$var$FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
    // convert -0 to +0
    if ($c0b33fd547546697$var$NEGATIVE_ZERO) return $f275acb1973d253b$exports($c0b33fd547546697$var$$lastIndexOf, this, arguments) || 0;
    var O = $44022b55b2d2b203$exports(this);
    var length = $027f7f84b95594e7$exports(O);
    var index = length - 1;
    if (arguments.length > 1) index = $c0b33fd547546697$var$min(index, $5e45f07a290dfff0$exports(arguments[1]));
    if (index < 0) index = length + index;
    for(; index >= 0; index--)if (index in O && O[index] === searchElement) return index || 0;
    return -1;
} : $c0b33fd547546697$var$$lastIndexOf;


// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: $c0b33fd547546697$exports !== [].lastIndexOf
}, {
    lastIndexOf: $c0b33fd547546697$exports
});


"use strict";


var $2941c4aa5a3b485d$require$$map = $d32fb3bde149eb49$exports.map;

var $2941c4aa5a3b485d$var$HAS_SPECIES_SUPPORT = $2088ff0e00858956$exports("map");
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: !$2941c4aa5a3b485d$var$HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $2941c4aa5a3b485d$require$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";




var $6b97902bfa37f99c$var$$Array = Array;
var $6b97902bfa37f99c$var$ISNT_GENERIC = $7bdc373729e45e27$exports(function() {
    function F() {}
    // eslint-disable-next-line es/no-array-of -- safe
    return !($6b97902bfa37f99c$var$$Array.of.call(F) instanceof F);
});
// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$d4b8e88525a1c695$exports({
    target: "Array",
    stat: true,
    forced: $6b97902bfa37f99c$var$ISNT_GENERIC
}, {
    of: function of() {
        var index = 0;
        var argumentsLength = arguments.length;
        var result = new ($0518088af72f3297$exports(this) ? this : $6b97902bfa37f99c$var$$Array)(argumentsLength);
        while(argumentsLength > index)$2ac89df48719a8b2$exports(result, index, arguments[index++]);
        result.length = argumentsLength;
        return result;
    }
});


"use strict";

var $1acdcfc5d8aef5ba$exports = {};
"use strict";




var $1acdcfc5d8aef5ba$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $1acdcfc5d8aef5ba$var$createMethod = function createMethod(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $7d5785aa2fc2b3e1$exports(that);
        var self = $20eeb1af973ba55b$exports(O);
        var length = $027f7f84b95594e7$exports(O);
        $8b3f43e1fb85f635$exports(callbackfn);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $1acdcfc5d8aef5ba$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$1acdcfc5d8aef5ba$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $1acdcfc5d8aef5ba$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $1acdcfc5d8aef5ba$var$createMethod(true)
};


var $846b1a7888b2ad7f$require$$reduce = $1acdcfc5d8aef5ba$exports.left;


var $02bca89736833817$exports = {};
"use strict";


$02bca89736833817$exports = $4cba9a2acb4bdb16$exports($0f4ea948f6673103$exports.process) === "process";


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $846b1a7888b2ad7f$var$CHROME_BUG = !$02bca89736833817$exports && $d478a9aa1d363d00$exports > 79 && $d478a9aa1d363d00$exports < 83;
var $846b1a7888b2ad7f$var$FORCED = $846b1a7888b2ad7f$var$CHROME_BUG || !$bbbf81a67afd4255$exports("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: $846b1a7888b2ad7f$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $846b1a7888b2ad7f$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


"use strict";


var $0acdbf26dffea47e$require$$reduceRight = $1acdcfc5d8aef5ba$exports.right;



// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $0acdbf26dffea47e$var$CHROME_BUG = !$02bca89736833817$exports && $d478a9aa1d363d00$exports > 79 && $d478a9aa1d363d00$exports < 83;
var $0acdbf26dffea47e$var$FORCED = $0acdbf26dffea47e$var$CHROME_BUG || !$bbbf81a67afd4255$exports("reduceRight");
// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: $0acdbf26dffea47e$var$FORCED
}, {
    reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
        return $0acdbf26dffea47e$require$$reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";



var $e34339eadbcb7fe9$var$nativeReverse = $23a00ee3e029ff58$exports([].reverse);
var $e34339eadbcb7fe9$var$test = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: String($e34339eadbcb7fe9$var$test) === String($e34339eadbcb7fe9$var$test.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($84765aa0c0d1e084$exports(this)) this.length = this.length;
        return $e34339eadbcb7fe9$var$nativeReverse(this);
    }
});


"use strict";











var $3cebda6a40cebd69$var$HAS_SPECIES_SUPPORT = $2088ff0e00858956$exports("slice");
var $3cebda6a40cebd69$var$SPECIES = $6c5fb57dad6dd350$exports("species");
var $3cebda6a40cebd69$var$$Array = Array;
var $3cebda6a40cebd69$var$max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: !$3cebda6a40cebd69$var$HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = $44022b55b2d2b203$exports(this);
        var length = $027f7f84b95594e7$exports(O);
        var k = $4c10e2bcec3cf322$exports(start, length);
        var fin = $4c10e2bcec3cf322$exports(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($84765aa0c0d1e084$exports(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($0518088af72f3297$exports(Constructor) && (Constructor === $3cebda6a40cebd69$var$$Array || $84765aa0c0d1e084$exports(Constructor.prototype))) Constructor = undefined;
            else if ($b1a75f6ed3e2d50f$exports(Constructor)) {
                Constructor = Constructor[$3cebda6a40cebd69$var$SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $3cebda6a40cebd69$var$$Array || Constructor === undefined) return $043da047ce6f37e9$exports(O, k, fin);
        }
        result = new (Constructor === undefined ? $3cebda6a40cebd69$var$$Array : Constructor)($3cebda6a40cebd69$var$max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $2ac89df48719a8b2$exports(result, n, O[k]);
        result.length = n;
        return result;
    }
});


"use strict";








var $460f17b401c23fbc$exports = {};
"use strict";

var $460f17b401c23fbc$var$floor = Math.floor;
var $460f17b401c23fbc$var$mergeSort = function mergeSort1(array, comparefn) {
    var length = array.length;
    var middle = $460f17b401c23fbc$var$floor(length / 2);
    return length < 8 ? $460f17b401c23fbc$var$insertionSort(array, comparefn) : $460f17b401c23fbc$var$merge(array, $460f17b401c23fbc$var$mergeSort($ad61b3a319da2150$exports(array, 0, middle), comparefn), $460f17b401c23fbc$var$mergeSort($ad61b3a319da2150$exports(array, middle), comparefn), comparefn);
};
var $460f17b401c23fbc$var$insertionSort = function insertionSort(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $460f17b401c23fbc$var$merge = function merge(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
$460f17b401c23fbc$exports = $460f17b401c23fbc$var$mergeSort;



var $8a1d74e2af462cb2$exports = {};
"use strict";

var $8a1d74e2af462cb2$var$firefox = $4e05041f80099315$exports.match(/firefox\/(\d+)/i);
$8a1d74e2af462cb2$exports = !!$8a1d74e2af462cb2$var$firefox && +$8a1d74e2af462cb2$var$firefox[1];


var $3ac96019ccffde9a$exports = {};
"use strict";

$3ac96019ccffde9a$exports = /MSIE|Trident/.test($4e05041f80099315$exports);



var $4a1556c357a98552$exports = {};
"use strict";

var $4a1556c357a98552$var$webkit = $4e05041f80099315$exports.match(/AppleWebKit\/(\d+)\./);
$4a1556c357a98552$exports = !!$4a1556c357a98552$var$webkit && +$4a1556c357a98552$var$webkit[1];


var $8380218fef4be3db$var$test = [];
var $8380218fef4be3db$var$nativeSort = $23a00ee3e029ff58$exports($8380218fef4be3db$var$test.sort);
var $8380218fef4be3db$var$push = $23a00ee3e029ff58$exports($8380218fef4be3db$var$test.push);
// IE8-
var $8380218fef4be3db$var$FAILS_ON_UNDEFINED = $7bdc373729e45e27$exports(function() {
    $8380218fef4be3db$var$test.sort(undefined);
});
// V8 bug
var $8380218fef4be3db$var$FAILS_ON_NULL = $7bdc373729e45e27$exports(function() {
    $8380218fef4be3db$var$test.sort(null);
});
// Old WebKit
var $8380218fef4be3db$var$STRICT_METHOD = $bbbf81a67afd4255$exports("sort");
var $8380218fef4be3db$var$STABLE_SORT = !$7bdc373729e45e27$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($d478a9aa1d363d00$exports) return $d478a9aa1d363d00$exports < 70;
    if ($8a1d74e2af462cb2$exports && $8a1d74e2af462cb2$exports > 3) return;
    if ($3ac96019ccffde9a$exports) return true;
    if ($4a1556c357a98552$exports) return $4a1556c357a98552$exports < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$8380218fef4be3db$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $8380218fef4be3db$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $8380218fef4be3db$var$test.length; index++){
        chr = $8380218fef4be3db$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var $8380218fef4be3db$var$FORCED = $8380218fef4be3db$var$FAILS_ON_UNDEFINED || !$8380218fef4be3db$var$FAILS_ON_NULL || !$8380218fef4be3db$var$STRICT_METHOD || !$8380218fef4be3db$var$STABLE_SORT;
var $8380218fef4be3db$var$getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $dd666817fb19c24c$exports(x) > $dd666817fb19c24c$exports(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: $8380218fef4be3db$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $8b3f43e1fb85f635$exports(comparefn);
        var array = $7d5785aa2fc2b3e1$exports(this);
        if ($8380218fef4be3db$var$STABLE_SORT) return comparefn === undefined ? $8380218fef4be3db$var$nativeSort(array) : $8380218fef4be3db$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $027f7f84b95594e7$exports(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $8380218fef4be3db$var$push(items, array[index]);
        $460f17b401c23fbc$exports(items, $8380218fef4be3db$var$getSortCompare(comparefn));
        itemsLength = $027f7f84b95594e7$exports(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$1613aa7d617d950d$exports(array, index++);
        return array;
    }
});


"use strict";
var $d28e0c47aa6e7b5c$exports = {};
"use strict";




var $d28e0c47aa6e7b5c$var$SPECIES = $6c5fb57dad6dd350$exports("species");
$d28e0c47aa6e7b5c$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $db85f9884fa161d0$exports(CONSTRUCTOR_NAME);
    if ($40260b59b65c2e4c$exports && Constructor && !Constructor[$d28e0c47aa6e7b5c$var$SPECIES]) $d235cf6ad826c1e5$exports(Constructor, $d28e0c47aa6e7b5c$var$SPECIES, {
        configurable: true,
        get: function get() {
            return this;
        }
    });
};


// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
$d28e0c47aa6e7b5c$exports("Array");


"use strict";





var $deb2f04fd4501781$exports = {};
"use strict";


var $deb2f04fd4501781$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $deb2f04fd4501781$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $deb2f04fd4501781$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $40260b59b65c2e4c$exports && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], "length", {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
$deb2f04fd4501781$exports = $deb2f04fd4501781$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($84765aa0c0d1e084$exports(O) && !$deb2f04fd4501781$var$getOwnPropertyDescriptor(O, "length").writable) throw new $deb2f04fd4501781$var$$TypeError("Cannot set read only .length");
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};







var $19fb401359eb8104$var$HAS_SPECIES_SUPPORT = $2088ff0e00858956$exports("splice");
var $19fb401359eb8104$var$max = Math.max;
var $19fb401359eb8104$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$d4b8e88525a1c695$exports({
    target: "Array",
    proto: true,
    forced: !$19fb401359eb8104$var$HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $7d5785aa2fc2b3e1$exports(this);
        var len = $027f7f84b95594e7$exports(O);
        var actualStart = $4c10e2bcec3cf322$exports(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $19fb401359eb8104$var$min($19fb401359eb8104$var$max($5e45f07a290dfff0$exports(deleteCount), 0), len - actualStart);
        }
        $9dbbb26ed323b85d$exports(len + insertCount - actualDeleteCount);
        A = $e32f0fc064471ecf$exports(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $2ac89df48719a8b2$exports(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $1613aa7d617d950d$exports(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$1613aa7d617d950d$exports(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $1613aa7d617d950d$exports(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $deb2f04fd4501781$exports(O, len - actualDeleteCount + insertCount);
        return A;
    }
});


"use strict";

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$b64e56242aa7106c$exports("flat");


"use strict";

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$b64e56242aa7106c$exports("flatMap");


"use strict";


var $f25346346715e360$exports = {};
"use strict";



var $b9a9a55923c0414f$exports = {};
"use strict";
// eslint-disable-next-line es/no-typed-arrays -- safe
$b9a9a55923c0414f$exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";





var $58a816cd3ba07075$exports = {};
"use strict";

$58a816cd3ba07075$exports = function(target, src, options) {
    for(var key in src)$f488b1cc13335fff$exports(target, key, src[key], options);
    return target;
};



var $cf50221949c767d8$exports = {};
"use strict";

var $cf50221949c767d8$var$$TypeError = TypeError;
$cf50221949c767d8$exports = function(it, Prototype) {
    if ($372efcd1340d8495$exports(Prototype, it)) return it;
    throw new $cf50221949c767d8$var$$TypeError("Incorrect invocation");
};




var $f9469686166638c6$exports = {};
"use strict";


var $f9469686166638c6$var$$RangeError = RangeError;
// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
$f9469686166638c6$exports = function(it) {
    if (it === undefined) return 0;
    var number = $5e45f07a290dfff0$exports(it);
    var length = $8beae9420c83acf0$exports(number);
    if (number !== length) throw new $f9469686166638c6$var$$RangeError("Wrong length or index");
    return length;
};


var $0798da968619740d$exports = {};
"use strict";
var $25af7a74a18365c2$exports = {};
"use strict";
var $32f7fd37b95a3c70$exports = {};
"use strict";
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
$32f7fd37b95a3c70$exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


var $25af7a74a18365c2$var$abs = Math.abs;
var $25af7a74a18365c2$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
var $25af7a74a18365c2$var$INVERSE_EPSILON = 1 / $25af7a74a18365c2$var$EPSILON;
var $25af7a74a18365c2$var$roundTiesToEven = function roundTiesToEven(n) {
    return n + $25af7a74a18365c2$var$INVERSE_EPSILON - $25af7a74a18365c2$var$INVERSE_EPSILON;
};
$25af7a74a18365c2$exports = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
    var n = +x;
    var absolute = $25af7a74a18365c2$var$abs(n);
    var s = $32f7fd37b95a3c70$exports(n);
    if (absolute < FLOAT_MIN_VALUE) return s * $25af7a74a18365c2$var$roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
    var a = (1 + FLOAT_EPSILON / $25af7a74a18365c2$var$EPSILON) * absolute;
    var result = a - (a - absolute);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
    return s * result;
};


var $0798da968619740d$var$FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var $0798da968619740d$var$FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var $0798da968619740d$var$FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
$0798da968619740d$exports = Math.fround || function fround(x) {
    return $25af7a74a18365c2$exports(x, $0798da968619740d$var$FLOAT32_EPSILON, $0798da968619740d$var$FLOAT32_MAX_VALUE, $0798da968619740d$var$FLOAT32_MIN_VALUE);
};


var $1af538b17ee86899$exports = {};
"use strict";
// IEEE754 conversions based on https://github.com/feross/ieee754
var $1af538b17ee86899$var$$Array = Array;
var $1af538b17ee86899$var$abs = Math.abs;
var $1af538b17ee86899$var$pow = Math.pow;
var $1af538b17ee86899$var$floor = Math.floor;
var $1af538b17ee86899$var$log = Math.log;
var $1af538b17ee86899$var$LN2 = Math.LN2;
var $1af538b17ee86899$var$pack = function pack(number, mantissaLength, bytes) {
    var buffer = $1af538b17ee86899$var$$Array(bytes);
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var rt = mantissaLength === 23 ? $1af538b17ee86899$var$pow(2, -24) - $1af538b17ee86899$var$pow(2, -77) : 0;
    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
    var index = 0;
    var exponent, mantissa, c;
    number = $1af538b17ee86899$var$abs(number);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number || number === Infinity) {
        // eslint-disable-next-line no-self-compare -- NaN check
        mantissa = number !== number ? 1 : 0;
        exponent = eMax;
    } else {
        exponent = $1af538b17ee86899$var$floor($1af538b17ee86899$var$log(number) / $1af538b17ee86899$var$LN2);
        c = $1af538b17ee86899$var$pow(2, -exponent);
        if (number * c < 1) {
            exponent--;
            c *= 2;
        }
        if (exponent + eBias >= 1) number += rt / c;
        else number += rt * $1af538b17ee86899$var$pow(2, 1 - eBias);
        if (number * c >= 2) {
            exponent++;
            c /= 2;
        }
        if (exponent + eBias >= eMax) {
            mantissa = 0;
            exponent = eMax;
        } else if (exponent + eBias >= 1) {
            mantissa = (number * c - 1) * $1af538b17ee86899$var$pow(2, mantissaLength);
            exponent += eBias;
        } else {
            mantissa = number * $1af538b17ee86899$var$pow(2, eBias - 1) * $1af538b17ee86899$var$pow(2, mantissaLength);
            exponent = 0;
        }
    }
    while(mantissaLength >= 8){
        buffer[index++] = mantissa & 255;
        mantissa /= 256;
        mantissaLength -= 8;
    }
    exponent = exponent << mantissaLength | mantissa;
    exponentLength += mantissaLength;
    while(exponentLength > 0){
        buffer[index++] = exponent & 255;
        exponent /= 256;
        exponentLength -= 8;
    }
    buffer[--index] |= sign * 128;
    return buffer;
};
var $1af538b17ee86899$var$unpack = function unpack(buffer, mantissaLength) {
    var bytes = buffer.length;
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var nBits = exponentLength - 7;
    var index = bytes - 1;
    var sign = buffer[index--];
    var exponent = sign & 127;
    var mantissa;
    sign >>= 7;
    while(nBits > 0){
        exponent = exponent * 256 + buffer[index--];
        nBits -= 8;
    }
    mantissa = exponent & (1 << -nBits) - 1;
    exponent >>= -nBits;
    nBits += mantissaLength;
    while(nBits > 0){
        mantissa = mantissa * 256 + buffer[index--];
        nBits -= 8;
    }
    if (exponent === 0) exponent = 1 - eBias;
    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
    else {
        mantissa += $1af538b17ee86899$var$pow(2, mantissaLength);
        exponent -= eBias;
    }
    return (sign ? -1 : 1) * mantissa * $1af538b17ee86899$var$pow(2, exponent - mantissaLength);
};
$1af538b17ee86899$exports = {
    pack: $1af538b17ee86899$var$pack,
    unpack: $1af538b17ee86899$var$unpack
};





var $f25346346715e360$require$getOwnPropertyNames = $a329b85dee9c6785$export$2d1720544b23b823;




var $f25346346715e360$var$PROPER_FUNCTION_NAME = $b7b4004231446e90$exports.PROPER;
var $f25346346715e360$var$CONFIGURABLE_FUNCTION_NAME = $b7b4004231446e90$exports.CONFIGURABLE;
var $f25346346715e360$var$ARRAY_BUFFER = "ArrayBuffer";
var $f25346346715e360$var$DATA_VIEW = "DataView";
var $f25346346715e360$var$PROTOTYPE = "prototype";
var $f25346346715e360$var$WRONG_LENGTH = "Wrong length";
var $f25346346715e360$var$WRONG_INDEX = "Wrong index";
var $f25346346715e360$var$getInternalArrayBufferState = $c70ec777954e7cbe$exports.getterFor($f25346346715e360$var$ARRAY_BUFFER);
var $f25346346715e360$var$getInternalDataViewState = $c70ec777954e7cbe$exports.getterFor($f25346346715e360$var$DATA_VIEW);
var $f25346346715e360$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $f25346346715e360$var$NativeArrayBuffer = $0f4ea948f6673103$exports[$f25346346715e360$var$ARRAY_BUFFER];
var $f25346346715e360$var$$ArrayBuffer = $f25346346715e360$var$NativeArrayBuffer;
var $f25346346715e360$var$ArrayBufferPrototype = $f25346346715e360$var$$ArrayBuffer && $f25346346715e360$var$$ArrayBuffer[$f25346346715e360$var$PROTOTYPE];
var $f25346346715e360$var$$DataView = $0f4ea948f6673103$exports[$f25346346715e360$var$DATA_VIEW];
var $f25346346715e360$var$DataViewPrototype = $f25346346715e360$var$$DataView && $f25346346715e360$var$$DataView[$f25346346715e360$var$PROTOTYPE];
var $f25346346715e360$var$ObjectPrototype = Object.prototype;
var $f25346346715e360$var$Array = $0f4ea948f6673103$exports.Array;
var $f25346346715e360$var$RangeError = $0f4ea948f6673103$exports.RangeError;
var $f25346346715e360$var$fill = $23a00ee3e029ff58$exports($e7bfcf8076f14c00$exports);
var $f25346346715e360$var$reverse = $23a00ee3e029ff58$exports([].reverse);
var $f25346346715e360$var$packIEEE754 = $1af538b17ee86899$exports.pack;
var $f25346346715e360$var$unpackIEEE754 = $1af538b17ee86899$exports.unpack;
var $f25346346715e360$var$packInt8 = function packInt8(number) {
    return [
        number & 0xFF
    ];
};
var $f25346346715e360$var$packInt16 = function packInt16(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF
    ];
};
var $f25346346715e360$var$packInt32 = function packInt32(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF,
        number >> 16 & 0xFF,
        number >> 24 & 0xFF
    ];
};
var $f25346346715e360$var$unpackInt32 = function unpackInt32(buffer) {
    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var $f25346346715e360$var$packFloat32 = function packFloat32(number) {
    return $f25346346715e360$var$packIEEE754($0798da968619740d$exports(number), 23, 4);
};
var $f25346346715e360$var$packFloat64 = function packFloat64(number) {
    return $f25346346715e360$var$packIEEE754(number, 52, 8);
};
var $f25346346715e360$var$addGetter = function addGetter(Constructor, key, getInternalState) {
    $d235cf6ad826c1e5$exports(Constructor[$f25346346715e360$var$PROTOTYPE], key, {
        configurable: true,
        get: function get() {
            return getInternalState(this)[key];
        }
    });
};
var $f25346346715e360$var$get = function get(view, count, index, isLittleEndian) {
    var store = $f25346346715e360$var$getInternalDataViewState(view);
    var intIndex = $f9469686166638c6$exports(index);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $f25346346715e360$var$RangeError($f25346346715e360$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    var pack = $ad61b3a319da2150$exports(bytes, start, start + count);
    return boolIsLittleEndian ? pack : $f25346346715e360$var$reverse(pack);
};
var $f25346346715e360$var$set = function set(view, count, index, conversion, value, isLittleEndian) {
    var store = $f25346346715e360$var$getInternalDataViewState(view);
    var intIndex = $f9469686166638c6$exports(index);
    var pack = conversion(+value);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $f25346346715e360$var$RangeError($f25346346715e360$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    for(var i = 0; i < count; i++)bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};
if (!$b9a9a55923c0414f$exports) {
    $f25346346715e360$var$$ArrayBuffer = function ArrayBuffer(length) {
        $cf50221949c767d8$exports(this, $f25346346715e360$var$ArrayBufferPrototype);
        var byteLength = $f9469686166638c6$exports(length);
        $f25346346715e360$var$setInternalState(this, {
            type: $f25346346715e360$var$ARRAY_BUFFER,
            bytes: $f25346346715e360$var$fill($f25346346715e360$var$Array(byteLength), 0),
            byteLength: byteLength
        });
        if (!$40260b59b65c2e4c$exports) {
            this.byteLength = byteLength;
            this.detached = false;
        }
    };
    $f25346346715e360$var$ArrayBufferPrototype = $f25346346715e360$var$$ArrayBuffer[$f25346346715e360$var$PROTOTYPE];
    $f25346346715e360$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $cf50221949c767d8$exports(this, $f25346346715e360$var$DataViewPrototype);
        $cf50221949c767d8$exports(buffer, $f25346346715e360$var$ArrayBufferPrototype);
        var bufferState = $f25346346715e360$var$getInternalArrayBufferState(buffer);
        var bufferLength = bufferState.byteLength;
        var offset = $5e45f07a290dfff0$exports(byteOffset);
        if (offset < 0 || offset > bufferLength) throw new $f25346346715e360$var$RangeError("Wrong offset");
        byteLength = byteLength === undefined ? bufferLength - offset : $8beae9420c83acf0$exports(byteLength);
        if (offset + byteLength > bufferLength) throw new $f25346346715e360$var$RangeError($f25346346715e360$var$WRONG_LENGTH);
        $f25346346715e360$var$setInternalState(this, {
            type: $f25346346715e360$var$DATA_VIEW,
            buffer: buffer,
            byteLength: byteLength,
            byteOffset: offset,
            bytes: bufferState.bytes
        });
        if (!$40260b59b65c2e4c$exports) {
            this.buffer = buffer;
            this.byteLength = byteLength;
            this.byteOffset = offset;
        }
    };
    $f25346346715e360$var$DataViewPrototype = $f25346346715e360$var$$DataView[$f25346346715e360$var$PROTOTYPE];
    if ($40260b59b65c2e4c$exports) {
        $f25346346715e360$var$addGetter($f25346346715e360$var$$ArrayBuffer, "byteLength", $f25346346715e360$var$getInternalArrayBufferState);
        $f25346346715e360$var$addGetter($f25346346715e360$var$$DataView, "buffer", $f25346346715e360$var$getInternalDataViewState);
        $f25346346715e360$var$addGetter($f25346346715e360$var$$DataView, "byteLength", $f25346346715e360$var$getInternalDataViewState);
        $f25346346715e360$var$addGetter($f25346346715e360$var$$DataView, "byteOffset", $f25346346715e360$var$getInternalDataViewState);
    }
    $58a816cd3ba07075$exports($f25346346715e360$var$DataViewPrototype, {
        getInt8: function getInt8(byteOffset) {
            return $f25346346715e360$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $f25346346715e360$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $f25346346715e360$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $f25346346715e360$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $f25346346715e360$var$unpackInt32($f25346346715e360$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $f25346346715e360$var$unpackInt32($f25346346715e360$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $f25346346715e360$var$unpackIEEE754($f25346346715e360$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $f25346346715e360$var$unpackIEEE754($f25346346715e360$var$get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
        },
        setInt8: function setInt8(byteOffset, value) {
            $f25346346715e360$var$set(this, 1, byteOffset, $f25346346715e360$var$packInt8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $f25346346715e360$var$set(this, 1, byteOffset, $f25346346715e360$var$packInt8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $f25346346715e360$var$set(this, 2, byteOffset, $f25346346715e360$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $f25346346715e360$var$set(this, 2, byteOffset, $f25346346715e360$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $f25346346715e360$var$set(this, 4, byteOffset, $f25346346715e360$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $f25346346715e360$var$set(this, 4, byteOffset, $f25346346715e360$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $f25346346715e360$var$set(this, 4, byteOffset, $f25346346715e360$var$packFloat32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $f25346346715e360$var$set(this, 8, byteOffset, $f25346346715e360$var$packFloat64, value, arguments.length > 2 ? arguments[2] : false);
        }
    });
} else {
    var $f25346346715e360$var$INCORRECT_ARRAY_BUFFER_NAME = $f25346346715e360$var$PROPER_FUNCTION_NAME && $f25346346715e360$var$NativeArrayBuffer.name !== $f25346346715e360$var$ARRAY_BUFFER;
    /* eslint-disable no-new -- required for testing */ if (!$7bdc373729e45e27$exports(function() {
        $f25346346715e360$var$NativeArrayBuffer(1);
    }) || !$7bdc373729e45e27$exports(function() {
        new $f25346346715e360$var$NativeArrayBuffer(-1);
    }) || $7bdc373729e45e27$exports(function() {
        new $f25346346715e360$var$NativeArrayBuffer();
        new $f25346346715e360$var$NativeArrayBuffer(1.5);
        new $f25346346715e360$var$NativeArrayBuffer(NaN);
        return $f25346346715e360$var$NativeArrayBuffer.length !== 1 || $f25346346715e360$var$INCORRECT_ARRAY_BUFFER_NAME && !$f25346346715e360$var$CONFIGURABLE_FUNCTION_NAME;
    })) {
        /* eslint-enable no-new -- required for testing */ $f25346346715e360$var$$ArrayBuffer = function ArrayBuffer(length) {
            $cf50221949c767d8$exports(this, $f25346346715e360$var$ArrayBufferPrototype);
            return new $f25346346715e360$var$NativeArrayBuffer($f9469686166638c6$exports(length));
        };
        $f25346346715e360$var$$ArrayBuffer[$f25346346715e360$var$PROTOTYPE] = $f25346346715e360$var$ArrayBufferPrototype;
        for(var $f25346346715e360$var$keys = $f25346346715e360$require$getOwnPropertyNames($f25346346715e360$var$NativeArrayBuffer), $f25346346715e360$var$j = 0, $f25346346715e360$var$key; $f25346346715e360$var$keys.length > $f25346346715e360$var$j;)if (!(($f25346346715e360$var$key = $f25346346715e360$var$keys[$f25346346715e360$var$j++]) in $f25346346715e360$var$$ArrayBuffer)) $4bc121b672cbfd84$exports($f25346346715e360$var$$ArrayBuffer, $f25346346715e360$var$key, $f25346346715e360$var$NativeArrayBuffer[$f25346346715e360$var$key]);
        $f25346346715e360$var$ArrayBufferPrototype.constructor = $f25346346715e360$var$$ArrayBuffer;
    } else if ($f25346346715e360$var$INCORRECT_ARRAY_BUFFER_NAME && $f25346346715e360$var$CONFIGURABLE_FUNCTION_NAME) $4bc121b672cbfd84$exports($f25346346715e360$var$NativeArrayBuffer, "name", $f25346346715e360$var$ARRAY_BUFFER);
    // WebKit bug - the same parent prototype for typed arrays and data view
    if ($5f3130f6ca40c617$exports && $7acbb54af94d406d$exports($f25346346715e360$var$DataViewPrototype) !== $f25346346715e360$var$ObjectPrototype) $5f3130f6ca40c617$exports($f25346346715e360$var$DataViewPrototype, $f25346346715e360$var$ObjectPrototype);
    // iOS Safari 7.x bug
    var $f25346346715e360$var$testView = new $f25346346715e360$var$$DataView(new $f25346346715e360$var$$ArrayBuffer(2));
    var $f25346346715e360$var$$setInt8 = $23a00ee3e029ff58$exports($f25346346715e360$var$DataViewPrototype.setInt8);
    $f25346346715e360$var$testView.setInt8(0, 2147483648);
    $f25346346715e360$var$testView.setInt8(1, 2147483649);
    if ($f25346346715e360$var$testView.getInt8(0) || !$f25346346715e360$var$testView.getInt8(1)) $58a816cd3ba07075$exports($f25346346715e360$var$DataViewPrototype, {
        setInt8: function setInt8(byteOffset, value) {
            $f25346346715e360$var$$setInt8(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $f25346346715e360$var$$setInt8(this, byteOffset, value << 24 >> 24);
        }
    }, {
        unsafe: true
    });
}
$0590ceb3c9c577a7$exports($f25346346715e360$var$$ArrayBuffer, $f25346346715e360$var$ARRAY_BUFFER);
$0590ceb3c9c577a7$exports($f25346346715e360$var$$DataView, $f25346346715e360$var$DATA_VIEW);
$f25346346715e360$exports = {
    ArrayBuffer: $f25346346715e360$var$$ArrayBuffer,
    DataView: $f25346346715e360$var$$DataView
};



var $62a029623af2e680$var$ARRAY_BUFFER = "ArrayBuffer";
var $62a029623af2e680$var$ArrayBuffer = $f25346346715e360$exports[$62a029623af2e680$var$ARRAY_BUFFER];
var $62a029623af2e680$var$NativeArrayBuffer = $0f4ea948f6673103$exports[$62a029623af2e680$var$ARRAY_BUFFER];
// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$d4b8e88525a1c695$exports({
    global: true,
    constructor: true,
    forced: $62a029623af2e680$var$NativeArrayBuffer !== $62a029623af2e680$var$ArrayBuffer
}, {
    ArrayBuffer: $62a029623af2e680$var$ArrayBuffer
});
$d28e0c47aa6e7b5c$exports($62a029623af2e680$var$ARRAY_BUFFER);


"use strict";







var $11472182d06f3dc1$exports = {};
"use strict";

var $6e7a3c29f95ae8ae$exports = {};
"use strict";


var $6e7a3c29f95ae8ae$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$6e7a3c29f95ae8ae$exports = function(argument) {
    if ($0518088af72f3297$exports(argument)) return argument;
    throw new $6e7a3c29f95ae8ae$var$$TypeError($815d6e8656bb616c$exports(argument) + " is not a constructor");
};




var $11472182d06f3dc1$var$SPECIES = $6c5fb57dad6dd350$exports("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$11472182d06f3dc1$exports = function(O, defaultConstructor) {
    var C = $c894fc907eeec831$exports(O).constructor;
    var S;
    return C === undefined || $76135a25443d684f$exports(S = $c894fc907eeec831$exports(C)[$11472182d06f3dc1$var$SPECIES]) ? defaultConstructor : $6e7a3c29f95ae8ae$exports(S);
};


var $084aa8cc06f540f1$var$ArrayBuffer = $f25346346715e360$exports.ArrayBuffer;
var $084aa8cc06f540f1$var$DataView = $f25346346715e360$exports.DataView;
var $084aa8cc06f540f1$var$DataViewPrototype = $084aa8cc06f540f1$var$DataView.prototype;
var $084aa8cc06f540f1$var$nativeArrayBufferSlice = $92ca88fbf3cbbcaa$exports($084aa8cc06f540f1$var$ArrayBuffer.prototype.slice);
var $084aa8cc06f540f1$var$getUint8 = $92ca88fbf3cbbcaa$exports($084aa8cc06f540f1$var$DataViewPrototype.getUint8);
var $084aa8cc06f540f1$var$setUint8 = $92ca88fbf3cbbcaa$exports($084aa8cc06f540f1$var$DataViewPrototype.setUint8);
var $084aa8cc06f540f1$var$INCORRECT_SLICE = $7bdc373729e45e27$exports(function() {
    return !new $084aa8cc06f540f1$var$ArrayBuffer(2).slice(1, undefined).byteLength;
});
// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$d4b8e88525a1c695$exports({
    target: "ArrayBuffer",
    proto: true,
    unsafe: true,
    forced: $084aa8cc06f540f1$var$INCORRECT_SLICE
}, {
    slice: function slice(start, end) {
        if ($084aa8cc06f540f1$var$nativeArrayBufferSlice && end === undefined) return $084aa8cc06f540f1$var$nativeArrayBufferSlice($c894fc907eeec831$exports(this), start); // FF fix
        var length = $c894fc907eeec831$exports(this).byteLength;
        var first = $4c10e2bcec3cf322$exports(start, length);
        var fin = $4c10e2bcec3cf322$exports(end === undefined ? length : end, length);
        var result = new ($11472182d06f3dc1$exports(this, $084aa8cc06f540f1$var$ArrayBuffer))($8beae9420c83acf0$exports(fin - first));
        var viewSource = new $084aa8cc06f540f1$var$DataView(this);
        var viewTarget = new $084aa8cc06f540f1$var$DataView(result);
        var index = 0;
        while(first < fin)$084aa8cc06f540f1$var$setUint8(viewTarget, index++, $084aa8cc06f540f1$var$getUint8(viewSource, first++));
        return result;
    }
});


"use strict";


var $0dd4452aabc8638d$exports = {};
"use strict";


var $0dd4452aabc8638d$var$$TypeError = TypeError;
// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
$0dd4452aabc8638d$exports = function(hint) {
    $c894fc907eeec831$exports(this);
    if (hint === "string" || hint === "default") hint = "string";
    else if (hint !== "number") throw new $0dd4452aabc8638d$var$$TypeError("Incorrect hint");
    return $35f9ffdabde9ad75$exports(this, hint);
};



var $fdac1fc1fb863115$var$TO_PRIMITIVE = $6c5fb57dad6dd350$exports("toPrimitive");
var $fdac1fc1fb863115$var$DatePrototype = Date.prototype;
// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!$5f4f8ca39500aba6$exports($fdac1fc1fb863115$var$DatePrototype, $fdac1fc1fb863115$var$TO_PRIMITIVE)) $f488b1cc13335fff$exports($fdac1fc1fb863115$var$DatePrototype, $fdac1fc1fb863115$var$TO_PRIMITIVE, $0dd4452aabc8638d$exports);


"use strict";






var $fcd386bbc9d5eb0b$var$HAS_INSTANCE = $6c5fb57dad6dd350$exports("hasInstance");
var $fcd386bbc9d5eb0b$var$FunctionPrototype = Function.prototype;
// `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
if (!($fcd386bbc9d5eb0b$var$HAS_INSTANCE in $fcd386bbc9d5eb0b$var$FunctionPrototype)) $18b1ebdefa97b93b$export$2d1720544b23b823($fcd386bbc9d5eb0b$var$FunctionPrototype, $fcd386bbc9d5eb0b$var$HAS_INSTANCE, {
    value: $79af1eca4f325743$exports(function(O) {
        if (!$64c802885f841370$exports(this) || !$b1a75f6ed3e2d50f$exports(O)) return false;
        var P = this.prototype;
        if (!$b1a75f6ed3e2d50f$exports(P)) return O instanceof this;
        // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
        while(O = $7acbb54af94d406d$exports(O))if (P === O) return true;
        return false;
    }, $fcd386bbc9d5eb0b$var$HAS_INSTANCE)
});


"use strict";


var $9d7e55141a69571b$require$FUNCTION_NAME_EXISTS = $b7b4004231446e90$exports.EXISTS;


var $9d7e55141a69571b$var$FunctionPrototype = Function.prototype;
var $9d7e55141a69571b$var$functionToString = $23a00ee3e029ff58$exports($9d7e55141a69571b$var$FunctionPrototype.toString);
var $9d7e55141a69571b$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $9d7e55141a69571b$var$regExpExec = $23a00ee3e029ff58$exports($9d7e55141a69571b$var$nameRE.exec);
var $9d7e55141a69571b$var$NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($40260b59b65c2e4c$exports && !$9d7e55141a69571b$require$FUNCTION_NAME_EXISTS) $d235cf6ad826c1e5$exports($9d7e55141a69571b$var$FunctionPrototype, $9d7e55141a69571b$var$NAME, {
    configurable: true,
    get: function get() {
        try {
            return $9d7e55141a69571b$var$regExpExec($9d7e55141a69571b$var$nameRE, $9d7e55141a69571b$var$functionToString(this))[1];
        } catch (error) {
            return "";
        }
    }
});


"use strict";


// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$0590ceb3c9c577a7$exports($0f4ea948f6673103$exports.JSON, "JSON", true);


"use strict";
"use strict";
var $5d209f01e9f191f6$exports = {};
"use strict";





var $52aadfc22a57c5ff$exports = {};

var $3L4GM = parcelRequire("3L4GM");
"use strict";






var $52aadfc22a57c5ff$require$defineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;


var $5d3c3c3ca0439a5a$exports = {};
"use strict";



var $3ceb953d1c0e7a72$exports = {};
"use strict";

$3ceb953d1c0e7a72$exports = $7bdc373729e45e27$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $5d3c3c3ca0439a5a$var$$isExtensible = Object.isExtensible;
var $5d3c3c3ca0439a5a$var$FAILS_ON_PRIMITIVES = $7bdc373729e45e27$exports(function() {
    $5d3c3c3ca0439a5a$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$5d3c3c3ca0439a5a$exports = $5d3c3c3ca0439a5a$var$FAILS_ON_PRIMITIVES || $3ceb953d1c0e7a72$exports ? function isExtensible(it) {
    if (!$b1a75f6ed3e2d50f$exports(it)) return false;
    if ($3ceb953d1c0e7a72$exports && $4cba9a2acb4bdb16$exports(it) === "ArrayBuffer") return false;
    return $5d3c3c3ca0439a5a$var$$isExtensible ? $5d3c3c3ca0439a5a$var$$isExtensible(it) : true;
} : $5d3c3c3ca0439a5a$var$$isExtensible;



var $a00e537c46774c22$exports = {};
"use strict";

$a00e537c46774c22$exports = !$7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});


var $52aadfc22a57c5ff$var$REQUIRED = false;
var $52aadfc22a57c5ff$var$METADATA = $3139b6d9415fe2b9$exports("meta");
var $52aadfc22a57c5ff$var$id = 0;
var $52aadfc22a57c5ff$var$setMetadata = function setMetadata(it) {
    $52aadfc22a57c5ff$require$defineProperty(it, $52aadfc22a57c5ff$var$METADATA, {
        value: {
            objectID: "O" + $52aadfc22a57c5ff$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $52aadfc22a57c5ff$var$fastKey = function fastKey(it, create) {
    // return a primitive with prefix
    if (!$b1a75f6ed3e2d50f$exports(it)) return (typeof it === "undefined" ? "undefined" : (0, $3L4GM._)(it)) == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$5f4f8ca39500aba6$exports(it, $52aadfc22a57c5ff$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$5d3c3c3ca0439a5a$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $52aadfc22a57c5ff$var$setMetadata(it);
    // return object ID
    }
    return it[$52aadfc22a57c5ff$var$METADATA].objectID;
};
var $52aadfc22a57c5ff$var$getWeakData = function getWeakData(it, create) {
    if (!$5f4f8ca39500aba6$exports(it, $52aadfc22a57c5ff$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$5d3c3c3ca0439a5a$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $52aadfc22a57c5ff$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$52aadfc22a57c5ff$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $52aadfc22a57c5ff$var$onFreeze = function onFreeze(it) {
    if ($a00e537c46774c22$exports && $52aadfc22a57c5ff$var$REQUIRED && $5d3c3c3ca0439a5a$exports(it) && !$5f4f8ca39500aba6$exports(it, $52aadfc22a57c5ff$var$METADATA)) $52aadfc22a57c5ff$var$setMetadata(it);
    return it;
};
var $52aadfc22a57c5ff$var$enable = function enable() {
    $52aadfc22a57c5ff$var$meta.enable = function() {};
    $52aadfc22a57c5ff$var$REQUIRED = true;
    var getOwnPropertyNames = $a329b85dee9c6785$export$2d1720544b23b823;
    var splice = $23a00ee3e029ff58$exports([].splice);
    var test = {};
    test[$52aadfc22a57c5ff$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $a329b85dee9c6785$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $52aadfc22a57c5ff$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $d4b8e88525a1c695$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $310e8a5d08b7fb31$export$2d1720544b23b823
        });
    }
};
var $52aadfc22a57c5ff$var$meta = $52aadfc22a57c5ff$exports = {
    enable: $52aadfc22a57c5ff$var$enable,
    fastKey: $52aadfc22a57c5ff$var$fastKey,
    getWeakData: $52aadfc22a57c5ff$var$getWeakData,
    onFreeze: $52aadfc22a57c5ff$var$onFreeze
};
$76695f3a4d4ba903$exports[$52aadfc22a57c5ff$var$METADATA] = true;


var $e8d49b748288eae0$exports = {};
"use strict";










var $e8d49b748288eae0$var$$TypeError = TypeError;
var $e8d49b748288eae0$var$Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $e8d49b748288eae0$var$ResultPrototype = $e8d49b748288eae0$var$Result.prototype;
$e8d49b748288eae0$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $042f91ff50d30f11$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        if (iterator) $bef2dd76087b2a5e$exports(iterator, "normal", condition);
        return new $e8d49b748288eae0$var$Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            $c894fc907eeec831$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $1ffb58790ca29df3$exports(iterable);
        if (!iterFn) throw new $e8d49b748288eae0$var$$TypeError($815d6e8656bb616c$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($4ea30f210c56f492$exports(iterFn)) {
            for(index = 0, length = $027f7f84b95594e7$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $372efcd1340d8495$exports($e8d49b748288eae0$var$ResultPrototype, result)) return result;
            }
            return new $e8d49b748288eae0$var$Result(false);
        }
        iterator = $246adf013c49aea4$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $4b3fe34719193049$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $bef2dd76087b2a5e$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $372efcd1340d8495$exports($e8d49b748288eae0$var$ResultPrototype, result)) return result;
    }
    return new $e8d49b748288eae0$var$Result(false);
};









var $f6721401d0718c1d$exports = {};
"use strict";



// makes subclassing work correct for wrapped built-ins
$f6721401d0718c1d$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $5f3130f6ca40c617$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $64c802885f841370$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $b1a75f6ed3e2d50f$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $5f3130f6ca40c617$exports($this, NewTargetPrototype);
    return $this;
};


$5d209f01e9f191f6$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $0f4ea948f6673103$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function fixMethod(KEY) {
        var uncurriedNativeMethod = $23a00ee3e029ff58$exports(NativePrototype[KEY]);
        $f488b1cc13335fff$exports(NativePrototype, KEY, KEY === "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === "delete" ? function(key) {
            return IS_WEAK && !$b1a75f6ed3e2d50f$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "get" ? function get(key) {
            return IS_WEAK && !$b1a75f6ed3e2d50f$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "has" ? function has(key) {
            return IS_WEAK && !$b1a75f6ed3e2d50f$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $0fb365768ae0f3c7$exports(CONSTRUCTOR_NAME, !$64c802885f841370$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$7bdc373729e45e27$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $52aadfc22a57c5ff$exports.enable();
    } else if ($0fb365768ae0f3c7$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $7bdc373729e45e27$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $14b7679ddc3bba0f$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $7bdc373729e45e27$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $cf50221949c767d8$exports(dummy, NativePrototype);
                var that = $f6721401d0718c1d$exports(new NativeConstructor(), dummy, Constructor);
                if (!$76135a25443d684f$exports(iterable)) $e8d49b748288eae0$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $d4b8e88525a1c695$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $0590ceb3c9c577a7$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $4f57ba8b05db6015$exports = {};
"use strict";












var $4f57ba8b05db6015$require$fastKey = $52aadfc22a57c5ff$exports.fastKey;

var $4f57ba8b05db6015$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $4f57ba8b05db6015$var$internalStateGetterFor = $c70ec777954e7cbe$exports.getterFor;
$4f57ba8b05db6015$exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $cf50221949c767d8$exports(that, Prototype);
            $4f57ba8b05db6015$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $9959f3fdced32995$exports(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!$40260b59b65c2e4c$exports) that.size = 0;
            if (!$76135a25443d684f$exports(iterable)) $e8d49b748288eae0$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $4f57ba8b05db6015$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $4f57ba8b05db6015$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($40260b59b65c2e4c$exports) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function getEntry(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $4f57ba8b05db6015$require$fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $58a816cd3ba07075$exports(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if ($40260b59b65c2e4c$exports) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($40260b59b65c2e4c$exports) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $042f91ff50d30f11$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $58a816cd3ba07075$exports(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($40260b59b65c2e4c$exports) $d235cf6ad826c1e5$exports(Prototype, "size", {
            configurable: true,
            get: function get() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = $4f57ba8b05db6015$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $4f57ba8b05db6015$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $34aff3def5c5238a$exports(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $4f57ba8b05db6015$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return $ecc47fe671ebbad0$exports(undefined, true);
            }
            // return step by kind
            if (kind === "keys") return $ecc47fe671ebbad0$exports(entry.key, false);
            if (kind === "values") return $ecc47fe671ebbad0$exports(entry.value, false);
            return $ecc47fe671ebbad0$exports([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $d28e0c47aa6e7b5c$exports(CONSTRUCTOR_NAME);
    }
};


// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$5d209f01e9f191f6$exports("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $4f57ba8b05db6015$exports);




"use strict";

var $b52d0b1499cc6a90$exports = {};
"use strict";
var $b52d0b1499cc6a90$var$log = Math.log;
// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe
$b52d0b1499cc6a90$exports = Math.log1p || function log1p(x) {
    var n = +x;
    return n > -0.00000001 && n < 1e-8 ? n - n * n / 2 : $b52d0b1499cc6a90$var$log(1 + n);
};


// eslint-disable-next-line es/no-math-acosh -- required for testing
var $7c75cdeee90f4f70$var$$acosh = Math.acosh;
var $7c75cdeee90f4f70$var$log = Math.log;
var $7c75cdeee90f4f70$var$sqrt = Math.sqrt;
var $7c75cdeee90f4f70$var$LN2 = Math.LN2;
var $7c75cdeee90f4f70$var$FORCED = !$7c75cdeee90f4f70$var$$acosh || Math.floor($7c75cdeee90f4f70$var$$acosh(Number.MAX_VALUE)) !== 710 || $7c75cdeee90f4f70$var$$acosh(Infinity) !== Infinity;
// `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true,
    forced: $7c75cdeee90f4f70$var$FORCED
}, {
    acosh: function acosh(x) {
        var n = +x;
        return n < 1 ? NaN : n > 94906265.62425156 ? $7c75cdeee90f4f70$var$log(n) + $7c75cdeee90f4f70$var$LN2 : $b52d0b1499cc6a90$exports(n - 1 + $7c75cdeee90f4f70$var$sqrt(n - 1) * $7c75cdeee90f4f70$var$sqrt(n + 1));
    }
});


"use strict";

// eslint-disable-next-line es/no-math-asinh -- required for testing
var $9b22b2c55e351110$var$$asinh = Math.asinh;
var $9b22b2c55e351110$var$log = Math.log;
var $9b22b2c55e351110$var$sqrt = Math.sqrt;
function $9b22b2c55e351110$var$asinh(x) {
    var n = +x;
    return !isFinite(n) || n === 0 ? n : n < 0 ? -$9b22b2c55e351110$var$asinh(-n) : $9b22b2c55e351110$var$log(n + $9b22b2c55e351110$var$sqrt(n * n + 1));
}
var $9b22b2c55e351110$var$FORCED = !($9b22b2c55e351110$var$$asinh && 1 / $9b22b2c55e351110$var$$asinh(0) > 0);
// `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true,
    forced: $9b22b2c55e351110$var$FORCED
}, {
    asinh: $9b22b2c55e351110$var$asinh
});


"use strict";

// eslint-disable-next-line es/no-math-atanh -- required for testing
var $47cf4d07612b4241$var$$atanh = Math.atanh;
var $47cf4d07612b4241$var$log = Math.log;
var $47cf4d07612b4241$var$FORCED = !($47cf4d07612b4241$var$$atanh && 1 / $47cf4d07612b4241$var$$atanh(-0) < 0);
// `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true,
    forced: $47cf4d07612b4241$var$FORCED
}, {
    atanh: function atanh(x) {
        var n = +x;
        return n === 0 ? n : $47cf4d07612b4241$var$log((1 + n) / (1 - n)) / 2;
    }
});


"use strict";


var $962ff8b88bf090af$var$abs = Math.abs;
var $962ff8b88bf090af$var$pow = Math.pow;
// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true
}, {
    cbrt: function cbrt(x) {
        var n = +x;
        return $32f7fd37b95a3c70$exports(n) * $962ff8b88bf090af$var$pow($962ff8b88bf090af$var$abs(n), 1 / 3);
    }
});


"use strict";

var $29fecfb15c80e002$var$floor = Math.floor;
var $29fecfb15c80e002$var$log = Math.log;
var $29fecfb15c80e002$var$LOG2E = Math.LOG2E;
// `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true
}, {
    clz32: function clz32(x) {
        var n = x >>> 0;
        return n ? 31 - $29fecfb15c80e002$var$floor($29fecfb15c80e002$var$log(n + 0.5) * $29fecfb15c80e002$var$LOG2E) : 32;
    }
});


"use strict";

var $57456376926a5194$exports = {};
"use strict";
// eslint-disable-next-line es/no-math-expm1 -- safe
var $57456376926a5194$var$$expm1 = Math.expm1;
var $57456376926a5194$var$exp = Math.exp;
// `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1
$57456376926a5194$exports = !$57456376926a5194$var$$expm1 || $57456376926a5194$var$$expm1(10) > 22025.465794806719 || $57456376926a5194$var$$expm1(10) < 22025.4657948067165168 || $57456376926a5194$var$$expm1(-0.00000000000000002) !== -0.00000000000000002 ? function expm1(x) {
    var n = +x;
    return n === 0 ? n : n > -0.000001 && n < 1e-6 ? n + n * n / 2 : $57456376926a5194$var$exp(n) - 1;
} : $57456376926a5194$var$$expm1;


// eslint-disable-next-line es/no-math-cosh -- required for testing
var $19e057ba762cf495$var$$cosh = Math.cosh;
var $19e057ba762cf495$var$abs = Math.abs;
var $19e057ba762cf495$var$E = Math.E;
var $19e057ba762cf495$var$FORCED = !$19e057ba762cf495$var$$cosh || $19e057ba762cf495$var$$cosh(710) === Infinity;
// `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true,
    forced: $19e057ba762cf495$var$FORCED
}, {
    cosh: function cosh(x) {
        var t = $57456376926a5194$exports($19e057ba762cf495$var$abs(x) - 1) + 1;
        return (t + 1 / (t * $19e057ba762cf495$var$E * $19e057ba762cf495$var$E)) * ($19e057ba762cf495$var$E / 2);
    }
});


"use strict";


// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true,
    forced: $57456376926a5194$exports !== Math.expm1
}, {
    expm1: $57456376926a5194$exports
});


"use strict";


// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true
}, {
    fround: $0798da968619740d$exports
});


"use strict";

// eslint-disable-next-line es/no-math-hypot -- required for testing
var $5dec047137b293e6$var$$hypot = Math.hypot;
var $5dec047137b293e6$var$abs = Math.abs;
var $5dec047137b293e6$var$sqrt = Math.sqrt;
// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var $5dec047137b293e6$var$FORCED = !!$5dec047137b293e6$var$$hypot && $5dec047137b293e6$var$$hypot(Infinity, NaN) !== Infinity;
// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true,
    arity: 2,
    forced: $5dec047137b293e6$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $5dec047137b293e6$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * $5dec047137b293e6$var$sqrt(sum);
    }
});


"use strict";


// eslint-disable-next-line es/no-math-imul -- required for testing
var $1f6eb7b700183207$var$$imul = Math.imul;
var $1f6eb7b700183207$var$FORCED = $7bdc373729e45e27$exports(function() {
    return $1f6eb7b700183207$var$$imul(0xFFFFFFFF, 5) !== -5 || $1f6eb7b700183207$var$$imul.length !== 2;
});
// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true,
    forced: $1f6eb7b700183207$var$FORCED
}, {
    imul: function imul(x, y) {
        var UINT16 = 0xFFFF;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});


"use strict";

var $84c17a205129d351$exports = {};
"use strict";
var $84c17a205129d351$var$log = Math.log;
var $84c17a205129d351$var$LOG10E = Math.LOG10E;
// eslint-disable-next-line es/no-math-log10 -- safe
$84c17a205129d351$exports = Math.log10 || function log10(x) {
    return $84c17a205129d351$var$log(x) * $84c17a205129d351$var$LOG10E;
};


// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true
}, {
    log10: $84c17a205129d351$exports
});


"use strict";


// `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true
}, {
    log1p: $b52d0b1499cc6a90$exports
});


"use strict";

var $ecb670e2f0035466$var$log = Math.log;
var $ecb670e2f0035466$var$LN2 = Math.LN2;
// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true
}, {
    log2: function log2(x) {
        return $ecb670e2f0035466$var$log(x) / $ecb670e2f0035466$var$LN2;
    }
});


"use strict";


// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true
}, {
    sign: $32f7fd37b95a3c70$exports
});


"use strict";



var $94a23e57ab588e5e$var$abs = Math.abs;
var $94a23e57ab588e5e$var$exp = Math.exp;
var $94a23e57ab588e5e$var$E = Math.E;
var $94a23e57ab588e5e$var$FORCED = $7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-math-sinh -- required for testing
    return Math.sinh(-0.00000000000000002) !== -0.00000000000000002;
});
// `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true,
    forced: $94a23e57ab588e5e$var$FORCED
}, {
    sinh: function sinh(x) {
        var n = +x;
        return $94a23e57ab588e5e$var$abs(n) < 1 ? ($57456376926a5194$exports(n) - $57456376926a5194$exports(-n)) / 2 : ($94a23e57ab588e5e$var$exp(n - 1) - $94a23e57ab588e5e$var$exp(-n - 1)) * ($94a23e57ab588e5e$var$E / 2);
    }
});


"use strict";


var $34146e8bfc20c713$var$exp = Math.exp;
// `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true
}, {
    tanh: function tanh(x) {
        var n = +x;
        var a = $57456376926a5194$exports(n);
        var b = $57456376926a5194$exports(-n);
        return a === Infinity ? 1 : b === Infinity ? -1 : (a - b) / ($34146e8bfc20c713$var$exp(n) + $34146e8bfc20c713$var$exp(-n));
    }
});


"use strict";

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
$0590ceb3c9c577a7$exports(Math, "Math", true);


"use strict";


// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$d4b8e88525a1c695$exports({
    target: "Math",
    stat: true
}, {
    trunc: $2f39dbb70845f716$exports
});



var $3L4GM = parcelRequire("3L4GM");
"use strict";














var $40e42aded55b3a43$require$getOwnPropertyNames = $a329b85dee9c6785$export$2d1720544b23b823;

var $40e42aded55b3a43$require$getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;

var $40e42aded55b3a43$require$defineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;
var $3031ee9dcea937be$exports = {};
"use strict";

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
$3031ee9dcea937be$exports = $23a00ee3e029ff58$exports(1.0.valueOf);


var $0da89d3a7f6e5b50$exports = {};
"use strict";



var $ce3283842b942e24$exports = {};
"use strict";
// a string of all valid unicode whitespaces
$ce3283842b942e24$exports = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";


var $0da89d3a7f6e5b50$var$replace = $23a00ee3e029ff58$exports("".replace);
var $0da89d3a7f6e5b50$var$ltrim = RegExp("^[" + $ce3283842b942e24$exports + "]+");
var $0da89d3a7f6e5b50$var$rtrim = RegExp("(^|[^" + $ce3283842b942e24$exports + "])[" + $ce3283842b942e24$exports + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $0da89d3a7f6e5b50$var$createMethod = function createMethod(TYPE) {
    return function($this) {
        var string = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports($this));
        if (TYPE & 1) string = $0da89d3a7f6e5b50$var$replace(string, $0da89d3a7f6e5b50$var$ltrim, "");
        if (TYPE & 2) string = $0da89d3a7f6e5b50$var$replace(string, $0da89d3a7f6e5b50$var$rtrim, "$1");
        return string;
    };
};
$0da89d3a7f6e5b50$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $0da89d3a7f6e5b50$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $0da89d3a7f6e5b50$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $0da89d3a7f6e5b50$var$createMethod(3)
};


var $40e42aded55b3a43$require$trim = $0da89d3a7f6e5b50$exports.trim;
var $40e42aded55b3a43$var$NUMBER = "Number";
var $40e42aded55b3a43$var$NativeNumber = $0f4ea948f6673103$exports[$40e42aded55b3a43$var$NUMBER];
var $40e42aded55b3a43$var$PureNumberNamespace = $0a6d052471fbbec7$exports[$40e42aded55b3a43$var$NUMBER];
var $40e42aded55b3a43$var$NumberPrototype = $40e42aded55b3a43$var$NativeNumber.prototype;
var $40e42aded55b3a43$var$TypeError = $0f4ea948f6673103$exports.TypeError;
var $40e42aded55b3a43$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $40e42aded55b3a43$var$charCodeAt = $23a00ee3e029ff58$exports("".charCodeAt);
// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var $40e42aded55b3a43$var$toNumeric = function toNumeric(value) {
    var primValue = $cd38c3644f9f1332$exports(value, "number");
    return (typeof primValue === "undefined" ? "undefined" : (0, $3L4GM._)(primValue)) == "bigint" ? primValue : $40e42aded55b3a43$var$toNumber(primValue);
};
// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var $40e42aded55b3a43$var$toNumber = function toNumber(argument) {
    var it = $cd38c3644f9f1332$exports(argument, "number");
    var first, third, radix, maxCode, digits, length, index, code;
    if ($368e2561dee205ff$exports(it)) throw new $40e42aded55b3a43$var$TypeError("Cannot convert a Symbol value to a number");
    if (typeof it == "string" && it.length > 2) {
        it = $40e42aded55b3a43$require$trim(it);
        first = $40e42aded55b3a43$var$charCodeAt(it, 0);
        if (first === 43 || first === 45) {
            third = $40e42aded55b3a43$var$charCodeAt(it, 2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch($40e42aded55b3a43$var$charCodeAt(it, 1)){
                // fast equal of /^0b[01]+$/i
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break;
                // fast equal of /^0o[0-7]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break;
                default:
                    return +it;
            }
            digits = $40e42aded55b3a43$var$stringSlice(it, 2);
            length = digits.length;
            for(index = 0; index < length; index++){
                code = $40e42aded55b3a43$var$charCodeAt(digits, index);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};
var $40e42aded55b3a43$var$FORCED = $0fb365768ae0f3c7$exports($40e42aded55b3a43$var$NUMBER, !$40e42aded55b3a43$var$NativeNumber(" 0o1") || !$40e42aded55b3a43$var$NativeNumber("0b1") || $40e42aded55b3a43$var$NativeNumber("+0x1"));
var $40e42aded55b3a43$var$calledWithNew = function calledWithNew(dummy) {
    // includes check on 1..constructor(foo) case
    return $372efcd1340d8495$exports($40e42aded55b3a43$var$NumberPrototype, dummy) && $7bdc373729e45e27$exports(function() {
        $3031ee9dcea937be$exports(dummy);
    });
};
// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var $40e42aded55b3a43$var$NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : $40e42aded55b3a43$var$NativeNumber($40e42aded55b3a43$var$toNumeric(value));
    return $40e42aded55b3a43$var$calledWithNew(this) ? $f6721401d0718c1d$exports(Object(n), this, $40e42aded55b3a43$var$NumberWrapper) : n;
};
$40e42aded55b3a43$var$NumberWrapper.prototype = $40e42aded55b3a43$var$NumberPrototype;
if ($40e42aded55b3a43$var$FORCED && !$bad8555d514b807c$exports) $40e42aded55b3a43$var$NumberPrototype.constructor = $40e42aded55b3a43$var$NumberWrapper;
$d4b8e88525a1c695$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $40e42aded55b3a43$var$FORCED
}, {
    Number: $40e42aded55b3a43$var$NumberWrapper
});
// Use `internal/copy-constructor-properties` helper in `core-js@4`
var $40e42aded55b3a43$var$copyConstructorProperties = function copyConstructorProperties(target, source) {
    for(var keys = $40260b59b65c2e4c$exports ? $40e42aded55b3a43$require$getOwnPropertyNames(source) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), j = 0, key; keys.length > j; j++)if ($5f4f8ca39500aba6$exports(source, key = keys[j]) && !$5f4f8ca39500aba6$exports(target, key)) $40e42aded55b3a43$require$defineProperty(target, key, $40e42aded55b3a43$require$getOwnPropertyDescriptor(source, key));
};
if ($bad8555d514b807c$exports && $40e42aded55b3a43$var$PureNumberNamespace) $40e42aded55b3a43$var$copyConstructorProperties($0a6d052471fbbec7$exports[$40e42aded55b3a43$var$NUMBER], $40e42aded55b3a43$var$PureNumberNamespace);
if ($40e42aded55b3a43$var$FORCED || $bad8555d514b807c$exports) $40e42aded55b3a43$var$copyConstructorProperties($0a6d052471fbbec7$exports[$40e42aded55b3a43$var$NUMBER], $40e42aded55b3a43$var$NativeNumber);


"use strict";

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$d4b8e88525a1c695$exports({
    target: "Number",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    EPSILON: Math.pow(2, -52)
});


"use strict";

var $2097e9bcd7fdf3ba$exports = {};
"use strict";

var $2097e9bcd7fdf3ba$var$globalIsFinite = $0f4ea948f6673103$exports.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
$2097e9bcd7fdf3ba$exports = Number.isFinite || function isFinite(it) {
    return typeof it == "number" && $2097e9bcd7fdf3ba$var$globalIsFinite(it);
};


// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$d4b8e88525a1c695$exports({
    target: "Number",
    stat: true
}, {
    isFinite: $2097e9bcd7fdf3ba$exports
});


"use strict";

var $9827a05bcaa934cf$exports = {};
"use strict";

var $9827a05bcaa934cf$var$floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
$9827a05bcaa934cf$exports = Number.isInteger || function isInteger(it) {
    return !$b1a75f6ed3e2d50f$exports(it) && isFinite(it) && $9827a05bcaa934cf$var$floor(it) === it;
};


// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$d4b8e88525a1c695$exports({
    target: "Number",
    stat: true
}, {
    isInteger: $9827a05bcaa934cf$exports
});


"use strict";

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$d4b8e88525a1c695$exports({
    target: "Number",
    stat: true
}, {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare -- NaN check
        return number !== number;
    }
});


"use strict";


var $3b1e109fc4ebe20e$var$abs = Math.abs;
// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$d4b8e88525a1c695$exports({
    target: "Number",
    stat: true
}, {
    isSafeInteger: function isSafeInteger(number) {
        return $9827a05bcaa934cf$exports(number) && $3b1e109fc4ebe20e$var$abs(number) <= 0x1FFFFFFFFFFFFF;
    }
});


"use strict";

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$d4b8e88525a1c695$exports({
    target: "Number",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


"use strict";

// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$d4b8e88525a1c695$exports({
    target: "Number",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MIN_SAFE_INTEGER: -9007199254740991
});


"use strict";

var $ce92a5c9a152a953$exports = {};
"use strict";





var $ce92a5c9a152a953$require$trim = $0da89d3a7f6e5b50$exports.trim;

var $ce92a5c9a152a953$var$charAt = $23a00ee3e029ff58$exports("".charAt);
var $ce92a5c9a152a953$var$$parseFloat = $0f4ea948f6673103$exports.parseFloat;
var $ce92a5c9a152a953$var$Symbol = $0f4ea948f6673103$exports.Symbol;
var $ce92a5c9a152a953$var$ITERATOR = $ce92a5c9a152a953$var$Symbol && $ce92a5c9a152a953$var$Symbol.iterator;
var $ce92a5c9a152a953$var$FORCED = 1 / $ce92a5c9a152a953$var$$parseFloat($ce3283842b942e24$exports + "-0") !== -Infinity || $ce92a5c9a152a953$var$ITERATOR && !$7bdc373729e45e27$exports(function() {
    $ce92a5c9a152a953$var$$parseFloat(Object($ce92a5c9a152a953$var$ITERATOR));
});
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$ce92a5c9a152a953$exports = $ce92a5c9a152a953$var$FORCED ? function parseFloat(string) {
    var trimmedString = $ce92a5c9a152a953$require$trim($dd666817fb19c24c$exports(string));
    var result = $ce92a5c9a152a953$var$$parseFloat(trimmedString);
    return result === 0 && $ce92a5c9a152a953$var$charAt(trimmedString, 0) === "-" ? -0 : result;
} : $ce92a5c9a152a953$var$$parseFloat;


// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$d4b8e88525a1c695$exports({
    target: "Number",
    stat: true,
    forced: Number.parseFloat !== $ce92a5c9a152a953$exports
}, {
    parseFloat: $ce92a5c9a152a953$exports
});


"use strict";

var $95ce1cde81bdd93c$exports = {};
"use strict";





var $95ce1cde81bdd93c$require$trim = $0da89d3a7f6e5b50$exports.trim;

var $95ce1cde81bdd93c$var$$parseInt = $0f4ea948f6673103$exports.parseInt;
var $95ce1cde81bdd93c$var$Symbol = $0f4ea948f6673103$exports.Symbol;
var $95ce1cde81bdd93c$var$ITERATOR = $95ce1cde81bdd93c$var$Symbol && $95ce1cde81bdd93c$var$Symbol.iterator;
var $95ce1cde81bdd93c$var$hex = /^[+-]?0x/i;
var $95ce1cde81bdd93c$var$exec = $23a00ee3e029ff58$exports($95ce1cde81bdd93c$var$hex.exec);
var $95ce1cde81bdd93c$var$FORCED = $95ce1cde81bdd93c$var$$parseInt($ce3283842b942e24$exports + "08") !== 8 || $95ce1cde81bdd93c$var$$parseInt($ce3283842b942e24$exports + "0x16") !== 22 || $95ce1cde81bdd93c$var$ITERATOR && !$7bdc373729e45e27$exports(function() {
    $95ce1cde81bdd93c$var$$parseInt(Object($95ce1cde81bdd93c$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$95ce1cde81bdd93c$exports = $95ce1cde81bdd93c$var$FORCED ? function parseInt(string, radix) {
    var S = $95ce1cde81bdd93c$require$trim($dd666817fb19c24c$exports(string));
    return $95ce1cde81bdd93c$var$$parseInt(S, radix >>> 0 || ($95ce1cde81bdd93c$var$exec($95ce1cde81bdd93c$var$hex, S) ? 16 : 10));
} : $95ce1cde81bdd93c$var$$parseInt;


// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$d4b8e88525a1c695$exports({
    target: "Number",
    stat: true,
    forced: Number.parseInt !== $95ce1cde81bdd93c$exports
}, {
    parseInt: $95ce1cde81bdd93c$exports
});


"use strict";




var $cee4247e238a4af5$exports = {};
"use strict";



var $cee4247e238a4af5$var$$RangeError = RangeError;
// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$cee4247e238a4af5$exports = function repeat(count) {
    var str = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports(this));
    var result = "";
    var n = $5e45f07a290dfff0$exports(count);
    if (n < 0 || n === Infinity) throw new $cee4247e238a4af5$var$$RangeError("Wrong number of repetitions");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
    return result;
};



var $85a3d1b1e7001ca6$var$$RangeError = RangeError;
var $85a3d1b1e7001ca6$var$$String = String;
var $85a3d1b1e7001ca6$var$floor = Math.floor;
var $85a3d1b1e7001ca6$var$repeat = $23a00ee3e029ff58$exports($cee4247e238a4af5$exports);
var $85a3d1b1e7001ca6$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $85a3d1b1e7001ca6$var$nativeToFixed = $23a00ee3e029ff58$exports(1.0.toFixed);
var $85a3d1b1e7001ca6$var$pow = function pow1(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $85a3d1b1e7001ca6$var$pow(x, n - 1, acc * x) : $85a3d1b1e7001ca6$var$pow(x * x, n / 2, acc);
};
var $85a3d1b1e7001ca6$var$log = function log(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};
var $85a3d1b1e7001ca6$var$multiply = function multiply(data, n, c) {
    var index = -1;
    var c2 = c;
    while(++index < 6){
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = $85a3d1b1e7001ca6$var$floor(c2 / 1e7);
    }
};
var $85a3d1b1e7001ca6$var$divide = function divide(data, n) {
    var index = 6;
    var c = 0;
    while(--index >= 0){
        c += data[index];
        data[index] = $85a3d1b1e7001ca6$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $85a3d1b1e7001ca6$var$dataToString = function dataToString(data) {
    var index = 6;
    var s = "";
    while(--index >= 0)if (s !== "" || index === 0 || data[index] !== 0) {
        var t = $85a3d1b1e7001ca6$var$$String(data[index]);
        s = s === "" ? t : s + $85a3d1b1e7001ca6$var$repeat("0", 7 - t.length) + t;
    }
    return s;
};
var $85a3d1b1e7001ca6$var$FORCED = $7bdc373729e45e27$exports(function() {
    return $85a3d1b1e7001ca6$var$nativeToFixed(0.00008, 3) !== "0.000" || $85a3d1b1e7001ca6$var$nativeToFixed(0.9, 0) !== "1" || $85a3d1b1e7001ca6$var$nativeToFixed(1.255, 2) !== "1.25" || $85a3d1b1e7001ca6$var$nativeToFixed(1000000000000000128.0, 0) !== "1000000000000000128";
}) || !$7bdc373729e45e27$exports(function() {
    // V8 ~ Android 4.3-
    $85a3d1b1e7001ca6$var$nativeToFixed({});
});
// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$d4b8e88525a1c695$exports({
    target: "Number",
    proto: true,
    forced: $85a3d1b1e7001ca6$var$FORCED
}, {
    toFixed: function toFixed(fractionDigits) {
        var number = $3031ee9dcea937be$exports(this);
        var fractDigits = $5e45f07a290dfff0$exports(fractionDigits);
        var data = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var sign = "";
        var result = "0";
        var e, z, j, k;
        // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
        if (fractDigits < 0 || fractDigits > 20) throw new $85a3d1b1e7001ca6$var$$RangeError("Incorrect fraction digits");
        // eslint-disable-next-line no-self-compare -- NaN check
        if (number !== number) return "NaN";
        if (number <= -1000000000000000000000 || number >= 1e21) return $85a3d1b1e7001ca6$var$$String(number);
        if (number < 0) {
            sign = "-";
            number = -number;
        }
        if (number > 1e-21) {
            e = $85a3d1b1e7001ca6$var$log(number * $85a3d1b1e7001ca6$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? number * $85a3d1b1e7001ca6$var$pow(2, -e, 1) : number / $85a3d1b1e7001ca6$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $85a3d1b1e7001ca6$var$multiply(data, 0, z);
                j = fractDigits;
                while(j >= 7){
                    $85a3d1b1e7001ca6$var$multiply(data, 1e7, 0);
                    j -= 7;
                }
                $85a3d1b1e7001ca6$var$multiply(data, $85a3d1b1e7001ca6$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $85a3d1b1e7001ca6$var$divide(data, 8388608);
                    j -= 23;
                }
                $85a3d1b1e7001ca6$var$divide(data, 1 << j);
                $85a3d1b1e7001ca6$var$multiply(data, 1, 1);
                $85a3d1b1e7001ca6$var$divide(data, 2);
                result = $85a3d1b1e7001ca6$var$dataToString(data);
            } else {
                $85a3d1b1e7001ca6$var$multiply(data, 0, z);
                $85a3d1b1e7001ca6$var$multiply(data, 1 << -e, 0);
                result = $85a3d1b1e7001ca6$var$dataToString(data) + $85a3d1b1e7001ca6$var$repeat("0", fractDigits);
            }
        }
        if (fractDigits > 0) {
            k = result.length;
            result = sign + (k <= fractDigits ? "0." + $85a3d1b1e7001ca6$var$repeat("0", fractDigits - k) + result : $85a3d1b1e7001ca6$var$stringSlice(result, 0, k - fractDigits) + "." + $85a3d1b1e7001ca6$var$stringSlice(result, k - fractDigits));
        } else result = sign + result;
        return result;
    }
});


"use strict";

var $45854d5fd0e8a856$exports = {};
"use strict";









// eslint-disable-next-line es/no-object-assign -- safe
var $45854d5fd0e8a856$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $45854d5fd0e8a856$var$defineProperty = Object.defineProperty;
var $45854d5fd0e8a856$var$concat = $23a00ee3e029ff58$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$45854d5fd0e8a856$exports = !$45854d5fd0e8a856$var$$assign || $7bdc373729e45e27$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($40260b59b65c2e4c$exports && $45854d5fd0e8a856$var$$assign({
        b: 1
    }, $45854d5fd0e8a856$var$$assign($45854d5fd0e8a856$var$defineProperty({}, "a", {
        enumerable: true,
        get: function get() {
            $45854d5fd0e8a856$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol("assign detection");
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $45854d5fd0e8a856$var$$assign({}, A)[symbol] !== 7 || $122382a0c203e2f5$exports($45854d5fd0e8a856$var$$assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
    var T = $7d5785aa2fc2b3e1$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $813bfc4ba50d6281$export$2d1720544b23b823;
    var propertyIsEnumerable = $11de82002a093be1$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $20eeb1af973ba55b$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $45854d5fd0e8a856$var$concat($122382a0c203e2f5$exports(S), getOwnPropertySymbols(S)) : $122382a0c203e2f5$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$40260b59b65c2e4c$exports || $4b3fe34719193049$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $45854d5fd0e8a856$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $45854d5fd0e8a856$exports
}, {
    assign: $45854d5fd0e8a856$exports
});


"use strict";


var $9b7d53a6c3332ea1$exports = {};
"use strict";




// Forced replacement object prototype accessors methods
$9b7d53a6c3332ea1$exports = $bad8555d514b807c$exports || !$7bdc373729e45e27$exports(function() {
    // This feature detection crashes old WebKit
    // https://github.com/zloirock/core-js/issues/232
    if ($4a1556c357a98552$exports && $4a1556c357a98552$exports < 535) return;
    var key = Math.random();
    // In FF throws only define methods
    // eslint-disable-next-line no-undef, no-useless-call, es/no-legacy-object-prototype-accessor-methods -- required for testing
    __defineSetter__.call(null, key, function() {});
    delete $0f4ea948f6673103$exports[key];
});





// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if ($40260b59b65c2e4c$exports) $d4b8e88525a1c695$exports({
    target: "Object",
    proto: true,
    forced: $9b7d53a6c3332ea1$exports
}, {
    __defineGetter__: function __defineGetter__(P, getter) {
        $18b1ebdefa97b93b$export$2d1720544b23b823($7d5785aa2fc2b3e1$exports(this), P, {
            get: $8b3f43e1fb85f635$exports(getter),
            enumerable: true,
            configurable: true
        });
    }
});


"use strict";






// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if ($40260b59b65c2e4c$exports) $d4b8e88525a1c695$exports({
    target: "Object",
    proto: true,
    forced: $9b7d53a6c3332ea1$exports
}, {
    __defineSetter__: function __defineSetter__(P, setter) {
        $18b1ebdefa97b93b$export$2d1720544b23b823($7d5785aa2fc2b3e1$exports(this), P, {
            set: $8b3f43e1fb85f635$exports(setter),
            enumerable: true,
            configurable: true
        });
    }
});


"use strict";

var $859f8e9c96ad5a56$exports = {};
"use strict";







var $859f8e9c96ad5a56$require$$propertyIsEnumerable = $11de82002a093be1$export$2d1720544b23b823;
var $859f8e9c96ad5a56$var$propertyIsEnumerable = $23a00ee3e029ff58$exports($859f8e9c96ad5a56$require$$propertyIsEnumerable);
var $859f8e9c96ad5a56$var$push = $23a00ee3e029ff58$exports([].push);
// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var $859f8e9c96ad5a56$var$IE_BUG = $40260b59b65c2e4c$exports && $7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-object-create -- safe
    var O = Object.create(null);
    O[2] = 2;
    return !$859f8e9c96ad5a56$var$propertyIsEnumerable(O, 2);
});
// `Object.{ entries, values }` methods implementation
var $859f8e9c96ad5a56$var$createMethod = function createMethod(TO_ENTRIES) {
    return function(it) {
        var O = $44022b55b2d2b203$exports(it);
        var keys = $122382a0c203e2f5$exports(O);
        var IE_WORKAROUND = $859f8e9c96ad5a56$var$IE_BUG && $7acbb54af94d406d$exports(O) === null;
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$40260b59b65c2e4c$exports || (IE_WORKAROUND ? key in O : $859f8e9c96ad5a56$var$propertyIsEnumerable(O, key))) $859f8e9c96ad5a56$var$push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
$859f8e9c96ad5a56$exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: $859f8e9c96ad5a56$var$createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: $859f8e9c96ad5a56$var$createMethod(false)
};


var $b5c6e3a9cce24a68$require$$entries = $859f8e9c96ad5a56$exports.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true
}, {
    entries: function entries(O) {
        return $b5c6e3a9cce24a68$require$$entries(O);
    }
});


"use strict";





var $59bd1b22aa75cb4f$require$onFreeze = $52aadfc22a57c5ff$exports.onFreeze;
// eslint-disable-next-line es/no-object-freeze -- safe
var $59bd1b22aa75cb4f$var$$freeze = Object.freeze;
var $59bd1b22aa75cb4f$var$FAILS_ON_PRIMITIVES = $7bdc373729e45e27$exports(function() {
    $59bd1b22aa75cb4f$var$$freeze(1);
});
// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $59bd1b22aa75cb4f$var$FAILS_ON_PRIMITIVES,
    sham: !$a00e537c46774c22$exports
}, {
    freeze: function freeze(it) {
        return $59bd1b22aa75cb4f$var$$freeze && $b1a75f6ed3e2d50f$exports(it) ? $59bd1b22aa75cb4f$var$$freeze($59bd1b22aa75cb4f$require$onFreeze(it)) : it;
    }
});


"use strict";



// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        $e8d49b748288eae0$exports(iterable, function(k, v) {
            $2ac89df48719a8b2$exports(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});


"use strict";




var $38411c87c00a958e$require$nativeGetOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;

var $38411c87c00a958e$var$FORCED = !$40260b59b65c2e4c$exports || $7bdc373729e45e27$exports(function() {
    $38411c87c00a958e$require$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $38411c87c00a958e$var$FORCED,
    sham: !$40260b59b65c2e4c$exports
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $38411c87c00a958e$require$nativeGetOwnPropertyDescriptor($44022b55b2d2b203$exports(it), key);
    }
});


"use strict";






// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    sham: !$40260b59b65c2e4c$exports
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $44022b55b2d2b203$exports(object);
        var getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;
        var keys = $3bb4a02eb78e659e$exports(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) $2ac89df48719a8b2$exports(result, key, descriptor);
        }
        return result;
    }
});


"use strict";



var $a588186874e41fb2$require$getOwnPropertyNames = $310e8a5d08b7fb31$export$2d1720544b23b823;
// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var $a588186874e41fb2$var$FAILS_ON_PRIMITIVES = $7bdc373729e45e27$exports(function() {
    return !Object.getOwnPropertyNames(1);
});
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $a588186874e41fb2$var$FAILS_ON_PRIMITIVES
}, {
    getOwnPropertyNames: $a588186874e41fb2$require$getOwnPropertyNames
});


"use strict";





var $5164b066ab257738$var$FAILS_ON_PRIMITIVES = $7bdc373729e45e27$exports(function() {
    $7acbb54af94d406d$exports(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $5164b066ab257738$var$FAILS_ON_PRIMITIVES,
    sham: !$d3799bfda0fa7a49$exports
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $7acbb54af94d406d$exports($7d5785aa2fc2b3e1$exports(it));
    }
});


"use strict";

var $86e08f15fc72b29d$exports = {};
"use strict";
// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
$86e08f15fc72b29d$exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};


// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true
}, {
    is: $86e08f15fc72b29d$exports
});


"use strict";


// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: Object.isExtensible !== $5d3c3c3ca0439a5a$exports
}, {
    isExtensible: $5d3c3c3ca0439a5a$exports
});


"use strict";





// eslint-disable-next-line es/no-object-isfrozen -- safe
var $b7b6cee8cd26e850$var$$isFrozen = Object.isFrozen;
var $b7b6cee8cd26e850$var$FORCED = $3ceb953d1c0e7a72$exports || $7bdc373729e45e27$exports(function() {
    $b7b6cee8cd26e850$var$$isFrozen(1);
});
// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $b7b6cee8cd26e850$var$FORCED
}, {
    isFrozen: function isFrozen(it) {
        if (!$b1a75f6ed3e2d50f$exports(it)) return true;
        if ($3ceb953d1c0e7a72$exports && $4cba9a2acb4bdb16$exports(it) === "ArrayBuffer") return true;
        return $b7b6cee8cd26e850$var$$isFrozen ? $b7b6cee8cd26e850$var$$isFrozen(it) : false;
    }
});


"use strict";





// eslint-disable-next-line es/no-object-issealed -- safe
var $7d932b08b65f949c$var$$isSealed = Object.isSealed;
var $7d932b08b65f949c$var$FORCED = $3ceb953d1c0e7a72$exports || $7bdc373729e45e27$exports(function() {
    $7d932b08b65f949c$var$$isSealed(1);
});
// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $7d932b08b65f949c$var$FORCED
}, {
    isSealed: function isSealed(it) {
        if (!$b1a75f6ed3e2d50f$exports(it)) return true;
        if ($3ceb953d1c0e7a72$exports && $4cba9a2acb4bdb16$exports(it) === "ArrayBuffer") return true;
        return $7d932b08b65f949c$var$$isSealed ? $7d932b08b65f949c$var$$isSealed(it) : false;
    }
});


"use strict";




var $c7d7201d3830f729$var$FAILS_ON_PRIMITIVES = $7bdc373729e45e27$exports(function() {
    $122382a0c203e2f5$exports(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $c7d7201d3830f729$var$FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return $122382a0c203e2f5$exports($7d5785aa2fc2b3e1$exports(it));
    }
});


"use strict";







var $5e14013dfee3d793$require$getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;
// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if ($40260b59b65c2e4c$exports) $d4b8e88525a1c695$exports({
    target: "Object",
    proto: true,
    forced: $9b7d53a6c3332ea1$exports
}, {
    __lookupGetter__: function __lookupGetter__(P) {
        var O = $7d5785aa2fc2b3e1$exports(this);
        var key = $8bc65e9087e8d1e0$exports(P);
        var desc;
        do {
            if (desc = $5e14013dfee3d793$require$getOwnPropertyDescriptor(O, key)) return desc.get;
        }while (O = $7acbb54af94d406d$exports(O));
    }
});


"use strict";







var $f15067a20da2ab47$require$getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;
// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if ($40260b59b65c2e4c$exports) $d4b8e88525a1c695$exports({
    target: "Object",
    proto: true,
    forced: $9b7d53a6c3332ea1$exports
}, {
    __lookupSetter__: function __lookupSetter__(P) {
        var O = $7d5785aa2fc2b3e1$exports(this);
        var key = $8bc65e9087e8d1e0$exports(P);
        var desc;
        do {
            if (desc = $f15067a20da2ab47$require$getOwnPropertyDescriptor(O, key)) return desc.set;
        }while (O = $7acbb54af94d406d$exports(O));
    }
});


"use strict";



var $a98e0ba74f665112$require$onFreeze = $52aadfc22a57c5ff$exports.onFreeze;


// eslint-disable-next-line es/no-object-preventextensions -- safe
var $a98e0ba74f665112$var$$preventExtensions = Object.preventExtensions;
var $a98e0ba74f665112$var$FAILS_ON_PRIMITIVES = $7bdc373729e45e27$exports(function() {
    $a98e0ba74f665112$var$$preventExtensions(1);
});
// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $a98e0ba74f665112$var$FAILS_ON_PRIMITIVES,
    sham: !$a00e537c46774c22$exports
}, {
    preventExtensions: function preventExtensions(it) {
        return $a98e0ba74f665112$var$$preventExtensions && $b1a75f6ed3e2d50f$exports(it) ? $a98e0ba74f665112$var$$preventExtensions($a98e0ba74f665112$require$onFreeze(it)) : it;
    }
});


"use strict";



var $883f4463eae1304a$require$onFreeze = $52aadfc22a57c5ff$exports.onFreeze;


// eslint-disable-next-line es/no-object-seal -- safe
var $883f4463eae1304a$var$$seal = Object.seal;
var $883f4463eae1304a$var$FAILS_ON_PRIMITIVES = $7bdc373729e45e27$exports(function() {
    $883f4463eae1304a$var$$seal(1);
});
// `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true,
    forced: $883f4463eae1304a$var$FAILS_ON_PRIMITIVES,
    sham: !$a00e537c46774c22$exports
}, {
    seal: function seal(it) {
        return $883f4463eae1304a$var$$seal && $b1a75f6ed3e2d50f$exports(it) ? $883f4463eae1304a$var$$seal($883f4463eae1304a$require$onFreeze(it)) : it;
    }
});


"use strict";


var $121fec7ceff8e52f$exports = {};
"use strict";


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$121fec7ceff8e52f$exports = $9b7720140eeedd4d$exports ? ({}).toString : function toString() {
    return "[object " + $19a284f0ad8e7bd9$exports(this) + "]";
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$9b7720140eeedd4d$exports) $f488b1cc13335fff$exports(Object.prototype, "toString", $121fec7ceff8e52f$exports, {
    unsafe: true
});


"use strict";


var $bfc064c16ec8b91a$require$$values = $859f8e9c96ad5a56$exports.values;
// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$d4b8e88525a1c695$exports({
    target: "Object",
    stat: true
}, {
    values: function values(O) {
        return $bfc064c16ec8b91a$require$$values(O);
    }
});


"use strict";


// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$d4b8e88525a1c695$exports({
    global: true,
    forced: parseFloat !== $ce92a5c9a152a953$exports
}, {
    parseFloat: $ce92a5c9a152a953$exports
});


"use strict";


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$d4b8e88525a1c695$exports({
    global: true,
    forced: parseInt !== $95ce1cde81bdd93c$exports
}, {
    parseInt: $95ce1cde81bdd93c$exports
});


"use strict";
"use strict";














var $b547defd499f8b78$exports = {};
"use strict";









var $9a0959ea981d3a43$exports = {};
"use strict";
var $9a0959ea981d3a43$var$$TypeError = TypeError;
$9a0959ea981d3a43$exports = function(passed, required) {
    if (passed < required) throw new $9a0959ea981d3a43$var$$TypeError("Not enough arguments");
    return passed;
};


var $a59b5a6b4eb6e159$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$a59b5a6b4eb6e159$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($4e05041f80099315$exports);



var $b547defd499f8b78$var$set = $0f4ea948f6673103$exports.setImmediate;
var $b547defd499f8b78$var$clear = $0f4ea948f6673103$exports.clearImmediate;
var $b547defd499f8b78$var$process = $0f4ea948f6673103$exports.process;
var $b547defd499f8b78$var$Dispatch = $0f4ea948f6673103$exports.Dispatch;
var $b547defd499f8b78$var$Function = $0f4ea948f6673103$exports.Function;
var $b547defd499f8b78$var$MessageChannel = $0f4ea948f6673103$exports.MessageChannel;
var $b547defd499f8b78$var$String = $0f4ea948f6673103$exports.String;
var $b547defd499f8b78$var$counter = 0;
var $b547defd499f8b78$var$queue = {};
var $b547defd499f8b78$var$ONREADYSTATECHANGE = "onreadystatechange";
var $b547defd499f8b78$var$$location, $b547defd499f8b78$var$defer, $b547defd499f8b78$var$channel, $b547defd499f8b78$var$port;
$7bdc373729e45e27$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $b547defd499f8b78$var$$location = $0f4ea948f6673103$exports.location;
});
var $b547defd499f8b78$var$run = function run(id) {
    if ($5f4f8ca39500aba6$exports($b547defd499f8b78$var$queue, id)) {
        var fn = $b547defd499f8b78$var$queue[id];
        delete $b547defd499f8b78$var$queue[id];
        fn();
    }
};
var $b547defd499f8b78$var$runner = function runner(id) {
    return function() {
        $b547defd499f8b78$var$run(id);
    };
};
var $b547defd499f8b78$var$eventListener = function eventListener(event) {
    $b547defd499f8b78$var$run(event.data);
};
var $b547defd499f8b78$var$globalPostMessageDefer = function globalPostMessageDefer(id) {
    // old engines have not location.origin
    $0f4ea948f6673103$exports.postMessage($b547defd499f8b78$var$String(id), $b547defd499f8b78$var$$location.protocol + "//" + $b547defd499f8b78$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$b547defd499f8b78$var$set || !$b547defd499f8b78$var$clear) {
    $b547defd499f8b78$var$set = function setImmediate(handler) {
        $9a0959ea981d3a43$exports(arguments.length, 1);
        var fn = $64c802885f841370$exports(handler) ? handler : $b547defd499f8b78$var$Function(handler);
        var args = $043da047ce6f37e9$exports(arguments, 1);
        $b547defd499f8b78$var$queue[++$b547defd499f8b78$var$counter] = function() {
            $f275acb1973d253b$exports(fn, undefined, args);
        };
        $b547defd499f8b78$var$defer($b547defd499f8b78$var$counter);
        return $b547defd499f8b78$var$counter;
    };
    $b547defd499f8b78$var$clear = function clearImmediate(id) {
        delete $b547defd499f8b78$var$queue[id];
    };
    // Node.js 0.8-
    if ($02bca89736833817$exports) $b547defd499f8b78$var$defer = function defer(id) {
        $b547defd499f8b78$var$process.nextTick($b547defd499f8b78$var$runner(id));
    };
    else if ($b547defd499f8b78$var$Dispatch && $b547defd499f8b78$var$Dispatch.now) $b547defd499f8b78$var$defer = function defer(id) {
        $b547defd499f8b78$var$Dispatch.now($b547defd499f8b78$var$runner(id));
    };
    else if ($b547defd499f8b78$var$MessageChannel && !$a59b5a6b4eb6e159$exports) {
        $b547defd499f8b78$var$channel = new $b547defd499f8b78$var$MessageChannel();
        $b547defd499f8b78$var$port = $b547defd499f8b78$var$channel.port2;
        $b547defd499f8b78$var$channel.port1.onmessage = $b547defd499f8b78$var$eventListener;
        $b547defd499f8b78$var$defer = $042f91ff50d30f11$exports($b547defd499f8b78$var$port.postMessage, $b547defd499f8b78$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($0f4ea948f6673103$exports.addEventListener && $64c802885f841370$exports($0f4ea948f6673103$exports.postMessage) && !$0f4ea948f6673103$exports.importScripts && $b547defd499f8b78$var$$location && $b547defd499f8b78$var$$location.protocol !== "file:" && !$7bdc373729e45e27$exports($b547defd499f8b78$var$globalPostMessageDefer)) {
        $b547defd499f8b78$var$defer = $b547defd499f8b78$var$globalPostMessageDefer;
        $0f4ea948f6673103$exports.addEventListener("message", $b547defd499f8b78$var$eventListener, false);
    // IE8-
    } else if ($b547defd499f8b78$var$ONREADYSTATECHANGE in $ef80f2f49f1eda1a$exports("script")) $b547defd499f8b78$var$defer = function defer(id) {
        $77a46ce9205fbe16$exports.appendChild($ef80f2f49f1eda1a$exports("script"))[$b547defd499f8b78$var$ONREADYSTATECHANGE] = function() {
            $77a46ce9205fbe16$exports.removeChild(this);
            $b547defd499f8b78$var$run(id);
        };
    };
    else $b547defd499f8b78$var$defer = function defer(id) {
        setTimeout($b547defd499f8b78$var$runner(id), 0);
    };
}
$b547defd499f8b78$exports = {
    set: $b547defd499f8b78$var$set,
    clear: $b547defd499f8b78$var$clear
};


var $53db9b954a14b04b$require$task = $b547defd499f8b78$exports.set;
var $6016ed5092740f73$exports = {};
"use strict";



var $6016ed5092740f73$require$getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;

var $6016ed5092740f73$require$macrotask = $b547defd499f8b78$exports.set;
var $65ec5127247a2b3f$exports = {};
"use strict";
var $65ec5127247a2b3f$var$Queue = function Queue() {
    this.head = null;
    this.tail = null;
};
$65ec5127247a2b3f$var$Queue.prototype = {
    add: function add(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function get() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
$65ec5127247a2b3f$exports = $65ec5127247a2b3f$var$Queue;



var $bd03ee8d089efe96$exports = {};
"use strict";

$bd03ee8d089efe96$exports = /ipad|iphone|ipod/i.test($4e05041f80099315$exports) && typeof Pebble != "undefined";


var $c456d09787d16d38$exports = {};
"use strict";

$c456d09787d16d38$exports = /web0s(?!.*chrome)/i.test($4e05041f80099315$exports);



var $6016ed5092740f73$var$MutationObserver = $0f4ea948f6673103$exports.MutationObserver || $0f4ea948f6673103$exports.WebKitMutationObserver;
var $6016ed5092740f73$var$document = $0f4ea948f6673103$exports.document;
var $6016ed5092740f73$var$process = $0f4ea948f6673103$exports.process;
var $6016ed5092740f73$var$Promise = $0f4ea948f6673103$exports.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $6016ed5092740f73$var$queueMicrotaskDescriptor = $6016ed5092740f73$require$getOwnPropertyDescriptor($0f4ea948f6673103$exports, "queueMicrotask");
var $6016ed5092740f73$var$microtask = $6016ed5092740f73$var$queueMicrotaskDescriptor && $6016ed5092740f73$var$queueMicrotaskDescriptor.value;
var $6016ed5092740f73$var$notify, $6016ed5092740f73$var$toggle, $6016ed5092740f73$var$node, $6016ed5092740f73$var$promise, $6016ed5092740f73$var$then;
// modern engines have queueMicrotask method
if (!$6016ed5092740f73$var$microtask) {
    var $6016ed5092740f73$var$queue = new $65ec5127247a2b3f$exports();
    var $6016ed5092740f73$var$flush = function flush() {
        var parent, fn;
        if ($02bca89736833817$exports && (parent = $6016ed5092740f73$var$process.domain)) parent.exit();
        while(fn = $6016ed5092740f73$var$queue.get())try {
            fn();
        } catch (error) {
            if ($6016ed5092740f73$var$queue.head) $6016ed5092740f73$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$a59b5a6b4eb6e159$exports && !$02bca89736833817$exports && !$c456d09787d16d38$exports && $6016ed5092740f73$var$MutationObserver && $6016ed5092740f73$var$document) {
        $6016ed5092740f73$var$toggle = true;
        $6016ed5092740f73$var$node = $6016ed5092740f73$var$document.createTextNode("");
        new $6016ed5092740f73$var$MutationObserver($6016ed5092740f73$var$flush).observe($6016ed5092740f73$var$node, {
            characterData: true
        });
        $6016ed5092740f73$var$notify = function notify() {
            $6016ed5092740f73$var$node.data = $6016ed5092740f73$var$toggle = !$6016ed5092740f73$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$bd03ee8d089efe96$exports && $6016ed5092740f73$var$Promise && $6016ed5092740f73$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $6016ed5092740f73$var$promise = $6016ed5092740f73$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $6016ed5092740f73$var$promise.constructor = $6016ed5092740f73$var$Promise;
        $6016ed5092740f73$var$then = $042f91ff50d30f11$exports($6016ed5092740f73$var$promise.then, $6016ed5092740f73$var$promise);
        $6016ed5092740f73$var$notify = function notify() {
            $6016ed5092740f73$var$then($6016ed5092740f73$var$flush);
        };
    // Node.js without promises
    } else if ($02bca89736833817$exports) $6016ed5092740f73$var$notify = function notify() {
        $6016ed5092740f73$var$process.nextTick($6016ed5092740f73$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $6016ed5092740f73$require$macrotask = $042f91ff50d30f11$exports($6016ed5092740f73$require$macrotask, $0f4ea948f6673103$exports);
        $6016ed5092740f73$var$notify = function notify() {
            $6016ed5092740f73$require$macrotask($6016ed5092740f73$var$flush);
        };
    }
    $6016ed5092740f73$var$microtask = function microtask(fn) {
        if (!$6016ed5092740f73$var$queue.head) $6016ed5092740f73$var$notify();
        $6016ed5092740f73$var$queue.add(fn);
    };
}
$6016ed5092740f73$exports = $6016ed5092740f73$var$microtask;


var $8c3369336581d2e5$exports = {};
"use strict";
$8c3369336581d2e5$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};


var $fc39ffc6386506f8$exports = {};
"use strict";
$fc39ffc6386506f8$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};




var $f62f8966ccd2c9c9$exports = {};
"use strict";

$f62f8966ccd2c9c9$exports = $0f4ea948f6673103$exports.Promise;


var $4079b81f74b7ed43$exports = {};
"use strict";






var $665dc9d10d290737$exports = {};
"use strict";
var $5967c3313b9c6ce3$exports = {};
"use strict";
/* global Deno -- Deno case */ $5967c3313b9c6ce3$exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";



$665dc9d10d290737$exports = !$5967c3313b9c6ce3$exports && !$02bca89736833817$exports && typeof window == "object" && typeof document == "object";





var $4079b81f74b7ed43$var$NativePromisePrototype = $f62f8966ccd2c9c9$exports && $f62f8966ccd2c9c9$exports.prototype;
var $4079b81f74b7ed43$var$SPECIES = $6c5fb57dad6dd350$exports("species");
var $4079b81f74b7ed43$var$SUBCLASSING = false;
var $4079b81f74b7ed43$var$NATIVE_PROMISE_REJECTION_EVENT = $64c802885f841370$exports($0f4ea948f6673103$exports.PromiseRejectionEvent);
var $4079b81f74b7ed43$var$FORCED_PROMISE_CONSTRUCTOR = $0fb365768ae0f3c7$exports("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $6b4a072d19c2902d$exports($f62f8966ccd2c9c9$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($f62f8966ccd2c9c9$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $d478a9aa1d363d00$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($bad8555d514b807c$exports && !($4079b81f74b7ed43$var$NativePromisePrototype["catch"] && $4079b81f74b7ed43$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$d478a9aa1d363d00$exports || $d478a9aa1d363d00$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $f62f8966ccd2c9c9$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function FakePromise(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$4079b81f74b7ed43$var$SPECIES] = FakePromise;
        $4079b81f74b7ed43$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$4079b81f74b7ed43$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($665dc9d10d290737$exports || $5967c3313b9c6ce3$exports) && !$4079b81f74b7ed43$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$4079b81f74b7ed43$exports = {
    CONSTRUCTOR: $4079b81f74b7ed43$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $4079b81f74b7ed43$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $4079b81f74b7ed43$var$SUBCLASSING
};


// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $db4cd6ba42994757$export$2d1720544b23b823;
"use strict";

var $db4cd6ba42994757$var$$TypeError = TypeError;
var $db4cd6ba42994757$var$PromiseCapability = function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $db4cd6ba42994757$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $8b3f43e1fb85f635$exports(resolve);
    this.reject = $8b3f43e1fb85f635$exports(reject);
};
$db4cd6ba42994757$export$2d1720544b23b823 = function(C) {
    return new $db4cd6ba42994757$var$PromiseCapability(C);
};


var $53db9b954a14b04b$var$PROMISE = "Promise";
var $53db9b954a14b04b$var$FORCED_PROMISE_CONSTRUCTOR = $4079b81f74b7ed43$exports.CONSTRUCTOR;
var $53db9b954a14b04b$var$NATIVE_PROMISE_REJECTION_EVENT = $4079b81f74b7ed43$exports.REJECTION_EVENT;
var $53db9b954a14b04b$var$NATIVE_PROMISE_SUBCLASSING = $4079b81f74b7ed43$exports.SUBCLASSING;
var $53db9b954a14b04b$var$getInternalPromiseState = $c70ec777954e7cbe$exports.getterFor($53db9b954a14b04b$var$PROMISE);
var $53db9b954a14b04b$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $53db9b954a14b04b$var$NativePromisePrototype = $f62f8966ccd2c9c9$exports && $f62f8966ccd2c9c9$exports.prototype;
var $53db9b954a14b04b$var$PromiseConstructor = $f62f8966ccd2c9c9$exports;
var $53db9b954a14b04b$var$PromisePrototype = $53db9b954a14b04b$var$NativePromisePrototype;
var $53db9b954a14b04b$var$TypeError = $0f4ea948f6673103$exports.TypeError;
var $53db9b954a14b04b$var$document = $0f4ea948f6673103$exports.document;
var $53db9b954a14b04b$var$process = $0f4ea948f6673103$exports.process;
var $53db9b954a14b04b$var$newPromiseCapability = $db4cd6ba42994757$export$2d1720544b23b823;
var $53db9b954a14b04b$var$newGenericPromiseCapability = $53db9b954a14b04b$var$newPromiseCapability;
var $53db9b954a14b04b$var$DISPATCH_EVENT = !!($53db9b954a14b04b$var$document && $53db9b954a14b04b$var$document.createEvent && $0f4ea948f6673103$exports.dispatchEvent);
var $53db9b954a14b04b$var$UNHANDLED_REJECTION = "unhandledrejection";
var $53db9b954a14b04b$var$REJECTION_HANDLED = "rejectionhandled";
var $53db9b954a14b04b$var$PENDING = 0;
var $53db9b954a14b04b$var$FULFILLED = 1;
var $53db9b954a14b04b$var$REJECTED = 2;
var $53db9b954a14b04b$var$HANDLED = 1;
var $53db9b954a14b04b$var$UNHANDLED = 2;
var $53db9b954a14b04b$var$Internal, $53db9b954a14b04b$var$OwnPromiseCapability, $53db9b954a14b04b$var$PromiseWrapper, $53db9b954a14b04b$var$nativeThen;
// helpers
var $53db9b954a14b04b$var$isThenable = function isThenable(it) {
    var then;
    return $b1a75f6ed3e2d50f$exports(it) && $64c802885f841370$exports(then = it.then) ? then : false;
};
var $53db9b954a14b04b$var$callReaction = function callReaction(reaction, state) {
    var value = state.value;
    var ok = state.state === $53db9b954a14b04b$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $53db9b954a14b04b$var$UNHANDLED) $53db9b954a14b04b$var$onHandleUnhandled(state);
                state.rejection = $53db9b954a14b04b$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $53db9b954a14b04b$var$TypeError("Promise-chain cycle"));
            else if (then = $53db9b954a14b04b$var$isThenable(result)) $4b3fe34719193049$exports(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $53db9b954a14b04b$var$notify = function notify(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $6016ed5092740f73$exports(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$53db9b954a14b04b$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $53db9b954a14b04b$var$onUnhandled(state);
    });
};
var $53db9b954a14b04b$var$dispatchEvent = function dispatchEvent(name, promise, reason) {
    var event, handler;
    if ($53db9b954a14b04b$var$DISPATCH_EVENT) {
        event = $53db9b954a14b04b$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $0f4ea948f6673103$exports.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$53db9b954a14b04b$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $0f4ea948f6673103$exports["on" + name])) handler(event);
    else if (name === $53db9b954a14b04b$var$UNHANDLED_REJECTION) $8c3369336581d2e5$exports("Unhandled promise rejection", reason);
};
var $53db9b954a14b04b$var$onUnhandled = function onUnhandled(state) {
    $4b3fe34719193049$exports($53db9b954a14b04b$require$task, $0f4ea948f6673103$exports, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $53db9b954a14b04b$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $fc39ffc6386506f8$exports(function() {
                if ($02bca89736833817$exports) $53db9b954a14b04b$var$process.emit("unhandledRejection", value, promise);
                else $53db9b954a14b04b$var$dispatchEvent($53db9b954a14b04b$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $02bca89736833817$exports || $53db9b954a14b04b$var$isUnhandled(state) ? $53db9b954a14b04b$var$UNHANDLED : $53db9b954a14b04b$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $53db9b954a14b04b$var$isUnhandled = function isUnhandled(state) {
    return state.rejection !== $53db9b954a14b04b$var$HANDLED && !state.parent;
};
var $53db9b954a14b04b$var$onHandleUnhandled = function onHandleUnhandled(state) {
    $4b3fe34719193049$exports($53db9b954a14b04b$require$task, $0f4ea948f6673103$exports, function() {
        var promise = state.facade;
        if ($02bca89736833817$exports) $53db9b954a14b04b$var$process.emit("rejectionHandled", promise);
        else $53db9b954a14b04b$var$dispatchEvent($53db9b954a14b04b$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $53db9b954a14b04b$var$bind = function bind(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $53db9b954a14b04b$var$internalReject = function internalReject(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $53db9b954a14b04b$var$REJECTED;
    $53db9b954a14b04b$var$notify(state, true);
};
var $53db9b954a14b04b$var$internalResolve = function internalResolve1(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $53db9b954a14b04b$var$TypeError("Promise can't be resolved itself");
        var then = $53db9b954a14b04b$var$isThenable(value);
        if (then) $6016ed5092740f73$exports(function() {
            var wrapper = {
                done: false
            };
            try {
                $4b3fe34719193049$exports(then, value, $53db9b954a14b04b$var$bind($53db9b954a14b04b$var$internalResolve, wrapper, state), $53db9b954a14b04b$var$bind($53db9b954a14b04b$var$internalReject, wrapper, state));
            } catch (error) {
                $53db9b954a14b04b$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $53db9b954a14b04b$var$FULFILLED;
            $53db9b954a14b04b$var$notify(state, false);
        }
    } catch (error) {
        $53db9b954a14b04b$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($53db9b954a14b04b$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $53db9b954a14b04b$var$PromiseConstructor = function Promise(executor) {
        $cf50221949c767d8$exports(this, $53db9b954a14b04b$var$PromisePrototype);
        $8b3f43e1fb85f635$exports(executor);
        $4b3fe34719193049$exports($53db9b954a14b04b$var$Internal, this);
        var state = $53db9b954a14b04b$var$getInternalPromiseState(this);
        try {
            executor($53db9b954a14b04b$var$bind($53db9b954a14b04b$var$internalResolve, state), $53db9b954a14b04b$var$bind($53db9b954a14b04b$var$internalReject, state));
        } catch (error) {
            $53db9b954a14b04b$var$internalReject(state, error);
        }
    };
    $53db9b954a14b04b$var$PromisePrototype = $53db9b954a14b04b$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $53db9b954a14b04b$var$Internal = function Promise(executor) {
        $53db9b954a14b04b$var$setInternalState(this, {
            type: $53db9b954a14b04b$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $65ec5127247a2b3f$exports(),
            rejection: false,
            state: $53db9b954a14b04b$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $53db9b954a14b04b$var$Internal.prototype = $f488b1cc13335fff$exports($53db9b954a14b04b$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $53db9b954a14b04b$var$getInternalPromiseState(this);
        var reaction = $53db9b954a14b04b$var$newPromiseCapability($11472182d06f3dc1$exports(this, $53db9b954a14b04b$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $64c802885f841370$exports(onFulfilled) ? onFulfilled : true;
        reaction.fail = $64c802885f841370$exports(onRejected) && onRejected;
        reaction.domain = $02bca89736833817$exports ? $53db9b954a14b04b$var$process.domain : undefined;
        if (state.state === $53db9b954a14b04b$var$PENDING) state.reactions.add(reaction);
        else $6016ed5092740f73$exports(function() {
            $53db9b954a14b04b$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $53db9b954a14b04b$var$OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new $53db9b954a14b04b$var$Internal();
        var state = $53db9b954a14b04b$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $53db9b954a14b04b$var$bind($53db9b954a14b04b$var$internalResolve, state);
        this.reject = $53db9b954a14b04b$var$bind($53db9b954a14b04b$var$internalReject, state);
    };
    $db4cd6ba42994757$export$2d1720544b23b823 = $53db9b954a14b04b$var$newPromiseCapability = function newPromiseCapability(C) {
        return C === $53db9b954a14b04b$var$PromiseConstructor || C === $53db9b954a14b04b$var$PromiseWrapper ? new $53db9b954a14b04b$var$OwnPromiseCapability(C) : $53db9b954a14b04b$var$newGenericPromiseCapability(C);
    };
    if (!$bad8555d514b807c$exports && $64c802885f841370$exports($f62f8966ccd2c9c9$exports) && $53db9b954a14b04b$var$NativePromisePrototype !== Object.prototype) {
        $53db9b954a14b04b$var$nativeThen = $53db9b954a14b04b$var$NativePromisePrototype.then;
        if (!$53db9b954a14b04b$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $f488b1cc13335fff$exports($53db9b954a14b04b$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $53db9b954a14b04b$var$PromiseConstructor(function(resolve, reject) {
                $4b3fe34719193049$exports($53db9b954a14b04b$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $53db9b954a14b04b$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($5f3130f6ca40c617$exports) $5f3130f6ca40c617$exports($53db9b954a14b04b$var$NativePromisePrototype, $53db9b954a14b04b$var$PromisePrototype);
    }
}
$d4b8e88525a1c695$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $53db9b954a14b04b$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $53db9b954a14b04b$var$PromiseConstructor
});
$0590ceb3c9c577a7$exports($53db9b954a14b04b$var$PromiseConstructor, $53db9b954a14b04b$var$PROMISE, false, true);
$d28e0c47aa6e7b5c$exports($53db9b954a14b04b$var$PROMISE);


"use strict";






var $d07ed8fcc8e17df7$exports = {};
"use strict";



var $d07ed8fcc8e17df7$require$FORCED_PROMISE_CONSTRUCTOR = $4079b81f74b7ed43$exports.CONSTRUCTOR;
$d07ed8fcc8e17df7$exports = $d07ed8fcc8e17df7$require$FORCED_PROMISE_CONSTRUCTOR || !$14b7679ddc3bba0f$exports(function(iterable) {
    $f62f8966ccd2c9c9$exports.all(iterable).then(undefined, function() {});
});


// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$d4b8e88525a1c695$exports({
    target: "Promise",
    stat: true,
    forced: $d07ed8fcc8e17df7$exports
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $db4cd6ba42994757$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $fc39ffc6386506f8$exports(function() {
            var $promiseResolve = $8b3f43e1fb85f635$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $e8d49b748288eae0$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $4b3fe34719193049$exports($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";



var $887db65cb7ae02d2$require$FORCED_PROMISE_CONSTRUCTOR = $4079b81f74b7ed43$exports.CONSTRUCTOR;




var $887db65cb7ae02d2$var$NativePromisePrototype = $f62f8966ccd2c9c9$exports && $f62f8966ccd2c9c9$exports.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$d4b8e88525a1c695$exports({
    target: "Promise",
    proto: true,
    forced: $887db65cb7ae02d2$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$bad8555d514b807c$exports && $64c802885f841370$exports($f62f8966ccd2c9c9$exports)) {
    var $887db65cb7ae02d2$var$method = $db85f9884fa161d0$exports("Promise").prototype["catch"];
    if ($887db65cb7ae02d2$var$NativePromisePrototype["catch"] !== $887db65cb7ae02d2$var$method) $f488b1cc13335fff$exports($887db65cb7ae02d2$var$NativePromisePrototype, "catch", $887db65cb7ae02d2$var$method, {
        unsafe: true
    });
}


"use strict";







// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$d4b8e88525a1c695$exports({
    target: "Promise",
    stat: true,
    forced: $d07ed8fcc8e17df7$exports
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $db4cd6ba42994757$export$2d1720544b23b823(C);
        var reject = capability.reject;
        var result = $fc39ffc6386506f8$exports(function() {
            var $promiseResolve = $8b3f43e1fb85f635$exports(C.resolve);
            $e8d49b748288eae0$exports(iterable, function(promise) {
                $4b3fe34719193049$exports($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";




var $e5df097ba7a5f3cd$require$FORCED_PROMISE_CONSTRUCTOR = $4079b81f74b7ed43$exports.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$d4b8e88525a1c695$exports({
    target: "Promise",
    stat: true,
    forced: $e5df097ba7a5f3cd$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $db4cd6ba42994757$export$2d1720544b23b823(this);
        $4b3fe34719193049$exports(capability.reject, undefined, r);
        return capability.promise;
    }
});


"use strict";





var $b9d080140287d636$require$FORCED_PROMISE_CONSTRUCTOR = $4079b81f74b7ed43$exports.CONSTRUCTOR;
var $517db387fb445d5d$exports = {};
"use strict";



$517db387fb445d5d$exports = function(C, x) {
    $c894fc907eeec831$exports(C);
    if ($b1a75f6ed3e2d50f$exports(x) && x.constructor === C) return x;
    var promiseCapability = $db4cd6ba42994757$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $b9d080140287d636$var$PromiseConstructorWrapper = $db85f9884fa161d0$exports("Promise");
var $b9d080140287d636$var$CHECK_WRAPPER = $bad8555d514b807c$exports && !$b9d080140287d636$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$d4b8e88525a1c695$exports({
    target: "Promise",
    stat: true,
    forced: $bad8555d514b807c$exports || $b9d080140287d636$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $517db387fb445d5d$exports($b9d080140287d636$var$CHECK_WRAPPER && this === $b9d080140287d636$var$PromiseConstructorWrapper ? $f62f8966ccd2c9c9$exports : this, x);
    }
});




"use strict";









var $c9ca8f5e757f63f3$var$NativePromisePrototype = $f62f8966ccd2c9c9$exports && $f62f8966ccd2c9c9$exports.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $c9ca8f5e757f63f3$var$NON_GENERIC = !!$f62f8966ccd2c9c9$exports && $7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $c9ca8f5e757f63f3$var$NativePromisePrototype["finally"].call({
        then: function then() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$d4b8e88525a1c695$exports({
    target: "Promise",
    proto: true,
    real: true,
    forced: $c9ca8f5e757f63f3$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $11472182d06f3dc1$exports(this, $db85f9884fa161d0$exports("Promise"));
        var isFunction = $64c802885f841370$exports(onFinally);
        return this.then(isFunction ? function(x) {
            return $517db387fb445d5d$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $517db387fb445d5d$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$bad8555d514b807c$exports && $64c802885f841370$exports($f62f8966ccd2c9c9$exports)) {
    var $c9ca8f5e757f63f3$var$method = $db85f9884fa161d0$exports("Promise").prototype["finally"];
    if ($c9ca8f5e757f63f3$var$NativePromisePrototype["finally"] !== $c9ca8f5e757f63f3$var$method) $f488b1cc13335fff$exports($c9ca8f5e757f63f3$var$NativePromisePrototype, "finally", $c9ca8f5e757f63f3$var$method, {
        unsafe: true
    });
}


"use strict";





// MS Edge argumentsList argument is optional
var $7492e6f70d3f5194$var$OPTIONAL_ARGUMENTS_LIST = !$7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.apply(function() {});
});
// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true,
    forced: $7492e6f70d3f5194$var$OPTIONAL_ARGUMENTS_LIST
}, {
    apply: function apply(target, thisArgument, argumentsList) {
        return $f275acb1973d253b$exports($8b3f43e1fb85f635$exports(target), thisArgument, $c894fc907eeec831$exports(argumentsList));
    }
});


"use strict";



var $87800e4aea6f046a$exports = {};
"use strict";






var $87800e4aea6f046a$var$$Function = Function;
var $87800e4aea6f046a$var$concat = $23a00ee3e029ff58$exports([].concat);
var $87800e4aea6f046a$var$join = $23a00ee3e029ff58$exports([].join);
var $87800e4aea6f046a$var$factories = {};
var $87800e4aea6f046a$var$construct = function construct(C, argsLength, args) {
    if (!$5f4f8ca39500aba6$exports($87800e4aea6f046a$var$factories, argsLength)) {
        var list = [];
        var i = 0;
        for(; i < argsLength; i++)list[i] = "a[" + i + "]";
        $87800e4aea6f046a$var$factories[argsLength] = $87800e4aea6f046a$var$$Function("C,a", "return new C(" + $87800e4aea6f046a$var$join(list, ",") + ")");
    }
    return $87800e4aea6f046a$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$87800e4aea6f046a$exports = $e206ebbecedd2bde$exports ? $87800e4aea6f046a$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $8b3f43e1fb85f635$exports(this);
    var Prototype = F.prototype;
    var partArgs = $043da047ce6f37e9$exports(arguments, 1);
    var boundFunction = function bound() {
        var args = $87800e4aea6f046a$var$concat(partArgs, $043da047ce6f37e9$exports(arguments));
        return this instanceof boundFunction ? $87800e4aea6f046a$var$construct(F, args.length, args) : F.apply(that, args);
    };
    if ($b1a75f6ed3e2d50f$exports(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};







var $912e413ca74d1e86$var$nativeConstruct = $db85f9884fa161d0$exports("Reflect", "construct");
var $912e413ca74d1e86$var$ObjectPrototype = Object.prototype;
var $912e413ca74d1e86$var$push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $912e413ca74d1e86$var$NEW_TARGET_BUG = $7bdc373729e45e27$exports(function() {
    function F() {}
    return !($912e413ca74d1e86$var$nativeConstruct(function() {}, [], F) instanceof F);
});
var $912e413ca74d1e86$var$ARGS_BUG = !$7bdc373729e45e27$exports(function() {
    $912e413ca74d1e86$var$nativeConstruct(function() {});
});
var $912e413ca74d1e86$var$FORCED = $912e413ca74d1e86$var$NEW_TARGET_BUG || $912e413ca74d1e86$var$ARGS_BUG;
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true,
    forced: $912e413ca74d1e86$var$FORCED,
    sham: $912e413ca74d1e86$var$FORCED
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        $6e7a3c29f95ae8ae$exports(Target);
        $c894fc907eeec831$exports(args);
        var newTarget = arguments.length < 3 ? Target : $6e7a3c29f95ae8ae$exports(arguments[2]);
        if ($912e413ca74d1e86$var$ARGS_BUG && !$912e413ca74d1e86$var$NEW_TARGET_BUG) return $912e413ca74d1e86$var$nativeConstruct(Target, args, newTarget);
        if (Target === newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $f275acb1973d253b$exports($912e413ca74d1e86$var$push, $args, args);
            return new ($f275acb1973d253b$exports($87800e4aea6f046a$exports, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $9959f3fdced32995$exports($b1a75f6ed3e2d50f$exports(proto) ? proto : $912e413ca74d1e86$var$ObjectPrototype);
        var result = $f275acb1973d253b$exports(Target, instance, args);
        return $b1a75f6ed3e2d50f$exports(result) ? result : instance;
    }
});


"use strict";






// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var $3cda5f332ddbe5e7$var$ERROR_INSTEAD_OF_FALSE = $7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.defineProperty($18b1ebdefa97b93b$export$2d1720544b23b823({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
});
// `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true,
    forced: $3cda5f332ddbe5e7$var$ERROR_INSTEAD_OF_FALSE,
    sham: !$40260b59b65c2e4c$exports
}, {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        $c894fc907eeec831$exports(target);
        var key = $8bc65e9087e8d1e0$exports(propertyKey);
        $c894fc907eeec831$exports(attributes);
        try {
            $18b1ebdefa97b93b$export$2d1720544b23b823(target, key, attributes);
            return true;
        } catch (error) {
            return false;
        }
    }
});


"use strict";



var $8475f9907a141e37$require$getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;
// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true
}, {
    deleteProperty: function deleteProperty(target, propertyKey) {
        var descriptor = $8475f9907a141e37$require$getOwnPropertyDescriptor($c894fc907eeec831$exports(target), propertyKey);
        return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
    }
});


"use strict";




var $7e5793829a106f48$exports = {};
"use strict";

$7e5793829a106f48$exports = function(descriptor) {
    return descriptor !== undefined && ($5f4f8ca39500aba6$exports(descriptor, "value") || $5f4f8ca39500aba6$exports(descriptor, "writable"));
};




// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function $2528108691c10606$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var descriptor, prototype;
    if ($c894fc907eeec831$exports(target) === receiver) return target[propertyKey];
    descriptor = $003023ef435958c5$export$2d1720544b23b823(target, propertyKey);
    if (descriptor) return $7e5793829a106f48$exports(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : $4b3fe34719193049$exports(descriptor.get, receiver);
    if ($b1a75f6ed3e2d50f$exports(prototype = $7acbb54af94d406d$exports(target))) return $2528108691c10606$var$get(prototype, propertyKey, receiver);
}
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true
}, {
    get: $2528108691c10606$var$get
});


"use strict";




// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true,
    sham: !$40260b59b65c2e4c$exports
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return $003023ef435958c5$export$2d1720544b23b823($c894fc907eeec831$exports(target), propertyKey);
    }
});


"use strict";




// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true,
    sham: !$d3799bfda0fa7a49$exports
}, {
    getPrototypeOf: function getPrototypeOf(target) {
        return $7acbb54af94d406d$exports($c894fc907eeec831$exports(target));
    }
});


"use strict";

// `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true
}, {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});


"use strict";



// `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true
}, {
    isExtensible: function isExtensible(target) {
        $c894fc907eeec831$exports(target);
        return $5d3c3c3ca0439a5a$exports(target);
    }
});


"use strict";


// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true
}, {
    ownKeys: $3bb4a02eb78e659e$exports
});


"use strict";




// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true,
    sham: !$a00e537c46774c22$exports
}, {
    preventExtensions: function preventExtensions(target) {
        $c894fc907eeec831$exports(target);
        try {
            var objectPreventExtensions = $db85f9884fa161d0$exports("Object", "preventExtensions");
            if (objectPreventExtensions) objectPreventExtensions(target);
            return true;
        } catch (error) {
            return false;
        }
    }
});


"use strict";










// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function $7556c4996db348cd$var$set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDescriptor = $003023ef435958c5$export$2d1720544b23b823($c894fc907eeec831$exports(target), propertyKey);
    var existingDescriptor, prototype, setter;
    if (!ownDescriptor) {
        if ($b1a75f6ed3e2d50f$exports(prototype = $7acbb54af94d406d$exports(target))) return $7556c4996db348cd$var$set(prototype, propertyKey, V, receiver);
        ownDescriptor = $ca4a4ced04e4a412$exports(0);
    }
    if ($7e5793829a106f48$exports(ownDescriptor)) {
        if (ownDescriptor.writable === false || !$b1a75f6ed3e2d50f$exports(receiver)) return false;
        if (existingDescriptor = $003023ef435958c5$export$2d1720544b23b823(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            $18b1ebdefa97b93b$export$2d1720544b23b823(receiver, propertyKey, existingDescriptor);
        } else $18b1ebdefa97b93b$export$2d1720544b23b823(receiver, propertyKey, $ca4a4ced04e4a412$exports(0, V));
    } else {
        setter = ownDescriptor.set;
        if (setter === undefined) return false;
        $4b3fe34719193049$exports(setter, receiver, V);
    }
    return true;
}
// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var $7556c4996db348cd$var$MS_EDGE_BUG = $7bdc373729e45e27$exports(function() {
    var Constructor = function Constructor() {};
    var object = $18b1ebdefa97b93b$export$2d1720544b23b823(new Constructor(), "a", {
        configurable: true
    });
    // eslint-disable-next-line es/no-reflect -- required for testing
    return Reflect.set(Constructor.prototype, "a", 1, object) !== false;
});
$d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true,
    forced: $7556c4996db348cd$var$MS_EDGE_BUG
}, {
    set: $7556c4996db348cd$var$set
});


"use strict";




// `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof
if ($5f3130f6ca40c617$exports) $d4b8e88525a1c695$exports({
    target: "Reflect",
    stat: true
}, {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        $c894fc907eeec831$exports(target);
        $3d753879cbb1080a$exports(proto);
        try {
            $5f3130f6ca40c617$exports(target, proto);
            return true;
        } catch (error) {
            return false;
        }
    }
});


"use strict";








var $e734d39281313a6c$require$getOwnPropertyNames = $a329b85dee9c6785$export$2d1720544b23b823;

var $ad24a4561be7fb63$exports = {};
"use strict";



var $ad24a4561be7fb63$var$MATCH = $6c5fb57dad6dd350$exports("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
$ad24a4561be7fb63$exports = function(it) {
    var isRegExp;
    return $b1a75f6ed3e2d50f$exports(it) && ((isRegExp = it[$ad24a4561be7fb63$var$MATCH]) !== undefined ? !!isRegExp : $4cba9a2acb4bdb16$exports(it) === "RegExp");
};



var $aa94276429cd93de$exports = {};
"use strict";



var $72a2f0735d0abca9$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$72a2f0735d0abca9$exports = function() {
    var that = $c894fc907eeec831$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};


var $aa94276429cd93de$var$RegExpPrototype = RegExp.prototype;
$aa94276429cd93de$exports = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $aa94276429cd93de$var$RegExpPrototype) && !$5f4f8ca39500aba6$exports(R, "flags") && $372efcd1340d8495$exports($aa94276429cd93de$var$RegExpPrototype, R) ? $4b3fe34719193049$exports($72a2f0735d0abca9$exports, R) : flags;
};


var $e46b75c6a6e3c0bc$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $e46b75c6a6e3c0bc$var$$RegExp = $0f4ea948f6673103$exports.RegExp;
var $e46b75c6a6e3c0bc$var$UNSUPPORTED_Y = $7bdc373729e45e27$exports(function() {
    var re = $e46b75c6a6e3c0bc$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $e46b75c6a6e3c0bc$var$MISSED_STICKY = $e46b75c6a6e3c0bc$var$UNSUPPORTED_Y || $7bdc373729e45e27$exports(function() {
    return !$e46b75c6a6e3c0bc$var$$RegExp("a", "y").sticky;
});
var $e46b75c6a6e3c0bc$var$BROKEN_CARET = $e46b75c6a6e3c0bc$var$UNSUPPORTED_Y || $7bdc373729e45e27$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $e46b75c6a6e3c0bc$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") !== null;
});
$e46b75c6a6e3c0bc$exports = {
    BROKEN_CARET: $e46b75c6a6e3c0bc$var$BROKEN_CARET,
    MISSED_STICKY: $e46b75c6a6e3c0bc$var$MISSED_STICKY,
    UNSUPPORTED_Y: $e46b75c6a6e3c0bc$var$UNSUPPORTED_Y
};


var $c9c328b7c3384d05$exports = {};
"use strict";

var $c9c328b7c3384d05$require$defineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;
$c9c328b7c3384d05$exports = function(Target, Source, key) {
    key in Target || $c9c328b7c3384d05$require$defineProperty(Target, key, {
        configurable: true,
        get: function get() {
            return Source[key];
        },
        set: function set(it) {
            Source[key] = it;
        }
    });
};






var $e734d39281313a6c$require$enforceInternalState = $c70ec777954e7cbe$exports.enforce;


var $446cbc502c1d068b$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $446cbc502c1d068b$var$$RegExp = $0f4ea948f6673103$exports.RegExp;
$446cbc502c1d068b$exports = $7bdc373729e45e27$exports(function() {
    var re = $446cbc502c1d068b$var$$RegExp(".", "s");
    return !(re.dotAll && re.test("\n") && re.flags === "s");
});


var $11009e6e3d6f92f0$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $11009e6e3d6f92f0$var$$RegExp = $0f4ea948f6673103$exports.RegExp;
$11009e6e3d6f92f0$exports = $7bdc373729e45e27$exports(function() {
    var re = $11009e6e3d6f92f0$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});


var $e734d39281313a6c$var$MATCH = $6c5fb57dad6dd350$exports("match");
var $e734d39281313a6c$var$NativeRegExp = $0f4ea948f6673103$exports.RegExp;
var $e734d39281313a6c$var$RegExpPrototype = $e734d39281313a6c$var$NativeRegExp.prototype;
var $e734d39281313a6c$var$SyntaxError = $0f4ea948f6673103$exports.SyntaxError;
var $e734d39281313a6c$var$exec = $23a00ee3e029ff58$exports($e734d39281313a6c$var$RegExpPrototype.exec);
var $e734d39281313a6c$var$charAt = $23a00ee3e029ff58$exports("".charAt);
var $e734d39281313a6c$var$replace = $23a00ee3e029ff58$exports("".replace);
var $e734d39281313a6c$var$stringIndexOf = $23a00ee3e029ff58$exports("".indexOf);
var $e734d39281313a6c$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
// TODO: Use only proper RegExpIdentifierName
var $e734d39281313a6c$var$IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var $e734d39281313a6c$var$re1 = /a/g;
var $e734d39281313a6c$var$re2 = /a/g;
// "new" should create a new object, old webkit bug
var $e734d39281313a6c$var$CORRECT_NEW = new $e734d39281313a6c$var$NativeRegExp($e734d39281313a6c$var$re1) !== $e734d39281313a6c$var$re1;
var $e734d39281313a6c$var$MISSED_STICKY = $e46b75c6a6e3c0bc$exports.MISSED_STICKY;
var $e734d39281313a6c$var$UNSUPPORTED_Y = $e46b75c6a6e3c0bc$exports.UNSUPPORTED_Y;
var $e734d39281313a6c$var$BASE_FORCED = $40260b59b65c2e4c$exports && (!$e734d39281313a6c$var$CORRECT_NEW || $e734d39281313a6c$var$MISSED_STICKY || $446cbc502c1d068b$exports || $11009e6e3d6f92f0$exports || $7bdc373729e45e27$exports(function() {
    $e734d39281313a6c$var$re2[$e734d39281313a6c$var$MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return $e734d39281313a6c$var$NativeRegExp($e734d39281313a6c$var$re1) !== $e734d39281313a6c$var$re1 || $e734d39281313a6c$var$NativeRegExp($e734d39281313a6c$var$re2) === $e734d39281313a6c$var$re2 || String($e734d39281313a6c$var$NativeRegExp($e734d39281313a6c$var$re1, "i")) !== "/a/i";
}));
var $e734d39281313a6c$var$handleDotAll = function handleDotAll(string) {
    var length = string.length;
    var index = 0;
    var result = "";
    var brackets = false;
    var chr;
    for(; index <= length; index++){
        chr = $e734d39281313a6c$var$charAt(string, index);
        if (chr === "\\") {
            result += chr + $e734d39281313a6c$var$charAt(string, ++index);
            continue;
        }
        if (!brackets && chr === ".") result += "[\\s\\S]";
        else {
            if (chr === "[") brackets = true;
            else if (chr === "]") brackets = false;
            result += chr;
        }
    }
    return result;
};
var $e734d39281313a6c$var$handleNCG = function handleNCG(string) {
    var length = string.length;
    var index = 0;
    var result = "";
    var named = [];
    var names = $9959f3fdced32995$exports(null);
    var brackets = false;
    var ncg = false;
    var groupid = 0;
    var groupname = "";
    var chr;
    for(; index <= length; index++){
        chr = $e734d39281313a6c$var$charAt(string, index);
        if (chr === "\\") chr += $e734d39281313a6c$var$charAt(string, ++index);
        else if (chr === "]") brackets = false;
        else if (!brackets) switch(true){
            case chr === "[":
                brackets = true;
                break;
            case chr === "(":
                if ($e734d39281313a6c$var$exec($e734d39281313a6c$var$IS_NCG, $e734d39281313a6c$var$stringSlice(string, index + 1))) {
                    index += 2;
                    ncg = true;
                }
                result += chr;
                groupid++;
                continue;
            case chr === ">" && ncg:
                if (groupname === "" || $5f4f8ca39500aba6$exports(names, groupname)) throw new $e734d39281313a6c$var$SyntaxError("Invalid capture group name");
                names[groupname] = true;
                named[named.length] = [
                    groupname,
                    groupid
                ];
                ncg = false;
                groupname = "";
                continue;
        }
        if (ncg) groupname += chr;
        else result += chr;
    }
    return [
        result,
        named
    ];
};
// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if ($0fb365768ae0f3c7$exports("RegExp", $e734d39281313a6c$var$BASE_FORCED)) {
    var $e734d39281313a6c$var$RegExpWrapper = function RegExp(pattern, flags) {
        var thisIsRegExp = $372efcd1340d8495$exports($e734d39281313a6c$var$RegExpPrototype, this);
        var patternIsRegExp = $ad24a4561be7fb63$exports(pattern);
        var flagsAreUndefined = flags === undefined;
        var groups = [];
        var rawPattern = pattern;
        var rawFlags, dotAll, sticky, handled, result, state;
        if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === $e734d39281313a6c$var$RegExpWrapper) return pattern;
        if (patternIsRegExp || $372efcd1340d8495$exports($e734d39281313a6c$var$RegExpPrototype, pattern)) {
            pattern = pattern.source;
            if (flagsAreUndefined) flags = $aa94276429cd93de$exports(rawPattern);
        }
        pattern = pattern === undefined ? "" : $dd666817fb19c24c$exports(pattern);
        flags = flags === undefined ? "" : $dd666817fb19c24c$exports(flags);
        rawPattern = pattern;
        if ($446cbc502c1d068b$exports && "dotAll" in $e734d39281313a6c$var$re1) {
            dotAll = !!flags && $e734d39281313a6c$var$stringIndexOf(flags, "s") > -1;
            if (dotAll) flags = $e734d39281313a6c$var$replace(flags, /s/g, "");
        }
        rawFlags = flags;
        if ($e734d39281313a6c$var$MISSED_STICKY && "sticky" in $e734d39281313a6c$var$re1) {
            sticky = !!flags && $e734d39281313a6c$var$stringIndexOf(flags, "y") > -1;
            if (sticky && $e734d39281313a6c$var$UNSUPPORTED_Y) flags = $e734d39281313a6c$var$replace(flags, /y/g, "");
        }
        if ($11009e6e3d6f92f0$exports) {
            handled = $e734d39281313a6c$var$handleNCG(pattern);
            pattern = handled[0];
            groups = handled[1];
        }
        result = $f6721401d0718c1d$exports($e734d39281313a6c$var$NativeRegExp(pattern, flags), thisIsRegExp ? this : $e734d39281313a6c$var$RegExpPrototype, $e734d39281313a6c$var$RegExpWrapper);
        if (dotAll || sticky || groups.length) {
            state = $e734d39281313a6c$require$enforceInternalState(result);
            if (dotAll) {
                state.dotAll = true;
                state.raw = $e734d39281313a6c$var$RegExpWrapper($e734d39281313a6c$var$handleDotAll(pattern), rawFlags);
            }
            if (sticky) state.sticky = true;
            if (groups.length) state.groups = groups;
        }
        if (pattern !== rawPattern) try {
            // fails in old engines, but we have no alternatives for unsupported regex syntax
            $4bc121b672cbfd84$exports(result, "source", rawPattern === "" ? "(?:)" : rawPattern);
        } catch (error) {}
        return result;
    };
    for(var $e734d39281313a6c$var$keys = $e734d39281313a6c$require$getOwnPropertyNames($e734d39281313a6c$var$NativeRegExp), $e734d39281313a6c$var$index = 0; $e734d39281313a6c$var$keys.length > $e734d39281313a6c$var$index;)$c9c328b7c3384d05$exports($e734d39281313a6c$var$RegExpWrapper, $e734d39281313a6c$var$NativeRegExp, $e734d39281313a6c$var$keys[$e734d39281313a6c$var$index++]);
    $e734d39281313a6c$var$RegExpPrototype.constructor = $e734d39281313a6c$var$RegExpWrapper;
    $e734d39281313a6c$var$RegExpWrapper.prototype = $e734d39281313a6c$var$RegExpPrototype;
    $f488b1cc13335fff$exports($0f4ea948f6673103$exports, "RegExp", $e734d39281313a6c$var$RegExpWrapper, {
        constructor: true
    });
}
// https://tc39.es/ecma262/#sec-get-regexp-@@species
$d28e0c47aa6e7b5c$exports("RegExp");


"use strict";

var $eb9509d37bda2de2$exports = {};
"use strict";








var $eb9509d37bda2de2$require$getInternalState = $c70ec777954e7cbe$exports.get;


var $eb9509d37bda2de2$var$nativeReplace = $7ecb1b65119c8ef8$exports("native-string-replace", String.prototype.replace);
var $eb9509d37bda2de2$var$nativeExec = RegExp.prototype.exec;
var $eb9509d37bda2de2$var$patchedExec = $eb9509d37bda2de2$var$nativeExec;
var $eb9509d37bda2de2$var$charAt = $23a00ee3e029ff58$exports("".charAt);
var $eb9509d37bda2de2$var$indexOf = $23a00ee3e029ff58$exports("".indexOf);
var $eb9509d37bda2de2$var$replace = $23a00ee3e029ff58$exports("".replace);
var $eb9509d37bda2de2$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $eb9509d37bda2de2$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $4b3fe34719193049$exports($eb9509d37bda2de2$var$nativeExec, re1, "a");
    $4b3fe34719193049$exports($eb9509d37bda2de2$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $eb9509d37bda2de2$var$UNSUPPORTED_Y = $e46b75c6a6e3c0bc$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $eb9509d37bda2de2$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $eb9509d37bda2de2$var$PATCH = $eb9509d37bda2de2$var$UPDATES_LAST_INDEX_WRONG || $eb9509d37bda2de2$var$NPCG_INCLUDED || $eb9509d37bda2de2$var$UNSUPPORTED_Y || $446cbc502c1d068b$exports || $11009e6e3d6f92f0$exports;
if ($eb9509d37bda2de2$var$PATCH) $eb9509d37bda2de2$var$patchedExec = function exec(string) {
    var re = this;
    var state = $eb9509d37bda2de2$require$getInternalState(re);
    var str = $dd666817fb19c24c$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $4b3fe34719193049$exports($eb9509d37bda2de2$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $eb9509d37bda2de2$var$UNSUPPORTED_Y && re.sticky;
    var flags = $4b3fe34719193049$exports($72a2f0735d0abca9$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $eb9509d37bda2de2$var$replace(flags, "y", "");
        if ($eb9509d37bda2de2$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $eb9509d37bda2de2$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $eb9509d37bda2de2$var$charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($eb9509d37bda2de2$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($eb9509d37bda2de2$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $4b3fe34719193049$exports($eb9509d37bda2de2$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $eb9509d37bda2de2$var$stringSlice(match.input, charsAdded);
            match[0] = $eb9509d37bda2de2$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($eb9509d37bda2de2$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($eb9509d37bda2de2$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $4b3fe34719193049$exports($eb9509d37bda2de2$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $9959f3fdced32995$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$eb9509d37bda2de2$exports = $eb9509d37bda2de2$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$d4b8e88525a1c695$exports({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $eb9509d37bda2de2$exports
}, {
    exec: $eb9509d37bda2de2$exports
});


"use strict";





// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $ce2b7f59d703ede8$var$RegExp = $0f4ea948f6673103$exports.RegExp;
var $ce2b7f59d703ede8$var$RegExpPrototype = $ce2b7f59d703ede8$var$RegExp.prototype;
var $ce2b7f59d703ede8$var$FORCED = $40260b59b65c2e4c$exports && $7bdc373729e45e27$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $ce2b7f59d703ede8$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function addGetter(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function get() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($ce2b7f59d703ede8$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($ce2b7f59d703ede8$var$FORCED) $d235cf6ad826c1e5$exports($ce2b7f59d703ede8$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $72a2f0735d0abca9$exports
});


"use strict";

var $c7493bbfaed1707f$require$PROPER_FUNCTION_NAME = $b7b4004231446e90$exports.PROPER;





var $c7493bbfaed1707f$var$TO_STRING = "toString";
var $c7493bbfaed1707f$var$RegExpPrototype = RegExp.prototype;
var $c7493bbfaed1707f$var$nativeToString = $c7493bbfaed1707f$var$RegExpPrototype[$c7493bbfaed1707f$var$TO_STRING];
var $c7493bbfaed1707f$var$NOT_GENERIC = $7bdc373729e45e27$exports(function() {
    return $c7493bbfaed1707f$var$nativeToString.call({
        source: "a",
        flags: "b"
    }) !== "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $c7493bbfaed1707f$var$INCORRECT_NAME = $c7493bbfaed1707f$require$PROPER_FUNCTION_NAME && $c7493bbfaed1707f$var$nativeToString.name !== $c7493bbfaed1707f$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($c7493bbfaed1707f$var$NOT_GENERIC || $c7493bbfaed1707f$var$INCORRECT_NAME) $f488b1cc13335fff$exports(RegExp.prototype, $c7493bbfaed1707f$var$TO_STRING, function toString() {
    var R = $c894fc907eeec831$exports(this);
    var pattern = $dd666817fb19c24c$exports(R.source);
    var flags = $dd666817fb19c24c$exports($aa94276429cd93de$exports(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});


"use strict";
"use strict";


// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
$5d209f01e9f191f6$exports("Set", function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $4f57ba8b05db6015$exports);




"use strict";

var $c1b384f4ceb18d47$exports = {};
"use strict";




var $c1b384f4ceb18d47$var$charAt = $23a00ee3e029ff58$exports("".charAt);
var $c1b384f4ceb18d47$var$charCodeAt = $23a00ee3e029ff58$exports("".charCodeAt);
var $c1b384f4ceb18d47$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $c1b384f4ceb18d47$var$createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports($this));
        var position = $5e45f07a290dfff0$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $c1b384f4ceb18d47$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $c1b384f4ceb18d47$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $c1b384f4ceb18d47$var$charAt(S, position) : first : CONVERT_TO_STRING ? $c1b384f4ceb18d47$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$c1b384f4ceb18d47$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $c1b384f4ceb18d47$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $c1b384f4ceb18d47$var$createMethod(true)
};


var $f9e22c87350897ee$require$codeAt = $c1b384f4ceb18d47$exports.codeAt;
// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true
}, {
    codePointAt: function codePointAt(pos) {
        return $f9e22c87350897ee$require$codeAt(this, pos);
    }
});


"use strict";



var $c0eb9738e9beb952$require$getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;


var $437d4b695bc3efe0$exports = {};
"use strict";

var $437d4b695bc3efe0$var$$TypeError = TypeError;
$437d4b695bc3efe0$exports = function(it) {
    if ($ad24a4561be7fb63$exports(it)) throw new $437d4b695bc3efe0$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};



var $0eb1ee8dd74b064e$exports = {};
"use strict";

var $0eb1ee8dd74b064e$var$MATCH = $6c5fb57dad6dd350$exports("match");
$0eb1ee8dd74b064e$exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$0eb1ee8dd74b064e$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};



// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var $c0eb9738e9beb952$var$nativeEndsWith = $92ca88fbf3cbbcaa$exports("".endsWith);
var $c0eb9738e9beb952$var$slice = $92ca88fbf3cbbcaa$exports("".slice);
var $c0eb9738e9beb952$var$min = Math.min;
var $c0eb9738e9beb952$var$CORRECT_IS_REGEXP_LOGIC = $0eb1ee8dd74b064e$exports("endsWith");
// https://github.com/zloirock/core-js/pull/702
var $c0eb9738e9beb952$var$MDN_POLYFILL_BUG = !$bad8555d514b807c$exports && !$c0eb9738e9beb952$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $c0eb9738e9beb952$require$getOwnPropertyDescriptor(String.prototype, "endsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: !$c0eb9738e9beb952$var$MDN_POLYFILL_BUG && !$c0eb9738e9beb952$var$CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports(this));
        $437d4b695bc3efe0$exports(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : $c0eb9738e9beb952$var$min($8beae9420c83acf0$exports(endPosition), len);
        var search = $dd666817fb19c24c$exports(searchString);
        return $c0eb9738e9beb952$var$nativeEndsWith ? $c0eb9738e9beb952$var$nativeEndsWith(that, search, end) : $c0eb9738e9beb952$var$slice(that, end - search.length, end) === search;
    }
});


"use strict";



var $db5d625936bca02f$var$$RangeError = RangeError;
var $db5d625936bca02f$var$fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $db5d625936bca02f$var$$fromCodePoint = String.fromCodePoint;
var $db5d625936bca02f$var$join = $23a00ee3e029ff58$exports([].join);
// length should be 1, old FF problem
var $db5d625936bca02f$var$INCORRECT_LENGTH = !!$db5d625936bca02f$var$$fromCodePoint && $db5d625936bca02f$var$$fromCodePoint.length !== 1;
// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$d4b8e88525a1c695$exports({
    target: "String",
    stat: true,
    arity: 1,
    forced: $db5d625936bca02f$var$INCORRECT_LENGTH
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function fromCodePoint(x) {
        var elements = [];
        var length = arguments.length;
        var i = 0;
        var code;
        while(length > i){
            code = +arguments[i++];
            if ($4c10e2bcec3cf322$exports(code, 0x10FFFF) !== code) throw new $db5d625936bca02f$var$$RangeError(code + " is not a valid code point");
            elements[i] = code < 0x10000 ? $db5d625936bca02f$var$fromCharCode(code) : $db5d625936bca02f$var$fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
        }
        return $db5d625936bca02f$var$join(elements, "");
    }
});


"use strict";






var $90de11a3a0aac2fd$var$stringIndexOf = $23a00ee3e029ff58$exports("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: !$0eb1ee8dd74b064e$exports("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$90de11a3a0aac2fd$var$stringIndexOf($dd666817fb19c24c$exports($ddbaa5896e5ed636$exports(this)), $dd666817fb19c24c$exports($437d4b695bc3efe0$exports(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";

var $fc6490565cafcc83$require$charAt = $c1b384f4ceb18d47$exports.charAt;




var $fc6490565cafcc83$var$STRING_ITERATOR = "String Iterator";
var $fc6490565cafcc83$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $fc6490565cafcc83$var$getInternalState = $c70ec777954e7cbe$exports.getterFor($fc6490565cafcc83$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$34aff3def5c5238a$exports(String, "String", function(iterated) {
    $fc6490565cafcc83$var$setInternalState(this, {
        type: $fc6490565cafcc83$var$STRING_ITERATOR,
        string: $dd666817fb19c24c$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $fc6490565cafcc83$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $ecc47fe671ebbad0$exports(undefined, true);
    point = $fc6490565cafcc83$require$charAt(string, index);
    state.index += point.length;
    return $ecc47fe671ebbad0$exports(point, false);
});


"use strict";

var $b0b108867e4f4617$exports = {};
"use strict";







var $b0b108867e4f4617$var$SPECIES = $6c5fb57dad6dd350$exports("species");
var $b0b108867e4f4617$var$RegExpPrototype = RegExp.prototype;
$b0b108867e4f4617$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $6c5fb57dad6dd350$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$7bdc373729e45e27$exports(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$7bdc373729e45e27$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$b0b108867e4f4617$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $92ca88fbf3cbbcaa$exports(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $92ca88fbf3cbbcaa$exports(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $eb9509d37bda2de2$exports || $exec === $b0b108867e4f4617$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $f488b1cc13335fff$exports(String.prototype, KEY, methods[0]);
        $f488b1cc13335fff$exports($b0b108867e4f4617$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $4bc121b672cbfd84$exports($b0b108867e4f4617$var$RegExpPrototype[SYMBOL], "sham", true);
};








var $0d93e8e6f857b923$exports = {};
"use strict";

var $0d93e8e6f857b923$require$charAt = $c1b384f4ceb18d47$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$0d93e8e6f857b923$exports = function(S, index, unicode) {
    return index + (unicode ? $0d93e8e6f857b923$require$charAt(S, index).length : 1);
};


var $ffa336a6a4395145$exports = {};
"use strict";





var $ffa336a6a4395145$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$ffa336a6a4395145$exports = function(R, S) {
    var exec = R.exec;
    if ($64c802885f841370$exports(exec)) {
        var result = $4b3fe34719193049$exports(exec, R, S);
        if (result !== null) $c894fc907eeec831$exports(result);
        return result;
    }
    if ($4cba9a2acb4bdb16$exports(R) === "RegExp") return $4b3fe34719193049$exports($eb9509d37bda2de2$exports, R, S);
    throw new $ffa336a6a4395145$var$$TypeError("RegExp#exec called on incompatible receiver");
};


// @@match logic
$b0b108867e4f4617$exports("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $ddbaa5896e5ed636$exports(this);
            var matcher = $76135a25443d684f$exports(regexp) ? undefined : $f29b070ab2fd2ce7$exports(regexp, MATCH);
            return matcher ? $4b3fe34719193049$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($dd666817fb19c24c$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $c894fc907eeec831$exports(this);
            var S = $dd666817fb19c24c$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $ffa336a6a4395145$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $ffa336a6a4395145$exports(rx, S)) !== null){
                var matchStr = $dd666817fb19c24c$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = $0d93e8e6f857b923$exports(S, $8beae9420c83acf0$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


"use strict";

var $93b5bcbc70a6eb27$exports = {};
"use strict";





var $93b5bcbc70a6eb27$var$repeat = $23a00ee3e029ff58$exports($cee4247e238a4af5$exports);
var $93b5bcbc70a6eb27$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $93b5bcbc70a6eb27$var$ceil = Math.ceil;
// `String.prototype.{ padStart, padEnd }` methods implementation
var $93b5bcbc70a6eb27$var$createMethod = function createMethod(IS_END) {
    return function($this, maxLength, fillString) {
        var S = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports($this));
        var intMaxLength = $8beae9420c83acf0$exports(maxLength);
        var stringLength = S.length;
        var fillStr = fillString === undefined ? " " : $dd666817fb19c24c$exports(fillString);
        var fillLen, stringFiller;
        if (intMaxLength <= stringLength || fillStr === "") return S;
        fillLen = intMaxLength - stringLength;
        stringFiller = $93b5bcbc70a6eb27$var$repeat(fillStr, $93b5bcbc70a6eb27$var$ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = $93b5bcbc70a6eb27$var$stringSlice(stringFiller, 0, fillLen);
        return IS_END ? S + stringFiller : stringFiller + S;
    };
};
$93b5bcbc70a6eb27$exports = {
    // `String.prototype.padStart` method
    // https://tc39.es/ecma262/#sec-string.prototype.padstart
    start: $93b5bcbc70a6eb27$var$createMethod(false),
    // `String.prototype.padEnd` method
    // https://tc39.es/ecma262/#sec-string.prototype.padend
    end: $93b5bcbc70a6eb27$var$createMethod(true)
};


var $1a2746a4efa09904$require$$padEnd = $93b5bcbc70a6eb27$exports.end;
var $528f7b0f1da6ee13$exports = {};
"use strict";

$528f7b0f1da6ee13$exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test($4e05041f80099315$exports);


// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $528f7b0f1da6ee13$exports
}, {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $1a2746a4efa09904$require$$padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";


var $ad8ed8a6f967e4d1$require$$padStart = $93b5bcbc70a6eb27$exports.start;

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $528f7b0f1da6ee13$exports
}, {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $ad8ed8a6f967e4d1$require$$padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";






var $e850c309b1c875ff$var$push = $23a00ee3e029ff58$exports([].push);
var $e850c309b1c875ff$var$join = $23a00ee3e029ff58$exports([].join);
// `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw
$d4b8e88525a1c695$exports({
    target: "String",
    stat: true
}, {
    raw: function raw(template) {
        var rawTemplate = $44022b55b2d2b203$exports($7d5785aa2fc2b3e1$exports(template).raw);
        var literalSegments = $027f7f84b95594e7$exports(rawTemplate);
        if (!literalSegments) return "";
        var argumentsLength = arguments.length;
        var elements = [];
        var i = 0;
        while(true){
            $e850c309b1c875ff$var$push(elements, $dd666817fb19c24c$exports(rawTemplate[i++]));
            if (i === literalSegments) return $e850c309b1c875ff$var$join(elements, "");
            if (i < argumentsLength) $e850c309b1c875ff$var$push(elements, $dd666817fb19c24c$exports(arguments[i]));
        }
    }
});


"use strict";


// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true
}, {
    repeat: $cee4247e238a4af5$exports
});


"use strict";














var $be5ce849ce561839$exports = {};
"use strict";


var $be5ce849ce561839$var$floor = Math.floor;
var $be5ce849ce561839$var$charAt = $23a00ee3e029ff58$exports("".charAt);
var $be5ce849ce561839$var$replace = $23a00ee3e029ff58$exports("".replace);
var $be5ce849ce561839$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $be5ce849ce561839$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $be5ce849ce561839$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$be5ce849ce561839$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $be5ce849ce561839$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $7d5785aa2fc2b3e1$exports(namedCaptures);
        symbols = $be5ce849ce561839$var$SUBSTITUTION_SYMBOLS;
    }
    return $be5ce849ce561839$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($be5ce849ce561839$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $be5ce849ce561839$var$stringSlice(str, 0, position);
            case "'":
                return $be5ce849ce561839$var$stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[$be5ce849ce561839$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $be5ce849ce561839$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $be5ce849ce561839$var$charAt(ch, 1) : captures[f - 1] + $be5ce849ce561839$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};




var $f7f7fe7f5d4732b9$var$REPLACE = $6c5fb57dad6dd350$exports("replace");
var $f7f7fe7f5d4732b9$var$max = Math.max;
var $f7f7fe7f5d4732b9$var$min = Math.min;
var $f7f7fe7f5d4732b9$var$concat = $23a00ee3e029ff58$exports([].concat);
var $f7f7fe7f5d4732b9$var$push = $23a00ee3e029ff58$exports([].push);
var $f7f7fe7f5d4732b9$var$stringIndexOf = $23a00ee3e029ff58$exports("".indexOf);
var $f7f7fe7f5d4732b9$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $f7f7fe7f5d4732b9$var$maybeToString = function maybeToString(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $f7f7fe7f5d4732b9$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $f7f7fe7f5d4732b9$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$f7f7fe7f5d4732b9$var$REPLACE]) return /./[$f7f7fe7f5d4732b9$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $f7f7fe7f5d4732b9$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$7bdc373729e45e27$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$b0b108867e4f4617$exports("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $f7f7fe7f5d4732b9$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $ddbaa5896e5ed636$exports(this);
            var replacer = $76135a25443d684f$exports(searchValue) ? undefined : $f29b070ab2fd2ce7$exports(searchValue, $f7f7fe7f5d4732b9$var$REPLACE);
            return replacer ? $4b3fe34719193049$exports(replacer, searchValue, O, replaceValue) : $4b3fe34719193049$exports(nativeReplace, $dd666817fb19c24c$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $c894fc907eeec831$exports(this);
            var S = $dd666817fb19c24c$exports(string);
            if (typeof replaceValue == "string" && $f7f7fe7f5d4732b9$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $f7f7fe7f5d4732b9$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $64c802885f841370$exports(replaceValue);
            if (!functionalReplace) replaceValue = $dd666817fb19c24c$exports(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $ffa336a6a4395145$exports(rx, S);
                if (result === null) break;
                $f7f7fe7f5d4732b9$var$push(results, result);
                if (!global) break;
                var matchStr = $dd666817fb19c24c$exports(result[0]);
                if (matchStr === "") rx.lastIndex = $0d93e8e6f857b923$exports(S, $8beae9420c83acf0$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $dd666817fb19c24c$exports(result[0]);
                var position = $f7f7fe7f5d4732b9$var$max($f7f7fe7f5d4732b9$var$min($5e45f07a290dfff0$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$f7f7fe7f5d4732b9$var$push(captures, $f7f7fe7f5d4732b9$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $f7f7fe7f5d4732b9$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $f7f7fe7f5d4732b9$var$push(replacerArgs, namedCaptures);
                    replacement = $dd666817fb19c24c$exports($f275acb1973d253b$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $be5ce849ce561839$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $f7f7fe7f5d4732b9$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $f7f7fe7f5d4732b9$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$f7f7fe7f5d4732b9$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$f7f7fe7f5d4732b9$var$REPLACE_KEEPS_$0 || $f7f7fe7f5d4732b9$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


"use strict";









// @@search logic
$b0b108867e4f4617$exports("search", function(SEARCH, nativeSearch, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.es/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = $ddbaa5896e5ed636$exports(this);
            var searcher = $76135a25443d684f$exports(regexp) ? undefined : $f29b070ab2fd2ce7$exports(regexp, SEARCH);
            return searcher ? $4b3fe34719193049$exports(searcher, regexp, O) : new RegExp(regexp)[SEARCH]($dd666817fb19c24c$exports(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
        function(string) {
            var rx = $c894fc907eeec831$exports(this);
            var S = $dd666817fb19c24c$exports(string);
            var res = maybeCallNative(nativeSearch, rx, S);
            if (res.done) return res.value;
            var previousLastIndex = rx.lastIndex;
            if (!$86e08f15fc72b29d$exports(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $ffa336a6a4395145$exports(rx, S);
            if (!$86e08f15fc72b29d$exports(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


"use strict";


















var $79b5d1e47b1311d0$var$UNSUPPORTED_Y = $e46b75c6a6e3c0bc$exports.UNSUPPORTED_Y;
var $79b5d1e47b1311d0$var$MAX_UINT32 = 0xFFFFFFFF;
var $79b5d1e47b1311d0$var$min = Math.min;
var $79b5d1e47b1311d0$var$$push = [].push;
var $79b5d1e47b1311d0$var$exec = $23a00ee3e029ff58$exports(/./.exec);
var $79b5d1e47b1311d0$var$push = $23a00ee3e029ff58$exports($79b5d1e47b1311d0$var$$push);
var $79b5d1e47b1311d0$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $79b5d1e47b1311d0$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = "ab".split(re);
    return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
// @@split logic
$b0b108867e4f4617$exports("split", function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    if ("abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
    "test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
    internalSplit = function internalSplit(separator, limit) {
        var string = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports(this));
        var lim = limit === undefined ? $79b5d1e47b1311d0$var$MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [
            string
        ];
        // If `separator` is not a regex, use native split
        if (!$ad24a4561be7fb63$exports(separator)) return $4b3fe34719193049$exports(nativeSplit, string, separator, lim);
        var output = [];
        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
        var lastLastIndex = 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + "g");
        var match, lastIndex, lastLength;
        while(match = $4b3fe34719193049$exports($eb9509d37bda2de2$exports, separatorCopy, string)){
            lastIndex = separatorCopy.lastIndex;
            if (lastIndex > lastLastIndex) {
                $79b5d1e47b1311d0$var$push(output, $79b5d1e47b1311d0$var$stringSlice(string, lastLastIndex, match.index));
                if (match.length > 1 && match.index < string.length) $f275acb1973d253b$exports($79b5d1e47b1311d0$var$$push, output, $ad61b3a319da2150$exports(match, 1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= lim) break;
            }
            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === string.length) {
            if (lastLength || !$79b5d1e47b1311d0$var$exec(separatorCopy, "")) $79b5d1e47b1311d0$var$push(output, "");
        } else $79b5d1e47b1311d0$var$push(output, $79b5d1e47b1311d0$var$stringSlice(string, lastLastIndex));
        return output.length > lim ? $ad61b3a319da2150$exports(output, 0, lim) : output;
    };
    else if ("0".split(undefined, 0).length) internalSplit = function internalSplit(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $4b3fe34719193049$exports(nativeSplit, this, separator, limit);
    };
    else internalSplit = nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $ddbaa5896e5ed636$exports(this);
            var splitter = $76135a25443d684f$exports(separator) ? undefined : $f29b070ab2fd2ce7$exports(separator, SPLIT);
            return splitter ? $4b3fe34719193049$exports(splitter, separator, O, limit) : $4b3fe34719193049$exports(internalSplit, $dd666817fb19c24c$exports(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $c894fc907eeec831$exports(this);
            var S = $dd666817fb19c24c$exports(string);
            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
            if (res.done) return res.value;
            var C = $11472182d06f3dc1$exports(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + ($79b5d1e47b1311d0$var$UNSUPPORTED_Y ? "g" : "y");
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($79b5d1e47b1311d0$var$UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
            var lim = limit === undefined ? $79b5d1e47b1311d0$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $ffa336a6a4395145$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $79b5d1e47b1311d0$var$UNSUPPORTED_Y ? 0 : q;
                var z = $ffa336a6a4395145$exports(splitter, $79b5d1e47b1311d0$var$UNSUPPORTED_Y ? $79b5d1e47b1311d0$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $79b5d1e47b1311d0$var$min($8beae9420c83acf0$exports(splitter.lastIndex + ($79b5d1e47b1311d0$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $0d93e8e6f857b923$exports(S, q, unicodeMatching);
                else {
                    $79b5d1e47b1311d0$var$push(A, $79b5d1e47b1311d0$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $79b5d1e47b1311d0$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $79b5d1e47b1311d0$var$push(A, $79b5d1e47b1311d0$var$stringSlice(S, p));
            return A;
        }
    ];
}, !$79b5d1e47b1311d0$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $79b5d1e47b1311d0$var$UNSUPPORTED_Y);


"use strict";



var $90d869ce7a40ad5f$require$getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;






// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $90d869ce7a40ad5f$var$nativeStartsWith = $92ca88fbf3cbbcaa$exports("".startsWith);
var $90d869ce7a40ad5f$var$stringSlice = $92ca88fbf3cbbcaa$exports("".slice);
var $90d869ce7a40ad5f$var$min = Math.min;
var $90d869ce7a40ad5f$var$CORRECT_IS_REGEXP_LOGIC = $0eb1ee8dd74b064e$exports("startsWith");
// https://github.com/zloirock/core-js/pull/702
var $90d869ce7a40ad5f$var$MDN_POLYFILL_BUG = !$bad8555d514b807c$exports && !$90d869ce7a40ad5f$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $90d869ce7a40ad5f$require$getOwnPropertyDescriptor(String.prototype, "startsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: !$90d869ce7a40ad5f$var$MDN_POLYFILL_BUG && !$90d869ce7a40ad5f$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports(this));
        $437d4b695bc3efe0$exports(searchString);
        var index = $8beae9420c83acf0$exports($90d869ce7a40ad5f$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = $dd666817fb19c24c$exports(searchString);
        return $90d869ce7a40ad5f$var$nativeStartsWith ? $90d869ce7a40ad5f$var$nativeStartsWith(that, search, index) : $90d869ce7a40ad5f$var$stringSlice(that, index, index + search.length) === search;
    }
});


"use strict";


var $46c37d383bbcaf31$require$$trim = $0da89d3a7f6e5b50$exports.trim;
var $720d07da16041540$exports = {};
"use strict";

var $720d07da16041540$require$PROPER_FUNCTION_NAME = $b7b4004231446e90$exports.PROPER;


var $720d07da16041540$var$non = "​\x85᠎";
// check that a method works with the correct list
// of whitespaces and has a correct name
$720d07da16041540$exports = function(METHOD_NAME) {
    return $7bdc373729e45e27$exports(function() {
        return !!$ce3283842b942e24$exports[METHOD_NAME]() || $720d07da16041540$var$non[METHOD_NAME]() !== $720d07da16041540$var$non || $720d07da16041540$require$PROPER_FUNCTION_NAME && $ce3283842b942e24$exports[METHOD_NAME].name !== METHOD_NAME;
    });
};


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $720d07da16041540$exports("trim")
}, {
    trim: function trim() {
        return $46c37d383bbcaf31$require$$trim(this);
    }
});


"use strict";
"use strict";

var $bcb071bff3906c0a$exports = {};
"use strict";

var $bcb071bff3906c0a$require$$trimEnd = $0da89d3a7f6e5b50$exports.end;

// `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
$bcb071bff3906c0a$exports = $720d07da16041540$exports("trimEnd") ? function trimEnd() {
    return $bcb071bff3906c0a$require$$trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : "".trimEnd;


// `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    name: "trimEnd",
    forced: "".trimRight !== $bcb071bff3906c0a$exports
}, {
    trimRight: $bcb071bff3906c0a$exports
});




// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    name: "trimEnd",
    forced: "".trimEnd !== $bcb071bff3906c0a$exports
}, {
    trimEnd: $bcb071bff3906c0a$exports
});


"use strict";
"use strict";

var $0fb99d03c680e4b8$exports = {};
"use strict";

var $0fb99d03c680e4b8$require$$trimStart = $0da89d3a7f6e5b50$exports.start;

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
$0fb99d03c680e4b8$exports = $720d07da16041540$exports("trimStart") ? function trimStart() {
    return $0fb99d03c680e4b8$require$$trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : "".trimStart;


// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    name: "trimStart",
    forced: "".trimLeft !== $0fb99d03c680e4b8$exports
}, {
    trimLeft: $0fb99d03c680e4b8$exports
});




// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    name: "trimStart",
    forced: "".trimStart !== $0fb99d03c680e4b8$exports
}, {
    trimStart: $0fb99d03c680e4b8$exports
});


"use strict";

var $ad8514a56658053b$exports = {};
"use strict";



var $ad8514a56658053b$var$quot = /"/g;
var $ad8514a56658053b$var$replace = $23a00ee3e029ff58$exports("".replace);
// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
$ad8514a56658053b$exports = function(string, tag, attribute, value) {
    var S = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports(string));
    var p1 = "<" + tag;
    if (attribute !== "") p1 += " " + attribute + '="' + $ad8514a56658053b$var$replace($dd666817fb19c24c$exports(value), $ad8514a56658053b$var$quot, "&quot;") + '"';
    return p1 + ">" + S + "</" + tag + ">";
};


var $4acc6dbe035fd8db$exports = {};
"use strict";

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
$4acc6dbe035fd8db$exports = function(METHOD_NAME) {
    return $7bdc373729e45e27$exports(function() {
        var test = ""[METHOD_NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    });
};


// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("anchor")
}, {
    anchor: function anchor(name) {
        return $ad8514a56658053b$exports(this, "a", "name", name);
    }
});


"use strict";



// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("big")
}, {
    big: function big() {
        return $ad8514a56658053b$exports(this, "big", "", "");
    }
});


"use strict";



// `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("blink")
}, {
    blink: function blink() {
        return $ad8514a56658053b$exports(this, "blink", "", "");
    }
});


"use strict";



// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("bold")
}, {
    bold: function bold() {
        return $ad8514a56658053b$exports(this, "b", "", "");
    }
});


"use strict";



// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("fixed")
}, {
    fixed: function fixed() {
        return $ad8514a56658053b$exports(this, "tt", "", "");
    }
});


"use strict";



// `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("fontcolor")
}, {
    fontcolor: function fontcolor(color) {
        return $ad8514a56658053b$exports(this, "font", "color", color);
    }
});


"use strict";



// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("fontsize")
}, {
    fontsize: function fontsize(size) {
        return $ad8514a56658053b$exports(this, "font", "size", size);
    }
});


"use strict";



// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("italics")
}, {
    italics: function italics() {
        return $ad8514a56658053b$exports(this, "i", "", "");
    }
});


"use strict";



// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("link")
}, {
    link: function link(url) {
        return $ad8514a56658053b$exports(this, "a", "href", url);
    }
});


"use strict";



// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("small")
}, {
    small: function small() {
        return $ad8514a56658053b$exports(this, "small", "", "");
    }
});


"use strict";



// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("strike")
}, {
    strike: function strike() {
        return $ad8514a56658053b$exports(this, "strike", "", "");
    }
});


"use strict";



// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("sub")
}, {
    sub: function sub() {
        return $ad8514a56658053b$exports(this, "sub", "", "");
    }
});


"use strict";



// `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $4acc6dbe035fd8db$exports("sup")
}, {
    sup: function sup() {
        return $ad8514a56658053b$exports(this, "sup", "", "");
    }
});


"use strict";
var $ff921fb9f5671f39$exports = {};
"use strict";




var $b082a18468c27384$exports = {};
"use strict";



var $5c744583e6986c06$exports = {};
"use strict";

















var $5c744583e6986c06$var$enforceInternalState = $c70ec777954e7cbe$exports.enforce;
var $5c744583e6986c06$var$getInternalState = $c70ec777954e7cbe$exports.get;
var $5c744583e6986c06$var$Int8Array = $0f4ea948f6673103$exports.Int8Array;
var $5c744583e6986c06$var$Int8ArrayPrototype = $5c744583e6986c06$var$Int8Array && $5c744583e6986c06$var$Int8Array.prototype;
var $5c744583e6986c06$var$Uint8ClampedArray = $0f4ea948f6673103$exports.Uint8ClampedArray;
var $5c744583e6986c06$var$Uint8ClampedArrayPrototype = $5c744583e6986c06$var$Uint8ClampedArray && $5c744583e6986c06$var$Uint8ClampedArray.prototype;
var $5c744583e6986c06$var$TypedArray = $5c744583e6986c06$var$Int8Array && $7acbb54af94d406d$exports($5c744583e6986c06$var$Int8Array);
var $5c744583e6986c06$var$TypedArrayPrototype = $5c744583e6986c06$var$Int8ArrayPrototype && $7acbb54af94d406d$exports($5c744583e6986c06$var$Int8ArrayPrototype);
var $5c744583e6986c06$var$ObjectPrototype = Object.prototype;
var $5c744583e6986c06$var$TypeError = $0f4ea948f6673103$exports.TypeError;
var $5c744583e6986c06$var$TO_STRING_TAG = $6c5fb57dad6dd350$exports("toStringTag");
var $5c744583e6986c06$var$TYPED_ARRAY_TAG = $3139b6d9415fe2b9$exports("TYPED_ARRAY_TAG");
var $5c744583e6986c06$var$TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS = $b9a9a55923c0414f$exports && !!$5f3130f6ca40c617$exports && $19a284f0ad8e7bd9$exports($0f4ea948f6673103$exports.opera) !== "Opera";
var $5c744583e6986c06$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $5c744583e6986c06$var$NAME, $5c744583e6986c06$var$Constructor, $5c744583e6986c06$var$Prototype;
var $5c744583e6986c06$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $5c744583e6986c06$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $5c744583e6986c06$var$isView = function isView(it) {
    if (!$b1a75f6ed3e2d50f$exports(it)) return false;
    var klass = $19a284f0ad8e7bd9$exports(it);
    return klass === "DataView" || $5f4f8ca39500aba6$exports($5c744583e6986c06$var$TypedArrayConstructorsList, klass) || $5f4f8ca39500aba6$exports($5c744583e6986c06$var$BigIntArrayConstructorsList, klass);
};
var $5c744583e6986c06$var$getTypedArrayConstructor = function getTypedArrayConstructor1(it) {
    var proto = $7acbb54af94d406d$exports(it);
    if (!$b1a75f6ed3e2d50f$exports(proto)) return;
    var state = $5c744583e6986c06$var$getInternalState(proto);
    return state && $5f4f8ca39500aba6$exports(state, $5c744583e6986c06$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$5c744583e6986c06$var$TYPED_ARRAY_CONSTRUCTOR] : $5c744583e6986c06$var$getTypedArrayConstructor(proto);
};
var $5c744583e6986c06$var$isTypedArray = function isTypedArray(it) {
    if (!$b1a75f6ed3e2d50f$exports(it)) return false;
    var klass = $19a284f0ad8e7bd9$exports(it);
    return $5f4f8ca39500aba6$exports($5c744583e6986c06$var$TypedArrayConstructorsList, klass) || $5f4f8ca39500aba6$exports($5c744583e6986c06$var$BigIntArrayConstructorsList, klass);
};
var $5c744583e6986c06$var$aTypedArray = function aTypedArray(it) {
    if ($5c744583e6986c06$var$isTypedArray(it)) return it;
    throw new $5c744583e6986c06$var$TypeError("Target is not a typed array");
};
var $5c744583e6986c06$var$aTypedArrayConstructor = function aTypedArrayConstructor(C) {
    if ($64c802885f841370$exports(C) && (!$5f3130f6ca40c617$exports || $372efcd1340d8495$exports($5c744583e6986c06$var$TypedArray, C))) return C;
    throw new $5c744583e6986c06$var$TypeError($815d6e8656bb616c$exports(C) + " is not a typed array constructor");
};
var $5c744583e6986c06$var$exportTypedArrayMethod = function exportTypedArrayMethod(KEY, property, forced, options) {
    if (!$40260b59b65c2e4c$exports) return;
    if (forced) for(var ARRAY in $5c744583e6986c06$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $0f4ea948f6673103$exports[ARRAY];
        if (TypedArrayConstructor && $5f4f8ca39500aba6$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$5c744583e6986c06$var$TypedArrayPrototype[KEY] || forced) $f488b1cc13335fff$exports($5c744583e6986c06$var$TypedArrayPrototype, KEY, forced ? property : $5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS && $5c744583e6986c06$var$Int8ArrayPrototype[KEY] || property, options);
};
var $5c744583e6986c06$var$exportTypedArrayStaticMethod = function exportTypedArrayStaticMethod(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$40260b59b65c2e4c$exports) return;
    if ($5f3130f6ca40c617$exports) {
        if (forced) for(ARRAY in $5c744583e6986c06$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $0f4ea948f6673103$exports[ARRAY];
            if (TypedArrayConstructor && $5f4f8ca39500aba6$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$5c744583e6986c06$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $f488b1cc13335fff$exports($5c744583e6986c06$var$TypedArray, KEY, forced ? property : $5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS && $5c744583e6986c06$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $5c744583e6986c06$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $0f4ea948f6673103$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $f488b1cc13335fff$exports(TypedArrayConstructor, KEY, property);
    }
};
for($5c744583e6986c06$var$NAME in $5c744583e6986c06$var$TypedArrayConstructorsList){
    $5c744583e6986c06$var$Constructor = $0f4ea948f6673103$exports[$5c744583e6986c06$var$NAME];
    $5c744583e6986c06$var$Prototype = $5c744583e6986c06$var$Constructor && $5c744583e6986c06$var$Constructor.prototype;
    if ($5c744583e6986c06$var$Prototype) $5c744583e6986c06$var$enforceInternalState($5c744583e6986c06$var$Prototype)[$5c744583e6986c06$var$TYPED_ARRAY_CONSTRUCTOR] = $5c744583e6986c06$var$Constructor;
    else $5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($5c744583e6986c06$var$NAME in $5c744583e6986c06$var$BigIntArrayConstructorsList){
    $5c744583e6986c06$var$Constructor = $0f4ea948f6673103$exports[$5c744583e6986c06$var$NAME];
    $5c744583e6986c06$var$Prototype = $5c744583e6986c06$var$Constructor && $5c744583e6986c06$var$Constructor.prototype;
    if ($5c744583e6986c06$var$Prototype) $5c744583e6986c06$var$enforceInternalState($5c744583e6986c06$var$Prototype)[$5c744583e6986c06$var$TYPED_ARRAY_CONSTRUCTOR] = $5c744583e6986c06$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS || !$64c802885f841370$exports($5c744583e6986c06$var$TypedArray) || $5c744583e6986c06$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $5c744583e6986c06$var$TypedArray = function TypedArray() {
        throw new $5c744583e6986c06$var$TypeError("Incorrect invocation");
    };
    if ($5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($5c744583e6986c06$var$NAME in $5c744583e6986c06$var$TypedArrayConstructorsList)if ($0f4ea948f6673103$exports[$5c744583e6986c06$var$NAME]) $5f3130f6ca40c617$exports($0f4ea948f6673103$exports[$5c744583e6986c06$var$NAME], $5c744583e6986c06$var$TypedArray);
    }
}
if (!$5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS || !$5c744583e6986c06$var$TypedArrayPrototype || $5c744583e6986c06$var$TypedArrayPrototype === $5c744583e6986c06$var$ObjectPrototype) {
    $5c744583e6986c06$var$TypedArrayPrototype = $5c744583e6986c06$var$TypedArray.prototype;
    if ($5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($5c744583e6986c06$var$NAME in $5c744583e6986c06$var$TypedArrayConstructorsList)if ($0f4ea948f6673103$exports[$5c744583e6986c06$var$NAME]) $5f3130f6ca40c617$exports($0f4ea948f6673103$exports[$5c744583e6986c06$var$NAME].prototype, $5c744583e6986c06$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS && $7acbb54af94d406d$exports($5c744583e6986c06$var$Uint8ClampedArrayPrototype) !== $5c744583e6986c06$var$TypedArrayPrototype) $5f3130f6ca40c617$exports($5c744583e6986c06$var$Uint8ClampedArrayPrototype, $5c744583e6986c06$var$TypedArrayPrototype);
if ($40260b59b65c2e4c$exports && !$5f4f8ca39500aba6$exports($5c744583e6986c06$var$TypedArrayPrototype, $5c744583e6986c06$var$TO_STRING_TAG)) {
    $5c744583e6986c06$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $d235cf6ad826c1e5$exports($5c744583e6986c06$var$TypedArrayPrototype, $5c744583e6986c06$var$TO_STRING_TAG, {
        configurable: true,
        get: function get() {
            return $b1a75f6ed3e2d50f$exports(this) ? this[$5c744583e6986c06$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($5c744583e6986c06$var$NAME in $5c744583e6986c06$var$TypedArrayConstructorsList)if ($0f4ea948f6673103$exports[$5c744583e6986c06$var$NAME]) $4bc121b672cbfd84$exports($0f4ea948f6673103$exports[$5c744583e6986c06$var$NAME], $5c744583e6986c06$var$TYPED_ARRAY_TAG, $5c744583e6986c06$var$NAME);
}
$5c744583e6986c06$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $5c744583e6986c06$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $5c744583e6986c06$var$TYPED_ARRAY_TAG_REQUIRED && $5c744583e6986c06$var$TYPED_ARRAY_TAG,
    aTypedArray: $5c744583e6986c06$var$aTypedArray,
    aTypedArrayConstructor: $5c744583e6986c06$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $5c744583e6986c06$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $5c744583e6986c06$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $5c744583e6986c06$var$getTypedArrayConstructor,
    isView: $5c744583e6986c06$var$isView,
    isTypedArray: $5c744583e6986c06$var$isTypedArray,
    TypedArray: $5c744583e6986c06$var$TypedArray,
    TypedArrayPrototype: $5c744583e6986c06$var$TypedArrayPrototype
};


var $b082a18468c27384$require$NATIVE_ARRAY_BUFFER_VIEWS = $5c744583e6986c06$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $b082a18468c27384$var$ArrayBuffer = $0f4ea948f6673103$exports.ArrayBuffer;
var $b082a18468c27384$var$Int8Array = $0f4ea948f6673103$exports.Int8Array;
$b082a18468c27384$exports = !$b082a18468c27384$require$NATIVE_ARRAY_BUFFER_VIEWS || !$7bdc373729e45e27$exports(function() {
    $b082a18468c27384$var$Int8Array(1);
}) || !$7bdc373729e45e27$exports(function() {
    new $b082a18468c27384$var$Int8Array(-1);
}) || !$14b7679ddc3bba0f$exports(function(iterable) {
    new $b082a18468c27384$var$Int8Array();
    new $b082a18468c27384$var$Int8Array(null);
    new $b082a18468c27384$var$Int8Array(1.5);
    new $b082a18468c27384$var$Int8Array(iterable);
}, true) || $7bdc373729e45e27$exports(function() {
    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
    return new $b082a18468c27384$var$Int8Array(new $b082a18468c27384$var$ArrayBuffer(2), 1, undefined).length !== 1;
});










var $d369d2689494fd50$exports = {};
"use strict";
var $072addfd2258cb62$exports = {};
"use strict";

var $072addfd2258cb62$var$$RangeError = RangeError;
$072addfd2258cb62$exports = function(it) {
    var result = $5e45f07a290dfff0$exports(it);
    if (result < 0) throw new $072addfd2258cb62$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $d369d2689494fd50$var$$RangeError = RangeError;
$d369d2689494fd50$exports = function(it, BYTES) {
    var offset = $072addfd2258cb62$exports(it);
    if (offset % BYTES) throw new $d369d2689494fd50$var$$RangeError("Wrong offset");
    return offset;
};


var $5eebe5951e6c03e2$exports = {};
"use strict";
var $5eebe5951e6c03e2$var$round = Math.round;
$5eebe5951e6c03e2$exports = function(it) {
    var value = $5eebe5951e6c03e2$var$round(it);
    return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};











var $ff921fb9f5671f39$require$getOwnPropertyNames = $a329b85dee9c6785$export$2d1720544b23b823;
var $c1d5ce54311db01b$exports = {};
"use strict";








var $6bccb993b894e720$exports = {};
"use strict";

$6bccb993b894e720$exports = function(it) {
    var klass = $19a284f0ad8e7bd9$exports(it);
    return klass === "BigInt64Array" || klass === "BigUint64Array";
};



var $c1d5ce54311db01b$require$aTypedArrayConstructor = $5c744583e6986c06$exports.aTypedArrayConstructor;
var $2a3c24b0f393c3c7$exports = {};
"use strict";

var $2a3c24b0f393c3c7$var$$TypeError = TypeError;
// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
$2a3c24b0f393c3c7$exports = function(argument) {
    var prim = $cd38c3644f9f1332$exports(argument, "number");
    if (typeof prim == "number") throw new $2a3c24b0f393c3c7$var$$TypeError("Can't convert number to bigint");
    // eslint-disable-next-line es/no-bigint -- safe
    return BigInt(prim);
};


$c1d5ce54311db01b$exports = function from(source /* , mapfn, thisArg */ ) {
    var C = $6e7a3c29f95ae8ae$exports(this);
    var O = $7d5785aa2fc2b3e1$exports(source);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iteratorMethod = $1ffb58790ca29df3$exports(O);
    var i, length, result, thisIsBigIntArray, value, step, iterator, next;
    if (iteratorMethod && !$4ea30f210c56f492$exports(iteratorMethod)) {
        iterator = $246adf013c49aea4$exports(O, iteratorMethod);
        next = iterator.next;
        O = [];
        while(!(step = $4b3fe34719193049$exports(next, iterator)).done)O.push(step.value);
    }
    if (mapping && argumentsLength > 2) mapfn = $042f91ff50d30f11$exports(mapfn, arguments[2]);
    length = $027f7f84b95594e7$exports(O);
    result = new ($c1d5ce54311db01b$require$aTypedArrayConstructor(C))(length);
    thisIsBigIntArray = $6bccb993b894e720$exports(result);
    for(i = 0; length > i; i++){
        value = mapping ? mapfn(O[i], i) : O[i];
        // FF30- typed arrays doesn't properly convert objects to typed array values
        result[i] = thisIsBigIntArray ? $2a3c24b0f393c3c7$exports(value) : +value;
    }
    return result;
};



var $ff921fb9f5671f39$require$forEach = $d32fb3bde149eb49$exports.forEach;






var $ff921fb9f5671f39$var$getInternalState = $c70ec777954e7cbe$exports.get;
var $ff921fb9f5671f39$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $ff921fb9f5671f39$var$enforceInternalState = $c70ec777954e7cbe$exports.enforce;
var $ff921fb9f5671f39$var$nativeDefineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;
var $ff921fb9f5671f39$var$nativeGetOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;
var $ff921fb9f5671f39$var$RangeError = $0f4ea948f6673103$exports.RangeError;
var $ff921fb9f5671f39$var$ArrayBuffer = $f25346346715e360$exports.ArrayBuffer;
var $ff921fb9f5671f39$var$ArrayBufferPrototype = $ff921fb9f5671f39$var$ArrayBuffer.prototype;
var $ff921fb9f5671f39$var$DataView = $f25346346715e360$exports.DataView;
var $ff921fb9f5671f39$var$NATIVE_ARRAY_BUFFER_VIEWS = $5c744583e6986c06$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $ff921fb9f5671f39$var$TYPED_ARRAY_TAG = $5c744583e6986c06$exports.TYPED_ARRAY_TAG;
var $ff921fb9f5671f39$var$TypedArray = $5c744583e6986c06$exports.TypedArray;
var $ff921fb9f5671f39$var$TypedArrayPrototype = $5c744583e6986c06$exports.TypedArrayPrototype;
var $ff921fb9f5671f39$var$aTypedArrayConstructor = $5c744583e6986c06$exports.aTypedArrayConstructor;
var $ff921fb9f5671f39$var$isTypedArray = $5c744583e6986c06$exports.isTypedArray;
var $ff921fb9f5671f39$var$BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
var $ff921fb9f5671f39$var$WRONG_LENGTH = "Wrong length";
var $ff921fb9f5671f39$var$fromList = function fromList(C, list) {
    $ff921fb9f5671f39$var$aTypedArrayConstructor(C);
    var index = 0;
    var length = list.length;
    var result = new C(length);
    while(length > index)result[index] = list[index++];
    return result;
};
var $ff921fb9f5671f39$var$addGetter = function addGetter(it, key) {
    $d235cf6ad826c1e5$exports(it, key, {
        configurable: true,
        get: function get() {
            return $ff921fb9f5671f39$var$getInternalState(this)[key];
        }
    });
};
var $ff921fb9f5671f39$var$isArrayBuffer = function isArrayBuffer(it) {
    var klass;
    return $372efcd1340d8495$exports($ff921fb9f5671f39$var$ArrayBufferPrototype, it) || (klass = $19a284f0ad8e7bd9$exports(it)) === "ArrayBuffer" || klass === "SharedArrayBuffer";
};
var $ff921fb9f5671f39$var$isTypedArrayIndex = function isTypedArrayIndex(target, key) {
    return $ff921fb9f5671f39$var$isTypedArray(target) && !$368e2561dee205ff$exports(key) && key in target && $9827a05bcaa934cf$exports(+key) && key >= 0;
};
var $ff921fb9f5671f39$var$wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = $8bc65e9087e8d1e0$exports(key);
    return $ff921fb9f5671f39$var$isTypedArrayIndex(target, key) ? $ca4a4ced04e4a412$exports(2, target[key]) : $ff921fb9f5671f39$var$nativeGetOwnPropertyDescriptor(target, key);
};
var $ff921fb9f5671f39$var$wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = $8bc65e9087e8d1e0$exports(key);
    if ($ff921fb9f5671f39$var$isTypedArrayIndex(target, key) && $b1a75f6ed3e2d50f$exports(descriptor) && $5f4f8ca39500aba6$exports(descriptor, "value") && !$5f4f8ca39500aba6$exports(descriptor, "get") && !$5f4f8ca39500aba6$exports(descriptor, "set") && !descriptor.configurable && (!$5f4f8ca39500aba6$exports(descriptor, "writable") || descriptor.writable) && (!$5f4f8ca39500aba6$exports(descriptor, "enumerable") || descriptor.enumerable)) {
        target[key] = descriptor.value;
        return target;
    }
    return $ff921fb9f5671f39$var$nativeDefineProperty(target, key, descriptor);
};
if ($40260b59b65c2e4c$exports) {
    if (!$ff921fb9f5671f39$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        $003023ef435958c5$export$2d1720544b23b823 = $ff921fb9f5671f39$var$wrappedGetOwnPropertyDescriptor;
        $18b1ebdefa97b93b$export$2d1720544b23b823 = $ff921fb9f5671f39$var$wrappedDefineProperty;
        $ff921fb9f5671f39$var$addGetter($ff921fb9f5671f39$var$TypedArrayPrototype, "buffer");
        $ff921fb9f5671f39$var$addGetter($ff921fb9f5671f39$var$TypedArrayPrototype, "byteOffset");
        $ff921fb9f5671f39$var$addGetter($ff921fb9f5671f39$var$TypedArrayPrototype, "byteLength");
        $ff921fb9f5671f39$var$addGetter($ff921fb9f5671f39$var$TypedArrayPrototype, "length");
    }
    $d4b8e88525a1c695$exports({
        target: "Object",
        stat: true,
        forced: !$ff921fb9f5671f39$var$NATIVE_ARRAY_BUFFER_VIEWS
    }, {
        getOwnPropertyDescriptor: $ff921fb9f5671f39$var$wrappedGetOwnPropertyDescriptor,
        defineProperty: $ff921fb9f5671f39$var$wrappedDefineProperty
    });
    $ff921fb9f5671f39$exports = function(TYPE, wrapper, CLAMPED) {
        var BYTES = TYPE.match(/\d+/)[0] / 8;
        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? "Clamped" : "") + "Array";
        var GETTER = "get" + TYPE;
        var SETTER = "set" + TYPE;
        var NativeTypedArrayConstructor = $0f4ea948f6673103$exports[CONSTRUCTOR_NAME];
        var TypedArrayConstructor = NativeTypedArrayConstructor;
        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
        var exported = {};
        var getter = function getter(that, index) {
            var data = $ff921fb9f5671f39$var$getInternalState(that);
            return data.view[GETTER](index * BYTES + data.byteOffset, true);
        };
        var setter = function setter(that, index, value) {
            var data = $ff921fb9f5671f39$var$getInternalState(that);
            data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? $5eebe5951e6c03e2$exports(value) : value, true);
        };
        var addElement = function addElement(that, index) {
            $ff921fb9f5671f39$var$nativeDefineProperty(that, index, {
                get: function get() {
                    return getter(this, index);
                },
                set: function set(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (!$ff921fb9f5671f39$var$NATIVE_ARRAY_BUFFER_VIEWS) {
            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                $cf50221949c767d8$exports(that, TypedArrayConstructorPrototype);
                var index = 0;
                var byteOffset = 0;
                var buffer, byteLength, length;
                if (!$b1a75f6ed3e2d50f$exports(data)) {
                    length = $f9469686166638c6$exports(data);
                    byteLength = length * BYTES;
                    buffer = new $ff921fb9f5671f39$var$ArrayBuffer(byteLength);
                } else if ($ff921fb9f5671f39$var$isArrayBuffer(data)) {
                    buffer = data;
                    byteOffset = $d369d2689494fd50$exports(offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw new $ff921fb9f5671f39$var$RangeError($ff921fb9f5671f39$var$WRONG_LENGTH);
                        byteLength = $len - byteOffset;
                        if (byteLength < 0) throw new $ff921fb9f5671f39$var$RangeError($ff921fb9f5671f39$var$WRONG_LENGTH);
                    } else {
                        byteLength = $8beae9420c83acf0$exports($length) * BYTES;
                        if (byteLength + byteOffset > $len) throw new $ff921fb9f5671f39$var$RangeError($ff921fb9f5671f39$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($ff921fb9f5671f39$var$isTypedArray(data)) return $ff921fb9f5671f39$var$fromList(TypedArrayConstructor, data);
                else return $4b3fe34719193049$exports($c1d5ce54311db01b$exports, TypedArrayConstructor, data);
                $ff921fb9f5671f39$var$setInternalState(that, {
                    buffer: buffer,
                    byteOffset: byteOffset,
                    byteLength: byteLength,
                    length: length,
                    view: new $ff921fb9f5671f39$var$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            if ($5f3130f6ca40c617$exports) $5f3130f6ca40c617$exports(TypedArrayConstructor, $ff921fb9f5671f39$var$TypedArray);
            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = $9959f3fdced32995$exports($ff921fb9f5671f39$var$TypedArrayPrototype);
        } else if ($b082a18468c27384$exports) {
            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                $cf50221949c767d8$exports(dummy, TypedArrayConstructorPrototype);
                return $f6721401d0718c1d$exports(function() {
                    if (!$b1a75f6ed3e2d50f$exports(data)) return new NativeTypedArrayConstructor($f9469686166638c6$exports(data));
                    if ($ff921fb9f5671f39$var$isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, $d369d2689494fd50$exports(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, $d369d2689494fd50$exports(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                    if ($ff921fb9f5671f39$var$isTypedArray(data)) return $ff921fb9f5671f39$var$fromList(TypedArrayConstructor, data);
                    return $4b3fe34719193049$exports($c1d5ce54311db01b$exports, TypedArrayConstructor, data);
                }(), dummy, TypedArrayConstructor);
            });
            if ($5f3130f6ca40c617$exports) $5f3130f6ca40c617$exports(TypedArrayConstructor, $ff921fb9f5671f39$var$TypedArray);
            $ff921fb9f5671f39$require$forEach($ff921fb9f5671f39$require$getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                if (!(key in TypedArrayConstructor)) $4bc121b672cbfd84$exports(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
            });
            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
        }
        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) $4bc121b672cbfd84$exports(TypedArrayConstructorPrototype, "constructor", TypedArrayConstructor);
        $ff921fb9f5671f39$var$enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
        if ($ff921fb9f5671f39$var$TYPED_ARRAY_TAG) $4bc121b672cbfd84$exports(TypedArrayConstructorPrototype, $ff921fb9f5671f39$var$TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
        var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;
        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
        $d4b8e88525a1c695$exports({
            global: true,
            constructor: true,
            forced: FORCED,
            sham: !$ff921fb9f5671f39$var$NATIVE_ARRAY_BUFFER_VIEWS
        }, exported);
        if (!($ff921fb9f5671f39$var$BYTES_PER_ELEMENT in TypedArrayConstructor)) $4bc121b672cbfd84$exports(TypedArrayConstructor, $ff921fb9f5671f39$var$BYTES_PER_ELEMENT, BYTES);
        if (!($ff921fb9f5671f39$var$BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) $4bc121b672cbfd84$exports(TypedArrayConstructorPrototype, $ff921fb9f5671f39$var$BYTES_PER_ELEMENT, BYTES);
        $d28e0c47aa6e7b5c$exports(CONSTRUCTOR_NAME);
    };
} else $ff921fb9f5671f39$exports = function() {};


// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ff921fb9f5671f39$exports("Float32", function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ff921fb9f5671f39$exports("Float64", function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ff921fb9f5671f39$exports("Int8", function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ff921fb9f5671f39$exports("Int16", function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ff921fb9f5671f39$exports("Int32", function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ff921fb9f5671f39$exports("Uint8", function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ff921fb9f5671f39$exports("Uint8", function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);


"use strict";

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ff921fb9f5671f39$exports("Uint16", function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ff921fb9f5671f39$exports("Uint32", function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";



var $193e26a40ef250b4$var$u$ArrayCopyWithin = $23a00ee3e029ff58$exports($222a224d577f6108$exports);
var $193e26a40ef250b4$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $193e26a40ef250b4$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
$193e26a40ef250b4$var$exportTypedArrayMethod("copyWithin", function copyWithin(target, start /* , end */ ) {
    return $193e26a40ef250b4$var$u$ArrayCopyWithin($193e26a40ef250b4$var$aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


"use strict";


var $b8e47a27841b072b$require$$every = $d32fb3bde149eb49$exports.every;
var $b8e47a27841b072b$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $b8e47a27841b072b$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
$b8e47a27841b072b$var$exportTypedArrayMethod("every", function every(callbackfn /* , thisArg */ ) {
    return $b8e47a27841b072b$require$$every($b8e47a27841b072b$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";







var $0095577636655769$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $0095577636655769$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
var $0095577636655769$var$slice = $23a00ee3e029ff58$exports("".slice);
// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var $0095577636655769$var$CONVERSION_BUG = $7bdc373729e45e27$exports(function() {
    var count = 0;
    // eslint-disable-next-line es/no-typed-arrays -- safe
    new Int8Array(2).fill({
        valueOf: function valueOf() {
            return count++;
        }
    });
    return count !== 1;
});
// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
$0095577636655769$var$exportTypedArrayMethod("fill", function fill(value /* , start, end */ ) {
    var length = arguments.length;
    $0095577636655769$var$aTypedArray(this);
    var actualValue = $0095577636655769$var$slice($19a284f0ad8e7bd9$exports(this), 0, 3) === "Big" ? $2a3c24b0f393c3c7$exports(value) : +value;
    return $4b3fe34719193049$exports($e7bfcf8076f14c00$exports, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, $0095577636655769$var$CONVERSION_BUG);


"use strict";


var $341c64ccf2c85d14$require$$filter = $d32fb3bde149eb49$exports.filter;
var $eaaabae7960db6a1$exports = {};
"use strict";
var $636fb5358fa16d4d$exports = {};
"use strict";

$636fb5358fa16d4d$exports = function(Constructor, list, $length) {
    var index = 0;
    var length = arguments.length > 2 ? $length : $027f7f84b95594e7$exports(list);
    var result = new Constructor(length);
    while(length > index)result[index] = list[index++];
    return result;
};


var $4e8cf3709288f98e$exports = {};
"use strict";


var $4e8cf3709288f98e$var$aTypedArrayConstructor = $5c744583e6986c06$exports.aTypedArrayConstructor;
var $4e8cf3709288f98e$var$getTypedArrayConstructor = $5c744583e6986c06$exports.getTypedArrayConstructor;
// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
$4e8cf3709288f98e$exports = function(originalArray) {
    return $4e8cf3709288f98e$var$aTypedArrayConstructor($11472182d06f3dc1$exports(originalArray, $4e8cf3709288f98e$var$getTypedArrayConstructor(originalArray)));
};


$eaaabae7960db6a1$exports = function(instance, list) {
    return $636fb5358fa16d4d$exports($4e8cf3709288f98e$exports(instance), list);
};


var $341c64ccf2c85d14$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $341c64ccf2c85d14$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
$341c64ccf2c85d14$var$exportTypedArrayMethod("filter", function filter(callbackfn /* , thisArg */ ) {
    var list = $341c64ccf2c85d14$require$$filter($341c64ccf2c85d14$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return $eaaabae7960db6a1$exports(this, list);
});


"use strict";


var $12a3e733cda71f7c$require$$find = $d32fb3bde149eb49$exports.find;
var $12a3e733cda71f7c$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $12a3e733cda71f7c$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
$12a3e733cda71f7c$var$exportTypedArrayMethod("find", function find(predicate /* , thisArg */ ) {
    return $12a3e733cda71f7c$require$$find($12a3e733cda71f7c$var$aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";


var $6bd22b8f268182f7$require$$findIndex = $d32fb3bde149eb49$exports.findIndex;
var $6bd22b8f268182f7$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $6bd22b8f268182f7$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
$6bd22b8f268182f7$var$exportTypedArrayMethod("findIndex", function findIndex(predicate /* , thisArg */ ) {
    return $6bd22b8f268182f7$require$$findIndex($6bd22b8f268182f7$var$aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";


var $f8d4cd5d02eb838c$require$$forEach = $d32fb3bde149eb49$exports.forEach;
var $f8d4cd5d02eb838c$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $f8d4cd5d02eb838c$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
$f8d4cd5d02eb838c$var$exportTypedArrayMethod("forEach", function forEach(callbackfn /* , thisArg */ ) {
    $f8d4cd5d02eb838c$require$$forEach($f8d4cd5d02eb838c$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";


var $9c6a660d1b150c59$require$exportTypedArrayStaticMethod = $5c744583e6986c06$exports.exportTypedArrayStaticMethod;

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
$9c6a660d1b150c59$require$exportTypedArrayStaticMethod("from", $c1d5ce54311db01b$exports, $b082a18468c27384$exports);


"use strict";


var $abb03632d957b2f9$require$$includes = $426db30bef2424d6$exports.includes;
var $abb03632d957b2f9$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $abb03632d957b2f9$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
$abb03632d957b2f9$var$exportTypedArrayMethod("includes", function includes(searchElement /* , fromIndex */ ) {
    return $abb03632d957b2f9$require$$includes($abb03632d957b2f9$var$aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";


var $4360bb6d87d701ab$require$$indexOf = $426db30bef2424d6$exports.indexOf;
var $4360bb6d87d701ab$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $4360bb6d87d701ab$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
$4360bb6d87d701ab$var$exportTypedArrayMethod("indexOf", function indexOf(searchElement /* , fromIndex */ ) {
    return $4360bb6d87d701ab$require$$indexOf($4360bb6d87d701ab$var$aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";






var $b6a51548cb76ae05$var$ITERATOR = $6c5fb57dad6dd350$exports("iterator");
var $b6a51548cb76ae05$var$Uint8Array = $0f4ea948f6673103$exports.Uint8Array;
var $b6a51548cb76ae05$var$arrayValues = $23a00ee3e029ff58$exports($c9b08ac37bf7fbb5$exports.values);
var $b6a51548cb76ae05$var$arrayKeys = $23a00ee3e029ff58$exports($c9b08ac37bf7fbb5$exports.keys);
var $b6a51548cb76ae05$var$arrayEntries = $23a00ee3e029ff58$exports($c9b08ac37bf7fbb5$exports.entries);
var $b6a51548cb76ae05$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $b6a51548cb76ae05$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
var $b6a51548cb76ae05$var$TypedArrayPrototype = $b6a51548cb76ae05$var$Uint8Array && $b6a51548cb76ae05$var$Uint8Array.prototype;
var $b6a51548cb76ae05$var$GENERIC = !$7bdc373729e45e27$exports(function() {
    $b6a51548cb76ae05$var$TypedArrayPrototype[$b6a51548cb76ae05$var$ITERATOR].call([
        1
    ]);
});
var $b6a51548cb76ae05$var$ITERATOR_IS_VALUES = !!$b6a51548cb76ae05$var$TypedArrayPrototype && $b6a51548cb76ae05$var$TypedArrayPrototype.values && $b6a51548cb76ae05$var$TypedArrayPrototype[$b6a51548cb76ae05$var$ITERATOR] === $b6a51548cb76ae05$var$TypedArrayPrototype.values && $b6a51548cb76ae05$var$TypedArrayPrototype.values.name === "values";
var $b6a51548cb76ae05$var$typedArrayValues = function values() {
    return $b6a51548cb76ae05$var$arrayValues($b6a51548cb76ae05$var$aTypedArray(this));
};
// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
$b6a51548cb76ae05$var$exportTypedArrayMethod("entries", function entries() {
    return $b6a51548cb76ae05$var$arrayEntries($b6a51548cb76ae05$var$aTypedArray(this));
}, $b6a51548cb76ae05$var$GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
$b6a51548cb76ae05$var$exportTypedArrayMethod("keys", function keys() {
    return $b6a51548cb76ae05$var$arrayKeys($b6a51548cb76ae05$var$aTypedArray(this));
}, $b6a51548cb76ae05$var$GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
$b6a51548cb76ae05$var$exportTypedArrayMethod("values", $b6a51548cb76ae05$var$typedArrayValues, $b6a51548cb76ae05$var$GENERIC || !$b6a51548cb76ae05$var$ITERATOR_IS_VALUES, {
    name: "values"
});
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
$b6a51548cb76ae05$var$exportTypedArrayMethod($b6a51548cb76ae05$var$ITERATOR, $b6a51548cb76ae05$var$typedArrayValues, $b6a51548cb76ae05$var$GENERIC || !$b6a51548cb76ae05$var$ITERATOR_IS_VALUES, {
    name: "values"
});


"use strict";


var $6e5fe47029ea49bc$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $6e5fe47029ea49bc$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
var $6e5fe47029ea49bc$var$$join = $23a00ee3e029ff58$exports([].join);
// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
$6e5fe47029ea49bc$var$exportTypedArrayMethod("join", function join(separator) {
    return $6e5fe47029ea49bc$var$$join($6e5fe47029ea49bc$var$aTypedArray(this), separator);
});


"use strict";



var $f802137a9a5541e3$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $f802137a9a5541e3$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
$f802137a9a5541e3$var$exportTypedArrayMethod("lastIndexOf", function lastIndexOf(searchElement /* , fromIndex */ ) {
    var length = arguments.length;
    return $f275acb1973d253b$exports($c0b33fd547546697$exports, $f802137a9a5541e3$var$aTypedArray(this), length > 1 ? [
        searchElement,
        arguments[1]
    ] : [
        searchElement
    ]);
});


"use strict";


var $eb7a2f2b676a9e2a$require$$map = $d32fb3bde149eb49$exports.map;

var $eb7a2f2b676a9e2a$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $eb7a2f2b676a9e2a$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
$eb7a2f2b676a9e2a$var$exportTypedArrayMethod("map", function map(mapfn /* , thisArg */ ) {
    return $eb7a2f2b676a9e2a$require$$map($eb7a2f2b676a9e2a$var$aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function(O, length) {
        return new ($4e8cf3709288f98e$exports(O))(length);
    });
});


"use strict";


var $789a3d85b49f93c4$var$aTypedArrayConstructor = $5c744583e6986c06$exports.aTypedArrayConstructor;
var $789a3d85b49f93c4$var$exportTypedArrayStaticMethod = $5c744583e6986c06$exports.exportTypedArrayStaticMethod;
// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
$789a3d85b49f93c4$var$exportTypedArrayStaticMethod("of", function of() {
    var index = 0;
    var length = arguments.length;
    var result = new ($789a3d85b49f93c4$var$aTypedArrayConstructor(this))(length);
    while(length > index)result[index] = arguments[index++];
    return result;
}, $b082a18468c27384$exports);


"use strict";


var $f1836032779d29f1$require$$reduce = $1acdcfc5d8aef5ba$exports.left;
var $f1836032779d29f1$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $f1836032779d29f1$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
$f1836032779d29f1$var$exportTypedArrayMethod("reduce", function reduce(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $f1836032779d29f1$require$$reduce($f1836032779d29f1$var$aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


"use strict";


var $514600ab91eb4122$require$$reduceRight = $1acdcfc5d8aef5ba$exports.right;
var $514600ab91eb4122$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $514600ab91eb4122$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
$514600ab91eb4122$var$exportTypedArrayMethod("reduceRight", function reduceRight(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $514600ab91eb4122$require$$reduceRight($514600ab91eb4122$var$aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


"use strict";

var $a4a3c599e2e61454$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $a4a3c599e2e61454$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
var $a4a3c599e2e61454$var$floor = Math.floor;
// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
$a4a3c599e2e61454$var$exportTypedArrayMethod("reverse", function reverse() {
    var that = this;
    var length = $a4a3c599e2e61454$var$aTypedArray(that).length;
    var middle = $a4a3c599e2e61454$var$floor(length / 2);
    var index = 0;
    var value;
    while(index < middle){
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
    }
    return that;
});


"use strict";







var $77648409445c6825$var$RangeError = $0f4ea948f6673103$exports.RangeError;
var $77648409445c6825$var$Int8Array = $0f4ea948f6673103$exports.Int8Array;
var $77648409445c6825$var$Int8ArrayPrototype = $77648409445c6825$var$Int8Array && $77648409445c6825$var$Int8Array.prototype;
var $77648409445c6825$var$$set = $77648409445c6825$var$Int8ArrayPrototype && $77648409445c6825$var$Int8ArrayPrototype.set;
var $77648409445c6825$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $77648409445c6825$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
var $77648409445c6825$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $4b3fe34719193049$exports($77648409445c6825$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $77648409445c6825$var$TO_OBJECT_BUG = $77648409445c6825$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $5c744583e6986c06$exports.NATIVE_ARRAY_BUFFER_VIEWS && $7bdc373729e45e27$exports(function() {
    var array = new $77648409445c6825$var$Int8Array(2);
    array.set(1);
    array.set("2", 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$77648409445c6825$var$exportTypedArrayMethod("set", function set(arrayLike /* , offset */ ) {
    $77648409445c6825$var$aTypedArray(this);
    var offset = $d369d2689494fd50$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $7d5785aa2fc2b3e1$exports(arrayLike);
    if ($77648409445c6825$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $4b3fe34719193049$exports($77648409445c6825$var$$set, this, src, offset);
    var length = this.length;
    var len = $027f7f84b95594e7$exports(src);
    var index = 0;
    if (len + offset > length) throw new $77648409445c6825$var$RangeError("Wrong length");
    while(index < len)this[offset + index] = src[index++];
}, !$77648409445c6825$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $77648409445c6825$var$TO_OBJECT_BUG);


"use strict";




var $34888b68df1bef0c$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $34888b68df1bef0c$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
var $34888b68df1bef0c$var$FORCED = $7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    new Int8Array(1).slice();
});
// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
$34888b68df1bef0c$var$exportTypedArrayMethod("slice", function slice(start, end) {
    var list = $043da047ce6f37e9$exports($34888b68df1bef0c$var$aTypedArray(this), start, end);
    var C = $4e8cf3709288f98e$exports(this);
    var index = 0;
    var length = list.length;
    var result = new C(length);
    while(length > index)result[index] = list[index++];
    return result;
}, $34888b68df1bef0c$var$FORCED);


"use strict";


var $a4b1d8280632aed4$require$$some = $d32fb3bde149eb49$exports.some;
var $a4b1d8280632aed4$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $a4b1d8280632aed4$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
$a4b1d8280632aed4$var$exportTypedArrayMethod("some", function some(callbackfn /* , thisArg */ ) {
    return $a4b1d8280632aed4$require$$some($a4b1d8280632aed4$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";










var $ed7eed73b833a5fe$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $ed7eed73b833a5fe$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
var $ed7eed73b833a5fe$var$Uint16Array = $0f4ea948f6673103$exports.Uint16Array;
var $ed7eed73b833a5fe$var$nativeSort = $ed7eed73b833a5fe$var$Uint16Array && $92ca88fbf3cbbcaa$exports($ed7eed73b833a5fe$var$Uint16Array.prototype.sort);
// WebKit
var $ed7eed73b833a5fe$var$ACCEPT_INCORRECT_ARGUMENTS = !!$ed7eed73b833a5fe$var$nativeSort && !($7bdc373729e45e27$exports(function() {
    $ed7eed73b833a5fe$var$nativeSort(new $ed7eed73b833a5fe$var$Uint16Array(2), null);
}) && $7bdc373729e45e27$exports(function() {
    $ed7eed73b833a5fe$var$nativeSort(new $ed7eed73b833a5fe$var$Uint16Array(2), {});
}));
var $ed7eed73b833a5fe$var$STABLE_SORT = !!$ed7eed73b833a5fe$var$nativeSort && !$7bdc373729e45e27$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($d478a9aa1d363d00$exports) return $d478a9aa1d363d00$exports < 74;
    if ($8a1d74e2af462cb2$exports) return $8a1d74e2af462cb2$exports < 67;
    if ($3ac96019ccffde9a$exports) return true;
    if ($4a1556c357a98552$exports) return $4a1556c357a98552$exports < 602;
    var array = new $ed7eed73b833a5fe$var$Uint16Array(516);
    var expected = Array(516);
    var index, mod;
    for(index = 0; index < 516; index++){
        mod = index % 4;
        array[index] = 515 - index;
        expected[index] = index - 2 * mod + 3;
    }
    $ed7eed73b833a5fe$var$nativeSort(array, function(a, b) {
        return (a / 4 | 0) - (b / 4 | 0);
    });
    for(index = 0; index < 516; index++){
        if (array[index] !== expected[index]) return true;
    }
});
var $ed7eed73b833a5fe$var$getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (y !== y) return -1;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (x !== x) return 1;
        if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
        return x > y;
    };
};
// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
$ed7eed73b833a5fe$var$exportTypedArrayMethod("sort", function sort(comparefn) {
    if (comparefn !== undefined) $8b3f43e1fb85f635$exports(comparefn);
    if ($ed7eed73b833a5fe$var$STABLE_SORT) return $ed7eed73b833a5fe$var$nativeSort(this, comparefn);
    return $460f17b401c23fbc$exports($ed7eed73b833a5fe$var$aTypedArray(this), $ed7eed73b833a5fe$var$getSortCompare(comparefn));
}, !$ed7eed73b833a5fe$var$STABLE_SORT || $ed7eed73b833a5fe$var$ACCEPT_INCORRECT_ARGUMENTS);


"use strict";




var $ecdba332ce00f657$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $ecdba332ce00f657$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
$ecdba332ce00f657$var$exportTypedArrayMethod("subarray", function subarray(begin, end) {
    var O = $ecdba332ce00f657$var$aTypedArray(this);
    var length = O.length;
    var beginIndex = $4c10e2bcec3cf322$exports(begin, length);
    var C = $4e8cf3709288f98e$exports(O);
    return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, $8beae9420c83acf0$exports((end === undefined ? length : $4c10e2bcec3cf322$exports(end, length)) - beginIndex));
});


"use strict";





var $f5b6a4aacca9eabd$var$Int8Array = $0f4ea948f6673103$exports.Int8Array;
var $f5b6a4aacca9eabd$var$aTypedArray = $5c744583e6986c06$exports.aTypedArray;
var $f5b6a4aacca9eabd$var$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;
var $f5b6a4aacca9eabd$var$$toLocaleString = [].toLocaleString;
// iOS Safari 6.x fails here
var $f5b6a4aacca9eabd$var$TO_LOCALE_STRING_BUG = !!$f5b6a4aacca9eabd$var$Int8Array && $7bdc373729e45e27$exports(function() {
    $f5b6a4aacca9eabd$var$$toLocaleString.call(new $f5b6a4aacca9eabd$var$Int8Array(1));
});
var $f5b6a4aacca9eabd$var$FORCED = $7bdc373729e45e27$exports(function() {
    return [
        1,
        2
    ].toLocaleString() !== new $f5b6a4aacca9eabd$var$Int8Array([
        1,
        2
    ]).toLocaleString();
}) || !$7bdc373729e45e27$exports(function() {
    $f5b6a4aacca9eabd$var$Int8Array.prototype.toLocaleString.call([
        1,
        2
    ]);
});
// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
$f5b6a4aacca9eabd$var$exportTypedArrayMethod("toLocaleString", function toLocaleString() {
    return $f275acb1973d253b$exports($f5b6a4aacca9eabd$var$$toLocaleString, $f5b6a4aacca9eabd$var$TO_LOCALE_STRING_BUG ? $043da047ce6f37e9$exports($f5b6a4aacca9eabd$var$aTypedArray(this)) : $f5b6a4aacca9eabd$var$aTypedArray(this), $043da047ce6f37e9$exports(arguments));
}, $f5b6a4aacca9eabd$var$FORCED);


"use strict";

var $9506762db6aac511$require$exportTypedArrayMethod = $5c744583e6986c06$exports.exportTypedArrayMethod;



var $9506762db6aac511$var$Uint8Array = $0f4ea948f6673103$exports.Uint8Array;
var $9506762db6aac511$var$Uint8ArrayPrototype = $9506762db6aac511$var$Uint8Array && $9506762db6aac511$var$Uint8Array.prototype || {};
var $9506762db6aac511$var$arrayToString = [].toString;
var $9506762db6aac511$var$join = $23a00ee3e029ff58$exports([].join);
if ($7bdc373729e45e27$exports(function() {
    $9506762db6aac511$var$arrayToString.call({});
})) $9506762db6aac511$var$arrayToString = function toString() {
    return $9506762db6aac511$var$join(this);
};
var $9506762db6aac511$var$IS_NOT_ARRAY_METHOD = $9506762db6aac511$var$Uint8ArrayPrototype.toString !== $9506762db6aac511$var$arrayToString;
// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
$9506762db6aac511$require$exportTypedArrayMethod("toString", $9506762db6aac511$var$arrayToString, $9506762db6aac511$var$IS_NOT_ARRAY_METHOD);


"use strict";
"use strict";






var $631523a3a0a00100$exports = {};
"use strict";



var $631523a3a0a00100$require$getWeakData = $52aadfc22a57c5ff$exports.getWeakData;








var $631523a3a0a00100$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $631523a3a0a00100$var$internalStateGetterFor = $c70ec777954e7cbe$exports.getterFor;
var $631523a3a0a00100$var$find = $d32fb3bde149eb49$exports.find;
var $631523a3a0a00100$var$findIndex = $d32fb3bde149eb49$exports.findIndex;
var $631523a3a0a00100$var$splice = $23a00ee3e029ff58$exports([].splice);
var $631523a3a0a00100$var$id = 0;
// fallback for uncaught frozen keys
var $631523a3a0a00100$var$uncaughtFrozenStore = function uncaughtFrozenStore(state) {
    return state.frozen || (state.frozen = new $631523a3a0a00100$var$UncaughtFrozenStore());
};
var $631523a3a0a00100$var$UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.entries = [];
};
var $631523a3a0a00100$var$findUncaughtFrozen = function findUncaughtFrozen(store, key) {
    return $631523a3a0a00100$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$631523a3a0a00100$var$UncaughtFrozenStore.prototype = {
    get: function get(key) {
        var entry = $631523a3a0a00100$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function has(key) {
        return !!$631523a3a0a00100$var$findUncaughtFrozen(this, key);
    },
    set: function set(key, value) {
        var entry = $631523a3a0a00100$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $631523a3a0a00100$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $631523a3a0a00100$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$631523a3a0a00100$exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $cf50221949c767d8$exports(that, Prototype);
            $631523a3a0a00100$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $631523a3a0a00100$var$id++,
                frozen: undefined
            });
            if (!$76135a25443d684f$exports(iterable)) $e8d49b748288eae0$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $631523a3a0a00100$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var data = $631523a3a0a00100$require$getWeakData($c894fc907eeec831$exports(key), true);
            if (data === true) $631523a3a0a00100$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $58a816cd3ba07075$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$b1a75f6ed3e2d50f$exports(key)) return false;
                var data = $631523a3a0a00100$require$getWeakData(key);
                if (data === true) return $631523a3a0a00100$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $5f4f8ca39500aba6$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$b1a75f6ed3e2d50f$exports(key)) return false;
                var data = $631523a3a0a00100$require$getWeakData(key);
                if (data === true) return $631523a3a0a00100$var$uncaughtFrozenStore(state).has(key);
                return data && $5f4f8ca39500aba6$exports(data, state.id);
            }
        });
        $58a816cd3ba07075$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($b1a75f6ed3e2d50f$exports(key)) {
                    var data = $631523a3a0a00100$require$getWeakData(key);
                    if (data === true) return $631523a3a0a00100$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $b4ebe09230ad5e31$require$enforceInternalState = $c70ec777954e7cbe$exports.enforce;


var $b4ebe09230ad5e31$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $b4ebe09230ad5e31$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $b4ebe09230ad5e31$var$isExtensible = $b4ebe09230ad5e31$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $b4ebe09230ad5e31$var$isFrozen = $b4ebe09230ad5e31$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $b4ebe09230ad5e31$var$isSealed = $b4ebe09230ad5e31$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $b4ebe09230ad5e31$var$freeze = $b4ebe09230ad5e31$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $b4ebe09230ad5e31$var$seal = $b4ebe09230ad5e31$var$$Object.seal;
var $b4ebe09230ad5e31$var$FROZEN = {};
var $b4ebe09230ad5e31$var$SEALED = {};
var $b4ebe09230ad5e31$var$IS_IE11 = !$0f4ea948f6673103$exports.ActiveXObject && "ActiveXObject" in $0f4ea948f6673103$exports;
var $b4ebe09230ad5e31$var$InternalWeakMap;
var $b4ebe09230ad5e31$var$wrapper = function wrapper(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $b4ebe09230ad5e31$var$$WeakMap = $5d209f01e9f191f6$exports("WeakMap", $b4ebe09230ad5e31$var$wrapper, $631523a3a0a00100$exports);
var $b4ebe09230ad5e31$var$WeakMapPrototype = $b4ebe09230ad5e31$var$$WeakMap.prototype;
var $b4ebe09230ad5e31$var$nativeSet = $23a00ee3e029ff58$exports($b4ebe09230ad5e31$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $b4ebe09230ad5e31$var$hasMSEdgeFreezingBug = function hasMSEdgeFreezingBug() {
    return $a00e537c46774c22$exports && $7bdc373729e45e27$exports(function() {
        var frozenArray = $b4ebe09230ad5e31$var$freeze([]);
        $b4ebe09230ad5e31$var$nativeSet(new $b4ebe09230ad5e31$var$$WeakMap(), frozenArray, 1);
        return !$b4ebe09230ad5e31$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($c8f8e42caa16fad5$exports) {
    if ($b4ebe09230ad5e31$var$IS_IE11) {
        $b4ebe09230ad5e31$var$InternalWeakMap = $631523a3a0a00100$exports.getConstructor($b4ebe09230ad5e31$var$wrapper, "WeakMap", true);
        $52aadfc22a57c5ff$exports.enable();
        var $b4ebe09230ad5e31$var$nativeDelete = $23a00ee3e029ff58$exports($b4ebe09230ad5e31$var$WeakMapPrototype["delete"]);
        var $b4ebe09230ad5e31$var$nativeHas = $23a00ee3e029ff58$exports($b4ebe09230ad5e31$var$WeakMapPrototype.has);
        var $b4ebe09230ad5e31$var$nativeGet = $23a00ee3e029ff58$exports($b4ebe09230ad5e31$var$WeakMapPrototype.get);
        $58a816cd3ba07075$exports($b4ebe09230ad5e31$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($b1a75f6ed3e2d50f$exports(key) && !$b4ebe09230ad5e31$var$isExtensible(key)) {
                    var state = $b4ebe09230ad5e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $b4ebe09230ad5e31$var$InternalWeakMap();
                    return $b4ebe09230ad5e31$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $b4ebe09230ad5e31$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($b1a75f6ed3e2d50f$exports(key) && !$b4ebe09230ad5e31$var$isExtensible(key)) {
                    var state = $b4ebe09230ad5e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $b4ebe09230ad5e31$var$InternalWeakMap();
                    return $b4ebe09230ad5e31$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $b4ebe09230ad5e31$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($b1a75f6ed3e2d50f$exports(key) && !$b4ebe09230ad5e31$var$isExtensible(key)) {
                    var state = $b4ebe09230ad5e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $b4ebe09230ad5e31$var$InternalWeakMap();
                    return $b4ebe09230ad5e31$var$nativeHas(this, key) ? $b4ebe09230ad5e31$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $b4ebe09230ad5e31$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($b1a75f6ed3e2d50f$exports(key) && !$b4ebe09230ad5e31$var$isExtensible(key)) {
                    var state = $b4ebe09230ad5e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $b4ebe09230ad5e31$var$InternalWeakMap();
                    $b4ebe09230ad5e31$var$nativeHas(this, key) ? $b4ebe09230ad5e31$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $b4ebe09230ad5e31$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($b4ebe09230ad5e31$var$hasMSEdgeFreezingBug()) $58a816cd3ba07075$exports($b4ebe09230ad5e31$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($b4ebe09230ad5e31$var$isArray(key)) {
                if ($b4ebe09230ad5e31$var$isFrozen(key)) arrayIntegrityLevel = $b4ebe09230ad5e31$var$FROZEN;
                else if ($b4ebe09230ad5e31$var$isSealed(key)) arrayIntegrityLevel = $b4ebe09230ad5e31$var$SEALED;
            }
            $b4ebe09230ad5e31$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel === $b4ebe09230ad5e31$var$FROZEN) $b4ebe09230ad5e31$var$freeze(key);
            if (arrayIntegrityLevel === $b4ebe09230ad5e31$var$SEALED) $b4ebe09230ad5e31$var$seal(key);
            return this;
        }
    });
}




"use strict";
"use strict";


// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
$5d209f01e9f191f6$exports("WeakSet", function(init) {
    return function WeakSet() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $631523a3a0a00100$exports);




"use strict";
"use strict";
"use strict";








var $0467e5295039be8f$exports = {};
"use strict";


// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
$0467e5295039be8f$exports = function(O, options) {
    if ($b1a75f6ed3e2d50f$exports(options) && "cause" in options) $4bc121b672cbfd84$exports(O, "cause", options.cause);
};


var $dc8750263476b72a$exports = {};
"use strict";

var $f677a8a29c5d6bbf$exports = {};
"use strict";

var $f677a8a29c5d6bbf$var$$Error = Error;
var $f677a8a29c5d6bbf$var$replace = $23a00ee3e029ff58$exports("".replace);
var $f677a8a29c5d6bbf$var$TEST = function(arg) {
    return String(new $f677a8a29c5d6bbf$var$$Error(arg).stack);
}("zxcasd");
// eslint-disable-next-line redos/no-vulnerable -- safe
var $f677a8a29c5d6bbf$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $f677a8a29c5d6bbf$var$IS_V8_OR_CHAKRA_STACK = $f677a8a29c5d6bbf$var$V8_OR_CHAKRA_STACK_ENTRY.test($f677a8a29c5d6bbf$var$TEST);
$f677a8a29c5d6bbf$exports = function(stack, dropEntries) {
    if ($f677a8a29c5d6bbf$var$IS_V8_OR_CHAKRA_STACK && typeof stack == "string" && !$f677a8a29c5d6bbf$var$$Error.prepareStackTrace) while(dropEntries--)stack = $f677a8a29c5d6bbf$var$replace(stack, $f677a8a29c5d6bbf$var$V8_OR_CHAKRA_STACK_ENTRY, "");
    return stack;
};


var $3457688da81e4e71$exports = {};
"use strict";


$3457688da81e4e71$exports = !$7bdc373729e45e27$exports(function() {
    var error = new Error("a");
    if (!("stack" in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, "stack", $ca4a4ced04e4a412$exports(1, 7));
    return error.stack !== 7;
});


// non-standard V8
var $dc8750263476b72a$var$captureStackTrace = Error.captureStackTrace;
$dc8750263476b72a$exports = function(error, C, stack, dropEntries) {
    if ($3457688da81e4e71$exports) {
        if ($dc8750263476b72a$var$captureStackTrace) $dc8750263476b72a$var$captureStackTrace(error, C);
        else $4bc121b672cbfd84$exports(error, "stack", $f677a8a29c5d6bbf$exports(stack, dropEntries));
    }
};



var $e9ebdec42d0a744d$exports = {};
"use strict";

$e9ebdec42d0a744d$exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? "" : $default : $dd666817fb19c24c$exports(argument);
};



var $44f49d97cc48dd98$var$TO_STRING_TAG = $6c5fb57dad6dd350$exports("toStringTag");
var $44f49d97cc48dd98$var$$Error = Error;
var $44f49d97cc48dd98$var$push = [].push;
var $44f49d97cc48dd98$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $372efcd1340d8495$exports($44f49d97cc48dd98$var$AggregateErrorPrototype, this);
    var that;
    if ($5f3130f6ca40c617$exports) that = $5f3130f6ca40c617$exports(new $44f49d97cc48dd98$var$$Error(), isInstance ? $7acbb54af94d406d$exports(this) : $44f49d97cc48dd98$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $9959f3fdced32995$exports($44f49d97cc48dd98$var$AggregateErrorPrototype);
        $4bc121b672cbfd84$exports(that, $44f49d97cc48dd98$var$TO_STRING_TAG, "Error");
    }
    if (message !== undefined) $4bc121b672cbfd84$exports(that, "message", $e9ebdec42d0a744d$exports(message));
    $dc8750263476b72a$exports(that, $44f49d97cc48dd98$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $0467e5295039be8f$exports(that, arguments[2]);
    var errorsArray = [];
    $e8d49b748288eae0$exports(errors, $44f49d97cc48dd98$var$push, {
        that: errorsArray
    });
    $4bc121b672cbfd84$exports(that, "errors", errorsArray);
    return that;
};
if ($5f3130f6ca40c617$exports) $5f3130f6ca40c617$exports($44f49d97cc48dd98$var$$AggregateError, $44f49d97cc48dd98$var$$Error);
else $bc7f39059f462d6d$exports($44f49d97cc48dd98$var$$AggregateError, $44f49d97cc48dd98$var$$Error, {
    name: true
});
var $44f49d97cc48dd98$var$AggregateErrorPrototype = $44f49d97cc48dd98$var$$AggregateError.prototype = $9959f3fdced32995$exports($44f49d97cc48dd98$var$$Error.prototype, {
    constructor: $ca4a4ced04e4a412$exports(1, $44f49d97cc48dd98$var$$AggregateError),
    message: $ca4a4ced04e4a412$exports(1, ""),
    name: $ca4a4ced04e4a412$exports(1, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$d4b8e88525a1c695$exports({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $44f49d97cc48dd98$var$$AggregateError
});






"use strict";
"use strict";


// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$d4b8e88525a1c695$exports({
    global: true,
    forced: $0f4ea948f6673103$exports.globalThis !== $0f4ea948f6673103$exports
}, {
    globalThis: $0f4ea948f6673103$exports
});




"use strict";
"use strict";







// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$d4b8e88525a1c695$exports({
    target: "Promise",
    stat: true,
    forced: $d07ed8fcc8e17df7$exports
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $db4cd6ba42994757$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $fc39ffc6386506f8$exports(function() {
            var promiseResolve = $8b3f43e1fb85f635$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $e8d49b748288eae0$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $4b3fe34719193049$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});




"use strict";
"use strict";








var $90b21cff525f7877$var$PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$d4b8e88525a1c695$exports({
    target: "Promise",
    stat: true,
    forced: $d07ed8fcc8e17df7$exports
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $db85f9884fa161d0$exports("AggregateError");
        var capability = $db4cd6ba42994757$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $fc39ffc6386506f8$exports(function() {
            var promiseResolve = $8b3f43e1fb85f635$exports(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $e8d49b748288eae0$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $4b3fe34719193049$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $90b21cff525f7877$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $90b21cff525f7877$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});




"use strict";
"use strict";






















var $9a5b35fb04e57485$var$MATCH_ALL = $6c5fb57dad6dd350$exports("matchAll");
var $9a5b35fb04e57485$var$REGEXP_STRING = "RegExp String";
var $9a5b35fb04e57485$var$REGEXP_STRING_ITERATOR = $9a5b35fb04e57485$var$REGEXP_STRING + " Iterator";
var $9a5b35fb04e57485$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $9a5b35fb04e57485$var$getInternalState = $c70ec777954e7cbe$exports.getterFor($9a5b35fb04e57485$var$REGEXP_STRING_ITERATOR);
var $9a5b35fb04e57485$var$RegExpPrototype = RegExp.prototype;
var $9a5b35fb04e57485$var$$TypeError = TypeError;
var $9a5b35fb04e57485$var$stringIndexOf = $92ca88fbf3cbbcaa$exports("".indexOf);
var $9a5b35fb04e57485$var$nativeMatchAll = $92ca88fbf3cbbcaa$exports("".matchAll);
var $9a5b35fb04e57485$var$WORKS_WITH_NON_GLOBAL_REGEX = !!$9a5b35fb04e57485$var$nativeMatchAll && !$7bdc373729e45e27$exports(function() {
    $9a5b35fb04e57485$var$nativeMatchAll("a", /./);
});
var $9a5b35fb04e57485$var$$RegExpStringIterator = $4377040e1fda8d6a$exports(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
    $9a5b35fb04e57485$var$setInternalState(this, {
        type: $9a5b35fb04e57485$var$REGEXP_STRING_ITERATOR,
        regexp: regexp,
        string: string,
        global: $global,
        unicode: fullUnicode,
        done: false
    });
}, $9a5b35fb04e57485$var$REGEXP_STRING, function next() {
    var state = $9a5b35fb04e57485$var$getInternalState(this);
    if (state.done) return $ecc47fe671ebbad0$exports(undefined, true);
    var R = state.regexp;
    var S = state.string;
    var match = $ffa336a6a4395145$exports(R, S);
    if (match === null) {
        state.done = true;
        return $ecc47fe671ebbad0$exports(undefined, true);
    }
    if (state.global) {
        if ($dd666817fb19c24c$exports(match[0]) === "") R.lastIndex = $0d93e8e6f857b923$exports(S, $8beae9420c83acf0$exports(R.lastIndex), state.unicode);
        return $ecc47fe671ebbad0$exports(match, false);
    }
    state.done = true;
    return $ecc47fe671ebbad0$exports(match, false);
});
var $9a5b35fb04e57485$var$$matchAll = function $matchAll(string) {
    var R = $c894fc907eeec831$exports(this);
    var S = $dd666817fb19c24c$exports(string);
    var C = $11472182d06f3dc1$exports(R, RegExp);
    var flags = $dd666817fb19c24c$exports($aa94276429cd93de$exports(R));
    var matcher, $global, fullUnicode;
    matcher = new C(C === RegExp ? R.source : R, flags);
    $global = !!~$9a5b35fb04e57485$var$stringIndexOf(flags, "g");
    fullUnicode = !!~$9a5b35fb04e57485$var$stringIndexOf(flags, "u");
    matcher.lastIndex = $8beae9420c83acf0$exports(R.lastIndex);
    return new $9a5b35fb04e57485$var$$RegExpStringIterator(matcher, S, $global, fullUnicode);
};
// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true,
    forced: $9a5b35fb04e57485$var$WORKS_WITH_NON_GLOBAL_REGEX
}, {
    matchAll: function matchAll(regexp) {
        var O = $ddbaa5896e5ed636$exports(this);
        var flags, S, matcher, rx;
        if (!$76135a25443d684f$exports(regexp)) {
            if ($ad24a4561be7fb63$exports(regexp)) {
                flags = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports($aa94276429cd93de$exports(regexp)));
                if (!~$9a5b35fb04e57485$var$stringIndexOf(flags, "g")) throw new $9a5b35fb04e57485$var$$TypeError("`.matchAll` does not allow non-global regexes");
            }
            if ($9a5b35fb04e57485$var$WORKS_WITH_NON_GLOBAL_REGEX) return $9a5b35fb04e57485$var$nativeMatchAll(O, regexp);
            matcher = $f29b070ab2fd2ce7$exports(regexp, $9a5b35fb04e57485$var$MATCH_ALL);
            if (matcher === undefined && $bad8555d514b807c$exports && $4cba9a2acb4bdb16$exports(regexp) === "RegExp") matcher = $9a5b35fb04e57485$var$$matchAll;
            if (matcher) return $4b3fe34719193049$exports(matcher, regexp, O);
        } else if ($9a5b35fb04e57485$var$WORKS_WITH_NON_GLOBAL_REGEX) return $9a5b35fb04e57485$var$nativeMatchAll(O, regexp);
        S = $dd666817fb19c24c$exports(O);
        rx = new RegExp(regexp, "g");
        return $bad8555d514b807c$exports ? $4b3fe34719193049$exports($9a5b35fb04e57485$var$$matchAll, rx, S) : rx[$9a5b35fb04e57485$var$MATCH_ALL](S);
    }
});
$bad8555d514b807c$exports || $9a5b35fb04e57485$var$MATCH_ALL in $9a5b35fb04e57485$var$RegExpPrototype || $f488b1cc13335fff$exports($9a5b35fb04e57485$var$RegExpPrototype, $9a5b35fb04e57485$var$MATCH_ALL, $9a5b35fb04e57485$var$$matchAll);




"use strict";
"use strict";













var $8cd88f444c32d064$var$REPLACE = $6c5fb57dad6dd350$exports("replace");
var $8cd88f444c32d064$var$$TypeError = TypeError;
var $8cd88f444c32d064$var$indexOf = $23a00ee3e029ff58$exports("".indexOf);
var $8cd88f444c32d064$var$replace = $23a00ee3e029ff58$exports("".replace);
var $8cd88f444c32d064$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $8cd88f444c32d064$var$max = Math.max;
var $8cd88f444c32d064$var$stringIndexOf = function stringIndexOf(string, searchValue, fromIndex) {
    if (fromIndex > string.length) return -1;
    if (searchValue === "") return fromIndex;
    return $8cd88f444c32d064$var$indexOf(string, searchValue, fromIndex);
};
// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$d4b8e88525a1c695$exports({
    target: "String",
    proto: true
}, {
    replaceAll: function replaceAll(searchValue, replaceValue) {
        var O = $ddbaa5896e5ed636$exports(this);
        var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
        var position = 0;
        var endOfLastMatch = 0;
        var result = "";
        if (!$76135a25443d684f$exports(searchValue)) {
            IS_REG_EXP = $ad24a4561be7fb63$exports(searchValue);
            if (IS_REG_EXP) {
                flags = $dd666817fb19c24c$exports($ddbaa5896e5ed636$exports($aa94276429cd93de$exports(searchValue)));
                if (!~$8cd88f444c32d064$var$indexOf(flags, "g")) throw new $8cd88f444c32d064$var$$TypeError("`.replaceAll` does not allow non-global regexes");
            }
            replacer = $f29b070ab2fd2ce7$exports(searchValue, $8cd88f444c32d064$var$REPLACE);
            if (replacer) return $4b3fe34719193049$exports(replacer, searchValue, O, replaceValue);
            else if ($bad8555d514b807c$exports && IS_REG_EXP) return $8cd88f444c32d064$var$replace($dd666817fb19c24c$exports(O), searchValue, replaceValue);
        }
        string = $dd666817fb19c24c$exports(O);
        searchString = $dd666817fb19c24c$exports(searchValue);
        functionalReplace = $64c802885f841370$exports(replaceValue);
        if (!functionalReplace) replaceValue = $dd666817fb19c24c$exports(replaceValue);
        searchLength = searchString.length;
        advanceBy = $8cd88f444c32d064$var$max(1, searchLength);
        position = $8cd88f444c32d064$var$stringIndexOf(string, searchString, 0);
        while(position !== -1){
            replacement = functionalReplace ? $dd666817fb19c24c$exports(replaceValue(searchString, position, string)) : $be5ce849ce561839$exports(searchString, string, position, [], undefined, replaceValue);
            result += $8cd88f444c32d064$var$stringSlice(string, endOfLastMatch, position) + replacement;
            endOfLastMatch = position + searchLength;
            position = $8cd88f444c32d064$var$stringIndexOf(string, searchString, position + advanceBy);
        }
        if (endOfLastMatch < string.length) result += $8cd88f444c32d064$var$stringSlice(string, endOfLastMatch);
        return result;
    }
});




"use strict";



var $023982941fd8359c$require$defineProperty = $18b1ebdefa97b93b$export$2d1720544b23b823;

var $023982941fd8359c$require$getOwnPropertyDescriptor = $003023ef435958c5$export$2d1720544b23b823;
var $023982941fd8359c$var$Symbol = $0f4ea948f6673103$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$b00a4c7565f1ee0f$exports("dispose");
if ($023982941fd8359c$var$Symbol) {
    var $023982941fd8359c$var$descriptor = $023982941fd8359c$require$getOwnPropertyDescriptor($023982941fd8359c$var$Symbol, "dispose");
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($023982941fd8359c$var$descriptor.enumerable && $023982941fd8359c$var$descriptor.configurable && $023982941fd8359c$var$descriptor.writable) $023982941fd8359c$require$defineProperty($023982941fd8359c$var$Symbol, "dispose", {
        value: $023982941fd8359c$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}


"use strict";

var $3cd1259027029b31$exports = {};
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$3cd1259027029b31$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $27fb3d8fb71d7865$exports = {};
"use strict";

var $27fb3d8fb71d7865$var$classList = $ef80f2f49f1eda1a$exports("span").classList;
var $27fb3d8fb71d7865$var$DOMTokenListPrototype = $27fb3d8fb71d7865$var$classList && $27fb3d8fb71d7865$var$classList.constructor && $27fb3d8fb71d7865$var$classList.constructor.prototype;
$27fb3d8fb71d7865$exports = $27fb3d8fb71d7865$var$DOMTokenListPrototype === Object.prototype ? undefined : $27fb3d8fb71d7865$var$DOMTokenListPrototype;


var $a6ca40248ce6946c$exports = {};
"use strict";

var $a6ca40248ce6946c$require$$forEach = $d32fb3bde149eb49$exports.forEach;

var $a6ca40248ce6946c$var$STRICT_METHOD = $bbbf81a67afd4255$exports("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
$a6ca40248ce6946c$exports = !$a6ca40248ce6946c$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $a6ca40248ce6946c$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;



var $f146f030e629ab1f$var$handlePrototype = function handlePrototype(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== $a6ca40248ce6946c$exports) try {
        $4bc121b672cbfd84$exports(CollectionPrototype, "forEach", $a6ca40248ce6946c$exports);
    } catch (error) {
        CollectionPrototype.forEach = $a6ca40248ce6946c$exports;
    }
};
for(var $f146f030e629ab1f$var$COLLECTION_NAME in $3cd1259027029b31$exports)if ($3cd1259027029b31$exports[$f146f030e629ab1f$var$COLLECTION_NAME]) $f146f030e629ab1f$var$handlePrototype($0f4ea948f6673103$exports[$f146f030e629ab1f$var$COLLECTION_NAME] && $0f4ea948f6673103$exports[$f146f030e629ab1f$var$COLLECTION_NAME].prototype);
$f146f030e629ab1f$var$handlePrototype($27fb3d8fb71d7865$exports);


"use strict";







var $8d5a8083b43094c1$var$ITERATOR = $6c5fb57dad6dd350$exports("iterator");
var $8d5a8083b43094c1$var$ArrayValues = $c9b08ac37bf7fbb5$exports.values;
var $8d5a8083b43094c1$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$8d5a8083b43094c1$var$ITERATOR] !== $8d5a8083b43094c1$var$ArrayValues) try {
            $4bc121b672cbfd84$exports(CollectionPrototype, $8d5a8083b43094c1$var$ITERATOR, $8d5a8083b43094c1$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$8d5a8083b43094c1$var$ITERATOR] = $8d5a8083b43094c1$var$ArrayValues;
        }
        $0590ceb3c9c577a7$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($3cd1259027029b31$exports[COLLECTION_NAME]) for(var METHOD_NAME in $c9b08ac37bf7fbb5$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $c9b08ac37bf7fbb5$exports[METHOD_NAME]) try {
                $4bc121b672cbfd84$exports(CollectionPrototype, METHOD_NAME, $c9b08ac37bf7fbb5$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $c9b08ac37bf7fbb5$exports[METHOD_NAME];
            }
        }
    }
};
for(var $8d5a8083b43094c1$var$COLLECTION_NAME in $3cd1259027029b31$exports)$8d5a8083b43094c1$var$handlePrototype($0f4ea948f6673103$exports[$8d5a8083b43094c1$var$COLLECTION_NAME] && $0f4ea948f6673103$exports[$8d5a8083b43094c1$var$COLLECTION_NAME].prototype, $8d5a8083b43094c1$var$COLLECTION_NAME);
$8d5a8083b43094c1$var$handlePrototype($27fb3d8fb71d7865$exports, "DOMTokenList");


"use strict";
"use strict";



var $cab610cf3a5058e8$require$clearImmediate = $b547defd499f8b78$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$d4b8e88525a1c695$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $0f4ea948f6673103$exports.clearImmediate !== $cab610cf3a5058e8$require$clearImmediate
}, {
    clearImmediate: $cab610cf3a5058e8$require$clearImmediate
});


"use strict";



var $541a42f52edb9278$require$setTask = $b547defd499f8b78$exports.set;
var $0fe49de6824e0076$exports = {};
"use strict";



var $bf872244bb70d6fc$exports = {};
"use strict";
/* global Bun -- Bun case */ $bf872244bb70d6fc$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $0fe49de6824e0076$var$Function = $0f4ea948f6673103$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $0fe49de6824e0076$var$WRAP = /MSIE .\./.test($4e05041f80099315$exports) || $bf872244bb70d6fc$exports && function() {
    var version = $0f4ea948f6673103$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$0fe49de6824e0076$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $0fe49de6824e0076$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $9a0959ea981d3a43$exports(arguments.length, 1) > firstParamIndex;
        var fn = $64c802885f841370$exports(handler) ? handler : $0fe49de6824e0076$var$Function(handler);
        var params = boundArgs ? $043da047ce6f37e9$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function callback() {
            $f275acb1973d253b$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $541a42f52edb9278$var$setImmediate = $0f4ea948f6673103$exports.setImmediate ? $0fe49de6824e0076$exports($541a42f52edb9278$require$setTask, false) : $541a42f52edb9278$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$d4b8e88525a1c695$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $0f4ea948f6673103$exports.setImmediate !== $541a42f52edb9278$var$setImmediate
}, {
    setImmediate: $541a42f52edb9278$var$setImmediate
});




"use strict";






var $e4a4241618ab446e$var$process = $0f4ea948f6673103$exports.process;
// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$d4b8e88525a1c695$exports({
    global: true,
    enumerable: true,
    dontCallGetSet: true
}, {
    queueMicrotask: function queueMicrotask(fn) {
        $9a0959ea981d3a43$exports(arguments.length, 1);
        $8b3f43e1fb85f635$exports(fn);
        var domain = $02bca89736833817$exports && $e4a4241618ab446e$var$process.domain;
        $6016ed5092740f73$exports(domain ? domain.bind(fn) : fn);
    }
});


"use strict";
"use strict";



var $7cbb4ff95f660138$exports = {};
"use strict";




var $7cbb4ff95f660138$var$ITERATOR = $6c5fb57dad6dd350$exports("iterator");
$7cbb4ff95f660138$exports = !$7bdc373729e45e27$exports(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL("b?a=1&b=2&c=3", "http://a");
    var params = url.searchParams;
    var params2 = new URLSearchParams("a=1&a=2&b=3");
    var result = "";
    url.pathname = "c%20d";
    params.forEach(function(value, key) {
        params["delete"]("b");
        result += key + value;
    });
    params2["delete"]("a", 2);
    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    params2["delete"]("b", undefined);
    return $bad8555d514b807c$exports && (!url.toJSON || !params2.has("a", 1) || params2.has("a", 2) || !params2.has("a", undefined) || params2.has("b")) || !params.size && ($bad8555d514b807c$exports || !$40260b59b65c2e4c$exports) || !params.sort || url.href !== "http://a/c%20d?a=1&c=3" || params.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !params[$7cbb4ff95f660138$var$ITERATOR] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://тест").host !== "xn--e1aybc" || new URL("http://a#б").hash !== "#%D0%B1" || result !== "a1c3" || new URL("http://x", undefined).host !== "x";
});













var $0a78e95513df5e72$require$codeAt = $c1b384f4ceb18d47$exports.codeAt;
var $11cc6f98fae8e925$exports = {};
"use strict";

var $11cc6f98fae8e925$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var $11cc6f98fae8e925$var$base = 36;
var $11cc6f98fae8e925$var$tMin = 1;
var $11cc6f98fae8e925$var$tMax = 26;
var $11cc6f98fae8e925$var$skew = 38;
var $11cc6f98fae8e925$var$damp = 700;
var $11cc6f98fae8e925$var$initialBias = 72;
var $11cc6f98fae8e925$var$initialN = 128; // 0x80
var $11cc6f98fae8e925$var$delimiter = "-"; // '\x2D'
var $11cc6f98fae8e925$var$regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var $11cc6f98fae8e925$var$regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var $11cc6f98fae8e925$var$OVERFLOW_ERROR = "Overflow: input needs wider integers to process";
var $11cc6f98fae8e925$var$baseMinusTMin = $11cc6f98fae8e925$var$base - $11cc6f98fae8e925$var$tMin;
var $11cc6f98fae8e925$var$$RangeError = RangeError;
var $11cc6f98fae8e925$var$exec = $23a00ee3e029ff58$exports($11cc6f98fae8e925$var$regexSeparators.exec);
var $11cc6f98fae8e925$var$floor = Math.floor;
var $11cc6f98fae8e925$var$fromCharCode = String.fromCharCode;
var $11cc6f98fae8e925$var$charCodeAt = $23a00ee3e029ff58$exports("".charCodeAt);
var $11cc6f98fae8e925$var$join = $23a00ee3e029ff58$exports([].join);
var $11cc6f98fae8e925$var$push = $23a00ee3e029ff58$exports([].push);
var $11cc6f98fae8e925$var$replace = $23a00ee3e029ff58$exports("".replace);
var $11cc6f98fae8e925$var$split = $23a00ee3e029ff58$exports("".split);
var $11cc6f98fae8e925$var$toLowerCase = $23a00ee3e029ff58$exports("".toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var $11cc6f98fae8e925$var$ucs2decode = function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = $11cc6f98fae8e925$var$charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = $11cc6f98fae8e925$var$charCodeAt(string, counter++);
            if ((extra & 0xFC00) === 0xDC00) $11cc6f98fae8e925$var$push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                $11cc6f98fae8e925$var$push(output, value);
                counter--;
            }
        } else $11cc6f98fae8e925$var$push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var $11cc6f98fae8e925$var$digitToBasic = function digitToBasic(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var $11cc6f98fae8e925$var$adapt = function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $11cc6f98fae8e925$var$floor(delta / $11cc6f98fae8e925$var$damp) : delta >> 1;
    delta += $11cc6f98fae8e925$var$floor(delta / numPoints);
    while(delta > $11cc6f98fae8e925$var$baseMinusTMin * $11cc6f98fae8e925$var$tMax >> 1){
        delta = $11cc6f98fae8e925$var$floor(delta / $11cc6f98fae8e925$var$baseMinusTMin);
        k += $11cc6f98fae8e925$var$base;
    }
    return $11cc6f98fae8e925$var$floor(k + ($11cc6f98fae8e925$var$baseMinusTMin + 1) * delta / (delta + $11cc6f98fae8e925$var$skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var $11cc6f98fae8e925$var$encode = function encode(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $11cc6f98fae8e925$var$ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = $11cc6f98fae8e925$var$initialN;
    var delta = 0;
    var bias = $11cc6f98fae8e925$var$initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) $11cc6f98fae8e925$var$push(output, $11cc6f98fae8e925$var$fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) $11cc6f98fae8e925$var$push(output, $11cc6f98fae8e925$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = $11cc6f98fae8e925$var$maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $11cc6f98fae8e925$var$floor(($11cc6f98fae8e925$var$maxInt - delta) / handledCPCountPlusOne)) throw new $11cc6f98fae8e925$var$$RangeError($11cc6f98fae8e925$var$OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > $11cc6f98fae8e925$var$maxInt) throw new $11cc6f98fae8e925$var$$RangeError($11cc6f98fae8e925$var$OVERFLOW_ERROR);
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = $11cc6f98fae8e925$var$base;
                while(true){
                    var t = k <= bias ? $11cc6f98fae8e925$var$tMin : k >= bias + $11cc6f98fae8e925$var$tMax ? $11cc6f98fae8e925$var$tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = $11cc6f98fae8e925$var$base - t;
                    $11cc6f98fae8e925$var$push(output, $11cc6f98fae8e925$var$fromCharCode($11cc6f98fae8e925$var$digitToBasic(t + qMinusT % baseMinusT)));
                    q = $11cc6f98fae8e925$var$floor(qMinusT / baseMinusT);
                    k += $11cc6f98fae8e925$var$base;
                }
                $11cc6f98fae8e925$var$push(output, $11cc6f98fae8e925$var$fromCharCode($11cc6f98fae8e925$var$digitToBasic(q)));
                bias = $11cc6f98fae8e925$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return $11cc6f98fae8e925$var$join(output, "");
};
$11cc6f98fae8e925$exports = function(input) {
    var encoded = [];
    var labels = $11cc6f98fae8e925$var$split($11cc6f98fae8e925$var$replace($11cc6f98fae8e925$var$toLowerCase(input), $11cc6f98fae8e925$var$regexSeparators, "."), ".");
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        $11cc6f98fae8e925$var$push(encoded, $11cc6f98fae8e925$var$exec($11cc6f98fae8e925$var$regexNonASCII, label) ? "xn--" + $11cc6f98fae8e925$var$encode(label) : label);
    }
    return $11cc6f98fae8e925$var$join(encoded, ".");
};





var $5e0d06bbca8ef0bc$exports = {};
"use strict";





























var $5e0d06bbca8ef0bc$var$ITERATOR = $6c5fb57dad6dd350$exports("iterator");
var $5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS = "URLSearchParams";
var $5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS_ITERATOR = $5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS + "Iterator";
var $5e0d06bbca8ef0bc$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $5e0d06bbca8ef0bc$var$getInternalParamsState = $c70ec777954e7cbe$exports.getterFor($5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS);
var $5e0d06bbca8ef0bc$var$getInternalIteratorState = $c70ec777954e7cbe$exports.getterFor($5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5e0d06bbca8ef0bc$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
var $5e0d06bbca8ef0bc$var$safeGetBuiltIn = function safeGetBuiltIn(name) {
    if (!$40260b59b65c2e4c$exports) return $0f4ea948f6673103$exports[name];
    var descriptor = $5e0d06bbca8ef0bc$var$getOwnPropertyDescriptor($0f4ea948f6673103$exports, name);
    return descriptor && descriptor.value;
};
var $5e0d06bbca8ef0bc$var$nativeFetch = $5e0d06bbca8ef0bc$var$safeGetBuiltIn("fetch");
var $5e0d06bbca8ef0bc$var$NativeRequest = $5e0d06bbca8ef0bc$var$safeGetBuiltIn("Request");
var $5e0d06bbca8ef0bc$var$Headers = $5e0d06bbca8ef0bc$var$safeGetBuiltIn("Headers");
var $5e0d06bbca8ef0bc$var$RequestPrototype = $5e0d06bbca8ef0bc$var$NativeRequest && $5e0d06bbca8ef0bc$var$NativeRequest.prototype;
var $5e0d06bbca8ef0bc$var$HeadersPrototype = $5e0d06bbca8ef0bc$var$Headers && $5e0d06bbca8ef0bc$var$Headers.prototype;
var $5e0d06bbca8ef0bc$var$RegExp = $0f4ea948f6673103$exports.RegExp;
var $5e0d06bbca8ef0bc$var$TypeError = $0f4ea948f6673103$exports.TypeError;
var $5e0d06bbca8ef0bc$var$decodeURIComponent = $0f4ea948f6673103$exports.decodeURIComponent;
var $5e0d06bbca8ef0bc$var$encodeURIComponent = $0f4ea948f6673103$exports.encodeURIComponent;
var $5e0d06bbca8ef0bc$var$charAt = $23a00ee3e029ff58$exports("".charAt);
var $5e0d06bbca8ef0bc$var$join = $23a00ee3e029ff58$exports([].join);
var $5e0d06bbca8ef0bc$var$push = $23a00ee3e029ff58$exports([].push);
var $5e0d06bbca8ef0bc$var$replace = $23a00ee3e029ff58$exports("".replace);
var $5e0d06bbca8ef0bc$var$shift = $23a00ee3e029ff58$exports([].shift);
var $5e0d06bbca8ef0bc$var$splice = $23a00ee3e029ff58$exports([].splice);
var $5e0d06bbca8ef0bc$var$split = $23a00ee3e029ff58$exports("".split);
var $5e0d06bbca8ef0bc$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $5e0d06bbca8ef0bc$var$plus = /\+/g;
var $5e0d06bbca8ef0bc$var$sequences = Array(4);
var $5e0d06bbca8ef0bc$var$percentSequence = function percentSequence(bytes) {
    return $5e0d06bbca8ef0bc$var$sequences[bytes - 1] || ($5e0d06bbca8ef0bc$var$sequences[bytes - 1] = $5e0d06bbca8ef0bc$var$RegExp("((?:%[\\da-f]{2}){" + bytes + "})", "gi"));
};
var $5e0d06bbca8ef0bc$var$percentDecode = function percentDecode(sequence) {
    try {
        return $5e0d06bbca8ef0bc$var$decodeURIComponent(sequence);
    } catch (error) {
        return sequence;
    }
};
var $5e0d06bbca8ef0bc$var$deserialize = function deserialize(it) {
    var result = $5e0d06bbca8ef0bc$var$replace(it, $5e0d06bbca8ef0bc$var$plus, " ");
    var bytes = 4;
    try {
        return $5e0d06bbca8ef0bc$var$decodeURIComponent(result);
    } catch (error) {
        while(bytes)result = $5e0d06bbca8ef0bc$var$replace(result, $5e0d06bbca8ef0bc$var$percentSequence(bytes--), $5e0d06bbca8ef0bc$var$percentDecode);
        return result;
    }
};
var $5e0d06bbca8ef0bc$var$find = /[!'()~]|%20/g;
var $5e0d06bbca8ef0bc$var$replacements = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
};
var $5e0d06bbca8ef0bc$var$replacer = function replacer(match) {
    return $5e0d06bbca8ef0bc$var$replacements[match];
};
var $5e0d06bbca8ef0bc$var$serialize = function serialize(it) {
    return $5e0d06bbca8ef0bc$var$replace($5e0d06bbca8ef0bc$var$encodeURIComponent(it), $5e0d06bbca8ef0bc$var$find, $5e0d06bbca8ef0bc$var$replacer);
};
var $5e0d06bbca8ef0bc$var$URLSearchParamsIterator = $4377040e1fda8d6a$exports(function Iterator(params, kind) {
    $5e0d06bbca8ef0bc$var$setInternalState(this, {
        type: $5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS_ITERATOR,
        target: $5e0d06bbca8ef0bc$var$getInternalParamsState(params).entries,
        index: 0,
        kind: kind
    });
}, $5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS, function next() {
    var state = $5e0d06bbca8ef0bc$var$getInternalIteratorState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $ecc47fe671ebbad0$exports(undefined, true);
    }
    var entry = target[index];
    switch(state.kind){
        case "keys":
            return $ecc47fe671ebbad0$exports(entry.key, false);
        case "values":
            return $ecc47fe671ebbad0$exports(entry.value, false);
    }
    return $ecc47fe671ebbad0$exports([
        entry.key,
        entry.value
    ], false);
}, true);
var $5e0d06bbca8ef0bc$var$URLSearchParamsState = function URLSearchParamsState(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if ($b1a75f6ed3e2d50f$exports(init)) this.parseObject(init);
        else this.parseQuery(typeof init == "string" ? $5e0d06bbca8ef0bc$var$charAt(init, 0) === "?" ? $5e0d06bbca8ef0bc$var$stringSlice(init, 1) : init : $dd666817fb19c24c$exports(init));
    }
};
$5e0d06bbca8ef0bc$var$URLSearchParamsState.prototype = {
    type: $5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS,
    bindURL: function bindURL(url) {
        this.url = url;
        this.update();
    },
    parseObject: function parseObject(object) {
        var entries = this.entries;
        var iteratorMethod = $1ffb58790ca29df3$exports(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = $246adf013c49aea4$exports(object, iteratorMethod);
            next = iterator.next;
            while(!(step = $4b3fe34719193049$exports(next, iterator)).done){
                entryIterator = $246adf013c49aea4$exports($c894fc907eeec831$exports(step.value));
                entryNext = entryIterator.next;
                if ((first = $4b3fe34719193049$exports(entryNext, entryIterator)).done || (second = $4b3fe34719193049$exports(entryNext, entryIterator)).done || !$4b3fe34719193049$exports(entryNext, entryIterator).done) throw new $5e0d06bbca8ef0bc$var$TypeError("Expected sequence with length 2");
                $5e0d06bbca8ef0bc$var$push(entries, {
                    key: $dd666817fb19c24c$exports(first.value),
                    value: $dd666817fb19c24c$exports(second.value)
                });
            }
        } else for(var key in object)if ($5f4f8ca39500aba6$exports(object, key)) $5e0d06bbca8ef0bc$var$push(entries, {
            key: key,
            value: $dd666817fb19c24c$exports(object[key])
        });
    },
    parseQuery: function parseQuery(query) {
        if (query) {
            var entries = this.entries;
            var attributes = $5e0d06bbca8ef0bc$var$split(query, "&");
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = $5e0d06bbca8ef0bc$var$split(attribute, "=");
                    $5e0d06bbca8ef0bc$var$push(entries, {
                        key: $5e0d06bbca8ef0bc$var$deserialize($5e0d06bbca8ef0bc$var$shift(entry)),
                        value: $5e0d06bbca8ef0bc$var$deserialize($5e0d06bbca8ef0bc$var$join(entry, "="))
                    });
                }
            }
        }
    },
    serialize: function serialize1() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            $5e0d06bbca8ef0bc$var$push(result, $5e0d06bbca8ef0bc$var$serialize(entry.key) + "=" + $5e0d06bbca8ef0bc$var$serialize(entry.value));
        }
        return $5e0d06bbca8ef0bc$var$join(result, "&");
    },
    update: function update() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function updateURL() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var $5e0d06bbca8ef0bc$var$URLSearchParamsConstructor = function URLSearchParams() {
    $cf50221949c767d8$exports(this, $5e0d06bbca8ef0bc$var$URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var state = $5e0d06bbca8ef0bc$var$setInternalState(this, new $5e0d06bbca8ef0bc$var$URLSearchParamsState(init));
    if (!$40260b59b65c2e4c$exports) this.size = state.entries.length;
};
var $5e0d06bbca8ef0bc$var$URLSearchParamsPrototype = $5e0d06bbca8ef0bc$var$URLSearchParamsConstructor.prototype;
$58a816cd3ba07075$exports($5e0d06bbca8ef0bc$var$URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        var state = $5e0d06bbca8ef0bc$var$getInternalParamsState(this);
        $9a0959ea981d3a43$exports(arguments.length, 2);
        $5e0d06bbca8ef0bc$var$push(state.entries, {
            key: $dd666817fb19c24c$exports(name),
            value: $dd666817fb19c24c$exports(value)
        });
        if (!$40260b59b65c2e4c$exports) this.length++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    "delete": function(name /* , value */ ) {
        var state = $5e0d06bbca8ef0bc$var$getInternalParamsState(this);
        var length = $9a0959ea981d3a43$exports(arguments.length, 1);
        var entries = state.entries;
        var key = $dd666817fb19c24c$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $dd666817fb19c24c$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index];
            if (entry.key === key && (value === undefined || entry.value === value)) {
                $5e0d06bbca8ef0bc$var$splice(entries, index, 1);
                if (value !== undefined) break;
            } else index++;
        }
        if (!$40260b59b65c2e4c$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        var entries = $5e0d06bbca8ef0bc$var$getInternalParamsState(this).entries;
        $9a0959ea981d3a43$exports(arguments.length, 1);
        var key = $dd666817fb19c24c$exports(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        var entries = $5e0d06bbca8ef0bc$var$getInternalParamsState(this).entries;
        $9a0959ea981d3a43$exports(arguments.length, 1);
        var key = $dd666817fb19c24c$exports(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) $5e0d06bbca8ef0bc$var$push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name /* , value */ ) {
        var entries = $5e0d06bbca8ef0bc$var$getInternalParamsState(this).entries;
        var length = $9a0959ea981d3a43$exports(arguments.length, 1);
        var key = $dd666817fb19c24c$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $dd666817fb19c24c$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index++];
            if (entry.key === key && (value === undefined || entry.value === value)) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        var state = $5e0d06bbca8ef0bc$var$getInternalParamsState(this);
        $9a0959ea981d3a43$exports(arguments.length, 1);
        var entries = state.entries;
        var found = false;
        var key = $dd666817fb19c24c$exports(name);
        var val = $dd666817fb19c24c$exports(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) $5e0d06bbca8ef0bc$var$splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) $5e0d06bbca8ef0bc$var$push(entries, {
            key: key,
            value: val
        });
        if (!$40260b59b65c2e4c$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = $5e0d06bbca8ef0bc$var$getInternalParamsState(this);
        $460f17b401c23fbc$exports(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = $5e0d06bbca8ef0bc$var$getInternalParamsState(this).entries;
        var boundFunction = $042f91ff50d30f11$exports(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new $5e0d06bbca8ef0bc$var$URLSearchParamsIterator(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new $5e0d06bbca8ef0bc$var$URLSearchParamsIterator(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new $5e0d06bbca8ef0bc$var$URLSearchParamsIterator(this, "entries");
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
$f488b1cc13335fff$exports($5e0d06bbca8ef0bc$var$URLSearchParamsPrototype, $5e0d06bbca8ef0bc$var$ITERATOR, $5e0d06bbca8ef0bc$var$URLSearchParamsPrototype.entries, {
    name: "entries"
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
$f488b1cc13335fff$exports($5e0d06bbca8ef0bc$var$URLSearchParamsPrototype, "toString", function toString() {
    return $5e0d06bbca8ef0bc$var$getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if ($40260b59b65c2e4c$exports) $d235cf6ad826c1e5$exports($5e0d06bbca8ef0bc$var$URLSearchParamsPrototype, "size", {
    get: function size() {
        return $5e0d06bbca8ef0bc$var$getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
});
$0590ceb3c9c577a7$exports($5e0d06bbca8ef0bc$var$URLSearchParamsConstructor, $5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS);
$d4b8e88525a1c695$exports({
    global: true,
    constructor: true,
    forced: !$7cbb4ff95f660138$exports
}, {
    URLSearchParams: $5e0d06bbca8ef0bc$var$URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!$7cbb4ff95f660138$exports && $64c802885f841370$exports($5e0d06bbca8ef0bc$var$Headers)) {
    var $5e0d06bbca8ef0bc$var$headersHas = $23a00ee3e029ff58$exports($5e0d06bbca8ef0bc$var$HeadersPrototype.has);
    var $5e0d06bbca8ef0bc$var$headersSet = $23a00ee3e029ff58$exports($5e0d06bbca8ef0bc$var$HeadersPrototype.set);
    var $5e0d06bbca8ef0bc$var$wrapRequestOptions = function wrapRequestOptions(init) {
        if ($b1a75f6ed3e2d50f$exports(init)) {
            var body = init.body;
            var headers;
            if ($19a284f0ad8e7bd9$exports(body) === $5e0d06bbca8ef0bc$var$URL_SEARCH_PARAMS) {
                headers = init.headers ? new $5e0d06bbca8ef0bc$var$Headers(init.headers) : new $5e0d06bbca8ef0bc$var$Headers();
                if (!$5e0d06bbca8ef0bc$var$headersHas(headers, "content-type")) $5e0d06bbca8ef0bc$var$headersSet(headers, "content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                return $9959f3fdced32995$exports(init, {
                    body: $ca4a4ced04e4a412$exports(0, $dd666817fb19c24c$exports(body)),
                    headers: $ca4a4ced04e4a412$exports(0, headers)
                });
            }
        }
        return init;
    };
    if ($64c802885f841370$exports($5e0d06bbca8ef0bc$var$nativeFetch)) $d4b8e88525a1c695$exports({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return $5e0d06bbca8ef0bc$var$nativeFetch(input, arguments.length > 1 ? $5e0d06bbca8ef0bc$var$wrapRequestOptions(arguments[1]) : {});
        }
    });
    if ($64c802885f841370$exports($5e0d06bbca8ef0bc$var$NativeRequest)) {
        var $5e0d06bbca8ef0bc$var$RequestConstructor = function Request(input /* , init */ ) {
            $cf50221949c767d8$exports(this, $5e0d06bbca8ef0bc$var$RequestPrototype);
            return new $5e0d06bbca8ef0bc$var$NativeRequest(input, arguments.length > 1 ? $5e0d06bbca8ef0bc$var$wrapRequestOptions(arguments[1]) : {});
        };
        $5e0d06bbca8ef0bc$var$RequestPrototype.constructor = $5e0d06bbca8ef0bc$var$RequestConstructor;
        $5e0d06bbca8ef0bc$var$RequestConstructor.prototype = $5e0d06bbca8ef0bc$var$RequestPrototype;
        $d4b8e88525a1c695$exports({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: $5e0d06bbca8ef0bc$var$RequestConstructor
        });
    }
}
$5e0d06bbca8ef0bc$exports = {
    URLSearchParams: $5e0d06bbca8ef0bc$var$URLSearchParamsConstructor,
    getState: $5e0d06bbca8ef0bc$var$getInternalParamsState
};



var $0a78e95513df5e72$var$setInternalState = $c70ec777954e7cbe$exports.set;
var $0a78e95513df5e72$var$getInternalURLState = $c70ec777954e7cbe$exports.getterFor("URL");
var $0a78e95513df5e72$var$URLSearchParams = $5e0d06bbca8ef0bc$exports.URLSearchParams;
var $0a78e95513df5e72$var$getInternalSearchParamsState = $5e0d06bbca8ef0bc$exports.getState;
var $0a78e95513df5e72$var$NativeURL = $0f4ea948f6673103$exports.URL;
var $0a78e95513df5e72$var$TypeError = $0f4ea948f6673103$exports.TypeError;
var $0a78e95513df5e72$var$parseInt = $0f4ea948f6673103$exports.parseInt;
var $0a78e95513df5e72$var$floor = Math.floor;
var $0a78e95513df5e72$var$pow = Math.pow;
var $0a78e95513df5e72$var$charAt = $23a00ee3e029ff58$exports("".charAt);
var $0a78e95513df5e72$var$exec = $23a00ee3e029ff58$exports(/./.exec);
var $0a78e95513df5e72$var$join = $23a00ee3e029ff58$exports([].join);
var $0a78e95513df5e72$var$numberToString = $23a00ee3e029ff58$exports(1.0.toString);
var $0a78e95513df5e72$var$pop = $23a00ee3e029ff58$exports([].pop);
var $0a78e95513df5e72$var$push = $23a00ee3e029ff58$exports([].push);
var $0a78e95513df5e72$var$replace = $23a00ee3e029ff58$exports("".replace);
var $0a78e95513df5e72$var$shift = $23a00ee3e029ff58$exports([].shift);
var $0a78e95513df5e72$var$split = $23a00ee3e029ff58$exports("".split);
var $0a78e95513df5e72$var$stringSlice = $23a00ee3e029ff58$exports("".slice);
var $0a78e95513df5e72$var$toLowerCase = $23a00ee3e029ff58$exports("".toLowerCase);
var $0a78e95513df5e72$var$unshift = $23a00ee3e029ff58$exports([].unshift);
var $0a78e95513df5e72$var$INVALID_AUTHORITY = "Invalid authority";
var $0a78e95513df5e72$var$INVALID_SCHEME = "Invalid scheme";
var $0a78e95513df5e72$var$INVALID_HOST = "Invalid host";
var $0a78e95513df5e72$var$INVALID_PORT = "Invalid port";
var $0a78e95513df5e72$var$ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var $0a78e95513df5e72$var$ALPHANUMERIC = /[\d+-.a-z]/i;
var $0a78e95513df5e72$var$DIGIT = /\d/;
var $0a78e95513df5e72$var$HEX_START = /^0x/i;
var $0a78e95513df5e72$var$OCT = /^[0-7]+$/;
var $0a78e95513df5e72$var$DEC = /^\d+$/;
var $0a78e95513df5e72$var$HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var $0a78e95513df5e72$var$FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var $0a78e95513df5e72$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var $0a78e95513df5e72$var$LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var $0a78e95513df5e72$var$TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var $0a78e95513df5e72$var$TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ var $0a78e95513df5e72$var$EOF;
// https://url.spec.whatwg.org/#ipv4-number-parser
var $0a78e95513df5e72$var$parseIPv4 = function parseIPv4(input) {
    var parts = $0a78e95513df5e72$var$split(input, ".");
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] === "") parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part === "") return input;
        radix = 10;
        if (part.length > 1 && $0a78e95513df5e72$var$charAt(part, 0) === "0") {
            radix = $0a78e95513df5e72$var$exec($0a78e95513df5e72$var$HEX_START, part) ? 16 : 8;
            part = $0a78e95513df5e72$var$stringSlice(part, radix === 8 ? 1 : 2);
        }
        if (part === "") number = 0;
        else {
            if (!$0a78e95513df5e72$var$exec(radix === 10 ? $0a78e95513df5e72$var$DEC : radix === 8 ? $0a78e95513df5e72$var$OCT : $0a78e95513df5e72$var$HEX, part)) return input;
            number = $0a78e95513df5e72$var$parseInt(part, radix);
        }
        $0a78e95513df5e72$var$push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index === partsLength - 1) {
            if (number >= $0a78e95513df5e72$var$pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = $0a78e95513df5e72$var$pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * $0a78e95513df5e72$var$pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var $0a78e95513df5e72$var$parseIPv6 = function parseIPv6(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function chr() {
        return $0a78e95513df5e72$var$charAt(input, pointer);
    };
    if (chr() === ":") {
        if ($0a78e95513df5e72$var$charAt(input, 1) !== ":") return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex === 8) return;
        if (chr() === ":") {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && $0a78e95513df5e72$var$exec($0a78e95513df5e72$var$HEX, chr())){
            value = value * 16 + $0a78e95513df5e72$var$parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() === ".") {
            if (length === 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() === "." && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!$0a78e95513df5e72$var$exec($0a78e95513df5e72$var$DIGIT, chr())) return;
                while($0a78e95513df5e72$var$exec($0a78e95513df5e72$var$DIGIT, chr())){
                    number = $0a78e95513df5e72$var$parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece === 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
            }
            if (numbersSeen !== 4) return;
            break;
        } else if (chr() === ":") {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex !== 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex !== 8) return;
    return address;
};
var $0a78e95513df5e72$var$findLongestZeroSequence = function findLongestZeroSequence(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
    }
    return maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var $0a78e95513df5e72$var$serializeHost = function serializeHost(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == "number") {
        result = [];
        for(index = 0; index < 4; index++){
            $0a78e95513df5e72$var$unshift(result, host % 256);
            host = $0a78e95513df5e72$var$floor(host / 256);
        }
        return $0a78e95513df5e72$var$join(result, ".");
    // ipv6
    } else if (typeof host == "object") {
        result = "";
        compress = $0a78e95513df5e72$var$findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ":" : "::";
                ignore0 = true;
            } else {
                result += $0a78e95513df5e72$var$numberToString(host[index], 16);
                if (index < 7) result += ":";
            }
        }
        return "[" + result + "]";
    }
    return host;
};
var $0a78e95513df5e72$var$C0ControlPercentEncodeSet = {};
var $0a78e95513df5e72$var$fragmentPercentEncodeSet = $45854d5fd0e8a856$exports({}, $0a78e95513df5e72$var$C0ControlPercentEncodeSet, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
});
var $0a78e95513df5e72$var$pathPercentEncodeSet = $45854d5fd0e8a856$exports({}, $0a78e95513df5e72$var$fragmentPercentEncodeSet, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
});
var $0a78e95513df5e72$var$userinfoPercentEncodeSet = $45854d5fd0e8a856$exports({}, $0a78e95513df5e72$var$pathPercentEncodeSet, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
});
var $0a78e95513df5e72$var$percentEncode = function percentEncode(chr, set) {
    var code = $0a78e95513df5e72$require$codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !$5f4f8ca39500aba6$exports(set, chr) ? chr : encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var $0a78e95513df5e72$var$specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var $0a78e95513df5e72$var$isWindowsDriveLetter = function isWindowsDriveLetter(string, normalized) {
    var second;
    return string.length === 2 && $0a78e95513df5e72$var$exec($0a78e95513df5e72$var$ALPHA, $0a78e95513df5e72$var$charAt(string, 0)) && ((second = $0a78e95513df5e72$var$charAt(string, 1)) === ":" || !normalized && second === "|");
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var $0a78e95513df5e72$var$startsWithWindowsDriveLetter = function startsWithWindowsDriveLetter(string) {
    var third;
    return string.length > 1 && $0a78e95513df5e72$var$isWindowsDriveLetter($0a78e95513df5e72$var$stringSlice(string, 0, 2)) && (string.length === 2 || (third = $0a78e95513df5e72$var$charAt(string, 2)) === "/" || third === "\\" || third === "?" || third === "#");
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var $0a78e95513df5e72$var$isSingleDot = function isSingleDot(segment) {
    return segment === "." || $0a78e95513df5e72$var$toLowerCase(segment) === "%2e";
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var $0a78e95513df5e72$var$isDoubleDot = function isDoubleDot(segment) {
    segment = $0a78e95513df5e72$var$toLowerCase(segment);
    return segment === ".." || segment === "%2e." || segment === ".%2e" || segment === "%2e%2e";
};
// States:
var $0a78e95513df5e72$var$SCHEME_START = {};
var $0a78e95513df5e72$var$SCHEME = {};
var $0a78e95513df5e72$var$NO_SCHEME = {};
var $0a78e95513df5e72$var$SPECIAL_RELATIVE_OR_AUTHORITY = {};
var $0a78e95513df5e72$var$PATH_OR_AUTHORITY = {};
var $0a78e95513df5e72$var$RELATIVE = {};
var $0a78e95513df5e72$var$RELATIVE_SLASH = {};
var $0a78e95513df5e72$var$SPECIAL_AUTHORITY_SLASHES = {};
var $0a78e95513df5e72$var$SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var $0a78e95513df5e72$var$AUTHORITY = {};
var $0a78e95513df5e72$var$HOST = {};
var $0a78e95513df5e72$var$HOSTNAME = {};
var $0a78e95513df5e72$var$PORT = {};
var $0a78e95513df5e72$var$FILE = {};
var $0a78e95513df5e72$var$FILE_SLASH = {};
var $0a78e95513df5e72$var$FILE_HOST = {};
var $0a78e95513df5e72$var$PATH_START = {};
var $0a78e95513df5e72$var$PATH = {};
var $0a78e95513df5e72$var$CANNOT_BE_A_BASE_URL_PATH = {};
var $0a78e95513df5e72$var$QUERY = {};
var $0a78e95513df5e72$var$FRAGMENT = {};
var $0a78e95513df5e72$var$URLState = function URLState1(url, isBase, base) {
    var urlString = $dd666817fb19c24c$exports(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw new $0a78e95513df5e72$var$TypeError(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new $0a78e95513df5e72$var$URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw new $0a78e95513df5e72$var$TypeError(failure);
        searchParams = $0a78e95513df5e72$var$getInternalSearchParamsState(new $0a78e95513df5e72$var$URLSearchParams());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
$0a78e95513df5e72$var$URLState.prototype = {
    type: "URL",
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function parse(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || $0a78e95513df5e72$var$SCHEME_START;
        var pointer = 0;
        var buffer = "";
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $dd666817fb19c24c$exports(input);
        if (!stateOverride) {
            url.scheme = "";
            url.username = "";
            url.password = "";
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = $0a78e95513df5e72$var$replace(input, $0a78e95513df5e72$var$LEADING_C0_CONTROL_OR_SPACE, "");
            input = $0a78e95513df5e72$var$replace(input, $0a78e95513df5e72$var$TRAILING_C0_CONTROL_OR_SPACE, "$1");
        }
        input = $0a78e95513df5e72$var$replace(input, $0a78e95513df5e72$var$TAB_AND_NEW_LINE, "");
        codePoints = $c598bb3b06504746$exports(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case $0a78e95513df5e72$var$SCHEME_START:
                    if (chr && $0a78e95513df5e72$var$exec($0a78e95513df5e72$var$ALPHA, chr)) {
                        buffer += $0a78e95513df5e72$var$toLowerCase(chr);
                        state = $0a78e95513df5e72$var$SCHEME;
                    } else if (!stateOverride) {
                        state = $0a78e95513df5e72$var$NO_SCHEME;
                        continue;
                    } else return $0a78e95513df5e72$var$INVALID_SCHEME;
                    break;
                case $0a78e95513df5e72$var$SCHEME:
                    if (chr && ($0a78e95513df5e72$var$exec($0a78e95513df5e72$var$ALPHANUMERIC, chr) || chr === "+" || chr === "-" || chr === ".")) buffer += $0a78e95513df5e72$var$toLowerCase(chr);
                    else if (chr === ":") {
                        if (stateOverride && (url.isSpecial() !== $5f4f8ca39500aba6$exports($0a78e95513df5e72$var$specialSchemes, buffer) || buffer === "file" && (url.includesCredentials() || url.port !== null) || url.scheme === "file" && !url.host)) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && $0a78e95513df5e72$var$specialSchemes[url.scheme] === url.port) url.port = null;
                            return;
                        }
                        buffer = "";
                        if (url.scheme === "file") state = $0a78e95513df5e72$var$FILE;
                        else if (url.isSpecial() && base && base.scheme === url.scheme) state = $0a78e95513df5e72$var$SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = $0a78e95513df5e72$var$SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] === "/") {
                            state = $0a78e95513df5e72$var$PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            $0a78e95513df5e72$var$push(url.path, "");
                            state = $0a78e95513df5e72$var$CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = "";
                        state = $0a78e95513df5e72$var$NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return $0a78e95513df5e72$var$INVALID_SCHEME;
                    break;
                case $0a78e95513df5e72$var$NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr !== "#") return $0a78e95513df5e72$var$INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr === "#") {
                        url.scheme = base.scheme;
                        url.path = $ad61b3a319da2150$exports(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        url.cannotBeABaseURL = true;
                        state = $0a78e95513df5e72$var$FRAGMENT;
                        break;
                    }
                    state = base.scheme === "file" ? $0a78e95513df5e72$var$FILE : $0a78e95513df5e72$var$RELATIVE;
                    continue;
                case $0a78e95513df5e72$var$SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr === "/" && codePoints[pointer + 1] === "/") {
                        state = $0a78e95513df5e72$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = $0a78e95513df5e72$var$RELATIVE;
                        continue;
                    }
                    break;
                case $0a78e95513df5e72$var$PATH_OR_AUTHORITY:
                    if (chr === "/") {
                        state = $0a78e95513df5e72$var$AUTHORITY;
                        break;
                    } else {
                        state = $0a78e95513df5e72$var$PATH;
                        continue;
                    }
                case $0a78e95513df5e72$var$RELATIVE:
                    url.scheme = base.scheme;
                    if (chr === $0a78e95513df5e72$var$EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $ad61b3a319da2150$exports(base.path);
                        url.query = base.query;
                    } else if (chr === "/" || chr === "\\" && url.isSpecial()) state = $0a78e95513df5e72$var$RELATIVE_SLASH;
                    else if (chr === "?") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $ad61b3a319da2150$exports(base.path);
                        url.query = "";
                        state = $0a78e95513df5e72$var$QUERY;
                    } else if (chr === "#") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $ad61b3a319da2150$exports(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        state = $0a78e95513df5e72$var$FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $ad61b3a319da2150$exports(base.path);
                        url.path.length--;
                        state = $0a78e95513df5e72$var$PATH;
                        continue;
                    }
                    break;
                case $0a78e95513df5e72$var$RELATIVE_SLASH:
                    if (url.isSpecial() && (chr === "/" || chr === "\\")) state = $0a78e95513df5e72$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr === "/") state = $0a78e95513df5e72$var$AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = $0a78e95513df5e72$var$PATH;
                        continue;
                    }
                    break;
                case $0a78e95513df5e72$var$SPECIAL_AUTHORITY_SLASHES:
                    state = $0a78e95513df5e72$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr !== "/" || $0a78e95513df5e72$var$charAt(buffer, pointer + 1) !== "/") continue;
                    pointer++;
                    break;
                case $0a78e95513df5e72$var$SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr !== "/" && chr !== "\\") {
                        state = $0a78e95513df5e72$var$AUTHORITY;
                        continue;
                    }
                    break;
                case $0a78e95513df5e72$var$AUTHORITY:
                    if (chr === "@") {
                        if (seenAt) buffer = "%40" + buffer;
                        seenAt = true;
                        bufferCodePoints = $c598bb3b06504746$exports(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint === ":" && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = $0a78e95513df5e72$var$percentEncode(codePoint, $0a78e95513df5e72$var$userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = "";
                    } else if (chr === $0a78e95513df5e72$var$EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial()) {
                        if (seenAt && buffer === "") return $0a78e95513df5e72$var$INVALID_AUTHORITY;
                        pointer -= $c598bb3b06504746$exports(buffer).length + 1;
                        buffer = "";
                        state = $0a78e95513df5e72$var$HOST;
                    } else buffer += chr;
                    break;
                case $0a78e95513df5e72$var$HOST:
                case $0a78e95513df5e72$var$HOSTNAME:
                    if (stateOverride && url.scheme === "file") {
                        state = $0a78e95513df5e72$var$FILE_HOST;
                        continue;
                    } else if (chr === ":" && !seenBracket) {
                        if (buffer === "") return $0a78e95513df5e72$var$INVALID_HOST;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = $0a78e95513df5e72$var$PORT;
                        if (stateOverride === $0a78e95513df5e72$var$HOSTNAME) return;
                    } else if (chr === $0a78e95513df5e72$var$EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial()) {
                        if (url.isSpecial() && buffer === "") return $0a78e95513df5e72$var$INVALID_HOST;
                        if (stateOverride && buffer === "" && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = $0a78e95513df5e72$var$PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr === "[") seenBracket = true;
                        else if (chr === "]") seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case $0a78e95513df5e72$var$PORT:
                    if ($0a78e95513df5e72$var$exec($0a78e95513df5e72$var$DIGIT, chr)) buffer += chr;
                    else if (chr === $0a78e95513df5e72$var$EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial() || stateOverride) {
                        if (buffer !== "") {
                            var port = $0a78e95513df5e72$var$parseInt(buffer, 10);
                            if (port > 0xFFFF) return $0a78e95513df5e72$var$INVALID_PORT;
                            url.port = url.isSpecial() && port === $0a78e95513df5e72$var$specialSchemes[url.scheme] ? null : port;
                            buffer = "";
                        }
                        if (stateOverride) return;
                        state = $0a78e95513df5e72$var$PATH_START;
                        continue;
                    } else return $0a78e95513df5e72$var$INVALID_PORT;
                    break;
                case $0a78e95513df5e72$var$FILE:
                    url.scheme = "file";
                    if (chr === "/" || chr === "\\") state = $0a78e95513df5e72$var$FILE_SLASH;
                    else if (base && base.scheme === "file") switch(chr){
                        case $0a78e95513df5e72$var$EOF:
                            url.host = base.host;
                            url.path = $ad61b3a319da2150$exports(base.path);
                            url.query = base.query;
                            break;
                        case "?":
                            url.host = base.host;
                            url.path = $ad61b3a319da2150$exports(base.path);
                            url.query = "";
                            state = $0a78e95513df5e72$var$QUERY;
                            break;
                        case "#":
                            url.host = base.host;
                            url.path = $ad61b3a319da2150$exports(base.path);
                            url.query = base.query;
                            url.fragment = "";
                            state = $0a78e95513df5e72$var$FRAGMENT;
                            break;
                        default:
                            if (!$0a78e95513df5e72$var$startsWithWindowsDriveLetter($0a78e95513df5e72$var$join($ad61b3a319da2150$exports(codePoints, pointer), ""))) {
                                url.host = base.host;
                                url.path = $ad61b3a319da2150$exports(base.path);
                                url.shortenPath();
                            }
                            state = $0a78e95513df5e72$var$PATH;
                            continue;
                    }
                    else {
                        state = $0a78e95513df5e72$var$PATH;
                        continue;
                    }
                    break;
                case $0a78e95513df5e72$var$FILE_SLASH:
                    if (chr === "/" || chr === "\\") {
                        state = $0a78e95513df5e72$var$FILE_HOST;
                        break;
                    }
                    if (base && base.scheme === "file" && !$0a78e95513df5e72$var$startsWithWindowsDriveLetter($0a78e95513df5e72$var$join($ad61b3a319da2150$exports(codePoints, pointer), ""))) {
                        if ($0a78e95513df5e72$var$isWindowsDriveLetter(base.path[0], true)) $0a78e95513df5e72$var$push(url.path, base.path[0]);
                        else url.host = base.host;
                    }
                    state = $0a78e95513df5e72$var$PATH;
                    continue;
                case $0a78e95513df5e72$var$FILE_HOST:
                    if (chr === $0a78e95513df5e72$var$EOF || chr === "/" || chr === "\\" || chr === "?" || chr === "#") {
                        if (!stateOverride && $0a78e95513df5e72$var$isWindowsDriveLetter(buffer)) state = $0a78e95513df5e72$var$PATH;
                        else if (buffer === "") {
                            url.host = "";
                            if (stateOverride) return;
                            state = $0a78e95513df5e72$var$PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host === "localhost") url.host = "";
                            if (stateOverride) return;
                            buffer = "";
                            state = $0a78e95513df5e72$var$PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case $0a78e95513df5e72$var$PATH_START:
                    if (url.isSpecial()) {
                        state = $0a78e95513df5e72$var$PATH;
                        if (chr !== "/" && chr !== "\\") continue;
                    } else if (!stateOverride && chr === "?") {
                        url.query = "";
                        state = $0a78e95513df5e72$var$QUERY;
                    } else if (!stateOverride && chr === "#") {
                        url.fragment = "";
                        state = $0a78e95513df5e72$var$FRAGMENT;
                    } else if (chr !== $0a78e95513df5e72$var$EOF) {
                        state = $0a78e95513df5e72$var$PATH;
                        if (chr !== "/") continue;
                    }
                    break;
                case $0a78e95513df5e72$var$PATH:
                    if (chr === $0a78e95513df5e72$var$EOF || chr === "/" || chr === "\\" && url.isSpecial() || !stateOverride && (chr === "?" || chr === "#")) {
                        if ($0a78e95513df5e72$var$isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr !== "/" && !(chr === "\\" && url.isSpecial())) $0a78e95513df5e72$var$push(url.path, "");
                        } else if ($0a78e95513df5e72$var$isSingleDot(buffer)) {
                            if (chr !== "/" && !(chr === "\\" && url.isSpecial())) $0a78e95513df5e72$var$push(url.path, "");
                        } else {
                            if (url.scheme === "file" && !url.path.length && $0a78e95513df5e72$var$isWindowsDriveLetter(buffer)) {
                                if (url.host) url.host = "";
                                buffer = $0a78e95513df5e72$var$charAt(buffer, 0) + ":"; // normalize windows drive letter
                            }
                            $0a78e95513df5e72$var$push(url.path, buffer);
                        }
                        buffer = "";
                        if (url.scheme === "file" && (chr === $0a78e95513df5e72$var$EOF || chr === "?" || chr === "#")) while(url.path.length > 1 && url.path[0] === "")$0a78e95513df5e72$var$shift(url.path);
                        if (chr === "?") {
                            url.query = "";
                            state = $0a78e95513df5e72$var$QUERY;
                        } else if (chr === "#") {
                            url.fragment = "";
                            state = $0a78e95513df5e72$var$FRAGMENT;
                        }
                    } else buffer += $0a78e95513df5e72$var$percentEncode(chr, $0a78e95513df5e72$var$pathPercentEncodeSet);
                    break;
                case $0a78e95513df5e72$var$CANNOT_BE_A_BASE_URL_PATH:
                    if (chr === "?") {
                        url.query = "";
                        state = $0a78e95513df5e72$var$QUERY;
                    } else if (chr === "#") {
                        url.fragment = "";
                        state = $0a78e95513df5e72$var$FRAGMENT;
                    } else if (chr !== $0a78e95513df5e72$var$EOF) url.path[0] += $0a78e95513df5e72$var$percentEncode(chr, $0a78e95513df5e72$var$C0ControlPercentEncodeSet);
                    break;
                case $0a78e95513df5e72$var$QUERY:
                    if (!stateOverride && chr === "#") {
                        url.fragment = "";
                        state = $0a78e95513df5e72$var$FRAGMENT;
                    } else if (chr !== $0a78e95513df5e72$var$EOF) {
                        if (chr === "'" && url.isSpecial()) url.query += "%27";
                        else if (chr === "#") url.query += "%23";
                        else url.query += $0a78e95513df5e72$var$percentEncode(chr, $0a78e95513df5e72$var$C0ControlPercentEncodeSet);
                    }
                    break;
                case $0a78e95513df5e72$var$FRAGMENT:
                    if (chr !== $0a78e95513df5e72$var$EOF) url.fragment += $0a78e95513df5e72$var$percentEncode(chr, $0a78e95513df5e72$var$fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function parseHost(input) {
        var result, codePoints, index;
        if ($0a78e95513df5e72$var$charAt(input, 0) === "[") {
            if ($0a78e95513df5e72$var$charAt(input, input.length - 1) !== "]") return $0a78e95513df5e72$var$INVALID_HOST;
            result = $0a78e95513df5e72$var$parseIPv6($0a78e95513df5e72$var$stringSlice(input, 1, -1));
            if (!result) return $0a78e95513df5e72$var$INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if ($0a78e95513df5e72$var$exec($0a78e95513df5e72$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return $0a78e95513df5e72$var$INVALID_HOST;
            result = "";
            codePoints = $c598bb3b06504746$exports(input);
            for(index = 0; index < codePoints.length; index++)result += $0a78e95513df5e72$var$percentEncode(codePoints[index], $0a78e95513df5e72$var$C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = $11cc6f98fae8e925$exports(input);
            if ($0a78e95513df5e72$var$exec($0a78e95513df5e72$var$FORBIDDEN_HOST_CODE_POINT, input)) return $0a78e95513df5e72$var$INVALID_HOST;
            result = $0a78e95513df5e72$var$parseIPv4(input);
            if (result === null) return $0a78e95513df5e72$var$INVALID_HOST;
            this.host = result;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function cannotHaveUsernamePasswordPort() {
        return !this.host || this.cannotBeABaseURL || this.scheme === "file";
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function includesCredentials() {
        return this.username !== "" || this.password !== "";
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function isSpecial() {
        return $5f4f8ca39500aba6$exports($0a78e95513df5e72$var$specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function shortenPath() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme !== "file" || pathSize !== 1 || !$0a78e95513df5e72$var$isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function serialize() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ":";
        if (host !== null) {
            output += "//";
            if (url.includesCredentials()) output += username + (password ? ":" + password : "") + "@";
            output += $0a78e95513df5e72$var$serializeHost(host);
            if (port !== null) output += ":" + port;
        } else if (scheme === "file") output += "//";
        output += url.cannotBeABaseURL ? path[0] : path.length ? "/" + $0a78e95513df5e72$var$join(path, "/") : "";
        if (query !== null) output += "?" + query;
        if (fragment !== null) output += "#" + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function setHref(href) {
        var failure = this.parse(href);
        if (failure) throw new $0a78e95513df5e72$var$TypeError(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function getOrigin() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme === "blob") try {
            return new $0a78e95513df5e72$var$URLConstructor(scheme.path[0]).origin;
        } catch (error) {
            return "null";
        }
        if (scheme === "file" || !this.isSpecial()) return "null";
        return scheme + "://" + $0a78e95513df5e72$var$serializeHost(this.host) + (port !== null ? ":" + port : "");
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function getProtocol() {
        return this.scheme + ":";
    },
    setProtocol: function setProtocol(protocol) {
        this.parse($dd666817fb19c24c$exports(protocol) + ":", $0a78e95513df5e72$var$SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function getUsername() {
        return this.username;
    },
    setUsername: function setUsername(username) {
        var codePoints = $c598bb3b06504746$exports($dd666817fb19c24c$exports(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = "";
        for(var i = 0; i < codePoints.length; i++)this.username += $0a78e95513df5e72$var$percentEncode(codePoints[i], $0a78e95513df5e72$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function getPassword() {
        return this.password;
    },
    setPassword: function setPassword(password) {
        var codePoints = $c598bb3b06504746$exports($dd666817fb19c24c$exports(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = "";
        for(var i = 0; i < codePoints.length; i++)this.password += $0a78e95513df5e72$var$percentEncode(codePoints[i], $0a78e95513df5e72$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function getHost() {
        var host = this.host;
        var port = this.port;
        return host === null ? "" : port === null ? $0a78e95513df5e72$var$serializeHost(host) : $0a78e95513df5e72$var$serializeHost(host) + ":" + port;
    },
    setHost: function setHost(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, $0a78e95513df5e72$var$HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function getHostname() {
        var host = this.host;
        return host === null ? "" : $0a78e95513df5e72$var$serializeHost(host);
    },
    setHostname: function setHostname(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, $0a78e95513df5e72$var$HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function getPort() {
        var port = this.port;
        return port === null ? "" : $dd666817fb19c24c$exports(port);
    },
    setPort: function setPort(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $dd666817fb19c24c$exports(port);
        if (port === "") this.port = null;
        else this.parse(port, $0a78e95513df5e72$var$PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function getPathname() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? "/" + $0a78e95513df5e72$var$join(path, "/") : "";
    },
    setPathname: function setPathname(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, $0a78e95513df5e72$var$PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function getSearch() {
        var query = this.query;
        return query ? "?" + query : "";
    },
    setSearch: function setSearch(search) {
        search = $dd666817fb19c24c$exports(search);
        if (search === "") this.query = null;
        else {
            if ($0a78e95513df5e72$var$charAt(search, 0) === "?") search = $0a78e95513df5e72$var$stringSlice(search, 1);
            this.query = "";
            this.parse(search, $0a78e95513df5e72$var$QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function getSearchParams() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function getHash() {
        var fragment = this.fragment;
        return fragment ? "#" + fragment : "";
    },
    setHash: function setHash(hash) {
        hash = $dd666817fb19c24c$exports(hash);
        if (hash === "") {
            this.fragment = null;
            return;
        }
        if ($0a78e95513df5e72$var$charAt(hash, 0) === "#") hash = $0a78e95513df5e72$var$stringSlice(hash, 1);
        this.fragment = "";
        this.parse(hash, $0a78e95513df5e72$var$FRAGMENT);
    },
    update: function update() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var $0a78e95513df5e72$var$URLConstructor = function URL(url /* , base */ ) {
    var that = $cf50221949c767d8$exports(this, $0a78e95513df5e72$var$URLPrototype);
    var base = $9a0959ea981d3a43$exports(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = $0a78e95513df5e72$var$setInternalState(that, new $0a78e95513df5e72$var$URLState(url, false, base));
    if (!$40260b59b65c2e4c$exports) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var $0a78e95513df5e72$var$URLPrototype = $0a78e95513df5e72$var$URLConstructor.prototype;
var $0a78e95513df5e72$var$accessorDescriptor = function accessorDescriptor(getter, setter) {
    return {
        get: function get() {
            return $0a78e95513df5e72$var$getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return $0a78e95513df5e72$var$getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if ($40260b59b65c2e4c$exports) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "href", $0a78e95513df5e72$var$accessorDescriptor("serialize", "setHref"));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "origin", $0a78e95513df5e72$var$accessorDescriptor("getOrigin"));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "protocol", $0a78e95513df5e72$var$accessorDescriptor("getProtocol", "setProtocol"));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "username", $0a78e95513df5e72$var$accessorDescriptor("getUsername", "setUsername"));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "password", $0a78e95513df5e72$var$accessorDescriptor("getPassword", "setPassword"));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "host", $0a78e95513df5e72$var$accessorDescriptor("getHost", "setHost"));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "hostname", $0a78e95513df5e72$var$accessorDescriptor("getHostname", "setHostname"));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "port", $0a78e95513df5e72$var$accessorDescriptor("getPort", "setPort"));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "pathname", $0a78e95513df5e72$var$accessorDescriptor("getPathname", "setPathname"));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "search", $0a78e95513df5e72$var$accessorDescriptor("getSearch", "setSearch"));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "searchParams", $0a78e95513df5e72$var$accessorDescriptor("getSearchParams"));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    $d235cf6ad826c1e5$exports($0a78e95513df5e72$var$URLPrototype, "hash", $0a78e95513df5e72$var$accessorDescriptor("getHash", "setHash"));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$f488b1cc13335fff$exports($0a78e95513df5e72$var$URLPrototype, "toJSON", function toJSON() {
    return $0a78e95513df5e72$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
$f488b1cc13335fff$exports($0a78e95513df5e72$var$URLPrototype, "toString", function toString() {
    return $0a78e95513df5e72$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if ($0a78e95513df5e72$var$NativeURL) {
    var $0a78e95513df5e72$var$nativeCreateObjectURL = $0a78e95513df5e72$var$NativeURL.createObjectURL;
    var $0a78e95513df5e72$var$nativeRevokeObjectURL = $0a78e95513df5e72$var$NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if ($0a78e95513df5e72$var$nativeCreateObjectURL) $f488b1cc13335fff$exports($0a78e95513df5e72$var$URLConstructor, "createObjectURL", $042f91ff50d30f11$exports($0a78e95513df5e72$var$nativeCreateObjectURL, $0a78e95513df5e72$var$NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if ($0a78e95513df5e72$var$nativeRevokeObjectURL) $f488b1cc13335fff$exports($0a78e95513df5e72$var$URLConstructor, "revokeObjectURL", $042f91ff50d30f11$exports($0a78e95513df5e72$var$nativeRevokeObjectURL, $0a78e95513df5e72$var$NativeURL));
}
$0590ceb3c9c577a7$exports($0a78e95513df5e72$var$URLConstructor, "URL");
$d4b8e88525a1c695$exports({
    global: true,
    constructor: true,
    forced: !$7cbb4ff95f660138$exports,
    sham: !$40260b59b65c2e4c$exports
}, {
    URL: $0a78e95513df5e72$var$URLConstructor
});




"use strict";


// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$d4b8e88525a1c695$exports({
    target: "URL",
    proto: true,
    enumerable: true
}, {
    toJSON: function toJSON() {
        return $4b3fe34719193049$exports(URL.prototype.toString, this);
    }
});


"use strict";



var $d67ee09f839f930f$exports = {};
"use strict";

$d67ee09f839f930f$exports = (parcelRequire("iy00I"));


var $7f9f21f33879fbd4$export$882461b6382ed46c;
var $7f9f21f33879fbd4$export$757ceba2d55c277e;
"use strict";
var $f7ecce75fdbc5756$exports = {};
"use strict";
function $f7ecce75fdbc5756$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f7ecce75fdbc5756$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f7ecce75fdbc5756$var$checkDCE();

$f7ecce75fdbc5756$exports = (parcelRequire("7J8D6"));


var $7f9f21f33879fbd4$var$i;
$7f9f21f33879fbd4$export$882461b6382ed46c = $f7ecce75fdbc5756$exports.createRoot;
$7f9f21f33879fbd4$export$757ceba2d55c277e = $f7ecce75fdbc5756$exports.hydrateRoot;


var $1f4531ebf250f6fa$exports = {};
"use strict";
Object.defineProperty($1f4531ebf250f6fa$exports, "__esModule", {
    value: true
});
var $05234172875cf8d2$exports = {};

var $3L4GM = parcelRequire("3L4GM");
"use strict";
Object.defineProperty($05234172875cf8d2$exports, "__esModule", {
    value: true
});
$05234172875cf8d2$exports.bodyOpenClassName = $05234172875cf8d2$exports.portalClassName = undefined;
var $05234172875cf8d2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $05234172875cf8d2$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $kVN77 = parcelRequire("kVN77");
var $05234172875cf8d2$var$_react2 = $05234172875cf8d2$var$_interopRequireDefault($kVN77);

var $05234172875cf8d2$var$_reactDom2 = $05234172875cf8d2$var$_interopRequireDefault($f7ecce75fdbc5756$exports);
var $f834a9f081b5b867$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f834a9f081b5b867$var$ReactIs, $f834a9f081b5b867$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$f834a9f081b5b867$exports = (parcelRequire("cx8MC"))();


var $05234172875cf8d2$var$_propTypes2 = $05234172875cf8d2$var$_interopRequireDefault($f834a9f081b5b867$exports);
var $ab09e4b08ee6cd04$exports = {};

var $3L4GM = parcelRequire("3L4GM");
"use strict";
Object.defineProperty($ab09e4b08ee6cd04$exports, "__esModule", {
    value: true
});
var $ab09e4b08ee6cd04$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ab09e4b08ee6cd04$var$_typeof = typeof Symbol === "function" && (0, $3L4GM._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, $3L4GM._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $3L4GM._)(obj);
};
var $ab09e4b08ee6cd04$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $kVN77 = parcelRequire("kVN77");

var $ab09e4b08ee6cd04$var$_propTypes2 = $ab09e4b08ee6cd04$var$_interopRequireDefault($f834a9f081b5b867$exports);
var $3779595638975557$exports = {};
"use strict";
Object.defineProperty($3779595638975557$exports, "__esModule", {
    value: true
});
$3779595638975557$exports.resetState = $3779595638975557$var$resetState;
$3779595638975557$exports.log = $3779595638975557$var$log;
$3779595638975557$exports.handleBlur = $3779595638975557$var$handleBlur;
$3779595638975557$exports.handleFocus = $3779595638975557$var$handleFocus;
$3779595638975557$exports.markForFocusLater = $3779595638975557$var$markForFocusLater;
$3779595638975557$exports.returnFocus = $3779595638975557$var$returnFocus;
$3779595638975557$exports.popWithoutFocus = $3779595638975557$var$popWithoutFocus;
$3779595638975557$exports.setupScopedFocus = $3779595638975557$var$setupScopedFocus;
$3779595638975557$exports.teardownScopedFocus = $3779595638975557$var$teardownScopedFocus;
var $9edf8b7c8058e1a8$exports = {};
"use strict";
Object.defineProperty($9edf8b7c8058e1a8$exports, "__esModule", {
    value: true
});
$9edf8b7c8058e1a8$exports.default = $9edf8b7c8058e1a8$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $9edf8b7c8058e1a8$var$tabbableNode = /input|select|textarea|button|object|iframe/;
function $9edf8b7c8058e1a8$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        return zeroSize ? style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
        element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $9edf8b7c8058e1a8$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($9edf8b7c8058e1a8$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $9edf8b7c8058e1a8$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $9edf8b7c8058e1a8$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $9edf8b7c8058e1a8$var$visible(element);
}
function $9edf8b7c8058e1a8$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $9edf8b7c8058e1a8$var$focusable(element, !isTabIndexNaN);
}
function $9edf8b7c8058e1a8$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $9edf8b7c8058e1a8$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($9edf8b7c8058e1a8$var$tabbable);
}
$9edf8b7c8058e1a8$exports = $9edf8b7c8058e1a8$exports["default"];


var $3779595638975557$var$_tabbable2 = $3779595638975557$var$_interopRequireDefault($9edf8b7c8058e1a8$exports);
function $3779595638975557$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3779595638975557$var$focusLaterElements = [];
var $3779595638975557$var$modalElement = null;
var $3779595638975557$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $3779595638975557$var$resetState() {
    $3779595638975557$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $3779595638975557$var$log() {}
/* eslint-enable no-console */ function $3779595638975557$var$handleBlur() {
    $3779595638975557$var$needToFocus = true;
}
function $3779595638975557$var$handleFocus() {
    if ($3779595638975557$var$needToFocus) {
        $3779595638975557$var$needToFocus = false;
        if (!$3779595638975557$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($3779595638975557$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $3779595638975557$var$_tabbable2.default)($3779595638975557$var$modalElement)[0] || $3779595638975557$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $3779595638975557$var$markForFocusLater() {
    $3779595638975557$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $3779595638975557$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($3779595638975557$var$focusLaterElements.length !== 0) {
            toFocus = $3779595638975557$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $3779595638975557$var$popWithoutFocus() {
    $3779595638975557$var$focusLaterElements.length > 0 && $3779595638975557$var$focusLaterElements.pop();
}
function $3779595638975557$var$setupScopedFocus(element) {
    $3779595638975557$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $3779595638975557$var$handleBlur, false);
        document.addEventListener("focus", $3779595638975557$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $3779595638975557$var$handleBlur);
        document.attachEvent("onFocus", $3779595638975557$var$handleFocus);
    }
}
function $3779595638975557$var$teardownScopedFocus() {
    $3779595638975557$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $3779595638975557$var$handleBlur);
        document.removeEventListener("focus", $3779595638975557$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $3779595638975557$var$handleBlur);
        document.detachEvent("onFocus", $3779595638975557$var$handleFocus);
    }
}


var $ab09e4b08ee6cd04$var$focusManager = $ab09e4b08ee6cd04$var$_interopRequireWildcard($3779595638975557$exports);
var $adc84bf8217e807c$exports = {};
"use strict";
Object.defineProperty($adc84bf8217e807c$exports, "__esModule", {
    value: true
});
$adc84bf8217e807c$exports.default = $adc84bf8217e807c$var$scopeTab;

var $adc84bf8217e807c$var$_tabbable2 = $adc84bf8217e807c$var$_interopRequireDefault($9edf8b7c8058e1a8$exports);
function $adc84bf8217e807c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $adc84bf8217e807c$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $adc84bf8217e807c$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $adc84bf8217e807c$var$scopeTab(node, event) {
    var tabbable = (0, $adc84bf8217e807c$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $adc84bf8217e807c$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$adc84bf8217e807c$exports = $adc84bf8217e807c$exports["default"];


var $ab09e4b08ee6cd04$var$_scopeTab2 = $ab09e4b08ee6cd04$var$_interopRequireDefault($adc84bf8217e807c$exports);
var $eca2eef2826c73f3$exports = {};
"use strict";
Object.defineProperty($eca2eef2826c73f3$exports, "__esModule", {
    value: true
});
$eca2eef2826c73f3$exports.resetState = $eca2eef2826c73f3$var$resetState;
$eca2eef2826c73f3$exports.log = $eca2eef2826c73f3$var$log;
$eca2eef2826c73f3$exports.assertNodeList = $eca2eef2826c73f3$var$assertNodeList;
$eca2eef2826c73f3$exports.setElement = $eca2eef2826c73f3$var$setElement;
$eca2eef2826c73f3$exports.validateElement = $eca2eef2826c73f3$var$validateElement;
$eca2eef2826c73f3$exports.hide = $eca2eef2826c73f3$var$hide;
$eca2eef2826c73f3$exports.show = $eca2eef2826c73f3$var$show;
$eca2eef2826c73f3$exports.documentNotReadyOrSSRTesting = $eca2eef2826c73f3$var$documentNotReadyOrSSRTesting;
var $ebc2e39f8809a1a9$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebc2e39f8809a1a9$var$__DEV__ = false;
var $ebc2e39f8809a1a9$var$warning = function warning() {};
if ($ebc2e39f8809a1a9$var$__DEV__) {
    var $ebc2e39f8809a1a9$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebc2e39f8809a1a9$var$warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebc2e39f8809a1a9$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebc2e39f8809a1a9$exports = $ebc2e39f8809a1a9$var$warning;


var $eca2eef2826c73f3$var$_warning2 = $eca2eef2826c73f3$var$_interopRequireDefault($ebc2e39f8809a1a9$exports);
var $dc91079dc72a8cd5$exports = {};
"use strict";
Object.defineProperty($dc91079dc72a8cd5$exports, "__esModule", {
    value: true
});
$dc91079dc72a8cd5$exports.canUseDOM = $dc91079dc72a8cd5$exports.SafeNodeList = $dc91079dc72a8cd5$exports.SafeHTMLCollection = undefined;
var $7521340ba6e1f64f$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, $7521340ba6e1f64f$exports) $7521340ba6e1f64f$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $dc91079dc72a8cd5$var$_exenv2 = $dc91079dc72a8cd5$var$_interopRequireDefault($7521340ba6e1f64f$exports);
function $dc91079dc72a8cd5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dc91079dc72a8cd5$var$EE = $dc91079dc72a8cd5$var$_exenv2.default;
var $dc91079dc72a8cd5$var$SafeHTMLElement = $dc91079dc72a8cd5$var$EE.canUseDOM ? window.HTMLElement : {};
var $dc91079dc72a8cd5$var$SafeHTMLCollection = $dc91079dc72a8cd5$exports.SafeHTMLCollection = $dc91079dc72a8cd5$var$EE.canUseDOM ? window.HTMLCollection : {};
var $dc91079dc72a8cd5$var$SafeNodeList = $dc91079dc72a8cd5$exports.SafeNodeList = $dc91079dc72a8cd5$var$EE.canUseDOM ? window.NodeList : {};
var $dc91079dc72a8cd5$var$canUseDOM = $dc91079dc72a8cd5$exports.canUseDOM = $dc91079dc72a8cd5$var$EE.canUseDOM;
$dc91079dc72a8cd5$exports.default = $dc91079dc72a8cd5$var$SafeHTMLElement;


function $eca2eef2826c73f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $eca2eef2826c73f3$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $eca2eef2826c73f3$var$resetState() {
    if ($eca2eef2826c73f3$var$globalElement) {
        if ($eca2eef2826c73f3$var$globalElement.removeAttribute) $eca2eef2826c73f3$var$globalElement.removeAttribute("aria-hidden");
        else if ($eca2eef2826c73f3$var$globalElement.length != null) $eca2eef2826c73f3$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($eca2eef2826c73f3$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $eca2eef2826c73f3$var$globalElement = null;
}
/* istanbul ignore next */ function $eca2eef2826c73f3$var$log() {
    var check;
}
/* eslint-enable no-console */ function $eca2eef2826c73f3$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $eca2eef2826c73f3$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $dc91079dc72a8cd5$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $eca2eef2826c73f3$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $eca2eef2826c73f3$var$globalElement = useElement || $eca2eef2826c73f3$var$globalElement;
    return $eca2eef2826c73f3$var$globalElement;
}
function $eca2eef2826c73f3$var$validateElement(appElement) {
    var el = appElement || $eca2eef2826c73f3$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $eca2eef2826c73f3$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $eca2eef2826c73f3$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $eca2eef2826c73f3$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $eca2eef2826c73f3$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $eca2eef2826c73f3$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $eca2eef2826c73f3$var$documentNotReadyOrSSRTesting() {
    $eca2eef2826c73f3$var$globalElement = null;
}


var $ab09e4b08ee6cd04$var$ariaAppHider = $ab09e4b08ee6cd04$var$_interopRequireWildcard($eca2eef2826c73f3$exports);
var $905a9cf4f058f1a7$exports = {};
"use strict";
Object.defineProperty($905a9cf4f058f1a7$exports, "__esModule", {
    value: true
});
$905a9cf4f058f1a7$exports.resetState = $905a9cf4f058f1a7$var$resetState;
$905a9cf4f058f1a7$exports.log = $905a9cf4f058f1a7$var$log;
var $905a9cf4f058f1a7$var$htmlClassList = {};
var $905a9cf4f058f1a7$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $905a9cf4f058f1a7$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $905a9cf4f058f1a7$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $905a9cf4f058f1a7$var$htmlClassList)$905a9cf4f058f1a7$var$removeClass(htmlElement, $905a9cf4f058f1a7$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $905a9cf4f058f1a7$var$docBodyClassList)$905a9cf4f058f1a7$var$removeClass(body, $905a9cf4f058f1a7$var$docBodyClassList[_cls]);
    $905a9cf4f058f1a7$var$htmlClassList = {};
    $905a9cf4f058f1a7$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $905a9cf4f058f1a7$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $905a9cf4f058f1a7$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $905a9cf4f058f1a7$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $905a9cf4f058f1a7$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $905a9cf4f058f1a7$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $905a9cf4f058f1a7$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $905a9cf4f058f1a7$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $905a9cf4f058f1a7$var$add = $905a9cf4f058f1a7$exports.add = function add(element, classString) {
    return $905a9cf4f058f1a7$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $905a9cf4f058f1a7$var$htmlClassList : $905a9cf4f058f1a7$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $905a9cf4f058f1a7$var$remove = $905a9cf4f058f1a7$exports.remove = function remove(element, classString) {
    return $905a9cf4f058f1a7$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $905a9cf4f058f1a7$var$htmlClassList : $905a9cf4f058f1a7$var$docBodyClassList, classString.split(" "));
};


var $ab09e4b08ee6cd04$var$classList = $ab09e4b08ee6cd04$var$_interopRequireWildcard($905a9cf4f058f1a7$exports);

var $ab09e4b08ee6cd04$var$_safeHTMLElement2 = $ab09e4b08ee6cd04$var$_interopRequireDefault($dc91079dc72a8cd5$exports);
var $16a7fb8c96676573$exports = {};
"use strict";
Object.defineProperty($16a7fb8c96676573$exports, "__esModule", {
    value: true
});
$16a7fb8c96676573$exports.log = $16a7fb8c96676573$var$log;
$16a7fb8c96676573$exports.resetState = $16a7fb8c96676573$var$resetState;
function $16a7fb8c96676573$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $16a7fb8c96676573$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $16a7fb8c96676573$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $16a7fb8c96676573$var$portalOpenInstances = new $16a7fb8c96676573$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $16a7fb8c96676573$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($16a7fb8c96676573$var$portalOpenInstances.openInstances.length);
    $16a7fb8c96676573$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $16a7fb8c96676573$var$resetState() {
    $16a7fb8c96676573$var$portalOpenInstances = new $16a7fb8c96676573$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $16a7fb8c96676573$exports.default = $16a7fb8c96676573$var$portalOpenInstances;


var $ab09e4b08ee6cd04$var$_portalOpenInstances2 = $ab09e4b08ee6cd04$var$_interopRequireDefault($16a7fb8c96676573$exports);
var $84708f60bc902266$exports = {};
"use strict";
Object.defineProperty($84708f60bc902266$exports, "__esModule", {
    value: true
});
$84708f60bc902266$exports.resetState = $84708f60bc902266$var$resetState;
$84708f60bc902266$exports.log = $84708f60bc902266$var$log;

var $84708f60bc902266$var$_portalOpenInstances2 = $84708f60bc902266$var$_interopRequireDefault($16a7fb8c96676573$exports);
function $84708f60bc902266$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $84708f60bc902266$var$before = void 0, $84708f60bc902266$var$after = void 0, $84708f60bc902266$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $84708f60bc902266$var$resetState() {
    var _arr = [
        $84708f60bc902266$var$before,
        $84708f60bc902266$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $84708f60bc902266$var$before = $84708f60bc902266$var$after = null;
    $84708f60bc902266$var$instances = [];
}
/* istanbul ignore next */ function $84708f60bc902266$var$log() {
    console.log("bodyTrap ----------");
    console.log($84708f60bc902266$var$instances.length);
    var _arr2 = [
        $84708f60bc902266$var$before,
        $84708f60bc902266$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $84708f60bc902266$var$focusContent() {
    if ($84708f60bc902266$var$instances.length === 0) return;
    $84708f60bc902266$var$instances[$84708f60bc902266$var$instances.length - 1].focusContent();
}
function $84708f60bc902266$var$bodyTrap(eventType, openInstances) {
    if (!$84708f60bc902266$var$before && !$84708f60bc902266$var$after) {
        $84708f60bc902266$var$before = document.createElement("div");
        $84708f60bc902266$var$before.setAttribute("data-react-modal-body-trap", "");
        $84708f60bc902266$var$before.style.position = "absolute";
        $84708f60bc902266$var$before.style.opacity = "0";
        $84708f60bc902266$var$before.setAttribute("tabindex", "0");
        $84708f60bc902266$var$before.addEventListener("focus", $84708f60bc902266$var$focusContent);
        $84708f60bc902266$var$after = $84708f60bc902266$var$before.cloneNode();
        $84708f60bc902266$var$after.addEventListener("focus", $84708f60bc902266$var$focusContent);
    }
    $84708f60bc902266$var$instances = openInstances;
    if ($84708f60bc902266$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $84708f60bc902266$var$before) document.body.insertBefore($84708f60bc902266$var$before, document.body.firstChild);
        if (document.body.lastChild !== $84708f60bc902266$var$after) document.body.appendChild($84708f60bc902266$var$after);
    } else {
        // Remove focus trap
        if ($84708f60bc902266$var$before.parentElement) $84708f60bc902266$var$before.parentElement.removeChild($84708f60bc902266$var$before);
        if ($84708f60bc902266$var$after.parentElement) $84708f60bc902266$var$after.parentElement.removeChild($84708f60bc902266$var$after);
    }
}
$84708f60bc902266$var$_portalOpenInstances2.default.subscribe($84708f60bc902266$var$bodyTrap);


function $ab09e4b08ee6cd04$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $ab09e4b08ee6cd04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ab09e4b08ee6cd04$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ab09e4b08ee6cd04$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ab09e4b08ee6cd04$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $3L4GM._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $ab09e4b08ee6cd04$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
var $ab09e4b08ee6cd04$var$TAB_KEY = 9;
var $ab09e4b08ee6cd04$var$ESC_KEY = 27;
var $ab09e4b08ee6cd04$var$ariaHiddenInstances = 0;
var $ab09e4b08ee6cd04$var$ModalPortal = function(_Component) {
    $ab09e4b08ee6cd04$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $ab09e4b08ee6cd04$var$_classCallCheck(this, ModalPortal);
        var _this = $ab09e4b08ee6cd04$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName;
            // Remove classes.
            bodyOpenClassName && $ab09e4b08ee6cd04$var$classList.remove(document.body, bodyOpenClassName);
            htmlOpenClassName && $ab09e4b08ee6cd04$var$classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $ab09e4b08ee6cd04$var$ariaHiddenInstances > 0) {
                $ab09e4b08ee6cd04$var$ariaHiddenInstances -= 1;
                if ($ab09e4b08ee6cd04$var$ariaHiddenInstances === 0) $ab09e4b08ee6cd04$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $ab09e4b08ee6cd04$var$focusManager.returnFocus(_this.props.preventScroll);
                    $ab09e4b08ee6cd04$var$focusManager.teardownScopedFocus();
                } else $ab09e4b08ee6cd04$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $ab09e4b08ee6cd04$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $ab09e4b08ee6cd04$var$focusManager.setupScopedFocus(_this.node);
                    $ab09e4b08ee6cd04$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if (event.keyCode === $ab09e4b08ee6cd04$var$TAB_KEY) (0, $ab09e4b08ee6cd04$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && event.keyCode === $ab09e4b08ee6cd04$var$ESC_KEY) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $ab09e4b08ee6cd04$var$_typeof(additional)) === "object" ? additional : {
                base: $ab09e4b08ee6cd04$var$CLASS_NAMES[which],
                afterOpen: $ab09e4b08ee6cd04$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $ab09e4b08ee6cd04$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $ab09e4b08ee6cd04$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName;
                // Add classes.
                bodyOpenClassName && $ab09e4b08ee6cd04$var$classList.add(document.body, bodyOpenClassName);
                htmlOpenClassName && $ab09e4b08ee6cd04$var$classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $ab09e4b08ee6cd04$var$ariaHiddenInstances += 1;
                    $ab09e4b08ee6cd04$var$ariaAppHider.hide(appElement);
                }
                $ab09e4b08ee6cd04$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $ab09e4b08ee6cd04$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $ab09e4b08ee6cd04$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $ab09e4b08ee6cd04$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $ab09e4b08ee6cd04$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($kVN77.Component);
$ab09e4b08ee6cd04$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$ab09e4b08ee6cd04$var$ModalPortal.propTypes = {
    isOpen: $ab09e4b08ee6cd04$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $ab09e4b08ee6cd04$var$_propTypes2.default.shape({
        content: $ab09e4b08ee6cd04$var$_propTypes2.default.object,
        overlay: $ab09e4b08ee6cd04$var$_propTypes2.default.object
    }),
    style: $ab09e4b08ee6cd04$var$_propTypes2.default.shape({
        content: $ab09e4b08ee6cd04$var$_propTypes2.default.object,
        overlay: $ab09e4b08ee6cd04$var$_propTypes2.default.object
    }),
    className: $ab09e4b08ee6cd04$var$_propTypes2.default.oneOfType([
        $ab09e4b08ee6cd04$var$_propTypes2.default.string,
        $ab09e4b08ee6cd04$var$_propTypes2.default.object
    ]),
    overlayClassName: $ab09e4b08ee6cd04$var$_propTypes2.default.oneOfType([
        $ab09e4b08ee6cd04$var$_propTypes2.default.string,
        $ab09e4b08ee6cd04$var$_propTypes2.default.object
    ]),
    bodyOpenClassName: $ab09e4b08ee6cd04$var$_propTypes2.default.string,
    htmlOpenClassName: $ab09e4b08ee6cd04$var$_propTypes2.default.string,
    ariaHideApp: $ab09e4b08ee6cd04$var$_propTypes2.default.bool,
    appElement: $ab09e4b08ee6cd04$var$_propTypes2.default.oneOfType([
        $ab09e4b08ee6cd04$var$_propTypes2.default.instanceOf($ab09e4b08ee6cd04$var$_safeHTMLElement2.default),
        $ab09e4b08ee6cd04$var$_propTypes2.default.instanceOf($dc91079dc72a8cd5$exports.SafeHTMLCollection),
        $ab09e4b08ee6cd04$var$_propTypes2.default.instanceOf($dc91079dc72a8cd5$exports.SafeNodeList),
        $ab09e4b08ee6cd04$var$_propTypes2.default.arrayOf($ab09e4b08ee6cd04$var$_propTypes2.default.instanceOf($ab09e4b08ee6cd04$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $ab09e4b08ee6cd04$var$_propTypes2.default.func,
    onAfterClose: $ab09e4b08ee6cd04$var$_propTypes2.default.func,
    onRequestClose: $ab09e4b08ee6cd04$var$_propTypes2.default.func,
    closeTimeoutMS: $ab09e4b08ee6cd04$var$_propTypes2.default.number,
    shouldFocusAfterRender: $ab09e4b08ee6cd04$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $ab09e4b08ee6cd04$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $ab09e4b08ee6cd04$var$_propTypes2.default.bool,
    preventScroll: $ab09e4b08ee6cd04$var$_propTypes2.default.bool,
    role: $ab09e4b08ee6cd04$var$_propTypes2.default.string,
    contentLabel: $ab09e4b08ee6cd04$var$_propTypes2.default.string,
    aria: $ab09e4b08ee6cd04$var$_propTypes2.default.object,
    data: $ab09e4b08ee6cd04$var$_propTypes2.default.object,
    children: $ab09e4b08ee6cd04$var$_propTypes2.default.node,
    shouldCloseOnEsc: $ab09e4b08ee6cd04$var$_propTypes2.default.bool,
    overlayRef: $ab09e4b08ee6cd04$var$_propTypes2.default.func,
    contentRef: $ab09e4b08ee6cd04$var$_propTypes2.default.func,
    id: $ab09e4b08ee6cd04$var$_propTypes2.default.string,
    overlayElement: $ab09e4b08ee6cd04$var$_propTypes2.default.func,
    contentElement: $ab09e4b08ee6cd04$var$_propTypes2.default.func,
    testId: $ab09e4b08ee6cd04$var$_propTypes2.default.string
};
$ab09e4b08ee6cd04$exports.default = $ab09e4b08ee6cd04$var$ModalPortal;
$ab09e4b08ee6cd04$exports = $ab09e4b08ee6cd04$exports["default"];


var $05234172875cf8d2$var$_ModalPortal2 = $05234172875cf8d2$var$_interopRequireDefault($ab09e4b08ee6cd04$exports);

var $05234172875cf8d2$var$ariaAppHider = $05234172875cf8d2$var$_interopRequireWildcard($eca2eef2826c73f3$exports);

var $05234172875cf8d2$var$_safeHTMLElement2 = $05234172875cf8d2$var$_interopRequireDefault($dc91079dc72a8cd5$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $8e3e51345af7ed87$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $8e3e51345af7ed87$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $8e3e51345af7ed87$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$8e3e51345af7ed87$var$componentWillMount.__suppressDeprecationWarning = true;
$8e3e51345af7ed87$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$8e3e51345af7ed87$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $8e3e51345af7ed87$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $8e3e51345af7ed87$var$componentWillMount;
        prototype.componentWillReceiveProps = $8e3e51345af7ed87$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $8e3e51345af7ed87$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $05234172875cf8d2$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $05234172875cf8d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $05234172875cf8d2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $05234172875cf8d2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $05234172875cf8d2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $3L4GM._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $05234172875cf8d2$var$portalClassName = $05234172875cf8d2$exports.portalClassName = "ReactModalPortal";
var $05234172875cf8d2$var$bodyOpenClassName = $05234172875cf8d2$exports.bodyOpenClassName = "ReactModal__Body--open";
var $05234172875cf8d2$var$isReact16 = $dc91079dc72a8cd5$exports.canUseDOM && $05234172875cf8d2$var$_reactDom2.default.createPortal !== undefined;
var $05234172875cf8d2$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $05234172875cf8d2$var$getCreatePortal = function getCreatePortal() {
    return $05234172875cf8d2$var$isReact16 ? $05234172875cf8d2$var$_reactDom2.default.createPortal : $05234172875cf8d2$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $05234172875cf8d2$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $05234172875cf8d2$var$Modal = function(_Component) {
    $05234172875cf8d2$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $05234172875cf8d2$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $05234172875cf8d2$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function _ret() {
            !$05234172875cf8d2$var$isReact16 && $05234172875cf8d2$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $05234172875cf8d2$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $05234172875cf8d2$var$getCreatePortal();
            var portal = createPortal(_this, $05234172875cf8d2$var$_react2.default.createElement($05234172875cf8d2$var$_ModalPortal2.default, $05234172875cf8d2$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $05234172875cf8d2$var$_possibleConstructorReturn(_this, _ret);
    }
    $05234172875cf8d2$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$dc91079dc72a8cd5$exports.canUseDOM) return;
                if (!$05234172875cf8d2$var$isReact16) this.node = $05234172875cf8d2$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $05234172875cf8d2$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$05234172875cf8d2$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $05234172875cf8d2$var$getParentElement(prevProps.parentSelector);
                var nextParent = $05234172875cf8d2$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$dc91079dc72a8cd5$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$05234172875cf8d2$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$dc91079dc72a8cd5$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$dc91079dc72a8cd5$exports.canUseDOM || !$05234172875cf8d2$var$isReact16) return null;
                if (!this.node && $05234172875cf8d2$var$isReact16) this.node = $05234172875cf8d2$var$createHTMLElement("div");
                var createPortal = $05234172875cf8d2$var$getCreatePortal();
                return createPortal($05234172875cf8d2$var$_react2.default.createElement($05234172875cf8d2$var$_ModalPortal2.default, $05234172875cf8d2$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $05234172875cf8d2$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($kVN77.Component);
$05234172875cf8d2$var$Modal.propTypes = {
    isOpen: $05234172875cf8d2$var$_propTypes2.default.bool.isRequired,
    style: $05234172875cf8d2$var$_propTypes2.default.shape({
        content: $05234172875cf8d2$var$_propTypes2.default.object,
        overlay: $05234172875cf8d2$var$_propTypes2.default.object
    }),
    portalClassName: $05234172875cf8d2$var$_propTypes2.default.string,
    bodyOpenClassName: $05234172875cf8d2$var$_propTypes2.default.string,
    htmlOpenClassName: $05234172875cf8d2$var$_propTypes2.default.string,
    className: $05234172875cf8d2$var$_propTypes2.default.oneOfType([
        $05234172875cf8d2$var$_propTypes2.default.string,
        $05234172875cf8d2$var$_propTypes2.default.shape({
            base: $05234172875cf8d2$var$_propTypes2.default.string.isRequired,
            afterOpen: $05234172875cf8d2$var$_propTypes2.default.string.isRequired,
            beforeClose: $05234172875cf8d2$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $05234172875cf8d2$var$_propTypes2.default.oneOfType([
        $05234172875cf8d2$var$_propTypes2.default.string,
        $05234172875cf8d2$var$_propTypes2.default.shape({
            base: $05234172875cf8d2$var$_propTypes2.default.string.isRequired,
            afterOpen: $05234172875cf8d2$var$_propTypes2.default.string.isRequired,
            beforeClose: $05234172875cf8d2$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $05234172875cf8d2$var$_propTypes2.default.oneOfType([
        $05234172875cf8d2$var$_propTypes2.default.instanceOf($05234172875cf8d2$var$_safeHTMLElement2.default),
        $05234172875cf8d2$var$_propTypes2.default.instanceOf($dc91079dc72a8cd5$exports.SafeHTMLCollection),
        $05234172875cf8d2$var$_propTypes2.default.instanceOf($dc91079dc72a8cd5$exports.SafeNodeList),
        $05234172875cf8d2$var$_propTypes2.default.arrayOf($05234172875cf8d2$var$_propTypes2.default.instanceOf($05234172875cf8d2$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $05234172875cf8d2$var$_propTypes2.default.func,
    onRequestClose: $05234172875cf8d2$var$_propTypes2.default.func,
    closeTimeoutMS: $05234172875cf8d2$var$_propTypes2.default.number,
    ariaHideApp: $05234172875cf8d2$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $05234172875cf8d2$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $05234172875cf8d2$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $05234172875cf8d2$var$_propTypes2.default.bool,
    preventScroll: $05234172875cf8d2$var$_propTypes2.default.bool,
    parentSelector: $05234172875cf8d2$var$_propTypes2.default.func,
    aria: $05234172875cf8d2$var$_propTypes2.default.object,
    data: $05234172875cf8d2$var$_propTypes2.default.object,
    role: $05234172875cf8d2$var$_propTypes2.default.string,
    contentLabel: $05234172875cf8d2$var$_propTypes2.default.string,
    shouldCloseOnEsc: $05234172875cf8d2$var$_propTypes2.default.bool,
    overlayRef: $05234172875cf8d2$var$_propTypes2.default.func,
    contentRef: $05234172875cf8d2$var$_propTypes2.default.func,
    id: $05234172875cf8d2$var$_propTypes2.default.string,
    overlayElement: $05234172875cf8d2$var$_propTypes2.default.func,
    contentElement: $05234172875cf8d2$var$_propTypes2.default.func
};
$05234172875cf8d2$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $05234172875cf8d2$var$portalClassName,
    bodyOpenClassName: $05234172875cf8d2$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $05234172875cf8d2$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $05234172875cf8d2$var$_react2.default.createElement("div", props, children);
    }
};
$05234172875cf8d2$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $8e3e51345af7ed87$export$cea1c58a6db52bca)($05234172875cf8d2$var$Modal);
$05234172875cf8d2$exports.default = $05234172875cf8d2$var$Modal;


var $1f4531ebf250f6fa$var$_Modal2 = $1f4531ebf250f6fa$var$_interopRequireDefault($05234172875cf8d2$exports);
function $1f4531ebf250f6fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1f4531ebf250f6fa$exports.default = $1f4531ebf250f6fa$var$_Modal2.default;
$1f4531ebf250f6fa$exports = $1f4531ebf250f6fa$exports["default"];





function $883161a1efd6c88e$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $04946c8c10a5ce4e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $04946c8c10a5ce4e$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $04946c8c10a5ce4e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $04946c8c10a5ce4e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $f9910f6ec45fc48d$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $d11724f4df760fe4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d11724f4df760fe4$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $d11724f4df760fe4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d11724f4df760fe4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $9907ed469d84fffe$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $a4fe904b8b62ee38$export$c2c98ac76e997b63(o, p) {
    $a4fe904b8b62ee38$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a4fe904b8b62ee38$export$c2c98ac76e997b63(o, p);
}


function $e2f3b9f65e5a5430$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $a4fe904b8b62ee38$export$c2c98ac76e997b63)(subClass, superClass);
}



function $79de63f6394f39c4$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $671b362f9d9fcab2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $671b362f9d9fcab2$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $671b362f9d9fcab2$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $101e88ca0fd42f5a$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $22010bf73afddb74$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $b23c16ab02ec78cc$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $8506f02dd4244f61$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $a46603d5dce0e429$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $8506f02dd4244f61$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $8506f02dd4244f61$export$79e617b1955a2616)(o, minLen);
}


function $21d7c00a954d6239$export$fdf2a89c76341bbf(arr, i) {
    return (0, $101e88ca0fd42f5a$export$e6256bf45c68d561)(arr) || (0, $22010bf73afddb74$export$2fd15edff6687200)(arr, i) || (0, $a46603d5dce0e429$export$a5be06335b3a083c)(arr, i) || (0, $b23c16ab02ec78cc$export$60dbc22abd7da546)();
}



function $bf43f97833ab28c7$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $8506f02dd4244f61$export$79e617b1955a2616)(arr);
}


function $c7301c0efd5ad07b$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $5b41ac029c22c000$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $15f021a0fca28358$export$1b5e630bc3aea29f(arr) {
    return (0, $bf43f97833ab28c7$export$7e0947b5ad3404e2)(arr) || (0, $c7301c0efd5ad07b$export$1eb58a6e75231000)(arr) || (0, $a46603d5dce0e429$export$a5be06335b3a083c)(arr) || (0, $5b41ac029c22c000$export$e6f3c4780d19eb2b)();
}



var $3L4GM = parcelRequire("3L4GM");
function $4fcacb688b12cad6$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $6e19942e3d21ad54$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $4fcacb688b12cad6$export$685354647fba1516)()) $6e19942e3d21ad54$export$2d841144c5f8c4ab = Reflect.construct;
    else $6e19942e3d21ad54$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $a4fe904b8b62ee38$export$c2c98ac76e997b63)(instance, Class.prototype);
        return instance;
    };
    return $6e19942e3d21ad54$export$2d841144c5f8c4ab.apply(null, arguments);
}


function $2d3ab33c4b11796a$export$f09211a7d3c496a1(o) {
    $2d3ab33c4b11796a$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2d3ab33c4b11796a$export$f09211a7d3c496a1(o);
}


function $d1049f75e1e32332$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $efec3851c979cc44$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $efec3851c979cc44$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $d1049f75e1e32332$export$514eda94019f4334)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $6e19942e3d21ad54$export$2d841144c5f8c4ab)(Class, arguments, (0, $2d3ab33c4b11796a$export$f09211a7d3c496a1)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $a4fe904b8b62ee38$export$c2c98ac76e997b63)(Wrapper, Class);
    };
    return $efec3851c979cc44$export$2466d533fda16e33(Class);
}






var $3L4GM = parcelRequire("3L4GM");
function $20a8019e1b585767$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $3L4GM._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $883161a1efd6c88e$export$f3b8ed2e4a5d10b8)(self);
}


function $cc66cd13885188db$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $4fcacb688b12cad6$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $2d3ab33c4b11796a$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $2d3ab33c4b11796a$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $20a8019e1b585767$export$ef97c660ca164e52)(this, result);
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $3L4GM = parcelRequire("3L4GM");
var $1a5e16f717d29077$var$extendStatics = function extendStatics1(d, b) {
    $1a5e16f717d29077$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1a5e16f717d29077$var$extendStatics(d, b);
};
function $1a5e16f717d29077$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1a5e16f717d29077$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1a5e16f717d29077$export$18ce0697a983be9b = function __assign1() {
    $1a5e16f717d29077$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a5e16f717d29077$export$18ce0697a983be9b.apply(this, arguments);
};
function $1a5e16f717d29077$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1a5e16f717d29077$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1a5e16f717d29077$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1a5e16f717d29077$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1a5e16f717d29077$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1a5e16f717d29077$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $3L4GM._)(x)) === "symbol" ? x : "".concat(x);
}
function $1a5e16f717d29077$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $3L4GM._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1a5e16f717d29077$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1a5e16f717d29077$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1a5e16f717d29077$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1a5e16f717d29077$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1a5e16f717d29077$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1a5e16f717d29077$export$45d3717a4c69092e(o, m, p);
}
function $1a5e16f717d29077$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1a5e16f717d29077$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1a5e16f717d29077$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1a5e16f717d29077$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1a5e16f717d29077$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1a5e16f717d29077$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1a5e16f717d29077$export$10c90e4f7922046c(v) {
    return this instanceof $1a5e16f717d29077$export$10c90e4f7922046c ? (this.v = v, this) : new $1a5e16f717d29077$export$10c90e4f7922046c(v);
}
function $1a5e16f717d29077$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1a5e16f717d29077$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1a5e16f717d29077$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1a5e16f717d29077$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1a5e16f717d29077$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1a5e16f717d29077$export$19a8beecd37a4c45 === "function" ? $1a5e16f717d29077$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1a5e16f717d29077$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1a5e16f717d29077$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $1a5e16f717d29077$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1a5e16f717d29077$export$45d3717a4c69092e(result, mod, k);
    }
    $1a5e16f717d29077$var$__setModuleDefault(result, mod);
    return result;
}
function $1a5e16f717d29077$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1a5e16f717d29077$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1a5e16f717d29077$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1a5e16f717d29077$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1a5e16f717d29077$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1a5e16f717d29077$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1a5e16f717d29077$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1a5e16f717d29077$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $1a5e16f717d29077$export$2e2bcd8739ae039 = {
    __extends: $1a5e16f717d29077$export$a8ba968b8961cb8a,
    __assign: $1a5e16f717d29077$export$18ce0697a983be9b,
    __rest: $1a5e16f717d29077$export$3c9a16f847548506,
    __decorate: $1a5e16f717d29077$export$29e00dfd3077644b,
    __param: $1a5e16f717d29077$export$d5ad3fd78186038f,
    __metadata: $1a5e16f717d29077$export$f1db080c865becb9,
    __awaiter: $1a5e16f717d29077$export$1050f835b63b671e,
    __generator: $1a5e16f717d29077$export$67ebef60e6f28a6,
    __createBinding: $1a5e16f717d29077$export$45d3717a4c69092e,
    __exportStar: $1a5e16f717d29077$export$f33643c0debef087,
    __values: $1a5e16f717d29077$export$19a8beecd37a4c45,
    __read: $1a5e16f717d29077$export$8d051b38c9118094,
    __spread: $1a5e16f717d29077$export$afc72e2116322959,
    __spreadArrays: $1a5e16f717d29077$export$6388937ca91ccae8,
    __spreadArray: $1a5e16f717d29077$export$1216008129fb82ed,
    __await: $1a5e16f717d29077$export$10c90e4f7922046c,
    __asyncGenerator: $1a5e16f717d29077$export$e427f37a30a4de9b,
    __asyncDelegator: $1a5e16f717d29077$export$bbd80228419bb833,
    __asyncValues: $1a5e16f717d29077$export$e3b29a3d6162315f,
    __makeTemplateObject: $1a5e16f717d29077$export$4fb47efe1390b86f,
    __importStar: $1a5e16f717d29077$export$c21735bcef00d192,
    __importDefault: $1a5e16f717d29077$export$da59b14a69baef04,
    __classPrivateFieldGet: $1a5e16f717d29077$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1a5e16f717d29077$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1a5e16f717d29077$export$81fdc39f203e4e04,
    __addDisposableResource: $1a5e16f717d29077$export$88ac25d8e944e405,
    __disposeResources: $1a5e16f717d29077$export$8f076105dc360e92
};


var $a782240af38642b4$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = function(val) {
        return val;
    };
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = function(items) {
        var obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                obj[item] = item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
    util.getValidEnumValues = function(obj) {
        var validKeys = util.objectKeys(obj).filter(function(k) {
            return typeof obj[obj[k]] !== "number";
        });
        var filtered = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = validKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                filtered[k] = obj[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return util.objectValues(filtered);
    };
    util.objectValues = function(obj) {
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? function(obj) {
        return Object.keys(obj) // eslint-disable-line ban/ban
        ;
    } : function(object) {
        var keys = [];
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = function(arr, checker) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (checker(item)) return item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? function(val) {
        return Number.isInteger(val) // eslint-disable-line ban/ban
        ;
    } : function(val) {
        return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    };
    function joinValues(array) {
        var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " | ";
        return array.map(function(val) {
            return typeof val === "string" ? "'".concat(val, "'") : val;
        }).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = function(_, value) {
        if ((typeof value === "undefined" ? "undefined" : (0, $3L4GM._)(value)) === "bigint") return value.toString();
        return value;
    };
})($a782240af38642b4$export$7debb50ef11d5e0b || ($a782240af38642b4$export$7debb50ef11d5e0b = {}));
var $a782240af38642b4$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = function(first, second) {
        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, first, second);
    };
})($a782240af38642b4$export$4aa2142c225fd5c7 || ($a782240af38642b4$export$4aa2142c225fd5c7 = {}));
var $a782240af38642b4$export$5716da67bfaa244d = $a782240af38642b4$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
var $a782240af38642b4$export$3e9057828ebd5c7a = function(data) {
    var t = typeof data === "undefined" ? "undefined" : (0, $3L4GM._)(data);
    switch(t){
        case "undefined":
            return $a782240af38642b4$export$5716da67bfaa244d.undefined;
        case "string":
            return $a782240af38642b4$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $a782240af38642b4$export$5716da67bfaa244d.nan : $a782240af38642b4$export$5716da67bfaa244d.number;
        case "boolean":
            return $a782240af38642b4$export$5716da67bfaa244d.boolean;
        case "function":
            return $a782240af38642b4$export$5716da67bfaa244d.function;
        case "bigint":
            return $a782240af38642b4$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $a782240af38642b4$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $a782240af38642b4$export$5716da67bfaa244d.array;
            if (data === null) return $a782240af38642b4$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $a782240af38642b4$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $a782240af38642b4$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $a782240af38642b4$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $a782240af38642b4$export$5716da67bfaa244d.date;
            return $a782240af38642b4$export$5716da67bfaa244d.object;
        default:
            return $a782240af38642b4$export$5716da67bfaa244d.unknown;
    }
};
var $a782240af38642b4$export$5ba560653e4a1035 = $a782240af38642b4$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
var $a782240af38642b4$export$913eddeaf297cfea = function(obj) {
    var json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
var $a782240af38642b4$export$f98dac4b251ab333 = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodError, Error1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodError);
    function ZodError(issues) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodError);
        var _this;
        _this = _super.call(this);
        _this.issues = [];
        _this.addIssue = function(sub) {
            _this.issues = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(_this.issues).concat([
                sub
            ]);
        };
        _this.addIssues = function() {
            var subs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            _this.issues = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(_this.issues).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(subs));
        };
        var actualProto = (this instanceof ZodError ? this.constructor : void 0).prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf((0, $883161a1efd6c88e$export$f3b8ed2e4a5d10b8)(_this), actualProto);
        else _this.__proto__ = actualProto;
        _this.name = "ZodError";
        _this.issues = issues;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodError, [
        {
            key: "errors",
            get: function get() {
                return this.issues;
            }
        },
        {
            key: "format",
            value: function format(_mapper) {
                var mapper = _mapper || function(issue) {
                    return issue.message;
                };
                var fieldErrors = {
                    _errors: []
                };
                var processError = function(error) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = error.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var issue = _step.value;
                            if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                            else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                            else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                            else {
                                var curr = fieldErrors;
                                var i = 0;
                                while(i < issue.path.length){
                                    var el = issue.path[i];
                                    var terminal = i === issue.path.length - 1;
                                    if (!terminal) curr[el] = curr[el] || {
                                        _errors: []
                                    };
                                    else {
                                        curr[el] = curr[el] || {
                                            _errors: []
                                        };
                                        curr[el]._errors.push(mapper(issue));
                                    }
                                    curr = curr[el];
                                    i++;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                processError(this);
                return fieldErrors;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.message;
            }
        },
        {
            key: "message",
            get: function get() {
                return JSON.stringify(this.issues, $a782240af38642b4$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
            }
        },
        {
            key: "isEmpty",
            get: function get() {
                return this.issues.length === 0;
            }
        },
        {
            key: "flatten",
            value: function flatten() {
                var mapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(issue) {
                    return issue.message;
                };
                var fieldErrors = {};
                var formErrors = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        if (sub.path.length > 0) {
                            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                            fieldErrors[sub.path[0]].push(mapper(sub));
                        } else formErrors.push(mapper(sub));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    formErrors: formErrors,
                    fieldErrors: fieldErrors
                };
            }
        },
        {
            key: "formErrors",
            get: function get() {
                return this.flatten();
            }
        }
    ]);
    return ZodError;
}((0, $efec3851c979cc44$export$2466d533fda16e33)(Error));
$a782240af38642b4$export$f98dac4b251ab333.create = function(issues) {
    var error = new $a782240af38642b4$export$f98dac4b251ab333(issues);
    return error;
};
var $a782240af38642b4$export$341b0b6e0a6f5099 = function(issue, _ctx) {
    var message;
    switch(issue.code){
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $a782240af38642b4$export$5716da67bfaa244d.undefined) message = "Required";
            else message = "Expected ".concat(issue.expected, ", received ").concat(issue.received);
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_literal:
            message = "Invalid literal value, expected ".concat(JSON.stringify(issue.expected, $a782240af38642b4$export$7debb50ef11d5e0b.jsonStringifyReplacer));
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.unrecognized_keys:
            message = "Unrecognized key(s) in object: ".concat($a782240af38642b4$export$7debb50ef11d5e0b.joinValues(issue.keys, ", "));
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_union:
            message = "Invalid input";
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_union_discriminator:
            message = "Invalid discriminator value. Expected ".concat($a782240af38642b4$export$7debb50ef11d5e0b.joinValues(issue.options));
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_enum_value:
            message = "Invalid enum value. Expected ".concat($a782240af38642b4$export$7debb50ef11d5e0b.joinValues(issue.options), ", received '").concat(issue.received, "'");
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_arguments:
            message = "Invalid function arguments";
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_return_type:
            message = "Invalid function return type";
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_date:
            message = "Invalid date";
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = 'Invalid input: must include "'.concat(issue.validation.includes, '"');
                    if (typeof issue.validation.position === "number") message = "".concat(message, " at one or more positions greater than or equal to ").concat(issue.validation.position);
                } else if ("startsWith" in issue.validation) message = 'Invalid input: must start with "'.concat(issue.validation.startsWith, '"');
                else if ("endsWith" in issue.validation) message = 'Invalid input: must end with "'.concat(issue.validation.endsWith, '"');
                else $a782240af38642b4$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = "Invalid ".concat(issue.validation);
            else message = "Invalid";
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "more than", " ").concat(issue.minimum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "over", " ").concat(issue.minimum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(issue.minimum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(new Date(Number(issue.minimum)));
            else message = "Invalid input";
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "less than", " ").concat(issue.maximum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "under", " ").concat(issue.maximum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "bigint") message = "BigInt must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "smaller than or equal to" : "smaller than", " ").concat(new Date(Number(issue.maximum)));
            else message = "Invalid input";
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.custom:
            message = "Invalid input";
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.invalid_intersection_types:
            message = "Intersection results could not be merged";
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.not_multiple_of:
            message = "Number must be a multiple of ".concat(issue.multipleOf);
            break;
        case $a782240af38642b4$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $a782240af38642b4$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
var $a782240af38642b4$var$overrideErrorMap = $a782240af38642b4$export$341b0b6e0a6f5099;
function $a782240af38642b4$export$1097a8289cfd22d7(map) {
    $a782240af38642b4$var$overrideErrorMap = map;
}
function $a782240af38642b4$export$32f27c719778d4c4() {
    return $a782240af38642b4$var$overrideErrorMap;
}
var $a782240af38642b4$export$244a85fde9c419ed = function(params) {
    var data = params.data, path = params.path, errorMaps = params.errorMaps, issueData = params.issueData;
    var fullPath = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(path).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(issueData.path || []));
    var fullIssue = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, issueData), {
        path: fullPath
    });
    var errorMessage = "";
    var maps = errorMaps.filter(function(m) {
        return !!m;
    }).slice().reverse();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = maps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var map = _step.value;
            errorMessage = map(fullIssue, {
                data: data,
                defaultError: errorMessage
            }).message;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, issueData), {
        path: fullPath,
        message: issueData.message || errorMessage
    });
};
var $a782240af38642b4$export$1526d2e05f74572 = [];
function $a782240af38642b4$export$db7caee60e5d514d(ctx, issueData) {
    var issue = $a782240af38642b4$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $a782240af38642b4$export$32f27c719778d4c4(),
            $a782240af38642b4$export$341b0b6e0a6f5099
        ].filter(function(x) {
            return !!x;
        })
    });
    ctx.common.issues.push(issue);
}
var $a782240af38642b4$export$5b20a5c3d05c1f6f = /*#__PURE__*/ function() {
    "use strict";
    function ParseStatus() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ParseStatus);
        this.value = "valid";
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ParseStatus, [
        {
            key: "dirty",
            value: function dirty() {
                if (this.value === "valid") this.value = "dirty";
            }
        },
        {
            key: "abort",
            value: function abort() {
                if (this.value !== "aborted") this.value = "aborted";
            }
        }
    ], [
        {
            key: "mergeArray",
            value: function mergeArray(status, results) {
                var arrayValue = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        if (s.status === "aborted") return $a782240af38642b4$export$9a105a556e65c2c0;
                        if (s.status === "dirty") status.dirty();
                        arrayValue.push(s.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: arrayValue
                };
            }
        },
        {
            key: "mergeObjectAsync",
            value: function mergeObjectAsync(status, pairs) {
                return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, _, _tmp, err;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                _ = syncPairs.push;
                                _tmp = {};
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                _tmp.key = _state.sent();
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    ParseStatus.mergeObjectSync(status, syncPairs)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mergeObjectSync",
            value: function mergeObjectSync(status, pairs) {
                var finalObject = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pair = _step.value;
                        var key = pair.key, value = pair.value;
                        if (key.status === "aborted") return $a782240af38642b4$export$9a105a556e65c2c0;
                        if (value.status === "aborted") return $a782240af38642b4$export$9a105a556e65c2c0;
                        if (key.status === "dirty") status.dirty();
                        if (value.status === "dirty") status.dirty();
                        if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: finalObject
                };
            }
        }
    ]);
    return ParseStatus;
}();
var $a782240af38642b4$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
var $a782240af38642b4$export$325a211da9693fcf = function(value) {
    return {
        status: "dirty",
        value: value
    };
};
var $a782240af38642b4$export$c6813a8d51f77eaf = function(value) {
    return {
        status: "valid",
        value: value
    };
};
var $a782240af38642b4$export$afa861e3c5730743 = function(x) {
    return x.status === "aborted";
};
var $a782240af38642b4$export$910b6cdd390341b3 = function(x) {
    return x.status === "dirty";
};
var $a782240af38642b4$export$1ea939691cdc45b8 = function(x) {
    return x.status === "valid";
};
var $a782240af38642b4$export$aefee5ebe1dcfd9e = function(x) {
    return typeof Promise !== "undefined" && x instanceof Promise;
};
var $a782240af38642b4$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = function(message) {
        return typeof message === "string" ? {
            message: message
        } : message || {};
    };
    errorUtil.toString = function(message) {
        return typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
    };
})($a782240af38642b4$var$errorUtil || ($a782240af38642b4$var$errorUtil = {}));
var $a782240af38642b4$var$ParseInputLazyPath = /*#__PURE__*/ function() {
    "use strict";
    function ParseInputLazyPath(parent, value, path, key) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ParseInputLazyPath);
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ParseInputLazyPath, [
        {
            key: "path",
            get: function get() {
                if (!this._cachedPath.length) {
                    var _this__cachedPath, _this__cachedPath1;
                    if (this._key instanceof Array) (_this__cachedPath = this._cachedPath).push.apply(_this__cachedPath, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._path).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._key)));
                    else (_this__cachedPath1 = this._cachedPath).push.apply(_this__cachedPath1, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._path).concat([
                        this._key
                    ]));
                }
                return this._cachedPath;
            }
        }
    ]);
    return ParseInputLazyPath;
}();
var $a782240af38642b4$var$handleResult = function(ctx, result) {
    if ($a782240af38642b4$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                var error = new $a782240af38642b4$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $a782240af38642b4$var$processCreateParams(params) {
    if (!params) return {};
    var errorMap = params.errorMap, invalid_type_error = params.invalid_type_error, required_error = params.required_error, description = params.description;
    if (errorMap && (invalid_type_error || required_error)) throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    var customMap = function(iss, ctx) {
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
var $a782240af38642b4$export$19342e026b58ebb7 = /*#__PURE__*/ function() {
    "use strict";
    function ZodType(def) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodType);
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodType, [
        {
            key: "description",
            get: function get() {
                return this._def.description;
            }
        },
        {
            key: "_getType",
            value: function _getType(input) {
                return $a782240af38642b4$export$3e9057828ebd5c7a(input.data);
            }
        },
        {
            key: "_getOrReturnCtx",
            value: function _getOrReturnCtx(input, ctx) {
                return ctx || {
                    common: input.parent.common,
                    data: input.data,
                    parsedType: $a782240af38642b4$export$3e9057828ebd5c7a(input.data),
                    schemaErrorMap: this._def.errorMap,
                    path: input.path,
                    parent: input.parent
                };
            }
        },
        {
            key: "_processInputParams",
            value: function _processInputParams(input) {
                return {
                    status: new $a782240af38642b4$export$5b20a5c3d05c1f6f(),
                    ctx: {
                        common: input.parent.common,
                        data: input.data,
                        parsedType: $a782240af38642b4$export$3e9057828ebd5c7a(input.data),
                        schemaErrorMap: this._def.errorMap,
                        path: input.path,
                        parent: input.parent
                    }
                };
            }
        },
        {
            key: "_parseSync",
            value: function _parseSync(input) {
                var result = this._parse(input);
                if ($a782240af38642b4$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
                return result;
            }
        },
        {
            key: "_parseAsync",
            value: function _parseAsync(input) {
                var result = this._parse(input);
                return Promise.resolve(result);
            }
        },
        {
            key: "parse",
            value: function parse(data, params) {
                var result = this.safeParse(data, params);
                if (result.success) return result.data;
                throw result.error;
            }
        },
        {
            key: "safeParse",
            value: function safeParse(data, params) {
                var _a;
                var ctx = {
                    common: {
                        issues: [],
                        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
                    },
                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                    schemaErrorMap: this._def.errorMap,
                    parent: null,
                    data: data,
                    parsedType: $a782240af38642b4$export$3e9057828ebd5c7a(data)
                };
                var result = this._parseSync({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
                return $a782240af38642b4$var$handleResult(ctx, result);
            }
        },
        {
            key: "parseAsync",
            value: function parseAsync(data, params) {
                var _this = this;
                return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var result;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safeParseAsync(data, params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.success) return [
                                    2,
                                    result.data
                                ];
                                throw result.error;
                        }
                    });
                })();
            }
        },
        {
            key: "safeParseAsync",
            value: function safeParseAsync(data, params) {
                var _this = this;
                return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var ctx, maybeAsyncResult, result;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ctx = {
                                    common: {
                                        issues: [],
                                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                                        async: true
                                    },
                                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                                    schemaErrorMap: _this._def.errorMap,
                                    parent: null,
                                    data: data,
                                    parsedType: $a782240af38642b4$export$3e9057828ebd5c7a(data)
                                };
                                maybeAsyncResult = _this._parse({
                                    data: data,
                                    path: ctx.path,
                                    parent: ctx
                                });
                                return [
                                    4,
                                    $a782240af38642b4$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    $a782240af38642b4$var$handleResult(ctx, result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refine",
            value: function refine(check, message) {
                var getIssueProperties = function(val) {
                    if (typeof message === "string" || typeof message === "undefined") return {
                        message: message
                    };
                    else if (typeof message === "function") return message(val);
                    else return message;
                };
                return this._refinement(function(val, ctx) {
                    var result = check(val);
                    var setError = function() {
                        return ctx.addIssue((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                            code: $a782240af38642b4$export$5ba560653e4a1035.custom
                        }, getIssueProperties(val)));
                    };
                    if (typeof Promise !== "undefined" && result instanceof Promise) return result.then(function(data) {
                        if (!data) {
                            setError();
                            return false;
                        } else return true;
                    });
                    if (!result) {
                        setError();
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "refinement",
            value: function refinement(check, refinementData) {
                return this._refinement(function(val, ctx) {
                    if (!check(val)) {
                        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "_refinement",
            value: function _refinement(refinement) {
                return new $a782240af38642b4$export$a60af00cc0ce2582({
                    schema: this,
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodEffects,
                    effect: {
                        type: "refinement",
                        refinement: refinement
                    }
                });
            }
        },
        {
            key: "superRefine",
            value: function superRefine(refinement) {
                return this._refinement(refinement);
            }
        },
        {
            key: "optional",
            value: function optional() {
                return $a782240af38642b4$export$aa56fec1e9d629b8.create(this, this._def);
            }
        },
        {
            key: "nullable",
            value: function nullable() {
                return $a782240af38642b4$export$aaac0b8b429cef5.create(this, this._def);
            }
        },
        {
            key: "nullish",
            value: function nullish() {
                return this.nullable().optional();
            }
        },
        {
            key: "array",
            value: function array() {
                return $a782240af38642b4$export$7acfc3e64785411.create(this, this._def);
            }
        },
        {
            key: "promise",
            value: function promise() {
                return $a782240af38642b4$export$3f196b0127d6e50a.create(this, this._def);
            }
        },
        {
            key: "or",
            value: function or(option) {
                return $a782240af38642b4$export$a8b236cb5070a311.create([
                    this,
                    option
                ], this._def);
            }
        },
        {
            key: "and",
            value: function and(incoming) {
                return $a782240af38642b4$export$c02deaf0bb5203d4.create(this, incoming, this._def);
            }
        },
        {
            key: "transform",
            value: function transform(transform) {
                return new $a782240af38642b4$export$a60af00cc0ce2582((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $a782240af38642b4$var$processCreateParams(this._def)), {
                    schema: this,
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodEffects,
                    effect: {
                        type: "transform",
                        transform: transform
                    }
                }));
            }
        },
        {
            key: "default",
            value: function _default(def) {
                var defaultValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new $a782240af38642b4$export$bb19b37874861e7e((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $a782240af38642b4$var$processCreateParams(this._def)), {
                    innerType: this,
                    defaultValue: defaultValueFunc,
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodDefault
                }));
            }
        },
        {
            key: "brand",
            value: function brand() {
                return new $a782240af38642b4$export$66b0c798a395271f((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodBranded,
                    type: this
                }, $a782240af38642b4$var$processCreateParams(this._def)));
            }
        },
        {
            key: "catch",
            value: function _catch(def) {
                var catchValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new $a782240af38642b4$export$75a44ec6249ac76b((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $a782240af38642b4$var$processCreateParams(this._def)), {
                    innerType: this,
                    catchValue: catchValueFunc,
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodCatch
                }));
            }
        },
        {
            key: "describe",
            value: function describe(description) {
                var This = this.constructor;
                return new This((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    description: description
                }));
            }
        },
        {
            key: "pipe",
            value: function pipe(target) {
                return $a782240af38642b4$export$a3c3ef8a0e95c6da.create(this, target);
            }
        },
        {
            key: "readonly",
            value: function readonly() {
                return $a782240af38642b4$export$5d1f7ef05c4e493a.create(this);
            }
        },
        {
            key: "isOptional",
            value: function isOptional() {
                return this.safeParse(undefined).success;
            }
        },
        {
            key: "isNullable",
            value: function isNullable() {
                return this.safeParse(null).success;
            }
        }
    ]);
    return ZodType;
}();
var $a782240af38642b4$var$cuidRegex = /^c[^\s-]{8,}$/i;
var $a782240af38642b4$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
var $a782240af38642b4$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
var $a782240af38642b4$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var $a782240af38642b4$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
var $a782240af38642b4$var$_emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
var $a782240af38642b4$var$emojiRegex;
var $a782240af38642b4$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var $a782240af38642b4$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
var $a782240af38642b4$var$datetimeRegex = function(args) {
    if (args.precision) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}(([+-]\\d{2}(:?\\d{2})?)|Z)$"));
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}Z$"));
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$");
    } else {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
    }
};
function $a782240af38642b4$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $a782240af38642b4$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $a782240af38642b4$var$ipv6Regex.test(ip)) return true;
    return false;
}
var $a782240af38642b4$export$1230eb29b8d3b502 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodString, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodString);
    function ZodString() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodString);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodString, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = String(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.string) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.string,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var status = new $a782240af38642b4$export$5b20a5c3d05c1f6f();
                var ctx1 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.length < check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.length > check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "length") {
                            var tooBig = input.data.length > check.value;
                            var tooSmall = input.data.length < check.value;
                            if (tooBig || tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                if (tooBig) $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                else if (tooSmall) $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "email") {
                            if (!$a782240af38642b4$var$emailRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    validation: "email",
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "emoji") {
                            if (!$a782240af38642b4$var$emojiRegex) $a782240af38642b4$var$emojiRegex = new RegExp($a782240af38642b4$var$_emojiRegex, "u");
                            if (!$a782240af38642b4$var$emojiRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    validation: "emoji",
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "uuid") {
                            if (!$a782240af38642b4$var$uuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    validation: "uuid",
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid") {
                            if (!$a782240af38642b4$var$cuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    validation: "cuid",
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid2") {
                            if (!$a782240af38642b4$var$cuid2Regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    validation: "cuid2",
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ulid") {
                            if (!$a782240af38642b4$var$ulidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    validation: "ulid",
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "url") try {
                            new URL(input.data);
                        } catch (_a) {
                            ctx1 = this._getOrReturnCtx(input, ctx1);
                            $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                validation: "url",
                                code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                message: check.message
                            });
                            status.dirty();
                        }
                        else if (check.kind === "regex") {
                            check.regex.lastIndex = 0;
                            var testResult = check.regex.test(input.data);
                            if (!testResult) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    validation: "regex",
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "trim") input.data = input.data.trim();
                        else if (check.kind === "includes") {
                            if (!input.data.includes(check.value, check.position)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    validation: {
                                        includes: check.value,
                                        position: check.position
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
                        else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
                        else if (check.kind === "startsWith") {
                            if (!input.data.startsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    validation: {
                                        startsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "endsWith") {
                            if (!input.data.endsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    validation: {
                                        endsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "datetime") {
                            var regex = $a782240af38642b4$var$datetimeRegex(check);
                            if (!regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    validation: "datetime",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ip") {
                            if (!$a782240af38642b4$var$isValidIP(input.data, check.version)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    validation: "ip",
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else $a782240af38642b4$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "_regex",
            value: function _regex(regex, validation, message) {
                return this.refinement(function(data) {
                    return regex.test(data);
                }, (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    validation: validation,
                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_string
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodString((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    checks: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "email",
            value: function email(message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "email"
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "url",
            value: function url(message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "url"
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "emoji",
            value: function emoji(message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "emoji"
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "uuid",
            value: function uuid(message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "uuid"
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid",
            value: function cuid(message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "cuid"
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid2",
            value: function cuid2(message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "cuid2"
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "ulid",
            value: function ulid(message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "ulid"
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "ip",
            value: function ip(options) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "ip"
                }, $a782240af38642b4$var$errorUtil.errToObj(options)));
            }
        },
        {
            key: "datetime",
            value: function datetime(options) {
                var _a;
                if (typeof options === "string") return this._addCheck({
                    kind: "datetime",
                    precision: null,
                    offset: false,
                    message: options
                });
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "datetime",
                    precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
                    offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
                }, $a782240af38642b4$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "regex",
            value: function regex(regex, message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "regex",
                    regex: regex
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "includes",
            value: function includes(value, options) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "includes",
                    value: value,
                    position: options === null || options === void 0 ? void 0 : options.position
                }, $a782240af38642b4$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "startsWith",
            value: function startsWith(value, message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "startsWith",
                    value: value
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "endsWith",
            value: function endsWith(value, message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "endsWith",
                    value: value
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "min",
                    value: minLength
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "max",
                    value: maxLength
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return this._addCheck((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    kind: "length",
                    value: len
                }, $a782240af38642b4$var$errorUtil.errToObj(message)));
            }
        },
        {
            /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, $a782240af38642b4$var$errorUtil.errToObj(message));
            }
        },
        {
            key: "trim",
            value: function trim() {
                return new ZodString((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    checks: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._def.checks).concat([
                        {
                            kind: "trim"
                        }
                    ])
                }));
            }
        },
        {
            key: "toLowerCase",
            value: function toLowerCase() {
                return new ZodString((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    checks: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._def.checks).concat([
                        {
                            kind: "toLowerCase"
                        }
                    ])
                }));
            }
        },
        {
            key: "toUpperCase",
            value: function toUpperCase() {
                return new ZodString((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    checks: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._def.checks).concat([
                        {
                            kind: "toUpperCase"
                        }
                    ])
                }));
            }
        },
        {
            key: "isDatetime",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "datetime";
                });
            }
        },
        {
            key: "isEmail",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "email";
                });
            }
        },
        {
            key: "isURL",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "url";
                });
            }
        },
        {
            key: "isEmoji",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "emoji";
                });
            }
        },
        {
            key: "isUUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "uuid";
                });
            }
        },
        {
            key: "isCUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid";
                });
            }
        },
        {
            key: "isCUID2",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid2";
                });
            }
        },
        {
            key: "isULID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ulid";
                });
            }
        },
        {
            key: "isIP",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ip";
                });
            }
        },
        {
            key: "minLength",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxLength",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodString;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$1230eb29b8d3b502.create = function(params) {
    var _a;
    return new $a782240af38642b4$export$1230eb29b8d3b502((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        checks: [],
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $a782240af38642b4$var$processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $a782240af38642b4$var$floatSafeRemainder(val, step) {
    var valDecCount = (val.toString().split(".")[1] || "").length;
    var stepDecCount = (step.toString().split(".")[1] || "").length;
    var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    var valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    var stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
var $a782240af38642b4$export$5b070a55c0c43e09 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodNumber, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodNumber);
    function ZodNumber() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodNumber);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        _this.step = _this.multipleOf;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodNumber, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Number(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.number) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.number,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var ctx1 = undefined;
                var status = new $a782240af38642b4$export$5b20a5c3d05c1f6f();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "int") {
                            if (!$a782240af38642b4$export$7debb50ef11d5e0b.isInteger(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                                    expected: "integer",
                                    received: "float",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_small,
                                    minimum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_big,
                                    maximum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if ($a782240af38642b4$var$floatSafeRemainder(input.data, check.value) !== 0) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "finite") {
                            if (!Number.isFinite(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.not_finite,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else $a782240af38642b4$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, $a782240af38642b4$var$errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, $a782240af38642b4$var$errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, $a782240af38642b4$var$errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, $a782240af38642b4$var$errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodNumber((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    checks: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: $a782240af38642b4$var$errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodNumber((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    checks: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "int",
            value: function int(message) {
                return this._addCheck({
                    kind: "int",
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: false,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: false,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: true,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: true,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "finite",
            value: function finite(message) {
                return this._addCheck({
                    kind: "finite",
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "safe",
            value: function safe(message) {
                return this._addCheck({
                    kind: "min",
                    inclusive: true,
                    value: Number.MIN_SAFE_INTEGER,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                })._addCheck({
                    kind: "max",
                    inclusive: true,
                    value: Number.MAX_SAFE_INTEGER,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        },
        {
            key: "isInt",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "int" || ch.kind === "multipleOf" && $a782240af38642b4$export$7debb50ef11d5e0b.isInteger(ch.value);
                });
            }
        },
        {
            key: "isFinite",
            get: function get() {
                var max = null, min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
                        else if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        } else if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Number.isFinite(min) && Number.isFinite(max);
            }
        }
    ]);
    return ZodNumber;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$5b070a55c0c43e09.create = function(params) {
    return new $a782240af38642b4$export$5b070a55c0c43e09((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        checks: [],
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$67d741fd70ff98f4 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodBigInt, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodBigInt);
    function ZodBigInt() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodBigInt);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodBigInt, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = BigInt(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.bigint) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.bigint,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var ctx1 = undefined;
                var status = new $a782240af38642b4$export$5b20a5c3d05c1f6f();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_small,
                                    type: "bigint",
                                    minimum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_big,
                                    type: "bigint",
                                    maximum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if (input.data % check.value !== BigInt(0)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else $a782240af38642b4$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, $a782240af38642b4$var$errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, $a782240af38642b4$var$errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, $a782240af38642b4$var$errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, $a782240af38642b4$var$errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodBigInt((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    checks: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: $a782240af38642b4$var$errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodBigInt((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    checks: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: false,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: false,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: true,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: true,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodBigInt;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$67d741fd70ff98f4.create = function(params) {
    var _a;
    return new $a782240af38642b4$export$67d741fd70ff98f4((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        checks: [],
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$723d146f80596191 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodBoolean, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodBoolean);
    function ZodBoolean() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodBoolean);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodBoolean, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Boolean(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.boolean) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.boolean,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                return $a782240af38642b4$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodBoolean;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$723d146f80596191.create = function(params) {
    return new $a782240af38642b4$export$723d146f80596191((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$e974be33bdc55521 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodDate, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodDate);
    function ZodDate() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodDate);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodDate, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = new Date(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.date) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.date,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                if (isNaN(input.data.getTime())) {
                    var ctx1 = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_date
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var status = new $a782240af38642b4$export$5b20a5c3d05c1f6f();
                var ctx2 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.getTime() < check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx2, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_small,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    minimum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.getTime() > check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                $a782240af38642b4$export$db7caee60e5d514d(ctx2, {
                                    code: $a782240af38642b4$export$5ba560653e4a1035.too_big,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    maximum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else $a782240af38642b4$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: new Date(input.data.getTime())
                };
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodDate((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    checks: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "min",
            value: function min(minDate, message) {
                return this._addCheck({
                    kind: "min",
                    value: minDate.getTime(),
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "max",
            value: function max(maxDate, message) {
                return this._addCheck({
                    kind: "max",
                    value: maxDate.getTime(),
                    message: $a782240af38642b4$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "minDate",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min != null ? new Date(min) : null;
            }
        },
        {
            key: "maxDate",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max != null ? new Date(max) : null;
            }
        }
    ]);
    return ZodDate;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$e974be33bdc55521.create = function(params) {
    return new $a782240af38642b4$export$e974be33bdc55521((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodDate
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$bcc3b40f6b638044 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodSymbol, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodSymbol);
    function ZodSymbol() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodSymbol);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodSymbol, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.symbol) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.symbol,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                return $a782240af38642b4$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodSymbol;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$bcc3b40f6b638044.create = function(params) {
    return new $a782240af38642b4$export$bcc3b40f6b638044((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodSymbol
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$4e780e961c30340d = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodUndefined, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodUndefined);
    function ZodUndefined() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodUndefined);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodUndefined, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.undefined,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                return $a782240af38642b4$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodUndefined;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$4e780e961c30340d.create = function(params) {
    return new $a782240af38642b4$export$4e780e961c30340d((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodUndefined
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$a96281f914484f2d = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodNull, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodNull);
    function ZodNull() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodNull);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodNull, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.null) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.null,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                return $a782240af38642b4$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodNull;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$a96281f914484f2d.create = function(params) {
    return new $a782240af38642b4$export$a96281f914484f2d((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodNull
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$b9d1edb536b4e4eb = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodAny, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodAny);
    function ZodAny() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodAny);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        _this._any = true;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodAny, [
        {
            key: "_parse",
            value: function _parse(input) {
                return $a782240af38642b4$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodAny;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$b9d1edb536b4e4eb.create = function(params) {
    return new $a782240af38642b4$export$b9d1edb536b4e4eb((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodAny
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$ef3b1bb1630977ae = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodUnknown, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodUnknown);
    function ZodUnknown() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodUnknown);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // required
        _this._unknown = true;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodUnknown, [
        {
            key: "_parse",
            value: function _parse(input) {
                return $a782240af38642b4$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodUnknown;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$ef3b1bb1630977ae.create = function(params) {
    return new $a782240af38642b4$export$ef3b1bb1630977ae((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodUnknown
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$1e576a20c3ce9fb5 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodNever, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodNever);
    function ZodNever() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodNever);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodNever, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._getOrReturnCtx(input);
                $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                    code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                    expected: $a782240af38642b4$export$5716da67bfaa244d.never,
                    received: ctx.parsedType
                });
                return $a782240af38642b4$export$9a105a556e65c2c0;
            }
        }
    ]);
    return ZodNever;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$1e576a20c3ce9fb5.create = function(params) {
    return new $a782240af38642b4$export$1e576a20c3ce9fb5((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodNever
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$7d39f5df85f21031 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodVoid, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodVoid);
    function ZodVoid() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodVoid);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodVoid, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.void,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                return $a782240af38642b4$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodVoid;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$7d39f5df85f21031.create = function(params) {
    return new $a782240af38642b4$export$7d39f5df85f21031((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodVoid
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$7acfc3e64785411 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodArray, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodArray);
    function ZodArray() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodArray);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodArray, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), ctx = _this__processInputParams.ctx, status = _this__processInputParams.status;
                var def = this._def;
                if (ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.array) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.array,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                if (def.exactLength !== null) {
                    var tooBig = ctx.data.length > def.exactLength.value;
                    var tooSmall = ctx.data.length < def.exactLength.value;
                    if (tooBig || tooSmall) {
                        $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                            code: tooBig ? $a782240af38642b4$export$5ba560653e4a1035.too_big : $a782240af38642b4$export$5ba560653e4a1035.too_small,
                            minimum: tooSmall ? def.exactLength.value : undefined,
                            maximum: tooBig ? def.exactLength.value : undefined,
                            type: "array",
                            inclusive: true,
                            exact: true,
                            message: def.exactLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.minLength !== null) {
                    if (ctx.data.length < def.minLength.value) {
                        $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                            code: $a782240af38642b4$export$5ba560653e4a1035.too_small,
                            minimum: def.minLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.minLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxLength !== null) {
                    if (ctx.data.length > def.maxLength.value) {
                        $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                            code: $a782240af38642b4$export$5ba560653e4a1035.too_big,
                            maximum: def.maxLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.maxLength.message
                        });
                        status.dirty();
                    }
                }
                if (ctx.common.async) return Promise.all((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(ctx.data).map(function(item, i) {
                    return def.type._parseAsync(new $a782240af38642b4$var$ParseInputLazyPath(ctx, item, ctx.path, i));
                })).then(function(result) {
                    return $a782240af38642b4$export$5b20a5c3d05c1f6f.mergeArray(status, result);
                });
                var result = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(ctx.data).map(function(item, i) {
                    return def.type._parseSync(new $a782240af38642b4$var$ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                return $a782240af38642b4$export$5b20a5c3d05c1f6f.mergeArray(status, result);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.type;
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return new ZodArray((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    minLength: {
                        value: minLength,
                        message: $a782240af38642b4$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return new ZodArray((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    maxLength: {
                        value: maxLength,
                        message: $a782240af38642b4$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return new ZodArray((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    exactLength: {
                        value: len,
                        message: $a782240af38642b4$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodArray;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$7acfc3e64785411.create = function(schema, params) {
    return new $a782240af38642b4$export$7acfc3e64785411((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodArray
    }, $a782240af38642b4$var$processCreateParams(params)));
};
function $a782240af38642b4$var$deepPartialify(schema) {
    if (schema instanceof $a782240af38642b4$export$736315c5b55efbad) {
        var newShape = {};
        for(var key in schema.shape){
            var fieldSchema = schema.shape[key];
            newShape[key] = $a782240af38642b4$export$aa56fec1e9d629b8.create($a782240af38642b4$var$deepPartialify(fieldSchema));
        }
        return new $a782240af38642b4$export$736315c5b55efbad((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, schema._def), {
            shape: function() {
                return newShape;
            }
        }));
    } else if (schema instanceof $a782240af38642b4$export$7acfc3e64785411) return new $a782240af38642b4$export$7acfc3e64785411((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, schema._def), {
        type: $a782240af38642b4$var$deepPartialify(schema.element)
    }));
    else if (schema instanceof $a782240af38642b4$export$aa56fec1e9d629b8) return $a782240af38642b4$export$aa56fec1e9d629b8.create($a782240af38642b4$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $a782240af38642b4$export$aaac0b8b429cef5) return $a782240af38642b4$export$aaac0b8b429cef5.create($a782240af38642b4$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $a782240af38642b4$export$e2a18bb771d8e6a3) return $a782240af38642b4$export$e2a18bb771d8e6a3.create(schema.items.map(function(item) {
        return $a782240af38642b4$var$deepPartialify(item);
    }));
    else return schema;
}
var $a782240af38642b4$export$736315c5b55efbad = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodObject, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodObject);
    function ZodObject() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodObject);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ _this.nonstrict = _this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ _this.augment = _this.extend;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodObject, [
        {
            key: "_getCached",
            value: function _getCached() {
                if (this._cached !== null) return this._cached;
                var shape = this._def.shape();
                var keys = $a782240af38642b4$export$7debb50ef11d5e0b.objectKeys(shape);
                return this._cached = {
                    shape: shape,
                    keys: keys
                };
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.object) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.object,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx1 = _this__processInputParams.ctx;
                var _this__getCached = this._getCached(), shape = _this__getCached.shape, shapeKeys = _this__getCached.keys;
                var extraKeys = [];
                if (!(this._def.catchall instanceof $a782240af38642b4$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
                    for(var key in ctx1.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
                }
                var pairs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = shapeKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        var keyValidator = shape[key1];
                        var value = ctx1.data[key1];
                        pairs.push({
                            key: {
                                status: "valid",
                                value: key1
                            },
                            value: keyValidator._parse(new $a782240af38642b4$var$ParseInputLazyPath(ctx1, value, ctx1.path, key1)),
                            alwaysSet: key1 in ctx1.data
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._def.catchall instanceof $a782240af38642b4$export$1e576a20c3ce9fb5) {
                    var unknownKeys = this._def.unknownKeys;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (unknownKeys === "passthrough") try {
                        for(var _iterator1 = extraKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key2 = _step1.value;
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key2
                                },
                                value: {
                                    status: "valid",
                                    value: ctx1.data[key2]
                                }
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    else if (unknownKeys === "strict") {
                        if (extraKeys.length > 0) {
                            $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                                code: $a782240af38642b4$export$5ba560653e4a1035.unrecognized_keys,
                                keys: extraKeys
                            });
                            status.dirty();
                        }
                    } else if (unknownKeys === "strip") ;
                    else throw new Error("Internal ZodObject error: invalid unknownKeys value.");
                } else {
                    // run catchall validation
                    var catchall = this._def.catchall;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = extraKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var key3 = _step2.value;
                            var value1 = ctx1.data[key3];
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key3
                                },
                                value: catchall._parse(new $a782240af38642b4$var$ParseInputLazyPath(ctx1, value1, ctx1.path, key3) //, ctx.child(key), value, getParsedType(value)
                                ),
                                alwaysSet: key3 in ctx1.data
                            });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
                if (ctx1.common.async) return Promise.resolve().then(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, _, _tmp, err;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                key = _state.sent();
                                _ = syncPairs.push;
                                _tmp = {
                                    key: key
                                };
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp.alwaysSet = pair.alwaysSet, _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    syncPairs
                                ];
                        }
                    });
                })).then(function(syncPairs) {
                    return $a782240af38642b4$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
                });
                else return $a782240af38642b4$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "shape",
            get: function get() {
                return this._def.shape();
            }
        },
        {
            key: "strict",
            value: function strict(message) {
                var _this = this;
                $a782240af38642b4$var$errorUtil.errToObj;
                return new ZodObject((0, $79de63f6394f39c4$export$581ff339ea0ba762)((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    unknownKeys: "strict"
                }), message !== undefined ? {
                    errorMap: function(issue, ctx) {
                        var _a, _b, _c, _d;
                        var defaultError = (_c = (_b = (_a = _this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys") return {
                            message: (_d = $a782240af38642b4$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                        };
                        return {
                            message: defaultError
                        };
                    }
                } : {}));
            }
        },
        {
            key: "strip",
            value: function strip() {
                return new ZodObject((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    unknownKeys: "strip"
                }));
            }
        },
        {
            key: "passthrough",
            value: function passthrough() {
                return new ZodObject((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    unknownKeys: "passthrough"
                }));
            }
        },
        {
            // const AugmentFactory =
            //   <Def extends ZodObjectDef>(def: Def) =>
            //   <Augmentation extends ZodRawShape>(
            //     augmentation: Augmentation
            //   ): ZodObject<
            //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
            //     Def["unknownKeys"],
            //     Def["catchall"]
            //   > => {
            //     return new ZodObject({
            //       ...def,
            //       shape: () => ({
            //         ...def.shape(),
            //         ...augmentation,
            //       }),
            //     }) as any;
            //   };
            key: "extend",
            value: function extend(augmentation) {
                var _this = this;
                return new ZodObject((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    shape: function() {
                        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _this._def.shape(), augmentation);
                    }
                }));
            }
        },
        {
            /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ key: "merge",
            value: function merge(merging) {
                var _this = this;
                var merged = new ZodObject({
                    unknownKeys: merging._def.unknownKeys,
                    catchall: merging._def.catchall,
                    shape: function() {
                        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _this._def.shape(), merging._def.shape());
                    },
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodObject
                });
                return merged;
            }
        },
        {
            // merge<
            //   Incoming extends AnyZodObject,
            //   Augmentation extends Incoming["shape"],
            //   NewOutput extends {
            //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
            //       ? Augmentation[k]["_output"]
            //       : k extends keyof Output
            //       ? Output[k]
            //       : never;
            //   },
            //   NewInput extends {
            //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
            //       ? Augmentation[k]["_input"]
            //       : k extends keyof Input
            //       ? Input[k]
            //       : never;
            //   }
            // >(
            //   merging: Incoming
            // ): ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"],
            //   NewOutput,
            //   NewInput
            // > {
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "setKey",
            value: function setKey(key, schema) {
                return this.augment((0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, key, schema));
            }
        },
        {
            // merge<Incoming extends AnyZodObject>(
            //   merging: Incoming
            // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
            // ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"]
            // > {
            //   // const mergedShape = objectUtil.mergeShapes(
            //   //   this._def.shape(),
            //   //   merging._def.shape()
            //   // );
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "catchall",
            value: function catchall(index) {
                return new ZodObject((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    catchall: index
                }));
            }
        },
        {
            key: "pick",
            value: function pick(mask) {
                var _this = this;
                var shape = {};
                $a782240af38642b4$export$7debb50ef11d5e0b.objectKeys(mask).forEach(function(key) {
                    if (mask[key] && _this.shape[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            key: "omit",
            value: function omit(mask) {
                var _this = this;
                var shape = {};
                $a782240af38642b4$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach(function(key) {
                    if (!mask[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            /**
     * @deprecated
     */ key: "deepPartial",
            value: function deepPartial() {
                return $a782240af38642b4$var$deepPartialify(this);
            }
        },
        {
            key: "partial",
            value: function partial(mask) {
                var _this = this;
                var newShape = {};
                $a782240af38642b4$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach(function(key) {
                    var fieldSchema = _this.shape[key];
                    if (mask && !mask[key]) newShape[key] = fieldSchema;
                    else newShape[key] = fieldSchema.optional();
                });
                return new ZodObject((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "required",
            value: function required(mask) {
                var _this = this;
                var newShape = {};
                $a782240af38642b4$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach(function(key) {
                    if (mask && !mask[key]) newShape[key] = _this.shape[key];
                    else {
                        var fieldSchema = _this.shape[key];
                        var newField = fieldSchema;
                        while(newField instanceof $a782240af38642b4$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                        newShape[key] = newField;
                    }
                });
                return new ZodObject((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "keyof",
            value: function keyof() {
                return $a782240af38642b4$var$createZodEnum($a782240af38642b4$export$7debb50ef11d5e0b.objectKeys(this.shape));
            }
        }
    ]);
    return ZodObject;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$736315c5b55efbad.create = function(shape, params) {
    return new $a782240af38642b4$export$736315c5b55efbad((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strip",
        catchall: $a782240af38642b4$export$1e576a20c3ce9fb5.create(),
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodObject
    }, $a782240af38642b4$var$processCreateParams(params)));
};
$a782240af38642b4$export$736315c5b55efbad.strictCreate = function(shape, params) {
    return new $a782240af38642b4$export$736315c5b55efbad((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strict",
        catchall: $a782240af38642b4$export$1e576a20c3ce9fb5.create(),
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodObject
    }, $a782240af38642b4$var$processCreateParams(params)));
};
$a782240af38642b4$export$736315c5b55efbad.lazycreate = function(shape, params) {
    return new $a782240af38642b4$export$736315c5b55efbad((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        shape: shape,
        unknownKeys: "strip",
        catchall: $a782240af38642b4$export$1e576a20c3ce9fb5.create(),
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodObject
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$a8b236cb5070a311 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodUnion, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodUnion);
    function ZodUnion() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodUnion);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var options = this._def.options;
                function handleResults(results) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // return first issue-free validation if it exists
                        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var result = _step.value;
                            if (result.result.status === "valid") return result.result;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = results[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var result1 = _step1.value;
                            if (result1.result.status === "dirty") {
                                var // add issues from dirty option
                                _ctx_common_issues;
                                (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(result1.ctx.common.issues));
                                return result1.result;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    // return invalid
                    var unionErrors = results.map(function(result) {
                        return new $a782240af38642b4$export$f98dac4b251ab333(result.ctx.common.issues);
                    });
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_union,
                        unionErrors: unionErrors
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                if (ctx.common.async) return Promise.all(options.map(function() {
                    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(option) {
                        var childCtx, _tmp;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    childCtx = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, ctx), {
                                        common: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, ctx.common), {
                                            issues: []
                                        }),
                                        parent: null
                                    });
                                    _tmp = {};
                                    return [
                                        4,
                                        option._parseAsync({
                                            data: ctx.data,
                                            path: ctx.path,
                                            parent: childCtx
                                        })
                                    ];
                                case 1:
                                    return [
                                        2,
                                        (_tmp.result = _state.sent(), _tmp.ctx = childCtx, _tmp)
                                    ];
                            }
                        });
                    });
                    return function(option) {
                        return _ref.apply(this, arguments);
                    };
                }())).then(handleResults);
                else {
                    var dirty = undefined;
                    var issues = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var option = _step.value;
                            var childCtx = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, ctx), {
                                common: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, ctx.common), {
                                    issues: []
                                }),
                                parent: null
                            });
                            var result = option._parseSync({
                                data: ctx.data,
                                path: ctx.path,
                                parent: childCtx
                            });
                            if (result.status === "valid") return result;
                            else if (result.status === "dirty" && !dirty) dirty = {
                                result: result,
                                ctx: childCtx
                            };
                            if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (dirty) {
                        var _ctx_common_issues;
                        (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(dirty.ctx.common.issues));
                        return dirty.result;
                    }
                    var unionErrors = issues.map(function(issues) {
                        return new $a782240af38642b4$export$f98dac4b251ab333(issues);
                    });
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_union,
                        unionErrors: unionErrors
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        }
    ]);
    return ZodUnion;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$a8b236cb5070a311.create = function(types, params) {
    return new $a782240af38642b4$export$a8b236cb5070a311((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        options: types,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodUnion
    }, $a782240af38642b4$var$processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
var $a782240af38642b4$var$getDiscriminator = function(type) {
    if (type instanceof $a782240af38642b4$export$378d0cfce37406e6) return $a782240af38642b4$var$getDiscriminator(type.schema);
    else if (type instanceof $a782240af38642b4$export$a60af00cc0ce2582) return $a782240af38642b4$var$getDiscriminator(type.innerType());
    else if (type instanceof $a782240af38642b4$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $a782240af38642b4$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $a782240af38642b4$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $a782240af38642b4$export$bb19b37874861e7e) return $a782240af38642b4$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $a782240af38642b4$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $a782240af38642b4$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
var $a782240af38642b4$export$5ef2424805ac76a3 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodDiscriminatedUnion, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodDiscriminatedUnion);
    function ZodDiscriminatedUnion() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodDiscriminatedUnion);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodDiscriminatedUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.object) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.object,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var discriminator = this.discriminator;
                var discriminatorValue = ctx.data[discriminator];
                var option = this.optionsMap.get(discriminatorValue);
                if (!option) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_union_discriminator,
                        options: Array.from(this.optionsMap.keys()),
                        path: [
                            discriminator
                        ]
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                if (ctx.common.async) return option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                else return option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "discriminator",
            get: function get() {
                return this._def.discriminator;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        },
        {
            key: "optionsMap",
            get: function get() {
                return this._def.optionsMap;
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ function create(discriminator, options, params) {
                // Get all the valid discriminator values
                var optionsMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // try {
                    for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var type = _step.value;
                        var discriminatorValues = $a782240af38642b4$var$getDiscriminator(type.shape[discriminator]);
                        if (!discriminatorValues) throw new Error("A discriminator value for key `".concat(discriminator, "` could not be extracted from all schema options"));
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = discriminatorValues[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var value = _step1.value;
                                if (optionsMap.has(value)) throw new Error("Discriminator property ".concat(String(discriminator), " has duplicate value ").concat(String(value)));
                                optionsMap.set(value, type);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new ZodDiscriminatedUnion((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodDiscriminatedUnion,
                    discriminator: discriminator,
                    options: options,
                    optionsMap: optionsMap
                }, $a782240af38642b4$var$processCreateParams(params)));
            }
        }
    ]);
    return ZodDiscriminatedUnion;
}($a782240af38642b4$export$19342e026b58ebb7);
function $a782240af38642b4$var$mergeValues(a, b) {
    var aType = $a782240af38642b4$export$3e9057828ebd5c7a(a);
    var bType = $a782240af38642b4$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $a782240af38642b4$export$5716da67bfaa244d.object && bType === $a782240af38642b4$export$5716da67bfaa244d.object) {
        var bKeys = $a782240af38642b4$export$7debb50ef11d5e0b.objectKeys(b);
        var sharedKeys = $a782240af38642b4$export$7debb50ef11d5e0b.objectKeys(a).filter(function(key) {
            return bKeys.indexOf(key) !== -1;
        });
        var newObj = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, a, b);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sharedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var sharedValue = $a782240af38642b4$var$mergeValues(a[key], b[key]);
                if (!sharedValue.valid) return {
                    valid: false
                };
                newObj[key] = sharedValue.data;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $a782240af38642b4$export$5716da67bfaa244d.array && bType === $a782240af38642b4$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        var newArray = [];
        for(var index = 0; index < a.length; index++){
            var itemA = a[index];
            var itemB = b[index];
            var sharedValue1 = $a782240af38642b4$var$mergeValues(itemA, itemB);
            if (!sharedValue1.valid) return {
                valid: false
            };
            newArray.push(sharedValue1.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $a782240af38642b4$export$5716da67bfaa244d.date && bType === $a782240af38642b4$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
var $a782240af38642b4$export$c02deaf0bb5203d4 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodIntersection, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodIntersection);
    function ZodIntersection() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodIntersection);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodIntersection, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var handleParsed = function(parsedLeft, parsedRight) {
                    if ($a782240af38642b4$export$afa861e3c5730743(parsedLeft) || $a782240af38642b4$export$afa861e3c5730743(parsedRight)) return $a782240af38642b4$export$9a105a556e65c2c0;
                    var merged = $a782240af38642b4$var$mergeValues(parsedLeft.value, parsedRight.value);
                    if (!merged.valid) {
                        $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                            code: $a782240af38642b4$export$5ba560653e4a1035.invalid_intersection_types
                        });
                        return $a782240af38642b4$export$9a105a556e65c2c0;
                    }
                    if ($a782240af38642b4$export$910b6cdd390341b3(parsedLeft) || $a782240af38642b4$export$910b6cdd390341b3(parsedRight)) status.dirty();
                    return {
                        status: status.value,
                        value: merged.data
                    };
                };
                if (ctx.common.async) return Promise.all([
                    this._def.left._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }),
                    this._def.right._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    })
                ]).then(function(param) {
                    var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 2), left = _param[0], right = _param[1];
                    return handleParsed(left, right);
                });
                else return handleParsed(this._def.left._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }), this._def.right._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }));
            }
        }
    ]);
    return ZodIntersection;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$c02deaf0bb5203d4.create = function(left, right, params) {
    return new $a782240af38642b4$export$c02deaf0bb5203d4((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        left: left,
        right: right,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodIntersection
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$e2a18bb771d8e6a3 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodTuple, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodTuple);
    function ZodTuple() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodTuple);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodTuple, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.array) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.array,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                if (ctx.data.length < this._def.items.length) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.too_small,
                        minimum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var rest = this._def.rest;
                if (!rest && ctx.data.length > this._def.items.length) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.too_big,
                        maximum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    status.dirty();
                }
                var items = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(ctx.data).map(function(item, itemIndex) {
                    var schema = _this._def.items[itemIndex] || _this._def.rest;
                    if (!schema) return null;
                    return schema._parse(new $a782240af38642b4$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
                }).filter(function(x) {
                    return !!x;
                }); // filter nulls
                if (ctx.common.async) return Promise.all(items).then(function(results) {
                    return $a782240af38642b4$export$5b20a5c3d05c1f6f.mergeArray(status, results);
                });
                else return $a782240af38642b4$export$5b20a5c3d05c1f6f.mergeArray(status, items);
            }
        },
        {
            key: "items",
            get: function get() {
                return this._def.items;
            }
        },
        {
            key: "rest",
            value: function rest(rest) {
                return new ZodTuple((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    rest: rest
                }));
            }
        }
    ]);
    return ZodTuple;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$e2a18bb771d8e6a3.create = function(schemas, params) {
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $a782240af38642b4$export$e2a18bb771d8e6a3((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        items: schemas,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodTuple,
        rest: null
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$a2acc09968cb4b7f = /*#__PURE__*/ function(ZodType1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodRecord, ZodType1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodRecord);
    function ZodRecord() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodRecord);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodRecord, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.object) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.object,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var pairs = [];
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                for(var key in ctx.data)pairs.push({
                    key: keyType._parse(new $a782240af38642b4$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
                    value: valueType._parse(new $a782240af38642b4$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
                });
                if (ctx.common.async) return $a782240af38642b4$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
                else return $a782240af38642b4$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.valueType;
            }
        }
    ], [
        {
            key: "create",
            value: function create(first, second, third) {
                if (second instanceof $a782240af38642b4$export$19342e026b58ebb7) return new ZodRecord((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    keyType: first,
                    valueType: second,
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodRecord
                }, $a782240af38642b4$var$processCreateParams(third)));
                return new ZodRecord((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    keyType: $a782240af38642b4$export$1230eb29b8d3b502.create(),
                    valueType: first,
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodRecord
                }, $a782240af38642b4$var$processCreateParams(second)));
            }
        }
    ]);
    return ZodRecord;
}($a782240af38642b4$export$19342e026b58ebb7);
var $a782240af38642b4$export$163b6a2b712d9542 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodMap, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodMap);
    function ZodMap() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodMap);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodMap, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.map) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.map,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                var pairs = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(ctx.data.entries()).map(function(param, index) {
                    var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 2), key = _param[0], value = _param[1];
                    return {
                        key: keyType._parse(new $a782240af38642b4$var$ParseInputLazyPath(ctx, key, ctx.path, [
                            index,
                            "key"
                        ])),
                        value: valueType._parse(new $a782240af38642b4$var$ParseInputLazyPath(ctx, value, ctx.path, [
                            index,
                            "value"
                        ]))
                    };
                });
                if (ctx.common.async) {
                    var finalMap = new Map();
                    return Promise.resolve().then(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, value, err;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        7,
                                        8,
                                        9
                                    ]);
                                    _iterator = pairs[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        6
                                    ];
                                    pair = _step.value;
                                    return [
                                        4,
                                        pair.key
                                    ];
                                case 3:
                                    key = _state.sent();
                                    return [
                                        4,
                                        pair.value
                                    ];
                                case 4:
                                    value = _state.sent();
                                    if (key.status === "aborted" || value.status === "aborted") return [
                                        2,
                                        $a782240af38642b4$export$9a105a556e65c2c0
                                    ];
                                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                                    finalMap.set(key.value, value.value);
                                    _state.label = 5;
                                case 5:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 6:
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 9:
                                    return [
                                        2,
                                        {
                                            status: status.value,
                                            value: finalMap
                                        }
                                    ];
                            }
                        });
                    }));
                } else {
                    var finalMap1 = new Map();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var pair = _step.value;
                            var key = pair.key;
                            var value = pair.value;
                            if (key.status === "aborted" || value.status === "aborted") return $a782240af38642b4$export$9a105a556e65c2c0;
                            if (key.status === "dirty" || value.status === "dirty") status.dirty();
                            finalMap1.set(key.value, value.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: finalMap1
                    };
                }
            }
        }
    ]);
    return ZodMap;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$163b6a2b712d9542.create = function(keyType, valueType, params) {
    return new $a782240af38642b4$export$163b6a2b712d9542((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        valueType: valueType,
        keyType: keyType,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodMap
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$977057706f816712 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodSet, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodSet);
    function ZodSet() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodSet);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodSet, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.set) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.set,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var def = this._def;
                if (def.minSize !== null) {
                    if (ctx.data.size < def.minSize.value) {
                        $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                            code: $a782240af38642b4$export$5ba560653e4a1035.too_small,
                            minimum: def.minSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.minSize.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxSize !== null) {
                    if (ctx.data.size > def.maxSize.value) {
                        $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                            code: $a782240af38642b4$export$5ba560653e4a1035.too_big,
                            maximum: def.maxSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.maxSize.message
                        });
                        status.dirty();
                    }
                }
                var valueType = this._def.valueType;
                function finalizeSet(elements) {
                    var parsedSet = new Set();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            if (element.status === "aborted") return $a782240af38642b4$export$9a105a556e65c2c0;
                            if (element.status === "dirty") status.dirty();
                            parsedSet.add(element.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: parsedSet
                    };
                }
                var elements = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(ctx.data.values()).map(function(item, i) {
                    return valueType._parse(new $a782240af38642b4$var$ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                if (ctx.common.async) return Promise.all(elements).then(function(elements) {
                    return finalizeSet(elements);
                });
                else return finalizeSet(elements);
            }
        },
        {
            key: "min",
            value: function min(minSize, message) {
                return new ZodSet((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    minSize: {
                        value: minSize,
                        message: $a782240af38642b4$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxSize, message) {
                return new ZodSet((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    maxSize: {
                        value: maxSize,
                        message: $a782240af38642b4$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "size",
            value: function size(size, message) {
                return this.min(size, message).max(size, message);
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodSet;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$977057706f816712.create = function(valueType, params) {
    return new $a782240af38642b4$export$977057706f816712((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodSet
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$d4602ba55673f53c = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodFunction, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodFunction);
    function ZodFunction() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodFunction);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.validate = _this.implement;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodFunction, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.function) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.function,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                function makeArgsIssue(args, error) {
                    return $a782240af38642b4$export$244a85fde9c419ed({
                        data: args,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            $a782240af38642b4$export$32f27c719778d4c4(),
                            $a782240af38642b4$export$341b0b6e0a6f5099
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: $a782240af38642b4$export$5ba560653e4a1035.invalid_arguments,
                            argumentsError: error
                        }
                    });
                }
                function makeReturnsIssue(returns, error) {
                    return $a782240af38642b4$export$244a85fde9c419ed({
                        data: returns,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            $a782240af38642b4$export$32f27c719778d4c4(),
                            $a782240af38642b4$export$341b0b6e0a6f5099
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: $a782240af38642b4$export$5ba560653e4a1035.invalid_return_type,
                            returnTypeError: error
                        }
                    });
                }
                var params = {
                    errorMap: ctx.common.contextualErrorMap
                };
                var fn = ctx.data;
                if (this._def.returns instanceof $a782240af38642b4$export$3f196b0127d6e50a) {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me = this;
                    return $a782240af38642b4$export$c6813a8d51f77eaf(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                        var _len, args, _key, error, parsedArgs, result, parsedReturns;
                        var _arguments = arguments;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                        args[_key] = _arguments[_key];
                                    }
                                    error = new $a782240af38642b4$export$f98dac4b251ab333([]);
                                    return [
                                        4,
                                        me._def.args.parseAsync(args, params).catch(function(e) {
                                            error.addIssue(makeArgsIssue(args, e));
                                            throw error;
                                        })
                                    ];
                                case 1:
                                    parsedArgs = _state.sent();
                                    return [
                                        4,
                                        Reflect.apply(fn, this, parsedArgs)
                                    ];
                                case 2:
                                    result = _state.sent();
                                    return [
                                        4,
                                        me._def.returns._def.type.parseAsync(result, params).catch(function(e) {
                                            error.addIssue(makeReturnsIssue(result, e));
                                            throw error;
                                        })
                                    ];
                                case 3:
                                    parsedReturns = _state.sent();
                                    return [
                                        2,
                                        parsedReturns
                                    ];
                            }
                        });
                    }));
                } else {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me1 = this;
                    return $a782240af38642b4$export$c6813a8d51f77eaf(function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var parsedArgs = me1._def.args.safeParse(args, params);
                        if (!parsedArgs.success) throw new $a782240af38642b4$export$f98dac4b251ab333([
                            makeArgsIssue(args, parsedArgs.error)
                        ]);
                        var result = Reflect.apply(fn, this, parsedArgs.data);
                        var parsedReturns = me1._def.returns.safeParse(result, params);
                        if (!parsedReturns.success) throw new $a782240af38642b4$export$f98dac4b251ab333([
                            makeReturnsIssue(result, parsedReturns.error)
                        ]);
                        return parsedReturns.data;
                    });
                }
            }
        },
        {
            key: "parameters",
            value: function parameters() {
                return this._def.args;
            }
        },
        {
            key: "returnType",
            value: function returnType() {
                return this._def.returns;
            }
        },
        {
            key: "args",
            value: function args() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return new ZodFunction((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    args: $a782240af38642b4$export$e2a18bb771d8e6a3.create(items).rest($a782240af38642b4$export$ef3b1bb1630977ae.create())
                }));
            }
        },
        {
            key: "returns",
            value: function returns(returnType) {
                return new ZodFunction((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this._def), {
                    returns: returnType
                }));
            }
        },
        {
            key: "implement",
            value: function implement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        },
        {
            key: "strictImplement",
            value: function strictImplement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        }
    ], [
        {
            key: "create",
            value: function create(args, returns, params) {
                return new ZodFunction((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    args: args ? args : $a782240af38642b4$export$e2a18bb771d8e6a3.create([]).rest($a782240af38642b4$export$ef3b1bb1630977ae.create()),
                    returns: returns || $a782240af38642b4$export$ef3b1bb1630977ae.create(),
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodFunction
                }, $a782240af38642b4$var$processCreateParams(params)));
            }
        }
    ]);
    return ZodFunction;
}($a782240af38642b4$export$19342e026b58ebb7);
var $a782240af38642b4$export$378d0cfce37406e6 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodLazy, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodLazy);
    function ZodLazy() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodLazy);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodLazy, [
        {
            key: "schema",
            get: function get() {
                return this._def.getter();
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var lazySchema = this._def.getter();
                return lazySchema._parse({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        }
    ]);
    return ZodLazy;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$378d0cfce37406e6.create = function(getter, params) {
    return new $a782240af38642b4$export$378d0cfce37406e6((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        getter: getter,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodLazy
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$7e44096782a165d3 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodLiteral, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodLiteral);
    function ZodLiteral() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodLiteral);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodLiteral, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (input.data !== this._def.value) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        received: ctx.data,
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_literal,
                        expected: this._def.value
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        },
        {
            key: "value",
            get: function get() {
                return this._def.value;
            }
        }
    ]);
    return ZodLiteral;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$7e44096782a165d3.create = function(value, params) {
    return new $a782240af38642b4$export$7e44096782a165d3((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        value: value,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodLiteral
    }, $a782240af38642b4$var$processCreateParams(params)));
};
function $a782240af38642b4$var$createZodEnum(values, params) {
    return new $a782240af38642b4$export$d325d1f0e1c20179((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        values: values,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodEnum
    }, $a782240af38642b4$var$processCreateParams(params)));
}
var $a782240af38642b4$export$d325d1f0e1c20179 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodEnum, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodEnum);
    function ZodEnum() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodEnum);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (typeof input.data !== "string") {
                    var ctx = this._getOrReturnCtx(input);
                    var expectedValues = this._def.values;
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        expected: $a782240af38642b4$export$7debb50ef11d5e0b.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                if (this._def.values.indexOf(input.data) === -1) {
                    var ctx1 = this._getOrReturnCtx(input);
                    var expectedValues1 = this._def.values;
                    $a782240af38642b4$export$db7caee60e5d514d(ctx1, {
                        received: ctx1.data,
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_enum_value,
                        options: expectedValues1
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                return $a782240af38642b4$export$c6813a8d51f77eaf(input.data);
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.values;
            }
        },
        {
            key: "enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Values",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "extract",
            value: function extract(values) {
                return ZodEnum.create(values);
            }
        },
        {
            key: "exclude",
            value: function exclude(values) {
                return ZodEnum.create(this.options.filter(function(opt) {
                    return !values.includes(opt);
                }));
            }
        }
    ]);
    return ZodEnum;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$d325d1f0e1c20179.create = $a782240af38642b4$var$createZodEnum;
var $a782240af38642b4$export$370b2e8d6d6f5c56 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodNativeEnum, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodNativeEnum);
    function ZodNativeEnum() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodNativeEnum);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodNativeEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                var nativeEnumValues = $a782240af38642b4$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
                var ctx = this._getOrReturnCtx(input);
                if (ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.string && ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.number) {
                    var expectedValues = $a782240af38642b4$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        expected: $a782240af38642b4$export$7debb50ef11d5e0b.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                if (nativeEnumValues.indexOf(input.data) === -1) {
                    var expectedValues1 = $a782240af38642b4$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        received: ctx.data,
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_enum_value,
                        options: expectedValues1
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                return $a782240af38642b4$export$c6813a8d51f77eaf(input.data);
            }
        },
        {
            key: "enum",
            get: function get() {
                return this._def.values;
            }
        }
    ]);
    return ZodNativeEnum;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$370b2e8d6d6f5c56.create = function(values, params) {
    return new $a782240af38642b4$export$370b2e8d6d6f5c56((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        values: values,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodNativeEnum
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$3f196b0127d6e50a = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodPromise, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodPromise);
    function ZodPromise() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodPromise);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodPromise, [
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== $a782240af38642b4$export$5716da67bfaa244d.promise && ctx.common.async === false) {
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.promise,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                var promisified = ctx.parsedType === $a782240af38642b4$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
                return $a782240af38642b4$export$c6813a8d51f77eaf(promisified.then(function(data) {
                    return _this._def.type.parseAsync(data, {
                        path: ctx.path,
                        errorMap: ctx.common.contextualErrorMap
                    });
                }));
            }
        }
    ]);
    return ZodPromise;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$3f196b0127d6e50a.create = function(schema, params) {
    return new $a782240af38642b4$export$3f196b0127d6e50a((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        type: schema,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodPromise
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$a60af00cc0ce2582 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodEffects, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodEffects);
    function ZodEffects() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodEffects);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodEffects, [
        {
            key: "innerType",
            value: function innerType() {
                return this._def.schema;
            }
        },
        {
            key: "sourceType",
            value: function sourceType() {
                return this._def.schema._def.typeName === $a782240af38642b4$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var effect = this._def.effect || null;
                var checkCtx = {
                    addIssue: function(arg) {
                        $a782240af38642b4$export$db7caee60e5d514d(ctx, arg);
                        if (arg.fatal) status.abort();
                        else status.dirty();
                    },
                    get path () {
                        return ctx.path;
                    }
                };
                checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
                if (effect.type === "preprocess") {
                    var processed = effect.transform(ctx.data, checkCtx);
                    if (ctx.common.issues.length) return {
                        status: "dirty",
                        value: ctx.data
                    };
                    if (ctx.common.async) return Promise.resolve(processed).then(function(processed) {
                        return _this._def.schema._parseAsync({
                            data: processed,
                            path: ctx.path,
                            parent: ctx
                        });
                    });
                    else return this._def.schema._parseSync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx
                    });
                }
                if (effect.type === "refinement") {
                    var executeRefinement = function(acc) {
                        var result = effect.refinement(acc, checkCtx);
                        if (ctx.common.async) return Promise.resolve(result);
                        if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                        return acc;
                    };
                    if (ctx.common.async === false) {
                        var inner = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (inner.status === "aborted") return $a782240af38642b4$export$9a105a556e65c2c0;
                        if (inner.status === "dirty") status.dirty();
                        // return value is ignored
                        executeRefinement(inner.value);
                        return {
                            status: status.value,
                            value: inner.value
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(inner) {
                        if (inner.status === "aborted") return $a782240af38642b4$export$9a105a556e65c2c0;
                        if (inner.status === "dirty") status.dirty();
                        return executeRefinement(inner.value).then(function() {
                            return {
                                status: status.value,
                                value: inner.value
                            };
                        });
                    });
                }
                if (effect.type === "transform") {
                    if (ctx.common.async === false) {
                        var base = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (!$a782240af38642b4$export$1ea939691cdc45b8(base)) return base;
                        var result = effect.transform(base.value, checkCtx);
                        if (result instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
                        return {
                            status: status.value,
                            value: result
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(base) {
                        if (!$a782240af38642b4$export$1ea939691cdc45b8(base)) return base;
                        return Promise.resolve(effect.transform(base.value, checkCtx)).then(function(result) {
                            return {
                                status: status.value,
                                value: result
                            };
                        });
                    });
                }
                $a782240af38642b4$export$7debb50ef11d5e0b.assertNever(effect);
            }
        }
    ]);
    return ZodEffects;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$a60af00cc0ce2582.create = function(schema, effect, params) {
    return new $a782240af38642b4$export$a60af00cc0ce2582((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        schema: schema,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodEffects,
        effect: effect
    }, $a782240af38642b4$var$processCreateParams(params)));
};
$a782240af38642b4$export$a60af00cc0ce2582.createWithPreprocess = function(preprocess, schema, params) {
    return new $a782240af38642b4$export$a60af00cc0ce2582((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodEffects
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$aa56fec1e9d629b8 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodOptional, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodOptional);
    function ZodOptional() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodOptional);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodOptional, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === $a782240af38642b4$export$5716da67bfaa244d.undefined) return $a782240af38642b4$export$c6813a8d51f77eaf(undefined);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodOptional;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$aa56fec1e9d629b8.create = function(type, params) {
    return new $a782240af38642b4$export$aa56fec1e9d629b8((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodOptional
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$aaac0b8b429cef5 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodNullable, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodNullable);
    function ZodNullable() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodNullable);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodNullable, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === $a782240af38642b4$export$5716da67bfaa244d.null) return $a782240af38642b4$export$c6813a8d51f77eaf(null);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodNullable;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$aaac0b8b429cef5.create = function(type, params) {
    return new $a782240af38642b4$export$aaac0b8b429cef5((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodNullable
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$bb19b37874861e7e = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodDefault, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodDefault);
    function ZodDefault() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodDefault);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodDefault, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                if (ctx.parsedType === $a782240af38642b4$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
                return this._def.innerType._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "removeDefault",
            value: function removeDefault() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodDefault;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$bb19b37874861e7e.create = function(type, params) {
    return new $a782240af38642b4$export$bb19b37874861e7e((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : function() {
            return params.default;
        }
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$75a44ec6249ac76b = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodCatch, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodCatch);
    function ZodCatch() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodCatch);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodCatch, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                // newCtx is used to not collect issues from inner types in ctx
                var newCtx = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, ctx), {
                    common: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, ctx.common), {
                        issues: []
                    })
                });
                var result = this._def.innerType._parse({
                    data: newCtx.data,
                    path: newCtx.path,
                    parent: (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, newCtx)
                });
                if ($a782240af38642b4$export$aefee5ebe1dcfd9e(result)) return result.then(function(result) {
                    return {
                        status: "valid",
                        value: result.status === "valid" ? result.value : _this._def.catchValue({
                            get error () {
                                return new $a782240af38642b4$export$f98dac4b251ab333(newCtx.common.issues);
                            },
                            input: newCtx.data
                        })
                    };
                });
                else return {
                    status: "valid",
                    value: result.status === "valid" ? result.value : this._def.catchValue({
                        get error () {
                            return new $a782240af38642b4$export$f98dac4b251ab333(newCtx.common.issues);
                        },
                        input: newCtx.data
                    })
                };
            }
        },
        {
            key: "removeCatch",
            value: function removeCatch() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodCatch;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$75a44ec6249ac76b.create = function(type, params) {
    return new $a782240af38642b4$export$75a44ec6249ac76b((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : function() {
            return params.catch;
        }
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$26ccfa0145e8511f = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodNaN, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodNaN);
    function ZodNaN() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodNaN);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodNaN, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $a782240af38642b4$export$5716da67bfaa244d.nan) {
                    var ctx = this._getOrReturnCtx(input);
                    $a782240af38642b4$export$db7caee60e5d514d(ctx, {
                        code: $a782240af38642b4$export$5ba560653e4a1035.invalid_type,
                        expected: $a782240af38642b4$export$5716da67bfaa244d.nan,
                        received: ctx.parsedType
                    });
                    return $a782240af38642b4$export$9a105a556e65c2c0;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        }
    ]);
    return ZodNaN;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$26ccfa0145e8511f.create = function(params) {
    return new $a782240af38642b4$export$26ccfa0145e8511f((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodNaN
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$cf2deea74cde46b4 = Symbol("zod_brand");
var $a782240af38642b4$export$66b0c798a395271f = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodBranded, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodBranded);
    function ZodBranded() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodBranded);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodBranded, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                return this._def.type._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        }
    ]);
    return ZodBranded;
}($a782240af38642b4$export$19342e026b58ebb7);
var $a782240af38642b4$export$a3c3ef8a0e95c6da = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodPipeline, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodPipeline);
    function ZodPipeline() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodPipeline);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodPipeline, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.common.async) {
                    var _this = this;
                    var handleAsync = function() {
                        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                            var inResult;
                            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this._def.in._parseAsync({
                                                data: ctx.data,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                    case 1:
                                        inResult = _state.sent();
                                        if (inResult.status === "aborted") return [
                                            2,
                                            $a782240af38642b4$export$9a105a556e65c2c0
                                        ];
                                        if (inResult.status === "dirty") {
                                            status.dirty();
                                            return [
                                                2,
                                                $a782240af38642b4$export$325a211da9693fcf(inResult.value)
                                            ];
                                        } else return [
                                            2,
                                            _this._def.out._parseAsync({
                                                data: inResult.value,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function handleAsync() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return handleAsync();
                } else {
                    var inResult = this._def.in._parseSync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    });
                    if (inResult.status === "aborted") return $a782240af38642b4$export$9a105a556e65c2c0;
                    if (inResult.status === "dirty") {
                        status.dirty();
                        return {
                            status: "dirty",
                            value: inResult.value
                        };
                    } else return this._def.out._parseSync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx
                    });
                }
            }
        }
    ], [
        {
            key: "create",
            value: function create(a, b) {
                return new ZodPipeline({
                    in: a,
                    out: b,
                    typeName: $a782240af38642b4$export$558106ce543bd011.ZodPipeline
                });
            }
        }
    ]);
    return ZodPipeline;
}($a782240af38642b4$export$19342e026b58ebb7);
var $a782240af38642b4$export$5d1f7ef05c4e493a = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ZodReadonly, ZodType);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ZodReadonly);
    function ZodReadonly() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ZodReadonly);
        return _super.apply(this, arguments);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(ZodReadonly, [
        {
            key: "_parse",
            value: function _parse(input) {
                var result = this._def.innerType._parse(input);
                if ($a782240af38642b4$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
                return result;
            }
        }
    ]);
    return ZodReadonly;
}($a782240af38642b4$export$19342e026b58ebb7);
$a782240af38642b4$export$5d1f7ef05c4e493a.create = function(type, params) {
    return new $a782240af38642b4$export$5d1f7ef05c4e493a((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $a782240af38642b4$export$558106ce543bd011.ZodReadonly
    }, $a782240af38642b4$var$processCreateParams(params)));
};
var $a782240af38642b4$export$4c00f665f0d4b443 = function(check) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal = arguments.length > 2 ? arguments[2] : void 0;
    if (check) return $a782240af38642b4$export$b9d1edb536b4e4eb.create().superRefine(function(data, ctx) {
        var _a, _b;
        if (!check(data)) {
            var p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            var _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            var p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return $a782240af38642b4$export$b9d1edb536b4e4eb.create();
};
var $a782240af38642b4$export$1ee8ee30835eab8b = {
    object: $a782240af38642b4$export$736315c5b55efbad.lazycreate
};
var $a782240af38642b4$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($a782240af38642b4$export$558106ce543bd011 || ($a782240af38642b4$export$558106ce543bd011 = {}));
var $a782240af38642b4$export$3d916e7c22dbd8b5 = function(// const instanceOfType = <T extends new (...args: any[]) => any>(
cls) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        message: "Input not instance of ".concat(cls.name)
    };
    return $a782240af38642b4$export$4c00f665f0d4b443(function(data) {
        return data instanceof cls;
    }, params);
};
var $a782240af38642b4$export$22b082955e083ec3 = $a782240af38642b4$export$1230eb29b8d3b502.create;
var $a782240af38642b4$export$98e628dec113755e = $a782240af38642b4$export$5b070a55c0c43e09.create;
var $a782240af38642b4$export$9e06de0973666692 = $a782240af38642b4$export$26ccfa0145e8511f.create;
var $a782240af38642b4$export$a0f65b52274bcc00 = $a782240af38642b4$export$67d741fd70ff98f4.create;
var $a782240af38642b4$export$4a21f16c33752377 = $a782240af38642b4$export$723d146f80596191.create;
var $a782240af38642b4$export$324d90190a8b822a = $a782240af38642b4$export$e974be33bdc55521.create;
var $a782240af38642b4$export$8f701197936bc2a6 = $a782240af38642b4$export$bcc3b40f6b638044.create;
var $a782240af38642b4$export$1db45310990710a5 = $a782240af38642b4$export$4e780e961c30340d.create;
var $a782240af38642b4$export$7b1b591b262c240 = $a782240af38642b4$export$a96281f914484f2d.create;
var $a782240af38642b4$export$4154a199d7d90455 = $a782240af38642b4$export$b9d1edb536b4e4eb.create;
var $a782240af38642b4$export$19282c40b967aec6 = $a782240af38642b4$export$ef3b1bb1630977ae.create;
var $a782240af38642b4$export$b3e22bcfd64c1022 = $a782240af38642b4$export$1e576a20c3ce9fb5.create;
var $a782240af38642b4$export$490e536ee7389aeb = $a782240af38642b4$export$7d39f5df85f21031.create;
var $a782240af38642b4$export$2f23118c22fb2630 = $a782240af38642b4$export$7acfc3e64785411.create;
var $a782240af38642b4$export$be5493f9613cbbe = $a782240af38642b4$export$736315c5b55efbad.create;
var $a782240af38642b4$export$8fb0df5f40d0b477 = $a782240af38642b4$export$736315c5b55efbad.strictCreate;
var $a782240af38642b4$export$971dd5b0dfd021b6 = $a782240af38642b4$export$a8b236cb5070a311.create;
var $a782240af38642b4$export$4b888e40c4ee26dd = $a782240af38642b4$export$5ef2424805ac76a3.create;
var $a782240af38642b4$export$bc86dfbf7795668c = $a782240af38642b4$export$c02deaf0bb5203d4.create;
var $a782240af38642b4$export$65e3907585753458 = $a782240af38642b4$export$e2a18bb771d8e6a3.create;
var $a782240af38642b4$export$e5185e241753e543 = $a782240af38642b4$export$a2acc09968cb4b7f.create;
var $a782240af38642b4$export$871de8747c9eaa88 = $a782240af38642b4$export$163b6a2b712d9542.create;
var $a782240af38642b4$export$adaa4cf7ef1b65be = $a782240af38642b4$export$977057706f816712.create;
var $a782240af38642b4$export$44e51c8aac7c2deb = $a782240af38642b4$export$d4602ba55673f53c.create;
var $a782240af38642b4$export$488013bae63b21da = $a782240af38642b4$export$378d0cfce37406e6.create;
var $a782240af38642b4$export$c8ec6e1ec9fefcb0 = $a782240af38642b4$export$7e44096782a165d3.create;
var $a782240af38642b4$export$78a99c8d44d72635 = $a782240af38642b4$export$d325d1f0e1c20179.create;
var $a782240af38642b4$export$6fe7eca19ebe5199 = $a782240af38642b4$export$370b2e8d6d6f5c56.create;
var $a782240af38642b4$export$c957ef27a0ebfd4 = $a782240af38642b4$export$3f196b0127d6e50a.create;
var $a782240af38642b4$export$dc573d8a6576cdb3 = $a782240af38642b4$export$a60af00cc0ce2582.create;
var $a782240af38642b4$export$516e28dec6a4b6d4 = $a782240af38642b4$export$aa56fec1e9d629b8.create;
var $a782240af38642b4$export$133fc36489ac9add = $a782240af38642b4$export$aaac0b8b429cef5.create;
var $a782240af38642b4$export$fc37fe19dfda43ee = $a782240af38642b4$export$a60af00cc0ce2582.createWithPreprocess;
var $a782240af38642b4$export$43f28b24e1eb8181 = $a782240af38642b4$export$a3c3ef8a0e95c6da.create;
var $a782240af38642b4$export$3b3d07727c5b702c = function() {
    return $a782240af38642b4$export$22b082955e083ec3().optional();
};
var $a782240af38642b4$export$eb150471a61fced6 = function() {
    return $a782240af38642b4$export$98e628dec113755e().optional();
};
var $a782240af38642b4$export$269251733cdcbbf1 = function() {
    return $a782240af38642b4$export$4a21f16c33752377().optional();
};
var $a782240af38642b4$export$8c14e57e778d3873 = {
    string: function(arg) {
        return $a782240af38642b4$export$1230eb29b8d3b502.create((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        }));
    },
    number: function(arg) {
        return $a782240af38642b4$export$5b070a55c0c43e09.create((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        }));
    },
    boolean: function(arg) {
        return $a782240af38642b4$export$723d146f80596191.create((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        }));
    },
    bigint: function(arg) {
        return $a782240af38642b4$export$67d741fd70ff98f4.create((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        }));
    },
    date: function(arg) {
        return $a782240af38642b4$export$e974be33bdc55521.create((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        }));
    }
};
var $a782240af38642b4$export$96c94437c95d7862 = $a782240af38642b4$export$9a105a556e65c2c0;
var $a782240af38642b4$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $a782240af38642b4$export$341b0b6e0a6f5099,
    setErrorMap: $a782240af38642b4$export$1097a8289cfd22d7,
    getErrorMap: $a782240af38642b4$export$32f27c719778d4c4,
    makeIssue: $a782240af38642b4$export$244a85fde9c419ed,
    EMPTY_PATH: $a782240af38642b4$export$1526d2e05f74572,
    addIssueToContext: $a782240af38642b4$export$db7caee60e5d514d,
    ParseStatus: $a782240af38642b4$export$5b20a5c3d05c1f6f,
    INVALID: $a782240af38642b4$export$9a105a556e65c2c0,
    DIRTY: $a782240af38642b4$export$325a211da9693fcf,
    OK: $a782240af38642b4$export$c6813a8d51f77eaf,
    isAborted: $a782240af38642b4$export$afa861e3c5730743,
    isDirty: $a782240af38642b4$export$910b6cdd390341b3,
    isValid: $a782240af38642b4$export$1ea939691cdc45b8,
    isAsync: $a782240af38642b4$export$aefee5ebe1dcfd9e,
    get util () {
        return $a782240af38642b4$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $a782240af38642b4$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $a782240af38642b4$export$5716da67bfaa244d,
    getParsedType: $a782240af38642b4$export$3e9057828ebd5c7a,
    ZodType: $a782240af38642b4$export$19342e026b58ebb7,
    ZodString: $a782240af38642b4$export$1230eb29b8d3b502,
    ZodNumber: $a782240af38642b4$export$5b070a55c0c43e09,
    ZodBigInt: $a782240af38642b4$export$67d741fd70ff98f4,
    ZodBoolean: $a782240af38642b4$export$723d146f80596191,
    ZodDate: $a782240af38642b4$export$e974be33bdc55521,
    ZodSymbol: $a782240af38642b4$export$bcc3b40f6b638044,
    ZodUndefined: $a782240af38642b4$export$4e780e961c30340d,
    ZodNull: $a782240af38642b4$export$a96281f914484f2d,
    ZodAny: $a782240af38642b4$export$b9d1edb536b4e4eb,
    ZodUnknown: $a782240af38642b4$export$ef3b1bb1630977ae,
    ZodNever: $a782240af38642b4$export$1e576a20c3ce9fb5,
    ZodVoid: $a782240af38642b4$export$7d39f5df85f21031,
    ZodArray: $a782240af38642b4$export$7acfc3e64785411,
    ZodObject: $a782240af38642b4$export$736315c5b55efbad,
    ZodUnion: $a782240af38642b4$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $a782240af38642b4$export$5ef2424805ac76a3,
    ZodIntersection: $a782240af38642b4$export$c02deaf0bb5203d4,
    ZodTuple: $a782240af38642b4$export$e2a18bb771d8e6a3,
    ZodRecord: $a782240af38642b4$export$a2acc09968cb4b7f,
    ZodMap: $a782240af38642b4$export$163b6a2b712d9542,
    ZodSet: $a782240af38642b4$export$977057706f816712,
    ZodFunction: $a782240af38642b4$export$d4602ba55673f53c,
    ZodLazy: $a782240af38642b4$export$378d0cfce37406e6,
    ZodLiteral: $a782240af38642b4$export$7e44096782a165d3,
    ZodEnum: $a782240af38642b4$export$d325d1f0e1c20179,
    ZodNativeEnum: $a782240af38642b4$export$370b2e8d6d6f5c56,
    ZodPromise: $a782240af38642b4$export$3f196b0127d6e50a,
    ZodEffects: $a782240af38642b4$export$a60af00cc0ce2582,
    ZodTransformer: $a782240af38642b4$export$a60af00cc0ce2582,
    ZodOptional: $a782240af38642b4$export$aa56fec1e9d629b8,
    ZodNullable: $a782240af38642b4$export$aaac0b8b429cef5,
    ZodDefault: $a782240af38642b4$export$bb19b37874861e7e,
    ZodCatch: $a782240af38642b4$export$75a44ec6249ac76b,
    ZodNaN: $a782240af38642b4$export$26ccfa0145e8511f,
    BRAND: $a782240af38642b4$export$cf2deea74cde46b4,
    ZodBranded: $a782240af38642b4$export$66b0c798a395271f,
    ZodPipeline: $a782240af38642b4$export$a3c3ef8a0e95c6da,
    ZodReadonly: $a782240af38642b4$export$5d1f7ef05c4e493a,
    custom: $a782240af38642b4$export$4c00f665f0d4b443,
    Schema: $a782240af38642b4$export$19342e026b58ebb7,
    ZodSchema: $a782240af38642b4$export$19342e026b58ebb7,
    late: $a782240af38642b4$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $a782240af38642b4$export$558106ce543bd011;
    },
    coerce: $a782240af38642b4$export$8c14e57e778d3873,
    any: $a782240af38642b4$export$4154a199d7d90455,
    array: $a782240af38642b4$export$2f23118c22fb2630,
    bigint: $a782240af38642b4$export$a0f65b52274bcc00,
    boolean: $a782240af38642b4$export$4a21f16c33752377,
    date: $a782240af38642b4$export$324d90190a8b822a,
    discriminatedUnion: $a782240af38642b4$export$4b888e40c4ee26dd,
    effect: $a782240af38642b4$export$dc573d8a6576cdb3,
    "enum": $a782240af38642b4$export$78a99c8d44d72635,
    "function": $a782240af38642b4$export$44e51c8aac7c2deb,
    "instanceof": $a782240af38642b4$export$3d916e7c22dbd8b5,
    intersection: $a782240af38642b4$export$bc86dfbf7795668c,
    lazy: $a782240af38642b4$export$488013bae63b21da,
    literal: $a782240af38642b4$export$c8ec6e1ec9fefcb0,
    map: $a782240af38642b4$export$871de8747c9eaa88,
    nan: $a782240af38642b4$export$9e06de0973666692,
    nativeEnum: $a782240af38642b4$export$6fe7eca19ebe5199,
    never: $a782240af38642b4$export$b3e22bcfd64c1022,
    "null": $a782240af38642b4$export$7b1b591b262c240,
    nullable: $a782240af38642b4$export$133fc36489ac9add,
    number: $a782240af38642b4$export$98e628dec113755e,
    object: $a782240af38642b4$export$be5493f9613cbbe,
    oboolean: $a782240af38642b4$export$269251733cdcbbf1,
    onumber: $a782240af38642b4$export$eb150471a61fced6,
    optional: $a782240af38642b4$export$516e28dec6a4b6d4,
    ostring: $a782240af38642b4$export$3b3d07727c5b702c,
    pipeline: $a782240af38642b4$export$43f28b24e1eb8181,
    preprocess: $a782240af38642b4$export$fc37fe19dfda43ee,
    promise: $a782240af38642b4$export$c957ef27a0ebfd4,
    record: $a782240af38642b4$export$e5185e241753e543,
    set: $a782240af38642b4$export$adaa4cf7ef1b65be,
    strictObject: $a782240af38642b4$export$8fb0df5f40d0b477,
    string: $a782240af38642b4$export$22b082955e083ec3,
    symbol: $a782240af38642b4$export$8f701197936bc2a6,
    transformer: $a782240af38642b4$export$dc573d8a6576cdb3,
    tuple: $a782240af38642b4$export$65e3907585753458,
    "undefined": $a782240af38642b4$export$1db45310990710a5,
    union: $a782240af38642b4$export$971dd5b0dfd021b6,
    unknown: $a782240af38642b4$export$19282c40b967aec6,
    "void": $a782240af38642b4$export$490e536ee7389aeb,
    NEVER: $a782240af38642b4$export$96c94437c95d7862,
    ZodIssueCode: $a782240af38642b4$export$5ba560653e4a1035,
    quotelessJson: $a782240af38642b4$export$913eddeaf297cfea,
    ZodError: $a782240af38642b4$export$f98dac4b251ab333
});


var $78a5beb0029c3750$export$48c1db756576ae1 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    value: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $78a5beb0029c3750$export$ab6045338fa7d71b = $78a5beb0029c3750$export$48c1db756576ae1.array();
var $78a5beb0029c3750$export$10762083065a1f71 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    status: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    ssl: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        status: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        validation_errors: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
            message: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
        }).array().optional()
    }),
    verification_errors: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().array().optional()
});
var $78a5beb0029c3750$export$4bfadd7b59276a6c;
(function(DomainStatus) {
    DomainStatus["PendingVerification"] = "PendingVerification";
    DomainStatus["PendingSsl"] = "PendingSsl";
    DomainStatus["Active"] = "Active";
    DomainStatus["Error"] = "Error";
})($78a5beb0029c3750$export$4bfadd7b59276a6c || ($78a5beb0029c3750$export$4bfadd7b59276a6c = {}));
var $78a5beb0029c3750$export$fda7fbe88a5ffb61 = (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($78a5beb0029c3750$export$4bfadd7b59276a6c);



var $227a41d6a40c4b57$export$740c928c8ba29add;
(function(InteractionHookEvent) {
    InteractionHookEvent["PostRegister"] = "PostRegister";
    InteractionHookEvent["PostSignIn"] = "PostSignIn";
    InteractionHookEvent["PostResetPassword"] = "PostResetPassword";
})($227a41d6a40c4b57$export$740c928c8ba29add || ($227a41d6a40c4b57$export$740c928c8ba29add = {}));
var $227a41d6a40c4b57$export$21fcfd6e96906288;
(function(DataHookSchema) {
    DataHookSchema["User"] = "User";
    DataHookSchema["Role"] = "Role";
    DataHookSchema["Scope"] = "Scope";
    DataHookSchema["Organization"] = "Organization";
    DataHookSchema["OrganizationRole"] = "OrganizationRole";
    DataHookSchema["OrganizationScope"] = "OrganizationScope";
})($227a41d6a40c4b57$export$21fcfd6e96906288 || ($227a41d6a40c4b57$export$21fcfd6e96906288 = {}));
var $227a41d6a40c4b57$var$DataHookBasicMutationType;
(function(DataHookBasicMutationType) {
    DataHookBasicMutationType["Created"] = "Created";
    DataHookBasicMutationType["Deleted"] = "Deleted";
})($227a41d6a40c4b57$var$DataHookBasicMutationType || ($227a41d6a40c4b57$var$DataHookBasicMutationType = {}));
var $227a41d6a40c4b57$var$DataHookDetailMutationType;
(function(DataHookDetailMutationType) {
    DataHookDetailMutationType["Updated"] = "Updated";
})($227a41d6a40c4b57$var$DataHookDetailMutationType || ($227a41d6a40c4b57$var$DataHookDetailMutationType = {}));
var $227a41d6a40c4b57$export$a2d50f63a5a1b889 = Object.freeze([
    $227a41d6a40c4b57$export$740c928c8ba29add.PostRegister,
    $227a41d6a40c4b57$export$740c928c8ba29add.PostSignIn,
    $227a41d6a40c4b57$export$740c928c8ba29add.PostResetPassword,
    "User.Created",
    "User.Deleted",
    "User.Data.Updated",
    "User.SuspensionStatus.Updated",
    "Role.Created",
    "Role.Deleted",
    "Role.Data.Updated",
    "Role.Scopes.Updated",
    "Scope.Created",
    "Scope.Deleted",
    "Scope.Data.Updated",
    "Organization.Created",
    "Organization.Deleted",
    "Organization.Data.Updated",
    "Organization.Membership.Updated",
    "OrganizationRole.Created",
    "OrganizationRole.Deleted",
    "OrganizationRole.Data.Updated",
    "OrganizationRole.Scopes.Updated",
    "OrganizationScope.Created",
    "OrganizationScope.Deleted",
    "OrganizationScope.Data.Updated"
]);
var $227a41d6a40c4b57$export$2d2b15eb4f8d4fc9 = (0, $a782240af38642b4$export$2e2bcd8739ae039).enum($227a41d6a40c4b57$export$a2d50f63a5a1b889);
var $227a41d6a40c4b57$export$56e77a150fce61b = $227a41d6a40c4b57$export$2d2b15eb4f8d4fc9.array();
var $227a41d6a40c4b57$export$d04e851658657a7f = (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($227a41d6a40c4b57$export$740c928c8ba29add);
var $227a41d6a40c4b57$export$924993b6fcd8d738 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    /** We don't need `type` since v1 only has web hook */ // type: 'web';
    /** Method fixed to `POST` */ url: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /** Additional headers that attach to the request */ headers: (0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).string()).optional(),
    /**
     * @deprecated
     * Retry times when hook response status >= 500.
     * Now the retry times is fixed to 3.
     * Keep for backward compatibility.
     */ retries: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().gte(0).lte(3).optional()
});
var $227a41d6a40c4b57$export$d5a3d643322527d7 = Object.freeze({
    "POST /users": "User.Created",
    "DELETE /users/:userId": "User.Deleted",
    "PATCH /users/:userId": "User.Data.Updated",
    "PATCH /users/:userId/custom-data": "User.Data.Updated",
    "PATCH /users/:userId/profile": "User.Data.Updated",
    "PATCH /users/:userId/password": "User.Data.Updated",
    "PATCH /users/:userId/is-suspended": "User.SuspensionStatus.Updated",
    "POST /roles": "Role.Created",
    "DELETE /roles/:id": "Role.Deleted",
    "PATCH /roles/:id": "Role.Data.Updated",
    "POST /roles/:id/scopes": "Role.Scopes.Updated",
    "DELETE /roles/:id/scopes/:scopeId": "Role.Scopes.Updated",
    "POST /resources/:resourceId/scopes": "Scope.Created",
    "DELETE /resources/:resourceId/scopes/:scopeId": "Scope.Deleted",
    "PATCH /resources/:resourceId/scopes/:scopeId": "Scope.Data.Updated",
    "POST /organizations": "Organization.Created",
    "DELETE /organizations/:id": "Organization.Deleted",
    "PATCH /organizations/:id": "Organization.Data.Updated",
    "PUT /organizations/:id/users": "Organization.Membership.Updated",
    "POST /organizations/:id/users": "Organization.Membership.Updated",
    "DELETE /organizations/:id/users/:userId": "Organization.Membership.Updated",
    "POST /organization-roles": "OrganizationRole.Created",
    "DELETE /organization-roles/:id": "OrganizationRole.Deleted",
    "PATCH /organization-roles/:id": "OrganizationRole.Data.Updated",
    "POST /organization-scopes": "OrganizationScope.Created",
    "DELETE /organization-scopes/:id": "OrganizationScope.Deleted",
    "PATCH /organization-scopes/:id": "OrganizationScope.Data.Updated",
    "PUT /organization-roles/:id/scopes": "OrganizationRole.Scopes.Updated",
    "POST /organization-roles/:id/scopes": "OrganizationRole.Scopes.Updated",
    "DELETE /organization-roles/:id/scopes/:organizationScopeId": "OrganizationRole.Scopes.Updated"
});


var $40a1317a33725c7b$exports = {};



var $3L4GM = parcelRequire("3L4GM");
var $7cc8c246b5551314$exports = {};
/* MIT license */ var $c02aa735e07d5b11$exports = {};
"use strict";
$c02aa735e07d5b11$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $bf9f398580fdc1b7$exports = {};
"use strict";
var $a55033329bcfbf37$exports = {};
$a55033329bcfbf37$exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};


var $bf9f398580fdc1b7$var$concat = Array.prototype.concat;
var $bf9f398580fdc1b7$var$slice = Array.prototype.slice;
var $bf9f398580fdc1b7$var$swizzle = $bf9f398580fdc1b7$exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($a55033329bcfbf37$exports(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $bf9f398580fdc1b7$var$concat.call(results, $bf9f398580fdc1b7$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$bf9f398580fdc1b7$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($bf9f398580fdc1b7$var$swizzle(arguments));
    };
};


var $7cc8c246b5551314$var$hasOwnProperty = Object.hasOwnProperty;
var $7cc8c246b5551314$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $7cc8c246b5551314$var$name in $c02aa735e07d5b11$exports)if ($7cc8c246b5551314$var$hasOwnProperty.call($c02aa735e07d5b11$exports, $7cc8c246b5551314$var$name)) $7cc8c246b5551314$var$reverseNames[$c02aa735e07d5b11$exports[$7cc8c246b5551314$var$name]] = $7cc8c246b5551314$var$name;
var $7cc8c246b5551314$var$cs = $7cc8c246b5551314$exports = {
    to: {},
    get: {}
};
$7cc8c246b5551314$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = $7cc8c246b5551314$var$cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = $7cc8c246b5551314$var$cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = $7cc8c246b5551314$var$cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$7cc8c246b5551314$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        if (!$7cc8c246b5551314$var$hasOwnProperty.call($c02aa735e07d5b11$exports, match[1])) return null;
        rgb = $c02aa735e07d5b11$exports[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $7cc8c246b5551314$var$clamp(rgb[i], 0, 255);
    rgb[3] = $7cc8c246b5551314$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$7cc8c246b5551314$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $7cc8c246b5551314$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $7cc8c246b5551314$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $7cc8c246b5551314$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$7cc8c246b5551314$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $7cc8c246b5551314$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $7cc8c246b5551314$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $7cc8c246b5551314$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$7cc8c246b5551314$var$cs.to.hex = function() {
    var rgba = $bf9f398580fdc1b7$exports(arguments);
    return "#" + $7cc8c246b5551314$var$hexDouble(rgba[0]) + $7cc8c246b5551314$var$hexDouble(rgba[1]) + $7cc8c246b5551314$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $7cc8c246b5551314$var$hexDouble(Math.round(rgba[3] * 255)) : "");
};
$7cc8c246b5551314$var$cs.to.rgb = function() {
    var rgba = $bf9f398580fdc1b7$exports(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
$7cc8c246b5551314$var$cs.to.rgb.percent = function() {
    var rgba = $bf9f398580fdc1b7$exports(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
$7cc8c246b5551314$var$cs.to.hsl = function() {
    var hsla = $bf9f398580fdc1b7$exports(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$7cc8c246b5551314$var$cs.to.hwb = function() {
    var hwba = $bf9f398580fdc1b7$exports(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
$7cc8c246b5551314$var$cs.to.keyword = function(rgb) {
    return $7cc8c246b5551314$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $7cc8c246b5551314$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $7cc8c246b5551314$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}


var $97a3172ba702b6f0$exports = {};
var $ac0167de145bf6c3$exports = {};
/* MIT license */ /* eslint-disable no-mixed-operators */ 

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var $ac0167de145bf6c3$var$reverseKeywords = {};
var $ac0167de145bf6c3$var$_iteratorNormalCompletion = true, $ac0167de145bf6c3$var$_didIteratorError = false, $ac0167de145bf6c3$var$_iteratorError = undefined;
try {
    for(var $ac0167de145bf6c3$var$_iterator = Object.keys($c02aa735e07d5b11$exports)[Symbol.iterator](), $ac0167de145bf6c3$var$_step; !($ac0167de145bf6c3$var$_iteratorNormalCompletion = ($ac0167de145bf6c3$var$_step = $ac0167de145bf6c3$var$_iterator.next()).done); $ac0167de145bf6c3$var$_iteratorNormalCompletion = true){
        var $ac0167de145bf6c3$var$key = $ac0167de145bf6c3$var$_step.value;
        $ac0167de145bf6c3$var$reverseKeywords[$c02aa735e07d5b11$exports[$ac0167de145bf6c3$var$key]] = $ac0167de145bf6c3$var$key;
    }
} catch (err) {
    $ac0167de145bf6c3$var$_didIteratorError = true;
    $ac0167de145bf6c3$var$_iteratorError = err;
} finally{
    try {
        if (!$ac0167de145bf6c3$var$_iteratorNormalCompletion && $ac0167de145bf6c3$var$_iterator.return != null) {
            $ac0167de145bf6c3$var$_iterator.return();
        }
    } finally{
        if ($ac0167de145bf6c3$var$_didIteratorError) {
            throw $ac0167de145bf6c3$var$_iteratorError;
        }
    }
}
var $ac0167de145bf6c3$var$convert = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
$ac0167de145bf6c3$exports = $ac0167de145bf6c3$var$convert;
var $ac0167de145bf6c3$var$_iteratorNormalCompletion1 = true, $ac0167de145bf6c3$var$_didIteratorError1 = false, $ac0167de145bf6c3$var$_iteratorError1 = undefined;
try {
    // Hide .channels and .labels properties
    for(var $ac0167de145bf6c3$var$_iterator1 = Object.keys($ac0167de145bf6c3$var$convert)[Symbol.iterator](), $ac0167de145bf6c3$var$_step1; !($ac0167de145bf6c3$var$_iteratorNormalCompletion1 = ($ac0167de145bf6c3$var$_step1 = $ac0167de145bf6c3$var$_iterator1.next()).done); $ac0167de145bf6c3$var$_iteratorNormalCompletion1 = true){
        var $ac0167de145bf6c3$var$model = $ac0167de145bf6c3$var$_step1.value;
        if (!("channels" in $ac0167de145bf6c3$var$convert[$ac0167de145bf6c3$var$model])) throw new Error("missing channels property: " + $ac0167de145bf6c3$var$model);
        if (!("labels" in $ac0167de145bf6c3$var$convert[$ac0167de145bf6c3$var$model])) throw new Error("missing channel labels property: " + $ac0167de145bf6c3$var$model);
        if ($ac0167de145bf6c3$var$convert[$ac0167de145bf6c3$var$model].labels.length !== $ac0167de145bf6c3$var$convert[$ac0167de145bf6c3$var$model].channels) throw new Error("channel and label counts mismatch: " + $ac0167de145bf6c3$var$model);
        var $ac0167de145bf6c3$var$_convert_model = $ac0167de145bf6c3$var$convert[$ac0167de145bf6c3$var$model], $ac0167de145bf6c3$var$channels = $ac0167de145bf6c3$var$_convert_model.channels, $ac0167de145bf6c3$var$labels = $ac0167de145bf6c3$var$_convert_model.labels;
        delete $ac0167de145bf6c3$var$convert[$ac0167de145bf6c3$var$model].channels;
        delete $ac0167de145bf6c3$var$convert[$ac0167de145bf6c3$var$model].labels;
        Object.defineProperty($ac0167de145bf6c3$var$convert[$ac0167de145bf6c3$var$model], "channels", {
            value: $ac0167de145bf6c3$var$channels
        });
        Object.defineProperty($ac0167de145bf6c3$var$convert[$ac0167de145bf6c3$var$model], "labels", {
            value: $ac0167de145bf6c3$var$labels
        });
    }
} catch (err) {
    $ac0167de145bf6c3$var$_didIteratorError1 = true;
    $ac0167de145bf6c3$var$_iteratorError1 = err;
} finally{
    try {
        if (!$ac0167de145bf6c3$var$_iteratorNormalCompletion1 && $ac0167de145bf6c3$var$_iterator1.return != null) {
            $ac0167de145bf6c3$var$_iterator1.return();
        }
    } finally{
        if ($ac0167de145bf6c3$var$_didIteratorError1) {
            throw $ac0167de145bf6c3$var$_iteratorError1;
        }
    }
}
$ac0167de145bf6c3$var$convert.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    var l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$ac0167de145bf6c3$var$convert.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function diffc(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$ac0167de145bf6c3$var$convert.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = $ac0167de145bf6c3$var$convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$ac0167de145bf6c3$var$convert.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var k = Math.min(1 - r, 1 - g, 1 - b);
    var c = (1 - r - k) / (1 - k) || 0;
    var m = (1 - g - k) / (1 - k) || 0;
    var y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $ac0167de145bf6c3$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
$ac0167de145bf6c3$var$convert.rgb.keyword = function(rgb) {
    var reversed = $ac0167de145bf6c3$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys($c02aa735e07d5b11$exports)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var keyword = _step.value;
            var value = $c02aa735e07d5b11$exports[keyword];
            // Compute comparative distance
            var distance = $ac0167de145bf6c3$var$comparativeDistance(rgb, value);
            // Check if its less, if so set as closest
            if (distance < currentClosestDistance) {
                currentClosestDistance = distance;
                currentClosestKeyword = keyword;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return currentClosestKeyword;
};
$ac0167de145bf6c3$var$convert.keyword.rgb = function(keyword) {
    return $c02aa735e07d5b11$exports[keyword];
};
$ac0167de145bf6c3$var$convert.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$ac0167de145bf6c3$var$convert.rgb.lab = function(rgb) {
    var xyz = $ac0167de145bf6c3$var$convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    var l = 116 * y - 16;
    var a = 500 * (x - y);
    var b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$ac0167de145bf6c3$var$convert.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t2;
    var t3;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    var t1 = 2 * l - t2;
    var rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$ac0167de145bf6c3$var$convert.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    var v = (l + s) / 2;
    var sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$ac0167de145bf6c3$var$convert.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$ac0167de145bf6c3$var$convert.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var sl;
    var l;
    l = (2 - s) * v;
    var lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$ac0167de145bf6c3$var$convert.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    var i = Math.floor(6 * h);
    var v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    var n = wh + f * (v - wh); // Linear interpolation
    var r;
    var g;
    var b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$ac0167de145bf6c3$var$convert.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r = 1 - Math.min(1, c * (1 - k) + k);
    var g = 1 - Math.min(1, m * (1 - k) + k);
    var b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$ac0167de145bf6c3$var$convert.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$ac0167de145bf6c3$var$convert.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    var l = 116 * y - 16;
    var a = 500 * (x - y);
    var b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$ac0167de145bf6c3$var$convert.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$ac0167de145bf6c3$var$convert.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var h;
    var hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    var c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$ac0167de145bf6c3$var$convert.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var hr = h / 360 * 2 * Math.PI;
    var a = c * Math.cos(hr);
    var b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$ac0167de145bf6c3$var$convert.rgb.ansi16 = function(args) {
    var saturation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var _args = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(args, 3), r = _args[0], g = _args[1], b = _args[2];
    var value = saturation === null ? $ac0167de145bf6c3$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$ac0167de145bf6c3$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $ac0167de145bf6c3$var$convert.rgb.ansi16($ac0167de145bf6c3$var$convert.hsv.rgb(args), args[2]);
};
$ac0167de145bf6c3$var$convert.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$ac0167de145bf6c3$var$convert.ansi16.rgb = function(args) {
    var color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$ac0167de145bf6c3$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$ac0167de145bf6c3$var$convert.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$ac0167de145bf6c3$var$convert.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map(function(char) {
        return char + char;
    }).join("");
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$ac0167de145bf6c3$var$convert.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$ac0167de145bf6c3$var$convert.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    var f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$ac0167de145bf6c3$var$convert.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$ac0167de145bf6c3$var$convert.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$ac0167de145bf6c3$var$convert.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$ac0167de145bf6c3$var$convert.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$ac0167de145bf6c3$var$convert.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$ac0167de145bf6c3$var$convert.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$ac0167de145bf6c3$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$ac0167de145bf6c3$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$ac0167de145bf6c3$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$ac0167de145bf6c3$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$ac0167de145bf6c3$var$convert.gray.hsv = $ac0167de145bf6c3$var$convert.gray.hsl;
$ac0167de145bf6c3$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$ac0167de145bf6c3$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$ac0167de145bf6c3$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$ac0167de145bf6c3$var$convert.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$ac0167de145bf6c3$var$convert.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};


var $19d64b499cb80677$exports = {};

/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $19d64b499cb80677$var$buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys($ac0167de145bf6c3$exports);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $19d64b499cb80677$var$deriveBFS(fromModel) {
    var graph = $19d64b499cb80677$var$buildGraph();
    var queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys($ac0167de145bf6c3$exports[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $19d64b499cb80677$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $19d64b499cb80677$var$wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = $ac0167de145bf6c3$exports[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $19d64b499cb80677$var$link($ac0167de145bf6c3$exports[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
$19d64b499cb80677$exports = function(fromModel) {
    var graph = $19d64b499cb80677$var$deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $19d64b499cb80677$var$wrapConversion(toModel, graph);
    }
    return conversion;
};


var $97a3172ba702b6f0$var$convert = {};
var $97a3172ba702b6f0$var$models = Object.keys($ac0167de145bf6c3$exports);
function $97a3172ba702b6f0$var$wrapRaw(fn) {
    var wrappedFn = function wrappedFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $97a3172ba702b6f0$var$wrapRounded(fn) {
    var wrappedFn = function wrappedFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        var result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$97a3172ba702b6f0$var$models.forEach(function(fromModel) {
    $97a3172ba702b6f0$var$convert[fromModel] = {};
    Object.defineProperty($97a3172ba702b6f0$var$convert[fromModel], "channels", {
        value: $ac0167de145bf6c3$exports[fromModel].channels
    });
    Object.defineProperty($97a3172ba702b6f0$var$convert[fromModel], "labels", {
        value: $ac0167de145bf6c3$exports[fromModel].labels
    });
    var routes = $19d64b499cb80677$exports(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        $97a3172ba702b6f0$var$convert[fromModel][toModel] = $97a3172ba702b6f0$var$wrapRounded(fn);
        $97a3172ba702b6f0$var$convert[fromModel][toModel].raw = $97a3172ba702b6f0$var$wrapRaw(fn);
    });
});
$97a3172ba702b6f0$exports = $97a3172ba702b6f0$var$convert;


var $40a1317a33725c7b$var$skippedModels = [
    // To be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // Gray conflicts with some method names, and has its own method defined.
    "gray",
    // Shouldn't really be in color-convert either...
    "hex"
];
var $40a1317a33725c7b$var$hashedModelKeys = {};
var $40a1317a33725c7b$var$_iteratorNormalCompletion = true, $40a1317a33725c7b$var$_didIteratorError = false, $40a1317a33725c7b$var$_iteratorError = undefined;
try {
    for(var $40a1317a33725c7b$var$_iterator = Object.keys($97a3172ba702b6f0$exports)[Symbol.iterator](), $40a1317a33725c7b$var$_step; !($40a1317a33725c7b$var$_iteratorNormalCompletion = ($40a1317a33725c7b$var$_step = $40a1317a33725c7b$var$_iterator.next()).done); $40a1317a33725c7b$var$_iteratorNormalCompletion = true){
        var $40a1317a33725c7b$var$model = $40a1317a33725c7b$var$_step.value;
        $40a1317a33725c7b$var$hashedModelKeys[(0, $15f021a0fca28358$export$1b5e630bc3aea29f)($97a3172ba702b6f0$exports[$40a1317a33725c7b$var$model].labels).sort().join("")] = $40a1317a33725c7b$var$model;
    }
} catch (err) {
    $40a1317a33725c7b$var$_didIteratorError = true;
    $40a1317a33725c7b$var$_iteratorError = err;
} finally{
    try {
        if (!$40a1317a33725c7b$var$_iteratorNormalCompletion && $40a1317a33725c7b$var$_iterator.return != null) {
            $40a1317a33725c7b$var$_iterator.return();
        }
    } finally{
        if ($40a1317a33725c7b$var$_didIteratorError) {
            throw $40a1317a33725c7b$var$_iteratorError;
        }
    }
}
var $40a1317a33725c7b$var$limiters = {};
function $40a1317a33725c7b$var$Color(object, model) {
    if (!(this instanceof $40a1317a33725c7b$var$Color)) return new $40a1317a33725c7b$var$Color(object, model);
    if (model && model in $40a1317a33725c7b$var$skippedModels) model = null;
    if (model && !(model in $97a3172ba702b6f0$exports)) throw new Error("Unknown model: " + model);
    var i;
    var channels;
    if (object == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (object instanceof $40a1317a33725c7b$var$Color) {
        this.model = object.model;
        this.color = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(object.color);
        this.valpha = object.valpha;
    } else if (typeof object === "string") {
        var result = $7cc8c246b5551314$exports.get(object);
        if (result === null) throw new Error("Unable to parse color from string: " + object);
        this.model = result.model;
        channels = $97a3172ba702b6f0$exports[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (object.length > 0) {
        this.model = model || "rgb";
        channels = $97a3172ba702b6f0$exports[this.model].channels;
        var newArray = Array.prototype.slice.call(object, 0, channels);
        this.color = $40a1317a33725c7b$var$zeroArray(newArray, channels);
        this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
    } else if (typeof object === "number") {
        // This is always RGB - can be converted later on.
        this.model = "rgb";
        this.color = [
            object >> 16 & 0xFF,
            object >> 8 & 0xFF,
            object & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        var keys = Object.keys(object);
        if ("alpha" in object) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
        }
        var hashedKeys = keys.sort().join("");
        if (!(hashedKeys in $40a1317a33725c7b$var$hashedModelKeys)) throw new Error("Unable to parse color from object: " + JSON.stringify(object));
        this.model = $40a1317a33725c7b$var$hashedModelKeys[hashedKeys];
        var labels = $97a3172ba702b6f0$exports[this.model].labels;
        var color = [];
        for(i = 0; i < labels.length; i++)color.push(object[labels[i]]);
        this.color = $40a1317a33725c7b$var$zeroArray(color);
    }
    // Perform limitations (clamping, etc.)
    if ($40a1317a33725c7b$var$limiters[this.model]) {
        channels = $97a3172ba702b6f0$exports[this.model].channels;
        for(i = 0; i < channels; i++){
            var limit = $40a1317a33725c7b$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$40a1317a33725c7b$var$Color.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(places) {
        var self = this.model in $7cc8c246b5551314$exports.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        var args = self.valpha === 1 ? self.color : (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(self.color).concat([
            this.valpha
        ]);
        return $7cc8c246b5551314$exports.to[self.model](args);
    },
    percentString: function(places) {
        var self = this.rgb().round(typeof places === "number" ? places : 1);
        var args = self.valpha === 1 ? self.color : (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(self.color).concat([
            this.valpha
        ]);
        return $7cc8c246b5551314$exports.to.rgb.percent(args);
    },
    array: function() {
        return this.valpha === 1 ? (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this.color) : (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this.color).concat([
            this.valpha
        ]);
    },
    object: function() {
        var result = {};
        var channels = $97a3172ba702b6f0$exports[this.model].channels;
        var labels = $97a3172ba702b6f0$exports[this.model].labels;
        for(var i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray: function() {
        var rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject: function() {
        var rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round: function(places) {
        places = Math.max(places || 0, 0);
        return new $40a1317a33725c7b$var$Color((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this.color.map($40a1317a33725c7b$var$roundToPlace(places))).concat([
            this.valpha
        ]), this.model);
    },
    alpha: function(value) {
        if (value !== undefined) return new $40a1317a33725c7b$var$Color((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(this.color).concat([
            Math.max(0, Math.min(1, value))
        ]), this.model);
        return this.valpha;
    },
    // Rgb
    red: $40a1317a33725c7b$var$getset("rgb", 0, $40a1317a33725c7b$var$maxfn(255)),
    green: $40a1317a33725c7b$var$getset("rgb", 1, $40a1317a33725c7b$var$maxfn(255)),
    blue: $40a1317a33725c7b$var$getset("rgb", 2, $40a1317a33725c7b$var$maxfn(255)),
    hue: $40a1317a33725c7b$var$getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, function(value) {
        return (value % 360 + 360) % 360;
    }),
    saturationl: $40a1317a33725c7b$var$getset("hsl", 1, $40a1317a33725c7b$var$maxfn(100)),
    lightness: $40a1317a33725c7b$var$getset("hsl", 2, $40a1317a33725c7b$var$maxfn(100)),
    saturationv: $40a1317a33725c7b$var$getset("hsv", 1, $40a1317a33725c7b$var$maxfn(100)),
    value: $40a1317a33725c7b$var$getset("hsv", 2, $40a1317a33725c7b$var$maxfn(100)),
    chroma: $40a1317a33725c7b$var$getset("hcg", 1, $40a1317a33725c7b$var$maxfn(100)),
    gray: $40a1317a33725c7b$var$getset("hcg", 2, $40a1317a33725c7b$var$maxfn(100)),
    white: $40a1317a33725c7b$var$getset("hwb", 1, $40a1317a33725c7b$var$maxfn(100)),
    wblack: $40a1317a33725c7b$var$getset("hwb", 2, $40a1317a33725c7b$var$maxfn(100)),
    cyan: $40a1317a33725c7b$var$getset("cmyk", 0, $40a1317a33725c7b$var$maxfn(100)),
    magenta: $40a1317a33725c7b$var$getset("cmyk", 1, $40a1317a33725c7b$var$maxfn(100)),
    yellow: $40a1317a33725c7b$var$getset("cmyk", 2, $40a1317a33725c7b$var$maxfn(100)),
    black: $40a1317a33725c7b$var$getset("cmyk", 3, $40a1317a33725c7b$var$maxfn(100)),
    x: $40a1317a33725c7b$var$getset("xyz", 0, $40a1317a33725c7b$var$maxfn(95.047)),
    y: $40a1317a33725c7b$var$getset("xyz", 1, $40a1317a33725c7b$var$maxfn(100)),
    z: $40a1317a33725c7b$var$getset("xyz", 2, $40a1317a33725c7b$var$maxfn(108.833)),
    l: $40a1317a33725c7b$var$getset("lab", 0, $40a1317a33725c7b$var$maxfn(100)),
    a: $40a1317a33725c7b$var$getset("lab", 1),
    b: $40a1317a33725c7b$var$getset("lab", 2),
    keyword: function(value) {
        if (value !== undefined) return new $40a1317a33725c7b$var$Color(value);
        return $97a3172ba702b6f0$exports[this.model].keyword(this.color);
    },
    hex: function(value) {
        if (value !== undefined) return new $40a1317a33725c7b$var$Color(value);
        return $7cc8c246b5551314$exports.to.hex(this.rgb().round().color);
    },
    hexa: function(value) {
        if (value !== undefined) return new $40a1317a33725c7b$var$Color(value);
        var rgbArray = this.rgb().round().color;
        var alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
        if (alphaHex.length === 1) alphaHex = "0" + alphaHex;
        return $7cc8c246b5551314$exports.to.hex(rgbArray) + alphaHex;
    },
    rgbNumber: function() {
        var rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity: function() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.rgb().color;
        var lum = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rgb.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), i = _step_value[0], element = _step_value[1];
                var chan = element / 255;
                lum[i] = chan <= 0.04045 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function(color2) {
        // https://www.w3.org/TR/WCAG/#contrast-enhanced
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark: function() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.rgb().color;
        var yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
        return yiq < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        var rgb = this.rgb();
        for(var i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten: function(ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken: function(ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale: function() {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var rgb = this.rgb().color;
        var value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $40a1317a33725c7b$var$Color.rgb(value, value, value);
    },
    fade: function(ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer: function(ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate: function(degrees) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix: function(mixinColor, weight) {
        // Ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + (typeof mixinColor === "undefined" ? "undefined" : (0, $3L4GM._)(mixinColor)));
        var color1 = mixinColor.rgb();
        var color2 = this.rgb();
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        var w2 = 1 - w1;
        return $40a1317a33725c7b$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
var $40a1317a33725c7b$var$_iteratorNormalCompletion1 = true, $40a1317a33725c7b$var$_didIteratorError1 = false, $40a1317a33725c7b$var$_iteratorError1 = undefined;
try {
    var $40a1317a33725c7b$var$_loop = function() {
        var model = $40a1317a33725c7b$var$_step1.value;
        if ($40a1317a33725c7b$var$skippedModels.includes(model)) return "continue";
        var channels = $97a3172ba702b6f0$exports[model].channels;
        // Conversion methods
        $40a1317a33725c7b$var$Color.prototype[model] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this.model === model) return new $40a1317a33725c7b$var$Color(this);
            if (args.length > 0) return new $40a1317a33725c7b$var$Color(args, model);
            return new $40a1317a33725c7b$var$Color((0, $15f021a0fca28358$export$1b5e630bc3aea29f)($40a1317a33725c7b$var$assertArray($97a3172ba702b6f0$exports[this.model][model].raw(this.color))).concat([
                this.valpha
            ]), model);
        };
        // 'static' construction methods
        $40a1317a33725c7b$var$Color[model] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var color = args[0];
            if (typeof color === "number") color = $40a1317a33725c7b$var$zeroArray(args, channels);
            return new $40a1317a33725c7b$var$Color(color, model);
        };
    };
    // Model conversion methods and static constructors
    for(var $40a1317a33725c7b$var$_iterator1 = Object.keys($97a3172ba702b6f0$exports)[Symbol.iterator](), $40a1317a33725c7b$var$_step1; !($40a1317a33725c7b$var$_iteratorNormalCompletion1 = ($40a1317a33725c7b$var$_step1 = $40a1317a33725c7b$var$_iterator1.next()).done); $40a1317a33725c7b$var$_iteratorNormalCompletion1 = true)$40a1317a33725c7b$var$_loop();
} catch (err) {
    $40a1317a33725c7b$var$_didIteratorError1 = true;
    $40a1317a33725c7b$var$_iteratorError1 = err;
} finally{
    try {
        if (!$40a1317a33725c7b$var$_iteratorNormalCompletion1 && $40a1317a33725c7b$var$_iterator1.return != null) {
            $40a1317a33725c7b$var$_iterator1.return();
        }
    } finally{
        if ($40a1317a33725c7b$var$_didIteratorError1) {
            throw $40a1317a33725c7b$var$_iteratorError1;
        }
    }
}
function $40a1317a33725c7b$var$roundTo(number, places) {
    return Number(number.toFixed(places));
}
function $40a1317a33725c7b$var$roundToPlace(places) {
    return function(number) {
        return $40a1317a33725c7b$var$roundTo(number, places);
    };
}
function $40a1317a33725c7b$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = model[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            ($40a1317a33725c7b$var$limiters[m] || ($40a1317a33725c7b$var$limiters[m] = []))[channel] = modifier;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    model = model[0];
    return function(value) {
        var result;
        if (value !== undefined) {
            if (modifier) value = modifier(value);
            result = this[model]();
            result.color[channel] = value;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $40a1317a33725c7b$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $40a1317a33725c7b$var$assertArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $40a1317a33725c7b$var$zeroArray(array, length) {
    for(var i = 0; i < length; i++)if (typeof array[i] !== "number") array[i] = 0;
    return array;
}
$40a1317a33725c7b$exports = $40a1317a33725c7b$var$Color;


var $bac3379ca35f67cc$export$2b47dd798c93e22f = function(baseColor, delta) {
    var hslArray = baseColor.hsl().round().array();
    var _hslArray_, _hslArray_1, _hslArray_2;
    return (0, (/*@__PURE__*/$parcel$interopDefault($40a1317a33725c7b$exports)))([
        (_hslArray_ = hslArray[0]) !== null && _hslArray_ !== void 0 ? _hslArray_ : 0,
        (_hslArray_1 = hslArray[1]) !== null && _hslArray_1 !== void 0 ? _hslArray_1 : 0,
        ((_hslArray_2 = hslArray[2]) !== null && _hslArray_2 !== void 0 ? _hslArray_2 : 0) + delta
    ], "hsl");
};
var $bac3379ca35f67cc$export$13a5971b241f058c = function(baseColor, delta) {
    var hslArray = baseColor.hsl().round().array();
    var _hslArray_, _hslArray_1, _hslArray_2;
    return (0, (/*@__PURE__*/$parcel$interopDefault($40a1317a33725c7b$exports)))([
        (_hslArray_ = hslArray[0]) !== null && _hslArray_ !== void 0 ? _hslArray_ : 0,
        (_hslArray_1 = hslArray[1]) !== null && _hslArray_1 !== void 0 ? _hslArray_1 : 0,
        ((_hslArray_2 = hslArray[2]) !== null && _hslArray_2 !== void 0 ? _hslArray_2 : 0) - delta
    ], "hsl");
};
var $bac3379ca35f67cc$export$2feb0cd4df065982 = function(lightColor) {
    return $bac3379ca35f67cc$export$2b47dd798c93e22f((0, (/*@__PURE__*/$parcel$interopDefault($40a1317a33725c7b$exports)))(lightColor), 10).hex();
};


var $b489f1f089aee5db$export$6561ab227a8e4a2 = function(regEx) {
    try {
        return Boolean(regEx && new RegExp(regEx));
    } catch (e) {
        return false;
    }
};


var $9f2f5d16fced0798$export$bdb23a0789f9885e = /^\S+@\S+\.\S+$/;
var $9f2f5d16fced0798$export$205be3a4a78028e = /^\d+$/;
var $9f2f5d16fced0798$export$3b90d915073188c = /^\+?[\d-( )]+$/;
var $9f2f5d16fced0798$export$221be9ce6b96eec3 = /^[A-Z_a-z]\w*$/;
var $9f2f5d16fced0798$export$faa873956c7a1484 = /^https?:$/;
var $9f2f5d16fced0798$export$cda568c01bd42f00 = /^[a-z][\d+_a-z-]*(\.[\d+_a-z-]+)+:$/;
var $9f2f5d16fced0798$export$ad64c5d64b2f359b = /^#[\da-f]{3}([\da-f]{3})?$/i;
var $9f2f5d16fced0798$export$2586bfd81a855904 = /^\d{4}(-\d{2}){2}/;
var $9f2f5d16fced0798$export$14b44af55c20c1e5 = /^\S+$/;
var $9f2f5d16fced0798$export$d9e81dda45f84c36 = /^[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?(?:\.[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?){2,}$/;


var $5ec0d22151529b3f$export$eabdc444ee87166e = function(url, type) {
    try {
        var protocol = new URL(url).protocol;
        var protocolRegEx = type === "mobile" ? (0, $9f2f5d16fced0798$export$cda568c01bd42f00) : (0, $9f2f5d16fced0798$export$faa873956c7a1484);
        return protocolRegEx.test(protocol);
    } catch (e) {
        return false;
    }
};
var $5ec0d22151529b3f$export$6ac9a0b3ab4a632f = function(url) {
    try {
        return new URL(url).origin === url;
    } catch (e) {
        return false;
    }
};
var $5ec0d22151529b3f$export$bef94a5618bf18bf = function(url) {
    try {
        return Boolean(url && new URL(url));
    } catch (e) {
        return false;
    }
};
var $5ec0d22151529b3f$export$ec8a6426516240fc = function(url) {
    var parsedUrl = new URL(url);
    return [
        "localhost",
        "127.0.0.1",
        "::1"
    ].includes(parsedUrl.hostname);
};





/** Scopes that reserved by Logto, which will be added to the auth request automatically. */ 

var $4f91f077d5b7f09a$export$1d2e82cebfd4b08;
(function(ReservedScope) {
    ReservedScope["OpenId"] = "openid";
    ReservedScope["OfflineAccess"] = "offline_access";
})($4f91f077d5b7f09a$export$1d2e82cebfd4b08 || ($4f91f077d5b7f09a$export$1d2e82cebfd4b08 = {}));
var $4f91f077d5b7f09a$export$36ba08a8e14b2df6;
(function(ReservedResource) {
    /**
     * The resource for organization template per RFC 0001.
     *
     * @see {@link https://github.com/logto-io/rfcs | RFC 0001} for more details.
     */ ReservedResource["Organization"] = "urn:logto:resource:organizations";
})($4f91f077d5b7f09a$export$36ba08a8e14b2df6 || ($4f91f077d5b7f09a$export$36ba08a8e14b2df6 = {}));
var $4f91f077d5b7f09a$export$4b02c5b431f6eb78;
(function(UserScope) {
    /**
     * Scope for basic user info.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Profile"] = "profile";
    /**
     * Scope for user email address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Email"] = "email";
    /**
     * Scope for user phone number.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Phone"] = "phone";
    /**
     * Scope for user address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Address"] = "address";
    /**
     * Scope for user's custom data.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["CustomData"] = "custom_data";
    /**
     * Scope for user's social and SSO identity details.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Identities"] = "identities";
    /**
     * Scope for user's roles.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Roles"] = "roles";
    /**
     * Scope for user's organization IDs and perform organization token grant per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Organizations"] = "urn:logto:scope:organizations";
    /**
     * Scope for user's organization roles per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["OrganizationRoles"] = "urn:logto:scope:organization_roles";
})($4f91f077d5b7f09a$export$4b02c5b431f6eb78 || ($4f91f077d5b7f09a$export$4b02c5b431f6eb78 = {}));
var $4f91f077d5b7f09a$var$_obj;
var $4f91f077d5b7f09a$export$f57bb8dda2a18319 = Object.freeze(($4f91f077d5b7f09a$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Profile, [
    // Standard claims
    "name",
    "family_name",
    "given_name",
    "middle_name",
    "nickname",
    "preferred_username",
    "profile",
    "picture",
    "website",
    "gender",
    "birthdate",
    "zoneinfo",
    "locale",
    "updated_at",
    // Custom claims
    "username",
    "created_at"
]), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Email, [
    "email",
    "email_verified"
]), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Phone, [
    "phone_number",
    "phone_number_verified"
]), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Address, [
    "address"
]), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Roles, [
    "roles"
]), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Organizations, [
    "organizations"
]), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.OrganizationRoles, [
    "organization_roles"
]), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.CustomData, []), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Identities, []), $4f91f077d5b7f09a$var$_obj));
var $4f91f077d5b7f09a$var$_obj1;
var $4f91f077d5b7f09a$export$c11d5a3385aa71dd = Object.freeze(($4f91f077d5b7f09a$var$_obj1 = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj1, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Profile, []), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj1, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Email, []), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj1, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Phone, []), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj1, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Address, []), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj1, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Roles, []), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj1, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Organizations, [
    "organization_data"
]), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj1, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.OrganizationRoles, []), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj1, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.CustomData, [
    "custom_data"
]), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($4f91f077d5b7f09a$var$_obj1, $4f91f077d5b7f09a$export$4b02c5b431f6eb78.Identities, [
    "identities",
    "sso_identities"
]), $4f91f077d5b7f09a$var$_obj1));
var $4f91f077d5b7f09a$export$6c46daeabb0176f9 = Object.freeze(// Hard to infer type directly, use `as` for a workaround.
// eslint-disable-next-line no-restricted-syntax
Object.fromEntries(Object.values($4f91f077d5b7f09a$export$4b02c5b431f6eb78).map(function(current) {
    return [
        current,
        (0, $15f021a0fca28358$export$1b5e630bc3aea29f)($4f91f077d5b7f09a$export$f57bb8dda2a18319[current]).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)($4f91f077d5b7f09a$export$c11d5a3385aa71dd[current]))
    ];
})));
var $4f91f077d5b7f09a$export$fc38cc6da79faa5c = "urn:logto:organization:";
var $4f91f077d5b7f09a$export$22667c0b6b2d7fac = function(organizationId) {
    return "".concat($4f91f077d5b7f09a$export$fc38cc6da79faa5c).concat(organizationId);
};
var $4f91f077d5b7f09a$export$a237ae1b02e4e718 = function(urn) {
    if (!urn.startsWith($4f91f077d5b7f09a$export$fc38cc6da79faa5c)) throw new TypeError("Invalid organization URN.");
    return urn.slice($4f91f077d5b7f09a$export$fc38cc6da79faa5c.length);
};


/*
  We does not export `sql.ts` here since it requires slonik which is not universal.
  It will be exported separately in `/src/index.ts`.
*/ 



/** The necessary headers for sending a form-urlencoded request. */ var $d82303f0b21779d2$export$b8439228f8686498 = Object.freeze({
    "content-type": "application/x-www-form-urlencoded"
});



var $976196230c459b95$export$4385e60b38654f68 = function(bytes) {
    return crypto.getRandomValues(new Uint8Array(bytes));
};
var $976196230c459b95$export$a5cee9e955a615e5 = function(alphabet, defaultSize, getRandom) {
    var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    var step = -~(1.6 * mask * defaultSize / alphabet.length);
    return function() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultSize;
        var id = "";
        while(true){
            var bytes = getRandom(step);
            var j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
var $976196230c459b95$export$62e99e5c9f473d7f = function(alphabet) {
    var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 21;
    return $976196230c459b95$export$a5cee9e955a615e5(alphabet, size, $976196230c459b95$export$4385e60b38654f68);
};
var $976196230c459b95$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    return crypto.getRandomValues(new Uint8Array(size)).reduce(function(id, byte) {
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");
};


var $77ca15834c94224a$var$lowercaseAlphabet = "0123456789abcdefghijklmnopqrstuvwxyz";
var $77ca15834c94224a$var$alphabet = "".concat($77ca15834c94224a$var$lowercaseAlphabet, "ABCDEFGHIJKLMNOPQRSTUVWXYZ");
var $77ca15834c94224a$var$buildIdGenerator = function(size) {
    var includingUppercase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return (0, $976196230c459b95$export$62e99e5c9f473d7f)(includingUppercase ? $77ca15834c94224a$var$alphabet : $77ca15834c94224a$var$lowercaseAlphabet, size);
};
var $77ca15834c94224a$export$7e648d54e633633e = $77ca15834c94224a$var$buildIdGenerator(21, false);
var $77ca15834c94224a$export$8702116b552d3dba = $77ca15834c94224a$var$buildIdGenerator(12, false);
var $77ca15834c94224a$export$877b6275f1b9e856 = $77ca15834c94224a$var$buildIdGenerator(32);


/* Migrated from @logto/app-insights */ 
var $6c4605b835724070$export$670d48958e84d448 = function(value) {
    if (value) return Array.isArray(value) ? value : [
        value
    ];
    return [];
};
// Disable FP rules here to use the performant approach while keep the function itself "FP"
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ var $6c4605b835724070$export$76d90c956114f2c2 = function(times, initial, iterate) {
    var result = initial;
    while(times--)result = iterate(result);
    return result;
};
/* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ var $6c4605b835724070$export$6b75200e58bc97d0 = function(array) {
    return (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(new Set(array));
};
/**
 * Deduplicate an array of objects by a specific key.
 *
 * @param array The array of objects to deduplicate.
 * @param key The key to deduplicate by.
 * @example
 * const array = [{ id: 1, name: 'John' }, { id: 2, name: 'Doe' }, { id: 1, name: 'John' }];
 * deduplicateByKey(array, 'id');
 * // Output: [{ id: 1, name: 'John' }, { id: 2, name: 'Doe' }]
 */ var $6c4605b835724070$export$863d7151f7b1a894 = function(array, key) {
    return (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(new Map(array.map(function(item) {
        return [
            item[key],
            item
        ];
    })).values());
};


// https://github.com/facebook/jest/issues/7547
var $82d1ca91f7c283ca$export$a7a9523472993e97 = function(value, error) {
    if (!value) // https://github.com/typescript-eslint/typescript-eslint/issues/3814
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
};


// eslint-disable-next-line id-length
var $998000e93202542e$var$compareFunction = function(a, b) {
    if (typeof a === "string" && typeof b === "string") return a.localeCompare(b);
    if (typeof a === "number" && typeof b === "number") return a - b;
    if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b);
    throw new Error("Unsupported compare type");
};
var $998000e93202542e$export$12dc7a11e2f7584e = function(array1, array2) {
    if (array1.length !== array2.length) return false;
    var sortedA = array1.slice().sort($998000e93202542e$var$compareFunction);
    var sortedB = array2.slice().sort($998000e93202542e$var$compareFunction);
    return sortedA.every(function(value, index) {
        return value === sortedB[index];
    });
};
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
var $998000e93202542e$export$ccb441c9c5feb3fc = function(value) {
    return Boolean(value);
};
var $998000e93202542e$export$b29ea735dcfba3c1 = function(value) {
    return value !== null && value !== undefined;
};
var $998000e93202542e$export$a4f4bb6b1453fff5 = function(data, property) {
    return Object.prototype.hasOwnProperty.call(data, property);
};
var $998000e93202542e$export$fb789885f1f64dd7 = function(string) {
    return Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));
};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ // eslint-disable-next-line @typescript-eslint/ban-types -- this is a utility function
var $998000e93202542e$var$isObject = function(object) {
    return Object.prototype.toString.call(object) === "[object Object]";
};
/** Returns true if an object was created by the `Object` constructor, or `Object.create(null)`. */ function $998000e93202542e$export$53b83ca8eaab0383(object) {
    if (!$998000e93202542e$var$isObject(object)) return false;
    // If has modified constructor
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (object.constructor === undefined) return true;
    // If has modified prototype
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, prefer-destructuring
    var prototype = object.constructor.prototype;
    if (!$998000e93202542e$var$isObject(prototype)) return false;
    // If constructor does not have an Object-specific method
    if (!$998000e93202542e$export$a4f4bb6b1453fff5(prototype, "isPrototypeOf")) return false;
    // Most likely a plain Object
    return true;
}




var $3539bd14a37ab7f4$export$133fc36489ac9add = function(exp) {
    return (0, $998000e93202542e$export$ccb441c9c5feb3fc)(exp) ? exp : null;
};
/**
 * Conditional return the expression result when it's not {@link Falsy};
 * otherwise return `undefined`.
 *
 * @example
 * ```ts
 * conditional(1 && '2') // '2'
 * conditional(false && '1') // undefined
 * ```
 */ var $3539bd14a37ab7f4$export$c327da55a124987a = function(exp) {
    return (0, $998000e93202542e$export$ccb441c9c5feb3fc)(exp) ? exp : undefined;
};
/** Alias for {@link conditional}. */ var $3539bd14a37ab7f4$export$7ffafceb12143143 = $3539bd14a37ab7f4$export$c327da55a124987a;
/**
 * Conditional return the stringified expression result (using `String`) when it's not {@link Falsy};
 * otherwise return an empty string.
 *
 * @example
 * ```ts
 * conditionalString(1 && 2) // '2'
 * conditionalString(false && '1') // ''
 * ```
 */ var $3539bd14a37ab7f4$export$78aa88a01782ee9d = function(exp) {
    return (0, $998000e93202542e$export$ccb441c9c5feb3fc)(exp) ? String(exp) : "";
};
/** Alias for {@link conditionalString}. */ var $3539bd14a37ab7f4$export$723fe479c809eebc = $3539bd14a37ab7f4$export$78aa88a01782ee9d;
/**
 * Conditional concat multiple expression results into a array by filtering all {@link Falsy} results
 * and flatten 1 level deep if the expression result is an array.
 *
 * @example
 * ```ts
 * conditionalArray(1, [2, 3]) // [1, 2, 3]
 * ```
 */ var $3539bd14a37ab7f4$export$c96eff0e57d59a5e = function() {
    for(var _len = arguments.length, exps = new Array(_len), _key = 0; _key < _len; _key++){
        exps[_key] = arguments[_key];
    }
    return exps.filter(function(value) {
        return (0, $998000e93202542e$export$ccb441c9c5feb3fc)(value);
    }).flat();
};
/** Alias for {@link conditionalArray}. */ var $3539bd14a37ab7f4$export$68c43792fed28aa6 = $3539bd14a37ab7f4$export$c96eff0e57d59a5e;
/**
 * Return a new object with all {@link Falsy} values removed.
 * This function only performs a shallow removal, i.e. it does not remove
 * {@link Falsy} values nested in objects.
 *
 * @example
 * ```ts
 * conditionalObject({
 *   foo: 'foo',
 *   bar: undefined,
 *   baz: false,
 * }) // { foo: 'foo' }
 * ```
 */ var $3539bd14a37ab7f4$export$6d93be478c042166 = function(object) {
    return(// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(function(param) {
        var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 2), value = _param[1];
        return (0, $998000e93202542e$export$ccb441c9c5feb3fc)(value);
    })));
};
/** Alias for {@link conditionalObject}. */ var $3539bd14a37ab7f4$export$48ab0026c89e64fa = $3539bd14a37ab7f4$export$6d93be478c042166;



var $a8849d5501bbbca1$exports = {};
// shim for using process in browser
var $a8849d5501bbbca1$var$process = $a8849d5501bbbca1$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $a8849d5501bbbca1$var$cachedSetTimeout;
var $a8849d5501bbbca1$var$cachedClearTimeout;
function $a8849d5501bbbca1$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $a8849d5501bbbca1$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $a8849d5501bbbca1$var$cachedSetTimeout = setTimeout;
        else $a8849d5501bbbca1$var$cachedSetTimeout = $a8849d5501bbbca1$var$defaultSetTimout;
    } catch (e) {
        $a8849d5501bbbca1$var$cachedSetTimeout = $a8849d5501bbbca1$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $a8849d5501bbbca1$var$cachedClearTimeout = clearTimeout;
        else $a8849d5501bbbca1$var$cachedClearTimeout = $a8849d5501bbbca1$var$defaultClearTimeout;
    } catch (e) {
        $a8849d5501bbbca1$var$cachedClearTimeout = $a8849d5501bbbca1$var$defaultClearTimeout;
    }
})();
function $a8849d5501bbbca1$var$runTimeout(fun) {
    if ($a8849d5501bbbca1$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($a8849d5501bbbca1$var$cachedSetTimeout === $a8849d5501bbbca1$var$defaultSetTimout || !$a8849d5501bbbca1$var$cachedSetTimeout) && setTimeout) {
        $a8849d5501bbbca1$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a8849d5501bbbca1$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $a8849d5501bbbca1$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $a8849d5501bbbca1$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $a8849d5501bbbca1$var$runClearTimeout(marker) {
    if ($a8849d5501bbbca1$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($a8849d5501bbbca1$var$cachedClearTimeout === $a8849d5501bbbca1$var$defaultClearTimeout || !$a8849d5501bbbca1$var$cachedClearTimeout) && clearTimeout) {
        $a8849d5501bbbca1$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a8849d5501bbbca1$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $a8849d5501bbbca1$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $a8849d5501bbbca1$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $a8849d5501bbbca1$var$queue = [];
var $a8849d5501bbbca1$var$draining = false;
var $a8849d5501bbbca1$var$currentQueue;
var $a8849d5501bbbca1$var$queueIndex = -1;
function $a8849d5501bbbca1$var$cleanUpNextTick() {
    if (!$a8849d5501bbbca1$var$draining || !$a8849d5501bbbca1$var$currentQueue) return;
    $a8849d5501bbbca1$var$draining = false;
    if ($a8849d5501bbbca1$var$currentQueue.length) $a8849d5501bbbca1$var$queue = $a8849d5501bbbca1$var$currentQueue.concat($a8849d5501bbbca1$var$queue);
    else $a8849d5501bbbca1$var$queueIndex = -1;
    if ($a8849d5501bbbca1$var$queue.length) $a8849d5501bbbca1$var$drainQueue();
}
function $a8849d5501bbbca1$var$drainQueue() {
    if ($a8849d5501bbbca1$var$draining) return;
    var timeout = $a8849d5501bbbca1$var$runTimeout($a8849d5501bbbca1$var$cleanUpNextTick);
    $a8849d5501bbbca1$var$draining = true;
    var len = $a8849d5501bbbca1$var$queue.length;
    while(len){
        $a8849d5501bbbca1$var$currentQueue = $a8849d5501bbbca1$var$queue;
        $a8849d5501bbbca1$var$queue = [];
        while(++$a8849d5501bbbca1$var$queueIndex < len)if ($a8849d5501bbbca1$var$currentQueue) $a8849d5501bbbca1$var$currentQueue[$a8849d5501bbbca1$var$queueIndex].run();
        $a8849d5501bbbca1$var$queueIndex = -1;
        len = $a8849d5501bbbca1$var$queue.length;
    }
    $a8849d5501bbbca1$var$currentQueue = null;
    $a8849d5501bbbca1$var$draining = false;
    $a8849d5501bbbca1$var$runClearTimeout(timeout);
}
$a8849d5501bbbca1$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $a8849d5501bbbca1$var$queue.push(new $a8849d5501bbbca1$var$Item(fun, args));
    if ($a8849d5501bbbca1$var$queue.length === 1 && !$a8849d5501bbbca1$var$draining) $a8849d5501bbbca1$var$runTimeout($a8849d5501bbbca1$var$drainQueue);
};
// v8 likes predictible objects
function $a8849d5501bbbca1$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$a8849d5501bbbca1$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$a8849d5501bbbca1$var$process.title = "browser";
$a8849d5501bbbca1$var$process.browser = true;
$a8849d5501bbbca1$var$process.env = {};
$a8849d5501bbbca1$var$process.argv = [];
$a8849d5501bbbca1$var$process.version = ""; // empty string to avoid regexp issues
$a8849d5501bbbca1$var$process.versions = {};
function $a8849d5501bbbca1$var$noop() {}
$a8849d5501bbbca1$var$process.on = $a8849d5501bbbca1$var$noop;
$a8849d5501bbbca1$var$process.addListener = $a8849d5501bbbca1$var$noop;
$a8849d5501bbbca1$var$process.once = $a8849d5501bbbca1$var$noop;
$a8849d5501bbbca1$var$process.off = $a8849d5501bbbca1$var$noop;
$a8849d5501bbbca1$var$process.removeListener = $a8849d5501bbbca1$var$noop;
$a8849d5501bbbca1$var$process.removeAllListeners = $a8849d5501bbbca1$var$noop;
$a8849d5501bbbca1$var$process.emit = $a8849d5501bbbca1$var$noop;
$a8849d5501bbbca1$var$process.prependListener = $a8849d5501bbbca1$var$noop;
$a8849d5501bbbca1$var$process.prependOnceListener = $a8849d5501bbbca1$var$noop;
$a8849d5501bbbca1$var$process.listeners = function(name) {
    return [];
};
$a8849d5501bbbca1$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$a8849d5501bbbca1$var$process.cwd = function() {
    return "/";
};
$a8849d5501bbbca1$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$a8849d5501bbbca1$var$process.umask = function() {
    return 0;
};


var $0f841471d5e490c3$var$_process_env_key;
// Browsers don't have `process`
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
var $0f841471d5e490c3$export$4bd44a2aa29d3d6e = function(key) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return ($0f841471d5e490c3$var$_process_env_key = $a8849d5501bbbca1$exports === null || $a8849d5501bbbca1$exports === void 0 ? void 0 : $a8849d5501bbbca1$exports.env[key]) !== null && $0f841471d5e490c3$var$_process_env_key !== void 0 ? $0f841471d5e490c3$var$_process_env_key : fallback;
};
var $0f841471d5e490c3$export$912b126b3b8a9cf1 = function(envKey) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var rawValue = $0f841471d5e490c3$export$4bd44a2aa29d3d6e(envKey);
    if (!rawValue) return fallback;
    return rawValue.split(",").map(function(value) {
        return value.trim();
    }).filter(Boolean);
};
var $0f841471d5e490c3$export$9f11f28d727ba39d = function(key) {
    // Browsers don't have `process`
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    var value = $a8849d5501bbbca1$exports === null || $a8849d5501bbbca1$exports === void 0 ? void 0 : $a8849d5501bbbca1$exports.env[key];
    (0, $82d1ca91f7c283ca$export$a7a9523472993e97)(value, new Error("env variable ".concat(key, " not found")));
    return value;
};
var $0f841471d5e490c3$export$8ee0fc9ee280b4ee = function() {
    return typeof window === "undefined";
};


// Intended
// eslint-disable-next-line @typescript-eslint/no-empty-function
var $71d6ce9e3e366d69$export$8793edee2d425525 = function() {};
var $71d6ce9e3e366d69$export$4369c812aac99591 = function(value) {
    return value !== null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function";
};
// eslint-disable-next-line @typescript-eslint/promise-function-async
var $71d6ce9e3e366d69$export$2cb2cb98cc670b59 = function(exec, onError) {
    var handleError = function(error) {
        if (onError instanceof Error) throw onError;
        return onError(error);
    };
    try {
        var unwrapped = typeof exec === "function" ? exec() : exec;
        // eslint-disable-next-line promise/prefer-await-to-then
        return $71d6ce9e3e366d69$export$4369c812aac99591(unwrapped) ? unwrapped.catch(handleError) : unwrapped;
    } catch (error) {
        return handleError(error);
    }
};
// eslint-disable-next-line @typescript-eslint/promise-function-async
var $71d6ce9e3e366d69$export$a3a27526e073307 = function(exec, onError) {
    try {
        var unwrapped = typeof exec === "function" ? exec() : exec;
        return $71d6ce9e3e366d69$export$4369c812aac99591(unwrapped) ? unwrapped.catch(function(error) {
            onError === null || onError === void 0 ? void 0 : onError(error);
        }) : unwrapped;
    } catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
    }
};



var $36b693815c3ffd4c$export$357523c63a2253b9 = function(object) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    // eslint-disable-next-line no-restricted-syntax
    return Object.fromEntries(keys.map(function(key) {
        return [
            key,
            object[key]
        ];
    }));
};
var $36b693815c3ffd4c$export$42fd73f889ee4d63 = function() {
    for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
        keys[_key] = arguments[_key];
    }
    return function(state) {
        return $36b693815c3ffd4c$export$357523c63a2253b9.apply(void 0, [
            state
        ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(keys)));
    };
};


function $20233a61d5ea6be0$export$1294308be85b4eca(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    return string.toLowerCase().replaceAll(/(?:^|\s|-)\S/g, function(value) {
        return value.toUpperCase();
    }).replaceAll("-", " ");
}
/**
 * RFC 4648 section 5: base64url (URL- and filename-safe standard)
 * @link https://datatracker.ietf.org/doc/html/rfc4648#section-5
 */ var $20233a61d5ea6be0$var$replaceNonUrlSafeCharacters = function(base64String) {
    return base64String.replaceAll("+", "-").replaceAll("/", "_").replaceAll(/=+$/g, "");
};
var $20233a61d5ea6be0$var$restoreNonUrlSafeCharacters = function(base64String) {
    return base64String.replaceAll("-", "+").replaceAll("_", "/");
};
var $20233a61d5ea6be0$export$cf6f352aaefa956f = {
    isSafe: function(input) {
        return /^[\w-]*$/.test(input);
    },
    encode: function(rawString) {
        var encodedString = btoa(unescape(encodeURIComponent(rawString)));
        return $20233a61d5ea6be0$var$replaceNonUrlSafeCharacters(encodedString);
    },
    decode: function(encodedString) {
        var nonUrlSafeEncodedString = $20233a61d5ea6be0$var$restoreNonUrlSafeCharacters(encodedString);
        return decodeURIComponent(escape(atob(nonUrlSafeEncodedString)));
    },
    replaceNonUrlSafeCharacters: $20233a61d5ea6be0$var$replaceNonUrlSafeCharacters,
    restoreNonUrlSafeCharacters: $20233a61d5ea6be0$var$restoreNonUrlSafeCharacters
};
var $20233a61d5ea6be0$export$7a668e70ea2210d9 = function(value) {
    return(// eslint-disable-next-line no-implicit-coercion
    !!value && [
        "1",
        "true",
        "y",
        "yes",
        "yep",
        "yeah"
    ].includes(value.toLowerCase()));
};




var $743ddd4fa303c286$export$3988ae62b71be9a3 = function(object, keySerial) {
    if (object === null || typeof object !== "object") throw new TypeError("Non-object received in `get()`.");
    var result = object;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keySerial.split(".")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            // @ts-expect-error for performance
            result = result[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
};
var $743ddd4fa303c286$export$fedb900c0ea4e699 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return (0, $71d6ce9e3e366d69$export$a3a27526e073307)(function() {
        return $743ddd4fa303c286$export$3988ae62b71be9a3.apply(void 0, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(args));
    });
};
/** Same to `get()` but with the strict type definition only to enable IntelliSense. */ var $743ddd4fa303c286$export$bf7199a9ebcb84a9 = function(object, keySerial) {
    return $743ddd4fa303c286$export$3988ae62b71be9a3(object, keySerial);
};


/** Join multiple path segments. This function exists since there's no native implementation in browser. */ 
var $cd8b8cb0243116a7$export$b891921babc70093 = function() {
    for(var _len = arguments.length, segments = new Array(_len), _key = 0; _key < _len; _key++){
        segments[_key] = arguments[_key];
    }
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments.join("/").split("/")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            if (!segment || segment === ".") continue;
            if ((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(segment).every(function(char) {
                return char === ".";
            })) {
                // eslint-disable-next-line @silverhand/fp/no-mutating-methods
                result.pop();
                continue;
            }
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods
            result.push(segment);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "/" + result.join("/");
};
/** Append path segments to the base URL. */ var $cd8b8cb0243116a7$export$c3cef1c0537c0eb2 = function(baseUrl) {
    for(var _len = arguments.length, pathnames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        pathnames[_key - 1] = arguments[_key];
    }
    return new URL($cd8b8cb0243116a7$export$b891921babc70093.apply(void 0, [
        baseUrl.pathname
    ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(pathnames))), baseUrl);
};


// eslint-disable-next-line @typescript-eslint/ban-types

var $6ff5599663801664$export$a6cdc56e425d0d0a = function(object) {
    return object !== null && typeof object === "object";
};
var $6ff5599663801664$export$dd89c3a817f05bc7 = function(object, key) {
    return $6ff5599663801664$export$a6cdc56e425d0d0a(object) && key in object;
};
/**
 * Remove all keys with `undefined` values from an object. This function only
 * performs a shallow removal, i.e. it does not remove `undefined` values nested
 * in objects.
 *
 * @param object The object to remove `undefined` keys from.
 * @returns A new object with all `undefined` keys removed.
 */ // eslint-disable-next-line @typescript-eslint/ban-types -- this is a utility function
var $6ff5599663801664$export$8e7457d724841712 = function(object) {
    return(// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(function(param) {
        var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 2), value = _param[1];
        return value !== undefined;
    })));
};


/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ function $16d28e921a6a1117$export$d2de3aaeafa91619(function_) {
    var called = false;
    var result;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}




var $a02dba33ed6b0b0a$var$transformedKey = Symbol("Indicates an object is transformed from an `Error` instance");
var $a02dba33ed6b0b0a$var$isObject = function(value) {
    return typeof value === "object" && value !== null;
};
// Edited from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value#circular_references
function $a02dba33ed6b0b0a$var$getCircularReplacer() {
    var ancestors = [];
    var transformedMap = new WeakMap();
    var transformErrorValue = function(value) {
        // Special handling for `Error` instances since they have non-enumerable properties
        if (value instanceof Error) {
            if (!transformedMap.has(value)) {
                var transformed = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.getOwnPropertyNames(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // @ts-expect-error getOwnPropertyNames() returns the valid keys
                        // eslint-disable-next-line @silverhand/fp/no-mutation
                        transformed[key] = value[key];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // eslint-disable-next-line @silverhand/fp/no-mutation
                transformed[$a02dba33ed6b0b0a$var$transformedKey] = true;
                transformedMap.set(value, transformed);
            }
            return transformedMap.get(value);
        }
        return value;
    };
    return function(key, value) {
        // Ignore `stack` property since ApplicationInsights will show it
        if ($a02dba33ed6b0b0a$var$isObject(this) && Object.hasOwn(this, $a02dba33ed6b0b0a$var$transformedKey) && key === "stack") return;
        if (!$a02dba33ed6b0b0a$var$isObject(value)) return value;
        // `this` is the object that value is contained in,
        // i.e., its direct parent.
        while(ancestors.length > 0 && ancestors.at(-1) !== this)// eslint-disable-next-line @silverhand/fp/no-mutating-methods
        ancestors.pop();
        var transformed = transformErrorValue(value);
        if (ancestors.includes(transformed)) return "[Circular ~]";
        // eslint-disable-next-line @silverhand/fp/no-mutating-methods
        ancestors.push(transformed);
        return transformed;
    };
}
var $a02dba33ed6b0b0a$export$e7bd538fb0c5db1a = function(error) {
    var _trySafe;
    /**
     * - Ensure the message if not empty otherwise Application Insights will respond 400
     *   and the error will not be recorded.
     * - We stringify error object here since other error properties won't show on the
     *   ApplicationInsights details page.
     */ var message = (_trySafe = (0, $71d6ce9e3e366d69$export$a3a27526e073307)(function() {
        return JSON.stringify(error, $a02dba33ed6b0b0a$var$getCircularReplacer());
    })) !== null && _trySafe !== void 0 ? _trySafe : "Unknown error";
    // Ensure we don't mutate the original error
    var normalized = new Error(message);
    if (error instanceof Error) {
        // Manually clone key fields of the error for AppInsights display
        /* eslint-disable @silverhand/fp/no-mutation */ normalized.name = error.name;
        normalized.stack = error.stack;
        normalized.cause = error.cause;
    /* eslint-enable @silverhand/fp/no-mutation */ }
    return normalized;
};


var $1fb7ddd7755f9710$export$dd89c3a817f05bc7 = function(object, key) {
    return object !== null && typeof object === "object" && key in object;
};


// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $2da1d13844d40b75$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $64644baca7251a95$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $2da1d13844d40b75$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $09c63c3fb2a2637b$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $09c63c3fb2a2637b$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $09c63c3fb2a2637b$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $09c63c3fb2a2637b$export$852d1d4a47329634 = "0-9０-９٠-٩۰-۹"; // `DASHES` will be right after the opening square bracket of the "character class"
var $09c63c3fb2a2637b$var$DASHES = "-‐-―−ー－";
var $09c63c3fb2a2637b$var$SLASHES = "／/";
var $09c63c3fb2a2637b$var$DOTS = "．.";
var $09c63c3fb2a2637b$export$20542845033f576e = " \xa0\xad​⁠　";
var $09c63c3fb2a2637b$var$BRACKETS = "()（）［］\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $09c63c3fb2a2637b$var$TILDES = "~⁓∼～"; // Regular expression of acceptable punctuation found in phone numbers. This
var $09c63c3fb2a2637b$export$7f01587e28f9194 = "".concat($09c63c3fb2a2637b$var$DASHES).concat($09c63c3fb2a2637b$var$SLASHES).concat($09c63c3fb2a2637b$var$DOTS).concat($09c63c3fb2a2637b$export$20542845033f576e).concat($09c63c3fb2a2637b$var$BRACKETS).concat($09c63c3fb2a2637b$var$TILDES);
var $09c63c3fb2a2637b$export$207c99ccf3902df8 = "+＋"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $2f7663dc47f36728$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2f7663dc47f36728$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2f7663dc47f36728$var$_typeof(obj);
}
function $2f7663dc47f36728$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2f7663dc47f36728$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2f7663dc47f36728$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2f7663dc47f36728$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2f7663dc47f36728$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2f7663dc47f36728$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2f7663dc47f36728$var$_setPrototypeOf(subClass, superClass);
}
function $2f7663dc47f36728$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2f7663dc47f36728$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2f7663dc47f36728$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2f7663dc47f36728$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2f7663dc47f36728$var$_possibleConstructorReturn(this, result);
    };
}
function $2f7663dc47f36728$var$_possibleConstructorReturn(self, call) {
    if (call && ($2f7663dc47f36728$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2f7663dc47f36728$var$_assertThisInitialized(self);
}
function $2f7663dc47f36728$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2f7663dc47f36728$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $2f7663dc47f36728$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$2f7663dc47f36728$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $2f7663dc47f36728$var$_construct(Class, arguments, $2f7663dc47f36728$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $2f7663dc47f36728$var$_setPrototypeOf(Wrapper, Class);
    };
    return $2f7663dc47f36728$var$_wrapNativeSuper(Class);
}
function $2f7663dc47f36728$var$_construct(Parent, args, Class) {
    if ($2f7663dc47f36728$var$_isNativeReflectConstruct()) $2f7663dc47f36728$var$_construct = Reflect.construct;
    else $2f7663dc47f36728$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $2f7663dc47f36728$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $2f7663dc47f36728$var$_construct.apply(null, arguments);
}
function $2f7663dc47f36728$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2f7663dc47f36728$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $2f7663dc47f36728$var$_setPrototypeOf(o, p) {
    $2f7663dc47f36728$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2f7663dc47f36728$var$_setPrototypeOf(o, p);
}
function $2f7663dc47f36728$var$_getPrototypeOf(o) {
    $2f7663dc47f36728$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2f7663dc47f36728$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $2f7663dc47f36728$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $2f7663dc47f36728$var$_inherits(ParseError, _Error);
    var _super = $2f7663dc47f36728$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $2f7663dc47f36728$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($2f7663dc47f36728$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $2f7663dc47f36728$var$_createClass(ParseError);
}(/*#__PURE__*/ $2f7663dc47f36728$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $7e3339b91e116bf7$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}


var $665b0b36ce5d0c63$var$objectConstructor = {}.constructor;
function $665b0b36ce5d0c63$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $665b0b36ce5d0c63$var$objectConstructor;
}


function $81668d0b6c6437f8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $81668d0b6c6437f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $81668d0b6c6437f8$var$_typeof(obj);
}
function $81668d0b6c6437f8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $81668d0b6c6437f8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $81668d0b6c6437f8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $81668d0b6c6437f8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $81668d0b6c6437f8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $81668d0b6c6437f8$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $81668d0b6c6437f8$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $81668d0b6c6437f8$var$V4 = "1.7.35";
var $81668d0b6c6437f8$var$DEFAULT_EXT_PREFIX = " ext. ";
var $81668d0b6c6437f8$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $81668d0b6c6437f8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $81668d0b6c6437f8$var$_classCallCheck(this, Metadata);
        $81668d0b6c6437f8$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $81668d0b6c6437f8$var$setVersion.call(this, metadata);
    }
    $81668d0b6c6437f8$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $81668d0b6c6437f8$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $81668d0b6c6437f8$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $81668d0b6c6437f8$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $81668d0b6c6437f8$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $81668d0b6c6437f8$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $81668d0b6c6437f8$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $81668d0b6c6437f8$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $81668d0b6c6437f8$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $81668d0b6c6437f8$var$getType(this.types(), _type2)) return new $81668d0b6c6437f8$var$Type($81668d0b6c6437f8$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $81668d0b6c6437f8$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $81668d0b6c6437f8$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $81668d0b6c6437f8$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $81668d0b6c6437f8$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $81668d0b6c6437f8$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$81668d0b6c6437f8$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $81668d0b6c6437f8$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $81668d0b6c6437f8$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $81668d0b6c6437f8$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $81668d0b6c6437f8$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $81668d0b6c6437f8$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $81668d0b6c6437f8$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $665b0b36ce5d0c63$export$2e2bcd8739ae039)(metadata) || !(0, $665b0b36ce5d0c63$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $665b0b36ce5d0c63$export$2e2bcd8739ae039)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $81668d0b6c6437f8$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $81668d0b6c6437f8$var$typeOf = function typeOf(_) {
    return $81668d0b6c6437f8$var$_typeof(_);
};
function $81668d0b6c6437f8$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $81668d0b6c6437f8$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $81668d0b6c6437f8$var$DEFAULT_EXT_PREFIX;
}
function $81668d0b6c6437f8$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $81668d0b6c6437f8$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $81668d0b6c6437f8$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $81668d0b6c6437f8$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $7e3339b91e116bf7$export$2e2bcd8739ae039)(version, $81668d0b6c6437f8$var$V3) === -1) this.v2 = true;
        else if ((0, $7e3339b91e116bf7$export$2e2bcd8739ae039)(version, $81668d0b6c6437f8$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $a888e393e072ca69$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $a888e393e072ca69$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $09c63c3fb2a2637b$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $a888e393e072ca69$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.．]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|\xf3))?n?|ｅ?ｘｔｎ?|доб|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $a888e393e072ca69$var$RFC3966_EXTN_PREFIX + $a888e393e072ca69$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $a888e393e072ca69$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $a888e393e072ca69$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $a888e393e072ca69$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $a888e393e072ca69$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $a888e393e072ca69$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $c26c63088ccfa0f7$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $09c63c3fb2a2637b$export$852d1d4a47329634) + "]{" + (0, $09c63c3fb2a2637b$export$cd8355bcbe13154) + "}"; //
var $c26c63088ccfa0f7$export$a77dd7471651eee = "[" + (0, $09c63c3fb2a2637b$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $09c63c3fb2a2637b$export$7f01587e28f9194) + "]*" + "[" + (0, $09c63c3fb2a2637b$export$852d1d4a47329634) + "]" + "){3,}" + "[" + (0, $09c63c3fb2a2637b$export$7f01587e28f9194) + (0, $09c63c3fb2a2637b$export$852d1d4a47329634) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $c26c63088ccfa0f7$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $09c63c3fb2a2637b$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $09c63c3fb2a2637b$export$7f01587e28f9194) + "]*" + "[" + (0, $09c63c3fb2a2637b$export$852d1d4a47329634) + "]" + "){1,2}" + "$", "i");
var $c26c63088ccfa0f7$export$a2d12a04749c087d = $c26c63088ccfa0f7$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $a888e393e072ca69$export$2e2bcd8739ae039)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $c26c63088ccfa0f7$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $c26c63088ccfa0f7$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $c26c63088ccfa0f7$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $c26c63088ccfa0f7$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $09c63c3fb2a2637b$export$cd8355bcbe13154) && $c26c63088ccfa0f7$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $c26c63088ccfa0f7$export$4c3f76c95c05197c(number) {
    return $c26c63088ccfa0f7$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $2eca5d4732f9e443$var$EXTN_PATTERN = new RegExp("(?:" + (0, $a888e393e072ca69$export$2e2bcd8739ae039)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $2eca5d4732f9e443$export$2e2bcd8739ae039(number) {
    var start = number.search($2eca5d4732f9e443$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($2eca5d4732f9e443$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $c52bf2880dc0c97a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c52bf2880dc0c97a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c52bf2880dc0c97a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c52bf2880dc0c97a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c52bf2880dc0c97a$var$_arrayLikeToArray(o, minLen);
}
function $c52bf2880dc0c97a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $c52bf2880dc0c97a$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "０": "0",
    // Fullwidth digit 0
    "１": "1",
    // Fullwidth digit 1
    "２": "2",
    // Fullwidth digit 2
    "３": "3",
    // Fullwidth digit 3
    "４": "4",
    // Fullwidth digit 4
    "５": "5",
    // Fullwidth digit 5
    "６": "6",
    // Fullwidth digit 6
    "７": "7",
    // Fullwidth digit 7
    "８": "8",
    // Fullwidth digit 8
    "９": "9",
    // Fullwidth digit 9
    "٠": "0",
    // Arabic-indic digit 0
    "١": "1",
    // Arabic-indic digit 1
    "٢": "2",
    // Arabic-indic digit 2
    "٣": "3",
    // Arabic-indic digit 3
    "٤": "4",
    // Arabic-indic digit 4
    "٥": "5",
    // Arabic-indic digit 5
    "٦": "6",
    // Arabic-indic digit 6
    "٧": "7",
    // Arabic-indic digit 7
    "٨": "8",
    // Arabic-indic digit 8
    "٩": "9",
    // Arabic-indic digit 9
    "۰": "0",
    // Eastern-Arabic digit 0
    "۱": "1",
    // Eastern-Arabic digit 1
    "۲": "2",
    // Eastern-Arabic digit 2
    "۳": "3",
    // Eastern-Arabic digit 3
    "۴": "4",
    // Eastern-Arabic digit 4
    "۵": "5",
    // Eastern-Arabic digit 5
    "۶": "6",
    // Eastern-Arabic digit 6
    "۷": "7",
    // Eastern-Arabic digit 7
    "۸": "8",
    // Eastern-Arabic digit 8
    "۹": "9" // Eastern-Arabic digit 9
};
function $c52bf2880dc0c97a$export$1d16fddea1437169(character) {
    return $c52bf2880dc0c97a$export$2848f3d68c08fe69[character];
}
function $c52bf2880dc0c97a$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $c52bf2880dc0c97a$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $c52bf2880dc0c97a$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $46dc874045f41509$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $46dc874045f41509$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $46dc874045f41509$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $46dc874045f41509$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $46dc874045f41509$var$_arrayLikeToArray(o, minLen);
}
function $46dc874045f41509$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $46dc874045f41509$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $46dc874045f41509$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $46dc874045f41509$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $46dc874045f41509$export$13d8790d7fb84c28(character, prevParsedCharacters) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) return;
        return "+";
    } // Allow digits.
    return (0, $c52bf2880dc0c97a$export$1d16fddea1437169)(character);
}




function $da610d2140d4c070$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $da610d2140d4c070$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $da610d2140d4c070$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $da610d2140d4c070$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $da610d2140d4c070$var$_arrayLikeToArray(o, minLen);
}
function $da610d2140d4c070$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $da610d2140d4c070$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $da610d2140d4c070$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $0ed4d7160584a919$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $0ed4d7160584a919$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $0ed4d7160584a919$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $0ed4d7160584a919$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $da610d2140d4c070$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}


function $199981f701f3df15$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $199981f701f3df15$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $199981f701f3df15$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $0ed4d7160584a919$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $f2b3f5c67f12ce65$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}




function $44552fbce7fb151e$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $44552fbce7fb151e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $44552fbce7fb151e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $44552fbce7fb151e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $44552fbce7fb151e$var$_arrayLikeToArray(o, minLen);
}
function $44552fbce7fb151e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $44552fbce7fb151e$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $44552fbce7fb151e$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $f2b3f5c67f12ce65$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($44552fbce7fb151e$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($44552fbce7fb151e$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $44552fbce7fb151e$var$_createForOfIteratorHelperLoose($44552fbce7fb151e$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($44552fbce7fb151e$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $44552fbce7fb151e$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $f2b3f5c67f12ce65$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $76273ba95d22207a$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
    /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */ metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $44552fbce7fb151e$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $f2b3f5c67f12ce65$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $88b97c64704716f3$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $88b97c64704716f3$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $88b97c64704716f3$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




function $ca01e371dd28e47b$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $09c63c3fb2a2637b$export$7f01587e28f9194), "]+"), "g"), " ").trim();
}


var $7d888294e31209e3$export$4f32ad1c51a7a6be = /(\$\d)/;
function $7d888294e31209e3$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($7d888294e31209e3$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $ca01e371dd28e47b$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $22e875d2b8d2f6ac$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $22e875d2b8d2f6ac$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($22e875d2b8d2f6ac$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $47e5774f8a597c79$var$_slicedToArray(arr, i) {
    return $47e5774f8a597c79$var$_arrayWithHoles(arr) || $47e5774f8a597c79$var$_iterableToArrayLimit(arr, i) || $47e5774f8a597c79$var$_unsupportedIterableToArray(arr, i) || $47e5774f8a597c79$var$_nonIterableRest();
}
function $47e5774f8a597c79$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $47e5774f8a597c79$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $47e5774f8a597c79$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $47e5774f8a597c79$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $47e5774f8a597c79$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $47e5774f8a597c79$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $47e5774f8a597c79$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $47e5774f8a597c79$var$_arrayLikeToArray(o, minLen);
}
function $47e5774f8a597c79$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $47e5774f8a597c79$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $47e5774f8a597c79$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $47e5774f8a597c79$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $c26c63088ccfa0f7$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $47e5774f8a597c79$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}


function $52c89f87b486dc56$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $52c89f87b486dc56$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $52c89f87b486dc56$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $52c89f87b486dc56$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $52c89f87b486dc56$var$_arrayLikeToArray(o, minLen);
}
function $52c89f87b486dc56$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $52c89f87b486dc56$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $52c89f87b486dc56$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $52c89f87b486dc56$var$ownKeys(Object(source), !0).forEach(function(key) {
            $52c89f87b486dc56$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $52c89f87b486dc56$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $52c89f87b486dc56$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $52c89f87b486dc56$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $52c89f87b486dc56$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $52c89f87b486dc56$var$_objectSpread($52c89f87b486dc56$var$_objectSpread({}, $52c89f87b486dc56$var$DEFAULT_OPTIONS), options);
    else options = $52c89f87b486dc56$var$DEFAULT_OPTIONS;
    metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $52c89f87b486dc56$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $52c89f87b486dc56$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $52c89f87b486dc56$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $52c89f87b486dc56$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $47e5774f8a597c79$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $52c89f87b486dc56$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $52c89f87b486dc56$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $52c89f87b486dc56$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $52c89f87b486dc56$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $7d888294e31209e3$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $52c89f87b486dc56$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $52c89f87b486dc56$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $f2b3f5c67f12ce65$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $52c89f87b486dc56$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $52c89f87b486dc56$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $81668d0b6c6437f8$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $52c89f87b486dc56$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $22e875d2b8d2f6ac$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($52c89f87b486dc56$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}


function $e17490c7d0e82713$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e17490c7d0e82713$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e17490c7d0e82713$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e17490c7d0e82713$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e17490c7d0e82713$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e17490c7d0e82713$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e17490c7d0e82713$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e17490c7d0e82713$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e17490c7d0e82713$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e17490c7d0e82713$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e17490c7d0e82713$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $e17490c7d0e82713$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $e17490c7d0e82713$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $e17490c7d0e82713$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $e17490c7d0e82713$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $e17490c7d0e82713$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $88b97c64704716f3$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $199981f701f3df15$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $76273ba95d22207a$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $44552fbce7fb151e$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $52c89f87b486dc56$export$2e2bcd8739ae039)(this, _format, options ? $e17490c7d0e82713$var$_objectSpread($e17490c7d0e82713$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $e17490c7d0e82713$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $e17490c7d0e82713$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($e17490c7d0e82713$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($e17490c7d0e82713$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}





var $c0f9845b1640e9d9$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $09c63c3fb2a2637b$export$852d1d4a47329634) + "])");
function $c0f9845b1640e9d9$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($c0f9845b1640e9d9$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $4ff8cb0a99da3d35$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $62b5ad2b6c39fdc3$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $4ff8cb0a99da3d35$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$62b5ad2b6c39fdc3$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$62b5ad2b6c39fdc3$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $62b5ad2b6c39fdc3$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $f2b3f5c67f12ce65$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $f2b3f5c67f12ce65$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $62b5ad2b6c39fdc3$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $0ed4d7160584a919$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $410fa95f31131b25$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $81668d0b6c6437f8$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $62b5ad2b6c39fdc3$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $62b5ad2b6c39fdc3$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $f2b3f5c67f12ce65$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $f2b3f5c67f12ce65$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $0ed4d7160584a919$export$2e2bcd8739ae039)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $f691ef2a8567aa60$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $c0f9845b1640e9d9$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $410fa95f31131b25$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $09c63c3fb2a2637b$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }






function $d1df64656e6a1b0a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d1df64656e6a1b0a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d1df64656e6a1b0a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d1df64656e6a1b0a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d1df64656e6a1b0a$var$_arrayLikeToArray(o, minLen);
}
function $d1df64656e6a1b0a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d1df64656e6a1b0a$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata);
    var matchingCountries = [];
    for(var _iterator = $d1df64656e6a1b0a$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $44552fbce7fb151e$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}


var $dba58430e3dec1ba$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $dba58430e3dec1ba$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($dba58430e3dec1ba$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $d1df64656e6a1b0a$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $b667e944ed3b2a9b$export$1ddc7eed78155f68 = "+";
var $b667e944ed3b2a9b$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $b667e944ed3b2a9b$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $09c63c3fb2a2637b$export$852d1d4a47329634) + "]" + "|" + $b667e944ed3b2a9b$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $b667e944ed3b2a9b$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $b667e944ed3b2a9b$export$1ddc7eed78155f68 + $b667e944ed3b2a9b$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $09c63c3fb2a2637b$export$852d1d4a47329634) + "]" + $b667e944ed3b2a9b$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $b667e944ed3b2a9b$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($b667e944ed3b2a9b$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $b667e944ed3b2a9b$var$ALPHANUM_ = (0, $09c63c3fb2a2637b$export$852d1d4a47329634);
var $b667e944ed3b2a9b$var$RFC3966_DOMAINLABEL_ = "[" + $b667e944ed3b2a9b$var$ALPHANUM_ + "]+((\\-)*[" + $b667e944ed3b2a9b$var$ALPHANUM_ + "])*";
var $b667e944ed3b2a9b$var$VALID_ALPHA_ = "a-zA-Z";
var $b667e944ed3b2a9b$var$RFC3966_TOPLABEL_ = "[" + $b667e944ed3b2a9b$var$VALID_ALPHA_ + "]+((\\-)*[" + $b667e944ed3b2a9b$var$ALPHANUM_ + "])*";
var $b667e944ed3b2a9b$var$RFC3966_DOMAINNAME_ = "^(" + $b667e944ed3b2a9b$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $b667e944ed3b2a9b$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $b667e944ed3b2a9b$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($b667e944ed3b2a9b$var$RFC3966_DOMAINNAME_, "g");
var $b667e944ed3b2a9b$export$70d485ce3f6de783 = "tel:";
var $b667e944ed3b2a9b$export$f6d5879d582c3a27 = ";phone-context=";
var $b667e944ed3b2a9b$export$9e356e12edb00a81 = ";isub=";
function $b667e944ed3b2a9b$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($b667e944ed3b2a9b$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $b667e944ed3b2a9b$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $b667e944ed3b2a9b$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $b667e944ed3b2a9b$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $b667e944ed3b2a9b$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $029598bdf082b090$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $b667e944ed3b2a9b$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $b667e944ed3b2a9b$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $2f7663dc47f36728$export$2e2bcd8739ae039)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $b667e944ed3b2a9b$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $b667e944ed3b2a9b$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $b667e944ed3b2a9b$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $b667e944ed3b2a9b$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $b667e944ed3b2a9b$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $3a1b0b1f17a3834f$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $3a1b0b1f17a3834f$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $09c63c3fb2a2637b$export$207c99ccf3902df8) + (0, $09c63c3fb2a2637b$export$852d1d4a47329634) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $3a1b0b1f17a3834f$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $09c63c3fb2a2637b$export$852d1d4a47329634) + "#" + "]+$");
var $3a1b0b1f17a3834f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $3a1b0b1f17a3834f$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $2f7663dc47f36728$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $3a1b0b1f17a3834f$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $2f7663dc47f36728$export$2e2bcd8739ae039)("TOO_SHORT");
            throw new (0, $2f7663dc47f36728$export$2e2bcd8739ae039)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $3a1b0b1f17a3834f$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $2f7663dc47f36728$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $09c63c3fb2a2637b$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $2f7663dc47f36728$export$2e2bcd8739ae039)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $09c63c3fb2a2637b$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $2f7663dc47f36728$export$2e2bcd8739ae039)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $e17490c7d0e82713$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $f2b3f5c67f12ce65$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $3a1b0b1f17a3834f$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $199981f701f3df15$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $3a1b0b1f17a3834f$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $3a1b0b1f17a3834f$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $2f7663dc47f36728$export$2e2bcd8739ae039)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($3a1b0b1f17a3834f$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($3a1b0b1f17a3834f$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $3a1b0b1f17a3834f$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $029598bdf082b090$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $3a1b0b1f17a3834f$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $c26c63088ccfa0f7$export$2e2bcd8739ae039)(number)) {
        if ((0, $c26c63088ccfa0f7$export$4c3f76c95c05197c)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $2eca5d4732f9e443$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $3a1b0b1f17a3834f$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $3a1b0b1f17a3834f$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $f691ef2a8567aa60$export$2e2bcd8739ae039)((0, $46dc874045f41509$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($3a1b0b1f17a3834f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $81668d0b6c6437f8$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $62b5ad2b6c39fdc3$export$2e2bcd8739ae039)((0, $46dc874045f41509$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $dba58430e3dec1ba$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $a47566aab8d7faa5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a47566aab8d7faa5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a47566aab8d7faa5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a47566aab8d7faa5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a47566aab8d7faa5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a47566aab8d7faa5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a47566aab8d7faa5$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $3a1b0b1f17a3834f$export$2e2bcd8739ae039)(text, $a47566aab8d7faa5$var$_objectSpread($a47566aab8d7faa5$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}



function $54dbb0b4e0504e50$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54dbb0b4e0504e50$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $54dbb0b4e0504e50$var$ownKeys(Object(source), !0).forEach(function(key) {
            $54dbb0b4e0504e50$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $54dbb0b4e0504e50$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $54dbb0b4e0504e50$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $54dbb0b4e0504e50$var$_slicedToArray(arr, i) {
    return $54dbb0b4e0504e50$var$_arrayWithHoles(arr) || $54dbb0b4e0504e50$var$_iterableToArrayLimit(arr, i) || $54dbb0b4e0504e50$var$_unsupportedIterableToArray(arr, i) || $54dbb0b4e0504e50$var$_nonIterableRest();
}
function $54dbb0b4e0504e50$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $54dbb0b4e0504e50$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $54dbb0b4e0504e50$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $54dbb0b4e0504e50$var$_arrayLikeToArray(o, minLen);
}
function $54dbb0b4e0504e50$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $54dbb0b4e0504e50$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $54dbb0b4e0504e50$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $54dbb0b4e0504e50$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $54dbb0b4e0504e50$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $54dbb0b4e0504e50$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $665b0b36ce5d0c63$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


function $08f1334dbe770d52$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $54dbb0b4e0504e50$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $a47566aab8d7faa5$export$2e2bcd8739ae039)(text, options, metadata);
}


function $74d71e500a0fa47c$export$176bb591929cc9a8() {
    return (0, $64644baca7251a95$export$2e2bcd8739ae039)((0, $08f1334dbe770d52$export$2e2bcd8739ae039), arguments);
}


var $d417a0abc2864103$export$da44e4eaa54bc82e = function(phone) {
    try {
        return (0, $74d71e500a0fa47c$export$176bb591929cc9a8)(phone).number.slice(1);
    } catch (e) {
        console.error("Invalid phone number: ".concat(phone));
        return phone;
    }
};
var $d417a0abc2864103$export$d79b62bd58081ca4 = function(phone) {
    try {
        var phoneNumber = phone.startsWith("+") ? phone : "+".concat(phone);
        return (0, $74d71e500a0fa47c$export$176bb591929cc9a8)(phoneNumber).formatInternational();
    } catch (e) {
        console.error("Invalid phone number: ".concat(phone));
        return phone;
    }
};


/**
 * Checks if the subdomain string is valid
 * @param subdomain subdomain string
 * @returns boolean indicating whether the subdomain is valid
 */ var $bae9e3cb058b8f21$export$7621d68d5c3b3a53 = function(subdomain) {
    return /^([\da-z]([\da-z-]{0,61}[\da-z])?)$/.test(subdomain);
};


/**
 * A cache that expires entries after a given time-to-live (TTL). It uses a
 * `Map` in memory to store the entries.
 */ 
function $ddc71b5f7aebcc68$export$ccedaf978f62b9dd(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}


function $a725191329b4e5e8$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $6e80d445a408dd14$export$1002c20f28174dbf(obj, privateSet) {
    (0, $a725191329b4e5e8$export$6b10452b5ac97eba)(obj, privateSet);
    privateSet.add(obj);
}



var $f7e43fede99e7bba$var$_purge = /*#__PURE__*/ new WeakSet();
var $f7e43fede99e7bba$export$4421a7403324ea68 = /*#__PURE__*/ function() {
    "use strict";
    function TtlCache() {
        var ttl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Number.POSITIVE_INFINITY;
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, TtlCache);
        (0, $6e80d445a408dd14$export$1002c20f28174dbf)(this, $f7e43fede99e7bba$var$_purge);
        this.ttl = ttl;
        this.data = new Map();
        this.expiration = new Map();
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(TtlCache, [
        {
            /**
     * Sets a value in the cache.
     * @param key The key to set.
     * @param value The value to set.
     * @param ttl The TTL for the entry in milliseconds. Defaults to the default
     * TTL.
     * @throws If the value is `undefined`.
     */ key: "set",
            value: function set(key, value) {
                var ttl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.ttl;
                if (value === undefined) throw new TypeError("Value cannot be undefined");
                this.expiration.set(key, Date.now() + ttl);
                this.data.set(key, value);
            }
        },
        {
            /**
     * Gets a value from the cache.
     * @param key The key to get.
     * @returns The value or `undefined` if the entry has expired or does not
     * exist.
     */ key: "get",
            value: function get(key) {
                (0, $ddc71b5f7aebcc68$export$ccedaf978f62b9dd)(this, $f7e43fede99e7bba$var$_purge, $f7e43fede99e7bba$var$purge).call(this, key);
                return this.data.get(key);
            }
        },
        {
            /**
     * Checks if a key exists in the cache.
     * @param key The key to check.
     * @returns `true` if the key exists and has not expired, `false` otherwise.
     */ key: "has",
            value: function has(key) {
                (0, $ddc71b5f7aebcc68$export$ccedaf978f62b9dd)(this, $f7e43fede99e7bba$var$_purge, $f7e43fede99e7bba$var$purge).call(this, key);
                return this.data.has(key);
            }
        },
        {
            /**
     * Deletes a key and its value from the cache. If the key does not exist, this
     * method does nothing.
     * @param key The key to delete.
     * @returns `true` if the key existed and was deleted, `false` otherwise.
     */ key: "delete",
            value: function _delete(key) {
                this.expiration.delete(key);
                return this.data.delete(key);
            }
        },
        {
            /**
     * Clears the cache. All entries will be deleted.
     */ key: "clear",
            value: function clear() {
                this.expiration.clear();
                this.data.clear();
            }
        }
    ]);
    return TtlCache;
}();
function $f7e43fede99e7bba$var$purge(key) {
    var expiration = this.expiration.get(key);
    if (expiration !== undefined && expiration < Date.now()) this.delete(key);
}




var $b80d88b38afe0622$export$b86884fca6ca2c21 = function(param) {
    var name = param.name, username = param.username, primaryEmail = param.primaryEmail, primaryPhone = param.primaryPhone;
    var formattedPhoneNumber = (0, $3539bd14a37ab7f4$export$c327da55a124987a)(primaryPhone && (0, $d417a0abc2864103$export$d79b62bd58081ca4)(primaryPhone));
    var _ref, _ref1, _ref2;
    return (_ref2 = (_ref1 = (_ref = name !== null && name !== void 0 ? name : primaryEmail) !== null && _ref !== void 0 ? _ref : formattedPhoneNumber) !== null && _ref1 !== void 0 ? _ref1 : username) !== null && _ref2 !== void 0 ? _ref2 : undefined;
};






// Use lowercase letters for tenant IDs to improve compatibility
var $563dc23c4586e437$var$generateTenantId = function() {
    return (0, $77ca15834c94224a$export$7e648d54e633633e)(6);
};
var $563dc23c4586e437$export$f7397bf6ffda60a4 = function(databaseName) {
    var tenantId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $563dc23c4586e437$var$generateTenantId();
    var parentRole = "logto_tenant_".concat(databaseName);
    var role = "logto_tenant_".concat(databaseName, "_").concat(tenantId);
    var password = (0, $77ca15834c94224a$export$7e648d54e633633e)(32);
    return {
        id: tenantId,
        parentRole: parentRole,
        role: role,
        password: password
    };
};




var $cb219ba407f95158$export$fd24084cc418abf6 = Object.freeze({
    200: "OK",
    201: "Created",
    202: "Accepted",
    203: "Non-Authoritative Information",
    204: "No Content",
    205: "Reset Content",
    206: "Partial Content",
    300: "Multiple Choices",
    301: "Moved Permanently",
    302: "Found",
    303: "See Other",
    304: "Not Modified",
    305: "Use Proxy",
    306: "Unused",
    307: "Temporary Redirect",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Required",
    413: "Request Entry Too Large",
    414: "Request-URI Too Long",
    415: "Unsupported Media Type",
    416: "Requested Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a teapot",
    422: "Unprocessable Content",
    429: "Too Many Requests",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported"
});









var $825feb71907001d2$export$72f2527c55497f9e = function() {
    return (0, $20233a61d5ea6be0$export$7a668e70ea2210d9)(undefined);
};
var $825feb71907001d2$export$3411cedb68d31149 = function() {
    if (!$825feb71907001d2$export$72f2527c55497f9e()) throw new Error("This function should only be called in integration tests");
    return Object.freeze([
        "123456aA",
        "test_password"
    ]);
};


var $ca0f9a3ed13a242f$export$5fffa90e2e38377b = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    length: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        min: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().int().min(1).default(8),
        max: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().int().min(1).default(256)
    }).default({}),
    characterTypes: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        min: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().int().min(1).max(4).optional().default(1)
    }).default({}),
    rejects: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        pwned: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().default(true),
        repetitionAndSequence: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().default(true),
        userInfo: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().default(true),
        words: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().array().default([])
    }).default({})
});
var $ca0f9a3ed13a242f$export$d2f225c121fa68bd = /*#__PURE__*/ function() {
    "use strict";
    function PasswordPolicyChecker(policy) {
        var /** The Web Crypto API to use. By default, the global `crypto.subtle` will be used. */ subtle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : crypto.subtle;
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, PasswordPolicyChecker);
        this.subtle = subtle;
        this.policy = $ca0f9a3ed13a242f$export$5fffa90e2e38377b.parse(policy);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(PasswordPolicyChecker, [
        {
            key: "check",
            value: /**
     * Check if a password meets all the policy requirements.
     *
     * @param password - Password to check.
     * @param userInfo - User information to check. Required if the policy
     * requires to reject passwords that include user information.
     * @returns An array of issues. If the password meets the policy, an empty array will be returned.
     * @throws TypeError - If the policy requires to reject passwords that include user information
     * but the user information is not provided.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation, @silverhand/fp/no-mutating-methods */ function check(password, userInfo) {
                var _this = this;
                return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var issues, _tmp, hashArray, issueCodes, _this_policy_rejects, repetitionAndSequence, words, rejectUserInfo, rejectWords, fillHashArray, i, sliced;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                issues = _this.fastCheck(password);
                                _tmp = _this.policy.rejects.pwned;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.hasBeenPwned(password)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (_tmp) issues.push({
                                    code: "password_rejected.pwned"
                                });
                                hashArray = Array.from({
                                    length: password.length
                                }).fill(0);
                                issueCodes = new Set();
                                _this_policy_rejects = _this.policy.rejects, repetitionAndSequence = _this_policy_rejects.repetitionAndSequence, words = _this_policy_rejects.words, rejectUserInfo = _this_policy_rejects.userInfo;
                                rejectWords = words.length > 0;
                                fillHashArray = function(startIndex, length, code) {
                                    if (length <= 0) return;
                                    for(var i = startIndex; i < startIndex + length; i += 1)hashArray[i] = 1;
                                    issueCodes.add(code);
                                };
                                for(i = 0; i < password.length; i += 1){
                                    sliced = password.slice(i);
                                    if (repetitionAndSequence) {
                                        fillHashArray(i, _this.repetitionLength(sliced), "restricted.repetition");
                                        fillHashArray(i, _this.sequenceLength(sliced), "restricted.sequence");
                                    }
                                    if (rejectWords) fillHashArray(i, _this.wordLength(sliced), "restricted.words");
                                    if (rejectUserInfo) {
                                        if (!userInfo) throw new TypeError("User information data is required to check user information.");
                                        fillHashArray(i, _this.userInfoLength(sliced, userInfo), "restricted.user_info");
                                    }
                                }
                                return [
                                    2,
                                    hashArray.reduce(function(total, current) {
                                        return total + current;
                                    }, 0) > PasswordPolicyChecker.getRestrictedPhraseThreshold(password) ? (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(issues).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(issueCodes).map(function(code) {
                                        return {
                                            code: "password_rejected.".concat(code)
                                        };
                                    }))) : issues
                                ];
                        }
                    });
                })();
            }
        },
        {
            /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation, @silverhand/fp/no-mutating-methods */ /**
     * Perform a fast check to see if the password passes the basic requirements.
     * Only the length and character types will be checked.
     *
     * This method is used for frontend validation.
     *
     * @param password - Password to check.
     * @returns Whether the password passes the basic requirements.
     */ /* eslint-disable @silverhand/fp/no-mutating-methods */ key: "fastCheck",
            value: function fastCheck(password) {
                var issues = [];
                if (password.length < this.policy.length.min) issues.push({
                    code: "password_rejected.too_short",
                    interpolation: {
                        min: this.policy.length.min
                    }
                });
                else if (password.length > this.policy.length.max) issues.push({
                    code: "password_rejected.too_long",
                    interpolation: {
                        max: this.policy.length.max
                    }
                });
                var characterTypes = this.checkCharTypes(password);
                if (characterTypes === "unsupported") issues.push({
                    code: "password_rejected.unsupported_characters"
                });
                else if (!characterTypes) issues.push({
                    code: "password_rejected.character_types",
                    interpolation: {
                        min: this.policy.characterTypes.min
                    }
                });
                return issues;
            }
        },
        {
            /* eslint-enable @silverhand/fp/no-mutating-methods */ /**
     * Check if the given password contains enough character types.
     *
     * @param password - Password to check.
     * @returns Whether the password contains enough character types; or `'unsupported'`
     * if the password contains unsupported characters.
     */ key: "checkCharTypes",
            value: function checkCharTypes(password) {
                var characterTypes = new Set();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = password[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var char = _step.value;
                        if (char >= "a" && char <= "z") characterTypes.add("lowercase");
                        else if (char >= "A" && char <= "Z") characterTypes.add("uppercase");
                        else if (char >= "0" && char <= "9") characterTypes.add("digits");
                        else if (PasswordPolicyChecker.symbols.includes(char)) characterTypes.add("symbols");
                        else return "unsupported";
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return characterTypes.size >= this.policy.characterTypes.min;
            }
        },
        {
            key: "hasBeenPwned",
            value: /**
     * Check if the given password has been pwned.
     *
     * @param password - Password to check.
     * @returns Whether the password has been pwned.
     */ function hasBeenPwned(password) {
                var _this = this;
                return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var hash, hashHex, hashPrefix, hashSuffix, response, text, hashes, found;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ((0, $825feb71907001d2$export$72f2527c55497f9e)()) return [
                                    2,
                                    (0, $825feb71907001d2$export$3411cedb68d31149)().includes(password)
                                ];
                                return [
                                    4,
                                    _this.subtle.digest("SHA-1", new TextEncoder().encode(password))
                                ];
                            case 1:
                                hash = _state.sent();
                                hashHex = Array.from(new Uint8Array(hash)).map(function(binary) {
                                    return binary.toString(16).padStart(2, "0");
                                }).join("");
                                hashPrefix = hashHex.slice(0, 5);
                                hashSuffix = hashHex.slice(5);
                                return [
                                    4,
                                    fetch("https://api.pwnedpasswords.com/range/".concat(hashPrefix))
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.text()
                                ];
                            case 3:
                                text = _state.sent();
                                hashes = text.split("\n");
                                found = hashes.some(function(hex) {
                                    return hex.toLowerCase().startsWith(hashSuffix);
                                });
                                return [
                                    2,
                                    found
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Get the length of the repetition at the beginning of the given string.
     * For example, `repetitionLength('aaaaa')` will return `5`.
     *
     * If the length is less than {@link PasswordPolicyChecker.repetitionAndSequenceThreshold},
     * `0` will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ key: "repetitionLength",
            value: function repetitionLength(password) {
                var repetitionAndSequenceThreshold = PasswordPolicyChecker.repetitionAndSequenceThreshold;
                var firstChar = password[0];
                var length = 0;
                if (firstChar === undefined) return 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = password[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var char = _step.value;
                        if (char === firstChar) length += 1;
                        else break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return length >= repetitionAndSequenceThreshold ? length : 0;
            }
        },
        {
            /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Get the length of the user information at the beginning of the given string.
     * For example, `userInfoLength('silverhand', { username: 'silverhand' })` will return `10`.
     *
     * For multiple matches, the longest length will be returned.
     */ // eslint-disable-next-line complexity
            key: "userInfoLength",
            value: function userInfoLength(password, userInfo) {
                var lowercased = password.toLowerCase();
                var name = userInfo.name, username = userInfo.username, email = userInfo.email, phoneNumber = userInfo.phoneNumber;
                // eslint-disable-next-line @silverhand/fp/no-let
                var length = 0;
                var updateLength = function(newLength) {
                    if (newLength > length) // eslint-disable-next-line @silverhand/fp/no-mutation
                    length = newLength;
                };
                if (name) {
                    var joined = name.replaceAll(/\s+/g, "");
                    // The original name should be the longest string, so we check it first.
                    if (lowercased.startsWith(name.toLowerCase())) updateLength(name.length);
                    else {
                        if (lowercased.startsWith(joined.toLowerCase())) updateLength(joined.length);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = name.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var word = _step.value;
                                if (lowercased.startsWith(word.toLowerCase())) updateLength(word.length);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
                if (username && lowercased.startsWith(username.toLowerCase())) updateLength(username.length);
                if (email) {
                    var emailPrefix = email.split("@")[0];
                    if (emailPrefix && lowercased.startsWith(emailPrefix.toLowerCase())) updateLength(emailPrefix.length);
                }
                if (phoneNumber && lowercased.startsWith(phoneNumber)) updateLength(phoneNumber.length);
                return length;
            }
        },
        {
            /**
     * Get the length of the word that matches the word list at the beginning of the given string.
     *
     * For multiple matches, the longest length will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ key: "wordLength",
            value: function wordLength(password) {
                var sliced = password.toLowerCase();
                var length = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.policy.rejects.words[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var word = _step.value;
                        if (sliced.startsWith(word.toLowerCase()) && word.length > length) length = word.length;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return length;
            }
        },
        {
            /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Get the length of the sequence at the beginning of the given string.
     * For example, `sequenceLength('12345')` will return `5`.
     *
     * If the length is less than {@link PasswordPolicyChecker.repetitionAndSequenceThreshold},
     * `0` will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ key: "sequenceLength",
            value: function sequenceLength(password) {
                var repetitionAndSequenceThreshold = PasswordPolicyChecker.repetitionAndSequenceThreshold;
                var value = "";
                var length = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = password[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var char = _step.value;
                        if (!value || this.isSequential(value + char)) {
                            value += char;
                            length += 1;
                        } else break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return length >= repetitionAndSequenceThreshold ? length : 0;
            }
        },
        {
            /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Check if the given string is sequential by iterating through the {@link PasswordPolicyChecker.sequence}.
     */ key: "isSequential",
            value: function isSequential(value) {
                var sequence = PasswordPolicyChecker.sequence;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = sequence[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var seq = _step.value;
                        // eslint-disable-next-line @silverhand/fp/no-mutating-methods -- created a new array before mutating
                        var reversedSeq = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(seq).reverse().join("");
                        if ([
                            seq,
                            reversedSeq,
                            seq.toUpperCase(),
                            reversedSeq.toUpperCase()
                        ].some(function(item) {
                            return item.includes(value);
                        })) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        }
    ], [
        {
            key: "getRestrictedPhraseThreshold",
            value: /** Get the length threshold for checking restricted phrases. */ function getRestrictedPhraseThreshold(password) {
                var restrictedPhrasesTolerance = PasswordPolicyChecker.restrictedPhrasesTolerance;
                return Math.max(1, password.length - restrictedPhrasesTolerance);
            }
        }
    ]);
    return PasswordPolicyChecker;
}();
(function() {
    $ca0f9a3ed13a242f$export$d2f225c121fa68bd.symbols = Object.freeze("!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~ ");
})();
(function() {
    $ca0f9a3ed13a242f$export$d2f225c121fa68bd.sequence = Object.freeze([
        "0123456789",
        "abcdefghijklmnopqrstuvwxyz",
        "qwertyuiop",
        "asdfghjkl",
        "zxcvbnm",
        "1qaz",
        "2wsx",
        "3edc",
        "4rfv",
        "5tgb",
        "6yhn",
        "7ujm",
        "8ik",
        "9ol"
    ]);
})();
(function() {
    $ca0f9a3ed13a242f$export$d2f225c121fa68bd.repetitionAndSequenceThreshold = 3;
})();
(function() {
    $ca0f9a3ed13a242f$export$d2f225c121fa68bd.restrictedPhrasesTolerance = 3;
})();





var $af3185488ed4f70a$export$a20c8b5ccf36e075;
(function(LogResult) {
    LogResult["Success"] = "Success";
    LogResult["Error"] = "Error";
})($af3185488ed4f70a$export$a20c8b5ccf36e075 || ($af3185488ed4f70a$export$a20c8b5ccf36e075 = {}));
var $af3185488ed4f70a$export$2938cb1ca9b4e331 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    key: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    result: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($af3185488ed4f70a$export$a20c8b5ccf36e075),
    error: (0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).string(), (0, $a782240af38642b4$export$2e2bcd8739ae039).unknown()).or((0, $a782240af38642b4$export$2e2bcd8739ae039).string()).optional(),
    ip: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    userAgent: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    sessionId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
}).catchall((0, $a782240af38642b4$export$2e2bcd8739ae039).unknown());
var $af3185488ed4f70a$export$eee4f836f95656a7 = (0, $ca0f9a3ed13a242f$export$5fffa90e2e38377b).deepPartial();





var $f875485805d06c56$export$525df20e0fb1714c = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    userCode: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    uid: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    grantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
})/**
     * Try to use `.passthrough()` if type has been fixed.
     * https://github.com/colinhacks/zod/issues/452
     */ .catchall((0, $a782240af38642b4$export$2e2bcd8739ae039).unknown());
var $f875485805d06c56$export$2b5eeb3c40bff26b = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    redirectUris: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().refine(function(url) {
        return (0, $5ec0d22151529b3f$export$eabdc444ee87166e)(url, "web");
    }).or((0, $a782240af38642b4$export$2e2bcd8739ae039).string().refine(function(url) {
        return (0, $5ec0d22151529b3f$export$eabdc444ee87166e)(url, "mobile");
    })).array(),
    postLogoutRedirectUris: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().url().array(),
    logoUri: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
});
var $f875485805d06c56$export$35a50069c63f27cc;
(function(CustomClientMetadataKey) {
    CustomClientMetadataKey["CorsAllowedOrigins"] = "corsAllowedOrigins";
    CustomClientMetadataKey["IdTokenTtl"] = "idTokenTtl";
    /** @deprecated Use {@link RefreshTokenTtlInDays} instead. */ CustomClientMetadataKey["RefreshTokenTtl"] = "refreshTokenTtl";
    CustomClientMetadataKey["RefreshTokenTtlInDays"] = "refreshTokenTtlInDays";
    CustomClientMetadataKey["TenantId"] = "tenantId";
    /**
     * Enabling this configuration will allow Logto to always issue Refresh Tokens, regardless of whether `prompt=consent` is presented in the authentication request.
     *
     * It only works for web applications when the client allowed grant types includes `refresh_token`.
     *
     * This config is for the third-party integrations that do not strictly follow OpenID Connect standards due to some reasons (e.g. they only know OAuth, but requires a Refresh Token to be returned anyway).
     */ CustomClientMetadataKey["AlwaysIssueRefreshToken"] = "alwaysIssueRefreshToken";
    /**
     * When enabled (default), Logto will issue a new Refresh Token for token requests when 70% of the original Time to Live (TTL) has passed.
     *
     * It can be turned off for only traditional web apps for enhanced security.
     */ CustomClientMetadataKey["RotateRefreshToken"] = "rotateRefreshToken";
})($f875485805d06c56$export$35a50069c63f27cc || ($f875485805d06c56$export$35a50069c63f27cc = {}));
var $f875485805d06c56$var$_obj;
var $f875485805d06c56$export$44618fabe8266610 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object(($f875485805d06c56$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f875485805d06c56$var$_obj, $f875485805d06c56$export$35a50069c63f27cc.CorsAllowedOrigins, (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).array().optional()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f875485805d06c56$var$_obj, $f875485805d06c56$export$35a50069c63f27cc.IdTokenTtl, (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f875485805d06c56$var$_obj, $f875485805d06c56$export$35a50069c63f27cc.RefreshTokenTtl, (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f875485805d06c56$var$_obj, $f875485805d06c56$export$35a50069c63f27cc.RefreshTokenTtlInDays, (0, $a782240af38642b4$export$2e2bcd8739ae039).number().int().min(1).max(90).optional()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f875485805d06c56$var$_obj, $f875485805d06c56$export$35a50069c63f27cc.TenantId, (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f875485805d06c56$var$_obj, $f875485805d06c56$export$35a50069c63f27cc.AlwaysIssueRefreshToken, (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f875485805d06c56$var$_obj, $f875485805d06c56$export$35a50069c63f27cc.RotateRefreshToken, (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()), $f875485805d06c56$var$_obj));



var $80fb3a0089879da8$export$aea1b2a91583fcef = (0, $a782240af38642b4$export$2e2bcd8739ae039).lazy(function() {
    return (0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).string().or($80fb3a0089879da8$export$aea1b2a91583fcef));
});



var $6dbf06f251d021be$export$d0d68bb9ed2c643d = Object.freeze({
    "af-ZA": "Afrikaans",
    "am-ET": "አማርኛ",
    "ar-AR": "العربية",
    "as-IN": "অসমীয়া",
    "az-AZ": "Azərbaycan dili",
    "be-BY": "Беларуская",
    "bg-BG": "Български",
    "bn-IN": "বাংলা",
    "br-FR": "Brezhoneg",
    "bs-BA": "Bosanski",
    "ca-ES": "Catal\xe0",
    "cb-IQ": "کوردیی ناوەندی",
    "co-FR": "Corsu",
    "cs-CZ": "Čeština",
    "cx-PH": "Bisaya",
    "cy-GB": "Cymraeg",
    "da-DK": "Dansk",
    de: "Deutsch",
    "de-DE": "Deutsch (Deutschland)",
    "el-GR": "Ελληνικά",
    en: "English",
    "en-GB": "English (UK)",
    "en-US": "English (US)",
    "eo-EO": "Esperanto",
    es: "Espa\xf1ol",
    "es-ES": "Espa\xf1ol (Espa\xf1a)",
    "es-419": "Espa\xf1ol (Latinoam\xe9rica)",
    "et-EE": "Eesti",
    "eu-ES": "Euskara",
    "fa-IR": "فارسی",
    "ff-NG": "Fula",
    "fi-FI": "Suomi",
    "fo-FO": "F\xf8royskt",
    fr: "Fran\xe7ais",
    "fr-CA": "Fran\xe7ais (Canada)",
    "fr-FR": "Fran\xe7ais (France)",
    "fy-NL": "Frysk",
    "ga-IE": "Gaeilge",
    "gl-ES": "Galego",
    "gn-PY": "Guarani",
    "gu-IN": "ગુજરાતી",
    "ha-NG": "Hausa",
    "he-IL": "עברית",
    "hi-IN": "हिन्दी",
    "hr-HR": "Hrvatski",
    "ht-HT": "Krey\xf2l Ayisyen",
    "hu-HU": "Magyar",
    "hy-AM": "Հայերեն",
    "id-ID": "Bahasa Indonesia",
    "ik-US": "I\xf1upiatun",
    "is-IS": "\xcdslenska",
    it: "Italiano",
    "it-IT": "Italiano (Italia)",
    "iu-CA": "Inuktitut",
    ja: "日本語",
    "ja-JP": "日本語",
    "ja-KS": "日本語(関西)",
    "jv-ID": "Basa Jawa",
    "ka-GE": "ქართული",
    "kk-KZ": "Қазақша",
    "km-KH": "ភាសាខ្មែរ",
    "kn-IN": "ಕನ್ನಡ",
    ko: "한국어",
    "ko-KR": "한국어",
    "ku-TR": "Kurd\xee (Kurmanc\xee)",
    "ky-KG": "кыргызча",
    "lo-LA": "ພາສາລາວ",
    "lt-LT": "Lietuvių",
    "lv-LV": "Latviešu",
    "mg-MG": "Malagasy",
    "mk-MK": "Македонски",
    "ml-IN": "മലയാളം",
    "mn-MN": "Монгол",
    "mr-IN": "मराठी",
    "ms-MY": "Bahasa Melayu",
    "mt-MT": "Malti",
    "my-MM": "မြန်မာဘာသာ",
    "nb-NO": "Norsk (bokm\xe5l)",
    "ne-NP": "नेपाली",
    "nl-BE": "Vlaams",
    "nl-NL": "Nederlands",
    "nn-NO": "Norsk (nynorsk)",
    "or-IN": "ଓଡ଼ିଆ",
    "pa-IN": "ਪੰਜਾਬੀ",
    "pl-PL": "Polski",
    "ps-AF": "پښتو",
    pt: "portugu\xeas",
    "pt-BR": "Portugu\xeas (Brasil)",
    "pt-PT": "Portugu\xeas (Portugal)",
    "ro-RO": "Rom\xe2nă",
    ru: "Русский",
    "ru-RU": "Русский",
    "rw-RW": "Ikinyarwanda",
    "sc-IT": "Sardu",
    "si-LK": "සිංහල",
    "sk-SK": "Slovenčina",
    "sl-SI": "Slovenščina",
    "sn-ZW": "Shona",
    "sq-AL": "Shqip",
    "sr-RS": "Српски",
    "sv-SE": "Svenska",
    "sw-KE": "Kiswahili",
    "sy-SY": "ܣܘܪܝܝܐ",
    "sz-PL": "ślōnskŏ gŏdka",
    "ta-IN": "தமிழ்",
    "te-IN": "తెలుగు",
    "tg-TJ": "Тоҷикӣ",
    "th-TH": "ภาษาไทย",
    "tl-PH": "Filipino",
    tr: "T\xfcrk\xe7e",
    "tr-TR": "T\xfcrk\xe7e",
    "tt-RU": "Татарча",
    "tz-MA": "ⵜⴰⵎⴰⵣⵉⵖⵜ",
    "uk-UA": "Українська",
    "ur-PK": "اردو",
    "uz-UZ": "O'zbek",
    "vi-VN": "Tiếng Việt",
    zh: "中文",
    "zh-CN": "简体中文",
    "zh-HK": "繁體中文（香港）",
    "zh-MO": "繁體中文（澳門）",
    "zh-TW": "繁體中文（台灣）",
    "zz-TR": "Zaza"
});






var $08b5a247edaf1be2$export$ab649249f0bfeb57 = function(value) {
    return typeof value === "string" && value in (0, $6dbf06f251d021be$export$d0d68bb9ed2c643d);
};
var $08b5a247edaf1be2$export$2b8b19a59fcec1e6 = (0, $a782240af38642b4$export$2e2bcd8739ae039).any().refine(function(value) {
    return $08b5a247edaf1be2$export$ab649249f0bfeb57(value);
});
function $08b5a247edaf1be2$export$bcd1dd1f397bba12(value) {
    return (0, $a782240af38642b4$export$4154a199d7d90455)().transform(function() {
        return value;
    });
}





var $6ae7ce06f09cd84a$export$5c91807cab7a8dc1 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    primaryColor: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().regex((0, $9f2f5d16fced0798$export$ad64c5d64b2f359b)),
    isDarkModeEnabled: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    darkPrimaryColor: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().regex((0, $9f2f5d16fced0798$export$ad64c5d64b2f359b))
});
var $6ae7ce06f09cd84a$export$c9d0acdc98ac45b = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    logoUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().url().optional(),
    darkLogoUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().url().optional(),
    favicon: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().url().optional()
});
var $6ae7ce06f09cd84a$export$b8fe26243f8b3b37 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    autoDetect: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    fallbackLanguage: (0, $08b5a247edaf1be2$export$2b8b19a59fcec1e6)
});
var $6ae7ce06f09cd84a$export$f2322d76aef584c7;
(function(SignInIdentifier) {
    SignInIdentifier["Username"] = "username";
    SignInIdentifier["Email"] = "email";
    SignInIdentifier["Phone"] = "phone";
})($6ae7ce06f09cd84a$export$f2322d76aef584c7 || ($6ae7ce06f09cd84a$export$f2322d76aef584c7 = {}));
var $6ae7ce06f09cd84a$export$fd48acc070c38d7b = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    identifiers: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($6ae7ce06f09cd84a$export$f2322d76aef584c7).array(),
    password: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    verify: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean()
});
var $6ae7ce06f09cd84a$export$8665c7c0edac5e7a = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    methods: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        identifier: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($6ae7ce06f09cd84a$export$f2322d76aef584c7),
        password: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
        verificationCode: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
        isPasswordPrimary: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean()
    }).array()
});
var $6ae7ce06f09cd84a$export$276d424b39387296 = (0, $a782240af38642b4$export$2e2bcd8739ae039).string().array();
var $6ae7ce06f09cd84a$export$7dfc08c51ef177a5 = (0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).string());
var $6ae7ce06f09cd84a$export$c62e7669a75c5961;
(function(MfaFactor) {
    MfaFactor["TOTP"] = "Totp";
    MfaFactor["WebAuthn"] = "WebAuthn";
    MfaFactor["BackupCode"] = "BackupCode";
})($6ae7ce06f09cd84a$export$c62e7669a75c5961 || ($6ae7ce06f09cd84a$export$c62e7669a75c5961 = {}));
var $6ae7ce06f09cd84a$export$10c80e60471dfbfa = (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($6ae7ce06f09cd84a$export$c62e7669a75c5961).array();
var $6ae7ce06f09cd84a$export$da22c5f01b0bc81;
(function(MfaPolicy) {
    MfaPolicy["UserControlled"] = "UserControlled";
    MfaPolicy["Mandatory"] = "Mandatory";
})($6ae7ce06f09cd84a$export$da22c5f01b0bc81 || ($6ae7ce06f09cd84a$export$da22c5f01b0bc81 = {}));
var $6ae7ce06f09cd84a$export$74899fc35c1207c8 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    factors: $6ae7ce06f09cd84a$export$10c80e60471dfbfa,
    policy: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($6ae7ce06f09cd84a$export$da22c5f01b0bc81)
});



var $b9e99febc780844b$export$f6585a37d5516193;
(function(SentinelActivityTargetType) {
    SentinelActivityTargetType["User"] = "User";
    SentinelActivityTargetType["App"] = "App";
})($b9e99febc780844b$export$f6585a37d5516193 || ($b9e99febc780844b$export$f6585a37d5516193 = {}));
var $b9e99febc780844b$export$47228912e855c2e6 = (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($b9e99febc780844b$export$f6585a37d5516193);
var $b9e99febc780844b$export$e4c510688679a019;
(function(SentinelActivityAction) {
    /**
     * The subject tries to pass a verification by inputting a password.
     *
     * For example, a user (subject) who inputted a password (action) to authenticate themselves
     * (target).
     */ SentinelActivityAction["Password"] = "Password";
    /**
     * The subject tries to pass a verification by inputting a verification code.
     *
     * For example, a user (subject) who inputted a verification code (action) to authenticate
     * themselves (target).
     */ SentinelActivityAction["VerificationCode"] = "VerificationCode";
})($b9e99febc780844b$export$e4c510688679a019 || ($b9e99febc780844b$export$e4c510688679a019 = {}));
var $b9e99febc780844b$export$8cdcc536cbf8daf0 = (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($b9e99febc780844b$export$e4c510688679a019);
var $b9e99febc780844b$export$ef3e193200f88c05 = (0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).unknown());








var $a35850cf4cb70722$export$dc13b60e2521b1fc;
(function(ConnectorConfigFormItemType) {
    ConnectorConfigFormItemType["Text"] = "Text";
    ConnectorConfigFormItemType["Number"] = "Number";
    ConnectorConfigFormItemType["MultilineText"] = "MultilineText";
    ConnectorConfigFormItemType["Switch"] = "Switch";
    ConnectorConfigFormItemType["Select"] = "Select";
    ConnectorConfigFormItemType["Json"] = "Json";
})($a35850cf4cb70722$export$dc13b60e2521b1fc || ($a35850cf4cb70722$export$dc13b60e2521b1fc = {}));
var $a35850cf4cb70722$var$baseConfigFormItem = {
    key: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    label: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    placeholder: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    required: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    defaultValue: (0, $a782240af38642b4$export$2e2bcd8739ae039).unknown().optional(),
    showConditions: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        targetKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        expectValue: (0, $a782240af38642b4$export$2e2bcd8739ae039).unknown().optional()
    })).optional(),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    tooltip: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    isConfidential: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
};
var $a35850cf4cb70722$export$ee34796348b9598a = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("type", [
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($a35850cf4cb70722$export$dc13b60e2521b1fc.Select),
        selectItems: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
            value: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
            title: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
        }))
    }, $a35850cf4cb70722$var$baseConfigFormItem)),
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        type: (0, $a782240af38642b4$export$2e2bcd8739ae039).enum([
            $a35850cf4cb70722$export$dc13b60e2521b1fc.Text,
            $a35850cf4cb70722$export$dc13b60e2521b1fc.Number,
            $a35850cf4cb70722$export$dc13b60e2521b1fc.MultilineText,
            $a35850cf4cb70722$export$dc13b60e2521b1fc.Switch,
            $a35850cf4cb70722$export$dc13b60e2521b1fc.Json
        ])
    }, $a35850cf4cb70722$var$baseConfigFormItem))
]);






var $049916b5b70bfb1d$export$2ecd4a627c6913d4;
(function(ConnectorErrorCodes) {
    ConnectorErrorCodes["General"] = "general";
    ConnectorErrorCodes["InvalidMetadata"] = "invalid_metadata";
    ConnectorErrorCodes["UnexpectedType"] = "unexpected_type";
    ConnectorErrorCodes["InvalidConfigGuard"] = "invalid_config_guard";
    ConnectorErrorCodes["InvalidRequestParameters"] = "invalid_request_parameters";
    ConnectorErrorCodes["InsufficientRequestParameters"] = "insufficient_request_parameters";
    ConnectorErrorCodes["InvalidConfig"] = "invalid_config";
    ConnectorErrorCodes["InvalidCertificate"] = "invalid_certificate";
    ConnectorErrorCodes["InvalidResponse"] = "invalid_response";
    /** The template is not found for the given type. */ ConnectorErrorCodes["TemplateNotFound"] = "template_not_found";
    /**
     * The template type is not supported by the connector.
     *
     * @deprecated Connector should be able to handle dynamic template type.
     */ ConnectorErrorCodes["TemplateNotSupported"] = "template_not_supported";
    ConnectorErrorCodes["RateLimitExceeded"] = "rate_limit_exceeded";
    ConnectorErrorCodes["NotImplemented"] = "not_implemented";
    ConnectorErrorCodes["SocialAuthCodeInvalid"] = "social_auth_code_invalid";
    ConnectorErrorCodes["SocialAccessTokenInvalid"] = "social_invalid_access_token";
    ConnectorErrorCodes["SocialIdTokenInvalid"] = "social_invalid_id_token";
    ConnectorErrorCodes["AuthorizationFailed"] = "authorization_failed";
})($049916b5b70bfb1d$export$2ecd4a627c6913d4 || ($049916b5b70bfb1d$export$2ecd4a627c6913d4 = {}));
var $049916b5b70bfb1d$export$1a6b62c5b97f19bd = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(ConnectorError, Error1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(ConnectorError);
    function ConnectorError(code, data) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ConnectorError);
        var _this;
        var message = "ConnectorError: ".concat(data ? JSON.stringify(data) : code);
        _this = _super.call(this, message);
        _this.code = code;
        _this.data = typeof data === "string" ? {
            message: data
        } : data;
        return _this;
    }
    return ConnectorError;
}((0, $efec3851c979cc44$export$2466d533fda16e33)(Error));





var $dfa943a5a56dac4f$export$e2b8cfc001e78efb;
(function(ConnectorPlatform) {
    ConnectorPlatform["Native"] = "Native";
    ConnectorPlatform["Universal"] = "Universal";
    ConnectorPlatform["Web"] = "Web";
})($dfa943a5a56dac4f$export$e2b8cfc001e78efb || ($dfa943a5a56dac4f$export$e2b8cfc001e78efb = {}));
var $dfa943a5a56dac4f$export$7241e9f50f26948a = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    en: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
}).and((0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).string())).refine(function(i18nObject) {
    var keys = Object.keys(i18nObject);
    if (!keys.includes("en")) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (!(0, $08b5a247edaf1be2$export$ab649249f0bfeb57)(value)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
});
var $dfa943a5a56dac4f$export$7d252e66ae683236 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    // Social connector platform. TODO: @darcyYe considering remove the nullable and make all the social connector field optional
    platform: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($dfa943a5a56dac4f$export$e2b8cfc001e78efb).nullable(),
    // Indicates custom connector that follows standard protocol. Currently supported standard connectors are OIDC, OAuth2, and SAML2
    isStandard: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
});
var $dfa943a5a56dac4f$export$f7d2da53d88c923c = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    // Unique connector factory id
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /* Connector provider. Unique for each provider. Users can have only one social identity per provider
      For Social connectors, it's manually set on connector creation
      For SSO connectors, it's the same as the issuer
    */ target: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    name: $dfa943a5a56dac4f$export$7241e9f50f26948a,
    description: $dfa943a5a56dac4f$export$7241e9f50f26948a,
    logo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    logoDark: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().nullable(),
    readme: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    configTemplate: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    formItems: (0, $a35850cf4cb70722$export$ee34796348b9598a).array().optional()
}).merge($dfa943a5a56dac4f$export$7d252e66ae683236).catchall((0, $a782240af38642b4$export$2e2bcd8739ae039).unknown());
var $dfa943a5a56dac4f$export$155cba4e58565525 = $dfa943a5a56dac4f$export$f7d2da53d88c923c.pick({
    target: true,
    name: true,
    logo: true,
    logoDark: true
}).partial();


var $c8cb0bd9e348aae8$export$18dbf40ba8d1d9db;
(function(ConnectorType) {
    ConnectorType["Email"] = "Email";
    ConnectorType["Sms"] = "Sms";
    ConnectorType["Social"] = "Social";
})($c8cb0bd9e348aae8$export$18dbf40ba8d1d9db || ($c8cb0bd9e348aae8$export$18dbf40ba8d1d9db = {}));


// MARK: SMS + Email connector

var $ffd0840d48192f90$export$849d15400f87ce3f;
(function(VerificationCodeType) {
    VerificationCodeType["SignIn"] = "SignIn";
    VerificationCodeType["Register"] = "Register";
    VerificationCodeType["ForgotPassword"] = "ForgotPassword";
    VerificationCodeType["Generic"] = "Generic";
    /** @deprecated Use `Generic` type template for sending test sms/email use case */ VerificationCodeType["Test"] = "Test";
})($ffd0840d48192f90$export$849d15400f87ce3f || ($ffd0840d48192f90$export$849d15400f87ce3f = {}));
var $ffd0840d48192f90$export$61cf650ef6de814a = (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($ffd0840d48192f90$export$849d15400f87ce3f);
var $ffd0840d48192f90$export$fd0446c06165ed92;
(function(TemplateType) {
    /** The template for sending verification code when user is signing in. */ TemplateType["SignIn"] = "SignIn";
    /** The template for sending verification code when user is registering. */ TemplateType["Register"] = "Register";
    /** The template for sending verification code when user is resetting password. */ TemplateType["ForgotPassword"] = "ForgotPassword";
    /** The template for sending organization invitation. */ TemplateType["OrganizationInvitation"] = "OrganizationInvitation";
    /** The template for generic usage. */ TemplateType["Generic"] = "Generic";
})($ffd0840d48192f90$export$fd0446c06165ed92 || ($ffd0840d48192f90$export$fd0446c06165ed92 = {}));
var $ffd0840d48192f90$export$28d17db1e2f10761 = (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($ffd0840d48192f90$export$fd0446c06165ed92);
var $ffd0840d48192f90$export$f9b3e019678b784e = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    code: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    link: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
}).and((0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).string()));
var $ffd0840d48192f90$export$51e0082496d4c1ff = /(https?:\/\/)?(?:www\.)?[\w#%+.:=@~-]{1,256}\.[\d()A-Za-z]{1,6}\b[\w#%&()+./:=?@~-]*/;
var $ffd0840d48192f90$export$21b1fc3b40375a1b = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    senderName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().refine(function(address) {
        return !$ffd0840d48192f90$export$51e0082496d4c1ff.test(address);
    }, "URL is not allowed in sender name."),
    companyInformation: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().refine(function(address) {
        return !$ffd0840d48192f90$export$51e0082496d4c1ff.test(address);
    }, "URL is not allowed in company information."),
    appLogo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().url()
}).partial();
var $ffd0840d48192f90$export$d68193cee3e4f305 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    to: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    type: $ffd0840d48192f90$export$28d17db1e2f10761.or($ffd0840d48192f90$export$61cf650ef6de814a),
    payload: $ffd0840d48192f90$export$f9b3e019678b784e
});



// Copied from https://github.com/colinhacks/zod#json-type
var $a49b7c3bf03b042d$var$literalSchema = (0, $a782240af38642b4$export$2e2bcd8739ae039).union([
    (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    (0, $a782240af38642b4$export$2e2bcd8739ae039).null()
]);
var $a49b7c3bf03b042d$export$80d8b5946da2a05e = (0, $a782240af38642b4$export$2e2bcd8739ae039).lazy(function() {
    return (0, $a782240af38642b4$export$2e2bcd8739ae039).union([
        $a49b7c3bf03b042d$var$literalSchema,
        (0, $a782240af38642b4$export$2e2bcd8739ae039).array($a49b7c3bf03b042d$export$80d8b5946da2a05e),
        (0, $a782240af38642b4$export$2e2bcd8739ae039).record($a49b7c3bf03b042d$export$80d8b5946da2a05e)
    ]);
});
var $a49b7c3bf03b042d$export$4ac62c0537cd0db7 = (0, $a782240af38642b4$export$2e2bcd8739ae039).record($a49b7c3bf03b042d$export$80d8b5946da2a05e);
var $a49b7c3bf03b042d$export$3788bacea3bf0dba = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    email: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    phone: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    avatar: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    rawData: $a49b7c3bf03b042d$export$80d8b5946da2a05e.optional()
});
var $a49b7c3bf03b042d$export$d09576a05941985c = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    nonce: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    redirectUri: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    connectorId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    connectorFactoryId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    jti: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    state: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
}).partial()// Accept arbitrary unspecified keys so developers who can not publish @logto/connector-kit can more flexibly utilize connector session.
.catchall((0, $a782240af38642b4$export$2e2bcd8739ae039).unknown());


var $b5939ba0029e9944$export$5dbd9b9b0aba9316;
(function(DemoConnector) {
    DemoConnector["Sms"] = "logto-sms";
    DemoConnector["Social"] = "logto-social-demo";
})($b5939ba0029e9944$export$5dbd9b9b0aba9316 || ($b5939ba0029e9944$export$5dbd9b9b0aba9316 = {}));
var $b5939ba0029e9944$export$a1fe89342af5f2bc = Object.freeze([
    $b5939ba0029e9944$export$5dbd9b9b0aba9316.Sms,
    $b5939ba0029e9944$export$5dbd9b9b0aba9316.Social
]);
var $b5939ba0029e9944$export$59c1b079c431ef40;
(function(ServiceConnector) {
    ServiceConnector["Email"] = "logto-email";
})($b5939ba0029e9944$export$59c1b079c431ef40 || ($b5939ba0029e9944$export$59c1b079c431ef40 = {}));
var $b5939ba0029e9944$export$4a0935744d2041a0 = Object.freeze([
    $b5939ba0029e9944$export$59c1b079c431ef40.Email
]);


function $356ee7c320d66a7a$export$127f9a442b42d18(config, guard) {
    var result = guard.safeParse(config);
    if (!result.success) throw new (0, $049916b5b70bfb1d$export$1a6b62c5b97f19bd)((0, $049916b5b70bfb1d$export$2ecd4a627c6913d4).InvalidConfig, result.error);
}
var $356ee7c320d66a7a$export$18c43dcebf00e571 = function(jsonString) {
    var errorCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $049916b5b70bfb1d$export$2ecd4a627c6913d4).InvalidResponse, errorPayload = arguments.length > 2 ? arguments[2] : void 0;
    try {
        return (0, $a49b7c3bf03b042d$export$80d8b5946da2a05e).parse(JSON.parse(jsonString));
    } catch (e) {
        throw new (0, $049916b5b70bfb1d$export$1a6b62c5b97f19bd)(errorCode, errorPayload !== null && errorPayload !== void 0 ? errorPayload : jsonString);
    }
};
var $356ee7c320d66a7a$export$7b9340ca5373286 = function() {
    for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
        _tmp[_key] = arguments[_key];
    }
    var _tmp1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_tmp, 3), jsonString = _tmp1[0], tmp = _tmp1[1], errorCode = tmp === void 0 ? (0, $049916b5b70bfb1d$export$2ecd4a627c6913d4).InvalidResponse : tmp, errorPayload = _tmp1[2];
    try {
        return (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).parse(JSON.parse(jsonString));
    } catch (e) {
        throw new (0, $049916b5b70bfb1d$export$1a6b62c5b97f19bd)(errorCode, errorPayload !== null && errorPayload !== void 0 ? errorPayload : jsonString);
    }
};
var $356ee7c320d66a7a$export$4fe65911a1cf396d = "logto_mock_verification_code_record.txt";
var $356ee7c320d66a7a$var$_obj;
var $356ee7c320d66a7a$export$139964ce187c5e2 = Object.freeze(($356ee7c320d66a7a$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($356ee7c320d66a7a$var$_obj, (0, $c8cb0bd9e348aae8$export$18dbf40ba8d1d9db).Sms, "/tmp/logto_mock_sms_record.txt"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($356ee7c320d66a7a$var$_obj, (0, $c8cb0bd9e348aae8$export$18dbf40ba8d1d9db).Email, "/tmp/logto_mock_email_record.txt"), $356ee7c320d66a7a$var$_obj));
var $356ee7c320d66a7a$export$24f9fc31d5505892 = function(template, payload) {
    var _payload_key;
    return Object.keys(payload).reduce(function(accumulator, key) {
        return accumulator.replaceAll(new RegExp("{{\\s*".concat(key, "\\s*}}"), "g"), (_payload_key = payload[key]) !== null && _payload_key !== void 0 ? _payload_key : "");
    }, template);
};




var $f593db28d49f5079$export$755522cf8b35e50 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    familyName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    givenName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    middleName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    nickname: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    preferredUsername: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    profile: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    website: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    gender: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    birthdate: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    zoneinfo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    locale: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    address: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        formatted: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        streetAddress: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        locality: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        region: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        postalCode: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        country: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
    }).partial()
}).partial();
var $f593db28d49f5079$export$572b146f6bc88040 = Object.freeze($f593db28d49f5079$export$755522cf8b35e50.keyof().options);
var $f593db28d49f5079$export$5b0e1cc5f5293c3b = (0, $a782240af38642b4$export$2e2bcd8739ae039).string().array();
var $f593db28d49f5079$export$4d846b5d465d17a5 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    details: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional()
});
var $f593db28d49f5079$export$9240af6bda06dde7 = (0, $a782240af38642b4$export$2e2bcd8739ae039).record($f593db28d49f5079$export$4d846b5d465d17a5);
var $f593db28d49f5079$export$45938720c8cd17da = {
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    lastUsedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
};
var $f593db28d49f5079$export$247de21853358ba3 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP)
}, $f593db28d49f5079$export$45938720c8cd17da), {
    key: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
}));
var $f593db28d49f5079$export$aa941865a0228ea6 = (0, $a782240af38642b4$export$2e2bcd8739ae039).enum([
    "usb",
    "nfc",
    "ble",
    "internal",
    "cable",
    "hybrid",
    "smart-card"
]);
var $f593db28d49f5079$export$d887df993511916c = (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn)
}, $f593db28d49f5079$export$45938720c8cd17da), {
    credentialId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    publicKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    transports: $f593db28d49f5079$export$aa941865a0228ea6.array().optional(),
    counter: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    agent: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
}));
var $f593db28d49f5079$export$b31bbb972ba29c41 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode)
}, $f593db28d49f5079$export$45938720c8cd17da), {
    codes: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        code: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        usedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
    }).array()
}));
var $f593db28d49f5079$export$e0149a7d7403659d = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $f593db28d49f5079$export$247de21853358ba3,
    $f593db28d49f5079$export$d887df993511916c,
    $f593db28d49f5079$export$b31bbb972ba29c41
]);
var $f593db28d49f5079$export$cd58e15effbd05b2 = $f593db28d49f5079$export$e0149a7d7403659d.array();



var $2162809728c8d1e3$export$d7a665f9067dd8f8 = (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).string());
var $2162809728c8d1e3$export$363bdce991737de = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    displayName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    logo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    darkLogo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
});




var $e24ee1bc71a21d60$export$7cbc7e52a66572d6 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    /* The domain name, e.g app.example.com */ domain: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /* The status of the domain in Cloudflare */ status: (0, $78a5beb0029c3750$export$fda7fbe88a5ffb61),
    /* The error message if any */ errorMessage: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().nullable(),
    /* The DNS records of the domain */ dnsRecords: (0, $78a5beb0029c3750$export$ab6045338fa7d71b),
    /* The remote Cloudflare data */ cloudflareData: (0, $78a5beb0029c3750$export$10762083065a1f71).nullable()
});
var $e24ee1bc71a21d60$export$dea254f43799108e = (0, $a782240af38642b4$export$2e2bcd8739ae039).array($e24ee1bc71a21d60$export$7cbc7e52a66572d6);
var $e24ee1bc71a21d60$export$f7af996b28fe8992 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    /* The host of the site */ host: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /* The origin of the site */ origin: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /* Session duration in seconds */ sessionDuration: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    pageRules: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        /* The path pattern (regex) to match */ path: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
    })),
    /* Custom domain */ customDomains: $e24ee1bc71a21d60$export$dea254f43799108e.optional()
});







// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
var $0adae18f63600c2d$export$d16f8fdf0c548b68;
(function(ApplicationType) {
    ApplicationType["Native"] = "Native";
    ApplicationType["SPA"] = "SPA";
    ApplicationType["Traditional"] = "Traditional";
    ApplicationType["MachineToMachine"] = "MachineToMachine";
    ApplicationType["Protected"] = "Protected";
})($0adae18f63600c2d$export$d16f8fdf0c548b68 || ($0adae18f63600c2d$export$d16f8fdf0c548b68 = {}));
var $0adae18f63600c2d$export$3ac4f2bb1c3a6ab6;
(function(OrganizationInvitationStatus) {
    OrganizationInvitationStatus["Pending"] = "Pending";
    OrganizationInvitationStatus["Accepted"] = "Accepted";
    OrganizationInvitationStatus["Expired"] = "Expired";
    OrganizationInvitationStatus["Revoked"] = "Revoked";
})($0adae18f63600c2d$export$3ac4f2bb1c3a6ab6 || ($0adae18f63600c2d$export$3ac4f2bb1c3a6ab6 = {}));
var $0adae18f63600c2d$export$e57c3ccf0ca02b45;
(function(RoleType) {
    RoleType["User"] = "User";
    RoleType["MachineToMachine"] = "MachineToMachine";
})($0adae18f63600c2d$export$e57c3ccf0ca02b45 || ($0adae18f63600c2d$export$e57c3ccf0ca02b45 = {}));
var $0adae18f63600c2d$export$dc6c7df092741a48;
(function(SentinelActionResult) {
    SentinelActionResult["Success"] = "Success";
    SentinelActionResult["Failed"] = "Failed";
})($0adae18f63600c2d$export$dc6c7df092741a48 || ($0adae18f63600c2d$export$dc6c7df092741a48 = {}));
var $0adae18f63600c2d$export$418d76209f25e60e;
(function(SentinelDecision) {
    SentinelDecision["Undecided"] = "Undecided";
    SentinelDecision["Allowed"] = "Allowed";
    SentinelDecision["Blocked"] = "Blocked";
    SentinelDecision["Challenge"] = "Challenge";
})($0adae18f63600c2d$export$418d76209f25e60e || ($0adae18f63600c2d$export$418d76209f25e60e = {}));
var $0adae18f63600c2d$export$f927bbb3d448dc2b;
(function(SignInMode) {
    SignInMode["SignIn"] = "SignIn";
    SignInMode["Register"] = "Register";
    SignInMode["SignInAndRegister"] = "SignInAndRegister";
})($0adae18f63600c2d$export$f927bbb3d448dc2b || ($0adae18f63600c2d$export$f927bbb3d448dc2b = {}));
var $0adae18f63600c2d$export$b3dbe23797267513;
(function(UsersPasswordEncryptionMethod) {
    UsersPasswordEncryptionMethod["Argon2i"] = "Argon2i";
    UsersPasswordEncryptionMethod["SHA1"] = "SHA1";
    UsersPasswordEncryptionMethod["SHA256"] = "SHA256";
    UsersPasswordEncryptionMethod["MD5"] = "MD5";
    UsersPasswordEncryptionMethod["Bcrypt"] = "Bcrypt";
})($0adae18f63600c2d$export$b3dbe23797267513 || ($0adae18f63600c2d$export$b3dbe23797267513 = {}));


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $adaf29a8bb1a8dbc$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    branding: (0, $6ae7ce06f09cd84a$export$c9d0acdc98ac45b).optional(),
    termsOfUseUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    privacyPolicyUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    displayName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(256).nullable().optional()
});
var $adaf29a8bb1a8dbc$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    branding: (0, $6ae7ce06f09cd84a$export$c9d0acdc98ac45b),
    termsOfUseUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable(),
    privacyPolicyUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable(),
    displayName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(256).nullable()
});
var $adaf29a8bb1a8dbc$export$b21e17c60fe7d89c = Object.freeze({
    table: "application_sign_in_experiences",
    tableSingular: "application_sign_in_experience",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        branding: "branding",
        termsOfUseUrl: "terms_of_use_url",
        privacyPolicyUrl: "privacy_policy_url",
        displayName: "display_name"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "branding",
        "termsOfUseUrl",
        "privacyPolicyUrl",
        "displayName"
    ],
    createGuard: $adaf29a8bb1a8dbc$var$createGuard,
    guard: $adaf29a8bb1a8dbc$var$guard,
    updateGuard: $adaf29a8bb1a8dbc$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $ee7dc1320002ae1d$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $ee7dc1320002ae1d$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $ee7dc1320002ae1d$export$e949b56fbcc38220 = Object.freeze({
    table: "application_user_consent_organization_resource_scopes",
    tableSingular: "application_user_consent_organization_resource_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "scopeId"
    ],
    createGuard: $ee7dc1320002ae1d$var$createGuard,
    guard: $ee7dc1320002ae1d$var$guard,
    updateGuard: $ee7dc1320002ae1d$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $f541001d29a0d776$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationScopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $f541001d29a0d776$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationScopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $f541001d29a0d776$export$cc7d7eb8b2d4c88f = Object.freeze({
    table: "application_user_consent_organization_scopes",
    tableSingular: "application_user_consent_organization_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        organizationScopeId: "organization_scope_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "organizationScopeId"
    ],
    createGuard: $f541001d29a0d776$var$createGuard,
    guard: $f541001d29a0d776$var$guard,
    updateGuard: $f541001d29a0d776$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $60cef9031b828a15$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $60cef9031b828a15$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $60cef9031b828a15$export$1477f056ed289a93 = Object.freeze({
    table: "application_user_consent_organizations",
    tableSingular: "application_user_consent_organization",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        organizationId: "organization_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "organizationId",
        "userId"
    ],
    createGuard: $60cef9031b828a15$var$createGuard,
    guard: $60cef9031b828a15$var$guard,
    updateGuard: $60cef9031b828a15$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $f8c164d38efcf9b4$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $f8c164d38efcf9b4$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $f8c164d38efcf9b4$export$5961a9d1caf5eb5f = Object.freeze({
    table: "application_user_consent_resource_scopes",
    tableSingular: "application_user_consent_resource_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "scopeId"
    ],
    createGuard: $f8c164d38efcf9b4$var$createGuard,
    guard: $f8c164d38efcf9b4$var$guard,
    updateGuard: $f8c164d38efcf9b4$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $873f95ec1b9188f5$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userScope: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64)
});
var $873f95ec1b9188f5$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userScope: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64)
});
var $873f95ec1b9188f5$export$23c1519812ac7ae7 = Object.freeze({
    table: "application_user_consent_user_scopes",
    tableSingular: "application_user_consent_user_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        userScope: "user_scope"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "userScope"
    ],
    createGuard: $873f95ec1b9188f5$var$createGuard,
    guard: $873f95ec1b9188f5$var$guard,
    updateGuard: $873f95ec1b9188f5$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.



var $16d3653139bc1b0b$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    secret: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().nullable().optional(),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$d16f8fdf0c548b68)),
    oidcClientMetadata: (0, $f875485805d06c56$export$2b5eeb3c40bff26b),
    customClientMetadata: (0, $f875485805d06c56$export$44618fabe8266610).optional(),
    protectedAppMetadata: (0, $e24ee1bc71a21d60$export$f7af996b28fe8992).nullable().optional(),
    isThirdParty: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $16d3653139bc1b0b$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    secret: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().nullable(),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$d16f8fdf0c548b68)),
    oidcClientMetadata: (0, $f875485805d06c56$export$2b5eeb3c40bff26b),
    customClientMetadata: (0, $f875485805d06c56$export$44618fabe8266610),
    protectedAppMetadata: (0, $e24ee1bc71a21d60$export$f7af996b28fe8992).nullable(),
    isThirdParty: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $16d3653139bc1b0b$export$73c91b53927e421e = Object.freeze({
    table: "applications",
    tableSingular: "application",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        secret: "secret",
        description: "description",
        type: "type",
        oidcClientMetadata: "oidc_client_metadata",
        customClientMetadata: "custom_client_metadata",
        protectedAppMetadata: "protected_app_metadata",
        isThirdParty: "is_third_party",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "secret",
        "description",
        "type",
        "oidcClientMetadata",
        "customClientMetadata",
        "protectedAppMetadata",
        "isThirdParty",
        "createdAt"
    ],
    createGuard: $16d3653139bc1b0b$var$createGuard,
    guard: $16d3653139bc1b0b$var$guard,
    updateGuard: $16d3653139bc1b0b$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $e4729f2eaaf0d803$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $e4729f2eaaf0d803$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $e4729f2eaaf0d803$export$9e9228a1487950f9 = Object.freeze({
    table: "applications_roles",
    tableSingular: "applications_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        applicationId: "application_id",
        roleId: "role_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "applicationId",
        "roleId"
    ],
    createGuard: $e4729f2eaaf0d803$var$createGuard,
    guard: $e4729f2eaaf0d803$var$guard,
    updateGuard: $e4729f2eaaf0d803$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $b8235cc44a26de0a$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    syncProfile: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    connectorId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    config: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional(),
    metadata: (0, $dfa943a5a56dac4f$export$155cba4e58565525).optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $b8235cc44a26de0a$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    syncProfile: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    connectorId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    config: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7),
    metadata: (0, $dfa943a5a56dac4f$export$155cba4e58565525),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $b8235cc44a26de0a$export$87ce1179d2402b5a = Object.freeze({
    table: "connectors",
    tableSingular: "connector",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        syncProfile: "sync_profile",
        connectorId: "connector_id",
        config: "config",
        metadata: "metadata",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "syncProfile",
        "connectorId",
        "config",
        "metadata",
        "createdAt"
    ],
    createGuard: $b8235cc44a26de0a$var$createGuard,
    guard: $b8235cc44a26de0a$var$guard,
    updateGuard: $b8235cc44a26de0a$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $271373cddc72e034$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    languageTag: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(16),
    translation: (0, $80fb3a0089879da8$export$aea1b2a91583fcef)
});
var $271373cddc72e034$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    languageTag: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(16),
    translation: (0, $80fb3a0089879da8$export$aea1b2a91583fcef)
});
var $271373cddc72e034$export$68f045a468761c0e = Object.freeze({
    table: "custom_phrases",
    tableSingular: "custom_phrase",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        languageTag: "language_tag",
        translation: "translation"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "languageTag",
        "translation"
    ],
    createGuard: $271373cddc72e034$var$createGuard,
    guard: $271373cddc72e034$var$guard,
    updateGuard: $271373cddc72e034$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $420b406a42078cc5$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    date: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $420b406a42078cc5$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    date: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $420b406a42078cc5$export$d153bb698683b0a7 = Object.freeze({
    table: "daily_active_users",
    tableSingular: "daily_active_user",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        userId: "user_id",
        date: "date"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "userId",
        "date"
    ],
    createGuard: $420b406a42078cc5$var$createGuard,
    guard: $420b406a42078cc5$var$guard,
    updateGuard: $420b406a42078cc5$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $be62608e3a1bf5af$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    usage: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    date: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $be62608e3a1bf5af$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    usage: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    date: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $be62608e3a1bf5af$export$46dadcefc3469961 = Object.freeze({
    table: "daily_token_usage",
    tableSingular: "daily_token_usage",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        usage: "usage",
        date: "date"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "usage",
        "date"
    ],
    createGuard: $be62608e3a1bf5af$var$createGuard,
    guard: $be62608e3a1bf5af$var$guard,
    updateGuard: $be62608e3a1bf5af$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $33ea7b655cd1e93f$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    domain: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    status: (0, $78a5beb0029c3750$export$fda7fbe88a5ffb61).optional(),
    errorMessage: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(1024).nullable().optional(),
    dnsRecords: (0, $78a5beb0029c3750$export$ab6045338fa7d71b).optional(),
    cloudflareData: (0, $78a5beb0029c3750$export$10762083065a1f71).nullable().optional(),
    updatedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $33ea7b655cd1e93f$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    domain: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    status: (0, $78a5beb0029c3750$export$fda7fbe88a5ffb61),
    errorMessage: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(1024).nullable(),
    dnsRecords: (0, $78a5beb0029c3750$export$ab6045338fa7d71b),
    cloudflareData: (0, $78a5beb0029c3750$export$10762083065a1f71).nullable(),
    updatedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $33ea7b655cd1e93f$export$e3e9d7fdf7b67caa = Object.freeze({
    table: "domains",
    tableSingular: "domain",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        domain: "domain",
        status: "status",
        errorMessage: "error_message",
        dnsRecords: "dns_records",
        cloudflareData: "cloudflare_data",
        updatedAt: "updated_at",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "domain",
        "status",
        "errorMessage",
        "dnsRecords",
        "cloudflareData",
        "updatedAt",
        "createdAt"
    ],
    createGuard: $33ea7b655cd1e93f$var$createGuard,
    guard: $33ea7b655cd1e93f$var$guard,
    updateGuard: $33ea7b655cd1e93f$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $f1e4867eaafd4781$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256).optional(),
    event: (0, $227a41d6a40c4b57$export$2d2b15eb4f8d4fc9).nullable().optional(),
    events: (0, $227a41d6a40c4b57$export$56e77a150fce61b).optional(),
    config: (0, $227a41d6a40c4b57$export$924993b6fcd8d738),
    signingKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64).optional(),
    enabled: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $f1e4867eaafd4781$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(256),
    event: (0, $227a41d6a40c4b57$export$2d2b15eb4f8d4fc9).nullable(),
    events: (0, $227a41d6a40c4b57$export$56e77a150fce61b),
    config: (0, $227a41d6a40c4b57$export$924993b6fcd8d738),
    signingKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(64),
    enabled: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $f1e4867eaafd4781$export$5fbefe39e79899a6 = Object.freeze({
    table: "hooks",
    tableSingular: "hook",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        event: "event",
        events: "events",
        config: "config",
        signingKey: "signing_key",
        enabled: "enabled",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "event",
        "events",
        "config",
        "signingKey",
        "enabled",
        "createdAt"
    ],
    createGuard: $f1e4867eaafd4781$var$createGuard,
    guard: $f1e4867eaafd4781$var$guard,
    updateGuard: $f1e4867eaafd4781$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $1533fb374c4bb241$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    key: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    payload: (0, $af3185488ed4f70a$export$2938cb1ca9b4e331).optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $1533fb374c4bb241$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    key: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    payload: (0, $af3185488ed4f70a$export$2938cb1ca9b4e331),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $1533fb374c4bb241$export$55c65d61db3da5ca = Object.freeze({
    table: "logs",
    tableSingular: "log",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        key: "key",
        payload: "payload",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "key",
        "payload",
        "createdAt"
    ],
    createGuard: $1533fb374c4bb241$var$createGuard,
    guard: $1533fb374c4bb241$var$guard,
    updateGuard: $1533fb374c4bb241$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $aa3356692b641509$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    key: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    value: (0, $a49b7c3bf03b042d$export$80d8b5946da2a05e).optional()
});
var $aa3356692b641509$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    key: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    value: (0, $a49b7c3bf03b042d$export$80d8b5946da2a05e)
});
var $aa3356692b641509$export$d95c9c1f4b55e315 = Object.freeze({
    table: "logto_configs",
    tableSingular: "logto_config",
    fields: {
        tenantId: "tenant_id",
        key: "key",
        value: "value"
    },
    fieldKeys: [
        "tenantId",
        "key",
        "value"
    ],
    createGuard: $aa3356692b641509$var$createGuard,
    guard: $aa3356692b641509$var$guard,
    updateGuard: $aa3356692b641509$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $729114e77a0d08fa$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    modelName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    payload: (0, $f875485805d06c56$export$525df20e0fb1714c),
    expiresAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    consumedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().nullable().optional()
});
var $729114e77a0d08fa$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    modelName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    payload: (0, $f875485805d06c56$export$525df20e0fb1714c),
    expiresAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    consumedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().nullable()
});
var $729114e77a0d08fa$export$4825f32a2bacdbff = Object.freeze({
    table: "oidc_model_instances",
    tableSingular: "oidc_model_instance",
    fields: {
        tenantId: "tenant_id",
        modelName: "model_name",
        id: "id",
        payload: "payload",
        expiresAt: "expires_at",
        consumedAt: "consumed_at"
    },
    fieldKeys: [
        "tenantId",
        "modelName",
        "id",
        "payload",
        "expiresAt",
        "consumedAt"
    ],
    createGuard: $729114e77a0d08fa$var$createGuard,
    guard: $729114e77a0d08fa$var$guard,
    updateGuard: $729114e77a0d08fa$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $f10326453ae1a5dc$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationInvitationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationRoleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $f10326453ae1a5dc$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    organizationInvitationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationRoleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $f10326453ae1a5dc$export$fc376a4cb789d28e = Object.freeze({
    table: "organization_invitation_role_relations",
    tableSingular: "organization_invitation_role_relation",
    fields: {
        tenantId: "tenant_id",
        organizationInvitationId: "organization_invitation_id",
        organizationRoleId: "organization_role_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationInvitationId",
        "organizationRoleId"
    ],
    createGuard: $f10326453ae1a5dc$var$createGuard,
    guard: $f10326453ae1a5dc$var$guard,
    updateGuard: $f10326453ae1a5dc$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $2d7bc4e2517ba976$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    inviterId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).nullable().optional(),
    invitee: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    acceptedUserId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).nullable().optional(),
    organizationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    status: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$3ac4f2bb1c3a6ab6)),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    updatedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    expiresAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $2d7bc4e2517ba976$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    inviterId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).nullable(),
    invitee: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    acceptedUserId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).nullable(),
    organizationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    status: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$3ac4f2bb1c3a6ab6)),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    updatedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    expiresAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $2d7bc4e2517ba976$export$63fd293d5536b534 = Object.freeze({
    table: "organization_invitations",
    tableSingular: "organization_invitation",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        inviterId: "inviter_id",
        invitee: "invitee",
        acceptedUserId: "accepted_user_id",
        organizationId: "organization_id",
        status: "status",
        createdAt: "created_at",
        updatedAt: "updated_at",
        expiresAt: "expires_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "inviterId",
        "invitee",
        "acceptedUserId",
        "organizationId",
        "status",
        "createdAt",
        "updatedAt",
        "expiresAt"
    ],
    createGuard: $2d7bc4e2517ba976$var$createGuard,
    guard: $2d7bc4e2517ba976$var$guard,
    updateGuard: $2d7bc4e2517ba976$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $17998cb1210bbb05$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationRoleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $17998cb1210bbb05$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    organizationRoleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $17998cb1210bbb05$export$7d2c2ca29d23087b = Object.freeze({
    table: "organization_role_resource_scope_relations",
    tableSingular: "organization_role_resource_scope_relation",
    fields: {
        tenantId: "tenant_id",
        organizationRoleId: "organization_role_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationRoleId",
        "scopeId"
    ],
    createGuard: $17998cb1210bbb05$var$createGuard,
    guard: $17998cb1210bbb05$var$guard,
    updateGuard: $17998cb1210bbb05$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $568bc76f320ebd25$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationRoleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationScopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $568bc76f320ebd25$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    organizationRoleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationScopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $568bc76f320ebd25$export$3c85c8a4a8d43867 = Object.freeze({
    table: "organization_role_scope_relations",
    tableSingular: "organization_role_scope_relation",
    fields: {
        tenantId: "tenant_id",
        organizationRoleId: "organization_role_id",
        organizationScopeId: "organization_scope_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationRoleId",
        "organizationScopeId"
    ],
    createGuard: $568bc76f320ebd25$var$createGuard,
    guard: $568bc76f320ebd25$var$guard,
    updateGuard: $568bc76f320ebd25$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $e5e82b6376e8f6d2$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationRoleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $e5e82b6376e8f6d2$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    organizationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationRoleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $e5e82b6376e8f6d2$export$92d9ab4d1ade1798 = Object.freeze({
    table: "organization_role_user_relations",
    tableSingular: "organization_role_user_relation",
    fields: {
        tenantId: "tenant_id",
        organizationId: "organization_id",
        organizationRoleId: "organization_role_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationId",
        "organizationRoleId",
        "userId"
    ],
    createGuard: $e5e82b6376e8f6d2$var$createGuard,
    guard: $e5e82b6376e8f6d2$var$guard,
    updateGuard: $e5e82b6376e8f6d2$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $1703009f52b0bf4d$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(256).nullable().optional()
});
var $1703009f52b0bf4d$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(256).nullable()
});
var $1703009f52b0bf4d$export$29f120f254b547e7 = Object.freeze({
    table: "organization_roles",
    tableSingular: "organization_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description"
    ],
    createGuard: $1703009f52b0bf4d$var$createGuard,
    guard: $1703009f52b0bf4d$var$guard,
    updateGuard: $1703009f52b0bf4d$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $6045b5c754440d63$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(256).nullable().optional()
});
var $6045b5c754440d63$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(256).nullable()
});
var $6045b5c754440d63$export$9d110f69f69dde7a = Object.freeze({
    table: "organization_scopes",
    tableSingular: "organization_scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description"
    ],
    createGuard: $6045b5c754440d63$var$createGuard,
    guard: $6045b5c754440d63$var$guard,
    updateGuard: $6045b5c754440d63$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $d41d5e8b7b873850$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $d41d5e8b7b873850$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    organizationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $d41d5e8b7b873850$export$cd9bcab5c5506817 = Object.freeze({
    table: "organization_user_relations",
    tableSingular: "organization_user_relation",
    fields: {
        tenantId: "tenant_id",
        organizationId: "organization_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationId",
        "userId"
    ],
    createGuard: $d41d5e8b7b873850$var$createGuard,
    guard: $d41d5e8b7b873850$var$guard,
    updateGuard: $d41d5e8b7b873850$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $f468964a1c639efd$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(256).nullable().optional(),
    customData: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $f468964a1c639efd$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(256).nullable(),
    customData: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $f468964a1c639efd$export$8cdb1b004e612f6c = Object.freeze({
    table: "organizations",
    tableSingular: "organization",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description",
        customData: "custom_data",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description",
        "customData",
        "createdAt"
    ],
    createGuard: $f468964a1c639efd$var$createGuard,
    guard: $f468964a1c639efd$var$guard,
    updateGuard: $f468964a1c639efd$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $35c67cdc80c581a7$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    interactionJti: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    phone: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(32).nullable().optional(),
    email: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(32),
    code: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(6),
    consumed: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    tryCount: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $35c67cdc80c581a7$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    interactionJti: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable(),
    phone: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(32).nullable(),
    email: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable(),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(32),
    code: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(6),
    consumed: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    tryCount: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $35c67cdc80c581a7$export$9bbf548a87a223fc = Object.freeze({
    table: "passcodes",
    tableSingular: "passcode",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        interactionJti: "interaction_jti",
        phone: "phone",
        email: "email",
        type: "type",
        code: "code",
        consumed: "consumed",
        tryCount: "try_count",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "interactionJti",
        "phone",
        "email",
        "type",
        "code",
        "consumed",
        "tryCount",
        "createdAt"
    ],
    createGuard: $35c67cdc80c581a7$var$createGuard,
    guard: $35c67cdc80c581a7$var$guard,
    updateGuard: $35c67cdc80c581a7$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $edc356f6da4e3bc2$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1),
    indicator: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1),
    isDefault: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    accessTokenTtl: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $edc356f6da4e3bc2$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1),
    indicator: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1),
    isDefault: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    accessTokenTtl: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $edc356f6da4e3bc2$export$e9a269813a6315a4 = Object.freeze({
    table: "resources",
    tableSingular: "resource",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        indicator: "indicator",
        isDefault: "is_default",
        accessTokenTtl: "access_token_ttl"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "indicator",
        "isDefault",
        "accessTokenTtl"
    ],
    createGuard: $edc356f6da4e3bc2$var$createGuard,
    guard: $edc356f6da4e3bc2$var$guard,
    updateGuard: $edc356f6da4e3bc2$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $c6e599dde6f7387b$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$e57c3ccf0ca02b45)).optional(),
    isDefault: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
});
var $c6e599dde6f7387b$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$e57c3ccf0ca02b45)),
    isDefault: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean()
});
var $c6e599dde6f7387b$export$d1d9e451800db729 = Object.freeze({
    table: "roles",
    tableSingular: "role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description",
        type: "type",
        isDefault: "is_default"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description",
        "type",
        "isDefault"
    ],
    createGuard: $c6e599dde6f7387b$var$createGuard,
    guard: $c6e599dde6f7387b$var$guard,
    updateGuard: $c6e599dde6f7387b$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $ebe20ae42224b547$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $ebe20ae42224b547$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $ebe20ae42224b547$export$a3e241bf0004129f = Object.freeze({
    table: "roles_scopes",
    tableSingular: "roles_scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        roleId: "role_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "roleId",
        "scopeId"
    ],
    createGuard: $ebe20ae42224b547$var$createGuard,
    guard: $ebe20ae42224b547$var$guard,
    updateGuard: $ebe20ae42224b547$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $05fb2d7675e38772$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    resourceId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().nullable().optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $05fb2d7675e38772$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    resourceId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().nullable(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $05fb2d7675e38772$export$8546186883d6ff3e = Object.freeze({
    table: "scopes",
    tableSingular: "scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        resourceId: "resource_id",
        name: "name",
        description: "description",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "resourceId",
        "name",
        "description",
        "createdAt"
    ],
    createGuard: $05fb2d7675e38772$var$createGuard,
    guard: $05fb2d7675e38772$var$guard,
    updateGuard: $05fb2d7675e38772$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.



var $d8096be7218b7415$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    targetType: (0, $b9e99febc780844b$export$47228912e855c2e6),
    targetHash: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64),
    action: (0, $b9e99febc780844b$export$8cdcc536cbf8daf0),
    actionResult: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$dc6c7df092741a48)),
    payload: (0, $b9e99febc780844b$export$ef3e193200f88c05),
    decision: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$418d76209f25e60e)),
    decisionExpiresAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $d8096be7218b7415$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    targetType: (0, $b9e99febc780844b$export$47228912e855c2e6),
    targetHash: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64),
    action: (0, $b9e99febc780844b$export$8cdcc536cbf8daf0),
    actionResult: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$dc6c7df092741a48)),
    payload: (0, $b9e99febc780844b$export$ef3e193200f88c05),
    decision: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$418d76209f25e60e)),
    decisionExpiresAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $d8096be7218b7415$export$ac14f56217b6b757 = Object.freeze({
    table: "sentinel_activities",
    tableSingular: "sentinel_activity",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        targetType: "target_type",
        targetHash: "target_hash",
        action: "action",
        actionResult: "action_result",
        payload: "payload",
        decision: "decision",
        decisionExpiresAt: "decision_expires_at",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "targetType",
        "targetHash",
        "action",
        "actionResult",
        "payload",
        "decision",
        "decisionExpiresAt",
        "createdAt"
    ],
    createGuard: $d8096be7218b7415$var$createGuard,
    guard: $d8096be7218b7415$var$guard,
    updateGuard: $d8096be7218b7415$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $88901421ab7d5178$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64),
    payload: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $88901421ab7d5178$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(64),
    payload: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $88901421ab7d5178$export$22ef66d3c161d6a7 = Object.freeze({
    table: "service_logs",
    tableSingular: "service_log",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        type: "type",
        payload: "payload",
        createdAt: "created_at"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "type",
        "payload",
        "createdAt"
    ],
    createGuard: $88901421ab7d5178$var$createGuard,
    guard: $88901421ab7d5178$var$guard,
    updateGuard: $88901421ab7d5178$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.



var $48933eb76d257af3$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    color: (0, $6ae7ce06f09cd84a$export$5c91807cab7a8dc1),
    branding: (0, $6ae7ce06f09cd84a$export$c9d0acdc98ac45b),
    languageInfo: (0, $6ae7ce06f09cd84a$export$b8fe26243f8b3b37),
    termsOfUseUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    privacyPolicyUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    signIn: (0, $6ae7ce06f09cd84a$export$8665c7c0edac5e7a),
    signUp: (0, $6ae7ce06f09cd84a$export$fd48acc070c38d7b),
    socialSignInConnectorTargets: (0, $6ae7ce06f09cd84a$export$276d424b39387296).optional(),
    signInMode: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$f927bbb3d448dc2b)).optional(),
    customCss: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().nullable().optional(),
    customContent: (0, $6ae7ce06f09cd84a$export$7dfc08c51ef177a5).optional(),
    passwordPolicy: (0, $af3185488ed4f70a$export$eee4f836f95656a7).optional(),
    mfa: (0, $6ae7ce06f09cd84a$export$74899fc35c1207c8).optional(),
    singleSignOnEnabled: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
});
var $48933eb76d257af3$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    color: (0, $6ae7ce06f09cd84a$export$5c91807cab7a8dc1),
    branding: (0, $6ae7ce06f09cd84a$export$c9d0acdc98ac45b),
    languageInfo: (0, $6ae7ce06f09cd84a$export$b8fe26243f8b3b37),
    termsOfUseUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable(),
    privacyPolicyUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable(),
    signIn: (0, $6ae7ce06f09cd84a$export$8665c7c0edac5e7a),
    signUp: (0, $6ae7ce06f09cd84a$export$fd48acc070c38d7b),
    socialSignInConnectorTargets: (0, $6ae7ce06f09cd84a$export$276d424b39387296),
    signInMode: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$f927bbb3d448dc2b)),
    customCss: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().nullable(),
    customContent: (0, $6ae7ce06f09cd84a$export$7dfc08c51ef177a5),
    passwordPolicy: (0, $af3185488ed4f70a$export$eee4f836f95656a7),
    mfa: (0, $6ae7ce06f09cd84a$export$74899fc35c1207c8),
    singleSignOnEnabled: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean()
});
var $48933eb76d257af3$export$761297ae014f2673 = Object.freeze({
    table: "sign_in_experiences",
    tableSingular: "sign_in_experience",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        color: "color",
        branding: "branding",
        languageInfo: "language_info",
        termsOfUseUrl: "terms_of_use_url",
        privacyPolicyUrl: "privacy_policy_url",
        signIn: "sign_in",
        signUp: "sign_up",
        socialSignInConnectorTargets: "social_sign_in_connector_targets",
        signInMode: "sign_in_mode",
        customCss: "custom_css",
        customContent: "custom_content",
        passwordPolicy: "password_policy",
        mfa: "mfa",
        singleSignOnEnabled: "single_sign_on_enabled"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "color",
        "branding",
        "languageInfo",
        "termsOfUseUrl",
        "privacyPolicyUrl",
        "signIn",
        "signUp",
        "socialSignInConnectorTargets",
        "signInMode",
        "customCss",
        "customContent",
        "passwordPolicy",
        "mfa",
        "singleSignOnEnabled"
    ],
    createGuard: $48933eb76d257af3$var$createGuard,
    guard: $48933eb76d257af3$var$guard,
    updateGuard: $48933eb76d257af3$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $8e9f8febefb85a11$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    providerName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    connectorName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    config: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional(),
    domains: (0, $2162809728c8d1e3$export$d7a665f9067dd8f8).optional(),
    branding: (0, $2162809728c8d1e3$export$363bdce991737de).optional(),
    syncProfile: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $8e9f8febefb85a11$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    providerName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    connectorName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    config: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7),
    domains: (0, $2162809728c8d1e3$export$d7a665f9067dd8f8),
    branding: (0, $2162809728c8d1e3$export$363bdce991737de),
    syncProfile: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $8e9f8febefb85a11$export$cb7d2ef46acb2840 = Object.freeze({
    table: "sso_connectors",
    tableSingular: "sso_connector",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        providerName: "provider_name",
        connectorName: "connector_name",
        config: "config",
        domains: "domains",
        branding: "branding",
        syncProfile: "sync_profile",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "providerName",
        "connectorName",
        "config",
        "domains",
        "branding",
        "syncProfile",
        "createdAt"
    ],
    createGuard: $8e9f8febefb85a11$var$createGuard,
    guard: $8e9f8febefb85a11$var$guard,
    updateGuard: $8e9f8febefb85a11$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $58b2a13ac7e0eb6f$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    key: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    value: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional()
});
var $58b2a13ac7e0eb6f$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    key: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    value: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7)
});
var $58b2a13ac7e0eb6f$export$2b3c0ad5912d86e2 = Object.freeze({
    table: "systems",
    tableSingular: "system",
    fields: {
        key: "key",
        value: "value"
    },
    fieldKeys: [
        "key",
        "value"
    ],
    createGuard: $58b2a13ac7e0eb6f$var$createGuard,
    guard: $58b2a13ac7e0eb6f$var$guard,
    updateGuard: $58b2a13ac7e0eb6f$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


var $6ae69310ff4de095$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(12),
    issuer: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    identityId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    detail: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    ssoConnectorId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128)
});
var $6ae69310ff4de095$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(12),
    issuer: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(256),
    identityId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128),
    detail: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    ssoConnectorId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(128)
});
var $6ae69310ff4de095$export$53f83427a403da1f = Object.freeze({
    table: "user_sso_identities",
    tableSingular: "user_sso_identity",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        issuer: "issuer",
        identityId: "identity_id",
        detail: "detail",
        createdAt: "created_at",
        ssoConnectorId: "sso_connector_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "issuer",
        "identityId",
        "detail",
        "createdAt",
        "ssoConnectorId"
    ],
    createGuard: $6ae69310ff4de095$var$createGuard,
    guard: $6ae69310ff4de095$var$guard,
    updateGuard: $6ae69310ff4de095$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.



var $2970d793b119295c$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(12),
    username: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    primaryEmail: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    primaryPhone: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    passwordEncrypted: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    passwordEncryptionMethod: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$b3dbe23797267513)).nullable().optional(),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    avatar: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    profile: (0, $f593db28d49f5079$export$755522cf8b35e50).optional(),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).nullable().optional(),
    identities: (0, $f593db28d49f5079$export$9240af6bda06dde7).optional(),
    customData: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional(),
    logtoConfig: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional(),
    mfaVerifications: (0, $f593db28d49f5079$export$cd58e15effbd05b2).optional(),
    isSuspended: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    lastSignInAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().nullable().optional(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    updatedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $2970d793b119295c$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(12),
    username: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable(),
    primaryEmail: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable(),
    primaryPhone: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable(),
    passwordEncrypted: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable(),
    passwordEncryptionMethod: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $0adae18f63600c2d$export$b3dbe23797267513)).nullable(),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(128).nullable(),
    avatar: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).nullable(),
    profile: (0, $f593db28d49f5079$export$755522cf8b35e50),
    applicationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).nullable(),
    identities: (0, $f593db28d49f5079$export$9240af6bda06dde7),
    customData: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7),
    logtoConfig: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7),
    mfaVerifications: (0, $f593db28d49f5079$export$cd58e15effbd05b2),
    isSuspended: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    lastSignInAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().nullable(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    updatedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $2970d793b119295c$export$a69f017b19597ff5 = Object.freeze({
    table: "users",
    tableSingular: "user",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        username: "username",
        primaryEmail: "primary_email",
        primaryPhone: "primary_phone",
        passwordEncrypted: "password_encrypted",
        passwordEncryptionMethod: "password_encryption_method",
        name: "name",
        avatar: "avatar",
        profile: "profile",
        applicationId: "application_id",
        identities: "identities",
        customData: "custom_data",
        logtoConfig: "logto_config",
        mfaVerifications: "mfa_verifications",
        isSuspended: "is_suspended",
        lastSignInAt: "last_sign_in_at",
        createdAt: "created_at",
        updatedAt: "updated_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "username",
        "primaryEmail",
        "primaryPhone",
        "passwordEncrypted",
        "passwordEncryptionMethod",
        "name",
        "avatar",
        "profile",
        "applicationId",
        "identities",
        "customData",
        "logtoConfig",
        "mfaVerifications",
        "isSuspended",
        "lastSignInAt",
        "createdAt",
        "updatedAt"
    ],
    createGuard: $2970d793b119295c$var$createGuard,
    guard: $2970d793b119295c$var$guard,
    updateGuard: $2970d793b119295c$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $fd4e4749e559d3f5$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $fd4e4749e559d3f5$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21)
});
var $fd4e4749e559d3f5$export$a93a64b4653e6020 = Object.freeze({
    table: "users_roles",
    tableSingular: "users_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        roleId: "role_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "roleId"
    ],
    createGuard: $fd4e4749e559d3f5$var$createGuard,
    guard: $fd4e4749e559d3f5$var$guard,
    updateGuard: $fd4e4749e559d3f5$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $8d547e587599cbc9$var$createGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $8d547e587599cbc9$var$guard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    tenantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(21),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1).max(21),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $8d547e587599cbc9$export$730f48ea7aa802b0 = Object.freeze({
    table: "verification_statuses",
    tableSingular: "verification_status",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "createdAt"
    ],
    createGuard: $8d547e587599cbc9$var$createGuard,
    guard: $8d547e587599cbc9$var$guard,
    updateGuard: $8d547e587599cbc9$var$guard.partial()
});







var $86014ba0677589dc$export$b52523f950bcfb2f = (0, $b8235cc44a26de0a$export$87ce1179d2402b5a).guard.pick({
    id: true,
    syncProfile: true,
    config: true,
    metadata: true,
    connectorId: true
}).merge((0, $dfa943a5a56dac4f$export$f7d2da53d88c923c)).merge((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $c8cb0bd9e348aae8$export$18dbf40ba8d1d9db)),
    isDemo: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    extraInfo: (0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).unknown()).optional(),
    usage: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
}));
var $86014ba0677589dc$export$8169eaabc815830f = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $c8cb0bd9e348aae8$export$18dbf40ba8d1d9db)),
    isDemo: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
}).merge((0, $dfa943a5a56dac4f$export$f7d2da53d88c923c));


var $c45fbec5e00a7b0b$export$82e9f45cca5ba907 = "Interaction";
var $c45fbec5e00a7b0b$export$a455218a85c89869;
(function(Field) {
    Field["Event"] = "Event";
    Field["Identifier"] = "Identifier";
    Field["Profile"] = "Profile";
    Field["BindMfa"] = "BindMfa";
    Field["Mfa"] = "Mfa";
})($c45fbec5e00a7b0b$export$a455218a85c89869 || ($c45fbec5e00a7b0b$export$a455218a85c89869 = {}));
var $c45fbec5e00a7b0b$export$31bb55db0b3e4187;
(function(Method) {
    Method["Password"] = "Password";
    Method["VerificationCode"] = "VerificationCode";
    Method["Social"] = "Social";
    Method["SingleSignOn"] = "SingleSignOn";
})($c45fbec5e00a7b0b$export$31bb55db0b3e4187 || ($c45fbec5e00a7b0b$export$31bb55db0b3e4187 = {}));
var $c45fbec5e00a7b0b$export$e19cd5f9376f8cee;
(function(Action) {
    /** Create a new entity. (E.g. create an interaction, create a verification code) */ Action["Create"] = "Create";
    /** Update an existing entity. (E.g. change interaction type) */ Action["Update"] = "Update";
    /** Submit updated info to an entity, or submit to the system. (E.g. submit an interaction, submit a verification code to get verified) */ Action["Submit"] = "Submit";
    /** Delete a existing entity. (E.g delete profile ) */ Action["Delete"] = "Delete";
    /** Change an entity to the end state. (E.g. end an interaction) */ Action["End"] = "End";
})($c45fbec5e00a7b0b$export$e19cd5f9376f8cee || ($c45fbec5e00a7b0b$export$e19cd5f9376f8cee = {}));


/** The type of a token event. */ var $64db704c43a1f77f$export$92738401e1603719;
(function(Type) {
    Type["ExchangeTokenBy"] = "ExchangeTokenBy";
    Type["RevokeToken"] = "RevokeToken";
})($64db704c43a1f77f$export$92738401e1603719 || ($64db704c43a1f77f$export$92738401e1603719 = {}));
var $64db704c43a1f77f$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType["AccessToken"] = "AccessToken";
    TokenType["RefreshToken"] = "RefreshToken";
    TokenType["IdToken"] = "IdToken";
    TokenType["AuthorizationCode"] = "AuthorizationCode";
    TokenType["DeviceCode"] = "DeviceCode";
    TokenType["BackchannelAuthenticationRequest"] = "BackchannelAuthenticationRequest";
})($64db704c43a1f77f$export$f435f793048e7a0f || ($64db704c43a1f77f$export$f435f793048e7a0f = {}));
var $64db704c43a1f77f$export$4a1942e414bbb622;
(function(ExchangeByType) {
    ExchangeByType["Unknown"] = "Unknown";
    ExchangeByType["AuthorizationCode"] = "AuthorizationCode";
    ExchangeByType["RefreshToken"] = "RefreshToken";
    ExchangeByType["ClientCredentials"] = "ClientCredentials";
})($64db704c43a1f77f$export$4a1942e414bbb622 || ($64db704c43a1f77f$export$4a1942e414bbb622 = {}));


/** The type of a hook event. */ var $c6d1b533a0d360f1$export$92738401e1603719;
(function(Type) {
    Type["TriggerHook"] = "TriggerHook";
})($c6d1b533a0d360f1$export$92738401e1603719 || ($c6d1b533a0d360f1$export$92738401e1603719 = {}));


var $c36c708a2b2c964f$export$82e9f45cca5ba907 = "JwtCustomizer";
var $c36c708a2b2c964f$export$92738401e1603719;
(function(Type) {
    Type["AccessToken"] = "AccessToken";
    Type["ClientCredentials"] = "ClientCredentials";
})($c36c708a2b2c964f$export$92738401e1603719 || ($c36c708a2b2c964f$export$92738401e1603719 = {}));


var $8ceebd19e45826f6$export$603af3d01cbca1e0 = "Unknown";


var $0599fb7ef8cd0d9e$export$ce68f19b50b39c0b;
(function(GrantType) {
    GrantType["AuthorizationCode"] = "authorization_code";
    GrantType["RefreshToken"] = "refresh_token";
    GrantType["ClientCredentials"] = "client_credentials";
})($0599fb7ef8cd0d9e$export$ce68f19b50b39c0b || ($0599fb7ef8cd0d9e$export$ce68f19b50b39c0b = {}));





var $3c7d99abf33fed0b$export$c917e1f6c2e1df9e = Object.freeze([
    "id",
    "username",
    "primaryEmail",
    "primaryPhone",
    "name",
    "avatar",
    "customData",
    "identities",
    "lastSignInAt",
    "createdAt",
    "updatedAt",
    "profile",
    "applicationId",
    "isSuspended"
]);
var $3c7d99abf33fed0b$export$996c89999cd0d06b = (0, $2970d793b119295c$export$a69f017b19597ff5).guard.pick(// eslint-disable-next-line no-restricted-syntax
Object.fromEntries($3c7d99abf33fed0b$export$c917e1f6c2e1df9e.map(function(field) {
    return [
        field,
        true
    ];
})));
var $3c7d99abf33fed0b$export$78c9be0b3d74e4aa = $3c7d99abf33fed0b$export$996c89999cd0d06b.extend({
    hasPassword: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    ssoIdentities: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $6ae69310ff4de095$export$53f83427a403da1f).guard).optional()
});
var $3c7d99abf33fed0b$export$45a6ff4daa005563 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961)),
    agent: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    remainCodes: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
}).array();
var $3c7d99abf33fed0b$export$a17952fc1a8aded7;
(function(InternalRole) {
    /**
     * Internal admin role for Machine-to-Machine apps in Logto user tenants.
     *
     * It should NOT be assigned to any user.
     */ InternalRole["Admin"] = "#internal:admin";
})($3c7d99abf33fed0b$export$a17952fc1a8aded7 || ($3c7d99abf33fed0b$export$a17952fc1a8aded7 = {}));
var $3c7d99abf33fed0b$export$cc68ab3265ed0467;
(function(AdminTenantRole) {
    /** Common user role in admin tenant. */ AdminTenantRole["User"] = "user";
    /** The role for machine to machine applications that represent a user tenant and send requests to Logto Cloud. */ AdminTenantRole["TenantApplication"] = "tenantApplication";
})($3c7d99abf33fed0b$export$cc68ab3265ed0467 || ($3c7d99abf33fed0b$export$cc68ab3265ed0467 = {}));
var $3c7d99abf33fed0b$export$90d62586f282d378;
(function(PredefinedScope) {
    PredefinedScope["All"] = "all";
})($3c7d99abf33fed0b$export$90d62586f282d378 || ($3c7d99abf33fed0b$export$90d62586f282d378 = {}));
var $3c7d99abf33fed0b$export$7ffb47057ef1f416 = (0, $2970d793b119295c$export$a69f017b19597ff5).guard.pick({
    id: true,
    avatar: true,
    name: true
});













var $f9f01cd69fdc1b29$export$3efa9f96d1ddc3f2 = (0, $05fb2d7675e38772$export$8546186883d6ff3e).guard.extend({
    resource: (0, $edc356f6da4e3bc2$export$e9a269813a6315a4).guard
});



/**
 * Manually implement zod guards of some node OIDC provider types.
 *
 * Please note that we defined `accessTokenPayloadGuard` and `clientCredentialsPayloadGuard` in this file, they are used to make the user-defined token
 * sample to be aligned with the real token payload given by the OIDC provider in a real use case.
 *
 * Only keep the least necessary fields in the guards to align with the raw token payload that can be used for `extraTokenClaims` method.
 */ 


var $a79d4baf897c1f6a$var$baseTokenPayloadGuardObject = {
    jti: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    aud: (0, $a782240af38642b4$export$2e2bcd8739ae039).union([
        (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        (0, $a782240af38642b4$export$2e2bcd8739ae039).string().array()
    ]),
    scope: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    clientId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
};
var $a79d4baf897c1f6a$export$e75da9f812cdc25c = (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $a79d4baf897c1f6a$var$baseTokenPayloadGuardObject), {
    accountId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    expiresWithSession: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
    grantId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    gty: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    sessionUid: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    sid: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    kind: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal("AccessToken")
})).strict();
var $a79d4baf897c1f6a$export$702899eeb662faa6 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $a79d4baf897c1f6a$var$baseTokenPayloadGuardObject), {
    kind: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal("ClientCredentials")
})).strict();


var $b573659d6e8fa416$export$35f2e5a17d1b65f1 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    script: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    environmentVariables: (0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).string()).optional(),
    contextSample: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7).optional()
});
var $b573659d6e8fa416$export$2b5732891b015568;
(function(LogtoJwtTokenKeyType) {
    LogtoJwtTokenKeyType["AccessToken"] = "access-token";
    LogtoJwtTokenKeyType["ClientCredentials"] = "client-credentials";
})($b573659d6e8fa416$export$2b5732891b015568 || ($b573659d6e8fa416$export$2b5732891b015568 = {}));
var $b573659d6e8fa416$export$f3e66f6027afb6ea = (0, $3c7d99abf33fed0b$export$996c89999cd0d06b).extend({
    ssoIdentities: (0, $6ae69310ff4de095$export$53f83427a403da1f).guard.pick({
        issuer: true,
        identityId: true,
        detail: true
    }).array(),
    mfaVerificationFactors: (0, $6ae7ce06f09cd84a$export$10c80e60471dfbfa),
    roles: (0, $c6e599dde6f7387b$export$d1d9e451800db729).guard.pick({
        id: true,
        name: true,
        description: true
    }).extend({
        scopes: (0, $f9f01cd69fdc1b29$export$3efa9f96d1ddc3f2).pick({
            id: true,
            name: true,
            description: true,
            resourceId: true,
            resource: true
        }).array()
    }).array(),
    organizations: (0, $f468964a1c639efd$export$8cdb1b004e612f6c).guard.pick({
        id: true,
        name: true,
        description: true
    }).array(),
    organizationRoles: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        organizationId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        roleId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        roleName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
    }).array()
});
var $b573659d6e8fa416$export$91f53954808434ef = $b573659d6e8fa416$export$35f2e5a17d1b65f1.extend({
    // Use partial token guard since users customization may not rely on all fields.
    tokenSample: (0, $a79d4baf897c1f6a$export$e75da9f812cdc25c).partial().optional(),
    contextSample: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        user: $b573659d6e8fa416$export$f3e66f6027afb6ea.partial()
    }).optional()
}).strict();
var $b573659d6e8fa416$export$7c0ea0dbf45c263b = $b573659d6e8fa416$export$35f2e5a17d1b65f1.extend({
    // Use partial token guard since users customization may not rely on all fields.
    tokenSample: (0, $a79d4baf897c1f6a$export$702899eeb662faa6).partial().optional()
}).strict();
var $b573659d6e8fa416$export$862c888fb3aaa059 = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("tokenType", [
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        tokenType: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($b573659d6e8fa416$export$2b5732891b015568.AccessToken)
    }, $b573659d6e8fa416$export$91f53954808434ef.pick({
        environmentVariables: true,
        script: true
    }).shape), {
        token: $b573659d6e8fa416$export$91f53954808434ef.required().shape.tokenSample,
        context: $b573659d6e8fa416$export$91f53954808434ef.required().shape.contextSample
    })),
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        tokenType: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($b573659d6e8fa416$export$2b5732891b015568.ClientCredentials)
    }, $b573659d6e8fa416$export$7c0ea0dbf45c263b.pick({
        environmentVariables: true,
        script: true
    }).shape), {
        token: $b573659d6e8fa416$export$7c0ea0dbf45c263b.required().shape.tokenSample
    }))
]);
/**
 * This guard is for cloud API use (request body guard).
 * Since the cloud API will be use by both testing and production, should keep the fields as general as possible.
 * The response guard for the cloud API is `jsonObjectGuard` since it extends the `token` with extra claims.
 */ var $b573659d6e8fa416$var$commonJwtCustomizerGuard = $b573659d6e8fa416$export$35f2e5a17d1b65f1.pick({
    script: true,
    environmentVariables: true
}).required({
    script: true
}).extend({
    token: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7)
});
var $b573659d6e8fa416$export$7a76d1cb4609fd08 = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("tokenType", [
    $b573659d6e8fa416$var$commonJwtCustomizerGuard.extend({
        tokenType: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($b573659d6e8fa416$export$2b5732891b015568.AccessToken),
        context: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7)
    }),
    $b573659d6e8fa416$var$commonJwtCustomizerGuard.extend({
        tokenType: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($b573659d6e8fa416$export$2b5732891b015568.ClientCredentials)
    })
]);



var $528d40be48481ad1$export$15b2d6ce08800aad;
(function(LogtoOidcConfigKeyType) {
    LogtoOidcConfigKeyType["PrivateKeys"] = "private-keys";
    LogtoOidcConfigKeyType["CookieKeys"] = "cookie-keys";
})($528d40be48481ad1$export$15b2d6ce08800aad || ($528d40be48481ad1$export$15b2d6ce08800aad = {}));
var $528d40be48481ad1$export$30b1b445ccf496a4;
(function(LogtoOidcConfigKey) {
    LogtoOidcConfigKey["PrivateKeys"] = "oidc.privateKeys";
    LogtoOidcConfigKey["CookieKeys"] = "oidc.cookieKeys";
})($528d40be48481ad1$export$30b1b445ccf496a4 || ($528d40be48481ad1$export$30b1b445ccf496a4 = {}));
var $528d40be48481ad1$export$e33814a1cc7d5e24;
(function(SupportedSigningKeyAlgorithm) {
    SupportedSigningKeyAlgorithm["RSA"] = "RSA";
    SupportedSigningKeyAlgorithm["EC"] = "EC";
})($528d40be48481ad1$export$e33814a1cc7d5e24 || ($528d40be48481ad1$export$e33814a1cc7d5e24 = {}));
var $528d40be48481ad1$export$a1c94f11d0704ec5 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    value: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    createdAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $528d40be48481ad1$var$_obj;
var $528d40be48481ad1$export$f5f9e866e854b681 = Object.freeze(($528d40be48481ad1$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($528d40be48481ad1$var$_obj, $528d40be48481ad1$export$30b1b445ccf496a4.PrivateKeys, $528d40be48481ad1$export$a1c94f11d0704ec5.array()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($528d40be48481ad1$var$_obj, $528d40be48481ad1$export$30b1b445ccf496a4.CookieKeys, $528d40be48481ad1$export$a1c94f11d0704ec5.array()), $528d40be48481ad1$var$_obj));
var $528d40be48481ad1$export$35597c7744ab3ee6;
(function(LogtoJwtTokenKey) {
    LogtoJwtTokenKey["AccessToken"] = "jwt.accessToken";
    LogtoJwtTokenKey["ClientCredentials"] = "jwt.clientCredentials";
})($528d40be48481ad1$export$35597c7744ab3ee6 || ($528d40be48481ad1$export$35597c7744ab3ee6 = {}));
var $528d40be48481ad1$var$_obj1;
var $528d40be48481ad1$export$2bd93abaa47d773b = Object.freeze(($528d40be48481ad1$var$_obj1 = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($528d40be48481ad1$var$_obj1, $528d40be48481ad1$export$35597c7744ab3ee6.AccessToken, (0, $b573659d6e8fa416$export$91f53954808434ef)), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($528d40be48481ad1$var$_obj1, $528d40be48481ad1$export$35597c7744ab3ee6.ClientCredentials, (0, $b573659d6e8fa416$export$7c0ea0dbf45c263b)), $528d40be48481ad1$var$_obj1));
var $528d40be48481ad1$export$f10f3dc56ae796fc = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("key", [
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        key: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($528d40be48481ad1$export$35597c7744ab3ee6.AccessToken),
        value: (0, $b573659d6e8fa416$export$91f53954808434ef)
    }),
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        key: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($528d40be48481ad1$export$35597c7744ab3ee6.ClientCredentials),
        value: (0, $b573659d6e8fa416$export$7c0ea0dbf45c263b)
    })
]);
var $528d40be48481ad1$export$73b6ce9fa4b1d915 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    signInExperienceCustomized: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    organizationCreated: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
    developmentTenantMigrationNotification: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        isPaidTenant: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean(),
        /**
         * Tag is used to store the original tenant tag before dev tenant migration.
         * This field is only used for DB rollback and because the `TenantTag` may change, so we don't guard it as the `TenantTag` type.
         */ tag: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        readAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
    }).optional(),
    checkedChargeNotification: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        token: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
        apiResource: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
        machineToMachineApp: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
        tenantMember: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
    }).optional()
});
var $528d40be48481ad1$export$bf5ba14ccde3732d = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    appId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    appSecret: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    resource: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $528d40be48481ad1$export$a249f1a8f5d6b725;
(function(LogtoTenantConfigKey) {
    LogtoTenantConfigKey["AdminConsole"] = "adminConsole";
    LogtoTenantConfigKey["CloudConnection"] = "cloudConnection";
    /** The URL to redirect when session not found in Sign-in Experience. */ LogtoTenantConfigKey["SessionNotFoundRedirectUrl"] = "sessionNotFoundRedirectUrl";
})($528d40be48481ad1$export$a249f1a8f5d6b725 || ($528d40be48481ad1$export$a249f1a8f5d6b725 = {}));
var $528d40be48481ad1$var$_obj2;
var $528d40be48481ad1$export$aebdc60e0ed8c4a5 = Object.freeze(($528d40be48481ad1$var$_obj2 = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($528d40be48481ad1$var$_obj2, $528d40be48481ad1$export$a249f1a8f5d6b725.AdminConsole, $528d40be48481ad1$export$73b6ce9fa4b1d915), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($528d40be48481ad1$var$_obj2, $528d40be48481ad1$export$a249f1a8f5d6b725.CloudConnection, $528d40be48481ad1$export$bf5ba14ccde3732d), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($528d40be48481ad1$var$_obj2, $528d40be48481ad1$export$a249f1a8f5d6b725.SessionNotFoundRedirectUrl, (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    url: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
})), $528d40be48481ad1$var$_obj2));
var $528d40be48481ad1$export$581c47e529f15f7a = Object.freeze((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(Object.values($528d40be48481ad1$export$30b1b445ccf496a4)).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(Object.values($528d40be48481ad1$export$35597c7744ab3ee6)), (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(Object.values($528d40be48481ad1$export$a249f1a8f5d6b725))));
var $528d40be48481ad1$export$7684a7ad17d11565 = Object.freeze((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $528d40be48481ad1$export$f5f9e866e854b681, $528d40be48481ad1$export$2bd93abaa47d773b, $528d40be48481ad1$export$aebdc60e0ed8c4a5));
var $528d40be48481ad1$export$aeb5ffc4d17f8d05 = $528d40be48481ad1$export$a1c94f11d0704ec5.omit({
    value: true
}).merge((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    signingKeyAlgorithm: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($528d40be48481ad1$export$e33814a1cc7d5e24).optional()
}));







var $d65c6662ac39d1b0$var$emailIdentifierGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).string().regex((0, $9f2f5d16fced0798$export$bdb23a0789f9885e));
var $d65c6662ac39d1b0$var$phoneIdentifierGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).string().regex((0, $9f2f5d16fced0798$export$205be3a4a78028e));
var $d65c6662ac39d1b0$var$codeGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1);
var $d65c6662ac39d1b0$export$6d0d05bfd78fb80d = (0, $a782240af38642b4$export$2e2bcd8739ae039).union([
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        email: $d65c6662ac39d1b0$var$emailIdentifierGuard
    }),
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        phone: $d65c6662ac39d1b0$var$phoneIdentifierGuard
    })
]);
var $d65c6662ac39d1b0$export$37e88450d6946bf5 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    email: $d65c6662ac39d1b0$var$emailIdentifierGuard,
    verificationCode: $d65c6662ac39d1b0$var$codeGuard
});
var $d65c6662ac39d1b0$export$7934fcc6bad2c738 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    phone: $d65c6662ac39d1b0$var$phoneIdentifierGuard,
    verificationCode: $d65c6662ac39d1b0$var$codeGuard
});
var $d65c6662ac39d1b0$export$40faae2aa67d03fa = (0, $a782240af38642b4$export$2e2bcd8739ae039).union([
    $d65c6662ac39d1b0$export$37e88450d6946bf5,
    $d65c6662ac39d1b0$export$7934fcc6bad2c738
]);


var $23cc5c0bb86213bf$export$6df2cc07ea6d94e4 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    username: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1),
    password: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1)
});
var $23cc5c0bb86213bf$export$fe8dab8622cea973 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    email: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1),
    password: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1)
});
var $23cc5c0bb86213bf$export$654a1e6496f28807 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    phone: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1),
    password: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().min(1)
});
var $23cc5c0bb86213bf$export$37cf496dfd2fc283 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    connectorId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    connectorData: (0, $a49b7c3bf03b042d$export$4ac62c0537cd0db7)
});
var $23cc5c0bb86213bf$export$c45e1b6fde4cf46f = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    connectorId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    email: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $23cc5c0bb86213bf$export$368d623e521112fc = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    connectorId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    phone: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $23cc5c0bb86213bf$export$5b6496a0e009b82d;
(function(InteractionEvent) {
    InteractionEvent["SignIn"] = "SignIn";
    InteractionEvent["Register"] = "Register";
    InteractionEvent["ForgotPassword"] = "ForgotPassword";
})($23cc5c0bb86213bf$export$5b6496a0e009b82d || ($23cc5c0bb86213bf$export$5b6496a0e009b82d = {}));
var $23cc5c0bb86213bf$export$bdffc825a5318abd = (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($23cc5c0bb86213bf$export$5b6496a0e009b82d);
var $23cc5c0bb86213bf$export$683a5ef9930735ce = (0, $a782240af38642b4$export$2e2bcd8739ae039).union([
    $23cc5c0bb86213bf$export$6df2cc07ea6d94e4,
    $23cc5c0bb86213bf$export$fe8dab8622cea973,
    $23cc5c0bb86213bf$export$654a1e6496f28807,
    (0, $d65c6662ac39d1b0$export$37e88450d6946bf5),
    (0, $d65c6662ac39d1b0$export$7934fcc6bad2c738),
    $23cc5c0bb86213bf$export$37cf496dfd2fc283,
    $23cc5c0bb86213bf$export$c45e1b6fde4cf46f,
    $23cc5c0bb86213bf$export$368d623e521112fc
]);
var $23cc5c0bb86213bf$export$5f4b9d03b6e579b = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    username: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().regex((0, $9f2f5d16fced0798$export$221be9ce6b96eec3)).optional(),
    email: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().regex((0, $9f2f5d16fced0798$export$bdb23a0789f9885e)).optional(),
    phone: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().regex((0, $9f2f5d16fced0798$export$205be3a4a78028e)).optional(),
    connectorId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    password: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
});
var $23cc5c0bb86213bf$export$68a887ed3b61b98e;
(function(MissingProfile) {
    MissingProfile["username"] = "username";
    MissingProfile["email"] = "email";
    MissingProfile["phone"] = "phone";
    MissingProfile["password"] = "password";
    MissingProfile["emailOrPhone"] = "emailOrPhone";
})($23cc5c0bb86213bf$export$68a887ed3b61b98e || ($23cc5c0bb86213bf$export$68a887ed3b61b98e = {}));
var $23cc5c0bb86213bf$export$3cf8b0ef3f34f283 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    // Unlike identifier payload which has indicator like "email",
    // mfa payload must have an additional type field to indicate type
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP),
    code: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $23cc5c0bb86213bf$export$909f398f25e38a05 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    rawId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /**
     * The response from WebAuthn API
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredential}
     */ response: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        clientDataJSON: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        attestationObject: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        authenticatorData: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
        transports: (0, $f593db28d49f5079$export$aa941865a0228ea6).array().optional(),
        publicKeyAlgorithm: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
        publicKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
    }),
    authenticatorAttachment: (0, $a782240af38642b4$export$2e2bcd8739ae039).enum([
        "cross-platform",
        "platform"
    ]).optional(),
    clientExtensionResults: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        appid: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
        crepProps: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
            rk: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
        }).optional(),
        hmacCreateSecret: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
    })
});
var $23cc5c0bb86213bf$export$f2b00820cf0758fd = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode)
});
var $23cc5c0bb86213bf$export$dd85cb6e2ec2273d = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $23cc5c0bb86213bf$export$3cf8b0ef3f34f283,
    $23cc5c0bb86213bf$export$909f398f25e38a05,
    $23cc5c0bb86213bf$export$f2b00820cf0758fd
]);
var $23cc5c0bb86213bf$export$850eb029f701b547 = $23cc5c0bb86213bf$export$3cf8b0ef3f34f283;
var $23cc5c0bb86213bf$export$4cf08ba69fb7c5b0 = $23cc5c0bb86213bf$export$909f398f25e38a05.omit({
    response: true
}).extend({
    response: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        clientDataJSON: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        authenticatorData: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        signature: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        userHandle: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
    })
});
var $23cc5c0bb86213bf$export$975166347c3a7642 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode),
    code: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $23cc5c0bb86213bf$export$4d6ec7236b10bd3 = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $23cc5c0bb86213bf$export$850eb029f701b547,
    $23cc5c0bb86213bf$export$4cf08ba69fb7c5b0,
    $23cc5c0bb86213bf$export$975166347c3a7642
]);
var $23cc5c0bb86213bf$export$fc67cd5d235908c3 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP),
    secret: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $23cc5c0bb86213bf$export$5159fecc862158ed = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn),
    challenge: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $23cc5c0bb86213bf$export$ea1eb8d3018f63a8 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode),
    codes: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).string())
});
var $23cc5c0bb86213bf$export$ad9fd10992842c85 = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $23cc5c0bb86213bf$export$fc67cd5d235908c3,
    $23cc5c0bb86213bf$export$5159fecc862158ed,
    $23cc5c0bb86213bf$export$ea1eb8d3018f63a8
]);
var $23cc5c0bb86213bf$export$4a8ba443157a60f8 = $23cc5c0bb86213bf$export$fc67cd5d235908c3;
var $23cc5c0bb86213bf$export$9c31fcc1c40b68d4 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn),
    credentialId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    publicKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    transports: (0, $f593db28d49f5079$export$aa941865a0228ea6).array(),
    counter: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    agent: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $23cc5c0bb86213bf$export$d103a080e257fd4e = $23cc5c0bb86213bf$export$ea1eb8d3018f63a8;
var $23cc5c0bb86213bf$export$346032d688e2ee1d = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $23cc5c0bb86213bf$export$4a8ba443157a60f8,
    $23cc5c0bb86213bf$export$9c31fcc1c40b68d4,
    $23cc5c0bb86213bf$export$d103a080e257fd4e
]);
var $23cc5c0bb86213bf$export$7d4f7ea03460ffc6 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    type: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961)),
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});


/** Mode for matching the given value(s) and database entries. */ var $7159820e48ab751e$export$a51f1551b9b55e4d;
(function(SearchMatchMode) {
    /** Use `=` or in-array checking. */ SearchMatchMode["Exact"] = "exact";
    /** Use the keyword `LIKE`. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-LIKE). */ SearchMatchMode["Like"] = "like";
    /** Use the keyword `SIMILAR TO` for regular expression matching. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-SIMILARTO-REGEXP). */ SearchMatchMode["SimilarTo"] = "similar_to";
    /** Use the keyword `POSIX` for regular expression matching. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-POSIX-REGEXP). */ SearchMatchMode["Posix"] = "posix";
})($7159820e48ab751e$export$a51f1551b9b55e4d || ($7159820e48ab751e$export$a51f1551b9b55e4d = {}));
var $7159820e48ab751e$export$6d217b707eba5852;
(function(SearchJointMode) {
    SearchJointMode["Or"] = "or";
    SearchJointMode["And"] = "and";
})($7159820e48ab751e$export$6d217b707eba5852 || ($7159820e48ab751e$export$6d217b707eba5852 = {}));











var $cfb13013cde8a542$export$71547dc50acd9a7c = (0, $16d3653139bc1b0b$export$73c91b53927e421e).guard.pick({
    id: true,
    name: true,
    type: true
});
var $cfb13013cde8a542$export$590c2403cf18bb08 = (0, $16d3653139bc1b0b$export$73c91b53927e421e).createGuard.omit({
    id: true,
    createdAt: true,
    secret: true,
    tenantId: true
}).partial().merge((0, $16d3653139bc1b0b$export$73c91b53927e421e).createGuard.pick({
    name: true,
    type: true
}));
var $cfb13013cde8a542$export$f8933e674a6d3243 = $cfb13013cde8a542$export$590c2403cf18bb08.partial().omit({
    type: true,
    isThirdParty: true
});
var $cfb13013cde8a542$var$resourceScopesGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    resource: (0, $edc356f6da4e3bc2$export$e9a269813a6315a4).guard.pick({
        id: true,
        name: true,
        indicator: true
    }),
    scopes: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $05fb2d7675e38772$export$8546186883d6ff3e).guard.pick({
        id: true,
        name: true,
        description: true
    }))
}));
var $cfb13013cde8a542$export$8f1fa196fa63bf04 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    organizationScopes: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $6045b5c754440d63$export$9d110f69f69dde7a).guard.pick({
        id: true,
        name: true,
        description: true
    })),
    resourceScopes: $cfb13013cde8a542$var$resourceScopesGuard,
    organizationResourceScopes: $cfb13013cde8a542$var$resourceScopesGuard,
    userScopes: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum((0, $4f91f077d5b7f09a$export$4b02c5b431f6eb78)))
});
var $cfb13013cde8a542$export$9b2e974edaaa0e9c;
(function(ApplicationUserConsentScopeType) {
    ApplicationUserConsentScopeType["OrganizationScopes"] = "organization-scopes";
    ApplicationUserConsentScopeType["ResourceScopes"] = "resource-scopes";
    ApplicationUserConsentScopeType["OrganizationResourceScopes"] = "organization-resource-scopes";
    ApplicationUserConsentScopeType["UserScopes"] = "user-scopes";
})($cfb13013cde8a542$export$9b2e974edaaa0e9c || ($cfb13013cde8a542$export$9b2e974edaaa0e9c = {}));
var $cfb13013cde8a542$export$8629c19b82b57228 = (0, $adaf29a8bb1a8dbc$export$b21e17c60fe7d89c).createGuard.omit({
    applicationId: true,
    tenantId: true,
    termsOfUseUrl: true,
    privacyPolicyUrl: true
})// Align with the sign-in-experience create guard.
.merge((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    termsOfUseUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).url().optional().nullable().or((0, $a782240af38642b4$export$2e2bcd8739ae039).literal("")),
    privacyPolicyUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().max(2048).url().optional().nullable().or((0, $a782240af38642b4$export$2e2bcd8739ae039).literal(""))
}));






var $7f9bc105425906c1$export$4857b48889187a39;
(function(AlterationStateKey) {
    AlterationStateKey["AlterationState"] = "alterationState";
})($7f9bc105425906c1$export$4857b48889187a39 || ($7f9bc105425906c1$export$4857b48889187a39 = {}));
var $7f9bc105425906c1$export$b648b84528d1cda3 = Object.freeze((0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, $7f9bc105425906c1$export$4857b48889187a39.AlterationState, (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    timestamp: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    updatedAt: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
})));
var $7f9bc105425906c1$export$465a18018f692373;
(function(StorageProvider) {
    StorageProvider["AzureStorage"] = "AzureStorage";
    StorageProvider["S3Storage"] = "S3Storage";
    StorageProvider["GoogleStorage"] = "GoogleStorage";
})($7f9bc105425906c1$export$465a18018f692373 || ($7f9bc105425906c1$export$465a18018f692373 = {}));
var $7f9bc105425906c1$var$basicConfig = {
    publicUrl: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
};
var $7f9bc105425906c1$export$6882da4bfe6c548e = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("provider", [
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        provider: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($7f9bc105425906c1$export$465a18018f692373.AzureStorage),
        connectionString: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        container: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
    }, $7f9bc105425906c1$var$basicConfig)),
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        provider: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($7f9bc105425906c1$export$465a18018f692373.S3Storage),
        endpoint: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
        region: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
        bucket: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        accessKeyId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        accessSecretKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
    }, $7f9bc105425906c1$var$basicConfig)),
    (0, $a782240af38642b4$export$2e2bcd8739ae039).object((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        provider: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($7f9bc105425906c1$export$465a18018f692373.GoogleStorage),
        projectId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        keyFilename: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        bucketName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
    }, $7f9bc105425906c1$var$basicConfig))
]);
var $7f9bc105425906c1$export$589fea410707bd1e;
(function(StorageProviderKey) {
    StorageProviderKey["StorageProvider"] = "storageProvider";
})($7f9bc105425906c1$export$589fea410707bd1e || ($7f9bc105425906c1$export$589fea410707bd1e = {}));
var $7f9bc105425906c1$export$1755428192b369f4 = Object.freeze((0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, $7f9bc105425906c1$export$589fea410707bd1e.StorageProvider, $7f9bc105425906c1$export$6882da4bfe6c548e));
var $7f9bc105425906c1$export$c04e0db396d22ede;
(function(EmailServiceProvider) {
    EmailServiceProvider["SendGrid"] = "SendGrid";
})($7f9bc105425906c1$export$c04e0db396d22ede || ($7f9bc105425906c1$export$c04e0db396d22ede = {}));
var $7f9bc105425906c1$export$ae559586eab6a29d = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    provider: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal($7f9bc105425906c1$export$c04e0db396d22ede.SendGrid),
    apiKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    templateId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    fromName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    fromEmail: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $7f9bc105425906c1$export$eed90e6abe4b6331 = (0, $a782240af38642b4$export$2e2bcd8739ae039).discriminatedUnion("provider", [
    $7f9bc105425906c1$export$ae559586eab6a29d
]);
var $7f9bc105425906c1$export$1b716a2fb233f165;
(function(EmailServiceProviderKey) {
    EmailServiceProviderKey["EmailServiceProvider"] = "emailServiceProvider";
})($7f9bc105425906c1$export$1b716a2fb233f165 || ($7f9bc105425906c1$export$1b716a2fb233f165 = {}));
var $7f9bc105425906c1$export$148ac52baf2fe1fe = Object.freeze((0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, $7f9bc105425906c1$export$1b716a2fb233f165.EmailServiceProvider, $7f9bc105425906c1$export$eed90e6abe4b6331));
var $7f9bc105425906c1$export$3f96ea771b870c9b;
(function(DemoSocialProvider) {
    DemoSocialProvider["Google"] = "google";
    DemoSocialProvider["GitHub"] = "github";
    DemoSocialProvider["Discord"] = "discord";
})($7f9bc105425906c1$export$3f96ea771b870c9b || ($7f9bc105425906c1$export$3f96ea771b870c9b = {}));
var $7f9bc105425906c1$export$b0cb774a6cdd5c2c = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    logo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    logoDark: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    provider: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($7f9bc105425906c1$export$3f96ea771b870c9b),
    clientId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
}).array();
var $7f9bc105425906c1$export$2b6e95870946a21e;
(function(DemoSocialKey) {
    DemoSocialKey["DemoSocial"] = "demoSocial";
})($7f9bc105425906c1$export$2b6e95870946a21e || ($7f9bc105425906c1$export$2b6e95870946a21e = {}));
var $7f9bc105425906c1$export$ae90bacd174e78c0 = Object.freeze((0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, $7f9bc105425906c1$export$2b6e95870946a21e.DemoSocial, $7f9bc105425906c1$export$b0cb774a6cdd5c2c));
var $7f9bc105425906c1$export$4792a20f2d99e347 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    zoneId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    apiToken: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    blockedDomains: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().array().optional()
});
var $7f9bc105425906c1$export$aa9834a14f8dda83 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    /* Cloudflare Workers & Pages account ID */ accountIdentifier: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /* KV namespace ID */ namespaceIdentifier: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /* Key prefix for protected app config */ keyName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /* The default domain (e.g protected.app) for the protected app */ domain: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    apiToken: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $7f9bc105425906c1$export$17c589ef0ecd4097 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    /** Cloudflare API Key (api_key). */ apiKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /** Cloudflare API Key (api_email). */ apiEmail: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /** Cloudflare account ID. */ accountId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    /** Default Cloudflare subdomain for the account. */ subdomain: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $7f9bc105425906c1$export$24bf5ccdb699e65e;
(function(CloudflareKey) {
    CloudflareKey["HostnameProvider"] = "cloudflareHostnameProvider";
    CloudflareKey["ProtectedAppConfigProvider"] = "cloudflareProtectedAppConfigProvider";
    CloudflareKey["ProtectedAppHostnameProvider"] = "cloudflareProtectedAppHostnameProvider";
    CloudflareKey["CustomJwtWorkerConfig"] = "cloudflareCustomJwtWorkerConfig";
})($7f9bc105425906c1$export$24bf5ccdb699e65e || ($7f9bc105425906c1$export$24bf5ccdb699e65e = {}));
var $7f9bc105425906c1$var$_obj;
var $7f9bc105425906c1$export$7dae3b09179b4445 = Object.freeze(($7f9bc105425906c1$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($7f9bc105425906c1$var$_obj, $7f9bc105425906c1$export$24bf5ccdb699e65e.HostnameProvider, $7f9bc105425906c1$export$4792a20f2d99e347), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($7f9bc105425906c1$var$_obj, $7f9bc105425906c1$export$24bf5ccdb699e65e.ProtectedAppConfigProvider, $7f9bc105425906c1$export$aa9834a14f8dda83), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($7f9bc105425906c1$var$_obj, $7f9bc105425906c1$export$24bf5ccdb699e65e.ProtectedAppHostnameProvider, $7f9bc105425906c1$export$4792a20f2d99e347), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($7f9bc105425906c1$var$_obj, $7f9bc105425906c1$export$24bf5ccdb699e65e.CustomJwtWorkerConfig, $7f9bc105425906c1$export$17c589ef0ecd4097), $7f9bc105425906c1$var$_obj));
var $7f9bc105425906c1$export$20b0450fb73770e2 = Object.freeze((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(Object.values($7f9bc105425906c1$export$4857b48889187a39)).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(Object.values($7f9bc105425906c1$export$589fea410707bd1e)), (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(Object.values($7f9bc105425906c1$export$2b6e95870946a21e)), (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(Object.values($7f9bc105425906c1$export$24bf5ccdb699e65e)), (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(Object.values($7f9bc105425906c1$export$1b716a2fb233f165))));
var $7f9bc105425906c1$export$b74a29afb5bd243f = Object.freeze((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $7f9bc105425906c1$export$b648b84528d1cda3, $7f9bc105425906c1$export$1755428192b369f4, $7f9bc105425906c1$export$ae90bacd174e78c0, $7f9bc105425906c1$export$7dae3b09179b4445, $7f9bc105425906c1$export$148ac52baf2fe1fe));



var $5081abb1e44aa22a$export$8ef133238cd2874 = 8388608; // 8MB
var $5081abb1e44aa22a$export$e2adfe8ff5d50ee4 = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/vnd.microsoft.icon",
    "image/x-icon",
    "image/svg+xml",
    "image/tiff",
    "image/webp",
    "image/bmp"
];
var $5081abb1e44aa22a$var$allowUploadMimeTypeGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).enum($5081abb1e44aa22a$export$e2adfe8ff5d50ee4);
var $5081abb1e44aa22a$export$2dd272e4b553b8ba = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    status: (0, $a782240af38642b4$export$2e2bcd8739ae039).union([
        (0, $a782240af38642b4$export$2e2bcd8739ae039).literal("ready"),
        (0, $a782240af38642b4$export$2e2bcd8739ae039).literal("not_configured")
    ]),
    allowUploadMimeTypes: (0, $a782240af38642b4$export$2e2bcd8739ae039).array($5081abb1e44aa22a$var$allowUploadMimeTypeGuard).optional(),
    maxUploadFileSize: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional()
});
var $5081abb1e44aa22a$export$aaf4674b6bfc26fb = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    url: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});




var $bea60aa2134f5e24$var$hookExecutionStatsGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    successCount: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    requestCount: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
});
var $bea60aa2134f5e24$export$5c5f088aefddc59e = (0, $f1e4867eaafd4781$export$5fbefe39e79899a6).guard.extend({
    executionStats: $bea60aa2134f5e24$var$hookExecutionStatsGuard
});
var $bea60aa2134f5e24$export$4d1fa1bc05a05454 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    responseStatus: (0, $a782240af38642b4$export$2e2bcd8739ae039).number(),
    responseBody: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});


var $6c806d3f55a9103f$export$2cad645b7df28dd5;
(function(ServiceLogType) {
    ServiceLogType["SendEmail"] = "sendEmail";
    ServiceLogType["SendSms"] = "sendSms";
    ServiceLogType["FetchCustomJwt"] = "fetchCustomJwt";
})($6c806d3f55a9103f$export$2cad645b7df28dd5 || ($6c806d3f55a9103f$export$2cad645b7df28dd5 = {}));


var $3435b1bcc8b985e2$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})($3435b1bcc8b985e2$export$14faa19a0f3bbeb2 || ($3435b1bcc8b985e2$export$14faa19a0f3bbeb2 = {}));



var $c8eb410e9d4e356e$export$3b9208034fe791c1 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    appId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
}).partial();



var $09623a221bbbd6e1$var$dashboardUsersDataGuard = (0, $a782240af38642b4$export$be5493f9613cbbe)({
    count: (0, $a782240af38642b4$export$98e628dec113755e)(),
    delta: (0, $a782240af38642b4$export$98e628dec113755e)()
});
var $09623a221bbbd6e1$export$9d1c6ddb5817c52e = (0, $a782240af38642b4$export$be5493f9613cbbe)({
    today: $09623a221bbbd6e1$var$dashboardUsersDataGuard,
    last7Days: $09623a221bbbd6e1$var$dashboardUsersDataGuard
});
var $09623a221bbbd6e1$export$fd0651ecbc2a1652 = (0, $a782240af38642b4$export$be5493f9613cbbe)({
    dauCurve: (0, $a782240af38642b4$export$2f23118c22fb2630)((0, $a782240af38642b4$export$be5493f9613cbbe)({
        date: (0, $a782240af38642b4$export$22b082955e083ec3)(),
        count: (0, $a782240af38642b4$export$98e628dec113755e)()
    })),
    dau: $09623a221bbbd6e1$var$dashboardUsersDataGuard,
    wau: $09623a221bbbd6e1$var$dashboardUsersDataGuard,
    mau: $09623a221bbbd6e1$var$dashboardUsersDataGuard
});



var $ee43c9a59379c77f$export$81290fbb16f7e442 = Object.freeze([
    "id",
    "domain",
    "status",
    "errorMessage",
    "dnsRecords"
]);
var $ee43c9a59379c77f$export$8181686bf073ccc4 = (0, $33ea7b655cd1e93f$export$e3e9d7fdf7b67caa).guard.pick({
    id: true,
    domain: true,
    status: true,
    errorMessage: true,
    dnsRecords: true
});


/**
 * The sentinel class interface.
 *
 * Sentinels are responsible for accepting activity reports and making decisions based on them.
 *
 * For example, for a user sign-in activity, the sentinel might decide to:
 *
 * - Accept since the user uses the same device and location as usual;
 * - Require a MFA code since the user uses a new device or location;
 * - Block the user since the user tried to sign-in too many times with an incorrect password.
 *
 * The implementation should be privacy-aware and not store any personal identifiable information.
 */ 
var $3c0e8be37ed43274$export$84d34c4405d4a2e8 = function Sentinel() {
    "use strict";
    (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, Sentinel);
};




var $969ce540c86cdf11$export$2334438dedb2ca6f = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    rp: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
    }),
    user: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        displayName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
    }),
    challenge: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    pubKeyCredParams: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal("public-key"),
        alg: (0, $a782240af38642b4$export$2e2bcd8739ae039).number()
    })),
    timeout: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    excludeCredentials: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal("public-key"),
        id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        transports: (0, $f593db28d49f5079$export$aa941865a0228ea6).array().optional()
    })).optional(),
    authenticatorSelection: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        authenticatorAttachment: (0, $a782240af38642b4$export$2e2bcd8739ae039).enum([
            "platform",
            "cross-platform"
        ]).optional(),
        requireResidentKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
        residentKey: (0, $a782240af38642b4$export$2e2bcd8739ae039).enum([
            "discouraged",
            "preferred",
            "required"
        ]).optional(),
        userVerification: (0, $a782240af38642b4$export$2e2bcd8739ae039).enum([
            "required",
            "preferred",
            "discouraged"
        ]).optional()
    }).optional(),
    attestation: (0, $a782240af38642b4$export$2e2bcd8739ae039).enum([
        "none",
        "indirect",
        "direct",
        "enterprise"
    ]).optional(),
    extensions: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        appid: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
        credProps: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
        hmacCreateSecret: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
    }).optional()
});
var $969ce540c86cdf11$export$e849189769e7ddda = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    challenge: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    timeout: (0, $a782240af38642b4$export$2e2bcd8739ae039).number().optional(),
    rpId: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    allowCredentials: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        type: (0, $a782240af38642b4$export$2e2bcd8739ae039).literal("public-key"),
        id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        transports: (0, $f593db28d49f5079$export$aa941865a0228ea6).array().optional()
    })).optional(),
    userVerification: (0, $a782240af38642b4$export$2e2bcd8739ae039).enum([
        "required",
        "preferred",
        "discouraged"
    ]).optional(),
    extensions: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        appid: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
        credProps: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional(),
        hmacCreateSecret: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
    }).optional()
});





var $5e1b8ee1d9145565$export$a8f6e59aae709371 = (0, $1703009f52b0bf4d$export$29f120f254b547e7).guard.extend({
    scopes: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
    }).array(),
    resourceScopes: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
        id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
        resource: (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
            id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
            name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
        })
    }).array()
});
var $5e1b8ee1d9145565$var$organizationRoleEntityGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $5e1b8ee1d9145565$export$a1b68498f213370c = (0, $f468964a1c639efd$export$8cdb1b004e612f6c).guard.extend({
    organizationRoles: $5e1b8ee1d9145565$var$organizationRoleEntityGuard.array()
});
var $5e1b8ee1d9145565$export$6c095334bcf53b71 = (0, $3c7d99abf33fed0b$export$996c89999cd0d06b).extend({
    organizationRoles: $5e1b8ee1d9145565$var$organizationRoleEntityGuard.array()
});
var $5e1b8ee1d9145565$export$c805c92fd00f1460 = (0, $2d7bc4e2517ba976$export$63fd293d5536b534).guard.extend({
    organizationRoles: $5e1b8ee1d9145565$var$organizationRoleEntityGuard.array()
});




var $82b6ecb2e23c540b$export$7f91c1744e02ec3c = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    connectorName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    logo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    darkLogo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional()
});
var $82b6ecb2e23c540b$export$88b6bcc5c3531d29;
(function(SsoProviderName) {
    SsoProviderName["OIDC"] = "OIDC";
    SsoProviderName["SAML"] = "SAML";
    SsoProviderName["AZURE_AD"] = "AzureAD";
    SsoProviderName["GOOGLE_WORKSPACE"] = "GoogleWorkspace";
    SsoProviderName["OKTA"] = "Okta";
    SsoProviderName["AZURE_AD_OIDC"] = "AzureAdOidc";
})($82b6ecb2e23c540b$export$88b6bcc5c3531d29 || ($82b6ecb2e23c540b$export$88b6bcc5c3531d29 = {}));
var $82b6ecb2e23c540b$export$f37fcb7c8234a0f8;
(function(SsoProviderType) {
    SsoProviderType["OIDC"] = "oidc";
    SsoProviderType["SAML"] = "saml";
})($82b6ecb2e23c540b$export$f37fcb7c8234a0f8 || ($82b6ecb2e23c540b$export$f37fcb7c8234a0f8 = {}));
var $82b6ecb2e23c540b$export$92ee0fc3a3bf5566 = Object.freeze([
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "live.com",
    "icloud.com",
    "aol.com",
    "yandex.com",
    "mail.com",
    "protonmail.com",
    "yanex.com",
    "gmx.com",
    "mail.ru",
    "zoho.com",
    "qq.com",
    "163.com",
    "126.com",
    "sina.com",
    "sohu.com"
]);
var $82b6ecb2e23c540b$var$ssoConnectorProviderDetailGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    providerName: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($82b6ecb2e23c540b$export$88b6bcc5c3531d29),
    providerType: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($82b6ecb2e23c540b$export$f37fcb7c8234a0f8),
    logo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    logoDark: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    description: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});
var $82b6ecb2e23c540b$export$daec852f2106e44c = (0, $a782240af38642b4$export$2e2bcd8739ae039).array($82b6ecb2e23c540b$var$ssoConnectorProviderDetailGuard);
var $82b6ecb2e23c540b$export$a536522a091757cc = (0, $8e9f8febefb85a11$export$cb7d2ef46acb2840).guard// Must be a supported SSO provider name. Overwrite the providerName string type to enum.
.extend({
    providerName: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($82b6ecb2e23c540b$export$88b6bcc5c3531d29)
}).merge(// Static provider details
(0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    name: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    providerType: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($82b6ecb2e23c540b$export$f37fcb7c8234a0f8),
    providerLogo: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    providerLogoDark: (0, $a782240af38642b4$export$2e2bcd8739ae039).string(),
    // SSO connection config parsed from the provider.
    // - OIDC: connection config fetched from the OIDC provider.
    // - SAML: connection config fetched from the metadata url or metadata file.
    providerConfig: (0, $a782240af38642b4$export$2e2bcd8739ae039).record((0, $a782240af38642b4$export$2e2bcd8739ae039).unknown()).optional()
}));


var $94407f95c3c65d60$export$3baa67aafdc7045f;
(function(TenantTag) {
    /* Development tenants are free to use but are not meant to be used as production environment. */ TenantTag["Development"] = "development";
    /* A production tenant must have an associated subscription plan, even if it's a free plan. */ TenantTag["Production"] = "production";
})($94407f95c3c65d60$export$3baa67aafdc7045f || ($94407f95c3c65d60$export$3baa67aafdc7045f = {}));


/**
 * @fileoverview
 * Tenant organizations are organizations in the admin tenant that represent tenants. They are
 * created when a tenant is created, and are used to define the roles and scopes for the users in
 * the tenant.
 *
 * This module provides utilities to manage tenant organizations.
 */ 
var $2af3fef12ae5d626$export$ccc9014151910116 = "default";
var $2af3fef12ae5d626$export$87d9f170d46b6e1e = "admin";


var $e31ddbb317dfffef$export$2469be9aaea94b3b = function(tenantId) {
    return "t-".concat(tenantId);
};
var $e31ddbb317dfffef$export$e34151e8896fc4e0 = function(organizationId) {
    if (!organizationId.startsWith("t-")) throw new Error("Invalid admin tenant organization ID: ".concat(organizationId));
    return organizationId.slice(2);
};
var $e31ddbb317dfffef$export$2d8382267fbcadbe = function(tenantId) {
    return Object.freeze({
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        id: $e31ddbb317dfffef$export$2469be9aaea94b3b(tenantId),
        name: "Tenant ".concat(tenantId)
    });
};
var $e31ddbb317dfffef$export$5bc5773220b3c720;
(function(TenantScope) {
    /** Read the tenant data. */ TenantScope["ReadData"] = "read:data";
    /** Write the tenant data, including creating and updating the tenant. */ TenantScope["WriteData"] = "write:data";
    /** Delete data of the tenant. */ TenantScope["DeleteData"] = "delete:data";
    /** Read members of the tenant. */ TenantScope["ReadMember"] = "read:member";
    /** Invite members to the tenant. */ TenantScope["InviteMember"] = "invite:member";
    /** Remove members from the tenant. */ TenantScope["RemoveMember"] = "remove:member";
    /** Update the role of a member in the tenant. */ TenantScope["UpdateMemberRole"] = "update:member:role";
    /** Manage the tenant settings, including name, billing, etc. */ TenantScope["ManageTenant"] = "manage:tenant";
})($e31ddbb317dfffef$export$5bc5773220b3c720 || ($e31ddbb317dfffef$export$5bc5773220b3c720 = {}));
var $e31ddbb317dfffef$var$allTenantScopes = Object.freeze(Object.values($e31ddbb317dfffef$export$5bc5773220b3c720));
var $e31ddbb317dfffef$export$d33885dda1bb96a0 = function(scope) {
    return Object.freeze({
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        id: scope.replaceAll(":", "-"),
        name: scope,
        description: $e31ddbb317dfffef$var$tenantScopeDescriptions[scope]
    });
};
var $e31ddbb317dfffef$var$_obj;
var $e31ddbb317dfffef$var$tenantScopeDescriptions = Object.freeze(($e31ddbb317dfffef$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj, $e31ddbb317dfffef$export$5bc5773220b3c720.ReadData, "Read the tenant data."), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj, $e31ddbb317dfffef$export$5bc5773220b3c720.WriteData, "Write the tenant data, including creating and updating the tenant."), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj, $e31ddbb317dfffef$export$5bc5773220b3c720.DeleteData, "Delete data of the tenant."), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj, $e31ddbb317dfffef$export$5bc5773220b3c720.ReadMember, "Read members of the tenant."), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj, $e31ddbb317dfffef$export$5bc5773220b3c720.InviteMember, "Invite members to the tenant."), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj, $e31ddbb317dfffef$export$5bc5773220b3c720.RemoveMember, "Remove members from the tenant."), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj, $e31ddbb317dfffef$export$5bc5773220b3c720.UpdateMemberRole, "Update the role of a member in the tenant."), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj, $e31ddbb317dfffef$export$5bc5773220b3c720.ManageTenant, "Manage the tenant settings, including name, billing, etc."), $e31ddbb317dfffef$var$_obj));
var $e31ddbb317dfffef$export$af4151a4e98c49fa;
(function(TenantRole) {
    /** Admin of the tenant, who has all permissions. */ TenantRole["Admin"] = "admin";
    /** Collaborator of the tenant, who has permissions to operate the tenant data, but not the tenant settings. */ TenantRole["Collaborator"] = "collaborator";
})($e31ddbb317dfffef$export$af4151a4e98c49fa || ($e31ddbb317dfffef$export$af4151a4e98c49fa = {}));
var $e31ddbb317dfffef$var$_obj1;
var $e31ddbb317dfffef$var$tenantRoleDescriptions = Object.freeze(($e31ddbb317dfffef$var$_obj1 = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj1, $e31ddbb317dfffef$export$af4151a4e98c49fa.Admin, "Admin of the tenant, who has all permissions."), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj1, $e31ddbb317dfffef$export$af4151a4e98c49fa.Collaborator, "Collaborator of the tenant, who has permissions to operate the tenant data, but not the tenant settings."), $e31ddbb317dfffef$var$_obj1));
var $e31ddbb317dfffef$export$1775965c9a0d8dc9 = function(role) {
    return Object.freeze({
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        id: role,
        name: role,
        description: $e31ddbb317dfffef$var$tenantRoleDescriptions[role]
    });
};
var $e31ddbb317dfffef$var$_obj2;
var $e31ddbb317dfffef$export$3f89b2d5d2b9eb42 = Object.freeze(($e31ddbb317dfffef$var$_obj2 = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj2, $e31ddbb317dfffef$export$af4151a4e98c49fa.Admin, $e31ddbb317dfffef$var$allTenantScopes), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($e31ddbb317dfffef$var$_obj2, $e31ddbb317dfffef$export$af4151a4e98c49fa.Collaborator, [
    $e31ddbb317dfffef$export$5bc5773220b3c720.ReadData,
    $e31ddbb317dfffef$export$5bc5773220b3c720.WriteData,
    $e31ddbb317dfffef$export$5bc5773220b3c720.DeleteData,
    $e31ddbb317dfffef$export$5bc5773220b3c720.ReadMember
]), $e31ddbb317dfffef$var$_obj2));


/**
 * @fileoverview
 * Mapi (Management API) proxy is an endpoint in Logto Cloud that proxies the requests to the
 * corresponding Management API. It has the following benefits:
 *
 * - When we migrate the tenant management from API resources to tenant organizations, we can
 *   migrate Console to use the mapi proxy endpoint by changing only the base URL.
 * - It decouples the access control of Cloud user collaboration from the machine-to-machine access
 *   control of the Management API.
 * - The mapi proxy endpoint shares the same domain with Logto Cloud, so it can be used in the
 *   browser without CORS.
 *
 * This module provides utilities to manage mapi proxy.
 */ 


var $911b2481794a33c6$export$a1252204700ae600 = function(tenantId) {
    return Object.freeze({
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        id: "m-".concat(tenantId),
        name: "machine:mapi:".concat(tenantId),
        description: "Machine-to-machine role for accessing Management API of tenant '".concat(tenantId, "'."),
        type: (0, $0adae18f63600c2d$export$e57c3ccf0ca02b45).MachineToMachine,
        isDefault: false
    });
};
var $911b2481794a33c6$export$deaf541980006e1f = function(tenantId) {
    return Object.freeze({
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        id: "m-".concat(tenantId),
        secret: (0, $77ca15834c94224a$export$877b6275f1b9e856)(32),
        name: "Management API access for ".concat(tenantId),
        description: "Machine-to-machine app for accessing Management API of tenant '".concat(tenantId, "'."),
        type: (0, $0adae18f63600c2d$export$d16f8fdf0c548b68).MachineToMachine,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        }
    });
};




var $7495aba9bfc1ace8$export$d6a2d3784301e7e6 = (0, $2970d793b119295c$export$a69f017b19597ff5).guard.pick({
    id: true,
    name: true,
    avatar: true,
    username: true,
    primaryEmail: true,
    primaryPhone: true
});
var $7495aba9bfc1ace8$export$bd52a8a3b354bd5c = (0, $16d3653139bc1b0b$export$73c91b53927e421e).guard.pick({
    id: true,
    name: true
});
var $7495aba9bfc1ace8$export$18c739dd80de9062 = (0, $adaf29a8bb1a8dbc$export$b21e17c60fe7d89c).guard.pick({
    branding: true,
    displayName: true,
    privacyPolicyUrl: true,
    termsOfUseUrl: true
});
var $7495aba9bfc1ace8$export$852b61cc27b5cdcd = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    // The original resource id has a maximum length of 21 restriction. We need to make it compatible with the logto reserved organization name.
    // use string here, as we do not care about the resource id length here.
    resource: (0, $edc356f6da4e3bc2$export$e9a269813a6315a4).guard.pick({
        name: true,
        indicator: true
    }).extend({
        id: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
    }),
    scopes: (0, $05fb2d7675e38772$export$8546186883d6ff3e).guard.pick({
        id: true,
        name: true,
        description: true
    }).array()
});
var $7495aba9bfc1ace8$export$9694f7ffb7c13fa0 = (0, $f468964a1c639efd$export$8cdb1b004e612f6c).guard.pick({
    id: true,
    name: true
}).extend({
    missingResourceScopes: $7495aba9bfc1ace8$export$852b61cc27b5cdcd.array().optional()
});
var $7495aba9bfc1ace8$export$c3e25094abccc08 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    application: $7495aba9bfc1ace8$export$bd52a8a3b354bd5c.merge($7495aba9bfc1ace8$export$18c739dd80de9062.partial()),
    user: $7495aba9bfc1ace8$export$d6a2d3784301e7e6,
    organizations: $7495aba9bfc1ace8$export$9694f7ffb7c13fa0.array().optional(),
    missingOIDCScope: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().array().optional(),
    missingResourceScopes: $7495aba9bfc1ace8$export$852b61cc27b5cdcd.array().optional(),
    redirectUri: (0, $a782240af38642b4$export$2e2bcd8739ae039).string()
});



var $78615cbd2ca0fb64$export$b68ca08271df260b = "onboarding";
var $78615cbd2ca0fb64$export$b6032183171af19f;
(function(Project) {
    Project["Personal"] = "personal";
    Project["Company"] = "company";
})($78615cbd2ca0fb64$export$b6032183171af19f || ($78615cbd2ca0fb64$export$b6032183171af19f = {}));
/** @deprecated Open-source options was for cloud preview use, no longer needed. Use default `Cloud` value for placeholder. */ var $78615cbd2ca0fb64$var$DeploymentType;
(function(DeploymentType) {
    DeploymentType["OpenSource"] = "open-source";
    DeploymentType["Cloud"] = "cloud";
})($78615cbd2ca0fb64$var$DeploymentType || ($78615cbd2ca0fb64$var$DeploymentType = {}));
var $78615cbd2ca0fb64$export$f99233281efd08a0;
(function(Title) {
    Title["Developer"] = "developer";
    Title["TeamLead"] = "team-lead";
    Title["Ceo"] = "ceo";
    Title["Cto"] = "cto";
    Title["Product"] = "product";
    Title["Others"] = "others";
})($78615cbd2ca0fb64$export$f99233281efd08a0 || ($78615cbd2ca0fb64$export$f99233281efd08a0 = {}));
var $78615cbd2ca0fb64$export$41cc48adf872ce3b;
(function(CompanySize) {
    CompanySize["Scale1"] = "1";
    CompanySize["Scale2"] = "2-49";
    CompanySize["Scale3"] = "50-199";
    CompanySize["Scale4"] = "200-999";
    CompanySize["Scale5"] = "1000+";
})($78615cbd2ca0fb64$export$41cc48adf872ce3b || ($78615cbd2ca0fb64$export$41cc48adf872ce3b = {}));
var $78615cbd2ca0fb64$export$fe867595c4640fb1;
(function(Reason) {
    Reason["Passwordless"] = "passwordless";
    Reason["Efficiency"] = "efficiency";
    Reason["AccessControl"] = "access-control";
    Reason["MultiTenancy"] = "multi-tenancy";
    Reason["Enterprise"] = "enterprise";
    Reason["Others"] = "others";
})($78615cbd2ca0fb64$export$fe867595c4640fb1 || ($78615cbd2ca0fb64$export$fe867595c4640fb1 = {}));
var $78615cbd2ca0fb64$export$208cd1682bd0e4b6;
(function(Stage) {
    Stage["NewProduct"] = "new-product";
    Stage["ExistingProduct"] = "existing-product";
    Stage["TargetEnterpriseReady"] = "target-enterprise-ready";
})($78615cbd2ca0fb64$export$208cd1682bd0e4b6 || ($78615cbd2ca0fb64$export$208cd1682bd0e4b6 = {}));
var $78615cbd2ca0fb64$export$e03ccbddd0690b5c;
(function(AdditionalFeatures) {
    AdditionalFeatures["CustomizeUiAndFlow"] = "customize-ui-and-flow";
    AdditionalFeatures["Compliance"] = "compliance";
    AdditionalFeatures["ExportUserDataFromLogto"] = "export-user-data-from-logto";
    AdditionalFeatures["BudgetControl"] = "budget-control";
    AdditionalFeatures["BringOwnAuth"] = "bring-own-auth";
    AdditionalFeatures["Others"] = "others";
})($78615cbd2ca0fb64$export$e03ccbddd0690b5c || ($78615cbd2ca0fb64$export$e03ccbddd0690b5c = {}));
var $78615cbd2ca0fb64$var$questionnaireGuard = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    project: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($78615cbd2ca0fb64$export$b6032183171af19f).optional(),
    /** @deprecated Open-source options was for cloud preview use, no longer needed. Use default `Cloud` value for placeholder. */ deploymentType: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($78615cbd2ca0fb64$var$DeploymentType).optional().default($78615cbd2ca0fb64$var$DeploymentType.Cloud),
    /** @deprecated */ titles: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($78615cbd2ca0fb64$export$f99233281efd08a0)).optional(),
    companyName: (0, $a782240af38642b4$export$2e2bcd8739ae039).string().optional(),
    /** @deprecated */ companySize: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($78615cbd2ca0fb64$export$41cc48adf872ce3b).optional(),
    /** @deprecated */ reasons: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($78615cbd2ca0fb64$export$fe867595c4640fb1)).optional(),
    stage: (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($78615cbd2ca0fb64$export$208cd1682bd0e4b6).optional(),
    additionalFeatures: (0, $a782240af38642b4$export$2e2bcd8739ae039).array((0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($78615cbd2ca0fb64$export$e03ccbddd0690b5c)).optional()
});
var $78615cbd2ca0fb64$export$a9c4e6d214c76225 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object({
    questionnaire: $78615cbd2ca0fb64$var$questionnaireGuard.optional(),
    isOnboardingDone: (0, $a782240af38642b4$export$2e2bcd8739ae039).boolean().optional()
});











var $1106bbf8d019e9bd$export$1bb5e159b3d64354 = "admin-console";
var $1106bbf8d019e9bd$export$92b495973538657d = "demo-app";
var $1106bbf8d019e9bd$export$c3f41e16cf1f3ff0 = function(tenantId) {
    return {
        tenantId: tenantId,
        id: $1106bbf8d019e9bd$export$92b495973538657d,
        name: "Live Preview",
        secret: "N/A",
        description: "Preview for Sign-in Experience.",
        type: (0, $0adae18f63600c2d$export$d16f8fdf0c548b68).SPA,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        },
        customClientMetadata: {},
        protectedAppMetadata: null,
        isThirdParty: false,
        createdAt: 0
    };
};
var $1106bbf8d019e9bd$export$e6ae95e19af732a3 = function() {
    return Object.freeze({
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        id: $1106bbf8d019e9bd$export$1bb5e159b3d64354,
        name: "Admin Console",
        secret: (0, $77ca15834c94224a$export$877b6275f1b9e856)(),
        description: "Logto Admin Console.",
        type: (0, $0adae18f63600c2d$export$d16f8fdf0c548b68).SPA,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        }
    });
};
var $1106bbf8d019e9bd$export$7480c3dfa7c833f3 = function(tenantId) {
    return Object.freeze({
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
        name: "Cloud Service",
        description: "Machine to machine application for tenant ".concat(tenantId),
        secret: (0, $77ca15834c94224a$export$877b6275f1b9e856)(),
        type: (0, $0adae18f63600c2d$export$d16f8fdf0c548b68).MachineToMachine,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        },
        customClientMetadata: {
            tenantId: tenantId
        }
    });
};
var $1106bbf8d019e9bd$export$2d5b05d2f01b280 = function(applicationId, roleId) {
    return Object.freeze({
        id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        applicationId: applicationId,
        roleId: roleId
    });
};






var $a02da07ee051d0ed$export$e3fa12c425ddba26 = "https://cloud.logto.io/api";
var $a02da07ee051d0ed$export$fd6cfb345221c2ba;
(function(CloudScope) {
    /** The user can create a user tenant. */ CloudScope["CreateTenant"] = "create:tenant";
    /** The user can update or delete its own tenants. */ CloudScope["ManageTenantSelf"] = "manage:tenant:self";
    CloudScope["SendSms"] = "send:sms";
    CloudScope["SendEmail"] = "send:email";
    /**
     * The user can access external (independent from Logto instance) resource to run JWT payload customizer
     * scripts and fetch the parsed token payload.
     */ CloudScope["FetchCustomJwt"] = "fetch:custom:jwt";
    /** The user can see and manage affiliates, including create, update, and delete. */ CloudScope["ManageAffiliate"] = "manage:affiliate";
    /** The user can create new affiliates and logs. */ CloudScope["CreateAffiliate"] = "create:affiliate";
})($a02da07ee051d0ed$export$fd6cfb345221c2ba || ($a02da07ee051d0ed$export$fd6cfb345221c2ba = {}));
var $a02da07ee051d0ed$export$3ae0ed740a70db11 = function() {
    var resourceId = (0, $77ca15834c94224a$export$7e648d54e633633e)();
    var buildScope = function(name, description) {
        return {
            tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
            id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
            name: name,
            description: description,
            resourceId: resourceId
        };
    };
    return Object.freeze([
        {
            resource: {
                tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
                id: resourceId,
                indicator: $a02da07ee051d0ed$export$e3fa12c425ddba26,
                name: "Logto Cloud API"
            },
            scopes: [
                buildScope($a02da07ee051d0ed$export$fd6cfb345221c2ba.CreateTenant, "Allow creating new tenants."),
                buildScope($a02da07ee051d0ed$export$fd6cfb345221c2ba.ManageTenantSelf, "Allow managing tenant itself, including update and delete.")
            ],
            role: {
                tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
                name: (0, $3c7d99abf33fed0b$export$cc68ab3265ed0467).User
            }
        },
        buildScope($a02da07ee051d0ed$export$fd6cfb345221c2ba.SendEmail, "Allow sending emails. This scope is only available to M2M application."),
        buildScope($a02da07ee051d0ed$export$fd6cfb345221c2ba.SendSms, "Allow sending SMS. This scope is only available to M2M application."),
        buildScope($a02da07ee051d0ed$export$fd6cfb345221c2ba.FetchCustomJwt, "Allow accessing external resource to execute JWT payload customizer script and fetch the parsed token payload."),
        buildScope($a02da07ee051d0ed$export$fd6cfb345221c2ba.CreateAffiliate, "Allow creating new affiliates and logs."),
        buildScope($a02da07ee051d0ed$export$fd6cfb345221c2ba.ManageAffiliate, "Allow managing affiliates, including create, update, and delete.")
    ]);
};
var $a02da07ee051d0ed$export$233b871be9b6564f = function() {
    return {
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
        name: (0, $3c7d99abf33fed0b$export$cc68ab3265ed0467).TenantApplication,
        description: "The role for M2M applications that represent a user tenant and send requests to Logto Cloud.",
        type: (0, $0adae18f63600c2d$export$e57c3ccf0ca02b45).MachineToMachine,
        isDefault: false
    };
};






// Consider remove the dependency of IDs
var $a03dd4bfbf369a1d$var$defaultResourceId = "management-api";
var $a03dd4bfbf369a1d$var$defaultScopeAllId = "management-api-all";
var $a03dd4bfbf369a1d$export$711b817cd779af20 = Object.freeze({
    resource: {
        tenantId: (0, $2af3fef12ae5d626$export$ccc9014151910116),
        /** @deprecated You should not rely on this constant. Change to something else. */ id: $a03dd4bfbf369a1d$var$defaultResourceId,
        /**
         * The fixed resource indicator for Management APIs.
         *
         * Admin Console requires the access token of this resource to be functional.
         */ indicator: "https://".concat((0, $2af3fef12ae5d626$export$ccc9014151910116), ".logto.app/api"),
        name: "Logto Management API"
    },
    scopes: [
        {
            tenantId: (0, $2af3fef12ae5d626$export$ccc9014151910116),
            /** @deprecated You should not rely on this constant. Change to something else. */ id: $a03dd4bfbf369a1d$var$defaultScopeAllId,
            name: (0, $3c7d99abf33fed0b$export$90d62586f282d378).All,
            description: "Default scope for Management API, allows all permissions.",
            /** @deprecated You should not rely on this constant. Change to something else. */ resourceId: $a03dd4bfbf369a1d$var$defaultResourceId
        }
    ],
    /**
     * An internal user role for Management API of the `default` tenant.
     * @deprecated This role will be removed soon.
     */ role: {
        tenantId: (0, $2af3fef12ae5d626$export$ccc9014151910116),
        /** @deprecated You should not rely on this constant. Change to something else. */ id: "admin-role",
        name: (0, $3c7d99abf33fed0b$export$a17952fc1a8aded7).Admin,
        description: "Internal admin role for Logto tenant ".concat((0, $2af3fef12ae5d626$export$ccc9014151910116), "."),
        type: (0, $0adae18f63600c2d$export$e57c3ccf0ca02b45).MachineToMachine
    }
});
function $a03dd4bfbf369a1d$export$245dbc301cf93887(tenantId) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "api";
    return "https://".concat(tenantId, ".logto.app/").concat(path);
}
var $a03dd4bfbf369a1d$export$ba32cb0bde5eb6df = "".concat((0, $2af3fef12ae5d626$export$ccc9014151910116), ":admin");
var $a03dd4bfbf369a1d$export$c7852ca43795084 = function(tenantId) {
    var resourceId = (0, $77ca15834c94224a$export$7e648d54e633633e)();
    return Object.freeze({
        resource: {
            tenantId: tenantId,
            id: resourceId,
            indicator: $a03dd4bfbf369a1d$export$245dbc301cf93887(tenantId),
            name: "Logto Management API"
        },
        scopes: [
            {
                tenantId: tenantId,
                id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
                name: (0, $3c7d99abf33fed0b$export$90d62586f282d378).All,
                description: "Default scope for Management API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        /** @deprecated This role will be removed soon. */ role: {
            tenantId: tenantId,
            id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
            name: (0, $3c7d99abf33fed0b$export$a17952fc1a8aded7).Admin,
            description: "Internal admin role for Logto tenant ".concat((0, $2af3fef12ae5d626$export$ccc9014151910116), "."),
            type: (0, $0adae18f63600c2d$export$e57c3ccf0ca02b45).MachineToMachine
        }
    });
};
var $a03dd4bfbf369a1d$export$305b333dcaea6e0e = function(tenantId) {
    var resourceId = (0, $77ca15834c94224a$export$7e648d54e633633e)();
    return Object.freeze({
        resource: {
            tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
            id: resourceId,
            indicator: $a03dd4bfbf369a1d$export$245dbc301cf93887(tenantId),
            name: "Logto Management API for tenant ".concat(tenantId)
        },
        scopes: [
            {
                tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
                id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
                name: (0, $3c7d99abf33fed0b$export$90d62586f282d378).All,
                description: "Default scope for Management API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        /** The machine-to-machine role for the Management API proxy of the given tenant ID. */ role: (0, $911b2481794a33c6$export$a1252204700ae600)(tenantId)
    });
};
var $a03dd4bfbf369a1d$export$3e34893e87727786 = function() {
    var resourceId = (0, $77ca15834c94224a$export$7e648d54e633633e)();
    return Object.freeze({
        resource: {
            tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
            id: resourceId,
            indicator: $a03dd4bfbf369a1d$export$245dbc301cf93887((0, $2af3fef12ae5d626$export$87d9f170d46b6e1e), "me"),
            name: "Logto Me API"
        },
        scopes: [
            {
                tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
                id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
                name: (0, $3c7d99abf33fed0b$export$90d62586f282d378).All,
                description: "Default scope for Me API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        role: {
            tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
            id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
            name: (0, $3c7d99abf33fed0b$export$cc68ab3265ed0467).User,
            description: "Default role for admin tenant.",
            type: (0, $0adae18f63600c2d$export$e57c3ccf0ca02b45).User
        }
    });
};
var $a03dd4bfbf369a1d$export$60d9196a3fb69639 = function(tenantId) {
    return {
        tenantId: tenantId,
        id: (0, $77ca15834c94224a$export$7e648d54e633633e)(),
        description: "This default role grants access to the Logto management API.",
        name: "Logto Management API access",
        type: (0, $0adae18f63600c2d$export$e57c3ccf0ca02b45).MachineToMachine
    };
};




var $05c0927f890238a1$export$eac2ea73871449a = function(forTenantId) {
    return Object.freeze({
        tenantId: forTenantId,
        key: (0, $528d40be48481ad1$export$a249f1a8f5d6b725).AdminConsole,
        value: {
            signInExperienceCustomized: false,
            organizationCreated: false
        }
    });
};
var $05c0927f890238a1$export$fb8e6733ef2d5505 = function(forTenantId, appId, appSecret) {
    return Object.freeze({
        tenantId: forTenantId,
        key: (0, $528d40be48481ad1$export$a249f1a8f5d6b725).CloudConnection,
        value: {
            appId: appId,
            appSecret: appSecret,
            resource: (0, $a02da07ee051d0ed$export$e3fa12c425ddba26)
        }
    });
};








var $3f40c016a64d8bd0$var$defaultPrimaryColor = "#6139F6";
var $3f40c016a64d8bd0$export$9aabb866d7e7cb45 = function(forTenantId, isCloud) {
    return Object.freeze({
        tenantId: forTenantId,
        id: "default",
        color: {
            primaryColor: $3f40c016a64d8bd0$var$defaultPrimaryColor,
            isDarkModeEnabled: false,
            darkPrimaryColor: (0, $bac3379ca35f67cc$export$2feb0cd4df065982)($3f40c016a64d8bd0$var$defaultPrimaryColor)
        },
        branding: {
            logoUrl: isCloud ? undefined : "https://logto.io/logo.svg",
            darkLogoUrl: isCloud ? undefined : "https://logto.io/logo-dark.svg"
        },
        languageInfo: {
            autoDetect: true,
            fallbackLanguage: "en"
        },
        termsOfUseUrl: null,
        privacyPolicyUrl: null,
        signUp: {
            identifiers: [
                isCloud ? (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email : (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username
            ],
            password: true,
            verify: isCloud
        },
        signIn: {
            methods: [
                {
                    identifier: isCloud ? (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email : (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username,
                    password: true,
                    verificationCode: false,
                    isPasswordPrimary: true
                }
            ]
        },
        socialSignInConnectorTargets: [],
        signInMode: (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).SignInAndRegister,
        customCss: null,
        customContent: {},
        passwordPolicy: {},
        mfa: {
            factors: [],
            policy: (0, $6ae7ce06f09cd84a$export$da22c5f01b0bc81).UserControlled
        }
    });
};
var $3f40c016a64d8bd0$export$7e36ef2bc7e2871f = $3f40c016a64d8bd0$export$9aabb866d7e7cb45((0, $2af3fef12ae5d626$export$ccc9014151910116), false);
var $3f40c016a64d8bd0$export$e9fd471c1ae91561 = function() {
    return Object.freeze((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $3f40c016a64d8bd0$export$7e36ef2bc7e2871f), {
        tenantId: (0, $2af3fef12ae5d626$export$87d9f170d46b6e1e),
        color: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $3f40c016a64d8bd0$export$7e36ef2bc7e2871f.color), {
            isDarkModeEnabled: true
        }),
        signInMode: (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).Register,
        branding: {
            logoUrl: "https://logto.io/logo.svg",
            darkLogoUrl: "https://logto.io/logo-dark.svg"
        }
    }));
};





var $e6c762963a8ced63$export$58a828960e98f161 = "_logto";


/**
 * In OSS:
 *
 * - Only one single user tenant (`default`) is available.
 * - Admin tenant and Admin Console share one endpoint (`ADMIN_ENDPOINT`).
 *
 * There's no need to parse tenant ID from the first path segment in OSS, and the segment should be a fixed value.
 *
 * If we use `/default`, the URL will look ugly; thus we keep the old fashion `/console`.
 */ var $8aec93a1500ef775$export$c114d6e260d7e866 = "/console";




var $575e69f821fa07d6$export$41e1f3752bfbbffc = Object.freeze({
    oneMinute: 60,
    oneHour: 3600,
    oneDay: 86400
});


var $423ee60d4739fc64$export$69773729edd6695 = "tenant_id";
var $423ee60d4739fc64$export$2d48ae5b9b7ef84 = Object.freeze({
    idTokenTtl: (0, $575e69f821fa07d6$export$41e1f3752bfbbffc).oneHour,
    refreshTokenTtlInDays: 14,
    rotateRefreshToken: true
});
var $423ee60d4739fc64$export$d59e370a591c2f6e;
(function(ExtraParamsKey) {
    /**
     * @deprecated Use {@link FirstScreen} instead.
     * @see {@link InteractionMode} for the available values.
     */ ExtraParamsKey["InteractionMode"] = "interaction_mode";
    /**
     * The first screen to show for the user.
     *
     * @see {@link FirstScreen} for the available values.
     */ ExtraParamsKey["FirstScreen"] = "first_screen";
    /**
     * Directly sign in via the specified method. Note that the method must be properly configured
     * in Logto.
     *
     * @remark
     * The format of the value for this key is one of the following:
     *
     * - `social:<target>` (Use a social connector with the specified target, e.g. `social:google`)
     * - `sso:<connector-id>` (Use the specified SSO connector, e.g. `sso:123456`)
     */ ExtraParamsKey["DirectSignIn"] = "direct_sign_in";
})($423ee60d4739fc64$export$d59e370a591c2f6e || ($423ee60d4739fc64$export$d59e370a591c2f6e = {}));
var $423ee60d4739fc64$export$d184c05d3e025a16;
(function(InteractionMode) {
    InteractionMode["SignIn"] = "signIn";
    InteractionMode["SignUp"] = "signUp";
})($423ee60d4739fc64$export$d184c05d3e025a16 || ($423ee60d4739fc64$export$d184c05d3e025a16 = {}));
var $423ee60d4739fc64$export$fa38afa20f77931e;
(function(FirstScreen) {
    FirstScreen["SignIn"] = "signIn";
    FirstScreen["Register"] = "register";
})($423ee60d4739fc64$export$fa38afa20f77931e || ($423ee60d4739fc64$export$fa38afa20f77931e = {}));
var $423ee60d4739fc64$var$_obj;
var $423ee60d4739fc64$export$d4edee201590d836 = (0, $a782240af38642b4$export$2e2bcd8739ae039).object(($423ee60d4739fc64$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($423ee60d4739fc64$var$_obj, $423ee60d4739fc64$export$d59e370a591c2f6e.InteractionMode, (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($423ee60d4739fc64$export$d184c05d3e025a16)), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($423ee60d4739fc64$var$_obj, $423ee60d4739fc64$export$d59e370a591c2f6e.FirstScreen, (0, $a782240af38642b4$export$2e2bcd8739ae039).nativeEnum($423ee60d4739fc64$export$fa38afa20f77931e)), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($423ee60d4739fc64$var$_obj, $423ee60d4739fc64$export$d59e370a591c2f6e.DirectSignIn, (0, $a782240af38642b4$export$2e2bcd8739ae039).string()), $423ee60d4739fc64$var$_obj)).partial();



var $fc0d5d55a529d9c8$export$33e784254961b75a = 10;


/**
 * Logto-provided predefined subscription plan IDs.
 *
 * In theory, the subscription plan ID will be a random string,
 * but Logto provides some predefined subscription plans and their IDs are reserved plan IDs.
 */ var $9e6d82ccd3e66151$export$70d79c7c84af5a3e;
(function(ReservedPlanId) {
    ReservedPlanId["Free"] = "free";
    /**
     * @deprecated
     * In recent refactoring, the `hobby` plan is now treated as the `pro` plan.
     * Only use this plan ID to check if a plan is a `pro` plan or not.
     * This plan ID will be renamed to `pro` after legacy Stripe data is migrated by @darcyYe
     *
     * Todo @darcyYe:
     * - LOG-7846: Rename `hobby` to `pro` and `pro` to `legacy-pro`
     * - LOG-8339: Migrate legacy Stripe data
     */ ReservedPlanId["Hobby"] = "hobby";
    /**
     * @deprecated
     * Now this `pro` ID is not used anymore, we use `hobby` as the `pro` plan ID.
     * Only use this `pro` value when displaying the plan ID to the user.
     *
     * Todo @darcyYe see `Hobby` todo
     */ ReservedPlanId["Pro"] = "pro";
    ReservedPlanId["Development"] = "dev";
})($9e6d82ccd3e66151$export$70d79c7c84af5a3e || ($9e6d82ccd3e66151$export$70d79c7c84af5a3e = {}));


var $02d5c091c91c4f6f$var$routes = Object.freeze({
    signIn: "sign-in",
    register: "register",
    sso: "single-sign-on",
    consent: "consent"
});
var $02d5c091c91c4f6f$export$45794d16c9d83fe2 = Object.freeze({
    routes: $02d5c091c91c4f6f$var$routes
});




/** @deprecated We don't restrict roles in the database anymore. */ var $6fc8400ddb10c671$export$7ebc507e3327c47b = "#internal:";
var $6fc8400ddb10c671$export$9aaedfefea44825f = function(roleName) {
    return roleName.startsWith($6fc8400ddb10c671$export$7ebc507e3327c47b);
};


var $c6e5c3f8f5e9f191$export$5ae1b4d89745ee61 = function(indicator) {
    return /^https:\/\/[^.]+\.logto\.app\/api$/.test(indicator);
};



var $544e29414b73de02$export$642cfcc4b084a733 = function(domains) {
    var blackListSet = new Set((0, $82b6ecb2e23c540b$export$92ee0fc3a3bf5566));
    var validDomainSet = new Set();
    var duplicatedDomains = new Set();
    var forbiddenDomains = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (domains !== null && domains !== void 0 ? domains : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var domain = _step.value;
            if (blackListSet.has(domain)) forbiddenDomains.add(domain);
            if (validDomainSet.has(domain)) duplicatedDomains.add(domain);
            else validDomainSet.add(domain);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        duplicatedDomains: duplicatedDomains,
        forbiddenDomains: forbiddenDomains
    };
};






/**
 * React Router DOM v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $kVN77 = parcelRequire("kVN77");
/**
 * @remix-run/router v1.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 









function $e72e4976c7e28e30$export$e62c166da838fa3(arr) {
    return (0, $101e88ca0fd42f5a$export$e6256bf45c68d561)(arr) || (0, $c7301c0efd5ad07b$export$1eb58a6e75231000)(arr) || (0, $a46603d5dce0e429$export$a5be06335b3a083c)(arr) || (0, $b23c16ab02ec78cc$export$60dbc22abd7da546)();
}







function $9302892d54567256$var$_extends() {
    $9302892d54567256$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9302892d54567256$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $9302892d54567256$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($9302892d54567256$export$e19cd5f9376f8cee || ($9302892d54567256$export$e19cd5f9376f8cee = {}));
var $9302892d54567256$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $9302892d54567256$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $9302892d54567256$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $9302892d54567256$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $9302892d54567256$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $9302892d54567256$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $9302892d54567256$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $9302892d54567256$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $9302892d54567256$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $9302892d54567256$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $9302892d54567256$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $9302892d54567256$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $9302892d54567256$export$fe53371bee54353d(to);
    }
    return $9302892d54567256$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $9302892d54567256$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $9302892d54567256$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        return $9302892d54567256$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $9302892d54567256$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $9302892d54567256$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $9302892d54567256$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $9302892d54567256$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $9302892d54567256$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $9302892d54567256$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $9302892d54567256$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $9302892d54567256$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $9302892d54567256$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $9302892d54567256$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $9302892d54567256$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $9302892d54567256$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $9302892d54567256$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $9302892d54567256$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, _$window = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = _$window.history;
    var action = $9302892d54567256$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($9302892d54567256$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $9302892d54567256$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $9302892d54567256$export$e19cd5f9376f8cee.Push;
        var location = $9302892d54567256$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $9302892d54567256$var$getHistoryState(location, index);
        var url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            _$window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $9302892d54567256$export$e19cd5f9376f8cee.Replace;
        var location = $9302892d54567256$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $9302892d54567256$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = _$window.location.origin !== "null" ? _$window.location.origin : _$window.location.href;
        var href = typeof to === "string" ? to : $9302892d54567256$export$fe53371bee54353d(to);
        $9302892d54567256$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(_$window, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            _$window.addEventListener($9302892d54567256$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                _$window.removeEventListener($9302892d54567256$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(_$window, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $9302892d54567256$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($9302892d54567256$var$ResultType || ($9302892d54567256$var$ResultType = {}));
var $9302892d54567256$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $9302892d54567256$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $9302892d54567256$export$4a6d22b32134ea5d(routes, detectErrorBoundary, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $9302892d54567256$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $9302892d54567256$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($9302892d54567256$var$isIndexRoute(route)) {
            var indexRoute = $9302892d54567256$var$_extends({}, route, {
                hasErrorBoundary: detectErrorBoundary(route),
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $9302892d54567256$var$_extends({}, route, {
                id: id,
                hasErrorBoundary: detectErrorBoundary(route),
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $9302892d54567256$export$4a6d22b32134ea5d(route.children, detectErrorBoundary, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $9302892d54567256$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $9302892d54567256$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $9302892d54567256$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $9302892d54567256$var$flattenRoutes(routes);
    $9302892d54567256$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $9302892d54567256$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $9302892d54567256$var$safelyDecodeURI(pathname));
    return matches;
}
function $9302892d54567256$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $9302892d54567256$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $9302892d54567256$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $9302892d54567256$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $9302892d54567256$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $9302892d54567256$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $9302892d54567256$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $9302892d54567256$var$explodeOptionalSegments(path) {
    var // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $e72e4976c7e28e30$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1); // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $9302892d54567256$var$explodeOptionalSegments(rest.join("/"));
    var result = []; // All child paths with the prefix.  Do this for all children before the
    (_result = result).push.apply(_result, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    }))); // Then if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(restExploded));
     // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $9302892d54567256$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $9302892d54567256$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $9302892d54567256$var$paramRe = /^:\w+$/;
var $9302892d54567256$var$dynamicSegmentValue = 3;
var $9302892d54567256$var$indexRouteValue = 2;
var $9302892d54567256$var$emptySegmentValue = 1;
var $9302892d54567256$var$staticSegmentValue = 10;
var $9302892d54567256$var$splatPenalty = -2;
var $9302892d54567256$var$isSplat = function(s) {
    return s === "*";
};
function $9302892d54567256$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($9302892d54567256$var$isSplat)) initialScore += $9302892d54567256$var$splatPenalty;
    if (index) initialScore += $9302892d54567256$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$9302892d54567256$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($9302892d54567256$var$paramRe.test(segment) ? $9302892d54567256$var$dynamicSegmentValue : segment === "" ? $9302892d54567256$var$emptySegmentValue : $9302892d54567256$var$staticSegmentValue);
    }, initialScore);
}
function $9302892d54567256$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $9302892d54567256$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $9302892d54567256$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $9302892d54567256$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $9302892d54567256$export$a5c6d149b50c1d86($9302892d54567256$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $9302892d54567256$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $9302892d54567256$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $9302892d54567256$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            var starParam = params[star]; // Apply the splat
            return starParam;
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $9302892d54567256$export$3e9cee6b33872309(false, 'Missing ":' + key + '" param');
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $9302892d54567256$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($9302892d54567256$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], paramNames = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = paramNames.reduce(function(memo, paramName, index) {
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $9302892d54567256$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $9302892d54567256$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $9302892d54567256$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var paramNames = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, function(_, paramName) {
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $9302892d54567256$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $9302892d54567256$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $9302892d54567256$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $9302892d54567256$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $9302892d54567256$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $9302892d54567256$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $9302892d54567256$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $9302892d54567256$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $9302892d54567256$var$normalizeSearch(search),
        hash: $9302892d54567256$var$normalizeHash(hash)
    };
}
function $9302892d54567256$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $9302892d54567256$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $9302892d54567256$export$90ba53ce1c7fdff2(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function $9302892d54567256$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $9302892d54567256$export$8ccf933b0513f8d0(toArg);
    else {
        to = $9302892d54567256$var$_extends({}, toArg);
        $9302892d54567256$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $9302892d54567256$var$getInvalidPathError("?", "pathname", "search", to));
        $9302892d54567256$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $9302892d54567256$var$getInvalidPathError("#", "pathname", "hash", to));
        $9302892d54567256$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $9302892d54567256$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $9302892d54567256$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $9302892d54567256$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $9302892d54567256$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $9302892d54567256$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $9302892d54567256$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $9302892d54567256$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $9302892d54567256$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $9302892d54567256$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $9302892d54567256$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $9302892d54567256$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(AbortedDeferredError, Error1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $efec3851c979cc44$export$2466d533fda16e33)(Error));
var $9302892d54567256$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $9302892d54567256$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $9302892d54567256$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref) {
            var _$_ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            return Object.assign(acc, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, null, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                }); // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $9302892d54567256$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                if (error) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var aborted, onAbort;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $9302892d54567256$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref2) {
                    var _$_ref2 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
                    return Object.assign(acc, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, key, $9302892d54567256$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $9302892d54567256$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $9302892d54567256$var$unwrapTrackedPromise(value) {
    if (!$9302892d54567256$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $9302892d54567256$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $9302892d54567256$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $9302892d54567256$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $9302892d54567256$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ var $9302892d54567256$export$acf1a680051f5031 = function ErrorResponse(status, statusText, data, internal) {
    "use strict";
    (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ErrorResponse);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $9302892d54567256$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $9302892d54567256$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $9302892d54567256$var$validMutationMethods = new Set($9302892d54567256$var$validMutationMethodsArr);
var $9302892d54567256$var$validRequestMethodsArr = [
    "get"
].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)($9302892d54567256$var$validMutationMethodsArr));
var $9302892d54567256$var$validRequestMethods = new Set($9302892d54567256$var$validRequestMethodsArr);
var $9302892d54567256$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $9302892d54567256$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $9302892d54567256$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
var $9302892d54567256$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
var $9302892d54567256$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $9302892d54567256$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $9302892d54567256$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $9302892d54567256$var$isServer = !$9302892d54567256$var$isBrowser;
var $9302892d54567256$var$defaultDetectErrorBoundary = function(route) {
    return Boolean(route.hasErrorBoundary);
}; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $9302892d54567256$export$baddd0131ee8c05b(init) {
    $9302892d54567256$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var detectErrorBoundary = init.detectErrorBoundary || $9302892d54567256$var$defaultDetectErrorBoundary; // Routes keyed by ID
    var manifest = {}; // Routes in tree format for matching
    var dataRoutes = $9302892d54567256$export$4a6d22b32134ea5d(init.routes, detectErrorBoundary, undefined, manifest);
    var inFlightDataRoutes; // Config driven behavior flags
    var future = $9302892d54567256$var$_extends({
        v7_normalizeFormMethod: false
    }, init.future); // Cleanup function for history
    var unlistenHistory = null; // Externally-provided functions to call on all state changes
    var subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    var getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $9302892d54567256$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $9302892d54567256$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $9302892d54567256$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, route.id, error);
    }
    var initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $9302892d54567256$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $9302892d54567256$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false; // AbortController for the active navigation
    var pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map(); // Track loads based on the order in which they started
    var incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    var fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $9302892d54567256$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($9302892d54567256$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $9302892d54567256$var$_extends({}, state, newState);
        subscribers.forEach(function(subscriber) {
            return subscriber(state);
        });
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $9302892d54567256$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $9302892d54567256$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // so we can start fresh
            for(var _iterator = blockerFunctions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 1), key = _step_value[0];
                deleteBlocker(key);
            } // Always respect the user flag.  Otherwise don't reset on mutation
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $9302892d54567256$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($9302892d54567256$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $9302892d54567256$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $9302892d54567256$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $9302892d54567256$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $9302892d54567256$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $9302892d54567256$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // replace with an optional submission
        (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(to, opts) {
            var _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, blockerKey;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        _normalizeNavigateOptions = $9302892d54567256$var$normalizeNavigateOptions(to, future, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $9302892d54567256$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $9302892d54567256$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $9302892d54567256$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $9302892d54567256$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $9302892d54567256$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $9302892d54567256$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    }); // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    deleteBlocker(blockerKey);
                                    updateState({
                                        blockers: new Map(state.blockers)
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        } // Revalidate all current loaders.  If a navigation is in progress or if this
        );
        return _navigate.apply(this, arguments);
    }
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, navigation, _ref, shortCircuited, loaderData, errors;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $9302892d54567256$export$2708184779ceb39d(routesToUse, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $9302892d54567256$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $9302892d54567256$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route; // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, route.id, error)
                            });
                            return [
                                2
                            ];
                        } // Short circuit if it's only a hash change and not a mutation submission
                        // For example, on /page#hash and submit a <Form method="post"> which will
                        // default to a navigation to /page
                        if ($9302892d54567256$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $9302892d54567256$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            });
                            return [
                                2
                            ];
                        } // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $9302892d54567256$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, $9302892d54567256$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $9302892d54567256$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        navigation = $9302892d54567256$var$_extends({
                            state: "loading",
                            location: location
                        }, opts.submission);
                        loadingNavigation = navigation; // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                         // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $9302892d54567256$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        } // Call the action matched by the leaf route for this navigation and handle
        );
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // redirects/errors
        (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads(); // Put us in a submitting state
                        navigation = $9302892d54567256$var$_extends({
                            state: "submitting",
                            location: location
                        }, submission);
                        updateState({
                            navigation: navigation
                        }); // Call our action and get the result
                        actionMatch = $9302892d54567256$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $9302892d54567256$var$ResultType.error,
                            error: $9302892d54567256$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $9302892d54567256$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, router.basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$9302892d54567256$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($9302892d54567256$var$isErrorResult(result)) {
                            boundaryMatch = $9302892d54567256$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $9302892d54567256$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($9302892d54567256$var$isDeferredResult(result)) throw $9302892d54567256$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        } // Call all applicable loaders for the given matches, handling redirects,
        );
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // errors, etc.
        (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
            var loadingNavigation, navigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, actionData, _ref, results, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, didAbortFetchLoads;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation;
                        if (!loadingNavigation) {
                            navigation = $9302892d54567256$var$_extends({
                                state: "loading",
                                location: location,
                                formMethod: undefined,
                                formAction: undefined,
                                formEncType: undefined,
                                formData: undefined
                            }, submission);
                            loadingNavigation = navigation;
                        } // If this was a redirect from an action we don't have a "submission" but
                        activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
                            formMethod: loadingNavigation.formMethod,
                            formAction: loadingNavigation.formAction,
                            formData: loadingNavigation.formData,
                            formEncType: loadingNavigation.formEncType
                        } : undefined;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($9302892d54567256$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1]; // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        }); // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            completeNavigation(location, $9302892d54567256$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}));
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        } // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = {
                                    state: "loading",
                                    data: fetcher && fetcher.data,
                                    formMethod: undefined,
                                    formAction: undefined,
                                    formEncType: undefined,
                                    formData: undefined,
                                    " _hasFetcherDoneAnything ": true
                                };
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($9302892d54567256$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                        }
                        pendingNavigationLoadId = ++incrementingLoadId;
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.set(rf.key, pendingNavigationController);
                        });
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                         // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        }); // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $9302892d54567256$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            startRedirectNavigation(state, redirect, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        _processLoaderData = $9302892d54567256$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors; // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        return [
                            2,
                            $9302892d54567256$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $9302892d54567256$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($9302892d54567256$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var matches = $9302892d54567256$export$2708184779ceb39d(routesToUse, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $9302892d54567256$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        var _normalizeNavigateOptions = $9302892d54567256$var$normalizeNavigateOptions(href, future, opts, true), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission;
        var match = $9302892d54567256$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $9302892d54567256$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // errors, and revalidation
        (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(key, routeId, path, match, requestMatches, submission) {
            var error, existingFetcher, fetcher, abortController, fetchRequest, actionResult, loadingFetcher, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, _ref, results, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher, didAbortFetchLoads;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $9302892d54567256$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error);
                            return [
                                2
                            ];
                        } // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        fetcher = $9302892d54567256$var$_extends({
                            state: "submitting"
                        }, submission, {
                            data: existingFetcher && existingFetcher.data,
                            " _hasFetcherDoneAnything ": true
                        });
                        state.fetchers.set(key, fetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        }); // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $9302892d54567256$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        return [
                            4,
                            $9302892d54567256$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, detectErrorBoundary, router.basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by ou our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if ($9302892d54567256$var$isRedirectResult(actionResult)) {
                            fetchControllers.delete(key);
                            fetchRedirectIds.add(key);
                            loadingFetcher = $9302892d54567256$var$_extends({
                                state: "loading"
                            }, submission, {
                                data: undefined,
                                " _hasFetcherDoneAnything ": true
                            });
                            state.fetchers.set(key, loadingFetcher);
                            updateState({
                                fetchers: new Map(state.fetchers)
                            });
                            return [
                                2,
                                startRedirectNavigation(state, actionResult, {
                                    submission: submission,
                                    isFetchActionRedirect: true
                                })
                            ];
                        } // Process any non-redirect errors thrown
                        if ($9302892d54567256$var$isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if ($9302892d54567256$var$isDeferredResult(actionResult)) throw $9302892d54567256$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                         // Start the data load for current matches, or the next location if we're
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $9302892d54567256$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $9302892d54567256$export$2708184779ceb39d(routesToUse, state.navigation.location, init.basename) : state.matches;
                        $9302892d54567256$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $9302892d54567256$var$_extends({
                            state: "loading",
                            data: actionResult.data
                        }, submission, {
                            " _hasFetcherDoneAnything ": true
                        });
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($9302892d54567256$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1]; // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = {
                                state: "loading",
                                data: existingFetcher && existingFetcher.data,
                                formMethod: undefined,
                                formAction: undefined,
                                formEncType: undefined,
                                formData: undefined,
                                " _hasFetcherDoneAnything ": true
                            };
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            fetchControllers.set(staleKey, abortController);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $9302892d54567256$var$findRedirect(results);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(state, redirect)
                        ];
                         // Process and commit output from loaders
                        _processLoaderData = $9302892d54567256$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        doneFetcher = {
                            state: "idle",
                            data: actionResult.data,
                            formMethod: undefined,
                            formAction: undefined,
                            formEncType: undefined,
                            formData: undefined,
                            " _hasFetcherDoneAnything ": true
                        };
                        state.fetchers.set(key, doneFetcher);
                        didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $9302892d54567256$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState($9302892d54567256$var$_extends({
                                errors: errors,
                                loaderData: $9302892d54567256$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
                            }, didAbortFetchLoads ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        );
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(key, routeId, path, match, matches, submission) {
            var existingFetcher, loadingFetcher, abortController, fetchRequest, result, boundaryMatch, doneFetcher;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
                        loadingFetcher = $9302892d54567256$var$_extends({
                            state: "loading",
                            formMethod: undefined,
                            formAction: undefined,
                            formEncType: undefined,
                            formData: undefined
                        }, submission, {
                            data: existingFetcher && existingFetcher.data,
                            " _hasFetcherDoneAnything ": true
                        });
                        state.fetchers.set(key, loadingFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        }); // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $9302892d54567256$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        return [
                            4,
                            $9302892d54567256$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, detectErrorBoundary, router.basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$9302892d54567256$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $9302892d54567256$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                         // If the loader threw a redirect Response, start a new REPLACE navigation
                        if (!$9302892d54567256$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        if ($9302892d54567256$var$isErrorResult(result)) {
                            boundaryMatch = $9302892d54567256$var$findNearestBoundary(state.matches, routeId);
                            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
                            // do we need to behave any differently with our non-redirect errors?
                            // What if it was a non-redirect Response?
                            updateState({
                                fetchers: new Map(state.fetchers),
                                errors: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error)
                            });
                            return [
                                2
                            ];
                        }
                        $9302892d54567256$export$3e9cee6b33872309(!$9302892d54567256$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
                        doneFetcher = {
                            state: "idle",
                            data: result.data,
                            formMethod: undefined,
                            formAction: undefined,
                            formEncType: undefined,
                            formData: undefined,
                            " _hasFetcherDoneAnything ": true
                        };
                        state.fetchers.set(key, doneFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(state, redirect, _temp) {
            var _window, _ref, submission, replace, isFetchActionRedirect, redirectLocation, url, isDifferentBasename, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, formData;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp === void 0 ? {} : _temp, submission = _ref.submission, replace = _ref.replace, isFetchActionRedirect = _ref.isFetchActionRedirect;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $9302892d54567256$var$createLocation(state.location, redirect.location, $9302892d54567256$var$_extends({
                            _isRedirect: true
                        }, isFetchActionRedirect ? {
                            _isFetchActionRedirect: true
                        } : {}));
                        $9302892d54567256$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
                        if ($9302892d54567256$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $9302892d54567256$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
                            url = init.history.createURL(redirect.location);
                            isDifferentBasename = $9302892d54567256$export$b69e3301ce081aa3(url.pathname, init.basename || "/") == null;
                            if (window.location.origin !== url.origin || isDifferentBasename) {
                                if (replace) window.location.replace(redirect.location);
                                else window.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        } // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $9302892d54567256$export$e19cd5f9376f8cee.Replace : $9302892d54567256$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType, formData = _state_navigation.formData;
                        if (!submission && formMethod && formAction && formData && formEncType) submission = {
                            formMethod: formMethod,
                            formAction: formAction,
                            formEncType: formEncType,
                            formData: formData
                        };
                         // If this was a 307/308 submission we want to preserve the HTTP method and
                        if (!($9302892d54567256$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $9302892d54567256$var$isMutationMethod(submission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $9302892d54567256$var$_extends({}, submission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!isFetchActionRedirect) return [
                            3,
                            4
                        ];
                        // For a fetch action redirect, we kick off a new loading navigation
                        // without the fetcher submission, but we send it along for shouldRevalidate
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: {
                                    state: "loading",
                                    location: redirectLocation,
                                    formMethod: undefined,
                                    formAction: undefined,
                                    formEncType: undefined,
                                    formData: undefined
                                },
                                fetcherSubmission: submission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        // Otherwise, we kick off a new loading navigation, preserving the
                        // submission info for the duration of this navigation
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: {
                                    state: "loading",
                                    location: redirectLocation,
                                    formMethod: submission ? submission.formMethod : undefined,
                                    formAction: submission ? submission.formAction : undefined,
                                    formEncType: submission ? submission.formEncType : undefined,
                                    formData: submission ? submission.formData : undefined
                                },
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(matchesToLoad.map(function(match) {
                                return $9302892d54567256$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, router.basename);
                            })).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match) return $9302892d54567256$var$callLoaderOrAction("loader", $9302892d54567256$var$createClientSideRequest(init.history, f.path, request.signal), f.match, f.matches, manifest, detectErrorBoundary, router.basename);
                                else {
                                    var error = {
                                        type: $9302892d54567256$var$ResultType.error,
                                        error: $9302892d54567256$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $9302892d54567256$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
                                $9302892d54567256$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, request.signal, true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(cancelActiveDeferreds())); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        var boundaryMatch = $9302892d54567256$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $9302892d54567256$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = {
                    state: "idle",
                    data: fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $9302892d54567256$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $9302892d54567256$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $9302892d54567256$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $9302892d54567256$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $9302892d54567256$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $9302892d54567256$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || function(location) {
            return location.key;
        }; // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $9302892d54567256$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            var userMatches = matches.map(function(m) {
                return $9302892d54567256$var$createUseMatchesMatch(m, state.loaderData);
            });
            var key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            var userMatches = matches.map(function(m) {
                return $9302892d54567256$var$createUseMatchesMatch(m, state.loaderData);
            });
            var key = getScrollRestorationKey(location, userMatches) || location.key;
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        inFlightDataRoutes = newRoutes;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $9302892d54567256$export$4d0306f8f6a4585b = Symbol("deferred");
function $9302892d54567256$export$3336b097a6fbc59a(routes, opts) {
    $9302892d54567256$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var detectErrorBoundary = (opts == null ? void 0 : opts.detectErrorBoundary) || $9302892d54567256$var$defaultDetectErrorBoundary;
    var dataRoutes = $9302892d54567256$export$4a6d22b32134ea5d(routes, detectErrorBoundary, undefined, manifest);
    var basename = (opts ? opts.basename : null) || "/";
    function query(request, _temp2) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(request, _temp2) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp2 === void 0 ? {} : _temp2).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $9302892d54567256$var$createLocation("", $9302892d54567256$export$fe53371bee54353d(url), null, "default");
                        matches = $9302892d54567256$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
                        if (!$9302892d54567256$var$isValidMethod(method) && method !== "HEAD") {
                            error = $9302892d54567256$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $9302892d54567256$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $9302892d54567256$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $9302892d54567256$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($9302892d54567256$var$isResponse(result)) return [
                            2,
                            result
                        ];
                         // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $9302892d54567256$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp3) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(request, _temp3) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $9302892d54567256$var$createLocation("", $9302892d54567256$export$fe53371bee54353d(url), null, "default");
                        matches = $9302892d54567256$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
                        if (!$9302892d54567256$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $9302892d54567256$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $9302892d54567256$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $9302892d54567256$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $9302892d54567256$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $9302892d54567256$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($9302892d54567256$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                         // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$9302892d54567256$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $9302892d54567256$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$9302892d54567256$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $9302892d54567256$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $9302892d54567256$var$isResponse(result1) ? result1 : $9302892d54567256$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($9302892d54567256$var$isQueryRouteResponse(e)) {
                            if (e.type === $9302892d54567256$var$ResultType.error && !$9302892d54567256$var$isRedirectResponse(e.response)) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        } // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($9302892d54567256$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $9302892d54567256$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $9302892d54567256$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $9302892d54567256$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        }
                        _state.label = 3;
                    case 3:
                        if ($9302892d54567256$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($9302892d54567256$var$isDeferredResult(result)) {
                            error1 = $9302892d54567256$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $9302892d54567256$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($9302892d54567256$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$9302892d54567256$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch = $9302892d54567256$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        return [
                            2,
                            $9302892d54567256$var$_extends({}, context, {
                                statusCode: $9302892d54567256$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $9302892d54567256$var$_extends({}, result.headers ? (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $9302892d54567256$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data),
                                actionHeaders: $9302892d54567256$var$_extends({}, result.headers ? (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $9302892d54567256$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $9302892d54567256$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        }); // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(matchesToLoad.map(function(match) {
                                return $9302892d54567256$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext);
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        } // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $9302892d54567256$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $9302892d54567256$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $9302892d54567256$export$fec11da027c70692(routes, context, error) {
    var newContext = $9302892d54567256$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $9302892d54567256$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $9302892d54567256$var$normalizeNavigateOptions(to, future, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    var path = typeof to === "string" ? to : $9302892d54567256$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$9302892d54567256$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$9302892d54567256$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $9302892d54567256$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    var submission;
    if (opts.formData) {
        var formMethod = opts.formMethod || "get";
        submission = {
            formMethod: future.v7_normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $9302892d54567256$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($9302892d54567256$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $9302892d54567256$export$8ccf933b0513f8d0(path);
    var searchParams = $9302892d54567256$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
    // navigation GET submissions which run all loaders), we need to preserve
    // any incoming ?index params
    if (isFetcher && parsedPath.search && $9302892d54567256$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $9302892d54567256$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $9302892d54567256$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $9302892d54567256$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    var defaultShouldRevalidate = isRevalidationRequired || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search; // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $9302892d54567256$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($9302892d54567256$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $9302892d54567256$var$shouldRevalidateLoader(match, $9302892d54567256$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate || $9302892d54567256$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        })) return;
        var fetcherMatches = $9302892d54567256$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push($9302892d54567256$var$_extends({
                key: key
            }, f, {
                matches: null,
                match: null
            }));
            return;
        }
        var fetcherMatch = $9302892d54567256$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push($9302892d54567256$var$_extends({
                key: key,
                matches: fetcherMatches,
                match: fetcherMatch
            }, f));
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        var shouldRevalidate = $9302892d54567256$var$shouldRevalidateLoader(fetcherMatch, $9302892d54567256$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (shouldRevalidate) revalidatingFetchers.push($9302892d54567256$var$_extends({
            key: key,
            matches: fetcherMatches,
            match: fetcherMatch
        }, f));
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $9302892d54567256$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $9302892d54567256$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $9302892d54567256$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $9302892d54567256$var$loadLazyRouteModule(route, detectErrorBoundary, manifest) {
    return $9302892d54567256$var$_loadLazyRouteModule.apply(this, arguments);
}
function $9302892d54567256$var$_loadLazyRouteModule() {
    $9302892d54567256$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(route, detectErrorBoundary, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $9302892d54567256$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $9302892d54567256$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$9302892d54567256$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    } // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to detectErrorBoundary
                    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, {
                        // To keep things framework agnostic, we use the provided
                        // `detectErrorBoundary` function to set the `hasErrorBoundary` route
                        // property since the logic will differ between frameworks.
                        hasErrorBoundary: detectErrorBoundary($9302892d54567256$var$_extends({}, routeToUpdate)),
                        lazy: undefined
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return $9302892d54567256$var$_loadLazyRouteModule.apply(this, arguments);
}
function $9302892d54567256$var$callLoaderOrAction(type, request, match, matches, manifest, detectErrorBoundary, basename, isStaticRequest, isRouteRequest, requestContext) {
    return $9302892d54567256$var$_callLoaderOrAction.apply(this, arguments);
}
function $9302892d54567256$var$_callLoaderOrAction() {
    $9302892d54567256$var$_callLoaderOrAction = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(type, request, match, matches, manifest, detectErrorBoundary, basename, isStaticRequest, isRouteRequest, requestContext) {
        var resultType, result, onReject, runHandler, handler, values, e, status, location, activeMatches, routePathnames, resolvedLocation, path, currentUrl, url, isSameBasename, data, contentType, _result$init, _result$init2;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (basename === void 0) basename = "/";
                    if (isStaticRequest === void 0) isStaticRequest = false;
                    if (isRouteRequest === void 0) isRouteRequest = false;
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        11,
                        12,
                        13
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler),
                            $9302892d54567256$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $9302892d54567256$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") throw $9302892d54567256$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: new URL(request.url).pathname,
                        routeId: match.route.id
                    });
                    else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $9302892d54567256$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    $9302892d54567256$export$3e9cee6b33872309(handler, "Could not find the " + type + ' to run on the "' + match.route.id + '" route');
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 9:
                    result = _state.sent();
                    _state.label = 10;
                case 10:
                    $9302892d54567256$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        13
                    ];
                case 11:
                    e = _state.sent();
                    resultType = $9302892d54567256$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 13:
                    if (!$9302892d54567256$var$isResponse(result)) return [
                        3,
                        18
                    ];
                    status = result.status; // Process redirects
                    if ($9302892d54567256$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $9302892d54567256$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
                        if (!$9302892d54567256$var$ABSOLUTE_URL_REGEX.test(location)) {
                            activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                            routePathnames = $9302892d54567256$export$90ba53ce1c7fdff2(activeMatches).map(function(match) {
                                return match.pathnameBase;
                            });
                            resolvedLocation = $9302892d54567256$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                            $9302892d54567256$export$3e9cee6b33872309($9302892d54567256$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                            if (basename) {
                                path = resolvedLocation.pathname;
                                resolvedLocation.pathname = path === "/" ? basename : $9302892d54567256$export$86d9a7913e44197e([
                                    basename,
                                    path
                                ]);
                            }
                            location = $9302892d54567256$export$fe53371bee54353d(resolvedLocation);
                        } else if (!isStaticRequest) {
                            currentUrl = new URL(request.url);
                            url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $9302892d54567256$export$b69e3301ce081aa3(url.pathname, basename) != null;
                            if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
                        } // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $9302892d54567256$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null
                            }
                        ];
                    } // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (isRouteRequest) // eslint-disable-next-line no-throw-literal
                    throw {
                        type: resultType || $9302892d54567256$var$ResultType.data,
                        response: result
                    };
                    contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        15
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 14:
                    data = _state.sent();
                    return [
                        3,
                        17
                    ];
                case 15:
                    return [
                        4,
                        result.text()
                    ];
                case 16:
                    data = _state.sent();
                    _state.label = 17;
                case 17:
                    if (resultType === $9302892d54567256$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $9302892d54567256$export$acf1a680051f5031(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $9302892d54567256$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 18:
                    if (resultType === $9302892d54567256$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($9302892d54567256$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $9302892d54567256$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $9302892d54567256$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    } // Utility method for creating the Request instances for loaders/actions during
    );
    return $9302892d54567256$var$_callLoaderOrAction.apply(this, arguments);
}
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $9302892d54567256$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($9302892d54567256$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $9302892d54567256$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType, formData = submission.formData; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $9302892d54567256$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $9302892d54567256$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, value instanceof File ? value.name : value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $9302892d54567256$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $9302892d54567256$export$3e9cee6b33872309(!$9302892d54567256$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($9302892d54567256$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $9302892d54567256$var$findNearestBoundary(matches, id);
            var error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $9302892d54567256$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($9302892d54567256$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $9302892d54567256$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $9302892d54567256$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors; // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match;
        $9302892d54567256$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($9302892d54567256$var$isErrorResult(result)) {
            var boundaryMatch = $9302892d54567256$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $9302892d54567256$var$_extends({}, errors, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($9302892d54567256$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $9302892d54567256$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($9302892d54567256$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $9302892d54567256$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $9302892d54567256$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $9302892d54567256$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $9302892d54567256$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $9302892d54567256$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $9302892d54567256$var$getInternalRouterError(status, _temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $9302892d54567256$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $9302892d54567256$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($9302892d54567256$var$isRedirectResult(result)) return result;
    }
}
function $9302892d54567256$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $9302892d54567256$export$8ccf933b0513f8d0(path) : path;
    return $9302892d54567256$export$fe53371bee54353d($9302892d54567256$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $9302892d54567256$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $9302892d54567256$var$isDeferredResult(result) {
    return result.type === $9302892d54567256$var$ResultType.deferred;
}
function $9302892d54567256$var$isErrorResult(result) {
    return result.type === $9302892d54567256$var$ResultType.error;
}
function $9302892d54567256$var$isRedirectResult(result) {
    return (result && result.type) === $9302892d54567256$var$ResultType.redirect;
}
function $9302892d54567256$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $9302892d54567256$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $9302892d54567256$var$isRedirectResponse(result) {
    if (!$9302892d54567256$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $9302892d54567256$var$isQueryRouteResponse(obj) {
    return obj && $9302892d54567256$var$isResponse(obj.response) && (obj.type === $9302892d54567256$var$ResultType.data || $9302892d54567256$var$ResultType.error);
}
function $9302892d54567256$var$isValidMethod(method) {
    return $9302892d54567256$var$validRequestMethods.has(method.toLowerCase());
}
function $9302892d54567256$var$isMutationMethod(method) {
    return $9302892d54567256$var$validMutationMethods.has(method.toLowerCase());
}
function $9302892d54567256$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    return $9302892d54567256$var$_resolveDeferredResults.apply(this, arguments);
}
function $9302892d54567256$var$_resolveDeferredResults() {
    $9302892d54567256$var$_resolveDeferredResults = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$9302892d54567256$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($9302892d54567256$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    return [
                                        4,
                                        $9302892d54567256$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $1a5e16f717d29077$export$19a8beecd37a4c45)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $9302892d54567256$var$_resolveDeferredResults.apply(this, arguments);
}
function $9302892d54567256$var$resolveDeferredData(result, signal, unwrap) {
    return $9302892d54567256$var$_resolveDeferredData.apply(this, arguments);
}
function $9302892d54567256$var$_resolveDeferredData() {
    $9302892d54567256$var$_resolveDeferredData = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(result, signal, unwrap) {
        var aborted;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $9302892d54567256$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $9302892d54567256$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $9302892d54567256$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $9302892d54567256$var$_resolveDeferredData.apply(this, arguments);
}
function $9302892d54567256$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $9302892d54567256$var$createUseMatchesMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $9302892d54567256$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $9302892d54567256$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $9302892d54567256$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $9302892d54567256$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 







var $kVN77 = parcelRequire("kVN77");
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $1c3a22059b479044$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
var $1c3a22059b479044$var$is = typeof Object.is === "function" ? Object.is : $1c3a22059b479044$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
var $1c3a22059b479044$var$useState = $kVN77.useState, $1c3a22059b479044$var$useEffect = $kVN77.useEffect, $1c3a22059b479044$var$useLayoutEffect = $kVN77.useLayoutEffect, $1c3a22059b479044$var$useDebugValue = $kVN77.useDebugValue;
var $1c3a22059b479044$var$didWarnOld18Alpha = false;
var $1c3a22059b479044$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $1c3a22059b479044$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($1c3a22059b479044$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), 2), inst = _useState[0].inst, forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $1c3a22059b479044$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($1c3a22059b479044$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $1c3a22059b479044$var$useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($1c3a22059b479044$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        var handleStoreChange = function() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($1c3a22059b479044$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $1c3a22059b479044$var$useDebugValue(value);
    return value;
}
function $1c3a22059b479044$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    var prevValue = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$1c3a22059b479044$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $1c3a22059b479044$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ var $1c3a22059b479044$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $1c3a22059b479044$var$isServerEnvironment = !$1c3a22059b479044$var$canUseDOM;
var $1c3a22059b479044$var$shim = $1c3a22059b479044$var$isServerEnvironment ? $1c3a22059b479044$var$useSyncExternalStore$1 : $1c3a22059b479044$var$useSyncExternalStore$2;
var $1c3a22059b479044$var$useSyncExternalStore = "useSyncExternalStore" in $kVN77 ? function(module) {
    return module.useSyncExternalStore;
}($kVN77) : $1c3a22059b479044$var$shim;
var $1c3a22059b479044$export$3add0d5dce533e2e = /*#__PURE__*/ $kVN77.createContext(null);
var $1c3a22059b479044$export$145dfa71566a64dc = /*#__PURE__*/ $kVN77.createContext(null);
var $1c3a22059b479044$var$AwaitContext = /*#__PURE__*/ $kVN77.createContext(null);
var $1c3a22059b479044$export$26749e8557646306 = /*#__PURE__*/ $kVN77.createContext(null);
var $1c3a22059b479044$export$c7914228fb69b0f5 = /*#__PURE__*/ $kVN77.createContext(null);
var $1c3a22059b479044$export$9072aa6dd1f93057 = /*#__PURE__*/ $kVN77.createContext({
    outlet: null,
    matches: []
});
var $1c3a22059b479044$var$RouteErrorContext = /*#__PURE__*/ $kVN77.createContext(null);
function $1c3a22059b479044$var$_extends() {
    $1c3a22059b479044$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c3a22059b479044$var$_extends.apply(this, arguments);
}
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $1c3a22059b479044$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$1c3a22059b479044$export$9c954a9d03d32f4a() && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    var _React_useContext = $kVN77.useContext($1c3a22059b479044$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $1c3a22059b479044$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $9302892d54567256$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $1c3a22059b479044$export$9c954a9d03d32f4a() {
    return $kVN77.useContext($1c3a22059b479044$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $1c3a22059b479044$export$45d76561a5302f2b() {
    !$1c3a22059b479044$export$9c954a9d03d32f4a() && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    return $kVN77.useContext($1c3a22059b479044$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $1c3a22059b479044$export$1b3f31771c5d07c() {
    return $kVN77.useContext($1c3a22059b479044$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $1c3a22059b479044$export$6c330e8992e8a295(pattern) {
    !$1c3a22059b479044$export$9c954a9d03d32f4a() && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    var pathname = $1c3a22059b479044$export$45d76561a5302f2b().pathname;
    return $kVN77.useMemo(function() {
        return (0, $9302892d54567256$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $1c3a22059b479044$export$9770f232ac06a008() {
    !$1c3a22059b479044$export$9c954a9d03d32f4a() && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    var _React_useContext = $kVN77.useContext($1c3a22059b479044$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = $kVN77.useContext($1c3a22059b479044$export$9072aa6dd1f93057).matches;
    var _useLocation = $1c3a22059b479044$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $9302892d54567256$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = $kVN77.useRef(false);
    $kVN77.useEffect(function() {
        activeRef.current = true;
    });
    var navigate = $kVN77.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $9302892d54567256$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9302892d54567256$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
var $1c3a22059b479044$var$OutletContext = /*#__PURE__*/ $kVN77.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $1c3a22059b479044$export$4138103a3ae699cc() {
    return $kVN77.useContext($1c3a22059b479044$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $1c3a22059b479044$export$a3be3530d8e40d0b(context) {
    var outlet = $kVN77.useContext($1c3a22059b479044$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $1c3a22059b479044$export$99eaa27ddbbb95ef() {
    var matches = $kVN77.useContext($1c3a22059b479044$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $1c3a22059b479044$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = $kVN77.useContext($1c3a22059b479044$export$9072aa6dd1f93057).matches;
    var _useLocation = $1c3a22059b479044$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $9302892d54567256$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return $kVN77.useMemo(function() {
        return (0, $9302892d54567256$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $1c3a22059b479044$export$5d3fca4a98652595(routes, locationArg) {
    !$1c3a22059b479044$export$9c954a9d03d32f4a() && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    var navigator = $kVN77.useContext($1c3a22059b479044$export$26749e8557646306).navigator;
    var dataRouterStateContext = $kVN77.useContext($1c3a22059b479044$export$145dfa71566a64dc);
    var _React_useContext = $kVN77.useContext($1c3a22059b479044$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $1c3a22059b479044$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $9302892d54567256$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $9302892d54567256$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $1c3a22059b479044$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $9302892d54567256$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $9302892d54567256$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $1c3a22059b479044$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $9302892d54567256$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $1c3a22059b479044$var$DefaultErrorComponent() {
    var error = $1c3a22059b479044$export$ed527bf60f6e05f2();
    var message = (0, $9302892d54567256$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $kVN77.createElement($kVN77.Fragment, null, /*#__PURE__*/ $kVN77.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $kVN77.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $kVN77.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $1c3a22059b479044$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(RenderErrorBoundary, _React_Component);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            error: props.error
        };
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location) return {
                    error: props.error,
                    location: props.location
                };
                 // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($kVN77.Component);
function $1c3a22059b479044$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $kVN77.useContext($1c3a22059b479044$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $1c3a22059b479044$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    var errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) {
            if (match.route.ErrorBoundary) errorElement = /*#__PURE__*/ $kVN77.createElement(match.route.ErrorBoundary, null);
            else if (match.route.errorElement) errorElement = match.route.errorElement;
            else errorElement = /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$var$DefaultErrorComponent, null);
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children = outlet;
            if (error) children = errorElement;
            else if (match.route.Component) children = /*#__PURE__*/ $kVN77.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            return /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches
            }
        }) : getChildren();
    }, null);
}
var $1c3a22059b479044$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($1c3a22059b479044$var$DataRouterHook || ($1c3a22059b479044$var$DataRouterHook = {}));
var $1c3a22059b479044$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($1c3a22059b479044$var$DataRouterStateHook || ($1c3a22059b479044$var$DataRouterStateHook = {}));
function $1c3a22059b479044$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $1c3a22059b479044$var$useDataRouterContext(hookName) {
    var ctx = $kVN77.useContext($1c3a22059b479044$export$3add0d5dce533e2e);
    !ctx && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    return ctx;
}
function $1c3a22059b479044$var$useDataRouterState(hookName) {
    var state = $kVN77.useContext($1c3a22059b479044$export$145dfa71566a64dc);
    !state && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    return state;
}
function $1c3a22059b479044$var$useRouteContext(hookName) {
    var route = $kVN77.useContext($1c3a22059b479044$export$9072aa6dd1f93057);
    !route && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    return route;
}
function $1c3a22059b479044$var$useCurrentRouteId(hookName) {
    var route = $1c3a22059b479044$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $1c3a22059b479044$export$d0fd4b7106de2769() {
    var state = $1c3a22059b479044$var$useDataRouterState($1c3a22059b479044$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $1c3a22059b479044$export$600dc272ed516c15() {
    var dataRouterContext = $1c3a22059b479044$var$useDataRouterContext($1c3a22059b479044$var$DataRouterHook.UseRevalidator);
    var state = $1c3a22059b479044$var$useDataRouterState($1c3a22059b479044$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $1c3a22059b479044$export$2378eb7f5ff86053() {
    var _useDataRouterState = $1c3a22059b479044$var$useDataRouterState($1c3a22059b479044$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $kVN77.useMemo(function() {
        return matches.map(function(match) {
            var pathname = match.pathname, params = match.params; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $1c3a22059b479044$export$1448a5050d252c4d() {
    var state = $1c3a22059b479044$var$useDataRouterState($1c3a22059b479044$var$DataRouterStateHook.UseLoaderData);
    var routeId = $1c3a22059b479044$var$useCurrentRouteId($1c3a22059b479044$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $1c3a22059b479044$export$fd5d37484eab868d(routeId) {
    var state = $1c3a22059b479044$var$useDataRouterState($1c3a22059b479044$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $1c3a22059b479044$export$fdc00f3f26066d5e() {
    var state = $1c3a22059b479044$var$useDataRouterState($1c3a22059b479044$var$DataRouterStateHook.UseActionData);
    var route = $kVN77.useContext($1c3a22059b479044$export$9072aa6dd1f93057);
    !route && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $1c3a22059b479044$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $kVN77.useContext($1c3a22059b479044$var$RouteErrorContext);
    var state = $1c3a22059b479044$var$useDataRouterState($1c3a22059b479044$var$DataRouterStateHook.UseRouteError);
    var routeId = $1c3a22059b479044$var$useCurrentRouteId($1c3a22059b479044$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $1c3a22059b479044$export$78a72ddb39bdd145() {
    var value = $kVN77.useContext($1c3a22059b479044$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $1c3a22059b479044$export$17f53340677d5831() {
    var value = $kVN77.useContext($1c3a22059b479044$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $1c3a22059b479044$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $1c3a22059b479044$export$2af03a1de5c0910(shouldBlock) {
    var router = $1c3a22059b479044$var$useDataRouterContext($1c3a22059b479044$var$DataRouterHook.UseBlocker).router;
    var state = $1c3a22059b479044$var$useDataRouterState($1c3a22059b479044$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($kVN77.useState(function() {
        return String(++$1c3a22059b479044$var$blockerId);
    }), 1), blockerKey = _React_useState[0];
    var blockerFunction = $kVN77.useCallback(function(args) {
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    var blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $kVN77.useEffect(function() {
        return function() {
            return router.deleteBlocker(blockerKey);
        };
    }, [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
var $1c3a22059b479044$var$alreadyWarned = {};
function $1c3a22059b479044$var$warningOnce(key, cond, message) {
    if (!cond && !$1c3a22059b479044$var$alreadyWarned[key]) $1c3a22059b479044$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $1c3a22059b479044$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router;
    var getState = $kVN77.useCallback(function() {
        return router.state;
    }, [
        router
    ]); // Sync router state to our component state to force re-renders
    var state = $1c3a22059b479044$var$useSyncExternalStore(router.subscribe, getState, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    getState);
    var navigator = $kVN77.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $kVN77.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $kVN77.createElement($kVN77.Fragment, null, /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$3565eb3d00ca5a74, null) : fallbackElement))), null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $1c3a22059b479044$export$ae46f04cfaffe093(_ref2) {
    var basename = _ref2.basename, children = _ref2.children, initialEntries = _ref2.initialEntries, initialIndex = _ref2.initialIndex;
    var historyRef = $kVN77.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9302892d54567256$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($kVN77.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    $kVN77.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $1c3a22059b479044$export$444b3ab0cb9aec40(_ref3) {
    var to = _ref3.to, replace = _ref3.replace, state = _ref3.state, relative = _ref3.relative;
    !$1c3a22059b479044$export$9c954a9d03d32f4a() && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    var dataRouterState = $kVN77.useContext($1c3a22059b479044$export$145dfa71566a64dc);
    var navigate = $1c3a22059b479044$export$9770f232ac06a008();
    $kVN77.useEffect(function() {
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $1c3a22059b479044$export$910ae8079b2c2852(props) {
    return $1c3a22059b479044$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $1c3a22059b479044$export$e7b0ac011bb776c6(_props) {
    (0, $9302892d54567256$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $1c3a22059b479044$export$55185c17a0fcbe46(_ref4) {
    var tmp = _ref4.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref4_children = _ref4.children, children = _ref4_children === void 0 ? null : _ref4_children, locationProp = _ref4.location, _ref4_navigationType = _ref4.navigationType, navigationType = _ref4_navigationType === void 0 ? (0, $9302892d54567256$export$e19cd5f9376f8cee).Pop : _ref4_navigationType, navigator = _ref4.navigator, tmp1 = _ref4.static, staticProp = tmp1 === void 0 ? false : tmp1;
    !!$1c3a22059b479044$export$9c954a9d03d32f4a() && (0, $9302892d54567256$export$3e9cee6b33872309)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $kVN77.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $9302892d54567256$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $kVN77.useMemo(function() {
        var trailingPathname = (0, $9302892d54567256$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $1c3a22059b479044$export$3565eb3d00ca5a74(_ref5) {
    var children = _ref5.children, location = _ref5.location;
    var dataRouterContext = $kVN77.useContext($1c3a22059b479044$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    var routes = dataRouterContext && !children ? dataRouterContext.router.routes : $1c3a22059b479044$export$16da398f5434bdec(children);
    return $1c3a22059b479044$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $1c3a22059b479044$export$6ddabde395c8c576(_ref6) {
    var children = _ref6.children, errorElement = _ref6.errorElement, resolve = _ref6.resolve;
    return /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$var$ResolveAwait, null, children));
}
var $1c3a22059b479044$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($1c3a22059b479044$var$AwaitRenderStatus || ($1c3a22059b479044$var$AwaitRenderStatus = {}));
var $1c3a22059b479044$var$neverSettledPromise = new Promise(function() {});
var $1c3a22059b479044$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $1c3a22059b479044$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $1c3a22059b479044$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $1c3a22059b479044$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $1c3a22059b479044$var$AwaitRenderStatus.error : promise._data !== undefined ? $1c3a22059b479044$var$AwaitRenderStatus.success : $1c3a22059b479044$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $1c3a22059b479044$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $1c3a22059b479044$var$AwaitRenderStatus.error && promise._error instanceof (0, $9302892d54567256$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $1c3a22059b479044$var$neverSettledPromise;
                if (status === $1c3a22059b479044$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $1c3a22059b479044$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $1c3a22059b479044$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $kVN77.createElement($1c3a22059b479044$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                 // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($kVN77.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $1c3a22059b479044$var$ResolveAwait(_ref7) {
    var children = _ref7.children;
    var data = $1c3a22059b479044$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $kVN77.createElement($kVN77.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $1c3a22059b479044$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $kVN77.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $kVN77.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(parentPath).concat([
            index
        ]);
        if (element.type === $kVN77.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $1c3a22059b479044$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $1c3a22059b479044$export$e7b0ac011bb776c6) && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $1c3a22059b479044$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $1c3a22059b479044$export$daf73786167a7f72(matches) {
    return $1c3a22059b479044$var$_renderMatches(matches);
}
function $1c3a22059b479044$export$48907b48b599f040(route) {
    // there if you change this
    return Boolean(route.ErrorBoundary) || Boolean(route.errorElement);
}
function $1c3a22059b479044$export$f30f7e456d254e83(routes, opts) {
    return (0, $9302892d54567256$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $9302892d54567256$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        detectErrorBoundary: $1c3a22059b479044$export$48907b48b599f040
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $d03cd69b331d3258$var$_extends() {
    $d03cd69b331d3258$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d03cd69b331d3258$var$_extends.apply(this, arguments);
}
function $d03cd69b331d3258$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d03cd69b331d3258$var$defaultMethod = "get";
var $d03cd69b331d3258$var$defaultEncType = "application/x-www-form-urlencoded";
function $d03cd69b331d3258$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $d03cd69b331d3258$var$isButtonElement(object) {
    return $d03cd69b331d3258$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $d03cd69b331d3258$var$isFormElement(object) {
    return $d03cd69b331d3258$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $d03cd69b331d3258$var$isInputElement(object) {
    return $d03cd69b331d3258$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $d03cd69b331d3258$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $d03cd69b331d3258$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$d03cd69b331d3258$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $d03cd69b331d3258$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $d03cd69b331d3258$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $d03cd69b331d3258$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
                    searchParams.append(key, value);
                });
            };
            for(var _iterator = defaultSearchParams.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return searchParams;
}
function $d03cd69b331d3258$var$getFormSubmissionInfo(target, defaultAction, options) {
    var method;
    var action;
    var encType;
    var formData;
    if ($d03cd69b331d3258$var$isFormElement(target)) {
        var submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $d03cd69b331d3258$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $d03cd69b331d3258$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($d03cd69b331d3258$var$isButtonElement(target) || $d03cd69b331d3258$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $d03cd69b331d3258$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $d03cd69b331d3258$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($d03cd69b331d3258$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $d03cd69b331d3258$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $d03cd69b331d3258$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (target instanceof URLSearchParams) try {
                for(var _iterator = target[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                    formData.append(name, value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else if (target != null) try {
                for(var _iterator1 = Object.keys(target)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var name1 = _step1.value;
                    formData.append(name1, target[name1]);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    }
    var _window_location = window.location, protocol = _window_location.protocol, host = _window_location.host;
    var url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
var $d03cd69b331d3258$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $d03cd69b331d3258$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $d03cd69b331d3258$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $d03cd69b331d3258$export$1f3f55432a00e06d(routes, opts) {
    return (0, $9302892d54567256$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $9302892d54567256$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d03cd69b331d3258$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $1c3a22059b479044$export$48907b48b599f040)
    }).initialize();
}
function $d03cd69b331d3258$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $9302892d54567256$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $9302892d54567256$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d03cd69b331d3258$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $1c3a22059b479044$export$48907b48b599f040)
    }).initialize();
}
function $d03cd69b331d3258$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $d03cd69b331d3258$var$_extends({}, state, {
        errors: $d03cd69b331d3258$var$deserializeErrors(state.errors)
    });
    return state;
}
function $d03cd69b331d3258$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $9302892d54567256$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                var error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $d03cd69b331d3258$export$9ba4e89fdfa1fc54(_ref) {
    var basename = _ref.basename, children = _ref.children, _$window = _ref.window;
    var historyRef = $kVN77.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9302892d54567256$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($kVN77.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    $kVN77.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ $kVN77.createElement((0, $1c3a22059b479044$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $d03cd69b331d3258$export$7221d69dcfc8e36b(_ref2) {
    var basename = _ref2.basename, children = _ref2.children, _$window = _ref2.window;
    var historyRef = $kVN77.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9302892d54567256$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($kVN77.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    $kVN77.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ $kVN77.createElement((0, $1c3a22059b479044$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $d03cd69b331d3258$export$eefb0c834599897e(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, history = _ref3.history;
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($kVN77.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    $kVN77.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ $kVN77.createElement((0, $1c3a22059b479044$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var $d03cd69b331d3258$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $d03cd69b331d3258$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ var $d03cd69b331d3258$export$a6c7ac8248d6e38a = /*#__PURE__*/ $kVN77.forwardRef(function LinkWithRef(_ref4, ref) {
    var onClick = _ref4.onClick, relative = _ref4.relative, reloadDocument = _ref4.reloadDocument, replace = _ref4.replace, state = _ref4.state, target = _ref4.target, to = _ref4.to, preventScrollReset = _ref4.preventScrollReset, rest = $d03cd69b331d3258$var$_objectWithoutPropertiesLoose(_ref4, $d03cd69b331d3258$var$_excluded);
    var basename = $kVN77.useContext((0, $1c3a22059b479044$export$26749e8557646306)).basename; // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $d03cd69b331d3258$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($d03cd69b331d3258$var$isBrowser) {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $9302892d54567256$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        }
    } // Rendered into <a href> for relative URLs
    var href = (0, $1c3a22059b479044$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $d03cd69b331d3258$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $kVN77.createElement("a", $d03cd69b331d3258$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $d03cd69b331d3258$export$b0d92dbee9b5b60d = /*#__PURE__*/ $kVN77.forwardRef(function NavLinkWithRef(_ref5, ref) {
    var tmp = _ref5["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref5_caseSensitive = _ref5.caseSensitive, caseSensitive = _ref5_caseSensitive === void 0 ? false : _ref5_caseSensitive, tmp1 = _ref5.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref5_end = _ref5.end, end = _ref5_end === void 0 ? false : _ref5_end, styleProp = _ref5.style, to = _ref5.to, children = _ref5.children, rest = $d03cd69b331d3258$var$_objectWithoutPropertiesLoose(_ref5, $d03cd69b331d3258$var$_excluded2);
    var path = (0, $1c3a22059b479044$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $1c3a22059b479044$export$45d76561a5302f2b)();
    var routerState = $kVN77.useContext((0, $1c3a22059b479044$export$145dfa71566a64dc));
    var navigator = $kVN77.useContext((0, $1c3a22059b479044$export$26749e8557646306)).navigator;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $kVN77.createElement($d03cd69b331d3258$export$a6c7ac8248d6e38a, $d03cd69b331d3258$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $d03cd69b331d3258$export$a7fed597f4b8afd8 = /*#__PURE__*/ $kVN77.forwardRef(function(props, ref) {
    return /*#__PURE__*/ $kVN77.createElement($d03cd69b331d3258$var$FormImpl, $d03cd69b331d3258$var$_extends({}, props, {
        ref: ref
    }));
});
var $d03cd69b331d3258$var$FormImpl = /*#__PURE__*/ $kVN77.forwardRef(function(_ref6, forwardedRef) {
    var reloadDocument = _ref6.reloadDocument, replace = _ref6.replace, _ref6_method = _ref6.method, method = _ref6_method === void 0 ? $d03cd69b331d3258$var$defaultMethod : _ref6_method, action = _ref6.action, onSubmit = _ref6.onSubmit, fetcherKey = _ref6.fetcherKey, routeId = _ref6.routeId, relative = _ref6.relative, preventScrollReset = _ref6.preventScrollReset, props = $d03cd69b331d3258$var$_objectWithoutPropertiesLoose(_ref6, $d03cd69b331d3258$var$_excluded3);
    var submit = $d03cd69b331d3258$var$useSubmitImpl(fetcherKey, routeId);
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var formAction = $d03cd69b331d3258$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $kVN77.createElement("form", $d03cd69b331d3258$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $d03cd69b331d3258$export$11aac1aab828f1fa(_ref7) {
    var getKey = _ref7.getKey, storageKey = _ref7.storageKey;
    $d03cd69b331d3258$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $d03cd69b331d3258$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($d03cd69b331d3258$var$DataRouterHook || ($d03cd69b331d3258$var$DataRouterHook = {}));
var $d03cd69b331d3258$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($d03cd69b331d3258$var$DataRouterStateHook || ($d03cd69b331d3258$var$DataRouterStateHook = {}));
function $d03cd69b331d3258$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d03cd69b331d3258$var$useDataRouterContext(hookName) {
    var ctx = $kVN77.useContext((0, $1c3a22059b479044$export$3add0d5dce533e2e));
    !ctx && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d03cd69b331d3258$var$useDataRouterState(hookName) {
    var state = $kVN77.useContext((0, $1c3a22059b479044$export$145dfa71566a64dc));
    !state && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $d03cd69b331d3258$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var location = (0, $1c3a22059b479044$export$45d76561a5302f2b)();
    var path = (0, $1c3a22059b479044$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $kVN77.useCallback(function(event) {
        if ($d03cd69b331d3258$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $9302892d54567256$export$fe53371bee54353d)(location) === (0, $9302892d54567256$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $d03cd69b331d3258$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $kVN77.useRef($d03cd69b331d3258$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $kVN77.useRef(false);
    var location = (0, $1c3a22059b479044$export$45d76561a5302f2b)();
    var searchParams = $kVN77.useMemo(function() {
        return(// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $d03cd69b331d3258$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var setSearchParams = $kVN77.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $d03cd69b331d3258$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $d03cd69b331d3258$export$47c85c6e3a081d3() {
    return $d03cd69b331d3258$var$useSubmitImpl();
}
function $d03cd69b331d3258$var$useSubmitImpl(fetcherKey, routeId) {
    var router = $d03cd69b331d3258$var$useDataRouterContext($d03cd69b331d3258$var$DataRouterHook.UseSubmitImpl).router;
    var defaultAction = $d03cd69b331d3258$export$89a6bd6db0d97c56();
    return $kVN77.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        var _getFormSubmissionInfo = $d03cd69b331d3258$var$getFormSubmissionInfo(target, defaultAction, options), method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, url = _getFormSubmissionInfo.url;
        var href = url.pathname + url.search;
        var opts = {
            replace: options.replace,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $d03cd69b331d3258$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $kVN77.useContext((0, $1c3a22059b479044$export$26749e8557646306)).basename;
    var routeContext = $kVN77.useContext((0, $1c3a22059b479044$export$9072aa6dd1f93057));
    !routeContext && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0]; // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $d03cd69b331d3258$var$_extends({}, (0, $1c3a22059b479044$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $1c3a22059b479044$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            var params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9302892d54567256$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $9302892d54567256$export$fe53371bee54353d)(path);
}
function $d03cd69b331d3258$var$createFetcherForm(fetcherKey, routeId) {
    var FetcherForm = /*#__PURE__*/ $kVN77.forwardRef(function(props, ref) {
        return /*#__PURE__*/ $kVN77.createElement($d03cd69b331d3258$var$FormImpl, $d03cd69b331d3258$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
var $d03cd69b331d3258$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $d03cd69b331d3258$export$5b0d2d9a9921565a() {
    var _route$matches;
    var router = $d03cd69b331d3258$var$useDataRouterContext($d03cd69b331d3258$var$DataRouterHook.UseFetcher).router;
    var route = $kVN77.useContext((0, $1c3a22059b479044$export$9072aa6dd1f93057));
    !route && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($kVN77.useState(function() {
        return String(++$d03cd69b331d3258$var$fetcherId);
    }), 1), fetcherKey = _React_useState[0];
    var _React_useState1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($kVN77.useState(function() {
        !routeId && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
        return $d03cd69b331d3258$var$createFetcherForm(fetcherKey, routeId);
    }), 1), Form = _React_useState1[0];
    var _React_useState2 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($kVN77.useState(function() {
        return function(href) {
            !router && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
            !routeId && (0, $9302892d54567256$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        };
    }), 1), load = _React_useState2[0];
    var submit = $d03cd69b331d3258$var$useSubmitImpl(fetcherKey, routeId);
    var fetcher = router.getFetcher(fetcherKey);
    var fetcherWithComponents = $kVN77.useMemo(function() {
        return $d03cd69b331d3258$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher);
    }, [
        fetcher,
        Form,
        submit,
        load
    ]);
    $kVN77.useEffect(function() {
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return function() {
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $d03cd69b331d3258$export$fa996778a3a31087() {
    var state = $d03cd69b331d3258$var$useDataRouterState($d03cd69b331d3258$var$DataRouterStateHook.UseFetchers);
    return (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(state.fetchers.values());
}
var $d03cd69b331d3258$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $d03cd69b331d3258$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $d03cd69b331d3258$export$25057cfe5591e3e9(_temp3) {
    var _ref = _temp3 === void 0 ? {} : _temp3, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $d03cd69b331d3258$var$useDataRouterContext($d03cd69b331d3258$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $d03cd69b331d3258$var$useDataRouterState($d03cd69b331d3258$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var location = (0, $1c3a22059b479044$export$45d76561a5302f2b)();
    var matches = (0, $1c3a22059b479044$export$2378eb7f5ff86053)();
    var navigation = (0, $1c3a22059b479044$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $kVN77.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $d03cd69b331d3258$var$usePageHide($kVN77.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $d03cd69b331d3258$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $d03cd69b331d3258$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($d03cd69b331d3258$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $kVN77.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $d03cd69b331d3258$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $d03cd69b331d3258$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $kVN77.useLayoutEffect(function() {
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($d03cd69b331d3258$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKey);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $kVN77.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d03cd69b331d3258$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $kVN77.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d03cd69b331d3258$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $kVN77.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $d03cd69b331d3258$export$39f4eb3dbd812741(_ref8) {
    var when = _ref8.when, message = _ref8.message;
    var blocker = (0, $1c3a22059b479044$export$2af03a1de5c0910)(when);
    $kVN77.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $kVN77.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}



var $adce05c96e8d4258$exports = {};

var $3L4GM = parcelRequire("3L4GM");
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg === "undefined" ? "undefined" : (0, $3L4GM._)(arg);
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $adce05c96e8d4258$exports) {
        classNames.default = classNames;
        $adce05c96e8d4258$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();






var $kVN77 = parcelRequire("kVN77");



var $kVN77 = parcelRequire("kVN77");
var $f230858f3ff7a967$exports = {};
"use strict";
Object.defineProperty($f230858f3ff7a967$exports, "__esModule", {
    value: true
});
function $f230858f3ff7a967$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $kVN77 = parcelRequire("kVN77");
var $f230858f3ff7a967$var$React__default = $f230858f3ff7a967$var$_interopDefault($kVN77);

var $lxN42 = parcelRequire("lxN42");
var $f230858f3ff7a967$var$ClientUAInstance = new $lxN42();
var $f230858f3ff7a967$var$browser = $f230858f3ff7a967$var$ClientUAInstance.getBrowser();
var $f230858f3ff7a967$var$cpu = $f230858f3ff7a967$var$ClientUAInstance.getCPU();
var $f230858f3ff7a967$var$device = $f230858f3ff7a967$var$ClientUAInstance.getDevice();
var $f230858f3ff7a967$var$engine = $f230858f3ff7a967$var$ClientUAInstance.getEngine();
var $f230858f3ff7a967$var$os = $f230858f3ff7a967$var$ClientUAInstance.getOS();
var $f230858f3ff7a967$var$ua = $f230858f3ff7a967$var$ClientUAInstance.getUA();
var $f230858f3ff7a967$var$setUa = function setUa(userAgentString) {
    return $f230858f3ff7a967$var$ClientUAInstance.setUA(userAgentString);
};
var $f230858f3ff7a967$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $lxN42(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $f230858f3ff7a967$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $f230858f3ff7a967$var$ClientUAInstance,
    browser: $f230858f3ff7a967$var$browser,
    cpu: $f230858f3ff7a967$var$cpu,
    device: $f230858f3ff7a967$var$device,
    engine: $f230858f3ff7a967$var$engine,
    os: $f230858f3ff7a967$var$os,
    ua: $f230858f3ff7a967$var$ua,
    setUa: $f230858f3ff7a967$var$setUa,
    parseUserAgent: $f230858f3ff7a967$var$parseUserAgent
});
function $f230858f3ff7a967$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f230858f3ff7a967$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f230858f3ff7a967$var$ownKeys(Object(source), true).forEach(function(key) {
            $f230858f3ff7a967$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f230858f3ff7a967$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f230858f3ff7a967$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f230858f3ff7a967$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f230858f3ff7a967$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f230858f3ff7a967$var$_typeof(obj);
}
function $f230858f3ff7a967$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f230858f3ff7a967$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f230858f3ff7a967$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f230858f3ff7a967$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f230858f3ff7a967$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f230858f3ff7a967$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f230858f3ff7a967$var$_extends() {
    $f230858f3ff7a967$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f230858f3ff7a967$var$_extends.apply(this, arguments);
}
function $f230858f3ff7a967$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f230858f3ff7a967$var$_setPrototypeOf(subClass, superClass);
}
function $f230858f3ff7a967$var$_getPrototypeOf(o) {
    $f230858f3ff7a967$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f230858f3ff7a967$var$_getPrototypeOf(o);
}
function $f230858f3ff7a967$var$_setPrototypeOf(o, p) {
    $f230858f3ff7a967$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f230858f3ff7a967$var$_setPrototypeOf(o, p);
}
function $f230858f3ff7a967$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f230858f3ff7a967$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f230858f3ff7a967$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f230858f3ff7a967$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f230858f3ff7a967$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f230858f3ff7a967$var$_assertThisInitialized(self);
}
function $f230858f3ff7a967$var$_slicedToArray(arr, i) {
    return $f230858f3ff7a967$var$_arrayWithHoles(arr) || $f230858f3ff7a967$var$_iterableToArrayLimit(arr, i) || $f230858f3ff7a967$var$_unsupportedIterableToArray(arr, i) || $f230858f3ff7a967$var$_nonIterableRest();
}
function $f230858f3ff7a967$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f230858f3ff7a967$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f230858f3ff7a967$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f230858f3ff7a967$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f230858f3ff7a967$var$_arrayLikeToArray(o, minLen);
}
function $f230858f3ff7a967$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f230858f3ff7a967$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $f230858f3ff7a967$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $f230858f3ff7a967$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $f230858f3ff7a967$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $f230858f3ff7a967$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $f230858f3ff7a967$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $f230858f3ff7a967$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $f230858f3ff7a967$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $f230858f3ff7a967$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $f230858f3ff7a967$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $f230858f3ff7a967$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $f230858f3ff7a967$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $f230858f3ff7a967$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $f230858f3ff7a967$var$InitialDeviceTypes;
    }
};
var $f230858f3ff7a967$var$setUserAgent = function setUserAgent(userAgent) {
    return $f230858f3ff7a967$var$setUa(userAgent);
};
var $f230858f3ff7a967$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $f230858f3ff7a967$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $f230858f3ff7a967$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $f230858f3ff7a967$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $f230858f3ff7a967$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $f230858f3ff7a967$var$setDefaults(browser.major),
        browserFullVersion: $f230858f3ff7a967$var$setDefaults(browser.version),
        browserName: $f230858f3ff7a967$var$setDefaults(browser.name),
        engineName: $f230858f3ff7a967$var$setDefaults(engine.name),
        engineVersion: $f230858f3ff7a967$var$setDefaults(engine.version),
        osName: $f230858f3ff7a967$var$setDefaults(os.name),
        osVersion: $f230858f3ff7a967$var$setDefaults(os.version),
        userAgent: $f230858f3ff7a967$var$setDefaults(ua)
    };
};
var $f230858f3ff7a967$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $f230858f3ff7a967$var$_objectSpread2({}, type, {
        vendor: $f230858f3ff7a967$var$setDefaults(device.vendor),
        model: $f230858f3ff7a967$var$setDefaults(device.model),
        os: $f230858f3ff7a967$var$setDefaults(os.name),
        osVersion: $f230858f3ff7a967$var$setDefaults(os.version),
        ua: $f230858f3ff7a967$var$setDefaults(ua)
    });
};
var $f230858f3ff7a967$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $f230858f3ff7a967$var$setDefaults(engine.name),
        engineVersion: $f230858f3ff7a967$var$setDefaults(engine.version),
        osName: $f230858f3ff7a967$var$setDefaults(os.name),
        osVersion: $f230858f3ff7a967$var$setDefaults(os.version),
        userAgent: $f230858f3ff7a967$var$setDefaults(ua)
    };
};
var $f230858f3ff7a967$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $f230858f3ff7a967$var$setDefaults(engine.name),
        engineVersion: $f230858f3ff7a967$var$setDefaults(engine.version),
        osName: $f230858f3ff7a967$var$setDefaults(os.name),
        osVersion: $f230858f3ff7a967$var$setDefaults(os.version),
        userAgent: $f230858f3ff7a967$var$setDefaults(ua)
    };
};
var $f230858f3ff7a967$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $f230858f3ff7a967$var$setDefaults(engine.name),
        engineVersion: $f230858f3ff7a967$var$setDefaults(engine.version),
        osName: $f230858f3ff7a967$var$setDefaults(os.name),
        osVersion: $f230858f3ff7a967$var$setDefaults(os.version),
        userAgent: $f230858f3ff7a967$var$setDefaults(ua)
    };
};
var $f230858f3ff7a967$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $f230858f3ff7a967$var$setDefaults(device.vendor),
        model: $f230858f3ff7a967$var$setDefaults(device.model),
        engineName: $f230858f3ff7a967$var$setDefaults(engine.name),
        engineVersion: $f230858f3ff7a967$var$setDefaults(engine.version),
        osName: $f230858f3ff7a967$var$setDefaults(os.name),
        osVersion: $f230858f3ff7a967$var$setDefaults(os.version),
        userAgent: $f230858f3ff7a967$var$setDefaults(ua)
    };
};
function $f230858f3ff7a967$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $f230858f3ff7a967$var$parseUserAgent(userAgent) : $f230858f3ff7a967$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $f230858f3ff7a967$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $f230858f3ff7a967$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $f230858f3ff7a967$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $f230858f3ff7a967$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $f230858f3ff7a967$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $f230858f3ff7a967$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $f230858f3ff7a967$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $f230858f3ff7a967$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $f230858f3ff7a967$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $f230858f3ff7a967$var$DeviceTypes.Mobile;
};
var $f230858f3ff7a967$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $f230858f3ff7a967$var$DeviceTypes.Tablet;
};
var $f230858f3ff7a967$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $f230858f3ff7a967$var$DeviceTypes.Mobile || type === $f230858f3ff7a967$var$DeviceTypes.Tablet;
};
var $f230858f3ff7a967$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $f230858f3ff7a967$var$DeviceTypes.SmartTv;
};
var $f230858f3ff7a967$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $f230858f3ff7a967$var$DeviceTypes.Browser;
};
var $f230858f3ff7a967$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $f230858f3ff7a967$var$DeviceTypes.Wearable;
};
var $f230858f3ff7a967$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $f230858f3ff7a967$var$DeviceTypes.Console;
};
var $f230858f3ff7a967$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $f230858f3ff7a967$var$DeviceTypes.Embedded;
};
var $f230858f3ff7a967$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $f230858f3ff7a967$var$setDefaults(vendor);
};
var $f230858f3ff7a967$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $f230858f3ff7a967$var$setDefaults(model);
};
var $f230858f3ff7a967$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $f230858f3ff7a967$var$setDefaults(type, "browser");
}; // os types
var $f230858f3ff7a967$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $f230858f3ff7a967$var$OsTypes.Android;
};
var $f230858f3ff7a967$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $f230858f3ff7a967$var$OsTypes.Windows;
};
var $f230858f3ff7a967$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $f230858f3ff7a967$var$OsTypes.MAC_OS;
};
var $f230858f3ff7a967$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $f230858f3ff7a967$var$OsTypes.WindowsPhone;
};
var $f230858f3ff7a967$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $f230858f3ff7a967$var$OsTypes.IOS;
};
var $f230858f3ff7a967$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $f230858f3ff7a967$var$setDefaults(version);
};
var $f230858f3ff7a967$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $f230858f3ff7a967$var$setDefaults(name);
}; // browser types
var $f230858f3ff7a967$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.Chrome;
};
var $f230858f3ff7a967$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.Firefox;
};
var $f230858f3ff7a967$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.Chromium;
};
var $f230858f3ff7a967$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.Edge;
};
var $f230858f3ff7a967$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.Yandex;
};
var $f230858f3ff7a967$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.Safari || name === $f230858f3ff7a967$var$BrowserTypes.MobileSafari;
};
var $f230858f3ff7a967$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.MobileSafari;
};
var $f230858f3ff7a967$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.Opera;
};
var $f230858f3ff7a967$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.InternetExplorer || name === $f230858f3ff7a967$var$BrowserTypes.Ie;
};
var $f230858f3ff7a967$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.MIUI;
};
var $f230858f3ff7a967$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $f230858f3ff7a967$var$BrowserTypes.SamsungBrowser;
};
var $f230858f3ff7a967$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $f230858f3ff7a967$var$setDefaults(version);
};
var $f230858f3ff7a967$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $f230858f3ff7a967$var$setDefaults(major);
};
var $f230858f3ff7a967$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $f230858f3ff7a967$var$setDefaults(name);
}; // engine types
var $f230858f3ff7a967$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $f230858f3ff7a967$var$setDefaults(name);
};
var $f230858f3ff7a967$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $f230858f3ff7a967$var$setDefaults(version);
};
var $f230858f3ff7a967$var$isElectronType = function isElectronType() {
    var nav = $f230858f3ff7a967$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $f230858f3ff7a967$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $f230858f3ff7a967$var$getIOS13 = function getIOS13() {
    var nav = $f230858f3ff7a967$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $f230858f3ff7a967$var$getIPad13 = function getIPad13() {
    return $f230858f3ff7a967$var$isIOS13Check("iPad");
};
var $f230858f3ff7a967$var$getIphone13 = function getIphone13() {
    return $f230858f3ff7a967$var$isIOS13Check("iPhone");
};
var $f230858f3ff7a967$var$getIPod13 = function getIPod13() {
    return $f230858f3ff7a967$var$isIOS13Check("iPod");
};
var $f230858f3ff7a967$var$getUseragent = function getUseragent(userAg) {
    return $f230858f3ff7a967$var$setDefaults(userAg);
};
function $f230858f3ff7a967$var$buildSelectorsObject(options) {
    var _ref = options ? options : $f230858f3ff7a967$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $f230858f3ff7a967$var$isSmartTVType(device),
        isConsole: $f230858f3ff7a967$var$isConsoleType(device),
        isWearable: $f230858f3ff7a967$var$isWearableType(device),
        isEmbedded: $f230858f3ff7a967$var$isEmbeddedType(device),
        isMobileSafari: $f230858f3ff7a967$var$isMobileSafariType(browser) || $f230858f3ff7a967$var$getIPad13(),
        isChromium: $f230858f3ff7a967$var$isChromiumType(browser),
        isMobile: $f230858f3ff7a967$var$isMobileAndTabletType(device) || $f230858f3ff7a967$var$getIPad13(),
        isMobileOnly: $f230858f3ff7a967$var$isMobileType(device),
        isTablet: $f230858f3ff7a967$var$isTabletType(device) || $f230858f3ff7a967$var$getIPad13(),
        isBrowser: $f230858f3ff7a967$var$isBrowserType(device),
        isDesktop: $f230858f3ff7a967$var$isBrowserType(device),
        isAndroid: $f230858f3ff7a967$var$isAndroidType(os),
        isWinPhone: $f230858f3ff7a967$var$isWinPhoneType(os),
        isIOS: $f230858f3ff7a967$var$isIOSType(os) || $f230858f3ff7a967$var$getIPad13(),
        isChrome: $f230858f3ff7a967$var$isChromeType(browser),
        isFirefox: $f230858f3ff7a967$var$isFirefoxType(browser),
        isSafari: $f230858f3ff7a967$var$isSafariType(browser),
        isOpera: $f230858f3ff7a967$var$isOperaType(browser),
        isIE: $f230858f3ff7a967$var$isIEType(browser),
        osVersion: $f230858f3ff7a967$var$getOsVersion(os),
        osName: $f230858f3ff7a967$var$getOsName(os),
        fullBrowserVersion: $f230858f3ff7a967$var$getBrowserFullVersion(browser),
        browserVersion: $f230858f3ff7a967$var$getBrowserVersion(browser),
        browserName: $f230858f3ff7a967$var$getBrowserName(browser),
        mobileVendor: $f230858f3ff7a967$var$getMobileVendor(device),
        mobileModel: $f230858f3ff7a967$var$getMobileModel(device),
        engineName: $f230858f3ff7a967$var$getEngineName(engine),
        engineVersion: $f230858f3ff7a967$var$getEngineVersion(engine),
        getUA: $f230858f3ff7a967$var$getUseragent(ua),
        isEdge: $f230858f3ff7a967$var$isEdgeType(browser) || $f230858f3ff7a967$var$isEdgeChromiumType(ua),
        isYandex: $f230858f3ff7a967$var$isYandexType(browser),
        deviceType: $f230858f3ff7a967$var$getDeviceType(device),
        isIOS13: $f230858f3ff7a967$var$getIOS13(),
        isIPad13: $f230858f3ff7a967$var$getIPad13(),
        isIPhone13: $f230858f3ff7a967$var$getIphone13(),
        isIPod13: $f230858f3ff7a967$var$getIPod13(),
        isElectron: $f230858f3ff7a967$var$isElectronType(),
        isEdgeChromium: $f230858f3ff7a967$var$isEdgeChromiumType(ua),
        isLegacyEdge: $f230858f3ff7a967$var$isEdgeType(browser) && !$f230858f3ff7a967$var$isEdgeChromiumType(ua),
        isWindows: $f230858f3ff7a967$var$isWindowsType(os),
        isMacOs: $f230858f3ff7a967$var$isMacOsType(os),
        isMIUI: $f230858f3ff7a967$var$isMIUIType(browser),
        isSamsungBrowser: $f230858f3ff7a967$var$isSamsungBrowserType(browser)
    };
}
var $f230858f3ff7a967$var$isSmartTV = $f230858f3ff7a967$var$isSmartTVType($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$isConsole = $f230858f3ff7a967$var$isConsoleType($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$isWearable = $f230858f3ff7a967$var$isWearableType($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$isEmbedded = $f230858f3ff7a967$var$isEmbeddedType($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$isMobileSafari = $f230858f3ff7a967$var$isMobileSafariType($f230858f3ff7a967$var$browser) || $f230858f3ff7a967$var$getIPad13();
var $f230858f3ff7a967$var$isChromium = $f230858f3ff7a967$var$isChromiumType($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$isMobile = $f230858f3ff7a967$var$isMobileAndTabletType($f230858f3ff7a967$var$device) || $f230858f3ff7a967$var$getIPad13();
var $f230858f3ff7a967$var$isMobileOnly = $f230858f3ff7a967$var$isMobileType($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$isTablet = $f230858f3ff7a967$var$isTabletType($f230858f3ff7a967$var$device) || $f230858f3ff7a967$var$getIPad13();
var $f230858f3ff7a967$var$isBrowser = $f230858f3ff7a967$var$isBrowserType($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$isDesktop = $f230858f3ff7a967$var$isBrowserType($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$isAndroid = $f230858f3ff7a967$var$isAndroidType($f230858f3ff7a967$var$os);
var $f230858f3ff7a967$var$isWinPhone = $f230858f3ff7a967$var$isWinPhoneType($f230858f3ff7a967$var$os);
var $f230858f3ff7a967$var$isIOS = $f230858f3ff7a967$var$isIOSType($f230858f3ff7a967$var$os) || $f230858f3ff7a967$var$getIPad13();
var $f230858f3ff7a967$var$isChrome = $f230858f3ff7a967$var$isChromeType($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$isFirefox = $f230858f3ff7a967$var$isFirefoxType($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$isSafari = $f230858f3ff7a967$var$isSafariType($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$isOpera = $f230858f3ff7a967$var$isOperaType($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$isIE = $f230858f3ff7a967$var$isIEType($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$osVersion = $f230858f3ff7a967$var$getOsVersion($f230858f3ff7a967$var$os);
var $f230858f3ff7a967$var$osName = $f230858f3ff7a967$var$getOsName($f230858f3ff7a967$var$os);
var $f230858f3ff7a967$var$fullBrowserVersion = $f230858f3ff7a967$var$getBrowserFullVersion($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$browserVersion = $f230858f3ff7a967$var$getBrowserVersion($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$browserName = $f230858f3ff7a967$var$getBrowserName($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$mobileVendor = $f230858f3ff7a967$var$getMobileVendor($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$mobileModel = $f230858f3ff7a967$var$getMobileModel($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$engineName = $f230858f3ff7a967$var$getEngineName($f230858f3ff7a967$var$engine);
var $f230858f3ff7a967$var$engineVersion = $f230858f3ff7a967$var$getEngineVersion($f230858f3ff7a967$var$engine);
var $f230858f3ff7a967$var$getUA = $f230858f3ff7a967$var$getUseragent($f230858f3ff7a967$var$ua);
var $f230858f3ff7a967$var$isEdge = $f230858f3ff7a967$var$isEdgeType($f230858f3ff7a967$var$browser) || $f230858f3ff7a967$var$isEdgeChromiumType($f230858f3ff7a967$var$ua);
var $f230858f3ff7a967$var$isYandex = $f230858f3ff7a967$var$isYandexType($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$deviceType = $f230858f3ff7a967$var$getDeviceType($f230858f3ff7a967$var$device);
var $f230858f3ff7a967$var$isIOS13 = $f230858f3ff7a967$var$getIOS13();
var $f230858f3ff7a967$var$isIPad13 = $f230858f3ff7a967$var$getIPad13();
var $f230858f3ff7a967$var$isIPhone13 = $f230858f3ff7a967$var$getIphone13();
var $f230858f3ff7a967$var$isIPod13 = $f230858f3ff7a967$var$getIPod13();
var $f230858f3ff7a967$var$isElectron = $f230858f3ff7a967$var$isElectronType();
var $f230858f3ff7a967$var$isEdgeChromium = $f230858f3ff7a967$var$isEdgeChromiumType($f230858f3ff7a967$var$ua);
var $f230858f3ff7a967$var$isLegacyEdge = $f230858f3ff7a967$var$isEdgeType($f230858f3ff7a967$var$browser) && !$f230858f3ff7a967$var$isEdgeChromiumType($f230858f3ff7a967$var$ua);
var $f230858f3ff7a967$var$isWindows = $f230858f3ff7a967$var$isWindowsType($f230858f3ff7a967$var$os);
var $f230858f3ff7a967$var$isMacOs = $f230858f3ff7a967$var$isMacOsType($f230858f3ff7a967$var$os);
var $f230858f3ff7a967$var$isMIUI = $f230858f3ff7a967$var$isMIUIType($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$isSamsungBrowser = $f230858f3ff7a967$var$isSamsungBrowserType($f230858f3ff7a967$var$browser);
var $f230858f3ff7a967$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $f230858f3ff7a967$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $f230858f3ff7a967$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $f230858f3ff7a967$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isAndroid ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isBrowser ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isIE ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isIOS ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isMobile ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isTablet ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isWinPhone ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $f230858f3ff7a967$var$isMobileOnly ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isSmartTV ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isConsole ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $f230858f3ff7a967$var$isWearable ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
var $f230858f3ff7a967$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $f230858f3ff7a967$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $f230858f3ff7a967$var$React__default.createElement($kVN77.Fragment, null, children) : $f230858f3ff7a967$var$React__default.createElement("div", props, children) : null;
};
function $f230858f3ff7a967$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $f230858f3ff7a967$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $f230858f3ff7a967$var$_classCallCheck(this, _class);
            _this = $f230858f3ff7a967$var$_possibleConstructorReturn(this, $f230858f3ff7a967$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($f230858f3ff7a967$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($f230858f3ff7a967$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($f230858f3ff7a967$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $f230858f3ff7a967$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $f230858f3ff7a967$var$_typeof(window)) !== undefined && $f230858f3ff7a967$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $f230858f3ff7a967$var$React__default.createElement(WrappedComponent, $f230858f3ff7a967$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($f230858f3ff7a967$var$React__default.Component);
}
function $f230858f3ff7a967$var$useMobileOrientation() {
    var _useState = $kVN77.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $f230858f3ff7a967$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $kVN77.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $kVN77.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $f230858f3ff7a967$var$_typeof(window)) !== undefined && $f230858f3ff7a967$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $f230858f3ff7a967$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $f230858f3ff7a967$var$parseUserAgent(hookUserAgent);
}
function $f230858f3ff7a967$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $f230858f3ff7a967$var$useDeviceData(hookUserAgent);
    var selectors = $f230858f3ff7a967$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$f230858f3ff7a967$exports.AndroidView = $f230858f3ff7a967$var$AndroidView;
$f230858f3ff7a967$exports.BrowserTypes = $f230858f3ff7a967$var$BrowserTypes;
$f230858f3ff7a967$exports.BrowserView = $f230858f3ff7a967$var$BrowserView;
$f230858f3ff7a967$exports.ConsoleView = $f230858f3ff7a967$var$ConsoleView;
$f230858f3ff7a967$exports.CustomView = $f230858f3ff7a967$var$CustomView;
$f230858f3ff7a967$exports.IEView = $f230858f3ff7a967$var$IEView;
$f230858f3ff7a967$exports.IOSView = $f230858f3ff7a967$var$IOSView;
$f230858f3ff7a967$exports.MobileOnlyView = $f230858f3ff7a967$var$MobileOnlyView;
$f230858f3ff7a967$exports.MobileView = $f230858f3ff7a967$var$MobileView;
$f230858f3ff7a967$exports.OsTypes = $f230858f3ff7a967$var$OsTypes;
$f230858f3ff7a967$exports.SmartTVView = $f230858f3ff7a967$var$SmartTVView;
$f230858f3ff7a967$exports.TabletView = $f230858f3ff7a967$var$TabletView;
$f230858f3ff7a967$exports.WearableView = $f230858f3ff7a967$var$WearableView;
$f230858f3ff7a967$exports.WinPhoneView = $f230858f3ff7a967$var$WinPhoneView;
$f230858f3ff7a967$exports.browserName = $f230858f3ff7a967$var$browserName;
$f230858f3ff7a967$exports.browserVersion = $f230858f3ff7a967$var$browserVersion;
$f230858f3ff7a967$exports.deviceDetect = $f230858f3ff7a967$var$deviceDetect;
$f230858f3ff7a967$exports.deviceType = $f230858f3ff7a967$var$deviceType;
$f230858f3ff7a967$exports.engineName = $f230858f3ff7a967$var$engineName;
$f230858f3ff7a967$exports.engineVersion = $f230858f3ff7a967$var$engineVersion;
$f230858f3ff7a967$exports.fullBrowserVersion = $f230858f3ff7a967$var$fullBrowserVersion;
$f230858f3ff7a967$exports.getSelectorsByUserAgent = $f230858f3ff7a967$var$getSelectorsByUserAgent;
$f230858f3ff7a967$exports.getUA = $f230858f3ff7a967$var$getUA;
$f230858f3ff7a967$exports.isAndroid = $f230858f3ff7a967$var$isAndroid;
$f230858f3ff7a967$exports.isBrowser = $f230858f3ff7a967$var$isBrowser;
$f230858f3ff7a967$exports.isChrome = $f230858f3ff7a967$var$isChrome;
$f230858f3ff7a967$exports.isChromium = $f230858f3ff7a967$var$isChromium;
$f230858f3ff7a967$exports.isConsole = $f230858f3ff7a967$var$isConsole;
$f230858f3ff7a967$exports.isDesktop = $f230858f3ff7a967$var$isDesktop;
$f230858f3ff7a967$exports.isEdge = $f230858f3ff7a967$var$isEdge;
$f230858f3ff7a967$exports.isEdgeChromium = $f230858f3ff7a967$var$isEdgeChromium;
$f230858f3ff7a967$exports.isElectron = $f230858f3ff7a967$var$isElectron;
$f230858f3ff7a967$exports.isEmbedded = $f230858f3ff7a967$var$isEmbedded;
$f230858f3ff7a967$exports.isFirefox = $f230858f3ff7a967$var$isFirefox;
$f230858f3ff7a967$exports.isIE = $f230858f3ff7a967$var$isIE;
$f230858f3ff7a967$exports.isIOS = $f230858f3ff7a967$var$isIOS;
$f230858f3ff7a967$exports.isIOS13 = $f230858f3ff7a967$var$isIOS13;
$f230858f3ff7a967$exports.isIPad13 = $f230858f3ff7a967$var$isIPad13;
$f230858f3ff7a967$exports.isIPhone13 = $f230858f3ff7a967$var$isIPhone13;
$f230858f3ff7a967$exports.isIPod13 = $f230858f3ff7a967$var$isIPod13;
$f230858f3ff7a967$exports.isLegacyEdge = $f230858f3ff7a967$var$isLegacyEdge;
$f230858f3ff7a967$exports.isMIUI = $f230858f3ff7a967$var$isMIUI;
$f230858f3ff7a967$exports.isMacOs = $f230858f3ff7a967$var$isMacOs;
$f230858f3ff7a967$exports.isMobile = $f230858f3ff7a967$var$isMobile;
$f230858f3ff7a967$exports.isMobileOnly = $f230858f3ff7a967$var$isMobileOnly;
$f230858f3ff7a967$exports.isMobileSafari = $f230858f3ff7a967$var$isMobileSafari;
$f230858f3ff7a967$exports.isOpera = $f230858f3ff7a967$var$isOpera;
$f230858f3ff7a967$exports.isSafari = $f230858f3ff7a967$var$isSafari;
$f230858f3ff7a967$exports.isSamsungBrowser = $f230858f3ff7a967$var$isSamsungBrowser;
$f230858f3ff7a967$exports.isSmartTV = $f230858f3ff7a967$var$isSmartTV;
$f230858f3ff7a967$exports.isTablet = $f230858f3ff7a967$var$isTablet;
$f230858f3ff7a967$exports.isWearable = $f230858f3ff7a967$var$isWearable;
$f230858f3ff7a967$exports.isWinPhone = $f230858f3ff7a967$var$isWinPhone;
$f230858f3ff7a967$exports.isWindows = $f230858f3ff7a967$var$isWindows;
$f230858f3ff7a967$exports.isYandex = $f230858f3ff7a967$var$isYandex;
$f230858f3ff7a967$exports.mobileModel = $f230858f3ff7a967$var$mobileModel;
$f230858f3ff7a967$exports.mobileVendor = $f230858f3ff7a967$var$mobileVendor;
$f230858f3ff7a967$exports.osName = $f230858f3ff7a967$var$osName;
$f230858f3ff7a967$exports.osVersion = $f230858f3ff7a967$var$osVersion;
$f230858f3ff7a967$exports.parseUserAgent = $f230858f3ff7a967$var$parseUserAgent;
$f230858f3ff7a967$exports.setUserAgent = $f230858f3ff7a967$var$setUserAgent;
$f230858f3ff7a967$exports.useDeviceData = $f230858f3ff7a967$var$useDeviceData;
$f230858f3ff7a967$exports.useDeviceSelectors = $f230858f3ff7a967$var$useDeviceSelectors;
$f230858f3ff7a967$exports.useMobileOrientation = $f230858f3ff7a967$var$useMobileOrientation;
$f230858f3ff7a967$exports.withOrientationChange = $f230858f3ff7a967$var$withOrientationChange;


var $0125155968220dbd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kVN77.createContext)({
    toast: "",
    theme: (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Light,
    loading: false,
    platform: (0, $f230858f3ff7a967$exports.isMobile) ? "mobile" : "web",
    termsAgreement: false,
    experienceSettings: undefined,
    isPreview: false,
    setTheme: (0, $71d6ce9e3e366d69$export$8793edee2d425525),
    setToast: (0, $71d6ce9e3e366d69$export$8793edee2d425525),
    setLoading: (0, $71d6ce9e3e366d69$export$8793edee2d425525),
    setPlatform: (0, $71d6ce9e3e366d69$export$8793edee2d425525),
    setTermsAgreement: (0, $71d6ce9e3e366d69$export$8793edee2d425525),
    setExperienceSettings: (0, $71d6ce9e3e366d69$export$8793edee2d425525)
});





parcelRequire("kVN77");
var $2e2209140b86fa70$var$SvgLogtoLogoDark = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 52,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("g", {
                clipPath: "url(#logto-logo-dark_svg__a)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z",
                        fill: "#928F9A"
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z",
                        fill: "url(#logto-logo-dark_svg__b)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                d: "M25.304 13.873c-.747 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.437-1.213-.437-1.951 0-.758.15-1.413.451-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.301.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952a3.23 3.23 0 0 1-1.267 1.31c-.543.302-1.19.457-1.937.467Zm.015-1.413c.408 0 .757-.102 1.048-.306.292-.204.515-.48.67-.83.166-.35.248-.743.248-1.18 0-.446-.078-.845-.233-1.194a1.861 1.861 0 0 0-.67-.816c-.291-.204-.64-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.247 1.18 0 .447.077.845.233 1.194.155.35.383.627.684.83.301.195.65.292 1.049.292ZM36.5 6.696a.076.076 0 0 0-.077-.076H34.93a.076.076 0 0 0-.076.076v7.453c0 .496-.185.803-.554 1.075-.36.272-.763.36-1.336.37-.398-.01-.772-.045-1.102-.151a6.157 6.157 0 0 1-1.002-.402.077.077 0 0 0-.103.036l-.537 1.144a.074.074 0 0 0 .025.093c.163.112.355.212.574.3.243.096.49.174.743.232.262.068.533.125.766.154.243.03.472.033.618.033.738 0 1.369-.116 1.893-.35.534-.232.942-.563 1.224-.99.29-.427.436-.937.436-1.529V6.696Zm-1.19 4.824a.078.078 0 0 0-.13-.02 3.174 3.174 0 0 1-.85.712 2.002 2.002 0 0 1-1.006.248c-.388 0-.728-.097-1.02-.291a1.901 1.901 0 0 1-.64-.83 3.123 3.123 0 0 1-.219-1.21c0-.436.073-.825.219-1.165.146-.35.36-.626.64-.83a1.757 1.757 0 0 1 1.035-.306c.369 0 .66.078.961.233.281.141.58.462.838.797.035.047.109.038.132-.016l.413-.975a.075.075 0 0 0-.007-.073c-.522-.748-1.404-1.364-2.408-1.364-.728 0-1.303.156-1.837.466-.534.311-.947.743-1.238 1.297-.282.553-.422 1.199-.422 1.937 0 .757.14 1.417.422 1.98.282.554.684.986 1.209 1.297.534.31 1.165.466 1.893.466.272 0 .554-.054.845-.16.301-.098.592-.243.874-.438.27-.185.508-.407.715-.664a.075.075 0 0 0 .01-.076l-.429-1.015ZM41.986 6.754a.076.076 0 0 0-.076-.076h-1.624a.076.076 0 0 1-.077-.076V4.615a.076.076 0 0 0-.076-.076h-1.479a.076.076 0 0 0-.076.076v1.987a.076.076 0 0 1-.076.076h-.99a.076.076 0 0 0-.075.077l.013 1.231c0 .042.034.075.076.075h.976c.042 0 .076.034.076.076v3.434c0 .515.102.952.306 1.311.214.35.505.617.874.801.369.185.816.277 1.34.277.146 0 .3-.02.466-.058a3.23 3.23 0 0 0 .49-.138c.13-.049.383-.176.512-.25a.072.072 0 0 0 .025-.099l-.6-1.06a.078.078 0 0 0-.097-.033 2.279 2.279 0 0 1-.3.091 1.68 1.68 0 0 1-.38.044c-.34 0-.592-.036-.757-.26-.165-.232-.248-.528-.248-.888V8.137c0-.042.034-.076.076-.076h1.625a.076.076 0 0 0 .076-.076V6.754ZM46.406 13.873c-.748 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.438-1.213-.438-1.951 0-.758.151-1.413.452-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.3.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952-.3.563-.723 1-1.267 1.31-.544.302-1.19.457-1.937.467Zm.015-1.413c.407 0 .757-.102 1.048-.306a1.96 1.96 0 0 0 .67-.83 2.73 2.73 0 0 0 .248-1.18c0-.446-.078-.845-.233-1.194a1.86 1.86 0 0 0-.67-.816c-.291-.204-.641-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.248 1.18 0 .447.078.845.233 1.194.156.35.384.627.685.83.301.195.65.292 1.049.292ZM21.053 12.402a.076.076 0 0 0-.076-.076h-3.91a.076.076 0 0 1-.076-.076V4.235a.076.076 0 0 0-.076-.076h-1.464a.076.076 0 0 0-.077.076v9.562c0 .042.034.076.076.076h5.527a.076.076 0 0 0 .076-.076v-1.395Z",
                fill: "#F7F8F8"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("linearGradient", {
                        id: "logto-logo-dark_svg__b",
                        x1: -2.219,
                        y1: 11.49,
                        x2: 10.737,
                        y2: 6.406,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("stop", {
                                stopColor: "#4B2EFB"
                            }),
                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E65FFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("clipPath", {
                        id: "logto-logo-dark_svg__a",
                        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(1 2.5)",
                            d: "M0 0h10.4v13H0z"
                        })
                    })
                ]
            })
        ]
    }));
};
var $2e2209140b86fa70$export$2e2bcd8739ae039 = $2e2209140b86fa70$var$SvgLogtoLogoDark;





parcelRequire("kVN77");
var $3c3f47d47f293c4d$var$SvgLogtoLogoLight = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 52,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("g", {
                clipPath: "url(#logto-logo-light_svg__a)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z",
                        fill: "#928F9A"
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z",
                        fill: "url(#logto-logo-light_svg__b)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                d: "M25.304 13.873c-.747 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.437-1.213-.437-1.951 0-.758.15-1.413.451-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.301.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952a3.23 3.23 0 0 1-1.267 1.31c-.543.302-1.19.457-1.937.467Zm.015-1.413c.408 0 .757-.102 1.048-.306.292-.204.515-.48.67-.83.166-.35.248-.743.248-1.18 0-.446-.078-.845-.233-1.194a1.861 1.861 0 0 0-.67-.816c-.291-.204-.64-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.247 1.18 0 .447.077.845.233 1.194.155.35.383.627.684.83.301.195.65.292 1.049.292ZM36.5 6.696a.076.076 0 0 0-.077-.076H34.93a.076.076 0 0 0-.076.076v7.453c0 .496-.185.803-.554 1.075-.36.272-.763.36-1.336.37-.398-.01-.772-.045-1.102-.151a6.157 6.157 0 0 1-1.002-.402.077.077 0 0 0-.103.036l-.537 1.144a.074.074 0 0 0 .025.093c.163.112.355.212.574.3.243.096.49.174.743.232.262.068.533.125.766.154.243.03.472.033.618.033.738 0 1.369-.116 1.893-.35.534-.232.942-.563 1.224-.99.29-.427.436-.937.436-1.529V6.696Zm-1.19 4.824a.078.078 0 0 0-.13-.02 3.174 3.174 0 0 1-.85.712 2.002 2.002 0 0 1-1.006.248c-.388 0-.728-.097-1.02-.291a1.901 1.901 0 0 1-.64-.83 3.123 3.123 0 0 1-.219-1.21c0-.436.073-.825.219-1.165.146-.35.36-.626.64-.83a1.757 1.757 0 0 1 1.035-.306c.369 0 .66.078.961.233.281.141.58.462.838.797.035.047.109.038.132-.016l.413-.975a.075.075 0 0 0-.007-.073c-.522-.748-1.404-1.364-2.408-1.364-.728 0-1.303.156-1.837.466-.534.311-.947.743-1.238 1.297-.282.553-.422 1.199-.422 1.937 0 .757.14 1.417.422 1.98.282.554.684.986 1.209 1.297.534.31 1.165.466 1.893.466.272 0 .554-.054.845-.16.301-.098.592-.243.874-.438.27-.185.508-.407.715-.664a.075.075 0 0 0 .01-.076l-.429-1.015ZM41.986 6.754a.076.076 0 0 0-.076-.076h-1.624a.076.076 0 0 1-.077-.076V4.615a.076.076 0 0 0-.076-.076h-1.479a.076.076 0 0 0-.076.076v1.987a.076.076 0 0 1-.076.076h-.99a.076.076 0 0 0-.075.077l.013 1.231c0 .042.034.075.076.075h.976c.042 0 .076.034.076.076v3.434c0 .515.102.952.306 1.311.214.35.505.617.874.801.369.185.816.277 1.34.277.146 0 .3-.02.466-.058.175-.039.344-.08.49-.138.13-.049.383-.176.512-.25a.072.072 0 0 0 .025-.099l-.6-1.06a.078.078 0 0 0-.097-.033 2.279 2.279 0 0 1-.3.091 1.68 1.68 0 0 1-.38.044c-.34 0-.592-.036-.757-.26-.165-.232-.248-.528-.248-.888V8.137c0-.042.034-.076.076-.076h1.625a.076.076 0 0 0 .076-.076V6.754ZM46.406 13.873c-.748 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.438-1.213-.438-1.951 0-.758.151-1.413.452-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.3.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952-.3.563-.723 1-1.267 1.31-.544.302-1.19.457-1.937.467Zm.015-1.413c.407 0 .757-.102 1.048-.306a1.96 1.96 0 0 0 .67-.83 2.73 2.73 0 0 0 .248-1.18c0-.446-.078-.845-.233-1.194a1.86 1.86 0 0 0-.67-.816c-.291-.204-.641-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.248 1.18 0 .447.078.845.233 1.194.156.35.384.627.685.83.301.195.65.292 1.049.292ZM21.053 12.402a.076.076 0 0 0-.076-.076h-3.91a.076.076 0 0 1-.076-.076V4.235a.076.076 0 0 0-.076-.076h-1.464a.076.076 0 0 0-.077.076v9.562c0 .042.034.076.076.076h5.527a.076.076 0 0 0 .076-.076v-1.395Z",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("linearGradient", {
                        id: "logto-logo-light_svg__b",
                        x1: -2.219,
                        y1: 11.49,
                        x2: 10.737,
                        y2: 6.406,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("stop", {
                                stopColor: "#4B2EFB"
                            }),
                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E65FFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("clipPath", {
                        id: "logto-logo-light_svg__a",
                        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(1 2.5)",
                            d: "M0 0h10.4v13H0z"
                        })
                    })
                ]
            })
        ]
    }));
};
var $3c3f47d47f293c4d$export$2e2bcd8739ae039 = $3c3f47d47f293c4d$var$SvgLogtoLogoLight;





parcelRequire("kVN77");
var $8028b84db508dfa4$var$SvgLogtoLogoShadow = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 52,
        height: 18,
        fill: "currentcolor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("g", {
                opacity: 0.8,
                clipPath: "url(#logto-logo-shadow_svg__a)",
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z"
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                d: "M25.304 13.873c-.747 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.437-1.213-.437-1.951 0-.758.15-1.413.451-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.301.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952a3.23 3.23 0 0 1-1.267 1.31c-.543.302-1.19.457-1.937.467Zm.015-1.413c.408 0 .757-.102 1.048-.306.292-.204.515-.48.67-.83.166-.35.248-.743.248-1.18 0-.446-.078-.845-.233-1.194a1.861 1.861 0 0 0-.67-.816c-.291-.204-.64-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.247 1.18 0 .447.077.845.233 1.194.155.35.383.627.684.83.301.195.65.292 1.049.292ZM36.5 6.696a.076.076 0 0 0-.077-.076H34.93a.076.076 0 0 0-.076.076v7.453c0 .496-.185.803-.554 1.075-.36.272-.763.36-1.336.37-.398-.01-.772-.045-1.102-.151a6.157 6.157 0 0 1-1.002-.402.077.077 0 0 0-.103.036l-.537 1.144a.074.074 0 0 0 .025.093c.163.112.355.212.574.3.243.096.49.174.743.232.262.068.533.125.766.154.243.03.472.033.618.033.738 0 1.369-.116 1.893-.35.534-.232.942-.563 1.224-.99.29-.427.436-.937.436-1.529V6.696Zm-1.19 4.824a.078.078 0 0 0-.13-.02 3.174 3.174 0 0 1-.85.712 2.002 2.002 0 0 1-1.006.248c-.388 0-.728-.097-1.02-.291a1.901 1.901 0 0 1-.64-.83 3.123 3.123 0 0 1-.219-1.21c0-.436.073-.825.219-1.165.146-.35.36-.626.64-.83a1.757 1.757 0 0 1 1.035-.306c.369 0 .66.078.961.233.281.141.58.462.838.797.035.047.109.038.132-.016l.413-.975a.075.075 0 0 0-.007-.073c-.522-.748-1.404-1.364-2.408-1.364-.728 0-1.303.156-1.837.466-.534.311-.947.743-1.238 1.297-.282.553-.422 1.199-.422 1.937 0 .757.14 1.417.422 1.98.282.554.684.986 1.209 1.297.534.31 1.165.466 1.893.466.272 0 .554-.054.845-.16.301-.098.592-.243.874-.438.27-.185.508-.407.715-.664a.075.075 0 0 0 .01-.076l-.429-1.015ZM41.986 6.754a.076.076 0 0 0-.076-.076h-1.624a.076.076 0 0 1-.077-.076V4.615a.076.076 0 0 0-.076-.076h-1.479a.076.076 0 0 0-.076.076v1.987a.076.076 0 0 1-.076.076h-.99a.076.076 0 0 0-.075.077l.013 1.231c0 .042.034.075.076.075h.976c.042 0 .076.034.076.076v3.434c0 .515.102.952.306 1.311.214.35.505.617.874.801.369.185.816.277 1.34.277.146 0 .3-.02.466-.058a3.23 3.23 0 0 0 .49-.138c.13-.049.383-.176.512-.25a.072.072 0 0 0 .025-.099l-.6-1.06a.078.078 0 0 0-.097-.033 2.279 2.279 0 0 1-.3.091 1.68 1.68 0 0 1-.38.044c-.34 0-.592-.036-.757-.26-.165-.232-.248-.528-.248-.888V8.137c0-.042.034-.076.076-.076h1.625a.076.076 0 0 0 .076-.076V6.754ZM46.406 13.873c-.748 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.438-1.213-.438-1.951 0-.758.151-1.413.452-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.3.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952-.3.563-.723 1-1.267 1.31-.544.302-1.19.457-1.937.467Zm.015-1.413c.407 0 .757-.102 1.048-.306a1.96 1.96 0 0 0 .67-.83 2.73 2.73 0 0 0 .248-1.18c0-.446-.078-.845-.233-1.194a1.86 1.86 0 0 0-.67-.816c-.291-.204-.641-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.248 1.18 0 .447.078.845.233 1.194.156.35.384.627.685.83.301.195.65.292 1.049.292ZM21.053 12.402a.076.076 0 0 0-.076-.076h-3.91a.076.076 0 0 1-.076-.076V4.235a.076.076 0 0 0-.076-.076h-1.464a.076.076 0 0 0-.077.076v9.562c0 .042.034.076.076.076h5.527a.076.076 0 0 0 .076-.076v-1.395Z"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("clipPath", {
                    id: "logto-logo-shadow_svg__a",
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(1 2.5)",
                        d: "M0 0h10.4v13H0z"
                    })
                })
            })
        ]
    }));
};
var $8028b84db508dfa4$export$2e2bcd8739ae039 = $8028b84db508dfa4$var$SvgLogtoLogoShadow;


var $26002d848aae73e1$export$1e394180dfc32a3c;
var $26002d848aae73e1$export$c9cd164b539ebb63;
var $26002d848aae73e1$export$e3dbcf7481dc9d;
var $26002d848aae73e1$export$6f093cfa640b7166;
$26002d848aae73e1$export$1e394180dfc32a3c = "uuY68G_highlightIcon";
$26002d848aae73e1$export$c9cd164b539ebb63 = "uuY68G_signature";
$26002d848aae73e1$export$e3dbcf7481dc9d = "uuY68G_staticIcon";
$26002d848aae73e1$export$6f093cfa640b7166 = "uuY68G_text";


var $3befa8c5871b7fae$var$logtoUrl = "https://logto.io/?".concat(new URLSearchParams({
    utm_source: "sign_in",
    utm_medium: "powered_by"
}).toString());
var $3befa8c5871b7fae$var$LogtoSignature = function(param) {
    var className = param.className;
    var theme = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).theme;
    var LogtoLogo = theme === (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Light ? (0, $3c3f47d47f293c4d$export$2e2bcd8739ae039) : (0, $2e2209140b86fa70$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("a", {
            className: $26002d848aae73e1$export$c9cd164b539ebb63,
            "aria-label": "Powered By Logto",
            href: $3befa8c5871b7fae$var$logtoUrl.toString(),
            target: "_blank",
            rel: "noopener",
            children: [
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
                    className: $26002d848aae73e1$export$6f093cfa640b7166,
                    children: "Powered by"
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8028b84db508dfa4$export$2e2bcd8739ae039), {
                    className: $26002d848aae73e1$export$e3dbcf7481dc9d
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)(LogtoLogo, {
                    className: $26002d848aae73e1$export$1e394180dfc32a3c
                })
            ]
        })
    });
};
var $3befa8c5871b7fae$export$2e2bcd8739ae039 = $3befa8c5871b7fae$var$LogtoSignature;






var $kVN77 = parcelRequire("kVN77");
function $dc6b79f8788226f5$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $dc6b79f8788226f5$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dc6b79f8788226f5$export$2e2bcd8739ae039(obj);
}



function $d7b2f3e8a6ec848c$export$2e2bcd8739ae039(input, hint) {
    if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3c6fffd6ad89a4c2$export$2e2bcd8739ae039(arg) {
    var key = (0, $d7b2f3e8a6ec848c$export$2e2bcd8739ae039)(arg, "string");
    return (0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $015c42b2ccedc741$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3c6fffd6ad89a4c2$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $cd1508321e981b61$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $f4f0e761fcedffde$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $cd1508321e981b61$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $kVN77 = parcelRequire("kVN77");




var $kVN77 = parcelRequire("kVN77");
var $10b3e6e709913965$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $10b3e6e709913965$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $8e234a84d5bccdad$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $8e234a84d5bccdad$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($10b3e6e709913965$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($8e234a84d5bccdad$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $8e234a84d5bccdad$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $8e234a84d5bccdad$var$i = /^\s*$/, $8e234a84d5bccdad$var$s = Object.create(null);
function $8e234a84d5bccdad$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var _$t = [];
                for(var n in e)_$t.push(n + '="' + e[n] + '"');
                return _$t.length ? " " + _$t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($8e234a84d5bccdad$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $8e234a84d5bccdad$var$c = {
    parse: function parse(e, t) {
        t || (t = {}), t.components || (t.components = $8e234a84d5bccdad$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($8e234a84d5bccdad$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $8e234a84d5bccdad$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $8e234a84d5bccdad$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $8e234a84d5bccdad$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function stringify(e) {
        return e.reduce(function(e, t) {
            return e + $8e234a84d5bccdad$var$a("", t);
        }, "");
    }
};
var $8e234a84d5bccdad$export$2e2bcd8739ae039 = $8e234a84d5bccdad$var$c;


function $397bf121c4524fd2$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $397bf121c4524fd2$var$alreadyWarned = {};
function $397bf121c4524fd2$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $397bf121c4524fd2$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $397bf121c4524fd2$var$alreadyWarned[args[0]] = new Date();
    $397bf121c4524fd2$export$c106dd0671a0fc2d.apply(void 0, args);
}
var $397bf121c4524fd2$var$loadedClb = function loadedClb(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
};
function $397bf121c4524fd2$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $397bf121c4524fd2$var$loadedClb(i18n, cb));
}
function $397bf121c4524fd2$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $397bf121c4524fd2$var$loadedClb(i18n, cb));
}
function $397bf121c4524fd2$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $397bf121c4524fd2$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $397bf121c4524fd2$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $397bf121c4524fd2$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $397bf121c4524fd2$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}



var $2ce9fb8f289da53c$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $2ce9fb8f289da53c$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $2ce9fb8f289da53c$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $2ce9fb8f289da53c$var$htmlEntities[m];
};
var $2ce9fb8f289da53c$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($2ce9fb8f289da53c$var$matchHtmlEntity, $2ce9fb8f289da53c$var$unescapeHtmlEntity);
};


function $e416584c203ad040$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e416584c203ad040$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e416584c203ad040$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e416584c203ad040$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e416584c203ad040$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $2ce9fb8f289da53c$export$e8bacd2802a88316)
};
function $e416584c203ad040$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $e416584c203ad040$var$defaultOptions = $e416584c203ad040$var$_objectSpread($e416584c203ad040$var$_objectSpread({}, $e416584c203ad040$var$defaultOptions), options);
}
function $e416584c203ad040$export$212bb2fc580a90a8() {
    return $e416584c203ad040$var$defaultOptions;
}


var $045718413ed7c19a$var$i18nInstance;
function $045718413ed7c19a$export$a039134f2fc7e0(instance) {
    $045718413ed7c19a$var$i18nInstance = instance;
}
function $045718413ed7c19a$export$64af334f494c2f47() {
    return $045718413ed7c19a$var$i18nInstance;
}


var $1c83f27a8825ee32$var$_excluded = [
    "format"
], $1c83f27a8825ee32$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $1c83f27a8825ee32$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c83f27a8825ee32$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1c83f27a8825ee32$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1c83f27a8825ee32$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1c83f27a8825ee32$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $1c83f27a8825ee32$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $1c83f27a8825ee32$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $kVN77.isValidElement)(child);
    });
}
function $1c83f27a8825ee32$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $1c83f27a8825ee32$var$mergeProps(source, target) {
    var newTarget = $1c83f27a8825ee32$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $1c83f27a8825ee32$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $1c83f27a8825ee32$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $kVN77.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $1c83f27a8825ee32$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $397bf121c4524fd2$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(child) === "object") {
            var format = child.format, clone = (0, $f4f0e761fcedffde$export$2e2bcd8739ae039)(child, $1c83f27a8825ee32$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $397bf121c4524fd2$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $397bf121c4524fd2$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $1c83f27a8825ee32$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $1c83f27a8825ee32$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($1c83f27a8825ee32$var$hasChildren(child)) getData($1c83f27a8825ee32$var$getChildren(child));
            else if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(child) === "object" && !(0, $kVN77.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $8e234a84d5bccdad$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $1c83f27a8825ee32$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $1c83f27a8825ee32$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $kVN77.cloneElement)(child, $1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $1c83f27a8825ee32$var$getAsArray(reactNode);
        var astNodes = $1c83f27a8825ee32$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $1c83f27a8825ee32$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $kVN77.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $1c83f27a8825ee32$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($1c83f27a8825ee32$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $kVN77.cloneElement)(child, $1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $kVN77.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $kVN77.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $kVN77.cloneElement)(child, $1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $kVN77.cloneElement)(child, $1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $kVN77.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $1c83f27a8825ee32$var$getAsArray(children || []));
    return $1c83f27a8825ee32$var$getChildren(result[0]);
}
function $1c83f27a8825ee32$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $f4f0e761fcedffde$export$2e2bcd8739ae039)(_ref, $1c83f27a8825ee32$var$_excluded2);
    var i18n = i18nFromProps || (0, $045718413ed7c19a$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $397bf121c4524fd2$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread({}, (0, $e416584c203ad040$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $1c83f27a8825ee32$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread($1c83f27a8825ee32$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $1c83f27a8825ee32$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $kVN77.createElement)(useAsParent, additionalProps, content) : content;
}



function $72cbeaa3bc3caa2a$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $0ec9a1d27e914406$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $3c6fffd6ad89a4c2$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $0ec9a1d27e914406$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $0ec9a1d27e914406$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0ec9a1d27e914406$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



var $kVN77 = parcelRequire("kVN77");




var $cd4ffcd56d27534c$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $e416584c203ad040$export$2e2366488d12e20d)(instance.options.react);
        (0, $045718413ed7c19a$export$a039134f2fc7e0)(instance);
    }
};


function $5b070c6752b89293$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5b070c6752b89293$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5b070c6752b89293$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5b070c6752b89293$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $5b070c6752b89293$export$5603ab5ced17ce64 = (0, $kVN77.createContext)();
var $5b070c6752b89293$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $5b070c6752b89293$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $5b070c6752b89293$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($5b070c6752b89293$var$_objectSpread($5b070c6752b89293$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $5b070c6752b89293$export$704200e5d0b9e8f() {
    var i18n = (0, $045718413ed7c19a$export$64af334f494c2f47)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


var $056babc663998f62$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $056babc663998f62$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $056babc663998f62$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $056babc663998f62$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $056babc663998f62$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $056babc663998f62$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $f4f0e761fcedffde$export$2e2bcd8739ae039)(_ref, $056babc663998f62$var$_excluded);
    var _ref2 = (0, $kVN77.useContext)((0, $5b070c6752b89293$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $045718413ed7c19a$export$64af334f494c2f47)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $1c83f27a8825ee32$export$8d6a9236f2e3f2ce)($056babc663998f62$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}



function $b98b9d69bb2af8f9$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $6f5488a502a7d2e3$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $329f0868ebe2606a$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d55e1ef55abf35bc$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $329f0868ebe2606a$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $329f0868ebe2606a$export$2e2bcd8739ae039)(o, minLen);
}


function $c66d1290c5ae97e1$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $532fa301e3509bf3$export$2e2bcd8739ae039(arr, i) {
    return (0, $b98b9d69bb2af8f9$export$2e2bcd8739ae039)(arr) || (0, $6f5488a502a7d2e3$export$2e2bcd8739ae039)(arr, i) || (0, $d55e1ef55abf35bc$export$2e2bcd8739ae039)(arr, i) || (0, $c66d1290c5ae97e1$export$2e2bcd8739ae039)();
}





var $kVN77 = parcelRequire("kVN77");


function $700154fdcf4dc05d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $700154fdcf4dc05d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $700154fdcf4dc05d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $700154fdcf4dc05d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $700154fdcf4dc05d$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $kVN77.useRef)();
    (0, $kVN77.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $700154fdcf4dc05d$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $kVN77.useContext)((0, $5b070c6752b89293$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $045718413ed7c19a$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $5b070c6752b89293$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $397bf121c4524fd2$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(optsOrDefaultValue) === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $397bf121c4524fd2$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $700154fdcf4dc05d$var$_objectSpread($700154fdcf4dc05d$var$_objectSpread($700154fdcf4dc05d$var$_objectSpread({}, (0, $e416584c203ad040$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $397bf121c4524fd2$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $kVN77.useState)(getT), _useState2 = (0, $532fa301e3509bf3$export$2e2bcd8739ae039)(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
    var previousJoinedNS = $700154fdcf4dc05d$var$usePrevious(joinedNS);
    var isMounted = (0, $kVN77.useRef)(true);
    (0, $kVN77.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $397bf121c4524fd2$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
            else (0, $397bf121c4524fd2$export$83be934b53fff43b)(i18n, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $kVN77.useRef)(true);
    (0, $kVN77.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        if (props.lng) (0, $397bf121c4524fd2$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, function() {
            return resolve();
        });
        else (0, $397bf121c4524fd2$export$83be934b53fff43b)(i18n, namespaces, function() {
            return resolve();
        });
    });
}






var $kVN77 = parcelRequire("kVN77");


var $eeb3e7b41b5a41ad$var$_excluded = [
    "forwardedRef"
];
function $eeb3e7b41b5a41ad$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eeb3e7b41b5a41ad$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $eeb3e7b41b5a41ad$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $eeb3e7b41b5a41ad$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $eeb3e7b41b5a41ad$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, $f4f0e761fcedffde$export$2e2bcd8739ae039)(_ref, $eeb3e7b41b5a41ad$var$_excluded);
            var _useTranslation = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)(ns, $eeb3e7b41b5a41ad$var$_objectSpread($eeb3e7b41b5a41ad$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, $532fa301e3509bf3$export$2e2bcd8739ae039)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $eeb3e7b41b5a41ad$var$_objectSpread($eeb3e7b41b5a41ad$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $kVN77.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $397bf121c4524fd2$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $kVN77.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $kVN77.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}





var $03d857e59d303faa$var$_excluded = [
    "ns",
    "children"
];
function $03d857e59d303faa$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, $f4f0e761fcedffde$export$2e2bcd8739ae039)(props, $03d857e59d303faa$var$_excluded);
    var _useTranslation = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)(ns, options), _useTranslation2 = (0, $532fa301e3509bf3$export$2e2bcd8739ae039)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $kVN77 = parcelRequire("kVN77");

function $2a640dad638c2559$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $kVN77.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $kVN77.createElement)((0, $5b070c6752b89293$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





var $kVN77 = parcelRequire("kVN77");

var $kVN77 = parcelRequire("kVN77");

function $aa507d2c5d781281$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $kVN77.useContext)((0, $5b070c6752b89293$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $045718413ed7c19a$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




var $a0e0074698ab0edc$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $a0e0074698ab0edc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a0e0074698ab0edc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a0e0074698ab0edc$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a0e0074698ab0edc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a0e0074698ab0edc$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, $f4f0e761fcedffde$export$2e2bcd8739ae039)(_ref, $a0e0074698ab0edc$var$_excluded);
            (0, $aa507d2c5d781281$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $kVN77.createElement)(WrappedComponent, $a0e0074698ab0edc$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $5b070c6752b89293$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $397bf121c4524fd2$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







var $6e01808c8d1a3c3f$export$324d90190a8b822a = function date() {
    return "";
};
var $6e01808c8d1a3c3f$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $6e01808c8d1a3c3f$export$98e628dec113755e = function number() {
    return "";
};
var $6e01808c8d1a3c3f$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $6e01808c8d1a3c3f$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $6e01808c8d1a3c3f$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};






parcelRequire("kVN77");
var $7ce74be83f7ef192$var$SvgDevIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "M12.41 6.74a.771.771 0 0 0-1.422-.598L7.58 13.215a.771.771 0 1 0 1.422.597l3.407-7.073ZM3.668 10l2.917-2.916a.806.806 0 0 0 0-1.167.806.806 0 0 0-1.167 0l-3.5 3.5a.806.806 0 0 0 0 1.167l3.5 3.5c.167.166.333.25.583.25.25 0 .417-.084.584-.25a.806.806 0 0 0 0-1.167L3.668 10ZM16.335 10l-2.917-2.916a.805.805 0 0 1 0-1.167.805.805 0 0 1 1.167 0l3.5 3.5a.805.805 0 0 1 0 1.167l-3.5 3.5a.757.757 0 0 1-.584.25.757.757 0 0 1-.583-.25.805.805 0 0 1 0-1.167L16.335 10Z",
            fill: "currentColor"
        })
    }));
};
var $7ce74be83f7ef192$export$2e2bcd8739ae039 = $7ce74be83f7ef192$var$SvgDevIcon;



var $kVN77 = parcelRequire("kVN77");

var $c732d3c3053b4284$var$usePlatform = function() {
    var platform = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).platform;
    return {
        isMobile: platform === "mobile",
        platform: platform
    };
};
var $c732d3c3053b4284$export$2e2bcd8739ae039 = $c732d3c3053b4284$var$usePlatform;


/**
 * Styles that may effect the visibility of a DOM element.
 */ var $27470b2e48dbe4b7$var$visibilityRelatedStyles = Object.freeze({
    visibility: "visible",
    height: "unset",
    width: "unset",
    transform: "unset",
    opacity: "unset",
    position: "static"
});
/** Build styles that will always be visible for a DOM element based on given styles */ var $27470b2e48dbe4b7$var$buildPermanentVisibleStyles = function(styles) {
    return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $27470b2e48dbe4b7$var$visibilityRelatedStyles, styles);
};
/**
 * Apply inline styles with '!important' to a DOM element to make theses styles become the highest priority.
 *
 * It's useful when we want to ensure these styles won't be override via the user's custom CSS config.
 */ var $27470b2e48dbe4b7$var$applyInlineStylesWithImportant = function(element, styles) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(styles)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            element.style.setProperty(key, value, "important");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
/**
 * Notification for development tenants to notify the user that the tenant is in development mode
 *
 * It is shown for development tenants and will be hidden in the preview mode even the tenant is a development tenant
 */ var $27470b2e48dbe4b7$var$DevelopmentTenantNotification = function() {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var ref = (0, $kVN77.useRef)(null);
    /**
   * Add a ref to the icon to specify styles for the icon,
   * since we cannot use CSS selectors to select the icon from its parent node (notification) via inline CSS.
   */ var iconRef = (0, $kVN77.useRef)(null);
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), experienceSettings = _useContext.experienceSettings, isPreview = _useContext.isPreview;
    var isDevelopmentTenant = (experienceSettings !== null && experienceSettings !== void 0 ? experienceSettings : {}).isDevelopmentTenant;
    var isMobile = (0, $c732d3c3053b4284$export$2e2bcd8739ae039)().isMobile;
    var styles = Object.freeze({
        display: "flex",
        "align-items": "center",
        "justify-content": "center",
        "align-self": "stretch",
        gap: "8px",
        margin: isMobile ? "-16px -20px 16px" : "-24px -24px 0",
        padding: "12px 16px",
        "border-radius": isMobile ? "unset" : "8px 8px 0 0",
        background: "var(--color-container-alert)",
        font: "var(--font-label-2)",
        color: "var(--color-type-primary)"
    });
    var iconStyles = Object.freeze({
        // Use 'display: inline-flex' and 'align-items: center' to vertically center the icon
        display: "inline-flex",
        "align-items": "center",
        color: "var(--color-container-on-alert)"
    });
    (0, $kVN77.useEffect)(function() {
        if (isPreview || !ref.current || !iconRef.current) return;
        $27470b2e48dbe4b7$var$applyInlineStylesWithImportant(ref.current, $27470b2e48dbe4b7$var$buildPermanentVisibleStyles(styles));
        $27470b2e48dbe4b7$var$applyInlineStylesWithImportant(iconRef.current, $27470b2e48dbe4b7$var$buildPermanentVisibleStyles(iconStyles));
    }, [
        iconStyles,
        isDevelopmentTenant,
        isPreview,
        ref,
        styles
    ]);
    if (!isDevelopmentTenant || isPreview) return null;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
                ref: iconRef,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $7ce74be83f7ef192$export$2e2bcd8739ae039), {})
            }),
            t("development_tenant.notification")
        ]
    });
};
var $27470b2e48dbe4b7$export$2e2bcd8739ae039 = $27470b2e48dbe4b7$var$DevelopmentTenantNotification;



var $37c193be69299d85$export$52b270a1b841cc00 = Object.freeze({
    pageContainer: "logto_page-container",
    mainContent: "logto_main-content",
    customContent: "logto_custom-content",
    signature: "logto_signature",
    brandingHeader: "logto_branding-header"
});








var $kVN77 = parcelRequire("kVN77");


var $41e7159e4ecba97c$export$317715a729435b35 = function() {
    var experienceSettings = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).experienceSettings;
    var _experienceSettings_signUp;
    var _ref = (_experienceSettings_signUp = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.signUp) !== null && _experienceSettings_signUp !== void 0 ? _experienceSettings_signUp : {}, identifiers = _ref.identifiers, password = _ref.password, verify = _ref.verify;
    var _experienceSettings_signIn_methods_filter, _experienceSettings_socialConnectors, _experienceSettings_ssoConnectors;
    return {
        signUpMethods: identifiers !== null && identifiers !== void 0 ? identifiers : [],
        signUpSettings: {
            password: password,
            verify: verify
        },
        signInMethods: (_experienceSettings_signIn_methods_filter = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.signIn.methods.filter(// Filter out empty settings
        function(param) {
            var password = param.password, verificationCode = param.verificationCode;
            return password || verificationCode;
        })) !== null && _experienceSettings_signIn_methods_filter !== void 0 ? _experienceSettings_signIn_methods_filter : [],
        socialConnectors: (_experienceSettings_socialConnectors = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.socialConnectors) !== null && _experienceSettings_socialConnectors !== void 0 ? _experienceSettings_socialConnectors : [],
        ssoConnectors: (_experienceSettings_ssoConnectors = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.ssoConnectors) !== null && _experienceSettings_ssoConnectors !== void 0 ? _experienceSettings_ssoConnectors : [],
        signInMode: experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.signInMode,
        forgotPassword: experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.forgotPassword,
        customContent: experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.customContent,
        singleSignOnEnabled: experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.singleSignOnEnabled
    };
};
var $41e7159e4ecba97c$export$b03f85e37d353e63 = function() {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var experienceSettings = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).experienceSettings;
    var _experienceSettings_passwordPolicy;
    var policy = (0, $kVN77.useMemo)(function() {
        return (0, $ca0f9a3ed13a242f$export$5fffa90e2e38377b).parse((_experienceSettings_passwordPolicy = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.passwordPolicy) !== null && _experienceSettings_passwordPolicy !== void 0 ? _experienceSettings_passwordPolicy : {});
    }, [
        experienceSettings
    ]);
    var policyChecker = (0, $kVN77.useMemo)(function() {
        return new (0, $ca0f9a3ed13a242f$export$d2f225c121fa68bd)(policy);
    }, [
        policy
    ]);
    var requirementsDescription = (0, $kVN77.useMemo)(function() {
        return policy.length.min <= 1 && policy.characterTypes.min <= 1 ? undefined : t("description.password_requirements", {
            items: (0, $3539bd14a37ab7f4$export$68c43792fed28aa6)(// There's no need to show the length requirement if it can be satisfied by the character types
            policy.length.min > policy.characterTypes.min && t("description.password_requirement.length", {
                count: policy.length.min
            }), // Show the character types requirement if it's greater than 1.
            policy.characterTypes.min > 1 && t("description.password_requirement.character_types", {
                count: policy.characterTypes.min
            }))
        });
    }, [
        t,
        policy.length.min,
        policy.characterTypes.min
    ]);
    return {
        policy: policy,
        policyChecker: policyChecker,
        /** The localized description of the password policy. */ requirementsDescription: requirementsDescription
    };
};
var $41e7159e4ecba97c$export$9418daf6fcecfff4 = function() {
    var experienceSettings = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).experienceSettings;
    var forgotPassword = (experienceSettings !== null && experienceSettings !== void 0 ? experienceSettings : {}).forgotPassword;
    var enabledMethodSet = new Set();
    if (forgotPassword === null || forgotPassword === void 0 ? void 0 : forgotPassword.email) enabledMethodSet.add((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email);
    if (forgotPassword === null || forgotPassword === void 0 ? void 0 : forgotPassword.phone) enabledMethodSet.add((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone);
    return {
        isForgotPasswordEnabled: enabledMethodSet.size > 0,
        enabledMethodSet: enabledMethodSet
    };
};


var $a7a685f15696e571$var$CustomContent = function(param) {
    var className = param.className;
    var customContent = (0, $41e7159e4ecba97c$export$317715a729435b35)().customContent;
    var pathname = (0, $1c3a22059b479044$export$45d76561a5302f2b)().pathname;
    var customHtml = customContent === null || customContent === void 0 ? void 0 : customContent[pathname];
    if (!customHtml) return null;
    try {
        // Expected error; CustomContent content is load from Logto remote server
        // eslint-disable-next-line react/no-danger
        return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: customHtml
            },
            className: className
        });
    } catch (e) {
        return null;
    }
};
var $a7a685f15696e571$export$2e2bcd8739ae039 = $a7a685f15696e571$var$CustomContent;


var $805ff54007662fa5$export$34e0f9847d4c02dd;
var $805ff54007662fa5$export$f22da7240b7add18;
var $805ff54007662fa5$export$c9cd164b539ebb63;
var $805ff54007662fa5$export$a179c88182cb9d56;
$805ff54007662fa5$export$34e0f9847d4c02dd = "uDMMma_container";
$805ff54007662fa5$export$f22da7240b7add18 = "uDMMma_main";
$805ff54007662fa5$export$c9cd164b539ebb63 = "uDMMma_signature";
$805ff54007662fa5$export$a179c88182cb9d56 = "uDMMma_viewBox";


var $ea9c8ef10380da96$var$AppLayout = function() {
    var isMobile = (0, $c732d3c3053b4284$export$2e2bcd8739ae039)().isMobile;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: $805ff54007662fa5$export$a179c88182cb9d56,
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($805ff54007662fa5$export$34e0f9847d4c02dd, (0, $37c193be69299d85$export$52b270a1b841cc00).pageContainer),
            children: [
                !isMobile && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $a7a685f15696e571$export$2e2bcd8739ae039), {
                    className: (0, $37c193be69299d85$export$52b270a1b841cc00).customContent
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("main", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($805ff54007662fa5$export$f22da7240b7add18, (0, $37c193be69299d85$export$52b270a1b841cc00).mainContent),
                    children: [
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $27470b2e48dbe4b7$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$910ae8079b2c2852), {}),
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3befa8c5871b7fae$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($805ff54007662fa5$export$c9cd164b539ebb63, (0, $37c193be69299d85$export$52b270a1b841cc00).signature)
                        })
                    ]
                })
            ]
        })
    });
};
var $ea9c8ef10380da96$export$2e2bcd8739ae039 = $ea9c8ef10380da96$var$AppLayout;









var $kVN77 = parcelRequire("kVN77");

var $1cc30ea82391ca4a$var$generateLightColorLibrary = function(primaryColor) {
    var _obj;
    return _obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-brand-default", primaryColor.hex()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-brand-hover", (0, $bac3379ca35f67cc$export$2b47dd798c93e22f)(primaryColor, 10).string()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-brand-pressed", (0, $bac3379ca35f67cc$export$13a5971b241f058c)(primaryColor, 10).string()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-overlay-brand-focused", primaryColor.alpha(0.16).string()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-overlay-brand-hover", primaryColor.alpha(0.08).string()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-overlay-brand-pressed", primaryColor.alpha(0.12).string()), _obj;
};
var $1cc30ea82391ca4a$var$generateDarkColorLibrary = function(primaryColor) {
    var _obj;
    return _obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-brand-default", primaryColor.hex()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-brand-hover", (0, $bac3379ca35f67cc$export$2b47dd798c93e22f)(primaryColor, 10).string()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-brand-pressed", (0, $bac3379ca35f67cc$export$13a5971b241f058c)(primaryColor, 10).string()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-overlay-brand-focused", (0, $bac3379ca35f67cc$export$2b47dd798c93e22f)(primaryColor, 30).rgb().alpha(0.16).string()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-overlay-brand-hover", (0, $bac3379ca35f67cc$export$2b47dd798c93e22f)(primaryColor, 30).rgb().alpha(0.08).string()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "--color-overlay-brand-pressed", (0, $bac3379ca35f67cc$export$2b47dd798c93e22f)(primaryColor, 30).rgb().alpha(0.12).string()), _obj;
};
var $1cc30ea82391ca4a$var$useColorTheme = function() {
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), theme = _useContext.theme, experienceSettings = _useContext.experienceSettings;
    var primaryColor = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.color.primaryColor;
    var darkPrimaryColor = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.color.darkPrimaryColor;
    (0, $kVN77.useEffect)(function() {
        if (!primaryColor) return;
        var lightPrimary = (0, (/*@__PURE__*/$parcel$interopDefault($40a1317a33725c7b$exports)))(primaryColor);
        if (theme === (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Light) {
            var lightColorLibrary = $1cc30ea82391ca4a$var$generateLightColorLibrary(lightPrimary);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(lightColorLibrary)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    document.body.style.setProperty(key, value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return;
        }
        var darkPrimary = darkPrimaryColor ? (0, (/*@__PURE__*/$parcel$interopDefault($40a1317a33725c7b$exports)))(darkPrimaryColor) : (0, $bac3379ca35f67cc$export$2b47dd798c93e22f)(lightPrimary, 10);
        var darkColorLibrary = $1cc30ea82391ca4a$var$generateDarkColorLibrary(darkPrimary);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(darkColorLibrary)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step1.value, 2), key1 = _step_value1[0], value1 = _step_value1[1];
                document.body.style.setProperty(key1, value1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }, [
        darkPrimaryColor,
        primaryColor,
        theme
    ]);
};
var $1cc30ea82391ca4a$export$2e2bcd8739ae039 = $1cc30ea82391ca4a$var$useColorTheme;





function $9be5b36bbe4a361d$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $487369748a2c1c33$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $9be5b36bbe4a361d$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}







var $kVN77 = parcelRequire("kVN77");



var $kVN77 = parcelRequire("kVN77");





parcelRequire("kVN77");
var $1dcac6c07ebd990c$var$SvgCloseIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "m13.41 12 6.3-6.29a1.004 1.004 0 0 0-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 1 0-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 0 0 0 1.42 1 1 0 0 0 1.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 0 0 1.639-.325 1 1 0 0 0-.22-1.095L13.41 12Z",
            fill: "currentcolor"
        })
    }));
};
var $1dcac6c07ebd990c$export$2e2bcd8739ae039 = $1dcac6c07ebd990c$var$SvgCloseIcon;









/**
 * A component to render a dynamic translation key.
 */ var $4f0e9068c17de251$var$DynamicT = function(param) {
    var forKey = param.forKey, interpolation = param.interpolation;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    if (!forKey) return null;
    var translated = t(forKey, interpolation !== null && interpolation !== void 0 ? interpolation : {});
    if (typeof translated === "string") // The fragment will ensure the component has the return type that is compatible with `JSX.Element`.
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d67ee09f839f930f$exports.Fragment), {
        children: translated
    });
    // The fragment will ensure the component has the return type that is compatible with `JSX.Element`.
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d67ee09f839f930f$exports.Fragment), {
        children: "Translation key ".concat(forKey, " is invalid.")
    }); // This would be great to have i18n as well. Not harmful for now.
};
var $4f0e9068c17de251$export$2e2bcd8739ae039 = $4f0e9068c17de251$var$DynamicT;


var $33189750e7c5f569$exports = {};

$parcel$export($33189750e7c5f569$exports, "button", function () { return $33189750e7c5f569$export$2ba01fb71ed41cb6; }, function (v) { return $33189750e7c5f569$export$2ba01fb71ed41cb6 = v; });
$parcel$export($33189750e7c5f569$exports, "disabled", function () { return $33189750e7c5f569$export$683472f6198a076e; }, function (v) { return $33189750e7c5f569$export$683472f6198a076e = v; });
$parcel$export($33189750e7c5f569$exports, "icon", function () { return $33189750e7c5f569$export$1ca1ec8b29a4ce27; }, function (v) { return $33189750e7c5f569$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($33189750e7c5f569$exports, "large", function () { return $33189750e7c5f569$export$f09585a853dddd32; }, function (v) { return $33189750e7c5f569$export$f09585a853dddd32 = v; });
$parcel$export($33189750e7c5f569$exports, "primary", function () { return $33189750e7c5f569$export$9ad721cf3b3debe0; }, function (v) { return $33189750e7c5f569$export$9ad721cf3b3debe0 = v; });
$parcel$export($33189750e7c5f569$exports, "secondary", function () { return $33189750e7c5f569$export$745c6f71a1e0e6f7; }, function (v) { return $33189750e7c5f569$export$745c6f71a1e0e6f7 = v; });
$parcel$export($33189750e7c5f569$exports, "small", function () { return $33189750e7c5f569$export$3c17b0e969a90510; }, function (v) { return $33189750e7c5f569$export$3c17b0e969a90510 = v; });
var $33189750e7c5f569$export$2ba01fb71ed41cb6;
var $33189750e7c5f569$export$683472f6198a076e;
var $33189750e7c5f569$export$1ca1ec8b29a4ce27;
var $33189750e7c5f569$export$f09585a853dddd32;
var $33189750e7c5f569$export$9ad721cf3b3debe0;
var $33189750e7c5f569$export$745c6f71a1e0e6f7;
var $33189750e7c5f569$export$3c17b0e969a90510;
$33189750e7c5f569$export$2ba01fb71ed41cb6 = "Ljn7Ea_button";
$33189750e7c5f569$export$683472f6198a076e = "Ljn7Ea_disabled";
$33189750e7c5f569$export$1ca1ec8b29a4ce27 = "Ljn7Ea_icon";
$33189750e7c5f569$export$f09585a853dddd32 = "Ljn7Ea_large";
$33189750e7c5f569$export$9ad721cf3b3debe0 = "Ljn7Ea_primary";
$33189750e7c5f569$export$745c6f71a1e0e6f7 = "Ljn7Ea_secondary";
$33189750e7c5f569$export$3c17b0e969a90510 = "Ljn7Ea_small";


var $41b320aeeb388826$var$Button = function(_param) {
    var _param_htmlType = _param.htmlType, htmlType = _param_htmlType === void 0 ? "button" : _param_htmlType, _param_type = _param.type, type = _param_type === void 0 ? "primary" : _param_type, _param_size = _param.size, size = _param_size === void 0 ? "large" : _param_size, title = _param.title, i18nProps = _param.i18nProps, className = _param.className, _param_isDisabled = _param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, icon = _param.icon, onClick = _param.onClick, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_param, [
        "htmlType",
        "type",
        "size",
        "title",
        "i18nProps",
        "className",
        "isDisabled",
        "icon",
        "onClick"
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("button", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        disabled: isDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($33189750e7c5f569$exports.button, $33189750e7c5f569$exports[type], $33189750e7c5f569$exports[size], isDisabled && $33189750e7c5f569$exports.isDisabled, className),
        type: htmlType,
        onClick: onClick
    }, rest), {
        children: [
            icon && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
                className: $33189750e7c5f569$exports.icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                forKey: title,
                interpolation: i18nProps
            })
        ]
    }));
};
var $41b320aeeb388826$export$2e2bcd8739ae039 = $41b320aeeb388826$var$Button;








var $kVN77 = parcelRequire("kVN77");
var $0882c4fa7a414be3$export$60bb6c1f29b8a8cc;
$0882c4fa7a414be3$export$60bb6c1f29b8a8cc = "D6WLUq_iconButton";


var $072ec55e67ff9777$var$IconButton = function(_param, ref) {
    var children = _param.children, className = _param.className, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("button", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($0882c4fa7a414be3$export$60bb6c1f29b8a8cc, className)
    }, rest), {
        children: children
    }));
};
var $072ec55e67ff9777$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kVN77.forwardRef)($072ec55e67ff9777$var$IconButton);


/* istanbul ignore file */ var $63d9e266638a38b7$export$c2c388d6a668999e = function(callback) {
    return function(event) {
        var key = event.key;
        if (typeof callback === "function" && [
            " ",
            "Enter"
        ].includes(key)) {
            callback(event);
            event.preventDefault();
        }
        if (typeof callback === "object") {
            var _callback_key;
            (_callback_key = callback[key]) === null || _callback_key === void 0 ? void 0 : _callback_key.call(callback, event);
            if (callback[key]) event.preventDefault();
        }
    };
};


var $efdf89e92d46c0d8$export$29dd17c7f3c81c36;
$efdf89e92d46c0d8$export$29dd17c7f3c81c36 = "LxEQZG_overlay";


var $135266018243d06c$export$34e0f9847d4c02dd;
var $135266018243d06c$export$a7db06668cad9adb;
var $135266018243d06c$export$adb608be33961c98;
var $135266018243d06c$export$38e42c68cf43b5d4;
var $135266018243d06c$export$96e4b36520c26a2c;
var $135266018243d06c$export$29dd17c7f3c81c36;
$135266018243d06c$export$34e0f9847d4c02dd = "DJy3WW_container";
$135266018243d06c$export$a7db06668cad9adb = "DJy3WW_content";
$135266018243d06c$export$adb608be33961c98 = "DJy3WW_footer";
$135266018243d06c$export$38e42c68cf43b5d4 = "DJy3WW_header";
$135266018243d06c$export$96e4b36520c26a2c = "DJy3WW_modal";
$135266018243d06c$export$29dd17c7f3c81c36 = "DJy3WW_overlay";


var $857b7821e8021309$var$AcModal = function(param) {
    var className = param.className, _param_isOpen = param.isOpen, isOpen = _param_isOpen === void 0 ? false : _param_isOpen, children = param.children, _param_cancelText = param.cancelText, cancelText = _param_cancelText === void 0 ? "action.cancel" : _param_cancelText, _param_confirmText = param.confirmText, confirmText = _param_confirmText === void 0 ? "action.confirm" : _param_confirmText, confirmTextI18nProps = param.confirmTextI18nProps, cancelTextI18nProps = param.cancelTextI18nProps, onConfirm = param.onConfirm, onClose = param.onClose;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var contentRef = (0, $kVN77.useRef)(null);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f4531ebf250f6fa$exports))), {
        isOpen: isOpen,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($135266018243d06c$export$96e4b36520c26a2c, className),
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($efdf89e92d46c0d8$export$29dd17c7f3c81c36, $135266018243d06c$export$29dd17c7f3c81c36),
        onAfterOpen: function() {
            var _contentRef_current;
            (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.focus();
        },
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
            ref: contentRef,
            className: $135266018243d06c$export$34e0f9847d4c02dd,
            role: "button",
            tabIndex: 0,
            onKeyDown: (0, $63d9e266638a38b7$export$c2c388d6a668999e)({
                Enter: onConfirm !== null && onConfirm !== void 0 ? onConfirm : onClose,
                " ": onConfirm !== null && onConfirm !== void 0 ? onConfirm : onClose,
                Escape: onClose
            }),
            children: [
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                    className: $135266018243d06c$export$38e42c68cf43b5d4,
                    children: [
                        t("description.reminder"),
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $072ec55e67ff9777$export$2e2bcd8739ae039), {
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1dcac6c07ebd990c$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                    className: $135266018243d06c$export$a7db06668cad9adb,
                    children: children
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                    className: $135266018243d06c$export$adb608be33961c98,
                    children: [
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                            title: cancelText,
                            type: "secondary",
                            i18nProps: cancelTextI18nProps,
                            size: "small",
                            onClick: onClose
                        }),
                        onConfirm && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                            title: confirmText,
                            i18nProps: confirmTextI18nProps,
                            size: "small",
                            onClick: onConfirm
                        })
                    ]
                })
            ]
        })
    });
};
var $857b7821e8021309$export$2e2bcd8739ae039 = $857b7821e8021309$var$AcModal;







var $4086a227000a89d9$export$34e0f9847d4c02dd;
var $4086a227000a89d9$export$a7db06668cad9adb;
var $4086a227000a89d9$export$adb608be33961c98;
var $4086a227000a89d9$export$908137cc4b52cbf2;
var $4086a227000a89d9$export$96e4b36520c26a2c;
var $4086a227000a89d9$export$29dd17c7f3c81c36;
$4086a227000a89d9$export$34e0f9847d4c02dd = "XjKGIq_container";
$4086a227000a89d9$export$a7db06668cad9adb = "XjKGIq_content";
$4086a227000a89d9$export$adb608be33961c98 = "XjKGIq_footer";
$4086a227000a89d9$export$908137cc4b52cbf2 = "XjKGIq_iframeModal";
$4086a227000a89d9$export$96e4b36520c26a2c = "XjKGIq_modal";
$4086a227000a89d9$export$29dd17c7f3c81c36 = "XjKGIq_overlay";


var $89206ac949b07344$var$MobileModal = function(param) {
    var className = param.className, _param_isOpen = param.isOpen, isOpen = _param_isOpen === void 0 ? false : _param_isOpen, children = param.children, _param_cancelText = param.cancelText, cancelText = _param_cancelText === void 0 ? "action.cancel" : _param_cancelText, _param_confirmText = param.confirmText, confirmText = _param_confirmText === void 0 ? "action.confirm" : _param_confirmText, cancelTextI18nProps = param.cancelTextI18nProps, confirmTextI18nProps = param.confirmTextI18nProps, onConfirm = param.onConfirm, onClose = param.onClose;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f4531ebf250f6fa$exports))), {
        shouldCloseOnEsc: true,
        role: "dialog",
        isOpen: isOpen,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($4086a227000a89d9$export$96e4b36520c26a2c, className),
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($efdf89e92d46c0d8$export$29dd17c7f3c81c36, $4086a227000a89d9$export$29dd17c7f3c81c36),
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
            className: $4086a227000a89d9$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                    className: $4086a227000a89d9$export$a7db06668cad9adb,
                    children: children
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                    className: $4086a227000a89d9$export$adb608be33961c98,
                    children: [
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                            title: cancelText,
                            i18nProps: cancelTextI18nProps,
                            type: "secondary",
                            onClick: onClose
                        }),
                        onConfirm && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                            title: confirmText,
                            i18nProps: confirmTextI18nProps,
                            onClick: onConfirm
                        })
                    ]
                })
            ]
        })
    });
};
var $89206ac949b07344$export$2e2bcd8739ae039 = $89206ac949b07344$var$MobileModal;





var $c1fc8b4c328692df$export$48cb88dd95836c3a = /*#__PURE__*/ (0, $kVN77.createContext)({
    show: /*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                [
                    true
                ]
            ];
        });
    }),
    confirm: (0, $71d6ce9e3e366d69$export$8793edee2d425525),
    cancel: (0, $71d6ce9e3e366d69$export$8793edee2d425525)
});
var $c1fc8b4c328692df$var$defaultModalState = {
    isOpen: false,
    type: "confirm",
    ModalContent: function() {
        return null;
    }
};
var $c1fc8b4c328692df$var$ConfirmModalProvider = function(param) {
    var children = param.children;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)($c1fc8b4c328692df$var$defaultModalState), 2), modalState = _useState[0], setModalState = _useState[1];
    var resolver = (0, $kVN77.useRef)();
    var isMobile = (0, $c732d3c3053b4284$export$2e2bcd8739ae039)().isMobile;
    var ConfirmModal = isMobile ? (0, $89206ac949b07344$export$2e2bcd8739ae039) : (0, $857b7821e8021309$export$2e2bcd8739ae039);
    var handleShow = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(_param) {
            var _param_type, type, props, _resolver_current;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                _param_type = _param.type, type = _param_type === void 0 ? "confirm" : _param_type, props = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_param, [
                    "type"
                ]);
                (_resolver_current = resolver.current) === null || _resolver_current === void 0 ? void 0 : _resolver_current.call(resolver, [
                    false
                ]);
                setModalState((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                    isOpen: true,
                    type: type
                }, props));
                return [
                    2,
                    new Promise(function(resolve) {
                        // eslint-disable-next-line @silverhand/fp/no-mutation
                        resolver.current = resolve;
                    })
                ];
            });
        });
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var handleConfirm = (0, $kVN77.useCallback)(function(data) {
        var _resolver_current;
        (_resolver_current = resolver.current) === null || _resolver_current === void 0 ? void 0 : _resolver_current.call(resolver, [
            true,
            data
        ]);
        setModalState($c1fc8b4c328692df$var$defaultModalState);
    }, []);
    var handleCancel = (0, $kVN77.useCallback)(function(data) {
        var _resolver_current;
        (_resolver_current = resolver.current) === null || _resolver_current === void 0 ? void 0 : _resolver_current.call(resolver, [
            false,
            data
        ]);
        setModalState($c1fc8b4c328692df$var$defaultModalState);
    }, []);
    var contextValue = (0, $kVN77.useMemo)(function() {
        return {
            show: handleShow,
            confirm: handleConfirm,
            cancel: handleCancel
        };
    }, [
        handleCancel,
        handleConfirm,
        handleShow
    ]);
    var ModalContent = modalState.ModalContent, type = modalState.type, restProps = (0, $487369748a2c1c33$export$69fdd232f62cde60)(modalState, [
        "ModalContent",
        "type"
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)($c1fc8b4c328692df$export$48cb88dd95836c3a.Provider, {
        value: contextValue,
        children: [
            children,
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)(ConfirmModal, (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, restProps), {
                onConfirm: type === "confirm" ? function() {
                    handleConfirm();
                } : undefined,
                onClose: function() {
                    handleCancel();
                },
                children: typeof ModalContent === "string" ? ModalContent : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)(ModalContent, {
                    confirm: handleConfirm,
                    cancel: handleCancel
                })
            }))
        ]
    });
};
var $c1fc8b4c328692df$export$2e2bcd8739ae039 = $c1fc8b4c328692df$var$ConfirmModalProvider;








var $kVN77 = parcelRequire("kVN77");






var $kVN77 = parcelRequire("kVN77");


var $kVN77 = parcelRequire("kVN77");
function $0210e12846622659$var$i() {
    return ($0210e12846622659$var$i = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var _$o = arguments[e];
            for(var n in _$o)Object.prototype.hasOwnProperty.call(_$o, n) && (t[n] = _$o[n]);
        }
        return t;
    }).apply(this, arguments);
}
var $0210e12846622659$var$c = function c() {};
function $0210e12846622659$var$l(t, e) {
    return Math.random() * (e - t + 1) + t;
}
function $0210e12846622659$var$s(t, e) {
    return Math.floor($0210e12846622659$var$l(t, e));
}
var $0210e12846622659$var$u = (0, $kVN77.forwardRef)(function(o, u) {
    var d = o.progress, f = o.height, v = void 0 === f ? 2 : f, h = o.className, p = void 0 === h ? "" : h, m = o.color, b = void 0 === m ? "red" : m, g = o.background, y = void 0 === g ? "transparent" : g, w = o.onLoaderFinished, x = o.transitionTime, S = void 0 === x ? 300 : x, k = o.loaderSpeed, M = void 0 === k ? 500 : k, N = o.waitingTime, R = void 0 === N ? 1e3 : N, T = o.shadow, Y = void 0 === T || T, I = o.containerStyle, O = void 0 === I ? {} : I, j = o.style, P = void 0 === j ? {} : j, z = o.shadowStyle, C = void 0 === z ? {} : z, F = o.containerClassName, L = void 0 === F ? "" : F, q = (0, $kVN77.useRef)(!1), A = (0, $kVN77.useState)(0), B = A[0], D = A[1], E = (0, $kVN77.useRef)({
        active: !1,
        refreshRate: 1e3
    }), G = (0, $kVN77.useState)(!1), H = G[0], J = G[1], K = (0, $kVN77.useState)({
        active: !1,
        value: 20
    }), Q = K[0], U = K[1], V = {
        position: "fixed",
        top: 0,
        left: 0,
        height: v,
        background: y,
        zIndex: 99999999999,
        width: "100%"
    }, W = {
        boxShadow: "0 0 10px " + b + ", 0 0 10px " + b,
        width: "5%",
        opacity: 1,
        position: "absolute",
        height: "100%",
        transition: "all " + M + "ms ease",
        transform: "rotate(3deg) translate(0px, -4px)",
        left: "-10rem"
    }, X = (0, $kVN77.useState)({
        height: "100%",
        background: b,
        transition: "all " + M + "ms ease",
        width: "0%"
    }), Z = X[0], $ = X[1], _ = (0, $kVN77.useState)(W), tt = _[0], et = _[1];
    (0, $kVN77.useEffect)(function() {
        return q.current = !0, function() {
            q.current = !1;
        };
    }, []), (0, $kVN77.useImperativeHandle)(u, function() {
        return {
            continuousStart: function continuousStart(t, e) {
                if (void 0 === e && (e = 1e3), !Q.active) {
                    if (H) console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
                    else {
                        var _$o = t || $0210e12846622659$var$s(10, 20);
                        E.current = {
                            active: !0,
                            refreshRate: e
                        }, D(_$o), at(_$o);
                    }
                }
            },
            staticStart: function staticStart(t) {
                if (!E.current.active) {
                    if (H) console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
                    else {
                        var _$e = t || $0210e12846622659$var$s(30, 50);
                        U({
                            active: !0,
                            value: _$e
                        }), D(_$e), at(_$e);
                    }
                }
            },
            complete: function complete() {
                H ? console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!") : (D(100), at(100));
            }
        };
    }), (0, $kVN77.useEffect)(function() {
        $($0210e12846622659$var$i({}, Z, {
            background: b
        })), et($0210e12846622659$var$i({}, tt, {
            boxShadow: "0 0 10px " + b + ", 0 0 5px " + b
        }));
    }, [
        b
    ]), (0, $kVN77.useEffect)(function() {
        if (u) {
            if (u && void 0 !== d) return void console.warn('react-top-loading-bar: You can\'t use both controlling by props and ref methods to control the bar! Please use only props or only ref methods! Ref methods will override props if "ref" property is available.');
            at(B), J(!1);
        } else d && at(d), J(!0);
    }, [
        d
    ]);
    var ot, nt, rt, at = function t(e) {
        e >= 100 ? ($($0210e12846622659$var$i({}, Z, {
            width: "100%"
        })), Y && et($0210e12846622659$var$i({}, tt, {
            left: e - 10 + "%"
        })), setTimeout(function() {
            q.current && ($($0210e12846622659$var$i({}, Z, {
                opacity: 0,
                width: "100%",
                transition: "all " + S + "ms ease-out",
                color: b
            })), setTimeout(function() {
                q.current && (E.current.active && (E.current = $0210e12846622659$var$i({}, E.current, {
                    active: !1
                }), D(0), t(0)), Q.active && (U($0210e12846622659$var$i({}, Q, {
                    active: !1
                })), D(0), t(0)), w && w(), D(0), t(0));
            }, S));
        }, R)) : ($(function(t) {
            return $0210e12846622659$var$i({}, t, {
                width: e + "%",
                opacity: 1,
                transition: e > 0 ? "all " + M + "ms ease" : ""
            });
        }), Y && et($0210e12846622659$var$i({}, tt, {
            left: e - 5.5 + "%",
            transition: e > 0 ? "all " + M + "ms ease" : ""
        })));
    };
    return ot = function ot() {
        var _$t = $0210e12846622659$var$l(Math.min(10, (100 - B) / 5), Math.min(20, (100 - B) / 3));
        B + _$t < 95 && (D(B + _$t), at(B + _$t));
    }, nt = E.current.active ? E.current.refreshRate : null, rt = (0, $kVN77.useRef)($0210e12846622659$var$c), (0, $kVN77.useEffect)(function() {
        rt.current = ot;
    }), (0, $kVN77.useEffect)(function() {}, [
        void 0
    ]), (0, $kVN77.useEffect)(function() {
        if (null !== nt && !1 !== nt) {
            var _$t = setInterval(function() {
                return rt.current();
            }, nt);
            return function() {
                return clearInterval(_$t);
            };
        }
    }, [
        nt
    ]), (0, $kVN77.createElement)("div", {
        className: L,
        style: $0210e12846622659$var$i({}, V, O)
    }, (0, $kVN77.createElement)("div", {
        className: p,
        style: $0210e12846622659$var$i({}, Z, P)
    }, Y ? (0, $kVN77.createElement)("div", {
        style: $0210e12846622659$var$i({}, tt, C)
    }) : null));
});
var $0210e12846622659$export$2e2bcd8739ae039 = $0210e12846622659$var$u;





var $kVN77 = parcelRequire("kVN77");





parcelRequire("kVN77");
var $85a2f2d25548ecbd$var$SvgArrowPrev = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 24,
        height: 24,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "m8.49 12.764 5.66 5.65a1.001 1.001 0 1 0 1.42-1.41l-4.95-5 4.95-4.95a1 1 0 0 0 0-1.41 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3l-5.66 5.65a1 1 0 0 0 0 1.47Z",
            fill: "currentcolor"
        })
    }));
};
var $85a2f2d25548ecbd$export$2e2bcd8739ae039 = $85a2f2d25548ecbd$var$SvgArrowPrev;





parcelRequire("kVN77");
var $aa205f1641749dfb$var$SvgNavClose = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "m13.41 12 4.3-4.29a1.004 1.004 0 0 0-1.42-1.42L12 10.59l-4.29-4.3a1.004 1.004 0 1 0-1.42 1.42l4.3 4.29-4.3 4.29a.999.999 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1.001 1.001 0 0 0 1.639-.325 1 1 0 0 0-.22-1.095L13.41 12Z",
            fill: "currentcolor"
        })
    }));
};
var $aa205f1641749dfb$export$2e2bcd8739ae039 = $aa205f1641749dfb$var$SvgNavClose;



var $6a529842b6b2f28b$export$73920f18ca706874;
var $6a529842b6b2f28b$export$188e5e76577d6e93;
var $6a529842b6b2f28b$export$2523f9cc9d8b8a36;
var $6a529842b6b2f28b$export$bc892abb8d6aa6fd;
var $6a529842b6b2f28b$export$fb184b623420d9be;
$6a529842b6b2f28b$export$73920f18ca706874 = "YrdfMG_hidden";
$6a529842b6b2f28b$export$188e5e76577d6e93 = "YrdfMG_navBar";
$6a529842b6b2f28b$export$2523f9cc9d8b8a36 = "YrdfMG_navButton";
$6a529842b6b2f28b$export$bc892abb8d6aa6fd = "YrdfMG_skipButton";
$6a529842b6b2f28b$export$fb184b623420d9be = "YrdfMG_title";


var $3dbbd783a5debe63$var$NavBar = function(param) {
    var title = param.title, _param_type = param.type, type = _param_type === void 0 ? "back" : _param_type, isHidden = param.isHidden, onClose = param.onClose, onSkip = param.onSkip;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var isClosable = type === "close";
    var clickHandler = (0, $kVN77.useCallback)(function() {
        if (onClose) {
            onClose();
            return;
        }
        if (isClosable) {
            window.close();
            return;
        }
        navigate(-1);
    }, [
        isClosable,
        navigate,
        onClose
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($6a529842b6b2f28b$export$188e5e76577d6e93, isHidden && $6a529842b6b2f28b$export$73920f18ca706874),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                role: "button",
                tabIndex: 0,
                className: $6a529842b6b2f28b$export$2523f9cc9d8b8a36,
                onKeyDown: (0, $63d9e266638a38b7$export$c2c388d6a668999e)(clickHandler),
                onClick: clickHandler,
                children: [
                    isClosable ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $aa205f1641749dfb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $85a2f2d25548ecbd$export$2e2bcd8739ae039), {}),
                    !isClosable && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
                        children: t("action.nav_back")
                    })
                ]
            }),
            title && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $6a529842b6b2f28b$export$fb184b623420d9be,
                children: title
            }),
            onSkip && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                role: "button",
                tabIndex: 0,
                className: $6a529842b6b2f28b$export$bc892abb8d6aa6fd,
                onKeyDown: (0, $63d9e266638a38b7$export$c2c388d6a668999e)(onSkip),
                onClick: onSkip,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
                    children: t("action.nav_skip")
                })
            })
        ]
    });
};
var $3dbbd783a5debe63$export$2e2bcd8739ae039 = $3dbbd783a5debe63$var$NavBar;


var $8a030e4ce19ed3e0$export$29dd17c7f3c81c36;
var $8a030e4ce19ed3e0$export$96e4b36520c26a2c;
var $8a030e4ce19ed3e0$export$34e0f9847d4c02dd;
var $8a030e4ce19ed3e0$export$38e42c68cf43b5d4;
var $8a030e4ce19ed3e0$export$a7db06668cad9adb;
var $8a030e4ce19ed3e0$export$b40fc69c4a2927a1;
var $8a030e4ce19ed3e0$export$f4c5de44377d2946;
$8a030e4ce19ed3e0$export$29dd17c7f3c81c36 = "overlay_f6be6c";
$8a030e4ce19ed3e0$export$96e4b36520c26a2c = "modal_f6be6c";
$8a030e4ce19ed3e0$export$34e0f9847d4c02dd = "container_f6be6c";
$8a030e4ce19ed3e0$export$38e42c68cf43b5d4 = "header_f6be6c";
$8a030e4ce19ed3e0$export$a7db06668cad9adb = "content_f6be6c";
$8a030e4ce19ed3e0$export$b40fc69c4a2927a1 = "loaded_f6be6c";
$8a030e4ce19ed3e0$export$f4c5de44377d2946 = "loader_f6be6c";


var $ae2f884df433411b$var$IframeModal = function(param) {
    var className = param.className, _param_title = param.title, title = _param_title === void 0 ? "" : _param_title, _param_href = param.href, href = _param_href === void 0 ? "" : _param_href, onClose = param.onClose;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(false), 2), isLoaded = _useState[0], setIsLoaded = _useState[1];
    var loadingBarRef = (0, $kVN77.useRef)(null);
    var brandingColor = document.body.style.getPropertyValue("--color-brand-default") || "#5d34f2";
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f4531ebf250f6fa$exports))), {
        shouldCloseOnEsc: true,
        id: "iframe-modal",
        role: "dialog",
        isOpen: Boolean(href),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($8a030e4ce19ed3e0$export$96e4b36520c26a2c, className),
        overlayClassName: $8a030e4ce19ed3e0$export$29dd17c7f3c81c36,
        closeTimeoutMS: 300,
        onAfterOpen: function() {
            var _loadingBarRef_current;
            (_loadingBarRef_current = loadingBarRef.current) === null || _loadingBarRef_current === void 0 ? void 0 : _loadingBarRef_current.continuousStart();
        },
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
            className: $8a030e4ce19ed3e0$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                    className: $8a030e4ce19ed3e0$export$38e42c68cf43b5d4,
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3dbbd783a5debe63$export$2e2bcd8739ae039), {
                        type: "close",
                        title: title,
                        onClose: onClose
                    })
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0210e12846622659$export$2e2bcd8739ae039), {
                    ref: loadingBarRef,
                    containerStyle: {
                        position: "relative"
                    },
                    shadow: false,
                    color: brandingColor,
                    waitingTime: 300,
                    className: $8a030e4ce19ed3e0$export$f4c5de44377d2946
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                    className: $8a030e4ce19ed3e0$export$a7db06668cad9adb,
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("iframe", {
                        title: title,
                        src: href,
                        sandbox: "allow-same-origin",
                        className: (0, $3539bd14a37ab7f4$export$c327da55a124987a)(isLoaded && $8a030e4ce19ed3e0$export$b40fc69c4a2927a1),
                        onLoad: function() {
                            var _loadingBarRef_current;
                            setIsLoaded(true);
                            (_loadingBarRef_current = loadingBarRef.current) === null || _loadingBarRef_current === void 0 ? void 0 : _loadingBarRef_current.complete();
                        },
                        onError: function() {
                            var _loadingBarRef_current;
                            setIsLoaded(true);
                            (_loadingBarRef_current = loadingBarRef.current) === null || _loadingBarRef_current === void 0 ? void 0 : _loadingBarRef_current.complete();
                        }
                    })
                })
            ]
        })
    });
};
var $ae2f884df433411b$export$2e2bcd8739ae039 = $ae2f884df433411b$var$IframeModal;


var $0d421b718ae2eec3$export$d1ae3eb34bde7fa3 = /*#__PURE__*/ (0, $kVN77.createContext)({
    href: undefined,
    title: undefined,
    setModalState: (0, $71d6ce9e3e366d69$export$8793edee2d425525)
});
var $0d421b718ae2eec3$export$6875a035353dd898 = function() {
    return (0, $kVN77.useContext)($0d421b718ae2eec3$export$d1ae3eb34bde7fa3);
};
var $0d421b718ae2eec3$var$IframeModalProvider = function(param) {
    var children = param.children;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), modalState = _useState[0], setModalState = _useState[1];
    var isMobile = (0, $c732d3c3053b4284$export$2e2bcd8739ae039)().isMobile;
    var context = (0, $kVN77.useMemo)(function() {
        return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, modalState), {
            setModalState: setModalState
        });
    }, [
        modalState
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)($0d421b718ae2eec3$export$d1ae3eb34bde7fa3.Provider, {
        value: context,
        children: [
            children,
            isMobile && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ae2f884df433411b$export$2e2bcd8739ae039), {
                href: modalState === null || modalState === void 0 ? void 0 : modalState.href,
                title: modalState === null || modalState === void 0 ? void 0 : modalState.title,
                onClose: function() {
                    setModalState(undefined);
                }
            })
        ]
    });
};
var $0d421b718ae2eec3$export$2e2bcd8739ae039 = $0d421b718ae2eec3$var$IframeModalProvider;




var $kVN77 = parcelRequire("kVN77");




var $kVN77 = parcelRequire("kVN77");

var $77e02b800d6b5e9a$export$71763d16552fd512;
var $77e02b800d6b5e9a$export$b410431fab84fa58;
$77e02b800d6b5e9a$export$71763d16552fd512 = "toastContainer_ba7e56";
$77e02b800d6b5e9a$export$b410431fab84fa58 = "toast_ba7e56";


var $b279c172f5da87b4$var$Toast = function(param) {
    var message = param.message, _param_duration = param.duration, duration = _param_duration === void 0 ? 3000 : _param_duration, callback = param.callback;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(""), 2), text = _useState[0], setText = _useState[1];
    (0, $kVN77.useEffect)(function() {
        if (!message) return;
        setText(message);
        var timer = setTimeout(function() {
            callback === null || callback === void 0 ? void 0 : callback();
        }, duration);
        return function() {
            clearTimeout(timer);
        };
    }, [
        callback,
        duration,
        message,
        text
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f4531ebf250f6fa$exports))), {
        shouldFocusAfterRender: false,
        // For styling use
        // eslint-disable-next-line jsx-a11y/aria-role
        role: "toast",
        isOpen: Boolean(message),
        overlayClassName: $77e02b800d6b5e9a$export$71763d16552fd512,
        className: $77e02b800d6b5e9a$export$b410431fab84fa58,
        closeTimeoutMS: 300,
        children: text
    });
};
var $b279c172f5da87b4$export$2e2bcd8739ae039 = $b279c172f5da87b4$var$Toast;


var $d7208e0213ec23ab$var$ToastProvider = function(param) {
    var children = param.children;
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), toast = _useContext.toast, setToast = _useContext.setToast;
    // Prevent internal eventListener rebind
    var hideToast = (0, $kVN77.useCallback)(function() {
        setToast("");
    }, [
        setToast
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b279c172f5da87b4$export$2e2bcd8739ae039), {
                message: toast,
                callback: hideToast
            })
        ]
    });
};
var $d7208e0213ec23ab$export$2e2bcd8739ae039 = $d7208e0213ec23ab$var$ToastProvider;








function $f38f801e616ac827$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $f181257dcd3f405a$export$2e2bcd8739ae039(o, p) {
    $f181257dcd3f405a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f181257dcd3f405a$export$2e2bcd8739ae039(o, p);
}


function $744fbf130698b5f6$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $f181257dcd3f405a$export$2e2bcd8739ae039)(subClass, superClass);
}




function $456189533e24f3fc$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $f38f801e616ac827$export$2e2bcd8739ae039)(self);
}


function $d866b19a9998757a$export$2e2bcd8739ae039(o) {
    $d866b19a9998757a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d866b19a9998757a$export$2e2bcd8739ae039(o);
}




function $95ce14eb556342be$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}




function $b6b79e1e4ac6c680$export$2e2bcd8739ae039(arr) {
    return (0, $b98b9d69bb2af8f9$export$2e2bcd8739ae039)(arr) || (0, $95ce14eb556342be$export$2e2bcd8739ae039)(arr) || (0, $d55e1ef55abf35bc$export$2e2bcd8739ae039)(arr) || (0, $c66d1290c5ae97e1$export$2e2bcd8739ae039)();
}


function $e55f3bd5a75ab76b$var$ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e55f3bd5a75ab76b$var$_objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e55f3bd5a75ab76b$var$ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e55f3bd5a75ab76b$var$ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e55f3bd5a75ab76b$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $e55f3bd5a75ab76b$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $e55f3bd5a75ab76b$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, $e55f3bd5a75ab76b$var$_objectSpread$6($e55f3bd5a75ab76b$var$_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var $e55f3bd5a75ab76b$var$baseLogger = new $e55f3bd5a75ab76b$var$Logger();
var $e55f3bd5a75ab76b$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $e55f3bd5a75ab76b$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $e55f3bd5a75ab76b$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $e55f3bd5a75ab76b$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $e55f3bd5a75ab76b$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $e55f3bd5a75ab76b$var$setPath(object, path, newValue) {
    var _getLastOfPath = $e55f3bd5a75ab76b$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $e55f3bd5a75ab76b$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $e55f3bd5a75ab76b$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $e55f3bd5a75ab76b$var$getPath(object, path) {
    var _getLastOfPath3 = $e55f3bd5a75ab76b$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $e55f3bd5a75ab76b$var$getPathWithDefaults(data, defaultData, key) {
    var value = $e55f3bd5a75ab76b$var$getPath(data, key);
    if (value !== undefined) return value;
    return $e55f3bd5a75ab76b$var$getPath(defaultData, key);
}
function $e55f3bd5a75ab76b$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $e55f3bd5a75ab76b$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $e55f3bd5a75ab76b$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $e55f3bd5a75ab76b$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $e55f3bd5a75ab76b$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $e55f3bd5a75ab76b$var$_entityMap[s];
    });
    return data;
}
var $e55f3bd5a75ab76b$var$isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $e55f3bd5a75ab76b$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $e55f3bd5a75ab76b$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = $e55f3bd5a75ab76b$var$chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $e55f3bd5a75ab76b$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $e55f3bd5a75ab76b$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $e55f3bd5a75ab76b$var$ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e55f3bd5a75ab76b$var$_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e55f3bd5a75ab76b$var$ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e55f3bd5a75ab76b$var$ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e55f3bd5a75ab76b$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $e55f3bd5a75ab76b$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $d866b19a9998757a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d866b19a9998757a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $456189533e24f3fc$export$2e2bcd8739ae039)(this, result);
    };
}
function $e55f3bd5a75ab76b$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $e55f3bd5a75ab76b$var$ResourceStore = function(_EventEmitter) {
    (0, $744fbf130698b5f6$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    var _super = $e55f3bd5a75ab76b$var$_createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = _super.call(this);
        if ($e55f3bd5a75ab76b$var$isIE10) $e55f3bd5a75ab76b$var$EventEmitter.call((0, $f38f801e616ac827$export$2e2bcd8739ae039)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $e55f3bd5a75ab76b$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $e55f3bd5a75ab76b$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $e55f3bd5a75ab76b$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $e55f3bd5a75ab76b$var$getPath(this.data, path) || {};
                if (deep) $e55f3bd5a75ab76b$var$deepExtend(pack, resources, overwrite);
                else pack = $e55f3bd5a75ab76b$var$_objectSpread$5($e55f3bd5a75ab76b$var$_objectSpread$5({}, pack), resources);
                $e55f3bd5a75ab76b$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return $e55f3bd5a75ab76b$var$_objectSpread$5($e55f3bd5a75ab76b$var$_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($e55f3bd5a75ab76b$var$EventEmitter);
var $e55f3bd5a75ab76b$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function $e55f3bd5a75ab76b$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e55f3bd5a75ab76b$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e55f3bd5a75ab76b$var$ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e55f3bd5a75ab76b$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e55f3bd5a75ab76b$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $e55f3bd5a75ab76b$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $d866b19a9998757a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d866b19a9998757a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $456189533e24f3fc$export$2e2bcd8739ae039)(this, result);
    };
}
function $e55f3bd5a75ab76b$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $e55f3bd5a75ab76b$var$checkedLoadedFor = {};
var $e55f3bd5a75ab76b$var$Translator = function(_EventEmitter) {
    (0, $744fbf130698b5f6$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    var _super = $e55f3bd5a75ab76b$var$_createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, Translator);
        _this = _super.call(this);
        if ($e55f3bd5a75ab76b$var$isIE10) $e55f3bd5a75ab76b$var$EventEmitter.call((0, $f38f801e616ac827$export$2e2bcd8739ae039)(_this));
        $e55f3bd5a75ab76b$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $f38f801e616ac827$export$2e2bcd8739ae039)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $e55f3bd5a75ab76b$var$baseLogger.create("translator");
        return _this;
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$e55f3bd5a75ab76b$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(options) === "object") options = $e55f3bd5a75ab76b$var$_objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, $e55f3bd5a75ab76b$var$_objectSpread$4($e55f3bd5a75ab76b$var$_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, $e55f3bd5a75ab76b$var$_objectSpread$4($e55f3bd5a75ab76b$var$_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, $e55f3bd5a75ab76b$var$_objectSpread$4($e55f3bd5a75ab76b$var$_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, $e55f3bd5a75ab76b$var$_objectSpread$4($e55f3bd5a75ab76b$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init($e55f3bd5a75ab76b$var$_objectSpread$4($e55f3bd5a75ab76b$var$_objectSpread$4({}, options), {
                        interpolation: $e55f3bd5a75ab76b$var$_objectSpread$4($e55f3bd5a75ab76b$var$_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = $e55f3bd5a75ab76b$var$_objectSpread$4($e55f3bd5a75ab76b$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $e55f3bd5a75ab76b$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? $e55f3bd5a75ab76b$var$_objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$e55f3bd5a75ab76b$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $e55f3bd5a75ab76b$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($e55f3bd5a75ab76b$var$EventEmitter);
function $e55f3bd5a75ab76b$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $e55f3bd5a75ab76b$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $e55f3bd5a75ab76b$var$baseLogger.create("languageUtils");
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $e55f3bd5a75ab76b$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $e55f3bd5a75ab76b$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $e55f3bd5a75ab76b$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $e55f3bd5a75ab76b$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $e55f3bd5a75ab76b$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var $e55f3bd5a75ab76b$var$deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var $e55f3bd5a75ab76b$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $e55f3bd5a75ab76b$var$createRules() {
    var rules = {};
    $e55f3bd5a75ab76b$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $e55f3bd5a75ab76b$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $e55f3bd5a75ab76b$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $e55f3bd5a75ab76b$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $e55f3bd5a75ab76b$var$createRules();
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return $e55f3bd5a75ab76b$var$suffixesOrder[pluralCategory1] - $e55f3bd5a75ab76b$var$suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !$e55f3bd5a75ab76b$var$deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function $e55f3bd5a75ab76b$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e55f3bd5a75ab76b$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e55f3bd5a75ab76b$var$ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e55f3bd5a75ab76b$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e55f3bd5a75ab76b$var$deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = $e55f3bd5a75ab76b$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $e55f3bd5a75ab76b$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $e55f3bd5a75ab76b$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var $e55f3bd5a75ab76b$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $e55f3bd5a75ab76b$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $e55f3bd5a75ab76b$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $e55f3bd5a75ab76b$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $e55f3bd5a75ab76b$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $e55f3bd5a75ab76b$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $e55f3bd5a75ab76b$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $e55f3bd5a75ab76b$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $e55f3bd5a75ab76b$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $e55f3bd5a75ab76b$var$deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, $e55f3bd5a75ab76b$var$_objectSpread$3($e55f3bd5a75ab76b$var$_objectSpread$3($e55f3bd5a75ab76b$var$_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($e55f3bd5a75ab76b$var$deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, $e55f3bd5a75ab76b$var$_objectSpread$3($e55f3bd5a75ab76b$var$_objectSpread$3($e55f3bd5a75ab76b$var$_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $e55f3bd5a75ab76b$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = $e55f3bd5a75ab76b$var$_objectSpread$3($e55f3bd5a75ab76b$var$_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = $e55f3bd5a75ab76b$var$_objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $e55f3bd5a75ab76b$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, $e55f3bd5a75ab76b$var$_objectSpread$3($e55f3bd5a75ab76b$var$_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $e55f3bd5a75ab76b$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e55f3bd5a75ab76b$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e55f3bd5a75ab76b$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e55f3bd5a75ab76b$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e55f3bd5a75ab76b$var$parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $b6b79e1e4ac6c680$export$2e2bcd8739ae039)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $e55f3bd5a75ab76b$var$createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var $e55f3bd5a75ab76b$var$Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, Formatter);
        this.logger = $e55f3bd5a75ab76b$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $e55f3bd5a75ab76b$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $e55f3bd5a75ab76b$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: $e55f3bd5a75ab76b$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $e55f3bd5a75ab76b$var$_objectSpread$2($e55f3bd5a75ab76b$var$_objectSpread$2({}, opt), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: $e55f3bd5a75ab76b$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, $e55f3bd5a75ab76b$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: $e55f3bd5a75ab76b$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, $e55f3bd5a75ab76b$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || "day");
                };
            }),
            list: $e55f3bd5a75ab76b$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, $e55f3bd5a75ab76b$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = $e55f3bd5a75ab76b$var$createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = $e55f3bd5a75ab76b$var$parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, $e55f3bd5a75ab76b$var$_objectSpread$2($e55f3bd5a75ab76b$var$_objectSpread$2($e55f3bd5a75ab76b$var$_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function $e55f3bd5a75ab76b$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e55f3bd5a75ab76b$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e55f3bd5a75ab76b$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e55f3bd5a75ab76b$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e55f3bd5a75ab76b$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $e55f3bd5a75ab76b$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $d866b19a9998757a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d866b19a9998757a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $456189533e24f3fc$export$2e2bcd8739ae039)(this, result);
    };
}
function $e55f3bd5a75ab76b$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e55f3bd5a75ab76b$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var $e55f3bd5a75ab76b$var$Connector = function(_EventEmitter) {
    (0, $744fbf130698b5f6$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    var _super = $e55f3bd5a75ab76b$var$_createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, Connector);
        _this = _super.call(this);
        if ($e55f3bd5a75ab76b$var$isIE10) $e55f3bd5a75ab76b$var$EventEmitter.call((0, $f38f801e616ac827$export$2e2bcd8739ae039)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $e55f3bd5a75ab76b$var$baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $e55f3bd5a75ab76b$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $e55f3bd5a75ab76b$var$removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function clb() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = $e55f3bd5a75ab76b$var$_objectSpread$1($e55f3bd5a75ab76b$var$_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($e55f3bd5a75ab76b$var$EventEmitter);
function $e55f3bd5a75ab76b$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(args[2]) === "object" || (0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $e55f3bd5a75ab76b$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $e55f3bd5a75ab76b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e55f3bd5a75ab76b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e55f3bd5a75ab76b$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $015c42b2ccedc741$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e55f3bd5a75ab76b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e55f3bd5a75ab76b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e55f3bd5a75ab76b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $d866b19a9998757a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d866b19a9998757a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $456189533e24f3fc$export$2e2bcd8739ae039)(this, result);
    };
}
function $e55f3bd5a75ab76b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e55f3bd5a75ab76b$var$noop() {}
function $e55f3bd5a75ab76b$var$bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var $e55f3bd5a75ab76b$var$I18n = function(_EventEmitter) {
    (0, $744fbf130698b5f6$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    var _super = $e55f3bd5a75ab76b$var$_createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, I18n);
        _this = _super.call(this);
        if ($e55f3bd5a75ab76b$var$isIE10) $e55f3bd5a75ab76b$var$EventEmitter.call((0, $f38f801e616ac827$export$2e2bcd8739ae039)(_this));
        _this.options = $e55f3bd5a75ab76b$var$transformOptions(options);
        _this.services = {};
        _this.logger = $e55f3bd5a75ab76b$var$baseLogger;
        _this.modules = {
            external: []
        };
        $e55f3bd5a75ab76b$var$bindMemberFunctions((0, $f38f801e616ac827$export$2e2bcd8739ae039)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $456189533e24f3fc$export$2e2bcd8739ae039)(_this, (0, $f38f801e616ac827$export$2e2bcd8739ae039)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = $e55f3bd5a75ab76b$var$get();
                this.options = $e55f3bd5a75ab76b$var$_objectSpread($e55f3bd5a75ab76b$var$_objectSpread($e55f3bd5a75ab76b$var$_objectSpread({}, defOpts), this.options), $e55f3bd5a75ab76b$var$transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = $e55f3bd5a75ab76b$var$_objectSpread($e55f3bd5a75ab76b$var$_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $e55f3bd5a75ab76b$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $e55f3bd5a75ab76b$var$baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = $e55f3bd5a75ab76b$var$Formatter;
                    var lu = new $e55f3bd5a75ab76b$var$LanguageUtil(this.options);
                    this.store = new $e55f3bd5a75ab76b$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $e55f3bd5a75ab76b$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $e55f3bd5a75ab76b$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new $e55f3bd5a75ab76b$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $e55f3bd5a75ab76b$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $e55f3bd5a75ab76b$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = $e55f3bd5a75ab76b$var$noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $e55f3bd5a75ab76b$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e55f3bd5a75ab76b$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $e55f3bd5a75ab76b$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $e55f3bd5a75ab76b$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $e55f3bd5a75ab76b$var$postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $e55f3bd5a75ab76b$var$defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $dc6b79f8788226f5$export$2e2bcd8739ae039)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = $e55f3bd5a75ab76b$var$_objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $e55f3bd5a75ab76b$var$defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $e55f3bd5a75ab76b$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new $e55f3bd5a75ab76b$var$LanguageUtil($e55f3bd5a75ab76b$var$get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e55f3bd5a75ab76b$var$noop;
                var mergedOptions = $e55f3bd5a75ab76b$var$_objectSpread($e55f3bd5a75ab76b$var$_objectSpread($e55f3bd5a75ab76b$var$_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = $e55f3bd5a75ab76b$var$_objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $e55f3bd5a75ab76b$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}($e55f3bd5a75ab76b$var$EventEmitter);
(0, $015c42b2ccedc741$export$2e2bcd8739ae039)($e55f3bd5a75ab76b$var$I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new $e55f3bd5a75ab76b$var$I18n(options, callback);
});
var $e55f3bd5a75ab76b$export$2e2bcd8739ae039 = $e55f3bd5a75ab76b$var$I18n.createInstance();
$e55f3bd5a75ab76b$export$2e2bcd8739ae039.createInstance = $e55f3bd5a75ab76b$var$I18n.createInstance;
var $e55f3bd5a75ab76b$export$99152e8d49ca4e7d = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.createInstance;
var $e55f3bd5a75ab76b$export$147ec2801e896265 = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.dir;
var $e55f3bd5a75ab76b$export$2cd8252107eb640b = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.init;
var $e55f3bd5a75ab76b$export$d3d08d944062d7e = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.loadResources;
var $e55f3bd5a75ab76b$export$a5d9bf5d83fcab09 = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.reloadResources;
var $e55f3bd5a75ab76b$export$1f96ae73734a86cc = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.use;
var $e55f3bd5a75ab76b$export$61465194746e7fd2 = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.changeLanguage;
var $e55f3bd5a75ab76b$export$f90d180fc7da3b3b = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.getFixedT;
var $e55f3bd5a75ab76b$export$625550452a3fa3ec = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.t;
var $e55f3bd5a75ab76b$export$f7e9f41ea797a17 = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.exists;
var $e55f3bd5a75ab76b$export$2b4b218e406d2d00 = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.setDefaultNamespace;
var $e55f3bd5a75ab76b$export$93d9ee97c1ad3f31 = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.hasLoadedNamespace;
var $e55f3bd5a75ab76b$export$83be934b53fff43b = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.loadNamespaces;
var $e55f3bd5a75ab76b$export$8cd7e7a54fa865bc = $e55f3bd5a75ab76b$export$2e2bcd8739ae039.loadLanguages;



var $kVN77 = parcelRequire("kVN77");

var $3L4GM = parcelRequire("3L4GM");

var $cfc1861ad23bc56b$exports = {};
"use strict";
function $cfc1861ad23bc56b$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $kVN77 = parcelRequire("kVN77");
var $cfc1861ad23bc56b$var$React__default = $cfc1861ad23bc56b$var$_interopDefault($kVN77);
function $cfc1861ad23bc56b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cfc1861ad23bc56b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $cfc1861ad23bc56b$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $cfc1861ad23bc56b$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $cfc1861ad23bc56b$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $cfc1861ad23bc56b$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($kVN77.PureComponent);
        $cfc1861ad23bc56b$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $cfc1861ad23bc56b$var$_defineProperty(SideEffect, "canUseDOM", $cfc1861ad23bc56b$var$canUseDOM);
        return SideEffect;
    };
}
$cfc1861ad23bc56b$exports = $cfc1861ad23bc56b$var$withSideEffect;


var $913dfae7b1bd1658$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $913dfae7b1bd1658$var$hasElementType = typeof Element !== "undefined";
var $913dfae7b1bd1658$var$hasMap = typeof Map === "function";
var $913dfae7b1bd1658$var$hasSet = typeof Set === "function";
var $913dfae7b1bd1658$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $913dfae7b1bd1658$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$913dfae7b1bd1658$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($913dfae7b1bd1658$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$913dfae7b1bd1658$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($913dfae7b1bd1658$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($913dfae7b1bd1658$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($913dfae7b1bd1658$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$913dfae7b1bd1658$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$913dfae7b1bd1658$exports = function isEqual(a, b) {
    try {
        return $913dfae7b1bd1658$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $kVN77 = parcelRequire("kVN77");
var $6afe2229bba35333$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $6afe2229bba35333$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6afe2229bba35333$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6afe2229bba35333$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $6afe2229bba35333$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $6afe2229bba35333$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$6afe2229bba35333$exports = $6afe2229bba35333$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $6afe2229bba35333$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($6afe2229bba35333$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($6afe2229bba35333$var$getOwnPropertySymbols) {
            symbols = $6afe2229bba35333$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($6afe2229bba35333$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $d387b2d0eaa648c2$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $d387b2d0eaa648c2$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $d387b2d0eaa648c2$var$VALID_TAG_NAMES = Object.keys($d387b2d0eaa648c2$var$TAG_NAMES).map(function(name) {
    return $d387b2d0eaa648c2$var$TAG_NAMES[name];
});
var $d387b2d0eaa648c2$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $d387b2d0eaa648c2$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $d387b2d0eaa648c2$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $d387b2d0eaa648c2$var$HTML_TAG_MAP = Object.keys($d387b2d0eaa648c2$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$d387b2d0eaa648c2$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $d387b2d0eaa648c2$var$SELF_CLOSING_TAGS = [
    $d387b2d0eaa648c2$var$TAG_NAMES.NOSCRIPT,
    $d387b2d0eaa648c2$var$TAG_NAMES.SCRIPT,
    $d387b2d0eaa648c2$var$TAG_NAMES.STYLE
];
var $d387b2d0eaa648c2$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $d387b2d0eaa648c2$var$_typeof = typeof Symbol === "function" && (0, $3L4GM._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, $3L4GM._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $3L4GM._)(obj);
};
var $d387b2d0eaa648c2$var$classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $d387b2d0eaa648c2$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $d387b2d0eaa648c2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d387b2d0eaa648c2$var$inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $3L4GM._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $d387b2d0eaa648c2$var$objectWithoutProperties = function objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $d387b2d0eaa648c2$var$possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $d387b2d0eaa648c2$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $d387b2d0eaa648c2$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $d387b2d0eaa648c2$var$getInnermostProperty(propsList, $d387b2d0eaa648c2$var$TAG_NAMES.TITLE);
    var innermostTemplate = $d387b2d0eaa648c2$var$getInnermostProperty(propsList, $d387b2d0eaa648c2$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $d387b2d0eaa648c2$var$getInnermostProperty(propsList, $d387b2d0eaa648c2$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $d387b2d0eaa648c2$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $d387b2d0eaa648c2$var$getInnermostProperty(propsList, $d387b2d0eaa648c2$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $d387b2d0eaa648c2$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $d387b2d0eaa648c2$var$_extends({}, tagAttrs, current);
    }, {});
};
var $d387b2d0eaa648c2$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$d387b2d0eaa648c2$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$d387b2d0eaa648c2$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $d387b2d0eaa648c2$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $d387b2d0eaa648c2$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $d387b2d0eaa648c2$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $d387b2d0eaa648c2$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $d387b2d0eaa648c2$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $d387b2d0eaa648c2$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $d387b2d0eaa648c2$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $d387b2d0eaa648c2$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($6afe2229bba35333$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $d387b2d0eaa648c2$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $d387b2d0eaa648c2$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $d387b2d0eaa648c2$var$getBaseTagFromPropsList([
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.HREF,
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $d387b2d0eaa648c2$var$getAttributesFromPropsList($d387b2d0eaa648c2$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $d387b2d0eaa648c2$var$getInnermostProperty(propsList, $d387b2d0eaa648c2$var$HELMET_PROPS.DEFER),
        encode: $d387b2d0eaa648c2$var$getInnermostProperty(propsList, $d387b2d0eaa648c2$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $d387b2d0eaa648c2$var$getAttributesFromPropsList($d387b2d0eaa648c2$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $d387b2d0eaa648c2$var$getTagsFromPropsList($d387b2d0eaa648c2$var$TAG_NAMES.LINK, [
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.REL,
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $d387b2d0eaa648c2$var$getTagsFromPropsList($d387b2d0eaa648c2$var$TAG_NAMES.META, [
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.NAME,
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.CHARSET,
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.HTTPEQUIV,
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.PROPERTY,
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $d387b2d0eaa648c2$var$getTagsFromPropsList($d387b2d0eaa648c2$var$TAG_NAMES.NOSCRIPT, [
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $d387b2d0eaa648c2$var$getOnChangeClientState(propsList),
        scriptTags: $d387b2d0eaa648c2$var$getTagsFromPropsList($d387b2d0eaa648c2$var$TAG_NAMES.SCRIPT, [
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.SRC,
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $d387b2d0eaa648c2$var$getTagsFromPropsList($d387b2d0eaa648c2$var$TAG_NAMES.STYLE, [
            $d387b2d0eaa648c2$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $d387b2d0eaa648c2$var$getTitleFromPropsList(propsList),
        titleAttributes: $d387b2d0eaa648c2$var$getAttributesFromPropsList($d387b2d0eaa648c2$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $d387b2d0eaa648c2$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $d387b2d0eaa648c2$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $d387b2d0eaa648c2$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $d387b2d0eaa648c2$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $d387b2d0eaa648c2$var$rafPolyfill : $parcel$global.requestAnimationFrame || $d387b2d0eaa648c2$var$rafPolyfill;
var $d387b2d0eaa648c2$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $d387b2d0eaa648c2$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $d387b2d0eaa648c2$var$cafPolyfill;
var $d387b2d0eaa648c2$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $d387b2d0eaa648c2$var$_helmetCallback = null;
var $d387b2d0eaa648c2$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($d387b2d0eaa648c2$var$_helmetCallback) $d387b2d0eaa648c2$var$cancelAnimationFrame($d387b2d0eaa648c2$var$_helmetCallback);
    if (newState.defer) $d387b2d0eaa648c2$var$_helmetCallback = $d387b2d0eaa648c2$var$requestAnimationFrame(function() {
        $d387b2d0eaa648c2$var$commitTagChanges(newState, function() {
            $d387b2d0eaa648c2$var$_helmetCallback = null;
        });
    });
    else {
        $d387b2d0eaa648c2$var$commitTagChanges(newState);
        $d387b2d0eaa648c2$var$_helmetCallback = null;
    }
};
var $d387b2d0eaa648c2$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $d387b2d0eaa648c2$var$updateAttributes($d387b2d0eaa648c2$var$TAG_NAMES.BODY, bodyAttributes);
    $d387b2d0eaa648c2$var$updateAttributes($d387b2d0eaa648c2$var$TAG_NAMES.HTML, htmlAttributes);
    $d387b2d0eaa648c2$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $d387b2d0eaa648c2$var$updateTags($d387b2d0eaa648c2$var$TAG_NAMES.BASE, baseTag),
        linkTags: $d387b2d0eaa648c2$var$updateTags($d387b2d0eaa648c2$var$TAG_NAMES.LINK, linkTags),
        metaTags: $d387b2d0eaa648c2$var$updateTags($d387b2d0eaa648c2$var$TAG_NAMES.META, metaTags),
        noscriptTags: $d387b2d0eaa648c2$var$updateTags($d387b2d0eaa648c2$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $d387b2d0eaa648c2$var$updateTags($d387b2d0eaa648c2$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $d387b2d0eaa648c2$var$updateTags($d387b2d0eaa648c2$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $d387b2d0eaa648c2$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $d387b2d0eaa648c2$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $d387b2d0eaa648c2$var$flattenArray(title);
    $d387b2d0eaa648c2$var$updateAttributes($d387b2d0eaa648c2$var$TAG_NAMES.TITLE, attributes);
};
var $d387b2d0eaa648c2$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($d387b2d0eaa648c2$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($d387b2d0eaa648c2$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($d387b2d0eaa648c2$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($d387b2d0eaa648c2$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $d387b2d0eaa648c2$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($d387b2d0eaa648c2$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $d387b2d0eaa648c2$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $d387b2d0eaa648c2$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $d387b2d0eaa648c2$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($d387b2d0eaa648c2$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $d387b2d0eaa648c2$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $d387b2d0eaa648c2$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $d387b2d0eaa648c2$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $d387b2d0eaa648c2$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $d387b2d0eaa648c2$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $d387b2d0eaa648c2$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $d387b2d0eaa648c2$var$HELMET_ATTRIBUTE + '="true">' + $d387b2d0eaa648c2$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $d387b2d0eaa648c2$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $d387b2d0eaa648c2$var$TAG_PROPERTIES.INNER_HTML || attribute === $d387b2d0eaa648c2$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $d387b2d0eaa648c2$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $d387b2d0eaa648c2$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $d387b2d0eaa648c2$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $d387b2d0eaa648c2$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$d387b2d0eaa648c2$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $d387b2d0eaa648c2$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$d387b2d0eaa648c2$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $d387b2d0eaa648c2$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$d387b2d0eaa648c2$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $d387b2d0eaa648c2$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).createElement($d387b2d0eaa648c2$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $d387b2d0eaa648c2$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$d387b2d0eaa648c2$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $d387b2d0eaa648c2$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $d387b2d0eaa648c2$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $d387b2d0eaa648c2$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).createElement(type, mappedTag);
    });
};
var $d387b2d0eaa648c2$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $d387b2d0eaa648c2$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $d387b2d0eaa648c2$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $d387b2d0eaa648c2$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $d387b2d0eaa648c2$var$ATTRIBUTE_NAMES.BODY:
        case $d387b2d0eaa648c2$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $d387b2d0eaa648c2$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $d387b2d0eaa648c2$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $d387b2d0eaa648c2$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $d387b2d0eaa648c2$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $d387b2d0eaa648c2$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $d387b2d0eaa648c2$var$getMethodsForTag($d387b2d0eaa648c2$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $d387b2d0eaa648c2$var$getMethodsForTag($d387b2d0eaa648c2$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $d387b2d0eaa648c2$var$getMethodsForTag($d387b2d0eaa648c2$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $d387b2d0eaa648c2$var$getMethodsForTag($d387b2d0eaa648c2$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $d387b2d0eaa648c2$var$getMethodsForTag($d387b2d0eaa648c2$var$TAG_NAMES.META, metaTags, encode),
        noscript: $d387b2d0eaa648c2$var$getMethodsForTag($d387b2d0eaa648c2$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $d387b2d0eaa648c2$var$getMethodsForTag($d387b2d0eaa648c2$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $d387b2d0eaa648c2$var$getMethodsForTag($d387b2d0eaa648c2$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $d387b2d0eaa648c2$var$getMethodsForTag($d387b2d0eaa648c2$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $d387b2d0eaa648c2$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $d387b2d0eaa648c2$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $d387b2d0eaa648c2$var$classCallCheck(this, HelmetWrapper);
            return $d387b2d0eaa648c2$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($913dfae7b1bd1658$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $d387b2d0eaa648c2$var$TAG_NAMES.SCRIPT:
                case $d387b2d0eaa648c2$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $d387b2d0eaa648c2$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $d387b2d0eaa648c2$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $d387b2d0eaa648c2$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $d387b2d0eaa648c2$var$TAG_NAMES.TITLE:
                    return $d387b2d0eaa648c2$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $d387b2d0eaa648c2$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $d387b2d0eaa648c2$var$TAG_NAMES.BODY:
                    return $d387b2d0eaa648c2$var$_extends({}, newProps, {
                        bodyAttributes: $d387b2d0eaa648c2$var$_extends({}, newChildProps)
                    });
                case $d387b2d0eaa648c2$var$TAG_NAMES.HTML:
                    return $d387b2d0eaa648c2$var$_extends({}, newProps, {
                        htmlAttributes: $d387b2d0eaa648c2$var$_extends({}, newChildProps)
                    });
            }
            return $d387b2d0eaa648c2$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $d387b2d0eaa648c2$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $d387b2d0eaa648c2$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $d387b2d0eaa648c2$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $d387b2d0eaa648c2$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $d387b2d0eaa648c2$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $d387b2d0eaa648c2$var$TAG_NAMES.LINK:
                    case $d387b2d0eaa648c2$var$TAG_NAMES.META:
                    case $d387b2d0eaa648c2$var$TAG_NAMES.NOSCRIPT:
                    case $d387b2d0eaa648c2$var$TAG_NAMES.SCRIPT:
                    case $d387b2d0eaa648c2$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $d387b2d0eaa648c2$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $d387b2d0eaa648c2$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).createElement(Component, newProps);
        };
        $d387b2d0eaa648c2$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($f834a9f081b5b867$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $d387b2d0eaa648c2$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $d387b2d0eaa648c2$var$NullComponent = function NullComponent() {
    return null;
};
var $d387b2d0eaa648c2$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($cfc1861ad23bc56b$exports)))($d387b2d0eaa648c2$var$reducePropsToState, $d387b2d0eaa648c2$var$handleClientStateChange, $d387b2d0eaa648c2$var$mapStateOnServer)($d387b2d0eaa648c2$var$NullComponent);
var $d387b2d0eaa648c2$export$dcef8f9bb9a41431 = $d387b2d0eaa648c2$var$Helmet($d387b2d0eaa648c2$var$HelmetSideEffects);
$d387b2d0eaa648c2$export$dcef8f9bb9a41431.renderStatic = $d387b2d0eaa648c2$export$dcef8f9bb9a41431.rewind;
var $d387b2d0eaa648c2$export$2e2bcd8739ae039 = $d387b2d0eaa648c2$export$dcef8f9bb9a41431;



var $e080ee6521d2fff4$exports = {};


$e080ee6521d2fff4$exports = (parcelRequire("3aHpZ")).getBundleURL("15lvv") + (parcelRequire("2n1zy")).resolve("7fb3i");


var $b677c477c670a7dc$exports = {};


$b677c477c670a7dc$exports = (parcelRequire("3aHpZ")).getBundleURL("15lvv") + (parcelRequire("2n1zy")).resolve("4wBTJ");


var $d98044c72d45e39d$exports = {};

$parcel$export($d98044c72d45e39d$exports, "dark", function () { return $d98044c72d45e39d$export$55ce6f3a06c59543; }, function (v) { return $d98044c72d45e39d$export$55ce6f3a06c59543 = v; });
$parcel$export($d98044c72d45e39d$exports, "light", function () { return $d98044c72d45e39d$export$a43af521ac8c3202; }, function (v) { return $d98044c72d45e39d$export$a43af521ac8c3202 = v; });
$parcel$export($d98044c72d45e39d$exports, "preview", function () { return $d98044c72d45e39d$export$48c2d0f2f545ac27; }, function (v) { return $d98044c72d45e39d$export$48c2d0f2f545ac27 = v; });
$parcel$export($d98044c72d45e39d$exports, "viewBox", function () { return $d98044c72d45e39d$export$a179c88182cb9d56; }, function (v) { return $d98044c72d45e39d$export$a179c88182cb9d56 = v; });
var $d98044c72d45e39d$export$55ce6f3a06c59543;
var $d98044c72d45e39d$export$a43af521ac8c3202;
var $d98044c72d45e39d$export$48c2d0f2f545ac27;
var $d98044c72d45e39d$export$a179c88182cb9d56;
$d98044c72d45e39d$export$55ce6f3a06c59543 = "mUhaAq_dark";
$d98044c72d45e39d$export$a43af521ac8c3202 = "mUhaAq_light";
$d98044c72d45e39d$export$48c2d0f2f545ac27 = "mUhaAq_preview";
$d98044c72d45e39d$export$a179c88182cb9d56 = "mUhaAq_viewBox";


/**
 * User React Helmet to manage html and body attributes
 * @see https://github.com/nfl/react-helmet
 *
 * - lang: set html lang attribute
 * - data-theme: set html data-theme attribute
 * - favicon: set favicon
 * - apple-touch-icon: set apple touch icon
 * - body class: set preview body class
 * - body class: set platform body class
 * - body class: set theme body class
 * - custom css: set custom css style tag
 */ var $0423c51259a0fddd$var$AppMeta = function() {
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), experienceSettings = _useContext.experienceSettings, theme = _useContext.theme, platform = _useContext.platform, isPreview = _useContext.isPreview;
    var _experienceSettings_branding_favicon, _experienceSettings_branding_favicon1;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d387b2d0eaa648c2$export$dcef8f9bb9a41431), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("html", {
                lang: (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).language,
                "data-theme": theme
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("link", {
                rel: "shortcut icon",
                href: (_experienceSettings_branding_favicon = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.branding.favicon) !== null && _experienceSettings_branding_favicon !== void 0 ? _experienceSettings_branding_favicon : (0, (/*@__PURE__*/$parcel$interopDefault($b677c477c670a7dc$exports)))
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("link", {
                rel: "apple-touch-icon",
                href: (_experienceSettings_branding_favicon1 = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.branding.favicon) !== null && _experienceSettings_branding_favicon1 !== void 0 ? _experienceSettings_branding_favicon1 : (0, (/*@__PURE__*/$parcel$interopDefault($e080ee6521d2fff4$exports))),
                sizes: "180x180"
            }),
            (experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.customCss) && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("style", {
                children: experienceSettings.customCss
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("body", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))((0, $3539bd14a37ab7f4$export$78aa88a01782ee9d)(isPreview && $d98044c72d45e39d$exports.preview), platform === "mobile" ? "mobile" : "desktop", (0, $3539bd14a37ab7f4$export$78aa88a01782ee9d)($d98044c72d45e39d$exports[theme]))
            })
        ]
    });
};
var $0423c51259a0fddd$export$2e2bcd8739ae039 = $0423c51259a0fddd$var$AppMeta;


var $3093c4cbf0bc0c38$var$AppBoundary = function(param) {
    var children = param.children;
    (0, $1cc30ea82391ca4a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0423c51259a0fddd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0d421b718ae2eec3$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c1fc8b4c328692df$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d7208e0213ec23ab$export$2e2bcd8739ae039), {
                        children: children
                    })
                })
            })
        ]
    });
};
var $3093c4cbf0bc0c38$export$2e2bcd8739ae039 = $3093c4cbf0bc0c38$var$AppBoundary;




var $kVN77 = parcelRequire("kVN77");


var $kVN77 = parcelRequire("kVN77");
/**
 * Hook-based wrapper for `setTimeout()`.
 */ function $8e013763ed0d1cd9$export$632123ff591ac565() {
    var _useState = (0, $kVN77.useState)({
        time: null,
        done: false
    }), state = _useState[0], setState = _useState[1];
    var timerId = (0, $kVN77.useRef)(null);
    var start = (0, $kVN77.useCallback)(function(ms) {
        setState({
            time: ms,
            done: false
        });
    }, [
        setState
    ]);
    (0, $kVN77.useEffect)(function() {
        if (!timerId.current && state.time) timerId.current = setTimeout(function() {
            setState({
                time: null,
                done: true
            });
            timerId.current = null;
        }, state.time);
        return function() {
            if (timerId.current) clearTimeout(timerId.current);
        };
    }, [
        state,
        setState
    ]);
    return {
        start: start,
        done: state.done
    };
}
var $8e013763ed0d1cd9$var$reducer = function reducer(state, action) {
    var isLoading = action.isLoading, timerDone = action.timerDone;
    switch(state){
        case "off":
            return isLoading ? "delayTrigger" : "off";
        case "delayTrigger":
            return isLoading ? "delayWait" : "off";
        case "delayWait":
            return isLoading ? timerDone ? "onTrigger" : "delayWait" : "off";
        case "onTrigger":
            return isLoading ? "onWait" : "off";
        case "onWait":
            return timerDone ? "on" : "onWait";
        case "on":
            return isLoading ? "on" : "off";
    }
};
/**
 * Debounces `isLoading` input. If `isLoading` remains `true` for at least `initialDelay` miliseconds, this hook
 * will returns `true` for `minimalTimeOn` miliseconds.
 * @param isLoading - Input signal you wish to debounce (usually it connects to a spinner and indicates a pending operation)
 * @param initialDelay - Delay in miliseconds. Requests shorter than `initialDelay` will be ignored.
 * @param minimalTimeOn - Once spinner appears, it will stay on screen for a least `minimalTimeOn` miliseconds.
 * @returns Debounced `isLoading` signal
 */ function $8e013763ed0d1cd9$export$acf523bed0f127d8(isLoading, initialDelay, minimalTimeOn) {
    if (initialDelay === void 0) initialDelay = 400;
    if (minimalTimeOn === void 0) minimalTimeOn = 400;
    var _useReducer = (0, $kVN77.useReducer)($8e013763ed0d1cd9$var$reducer, "off"), state = _useReducer[0], dispatch = _useReducer[1];
    var _useTimer = $8e013763ed0d1cd9$export$632123ff591ac565(), start = _useTimer.start, done = _useTimer.done;
    (0, $kVN77.useEffect)(function() {
        if (state === "delayTrigger") start(initialDelay);
        else if (state === "onTrigger") start(minimalTimeOn);
        dispatch({
            isLoading: isLoading,
            timerDone: done
        });
    }, [
        state,
        isLoading,
        start,
        done,
        initialDelay,
        minimalTimeOn
    ]);
    return state === "on" || state === "onWait";
}









parcelRequire("kVN77");
var $d6febe7161d4bdec$var$SvgLoadingIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 32,
        height: 32,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.48,
                x: 15,
                width: 2,
                height: 8,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.96,
                x: 15,
                y: 24,
                width: 2,
                height: 8,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.72,
                y: 17,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-90 0 17)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.24,
                x: 24,
                y: 17,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-90 24 17)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.32,
                x: 29.356,
                y: 7.134,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(60 29.356 7.134)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.8,
                x: 8.572,
                y: 19.134,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(60 8.572 19.134)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.64,
                x: 1.644,
                y: 8.866,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-60 1.644 8.866)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.16,
                x: 22.428,
                y: 20.866,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-60 22.428 20.866)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.4,
                x: 23.134,
                y: 1.644,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(30 23.134 1.644)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.88,
                x: 11.134,
                y: 22.428,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(30 11.134 22.428)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.56,
                x: 7.134,
                y: 2.644,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-30 7.134 2.644)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                opacity: 0.08,
                x: 19.134,
                y: 23.428,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-30 19.134 23.428)",
                fill: "currentColor"
            })
        ]
    }));
};
var $d6febe7161d4bdec$export$2e2bcd8739ae039 = $d6febe7161d4bdec$var$SvgLoadingIcon;


var $76355522bd3e9ea0$export$34e0f9847d4c02dd;
var $76355522bd3e9ea0$export$5dd8d3d3c0fde971;
var $76355522bd3e9ea0$export$29dd17c7f3c81c36;
var $76355522bd3e9ea0$export$bfd64c937657f93a;
$76355522bd3e9ea0$export$34e0f9847d4c02dd = "qNKCfW_container";
$76355522bd3e9ea0$export$5dd8d3d3c0fde971 = "qNKCfW_loadingIcon";
$76355522bd3e9ea0$export$29dd17c7f3c81c36 = "qNKCfW_overlay";
$76355522bd3e9ea0$export$bfd64c937657f93a = "qNKCfW_rotating";
$76355522bd3e9ea0$export$bfd64c937657f93a;


var $4bc5d6d9a8c5bdf7$var$LoadingIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d6febe7161d4bdec$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($76355522bd3e9ea0$export$5dd8d3d3c0fde971, className)
    });
};
var $4bc5d6d9a8c5bdf7$export$2e2bcd8739ae039 = $4bc5d6d9a8c5bdf7$var$LoadingIcon;



var $fd8b596ccc1e1b22$var$LoadingLayer = function() {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: $76355522bd3e9ea0$export$29dd17c7f3c81c36,
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
            className: $76355522bd3e9ea0$export$34e0f9847d4c02dd,
            children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4bc5d6d9a8c5bdf7$export$2e2bcd8739ae039), {})
        })
    });
};
var $fd8b596ccc1e1b22$export$2e2bcd8739ae039 = $fd8b596ccc1e1b22$var$LoadingLayer;


var $8da9bb0819deeb08$var$LoadingLayerProvider = function() {
    var loading = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).loading;
    var debouncedLoading = (0, $8e013763ed0d1cd9$export$acf523bed0f127d8)(loading, 500);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$910ae8079b2c2852), {}),
            debouncedLoading && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $fd8b596ccc1e1b22$export$2e2bcd8739ae039), {})
        ]
    });
};
var $8da9bb0819deeb08$export$2e2bcd8739ae039 = $8da9bb0819deeb08$var$LoadingLayerProvider;






var $kVN77 = parcelRequire("kVN77");



var $3f272dd8685efc71$var$PageContextProvider = function(param) {
    var children = param.children, preset = param.preset;
    var _useSearchParams = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $d03cd69b331d3258$export$f1a78c17382fe22a)(), 1), searchParameters = _useSearchParams[0];
    var _preset_loading;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)((_preset_loading = preset === null || preset === void 0 ? void 0 : preset.loading) !== null && _preset_loading !== void 0 ? _preset_loading : false), 2), loading = _useState[0], setLoading = _useState[1];
    var _preset_toast;
    var _useState1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)((_preset_toast = preset === null || preset === void 0 ? void 0 : preset.toast) !== null && _preset_toast !== void 0 ? _preset_toast : ""), 2), toast = _useState1[0], setToast = _useState1[1];
    var _preset_theme;
    var _useState2 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)((_preset_theme = preset === null || preset === void 0 ? void 0 : preset.theme) !== null && _preset_theme !== void 0 ? _preset_theme : (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Light), 2), theme = _useState2[0], setTheme = _useState2[1];
    var _preset_platform;
    var _useState3 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)((_preset_platform = preset === null || preset === void 0 ? void 0 : preset.platform) !== null && _preset_platform !== void 0 ? _preset_platform : (0, $f230858f3ff7a967$exports.isMobile) ? "mobile" : "web"), 2), platform = _useState3[0], setPlatform = _useState3[1];
    var _preset_termsAgreement;
    var _useState4 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)((_preset_termsAgreement = preset === null || preset === void 0 ? void 0 : preset.termsAgreement) !== null && _preset_termsAgreement !== void 0 ? _preset_termsAgreement : false), 2), termsAgreement = _useState4[0], setTermsAgreement = _useState4[1];
    var _preset_experienceSettings;
    var _useState5 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)((_preset_experienceSettings = preset === null || preset === void 0 ? void 0 : preset.experienceSettings) !== null && _preset_experienceSettings !== void 0 ? _preset_experienceSettings : undefined), 2), experienceSettings = _useState5[0], setExperienceSettings = _useState5[1];
    var isPreview = searchParameters.get("preview") === "true";
    var pageContext = (0, $kVN77.useMemo)(function() {
        return {
            theme: theme,
            toast: toast,
            loading: loading,
            platform: platform,
            termsAgreement: termsAgreement,
            experienceSettings: experienceSettings,
            isPreview: isPreview,
            setTheme: setTheme,
            setLoading: setLoading,
            setToast: setToast,
            setPlatform: setPlatform,
            setTermsAgreement: setTermsAgreement,
            setExperienceSettings: setExperienceSettings
        };
    }, [
        experienceSettings,
        isPreview,
        loading,
        platform,
        termsAgreement,
        theme,
        toast
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0125155968220dbd$export$2e2bcd8739ae039).Provider, {
        value: pageContext,
        children: children
    });
};
var $3f272dd8685efc71$export$2e2bcd8739ae039 = $3f272dd8685efc71$var$PageContextProvider;



var $kVN77 = parcelRequire("kVN77");









var $kVN77 = parcelRequire("kVN77");











var $f9b30a5e52cfb578$var$action = {
    sign_in: "Anmelden",
    continue: "Weiter",
    create_account: "Konto erstellen",
    create_account_without_linking: "Erstelle ein Konto ohne Verkn\xfcpfung",
    create: "Erstellen",
    enter_passcode: "Best\xe4tigungscode eingeben",
    confirm: "Best\xe4tigen",
    cancel: "Abbrechen",
    save_password: "Passwort speichern",
    bind: "Mit {{address}} verkn\xfcpfen",
    bind_and_continue: "Verkn\xfcpfen und weiter",
    back: "Gehe zur\xfcck",
    nav_back: "Zur\xfcck",
    nav_skip: "\xdcberspringen",
    agree: "Zustimmen",
    got_it: "Alles klar",
    sign_in_with: "Mit {{name}} anmelden",
    forgot_password: "Passwort vergessen?",
    switch_to: "Zu {{method}} wechseln",
    sign_in_via_passcode: "Mit Best\xe4tigungscode anmelden",
    sign_in_via_password: "Mit Passwort anmelden",
    change: "{{method}} \xe4ndern",
    link_another_email: "Andere Email verkn\xfcpfen",
    link_another_phone: "Andere Telefonnummer verkn\xfcpfen",
    link_another_email_or_phone: "Andere Email oder Telefonnummer verkn\xfcpfen",
    show_password: "Passwort anzeigen",
    copy: "Kopieren",
    verify_via_passkey: "\xdcberpr\xfcfen \xfcber Passkey",
    download: "Herunterladen",
    single_sign_on: "Single Sign-On",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $f9b30a5e52cfb578$export$2e2bcd8739ae039 = Object.freeze($f9b30a5e52cfb578$var$action);


var $d6f1a2bb1a3d18d8$var$description = {
    email: "Email",
    phone_number: "Telefonnummer",
    username: "Benutzername",
    reminder: "Erinnerung",
    not_found: "404 Nicht gefunden",
    agree_with_terms: "Ich akzeptiere die ",
    agree_with_terms_modal: "Bitte akzeptiere die <link></link>.",
    terms_of_use: "Nutzungsbedingungen",
    sign_in: "Anmelden",
    privacy_policy: "Datenschutzrichtlinien",
    create_account: "Konto erstellen",
    or: "oder",
    and: "und",
    enter_passcode: "Der Best\xe4tigungscode wurde an deine {{address}} gesendet",
    passcode_sent: "Der Best\xe4tigungscode wurde erneut gesendet",
    resend_after_seconds: "Nach <span>{{seconds}}</span> Sekunden erneut senden",
    resend_passcode: "Best\xe4tigungscode erneut senden",
    create_account_id_exists: "Das Konto mit {{type}} {{value}} existiert bereits, m\xf6chtest du dich anmelden?",
    link_account_id_exists: "Das Konto mit {{type}} {{value}} existiert bereits, m\xf6chtest du es mit deinem Konto verkn\xfcpfen?",
    sign_in_id_does_not_exist: "Das Konto mit {{type}} {{value}} existiert nicht, m\xf6chtest du ein neues Konto erstellen?",
    sign_in_id_does_not_exist_alert: "Das Konto mit {{type}} {{value}} existiert nicht",
    create_account_id_exists_alert: "Das Konto mit {{type}} {{value}} ist mit einem anderen Konto verkn\xfcpft. Bitte versuche es mit einem anderen {{type}} erneut",
    social_identity_exist: "{{type}} {{value}} ist mit einem anderen Konto verkn\xfcpft. Bitte versuche ein(e(n)) andere(n/s) {{type}}",
    bind_account_title: "Verlinke oder erstelle ein Konto",
    social_create_account: "Sie k\xf6nnen ein neues Konto erstellen.",
    social_link_email: "Du kannst eine weitere Email verkn\xfcpfen",
    social_link_phone: "Du kannst eine weitere Telefonnummer verkn\xfcpfen",
    social_link_email_or_phone: "Du kannst eine weitere Email oder Telefonnummer verkn\xfcpfen",
    social_bind_with_existing: "Wir haben ein verwandtes Konto gefunden, du kannst es direkt verkn\xfcpfen.",
    reset_password: "Passwort vergessen",
    reset_password_description: "Gib die {{types, list(type: disjunction;)}} deines Kontos ein und wir senden dir einen Best\xe4tigungscode um dein Passwort zur\xfcckzusetzen.",
    new_password: "Neues Passwort",
    set_password: "Passwort setzen",
    password_changed: "Passwort ge\xe4ndert",
    no_account: "Noch kein Konto? ",
    have_account: "Hast du schon ein Konto?",
    enter_password: "Passwort eingeben",
    enter_password_for: "Passwort f\xfcr {{method}} {{value}} eingeben",
    enter_username: "Benutzernamen festlegen",
    enter_username_description: "Der Benutzername kann f\xfcr die Anmeldung verwendet werden. Der Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten.",
    link_email: "Email verkn\xfcpfen",
    link_phone: "Telefonnummer verkn\xfcpfen",
    link_email_or_phone: "Email oder Telefonnummer verkn\xfcpfen",
    link_email_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Email mit dem Konto.",
    link_phone_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Telefonnummer mit dem Konto.",
    link_email_or_phone_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Email oder Telefonnummer mit dem Konto.",
    continue_with_more_information: "F\xfcr zus\xe4tzliche Sicherheit, vervollst\xe4ndige bitte deine Informationen.",
    create_your_account: "Erstelle dein Konto",
    sign_in_to_your_account: "Melde dich in deinem Konto an",
    no_region_code_found: "Kein Regionencode gefunden",
    verify_email: "Best\xe4tige deine E-Mail-Adresse",
    verify_phone: "Best\xe4tige deine Telefonnummer",
    password_requirements: "Passwort {{items, list}}.",
    password_requirement: {
        length_one: "erfordert mindestens {{count}} Zeichen",
        length_other: "erfordert mindestens {{count}} Zeichen",
        character_types_one: "sollte mindestens {{count}} Kategorie der folgenden Zeichenarten enthalten: Gro\xdfbuchstaben, Kleinbuchstaben, Zahlen und Symbole",
        character_types_other: "sollte mindestens {{count}} Kategorien der folgenden Zeichenarten enthalten: Gro\xdfbuchstaben, Kleinbuchstaben, Zahlen und Symbole"
    },
    use: "Verwenden",
    single_sign_on_email_form: "Gib deine Unternehmens-E-Mail-Adresse ein.",
    single_sign_on_connectors_list: "Ihr Unternehmen hat Single Sign-On f\xfcr das E-Mail-Konto {{email}} aktiviert. Sie k\xf6nnen sich weiterhin mit den folgenden SSO-Anbietern anmelden.",
    single_sign_on_enabled: "Single Sign-On ist f\xfcr dieses Konto aktiviert",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $d6f1a2bb1a3d18d8$export$2e2bcd8739ae039 = Object.freeze($d6f1a2bb1a3d18d8$var$description);


var $8a014c4be70a3a31$var$development_tenant = {
    notification: "Du befindest dich im Entwicklungsmodus"
};
var $8a014c4be70a3a31$export$2e2bcd8739ae039 = Object.freeze($8a014c4be70a3a31$var$development_tenant);


var $23e4c4417f585fa5$var$password_rejected = {
    too_short: "Die minimale L\xe4nge betr\xe4gt {{min}}.",
    too_long: "Die maximale L\xe4nge betr\xe4gt {{max}}.",
    character_types: "Mindestens {{min}} Arten von Zeichen sind erforderlich.",
    unsupported_characters: "Nicht unterst\xfctztes Zeichen gefunden.",
    pwned: "Verwenden Sie keine einfachen Passw\xf6rter, die leicht zu erraten sind.",
    restricted_found: "Vermeiden Sie \xfcberm\xe4\xdfigen Gebrauch von {{list, list}}.",
    restricted: {
        repetition: "wiederholte Zeichen",
        sequence: "sequenzielle Zeichen",
        user_info: "Ihre pers\xf6nlichen Informationen",
        words: "Produktkontext"
    }
};
var $23e4c4417f585fa5$export$2e2bcd8739ae039 = Object.freeze($23e4c4417f585fa5$var$password_rejected);


var $7749aa696c3372f8$var$error = {
    general_required: "{{types, list(type: disjunction;)}} ist erforderlich",
    general_invalid: "Die {{types, list(type: disjunction;)}} is ung\xfcltig",
    username_required: "Benutzername ist erforderlich",
    password_required: "Passwort ist erforderlich",
    username_exists: "Benutzername existiert bereits",
    username_should_not_start_with_number: "Benutzername darf nicht mit einer Zahl beginnen",
    username_invalid_charset: "Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten",
    invalid_email: "Die Email ist ung\xfcltig",
    invalid_phone: "Die Telefonnummer ist ung\xfcltig",
    passwords_do_not_match: "Passw\xf6rter stimmen nicht \xfcberein",
    invalid_passcode: "Der Best\xe4tigungscode ist ung\xfcltig",
    invalid_connector_auth: "Die Autorisierung ist ung\xfcltig",
    invalid_connector_request: "Connector Daten sind ung\xfcltig",
    unknown: "Unbekannter Fehler. Versuche es sp\xe4ter noch einmal.",
    invalid_session: "Die Sitzung ist ung\xfcltig. Bitte melde dich erneut an.",
    timeout: "Zeit\xfcberschreitung. Bitte melde dich erneut an.",
    password_rejected: (0, $23e4c4417f585fa5$export$2e2bcd8739ae039),
    sso_not_enabled: "Single Sign-On ist f\xfcr dieses E-Mail-Konto nicht aktiviert."
};
var $7749aa696c3372f8$export$2e2bcd8739ae039 = Object.freeze($7749aa696c3372f8$var$error);


var $0abe3357c2feaf8b$var$input = {
    username: "Benutzername",
    password: "Passwort",
    email: "Email",
    phone_number: "Telefonnummer",
    confirm_password: "Passwort best\xe4tigen",
    search_region_code: "Suche region code",
    backup_code: "Backup-Code"
};
var $0abe3357c2feaf8b$export$2e2bcd8739ae039 = Object.freeze($0abe3357c2feaf8b$var$input);


var $a67f741bdb38b19a$var$list = {
    or: "oder",
    and: "und",
    separator: ","
};
var $a67f741bdb38b19a$export$2e2bcd8739ae039 = Object.freeze($a67f741bdb38b19a$var$list);


var $fd3fef02d68635a3$var$mfa = {
    totp: "Authenticator-App-OTP",
    webauthn: "Passkey",
    backup_code: "Backup-Code",
    link_totp_description: "z.B. Google Authenticator usw.",
    link_webauthn_description: "Verkn\xfcpfen Sie Ihr Ger\xe4t oder USB-Hardware",
    link_backup_code_description: "Backup-Code generieren",
    verify_totp_description: "Geben Sie den Einmalcode in der App ein",
    verify_webauthn_description: "Verifizieren Sie Ihr Ger\xe4t oder Ihre USB-Hardware",
    verify_backup_code_description: "F\xfcgen Sie den gespeicherten Backup-Code ein",
    add_mfa_factors: "2-Schritte-Verifizierung hinzuf\xfcgen",
    add_mfa_description: "Die Zwei-Faktor-Verifizierung ist aktiviert. W\xe4hlen Sie Ihre zweite Verifizierungsmethode f\xfcr sicheres Anmelden aus.",
    verify_mfa_factors: "2-Schritte-Verifizierung",
    verify_mfa_description: "Die 2-Schritte-Verifizierung ist f\xfcr dieses Konto aktiviert. Bitte w\xe4hlen Sie die zweite Methode zur Verifizierung Ihrer Identit\xe4t aus.",
    add_authenticator_app: "Authenticator-App hinzuf\xfcgen",
    step: "Schritt {{step, number}}: {{content}}",
    scan_qr_code: "Scannen Sie diesen QR-Code",
    scan_qr_code_description: "Scannen Sie den folgenden QR-Code mit Ihrer Authenticator-App, wie z.B. Google Authenticator, Duo Mobile, Authy usw.",
    qr_code_not_available: "Kann den QR-Code nicht scannen?",
    copy_and_paste_key: "Schl\xfcssel kopieren und einf\xfcgen",
    copy_and_paste_key_description: "Kopieren Sie den folgenden Schl\xfcssel und f\xfcgen Sie ihn in Ihre Authenticator-App ein, wie z.B. Google Authenticator, Duo Mobile, Authy usw.",
    want_to_scan_qr_code: "M\xf6chten Sie den QR-Code scannen?",
    enter_one_time_code: "Einmalcode eingeben",
    enter_one_time_code_link_description: "Geben Sie den 6-stelligen Verifizierungscode ein, der von der Authenticator-App generiert wurde.",
    enter_one_time_code_description: "F\xfcr dieses Konto wurde die Zwei-Faktor-Authentifizierung aktiviert. Bitte geben Sie den einmaligen Code ein, der in Ihrer verkn\xfcpften Authentifizierungs-App angezeigt wird.",
    link_another_mfa_factor: "Zu einer anderen Methode wechseln",
    save_backup_code: "Backup-Code speichern",
    save_backup_code_description: "Sie k\xf6nnen einen dieser Backup-Codes verwenden, um auf Ihr Konto zuzugreifen, wenn Sie w\xe4hrend der 2-Schritte-Verifizierung auf andere Weise Probleme haben. Jeder Code kann nur einmal verwendet werden.",
    backup_code_hint: "Stellen Sie sicher, dass Sie sie kopieren und an einem sicheren Ort speichern.",
    enter_a_backup_code: "Backup-Code eingeben",
    enter_backup_code_description: "Geben Sie den Backup-Code ein, den Sie gespeichert haben, als die 2-Schritte-Verifizierung initial aktiviert wurde.",
    create_a_passkey: "Passkey erstellen",
    create_passkey_description: "Registrieren Sie Ihren Passkey mit biometrischen Daten, Sicherheitsschl\xfcsseln (z.B. YubiKey) oder anderen verf\xfcgbaren Methoden.",
    try_another_verification_method: "Versuchen Sie eine andere Methode zur Verifizierung",
    verify_via_passkey: "\xdcber Passkey verifizieren",
    verify_via_passkey_description: "Verwenden Sie den Passkey zur Verifizierung durch Ihr Ger\xe4tepasswort oder Biometrie, zum Scannen des QR-Codes oder zum Verwenden eines USB-Sicherheitsschl\xfcssels wie YubiKey.",
    secret_key_copied: "Geheimer Schl\xfcssel kopiert.",
    backup_code_copied: "Backup-Code kopiert.",
    webauthn_not_ready: "WebAuthn ist noch nicht bereit. Bitte versuchen Sie es sp\xe4ter erneut.",
    webauthn_not_supported: "WebAuthn wird in diesem Browser nicht unterst\xfctzt.",
    webauthn_failed_to_create: "Erstellung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    webauthn_failed_to_verify: "Verifizierung fehlgeschlagen. Bitte versuchen Sie es erneut."
};
var $fd3fef02d68635a3$export$2e2bcd8739ae039 = Object.freeze($fd3fef02d68635a3$var$mfa);


var $b20a30f7d7cd7a8c$var$secondary = {
    social_bind_with: "Besitzt du schon ein Konto? Melde dich an, um {{methods, list(type: disjunction;)}} mit deiner Identit\xe4t zu verbinden."
};
var $b20a30f7d7cd7a8c$export$2e2bcd8739ae039 = Object.freeze($b20a30f7d7cd7a8c$var$secondary);


var $6d7fd11520b48c3c$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $6d7fd11520b48c3c$export$2e2bcd8739ae039 = Object.freeze($6d7fd11520b48c3c$var$user_scopes);


var $0d29a8fb74ca77ba$var$de = {
    translation: {
        input: (0, $0abe3357c2feaf8b$export$2e2bcd8739ae039),
        secondary: (0, $b20a30f7d7cd7a8c$export$2e2bcd8739ae039),
        action: (0, $f9b30a5e52cfb578$export$2e2bcd8739ae039),
        description: (0, $d6f1a2bb1a3d18d8$export$2e2bcd8739ae039),
        error: (0, $7749aa696c3372f8$export$2e2bcd8739ae039),
        list: (0, $a67f741bdb38b19a$export$2e2bcd8739ae039),
        mfa: (0, $fd3fef02d68635a3$export$2e2bcd8739ae039),
        development_tenant: (0, $8a014c4be70a3a31$export$2e2bcd8739ae039),
        user_scopes: (0, $6d7fd11520b48c3c$export$2e2bcd8739ae039)
    }
};
var $0d29a8fb74ca77ba$export$2e2bcd8739ae039 = Object.freeze($0d29a8fb74ca77ba$var$de);


var $eb23177d0fb19d77$var$action = {
    sign_in: "Sign in",
    continue: "Continue",
    create_account: "Create account",
    create_account_without_linking: "Create account without linking",
    create: "Create",
    enter_passcode: "Enter verification code",
    confirm: "Confirm",
    cancel: "Cancel",
    save_password: "Save password",
    bind: "Link with {{address}}",
    bind_and_continue: "Link and continue",
    back: "Go back",
    nav_back: "Back",
    nav_skip: "Skip",
    agree: "Agree",
    got_it: "Got it",
    sign_in_with: "Continue with {{name}}",
    forgot_password: "Forgot your password?",
    switch_to: "Switch to {{method}}",
    sign_in_via_passcode: "Sign in with verification code",
    sign_in_via_password: "Sign in with password",
    change: "Change {{method}}",
    link_another_email: "Link another email",
    link_another_phone: "Link another phone",
    link_another_email_or_phone: "Link another email or phone",
    show_password: "Show password",
    copy: "Copy",
    verify_via_passkey: "Verify via passkey",
    download: "Download",
    single_sign_on: "Single Sign-On",
    authorize: "Authorize",
    use_another_account: "Use another account"
};
var $eb23177d0fb19d77$export$2e2bcd8739ae039 = Object.freeze($eb23177d0fb19d77$var$action);


var $1802ee656b432451$var$description = {
    email: "email",
    phone_number: "phone number",
    username: "username",
    reminder: "Reminder",
    not_found: "404 Not Found",
    agree_with_terms: "I have read and agree to the ",
    agree_with_terms_modal: "To proceed, please agree to the <link></link>.",
    terms_of_use: "Terms of Use",
    sign_in: "Sign in",
    privacy_policy: "Privacy Policy",
    create_account: "Create account",
    or: "or",
    and: "and",
    enter_passcode: "The verification code has been sent to your {{address}} {{target}}",
    passcode_sent: "The verification code has been resent",
    resend_after_seconds: "Resend after <span>{{seconds}}</span> seconds",
    resend_passcode: "Resend verification code",
    create_account_id_exists: "The account with {{type}} {{value}} already exists, would you like to sign in?",
    link_account_id_exists: "The account with {{type}} {{value}} already exists. Would you like to link?",
    sign_in_id_does_not_exist: "The account with {{type}} {{value}} does not exist, would you like to create a new account?",
    sign_in_id_does_not_exist_alert: "The account with {{type}} {{value}} does not exist.",
    create_account_id_exists_alert: "The account with {{type}} {{value}} is linked to another account. Please try another {{type}}.",
    social_identity_exist: "The {{type}} {{value}} is linked to another account. Please try another {{type}}.",
    bind_account_title: "Link or create account",
    social_create_account: "You can create a new account.",
    social_link_email: "You can link another email",
    social_link_phone: "You can link another phone",
    social_link_email_or_phone: "You can link another email or phone",
    social_bind_with_existing: "We find a related account, you can link it directly.",
    reset_password: "Reset password",
    reset_password_description: "Enter the {{types, list(type: disjunction;)}} associated with your account, and we’ll send you the verification code to reset your password.",
    new_password: "New password",
    set_password: "Set password",
    password_changed: "Password changed",
    no_account: "No account yet? ",
    have_account: "Already had an account?",
    enter_password: "Enter password",
    enter_password_for: "Sign in with the password to {{method}} {{value}}",
    enter_username: "Set username",
    enter_username_description: "Username is an alternative for sign-in. Username should contain only letters, numbers, and underscores.",
    link_email: "Link email",
    link_phone: "Link phone",
    link_email_or_phone: "Link email or phone",
    link_email_description: "For added security, please link your email with the account.",
    link_phone_description: "For added security, please link your phone with the account.",
    link_email_or_phone_description: "For added security, please link your email or phone with the account.",
    continue_with_more_information: "For added security, please complete below account details.",
    create_your_account: "Create your account",
    sign_in_to_your_account: "Sign in to your account",
    no_region_code_found: "No region code found",
    verify_email: "Verify your email",
    verify_phone: "Verify your phone number",
    password_requirements: "Password {{items, list}}.",
    password_requirement: {
        length_one: "requires a minimum of {{count}} character",
        length_other: "requires a minimum of {{count}} characters",
        character_types_one: "should contain at least {{count}} type of uppercase letters, lowercase letters, digits, and symbols",
        character_types_other: "should contain at least {{count}} types of uppercase letters, lowercase letters, digits, and symbols"
    },
    use: "Use",
    single_sign_on_email_form: "Enter your enterprise email address",
    single_sign_on_connectors_list: "Your enterprise has enabled Single Sign-On for the email account {{email}}. You can continue to sign in with the following SSO providers.",
    single_sign_on_enabled: "Single Sign-On is enabled for this account",
    authorize_title: "Authorize {{name}}",
    request_permission: "{{name}} is requesting access to:",
    grant_organization_access: "Grant the organization access:",
    authorize_personal_data_usage: "Authorize the use of your personal data:",
    authorize_organization_access: "Authorize access to the specific organization:",
    user_scopes: "Personal user data",
    organization_scopes: "Organization access",
    authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    not_you: "Not you?",
    user_id: "User ID: {{id}}",
    redirect_to: "You will be redirected to {{name}}."
};
var $1802ee656b432451$export$2e2bcd8739ae039 = Object.freeze($1802ee656b432451$var$description);


var $77862d9d288165c4$var$development_tenant = {
    notification: "You're in development mode"
};
var $77862d9d288165c4$export$2e2bcd8739ae039 = Object.freeze($77862d9d288165c4$var$development_tenant);


var $29080675e8229368$var$password_rejected = {
    too_short: "Minimum length is {{min}}.",
    too_long: "Maximum length is {{max}}.",
    character_types: "At least {{min}} types of characters are required.",
    unsupported_characters: "Unsupported character found.",
    pwned: "Avoid using simple passwords that are easy to guess.",
    restricted_found: "Avoid overusing {{list, list}}.",
    restricted: {
        repetition: "repeated characters",
        sequence: "sequential characters",
        user_info: "your personal information",
        words: "product context"
    }
};
var $29080675e8229368$export$2e2bcd8739ae039 = Object.freeze($29080675e8229368$var$password_rejected);


var $3a7f92c467bc8845$var$error = {
    general_required: "{{types, list(type: disjunction;)}} is required",
    general_invalid: "The {{types, list(type: disjunction;)}} is invalid",
    username_required: "Username is required",
    password_required: "Password is required",
    username_exists: "Username already exists",
    username_should_not_start_with_number: "Username should not start with a number",
    username_invalid_charset: "Username should only contain letters, numbers, or underscores.",
    invalid_email: "The email is invalid",
    invalid_phone: "The phone number is invalid",
    passwords_do_not_match: "Your passwords don’t match. Please try again.",
    invalid_passcode: "The verification code is invalid",
    invalid_connector_auth: "The authorization is invalid",
    invalid_connector_request: "The connector data is invalid",
    unknown: "Unknown error. Please try again later.",
    invalid_session: "Session not found. Please go back and sign in again.",
    timeout: "Request timeout. Please try again later.",
    password_rejected: (0, $29080675e8229368$export$2e2bcd8739ae039),
    sso_not_enabled: "Single Sign-On is not enabled for this email account."
};
var $3a7f92c467bc8845$export$2e2bcd8739ae039 = Object.freeze($3a7f92c467bc8845$var$error);


var $a037a355be6774ed$var$input = {
    username: "Username",
    password: "Password",
    email: "Email",
    phone_number: "Phone number",
    confirm_password: "Confirm password",
    search_region_code: "Search region code",
    backup_code: "Backup code"
};
var $a037a355be6774ed$export$2e2bcd8739ae039 = Object.freeze($a037a355be6774ed$var$input);


var $b2822d839ad08259$var$list = {
    or: "or",
    and: "and",
    separator: ","
};
var $b2822d839ad08259$export$2e2bcd8739ae039 = Object.freeze($b2822d839ad08259$var$list);


var $4781691bef21b1ee$var$mfa = {
    totp: "Authenticator app OTP",
    webauthn: "Passkey",
    backup_code: "Backup code",
    link_totp_description: "E.g., Google Authenticator, etc.",
    link_webauthn_description: "Link your device or USB hardware",
    link_backup_code_description: "Generate a backup code",
    verify_totp_description: "Enter the one-time code in app",
    verify_webauthn_description: "Verify your device or USB hardware",
    verify_backup_code_description: "Paste the backup code you saved",
    add_mfa_factors: "Add 2-step verification",
    add_mfa_description: "Two-factor verification is enabled. Select your second verification method for secure sign-in.",
    verify_mfa_factors: "2-step verification",
    verify_mfa_description: "2-step verification has been enabled for this account. Please select the second way to verify your identity.",
    add_authenticator_app: "Add authenticator app",
    step: "Step {{step, number}}: {{content}}",
    scan_qr_code: "Scan this QR code",
    scan_qr_code_description: "Scan the following QR code with your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "Can’t scan the QR code?",
    copy_and_paste_key: "Copy and paste the key",
    copy_and_paste_key_description: "Copy and paste the following key into your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Want to scan QR code?",
    enter_one_time_code: "Enter the one-time code",
    enter_one_time_code_link_description: "Enter the 6-digit verification code generated by the authenticator app.",
    enter_one_time_code_description: "2-step verification has been enabled for this account. Please enter the one-time code shown on your linked authenticator app.",
    link_another_mfa_factor: "Switch to another method",
    save_backup_code: "Save your backup code",
    save_backup_code_description: "You can use one of these backup code to access your account if you have trouble during 2-step verification in another ways. Each code may be used only once.",
    backup_code_hint: "Make sure copy them and save in a safe place.",
    enter_a_backup_code: "Enter a backup code",
    enter_backup_code_description: "Enter the backup code you saved when the 2-step verification was initially enabled.",
    create_a_passkey: "Create a passkey",
    create_passkey_description: "Register your passkey using device biometrics, security keys (e.g., YubiKey), or other available methods.",
    try_another_verification_method: "Try another method to verify",
    verify_via_passkey: "Verify via passkey",
    verify_via_passkey_description: "Use passkey to verify by your device password or biometrics, scanning QR code, or using USB security key like YubiKey.",
    secret_key_copied: "Secret key copied.",
    backup_code_copied: "Backup code copied.",
    webauthn_not_ready: "WebAuthn is not ready yet. Please try again later.",
    webauthn_not_supported: "WebAuthn is not supported in this browser.",
    webauthn_failed_to_create: "Failed to create. Please try again.",
    webauthn_failed_to_verify: "Failed to verify. Please try again."
};
var $4781691bef21b1ee$export$2e2bcd8739ae039 = Object.freeze($4781691bef21b1ee$var$mfa);


var $5ff8ec9a9e595f66$var$secondary = {
    social_bind_with: "Already had an account? Sign in to link {{methods, list(type: disjunction;)}} with your social identity."
};
var $5ff8ec9a9e595f66$export$2e2bcd8739ae039 = Object.freeze($5ff8ec9a9e595f66$var$secondary);


var $b85afe7642a09a6a$var$user_scopes = {
    descriptions: {
        custom_data: "Your custom data",
        email: "Your email address",
        phone: "Your phone number",
        profile: "Your name, username, avatar, and other profile info",
        roles: "Your roles",
        identities: "Your linked social identities",
        "urn:logto:scope:organizations": "Your organizations info",
        "urn:logto:scope:organization_roles": "Your organization roles",
        address: "Your address"
    }
};
var $b85afe7642a09a6a$export$2e2bcd8739ae039 = Object.freeze($b85afe7642a09a6a$var$user_scopes);


var $f5f0e5a7776a996a$var$en = {
    translation: {
        input: (0, $a037a355be6774ed$export$2e2bcd8739ae039),
        secondary: (0, $5ff8ec9a9e595f66$export$2e2bcd8739ae039),
        action: (0, $eb23177d0fb19d77$export$2e2bcd8739ae039),
        description: (0, $1802ee656b432451$export$2e2bcd8739ae039),
        error: (0, $3a7f92c467bc8845$export$2e2bcd8739ae039),
        list: (0, $b2822d839ad08259$export$2e2bcd8739ae039),
        mfa: (0, $4781691bef21b1ee$export$2e2bcd8739ae039),
        development_tenant: (0, $77862d9d288165c4$export$2e2bcd8739ae039),
        user_scopes: (0, $b85afe7642a09a6a$export$2e2bcd8739ae039)
    }
};
var $f5f0e5a7776a996a$export$2e2bcd8739ae039 = Object.freeze($f5f0e5a7776a996a$var$en);


var $56b4e8647e37e936$var$action = {
    sign_in: "Iniciar sesi\xf3n",
    continue: "Continuar",
    create_account: "Crear una cuenta",
    create_account_without_linking: "Crear una cuenta sin vinculaci\xf3n",
    create: "Crear",
    enter_passcode: "Ingresar c\xf3digo de verificaci\xf3n",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Guardar contrase\xf1a",
    bind: "Vincular con {{address}}",
    bind_and_continue: "Vincular y continuar",
    back: "Regresar",
    nav_back: "Atr\xe1s",
    nav_skip: "Omitir",
    agree: "Aceptar",
    got_it: "Entendido",
    sign_in_with: "Continuar con {{name}}",
    forgot_password: "\xbfOlvidaste tu contrase\xf1a?",
    switch_to: "Cambiar a {{method}}",
    sign_in_via_passcode: "Iniciar sesi\xf3n con c\xf3digo de verificaci\xf3n",
    sign_in_via_password: "Iniciar sesi\xf3n con contrase\xf1a",
    change: "Cambiar {{method}}",
    link_another_email: "Vincular otro correo electr\xf3nico",
    link_another_phone: "Vincular otro n\xfamero de tel\xe9fono",
    link_another_email_or_phone: "Vincular otro correo electr\xf3nico o n\xfamero de tel\xe9fono",
    show_password: "Mostrar contrase\xf1a",
    copy: "Copiar",
    verify_via_passkey: "Verificar mediante clave de acceso",
    download: "Descargar",
    single_sign_on: "Inicio de sesi\xf3n \xfanico",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $56b4e8647e37e936$export$2e2bcd8739ae039 = Object.freeze($56b4e8647e37e936$var$action);


var $7ba0fe0b0633099c$var$description = {
    email: "correo electr\xf3nico",
    phone_number: "n\xfamero de tel\xe9fono",
    username: "nombre de usuario",
    reminder: "Recordatorio",
    not_found: "404 No encontrado",
    agree_with_terms: "He le\xeddo y acepto los ",
    agree_with_terms_modal: "Para continuar, por favor acepte los <link></link>.",
    terms_of_use: "T\xe9rminos de uso",
    sign_in: "Iniciar sesi\xf3n",
    privacy_policy: "Pol\xedtica de privacidad",
    create_account: "Crear cuenta",
    or: "o",
    and: "y",
    enter_passcode: "El c\xf3digo de verificaci\xf3n ha sido enviado a su {{address}} {{target}}",
    passcode_sent: "El c\xf3digo de verificaci\xf3n ha sido reenviado",
    resend_after_seconds: "Reenviar despu\xe9s de <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verificaci\xf3n",
    create_account_id_exists: "La cuenta con {{type}} {{value}} ya existe, \xbfdesea iniciar sesi\xf3n?",
    link_account_id_exists: "La cuenta con {{type}} {{value}} ya existe. \xbfDesea vincular?",
    sign_in_id_does_not_exist: "La cuenta con {{type}} {{value}} no existe, \xbfdesea crear una nueva cuenta?",
    sign_in_id_does_not_exist_alert: "La cuenta con {{type}} {{value}} no existe.",
    create_account_id_exists_alert: "La cuenta con {{type}} {{value}} est\xe1 vinculada a otra cuenta. Por favor intente con otra {{type}}.",
    social_identity_exist: "La {{type}} {{value}} est\xe1 vinculada a otra cuenta. Por favor intente con otra {{type}}.",
    bind_account_title: "Vincular o crear cuenta",
    social_create_account: "Puede crear una nueva cuenta.",
    social_link_email: "Puede vincular otro correo electr\xf3nico",
    social_link_phone: "Puede vincular otro tel\xe9fono",
    social_link_email_or_phone: "Puede vincular otro correo electr\xf3nico o tel\xe9fono",
    social_bind_with_existing: "Hemos encontrado una cuenta relacionada, puede vincularla directamente.",
    reset_password: "Restablecer contrase\xf1a",
    reset_password_description: "Ingrese los {{types, lista(type: disyunci\xf3n;)}} asociados a su cuenta, y le enviaremos el c\xf3digo de verificaci\xf3n para restablecer su contrase\xf1a.",
    new_password: "Nueva contrase\xf1a",
    set_password: "Establecer contrase\xf1a",
    password_changed: "Contrase\xf1a cambiada",
    no_account: "\xbfNo tiene una cuenta todav\xeda? ",
    have_account: "\xbfYa tiene una cuenta?",
    enter_password: "Ingrese la contrase\xf1a",
    enter_password_for: "Inicie sesi\xf3n con la contrase\xf1a de {{method}} {{value}}",
    enter_username: "Establecer nombre de usuario",
    enter_username_description: "El nombre de usuario es una alternativa para iniciar sesi\xf3n. Debe contener solo letras, n\xfameros y guiones bajos.",
    link_email: "Vincular correo electr\xf3nico",
    link_phone: "Vincular tel\xe9fono",
    link_email_or_phone: "Vincular correo electr\xf3nico o tel\xe9fono",
    link_email_description: "Para mayor seguridad, por favor vincule su correo electr\xf3nico con la cuenta.",
    link_phone_description: "Para mayor seguridad, por favor vincule su tel\xe9fono con la cuenta.",
    link_email_or_phone_description: "Para mayor seguridad, por favor vincule su correo electr\xf3nico o tel\xe9fono con la cuenta.",
    continue_with_more_information: "Para mayor seguridad, por favor complete los detalles de su cuenta a continuaci\xf3n.",
    create_your_account: "Cree su cuenta",
    sign_in_to_your_account: "Inicie sesi\xf3n en su cuenta",
    no_region_code_found: "No se encontr\xf3 c\xf3digo de regi\xf3n",
    verify_email: "Verificar su correo electr\xf3nico",
    verify_phone: "Verificar su n\xfamero de tel\xe9fono",
    password_requirements: "Contrase\xf1a {{items, lista}}.",
    password_requirement: {
        length_one: "requiere un m\xednimo de {{count}} car\xe1cter",
        length_other: "requiere un m\xednimo de {{count}} caracteres",
        character_types_one: "debe contener al menos {{count}} tipo de letras may\xfasculas, letras min\xfasculas, d\xedgitos y s\xedmbolos",
        character_types_other: "debe contener al menos {{count}} tipos de letras may\xfasculas, letras min\xfasculas, d\xedgitos y s\xedmbolos"
    },
    use: "Usar",
    single_sign_on_email_form: "Ingrese su direcci\xf3n de correo electr\xf3nico corporativo",
    single_sign_on_connectors_list: "Su empresa ha habilitado el inicio de sesi\xf3n \xfanico (Single Sign-On) para la cuenta de correo electr\xf3nico {{email}}. Puede continuar iniciando sesi\xf3n con los siguientes proveedores de SSO.",
    single_sign_on_enabled: "El inicio de sesi\xf3n \xfanico (Single Sign-On) est\xe1 habilitado para esta cuenta",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $7ba0fe0b0633099c$export$2e2bcd8739ae039 = Object.freeze($7ba0fe0b0633099c$var$description);


var $924a109e699100f3$var$development_tenant = {
    notification: "Est\xe1s en modo de desarrollo"
};
var $924a109e699100f3$export$2e2bcd8739ae039 = Object.freeze($924a109e699100f3$var$development_tenant);


var $1ab3e3513a33ec74$var$password_rejected = {
    too_short: "La longitud m\xednima es {{min}}.",
    too_long: "La longitud m\xe1xima es {{max}}.",
    character_types: "Se necesitan al menos {{min}} tipos de caracteres.",
    unsupported_characters: "Se encontr\xf3 un car\xe1cter no admitido.",
    pwned: "Evite usar contrase\xf1as simples que sean f\xe1ciles de adivinar.",
    restricted_found: "Evite utilizar en exceso {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres secuenciales",
        user_info: "su informaci\xf3n personal",
        words: "contexto del producto"
    }
};
var $1ab3e3513a33ec74$export$2e2bcd8739ae039 = Object.freeze($1ab3e3513a33ec74$var$password_rejected);


var $0a229f727bfdc04d$var$error = {
    general_required: "{{types, list(type: disjunction;)}} es requerido",
    general_invalid: "El/La {{types, list(type: disjunction;)}} no es v\xe1lido",
    username_required: "Se requiere un nombre de usuario",
    password_required: "Se requiere una contrase\xf1a",
    username_exists: "El nombre de usuario ya existe",
    username_should_not_start_with_number: "El nombre de usuario no debe comenzar con un n\xfamero",
    username_invalid_charset: "El nombre de usuario solo debe contener letras, n\xfameros o guiones bajos.",
    invalid_email: "El correo electr\xf3nico no es v\xe1lido",
    invalid_phone: "El n\xfamero de tel\xe9fono no es v\xe1lido",
    passwords_do_not_match: "Las contrase\xf1as no coinciden. Por favor intente de nuevo",
    invalid_passcode: "El c\xf3digo de verificaci\xf3n no es v\xe1lido",
    invalid_connector_auth: "La autorizaci\xf3n no es v\xe1lida",
    invalid_connector_request: "Los datos del conector no son v\xe1lidos",
    unknown: "Error desconocido. Por favor intente de nuevo m\xe1s tarde.",
    invalid_session: "No se encontr\xf3 la sesi\xf3n. Por favor regrese e inicie sesi\xf3n nuevamente.",
    timeout: "Tiempo de espera de solicitud agotado. Por favor intente de nuevo m\xe1s tarde.",
    password_rejected: (0, $1ab3e3513a33ec74$export$2e2bcd8739ae039),
    sso_not_enabled: "El inicio de sesi\xf3n \xfanico no est\xe1 habilitado para esta cuenta de correo electr\xf3nico."
};
var $0a229f727bfdc04d$export$2e2bcd8739ae039 = Object.freeze($0a229f727bfdc04d$var$error);


var $a5731f250551f950$var$input = {
    username: "Nombre de usuario",
    password: "Contrase\xf1a",
    email: "Correo electr\xf3nico",
    phone_number: "N\xfamero de tel\xe9fono",
    confirm_password: "Confirmar contrase\xf1a",
    search_region_code: "C\xf3digo de regi\xf3n de b\xfasqueda",
    backup_code: "C\xf3digo de respaldo"
};
var $a5731f250551f950$export$2e2bcd8739ae039 = Object.freeze($a5731f250551f950$var$input);


var $c2e44420bf84d239$var$list = {
    or: "o",
    and: "y",
    separator: ","
};
var $c2e44420bf84d239$export$2e2bcd8739ae039 = Object.freeze($c2e44420bf84d239$var$list);


var $8f39141fad8069da$var$mfa = {
    totp: "OTP de la aplicaci\xf3n autenticadora",
    webauthn: "Contrase\xf1a",
    backup_code: "C\xf3digo de respaldo",
    link_totp_description: "Ej., Google Authenticator, etc.",
    link_webauthn_description: "Vincule su dispositivo o hardware USB",
    link_backup_code_description: "Genere un c\xf3digo de respaldo",
    verify_totp_description: "Ingrese el c\xf3digo de un solo uso en la aplicaci\xf3n",
    verify_webauthn_description: "Verifique su dispositivo o hardware USB",
    verify_backup_code_description: "Pegue el c\xf3digo de respaldo que guard\xf3",
    add_mfa_factors: "Agregar verificaci\xf3n de 2 pasos",
    add_mfa_description: "La verificaci\xf3n de dos factores est\xe1 habilitada. Seleccione su segundo m\xe9todo de verificaci\xf3n para iniciar sesi\xf3n de forma segura.",
    verify_mfa_factors: "Verificaci\xf3n de 2 pasos",
    verify_mfa_description: "La verificaci\xf3n de 2 pasos se ha habilitado para esta cuenta. Seleccione la segunda forma de verificar su identidad.",
    add_authenticator_app: "Agregar aplicaci\xf3n autenticadora",
    step: "Paso {{step, number}}: {{content}}",
    scan_qr_code: "Escanee este c\xf3digo QR",
    scan_qr_code_description: "Escanee el siguiente c\xf3digo QR con su aplicaci\xf3n autenticadora, como Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "\xbfNo puede escanear el c\xf3digo QR?",
    copy_and_paste_key: "Copie y pegue la clave",
    copy_and_paste_key_description: "Copie y pegue la siguiente clave en su aplicaci\xf3n autenticadora, como Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "\xbfQuiere escanear el c\xf3digo QR?",
    enter_one_time_code: "Ingrese el c\xf3digo de un solo uso",
    enter_one_time_code_link_description: "Ingrese el c\xf3digo de verificaci\xf3n de 6 d\xedgitos generado por la aplicaci\xf3n autenticadora.",
    enter_one_time_code_description: "Se ha habilitado la verificaci\xf3n en dos pasos para esta cuenta. Por favor, ingrese el c\xf3digo de un solo uso que se muestra en su aplicaci\xf3n de autenticaci\xf3n vinculada.",
    link_another_mfa_factor: "Cambiar a otro m\xe9todo",
    save_backup_code: "Guarde su c\xf3digo de respaldo",
    save_backup_code_description: "Puede usar uno de estos c\xf3digos de respaldo para acceder a su cuenta si tiene problemas durante la verificaci\xf3n de 2 pasos de otras maneras. Cada c\xf3digo solo se puede usar una vez.",
    backup_code_hint: "Aseg\xfarese de copiarlos y guardarlos en un lugar seguro.",
    enter_a_backup_code: "Ingrese un c\xf3digo de respaldo",
    enter_backup_code_description: "Ingrese el c\xf3digo de respaldo que guard\xf3 cuando se habilit\xf3 la verificaci\xf3n de 2 pasos inicialmente.",
    create_a_passkey: "Crear una contrase\xf1a",
    create_passkey_description: "Registre su contrase\xf1a utilizando la biometr\xeda del dispositivo, claves de seguridad (por ejemplo, YubiKey) u otros m\xe9todos disponibles.",
    try_another_verification_method: "Pruebe otro m\xe9todo de verificaci\xf3n",
    verify_via_passkey: "Verificar mediante contrase\xf1a",
    verify_via_passkey_description: "Use la contrase\xf1a para verificar mediante la contrase\xf1a de su dispositivo o biometr\xeda, escanee el c\xf3digo QR o use una clave de seguridad USB como YubiKey.",
    secret_key_copied: "Clave secreta copiada.",
    backup_code_copied: "C\xf3digo de respaldo copiado.",
    webauthn_not_ready: "WebAuthn a\xfan no est\xe1 listo. Por favor, int\xe9ntelo de nuevo m\xe1s tarde.",
    webauthn_not_supported: "WebAuthn no es compatible con este navegador.",
    webauthn_failed_to_create: "Error al crear. Por favor, int\xe9ntelo de nuevo.",
    webauthn_failed_to_verify: "Error al verificar. Por favor, int\xe9ntelo de nuevo."
};
var $8f39141fad8069da$export$2e2bcd8739ae039 = Object.freeze($8f39141fad8069da$var$mfa);


var $a1df9780309684e5$var$secondary = {
    social_bind_with: "\xbfYa tienes una cuenta? Inicia sesi\xf3n para vincular {{methods, list(type: disjunction;)}} con tu identidad social."
};
var $a1df9780309684e5$export$2e2bcd8739ae039 = Object.freeze($a1df9780309684e5$var$secondary);


var $5c8b01246536625b$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $5c8b01246536625b$export$2e2bcd8739ae039 = Object.freeze($5c8b01246536625b$var$user_scopes);


var $5058dd85111aa6a2$var$es = {
    translation: {
        input: (0, $a5731f250551f950$export$2e2bcd8739ae039),
        secondary: (0, $a1df9780309684e5$export$2e2bcd8739ae039),
        action: (0, $56b4e8647e37e936$export$2e2bcd8739ae039),
        description: (0, $7ba0fe0b0633099c$export$2e2bcd8739ae039),
        error: (0, $0a229f727bfdc04d$export$2e2bcd8739ae039),
        list: (0, $c2e44420bf84d239$export$2e2bcd8739ae039),
        mfa: (0, $8f39141fad8069da$export$2e2bcd8739ae039),
        development_tenant: (0, $924a109e699100f3$export$2e2bcd8739ae039),
        user_scopes: (0, $5c8b01246536625b$export$2e2bcd8739ae039)
    }
};
var $5058dd85111aa6a2$export$2e2bcd8739ae039 = Object.freeze($5058dd85111aa6a2$var$es);


var $dabc2f7b21b052d8$var$action = {
    sign_in: "Connexion",
    continue: "Continuer",
    create_account: "Cr\xe9er un compte",
    create_account_without_linking: "Cr\xe9er un compte sans lier",
    create: "Cr\xe9er",
    enter_passcode: "Entrer le code",
    confirm: "Confirmer",
    cancel: "Annuler",
    save_password: "Enregistrer le mot de passe",
    bind: "Lier avec {{address}}",
    bind_and_continue: "Lier et continuer",
    back: "Aller en arri\xe8re",
    nav_back: "Retour",
    nav_skip: "Passer",
    agree: "Accepter",
    got_it: "Compris",
    sign_in_with: "Continuer avec {{name}}",
    forgot_password: "Mot de passe oubli\xe9?",
    switch_to: "Passer au {{method}}",
    sign_in_via_passcode: "Se connecter avec le code de v\xe9rification",
    sign_in_via_password: "Se connecter avec le mot de passe",
    change: "Changer {{method}}",
    link_another_email: "Lier une autre adresse e-mail",
    link_another_phone: "Lier un autre num\xe9ro de t\xe9l\xe9phone",
    link_another_email_or_phone: "Lier une autre adresse e-mail ou un autre num\xe9ro de t\xe9l\xe9phone",
    show_password: "Afficher le mot de passe",
    copy: "Copier",
    verify_via_passkey: "V\xe9rifier via la cl\xe9 d'acc\xe8s",
    download: "T\xe9l\xe9charger",
    single_sign_on: "Connexion unique",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $dabc2f7b21b052d8$export$2e2bcd8739ae039 = Object.freeze($dabc2f7b21b052d8$var$action);


var $ced0f8d94792474e$var$description = {
    email: "email",
    phone_number: "num\xe9ro de t\xe9l\xe9phone",
    username: "nom d'utilisateur",
    reminder: "Rappel",
    not_found: "404 Non trouv\xe9",
    agree_with_terms: "J'ai lu et accept\xe9 les ",
    agree_with_terms_modal: "Pour continuer, veuillez accepter le <link></link>.",
    terms_of_use: "Conditions d'utilisation",
    sign_in: "Connexion",
    privacy_policy: "Politique de confidentialit\xe9",
    create_account: "Cr\xe9er un compte",
    or: "ou",
    and: "et",
    enter_passcode: "Le code a \xe9t\xe9 envoy\xe9 \xe0 {{address}} {{target}}",
    passcode_sent: "Le code a \xe9t\xe9 renvoy\xe9",
    resend_after_seconds: "Renvoyer apr\xe8s <span>{{seconds}}</span> secondes",
    resend_passcode: "Renvoyer le code",
    create_account_id_exists: "Le compte avec {{type}} {{value}} existe d\xe9j\xe0, voulez-vous vous connecter?",
    link_account_id_exists: "Le compte avec {{type}} {{value}} existe d\xe9j\xe0, voulez-vous le lier?",
    sign_in_id_does_not_exist: "Le compte avec {{type}} {{value}} n'existe pas, voulez-vous cr\xe9er un nouveau compte?",
    sign_in_id_does_not_exist_alert: "Nous ne trouvons aucun compte associ\xe9 \xe0 {{type}} {{value}}.",
    create_account_id_exists_alert: "Le compte avec {{type}} {{value}} est li\xe9 \xe0 un autre compte. Veuillez essayer un autre {{type}}.",
    social_identity_exist: "Le {{type}} {{value}} est li\xe9 \xe0 un autre compte. Veuillez essayer un autre {{type}}.",
    bind_account_title: "Lier ou cr\xe9er un compte",
    social_create_account: "Vous pouvez cr\xe9er un nouveau compte",
    social_link_email: "Vous pouvez lier une autre adresse e-mail",
    social_link_phone: "Vous pouvez lier un autre num\xe9ro de t\xe9l\xe9phone",
    social_link_email_or_phone: "Vous pouvez lier une autre adresse e-mail ou un autre num\xe9ro de t\xe9l\xe9phone",
    social_bind_with_existing: "Nous avons trouv\xe9 un compte associ\xe9, vous pouvez le lier directement.",
    reset_password: "Mot de passe oubli\xe9",
    reset_password_description: "Entrez le {{types, list(type: disjunction;)}} associ\xe9 \xe0 votre compte et nous vous enverrons le code de v\xe9rification pour r\xe9initialiser votre mot de passe.",
    new_password: "Nouveau mot de passe",
    set_password: "D\xe9finir un mot de passe",
    password_changed: "Mot de passe modifi\xe9",
    no_account: "Pas encore de compte? ",
    have_account: "D\xe9j\xe0 un compte?",
    enter_password: "Entrer le mot de passe",
    enter_password_for: "Connectez-vous avec le mot de passe pour {{method}} {{value}}",
    enter_username: "D\xe9finir un nom d'utilisateur",
    enter_username_description: "Le nom d'utilisateur est une alternative pour la connexion. Le nom d'utilisateur doit contenir uniquement des lettres, des chiffres et des underscores.",
    link_email: "Lier l'adresse e-mail",
    link_phone: "Lier le num\xe9ro de t\xe9l\xe9phone",
    link_email_or_phone: "Lier l'adresse e-mail ou le num\xe9ro de t\xe9l\xe9phone",
    link_email_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre adresse e-mail au compte.",
    link_phone_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre num\xe9ro de t\xe9l\xe9phone au compte.",
    link_email_or_phone_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre adresse e-mail ou votre num\xe9ro de t\xe9l\xe9phone au compte.",
    continue_with_more_information: "Pour une s\xe9curit\xe9 accrue, veuillez compl\xe9ter les d\xe9tails du compte ci-dessous.",
    create_your_account: "Cr\xe9er votre compte",
    sign_in_to_your_account: "Connecte-toi \xe0 ton compte",
    no_region_code_found: "Aucun code de r\xe9gion trouv\xe9",
    verify_email: "V\xe9rifiez votre e-mail",
    verify_phone: "V\xe9rifiez votre num\xe9ro de t\xe9l\xe9phone",
    password_requirements: "Mot de passe {{items, list}}.",
    password_requirement: {
        length_one: "doit contenir au minimum {{count}} caract\xe8re",
        length_other: "doit contenir au minimum {{count}} caract\xe8res",
        character_types_one: "doit contenir au moins {{count}} type de lettres majuscules, lettres minuscules, chiffres et symboles",
        character_types_other: "doit contenir au moins {{count}} types de lettres majuscules, lettres minuscules, chiffres et symboles"
    },
    use: "Utiliser",
    single_sign_on_email_form: "Entrez votre adresse e-mail d'entreprise",
    single_sign_on_connectors_list: "Votre entreprise a activ\xe9 la connexion unique (Single Sign-On) pour le compte email {{email}}. Vous pouvez continuer \xe0 vous connecter avec les fournisseurs SSO suivants.",
    single_sign_on_enabled: "La connexion unique (Single Sign-On) est activ\xe9e pour ce compte",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $ced0f8d94792474e$export$2e2bcd8739ae039 = Object.freeze($ced0f8d94792474e$var$description);


var $189f9e7b6f5f3a2c$var$development_tenant = {
    notification: "Vous \xeates en mode d\xe9veloppement"
};
var $189f9e7b6f5f3a2c$export$2e2bcd8739ae039 = Object.freeze($189f9e7b6f5f3a2c$var$development_tenant);


var $406c81e130250784$var$password_rejected = {
    too_short: "La longueur minimale est {{min}}.",
    too_long: "La longueur maximale est {{max}}.",
    character_types: "Au moins {{min}} types de caract\xe8res sont requis.",
    unsupported_characters: "Caract\xe8re non support\xe9 trouv\xe9.",
    pwned: "\xc9vitez d'utiliser des mots de passe simples faciles \xe0 deviner.",
    restricted_found: "\xc9vitez d'utiliser de mani\xe8re excessive {{list, list}}.",
    restricted: {
        repetition: "caract\xe8res r\xe9p\xe9t\xe9s",
        sequence: "caract\xe8res s\xe9quentiels",
        user_info: "vos informations personnelles",
        words: "contexte produit"
    }
};
var $406c81e130250784$export$2e2bcd8739ae039 = Object.freeze($406c81e130250784$var$password_rejected);


var $26cf8586f8f69c79$var$error = {
    general_required: "Le {{types, list(type: disjunction;)}} est requis",
    general_invalid: "Le {{types, list(type: disjunction;)}} n'est pas valide",
    username_required: "Le nom d'utilisateur est requis",
    password_required: "Le mot de passe est requis",
    username_exists: "Ce Nom d'utilisateur existe d\xe9j\xe0",
    username_should_not_start_with_number: "Le nom d'utilisateur ne doit pas commencer par un chiffre",
    username_invalid_charset: "Le nom d'utilisateur ne doit contenir que des lettres, des chiffres ou des caract\xe8res de soulignement.",
    invalid_email: "L'email n'est pas valide",
    invalid_phone: "Le num\xe9ro de t\xe9l\xe9phone n'est pas valide",
    passwords_do_not_match: "Les mots de passe ne correspondent pas",
    invalid_passcode: "Le code est invalide",
    invalid_connector_auth: "L'autorisation n'est pas valide",
    invalid_connector_request: "Les donn\xe9es du connecteur ne sont pas valides",
    unknown: "Erreur inconnue. Veuillez r\xe9essayer plus tard.",
    invalid_session: "Session non trouv\xe9e. Veuillez revenir en arri\xe8re et vous connecter \xe0 nouveau.",
    timeout: "D\xe9lai d'attente de la requ\xeate d\xe9pass\xe9. Veuillez r\xe9essayer plus tard.",
    password_rejected: (0, $406c81e130250784$export$2e2bcd8739ae039),
    sso_not_enabled: "La authentification unique n'est pas activ\xe9e pour ce compte de messagerie."
};
var $26cf8586f8f69c79$export$2e2bcd8739ae039 = Object.freeze($26cf8586f8f69c79$var$error);


var $76c56a460d0a6ff1$var$input = {
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    email: "Email",
    phone_number: "Num\xe9ro de t\xe9l\xe9phone",
    confirm_password: "Confirmer le mot de passe",
    search_region_code: "Rechercher le code de r\xe9gion",
    backup_code: "Code de sauvegarde"
};
var $76c56a460d0a6ff1$export$2e2bcd8739ae039 = Object.freeze($76c56a460d0a6ff1$var$input);


var $e0b2e881b83e0252$var$list = {
    or: "ou",
    and: "et",
    separator: ","
};
var $e0b2e881b83e0252$export$2e2bcd8739ae039 = Object.freeze($e0b2e881b83e0252$var$list);


var $c9cd171aa985e156$var$mfa = {
    totp: "OTP de l'application d'authentification",
    webauthn: "Passkey",
    backup_code: "Code de sauvegarde",
    link_totp_description: "Par exemple, Google Authenticator, etc.",
    link_webauthn_description: "Associez votre appareil ou mat\xe9riel USB",
    link_backup_code_description: "G\xe9n\xe9rez un code de sauvegarde",
    verify_totp_description: "Saisissez le code \xe0 usage unique dans l'application",
    verify_webauthn_description: "V\xe9rifiez votre appareil ou mat\xe9riel USB",
    verify_backup_code_description: "Collez le code de sauvegarde que vous avez enregistr\xe9",
    add_mfa_factors: "Ajouter la v\xe9rification en deux \xe9tapes",
    add_mfa_description: "La v\xe9rification en deux \xe9tapes est activ\xe9e. S\xe9lectionnez votre deuxi\xe8me m\xe9thode de v\xe9rification pour une connexion s\xe9curis\xe9e.",
    verify_mfa_factors: "V\xe9rification en deux \xe9tapes",
    verify_mfa_description: "La v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e pour ce compte. Veuillez s\xe9lectionner la deuxi\xe8me fa\xe7on de v\xe9rifier votre identit\xe9.",
    add_authenticator_app: "Ajouter une application d'authentification",
    step: "\xc9tape {{step, number}} : {{content}}",
    scan_qr_code: "Scannez ce code QR",
    scan_qr_code_description: "Scannez le code QR suivant avec votre application d'authentification, telle que Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "Impossible de scanner le code QR ?",
    copy_and_paste_key: "Copiez et collez la cl\xe9",
    copy_and_paste_key_description: "Copiez et collez la cl\xe9 suivante dans votre application d'authentification, telle que Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Vous voulez scanner le code QR ?",
    enter_one_time_code: "Saisissez le code \xe0 usage unique",
    enter_one_time_code_link_description: "Saisissez le code de v\xe9rification \xe0 6 chiffres g\xe9n\xe9r\xe9 par l'application d'authentification.",
    enter_one_time_code_description: "La v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e pour ce compte. Veuillez entrer le code \xe0 usage unique affich\xe9 sur votre application d'authentification li\xe9e.",
    link_another_mfa_factor: "Passez \xe0 une autre m\xe9thode",
    save_backup_code: "Enregistrez votre code de sauvegarde",
    save_backup_code_description: "Vous pouvez utiliser l'un de ces codes de sauvegarde pour acc\xe9der \xe0 votre compte en cas de probl\xe8me lors de la v\xe9rification en deux \xe9tapes par d'autres moyens. Chaque code ne peut \xeatre utilis\xe9 qu'une fois.",
    backup_code_hint: "Assurez-vous de les copier et de les sauvegarder dans un endroit s\xfbr.",
    enter_a_backup_code: "Saisissez un code de sauvegarde",
    enter_backup_code_description: "Saisissez le code de sauvegarde que vous avez enregistr\xe9 lorsque la v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e initialement.",
    create_a_passkey: "Cr\xe9ez une cl\xe9 d'acc\xe8s",
    create_passkey_description: "Enregistrez votre cl\xe9 d'acc\xe8s \xe0 l'aide de la biom\xe9trie de l'appareil, de cl\xe9s de s\xe9curit\xe9 (par exemple, YubiKey) ou d'autres m\xe9thodes disponibles.",
    try_another_verification_method: "Essayez une autre m\xe9thode de v\xe9rification",
    verify_via_passkey: "V\xe9rifiez via la cl\xe9 d'acc\xe8s",
    verify_via_passkey_description: "Utilisez la cl\xe9 d'acc\xe8s pour v\xe9rifier avec votre mot de passe ou la biom\xe9trie de votre appareil, en scannant le code QR ou en utilisant une cl\xe9 de s\xe9curit\xe9 USB comme la YubiKey.",
    secret_key_copied: "Cl\xe9 secr\xe8te copi\xe9e.",
    backup_code_copied: "Code de sauvegarde copi\xe9.",
    webauthn_not_ready: "WebAuthn n'est pas pr\xeat pour le moment. Veuillez r\xe9essayer plus tard.",
    webauthn_not_supported: "WebAuthn n'est pas pris en charge dans ce navigateur.",
    webauthn_failed_to_create: "\xc9chec de la cr\xe9ation. Veuillez r\xe9essayer.",
    webauthn_failed_to_verify: "\xc9chec de la v\xe9rification. Veuillez r\xe9essayer."
};
var $c9cd171aa985e156$export$2e2bcd8739ae039 = Object.freeze($c9cd171aa985e156$var$mfa);


var $15f26a3518a106ae$var$secondary = {
    social_bind_with: "Vous avez d\xe9j\xe0 un compte? Connectez-vous pour lier {{methods, list(type: disjunction;)}} avec votre identit\xe9 sociale."
};
var $15f26a3518a106ae$export$2e2bcd8739ae039 = Object.freeze($15f26a3518a106ae$var$secondary);


var $145104eaaf466d24$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $145104eaaf466d24$export$2e2bcd8739ae039 = Object.freeze($145104eaaf466d24$var$user_scopes);


var $4ab399efe9571b36$var$fr = {
    translation: {
        input: (0, $76c56a460d0a6ff1$export$2e2bcd8739ae039),
        secondary: (0, $15f26a3518a106ae$export$2e2bcd8739ae039),
        action: (0, $dabc2f7b21b052d8$export$2e2bcd8739ae039),
        description: (0, $ced0f8d94792474e$export$2e2bcd8739ae039),
        error: (0, $26cf8586f8f69c79$export$2e2bcd8739ae039),
        list: (0, $e0b2e881b83e0252$export$2e2bcd8739ae039),
        mfa: (0, $c9cd171aa985e156$export$2e2bcd8739ae039),
        development_tenant: (0, $189f9e7b6f5f3a2c$export$2e2bcd8739ae039),
        user_scopes: (0, $145104eaaf466d24$export$2e2bcd8739ae039)
    }
};
var $4ab399efe9571b36$export$2e2bcd8739ae039 = Object.freeze($4ab399efe9571b36$var$fr);


var $da1b2a885dc7e0b1$var$action = {
    sign_in: "Accedi",
    continue: "Continua",
    create_account: "Crea account",
    create_account_without_linking: "Crea account senza collegare",
    create: "Crea",
    enter_passcode: "Inserisci il codice di verifica",
    confirm: "Conferma",
    cancel: "Annulla",
    save_password: "Salva password",
    bind: "Collega con {{address}}",
    bind_and_continue: "Collega e continua",
    back: "Torna indietro",
    nav_back: "Indietro",
    nav_skip: "Salta",
    agree: "Accetto",
    got_it: "Capito",
    sign_in_with: "Continua con {{name}}",
    forgot_password: "Hai dimenticato la password?",
    switch_to: "Passa a {{method}}",
    sign_in_via_passcode: "Accedi con il codice di verifica",
    sign_in_via_password: "Accedi con la password",
    change: "Cambia {{method}}",
    link_another_email: "Collega un altro indirizzo email",
    link_another_phone: "Collega un altro numero di telefono",
    link_another_email_or_phone: "Collega un altro indirizzo email o numero di telefono",
    show_password: "Mostra password",
    copy: "Copia",
    verify_via_passkey: "Verifica tramite passkey",
    download: "Scarica",
    single_sign_on: "Single Sign-On",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $da1b2a885dc7e0b1$export$2e2bcd8739ae039 = Object.freeze($da1b2a885dc7e0b1$var$action);


var $d88864e7e643ea5a$var$description = {
    email: "email",
    phone_number: "numero di telefono",
    username: "username",
    reminder: "Promemoria",
    not_found: "404 Non trovato",
    agree_with_terms: "Ho letto e accetto i ",
    agree_with_terms_modal: "Per procedere, si prega di accettare i <link></link>.",
    terms_of_use: "Termini di utilizzo",
    sign_in: "Accedi",
    privacy_policy: "Informativa sulla privacy",
    create_account: "Crea account",
    or: "o",
    and: "e",
    enter_passcode: "Il codice di verifica \xe8 stato inviato alla tua {{address}} {{target}}",
    passcode_sent: "Il codice di verifica \xe8 stato inviato di nuovo",
    resend_after_seconds: "Inviare di nuovo dopo <span>{{seconds}}</span> secondi",
    resend_passcode: "Inviare nuovamente il codice di verifica",
    create_account_id_exists: "L'account con {{type}} {{value}} gi\xe0 esiste, vuoi accedere?",
    link_account_id_exists: "L'account con {{type}} {{value}} \xe8 gi\xe0 esistente. Vuoi collegarlo?",
    sign_in_id_does_not_exist: "L'account con {{type}} {{value}} non esiste, vuoi creare un nuovo account?",
    sign_in_id_does_not_exist_alert: "L'account con {{type}} {{value}} non esiste.",
    create_account_id_exists_alert: "L'account {{type}} {{value}} \xe8 collegato ad un altro account. Prova con un altro {{type}}.",
    social_identity_exist: "L'{{type}} {{value}} \xe8 collegato ad un altro account. Prova con un altro {{type}}.",
    bind_account_title: "Collega o crea un account",
    social_create_account: "Puoi creare un nuovo account.",
    social_link_email: "Puoi collegare un'altra email",
    social_link_phone: "Puoi collegare un altro telefono",
    social_link_email_or_phone: "Puoi collegare un'altra email o telefono",
    social_bind_with_existing: "Abbiamo trovato un account correlato, puoi collegarlo direttamente.",
    reset_password: "Resetta la password",
    reset_password_description: "Inserisci il {{types, list(type: disjunction;)}} associato al tuo account, e ti invieremo il codice di verifica per resettare la password.",
    new_password: "Nuova password",
    set_password: "Imposta una password",
    password_changed: "Password cambiata",
    no_account: "Ancora nessun account? ",
    have_account: "Hai gi\xe0 un account?",
    enter_password: "Inserisci la password",
    enter_password_for: "Accedi con la password per {{method}} {{value}}",
    enter_username: "Imposta username",
    enter_username_description: "L'username \xe8 un'alternativa per l'accesso. L'username deve contenere solo lettere, numeri e trattini bassi.",
    link_email: "Collega emails",
    link_phone: "Collega telefono",
    link_email_or_phone: "Collega email o telefono",
    link_email_description: "Per maggiore sicurezza, collega la tua email all'account.",
    link_phone_description: "Per maggiore sicurezza, collega il tuo telefono all'account.",
    link_email_or_phone_description: "Per maggiore sicurezza, collega la tua email o il tuo telefono all'account.",
    continue_with_more_information: "Per maggiore sicurezza, completa i dettagli dell'account qui sotto.",
    create_your_account: "Crea il tuo account",
    sign_in_to_your_account: "Accedi al tuo account",
    no_region_code_found: "Nessun codice di regione trovato",
    verify_email: "Verifica la tua email",
    verify_phone: "Verifica il tuo numero di telefono",
    password_requirements: "Password {{items, list}}.",
    password_requirement: {
        length_one: "richiede almeno {{count}} carattere",
        length_other: "richiede almeno {{count}} caratteri",
        character_types_one: "dovrebbe contenere almeno {{count}} tipo di lettere maiuscole, lettere minuscole, numeri e simboli",
        character_types_other: "dovrebbe contenere almeno {{count}} tipi di lettere maiuscole, lettere minuscole, numeri e simboli"
    },
    use: "Utilizzare",
    single_sign_on_email_form: "Inserisci il tuo indirizzo email aziendale",
    single_sign_on_connectors_list: "La tua azienda ha abilitato il Single Sign-On per l'account email {{email}}. Puoi continuare ad accedere con i seguenti fornitori di SSO.",
    single_sign_on_enabled: "Il Single Sign-On \xe8 abilitato per questo account",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $d88864e7e643ea5a$export$2e2bcd8739ae039 = Object.freeze($d88864e7e643ea5a$var$description);


var $d3d83cf45970b8ff$var$development_tenant = {
    notification: "Sei in modalit\xe0 di sviluppo"
};
var $d3d83cf45970b8ff$export$2e2bcd8739ae039 = Object.freeze($d3d83cf45970b8ff$var$development_tenant);


var $a7afe291a4903781$var$password_rejected = {
    too_short: "La lunghezza minima \xe8 {{min}}.",
    too_long: "La lunghezza massima \xe8 {{max}}.",
    character_types: "Sono richiesti almeno {{min}} tipi di caratteri.",
    unsupported_characters: "Carattere non supportato trovato.",
    pwned: "Evita di utilizzare password semplici facili da indovinare.",
    restricted_found: "Evita di utilizzare in eccesso {{list, list}}.",
    restricted: {
        repetition: "caratteri ripetuti",
        sequence: "caratteri sequenziali",
        user_info: "le tue informazioni personali",
        words: "contesto del prodotto"
    }
};
var $a7afe291a4903781$export$2e2bcd8739ae039 = Object.freeze($a7afe291a4903781$var$password_rejected);


var $16dfa191dec84335$var$error = {
    general_required: "{{types, list(type: disjunction;)}} \xe8 richiesto",
    general_invalid: "Il {{types, list(type: disjunction;)}} non \xe8 valido",
    username_required: "Username \xe8 richiesto",
    password_required: "La password \xe8 richiesta",
    username_exists: "Username esiste gi\xe0",
    username_should_not_start_with_number: "L'username non dovrebbe iniziare con un numero",
    username_invalid_charset: "L'username dovrebbe contenere solo lettere, numeri o underscore.",
    invalid_email: "L'email non \xe8 valida",
    invalid_phone: "Il numero di telefono non \xe8 valido",
    passwords_do_not_match: "Le password non corrispondono. Per favore prova di nuovo.",
    invalid_passcode: "Il codice di verifica non \xe8 valido",
    invalid_connector_auth: "L'autorizzazione \xe8 invalida",
    invalid_connector_request: "I dati del connettore non sono validi",
    unknown: "Errore sconosciuto. Si prega di riprovare pi\xf9 tardi.",
    invalid_session: "Sessione non trovata. Si prega di tornare indietro e accedere di nuovo.",
    timeout: "Timeout della richiesta. Si prega di riprovare pi\xf9 tardi.",
    password_rejected: (0, $a7afe291a4903781$export$2e2bcd8739ae039),
    sso_not_enabled: "Single sign-on non abilitato per questo account email."
};
var $16dfa191dec84335$export$2e2bcd8739ae039 = Object.freeze($16dfa191dec84335$var$error);


var $5165b1778455b471$var$input = {
    username: "Nome utente",
    password: "Password",
    email: "Email",
    phone_number: "Numero di telefono",
    confirm_password: "Conferma password",
    search_region_code: "Codice regione di ricerca",
    backup_code: "Codice di backup"
};
var $5165b1778455b471$export$2e2bcd8739ae039 = Object.freeze($5165b1778455b471$var$input);


var $fdb489d320e59640$var$list = {
    or: "o",
    and: "e",
    separator: ","
};
var $fdb489d320e59640$export$2e2bcd8739ae039 = Object.freeze($fdb489d320e59640$var$list);


var $8bbcdab5b74a9ebf$var$mfa = {
    totp: "OTP dell'app Autenticatore",
    webauthn: "Passkey",
    backup_code: "Codice di backup",
    link_totp_description: "Ad esempio, Google Authenticator, ecc.",
    link_webauthn_description: "Collega il tuo dispositivo o hardware USB",
    link_backup_code_description: "Genera un codice di backup",
    verify_totp_description: "Inserisci il codice monouso nell'app",
    verify_webauthn_description: "Verifica il tuo dispositivo o hardware USB",
    verify_backup_code_description: "Incolla il codice di backup che hai salvato",
    add_mfa_factors: "Aggiungi la verifica in due passaggi",
    add_mfa_description: "La verifica in due passaggi \xe8 abilitata. Seleziona il tuo secondo metodo di verifica per un accesso sicuro.",
    verify_mfa_factors: "Verifica in due passaggi",
    verify_mfa_description: "La verifica in due passaggi \xe8 stata abilitata per questo account. Seleziona il secondo modo per verificare la tua identit\xe0.",
    add_authenticator_app: "Aggiungi app di autenticazione",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Scansiona questo codice QR",
    scan_qr_code_description: "Scansiona il seguente codice QR con la tua app di autenticazione, come Google Authenticator, Duo Mobile, Authy, ecc.",
    qr_code_not_available: "Non \xe8 possibile scansionare il codice QR?",
    copy_and_paste_key: "Copia e incolla la chiave",
    copy_and_paste_key_description: "Copia e incolla la seguente chiave nella tua app di autenticazione, come Google Authenticator, Duo Mobile, Authy, ecc.",
    want_to_scan_qr_code: "Vuoi scansionare il codice QR?",
    enter_one_time_code: "Inserisci il codice monouso",
    enter_one_time_code_link_description: "Inserisci il codice di verifica a 6 cifre generato dall'app di autenticazione.",
    enter_one_time_code_description: "La verifica in due passaggi \xe8 stata abilitata per questo account. Inserisci il codice monouso mostrato sulla tua app di autenticazione collegata.",
    link_another_mfa_factor: "Passa a un altro metodo",
    save_backup_code: "Salva il codice di backup",
    save_backup_code_description: "Puoi utilizzare uno di questi codici di backup per accedere al tuo account in caso di problemi durante la verifica in due passaggi in altri modi. Ogni codice pu\xf2 essere utilizzato solo una volta.",
    backup_code_hint: "Assicurati di copiarli e salvarli in un luogo sicuro.",
    enter_a_backup_code: "Inserisci un codice di backup",
    enter_backup_code_description: "Inserisci il codice di backup salvato quando \xe8 stata abilitata la verifica in due passaggi.",
    create_a_passkey: "Crea una chiave di accesso",
    create_passkey_description: "Registra la tua chiave di accesso utilizzando le biometrie del dispositivo, le chiavi di sicurezza (ad esempio, YubiKey) o altri metodi disponibili.",
    try_another_verification_method: "Prova un altro metodo di verifica",
    verify_via_passkey: "Verifica tramite chiave di accesso",
    verify_via_passkey_description: "Usa la chiave di accesso per verificare tramite la password o le biometrie del tuo dispositivo, la scansione del codice QR o l'uso di una chiave di sicurezza USB come YubiKey.",
    secret_key_copied: "Chiave segreta copiata.",
    backup_code_copied: "Codice di backup copiato.",
    webauthn_not_ready: "WebAuthn non \xe8 ancora pronto. Riprova pi\xf9 tardi.",
    webauthn_not_supported: "WebAuthn non \xe8 supportato in questo browser.",
    webauthn_failed_to_create: "Impossibile creare. Riprova.",
    webauthn_failed_to_verify: "Verifica non riuscita. Riprova."
};
var $8bbcdab5b74a9ebf$export$2e2bcd8739ae039 = Object.freeze($8bbcdab5b74a9ebf$var$mfa);


var $5b93b6353d177810$var$secondary = {
    social_bind_with: "Gi\xe0 un account? Accedi per collegare {{methods, list(type: disjunction;)}} con la tua identit\xe0 sociale."
};
var $5b93b6353d177810$export$2e2bcd8739ae039 = Object.freeze($5b93b6353d177810$var$secondary);


var $29c252acbe72e143$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $29c252acbe72e143$export$2e2bcd8739ae039 = Object.freeze($29c252acbe72e143$var$user_scopes);


var $37fa5c97215dc3cd$var$it = {
    translation: {
        input: (0, $5165b1778455b471$export$2e2bcd8739ae039),
        secondary: (0, $5b93b6353d177810$export$2e2bcd8739ae039),
        action: (0, $da1b2a885dc7e0b1$export$2e2bcd8739ae039),
        description: (0, $d88864e7e643ea5a$export$2e2bcd8739ae039),
        error: (0, $16dfa191dec84335$export$2e2bcd8739ae039),
        list: (0, $fdb489d320e59640$export$2e2bcd8739ae039),
        mfa: (0, $8bbcdab5b74a9ebf$export$2e2bcd8739ae039),
        development_tenant: (0, $d3d83cf45970b8ff$export$2e2bcd8739ae039),
        user_scopes: (0, $29c252acbe72e143$export$2e2bcd8739ae039)
    }
};
var $37fa5c97215dc3cd$export$2e2bcd8739ae039 = Object.freeze($37fa5c97215dc3cd$var$it);


var $c4fdd038ba46e176$var$action = {
    sign_in: "サインイン",
    continue: "続ける",
    create_account: "アカウントを作成する",
    create_account_without_linking: "リンクなしでアカウントを作成する",
    create: "作成する",
    enter_passcode: "認証コードを入力してください",
    confirm: "確認する",
    cancel: "キャンセル",
    save_password: "パスワードを保存する",
    bind: "{{address}} とリンクする",
    bind_and_continue: "リンクして続行する",
    back: "戻る",
    nav_back: "戻る",
    nav_skip: "スキップ",
    agree: "同意する",
    got_it: "わかりました",
    sign_in_with: "{{name}} で続ける",
    forgot_password: "パスワードを忘れましたか？",
    switch_to: "{{method}} に切り替える",
    sign_in_via_passcode: "認証コードでサインインする",
    sign_in_via_password: "パスワードでサインインする",
    change: "{{method}} を変更する",
    link_another_email: "別のメールアドレスをリンクする",
    link_another_phone: "別の電話番号をリンクする",
    link_another_email_or_phone: "別のメールアドレスまたは電話番号をリンクする",
    show_password: "パスワードを表示する",
    copy: "コピー",
    verify_via_passkey: "パスキー経由で確認",
    download: "ダウンロード",
    single_sign_on: "シングルサインオン",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $c4fdd038ba46e176$export$2e2bcd8739ae039 = Object.freeze($c4fdd038ba46e176$var$action);


var $4237b7829d0136c6$var$description = {
    email: "メールアドレス",
    phone_number: "電話番号",
    username: "ユーザー名",
    reminder: "リマインダー",
    not_found: "404 Not Found",
    agree_with_terms: "以下に同意することを確認しました：",
    agree_with_terms_modal: "続行するには、<link></link>に同意してください。",
    terms_of_use: "利用規約",
    sign_in: "サインイン",
    privacy_policy: "プライバシーポリシー",
    create_account: "アカウントを作成する",
    or: "または",
    and: "及び",
    enter_passcode: "確認コードが{{address}} {{target}}に送信されました",
    passcode_sent: "確認コードを再送します",
    resend_after_seconds: "<span>{{seconds}}</span>秒後に再送信",
    resend_passcode: "確認コードを再送信します",
    create_account_id_exists: "{{type}} {{value}}でアカウントが既に存在しています。ログインしますか？",
    link_account_id_exists: "{{type}} {{value}}でアカウントが既に存在しています。リンクしますか？",
    sign_in_id_does_not_exist: "{{type}} {{value}}のアカウントは存在しません。新しいアカウントを作成しますか？",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}}のアカウントは存在しません。",
    create_account_id_exists_alert: "{{type}} {{value}}は他のアカウントにリンクされています。他の{{type}}を試してください。",
    social_identity_exist: "{{type}} {{value}}は他のアカウントにリンクされています。他の{{type}}を試してください。",
    bind_account_title: "アカウントのリンクまたは作成",
    social_create_account: "新しいアカウントを作成できます。",
    social_link_email: "別のメールアドレスをリンクできます。",
    social_link_phone: "他の電話番号にリンクできます。",
    social_link_email_or_phone: "他のメールアドレスまたは電話番号にリンクできます。",
    social_bind_with_existing: "関連するアカウントが見つかりました。それを直接リンクできます。",
    reset_password: "パスワードを再設定する",
    reset_password_description: "アカウントに関連する{{types, list(type: disjunction;)}}を入力すると、パスワードの再設定に必要な確認コードが送信されます。",
    new_password: "新しいパスワード",
    set_password: "パスワードを設定する",
    password_changed: "パスワードが変更されました",
    no_account: "アカウントを作成していませんか？",
    have_account: "すでにアカウントをお持ちですか？",
    enter_password: "パスワードを入力する",
    enter_password_for: "{{method}} {{value}}でパスワードでサインインする",
    enter_username: "ユーザー名を入力する",
    enter_username_description: "ユーザー名はサインインの代替手段です。ユーザー名には、文字、数字、アンダースコアのみを含める必要があります。",
    link_email: "メールアドレスをリンクする",
    link_phone: "電話番号をリンクする",
    link_email_or_phone: "メールアドレスまたは電話番号をリンクする",
    link_email_description: "セキュリティを高めるために、アカウントにメールアドレスをリンクしてください。",
    link_phone_description: "セキュリティを高めるために、アカウントに電話番号をリンクしてください。",
    link_email_or_phone_description: "セキュリティを高めるために、アカウントに別のメールアドレスまたは電話番号をリンクしてください。",
    continue_with_more_information: "以下にアカウントの詳細を入力して、セキュリティを高めてください。",
    create_your_account: "アカウントを作成する",
    sign_in_to_your_account: "アカウントにサインインする",
    no_region_code_found: "地域コードが見つかりません",
    verify_email: "Eメールを確認する",
    verify_phone: "電話番号を確認する",
    password_requirements: "パスワード {{items, list}}。",
    password_requirement: {
        length_one: "最低 {{count}} 文字",
        length_other: "最低 {{count}} 文字",
        character_types_one: "大文字、小文字、数字、記号のうち {{count}} 種類を含む必要があります",
        character_types_other: "大文字、小文字、数字、記号のうち {{count}} 種類を含む必要があります"
    },
    use: "使用する",
    single_sign_on_email_form: "企業のメールアドレスを入力してください",
    single_sign_on_connectors_list: "あなたの企業は、メールアカウント{{email}}に対してシングルサインオンを有効にしました。以下のSSOプロバイダーを使用してサインインを続けることができます。",
    single_sign_on_enabled: "このアカウントではシングル サインオンが有効になっています",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $4237b7829d0136c6$export$2e2bcd8739ae039 = Object.freeze($4237b7829d0136c6$var$description);


var $a96785b4b64377a3$var$development_tenant = {
    notification: "開発モードです"
};
var $a96785b4b64377a3$export$2e2bcd8739ae039 = Object.freeze($a96785b4b64377a3$var$development_tenant);


var $a1298e39f2cc4c86$var$password_rejected = {
    too_short: "最小の長さは{{min}}です。",
    too_long: "最大の長さは{{max}}です。",
    character_types: "少なくとも{{min}}種類の文字が必要です。",
    unsupported_characters: "サポートされていない文字が見つかりました。",
    pwned: "簡単に推測できる簡単なパスワードの使用を避けてください。",
    restricted_found: "{{list, list}}の過度な使用を避けてください。",
    restricted: {
        repetition: "繰り返された文字",
        sequence: "連続する文字",
        user_info: "個人情報",
        words: "製品のコンテキスト"
    }
};
var $a1298e39f2cc4c86$export$2e2bcd8739ae039 = Object.freeze($a1298e39f2cc4c86$var$password_rejected);


var $eb65acab6163cd88$var$error = {
    general_required: "{{types, list(type: disjunction;)}}が必要です",
    general_invalid: "{{types, list(type: disjunction;)}}が無効です",
    username_required: "ユーザー名が必要です",
    password_required: "パスワードが必要です",
    username_exists: "ユーザー名が既に存在しています",
    username_should_not_start_with_number: "ユーザー名は数字で始めることはできません",
    username_invalid_charset: "ユーザー名は文字、数字、またはアンダースコアのみを含める必要があります。",
    invalid_email: "メールアドレスが無効です",
    invalid_phone: "電話番号が無効です",
    passwords_do_not_match: "パスワードが一致しません。もう一度お試しください。",
    invalid_passcode: "検証コードが無効です",
    invalid_connector_auth: "認証が無効です",
    invalid_connector_request: "コネクターデータが無効です",
    unknown: "不明なエラーが発生しました。後でもう一度お試しください。",
    invalid_session: "セッションが見つかりません。もう一度サインインしてください。",
    timeout: "リクエストタイムアウト。後でもう一度お試しください。",
    password_rejected: (0, $a1298e39f2cc4c86$export$2e2bcd8739ae039),
    sso_not_enabled: "このメールアカウントではシングルサインオンが有効になっていません。"
};
var $eb65acab6163cd88$export$2e2bcd8739ae039 = Object.freeze($eb65acab6163cd88$var$error);


var $1f6035912334d756$var$input = {
    username: "ユーザー名",
    password: "パスワード",
    email: "メールアドレス",
    phone_number: "電話番号",
    confirm_password: "パスワード確認",
    search_region_code: "地域コード検索",
    backup_code: "バックアップコード"
};
var $1f6035912334d756$export$2e2bcd8739ae039 = Object.freeze($1f6035912334d756$var$input);


var $7337f91a3d72f859$var$list = {
    or: "または",
    and: "そして",
    separator: ","
};
var $7337f91a3d72f859$export$2e2bcd8739ae039 = Object.freeze($7337f91a3d72f859$var$list);


var $f8762a4fb0790d49$var$mfa = {
    totp: "認証アプリOTP",
    webauthn: "パスキー",
    backup_code: "バックアップコード",
    link_totp_description: "例：Google Authenticator など",
    link_webauthn_description: "デバイスまたはUSBハードウェアをリンク",
    link_backup_code_description: "バックアップコードを生成",
    verify_totp_description: "アプリに表示されるワンタイムコードを入力",
    verify_webauthn_description: "デバイスまたはUSBハードウェアを確認",
    verify_backup_code_description: "保存したバックアップコードを貼り付け",
    add_mfa_factors: "2段階認証を追加",
    add_mfa_description: "2段階認証が有効になっています。安全なサインインのために第二の認証方法を選択してください。",
    verify_mfa_factors: "2段階認証",
    verify_mfa_description: "このアカウントでは2段階認証が有効になっています。アイデンティティを確認するための第二の方法を選択してください。",
    add_authenticator_app: "認証アプリを追加",
    step: "ステップ{{step, number}}：{{content}}",
    scan_qr_code: "このQRコードをスキャン",
    scan_qr_code_description: "次のQRコードを認証アプリ（例：Google Authenticator、Duo Mobile、Authyなど）でスキャンしてください。",
    qr_code_not_available: "QRコードをスキャンできませんか？",
    copy_and_paste_key: "キーをコピーして貼り付ける",
    copy_and_paste_key_description: "次のキーを認証アプリ（例：Google Authenticator、Duo Mobile、Authyなど）にコピーして貼り付けてください。",
    want_to_scan_qr_code: "QRコードをスキャンしますか？",
    enter_one_time_code: "ワンタイムコードを入力",
    enter_one_time_code_link_description: "認証アプリで生成された6桁の確認コードを入力してください。",
    enter_one_time_code_description: "このアカウントでは2段階認証が有効になっています。リンクされた認証アプリに表示されるワンタイムコードを入力してください。",
    link_another_mfa_factor: "別の方法に切り替える",
    save_backup_code: "バックアップコードを保存",
    save_backup_code_description: "2段階認証中に他の方法で問題が発生した場合、これらのバックアップコードのいずれかを使用してアカウントにアクセスできます。各コードは一度だけ使用できます。",
    backup_code_hint: "必ずコピーして安全な場所に保存してください。",
    enter_a_backup_code: "バックアップコードを入力",
    enter_backup_code_description: "初めて2段階認証が有効になったときに保存したバックアップコードを入力してください。",
    create_a_passkey: "パスキーを作成",
    create_passkey_description: "デバイスの生体認証、セキュリティキー（例：YubiKey）などを使用してパスキーを登録します。",
    try_another_verification_method: "別の検証方法を試す",
    verify_via_passkey: "パスキーで確認",
    verify_via_passkey_description: "デバイスのパスワードまたは生体認証、QRコードのスキャン、YubiKeyなどのUSBセキュリティキーを使用してパスキーで確認します。",
    secret_key_copied: "秘密鍵がコピーされました。",
    backup_code_copied: "バックアップコードがコピーされました。",
    webauthn_not_ready: "WebAuthnはまだ準備ができていません。後でもう一度試してください。",
    webauthn_not_supported: "このブラウザではWebAuthnはサポートされていません。",
    webauthn_failed_to_create: "作成に失敗しました。もう一度試してください。",
    webauthn_failed_to_verify: "確認に失敗しました。もう一度試してください。"
};
var $f8762a4fb0790d49$export$2e2bcd8739ae039 = Object.freeze($f8762a4fb0790d49$var$mfa);


var $0dc432c674047c38$var$secondary = {
    social_bind_with: "既にアカウントを持っていますか？{{methods, list(type: disjunction;)}}をソーシャルアイデンティティにリンクするためにサインインしてください。"
};
var $0dc432c674047c38$export$2e2bcd8739ae039 = Object.freeze($0dc432c674047c38$var$secondary);


var $7fb9d9ae3bb24e59$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $7fb9d9ae3bb24e59$export$2e2bcd8739ae039 = Object.freeze($7fb9d9ae3bb24e59$var$user_scopes);


var $555756cb712bade1$var$ja = {
    translation: {
        input: (0, $1f6035912334d756$export$2e2bcd8739ae039),
        secondary: (0, $0dc432c674047c38$export$2e2bcd8739ae039),
        action: (0, $c4fdd038ba46e176$export$2e2bcd8739ae039),
        description: (0, $4237b7829d0136c6$export$2e2bcd8739ae039),
        error: (0, $eb65acab6163cd88$export$2e2bcd8739ae039),
        list: (0, $7337f91a3d72f859$export$2e2bcd8739ae039),
        mfa: (0, $f8762a4fb0790d49$export$2e2bcd8739ae039),
        development_tenant: (0, $a96785b4b64377a3$export$2e2bcd8739ae039),
        user_scopes: (0, $7fb9d9ae3bb24e59$export$2e2bcd8739ae039)
    }
};
var $555756cb712bade1$export$2e2bcd8739ae039 = Object.freeze($555756cb712bade1$var$ja);


var $fe4e4d9df4108e52$var$action = {
    sign_in: "로그인",
    continue: "계속",
    create_account: "계정 생성",
    create_account_without_linking: "연동 없이 계정 생성하기",
    create: "생성",
    enter_passcode: "비밀번호 입력",
    confirm: "확인",
    cancel: "취소",
    save_password: "저장",
    bind: "{{address}}로 연동",
    bind_and_continue: "연동하고 계속하기",
    back: "뒤로 가기",
    nav_back: "뒤로",
    nav_skip: "건너뛰기",
    agree: "동의",
    got_it: "알겠습니다",
    sign_in_with: "{{name}} 계속",
    forgot_password: "비밀번호를 잊어버리셨나요?",
    switch_to: "{{method}}로 전환",
    sign_in_via_passcode: "인증번호로 로그인",
    sign_in_via_password: "비밀번호로 로그인",
    change: "변경 {{method}}",
    link_another_email: "다른 이메일 연동",
    link_another_phone: "다른 전화번호 연동",
    link_another_email_or_phone: "다른 이메일 또는 전화번호 연동",
    show_password: "비밀번호 보기",
    copy: "복사",
    verify_via_passkey: "패스키로 확인",
    download: "다운로드",
    single_sign_on: "단일 로그인",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $fe4e4d9df4108e52$export$2e2bcd8739ae039 = Object.freeze($fe4e4d9df4108e52$var$action);


var $0ad03a803e193a59$var$description = {
    email: "이메일",
    phone_number: "휴대전화번호",
    username: "사용자 이름",
    reminder: "리마인더",
    not_found: "404 찾을 수 없음",
    agree_with_terms: "나는 내용을 읽었으며, 이에 동의합니다.",
    agree_with_terms_modal: "진행하기 위해서는, 다음을 동의해주세요 <link></link>.",
    terms_of_use: "이용약관",
    sign_in: "로그인",
    privacy_policy: "개인정보처리방침",
    create_account: "계정 생성",
    or: "또는",
    and: "그리고",
    enter_passcode: "{{address}} {{target}} 으로 비밀번호가 전송되었어요.",
    passcode_sent: "비밀번호가 재전송되었어요.",
    resend_after_seconds: "<span>{{seconds}}</span> 초 후에 재전송",
    resend_passcode: "비밀번호 재전송",
    create_account_id_exists: "{{type}} {{value}} 계정은 다른 계정과 연결되어 있습니다. 다른 {{type}}을(를) 시도해주세요.",
    link_account_id_exists: "{{type}} {{value}}와/과 연동된 계정이 이미 존재해요. 연동할까요?",
    sign_in_id_does_not_exist: "{type}} {{value}} 계정이 존재하지 않아요. 새로 만드시겠어요?",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}} 계정이 존재하지 않아요.",
    create_account_id_exists_alert: "{{type}} {{value}} 이미 존재해요.",
    social_identity_exist: "{{type}} {{value}}이/가 다른 계정과 연동되어 있어요. 다른 {{type}}을/를 시도해 보세요.",
    bind_account_title: "계정 만들거나 연동하기",
    social_create_account: "새로운 계정을 만들 수 있습니다.",
    social_link_email: "다른 이메일을 연동할 수 있어요",
    social_link_phone: "다른 휴대전화를 연동할 수 있어요",
    social_link_email_or_phone: "다른 이메일이나 휴대전화를 연동할 수 있어요",
    social_bind_with_existing: "관련된 계정을 찾았어요. 직접 연동할 수 있어요.",
    reset_password: "비밀번호를 잊으셨나요",
    reset_password_description: "귀하의 계정과 연결된 {{types, list(type: disjunction;)}}를 입력하면 비밀번호 재설정을 위한 인증 코드를 보내드립니다.",
    new_password: "새 비밀번호",
    set_password: "비밀번호 설정",
    password_changed: "비밀번호 변경됨",
    no_account: "계정이 없나요?",
    have_account: "이미 계정이 있나요?",
    enter_password: "비밀번호 입력",
    enter_password_for: "{{method}} {{value}} 비밀번호 로그인",
    enter_username: "사용자 이름 설정하기",
    enter_username_description: "사용자 이름은 로그인을 할 때 사용되요. 사용자 이름에는 문자, 숫자 및 밑줄만 포함되어야 해요.",
    link_email: "이메일 연동",
    link_phone: "휴대전화번호 연동",
    link_email_or_phone: "이메일 또는 휴대전화번호 연동",
    link_email_description: "더 나은 보안을 위해 이메일을 연동해 주세요.",
    link_phone_description: "더 나은 보안을 위해 휴대전화번호를 연동해 주세요.",
    link_email_or_phone_description: "더 나은 보안을 위해 이메일 또는 휴대전화번호를 연동해 주세요.",
    continue_with_more_information: "더 나은 보안을 위해 아래 자세한 내용을 따라 주세요.",
    create_your_account: "계정 생성하기",
    sign_in_to_your_account: "계정에 로그인하세요",
    no_region_code_found: "지역 코드를 찾을 수 없습니다.",
    verify_email: "이메일 인증",
    verify_phone: "휴대전화번호 인증",
    password_requirements: "비밀번호는 {{items, list}} 로 이루어져야 합니다.",
    password_requirement: {
        length_one: "최소 {{count}} 자 이상이어야 함",
        length_other: "최소 {{count}} 문자 이상이어야 함",
        character_types_one: "최소 {{count}} 개의 대문자, 소문자, 숫자, 특수 기호를 포함해야 함",
        character_types_other: "최소 {{count}} 개의 대문자, 소문자, 숫자, 특수 기호를 포함해야 함"
    },
    use: "사용",
    single_sign_on_email_form: "기업 이메일 주소를 입력하세요",
    single_sign_on_connectors_list: "귀하의 기업은 {{email}} 이메일 계정에 대해 Single Sign-On을 활성화했습니다. 다음 SSO 제공업체를 사용하여 로그인을 계속할 수 있습니다.",
    single_sign_on_enabled: "이 계정에는 Single Sign-On이 활성화되어 있습니다.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $0ad03a803e193a59$export$2e2bcd8739ae039 = Object.freeze($0ad03a803e193a59$var$description);


var $4c358c461a594f5c$var$development_tenant = {
    notification: "개발 모드입니다"
};
var $4c358c461a594f5c$export$2e2bcd8739ae039 = Object.freeze($4c358c461a594f5c$var$development_tenant);


var $dad351ab1e8dd020$var$password_rejected = {
    too_short: "최소 길이는 {{min}}입니다.",
    too_long: "최대 길이는 {{max}}입니다.",
    character_types: "최소 {{min}}개의 문자 유형이 필요합니다.",
    unsupported_characters: "지원되지 않는 문자가 발견되었습니다.",
    pwned: "추측하기 쉬운 간단한 암호 사용을 피하십시오.",
    restricted_found: "{{list, list}}을(를) 과도하게 사용하지 마십시오.",
    restricted: {
        repetition: "반복된 문자",
        sequence: "연속된 문자",
        user_info: "개인 정보",
        words: "품질 가능성"
    }
};
var $dad351ab1e8dd020$export$2e2bcd8739ae039 = Object.freeze($dad351ab1e8dd020$var$password_rejected);


var $5eb474cc319fe34e$var$error = {
    general_required: "{{types, list(type: disjunction;)}}은/는 필수예요.",
    general_invalid: "{{types, list(type: disjunction;)}}은/는 유효하지 않아요.",
    username_required: "사용자 이름은 필수예요.",
    password_required: "비밀번호는 필수예요.",
    username_exists: "사용자 이름이 이미 존재해요.",
    username_should_not_start_with_number: "사용자 이름은 숫자로 시작하면 안 돼요.",
    username_invalid_charset: "사용자 이름은 문자, 숫자, _(밑줄 문자) 로만 이루어져야 해요.",
    invalid_email: "이메일이 유효하지 않아요.",
    invalid_phone: "휴대전화번호가 유효하지 않아요.",
    passwords_do_not_match: "비밀번호가 일치하지 않아요.",
    invalid_passcode: "비밀번호가 유효하지 않아요.",
    invalid_connector_auth: "인증이 유효하지 않아요.",
    invalid_connector_request: "연동 정보가 유효하지 않아요.",
    unknown: "알 수 없는 오류가 발생했어요. 잠시 후에 시도해 주세요.",
    invalid_session: "세션을 찾을 수 없어요. 다시 로그인해 주세요.",
    timeout: "요청 시간이 초과되었어요. 잠시 후에 다시 시도해 주세요.",
    password_rejected: (0, $dad351ab1e8dd020$export$2e2bcd8739ae039),
    sso_not_enabled: "이 이메일 계정에 대해 단일 로그인이 활성화되지 않았어요."
};
var $5eb474cc319fe34e$export$2e2bcd8739ae039 = Object.freeze($5eb474cc319fe34e$var$error);


var $28ec2c2a5a991409$var$input = {
    username: "사용자 이름",
    password: "비밀번호",
    email: "이메일",
    phone_number: "휴대전화번호",
    confirm_password: "비밀번호 확인",
    search_region_code: "지역 코드 검색",
    backup_code: "백업 코드"
};
var $28ec2c2a5a991409$export$2e2bcd8739ae039 = Object.freeze($28ec2c2a5a991409$var$input);


var $9282b5748157b1c7$var$list = {
    or: "또는",
    and: "및",
    separator: ","
};
var $9282b5748157b1c7$export$2e2bcd8739ae039 = Object.freeze($9282b5748157b1c7$var$list);


var $a0df0ef0fddcfd19$var$mfa = {
    totp: "인증 앱 OTP",
    webauthn: "패스키",
    backup_code: "백업 코드",
    link_totp_description: "예: Google Authenticator 등",
    link_webauthn_description: "기기 또는 USB 하드웨어 연결",
    link_backup_code_description: "백업 코드 생성",
    verify_totp_description: "앱에 일회용 코드 입력",
    verify_webauthn_description: "기기 또는 USB 하드웨어 확인",
    verify_backup_code_description: "저장한 백업 코드 붙여넣기",
    add_mfa_factors: "2단계 인증 추가",
    add_mfa_description: "2단계 인증이 활성화되었습니다. 안전한 로그인을 위해 두 번째 인증 방법을 선택하세요.",
    verify_mfa_factors: "2단계 인증 확인",
    verify_mfa_description: "이 계정에 대해 2단계 인증이 활성화되었습니다. 신원을 확인하는 두 번째 방법을 선택하세요.",
    add_authenticator_app: "인증 앱 추가",
    step: "단계 {{step, number}}: {{content}}",
    scan_qr_code: "이 QR 코드 스캔",
    scan_qr_code_description: "Google Authenticator, Duo Mobile, Authy 등의 인증 앱으로 다음 QR 코드를 스캔하세요.",
    qr_code_not_available: "QR 코드를 스캔할 수 없나요?",
    copy_and_paste_key: "키 복사 및 붙여넣기",
    copy_and_paste_key_description: "다음 키를 Google Authenticator, Duo Mobile, Authy 등의 인증 앱에 복사하여 붙여넣으세요.",
    want_to_scan_qr_code: "QR 코드를 스캔하고 싶나요?",
    enter_one_time_code: "일회용 코드 입력",
    enter_one_time_code_link_description: "인증 앱에서 생성된 6자리 확인 코드를 입력하세요.",
    enter_one_time_code_description: "이 계정에서는 2단계 인증이 활성화되었습니다. 연결된 인증 앱에 표시된 일회용 코드를 입력하세요.",
    link_another_mfa_factor: "다른 방법으로 전환",
    save_backup_code: "백업 코드 저장",
    save_backup_code_description: "다른 방법으로 2단계 인증 중 문제가 발생하면 이러한 백업 코드 중 하나를 사용하여 계정에 액세스할 수 있습니다. 각 코드는 한 번만 사용할 수 있습니다.",
    backup_code_hint: "반드시 복사하고 안전한 곳에 저장하세요.",
    enter_a_backup_code: "백업 코드 입력",
    enter_backup_code_description: "2단계 인증이 초기에 활성화될 때 저장한 백업 코드를 입력하세요.",
    create_a_passkey: "패스키 생성",
    create_passkey_description: "기기 바이오메트릭스, 보안 키(예: YubiKey) 또는 기타 사용 가능한 방법을 사용하여 패스키를 등록하세요.",
    try_another_verification_method: "다른 방법으로 확인해보세요",
    verify_via_passkey: "패스키로 확인",
    verify_via_passkey_description: "디바이스 비밀번호 또는 바이오메트릭스, QR 코드 스캔 또는 YubiKey와 같은 USB 보안 키 사용하여 패스키로 확인하세요.",
    secret_key_copied: "비밀 키가 복사되었습니다.",
    backup_code_copied: "백업 코드가 복사되었습니다.",
    webauthn_not_ready: "WebAuthn이 아직 준비되지 않았습니다. 나중에 다시 시도하세요.",
    webauthn_not_supported: "이 브라우저에서는 WebAuthn이 지원되지 않습니다.",
    webauthn_failed_to_create: "생성 실패. 다시 시도하세요.",
    webauthn_failed_to_verify: "확인 실패. 다시 시도하세요."
};
var $a0df0ef0fddcfd19$export$2e2bcd8739ae039 = Object.freeze($a0df0ef0fddcfd19$var$mfa);


var $3ea204927c020107$var$secondary = {
    social_bind_with: "이미 계정이 있으신가요? {{methods, list(type: disjunction;)}}로 로그인 해보세요!"
};
var $3ea204927c020107$export$2e2bcd8739ae039 = Object.freeze($3ea204927c020107$var$secondary);


var $8e044bd4aec71b7e$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $8e044bd4aec71b7e$export$2e2bcd8739ae039 = Object.freeze($8e044bd4aec71b7e$var$user_scopes);


var $421dd505ef727661$var$ko = {
    translation: {
        input: (0, $28ec2c2a5a991409$export$2e2bcd8739ae039),
        secondary: (0, $3ea204927c020107$export$2e2bcd8739ae039),
        action: (0, $fe4e4d9df4108e52$export$2e2bcd8739ae039),
        description: (0, $0ad03a803e193a59$export$2e2bcd8739ae039),
        error: (0, $5eb474cc319fe34e$export$2e2bcd8739ae039),
        list: (0, $9282b5748157b1c7$export$2e2bcd8739ae039),
        mfa: (0, $a0df0ef0fddcfd19$export$2e2bcd8739ae039),
        development_tenant: (0, $4c358c461a594f5c$export$2e2bcd8739ae039),
        user_scopes: (0, $8e044bd4aec71b7e$export$2e2bcd8739ae039)
    }
};
var $421dd505ef727661$export$2e2bcd8739ae039 = Object.freeze($421dd505ef727661$var$ko);


var $83bd94c1bba2fe9d$var$action = {
    sign_in: "Zaloguj się",
    continue: "Kontynuuj",
    create_account: "Utw\xf3rz konto",
    create_account_without_linking: "Utw\xf3rz konto bez łączenia",
    create: "Utw\xf3rz",
    enter_passcode: "Wprowadź kod weryfikacyjny",
    confirm: "Potwierdź",
    cancel: "Anuluj",
    save_password: "Zapisz hasło",
    bind: "Połącz z {{address}}",
    bind_and_continue: "Połącz i kontynuuj",
    back: "Wr\xf3ć",
    nav_back: "Wstecz",
    nav_skip: "Pomiń",
    agree: "Zgadzam się",
    got_it: "Zrozumiałem",
    sign_in_with: "Kontynuuj z {{name}}",
    forgot_password: "Zapomniałeś hasła?",
    switch_to: "Przełącz na {{method}}",
    sign_in_via_passcode: "Zaloguj się za pomocą kodu weryfikacyjnego",
    sign_in_via_password: "Zaloguj się za pomocą hasła",
    change: "Zmień {{method}}",
    link_another_email: "Połącz inne konto email",
    link_another_phone: "Połącz inne konto telefoniczne",
    link_another_email_or_phone: "Połącz inne konto email lub telefoniczne",
    show_password: "Pokaż hasło",
    copy: "Kopiuj",
    verify_via_passkey: "Weryfikacja za pomocą klucza dostępu",
    download: "Pobierz",
    single_sign_on: "Pojedyncze logowanie",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $83bd94c1bba2fe9d$export$2e2bcd8739ae039 = Object.freeze($83bd94c1bba2fe9d$var$action);


var $200b1c8c5e90f9b0$var$description = {
    email: "adres email",
    phone_number: "numer telefonu",
    username: "nazwa użytkownika",
    reminder: "Przypomnienie",
    not_found: "404 Nie znaleziono",
    agree_with_terms: "Przeczytałem/am i zgadzam się z ",
    agree_with_terms_modal: "Do kontynuacji należy zaakceptować <link></link>.",
    terms_of_use: "Warunki korzystania",
    sign_in: "Zaloguj się",
    privacy_policy: "Polityka prywatności",
    create_account: "Utw\xf3rz konto",
    or: "lub",
    and: "i",
    enter_passcode: "Kod weryfikacyjny został wysłany na twoje {{address}} {{target}}",
    passcode_sent: "Kod weryfikacyjny został wysłany ponownie",
    resend_after_seconds: "Wyślij ponownie po <span>{{seconds}}</span> sekundach",
    resend_passcode: "Wyślij kod weryfikacyjny ponownie",
    create_account_id_exists: "Konto z {{type}} {{value}} już istnieje. Czy chcesz się zalogować?",
    link_account_id_exists: "Konto z {{type}} {{value}} już istnieje. Czy chcesz je połączyć?",
    sign_in_id_does_not_exist: "Konto z {{type}} {{value}} nie istnieje. Czy chcesz utworzyć nowe konto?",
    sign_in_id_does_not_exist_alert: "Konto z {{type}} {{value}} nie istnieje.",
    create_account_id_exists_alert: "Konto z {{type}} {{value}} jest połączone z innym kontem. Spr\xf3buj inny {{type}}.",
    social_identity_exist: "{{type}} {{value}} jest połączony z innym kontem. Spr\xf3buj inny {{type}}.",
    bind_account_title: "Połącz lub utw\xf3rz konto",
    social_create_account: "Możesz utworzyć nowe konto.",
    social_link_email: "Możesz połączyć kolejny adres email",
    social_link_phone: "Możesz połączyć kolejny numer telefonu",
    social_link_email_or_phone: "Możesz połączyć kolejny adres email lub numer telefonu",
    social_bind_with_existing: "Znaleźliśmy powiązane konto, możesz je połączyć bezpośrednio.",
    reset_password: "Zresetuj hasło",
    reset_password_description: "Wpisz {{types, lista(type: złączonych;)}} związanego z twoim kontem, a wyślemy ci kod weryfikacyjny do zresetowania hasła.",
    new_password: "Nowe hasło",
    set_password: "Ustaw hasło",
    password_changed: "Hasło zmienione",
    no_account: "Nie masz jeszcze konta? ",
    have_account: "Masz już konto?",
    enter_password: "Wpisz hasło",
    enter_password_for: "Zaloguj się przy użyciu hasła do {{method}} {{value}}",
    enter_username: "Ustaw nazwę użytkownika",
    enter_username_description: "Nazwa użytkownika jest alternatywną formą logowania. Nazwa użytkownika powinna zawierać tylko litery, cyfry i podkreślenia.",
    link_email: "Połącz adres email",
    link_phone: "Połącz numer telefonu",
    link_email_or_phone: "Połącz adres email lub numer telefonu",
    link_email_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z adresem e-mail.",
    link_phone_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z numerem telefonu.",
    link_email_or_phone_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z adresem e-mail lub numerem telefonu.",
    continue_with_more_information: "Dla zwiększenia bezpieczeństwa, proszę uzupełnić poniższe informacje o koncie.",
    create_your_account: "Utw\xf3rz konto",
    sign_in_to_your_account: "Zaloguj się do swojego konta",
    no_region_code_found: "Nie znaleziono kodu regionu",
    verify_email: "Potwierdź sw\xf3j email",
    verify_phone: "Potwierdź sw\xf3j numer telefonu",
    password_requirements: "Wymagania dotyczące hasła {{items, list}}.",
    password_requirement: {
        length_one: "wymaga co najmniej {{count}} znaku",
        length_other: "wymaga co najmniej {{count}} znak\xf3w",
        character_types_one: "powinno zawierać co najmniej {{count}} rodzaj liter wielkich, małych liter, cyfr i symboli",
        character_types_other: "powinno zawierać co najmniej {{count}} rodzaje liter wielkich, małych liter, cyfr i symboli"
    },
    use: "Użyj",
    single_sign_on_email_form: "Wpisz sw\xf3j służbowy adres email",
    single_sign_on_connectors_list: "Twoja firma włączyła jednokrotne logowanie dla konta e-mail {{email}}. Możesz kontynuować logowanie za pomocą następujących dostawc\xf3w SSO.",
    single_sign_on_enabled: "To konto ma włączone jednokrotne logowanie.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $200b1c8c5e90f9b0$export$2e2bcd8739ae039 = Object.freeze($200b1c8c5e90f9b0$var$description);


var $b414822eb29ad1de$var$development_tenant = {
    notification: "Jesteś w trybie deweloperskim"
};
var $b414822eb29ad1de$export$2e2bcd8739ae039 = Object.freeze($b414822eb29ad1de$var$development_tenant);


var $21db6d49d726fe35$var$password_rejected = {
    too_short: "Minimalna długość to {{min}}.",
    too_long: "Maksymalna długość to {{max}}.",
    character_types: "Wymagane są przynajmniej {{min}} rodzaje znak\xf3w.",
    unsupported_characters: "Znaleziono niedozwolony znak.",
    pwned: "Unikaj używania prostych haseł, kt\xf3re są łatwe do odgadnięcia.",
    restricted_found: "Unikaj nadużywania {{list, list}}.",
    restricted: {
        repetition: "powtarzających się znak\xf3w",
        sequence: "sekwencyjnych znak\xf3w",
        user_info: "twoich informacji osobistych",
        words: "kontekstu produktu"
    }
};
var $21db6d49d726fe35$export$2e2bcd8739ae039 = Object.freeze($21db6d49d726fe35$var$password_rejected);


var $5778b82a44538bfe$var$error = {
    general_required: "{{types, list(type: disjunction;)}} jest wymagany",
    general_invalid: "{{types, list(type: disjunction;)}} jest nieprawidłowe",
    username_required: "Nazwa użytkownika jest wymagana",
    password_required: "Hasło jest wymagane",
    username_exists: "Nazwa użytkownika już istnieje",
    username_should_not_start_with_number: "Nazwa użytkownika nie powinna zaczynać się od liczby",
    username_invalid_charset: "Nazwa użytkownika powinna zawierać tylko litery, liczby lub podkreślenia.",
    invalid_email: "Nieprawidłowy adres e-mail",
    invalid_phone: "Nieprawidłowy numer telefonu",
    passwords_do_not_match: "Hasła nie pasują do siebie. Proszę spr\xf3buj ponownie.",
    invalid_passcode: "Nieprawidłowy kod weryfikacyjny",
    invalid_connector_auth: "Nieprawidłowa autoryzacja",
    invalid_connector_request: "Nieprawidłowe dane konektora",
    unknown: "Nieznany błąd. Proszę spr\xf3buj ponownie p\xf3źniej.",
    invalid_session: "Sesja nie znaleziona. Proszę wr\xf3ć i zaloguj się ponownie.",
    timeout: "Czas żądania upłynął. Proszę spr\xf3buj ponownie p\xf3źniej.",
    password_rejected: (0, $21db6d49d726fe35$export$2e2bcd8739ae039),
    sso_not_enabled: "Pojedyncze logowanie nie jest włączony dla tego konta e-mail."
};
var $5778b82a44538bfe$export$2e2bcd8739ae039 = Object.freeze($5778b82a44538bfe$var$error);


var $825b37cb1a8a0d20$var$input = {
    username: "Nazwa użytkownika",
    password: "Hasło",
    email: "E-mail",
    phone_number: "Numer telefonu",
    confirm_password: "Potwierdź hasło",
    search_region_code: "Kod regionu wyszukiwania",
    backup_code: "Kod kopii zapasowej"
};
var $825b37cb1a8a0d20$export$2e2bcd8739ae039 = Object.freeze($825b37cb1a8a0d20$var$input);


var $ecf7c721e7d5929e$var$list = {
    or: "lub",
    and: "i",
    separator: ","
};
var $ecf7c721e7d5929e$export$2e2bcd8739ae039 = Object.freeze($ecf7c721e7d5929e$var$list);


var $8098c198da67ee2a$var$mfa = {
    totp: "OTP aplikacji autentykacyjnej",
    webauthn: "Klucz gł\xf3wny",
    backup_code: "Kod zapasowy",
    link_totp_description: "Np. Google Authenticator itp.",
    link_webauthn_description: "Połącz urządzenie lub sprzęt USB",
    link_backup_code_description: "Generuj kod zapasowy",
    verify_totp_description: "Wprowadź jednorazowy kod w aplikacji",
    verify_webauthn_description: "Zweryfikuj urządzenie lub sprzęt USB",
    verify_backup_code_description: "Wklej kod zapasowy, kt\xf3ry zapisałeś",
    add_mfa_factors: "Dodaj weryfikację dwuetapową",
    add_mfa_description: "Weryfikacja dwuetapowa jest włączona. Wybierz sw\xf3j drugi spos\xf3b weryfikacji dla bezpiecznego logowania.",
    verify_mfa_factors: "Weryfikacja dwuetapowa",
    verify_mfa_description: "Włączono weryfikację dwuetapową dla tego konta. Proszę wybrać drugi spos\xf3b weryfikacji swojej tożsamości.",
    add_authenticator_app: "Dodaj aplikację autentykacyjną",
    step: "Krok {{step, number}}: {{content}}",
    scan_qr_code: "Zeskanuj ten kod QR",
    scan_qr_code_description: "Zeskanuj poniższy kod QR za pomocą aplikacji autentykacyjnej, takiej jak Google Authenticator, Duo Mobile, Authy, itp.",
    qr_code_not_available: "Nie można zeskanować kodu QR?",
    copy_and_paste_key: "Skopiuj i wklej klucz",
    copy_and_paste_key_description: "Skopiuj i wklej poniższy klucz do aplikacji autentykacyjnej, takiej jak Google Authenticator, Duo Mobile, Authy, itp.",
    want_to_scan_qr_code: "Chcesz zeskanować kod QR?",
    enter_one_time_code: "Wprowadź jednorazowy kod",
    enter_one_time_code_link_description: "Wprowadź 6-cyfrowy kod weryfikacyjny wygenerowany przez aplikację autentykacyjną.",
    enter_one_time_code_description: "Dla tego konta włączono weryfikację dwuetapową. Proszę wprowadzić jednorazowy kod widoczny w aplikacji autentykacyjnej powiązanej z kontem.",
    link_another_mfa_factor: "Przełącz na inny spos\xf3b",
    save_backup_code: "Zapisz sw\xf3j kod zapasowy",
    save_backup_code_description: "Możesz użyć jednego z tych kod\xf3w zapasowych, aby uzyskać dostęp do swojego konta w przypadku problem\xf3w z weryfikacją dwuetapową w inny spos\xf3b. Każdy kod można użyć tylko raz.",
    backup_code_hint: "Upewnij się, że je skopiujesz i zapiszesz w bezpiecznym miejscu.",
    enter_a_backup_code: "Wprowadź kod zapasowy",
    enter_backup_code_description: "Wprowadź kod zapasowy, kt\xf3ry zapisałeś, gdy włączono weryfikację dwuetapową.",
    create_a_passkey: "Utw\xf3rz klucz dostępu",
    create_passkey_description: "Zarejestruj sw\xf3j klucz dostępu za pomocą biometrii urządzenia, kluczy bezpieczeństwa (np. YubiKey) lub innych dostępnych metod.",
    try_another_verification_method: "Wypr\xf3buj inny spos\xf3b weryfikacji",
    verify_via_passkey: "Zweryfikuj za pomocą klucza dostępu",
    verify_via_passkey_description: "Użyj klucza dostępu do weryfikacji za pomocą hasła urządzenia lub biometrii, skanowania kodu QR lub użycia klucza bezpieczeństwa USB, takiego jak YubiKey.",
    secret_key_copied: "Skopiowano klucz prywatny.",
    backup_code_copied: "Skopiowano kod zapasowy.",
    webauthn_not_ready: "WebAuthn nie jest jeszcze gotowy. Spr\xf3buj ponownie p\xf3źniej.",
    webauthn_not_supported: "WebAuthn nie jest obsługiwane w tej przeglądarce.",
    webauthn_failed_to_create: "Nie udało się utworzyć. Spr\xf3buj ponownie.",
    webauthn_failed_to_verify: "Nie udało się zweryfikować. Spr\xf3buj ponownie."
};
var $8098c198da67ee2a$export$2e2bcd8739ae039 = Object.freeze($8098c198da67ee2a$var$mfa);


var $4996c9efedc8e891$var$secondary = {
    social_bind_with: "Masz już konto? Zaloguj się, aby połączyć {{methods, list(type: disjunction;)}} z twoją tożsamością społeczną."
};
var $4996c9efedc8e891$export$2e2bcd8739ae039 = Object.freeze($4996c9efedc8e891$var$secondary);


var $e88e3cbfb2061d0a$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $e88e3cbfb2061d0a$export$2e2bcd8739ae039 = Object.freeze($e88e3cbfb2061d0a$var$user_scopes);


var $9580da2c87f02325$var$pl_pl = {
    translation: {
        input: (0, $825b37cb1a8a0d20$export$2e2bcd8739ae039),
        secondary: (0, $4996c9efedc8e891$export$2e2bcd8739ae039),
        action: (0, $83bd94c1bba2fe9d$export$2e2bcd8739ae039),
        description: (0, $200b1c8c5e90f9b0$export$2e2bcd8739ae039),
        error: (0, $5778b82a44538bfe$export$2e2bcd8739ae039),
        list: (0, $ecf7c721e7d5929e$export$2e2bcd8739ae039),
        mfa: (0, $8098c198da67ee2a$export$2e2bcd8739ae039),
        development_tenant: (0, $b414822eb29ad1de$export$2e2bcd8739ae039),
        user_scopes: (0, $e88e3cbfb2061d0a$export$2e2bcd8739ae039)
    }
};
var $9580da2c87f02325$export$2e2bcd8739ae039 = Object.freeze($9580da2c87f02325$var$pl_pl);


var $d23787479919a64c$var$action = {
    sign_in: "Entrar",
    continue: "Continuar",
    create_account: "Criar conta",
    create_account_without_linking: "Criar conta sem vincular",
    create: "Criar",
    enter_passcode: "Inserir c\xf3digo de verifica\xe7\xe3o",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Salvar senha",
    bind: "Link com {{address}}",
    bind_and_continue: "Linkar e continuar",
    back: "Voltar",
    nav_back: "Voltar",
    nav_skip: "Pular",
    agree: "Aceito",
    got_it: "Entendido",
    sign_in_with: "Continuar com {{name}}",
    forgot_password: "Esqueceu sua senha?",
    switch_to: "Trocar para {{method}}",
    sign_in_via_passcode: "Fazer login com c\xf3digo de verifica\xe7\xe3o",
    sign_in_via_password: "Fazer login com senha",
    change: "Alterar {{method}}",
    link_another_email: "Vincular outro e-mail",
    link_another_phone: "Vincular outro telefone",
    link_another_email_or_phone: "Vincular outro e-mail ou telefone",
    show_password: "Mostrar senha",
    copy: "Copiar",
    verify_via_passkey: "Verificar via chave de acesso",
    download: "Baixar",
    single_sign_on: "Single Sign-On",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $d23787479919a64c$export$2e2bcd8739ae039 = Object.freeze($d23787479919a64c$var$action);


var $ff20e01a376ec829$var$description = {
    email: "e-mail",
    phone_number: "n\xfamero de telefone",
    username: "nome de usu\xe1rio",
    reminder: "Lembrete",
    not_found: "404 N\xe3o Encontrado",
    agree_with_terms: "Eu li e concordo com os ",
    agree_with_terms_modal: "Para continuar, por favor, concorde com os <link></link>.",
    terms_of_use: "Termos de uso",
    sign_in: "Entrar",
    privacy_policy: "Pol\xedtica de privacidade",
    create_account: "Criar conta",
    or: "ou",
    and: "e",
    enter_passcode: "O c\xf3digo de verifica\xe7\xe3o foi enviado para o seu {{address}} {{target}}",
    passcode_sent: "O c\xf3digo de verifica\xe7\xe3o foi reenviado",
    resend_after_seconds: "Reenviar depois <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verifica\xe7\xe3o",
    create_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de entrar?",
    link_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de vincular?",
    sign_in_id_does_not_exist: "A conta com {{type}} {{value}} n\xe3o existe, gostaria de criar uma nova conta?",
    sign_in_id_does_not_exist_alert: "A conta com {{type}} {{value}} n\xe3o existe.",
    create_account_id_exists_alert: "A conta com {{type}} {{value}} est\xe1 vinculada a outra conta. Por favor, tente outro {{type}}.",
    social_identity_exist: "O {{type}} {{value}} est\xe1 vinculado a outra conta. Por favor, tente outro {{type}}.",
    bind_account_title: "Vincular ou criar conta",
    social_create_account: "Voc\xea pode criar uma nova conta.",
    social_link_email: "\xc9 poss\xedvel vincular outro e-mail",
    social_link_phone: "\xc9 poss\xedvel vincular outro telefone",
    social_link_email_or_phone: "\xc9 poss\xedvel vincular outro e-mail ou telefone",
    social_bind_with_existing: "Encontramos uma conta relacionada registrada e voc\xea pode vincul\xe1-la diretamente.",
    reset_password: "Esqueceu a senha",
    reset_password_description: "Digite o {{types, list(type: disjunction;)}} \xe0 sua conta e enviaremos a voc\xea o c\xf3digo de verifica\xe7\xe3o para redefinir sua senha.",
    new_password: "Nova senha",
    set_password: "Configurar senha",
    password_changed: "Senha alterada",
    no_account: "Ainda n\xe3o tem conta? ",
    have_account: "J\xe1 tinha uma conta?",
    enter_password: "Digite a senha",
    enter_password_for: "Entre com a senha para {{method}} {{value}}",
    enter_username: "Definir nome de usu\xe1rio",
    enter_username_description: "O nome de usu\xe1rio \xe9 uma alternativa para fazer login. O nome de usu\xe1rio deve conter apenas letras, n\xfameros e sublinhados.",
    link_email: "Linkar e-mail",
    link_phone: "Linkar telefone",
    link_email_or_phone: "Linkar e-mail ou telefone",
    link_email_description: "Para maior seguran\xe7a, vincule seu e-mail \xe0 conta.",
    link_phone_description: "Para maior seguran\xe7a, vincule seu telefone \xe0 conta.",
    link_email_or_phone_description: "Para maior seguran\xe7a, vincule seu e-mail ou telefone \xe0 conta.",
    continue_with_more_information: "Para maior seguran\xe7a, preencha os detalhes da conta abaixo.",
    create_your_account: "Crie sua conta",
    sign_in_to_your_account: "Fa\xe7a login na sua conta",
    no_region_code_found: "N\xe3o foi poss\xedvel encontrar o c\xf3digo de regi\xe3o do seu telefone.",
    verify_email: "Verificar e-mail",
    verify_phone: "Verificar n\xfamero de telefone",
    password_requirements: "Senha {{items, list}}.",
    password_requirement: {
        length_one: "requer no m\xednimo 1 caractere.",
        length_other: "requer no m\xednimo {{count}} caracteres.",
        character_types_one: "deve conter pelo menos 1 tipo de letra mai\xfascula, letra min\xfascula, d\xedgito e s\xedmbolo.",
        character_types_other: "deve conter pelo menos {{count}} tipos de letra mai\xfascula, letra min\xfascula, d\xedgito e s\xedmbolo."
    },
    use: "Usar",
    single_sign_on_email_form: "Insira o endere\xe7o de e-mail corporativo",
    single_sign_on_connectors_list: "Sua empresa ativou o Single Sign-On para a conta de email {{email}}. Voc\xea pode continuar a fazer login com os seguintes provedores de SSO.",
    single_sign_on_enabled: "Esta conta tem Single Sign-On ativado.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $ff20e01a376ec829$export$2e2bcd8739ae039 = Object.freeze($ff20e01a376ec829$var$description);


var $2ba8a4922407ee43$var$development_tenant = {
    notification: "Voc\xea est\xe1 no modo de desenvolvimento"
};
var $2ba8a4922407ee43$export$2e2bcd8739ae039 = Object.freeze($2ba8a4922407ee43$var$development_tenant);


var $9d8a4a4b0f6e786b$var$password_rejected = {
    too_short: "O comprimento m\xednimo \xe9 {{min}}.",
    too_long: "O comprimento m\xe1ximo \xe9 {{max}}.",
    character_types: "Pelo menos {{min}} tipos de caracteres s\xe3o necess\xe1rios.",
    unsupported_characters: "Caractere n\xe3o suportado encontrado.",
    pwned: "Evite o uso de senhas simples que s\xe3o f\xe1ceis de adivinhar.",
    restricted_found: "Evite usar em excesso {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres sequenciais",
        user_info: "suas informa\xe7\xf5es pessoais",
        words: "contexto do produto"
    }
};
var $9d8a4a4b0f6e786b$export$2e2bcd8739ae039 = Object.freeze($9d8a4a4b0f6e786b$var$password_rejected);


var $0811f159e6e809d8$var$error = {
    general_required: "{{types, list(type: disjunction;)}} \xe9 obrigat\xf3rio",
    general_invalid: "O {{types, list(type: disjunction;)}} \xe9 inv\xe1lido",
    username_required: "Nome de usu\xe1rio \xe9 obrigat\xf3rio",
    password_required: "Senha \xe9 obrigat\xf3rio",
    username_exists: "O nome de usu\xe1rio j\xe1 existe",
    username_should_not_start_with_number: "O nome de usu\xe1rio n\xe3o deve come\xe7ar com um n\xfamero",
    username_invalid_charset: "O nome de usu\xe1rio deve conter apenas letras, n\xfameros ou sublinhados.",
    invalid_email: "O e-mail \xe9 inv\xe1lido",
    invalid_phone: "O n\xfamero de telefone \xe9 inv\xe1lido",
    passwords_do_not_match: "Suas senhas n\xe3o correspondem. Por favor, tente novamente.",
    invalid_passcode: "O c\xf3digo de verifica\xe7\xe3o \xe9 inv\xe1lido",
    invalid_connector_auth: "A autoriza\xe7\xe3o \xe9 inv\xe1lida",
    invalid_connector_request: "Os dados do conector s\xe3o inv\xe1lidos",
    unknown: "Erro desconhecido. Por favor, tente novamente mais tarde.",
    invalid_session: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    timeout: "Tempo limite excedido. Por favor, tente novamente mais tarde.",
    password_rejected: (0, $9d8a4a4b0f6e786b$export$2e2bcd8739ae039),
    sso_not_enabled: "O Single Sign-On n\xe3o est\xe1 habilitado para esta conta de e-mail."
};
var $0811f159e6e809d8$export$2e2bcd8739ae039 = Object.freeze($0811f159e6e809d8$var$error);


var $b2f05938b6746e11$var$input = {
    username: "Nome de usu\xe1rio",
    password: "Senha",
    email: "E-mail",
    phone_number: "N\xfamero de telefone",
    confirm_password: "Confirme a senha",
    search_region_code: "Pesquisar c\xf3digo de regi\xe3o",
    backup_code: "C\xf3digo de backup"
};
var $b2f05938b6746e11$export$2e2bcd8739ae039 = Object.freeze($b2f05938b6746e11$var$input);


var $24c106d91b13bc84$var$list = {
    or: "ou",
    and: "e",
    separator: ","
};
var $24c106d91b13bc84$export$2e2bcd8739ae039 = Object.freeze($24c106d91b13bc84$var$list);


var $fee4e91cfc696e47$var$mfa = {
    totp: "Senha \xfanica do aplicativo autenticador",
    webauthn: "Senha de dispositivo",
    backup_code: "C\xf3digo de backup",
    link_totp_description: "Por exemplo, Google Authenticator, etc.",
    link_webauthn_description: "Vincule seu dispositivo ou hardware USB",
    link_backup_code_description: "Gere um c\xf3digo de backup",
    verify_totp_description: "Digite o c\xf3digo \xfanico no aplicativo",
    verify_webauthn_description: "Verifique seu dispositivo ou hardware USB",
    verify_backup_code_description: "Cole o c\xf3digo de backup que voc\xea salvou",
    add_mfa_factors: "Adicionar verifica\xe7\xe3o em duas etapas",
    add_mfa_description: "A verifica\xe7\xe3o em duas etapas est\xe1 ativada. Selecione seu segundo m\xe9todo de verifica\xe7\xe3o para login seguro.",
    verify_mfa_factors: "Verifica\xe7\xe3o em duas etapas",
    verify_mfa_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, selecione a segunda forma de verificar sua identidade.",
    add_authenticator_app: "Adicionar aplicativo autenticador",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Escanear este c\xf3digo QR",
    scan_qr_code_description: "Escanee o seguinte c\xf3digo QR com seu aplicativo autenticador, como Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "N\xe3o consegue escanear o c\xf3digo QR?",
    copy_and_paste_key: "Copiar e colar a chave",
    copy_and_paste_key_description: "Copie e cole a seguinte chave no seu aplicativo autenticador, como Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Quer escanear o c\xf3digo QR?",
    enter_one_time_code: "Digite o c\xf3digo \xfanico",
    enter_one_time_code_link_description: "Digite o c\xf3digo de verifica\xe7\xe3o de 6 d\xedgitos gerado pelo aplicativo autenticador.",
    enter_one_time_code_description: "A verifica\xe7\xe3o em duas etapas foi habilitada para esta conta. Por favor, insira o c\xf3digo de uso \xfanico mostrado no seu aplicativo autenticador vinculado.",
    link_another_mfa_factor: "Trocar para outro m\xe9todo",
    save_backup_code: "Salve seu c\xf3digo de backup",
    save_backup_code_description: "Voc\xea pode usar um desses c\xf3digos de backup para acessar sua conta se tiver problemas durante a verifica\xe7\xe3o em duas etapas de outras maneiras. Cada c\xf3digo pode ser usado apenas uma vez.",
    backup_code_hint: "Certifique-se de copi\xe1-los e salvar em um local seguro.",
    enter_a_backup_code: "Digite um c\xf3digo de backup",
    enter_backup_code_description: "Digite o c\xf3digo de backup que voc\xea salvou quando a verifica\xe7\xe3o em duas etapas foi ativada inicialmente.",
    create_a_passkey: "Criar uma senha",
    create_passkey_description: "Registre sua senha usando biometria do dispositivo, chaves de seguran\xe7a (por exemplo, YubiKey) ou outros m\xe9todos dispon\xedveis.",
    try_another_verification_method: "Experimente outro m\xe9todo de verifica\xe7\xe3o",
    verify_via_passkey: "Verificar via senha",
    verify_via_passkey_description: "Use a senha para verificar por meio da senha do seu dispositivo ou biometria, escaneando o c\xf3digo QR ou usando uma chave de seguran\xe7a USB como a YubiKey.",
    secret_key_copied: "Chave secreta copiada.",
    backup_code_copied: "C\xf3digo de backup copiado.",
    webauthn_not_ready: "WebAuthn ainda n\xe3o est\xe1 pronto. Por favor, tente novamente mais tarde.",
    webauthn_not_supported: "WebAuthn n\xe3o \xe9 suportado neste navegador.",
    webauthn_failed_to_create: "Falha ao criar. Por favor, tente novamente.",
    webauthn_failed_to_verify: "Falha ao verificar. Por favor, tente novamente."
};
var $fee4e91cfc696e47$export$2e2bcd8739ae039 = Object.freeze($fee4e91cfc696e47$var$mfa);


var $575454ef558fdb22$var$secondary = {
    social_bind_with: "J\xe1 tinha uma conta? Fa\xe7a login no link {{methods, list(type: disjunction;)}} com sua identidade social."
};
var $575454ef558fdb22$export$2e2bcd8739ae039 = Object.freeze($575454ef558fdb22$var$secondary);


var $493c4f6b90b46f78$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $493c4f6b90b46f78$export$2e2bcd8739ae039 = Object.freeze($493c4f6b90b46f78$var$user_scopes);


var $c8b6501141c8c172$var$pt_br = {
    translation: {
        input: (0, $b2f05938b6746e11$export$2e2bcd8739ae039),
        secondary: (0, $575454ef558fdb22$export$2e2bcd8739ae039),
        action: (0, $d23787479919a64c$export$2e2bcd8739ae039),
        description: (0, $ff20e01a376ec829$export$2e2bcd8739ae039),
        error: (0, $0811f159e6e809d8$export$2e2bcd8739ae039),
        list: (0, $24c106d91b13bc84$export$2e2bcd8739ae039),
        mfa: (0, $fee4e91cfc696e47$export$2e2bcd8739ae039),
        development_tenant: (0, $2ba8a4922407ee43$export$2e2bcd8739ae039),
        user_scopes: (0, $493c4f6b90b46f78$export$2e2bcd8739ae039)
    }
};
var $c8b6501141c8c172$export$2e2bcd8739ae039 = Object.freeze($c8b6501141c8c172$var$pt_br);


var $0d765a2a6c9cb340$var$action = {
    sign_in: "Entrar",
    continue: "Continuar",
    create_account: "Criar uma conta",
    create_account_without_linking: "Criar conta sem vincula\xe7\xe3o",
    create: "Criar",
    enter_passcode: "Introduzir c\xf3digo de verifica\xe7\xe3o",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Guardar palavra-passe",
    bind: "Agregar a {{address}}",
    bind_and_continue: "Ligar e continuar",
    back: "Voltar",
    nav_back: "Anterior",
    nav_skip: "Saltar",
    agree: "Aceito",
    got_it: "Entendi",
    sign_in_with: "Continuar com {{name}}",
    forgot_password: "Esqueceu-se da palavra-passe?",
    switch_to: "Mudar para {{method}}",
    sign_in_via_passcode: "Iniciar sess\xe3o com c\xf3digo de verifica\xe7\xe3o",
    sign_in_via_password: "Iniciar sess\xe3o com palavra-passe",
    change: "Alterar {{method}}",
    link_another_email: "Vincular outro email",
    link_another_phone: "Vincular outro telefone",
    link_another_email_or_phone: "Vincular outro email ou telefone",
    show_password: "Mostrar palavra-passe",
    copy: "Copiar",
    verify_via_passkey: "Verificar atrav\xe9s de chave de acesso",
    download: "Transferir",
    single_sign_on: "Logon \xdanico",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $0d765a2a6c9cb340$export$2e2bcd8739ae039 = Object.freeze($0d765a2a6c9cb340$var$action);


var $9e00202f2f9b0bf3$var$description = {
    email: "email",
    phone_number: "telefone",
    username: "utilizador",
    reminder: "Lembrete",
    not_found: "404 N\xe3o encontrado",
    agree_with_terms: "Eu li e concordo com os ",
    agree_with_terms_modal: "Para prosseguir, por favor, concorde com o <link></link>.",
    terms_of_use: "Termos de uso",
    sign_in: "Entrar",
    privacy_policy: "Pol\xedtica de privacidade",
    create_account: "Criar uma conta",
    or: "ou",
    and: "e",
    enter_passcode: "O c\xf3digo de verifica\xe7\xe3o foi enviado para o seu {{address}} {{target}}",
    passcode_sent: "O c\xf3digo de verifica\xe7\xe3o foi reenviado",
    resend_after_seconds: "Reenviar ap\xf3s <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verifica\xe7\xe3o",
    create_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de fazer login?",
    link_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de vincul\xe1-la?",
    sign_in_id_does_not_exist: "A conta com {{type}} {{value}} n\xe3o existe, gostaria de criar uma?",
    sign_in_id_does_not_exist_alert: "A conta com {{type}} {{value}} n\xe3o existe.",
    create_account_id_exists_alert: "A conta com {{type}} {{value}} est\xe1 vinculada a outra conta. Por favor, tente outro {{type}}.",
    social_identity_exist: "O {{type}} {{value}} est\xe1 vinculado a outra conta. Por favor, tente outro {{type}}.",
    bind_account_title: "Vincular ou criar conta",
    social_create_account: "Pode criar uma nova conta.",
    social_link_email: "Pode vincular outro email",
    social_link_phone: "Pode vincular outro telefone",
    social_link_email_or_phone: "Pode vincular outro email ou telefone",
    social_bind_with_existing: "Encontramos uma conta relacionada registrada e voc\xea pode vincul\xe1-la diretamente.",
    reset_password: "Esqueceu a senha",
    reset_password_description: "Insira os {{types, list(type: disjunction;)}} associados \xe0 sua conta e enviaremos o c\xf3digo de verifica\xe7\xe3o para redefinir sua senha.",
    new_password: "Nova Senha",
    set_password: "Definir senha",
    password_changed: "Senha alterada",
    no_account: "Ainda n\xe3o tem conta?",
    have_account: "J\xe1 tem conta?",
    enter_password: "Digite a senha",
    enter_password_for: "Fa\xe7a login com a senha do {{method}} {{value}}",
    enter_username: "Definir nome de usu\xe1rio",
    enter_username_description: "O nome de usu\xe1rio \xe9 uma alternativa para o login. O nome de usu\xe1rio deve conter apenas letras, n\xfameros e sublinhados.",
    link_email: "Vincular email",
    link_phone: "Vincular telefone",
    link_email_or_phone: "Vincular email ou telefone",
    link_email_description: "Para maior seguran\xe7a, vincule o seu email \xe0 conta.",
    link_phone_description: "Para maior seguran\xe7a, vincule o seu telefone \xe0 conta.",
    link_email_or_phone_description: "Para maior seguran\xe7a, vincule o seu email ou telefone \xe0 conta.",
    continue_with_more_information: "Para maior seguran\xe7a, por favor complete os detalhes da conta abaixo.",
    create_your_account: "Crie a sua conta",
    sign_in_to_your_account: "Inicie sess\xe3o na sua conta",
    no_region_code_found: "N\xe3o foi poss\xedvel encontrar o c\xf3digo de regi\xe3o do seu telefone.",
    verify_email: "Verifique o seu email",
    verify_phone: "Verifique o seu n\xfamero de telefone",
    password_requirements: "Requisitos de senha {{items, list}}.",
    password_requirement: {
        length_one: "requer um m\xednimo de {{count}} caracter",
        length_other: "requer um m\xednimo de {{count}} caracteres",
        character_types_one: "deve conter pelo menos {{count}} tipo de letras mai\xfasculas, letras min\xfasculas, d\xedgitos e s\xedmbolos",
        character_types_other: "deve conter pelo menos {{count}} tipos de letras mai\xfasculas, letras min\xfasculas, d\xedgitos e s\xedmbolos"
    },
    use: "Usar",
    single_sign_on_email_form: "Insira o endere\xe7o de email corporativo",
    single_sign_on_connectors_list: "A sua empresa ativou o Single Sign-On para a conta de email {{email}}. Pode continuar a iniciar sess\xe3o com os seguintes fornecedores de SSO.",
    single_sign_on_enabled: "Esta conta tem o Single Sign-On ativado.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $9e00202f2f9b0bf3$export$2e2bcd8739ae039 = Object.freeze($9e00202f2f9b0bf3$var$description);


var $cbc8b2c1a66d665e$var$development_tenant = {
    notification: "Est\xe1s em modo de desenvolvimento"
};
var $cbc8b2c1a66d665e$export$2e2bcd8739ae039 = Object.freeze($cbc8b2c1a66d665e$var$development_tenant);


var $0a4f55a0d8ac8e22$var$password_rejected = {
    too_short: "M\xednimo de comprimento \xe9 {{min}}.",
    too_long: "M\xe1ximo de comprimento \xe9 {{max}}.",
    character_types: "S\xe3o necess\xe1rios pelo menos {{min}} tipos de caracteres.",
    unsupported_characters: "Caractere n\xe3o suportado encontrado.",
    pwned: "Evite o uso de senhas simples que s\xe3o f\xe1ceis de adivinhar.",
    restricted_found: "Evite o uso excessivo de {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres sequenciais",
        user_info: "suas informa\xe7\xf5es pessoais",
        words: "contexto do produto"
    }
};
var $0a4f55a0d8ac8e22$export$2e2bcd8739ae039 = Object.freeze($0a4f55a0d8ac8e22$var$password_rejected);


var $eb35bb6aecae1c74$var$error = {
    general_required: "{{types, list(type: disjunction;)}} is necess\xe1rio",
    general_invalid: "O {{types, list(type: disjunction;)}} \xe9 inv\xe1lido",
    username_required: "Utilizador necess\xe1rio",
    password_required: "Password necess\xe1ria",
    username_exists: "O nome de utilizador j\xe1 existe",
    username_should_not_start_with_number: "O nome de utilizador n\xe3o deve come\xe7ar com um n\xfamero",
    username_invalid_charset: "O nome de utilizador deve conter apenas letras, n\xfameros ou underscores.",
    invalid_email: "O email \xe9 inv\xe1lido",
    invalid_phone: "O n\xfamero de telefone \xe9 inv\xe1lido",
    passwords_do_not_match: "As passwords n\xe3o coincidem",
    invalid_passcode: "O c\xf3digo de verifica\xe7\xe3o \xe9 inv\xe1lido.",
    invalid_connector_auth: "A autoriza\xe7\xe3o \xe9 inv\xe1lida",
    invalid_connector_request: "Os dados do conector s\xe3o inv\xe1lidos",
    unknown: "Erro desconhecido. Por favor, tente novamente mais tarde.",
    invalid_session: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    timeout: "Tempo limite de sess\xe3o. Volte e fa\xe7a login novamente.",
    password_rejected: (0, $0a4f55a0d8ac8e22$export$2e2bcd8739ae039),
    sso_not_enabled: "O Single Sign-On n\xe3o est\xe1 habilitado para esta conta de e-mail."
};
var $eb35bb6aecae1c74$export$2e2bcd8739ae039 = Object.freeze($eb35bb6aecae1c74$var$error);


var $cbb371f737dc525d$var$input = {
    username: "Utilizador",
    password: "Palavra-passe",
    email: "Email",
    phone_number: "Telefone",
    confirm_password: "Confirmar palavra-passe",
    search_region_code: "Procurar c\xf3digo de regi\xe3o",
    backup_code: "C\xf3digo de backup"
};
var $cbb371f737dc525d$export$2e2bcd8739ae039 = Object.freeze($cbb371f737dc525d$var$input);


var $cec0d252cb47b564$var$list = {
    or: "ou",
    and: "e",
    separator: ","
};
var $cec0d252cb47b564$export$2e2bcd8739ae039 = Object.freeze($cec0d252cb47b564$var$list);


var $d200ce727697ca41$var$mfa = {
    totp: "Senha \xfanica do aplicativo autenticador",
    webauthn: "Senha de dispositivo",
    backup_code: "C\xf3digo de backup",
    link_totp_description: "Por exemplo, Google Authenticator, etc.",
    link_webauthn_description: "Vincule o seu dispositivo ou hardware USB",
    link_backup_code_description: "Gere um c\xf3digo de backup",
    verify_totp_description: "Introduza o c\xf3digo \xfanico na aplica\xe7\xe3o",
    verify_webauthn_description: "Verifique o seu dispositivo ou hardware USB",
    verify_backup_code_description: "Cole o c\xf3digo de backup que guardou",
    add_mfa_factors: "Adicionar verifica\xe7\xe3o em duas etapas",
    add_mfa_description: "A verifica\xe7\xe3o em duas etapas est\xe1 ativada. Selecione o seu segundo m\xe9todo de verifica\xe7\xe3o para iniciar sess\xe3o de forma segura.",
    verify_mfa_factors: "Verifica\xe7\xe3o em duas etapas",
    verify_mfa_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, selecione a segunda forma de verificar a sua identidade.",
    add_authenticator_app: "Adicionar aplicativo autenticador",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Digitalize este c\xf3digo QR",
    scan_qr_code_description: "Digitalize o c\xf3digo QR seguinte com a sua aplica\xe7\xe3o autenticadora, como o Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "N\xe3o consegue digitalizar o c\xf3digo QR?",
    copy_and_paste_key: "Copiar e colar a chave",
    copy_and_paste_key_description: "Copie e cole a seguinte chave na sua aplica\xe7\xe3o autenticadora, como o Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Quer digitalizar o c\xf3digo QR?",
    enter_one_time_code: "Introduza o c\xf3digo \xfanico",
    enter_one_time_code_link_description: "Introduza o c\xf3digo de verifica\xe7\xe3o de 6 d\xedgitos gerado pela aplica\xe7\xe3o autenticadora.",
    enter_one_time_code_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, insira o c\xf3digo de utiliza\xe7\xe3o \xfanica mostrado na sua aplica\xe7\xe3o autenticadora vinculada.",
    link_another_mfa_factor: "Mudar para outro m\xe9todo",
    save_backup_code: "Guarde o seu c\xf3digo de backup",
    save_backup_code_description: "Pode usar um destes c\xf3digos de backup para aceder \xe0 sua conta se tiver problemas durante a verifica\xe7\xe3o em duas etapas de outras formas. Cada c\xf3digo s\xf3 pode ser utilizado uma vez.",
    backup_code_hint: "Certifique-se de os copiar e guardar num local seguro.",
    enter_a_backup_code: "Introduza um c\xf3digo de backup",
    enter_backup_code_description: "Introduza o c\xf3digo de backup que guardou quando a verifica\xe7\xe3o em duas etapas foi ativada inicialmente.",
    create_a_passkey: "Criar uma palavra-passe",
    create_passkey_description: "Registe a sua palavra-passe utilizando a biometria do dispositivo, chaves de seguran\xe7a (por exemplo, YubiKey) ou outros m\xe9todos dispon\xedveis.",
    try_another_verification_method: "Experimente outro m\xe9todo de verifica\xe7\xe3o",
    verify_via_passkey: "Verificar atrav\xe9s da palavra-passe",
    verify_via_passkey_description: "Utilize a palavra-passe para verificar atrav\xe9s da senha do seu dispositivo ou biometria, digitalizando o c\xf3digo QR ou utilizando uma chave de seguran\xe7a USB como a YubiKey.",
    secret_key_copied: "Chave secreta copiada.",
    backup_code_copied: "C\xf3digo de backup copiado.",
    webauthn_not_ready: "O WebAuthn ainda n\xe3o est\xe1 pronto. Por favor, tente novamente mais tarde.",
    webauthn_not_supported: "O WebAuthn n\xe3o \xe9 suportado neste navegador.",
    webauthn_failed_to_create: "Falha ao criar. Por favor, tente novamente.",
    webauthn_failed_to_verify: "Falha ao verificar. Por favor, tente novamente."
};
var $d200ce727697ca41$export$2e2bcd8739ae039 = Object.freeze($d200ce727697ca41$var$mfa);


var $3081aef7ef1d96c6$var$secondary = {
    social_bind_with: "J\xe1 tem uma conta? Fa\xe7a login para agregar {{methods, list(type: disjunction;)}} com a sua identidade social."
};
var $3081aef7ef1d96c6$export$2e2bcd8739ae039 = Object.freeze($3081aef7ef1d96c6$var$secondary);


var $219bcd15eaa470af$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $219bcd15eaa470af$export$2e2bcd8739ae039 = Object.freeze($219bcd15eaa470af$var$user_scopes);


var $102e9d308a850bb4$var$pt_pt = {
    translation: {
        input: (0, $cbb371f737dc525d$export$2e2bcd8739ae039),
        secondary: (0, $3081aef7ef1d96c6$export$2e2bcd8739ae039),
        action: (0, $0d765a2a6c9cb340$export$2e2bcd8739ae039),
        description: (0, $9e00202f2f9b0bf3$export$2e2bcd8739ae039),
        error: (0, $eb35bb6aecae1c74$export$2e2bcd8739ae039),
        list: (0, $cec0d252cb47b564$export$2e2bcd8739ae039),
        mfa: (0, $d200ce727697ca41$export$2e2bcd8739ae039),
        development_tenant: (0, $cbc8b2c1a66d665e$export$2e2bcd8739ae039),
        user_scopes: (0, $219bcd15eaa470af$export$2e2bcd8739ae039)
    }
};
var $102e9d308a850bb4$export$2e2bcd8739ae039 = Object.freeze($102e9d308a850bb4$var$pt_pt);


var $4bdc02655ec7df61$var$action = {
    sign_in: "Войти",
    continue: "Продолжить",
    create_account: "Создать аккаунт",
    create_account_without_linking: "Создать аккаунт без связывания",
    create: "Создать",
    enter_passcode: "Введите код подтверждения",
    confirm: "Подтвердить",
    cancel: "Отменить",
    save_password: "Сохраните пароль",
    bind: "Привязать к {{address}}",
    bind_and_continue: "Привязать и продолжить",
    back: "Назад",
    nav_back: "Назад",
    nav_skip: "Пропустить",
    agree: "Согласен",
    got_it: "Понял",
    sign_in_with: "Войти через {{name}}",
    forgot_password: "Забыли пароль?",
    switch_to: "Изменить на {{method}}",
    sign_in_via_passcode: "Войти с кодом подтверждения",
    sign_in_via_password: "Войти с паролем",
    change: "Изменить {{method}}",
    link_another_email: "Привязать другую почту",
    link_another_phone: "Привязать другой номер",
    link_another_email_or_phone: "Привязать другую почту или номер",
    show_password: "Показать пароль",
    copy: "Копировать",
    verify_via_passkey: "Проверить с помощью ключа доступа",
    download: "Скачать",
    single_sign_on: "Единый вход",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $4bdc02655ec7df61$export$2e2bcd8739ae039 = Object.freeze($4bdc02655ec7df61$var$action);


var $2233d403541781e6$var$description = {
    email: "адрес электронной почты",
    phone_number: "номер телефона",
    username: "имя пользователя",
    reminder: "Напоминание",
    not_found: "404 Не найдено",
    agree_with_terms: "Я прочитал и согласен с ",
    agree_with_terms_modal: "Чтобы продолжить, пожалуйста, согласитесь с <link></link>",
    terms_of_use: "Условиями использования",
    sign_in: "Войти",
    privacy_policy: "Политикой конфиденциальности",
    create_account: "Создать аккаунт",
    or: "или",
    and: "и",
    enter_passcode: "Код подтверждения был отправлен на {{address}}",
    passcode_sent: "Код подтверждения был отправлен повторно",
    resend_after_seconds: "Отправить повторно через <span>{{seconds}}</span> сек.",
    resend_passcode: "Отправить повторно",
    create_account_id_exists: "Учетная запись для {{value}} уже существует, хотите войти?",
    link_account_id_exists: "Учетная запись для {{value}} уже существует, хотите привязать?",
    sign_in_id_does_not_exist: "Учетная запись для {{value}} не существует, хотите зарегистрироваться?",
    sign_in_id_does_not_exist_alert: "Учетная запись для {{value}} не существует.",
    create_account_id_exists_alert: "Аккаунт с {{type}} {{value}} связан с другим аккаунтом. Пожалуйста, попробуйте другой {{type}}.",
    social_identity_exist: "{{type}} {{value}} связан с другим аккаунтом. Пожалуйста, попробуйте другой {{type}}.",
    bind_account_title: "Привязать или создать аккаунт",
    social_create_account: "Вы можете создать новую учетную запись.",
    social_link_email: "Вы можете привязать другой адрес электронной почты",
    social_link_phone: "Вы можете привязать другой номер телефона",
    social_link_email_or_phone: "Вы можете привязать другой адрес электронной почты или телефон",
    social_bind_with_existing: "Мы находим зарегистрированную связанную учетную запись, и вы можете связать ее напрямую.",
    reset_password: "Забыли пароль",
    reset_password_description: "Введите {{types, list(type: disjunction;)}} от вашей учетной записи, и мы вышлем вам код для восстановления пароля.",
    new_password: "Новый пароль",
    set_password: "Задать пароль",
    password_changed: "Пароль изменен",
    no_account: "Еще не зарегистрированы? ",
    have_account: "Уже есть аккаунт?",
    enter_password: "Введите пароль",
    enter_password_for: "Введите пароль для {{value}}",
    enter_username: "Установить имя пользователя",
    enter_username_description: "Имя пользователя является альтернативой для входа в систему. Имя пользователя должно содержать только буквы, цифры и символы подчеркивания.",
    link_email: "Привязать почту",
    link_phone: "Привязать номер телефона",
    link_email_or_phone: "Привязать почту или номер телефона",
    link_email_description: "Для дополнительной безопасности, пожалуйста, привяжите свою электронную почту к учетной записи.",
    link_phone_description: "Для дополнительной безопасности, пожалуйста, привяжите свой номер телефона к учетной записи.",
    link_email_or_phone_description: "Для дополнительной безопасности, пожалуйста, привяжите свою электронную почту или номер телефона к учетной записи.",
    continue_with_more_information: "Для дополнительной безопасности, пожалуйста, заполните приведенные ниже данные учетной записи.",
    create_your_account: "Создайте свой аккаунт",
    sign_in_to_your_account: "Войди в свой аккаунт",
    no_region_code_found: "Не удалось определить код региона",
    verify_email: "Подтвердите Ваш электронный адрес",
    verify_phone: "Подтвердите свой номер телефона",
    password_requirements: "Требования к паролю {{items, list}}.",
    password_requirement: {
        length_one: "требуется минимум {{count}} символ",
        length_other: "требуется минимум {{count}} символов",
        character_types_one: "должен содержать по крайней мере {{count}} тип прописных букв, строчных букв, цифр и символов",
        character_types_other: "должен содержать по крайней мере {{count}} типа прописных букв, строчных букв, цифр и символов"
    },
    use: "Использовать",
    single_sign_on_email_form: "Введите корпоративный адрес электронной почты",
    single_sign_on_connectors_list: "Ваше предприятие включило функцию единого входа для электронной почты {{email}}. Вы можете продолжить вход в систему с помощью следующих провайдеров SSO.",
    single_sign_on_enabled: "Единый вход в систему включен для этой учетной записи",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $2233d403541781e6$export$2e2bcd8739ae039 = Object.freeze($2233d403541781e6$var$description);


var $c154094824560923$var$development_tenant = {
    notification: "Вы в режиме разработки"
};
var $c154094824560923$export$2e2bcd8739ae039 = Object.freeze($c154094824560923$var$development_tenant);


var $df0bcd2c7b2f3ade$var$password_rejected = {
    too_short: "Минимальная длина {{min}} символов.",
    too_long: "Максимальная длина {{max}} символов.",
    character_types: "Требуется как минимум {{min}} типов символов.",
    unsupported_characters: "Найден неподдерживаемый символ.",
    pwned: "Избегайте использования простых паролей, которые легко угадать.",
    restricted_found: "Избегайте чрезмерного использования {{list,list}}.",
    restricted: {
        repetition: "повторяющиеся символы",
        sequence: "последовательные символы",
        user_info: "ваши личные данные",
        words: "контекст продукта"
    }
};
var $df0bcd2c7b2f3ade$export$2e2bcd8739ae039 = Object.freeze($df0bcd2c7b2f3ade$var$password_rejected);


var $8f943590770b3ecd$var$error = {
    general_required: "Введите {{types, list(type: disjunction;)}}",
    general_invalid: "Проверьте {{types, list(type: disjunction;)}}",
    username_required: "Введите имя пользователя",
    password_required: "Введите пароль",
    username_exists: "Имя пользователя занято",
    username_should_not_start_with_number: "Имя пользователя не должно начинаться с цифры",
    username_invalid_charset: "Имя пользователя должно содержать только буквы, цифры или символы подчеркивания",
    invalid_email: "Электронная почта указана неправильно",
    invalid_phone: "Номер телефона указан неправильно",
    passwords_do_not_match: "Пароли не совпадают. Пожалуйста, попробуйте еще раз.",
    invalid_passcode: "Неправильный код подтверждения",
    invalid_connector_auth: "Авторизация недействительна",
    invalid_connector_request: "Данные коннектора недействительны.",
    unknown: "Неизвестная ошибка. Пожалуйста, повторите попытку позднее.",
    invalid_session: "Сессия не найдена. Пожалуйста, войдите снова.",
    timeout: "Время ожидания истекло. Пожалуйста, повторите попытку позднее.",
    password_rejected: (0, $df0bcd2c7b2f3ade$export$2e2bcd8739ae039),
    sso_not_enabled: "Односторонняя авторизация не включена для этого аккаунта электронной почты."
};
var $8f943590770b3ecd$export$2e2bcd8739ae039 = Object.freeze($8f943590770b3ecd$var$error);


var $3daa20cc8fcb093b$var$input = {
    username: "Имя пользователя",
    password: "Пароль",
    email: "Электронная почта",
    phone_number: "Номер телефона",
    confirm_password: "Подтверждение пароля",
    search_region_code: "Поиск кода региона",
    backup_code: "Резервный код"
};
var $3daa20cc8fcb093b$export$2e2bcd8739ae039 = Object.freeze($3daa20cc8fcb093b$var$input);


var $27f36c5ff0296618$var$list = {
    or: "или",
    and: "и",
    separator: ","
};
var $27f36c5ff0296618$export$2e2bcd8739ae039 = Object.freeze($27f36c5ff0296618$var$list);


var $11ecae600e4e34d0$var$mfa = {
    totp: "Одноразовый пароль приложения для аутентификации",
    webauthn: "Пароль",
    backup_code: "Резервный код",
    link_totp_description: "Например, Google Authenticator и др.",
    link_webauthn_description: "Привяжите ваше устройство или USB-ключ",
    link_backup_code_description: "Создайте резервный код",
    verify_totp_description: "Введите одноразовый код в приложении",
    verify_webauthn_description: "Подтвердите ваше устройство или USB-ключ",
    verify_backup_code_description: "Вставьте резервный код, который вы сохранили",
    add_mfa_factors: "Добавить двухфакторную аутентификацию",
    add_mfa_description: "Включена двухфакторная аутентификация. Выберите второй метод для безопасного входа.",
    verify_mfa_factors: "Двухфакторная аутентификация",
    verify_mfa_description: "Двухфакторная аутентификация включена для этого аккаунта. Выберите второй способ подтверждения вашей личности.",
    add_authenticator_app: "Добавить приложение для аутентификации",
    step: "Шаг {{step, number}}: {{content}}",
    scan_qr_code: "Отсканируйте этот QR-код",
    scan_qr_code_description: "Отсканируйте следующий QR-код с помощью вашего приложения для аутентификации, такого как Google Authenticator, Duo Mobile, Authy и др.",
    qr_code_not_available: "Нельзя отсканировать QR-код?",
    copy_and_paste_key: "Скопируйте и вставьте ключ",
    copy_and_paste_key_description: "Скопируйте и вставьте следующий ключ в ваше приложение для аутентификации, такое как Google Authenticator, Duo Mobile, Authy и др.",
    want_to_scan_qr_code: "Хотите отсканировать QR-код?",
    enter_one_time_code: "Введите одноразовый код",
    enter_one_time_code_link_description: "Введите 6-значный код, сгенерированный приложением для аутентификации.",
    enter_one_time_code_description: "Для этого аккаунта включена двухэтапная аутентификация. Введите одноразовый код, отображаемый в вашем связанном приложении для аутентификации.",
    link_another_mfa_factor: "Переключиться на другой метод",
    save_backup_code: "Сохраните ваш резервный код",
    save_backup_code_description: "Вы можете использовать один из этих резервных кодов для доступа к своему аккаунту, если у вас возникнут проблемы с двухфакторной аутентификацией другим способом. Каждый код может быть использован только один раз.",
    backup_code_hint: "Убедитесь, что вы скопировали и сохранили их в надежном месте.",
    enter_a_backup_code: "Введите резервный код",
    enter_backup_code_description: "Введите резервный код, который вы сохранили при включении двухфакторной аутентификации.",
    create_a_passkey: "Создать код доступа",
    create_passkey_description: "Зарегистрируйте свой код доступа с использованием биометрических данных устройства, ключей безопасности (например, YubiKey) или других доступных методов.",
    try_another_verification_method: "Попробуйте другой метод подтверждения",
    verify_via_passkey: "Подтвердите через код доступа",
    verify_via_passkey_description: "Используйте код доступа для подтверждения с помощью пароля устройства или биометрии, сканирования QR-кода или использования USB-ключа безопасности, такого как YubiKey.",
    secret_key_copied: "Ключ скопирован.",
    backup_code_copied: "Резервный код скопирован.",
    webauthn_not_ready: "WebAuthn еще не готов. Пожалуйста, попробуйте позже.",
    webauthn_not_supported: "WebAuthn не поддерживается в этом браузере.",
    webauthn_failed_to_create: "Не удалось создать. Пожалуйста, попробуйте еще раз.",
    webauthn_failed_to_verify: "Не удалось проверить. Пожалуйста, попробуйте еще раз."
};
var $11ecae600e4e34d0$export$2e2bcd8739ae039 = Object.freeze($11ecae600e4e34d0$var$mfa);


var $3da179ffb14ed179$var$secondary = {
    social_bind_with: "Уже есть аккаунт? Войдите, чтобы привязать {{methods, list(type: disjunction;)}}."
};
var $3da179ffb14ed179$export$2e2bcd8739ae039 = Object.freeze($3da179ffb14ed179$var$secondary);


var $710b9b340a175e37$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $710b9b340a175e37$export$2e2bcd8739ae039 = Object.freeze($710b9b340a175e37$var$user_scopes);


var $438d6e5ceb1ea704$var$ru = {
    translation: {
        input: (0, $3daa20cc8fcb093b$export$2e2bcd8739ae039),
        secondary: (0, $3da179ffb14ed179$export$2e2bcd8739ae039),
        action: (0, $4bdc02655ec7df61$export$2e2bcd8739ae039),
        description: (0, $2233d403541781e6$export$2e2bcd8739ae039),
        error: (0, $8f943590770b3ecd$export$2e2bcd8739ae039),
        list: (0, $27f36c5ff0296618$export$2e2bcd8739ae039),
        mfa: (0, $11ecae600e4e34d0$export$2e2bcd8739ae039),
        development_tenant: (0, $c154094824560923$export$2e2bcd8739ae039),
        user_scopes: (0, $710b9b340a175e37$export$2e2bcd8739ae039)
    }
};
var $438d6e5ceb1ea704$export$2e2bcd8739ae039 = Object.freeze($438d6e5ceb1ea704$var$ru);


var $7467a292a7893e58$var$action = {
    sign_in: "Giriş Yap",
    continue: "İlerle",
    create_account: "Hesap Oluştur",
    create_account_without_linking: "Bağlamadan hesap oluştur",
    create: "Oluştur",
    enter_passcode: "Doğrulama kodunu girin",
    confirm: "Onayla",
    cancel: "İptal Et",
    save_password: "Şifreyi kaydet",
    bind: "{{address}} ile birleştir",
    bind_and_continue: "Bağla ve devam et",
    back: "Geri D\xf6n",
    nav_back: "Geri",
    nav_skip: "Atla",
    agree: "Kabul Et",
    got_it: "Anladım",
    sign_in_with: "{{name}} ile ilerle",
    forgot_password: "Şifremi Unuttum?",
    switch_to: "{{method}} y\xf6ntemine ge\xe7",
    sign_in_via_passcode: "Doğrulama koduyla oturum a\xe7ın",
    sign_in_via_password: "şifre ile giriş yap",
    change: "{{method}} değiştir",
    link_another_email: "Başka bir e-postayı bağla",
    link_another_phone: "Başka bir telefon bağla",
    link_another_email_or_phone: "Başka bir e-posta veya telefon bağlayın",
    show_password: "Şifreyi g\xf6ster",
    copy: "Kopyala",
    verify_via_passkey: "Parola ile doğrula",
    download: "İndir",
    single_sign_on: "Tek oturum a\xe7ma",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $7467a292a7893e58$export$2e2bcd8739ae039 = Object.freeze($7467a292a7893e58$var$action);


var $7888da350ea84557$var$description = {
    email: "e-posta adresi",
    phone_number: "telefon numarası",
    username: "kullanıcı Adı",
    reminder: "Hatırlatıcı",
    not_found: "404 Bulunamadı",
    agree_with_terms: "Okudum ve anladım",
    agree_with_terms_modal: "Devam etmek i\xe7in l\xfctfen <link></link>'i kabul edin.",
    terms_of_use: "Kullanım Koşulları",
    sign_in: "Giriş Yap",
    privacy_policy: "Gizlilik Politikası",
    create_account: "Hesap Oluştur",
    or: "veya",
    and: "ve",
    enter_passcode: "Doğrulama kodu {{address}} {{target}} adresinize g\xf6nderildi",
    passcode_sent: "Doğrulama kodu yeniden g\xf6nderildi",
    resend_after_seconds: "<span>{{seconds}}</span> saniye sonra tekrar g\xf6nder",
    resend_passcode: "Doğrulama kodunu tekrar g\xf6nder",
    create_account_id_exists: "{{type}} {{value}} ile hesap mevcut, giriş yapmak ister misiniz?",
    link_account_id_exists: "{{type}} {{value}} olan hesap zaten var, bağlamak ister misiniz?",
    sign_in_id_does_not_exist: "{{type}} {{value}} ile hesap mevcut değil, yeni bir hesap oluşturmak ister misiniz?",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}} olan hesap mevcut değil.",
    create_account_id_exists_alert: "{{type}} {{value}} olan hesap başka bir hesaba bağlı. L\xfctfen başka bir {{type}} deneyin.",
    social_identity_exist: "{{type}} {{value}} başka bir hesaba bağlı. L\xfctfen başka bir {{type}} deneyin.",
    bind_account_title: "Bağla veya hesap oluştur",
    social_create_account: "Yeni bir hesap oluşturabilirsiniz.",
    social_link_email: "Başka bir e-posta bağlayabilirsiniz",
    social_link_phone: "Başka bir telefon bağlayabilirsiniz",
    social_link_email_or_phone: "Başka bir e-posta veya telefon bağlayabilirsiniz",
    social_bind_with_existing: "Kayıtlı ilgili bir hesap bulduk ve onu doğrudan bağlayabilirsiniz.",
    reset_password: "Parolanızı mı unuttunuz",
    reset_password_description: "Hesabınızla ilişkili {{types, list(type: disjunction;)}} girin, şifrenizi sıfırlamanız i\xe7in size doğrulama kodunu g\xf6ndereceğiz.",
    new_password: "Yeni Şifre",
    set_password: "Şifreyi belirle",
    password_changed: "Şifre değişti",
    no_account: "Hen\xfcz hesap yok mu?",
    have_account: "Zaten bir hesabınız var mıydı?",
    enter_password: "Parolanı Gir",
    enter_password_for: "{{method}} {{value}} şifresiyle oturum a\xe7ın",
    enter_username: "Kullanıcı adını ayarla",
    enter_username_description: "Kullanıcı adı, oturum a\xe7mak i\xe7in bir alternatiftir. Kullanıcı adı yalnızca harf, sayı ve alt \xe7izgi i\xe7ermelidir.",
    link_email: "E-postayı bağla",
    link_phone: "Telefonu bağla",
    link_email_or_phone: "E-posta veya telefon bağlantısı",
    link_email_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen e-postanızı hesapla ilişkilendirin.",
    link_phone_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen telefonunuzu hesaba bağlayın.",
    link_email_or_phone_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen e-postanızı veya telefonunuzu hesaba bağlayın.",
    continue_with_more_information: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen aşağıdaki hesap ayrıntılarını tamamlayın.",
    create_your_account: "Hesabını oluştur",
    sign_in_to_your_account: "Hesabına giriş yap",
    no_region_code_found: "B\xf6lge kodu bulunamadı",
    verify_email: "E-postanızın doğrulanması",
    verify_phone: "Telefon numaranızın doğrulanması",
    password_requirements: "Şifre {{items, list}}.",
    password_requirement: {
        length_one: "en az {{count}} karakter gerektirir",
        length_other: "en az {{count}} karakter gerektirir",
        character_types_one: "en az {{count}} tane b\xfcy\xfck harf, k\xfc\xe7\xfck harf, rakam ve sembol i\xe7ermelidir",
        character_types_other: "en az {{count}} tane b\xfcy\xfck harf, k\xfc\xe7\xfck harf, rakam ve sembol i\xe7ermelidir"
    },
    use: "Kullan",
    single_sign_on_email_form: "Kurumsal e-posta adresinizi girin",
    single_sign_on_connectors_list: "Şirketiniz, {{email}} e-posta hesabı i\xe7in Tekli Oturum A\xe7mayı (Single Sign-On) etkinleştirdi. Aşağıdaki SSO sağlayıcıları ile oturum a\xe7maya devam edebilirsiniz.",
    single_sign_on_enabled: "Bu hesapta Tekli Oturum A\xe7ma etkinleştirildi.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $7888da350ea84557$export$2e2bcd8739ae039 = Object.freeze($7888da350ea84557$var$description);


var $268dbc8ac5e3e799$var$development_tenant = {
    notification: "Geliştirme modundasın"
};
var $268dbc8ac5e3e799$export$2e2bcd8739ae039 = Object.freeze($268dbc8ac5e3e799$var$development_tenant);


var $85e45d9fa7f894cb$var$password_rejected = {
    too_short: "Minimum length is {{min}}.",
    too_long: "Maximum length is {{max}}.",
    character_types: "En az {{min}} t\xfcrde karakter gereklidir.",
    unsupported_characters: "Desteklenmeyen karakter bulundu.",
    pwned: "Kolayca tahmin edilebilen basit şifreleri kullanmaktan ka\xe7ının.",
    restricted_found: "{{list, list}} fazla kullanımdan ka\xe7ının.",
    restricted: {
        repetition: "tekrarlanan karakterler",
        sequence: "dizisel karakterler",
        user_info: "kişisel bilgileriniz",
        words: "\xfcr\xfcnle ilgili terimler"
    }
};
var $85e45d9fa7f894cb$export$2e2bcd8739ae039 = Object.freeze($85e45d9fa7f894cb$var$password_rejected);


var $ee35e69a9a81508b$var$error = {
    general_required: "{{types, list(type: disjunction;)}} gerekli",
    general_invalid: "{{types, list(type: disjunction;)}} ge\xe7ersiz",
    username_required: "Kullanıcı adı gerekli.",
    password_required: "Şifre gerekli.",
    username_exists: "Kullanıcı adı mevcut.",
    username_should_not_start_with_number: "Kullanıcı adı sayı ile başlayamaz.",
    username_invalid_charset: "Kullanıcı adı yalnızca harf,sayı veya alt \xe7izgi i\xe7ermeli.",
    invalid_email: "E-posta adresi ge\xe7ersiz",
    invalid_phone: "Telefon numarası ge\xe7ersiz",
    passwords_do_not_match: "Şifreler eşleşmiyor",
    invalid_passcode: "Doğrulama kodu ge\xe7ersiz",
    invalid_connector_auth: "Yetki ge\xe7ersiz",
    invalid_connector_request: "Bağlayıcı veri ge\xe7ersiz",
    unknown: "Bilinmeyen hata. L\xfctfen daha sonra tekrar deneyiniz.",
    invalid_session: "Oturum bulunamadı. L\xfctfen geri d\xf6n\xfcp tekrar giriş yapınız.",
    timeout: "Oturum zaman aşımına uğradı. L\xfctfen geri d\xf6n\xfcp tekrar giriş yapınız.",
    password_rejected: (0, $85e45d9fa7f894cb$export$2e2bcd8739ae039),
    sso_not_enabled: "Bu e-posta hesabı i\xe7in tek oturum a\xe7ma etkin değil."
};
var $ee35e69a9a81508b$export$2e2bcd8739ae039 = Object.freeze($ee35e69a9a81508b$var$error);


var $2a1eda7529b5599c$var$input = {
    username: "Kullanıcı Adı",
    password: "Şifre",
    email: "E-posta Adresi",
    phone_number: "Telefon Numarası",
    confirm_password: "Şifreyi Doğrula",
    search_region_code: "B\xf6lge kodunu ara",
    backup_code: "Yedek kod"
};
var $2a1eda7529b5599c$export$2e2bcd8739ae039 = Object.freeze($2a1eda7529b5599c$var$input);


var $e6c32dbf6e7db22d$var$list = {
    or: "veya",
    and: "ve",
    separator: ","
};
var $e6c32dbf6e7db22d$export$2e2bcd8739ae039 = Object.freeze($e6c32dbf6e7db22d$var$list);


var $fb24705fc42e4136$var$mfa = {
    totp: "Authenticator uygulaması OTP",
    webauthn: "Anahtar",
    backup_code: "Yedek kod",
    link_totp_description: "\xd6rn., Google Authenticator, vb.",
    link_webauthn_description: "Cihazınızı veya USB donanımınızı bağlayın",
    link_backup_code_description: "Yedek kod oluşturun",
    verify_totp_description: "Uygulamadaki tek kullanımlık kodu girin",
    verify_webauthn_description: "Cihazınızı veya USB donanımınızı doğrulayın",
    verify_backup_code_description: "Kaydettiğiniz yedek kodu yapıştırın",
    add_mfa_factors: "2 aşamalı doğrulamayı ekle",
    add_mfa_description: "İki fakt\xf6rl\xfc doğrulama etkin. G\xfcvenli giriş i\xe7in ikinci doğrulama y\xf6nteminizi se\xe7in.",
    verify_mfa_factors: "2 aşamalı doğrulama",
    verify_mfa_description: "Bu hesap i\xe7in 2 aşamalı doğrulama etkinleştirildi. L\xfctfen kimliğinizi doğrulamak i\xe7in ikinci yolu se\xe7in.",
    add_authenticator_app: "Authenticator uygulaması ekle",
    step: "Adım {{step, number}}: {{content}}",
    scan_qr_code: "Bu QR kodunu tarayın",
    scan_qr_code_description: "Bu QR kodunu authenticator uygulamanızla tarayın, \xf6rneğin Google Authenticator, Duo Mobile, Authy, vb.",
    qr_code_not_available: "QR kodu taranamıyor mu?",
    copy_and_paste_key: "Anahtarı kopyala ve yapıştır",
    copy_and_paste_key_description: "Aşağıdaki anahtarı authenticator uygulamanıza kopyala ve yapıştır, \xf6rneğin Google Authenticator, Duo Mobile, Authy, vb.",
    want_to_scan_qr_code: "QR kodunu tarımak mı istiyorsunuz?",
    enter_one_time_code: "Tek kullanımlık kodu girin",
    enter_one_time_code_link_description: "Authenticator uygulaması tarafından oluşturulan 6 haneli doğrulama kodunu girin.",
    enter_one_time_code_description: "Bu hesap i\xe7in iki aşamalı doğrulama etkinleştirildi. L\xfctfen bağlı kimlik doğrulama uygulamanızda g\xf6sterilen tek kullanımlık kodu girin.",
    link_another_mfa_factor: "Başka bir y\xf6nteme ge\xe7in",
    save_backup_code: "Yedek kodunuzu kaydedin",
    save_backup_code_description: "Başka bir y\xf6ntemle 2 aşamalı doğrulama sırasında sorun yaşarsanız bu yedek kodlardan birini kullanabilirsiniz. Her kod sadece bir kez kullanılabilir.",
    backup_code_hint: "Onları kopyalayın ve g\xfcvenli bir yerde sakladığınızdan emin olun.",
    enter_a_backup_code: "Bir yedek kod girin",
    enter_backup_code_description: "İlk olarak 2 aşamalı doğrulama etkinleştirildiğinde kaydettiğiniz yedek kodu girin.",
    create_a_passkey: "Bir anahtar oluşturun",
    create_passkey_description: "Cihaz biyometrisi, g\xfcvenlik anahtarları (\xf6rneğin YubiKey) veya diğer kullanılabilir y\xf6ntemler kullanarak anahtarınızı kaydedin.",
    try_another_verification_method: "Başka bir doğrulama y\xf6ntemini deneyin",
    verify_via_passkey: "Anahtar ile doğrula",
    verify_via_passkey_description: "Anahtar kullanarak cihaz parolanız veya biyometri ile doğrulama, QR kodunu tarama veya YubiKey gibi USB g\xfcvenlik anahtarı kullanma.",
    secret_key_copied: "Gizli anahtar kopyalandı.",
    backup_code_copied: "Yedek kod kopyalandı.",
    webauthn_not_ready: "WebAuthn hen\xfcz hazır değil. L\xfctfen daha sonra tekrar deneyin.",
    webauthn_not_supported: "Bu tarayıcıda WebAuthn desteklenmiyor.",
    webauthn_failed_to_create: "Oluşturulamadı. L\xfctfen tekrar deneyin.",
    webauthn_failed_to_verify: "Doğrulama başarısız oldu. L\xfctfen tekrar deneyin."
};
var $fb24705fc42e4136$export$2e2bcd8739ae039 = Object.freeze($fb24705fc42e4136$var$mfa);


var $e27244acaf5d03d1$var$secondary = {
    social_bind_with: "Hesabınız zaten var mı? {{methods, list(type: disjunction;)}} bağlantısına tıklayarak giriş yapabilirsiniz"
};
var $e27244acaf5d03d1$export$2e2bcd8739ae039 = Object.freeze($e27244acaf5d03d1$var$secondary);


var $cd49313c17288dd1$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $cd49313c17288dd1$export$2e2bcd8739ae039 = Object.freeze($cd49313c17288dd1$var$user_scopes);


var $f8a0b9d6cfd6eb8f$var$tr_tr = {
    translation: {
        input: (0, $2a1eda7529b5599c$export$2e2bcd8739ae039),
        secondary: (0, $e27244acaf5d03d1$export$2e2bcd8739ae039),
        action: (0, $7467a292a7893e58$export$2e2bcd8739ae039),
        description: (0, $7888da350ea84557$export$2e2bcd8739ae039),
        error: (0, $ee35e69a9a81508b$export$2e2bcd8739ae039),
        list: (0, $e6c32dbf6e7db22d$export$2e2bcd8739ae039),
        mfa: (0, $fb24705fc42e4136$export$2e2bcd8739ae039),
        development_tenant: (0, $268dbc8ac5e3e799$export$2e2bcd8739ae039),
        user_scopes: (0, $cd49313c17288dd1$export$2e2bcd8739ae039)
    }
};
var $f8a0b9d6cfd6eb8f$export$2e2bcd8739ae039 = Object.freeze($f8a0b9d6cfd6eb8f$var$tr_tr);


var $acadd9dfac87544b$var$action = {
    sign_in: "登录",
    continue: "继续",
    create_account: "注册",
    create_account_without_linking: "注册新的账号",
    create: "注册",
    enter_passcode: "输入验证码",
    confirm: "确认",
    cancel: "取消",
    save_password: "保存密码",
    bind: "绑定到 {{address}}",
    bind_and_continue: "绑定并继续",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳过",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通过 {{name}} 继续",
    forgot_password: "忘记密码？",
    switch_to: "切换到{{method}}",
    sign_in_via_passcode: "用验证码登录",
    sign_in_via_password: "密码登录",
    change: "更改{{method}}",
    link_another_email: "绑定其它邮箱",
    link_another_phone: "绑定其它手机",
    link_another_email_or_phone: "绑定邮箱或手机号",
    show_password: "显示密码",
    copy: "复制",
    verify_via_passkey: "通过 Passkey 验证",
    download: "下载",
    single_sign_on: "单点登录",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $acadd9dfac87544b$export$2e2bcd8739ae039 = Object.freeze($acadd9dfac87544b$var$action);


var $94ca7ffd218c108d$var$description = {
    email: "邮箱",
    phone_number: "手机号",
    username: "用户名",
    reminder: "提示",
    not_found: "404 页面不存在",
    agree_with_terms: "我已阅读并同意 ",
    agree_with_terms_modal: "请先同意 <link></link> 以继续",
    terms_of_use: "使用条款",
    sign_in: "登录",
    privacy_policy: "隐私政策",
    create_account: "创建帐号",
    or: "或",
    and: "和",
    enter_passcode: "验证码已经发送至你的{{ address }} {{target}}",
    passcode_sent: "验证码已经发送",
    resend_after_seconds: "在 <span>{{ seconds }}</span> 秒后重发",
    resend_passcode: "重发验证码",
    create_account_id_exists: "{{type}}为 {{value}} 的帐号已存在，你要登录吗？",
    link_account_id_exists: " {{type}}为 {{value}} 的账号已注册，你要绑定至这个账号吗？",
    sign_in_id_does_not_exist: "{{type}}为 {{value}} 的帐号不存在，你要创建一个新帐号吗？",
    sign_in_id_does_not_exist_alert: "{{type}}为 {{value}} 的帐号不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已绑定其他账号。请尝试其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已绑定其他账号。请尝试其他{{type}}",
    bind_account_title: "绑定或注册帐号",
    social_create_account: "你可以注册一个新的账号。",
    social_link_email: "你可以绑定其他邮箱",
    social_link_phone: "你可以绑定其他手机号",
    social_link_email_or_phone: "你可以绑定其他邮箱或手机号",
    social_bind_with_existing: "找到了一个已注册的账号，你可以直接绑定。",
    reset_password: "忘记密码",
    reset_password_description: "输入{{types, list(type: disjunction;)}}，获取验证码以重设密码。",
    new_password: "新密码",
    set_password: "设置密码",
    password_changed: "已重置密码！",
    no_account: "还没有账号？",
    have_account: " 已有账号？",
    enter_password: "输入密码",
    enter_password_for: "输入{{method}} {{value}} 对应的密码进行登录",
    enter_username: "设置用户名",
    enter_username_description: "用户名可以用来进行登录。用户名仅可以包含字母、数字和下划线。",
    link_email: "绑定邮箱",
    link_phone: "绑定手机",
    link_email_or_phone: "绑定邮箱或手机号",
    link_email_description: "绑定邮箱以保障你的账号安全",
    link_phone_description: "绑定手机号以保障你的账号安全",
    link_email_or_phone_description: "绑定邮箱或手机号以保障你的账号安全",
    continue_with_more_information: "为保障你的账号安全，需要你补充以下信息。",
    create_your_account: "注册你的账号",
    sign_in_to_your_account: "登录你的账号",
    no_region_code_found: "没有找到区域码",
    verify_email: "验证你的邮箱",
    verify_phone: "验证你的手机号",
    password_requirements: "密码 {{items, list}}。",
    password_requirement: {
        length_one: "应至少有 {{count}} 个字符",
        length_other: "应至少有 {{count}} 个字符",
        character_types_one: "应包含至少 {{count}} 种大写字母、小写字母、数字和符号",
        character_types_other: "应包含至少 {{count}} 种大写字母、小写字母、数字和符号"
    },
    use: "使用",
    single_sign_on_email_form: "输入你的企业电子邮件地址",
    single_sign_on_connectors_list: "你的企业已为电子邮件账户 {{email}} 启用了单点登录。你可以继续使用以下SSO提供商进行登录。",
    single_sign_on_enabled: "该帐户已启用单点登录",
    authorize_title: "授权给 {{name}}",
    request_permission: "{{name}} 需要权限：",
    grant_organization_access: "授予组织访问权限：",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    user_scopes: "用户个人信息",
    organization_scopes: "组织权限",
    authorize_agreement: "你将同意授权给 {{name}} <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "你将同意授权给 {{name}} <link></link>，然后你将被重定向到 {{uri}}。",
    not_you: "不是你本人吗？",
    user_id: "用户 ID: {{id}}",
    redirect_to: "你将被重定向到 {{name}}。"
};
var $94ca7ffd218c108d$export$2e2bcd8739ae039 = Object.freeze($94ca7ffd218c108d$var$description);


var $2947db50859468cc$var$development_tenant = {
    notification: "你处于开发模式"
};
var $2947db50859468cc$export$2e2bcd8739ae039 = Object.freeze($2947db50859468cc$var$development_tenant);


var $3656a8182885ddfa$var$password_rejected = {
    too_short: "最短长度为{{min}}。",
    too_long: "最长长度为{{max}}。",
    character_types: "需要至少{{min}}种字符类型。",
    unsupported_characters: "发现不支持的字符。",
    pwned: "避免使用容易被猜到的简单密码。",
    restricted_found: "避免过度使用{{list, list}}。",
    restricted: {
        repetition: "重复字符",
        sequence: "连续字符",
        user_info: "您的个人信息",
        words: "产品上下文"
    }
};
var $3656a8182885ddfa$export$2e2bcd8739ae039 = Object.freeze($3656a8182885ddfa$var$password_rejected);


var $75457b79c7eb3edd$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "无效的{{types, list(type: disjunction;)}}",
    username_required: "用户名必填",
    password_required: "密码必填",
    username_exists: "用户名已存在",
    username_should_not_start_with_number: "用户名不能以数字开头",
    username_invalid_charset: "用户名只能包含英文字母、数字或下划线。",
    invalid_email: "无效的邮箱",
    invalid_phone: "无效的手机号",
    passwords_do_not_match: "两次输入的密码不一致，请重试。",
    invalid_passcode: "无效的验证码",
    invalid_connector_auth: "登录失败",
    invalid_connector_request: "无效的登录请求",
    unknown: "未知错误，请稍后重试。",
    invalid_session: "未找到会话，请返回并重新登录。",
    timeout: "请求超时，请稍后重试。",
    password_rejected: (0, $3656a8182885ddfa$export$2e2bcd8739ae039),
    sso_not_enabled: "此邮箱账户未启用单点登录。"
};
var $75457b79c7eb3edd$export$2e2bcd8739ae039 = Object.freeze($75457b79c7eb3edd$var$error);


var $4289cbaab3a02877$var$input = {
    username: "用户名",
    password: "密码",
    email: "邮箱",
    phone_number: "手机号",
    confirm_password: "确认密码",
    search_region_code: "搜索区域码",
    backup_code: "备用码"
};
var $4289cbaab3a02877$export$2e2bcd8739ae039 = Object.freeze($4289cbaab3a02877$var$input);


var $5ada168f7e787ec3$var$list = {
    or: "或者",
    and: "和",
    separator: "，"
};
var $5ada168f7e787ec3$export$2e2bcd8739ae039 = Object.freeze($5ada168f7e787ec3$var$list);


var $d52ee718853ecad4$var$mfa = {
    totp: "身份验证应用 OTP",
    webauthn: "通行证",
    backup_code: "备份代码",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "链接您的设备或 USB 硬件",
    link_backup_code_description: "生成备份代码",
    verify_totp_description: "在应用程序中输入一次性代码",
    verify_webauthn_description: "验证您的设备或 USB 硬件",
    verify_backup_code_description: "粘贴您保存的备份代码",
    add_mfa_factors: "添加两步验证",
    add_mfa_description: "已启用两步验证。选择第二种验证方法以进行安全登录。",
    verify_mfa_factors: "两步验证",
    verify_mfa_description: "此帐户已启用两步验证。请选择第二种验证身份的方式。",
    add_authenticator_app: "添加身份验证应用",
    step: "步骤 {{step, number}}: {{content}}",
    scan_qr_code: "扫描此 QR 码",
    scan_qr_code_description: "使用身份验证应用程序（如 Google Authenticator、Duo Mobile、Authy 等）扫描以下 QR 码。",
    qr_code_not_available: "无法扫描 QR 码？",
    copy_and_paste_key: "复制并粘贴密钥",
    copy_and_paste_key_description: "将以下密钥复制并粘贴到身份验证应用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要扫描 QR 码吗？",
    enter_one_time_code: "输入一次性代码",
    enter_one_time_code_link_description: "输入身份验证应用生成的 6 位验证码。",
    enter_one_time_code_description: "此帐户启用了两步验证。请在你关联的认证应用中输入显示的一次性代码。",
    link_another_mfa_factor: "切换到另一种方法",
    save_backup_code: "保存您的备份代码",
    save_backup_code_description: "如果在其他方式的两步验证中遇到问题，您可以使用这些备份代码之一访问您的帐户。每个代码只能使用一次。",
    backup_code_hint: "确保复制它们并保存在安全的地方。",
    enter_a_backup_code: "输入备份代码",
    enter_backup_code_description: "输入初始启用两步验证时保存的备份代码。",
    create_a_passkey: "创建通行证",
    create_passkey_description: "使用设备生物识别、安全密钥（例如 YubiKey）或其他可用方法注册您的通行证。",
    try_another_verification_method: "尝试其他验证方法",
    verify_via_passkey: "通过通行证验证",
    verify_via_passkey_description: "使用通行证通过设备密码或生物识别、扫描 QR 码或使用 USB 安全密钥（如 YubiKey）进行验证。",
    secret_key_copied: "密钥已复制。",
    backup_code_copied: "备份代码已复制。",
    webauthn_not_ready: "WebAuthn 尚未准备就绪。请稍后重试。",
    webauthn_not_supported: "此浏览器不支持 WebAuthn。",
    webauthn_failed_to_create: "创建失败。请重试。",
    webauthn_failed_to_verify: "验证失败。请重试。"
};
var $d52ee718853ecad4$export$2e2bcd8739ae039 = Object.freeze($d52ee718853ecad4$var$mfa);


var $6cf4aa247f83d13f$var$secondary = {
    social_bind_with: "绑定到已有账户? 使用 {{methods, list(type: disjunction;), zhOrSpaces}} 登录并绑定。"
};
var $6cf4aa247f83d13f$export$2e2bcd8739ae039 = Object.freeze($6cf4aa247f83d13f$var$secondary);


var $bbb0e1301e2591c7$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $bbb0e1301e2591c7$export$2e2bcd8739ae039 = Object.freeze($bbb0e1301e2591c7$var$user_scopes);


var $e9ab744ca360fba7$var$zh_cn = {
    translation: {
        input: (0, $4289cbaab3a02877$export$2e2bcd8739ae039),
        secondary: (0, $6cf4aa247f83d13f$export$2e2bcd8739ae039),
        action: (0, $acadd9dfac87544b$export$2e2bcd8739ae039),
        description: (0, $94ca7ffd218c108d$export$2e2bcd8739ae039),
        error: (0, $75457b79c7eb3edd$export$2e2bcd8739ae039),
        list: (0, $5ada168f7e787ec3$export$2e2bcd8739ae039),
        mfa: (0, $d52ee718853ecad4$export$2e2bcd8739ae039),
        development_tenant: (0, $2947db50859468cc$export$2e2bcd8739ae039),
        user_scopes: (0, $bbb0e1301e2591c7$export$2e2bcd8739ae039)
    }
};
var $e9ab744ca360fba7$export$2e2bcd8739ae039 = Object.freeze($e9ab744ca360fba7$var$zh_cn);


var $344756ea8246c98c$var$action = {
    sign_in: "登錄",
    continue: "繼續",
    create_account: "註冊",
    create_account_without_linking: "註冊新的帳號",
    create: "註冊",
    enter_passcode: "輸入驗證碼",
    confirm: "確認",
    cancel: "取消",
    save_password: "保存密碼",
    bind: "綁定到 {{address}}",
    bind_and_continue: "綁定並繼續",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳過",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通過 {{name}} 繼續",
    forgot_password: "忘記密碼？",
    switch_to: "切換到{{method}}",
    sign_in_via_passcode: "用驗證碼登錄",
    sign_in_via_password: "密碼登錄",
    change: "更改{{method}}",
    link_another_email: "綁定其他電子郵件",
    link_another_phone: "綁定其他手機",
    link_another_email_or_phone: "綁定電子郵件或手機號碼",
    show_password: "顯示密碼",
    copy: "複製",
    verify_via_passkey: "透過 Passkey 驗證",
    download: "下載",
    single_sign_on: "單點登錄",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $344756ea8246c98c$export$2e2bcd8739ae039 = Object.freeze($344756ea8246c98c$var$action);


var $4f0e97401e2c9707$var$description = {
    email: "郵箱",
    phone_number: "手機號",
    username: "用戶名",
    reminder: "提示",
    not_found: "404 頁面不存在",
    agree_with_terms: "我已閱讀並同意 ",
    agree_with_terms_modal: "請先同意 <link></link> 以繼續",
    terms_of_use: "使用條款",
    sign_in: "登錄",
    privacy_policy: "隱私政策",
    create_account: "創建帳號",
    or: "或",
    and: "和",
    enter_passcode: "驗證碼已經發送至你的{{ address }} {{target}}",
    passcode_sent: "驗證碼已經發送",
    resend_after_seconds: "在 <span>{{ seconds }}</span> 秒後重發",
    resend_passcode: "重發驗證碼",
    create_account_id_exists: "{{type}}為 {{value}} 的帳號已存在，你要登錄嗎？",
    link_account_id_exists: " {{type}}為 {{value}} 的帳號已註冊，你要綁定至這個帳號嗎？",
    sign_in_id_does_not_exist: "{{type}}為 {{value}} 的帳號不存在，你要創建一個新帳號嗎？",
    sign_in_id_does_not_exist_alert: "{{type}}為 {{value}} 的帳號不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}",
    bind_account_title: "綁定或註冊帳號",
    social_create_account: "你可以註冊一個新的帳號。",
    social_link_email: "你可以綁定其他郵箱",
    social_link_phone: "你可以綁定其他手機號",
    social_link_email_or_phone: "你可以綁定其他郵箱或手機號",
    social_bind_with_existing: "找到了一個已註冊的帳號，你可以直接綁定。",
    reset_password: "忘記密碼",
    reset_password_description: "輸入{{types, list(type: disjunction;)}}，獲取驗證碼以重設密碼。",
    new_password: "新密碼",
    set_password: "設定密碼",
    password_changed: "已重置密碼！",
    no_account: "還沒有帳號？",
    have_account: " 已有帳號？",
    enter_password: "輸入密碼",
    enter_password_for: "輸入{{method}} {{value}} 對應的密碼進行登錄",
    enter_username: "設定用戶名",
    enter_username_description: "用戶名可以用來進行登錄。用戶名僅可以包含字母、數字和下劃線。",
    link_email: "綁定郵箱",
    link_phone: "綁定手機",
    link_email_or_phone: "綁定郵箱或手機號",
    link_email_description: "綁定郵箱以保障你的帳號安全",
    link_phone_description: "綁定手機號以保障你的帳號安全",
    link_email_or_phone_description: "綁定郵箱或手機號以保障你的帳號安全",
    continue_with_more_information: "為保障你的帳號安全，需要你補充以下信息。",
    create_your_account: "註冊你的帳號",
    sign_in_to_your_account: "登錄你的帳號",
    no_region_code_found: "沒有找到區域碼",
    verify_email: "驗證你的郵箱",
    verify_phone: "驗證你的手機號",
    password_requirements: "要求密碼 {{items, list}}。",
    password_requirement: {
        length_one: "要求至少 {{count}} 個字符",
        length_other: "要求至少 {{count}} 個字符",
        character_types_one: "要求包含至少 {{count}} 類型的大寫字母，小寫字母，數字和符號",
        character_types_other: "要求包含至少 {{count}} 類型的大寫字母，小寫字母，數字和符號"
    },
    use: "使用",
    single_sign_on_email_form: "輸入你的企業電子郵件地址",
    single_sign_on_connectors_list: "您的企業已為電郵賬戶{{email}}啟用單一登入。您可以繼續使用以下的SSO供應商登入。",
    single_sign_on_enabled: "該帳戶已啟用單一登入",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $4f0e97401e2c9707$export$2e2bcd8739ae039 = Object.freeze($4f0e97401e2c9707$var$description);


var $e8dbf44357e95082$var$development_tenant = {
    notification: "你處於開發模式"
};
var $e8dbf44357e95082$export$2e2bcd8739ae039 = Object.freeze($e8dbf44357e95082$var$development_tenant);


var $026dc924ff32be1a$var$password_rejected = {
    too_short: "最少長度為{{min}}。",
    too_long: "最大長度為{{max}}。",
    character_types: "至少需要{{min}}種類的字符。",
    unsupported_characters: "發現不支援的字符。",
    pwned: "避免使用容易猜測的簡單密碼。",
    restricted_found: "避免過度使用{{list, list}}。",
    restricted: {
        repetition: "重複的字符",
        sequence: "連續的字符",
        user_info: "個人資訊",
        words: "產品上下文"
    }
};
var $026dc924ff32be1a$export$2e2bcd8739ae039 = Object.freeze($026dc924ff32be1a$var$password_rejected);


var $b40a7c95902703f0$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "無效的{{types, list(type: disjunction;)}}",
    username_required: "用戶名必填",
    password_required: "密碼必填",
    username_exists: "用戶名已存在",
    username_should_not_start_with_number: "用戶名不能以數字開頭",
    username_invalid_charset: "用戶名只能包含英文字母、數字或下劃線。",
    invalid_email: "無效的電子郵件",
    invalid_phone: "無效的手機號碼",
    passwords_do_not_match: "兩次輸入的密碼不一致，請重試。",
    invalid_passcode: "無效的驗證碼",
    invalid_connector_auth: "登錄失敗",
    invalid_connector_request: "無效的登錄請求",
    unknown: "未知錯誤，請稍後重試。",
    invalid_session: "未找到會話，請返回並重新登錄。",
    timeout: "請求超時，請稍後重試。",
    password_rejected: (0, $026dc924ff32be1a$export$2e2bcd8739ae039),
    sso_not_enabled: "此電子郵件帳戶未啟用單一登錄。"
};
var $b40a7c95902703f0$export$2e2bcd8739ae039 = Object.freeze($b40a7c95902703f0$var$error);


var $645722ecb9a066b0$var$input = {
    username: "用戶名",
    password: "密碼",
    email: "電郵",
    phone_number: "手機號碼",
    confirm_password: "確認密碼",
    search_region_code: "搜索區域碼",
    backup_code: "備用碼"
};
var $645722ecb9a066b0$export$2e2bcd8739ae039 = Object.freeze($645722ecb9a066b0$var$input);


var $97c39e9d603b267f$var$list = {
    or: "或",
    and: "和",
    separator: "，"
};
var $97c39e9d603b267f$export$2e2bcd8739ae039 = Object.freeze($97c39e9d603b267f$var$list);


var $72fdc5953f55cbf4$var$mfa = {
    totp: "身份驗證應用 OTP",
    webauthn: "通行證",
    backup_code: "備份代碼",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "鏈接您的設備或 USB 硬件",
    link_backup_code_description: "生成備份代碼",
    verify_totp_description: "在應用程序中輸入一次性代碼",
    verify_webauthn_description: "驗證您的設備或 USB 硬件",
    verify_backup_code_description: "粘貼您保存的備份代碼",
    add_mfa_factors: "添加兩步驗證",
    add_mfa_description: "已啟用兩步驗證。選擇第二種驗證方法進行安全登錄。",
    verify_mfa_factors: "兩步驗證",
    verify_mfa_description: "此帳戶已啟用兩步驗證。請選擇第二種驗證身份的方式。",
    add_authenticator_app: "添加身份驗證應用",
    step: "步驟 {{step, number}}: {{content}}",
    scan_qr_code: "掃描此 QR 碼",
    scan_qr_code_description: "使用身份驗證應用程序（如 Google Authenticator、Duo Mobile、Authy 等）掃描以下 QR 碼。",
    qr_code_not_available: "無法掃描 QR 碼？",
    copy_and_paste_key: "複製並粘貼密鑰",
    copy_and_paste_key_description: "將以下密鑰複製並粘貼到身份驗證應用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要掃描 QR 碼嗎？",
    enter_one_time_code: "輸入一次性代碼",
    enter_one_time_code_link_description: "輸入身份驗證應用生成的 6 位驗證碼。",
    enter_one_time_code_description: "此帳戶啟用了兩步驗證。請輸入在您關聯的認證應用中顯示的一次性代碼。",
    link_another_mfa_factor: "切換到另一種方法",
    save_backup_code: "保存您的備份代碼",
    save_backup_code_description: "如果在其他方式的兩步驗證中遇到問題，您可以使用這些備份代碼之一訪問您的帳戶。每個代碼只能使用一次。",
    backup_code_hint: "確保複製它們並保存在安全的地方。",
    enter_a_backup_code: "輸入備份代碼",
    enter_backup_code_description: "輸入初始啟用兩步驗證時保存的備份代碼。",
    create_a_passkey: "創建通行證",
    create_passkey_description: "使用設備生物識別、安全密鑰（例如 YubiKey）或其他可用方法註冊您的通行證。",
    try_another_verification_method: "嘗試其他驗證方法",
    verify_via_passkey: "通過通行證驗證",
    verify_via_passkey_description: "使用通行證通過設備密碼或生物識別、掃描 QR 碼或使用 USB 安全密鑰（如 YubiKey）進行驗證。",
    secret_key_copied: "密鑰已複製。",
    backup_code_copied: "備份代碼已複製。",
    webauthn_not_ready: "WebAuthn 尚未準備就緒。請稍後重試。",
    webauthn_not_supported: "此瀏覽器不支援 WebAuthn。",
    webauthn_failed_to_create: "創建失敗。請重試。",
    webauthn_failed_to_verify: "驗證失敗。請重試。"
};
var $72fdc5953f55cbf4$export$2e2bcd8739ae039 = Object.freeze($72fdc5953f55cbf4$var$mfa);


var $6316206aba9a95f8$var$secondary = {
    social_bind_with: "綁定到已有帳戶? 使用 {{methods, list(type: disjunction;), zhOrSpaces}} 登入並綁定。"
};
var $6316206aba9a95f8$export$2e2bcd8739ae039 = Object.freeze($6316206aba9a95f8$var$secondary);


var $c72fa2062b83ff9b$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $c72fa2062b83ff9b$export$2e2bcd8739ae039 = Object.freeze($c72fa2062b83ff9b$var$user_scopes);


var $52f8d07d2808eaa6$var$zh_hk = {
    translation: {
        input: (0, $645722ecb9a066b0$export$2e2bcd8739ae039),
        secondary: (0, $6316206aba9a95f8$export$2e2bcd8739ae039),
        action: (0, $344756ea8246c98c$export$2e2bcd8739ae039),
        description: (0, $4f0e97401e2c9707$export$2e2bcd8739ae039),
        error: (0, $b40a7c95902703f0$export$2e2bcd8739ae039),
        list: (0, $97c39e9d603b267f$export$2e2bcd8739ae039),
        mfa: (0, $72fdc5953f55cbf4$export$2e2bcd8739ae039),
        development_tenant: (0, $e8dbf44357e95082$export$2e2bcd8739ae039),
        user_scopes: (0, $c72fa2062b83ff9b$export$2e2bcd8739ae039)
    }
};
var $52f8d07d2808eaa6$export$2e2bcd8739ae039 = Object.freeze($52f8d07d2808eaa6$var$zh_hk);


var $4ae73b5fc307d086$var$action = {
    sign_in: "登錄",
    continue: "繼續",
    create_account: "註冊",
    create_account_without_linking: "註冊新的帳號",
    create: "註冊",
    enter_passcode: "輸入驗證碼",
    confirm: "確認",
    cancel: "取消",
    save_password: "保存密碼",
    bind: "綁定到 {{address}}",
    bind_and_continue: "綁定並繼續",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳過",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通過 {{name}} 繼續",
    forgot_password: "忘記密碼？",
    switch_to: "切換到{{method}}",
    sign_in_via_passcode: "用驗證碼登錄",
    sign_in_via_password: "密碼登錄",
    change: "更改{{method}}",
    link_another_email: "綁定其他郵箱",
    link_another_phone: "綁定其他手機",
    link_another_email_or_phone: "綁定郵箱或手機號",
    show_password: "顯示密碼",
    copy: "複製",
    verify_via_passkey: "透過 Passkey 驗證",
    download: "下載",
    single_sign_on: "單點登錄",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $4ae73b5fc307d086$export$2e2bcd8739ae039 = Object.freeze($4ae73b5fc307d086$var$action);


var $fe17593968ff8d25$var$description = {
    email: "郵箱",
    phone_number: "手機號碼",
    username: "用戶名",
    reminder: "提示",
    not_found: "404 頁面不存在",
    agree_with_terms: "我已閱讀並同意 ",
    agree_with_terms_modal: "請先同意<link></link>以繼續",
    terms_of_use: "使用條款",
    sign_in: "登錄",
    privacy_policy: "隱私政策",
    create_account: "創建帳號",
    or: "或",
    and: "和",
    enter_passcode: "驗證碼已經發送至你的{{address}} {{target}}",
    passcode_sent: "驗證碼已經發送",
    resend_after_seconds: "在 <span>{{seconds}}</span> 秒後重新發送",
    resend_passcode: "重新發送驗證碼",
    create_account_id_exists: "{{type}} 為 {{value}} 的帳號已存在，你要登錄嗎？",
    link_account_id_exists: " {{type}} 為 {{value}} 的帳號已註冊，你要綁定至這個帳號嗎？",
    sign_in_id_does_not_exist: "{{type}} 為 {{value}} 的帳號不存在，你要創建一個新帳號嗎？",
    sign_in_id_does_not_exist_alert: "{{type}} 為 {{value}} 的帳號不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}",
    bind_account_title: "綁定或註冊帳號",
    social_create_account: "你可以註冊一個新的帳號。",
    social_link_email: "你可以綁定其他郵箱",
    social_link_phone: "你可以綁定其他手機號碼",
    social_link_email_or_phone: "你可以綁定其他郵箱或手機號碼",
    social_bind_with_existing: "找到了一個已註冊的帳號，你可以直接綁定。",
    reset_password: "忘記密碼",
    reset_password_description: "輸入{{types, list(type: disjunction;)}}，獲取驗證碼以重設密碼。",
    new_password: "新密碼",
    set_password: "設置密碼",
    password_changed: "已重置密碼！",
    no_account: "還沒有帳號？",
    have_account: " 已有帳號？",
    enter_password: "輸入密碼",
    enter_password_for: "輸入{{method}} {{value}}對應的密碼進行登錄",
    enter_username: "設置用戶名",
    enter_username_description: "用戶名可以用來進行登錄。用戶名僅可以包含字母、數字和下劃線。",
    link_email: "綁定郵箱",
    link_phone: "綁定手機",
    link_email_or_phone: "綁定郵箱或手機號碼",
    link_email_description: "綁定郵箱以保障你的帳號安全",
    link_phone_description: "綁定手機號碼以保障你的帳號安全",
    link_email_or_phone_description: "綁定郵箱或手機號碼以保障你的帳號安全",
    continue_with_more_information: "為保障你的帳號安全，需要你補充以下信息。",
    create_your_account: "註冊你的帳號",
    sign_in_to_your_account: "登錄你的帳號",
    no_region_code_found: "沒有找到區域碼",
    verify_email: "驗證你的郵箱",
    verify_phone: "驗證你的手機號碼",
    password_requirements: "密碼{{items, list}}。",
    password_requirement: {
        length_one: "長度至少為 {{count}} 個字符",
        length_other: "長度至少為 {{count}} 個字符",
        character_types_one: "需包含 {{count}} 類型的大寫字母、小寫字母、數字和符號",
        character_types_other: "需包含 {{count}} 類型的大寫字母、小寫字母、數字和符號"
    },
    use: "使用",
    single_sign_on_email_form: "輸入你的企業電子郵件地址",
    single_sign_on_connectors_list: "您的企業已為電子郵件帳戶{{email}}啟用單一登入。您可以繼續使用以下的SSO供應商登入。",
    single_sign_on_enabled: "該帳戶已啟用單一登入",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: "By authorizing the access, you agree to the {{name}}'s <link></link>.",
    /** UNTRANSLATED */ authorize_agreement_with_redirect: "By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.",
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $fe17593968ff8d25$export$2e2bcd8739ae039 = Object.freeze($fe17593968ff8d25$var$description);


var $c94ba7ba248b8ef6$var$development_tenant = {
    notification: "你處於開發模式"
};
var $c94ba7ba248b8ef6$export$2e2bcd8739ae039 = Object.freeze($c94ba7ba248b8ef6$var$development_tenant);


var $6187e129c149c64f$var$password_rejected = {
    too_short: "最少需要 {{min}} 位字元。",
    too_long: "最多只能有 {{max}} 位字元。",
    character_types: "至少需要 {{min}} 種不同的字元類型。",
    unsupported_characters: "發現不支援的字元。",
    pwned: "請避免使用容易被猜中的簡單密碼。",
    restricted_found: "請避免過度使用 {{list, list}}。",
    restricted: {
        repetition: "連續重複的字元",
        sequence: "連續的字元",
        user_info: "個人資訊",
        words: "使用產品相關的字詞"
    }
};
var $6187e129c149c64f$export$2e2bcd8739ae039 = Object.freeze($6187e129c149c64f$var$password_rejected);


var $f4f2b37b907e9733$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "無效的{{types, list(type: disjunction;)}}",
    username_required: "使用者名稱必填",
    password_required: "密碼必填",
    username_exists: "使用者名稱已存在",
    username_should_not_start_with_number: "使用者名稱不能以數字開頭",
    username_invalid_charset: "使用者名稱只能包含英文字母、數字或下劃線。",
    invalid_email: "無效的郵箱",
    invalid_phone: "無效的手機號",
    passwords_do_not_match: "兩次輸入的密碼不一致，請重試。",
    invalid_passcode: "無效的驗證碼",
    invalid_connector_auth: "登錄失敗",
    invalid_connector_request: "無效的登錄請求",
    unknown: "未知錯誤，請稍後重試。",
    invalid_session: "未找到會話，請返回並重新登錄。",
    timeout: "請求超時，請稍後重試。",
    password_rejected: (0, $6187e129c149c64f$export$2e2bcd8739ae039),
    sso_not_enabled: "此郵箱帳戶未啟用單一登錄。"
};
var $f4f2b37b907e9733$export$2e2bcd8739ae039 = Object.freeze($f4f2b37b907e9733$var$error);


var $b63dc33feb5be179$var$input = {
    username: "用戶名",
    password: "密碼",
    email: "電子郵件",
    phone_number: "手機號碼",
    confirm_password: "確認密碼",
    search_region_code: "搜尋區域碼",
    backup_code: "備用碼"
};
var $b63dc33feb5be179$export$2e2bcd8739ae039 = Object.freeze($b63dc33feb5be179$var$input);


var $f5024f663c469268$var$list = {
    or: "或",
    and: "和",
    separator: "，"
};
var $f5024f663c469268$export$2e2bcd8739ae039 = Object.freeze($f5024f663c469268$var$list);


var $1677ff6b203bf60a$var$mfa = {
    totp: "身份驗證應用 OTP",
    webauthn: "通行證",
    backup_code: "備份代碼",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "鏈接您的設備或 USB 硬件",
    link_backup_code_description: "生成備份代碼",
    verify_totp_description: "在應用程序中輸入一次性代碼",
    verify_webauthn_description: "驗證您的設備或 USB 硬件",
    verify_backup_code_description: "粘貼您保存的備份代碼",
    add_mfa_factors: "添加兩步驗證",
    add_mfa_description: "已啟用兩步驗證。選擇第二種驗證方法進行安全登錄。",
    verify_mfa_factors: "兩步驗證",
    verify_mfa_description: "此帳戶已啟用兩步驗證。請選擇第二種驗證身份的方式。",
    add_authenticator_app: "添加身份驗證應用",
    step: "步驟 {{step, number}}: {{content}}",
    scan_qr_code: "掃描此 QR 碼",
    scan_qr_code_description: "使用身份驗證應用程序（如 Google Authenticator、Duo Mobile、Authy 等）掃描以下 QR 碼。",
    qr_code_not_available: "無法掃描 QR 碼？",
    copy_and_paste_key: "複製並粘貼密鑰",
    copy_and_paste_key_description: "將以下密鑰複製並粘貼到身份驗證應用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要掃描 QR 碼嗎？",
    enter_one_time_code: "輸入一次性代碼",
    enter_one_time_code_link_description: "輸入身份驗證應用生成的 6 位驗證碼。",
    enter_one_time_code_description: "此帳戶啟用了兩步驗證。請輸入在您關聯的認證應用中顯示的一次性代碼。",
    link_another_mfa_factor: "切換到另一種方法",
    save_backup_code: "保存您的備份代碼",
    save_backup_code_description: "如果在其他方式的兩步驗證中遇到問題，您可以使用這些備份代碼之一訪問您的帳戶。每個代碼只能使用一次。",
    backup_code_hint: "確保複製它們並保存在安全的地方。",
    enter_a_backup_code: "輸入備份代碼",
    enter_backup_code_description: "輸入初始啟用兩步驗證時保存的備份代碼。",
    create_a_passkey: "創建通行證",
    create_passkey_description: "使用設備生物識別、安全密鑰（例如 YubiKey）或其他可用方法註冊您的通行證。",
    try_another_verification_method: "嘗試其他驗證方法",
    verify_via_passkey: "通過通行證驗證",
    verify_via_passkey_description: "使用通行證通過設備密碼或生物識別、掃描 QR 碼或使用 USB 安全密鑰（如 YubiKey）進行驗證。",
    secret_key_copied: "密鑰已複製。",
    backup_code_copied: "備份代碼已複製。",
    webauthn_not_ready: "WebAuthn 尚未準備就緒。請稍後重試。",
    webauthn_not_supported: "此瀏覽器不支援 WebAuthn。",
    webauthn_failed_to_create: "創建失敗。請重試。",
    webauthn_failed_to_verify: "驗證失敗。請重試。"
};
var $1677ff6b203bf60a$export$2e2bcd8739ae039 = Object.freeze($1677ff6b203bf60a$var$mfa);


var $64e4d5c4626150ec$var$secondary = {
    social_bind_with: "綁定到已有帳戶？使用 {{methods，list(type：disjunction;)，zhOrSpaces}} 登入並綁定。"
};
var $64e4d5c4626150ec$export$2e2bcd8739ae039 = Object.freeze($64e4d5c4626150ec$var$secondary);


var $41837fd675c83b52$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $41837fd675c83b52$export$2e2bcd8739ae039 = Object.freeze($41837fd675c83b52$var$user_scopes);


var $9bdffce1af9dd2fe$var$zh_tw = {
    translation: {
        input: (0, $b63dc33feb5be179$export$2e2bcd8739ae039),
        secondary: (0, $64e4d5c4626150ec$export$2e2bcd8739ae039),
        action: (0, $4ae73b5fc307d086$export$2e2bcd8739ae039),
        description: (0, $fe17593968ff8d25$export$2e2bcd8739ae039),
        error: (0, $f4f2b37b907e9733$export$2e2bcd8739ae039),
        list: (0, $f5024f663c469268$export$2e2bcd8739ae039),
        mfa: (0, $1677ff6b203bf60a$export$2e2bcd8739ae039),
        development_tenant: (0, $c94ba7ba248b8ef6$export$2e2bcd8739ae039),
        user_scopes: (0, $41837fd675c83b52$export$2e2bcd8739ae039)
    }
};
var $9bdffce1af9dd2fe$export$2e2bcd8739ae039 = Object.freeze($9bdffce1af9dd2fe$var$zh_tw);


var $3ad892cee7f164a8$export$651548ae3cf5e245 = [
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "pl-PL",
    "pt-PT",
    "pt-BR",
    "ru",
    "tr-TR",
    "zh-CN",
    "zh-HK",
    "zh-TW"
];
var $3ad892cee7f164a8$export$91d555a17bb93dc7 = $3ad892cee7f164a8$export$651548ae3cf5e245.map(function(languageTag) {
    return {
        value: languageTag,
        title: (0, $6dbf06f251d021be$export$d0d68bb9ed2c643d)[languageTag]
    };
});
var $3ad892cee7f164a8$export$5ac61cba82e41a23 = (0, $a782240af38642b4$export$2e2bcd8739ae039).enum($3ad892cee7f164a8$export$651548ae3cf5e245);
var $3ad892cee7f164a8$var$resource = {
    de: (0, $0d29a8fb74ca77ba$export$2e2bcd8739ae039),
    en: (0, $f5f0e5a7776a996a$export$2e2bcd8739ae039),
    es: (0, $5058dd85111aa6a2$export$2e2bcd8739ae039),
    fr: (0, $4ab399efe9571b36$export$2e2bcd8739ae039),
    it: (0, $37fa5c97215dc3cd$export$2e2bcd8739ae039),
    ja: (0, $555756cb712bade1$export$2e2bcd8739ae039),
    ko: (0, $421dd505ef727661$export$2e2bcd8739ae039),
    "pl-PL": (0, $9580da2c87f02325$export$2e2bcd8739ae039),
    "pt-PT": (0, $102e9d308a850bb4$export$2e2bcd8739ae039),
    "pt-BR": (0, $c8b6501141c8c172$export$2e2bcd8739ae039),
    ru: (0, $438d6e5ceb1ea704$export$2e2bcd8739ae039),
    "tr-TR": (0, $f8a0b9d6cfd6eb8f$export$2e2bcd8739ae039),
    "zh-CN": (0, $e9ab744ca360fba7$export$2e2bcd8739ae039),
    "zh-HK": (0, $52f8d07d2808eaa6$export$2e2bcd8739ae039),
    "zh-TW": (0, $9bdffce1af9dd2fe$export$2e2bcd8739ae039)
};
var $3ad892cee7f164a8$export$559ef0bafb7e082f = function(language) {
    return $3ad892cee7f164a8$export$5ac61cba82e41a23.or((0, $08b5a247edaf1be2$export$bcd1dd1f397bba12)("en")).parse(language);
};
var $3ad892cee7f164a8$export$562f9b4f03c85f6c = function(language) {
    return $3ad892cee7f164a8$export$5ac61cba82e41a23.safeParse(language).success;
};
var $3ad892cee7f164a8$export$2e2bcd8739ae039 = $3ad892cee7f164a8$var$resource;





var $e37f0af875b54684$var$arr = [];
var $e37f0af875b54684$var$each = $e37f0af875b54684$var$arr.forEach;
var $e37f0af875b54684$var$slice = $e37f0af875b54684$var$arr.slice;
function $e37f0af875b54684$var$defaults(obj) {
    $e37f0af875b54684$var$each.call($e37f0af875b54684$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $e37f0af875b54684$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $e37f0af875b54684$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$e37f0af875b54684$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$e37f0af875b54684$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $e37f0af875b54684$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $e37f0af875b54684$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $e37f0af875b54684$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $e37f0af875b54684$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $e37f0af875b54684$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $e37f0af875b54684$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $e37f0af875b54684$var$hasLocalStorageSupport = null;
var $e37f0af875b54684$var$localStorageAvailable = function localStorageAvailable() {
    if ($e37f0af875b54684$var$hasLocalStorageSupport !== null) return $e37f0af875b54684$var$hasLocalStorageSupport;
    try {
        $e37f0af875b54684$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $e37f0af875b54684$var$hasLocalStorageSupport = false;
    }
    return $e37f0af875b54684$var$hasLocalStorageSupport;
};
var $e37f0af875b54684$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $e37f0af875b54684$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $e37f0af875b54684$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $e37f0af875b54684$var$hasSessionStorageSupport = null;
var $e37f0af875b54684$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($e37f0af875b54684$var$hasSessionStorageSupport !== null) return $e37f0af875b54684$var$hasSessionStorageSupport;
    try {
        $e37f0af875b54684$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $e37f0af875b54684$var$hasSessionStorageSupport = false;
    }
    return $e37f0af875b54684$var$hasSessionStorageSupport;
};
var $e37f0af875b54684$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $e37f0af875b54684$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $e37f0af875b54684$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $e37f0af875b54684$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $e37f0af875b54684$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $e37f0af875b54684$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $e37f0af875b54684$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $e37f0af875b54684$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ]
    };
}
var $e37f0af875b54684$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $72cbeaa3bc3caa2a$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $0ec9a1d27e914406$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $e37f0af875b54684$var$defaults(options, this.options || {}, $e37f0af875b54684$var$getDefaults());
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($e37f0af875b54684$var$cookie$1);
                this.addDetector($e37f0af875b54684$var$querystring);
                this.addDetector($e37f0af875b54684$var$localStorage);
                this.addDetector($e37f0af875b54684$var$sessionStorage);
                this.addDetector($e37f0af875b54684$var$navigator$1);
                this.addDetector($e37f0af875b54684$var$htmlTag);
                this.addDetector($e37f0af875b54684$var$path);
                this.addDetector($e37f0af875b54684$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$e37f0af875b54684$export$2e2bcd8739ae039.type = "languageDetector";


/**
 * Used to get and general sign-in experience settings.
 * The API will be deprecated in the future once SSR is implemented.
 */ 



/*! MIT License © Sindre Sorhus */ 






// eslint-lint-disable-next-line @typescript-eslint/naming-convention





var $1a87adca8ebe72c6$export$aa9d629c530f62a7 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(HTTPError, Error1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(HTTPError);
    function HTTPError(response, request, options) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, HTTPError);
        var _this;
        var code = response.status || response.status === 0 ? response.status : "";
        var title = response.statusText || "";
        var status = "".concat(code, " ").concat(title).trim();
        var reason = status ? "status code ".concat(status) : "an unknown error";
        _this = _super.call(this, "Request failed with ".concat(reason));
        Object.defineProperty((0, $883161a1efd6c88e$export$f3b8ed2e4a5d10b8)(_this), "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $883161a1efd6c88e$export$f3b8ed2e4a5d10b8)(_this), "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $883161a1efd6c88e$export$f3b8ed2e4a5d10b8)(_this), "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.name = "HTTPError";
        _this.response = response;
        _this.request = request;
        _this.options = options;
        return _this;
    }
    return HTTPError;
}((0, $efec3851c979cc44$export$2466d533fda16e33)(Error));







var $823ae9dbb4658b29$export$66d311bf29d5c89c = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(TimeoutError, Error1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(TimeoutError);
    function TimeoutError(request) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, TimeoutError);
        var _this;
        _this = _super.call(this, "Request timed out");
        Object.defineProperty((0, $883161a1efd6c88e$export$f3b8ed2e4a5d10b8)(_this), "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.name = "TimeoutError";
        _this.request = request;
        return _this;
    }
    return TimeoutError;
}((0, $efec3851c979cc44$export$2466d533fda16e33)(Error));







// eslint-disable-next-line @typescript-eslint/ban-types
var $b9c584e83ced1997$export$a6cdc56e425d0d0a = function(value) {
    return value !== null && typeof value === "object";
};


var $b64972762c06789e$export$8886f5ba30bd5e0 = function() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
        sources[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var source = _step.value;
            if ((!(0, $b9c584e83ced1997$export$a6cdc56e425d0d0a)(source) || Array.isArray(source)) && source !== undefined) throw new TypeError("The `options` argument must be an object");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $b64972762c06789e$export$6969335ea1e4e77c.apply(void 0, [
        {}
    ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(sources)));
};
var $b64972762c06789e$export$eee1781d075786ae = function() {
    var source1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, source2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var result = new globalThis.Headers(source1);
    var isHeadersInstance = source2 instanceof globalThis.Headers;
    var source = new globalThis.Headers(source2);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = source.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (isHeadersInstance && value === "undefined" || value === undefined) result.delete(key);
            else result.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
};
var $b64972762c06789e$export$6969335ea1e4e77c = function() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
        sources[_key] = arguments[_key];
    }
    var returnValue = {};
    var headers = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var source = _step.value;
            if (Array.isArray(source)) {
                if (!Array.isArray(returnValue)) returnValue = [];
                returnValue = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(returnValue).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(source));
            } else if ((0, $b9c584e83ced1997$export$a6cdc56e425d0d0a)(source)) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = Object.entries(source)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step1.value, 2), key = _step_value[0], value = _step_value[1];
                        if ((0, $b9c584e83ced1997$export$a6cdc56e425d0d0a)(value) && key in returnValue) value = $b64972762c06789e$export$6969335ea1e4e77c(returnValue[key], value);
                        returnValue = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, returnValue), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, key, value));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if ((0, $b9c584e83ced1997$export$a6cdc56e425d0d0a)(source.headers)) {
                    headers = $b64972762c06789e$export$eee1781d075786ae(headers, source.headers);
                    returnValue.headers = headers;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return returnValue;
};




var $932e141f50dd92dd$export$d8618555562b76b7 = function() {
    var duplexAccessed = false;
    var hasContentType = false;
    var supportsReadableStream = typeof globalThis.ReadableStream === "function";
    var supportsRequest = typeof globalThis.Request === "function";
    if (supportsReadableStream && supportsRequest) hasContentType = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
}();
var $932e141f50dd92dd$export$6c0aacaed85a4966 = typeof globalThis.AbortController === "function";
var $932e141f50dd92dd$export$135162ac70ac2b21 = typeof globalThis.ReadableStream === "function";
var $932e141f50dd92dd$export$f1525fa7979d0aa9 = typeof globalThis.FormData === "function";
var $932e141f50dd92dd$export$fb003dbd6df95edb = [
    "get",
    "post",
    "put",
    "patch",
    "head",
    "delete"
];
var $932e141f50dd92dd$var$validate = function() {
    return undefined;
};
$932e141f50dd92dd$var$validate();
var $932e141f50dd92dd$export$a6f212d4ee888d8c = {
    json: "application/json",
    text: "text/*",
    formData: "multipart/form-data",
    arrayBuffer: "*/*",
    blob: "*/*"
};
var $932e141f50dd92dd$export$9b60a72e3f70a1d2 = 2147483647;
var $932e141f50dd92dd$export$fa6813432f753b0d = Symbol("stop");
var $932e141f50dd92dd$export$601fffa09f19102d = {
    json: true,
    parseJson: true,
    searchParams: true,
    prefixUrl: true,
    retry: true,
    timeout: true,
    hooks: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    fetch: true
};
var $932e141f50dd92dd$export$b2ec467665ae937d = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    dispatcher: true,
    duplex: true,
    priority: true
};


var $e313ff4a1968d3ad$export$d585027d4667ffce = function(input) {
    return (0, $932e141f50dd92dd$export$fb003dbd6df95edb).includes(input) ? input.toUpperCase() : input;
};
var $e313ff4a1968d3ad$var$retryMethods = [
    "get",
    "put",
    "head",
    "delete",
    "options",
    "trace"
];
var $e313ff4a1968d3ad$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
var $e313ff4a1968d3ad$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
var $e313ff4a1968d3ad$var$defaultRetryOptions = {
    limit: 2,
    methods: $e313ff4a1968d3ad$var$retryMethods,
    statusCodes: $e313ff4a1968d3ad$var$retryStatusCodes,
    afterStatusCodes: $e313ff4a1968d3ad$var$retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY,
    delay: function(attemptCount) {
        return 0.3 * Math.pow(2, attemptCount - 1) * 1000;
    }
};
var $e313ff4a1968d3ad$export$3e5471bb9440c9c1 = function() {
    var retry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (typeof retry === "number") return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $e313ff4a1968d3ad$var$defaultRetryOptions), {
        limit: retry
    });
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error("retry.methods must be an array");
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error("retry.statusCodes must be an array");
    return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $e313ff4a1968d3ad$var$defaultRetryOptions, retry), {
        afterStatusCodes: $e313ff4a1968d3ad$var$retryAfterStatusCodes
    });
};





function $a8fc7689774cd923$export$2e2bcd8739ae039(request, init, abortController, options) {
    return $a8fc7689774cd923$var$_timeout.apply(this, arguments);
}
function $a8fc7689774cd923$var$_timeout() {
    $a8fc7689774cd923$var$_timeout = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(request, init, abortController, options) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var timeoutId = setTimeout(function() {
                        if (abortController) abortController.abort();
                        reject(new (0, $823ae9dbb4658b29$export$66d311bf29d5c89c)(request));
                    }, options.timeout);
                    options.fetch(request, init).then(resolve).catch(reject).then(function() {
                        clearTimeout(timeoutId);
                    });
                })
            ];
        });
    });
    return $a8fc7689774cd923$var$_timeout.apply(this, arguments);
}


// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111


function $d4401f43c845a1b7$export$2e2bcd8739ae039(ms, _) {
    return $d4401f43c845a1b7$var$_delay.apply(this, arguments);
}
function $d4401f43c845a1b7$var$_delay() {
    $d4401f43c845a1b7$var$_delay = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(ms, param) {
        var signal;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            signal = param.signal;
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (signal) {
                        signal.throwIfAborted();
                        signal.addEventListener("abort", abortHandler, {
                            once: true
                        });
                    }
                    function abortHandler() {
                        clearTimeout(timeoutId);
                        reject(signal.reason);
                    }
                    var timeoutId = setTimeout(function() {
                        signal === null || signal === void 0 ? void 0 : signal.removeEventListener("abort", abortHandler);
                        resolve();
                    }, ms);
                })
            ];
        });
    });
    return $d4401f43c845a1b7$var$_delay.apply(this, arguments);
}



var $28db687191b231b5$export$95d8775889ec941f = function(request, options) {
    var unknownOptions = {};
    for(var key in options)if (!(key in (0, $932e141f50dd92dd$export$b2ec467665ae937d)) && !(key in (0, $932e141f50dd92dd$export$601fffa09f19102d)) && !(key in request)) unknownOptions[key] = options[key];
    return unknownOptions;
};



var $cc88cbd8f49903ad$export$c482d6f00e170af3 = /*#__PURE__*/ function() {
    "use strict";
    function Ky(input) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _this = this;
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, Ky);
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "abortController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_retryCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "_input", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._input = input;
        var credentials = this._input instanceof Request && "credentials" in Request.prototype ? this._input.credentials : undefined;
        var _options_method, _options_timeout, _options_fetch;
        this._options = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, credentials && {
            credentials: credentials
        }, options), {
            headers: (0, $b64972762c06789e$export$eee1781d075786ae)(this._input.headers, options.headers),
            hooks: (0, $b64972762c06789e$export$6969335ea1e4e77c)({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: []
            }, options.hooks),
            method: (0, $e313ff4a1968d3ad$export$d585027d4667ffce)((_options_method = options.method) !== null && _options_method !== void 0 ? _options_method : this._input.method),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ""),
            retry: (0, $e313ff4a1968d3ad$export$3e5471bb9440c9c1)(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: (_options_timeout = options.timeout) !== null && _options_timeout !== void 0 ? _options_timeout : 10000,
            fetch: (_options_fetch = options.fetch) !== null && _options_fetch !== void 0 ? _options_fetch : globalThis.fetch.bind(globalThis)
        });
        if (typeof this._input !== "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request)) throw new TypeError("`input` must be a string, URL, or Request");
        if (this._options.prefixUrl && typeof this._input === "string") {
            if (this._input.startsWith("/")) throw new Error("`input` must not begin with a slash when using `prefixUrl`");
            if (!this._options.prefixUrl.endsWith("/")) this._options.prefixUrl += "/";
            this._input = this._options.prefixUrl + this._input;
        }
        if (0, $932e141f50dd92dd$export$6c0aacaed85a4966) {
            this.abortController = new globalThis.AbortController();
            if (this._options.signal) {
                var originalSignal = this._options.signal;
                this._options.signal.addEventListener("abort", function() {
                    _this.abortController.abort(originalSignal.reason);
                });
            }
            this._options.signal = this.abortController.signal;
        }
        if (0, $932e141f50dd92dd$export$d8618555562b76b7) // @ts-expect-error - Types are outdated.
        this._options.duplex = "half";
        this.request = new globalThis.Request(this._input, this._options);
        if (this._options.searchParams) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            var textSearchParams = typeof this._options.searchParams === "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            var searchParams = "?" + textSearchParams;
            var url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // To provide correct form boundary, Content-Type header should be deleted each time when new Request instantiated from another one
            if (((0, $932e141f50dd92dd$export$f1525fa7979d0aa9) && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"])) this.request.headers.delete("content-type");
            // The spread of `this.request` is required as otherwise it misses the `duplex` option for some reason and throws.
            this.request = new globalThis.Request(new globalThis.Request(url, (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, this.request)), this._options);
        }
        if (this._options.json !== undefined) {
            this._options.body = JSON.stringify(this._options.json);
            var _this__options_headers_get;
            this.request.headers.set("content-type", (_this__options_headers_get = this._options.headers.get("content-type")) !== null && _this__options_headers_get !== void 0 ? _this__options_headers_get : "application/json");
            this.request = new globalThis.Request(this.request, {
                body: this._options.body
            });
        }
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(Ky, [
        {
            key: "_calculateRetryDelay",
            value: function _calculateRetryDelay(error) {
                this._retryCount++;
                if (this._retryCount <= this._options.retry.limit && !(error instanceof (0, $823ae9dbb4658b29$export$66d311bf29d5c89c))) {
                    if (error instanceof (0, $1a87adca8ebe72c6$export$aa9d629c530f62a7)) {
                        if (!this._options.retry.statusCodes.includes(error.response.status)) return 0;
                        var retryAfter = error.response.headers.get("Retry-After");
                        if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                            var after = Number(retryAfter);
                            if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                            else after *= 1000;
                            if (this._options.retry.maxRetryAfter !== undefined && after > this._options.retry.maxRetryAfter) return 0;
                            return after;
                        }
                        if (error.response.status === 413) return 0;
                    }
                    var retryDelay = this._options.retry.delay(this._retryCount);
                    return Math.min(this._options.retry.backoffLimit, retryDelay);
                }
                return 0;
            }
        },
        {
            key: "_decorateResponse",
            value: function _decorateResponse(response) {
                var _this = this;
                if (this._options.parseJson) response.json = /*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var _, _1;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = _this._options).parseJson;
                                return [
                                    4,
                                    response.text()
                                ];
                            case 1:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
                return response;
            }
        },
        {
            key: "_retry",
            value: function _retry(function_) {
                var _this = this;
                return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var error, ms, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, hook, hookResult, err;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    13
                                ]);
                                return [
                                    4,
                                    function_()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                ms = Math.min(_this._calculateRetryDelay(error), (0, $932e141f50dd92dd$export$9b60a72e3f70a1d2));
                                if (!(ms !== 0 && _this._retryCount > 0)) return [
                                    3,
                                    12
                                ];
                                return [
                                    4,
                                    (0, $d4401f43c845a1b7$export$2e2bcd8739ae039)(ms, {
                                        signal: _this._options.signal
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = _this._options.hooks.beforeRetry[Symbol.iterator]();
                                _state.label = 5;
                            case 5:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                hook = _step.value;
                                return [
                                    4,
                                    hook({
                                        request: _this.request,
                                        options: _this._options,
                                        error: error,
                                        retryCount: _this._retryCount
                                    })
                                ];
                            case 6:
                                hookResult = _state.sent();
                                // If `stop` is returned from the hook, the retry process is stopped
                                if (hookResult === (0, $932e141f50dd92dd$export$fa6813432f753b0d)) return [
                                    2
                                ];
                                _state.label = 7;
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    5
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    2,
                                    _this._retry(function_)
                                ];
                            case 12:
                                throw error;
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_fetch",
            value: function _fetch() {
                var _this = this;
                return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, hook, result, err, nonRequestOptions;
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = _this._options.hooks.beforeRequest[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                hook = _step.value;
                                return [
                                    4,
                                    hook(_this.request, _this._options)
                                ];
                            case 3:
                                result = _state.sent();
                                if (result instanceof Request) {
                                    _this.request = result;
                                    return [
                                        3,
                                        5
                                    ];
                                }
                                if (result instanceof Response) return [
                                    2,
                                    result
                                ];
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                nonRequestOptions = (0, $28db687191b231b5$export$95d8775889ec941f)(_this.request, _this._options);
                                if (_this._options.timeout === false) return [
                                    2,
                                    _this._options.fetch(_this.request.clone(), nonRequestOptions)
                                ];
                                return [
                                    2,
                                    (0, $a8fc7689774cd923$export$2e2bcd8739ae039)(_this.request.clone(), nonRequestOptions, _this.abortController, _this._options)
                                ];
                        }
                    });
                })();
            }
        },
        {
            /* istanbul ignore next */ key: "_stream",
            value: function _stream(response, onDownloadProgress) {
                var totalBytes = Number(response.headers.get("content-length")) || 0;
                var transferredBytes = 0;
                if (response.status === 204) {
                    if (onDownloadProgress) onDownloadProgress({
                        percent: 1,
                        totalBytes: totalBytes,
                        transferredBytes: transferredBytes
                    }, new Uint8Array());
                    return new globalThis.Response(null, {
                        status: response.status,
                        statusText: response.statusText,
                        headers: response.headers
                    });
                }
                return new globalThis.Response(new globalThis.ReadableStream({
                    start: function(controller) {
                        return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                            var reader;
                            function read() {
                                return _read.apply(this, arguments);
                            }
                            function _read() {
                                _read = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                                    var _ref, done, value, percent;
                                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    reader.read()
                                                ];
                                            case 1:
                                                _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                                if (done) {
                                                    controller.close();
                                                    return [
                                                        2
                                                    ];
                                                }
                                                if (onDownloadProgress) {
                                                    transferredBytes += value.byteLength;
                                                    percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                                                    onDownloadProgress({
                                                        percent: percent,
                                                        transferredBytes: transferredBytes,
                                                        totalBytes: totalBytes
                                                    }, value);
                                                }
                                                controller.enqueue(value);
                                                return [
                                                    4,
                                                    read()
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return _read.apply(this, arguments);
                            }
                            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        reader = response.body.getReader();
                                        if (onDownloadProgress) onDownloadProgress({
                                            percent: 0,
                                            transferredBytes: 0,
                                            totalBytes: totalBytes
                                        }, new Uint8Array());
                                        return [
                                            4,
                                            read()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                }), {
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers
                });
            }
        }
    ], [
        {
            key: "create",
            value: function create(input, options) {
                var ky = new Ky(input, options);
                var function_ = function() {
                    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                        var response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, hook, modifiedResponse, err, error, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, hook1, err;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (typeof ky._options.timeout === "number" && ky._options.timeout > (0, $932e141f50dd92dd$export$9b60a72e3f70a1d2)) throw new RangeError("The `timeout` option cannot be greater than ".concat((0, $932e141f50dd92dd$export$9b60a72e3f70a1d2)));
                                    // Delay the fetch so that body method shortcuts can set the Accept header
                                    return [
                                        4,
                                        Promise.resolve()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        ky._fetch()
                                    ];
                                case 2:
                                    response = _state.sent();
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 3;
                                case 3:
                                    _state.trys.push([
                                        3,
                                        8,
                                        9,
                                        10
                                    ]);
                                    _iterator = ky._options.hooks.afterResponse[Symbol.iterator]();
                                    _state.label = 4;
                                case 4:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        7
                                    ];
                                    hook = _step.value;
                                    return [
                                        4,
                                        hook(ky.request, ky._options, ky._decorateResponse(response.clone()))
                                    ];
                                case 5:
                                    modifiedResponse = _state.sent();
                                    if (modifiedResponse instanceof globalThis.Response) response = modifiedResponse;
                                    _state.label = 6;
                                case 6:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        4
                                    ];
                                case 7:
                                    return [
                                        3,
                                        10
                                    ];
                                case 8:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        10
                                    ];
                                case 9:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 10:
                                    ky._decorateResponse(response);
                                    if (!(!response.ok && ky._options.throwHttpErrors)) return [
                                        3,
                                        19
                                    ];
                                    error = new (0, $1a87adca8ebe72c6$export$aa9d629c530f62a7)(response, ky.request, ky._options);
                                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    _state.label = 11;
                                case 11:
                                    _state.trys.push([
                                        11,
                                        16,
                                        17,
                                        18
                                    ]);
                                    _iterator1 = ky._options.hooks.beforeError[Symbol.iterator]();
                                    _state.label = 12;
                                case 12:
                                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                        3,
                                        15
                                    ];
                                    hook1 = _step1.value;
                                    return [
                                        4,
                                        hook1(error)
                                    ];
                                case 13:
                                    // eslint-disable-next-line no-await-in-loop
                                    error = _state.sent();
                                    _state.label = 14;
                                case 14:
                                    _iteratorNormalCompletion1 = true;
                                    return [
                                        3,
                                        12
                                    ];
                                case 15:
                                    return [
                                        3,
                                        18
                                    ];
                                case 16:
                                    err = _state.sent();
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                    return [
                                        3,
                                        18
                                    ];
                                case 17:
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 18:
                                    throw error;
                                case 19:
                                    // If `onDownloadProgress` is passed, it uses the stream API internally
                                    /* istanbul ignore next */ if (ky._options.onDownloadProgress) {
                                        if (typeof ky._options.onDownloadProgress !== "function") throw new TypeError("The `onDownloadProgress` option must be a function");
                                        if (!(0, $932e141f50dd92dd$export$135162ac70ac2b21)) throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
                                        return [
                                            2,
                                            ky._stream(response.clone(), ky._options.onDownloadProgress)
                                        ];
                                    }
                                    return [
                                        2,
                                        response
                                    ];
                            }
                        });
                    });
                    return function function_() {
                        return _ref.apply(this, arguments);
                    };
                }();
                var isRetriableMethod = ky._options.retry.methods.includes(ky.request.method.toLowerCase());
                var result = isRetriableMethod ? ky._retry(function_) : function_();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), type = _step_value[0], mimeType = _step_value[1];
                        result[type] = /*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                            var awaitedResult, response, arrayBuffer, responseSize, _;
                            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                                        ky.request.headers.set("accept", ky.request.headers.get("accept") || mimeType);
                                        return [
                                            4,
                                            result
                                        ];
                                    case 1:
                                        awaitedResult = _state.sent();
                                        response = awaitedResult.clone();
                                        if (!(type === "json")) return [
                                            3,
                                            4
                                        ];
                                        if (response.status === 204) return [
                                            2,
                                            ""
                                        ];
                                        return [
                                            4,
                                            response.clone().arrayBuffer()
                                        ];
                                    case 2:
                                        arrayBuffer = _state.sent();
                                        responseSize = arrayBuffer.byteLength;
                                        if (responseSize === 0) return [
                                            2,
                                            ""
                                        ];
                                        if (!options.parseJson) return [
                                            3,
                                            4
                                        ];
                                        _ = options.parseJson;
                                        return [
                                            4,
                                            response.text()
                                        ];
                                    case 3:
                                        return [
                                            2,
                                            _.apply(options, [
                                                _state.sent()
                                            ])
                                        ];
                                    case 4:
                                        return [
                                            2,
                                            response[type]()
                                        ];
                                }
                            });
                        });
                    };
                    for(var _iterator = Object.entries((0, $932e141f50dd92dd$export$a6f212d4ee888d8c))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        }
    ]);
    return Ky;
}();






var $1ba6ecb4eaf342b0$var$createInstance = function(defaults) {
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    var ky = function(input, options) {
        return (0, $cc88cbd8f49903ad$export$c482d6f00e170af3).create(input, (0, $b64972762c06789e$export$8886f5ba30bd5e0)(defaults, options));
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var method = _step.value;
            // eslint-disable-next-line @typescript-eslint/promise-function-async
            ky[method] = function(input, options) {
                return (0, $cc88cbd8f49903ad$export$c482d6f00e170af3).create(input, (0, $b64972762c06789e$export$8886f5ba30bd5e0)(defaults, options, {
                    method: method
                }));
            };
        };
        for(var _iterator = (0, $932e141f50dd92dd$export$fb003dbd6df95edb)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ky.create = function(newDefaults) {
        return $1ba6ecb4eaf342b0$var$createInstance((0, $b64972762c06789e$export$8886f5ba30bd5e0)(newDefaults));
    };
    ky.extend = function(newDefaults) {
        return $1ba6ecb4eaf342b0$var$createInstance((0, $b64972762c06789e$export$8886f5ba30bd5e0)(defaults, newDefaults));
    };
    ky.stop = (0, $932e141f50dd92dd$export$fa6813432f753b0d);
    return ky;
};
var $1ba6ecb4eaf342b0$var$ky = $1ba6ecb4eaf342b0$var$createInstance();
var $1ba6ecb4eaf342b0$export$2e2bcd8739ae039 = $1ba6ecb4eaf342b0$var$ky;


var $9f37205a8c53f1c7$export$7b45cbfd4fd1e917 = Object.freeze({
    noCache: "no_cache"
});
var $9f37205a8c53f1c7$export$24c2f7fddd6751e5 = function() {
    var search = window.location.search;
    if (!search) return;
    var parameters = new URLSearchParams(search);
    if (parameters.get($9f37205a8c53f1c7$export$7b45cbfd4fd1e917.noCache) !== null) sessionStorage.setItem($9f37205a8c53f1c7$export$7b45cbfd4fd1e917.noCache, "true");
};


var $94cdfd151a798194$var$buildSearchParameters = function(record) {
    var entries = Object.entries(record).filter(function(entry) {
        return Boolean(entry[0] && entry[1]);
    });
    return (0, $3539bd14a37ab7f4$export$c327da55a124987a)(entries.length > 0 && entries);
};
var $94cdfd151a798194$export$acc5aa4723208a61 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $1ba6ecb4eaf342b0$export$2e2bcd8739ae039).get("/api/.well-known/sign-in-exp", {
                    searchParams: $94cdfd151a798194$var$buildSearchParameters((0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, (0, $9f37205a8c53f1c7$export$7b45cbfd4fd1e917).noCache, sessionStorage.getItem((0, $9f37205a8c53f1c7$export$7b45cbfd4fd1e917).noCache)))
                }).json()
            ];
        });
    });
    return function getSignInExperience() {
        return _ref.apply(this, arguments);
    };
}();
var $94cdfd151a798194$export$bc4d46b9876ba37 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
        var localLanguage, language, _obj;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            localLanguage = param.localLanguage, language = param.language;
            return [
                2,
                (0, $1ba6ecb4eaf342b0$export$2e2bcd8739ae039).extend({
                    hooks: {
                        beforeRequest: [
                            function(request) {
                                if (localLanguage) request.headers.set("Accept-Language", localLanguage);
                            }
                        ]
                    }
                }).get("/api/.well-known/phrases", {
                    searchParams: $94cdfd151a798194$var$buildSearchParameters((_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, (0, $9f37205a8c53f1c7$export$7b45cbfd4fd1e917).noCache, sessionStorage.getItem((0, $9f37205a8c53f1c7$export$7b45cbfd4fd1e917).noCache)), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "lng", language), _obj))
                })
            ];
        });
    });
    return function getPhrases(_) {
        return _ref.apply(this, arguments);
    };
}();


var $bf9bb39c4fee6ca3$export$ac7fcc5388462ab3 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(language) {
        var detectedLanguage, response, phrases, lng, e;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    detectedLanguage = $bf9bb39c4fee6ca3$export$ae9ea24a1b29b07c();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0, $94cdfd151a798194$export$bc4d46b9876ba37)({
                            localLanguage: Array.isArray(detectedLanguage) ? detectedLanguage.join(" ") : detectedLanguage,
                            language: language
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    phrases = _state.sent();
                    lng = response.headers.get("Content-Language");
                    if (!lng) throw new Error("lng not found");
                    return [
                        2,
                        {
                            resources: (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, lng, phrases),
                            lng: lng
                        }
                    ];
                case 4:
                    e = _state.sent();
                    // Fallback to build in en
                    return [
                        2,
                        {
                            resources: {
                                en: (0, $3ad892cee7f164a8$export$2e2bcd8739ae039).en
                            },
                            lng: "en"
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function getI18nResource(language) {
        return _ref.apply(this, arguments);
    };
}();
var $bf9bb39c4fee6ca3$var$storageKey = "i18nextLogtoUiLng";
var $bf9bb39c4fee6ca3$export$ae9ea24a1b29b07c = function(languageSettings) {
    if ((languageSettings === null || languageSettings === void 0 ? void 0 : languageSettings.autoDetect) === false) return languageSettings.fallbackLanguage;
    var languageDetector = new (0, $e37f0af875b54684$export$2e2bcd8739ae039)();
    languageDetector.init(// Pass in a empty i18n languageUtils server instance to bypass the [languageDetector detection](https://github.com/i18next/i18next-browser-languageDetector/blob/master/src/index.js#L70)
    {
        languageUtils: {}
    }, {
        lookupLocalStorage: $bf9bb39c4fee6ca3$var$storageKey,
        lookupSessionStorage: $bf9bb39c4fee6ca3$var$storageKey
    });
    return languageDetector.detect();
};
var $bf9bb39c4fee6ca3$export$61465194746e7fd2 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(language) {
        var _ref, resources, lng, _resources_lng, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, namespace, resource;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $bf9bb39c4fee6ca3$export$ac7fcc5388462ab3(language)
                    ];
                case 1:
                    _ref = _state.sent(), resources = _ref.resources, lng = _ref.lng;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = Object.entries((_resources_lng = resources[lng]) !== null && _resources_lng !== void 0 ? _resources_lng : {})[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), namespace = _step_value[0], resource = _step_value[1];
                            (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).addResourceBundle(lng, namespace, resource);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).changeLanguage(lng)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function changeLanguage(language) {
        return _ref.apply(this, arguments);
    };
}();


// Call once globally
(0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).use((0, $cd4ffcd56d27534c$export$ae7e14d40d89f296));
var $4197d21ae5a6e6a2$var$initI18n = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(initialLanguage) {
        var /**
   * Note
   * - Must call after i18next is initialized
   * - Don't worry to call this multiple times, i18next will replace the formatter if it's already added.
   */ _i18next_services_formatter, _ref, resources, lng, options, i18n;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $bf9bb39c4fee6ca3$export$ac7fcc5388462ab3)(initialLanguage)
                    ];
                case 1:
                    _ref = _state.sent(), resources = _ref.resources, lng = _ref.lng;
                    options = {
                        resources: resources,
                        lng: lng,
                        interpolation: {
                            escapeValue: false
                        }
                    };
                    i18n = (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).init(options);
                    (_i18next_services_formatter = (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).services.formatter) === null || _i18next_services_formatter === void 0 ? void 0 : _i18next_services_formatter.add("zhOrSpaces", function(value, lng) {
                        if (lng !== "zh-CN") return value;
                        return value.replaceAll(/或/g, " 或 ");
                    });
                    return [
                        2,
                        i18n
                    ];
            }
        });
    });
    return function initI18n(initialLanguage) {
        return _ref.apply(this, arguments);
    };
}();
var $4197d21ae5a6e6a2$export$2e2bcd8739ae039 = $4197d21ae5a6e6a2$var$initI18n;




var $14a274f0b6caba9a$export$12e44e23ec720850;
(function(UserFlow) {
    UserFlow["SignIn"] = "sign-in";
    UserFlow["Register"] = "register";
    UserFlow["ForgotPassword"] = "forgot-password";
    UserFlow["Continue"] = "continue";
})($14a274f0b6caba9a$export$12e44e23ec720850 || ($14a274f0b6caba9a$export$12e44e23ec720850 = {}));
var $14a274f0b6caba9a$export$6a49be5b3307a2d;
(function(UserMfaFlow) {
    UserMfaFlow["MfaBinding"] = "mfa-binding";
    UserMfaFlow["MfaVerification"] = "mfa-verification";
})($14a274f0b6caba9a$export$6a49be5b3307a2d || ($14a274f0b6caba9a$export$6a49be5b3307a2d = {}));
var $14a274f0b6caba9a$export$c4eb3ba4f04fab5;
(function(SearchParameters) {
    SearchParameters["NativeCallbackLink"] = "native_callback";
    SearchParameters["RedirectTo"] = "redirect_to";
    SearchParameters["LinkSocial"] = "link_social";
})($14a274f0b6caba9a$export$c4eb3ba4f04fab5 || ($14a274f0b6caba9a$export$c4eb3ba4f04fab5 = {}));




/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $3L4GM = parcelRequire("3L4GM");
var $53886a39c0d513d2$export$a143d493d941bafc;
var $53886a39c0d513d2$export$e4cf37d7f6fb9e0a;
var $53886a39c0d513d2$export$f99ded8fe4b79145;
var $53886a39c0d513d2$export$599f31c3813fae4d;
"use strict";
var $f61bca71547a48ec$export$a48f0734ac7c2329;
var $f61bca71547a48ec$export$d622b2ad8d90c771;
var $f61bca71547a48ec$export$6100ba28696e12de;
"use strict";
$f61bca71547a48ec$export$a48f0734ac7c2329 = $f61bca71547a48ec$var$byteLength;
$f61bca71547a48ec$export$d622b2ad8d90c771 = $f61bca71547a48ec$var$toByteArray;
$f61bca71547a48ec$export$6100ba28696e12de = $f61bca71547a48ec$var$fromByteArray;
var $f61bca71547a48ec$var$lookup = [];
var $f61bca71547a48ec$var$revLookup = [];
var $f61bca71547a48ec$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $f61bca71547a48ec$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $f61bca71547a48ec$var$i = 0, $f61bca71547a48ec$var$len = $f61bca71547a48ec$var$code.length; $f61bca71547a48ec$var$i < $f61bca71547a48ec$var$len; ++$f61bca71547a48ec$var$i){
    $f61bca71547a48ec$var$lookup[$f61bca71547a48ec$var$i] = $f61bca71547a48ec$var$code[$f61bca71547a48ec$var$i];
    $f61bca71547a48ec$var$revLookup[$f61bca71547a48ec$var$code.charCodeAt($f61bca71547a48ec$var$i)] = $f61bca71547a48ec$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$f61bca71547a48ec$var$revLookup["-".charCodeAt(0)] = 62;
$f61bca71547a48ec$var$revLookup["_".charCodeAt(0)] = 63;
function $f61bca71547a48ec$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $f61bca71547a48ec$var$byteLength(b64) {
    var lens = $f61bca71547a48ec$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f61bca71547a48ec$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f61bca71547a48ec$var$toByteArray(b64) {
    var tmp;
    var lens = $f61bca71547a48ec$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $f61bca71547a48ec$var$Arr($f61bca71547a48ec$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $f61bca71547a48ec$var$revLookup[b64.charCodeAt(i)] << 18 | $f61bca71547a48ec$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $f61bca71547a48ec$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $f61bca71547a48ec$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $f61bca71547a48ec$var$revLookup[b64.charCodeAt(i)] << 2 | $f61bca71547a48ec$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $f61bca71547a48ec$var$revLookup[b64.charCodeAt(i)] << 10 | $f61bca71547a48ec$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $f61bca71547a48ec$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $f61bca71547a48ec$var$tripletToBase64(num) {
    return $f61bca71547a48ec$var$lookup[num >> 18 & 0x3F] + $f61bca71547a48ec$var$lookup[num >> 12 & 0x3F] + $f61bca71547a48ec$var$lookup[num >> 6 & 0x3F] + $f61bca71547a48ec$var$lookup[num & 0x3F];
}
function $f61bca71547a48ec$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($f61bca71547a48ec$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $f61bca71547a48ec$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($f61bca71547a48ec$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($f61bca71547a48ec$var$lookup[tmp >> 2] + $f61bca71547a48ec$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($f61bca71547a48ec$var$lookup[tmp >> 10] + $f61bca71547a48ec$var$lookup[tmp >> 4 & 0x3F] + $f61bca71547a48ec$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $1681d77caba18500$export$aafa59e2e03f2942;
var $1681d77caba18500$export$68d8715fc104d294;
$1681d77caba18500$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$1681d77caba18500$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $53886a39c0d513d2$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$53886a39c0d513d2$export$a143d493d941bafc = $53886a39c0d513d2$var$Buffer;
$53886a39c0d513d2$export$e4cf37d7f6fb9e0a = $53886a39c0d513d2$var$SlowBuffer;
$53886a39c0d513d2$export$f99ded8fe4b79145 = 50;
var $53886a39c0d513d2$var$K_MAX_LENGTH = 0x7fffffff;
$53886a39c0d513d2$export$599f31c3813fae4d = $53886a39c0d513d2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $53886a39c0d513d2$var$Buffer.TYPED_ARRAY_SUPPORT = $53886a39c0d513d2$var$typedArraySupport();
if (!$53886a39c0d513d2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $53886a39c0d513d2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($53886a39c0d513d2$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$53886a39c0d513d2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($53886a39c0d513d2$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$53886a39c0d513d2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $53886a39c0d513d2$var$createBuffer(length) {
    if (length > $53886a39c0d513d2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $53886a39c0d513d2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $53886a39c0d513d2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $53886a39c0d513d2$var$allocUnsafe(arg);
    }
    return $53886a39c0d513d2$var$from(arg, encodingOrOffset, length);
}
$53886a39c0d513d2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $53886a39c0d513d2$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $53886a39c0d513d2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $53886a39c0d513d2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3L4GM._)(value)));
    if ($53886a39c0d513d2$var$isInstance(value, ArrayBuffer) || value && $53886a39c0d513d2$var$isInstance(value.buffer, ArrayBuffer)) return $53886a39c0d513d2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($53886a39c0d513d2$var$isInstance(value, SharedArrayBuffer) || value && $53886a39c0d513d2$var$isInstance(value.buffer, SharedArrayBuffer))) return $53886a39c0d513d2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $53886a39c0d513d2$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $53886a39c0d513d2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $53886a39c0d513d2$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3L4GM._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $53886a39c0d513d2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $53886a39c0d513d2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($53886a39c0d513d2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($53886a39c0d513d2$var$Buffer, Uint8Array);
function $53886a39c0d513d2$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $53886a39c0d513d2$var$alloc(size, fill, encoding) {
    $53886a39c0d513d2$var$assertSize(size);
    if (size <= 0) return $53886a39c0d513d2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $53886a39c0d513d2$var$createBuffer(size).fill(fill, encoding) : $53886a39c0d513d2$var$createBuffer(size).fill(fill);
    return $53886a39c0d513d2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $53886a39c0d513d2$var$Buffer.alloc = function(size, fill, encoding) {
    return $53886a39c0d513d2$var$alloc(size, fill, encoding);
};
function $53886a39c0d513d2$var$allocUnsafe(size) {
    $53886a39c0d513d2$var$assertSize(size);
    return $53886a39c0d513d2$var$createBuffer(size < 0 ? 0 : $53886a39c0d513d2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $53886a39c0d513d2$var$Buffer.allocUnsafe = function(size) {
    return $53886a39c0d513d2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $53886a39c0d513d2$var$Buffer.allocUnsafeSlow = function(size) {
    return $53886a39c0d513d2$var$allocUnsafe(size);
};
function $53886a39c0d513d2$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$53886a39c0d513d2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $53886a39c0d513d2$var$byteLength(string, encoding) | 0;
    var buf = $53886a39c0d513d2$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $53886a39c0d513d2$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $53886a39c0d513d2$var$checked(array.length) | 0;
    var buf = $53886a39c0d513d2$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $53886a39c0d513d2$var$fromArrayView(arrayView) {
    if ($53886a39c0d513d2$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $53886a39c0d513d2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $53886a39c0d513d2$var$fromArrayLike(arrayView);
}
function $53886a39c0d513d2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $53886a39c0d513d2$var$Buffer.prototype);
    return buf;
}
function $53886a39c0d513d2$var$fromObject(obj) {
    if ($53886a39c0d513d2$var$Buffer.isBuffer(obj)) {
        var len = $53886a39c0d513d2$var$checked(obj.length) | 0;
        var buf = $53886a39c0d513d2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $53886a39c0d513d2$var$numberIsNaN(obj.length)) return $53886a39c0d513d2$var$createBuffer(0);
        return $53886a39c0d513d2$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $53886a39c0d513d2$var$fromArrayLike(obj.data);
}
function $53886a39c0d513d2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $53886a39c0d513d2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $53886a39c0d513d2$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $53886a39c0d513d2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $53886a39c0d513d2$var$Buffer.alloc(+length);
}
$53886a39c0d513d2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $53886a39c0d513d2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$53886a39c0d513d2$var$Buffer.compare = function compare(a, b) {
    if ($53886a39c0d513d2$var$isInstance(a, Uint8Array)) a = $53886a39c0d513d2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($53886a39c0d513d2$var$isInstance(b, Uint8Array)) b = $53886a39c0d513d2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$53886a39c0d513d2$var$Buffer.isBuffer(a) || !$53886a39c0d513d2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$53886a39c0d513d2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$53886a39c0d513d2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $53886a39c0d513d2$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $53886a39c0d513d2$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($53886a39c0d513d2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $53886a39c0d513d2$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$53886a39c0d513d2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $53886a39c0d513d2$var$byteLength(string, encoding) {
    if ($53886a39c0d513d2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $53886a39c0d513d2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3L4GM._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $53886a39c0d513d2$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $53886a39c0d513d2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $53886a39c0d513d2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$53886a39c0d513d2$var$Buffer.byteLength = $53886a39c0d513d2$var$byteLength;
function $53886a39c0d513d2$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $53886a39c0d513d2$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $53886a39c0d513d2$var$utf8Slice(this, start, end);
        case "ascii":
            return $53886a39c0d513d2$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $53886a39c0d513d2$var$latin1Slice(this, start, end);
        case "base64":
            return $53886a39c0d513d2$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $53886a39c0d513d2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$53886a39c0d513d2$var$Buffer.prototype._isBuffer = true;
function $53886a39c0d513d2$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$53886a39c0d513d2$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$53886a39c0d513d2$var$swap(this, i, i + 1);
    return this;
};
$53886a39c0d513d2$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $53886a39c0d513d2$var$swap(this, i, i + 3);
        $53886a39c0d513d2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$53886a39c0d513d2$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $53886a39c0d513d2$var$swap(this, i, i + 7);
        $53886a39c0d513d2$var$swap(this, i + 1, i + 6);
        $53886a39c0d513d2$var$swap(this, i + 2, i + 5);
        $53886a39c0d513d2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$53886a39c0d513d2$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $53886a39c0d513d2$var$utf8Slice(this, 0, length);
    return $53886a39c0d513d2$var$slowToString.apply(this, arguments);
};
$53886a39c0d513d2$var$Buffer.prototype.toLocaleString = $53886a39c0d513d2$var$Buffer.prototype.toString;
$53886a39c0d513d2$var$Buffer.prototype.equals = function equals(b) {
    if (!$53886a39c0d513d2$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $53886a39c0d513d2$var$Buffer.compare(this, b) === 0;
};
$53886a39c0d513d2$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $53886a39c0d513d2$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($53886a39c0d513d2$var$customInspectSymbol) $53886a39c0d513d2$var$Buffer.prototype[$53886a39c0d513d2$var$customInspectSymbol] = $53886a39c0d513d2$var$Buffer.prototype.inspect;
$53886a39c0d513d2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($53886a39c0d513d2$var$isInstance(target, Uint8Array)) target = $53886a39c0d513d2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$53886a39c0d513d2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3L4GM._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $53886a39c0d513d2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($53886a39c0d513d2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $53886a39c0d513d2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($53886a39c0d513d2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $53886a39c0d513d2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $53886a39c0d513d2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $53886a39c0d513d2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$53886a39c0d513d2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$53886a39c0d513d2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $53886a39c0d513d2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$53886a39c0d513d2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $53886a39c0d513d2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $53886a39c0d513d2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($53886a39c0d513d2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $53886a39c0d513d2$var$utf8Write(buf, string, offset, length) {
    return $53886a39c0d513d2$var$blitBuffer($53886a39c0d513d2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $53886a39c0d513d2$var$asciiWrite(buf, string, offset, length) {
    return $53886a39c0d513d2$var$blitBuffer($53886a39c0d513d2$var$asciiToBytes(string), buf, offset, length);
}
function $53886a39c0d513d2$var$base64Write(buf, string, offset, length) {
    return $53886a39c0d513d2$var$blitBuffer($53886a39c0d513d2$var$base64ToBytes(string), buf, offset, length);
}
function $53886a39c0d513d2$var$ucs2Write(buf, string, offset, length) {
    return $53886a39c0d513d2$var$blitBuffer($53886a39c0d513d2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$53886a39c0d513d2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $53886a39c0d513d2$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $53886a39c0d513d2$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $53886a39c0d513d2$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $53886a39c0d513d2$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $53886a39c0d513d2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$53886a39c0d513d2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $53886a39c0d513d2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $f61bca71547a48ec$export$6100ba28696e12de(buf);
    else return $f61bca71547a48ec$export$6100ba28696e12de(buf.slice(start, end));
}
function $53886a39c0d513d2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $53886a39c0d513d2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $53886a39c0d513d2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $53886a39c0d513d2$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $53886a39c0d513d2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $53886a39c0d513d2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $53886a39c0d513d2$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $53886a39c0d513d2$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $53886a39c0d513d2$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $53886a39c0d513d2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $53886a39c0d513d2$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$53886a39c0d513d2$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $53886a39c0d513d2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $53886a39c0d513d2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$53886a39c0d513d2$var$Buffer.prototype.readUintLE = $53886a39c0d513d2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$53886a39c0d513d2$var$Buffer.prototype.readUintBE = $53886a39c0d513d2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$53886a39c0d513d2$var$Buffer.prototype.readUint8 = $53886a39c0d513d2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$53886a39c0d513d2$var$Buffer.prototype.readUint16LE = $53886a39c0d513d2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$53886a39c0d513d2$var$Buffer.prototype.readUint16BE = $53886a39c0d513d2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$53886a39c0d513d2$var$Buffer.prototype.readUint32LE = $53886a39c0d513d2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$53886a39c0d513d2$var$Buffer.prototype.readUint32BE = $53886a39c0d513d2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$53886a39c0d513d2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$53886a39c0d513d2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$53886a39c0d513d2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$53886a39c0d513d2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$53886a39c0d513d2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$53886a39c0d513d2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$53886a39c0d513d2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$53886a39c0d513d2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 4, this.length);
    return $1681d77caba18500$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$53886a39c0d513d2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 4, this.length);
    return $1681d77caba18500$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$53886a39c0d513d2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 8, this.length);
    return $1681d77caba18500$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$53886a39c0d513d2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkOffset(offset, 8, this.length);
    return $1681d77caba18500$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $53886a39c0d513d2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$53886a39c0d513d2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$53886a39c0d513d2$var$Buffer.prototype.writeUintLE = $53886a39c0d513d2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $53886a39c0d513d2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$53886a39c0d513d2$var$Buffer.prototype.writeUintBE = $53886a39c0d513d2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $53886a39c0d513d2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$53886a39c0d513d2$var$Buffer.prototype.writeUint8 = $53886a39c0d513d2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$53886a39c0d513d2$var$Buffer.prototype.writeUint16LE = $53886a39c0d513d2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$53886a39c0d513d2$var$Buffer.prototype.writeUint16BE = $53886a39c0d513d2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$53886a39c0d513d2$var$Buffer.prototype.writeUint32LE = $53886a39c0d513d2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$53886a39c0d513d2$var$Buffer.prototype.writeUint32BE = $53886a39c0d513d2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$53886a39c0d513d2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $53886a39c0d513d2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$53886a39c0d513d2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $53886a39c0d513d2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$53886a39c0d513d2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$53886a39c0d513d2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$53886a39c0d513d2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$53886a39c0d513d2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$53886a39c0d513d2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $53886a39c0d513d2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $53886a39c0d513d2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1681d77caba18500$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$53886a39c0d513d2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $53886a39c0d513d2$var$writeFloat(this, value, offset, true, noAssert);
};
$53886a39c0d513d2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $53886a39c0d513d2$var$writeFloat(this, value, offset, false, noAssert);
};
function $53886a39c0d513d2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $53886a39c0d513d2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1681d77caba18500$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$53886a39c0d513d2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $53886a39c0d513d2$var$writeDouble(this, value, offset, true, noAssert);
};
$53886a39c0d513d2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $53886a39c0d513d2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$53886a39c0d513d2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$53886a39c0d513d2$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$53886a39c0d513d2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$53886a39c0d513d2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $53886a39c0d513d2$var$Buffer.isBuffer(val) ? val : $53886a39c0d513d2$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $53886a39c0d513d2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $53886a39c0d513d2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($53886a39c0d513d2$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $53886a39c0d513d2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $53886a39c0d513d2$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $53886a39c0d513d2$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $53886a39c0d513d2$var$base64ToBytes(str) {
    return $f61bca71547a48ec$export$d622b2ad8d90c771($53886a39c0d513d2$var$base64clean(str));
}
function $53886a39c0d513d2$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $53886a39c0d513d2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $53886a39c0d513d2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $53886a39c0d513d2$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $8f7dad84c2bf1bf9$require$Buffer = $53886a39c0d513d2$export$a143d493d941bafc;
var $8f7dad84c2bf1bf9$export$83d89fbfd8236492 = "3.7.5";
/**
 * @deprecated use lowercase `version`.
 */ var $8f7dad84c2bf1bf9$export$a4ad2735b021c132 = $8f7dad84c2bf1bf9$export$83d89fbfd8236492;
var $8f7dad84c2bf1bf9$var$_hasatob = typeof atob === "function";
var $8f7dad84c2bf1bf9$var$_hasbtoa = typeof btoa === "function";
var $8f7dad84c2bf1bf9$var$_hasBuffer = typeof $8f7dad84c2bf1bf9$require$Buffer === "function";
var $8f7dad84c2bf1bf9$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
var $8f7dad84c2bf1bf9$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
var $8f7dad84c2bf1bf9$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var $8f7dad84c2bf1bf9$var$b64chs = Array.prototype.slice.call($8f7dad84c2bf1bf9$var$b64ch);
var $8f7dad84c2bf1bf9$var$b64tab = function(a) {
    var tab = {};
    a.forEach(function(c, i) {
        return tab[c] = i;
    });
    return tab;
}($8f7dad84c2bf1bf9$var$b64chs);
var $8f7dad84c2bf1bf9$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
var $8f7dad84c2bf1bf9$var$_fromCC = String.fromCharCode.bind(String);
var $8f7dad84c2bf1bf9$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : function(it) {
    return new Uint8Array(Array.prototype.slice.call(it, 0));
};
var $8f7dad84c2bf1bf9$var$_mkUriSafe = function(src) {
    return src.replace(/=/g, "").replace(/[+\/]/g, function(m0) {
        return m0 == "+" ? "-" : "_";
    });
};
var $8f7dad84c2bf1bf9$var$_tidyB64 = function(s) {
    return s.replace(/[^A-Za-z0-9\+\/]/g, "");
};
/**
 * polyfill version of `btoa`
 */ var $8f7dad84c2bf1bf9$export$ec0fb543302ee251 = function(bin) {
    // console.log('polyfilled');
    var u32, c0, c1, c2, asc = "";
    var pad = bin.length % 3;
    for(var i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $8f7dad84c2bf1bf9$var$b64chs[u32 >> 18 & 63] + $8f7dad84c2bf1bf9$var$b64chs[u32 >> 12 & 63] + $8f7dad84c2bf1bf9$var$b64chs[u32 >> 6 & 63] + $8f7dad84c2bf1bf9$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ var $8f7dad84c2bf1bf9$export$a32219e24f8d1e2 = $8f7dad84c2bf1bf9$var$_hasbtoa ? function(bin) {
    return btoa(bin);
} : $8f7dad84c2bf1bf9$var$_hasBuffer ? function(bin) {
    return $8f7dad84c2bf1bf9$require$Buffer.from(bin, "binary").toString("base64");
} : $8f7dad84c2bf1bf9$export$ec0fb543302ee251;
var $8f7dad84c2bf1bf9$var$_fromUint8Array = $8f7dad84c2bf1bf9$var$_hasBuffer ? function(u8a) {
    return $8f7dad84c2bf1bf9$require$Buffer.from(u8a).toString("base64");
} : function(u8a) {
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    var maxargs = 0x1000;
    var strs = [];
    for(var i = 0, l = u8a.length; i < l; i += maxargs)strs.push($8f7dad84c2bf1bf9$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $8f7dad84c2bf1bf9$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ var $8f7dad84c2bf1bf9$export$27bbb4e040978768 = function(u8a) {
    var urlsafe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return urlsafe ? $8f7dad84c2bf1bf9$var$_mkUriSafe($8f7dad84c2bf1bf9$var$_fromUint8Array(u8a)) : $8f7dad84c2bf1bf9$var$_fromUint8Array(u8a);
};
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
var $8f7dad84c2bf1bf9$var$cb_utob = function(c) {
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $8f7dad84c2bf1bf9$var$_fromCC(0xc0 | cc >>> 6) + $8f7dad84c2bf1bf9$var$_fromCC(0x80 | cc & 0x3f) : $8f7dad84c2bf1bf9$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $8f7dad84c2bf1bf9$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $8f7dad84c2bf1bf9$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $8f7dad84c2bf1bf9$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $8f7dad84c2bf1bf9$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $8f7dad84c2bf1bf9$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $8f7dad84c2bf1bf9$var$_fromCC(0x80 | cc & 0x3f);
    }
};
var $8f7dad84c2bf1bf9$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ var $8f7dad84c2bf1bf9$export$10d4b9bd20a66b0 = function(u) {
    return u.replace($8f7dad84c2bf1bf9$var$re_utob, $8f7dad84c2bf1bf9$var$cb_utob);
};
//
var $8f7dad84c2bf1bf9$var$_encode = $8f7dad84c2bf1bf9$var$_hasBuffer ? function(s) {
    return $8f7dad84c2bf1bf9$require$Buffer.from(s, "utf8").toString("base64");
} : $8f7dad84c2bf1bf9$var$_TE ? function(s) {
    return $8f7dad84c2bf1bf9$var$_fromUint8Array($8f7dad84c2bf1bf9$var$_TE.encode(s));
} : function(s) {
    return $8f7dad84c2bf1bf9$export$a32219e24f8d1e2($8f7dad84c2bf1bf9$export$10d4b9bd20a66b0(s));
};
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ var $8f7dad84c2bf1bf9$export$37cc283d8fbd3462 = function(src) {
    var urlsafe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return urlsafe ? $8f7dad84c2bf1bf9$var$_mkUriSafe($8f7dad84c2bf1bf9$var$_encode(src)) : $8f7dad84c2bf1bf9$var$_encode(src);
};
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ var $8f7dad84c2bf1bf9$export$90c31d5baa78df44 = function(src) {
    return $8f7dad84c2bf1bf9$export$37cc283d8fbd3462(src, true);
};
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
var $8f7dad84c2bf1bf9$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
var $8f7dad84c2bf1bf9$var$cb_btou = function(cccc) {
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $8f7dad84c2bf1bf9$var$_fromCC((offset >>> 10) + 0xD800) + $8f7dad84c2bf1bf9$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $8f7dad84c2bf1bf9$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $8f7dad84c2bf1bf9$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ var $8f7dad84c2bf1bf9$export$67e9defdeac3dd95 = function(b) {
    return b.replace($8f7dad84c2bf1bf9$var$re_btou, $8f7dad84c2bf1bf9$var$cb_btou);
};
/**
 * polyfill version of `atob`
 */ var $8f7dad84c2bf1bf9$export$7f16d8e674ddec24 = function(asc) {
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$8f7dad84c2bf1bf9$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    var u24, bin = "", r1, r2;
    for(var i = 0; i < asc.length;){
        u24 = $8f7dad84c2bf1bf9$var$b64tab[asc.charAt(i++)] << 18 | $8f7dad84c2bf1bf9$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $8f7dad84c2bf1bf9$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $8f7dad84c2bf1bf9$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $8f7dad84c2bf1bf9$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $8f7dad84c2bf1bf9$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $8f7dad84c2bf1bf9$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ var $8f7dad84c2bf1bf9$export$1406ac7a6dfd7b7a = $8f7dad84c2bf1bf9$var$_hasatob ? function(asc) {
    return atob($8f7dad84c2bf1bf9$var$_tidyB64(asc));
} : $8f7dad84c2bf1bf9$var$_hasBuffer ? function(asc) {
    return $8f7dad84c2bf1bf9$require$Buffer.from(asc, "base64").toString("binary");
} : $8f7dad84c2bf1bf9$export$7f16d8e674ddec24;
//
var $8f7dad84c2bf1bf9$var$_toUint8Array = $8f7dad84c2bf1bf9$var$_hasBuffer ? function(a) {
    return $8f7dad84c2bf1bf9$var$_U8Afrom($8f7dad84c2bf1bf9$require$Buffer.from(a, "base64"));
} : function(a) {
    return $8f7dad84c2bf1bf9$var$_U8Afrom($8f7dad84c2bf1bf9$export$1406ac7a6dfd7b7a(a).split("").map(function(c) {
        return c.charCodeAt(0);
    }));
};
/**
 * converts a Base64 string to a Uint8Array.
 */ var $8f7dad84c2bf1bf9$export$73470fd2221e6aef = function(a) {
    return $8f7dad84c2bf1bf9$var$_toUint8Array($8f7dad84c2bf1bf9$var$_unURI(a));
};
//
var $8f7dad84c2bf1bf9$var$_decode = $8f7dad84c2bf1bf9$var$_hasBuffer ? function(a) {
    return $8f7dad84c2bf1bf9$require$Buffer.from(a, "base64").toString("utf8");
} : $8f7dad84c2bf1bf9$var$_TD ? function(a) {
    return $8f7dad84c2bf1bf9$var$_TD.decode($8f7dad84c2bf1bf9$var$_toUint8Array(a));
} : function(a) {
    return $8f7dad84c2bf1bf9$export$67e9defdeac3dd95($8f7dad84c2bf1bf9$export$1406ac7a6dfd7b7a(a));
};
var $8f7dad84c2bf1bf9$var$_unURI = function(a) {
    return $8f7dad84c2bf1bf9$var$_tidyB64(a.replace(/[-_]/g, function(m0) {
        return m0 == "-" ? "+" : "/";
    }));
};
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ var $8f7dad84c2bf1bf9$export$c537b38001c583b7 = function(src) {
    return $8f7dad84c2bf1bf9$var$_decode($8f7dad84c2bf1bf9$var$_unURI(src));
};
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ var $8f7dad84c2bf1bf9$export$1ea939691cdc45b8 = function(src) {
    if (typeof src !== "string") return false;
    var s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
var $8f7dad84c2bf1bf9$var$_noEnum = function(v) {
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ var $8f7dad84c2bf1bf9$export$4678ebf2295c49b = function extendString() {
    var _add = function(name, body) {
        return Object.defineProperty(String.prototype, name, $8f7dad84c2bf1bf9$var$_noEnum(body));
    };
    _add("fromBase64", function() {
        return $8f7dad84c2bf1bf9$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $8f7dad84c2bf1bf9$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $8f7dad84c2bf1bf9$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $8f7dad84c2bf1bf9$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $8f7dad84c2bf1bf9$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ var $8f7dad84c2bf1bf9$export$a105d6a15258bd2 = function extendUint8Array() {
    var _add = function(name, body) {
        return Object.defineProperty(Uint8Array.prototype, name, $8f7dad84c2bf1bf9$var$_noEnum(body));
    };
    _add("toBase64", function(urlsafe) {
        return $8f7dad84c2bf1bf9$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $8f7dad84c2bf1bf9$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $8f7dad84c2bf1bf9$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ var $8f7dad84c2bf1bf9$export$1abf1fe5ebfd5245 = function() {
    $8f7dad84c2bf1bf9$export$4678ebf2295c49b();
    $8f7dad84c2bf1bf9$export$a105d6a15258bd2();
};
var $8f7dad84c2bf1bf9$export$f436b0c2107cbd35 = {
    version: $8f7dad84c2bf1bf9$export$83d89fbfd8236492,
    VERSION: $8f7dad84c2bf1bf9$export$a4ad2735b021c132,
    atob: $8f7dad84c2bf1bf9$export$1406ac7a6dfd7b7a,
    atobPolyfill: $8f7dad84c2bf1bf9$export$7f16d8e674ddec24,
    btoa: $8f7dad84c2bf1bf9$export$a32219e24f8d1e2,
    btoaPolyfill: $8f7dad84c2bf1bf9$export$ec0fb543302ee251,
    fromBase64: $8f7dad84c2bf1bf9$export$c537b38001c583b7,
    toBase64: $8f7dad84c2bf1bf9$export$37cc283d8fbd3462,
    encode: $8f7dad84c2bf1bf9$export$37cc283d8fbd3462,
    encodeURI: $8f7dad84c2bf1bf9$export$90c31d5baa78df44,
    encodeURL: $8f7dad84c2bf1bf9$export$90c31d5baa78df44,
    utob: $8f7dad84c2bf1bf9$export$10d4b9bd20a66b0,
    btou: $8f7dad84c2bf1bf9$export$67e9defdeac3dd95,
    decode: $8f7dad84c2bf1bf9$export$c537b38001c583b7,
    isValid: $8f7dad84c2bf1bf9$export$1ea939691cdc45b8,
    fromUint8Array: $8f7dad84c2bf1bf9$export$27bbb4e040978768,
    toUint8Array: $8f7dad84c2bf1bf9$export$73470fd2221e6aef,
    extendString: $8f7dad84c2bf1bf9$export$4678ebf2295c49b,
    extendUint8Array: $8f7dad84c2bf1bf9$export$a105d6a15258bd2,
    extendBuiltins: $8f7dad84c2bf1bf9$export$1abf1fe5ebfd5245
};


var $300f68c6e84b0fc8$export$9e15fb06e64c4810 = function() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
    return (0, $8f7dad84c2bf1bf9$export$27bbb4e040978768)(crypto.getRandomValues(new Uint8Array(length)), true);
};
var $300f68c6e84b0fc8$export$2469638cb19f7e00 = function(parameters) {
    var searchParameters = parameters instanceof URLSearchParams ? parameters : new URLSearchParams(parameters);
    return Object.fromEntries((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(searchParameters.entries()).map(function(param) {
        var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            decodeURIComponent(value)
        ];
    }));
};
var $300f68c6e84b0fc8$export$160057b430cb5a30 = function(parameters) {
    var searchParameters = parameters instanceof URLSearchParams ? parameters : new URLSearchParams(parameters);
    return searchParameters.toString();
};
var $300f68c6e84b0fc8$export$6bcd65cae0372ddf = function(parameters, key) {
    var searchParameters = parameters instanceof URLSearchParams ? parameters : new URLSearchParams(parameters);
    var _searchParameters_get;
    return (_searchParameters_get = searchParameters.get(key)) !== null && _searchParameters_get !== void 0 ? _searchParameters_get : undefined;
};
var $300f68c6e84b0fc8$export$3e9f948b41964866 = function(object) {
    return(// eslint-disable-next-line no-restricted-syntax
    Object.entries(object));
};
var $300f68c6e84b0fc8$export$5150077fc2e7c662 = function(entries) {
    return(// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(entries));
};
var $300f68c6e84b0fc8$export$593c2aea212a54d2 = function(key, object) {
    return key in object;
};


/**
 * Native SDK Utility Methods
 */ var $77651ccac61c94e5$export$83ff207f4052eaad = function() {
    if (typeof logtoNativeSdk !== "undefined") return logtoNativeSdk;
};
var $77651ccac61c94e5$export$a38f4a317af23d71 = function() {
    var _getLogtoNativeSdk;
    var _getLogtoNativeSdk_platform;
    var platform = (_getLogtoNativeSdk_platform = (_getLogtoNativeSdk = $77651ccac61c94e5$export$83ff207f4052eaad()) === null || _getLogtoNativeSdk === void 0 ? void 0 : _getLogtoNativeSdk.platform) !== null && _getLogtoNativeSdk_platform !== void 0 ? _getLogtoNativeSdk_platform : "";
    return [
        "ios",
        "android"
    ].includes(platform);
};


/**
 * Social Connector State Utility Methods
 */ var $6f7af2e59a37a635$var$storageStateKeyPrefix = "social_auth_state";
var $6f7af2e59a37a635$export$9ccd2716e53a229b = function() {
    var uuid = (0, $300f68c6e84b0fc8$export$9e15fb06e64c4810)();
    return uuid;
};
var $6f7af2e59a37a635$export$ca97131192bad836 = function(state, connectorId) {
    sessionStorage.setItem("".concat($6f7af2e59a37a635$var$storageStateKeyPrefix, ":").concat(connectorId), state);
};
var $6f7af2e59a37a635$export$cd0e7726290ef99e = function(state, connectorId) {
    var storageKey = "".concat($6f7af2e59a37a635$var$storageStateKeyPrefix, ":").concat(connectorId);
    var stateStorage = sessionStorage.getItem(storageKey);
    sessionStorage.removeItem(storageKey);
    return stateStorage === state;
};
var $6f7af2e59a37a635$export$4c3119be9cbddec4 = "social_callback_data";
var $6f7af2e59a37a635$export$89813b95fc66aafa = function(path, redirectTo) {
    var _getLogtoNativeSdk;
    var origin = window.location.origin;
    var url = new URL("".concat(origin).concat(path));
    url.searchParams.set((0, $14a274f0b6caba9a$export$c4eb3ba4f04fab5).RedirectTo, redirectTo);
    var callbackLink = (_getLogtoNativeSdk = (0, $77651ccac61c94e5$export$83ff207f4052eaad)()) === null || _getLogtoNativeSdk === void 0 ? void 0 : _getLogtoNativeSdk.callbackLink;
    if (callbackLink) url.searchParams.set((0, $14a274f0b6caba9a$export$c4eb3ba4f04fab5).NativeCallbackLink, callbackLink);
    return url;
};
var $6f7af2e59a37a635$export$1532ee36eebdb77d = function(connectorId, callbackLink) {
    sessionStorage.setItem("".concat($6f7af2e59a37a635$export$4c3119be9cbddec4, ":").concat(connectorId), callbackLink);
};
var $6f7af2e59a37a635$export$179d5bca54e18dc6 = function(connectorId) {
    return sessionStorage.getItem("".concat($6f7af2e59a37a635$export$4c3119be9cbddec4, ":").concat(connectorId));
};
var $6f7af2e59a37a635$export$d02cb51c63c7e560 = function(connectorId) {
    sessionStorage.removeItem("".concat($6f7af2e59a37a635$export$4c3119be9cbddec4, ":").concat(connectorId));
};
var $6f7af2e59a37a635$export$a52a66b412bd435d = function(socialConnectors) {
    if (!socialConnectors) return [];
    var connectorMap = new Map();
    /**
   * Browser Environment
   * Accepts both web and universal platform connectors.
   * Insert universal connectors only if there is no web platform connector provided with the same target.
   * Web platform has higher priority.
   **/ if (!(0, $77651ccac61c94e5$export$a38f4a317af23d71)()) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = socialConnectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var connector = _step.value;
                var platform = connector.platform, target = connector.target;
                if (platform === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Native) continue;
                if (platform === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Web || !connectorMap.get(target)) {
                    connectorMap.set(target, connector);
                    continue;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return Array.from(connectorMap.values());
    }
    var _getLogtoNativeSdk;
    /**
   * Native Webview Environment
   * Accepts both native and universal platform connectors.
   * Native platform has higher priority.
   **/ var _ref = (_getLogtoNativeSdk = (0, $77651ccac61c94e5$export$83ff207f4052eaad)()) !== null && _getLogtoNativeSdk !== void 0 ? _getLogtoNativeSdk : {}, supportedConnector = _ref.supportedConnector, getPostMessage = _ref.getPostMessage, callbackLink = _ref.callbackLink;
    if (!getPostMessage) // Invalid Native SDK bridge injections, not able to sign in with any social connectors.
    return [];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = socialConnectors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var connector1 = _step1.value;
            var platform1 = connector1.platform, target1 = connector1.target;
            if (platform1 === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Web) continue;
            // Native SupportedConnector Settings is required
            if (!supportedConnector) continue;
            // Native supported nativeTargets flag is required
            if (platform1 === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Native && supportedConnector.nativeTargets.includes(target1)) {
                connectorMap.set(target1, connector1);
                continue;
            }
            /**
     *  Native supportedConnector.universal flag is required
     *  Native callback link settings is required
     *  Only if there is no native platform connector provided with the same target.
     **/ if (platform1 === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Universal && supportedConnector.universal && callbackLink && !connectorMap.get(target1)) {
                connectorMap.set(target1, connector1);
                continue;
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return Array.from(connectorMap.values());
};
var $6f7af2e59a37a635$export$d5f28122a6cebc76 = function(platform, socialConnectors) {
    if (!socialConnectors) return [];
    var connectorMap = new Map();
    /**
   * Browser Environment
   * Accepts both web and universal platform connectors.
   * Insert universal connectors only if there is no web platform connector provided with the same target.
   * Web platform has higher priority.
   **/ if (platform === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Web) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = socialConnectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var connector = _step.value;
                var _$platform = connector.platform, target = connector.target;
                if (_$platform === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Native) continue;
                if (_$platform === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Web || !connectorMap.get(target)) {
                    connectorMap.set(target, connector);
                    continue;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return Array.from(connectorMap.values());
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        /**
   * Native Webview Environment
   * Accepts both native and universal platform connectors.
   * Insert universal connectors only if there is no native platform connector provided with the same target.
   * Native platform has higher priority.
   **/ for(var _iterator1 = socialConnectors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var connector1 = _step1.value;
            var _$platform1 = connector1.platform, target1 = connector1.target;
            if (_$platform1 === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Web) continue;
            if (_$platform1 === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Native || !connectorMap.get(target1)) {
                connectorMap.set(target1, connector1);
                continue;
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return Array.from(connectorMap.values());
};
var $6f7af2e59a37a635$export$f48dbaf6d711748a = function(target) {
    return target === "apple";
};


var $92cc88edb8737776$var$usePreview = function() {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), previewConfig = _useState[0], setPreviewConfig = _useState[1];
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), setTheme = _useContext.setTheme, setPlatform = _useContext.setPlatform, setExperienceSettings = _useContext.setExperienceSettings;
    // Fetch the preview config
    (0, $kVN77.useEffect)(function() {
        // Listen to the message from the ancestor window
        var previewMessageHandler = function() {
            var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
                var previewConfig;
                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(event.data.sender === "ac_preview")) return [
                                3,
                                2
                            ];
                            previewConfig = event.data.config;
                            // Wait for i18n to be initialized
                            return [
                                4,
                                (0, $4197d21ae5a6e6a2$export$2e2bcd8739ae039)(previewConfig.language)
                            ];
                        case 1:
                            _state.sent();
                            setPreviewConfig(previewConfig);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function previewMessageHandler(event) {
                return _ref.apply(this, arguments);
            };
        }();
        window.addEventListener("message", previewMessageHandler);
        return function() {
            window.removeEventListener("message", previewMessageHandler);
        };
    }, []);
    // Set Experience settings
    (0, $kVN77.useEffect)(function() {
        if (!previewConfig) return;
        var socialConnectors = previewConfig.signInExperience.socialConnectors, isNative = previewConfig.isNative, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(previewConfig.signInExperience, [
            "socialConnectors"
        ]);
        var experienceSettings = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, rest), {
            socialConnectors: (0, $6f7af2e59a37a635$export$d5f28122a6cebc76)(isNative ? (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Native : (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Web, socialConnectors)
        });
        setExperienceSettings(experienceSettings);
    }, [
        previewConfig,
        setExperienceSettings
    ]);
    // Set Theme
    (0, $kVN77.useEffect)(function() {
        if (previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.mode) setTheme(previewConfig.mode);
    }, [
        previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.mode,
        setTheme
    ]);
    // Set Platform
    (0, $kVN77.useEffect)(function() {
        if (previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.platform) setPlatform(previewConfig.platform);
    }, [
        previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.platform,
        setPlatform
    ]);
    // Set Language
    (0, $kVN77.useEffect)(function() {
        if (previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.language) (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $bf9bb39c4fee6ca3$export$61465194746e7fd2)(previewConfig.language)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.language
    ]);
};
var $92cc88edb8737776$export$2e2bcd8739ae039 = $92cc88edb8737776$var$usePreview;






var $kVN77 = parcelRequire("kVN77");


/**
 * Temp Solution for getting the sign in experience
 * Remove this once we have a better way to get the sign in experience through SSR
 */ 








var $ad58c69c17955c9c$var$parseSignInExperienceResponse = function(response) {
    var socialConnectors = response.socialConnectors, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(response, [
        "socialConnectors"
    ]);
    return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, rest), {
        socialConnectors: (0, $6f7af2e59a37a635$export$a52a66b412bd435d)(socialConnectors)
    });
};
var $ad58c69c17955c9c$export$8ca2c7a89b3c710d = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var response;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $94cdfd151a798194$export$acc5aa4723208a61)()
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        $ad58c69c17955c9c$var$parseSignInExperienceResponse(response)
                    ];
            }
        });
    });
    return function getSignInExperienceSettings() {
        return _ref.apply(this, arguments);
    };
}();
var $ad58c69c17955c9c$export$627424bf77ed4c79 = function(method) {
    return [
        (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email,
        (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone
    ].includes(method);
};
var $ad58c69c17955c9c$export$9eebb4c3f2056b81 = function(path) {
    // Will update soon, remove generic of `.t()` to unblock
    if (path.startsWith("/sign-in") || path.startsWith("/callback") || path.startsWith("/consent")) return (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).t("description.sign_in");
    if (path.startsWith("/register") || path.startsWith("/social/link")) return (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).t("description.create_account");
    if (path.startsWith("/forgot-password")) return (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).t("description.reset_password");
    // Return undefined for all continue flow pages to keep title remain the same as the previous page
    if (path.startsWith("/continue")) return;
    return "Logto";
};




var $kVN77 = parcelRequire("kVN77");

var $0af32b9ee4c87461$var$darkThemeWatchMedia = window.matchMedia("(prefers-color-scheme: dark)");
var $0af32b9ee4c87461$var$getThemeBySystemConfiguration = function() {
    return $0af32b9ee4c87461$var$darkThemeWatchMedia.matches ? (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Dark : (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Light;
};
function $0af32b9ee4c87461$export$2e2bcd8739ae039() {
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), isPreview = _useContext.isPreview, experienceSettings = _useContext.experienceSettings, setTheme = _useContext.setTheme;
    (0, $kVN77.useEffect)(function() {
        if (!(experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.color.isDarkModeEnabled)) return;
        var changeTheme = function() {
            setTheme($0af32b9ee4c87461$var$getThemeBySystemConfiguration());
        };
        changeTheme();
        $0af32b9ee4c87461$var$darkThemeWatchMedia.addEventListener("change", changeTheme);
        return function() {
            $0af32b9ee4c87461$var$darkThemeWatchMedia.removeEventListener("change", changeTheme);
        };
    }, [
        experienceSettings,
        isPreview,
        setTheme
    ]);
}


var $5a7dfc7b2fbad5f5$var$useSignInExperience = function() {
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), isPreview = _useContext.isPreview, setExperienceSettings = _useContext.setExperienceSettings;
    (0, $0af32b9ee4c87461$export$2e2bcd8739ae039)();
    (0, $kVN77.useEffect)(function() {
        (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
            var _ref, settings;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                (0, $ad58c69c17955c9c$export$8ca2c7a89b3c710d)(),
                                (0, $4197d21ae5a6e6a2$export$2e2bcd8739ae039)()
                            ])
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            1
                        ]), settings = _ref[0];
                        // Init the page settings and render
                        setExperienceSettings(settings);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isPreview,
        setExperienceSettings
    ]);
};
var $5a7dfc7b2fbad5f5$export$2e2bcd8739ae039 = $5a7dfc7b2fbad5f5$var$useSignInExperience;


var $d8c42a2180dab720$var$SettingsProvider = function(param) {
    var children = param.children;
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), isPreview = _useContext.isPreview, experienceSettings = _useContext.experienceSettings;
    var usePageLoad = (0, $kVN77.useMemo)(function() {
        return isPreview ? (0, $92cc88edb8737776$export$2e2bcd8739ae039) : (0, $5a7dfc7b2fbad5f5$export$2e2bcd8739ae039);
    }, [
        isPreview
    ]);
    usePageLoad();
    return experienceSettings ? children : null;
};
var $d8c42a2180dab720$export$2e2bcd8739ae039 = $d8c42a2180dab720$var$SettingsProvider;





var $kVN77 = parcelRequire("kVN77");
/**
 * Provides a hook to access the session storage.
 */ 


var $kVN77 = parcelRequire("kVN77");
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ 










var $3L4GM = parcelRequire("3L4GM");




var $9ca557716949399a$export$58cc9131e3e8861b = /*#__PURE__*/ function(TypeError1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(StructError, TypeError1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(StructError);
    function StructError(failure, failures) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, StructError);
        var _this;
        var cached;
        var message = failure.message, explanation = failure.explanation, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(failure, [
            "message",
            "explanation"
        ]);
        var path = failure.path;
        var msg = path.length === 0 ? message : "At path: ".concat(path.join("."), " -- ").concat(message);
        _this = _super.call(this, explanation !== null && explanation !== void 0 ? explanation : msg);
        if (explanation != null) _this.cause = msg;
        Object.assign((0, $883161a1efd6c88e$export$f3b8ed2e4a5d10b8)(_this), rest);
        _this.name = _this.constructor.name;
        _this.failures = function() {
            return cached !== null && cached !== void 0 ? cached : cached = [
                failure
            ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(failures()));
        };
        return _this;
    }
    return StructError;
}((0, $efec3851c979cc44$export$2466d533fda16e33)(TypeError));
/**
 * Check if a value is an iterator.
 */ function $9ca557716949399a$var$isIterable(x) {
    return $9ca557716949399a$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $9ca557716949399a$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $9ca557716949399a$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $9ca557716949399a$var$print(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $3L4GM._)(value)) === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : "".concat(value);
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $9ca557716949399a$var$shiftIterator(input) {
    var _input_next = input.next(), done = _input_next.done, value = _input_next.value;
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $9ca557716949399a$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    var path = context.path, branch = context.branch;
    var type = struct.type;
    var refinement = result.refinement, _result_message = result.message, message = _result_message === void 0 ? "Expected a value of type `".concat(type, "`").concat(refinement ? " with refinement `".concat(refinement, "`") : "", ", but received: `").concat($9ca557716949399a$var$print(value), "`") : _result_message;
    return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch
    }, result), {
        message: message
    });
}
/**
 * Convert a validation result to an iterable of failures.
 */ function $9ca557716949399a$var$toFailures(result, context, struct, value) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, failure, err;
    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!$9ca557716949399a$var$isIterable(result)) result = [
                    result
                ];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = result[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                r = _step.value;
                failure = $9ca557716949399a$var$toFailure(r, context, struct, value);
                if (!failure) return [
                    3,
                    4
                ];
                return [
                    4,
                    failure
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function $9ca557716949399a$var$run(value, struct) {
    var options, _options_path, path, _options_branch, branch, _options_coerce, coerce, _options_mask, mask, ctx, key, status, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, failure, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, k, v, s, ts, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, t, err, err, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, failure1, err;
    var _arguments = arguments;
    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
        switch(_state.label){
            case 0:
                options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                _options_path = options.path, path = _options_path === void 0 ? [] : _options_path, _options_branch = options.branch, branch = _options_branch === void 0 ? [
                    value
                ] : _options_branch, _options_coerce = options.coerce, coerce = _options_coerce === void 0 ? false : _options_coerce, _options_mask = options.mask, mask = _options_mask === void 0 ? false : _options_mask;
                ctx = {
                    path: path,
                    branch: branch
                };
                if (coerce) {
                    value = struct.coercer(value, ctx);
                    if (mask && struct.type !== "type" && $9ca557716949399a$var$isObject(struct.schema) && $9ca557716949399a$var$isObject(value) && !Array.isArray(value)) {
                        for(var key in value)if (struct.schema[key] === undefined) delete value[key];
                    }
                }
                status = "valid";
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = struct.validator(value, ctx)[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                failure = _step.value;
                failure.explanation = options.message;
                status = "not_valid";
                return [
                    4,
                    [
                        failure,
                        undefined
                    ]
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                _state.label = 9;
            case 9:
                _state.trys.push([
                    9,
                    21,
                    22,
                    23
                ]);
                _iterator1 = struct.entries(value, ctx)[Symbol.iterator]();
                _state.label = 10;
            case 10:
                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                    3,
                    20
                ];
                _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step1.value, 3), k = _step_value[0], v = _step_value[1], s = _step_value[2];
                ts = $9ca557716949399a$var$run(v, s, {
                    path: k === undefined ? path : (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(path).concat([
                        k
                    ]),
                    branch: k === undefined ? branch : (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(branch).concat([
                        v
                    ]),
                    coerce: coerce,
                    mask: mask,
                    message: options.message
                });
                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                _state.label = 11;
            case 11:
                _state.trys.push([
                    11,
                    17,
                    18,
                    19
                ]);
                _iterator2 = ts[Symbol.iterator]();
                _state.label = 12;
            case 12:
                if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                    3,
                    16
                ];
                t = _step2.value;
                if (!t[0]) return [
                    3,
                    14
                ];
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                return [
                    4,
                    [
                        t[0],
                        undefined
                    ]
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    15
                ];
            case 14:
                if (coerce) {
                    v = t[1];
                    if (k === undefined) value = v;
                    else if (value instanceof Map) value.set(k, v);
                    else if (value instanceof Set) value.add(v);
                    else if ($9ca557716949399a$var$isObject(value)) {
                        if (v !== undefined || k in value) value[k] = v;
                    }
                }
                _state.label = 15;
            case 15:
                _iteratorNormalCompletion2 = true;
                return [
                    3,
                    12
                ];
            case 16:
                return [
                    3,
                    19
                ];
            case 17:
                err = _state.sent();
                _didIteratorError2 = true;
                _iteratorError2 = err;
                return [
                    3,
                    19
                ];
            case 18:
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
                return [
                    7
                ];
            case 19:
                _iteratorNormalCompletion1 = true;
                return [
                    3,
                    10
                ];
            case 20:
                return [
                    3,
                    23
                ];
            case 21:
                err = _state.sent();
                _didIteratorError1 = true;
                _iteratorError1 = err;
                return [
                    3,
                    23
                ];
            case 22:
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
                return [
                    7
                ];
            case 23:
                _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                if (!(status !== "not_valid")) return [
                    3,
                    31
                ];
                _state.label = 24;
            case 24:
                _state.trys.push([
                    24,
                    29,
                    30,
                    31
                ]);
                _iterator3 = struct.refiner(value, ctx)[Symbol.iterator]();
                _state.label = 25;
            case 25:
                if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                    3,
                    28
                ];
                failure1 = _step3.value;
                failure1.explanation = options.message;
                status = "not_refined";
                return [
                    4,
                    [
                        failure1,
                        undefined
                    ]
                ];
            case 26:
                _state.sent();
                _state.label = 27;
            case 27:
                _iteratorNormalCompletion3 = true;
                return [
                    3,
                    25
                ];
            case 28:
                return [
                    3,
                    31
                ];
            case 29:
                err = _state.sent();
                _didIteratorError3 = true;
                _iteratorError3 = err;
                return [
                    3,
                    31
                ];
            case 30:
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
                return [
                    7
                ];
            case 31:
                if (!(status === "valid")) return [
                    3,
                    33
                ];
                return [
                    4,
                    [
                        undefined,
                        value
                    ]
                ];
            case 32:
                _state.sent();
                _state.label = 33;
            case 33:
                return [
                    2
                ];
        }
    });
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ var $9ca557716949399a$export$eabc71f011df675a = /*#__PURE__*/ function() {
    "use strict";
    function Struct(props) {
        var _this = this;
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, Struct);
        var type = props.type, schema = props.schema, validator = props.validator, refiner = props.refiner, _props_coercer = props.coercer, coercer = _props_coercer === void 0 ? function(value) {
            return value;
        } : _props_coercer, _props_entries = props.entries, entries = _props_entries === void 0 ? function() {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                return [
                    2
                ];
            });
        } : _props_entries;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = function(value, context) {
            var result = validator(value, context);
            return $9ca557716949399a$var$toFailures(result, context, _this, value);
        };
        else this.validator = function() {
            return [];
        };
        if (refiner) this.refiner = function(value, context) {
            var result = refiner(value, context);
            return $9ca557716949399a$var$toFailures(result, context, _this, value);
        };
        else this.refiner = function() {
            return [];
        };
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(Struct, [
        {
            /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ key: "assert",
            value: function assert1(value, message) {
                return $9ca557716949399a$export$a7a9523472993e97(value, this, message);
            }
        },
        {
            /**
     * Create a value with the struct's coercion logic, then validate it.
     */ key: "create",
            value: function create1(value, message) {
                return $9ca557716949399a$export$185802fd694ee1f5(value, this, message);
            }
        },
        {
            /**
     * Check if a value passes the struct's validation.
     */ key: "is",
            value: function is1(value) {
                return $9ca557716949399a$export$226b3eccf92c9ed9(value, this);
            }
        },
        {
            /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema.
     */ key: "mask",
            value: function mask1(value, message) {
                return $9ca557716949399a$export$d99f0801a68bbcf1(value, this, message);
            }
        },
        {
            /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `withCoercion` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful.
     */ key: "validate",
            value: function validate1(value) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return $9ca557716949399a$export$a22775fa5e2eebd9(value, this, options);
            }
        }
    ]);
    return Struct;
}();
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $9ca557716949399a$export$a7a9523472993e97(value, struct, message) {
    var result = $9ca557716949399a$export$a22775fa5e2eebd9(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $9ca557716949399a$export$185802fd694ee1f5(value, struct, message) {
    var result = $9ca557716949399a$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $9ca557716949399a$export$d99f0801a68bbcf1(value, struct, message) {
    var result = $9ca557716949399a$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $9ca557716949399a$export$226b3eccf92c9ed9(value, struct) {
    var result = $9ca557716949399a$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $9ca557716949399a$export$a22775fa5e2eebd9(value, struct) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var tuples = $9ca557716949399a$var$run(value, struct, options);
    var tuple = $9ca557716949399a$var$shiftIterator(tuples);
    if (tuple[0]) {
        var error = new $9ca557716949399a$export$58cc9131e3e8861b(tuple[0], function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = tuples[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        t = _step.value;
                        if (!t[0]) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            t[0]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return [
            error,
            undefined
        ];
    } else {
        var v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $9ca557716949399a$export$e6e34fd1f2686227() {
    for(var _len = arguments.length, Structs = new Array(_len), _key = 0; _key < _len; _key++){
        Structs[_key] = arguments[_key];
    }
    var _Object;
    var isType = Structs[0].type === "type";
    var schemas = Structs.map(function(s) {
        return s.schema;
    });
    var schema = (_Object = Object).assign.apply(_Object, [
        {}
    ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(schemas)));
    return isType ? $9ca557716949399a$export$bf9fb029d174d554(schema) : $9ca557716949399a$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $9ca557716949399a$export$f36d6a7a5c09a23e(name, validator) {
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $9ca557716949399a$export$cdd73fc4100a6ef4(struct, log) {
    return new $9ca557716949399a$export$eabc71f011df675a((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, struct), {
        refiner: function(value, ctx) {
            return value === undefined || struct.refiner(value, ctx);
        },
        validator: function(value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    }));
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $9ca557716949399a$export$7077912c31975674(fn) {
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        entries: function(value, ctx) {
            var struct;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        struct = fn(value, ctx);
                        return [
                            5,
                            (0, $1a5e16f717d29077$export$19a8beecd37a4c45)(struct.entries(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $9ca557716949399a$export$488013bae63b21da(fn) {
    var struct;
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        entries: function(value, ctx) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        struct !== null && struct !== void 0 ? struct : struct = fn();
                        return [
                            5,
                            (0, $1a5e16f717d29077$export$19a8beecd37a4c45)(struct.entries(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.coercer(value, ctx);
        },
        refiner: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $9ca557716949399a$export$30a06c8d3562193f(struct, keys) {
    var schema = struct.schema;
    var subschema = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, schema);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            delete subschema[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    switch(struct.type){
        case "type":
            return $9ca557716949399a$export$bf9fb029d174d554(subschema);
        default:
            return $9ca557716949399a$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $9ca557716949399a$export$e45945969df8035a(struct) {
    var schema = struct instanceof $9ca557716949399a$export$eabc71f011df675a ? (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, struct.schema) : (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, struct);
    for(var key in schema)schema[key] = $9ca557716949399a$export$516e28dec6a4b6d4(schema[key]);
    return $9ca557716949399a$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $9ca557716949399a$export$357523c63a2253b9(struct, keys) {
    var schema = struct.schema;
    var subschema = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            subschema[key] = schema[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $9ca557716949399a$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $9ca557716949399a$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $9ca557716949399a$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $9ca557716949399a$export$4154a199d7d90455() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("any", function() {
        return true;
    });
}
function $9ca557716949399a$export$2f23118c22fb2630(Element) {
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, i, v, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Element && Array.isArray(value))) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = value.entries()[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), i = _step_value[0], v = _step_value[1];
                        return [
                            4,
                            [
                                i,
                                v,
                                Element
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator: function(value) {
            return Array.isArray(value) || "Expected an array value, but received: ".concat($9ca557716949399a$var$print(value));
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function $9ca557716949399a$export$a0f65b52274bcc00() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("bigint", function(value) {
        return (typeof value === "undefined" ? "undefined" : (0, $3L4GM._)(value)) === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $9ca557716949399a$export$4a21f16c33752377() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("boolean", function(value) {
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $9ca557716949399a$export$324d90190a8b822a() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("date", function(value) {
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: ".concat($9ca557716949399a$var$print(value));
    });
}
function $9ca557716949399a$export$9b16c434df8cc259(values) {
    var schema = {};
    var description = values.map(function(v) {
        return $9ca557716949399a$var$print(v);
    }).join();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            schema[key] = key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator: function(value) {
            return values.includes(value) || "Expected one of `".concat(description, "`, but received: ").concat($9ca557716949399a$var$print(value));
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $9ca557716949399a$export$86951950244e2001() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("func", function(value) {
        return typeof value === "function" || "Expected a function, but received: ".concat($9ca557716949399a$var$print(value));
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $9ca557716949399a$export$9544d5bb712b01ea(Class) {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("instance", function(value) {
        return value instanceof Class || "Expected a `".concat(Class.name, "` instance, but received: ").concat($9ca557716949399a$var$print(value));
    });
}
/**
 * Ensure that a value is an integer.
 */ function $9ca557716949399a$export$32744b5b3bba4764() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("integer", function(value) {
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: ".concat($9ca557716949399a$var$print(value));
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function $9ca557716949399a$export$bc86dfbf7795668c(Structs) {
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        entries: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $1a5e16f717d29077$export$19a8beecd37a4c45)(S.entries(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $1a5e16f717d29077$export$19a8beecd37a4c45)(S.validator(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        refiner: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $1a5e16f717d29077$export$19a8beecd37a4c45)(S.refiner(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        }
    });
}
function $9ca557716949399a$export$c8ec6e1ec9fefcb0(constant) {
    var description = $9ca557716949399a$var$print(constant);
    var t = typeof constant === "undefined" ? "undefined" : (0, $3L4GM._)(constant);
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator: function(value) {
            return value === constant || "Expected the literal `".concat(description, "`, but received: ").concat($9ca557716949399a$var$print(value));
        }
    });
}
function $9ca557716949399a$export$871de8747c9eaa88(Key, Value) {
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "map",
        schema: null,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, k, v, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Key && Value && value instanceof Map)) return [
                            3,
                            9
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        _iterator = value.entries()[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                        return [
                            4,
                            [
                                k,
                                k,
                                Key
                            ]
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            [
                                k,
                                v,
                                Value
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator: function(value) {
            return value instanceof Map || "Expected a `Map` object, but received: ".concat($9ca557716949399a$var$print(value));
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $9ca557716949399a$export$b3e22bcfd64c1022() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("never", function() {
        return false;
    });
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $9ca557716949399a$export$133fc36489ac9add(struct) {
    return new $9ca557716949399a$export$eabc71f011df675a((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, struct), {
        validator: function(value, ctx) {
            return value === null || struct.validator(value, ctx);
        },
        refiner: function(value, ctx) {
            return value === null || struct.refiner(value, ctx);
        }
    }));
}
/**
 * Ensure that a value is a number.
 */ function $9ca557716949399a$export$98e628dec113755e() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("number", function(value) {
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: ".concat($9ca557716949399a$var$print(value));
    });
}
function $9ca557716949399a$export$be5493f9613cbbe(schema) {
    var knowns = schema ? Object.keys(schema) : [];
    var Never = $9ca557716949399a$export$b3e22bcfd64c1022();
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        entries: function(value) {
            var unknowns, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key1, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(schema && $9ca557716949399a$var$isObject(value))) return [
                            3,
                            16
                        ];
                        unknowns = new Set(Object.keys(value));
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = knowns[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        key = _step.value;
                        unknowns.delete(key);
                        return [
                            4,
                            [
                                key,
                                value[key],
                                schema[key]
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            14,
                            15,
                            16
                        ]);
                        _iterator1 = unknowns[Symbol.iterator]();
                        _state.label = 10;
                    case 10:
                        if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                            3,
                            13
                        ];
                        key1 = _step1.value;
                        return [
                            4,
                            [
                                key1,
                                value[key1],
                                Never
                            ]
                        ];
                    case 11:
                        _state.sent();
                        _state.label = 12;
                    case 12:
                        _iteratorNormalCompletion1 = true;
                        return [
                            3,
                            10
                        ];
                    case 13:
                        return [
                            3,
                            16
                        ];
                    case 14:
                        err = _state.sent();
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                        return [
                            3,
                            16
                        ];
                    case 15:
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                        return [
                            7
                        ];
                    case 16:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return $9ca557716949399a$var$isObject(value) || "Expected an object, but received: ".concat($9ca557716949399a$var$print(value));
        },
        coercer: function(value) {
            return $9ca557716949399a$var$isObject(value) ? (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, value) : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $9ca557716949399a$export$516e28dec6a4b6d4(struct) {
    return new $9ca557716949399a$export$eabc71f011df675a((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, struct), {
        validator: function(value, ctx) {
            return value === undefined || struct.validator(value, ctx);
        },
        refiner: function(value, ctx) {
            return value === undefined || struct.refiner(value, ctx);
        }
    }));
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $9ca557716949399a$export$e5185e241753e543(Key, Value) {
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "record",
        schema: null,
        entries: function(value) {
            var _tmp, _tmp1, _i, k, v;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!$9ca557716949399a$var$isObject(value)) return [
                            3,
                            5
                        ];
                        _tmp = [];
                        for(_tmp1 in value)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            5
                        ];
                        k = _tmp[_i];
                        v = value[k];
                        return [
                            4,
                            [
                                k,
                                k,
                                Key
                            ]
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            [
                                k,
                                v,
                                Value
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return $9ca557716949399a$var$isObject(value) || "Expected an object, but received: ".concat($9ca557716949399a$var$print(value));
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $9ca557716949399a$export$efdc1e5bdb609bb() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("regexp", function(value) {
        return value instanceof RegExp;
    });
}
function $9ca557716949399a$export$adaa4cf7ef1b65be(Element) {
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "set",
        schema: null,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Element && value instanceof Set)) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = value[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        v = _step.value;
                        return [
                            4,
                            [
                                v,
                                v,
                                Element
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator: function(value) {
            return value instanceof Set || "Expected a `Set` object, but received: ".concat($9ca557716949399a$var$print(value));
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $9ca557716949399a$export$22b082955e083ec3() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("string", function(value) {
        return typeof value === "string" || "Expected a string, but received: ".concat($9ca557716949399a$var$print(value));
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function $9ca557716949399a$export$65e3907585753458(Structs) {
    var Never = $9ca557716949399a$export$b3e22bcfd64c1022();
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        entries: function(value) {
            var length, i;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!Array.isArray(value)) return [
                            3,
                            4
                        ];
                        length = Math.max(Structs.length, value.length);
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < length)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            [
                                i,
                                value[i],
                                Structs[i] || Never
                            ]
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return Array.isArray(value) || "Expected an array, but received: ".concat($9ca557716949399a$var$print(value));
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $9ca557716949399a$export$bf9fb029d174d554(schema) {
    var keys = Object.keys(schema);
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, k, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!$9ca557716949399a$var$isObject(value)) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = keys[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        k = _step.value;
                        return [
                            4,
                            [
                                k,
                                value[k],
                                schema[k]
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return $9ca557716949399a$var$isObject(value) || "Expected an object, but received: ".concat($9ca557716949399a$var$print(value));
        },
        coercer: function(value) {
            return $9ca557716949399a$var$isObject(value) ? (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, value) : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $9ca557716949399a$export$971dd5b0dfd021b6(Structs) {
    var description = Structs.map(function(s) {
        return s.type;
    }).join(" | ");
    return new $9ca557716949399a$export$eabc71f011df675a({
        type: "union",
        schema: null,
        coercer: function(value) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Structs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var S = _step.value;
                    var _S_validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(S.validate(value, {
                        coerce: true
                    }), 2), error = _S_validate[0], coerced = _S_validate[1];
                    if (!error) return coerced;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return value;
        },
        validator: function(value, ctx) {
            var failures = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Structs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var S = _step.value;
                    var _run = (0, $e72e4976c7e28e30$export$e62c166da838fa3)($9ca557716949399a$var$run(value, S, ctx)), tuples = _run.slice(0);
                    var _tuples = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(tuples, 1), first = _tuples[0];
                    if (!first[0]) return [];
                    else {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = tuples[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _step_value = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_step1.value, 1), failure = _step_value[0];
                                if (failure) failures.push(failure);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                "Expected the value to satisfy a union of `".concat(description, "`, but received: ").concat($9ca557716949399a$var$print(value))
            ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(failures));
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $9ca557716949399a$export$19282c40b967aec6() {
    return $9ca557716949399a$export$f36d6a7a5c09a23e("unknown", function() {
        return true;
    });
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $9ca557716949399a$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $9ca557716949399a$export$eabc71f011df675a((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, struct), {
        coercer: function(value, ctx) {
            return $9ca557716949399a$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    }));
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $9ca557716949399a$export$83c510c4356017ae(struct, fallback) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return $9ca557716949399a$export$8c14e57e778d3873(struct, $9ca557716949399a$export$19282c40b967aec6(), function(x) {
        var f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $9ca557716949399a$var$isPlainObject(x) && $9ca557716949399a$var$isPlainObject(f)) {
            var ret = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, x);
            var changed = false;
            for(var key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $9ca557716949399a$export$41f369984ed28930(struct) {
    return $9ca557716949399a$export$8c14e57e778d3873(struct, $9ca557716949399a$export$22b082955e083ec3(), function(x) {
        return x.trim();
    });
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $9ca557716949399a$export$6e22c362a0406a2c(struct) {
    return $9ca557716949399a$export$edc9d475108b3212(struct, "empty", function(value) {
        var size = $9ca557716949399a$var$getSize(value);
        return size === 0 || "Expected an empty ".concat(struct.type, " but received one with a size of `").concat(size, "`");
    });
}
function $9ca557716949399a$var$getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $9ca557716949399a$export$8960430cfd85939f(struct, threshold) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var exclusive = options.exclusive;
    return $9ca557716949399a$export$edc9d475108b3212(struct, "max", function(value) {
        return exclusive ? value < threshold : value <= threshold || "Expected a ".concat(struct.type, " less than ").concat(exclusive ? "" : "or equal to ").concat(threshold, " but received `").concat(value, "`");
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $9ca557716949399a$export$96ec731ed4dcb222(struct, threshold) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var exclusive = options.exclusive;
    return $9ca557716949399a$export$edc9d475108b3212(struct, "min", function(value) {
        return exclusive ? value > threshold : value >= threshold || "Expected a ".concat(struct.type, " greater than ").concat(exclusive ? "" : "or equal to ").concat(threshold, " but received `").concat(value, "`");
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function $9ca557716949399a$export$6ce6c9218151d511(struct) {
    return $9ca557716949399a$export$edc9d475108b3212(struct, "nonempty", function(value) {
        var size = $9ca557716949399a$var$getSize(value);
        return size > 0 || "Expected a nonempty ".concat(struct.type, " but received an empty one");
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $9ca557716949399a$export$24f82734ea047e6f(struct, regexp) {
    return $9ca557716949399a$export$edc9d475108b3212(struct, "pattern", function(value) {
        return regexp.test(value) || "Expected a ".concat(struct.type, " matching `/").concat(regexp.source, '/` but received "').concat(value, '"');
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $9ca557716949399a$export$346677f925de839c(struct, min) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : min;
    var expected = "Expected a ".concat(struct.type);
    var of = min === max ? "of `".concat(min, "`") : "between `".concat(min, "` and `").concat(max, "`");
    return $9ca557716949399a$export$edc9d475108b3212(struct, "size", function(value) {
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || "".concat(expected, " ").concat(of, " but received `").concat(value, "`");
        else if (value instanceof Map || value instanceof Set) {
            var size = value.size;
            return min <= size && size <= max || "".concat(expected, " with a size ").concat(of, " but received one with a size of `").concat(size, "`");
        } else {
            var length = value.length;
            return min <= length && length <= max || "".concat(expected, " with a length ").concat(of, " but received one with a length of `").concat(length, "`");
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $9ca557716949399a$export$edc9d475108b3212(struct, name, refiner) {
    return new $9ca557716949399a$export$eabc71f011df675a((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, struct), {
        refiner: function(value, ctx) {
            var result, failures, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, failure, err;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            5,
                            (0, $1a5e16f717d29077$export$19a8beecd37a4c45)(struct.refiner(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        result = refiner(value, ctx);
                        failures = $9ca557716949399a$var$toFailures(result, ctx, struct, value);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _iterator = failures[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        failure = _step.value;
                        return [
                            4,
                            (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, failure), {
                                refinement: name
                            })
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        }
    }));
}





var $fc4a7cd559bffd34$export$76ad0037102e2eeb = $9ca557716949399a$export$9b16c434df8cc259([
    (0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn,
    (0, $14a274f0b6caba9a$export$12e44e23ec720850).Register,
    (0, $14a274f0b6caba9a$export$12e44e23ec720850).ForgotPassword,
    (0, $14a274f0b6caba9a$export$12e44e23ec720850).Continue
]);
var $fc4a7cd559bffd34$export$1e3360d68cdc393f = $9ca557716949399a$export$be5493f9613cbbe({
    identifier: $9ca557716949399a$export$9b16c434df8cc259([
        (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email,
        (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone,
        (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username
    ]),
    value: $9ca557716949399a$export$22b082955e083ec3()
});
/* Verification Code Flow Guard */ var $fc4a7cd559bffd34$var$verificationCodeMethodGuard = $9ca557716949399a$export$971dd5b0dfd021b6([
    $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email),
    $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone)
]);
var $fc4a7cd559bffd34$export$1e0c25ccbe67b008 = $9ca557716949399a$export$be5493f9613cbbe({
    identifier: $fc4a7cd559bffd34$var$verificationCodeMethodGuard,
    value: $9ca557716949399a$export$22b082955e083ec3()
});
/* Social Flow Guard */ var $fc4a7cd559bffd34$var$registeredSocialIdentity = $9ca557716949399a$export$516e28dec6a4b6d4($9ca557716949399a$export$be5493f9613cbbe({
    email: $9ca557716949399a$export$516e28dec6a4b6d4($9ca557716949399a$export$22b082955e083ec3()),
    phone: $9ca557716949399a$export$516e28dec6a4b6d4($9ca557716949399a$export$22b082955e083ec3())
}));
var $fc4a7cd559bffd34$export$4563eb9e4106afd7 = $9ca557716949399a$export$be5493f9613cbbe({
    missingProfile: $9ca557716949399a$export$2f23118c22fb2630($9ca557716949399a$export$971dd5b0dfd021b6([
        $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).password),
        $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).email),
        $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).phone),
        $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).username),
        $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).emailOrPhone)
    ])),
    registeredSocialIdentity: $fc4a7cd559bffd34$var$registeredSocialIdentity
});
var $fc4a7cd559bffd34$export$184f9f29032ada80 = $9ca557716949399a$export$bf9fb029d174d554({
    registeredSocialIdentity: $fc4a7cd559bffd34$var$registeredSocialIdentity
});
var $fc4a7cd559bffd34$export$d3035cdec99fb931 = $9ca557716949399a$export$be5493f9613cbbe({
    relatedUser: $9ca557716949399a$export$be5493f9613cbbe({
        type: $9ca557716949399a$export$971dd5b0dfd021b6([
            $9ca557716949399a$export$c8ec6e1ec9fefcb0("email"),
            $9ca557716949399a$export$c8ec6e1ec9fefcb0("phone")
        ]),
        value: $9ca557716949399a$export$22b082955e083ec3()
    })
});
/* Mfa */ var $fc4a7cd559bffd34$var$mfaFactorsGuard = $9ca557716949399a$export$2f23118c22fb2630($9ca557716949399a$export$971dd5b0dfd021b6([
    $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP),
    $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn),
    $9ca557716949399a$export$c8ec6e1ec9fefcb0((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode)
]));
var $fc4a7cd559bffd34$export$c098e744493f7349 = $9ca557716949399a$export$be5493f9613cbbe({
    availableFactors: $fc4a7cd559bffd34$var$mfaFactorsGuard,
    skippable: $9ca557716949399a$export$516e28dec6a4b6d4($9ca557716949399a$export$4a21f16c33752377())
});
var $fc4a7cd559bffd34$export$5b8a6b67ca446381 = $fc4a7cd559bffd34$export$c098e744493f7349;
var $fc4a7cd559bffd34$export$8014a7293b97852c = $9ca557716949399a$export$e6e34fd1f2686227($9ca557716949399a$export$be5493f9613cbbe({
    secret: $9ca557716949399a$export$22b082955e083ec3(),
    secretQrCode: $9ca557716949399a$export$22b082955e083ec3()
}), $fc4a7cd559bffd34$export$5b8a6b67ca446381);
var $fc4a7cd559bffd34$export$4a47cfca3f992c62 = $9ca557716949399a$export$be5493f9613cbbe({
    codes: $9ca557716949399a$export$2f23118c22fb2630($9ca557716949399a$export$22b082955e083ec3())
});
var $fc4a7cd559bffd34$export$8572183290edea8b = $fc4a7cd559bffd34$export$4a47cfca3f992c62;
var $fc4a7cd559bffd34$export$491937bf2814b26 = $9ca557716949399a$export$e6e34fd1f2686227($9ca557716949399a$export$be5493f9613cbbe({
    options: $9ca557716949399a$export$e5185e241753e543($9ca557716949399a$export$22b082955e083ec3(), $9ca557716949399a$export$19282c40b967aec6())
}), $fc4a7cd559bffd34$export$5b8a6b67ca446381);
var $fc4a7cd559bffd34$export$7f91c1744e02ec3c = $9ca557716949399a$export$be5493f9613cbbe({
    id: $9ca557716949399a$export$22b082955e083ec3(),
    logo: $9ca557716949399a$export$22b082955e083ec3(),
    darkLogo: $9ca557716949399a$export$516e28dec6a4b6d4($9ca557716949399a$export$22b082955e083ec3()),
    connectorName: $9ca557716949399a$export$22b082955e083ec3()
});


var $d8124e0ec675c3a4$var$logtoStorageKeyPrefix = "logto:".concat(window.location.origin);
var $d8124e0ec675c3a4$export$25c0d5b425a20ec;
(function(StorageKeys) {
    StorageKeys["SsoEmail"] = "sso-email";
    StorageKeys["SsoConnectors"] = "sso-connectors";
})($d8124e0ec675c3a4$export$25c0d5b425a20ec || ($d8124e0ec675c3a4$export$25c0d5b425a20ec = {}));
var $d8124e0ec675c3a4$var$_obj;
var $d8124e0ec675c3a4$var$valueGuard = Object.freeze(($d8124e0ec675c3a4$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($d8124e0ec675c3a4$var$_obj, $d8124e0ec675c3a4$export$25c0d5b425a20ec.SsoEmail, $9ca557716949399a$export$22b082955e083ec3()), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($d8124e0ec675c3a4$var$_obj, $d8124e0ec675c3a4$export$25c0d5b425a20ec.SsoConnectors, $9ca557716949399a$export$2f23118c22fb2630((0, $fc4a7cd559bffd34$export$7f91c1744e02ec3c))), $d8124e0ec675c3a4$var$_obj));
var $d8124e0ec675c3a4$var$useSessionStorage = function() {
    var set = (0, $kVN77.useCallback)(function(key, value) {
        if (typeof value === "object") {
            sessionStorage.setItem("".concat($d8124e0ec675c3a4$var$logtoStorageKeyPrefix, ":").concat(key), JSON.stringify(value));
            return;
        }
        sessionStorage.setItem("".concat($d8124e0ec675c3a4$var$logtoStorageKeyPrefix, ":").concat(key), value);
    }, []);
    var remove = (0, $kVN77.useCallback)(function(key) {
        sessionStorage.removeItem("".concat($d8124e0ec675c3a4$var$logtoStorageKeyPrefix, ":").concat(key));
    }, []);
    var get = (0, $kVN77.useCallback)(function(key) {
        var value = sessionStorage.getItem("".concat($d8124e0ec675c3a4$var$logtoStorageKeyPrefix, ":").concat(key));
        if (value === null) return;
        var _valueGuard_key_validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($d8124e0ec675c3a4$var$valueGuard[key].validate(function() {
            try {
                // eslint-disable-next-line no-restricted-syntax -- we use superstruct to validate the value
                return JSON.parse(value);
            } catch (e) {
                return value;
            }
        }()), 2), error = _valueGuard_key_validate[0], rawValue = _valueGuard_key_validate[1];
        if (error) {
            // Clear the invalid value
            remove(key);
            return;
        }
        return rawValue;
    }, [
        remove
    ]);
    return {
        set: set,
        get: get,
        remove: remove
    };
};
var $d8124e0ec675c3a4$export$2e2bcd8739ae039 = $d8124e0ec675c3a4$var$useSessionStorage;





var $kVN77 = parcelRequire("kVN77");
var $292f0b9481a802e6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kVN77.createContext)({
    email: undefined,
    availableSsoConnectorsMap: new Map(),
    ssoConnectors: [],
    setEmail: (0, $71d6ce9e3e366d69$export$8793edee2d425525),
    setSsoConnectors: (0, $71d6ce9e3e366d69$export$8793edee2d425525)
});


var $68a14edeef3806c5$var$SingleSignOnContextProvider = function(param) {
    var children = param.children;
    var ssoConnectors = (0, $41e7159e4ecba97c$export$317715a729435b35)().ssoConnectors;
    var _useSessionStorage = (0, $d8124e0ec675c3a4$export$2e2bcd8739ae039)(), get = _useSessionStorage.get, set = _useSessionStorage.set, remove = _useSessionStorage.remove;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(get((0, $d8124e0ec675c3a4$export$25c0d5b425a20ec).SsoEmail)), 2), email = _useState[0], setEmail = _useState[1];
    var _get;
    var _useState1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)((_get = get((0, $d8124e0ec675c3a4$export$25c0d5b425a20ec).SsoConnectors)) !== null && _get !== void 0 ? _get : []), 2), domainFilteredConnectors = _useState1[0], setDomainFilteredConnectors = _useState1[1];
    (0, $kVN77.useEffect)(function() {
        if (!email) {
            remove((0, $d8124e0ec675c3a4$export$25c0d5b425a20ec).SsoEmail);
            return;
        }
        set((0, $d8124e0ec675c3a4$export$25c0d5b425a20ec).SsoEmail, email);
    }, [
        email,
        remove,
        set
    ]);
    (0, $kVN77.useEffect)(function() {
        if (domainFilteredConnectors.length === 0) {
            remove((0, $d8124e0ec675c3a4$export$25c0d5b425a20ec).SsoConnectors);
            return;
        }
        set((0, $d8124e0ec675c3a4$export$25c0d5b425a20ec).SsoConnectors, domainFilteredConnectors);
    }, [
        domainFilteredConnectors,
        remove,
        set
    ]);
    var ssoConnectorsMap = (0, $kVN77.useMemo)(function() {
        return new Map(ssoConnectors.map(function(connector) {
            return [
                connector.id,
                connector
            ];
        }));
    }, [
        ssoConnectors
    ]);
    var singleSignOnContext = (0, $kVN77.useMemo)(function() {
        return {
            email: email,
            setEmail: setEmail,
            availableSsoConnectorsMap: ssoConnectorsMap,
            ssoConnectors: domainFilteredConnectors,
            setSsoConnectors: setDomainFilteredConnectors
        };
    }, [
        domainFilteredConnectors,
        email,
        ssoConnectorsMap
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $292f0b9481a802e6$export$2e2bcd8739ae039).Provider, {
        value: singleSignOnContext,
        children: children
    });
};
var $68a14edeef3806c5$export$2e2bcd8739ae039 = $68a14edeef3806c5$var$SingleSignOnContextProvider;




var $kVN77 = parcelRequire("kVN77");


var $8eb25d1e4b9b7d35$export$cc74dcc53cfce4eb;
$8eb25d1e4b9b7d35$export$cc74dcc53cfce4eb = "UttbVG_wrapper";


var $bc289486222dabf4$var$StaticPageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: $8eb25d1e4b9b7d35$export$cc74dcc53cfce4eb,
        children: children
    });
};
var $bc289486222dabf4$export$2e2bcd8739ae039 = $bc289486222dabf4$var$StaticPageLayout;







var $kVN77 = parcelRequire("kVN77");


var $63d42c0a1a1c817c$var$useConnectors = function() {
    var _useSieMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)(), socialConnectors = _useSieMethods.socialConnectors, ssoConnectors = _useSieMethods.ssoConnectors;
    var theme = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).theme;
    /**
   * Find the single sign-on or social connector by given connector id
   */ var findConnectorById = (0, $kVN77.useCallback)(function(connectorId) {
        var ssoConnector = ssoConnectors.find(function(connector) {
            return connector.id === connectorId;
        });
        if (ssoConnector) return {
            connector: ssoConnector,
            type: "sso"
        };
        var socialConnector = socialConnectors.find(function(connector) {
            return connector.id === connectorId;
        });
        if (socialConnector) return {
            connector: socialConnector,
            type: "social"
        };
    }, [
        socialConnectors,
        ssoConnectors
    ]);
    var getConnectorLogo = (0, $kVN77.useCallback)(function(param) {
        var connector = param.connector, type = param.type;
        var _connector_darkLogo;
        if (type === "sso") return theme === (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Dark ? (_connector_darkLogo = connector.darkLogo) !== null && _connector_darkLogo !== void 0 ? _connector_darkLogo : connector.logo : connector.logo;
        var _connector_logoDark;
        return theme === (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Dark ? (_connector_logoDark = connector.logoDark) !== null && _connector_logoDark !== void 0 ? _connector_logoDark : connector.logo : connector.logo;
    }, [
        theme
    ]);
    return {
        findConnectorById: findConnectorById,
        getConnectorLogo: getConnectorLogo
    };
};
var $63d42c0a1a1c817c$export$2e2bcd8739ae039 = $63d42c0a1a1c817c$var$useConnectors;


var $a6d599d85caf7a7e$export$f79a732982c93a3b;
var $a6d599d85caf7a7e$export$34e0f9847d4c02dd;
var $a6d599d85caf7a7e$export$a8ecead220dd38a6;
$a6d599d85caf7a7e$export$f79a732982c93a3b = "OMwqca_connector";
$a6d599d85caf7a7e$export$34e0f9847d4c02dd = "OMwqca_container";
$a6d599d85caf7a7e$export$a8ecead220dd38a6 = "OMwqca_message";


var $125e686934f710b5$var$SocialLanding = function(param) {
    var className = param.className, connectorId = param.connectorId, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading;
    var _useConnectors = (0, $63d42c0a1a1c817c$export$2e2bcd8739ae039)(), findConnectorById = _useConnectors.findConnectorById, getConnectorLogo = _useConnectors.getConnectorLogo;
    var result = findConnectorById(connectorId);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($a6d599d85caf7a7e$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $a6d599d85caf7a7e$export$f79a732982c93a3b,
                children: result ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("img", {
                    src: getConnectorLogo(result),
                    alt: "logo",
                    crossOrigin: "anonymous"
                }) : connectorId
            }),
            isLoading && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4bc5d6d9a8c5bdf7$export$2e2bcd8739ae039), {})
        ]
    });
};
var $125e686934f710b5$export$2e2bcd8739ae039 = $125e686934f710b5$var$SocialLanding;


var $9f9e6fd44ebceb0e$export$bd05d1c161235462;
$9f9e6fd44ebceb0e$export$bd05d1c161235462 = "-76m7q_connectorContainer";




var $kVN77 = parcelRequire("kVN77");


var $878dea3682808de4$var$useSocialCallbackHandler = function() {
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var socialCallbackHandler = (0, $kVN77.useCallback)(function(connectorId) {
        // Get search parameter to evaluate
        var searchParams = new URLSearchParams(window.location.search);
        // Get hash parameter to evaluate
        var hashParams = new URLSearchParams(window.location.hash.slice(1));
        // Join search and hash parameters
        var joinedSearchParams = new URLSearchParams((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(searchParams).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(hashParams)));
        var search = joinedSearchParams.toString() ? "?".concat(joinedSearchParams.toString()) : "";
        // Get native callback link from storage
        var callbackLink = (0, $6f7af2e59a37a635$export$179d5bca54e18dc6)(connectorId);
        (0, $6f7af2e59a37a635$export$d02cb51c63c7e560)(connectorId);
        if (callbackLink) {
            window.location.replace(new URL("".concat(callbackLink).concat(search)));
            return;
        }
        // Web flow
        navigate({
            pathname: "/callback/social/".concat(connectorId),
            search: search
        }, {
            replace: true
        });
    }, [
        navigate
    ]);
    return {
        socialCallbackHandler: socialCallbackHandler
    };
};
var $878dea3682808de4$export$2e2bcd8739ae039 = $878dea3682808de4$var$useSocialCallbackHandler;


/**
 * Callback landing page for social sign-in and single sign-on.
 */ var $283877bb773fa6c0$var$Callback = function() {
    var connectorId = (0, $1c3a22059b479044$export$99eaa27ddbbb95ef)().connectorId;
    var socialCallbackHandler = (0, $878dea3682808de4$export$2e2bcd8739ae039)().socialCallbackHandler;
    // SocialSignIn Callback Handler
    (0, $kVN77.useEffect)(function() {
        if (!connectorId) return;
        socialCallbackHandler(connectorId);
    }, [
        socialCallbackHandler,
        connectorId
    ]);
    if (!connectorId) return null;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $bc289486222dabf4$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $125e686934f710b5$export$2e2bcd8739ae039), {
            isLoading: true,
            className: $9f9e6fd44ebceb0e$export$bd05d1c161235462,
            connectorId: connectorId
        })
    });
};
var $283877bb773fa6c0$export$2e2bcd8739ae039 = $283877bb773fa6c0$var$Callback;








var $kVN77 = parcelRequire("kVN77");




var $kVN77 = parcelRequire("kVN77");






parcelRequire("kVN77");
var $d24514fa3e876a86$var$SvgConnectIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 21,
        height: 4,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("circle", {
                cx: 2.5,
                cy: 2,
                r: 2,
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("circle", {
                cx: 10.5,
                cy: 2,
                r: 2,
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("circle", {
                cx: 18.5,
                cy: 2,
                r: 2,
                fill: "currentcolor"
            })
        ]
    }));
};
var $d24514fa3e876a86$export$2e2bcd8739ae039 = $d24514fa3e876a86$var$SvgConnectIcon;



var $c2ab715fb366c468$export$e9cf79b2df667146;
var $c2ab715fb366c468$export$34e0f9847d4c02dd;
var $c2ab715fb366c468$export$516dd90aeaaabcf0;
var $c2ab715fb366c468$export$db3c28d99448dcff;
var $c2ab715fb366c468$export$3fca35e0a6eb1bfc;
$c2ab715fb366c468$export$e9cf79b2df667146 = "ctiCua_connectIcon";
$c2ab715fb366c468$export$34e0f9847d4c02dd = "ctiCua_container";
$c2ab715fb366c468$export$516dd90aeaaabcf0 = "ctiCua_headline";
$c2ab715fb366c468$export$db3c28d99448dcff = "ctiCua_logo";
$c2ab715fb366c468$export$3fca35e0a6eb1bfc = "ctiCua_logoWrapper";


var $e294b26aa6dfd011$var$BrandingHeader = function(param) {
    var logo = param.logo, thirdPartyLogo = param.thirdPartyLogo, headline = param.headline, headlineInterpolation = param.headlineInterpolation, className = param.className;
    var shouldShowLogo = Boolean(thirdPartyLogo !== null && thirdPartyLogo !== void 0 ? thirdPartyLogo : logo);
    var shouldConnectSvg = Boolean(thirdPartyLogo && logo);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($c2ab715fb366c468$export$34e0f9847d4c02dd, className),
        children: [
            shouldShowLogo && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $c2ab715fb366c468$export$3fca35e0a6eb1bfc,
                children: [
                    thirdPartyLogo && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("img", {
                        className: $c2ab715fb366c468$export$db3c28d99448dcff,
                        alt: "third party logo",
                        src: thirdPartyLogo,
                        crossOrigin: "anonymous"
                    }),
                    shouldConnectSvg && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d24514fa3e876a86$export$2e2bcd8739ae039), {
                        className: $c2ab715fb366c468$export$e9cf79b2df667146
                    }),
                    logo && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("img", {
                        className: $c2ab715fb366c468$export$db3c28d99448dcff,
                        alt: "app logo",
                        src: logo,
                        crossOrigin: "anonymous"
                    })
                ]
            }),
            headline && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $c2ab715fb366c468$export$516dd90aeaaabcf0,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                    forKey: headline,
                    interpolation: headlineInterpolation
                })
            })
        ]
    });
};
var $e294b26aa6dfd011$export$2e2bcd8739ae039 = $e294b26aa6dfd011$var$BrandingHeader;





var $f69507d36a87d6c0$var$PageMeta = function(param) {
    var titleKey = param.titleKey, _param_titleKeyInterpolation = param.titleKeyInterpolation, titleKeyInterpolation = _param_titleKeyInterpolation === void 0 ? {} : _param_titleKeyInterpolation;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var title = t(titleKey, titleKeyInterpolation);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d387b2d0eaa648c2$export$dcef8f9bb9a41431), {
        title: String(title)
    });
};
var $f69507d36a87d6c0$export$2e2bcd8739ae039 = $f69507d36a87d6c0$var$PageMeta;




var $7a7feeb62f2ee9c7$export$976f80239b15365 = function(param) {
    var theme = param.theme, logoUrl = param.logoUrl, darkLogoUrl = param.darkLogoUrl, isApple = param.isApple;
    if (theme === (isApple ? (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Light : (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Dark)) return darkLogoUrl !== null && darkLogoUrl !== void 0 ? darkLogoUrl : logoUrl;
    return logoUrl;
};
var $7a7feeb62f2ee9c7$export$7de80206228fa969 = function(param) {
    var theme = param.theme, branding = param.branding, isDarkModeEnabled = param.isDarkModeEnabled;
    var logoUrl = branding.logoUrl, darkLogoUrl = branding.darkLogoUrl;
    if (!isDarkModeEnabled) return logoUrl;
    if (!logoUrl && !darkLogoUrl) return null;
    if (logoUrl && darkLogoUrl) return $7a7feeb62f2ee9c7$export$976f80239b15365({
        theme: theme,
        logoUrl: logoUrl,
        darkLogoUrl: darkLogoUrl
    });
    return logoUrl !== null && logoUrl !== void 0 ? logoUrl : darkLogoUrl;
};


var $dd6a5e8d7204fdfc$export$38e42c68cf43b5d4;
var $dd6a5e8d7204fdfc$export$d039a117f4b4a172;
var $dd6a5e8d7204fdfc$export$2a783d3dea58cac6;
var $dd6a5e8d7204fdfc$export$cc74dcc53cfce4eb;
$dd6a5e8d7204fdfc$export$38e42c68cf43b5d4 = "pdwYva_header";
$dd6a5e8d7204fdfc$export$d039a117f4b4a172 = "pdwYva_placeholderBottom";
$dd6a5e8d7204fdfc$export$2a783d3dea58cac6 = "pdwYva_placeholderTop";
$dd6a5e8d7204fdfc$export$cc74dcc53cfce4eb = "pdwYva_wrapper";


var $1b7e9c0f93e4c544$var$LandingPageLayout = function(param) {
    var children = param.children, className = param.className, title = param.title, titleInterpolation = param.titleInterpolation, thirdPartyBranding = param.thirdPartyBranding;
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), experienceSettings = _useContext.experienceSettings, theme = _useContext.theme, platform = _useContext.platform;
    if (!experienceSettings) return null;
    var isDarkModeEnabled = experienceSettings.color.isDarkModeEnabled, branding = experienceSettings.branding;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $f69507d36a87d6c0$export$2e2bcd8739ae039), {
                titleKey: title,
                titleKeyInterpolation: titleInterpolation
            }),
            platform === "web" && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $dd6a5e8d7204fdfc$export$2a783d3dea58cac6
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($dd6a5e8d7204fdfc$export$cc74dcc53cfce4eb, className),
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $e294b26aa6dfd011$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($dd6a5e8d7204fdfc$export$38e42c68cf43b5d4, (0, $37c193be69299d85$export$52b270a1b841cc00).brandingHeader),
                        headline: title,
                        headlineInterpolation: titleInterpolation,
                        logo: (0, $7a7feeb62f2ee9c7$export$7de80206228fa969)({
                            theme: theme,
                            branding: branding,
                            isDarkModeEnabled: isDarkModeEnabled
                        }),
                        thirdPartyLogo: thirdPartyBranding && (0, $7a7feeb62f2ee9c7$export$7de80206228fa969)({
                            theme: theme,
                            branding: thirdPartyBranding,
                            isDarkModeEnabled: isDarkModeEnabled
                        })
                    }),
                    children
                ]
            }),
            platform === "web" && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $dd6a5e8d7204fdfc$export$d039a117f4b4a172
            })
        ]
    });
};
var $1b7e9c0f93e4c544$export$2e2bcd8739ae039 = $1b7e9c0f93e4c544$var$LandingPageLayout;






var $fc2d839f2675643a$export$2e2bcd8739ae039 = (0, $1ba6ecb4eaf342b0$export$2e2bcd8739ae039).extend({
    hooks: {
        beforeRequest: [
            function(request) {
                request.headers.set("Accept-Language", (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).language);
            }
        ]
    }
});


var $69ea688e66b8ae56$export$a6dfab0e9e63c404 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(organizationId) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("/api/interaction/consent", {
                    json: {
                        organizationIds: organizationId && [
                            organizationId
                        ]
                    }
                }).json()
            ];
        });
    });
    return function consent(organizationId) {
        return _ref.apply(this, arguments);
    };
}();
var $69ea688e66b8ae56$export$63817cd70bf84ca6 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $fc2d839f2675643a$export$2e2bcd8739ae039).get("/api/interaction/consent").json()
            ];
        });
    });
    return function getConsentInfo() {
        return _ref.apply(this, arguments);
    };
}();











var $kVN77 = parcelRequire("kVN77");





var $2b3df94351994eee$exports = {};

$parcel$export($2b3df94351994eee$exports, "link", function () { return $2b3df94351994eee$export$9c30223ca0a664fb; }, function (v) { return $2b3df94351994eee$export$9c30223ca0a664fb = v; });
$parcel$export($2b3df94351994eee$exports, "primary", function () { return $2b3df94351994eee$export$9ad721cf3b3debe0; }, function (v) { return $2b3df94351994eee$export$9ad721cf3b3debe0 = v; });
$parcel$export($2b3df94351994eee$exports, "secondary", function () { return $2b3df94351994eee$export$745c6f71a1e0e6f7; }, function (v) { return $2b3df94351994eee$export$745c6f71a1e0e6f7 = v; });
var $2b3df94351994eee$export$9c30223ca0a664fb;
var $2b3df94351994eee$export$9ad721cf3b3debe0;
var $2b3df94351994eee$export$745c6f71a1e0e6f7;
$2b3df94351994eee$export$9c30223ca0a664fb = "R5EY3G_link";
$2b3df94351994eee$export$9ad721cf3b3debe0 = "R5EY3G_primary";
$2b3df94351994eee$export$745c6f71a1e0e6f7 = "R5EY3G_secondary";


var $4cbbfa6dbb472410$var$TextLink = function(_param) {
    var className = _param.className, children = _param.children, text = _param.text, icon = _param.icon, _param_type = _param.type, type = _param_type === void 0 ? "primary" : _param_type, to = _param.to, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_param, [
        "className",
        "children",
        "text",
        "icon",
        "type",
        "to"
    ]);
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var isMobile = (0, $c732d3c3053b4284$export$2e2bcd8739ae039)().isMobile;
    var setModalState = (0, $0d421b718ae2eec3$export$6875a035353dd898)().setModalState;
    // By default the behavior of opening a new window is not supported in WkWebView, or in android webview.
    // Hijack the hyperlink props and open the link in an iframe modal instead.
    var hyperLinkProps = (0, $kVN77.useMemo)(function() {
        var href = rest.href, target = rest.target, onClick = rest.onClick, others = (0, $487369748a2c1c33$export$69fdd232f62cde60)(rest, [
            "href",
            "target",
            "onClick"
        ]);
        // Keep the original behavior if the link is not external.
        if (!href || target !== "_blank") return rest;
        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            href: href,
            target: target,
            onClick: function(event) {
                if (isMobile) {
                    var title = text && t(text);
                    event.preventDefault();
                    setModalState({
                        href: href,
                        title: typeof title === "string" ? title : undefined
                    });
                }
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
            }
        }, others);
    }, [
        isMobile,
        rest,
        setModalState,
        t,
        text
    ]);
    if (to) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d03cd69b331d3258$export$a6c7ac8248d6e38a), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($2b3df94351994eee$exports.link, $2b3df94351994eee$exports[type], className),
        to: to
    }, rest), {
        children: [
            icon,
            children !== null && children !== void 0 ? children : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                forKey: text
            })
        ]
    }));
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("a", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($2b3df94351994eee$exports.link, $2b3df94351994eee$exports[type], className)
    }, hyperLinkProps), {
        rel: "noopener",
        children: [
            icon,
            children !== null && children !== void 0 ? children : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                forKey: text
            })
        ]
    }));
};
var $4cbbfa6dbb472410$export$2e2bcd8739ae039 = $4cbbfa6dbb472410$var$TextLink;


var $31c496b67726995b$export$e8c9778bf415dd08;
var $31c496b67726995b$export$9c30223ca0a664fb;
$31c496b67726995b$export$e8c9778bf415dd08 = "_2WTKYW_divider";
$31c496b67726995b$export$9c30223ca0a664fb = "_2WTKYW_link";


var $92a809d54e7cd2ca$var$TermsLinks = function(param) {
    var inline = param.inline, termsOfUseUrl = param.termsOfUseUrl, privacyPolicyUrl = param.privacyPolicyUrl, _param_linkType = param.linkType, linkType = _param_linkType === void 0 ? "secondary" : _param_linkType;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
        children: [
            termsOfUseUrl && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                className: $31c496b67726995b$export$9c30223ca0a664fb,
                text: "description.terms_of_use",
                href: termsOfUseUrl,
                type: linkType,
                target: "_blank",
                onClick: function(event) {
                    event.stopPropagation();
                }
            }),
            termsOfUseUrl && privacyPolicyUrl && inline && " ".concat(t("description.and"), " "),
            termsOfUseUrl && privacyPolicyUrl && !inline && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("i", {
                className: $31c496b67726995b$export$e8c9778bf415dd08
            }),
            privacyPolicyUrl && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                className: $31c496b67726995b$export$9c30223ca0a664fb,
                text: "description.privacy_policy",
                href: privacyPolicyUrl,
                type: linkType,
                target: "_blank",
                onClick: function(event) {
                    event.stopPropagation();
                }
            })
        ]
    });
};
var $92a809d54e7cd2ca$export$2e2bcd8739ae039 = $92a809d54e7cd2ca$var$TermsLinks;







var $kVN77 = parcelRequire("kVN77");

var $57790173b1762f43$var$useApi = function(api, options) {
    var setLoading = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).setLoading;
    var request = (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var _len, args, _key, result, error;
        var _arguments = arguments;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _arguments[_key];
                    }
                    if (!(options === null || options === void 0 ? void 0 : options.silent)) setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        api.apply(void 0, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(args))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        [
                            null,
                            result
                        ]
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        [
                            error
                        ]
                    ];
                case 4:
                    setLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        api,
        options === null || options === void 0 ? void 0 : options.silent,
        setLoading
    ]);
    return request;
};
var $57790173b1762f43$export$2e2bcd8739ae039 = $57790173b1762f43$var$useApi;






var $kVN77 = parcelRequire("kVN77");


var $kVN77 = parcelRequire("kVN77");

var $9a3c35ddfdc94481$var$useToast = function() {
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), toast = _useContext.toast, setToast = _useContext.setToast;
    return {
        toast: toast,
        setToast: setToast
    };
};
var $9a3c35ddfdc94481$export$2e2bcd8739ae039 = $9a3c35ddfdc94481$var$useToast;


var $09dc68536e5e270c$var$useErrorHandler = function() {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var handleError = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error, errorHandlers) {
            var logtoError, code, message, _errorHandlers_code, handler, e;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(error instanceof (0, $1a87adca8ebe72c6$export$aa9d629c530f62a7))) return [
                            3,
                            7
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            error.response.json()
                        ];
                    case 2:
                        logtoError = _state.sent();
                        code = logtoError.code, message = logtoError.message;
                        handler = (_errorHandlers_code = errorHandlers === null || errorHandlers === void 0 ? void 0 : errorHandlers[code]) !== null && _errorHandlers_code !== void 0 ? _errorHandlers_code : errorHandlers === null || errorHandlers === void 0 ? void 0 : errorHandlers.global;
                        if (!handler) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            handler(logtoError)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setToast(message);
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                    case 6:
                        e = _state.sent();
                        setToast(t("error.unknown"));
                        console.error(error);
                        return [
                            2
                        ];
                    case 7:
                        if (error instanceof (0, $823ae9dbb4658b29$export$66d311bf29d5c89c)) {
                            setToast(t("error.timeout"));
                            return [
                                2
                            ];
                        }
                        setToast(t("error.unknown"));
                        console.error(error);
                        return [
                            2
                        ];
                }
            });
        });
        return function(error, errorHandlers) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setToast,
        t
    ]);
    return handleError;
};
var $09dc68536e5e270c$export$2e2bcd8739ae039 = $09dc68536e5e270c$var$useErrorHandler;



var $kVN77 = parcelRequire("kVN77");

/**
 * This hook provides a function that process the app redirection after user successfully signs in.
 * Use window.location.replace to handle the redirection.
 * Set the global loading state to true before redirecting.
 * This is to prevent the user from interacting with the app while the redirection is in progress.
 */ function $74b08314cd062cbb$var$useGlobalRedirectTo() {
    var setLoading = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).setLoading;
    var redirectTo = (0, $kVN77.useCallback)(function(url) {
        setLoading(true);
        window.location.replace(url);
    }, [
        setLoading
    ]);
    return redirectTo;
}
var $74b08314cd062cbb$export$2e2bcd8739ae039 = $74b08314cd062cbb$var$useGlobalRedirectTo;







var $kVN77 = parcelRequire("kVN77");




parcelRequire("kVN77");
var $84d777a3a9676dbd$var$SvgExpandableIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "M13.575 11.908 10 15.492l-3.575-3.584a.837.837 0 0 0-1.183 1.184l4.166 4.166a.833.833 0 0 0 1.184 0l4.166-4.166a.836.836 0 1 0-1.183-1.184Zm-7.15-3.816L10 4.508l3.575 3.584a.833.833 0 0 0 1.183 0 .833.833 0 0 0 0-1.184l-4.166-4.166a.834.834 0 0 0-1.184 0L5.242 6.908a.837.837 0 0 0 1.183 1.184Z",
            fill: "currentcolor"
        })
    }));
};
var $84d777a3a9676dbd$export$2e2bcd8739ae039 = $84d777a3a9676dbd$var$SvgExpandableIcon;






var $kVN77 = parcelRequire("kVN77");



parcelRequire("kVN77");
var $40226f06eca87ae6$var$SvgArrowDown = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "M10.592 12.95 15.3 8.233a.833.833 0 1 0-1.175-1.183l-4.167 4.125L5.833 7.05a.833.833 0 0 0-1.36.27.833.833 0 0 0-.065.322.833.833 0 0 0 .25.591l4.709 4.717a.834.834 0 0 0 1.225 0Z",
            fill: "currentcolor"
        })
    }));
};
var $40226f06eca87ae6$export$2e2bcd8739ae039 = $40226f06eca87ae6$var$SvgArrowDown;





parcelRequire("kVN77");
var $4b8c4593f0852a72$var$SvgCheckMark = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 20,
        height: 21,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "M15.584 6.5a.806.806 0 0 0-1.167 0l-6.25 6.25-2.583-2.583a.805.805 0 0 0-1.167 0 .805.805 0 0 0 0 1.166L7.584 14.5c.166.167.333.25.583.25.25 0 .417-.083.583-.25l6.834-6.833a.806.806 0 0 0 0-1.167Z",
            fill: "currentcolor"
        })
    }));
};
var $4b8c4593f0852a72$export$2e2bcd8739ae039 = $4b8c4593f0852a72$var$SvgCheckMark;



var $1ca5896db469aa98$export$35dc45686fc2dbd7;
var $1ca5896db469aa98$export$7b7a21e0da99e9eb;
var $1ca5896db469aa98$export$b630af4ecfd2d6e7;
var $1ca5896db469aa98$export$deb14886aeaa75c6;
var $1ca5896db469aa98$export$93f351753d52de5b;
var $1ca5896db469aa98$export$4c6c3452301d55be;
var $1ca5896db469aa98$export$c3f9788a1ddcf2d9;
$1ca5896db469aa98$export$35dc45686fc2dbd7 = "BQSd3G_check";
$1ca5896db469aa98$export$7b7a21e0da99e9eb = "BQSd3G_scopeGroup";
$1ca5896db469aa98$export$b630af4ecfd2d6e7 = "BQSd3G_scopeGroupHeader";
$1ca5896db469aa98$export$deb14886aeaa75c6 = "BQSd3G_scopeGroupName";
$1ca5896db469aa98$export$93f351753d52de5b = "BQSd3G_scopeItem";
$1ca5896db469aa98$export$4c6c3452301d55be = "BQSd3G_scopesList";
$1ca5896db469aa98$export$c3f9788a1ddcf2d9 = "BQSd3G_toggleButton";


var $681208bb5f66ad48$var$ScopeGroup = function(param) {
    var groupName = param.groupName, scopes = param.scopes, _param_isAutoExpand = param.isAutoExpand, isAutoExpand = _param_isAutoExpand === void 0 ? false : _param_isAutoExpand;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(isAutoExpand), 2), expanded = _useState[0], setExpanded = _useState[1];
    var toggle = (0, $kVN77.useCallback)(function() {
        setExpanded(function(previous) {
            return !previous;
        });
    }, []);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($1ca5896db469aa98$export$7b7a21e0da99e9eb),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $1ca5896db469aa98$export$b630af4ecfd2d6e7,
                role: "button",
                tabIndex: 0,
                onClick: toggle,
                onKeyDown: (0, $63d9e266638a38b7$export$c2c388d6a668999e)(toggle),
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4b8c4593f0852a72$export$2e2bcd8739ae039), {
                        className: $1ca5896db469aa98$export$35dc45686fc2dbd7
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                        className: $1ca5896db469aa98$export$deb14886aeaa75c6,
                        children: groupName
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $40226f06eca87ae6$export$2e2bcd8739ae039), {
                        className: $1ca5896db469aa98$export$c3f9788a1ddcf2d9,
                        "data-expanded": expanded
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("ul", {
                className: $1ca5896db469aa98$export$4c6c3452301d55be,
                children: scopes.map(function(param) {
                    var id = param.id, name = param.name, description = param.description;
                    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("li", {
                        className: $1ca5896db469aa98$export$93f351753d52de5b,
                        children: description !== null && description !== void 0 ? description : name
                    }, id);
                })
            })
        ]
    });
};
var $681208bb5f66ad48$export$2e2bcd8739ae039 = $681208bb5f66ad48$var$ScopeGroup;










parcelRequire("kVN77");
var $25ffcc0c9063e424$var$SvgOrganizationIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "M11.666 6.667h.834A.833.833 0 1 0 12.5 5h-.834a.833.833 0 0 0 0 1.667Zm0 3.333h.834a.833.833 0 1 0 0-1.666h-.834a.833.833 0 0 0 0 1.666ZM7.5 6.667h.833a.833.833 0 1 0 0-1.667H7.5a.833.833 0 1 0 0 1.667ZM7.5 10h.833a.833.833 0 1 0 0-1.666H7.5A.833.833 0 1 0 7.5 10Zm10 6.667h-.834V2.5a.833.833 0 0 0-.833-.833H4.167a.833.833 0 0 0-.834.833v14.167H2.5a.833.833 0 1 0 0 1.667h15a.833.833 0 1 0 0-1.667Zm-6.667 0H9.166v-3.333h1.667v3.333Zm4.167 0h-2.5V12.5a.834.834 0 0 0-.834-.833H8.333a.833.833 0 0 0-.833.833v4.167H5V3.334h10v13.333Z",
            fill: "currentcolor"
        })
    }));
};
var $25ffcc0c9063e424$export$2e2bcd8739ae039 = $25ffcc0c9063e424$var$SvgOrganizationIcon;



var $425ccee08fb6a01d$export$1ca1ec8b29a4ce27;
var $425ccee08fb6a01d$export$b13d9ff9b87243f5;
var $425ccee08fb6a01d$export$cda7feabc85def4e;
$425ccee08fb6a01d$export$1ca1ec8b29a4ce27 = "_6z3pgG_icon";
$425ccee08fb6a01d$export$b13d9ff9b87243f5 = "_6z3pgG_organizationItem";
$425ccee08fb6a01d$export$cda7feabc85def4e = "_6z3pgG_organizationName";


var $ebb498e41c615bf4$var$OrganizationItem = function(param) {
    var organization = param.organization, onSelect = param.onSelect, isSelected = param.isSelected, suffixElement = param.suffixElement, className = param.className;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($425ccee08fb6a01d$export$b13d9ff9b87243f5, className),
        "data-selected": isSelected
    }, onSelect && {
        role: "button",
        tabIndex: 0,
        onClick: function() {
            onSelect(organization);
        },
        onKeyDown: (0, $63d9e266638a38b7$export$c2c388d6a668999e)(function() {
            onSelect(organization);
        })
    }), {
        children: [
            isSelected ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4b8c4593f0852a72$export$2e2bcd8739ae039), {
                className: $425ccee08fb6a01d$export$1ca1ec8b29a4ce27
            }) : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $25ffcc0c9063e424$export$2e2bcd8739ae039), {
                className: $425ccee08fb6a01d$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $425ccee08fb6a01d$export$cda7feabc85def4e,
                children: organization.name
            }),
            suffixElement
        ]
    }));
};
var $ebb498e41c615bf4$export$2e2bcd8739ae039 = $ebb498e41c615bf4$var$OrganizationItem;






var $kVN77 = parcelRequire("kVN77");



var $60f454b8ee4260a3$export$955245c47f738f8a;
var $60f454b8ee4260a3$export$ec06ab6513f0c8c6;
var $60f454b8ee4260a3$export$34e0f9847d4c02dd;
var $60f454b8ee4260a3$export$b13d9ff9b87243f5;
$60f454b8ee4260a3$export$955245c47f738f8a = "dropdownOverlay_cdf321";
$60f454b8ee4260a3$export$ec06ab6513f0c8c6 = "dropdownModal_cdf321";
$60f454b8ee4260a3$export$34e0f9847d4c02dd = "container_cdf321";
$60f454b8ee4260a3$export$b13d9ff9b87243f5 = "organizationItem_cdf321";


var $4b21b5a88d080580$var$OrganizationSelectorModal = function(param) {
    var isOpen = param.isOpen, parentElementRef = param.parentElementRef, organizations = param.organizations, selectedOrganization = param.selectedOrganization, onSelect = param.onSelect, onClose = param.onClose;
    var isMobile = (0, $c732d3c3053b4284$export$2e2bcd8739ae039)().isMobile;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)({}), 2), position = _useState[0], setPosition = _useState[1];
    var updatePosition = (0, $kVN77.useCallback)(function() {
        var parent = parentElementRef.current;
        if (!parent || isMobile || !isOpen) {
            setPosition({});
            return;
        }
        var _parent_getBoundingClientRect = parent.getBoundingClientRect(), top = _parent_getBoundingClientRect.top, left = _parent_getBoundingClientRect.left, height = _parent_getBoundingClientRect.height, width = _parent_getBoundingClientRect.width;
        // Offset the modal from the parent element
        var offset = 8;
        // The height of each organization item
        var organizationItemHeight = 40;
        // The padding around the modal content
        var organizationModalPadding = 8;
        // Calculate the max top position so that the modal doesn't go off the screen
        var modalContentHeight = organizations.length * organizationItemHeight + organizationModalPadding * 2;
        var windowHeight = window.innerHeight;
        var maxTop = windowHeight - modalContentHeight;
        setPosition({
            top: Math.min(top + height + offset, maxTop),
            left: left,
            width: width
        });
    }, [
        isMobile,
        isOpen,
        organizations.length,
        parentElementRef
    ]);
    (0, $kVN77.useLayoutEffect)(function() {
        updatePosition();
        window.addEventListener("resize", updatePosition);
        return function() {
            window.removeEventListener("resize", updatePosition);
        };
    }, [
        updatePosition,
        isOpen
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f4531ebf250f6fa$exports))), {
        isOpen: isOpen,
        overlayClassName: $60f454b8ee4260a3$export$955245c47f738f8a,
        className: $60f454b8ee4260a3$export$ec06ab6513f0c8c6,
        style: {
            content: (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, position)
        },
        closeTimeoutMS: isMobile ? 300 : 0,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
            className: $60f454b8ee4260a3$export$34e0f9847d4c02dd,
            children: organizations.map(function(organization) {
                return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ebb498e41c615bf4$export$2e2bcd8739ae039), {
                    className: $60f454b8ee4260a3$export$b13d9ff9b87243f5,
                    organization: organization,
                    isSelected: organization.id === selectedOrganization.id,
                    onSelect: function() {
                        onClose();
                        onSelect(organization);
                    }
                }, organization.id);
            })
        })
    });
};
var $4b21b5a88d080580$export$2e2bcd8739ae039 = $4b21b5a88d080580$var$OrganizationSelectorModal;


var $ab7d0150b6f2fba2$export$3f5ca3638bdbafaf;
var $ab7d0150b6f2fba2$export$b94e31e2de63b9f5;
var $ab7d0150b6f2fba2$export$7e1ffd3cb3fff7c0;
var $ab7d0150b6f2fba2$export$63105c67789fc26a;
var $ab7d0150b6f2fba2$export$fb184b623420d9be;
var $ab7d0150b6f2fba2$export$2de5f59b15ed5c63;
$ab7d0150b6f2fba2$export$3f5ca3638bdbafaf = "_4xxBLa_cardWrapper";
$ab7d0150b6f2fba2$export$b94e31e2de63b9f5 = "_4xxBLa_expandButton";
$ab7d0150b6f2fba2$export$7e1ffd3cb3fff7c0 = "_4xxBLa_scopeListWrapper";
$ab7d0150b6f2fba2$export$63105c67789fc26a = "_4xxBLa_selectedOrganization";
$ab7d0150b6f2fba2$export$fb184b623420d9be = "_4xxBLa_title";
$ab7d0150b6f2fba2$export$2de5f59b15ed5c63 = "_4xxBLa_withoutTopRadius";


var $01180c912f70a5d8$var$OrganizationSelector = function(param) {
    var organizations = param.organizations, selectedOrganization = param.selectedOrganization, onSelect = param.onSelect, className = param.className;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var parentElementRef = (0, $kVN77.useRef)(null);
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(false), 2), showDropdown = _useState[0], setShowDropdown = _useState[1];
    if (organizations.length === 0 || !selectedOrganization) return null;
    var resourceScopes = selectedOrganization.missingResourceScopes;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $ab7d0150b6f2fba2$export$fb184b623420d9be,
                children: t("description.authorize_organization_access")
            }),
            resourceScopes && resourceScopes.length > 0 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $ab7d0150b6f2fba2$export$7e1ffd3cb3fff7c0,
                children: resourceScopes.slice()// Sort the scopes to make sure the organization scope is always on top
                .sort(function(param, param1) {
                    var resourceA = param.resource, resourceB = param1.resource;
                    if (resourceA.id === (0, $4f91f077d5b7f09a$export$36ba08a8e14b2df6).Organization) return -1;
                    return resourceB.id === (0, $4f91f077d5b7f09a$export$36ba08a8e14b2df6).Organization ? 1 : 0;
                }).map(function(param) {
                    var resource = param.resource, scopes = param.scopes;
                    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $681208bb5f66ad48$export$2e2bcd8739ae039), {
                        groupName: resource.id === (0, $4f91f077d5b7f09a$export$36ba08a8e14b2df6).Organization ? t("description.organization_scopes") : resource.name,
                        scopes: scopes,
                        isAutoExpand: resourceScopes.length === 1
                    }, resource.id);
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                ref: parentElementRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($ab7d0150b6f2fba2$export$3f5ca3638bdbafaf, Boolean(resourceScopes === null || resourceScopes === void 0 ? void 0 : resourceScopes.length) && $ab7d0150b6f2fba2$export$2de5f59b15ed5c63),
                "data-active": showDropdown,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ebb498e41c615bf4$export$2e2bcd8739ae039), {
                    className: $ab7d0150b6f2fba2$export$63105c67789fc26a,
                    organization: selectedOrganization,
                    suffixElement: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $84d777a3a9676dbd$export$2e2bcd8739ae039), {
                        className: $ab7d0150b6f2fba2$export$b94e31e2de63b9f5
                    }),
                    onSelect: function() {
                        setShowDropdown(true);
                    }
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4b21b5a88d080580$export$2e2bcd8739ae039), {
                isOpen: showDropdown,
                parentElementRef: parentElementRef,
                organizations: organizations,
                selectedOrganization: selectedOrganization,
                onSelect: onSelect,
                onClose: function() {
                    setShowDropdown(false);
                }
            })
        ]
    });
};
var $01180c912f70a5d8$export$2e2bcd8739ae039 = $01180c912f70a5d8$var$OrganizationSelector;





var $kVN77 = parcelRequire("kVN77");


var $c2e7811c17ca653c$export$3f5ca3638bdbafaf;
var $c2e7811c17ca653c$export$35dc45686fc2dbd7;
var $c2e7811c17ca653c$export$7b7a21e0da99e9eb;
var $c2e7811c17ca653c$export$b630af4ecfd2d6e7;
var $c2e7811c17ca653c$export$deb14886aeaa75c6;
var $c2e7811c17ca653c$export$93f351753d52de5b;
var $c2e7811c17ca653c$export$4c6c3452301d55be;
var $c2e7811c17ca653c$export$8a21ba990ca4a7cb;
var $c2e7811c17ca653c$export$fb184b623420d9be;
var $c2e7811c17ca653c$export$c3f9788a1ddcf2d9;
$c2e7811c17ca653c$export$3f5ca3638bdbafaf = "CCj1Qq_cardWrapper";
$c2e7811c17ca653c$export$35dc45686fc2dbd7 = "CCj1Qq_check";
$c2e7811c17ca653c$export$7b7a21e0da99e9eb = "CCj1Qq_scopeGroup";
$c2e7811c17ca653c$export$b630af4ecfd2d6e7 = "CCj1Qq_scopeGroupHeader";
$c2e7811c17ca653c$export$deb14886aeaa75c6 = "CCj1Qq_scopeGroupName";
$c2e7811c17ca653c$export$93f351753d52de5b = "CCj1Qq_scopeItem";
$c2e7811c17ca653c$export$4c6c3452301d55be = "CCj1Qq_scopesList";
$c2e7811c17ca653c$export$8a21ba990ca4a7cb = "CCj1Qq_terms";
$c2e7811c17ca653c$export$fb184b623420d9be = "CCj1Qq_title";
$c2e7811c17ca653c$export$c3f9788a1ddcf2d9 = "CCj1Qq_toggleButton";


var $5fc818d04a626e9b$var$isUserScope = function(scope) {
    return Object.values((0, $4f91f077d5b7f09a$export$4b02c5b431f6eb78)).includes(scope);
};
var $5fc818d04a626e9b$var$ScopesListCard = function(param) {
    var userScopes = param.userScopes, resourceScopes = param.resourceScopes, appName = param.appName, className = param.className;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var userScopesData = (0, $kVN77.useMemo)(function() {
        return userScopes === null || userScopes === void 0 ? void 0 : userScopes.map(function(scope) {
            return {
                id: scope,
                name: scope,
                description: $5fc818d04a626e9b$var$isUserScope(scope) ? t("user_scopes.descriptions.".concat(scope), {
                    nsSeparator: "|"
                }) : undefined
            };
        });
    }, [
        t,
        userScopes
    ]);
    // If there is no user scopes and resource scopes, we don't need to show the scopes list.
    if (!(userScopesData === null || userScopesData === void 0 ? void 0 : userScopesData.length) && !(resourceScopes === null || resourceScopes === void 0 ? void 0 : resourceScopes.length)) return null;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $c2e7811c17ca653c$export$fb184b623420d9be,
                children: t("description.authorize_personal_data_usage", {
                    name: appName
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $c2e7811c17ca653c$export$3f5ca3638bdbafaf,
                children: [
                    userScopesData && userScopesData.length > 0 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $681208bb5f66ad48$export$2e2bcd8739ae039), {
                        groupName: "User Scopes",
                        scopes: userScopesData,
                        // If there is no resource scopes, we should auto expand the user scopes
                        isAutoExpand: !(resourceScopes === null || resourceScopes === void 0 ? void 0 : resourceScopes.length)
                    }),
                    resourceScopes === null || resourceScopes === void 0 ? void 0 : resourceScopes.map(function(param) {
                        var resource = param.resource, scopes = param.scopes;
                        /*#__PURE__*/ return (0, $d67ee09f839f930f$exports.jsx)((0, $681208bb5f66ad48$export$2e2bcd8739ae039), {
                            groupName: resource.name,
                            scopes: scopes,
                            // If there is no user scopes, we should auto expand the resource scopes
                            isAutoExpand: !(userScopesData === null || userScopesData === void 0 ? void 0 : userScopesData.length) && resourceScopes.length === 1
                        }, resource.id);
                    })
                ]
            })
        ]
    });
};
var $5fc818d04a626e9b$export$2e2bcd8739ae039 = $5fc818d04a626e9b$var$ScopesListCard;








parcelRequire("kVN77");
var $958c61748b846851$var$SvgDefaultUserAvatar = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "#F7F8F8"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "#78767F",
                fillOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "#5D34F2",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.145 8.334a4.565 4.565 0 0 0-4.565 4.565v1.014a4.565 4.565 0 0 0 9.13 0V12.9a4.565 4.565 0 0 0-4.565-4.565Zm0 23.333c10.145 0 10.145-3.298 10.145-3.298 0-4.277-2.123-8.264-7.609-8.369-.023 0-.181.154-.411.377-.603.587-1.696 1.65-2.125 1.65-.429 0-1.522-1.064-2.125-1.65-.23-.223-.388-.377-.411-.377C12.123 20.105 10 24.092 10 28.37c0 0 0 3.298 10.145 3.298Z",
                fill: "#947DFF"
            })
        ]
    }));
};
var $958c61748b846851$export$2e2bcd8739ae039 = $958c61748b846851$var$SvgDefaultUserAvatar;


var $a61cf69c9bbc20db$export$345c5736c8054f22;
var $a61cf69c9bbc20db$export$c2ab62c7bf24634;
var $a61cf69c9bbc20db$export$a8ff84c12d48cfa6;
var $a61cf69c9bbc20db$export$cc74dcc53cfce4eb;
$a61cf69c9bbc20db$export$345c5736c8054f22 = "kEaEPG_avatar";
$a61cf69c9bbc20db$export$c2ab62c7bf24634 = "kEaEPG_identifier";
$a61cf69c9bbc20db$export$a8ff84c12d48cfa6 = "kEaEPG_name";
$a61cf69c9bbc20db$export$cc74dcc53cfce4eb = "kEaEPG_wrapper";


var $7ece7bcfcfea92b7$var$UserProfile = function(param) {
    var _param_user = param.user, id = _param_user.id, avatar = _param_user.avatar, name = _param_user.name, primaryEmail = _param_user.primaryEmail, primaryPhone = _param_user.primaryPhone, username = _param_user.username, className = param.className;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _ref;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($a61cf69c9bbc20db$export$cc74dcc53cfce4eb, className),
        children: [
            avatar ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("img", {
                src: avatar,
                alt: "avatar",
                className: $a61cf69c9bbc20db$export$345c5736c8054f22
            }) : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $958c61748b846851$export$2e2bcd8739ae039), {
                className: $a61cf69c9bbc20db$export$345c5736c8054f22
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                        className: $a61cf69c9bbc20db$export$a8ff84c12d48cfa6,
                        children: name !== null && name !== void 0 ? name : t("description.user_id", {
                            id: id
                        })
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                        className: $a61cf69c9bbc20db$export$c2ab62c7bf24634,
                        children: (_ref = primaryEmail !== null && primaryEmail !== void 0 ? primaryEmail : primaryPhone) !== null && _ref !== void 0 ? _ref : username
                    })
                ]
            })
        ]
    });
};
var $7ece7bcfcfea92b7$export$2e2bcd8739ae039 = $7ece7bcfcfea92b7$var$UserProfile;


var $36f97bba3391fc52$export$f66169a144f13441;
var $36f97bba3391fc52$export$479d2866b0c2b2a9;
var $36f97bba3391fc52$export$3b0cadee2e474bed;
var $36f97bba3391fc52$export$472007267a19777f;
var $36f97bba3391fc52$export$aecd16287464ee90;
var $36f97bba3391fc52$export$8a21ba990ca4a7cb;
$36f97bba3391fc52$export$f66169a144f13441 = "U5sxCa_footerButton";
$36f97bba3391fc52$export$479d2866b0c2b2a9 = "U5sxCa_footerLink";
$36f97bba3391fc52$export$3b0cadee2e474bed = "U5sxCa_organizationSelector";
$36f97bba3391fc52$export$472007267a19777f = "U5sxCa_redirectUri";
$36f97bba3391fc52$export$aecd16287464ee90 = "U5sxCa_scopesCard";
$36f97bba3391fc52$export$8a21ba990ca4a7cb = "U5sxCa_terms";


/**
 * We need to hide the query params and path from the redirectUri for security reasons when displaying it to the user.
 *
 * if the redirectUri is a http url, we should return the origin
 * Otherwise return the original uri. e.g. native schema io.logto://callback
 */ var $de52650937db2b63$export$941e0612af2803f1 = function(redirectUri) {
    var url = new URL(redirectUri);
    // If the redirectUri is a http url, we should return the origin
    if (url.protocol.startsWith("http")) return url.origin;
    // Otherwise return the original uri. e.g. native schema io.logto://callback
    return redirectUri;
};


var $a32ac716ba310ce9$var$Consent = function() {
    var _consentData_missingResourceScopes;
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var asyncConsent = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $69ea688e66b8ae56$export$a6dfab0e9e63c404));
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), consentData = _useState[0], setConsentData = _useState[1];
    var _useState1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), selectedOrganization = _useState1[0], setSelectedOrganization = _useState1[1];
    var asyncGetConsentInfo = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $69ea688e66b8ae56$export$63817cd70bf84ca6));
    var consentHandler = (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var _ref, error, result;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        asyncConsent(selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.id)
                    ];
                case 1:
                    _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                        _state.sent(),
                        2
                    ]), error = _ref[0], result = _ref[1];
                    if (!error) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handleError(error)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                    return [
                        2
                    ];
            }
        });
    }), [
        asyncConsent,
        handleError,
        redirectTo,
        selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.id
    ]);
    (0, $kVN77.useEffect)(function() {
        var getConsentInfoHandler = function() {
            var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                var _result_organizations, _ref, error, result;
                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                asyncGetConsentInfo()
                            ];
                        case 1:
                            _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                                _state.sent(),
                                2
                            ]), error = _ref[0], result = _ref[1];
                            if (!error) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                handleError(error)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                        case 3:
                            setConsentData(result);
                            // Init the default organization selection
                            if (!(result === null || result === void 0 ? void 0 : (_result_organizations = result.organizations) === null || _result_organizations === void 0 ? void 0 : _result_organizations.length)) return [
                                2
                            ];
                            setSelectedOrganization(result.organizations[0]);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getConsentInfoHandler() {
                return _ref.apply(this, arguments);
            };
        }();
        getConsentInfoHandler();
    }, [
        asyncGetConsentInfo,
        handleError
    ]);
    if (!consentData) return null;
    var _consentData_application = consentData.application, displayName = _consentData_application.displayName, name = _consentData_application.name, termsOfUseUrl = _consentData_application.termsOfUseUrl, privacyPolicyUrl = _consentData_application.privacyPolicyUrl;
    var applicationName = displayName !== null && displayName !== void 0 ? displayName : name;
    var showTerms = Boolean(termsOfUseUrl !== null && termsOfUseUrl !== void 0 ? termsOfUseUrl : privacyPolicyUrl);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1b7e9c0f93e4c544$export$2e2bcd8739ae039), {
        title: "description.authorize_title",
        titleInterpolation: {
            name: applicationName
        },
        thirdPartyBranding: consentData.application.branding,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $7ece7bcfcfea92b7$export$2e2bcd8739ae039), {
                user: consentData.user
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $5fc818d04a626e9b$export$2e2bcd8739ae039), {
                userScopes: consentData.missingOIDCScope,
                /**
         * The org resources is included in the user scopes for compatibility.
         */ resourceScopes: (_consentData_missingResourceScopes = consentData.missingResourceScopes) === null || _consentData_missingResourceScopes === void 0 ? void 0 : _consentData_missingResourceScopes.filter(function(param) {
                    var resource = param.resource;
                    return resource.id !== (0, $4f91f077d5b7f09a$export$36ba08a8e14b2df6).Organization;
                }),
                appName: applicationName,
                className: $36f97bba3391fc52$export$aecd16287464ee90
            }),
            consentData.organizations && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $01180c912f70a5d8$export$2e2bcd8739ae039), {
                className: $36f97bba3391fc52$export$3b0cadee2e474bed,
                organizations: consentData.organizations,
                selectedOrganization: selectedOrganization,
                onSelect: setSelectedOrganization
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $36f97bba3391fc52$export$f66169a144f13441,
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                        title: "action.cancel",
                        type: "secondary",
                        onClick: function() {
                            window.location.replace(consentData.redirectUri);
                        }
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                        title: "action.authorize",
                        onClick: consentHandler
                    })
                ]
            }),
            !showTerms && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $36f97bba3391fc52$export$472007267a19777f,
                children: t("description.redirect_to", {
                    name: (0, $de52650937db2b63$export$941e0612af2803f1)(consentData.redirectUri)
                })
            }),
            showTerms && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $36f97bba3391fc52$export$8a21ba990ca4a7cb,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $056babc663998f62$export$8d6a9236f2e3f2ce), {
                    components: {
                        link: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $92a809d54e7cd2ca$export$2e2bcd8739ae039), {
                            inline: true,
                            termsOfUseUrl: termsOfUseUrl !== null && termsOfUseUrl !== void 0 ? termsOfUseUrl : "",
                            privacyPolicyUrl: privacyPolicyUrl !== null && privacyPolicyUrl !== void 0 ? privacyPolicyUrl : ""
                        })
                    },
                    children: t("description.authorize_agreement_with_redirect", {
                        name: name,
                        uri: (0, $de52650937db2b63$export$941e0612af2803f1)(consentData.redirectUri)
                    })
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $36f97bba3391fc52$export$479d2866b0c2b2a9,
                children: [
                    t("description.not_you"),
                    " ",
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                        replace: true,
                        to: "/sign-in",
                        text: "action.use_another_account"
                    })
                ]
            })
        ]
    });
};
var $a32ac716ba310ce9$export$2e2bcd8739ae039 = $a32ac716ba310ce9$var$Consent;








var $kVN77 = parcelRequire("kVN77");





parcelRequire("kVN77");
var $02eda22e3f16cfd0$var$SvgEmptyStateDark = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 194,
        height: 196,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 34,
                y: 46,
                width: 140,
                height: 108,
                rx: 12,
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("mask", {
                id: "empty-state-dark_svg__a",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 34,
                y: 46,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                    x: 34,
                    y: 46,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#928F9A"
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                d: "M34 58c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v4H34v-4Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.686 96.686a4 4 0 0 0 0 5.657L83.343 108l-5.656 5.657a3.999 3.999 0 0 0 0 5.656 3.998 3.998 0 0 0 5.657 0L89 113.657l5.656 5.656a4 4 0 0 0 5.657-5.656L94.657 108l5.658-5.657a4 4 0 0 0-5.657-5.657L89 102.344l-5.657-5.658a4 4 0 0 0-5.657 0ZM125.686 96.686a4 4 0 0 0 0 5.657l5.657 5.657-5.656 5.657a4 4 0 1 0 5.657 5.656l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.656L142.657 108l5.658-5.657a4 4 0 0 0-5.657-5.657L137 102.344l-5.657-5.658a4 4 0 0 0-5.657 0Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("circle", {
                cx: 48,
                cy: 54,
                r: 2,
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("circle", {
                cx: 58,
                cy: 54,
                r: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("circle", {
                cx: 68,
                cy: 54,
                r: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 50,
                y: 74,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 50,
                y: 81,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 148,
                y: 81,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 68,
                y: 81,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 122,
                y: 74,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 135,
                y: 74,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("mask", {
                id: "empty-state-dark_svg__b",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 1,
                y: 65,
                width: 92,
                height: 99,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                    d: "M92 70.5V66H1.5v97.5H39c13.255 0 24-10.745 24-24v-40C63 91.492 69.492 85 77.5 85S92 78.508 92 70.5Z",
                    fill: "#fff",
                    stroke: "#F7F8F8",
                    strokeOpacity: 0.16,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("g", {
                mask: "url(#empty-state-dark_svg__b)",
                stroke: "#F7F8F8",
                strokeOpacity: 0.16,
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                    d: "m-28 62 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.044a8.912 8.912 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 62M-28 66l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 66M-28 70l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 70M-28 74l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 74M-28 78l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 78M-28 82l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 82M-28 86l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 86M-28 90l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 90M-28 94l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 94M-28 98l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.971 8.971 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.695 8.695 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.979 8.979 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.92 8.92 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 98M-28 102l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 102M-28 106l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 106M-28 110l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 110M-28 114l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 114M-28 118l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 118M-28 122l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 122M-28 126l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 126M-28 130l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 130M-28 134l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 134M-28 138l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 138M-28 142l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 142M-28 146l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 146M-28 150l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 150M-28 154l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 154M-28 158l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 158M-28 162l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 162"
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 143.453,
                y: 24,
                width: 24,
                height: 24,
                rx: 4,
                transform: "rotate(50.249 143.453 24)",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M181.914.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305V.208Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 25A8 8 0 1 0 8 9a8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M170 162c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                d: "M52.305 25.602c-1.066-2.889 1.395-5.848 4.43-5.327l4.552.783c3.035.521 4.367 4.132 2.398 6.5l-2.953 3.55c-1.97 2.368-5.763 1.716-6.829-1.173l-1.598-4.333Z",
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 51,
                y: 192,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#CABEFF",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 143,
                y: 192,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#CABEFF",
                fillOpacity: 0.12
            })
        ]
    }));
};
var $02eda22e3f16cfd0$export$2e2bcd8739ae039 = $02eda22e3f16cfd0$var$SvgEmptyStateDark;





parcelRequire("kVN77");
var $30910b074d6e1bc4$var$SvgEmptyState = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 194,
        height: 196,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 34,
                y: 46,
                width: 140,
                height: 108,
                rx: 12,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("mask", {
                id: "empty-state_svg__a",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 34,
                y: 46,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                    x: 34,
                    y: 46,
                    width: 140,
                    height: 108,
                    rx: 12,
                    fill: "#D5CFF1"
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                d: "M34 58c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v4H34v-4Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.686 96.686a4 4 0 0 0 0 5.657l5.657 5.658-5.656 5.656a4 4 0 0 0 5.657 5.657L89 113.658l5.656 5.656a4 4 0 1 0 5.657-5.657l-5.656-5.656 5.658-5.658a4 4 0 1 0-5.657-5.657L89 102.344l-5.657-5.658a4 4 0 0 0-5.657 0ZM125.686 96.686a4 4 0 0 0 0 5.657l5.657 5.658-5.656 5.656a4 4 0 0 0 5.657 5.657l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.657l-5.656-5.656 5.658-5.658a4 4 0 0 0-5.657-5.657L137 102.344l-5.657-5.658a4 4 0 0 0-5.657 0Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("circle", {
                cx: 48,
                cy: 54,
                r: 2,
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("circle", {
                cx: 58,
                cy: 54,
                r: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("circle", {
                cx: 68,
                cy: 54,
                r: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 50,
                y: 74,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 50,
                y: 81,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 148,
                y: 81,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 68,
                y: 81,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 122,
                y: 74,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 135,
                y: 74,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("mask", {
                id: "empty-state_svg__b",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 1,
                y: 66,
                width: 91,
                height: 98,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                    d: "M92 70.5V66H1.5v97.5H39c13.255 0 24-10.745 24-24v-40C63 91.492 69.492 85 77.5 85S92 78.508 92 70.5Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("g", {
                mask: "url(#empty-state_svg__b)",
                stroke: "#C9C5D0",
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                    d: "m-28 66 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 66M-28 70l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 70M-28 74l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 74M-28 78l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 78M-28 82l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 82M-28 86l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 86M-28 90l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 90M-28 94l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 94M-28 98l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.971 8.971 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.695 8.695 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.979 8.979 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.92 8.92 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 98M-28 102l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 102M-28 106l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 106M-28 110l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 110M-28 114l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 114M-28 118l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 118M-28 122l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 122M-28 126l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 126M-28 130l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 130M-28 134l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 134M-28 138l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 138M-28 142l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 142M-28 146l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 146M-28 150l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 150M-28 154l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 154M-28 158l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 158M-28 162l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 162"
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 143.453,
                y: 24,
                width: 24,
                height: 24,
                rx: 6,
                transform: "rotate(50.249 143.453 24)",
                fill: "#C9C5D0",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M181.914.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305V.208Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 25A8 8 0 1 0 8 9a8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M170 162c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#E5E1EC",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                d: "M52.305 25.602c-1.066-2.889 1.395-5.848 4.43-5.327l4.552.783c3.035.521 4.367 4.132 2.398 6.5l-2.953 3.55c-1.97 2.368-5.763 1.716-6.829-1.173l-1.598-4.333Z",
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 51,
                y: 192,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                x: 143,
                y: 192,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#C9C5D0"
            })
        ]
    }));
};
var $30910b074d6e1bc4$export$2e2bcd8739ae039 = $30910b074d6e1bc4$var$SvgEmptyState;





var $c7ca187b3163a351$export$8d6d009d1f06226e;
var $c7ca187b3163a351$export$34e0f9847d4c02dd;
var $c7ca187b3163a351$export$a8ecead220dd38a6;
var $c7ca187b3163a351$export$fb184b623420d9be;
$c7ca187b3163a351$export$8d6d009d1f06226e = "yIkPZG_backButton";
$c7ca187b3163a351$export$34e0f9847d4c02dd = "yIkPZG_container";
$c7ca187b3163a351$export$a8ecead220dd38a6 = "yIkPZG_message";
$c7ca187b3163a351$export$fb184b623420d9be = "yIkPZG_title";


var $58ebb1359bf01f2d$var$ErrorPage = function(param) {
    var _param_title = param.title, title = _param_title === void 0 ? "description.not_found" : _param_title, message = param.message, rawMessage = param.rawMessage;
    var theme = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).theme;
    var errorMessage = Boolean(rawMessage !== null && rawMessage !== void 0 ? rawMessage : message);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $bc289486222dabf4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $f69507d36a87d6c0$export$2e2bcd8739ae039), {
                titleKey: title
            }),
            history.length > 1 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3dbbd783a5debe63$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $c7ca187b3163a351$export$34e0f9847d4c02dd,
                children: [
                    theme === (0, $3435b1bcc8b985e2$export$14faa19a0f3bbeb2).Light ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $30910b074d6e1bc4$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $02eda22e3f16cfd0$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                        className: $c7ca187b3163a351$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                            forKey: title
                        })
                    }),
                    errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                        className: $c7ca187b3163a351$export$a8ecead220dd38a6,
                        children: rawMessage !== null && rawMessage !== void 0 ? rawMessage : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                            forKey: message
                        })
                    })
                ]
            })
        ]
    });
};
var $58ebb1359bf01f2d$export$2e2bcd8739ae039 = $58ebb1359bf01f2d$var$ErrorPage;
















var $kVN77 = parcelRequire("kVN77");



parcelRequire("kVN77");
var $ef4360cebac7eaac$var$SvgInfoIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                d: "M9.41 9.41a.833.833 0 0 1 1.423.59v3.333a.833.833 0 1 1-1.666 0V10c0-.221.088-.433.244-.59ZM9.683 5.9a.833.833 0 0 1 .634 0c.102.04.195.1.275.175.152.16.238.37.241.592a.834.834 0 0 1-1.15.766.958.958 0 0 1-.275-.175.833.833 0 0 1-.175-.908.958.958 0 0 1 .175-.275.834.834 0 0 1 .275-.175Z",
                fill: "#fff"
            })
        ]
    }));
};
var $ef4360cebac7eaac$export$2e2bcd8739ae039 = $ef4360cebac7eaac$var$SvgInfoIcon;



var $6e7bab8f0a2faf02$export$1ca1ec8b29a4ce27;
var $6e7bab8f0a2faf02$export$9c30223ca0a664fb;
var $6e7bab8f0a2faf02$export$a8ecead220dd38a6;
var $6e7bab8f0a2faf02$export$2adf6238a2d0dafa;
$6e7bab8f0a2faf02$export$1ca1ec8b29a4ce27 = "HCi3vq_icon";
$6e7bab8f0a2faf02$export$9c30223ca0a664fb = "HCi3vq_link";
$6e7bab8f0a2faf02$export$a8ecead220dd38a6 = "HCi3vq_message";
$6e7bab8f0a2faf02$export$2adf6238a2d0dafa = "HCi3vq_notification";


/* eslint-enable react/require-default-props */ var $3db617c31aec1384$var$AppNotification = /*#__PURE__*/ (0, $kVN77.forwardRef)(function(param, ref) {
    var className = param.className, message = param.message, style = param.style, onClose = param.onClose;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($6e7bab8f0a2faf02$export$2adf6238a2d0dafa, className),
        style: style,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ef4360cebac7eaac$export$2e2bcd8739ae039), {
                className: $6e7bab8f0a2faf02$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $6e7bab8f0a2faf02$export$a8ecead220dd38a6,
                children: message
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                text: "action.got_it",
                className: $6e7bab8f0a2faf02$export$9c30223ca0a664fb,
                onClick: onClose
            })
        ]
    });
});
var $3db617c31aec1384$export$2e2bcd8739ae039 = $3db617c31aec1384$var$AppNotification;





var $b604a4ab18f524e9$export$2adf6238a2d0dafa;
$b604a4ab18f524e9$export$2adf6238a2d0dafa = "TGbnSW_notification";


var $24158042221f5122$var$InlineNotification = function(param) {
    var className = param.className, message = param.message;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($b604a4ab18f524e9$export$2adf6238a2d0dafa, className),
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
            forKey: message
        })
    });
};
var $24158042221f5122$export$2e2bcd8739ae039 = $24158042221f5122$var$InlineNotification;




var $0770773b1d2445c6$export$34e0f9847d4c02dd;
var $0770773b1d2445c6$export$6d59db4903f20f7d;
var $0770773b1d2445c6$export$38e42c68cf43b5d4;
var $0770773b1d2445c6$export$2adf6238a2d0dafa;
var $0770773b1d2445c6$export$fb184b623420d9be;
var $0770773b1d2445c6$export$cc74dcc53cfce4eb;
$0770773b1d2445c6$export$34e0f9847d4c02dd = "Se2C6G_container";
$0770773b1d2445c6$export$6d59db4903f20f7d = "Se2C6G_description";
$0770773b1d2445c6$export$38e42c68cf43b5d4 = "Se2C6G_header";
$0770773b1d2445c6$export$2adf6238a2d0dafa = "Se2C6G_notification";
$0770773b1d2445c6$export$fb184b623420d9be = "Se2C6G_title";
$0770773b1d2445c6$export$cc74dcc53cfce4eb = "Se2C6G_wrapper";


var $b5ebb61f0176ceed$var$SecondaryPageLayout = function(param) {
    var title = param.title, description = param.description, titleProps = param.titleProps, descriptionProps = param.descriptionProps, notification = param.notification, onSkip = param.onSkip, isNavBarHidden = param.isNavBarHidden, children = param.children;
    var isMobile = (0, $c732d3c3053b4284$export$2e2bcd8739ae039)().isMobile;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: $0770773b1d2445c6$export$cc74dcc53cfce4eb,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $f69507d36a87d6c0$export$2e2bcd8739ae039), {
                titleKey: title
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3dbbd783a5debe63$export$2e2bcd8739ae039), {
                isHidden: isNavBarHidden,
                onSkip: onSkip
            }),
            isMobile && notification && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $24158042221f5122$export$2e2bcd8739ae039), {
                message: notification,
                className: $0770773b1d2445c6$export$2adf6238a2d0dafa
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $0770773b1d2445c6$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                        className: $0770773b1d2445c6$export$38e42c68cf43b5d4,
                        children: [
                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                                className: $0770773b1d2445c6$export$fb184b623420d9be,
                                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                                    forKey: title,
                                    interpolation: titleProps
                                })
                            }),
                            description && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                                className: $0770773b1d2445c6$export$6d59db4903f20f7d,
                                children: typeof description === "string" ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                                    forKey: description,
                                    interpolation: descriptionProps
                                }) : description
                            })
                        ]
                    }),
                    children
                ]
            }),
            !isMobile && notification && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $24158042221f5122$export$2e2bcd8739ae039), {
                message: notification,
                className: $0770773b1d2445c6$export$2adf6238a2d0dafa
            })
        ]
    });
};
var $b5ebb61f0176ceed$export$2e2bcd8739ae039 = $b5ebb61f0176ceed$var$SecondaryPageLayout;


/* Replace legacy useSendVerificationCode hook with this one after the refactor */ 





var $kVN77 = parcelRequire("kVN77");





/* istanbul ignore file */ 






var $bc69946dbbb06dd3$export$9dd6b5912a64e305 = "/api/interaction";
var $bc69946dbbb06dd3$var$verificationPath = "verification";
var $bc69946dbbb06dd3$export$9e0f2ad532e0b36f = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305), {
                            json: {
                                event: (0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).SignIn,
                                identifier: payload
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function signInWithPasswordIdentifier(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$3053dcea78a60348 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(username, password) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305), {
                            json: {
                                event: (0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).Register,
                                profile: (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                                    username: username
                                }, (0, $3539bd14a37ab7f4$export$c327da55a124987a)(password && {
                                    password: password
                                }))
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function registerWithUsernamePassword(username, password) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$bc3a34d5df3015fe = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(password) {
        var result;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/profile"), {
                            json: {
                                password: password
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
                case 2:
                    result = _state.sent();
                    // Reset password does not have any response body
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                    return [
                        2,
                        result || {
                            success: true
                        }
                    ];
            }
        });
    });
    return function setUserPassword(password) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$b8e11e1a71f798c = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305), {
                    json: {
                        event: event
                    }
                })
            ];
        });
    });
    return function putInteraction(event) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$fa789d461ee63605 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/").concat($bc69946dbbb06dd3$var$verificationPath, "/verification-code"), {
                            json: payload
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        {
                            success: true
                        }
                    ];
            }
        });
    });
    return function sendVerificationCode(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$e01e93c3ae4f0e08 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/identifiers"), {
                            json: payload
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function signInWithVerificationCodeIdentifier(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$1f2cf4d85f14ded7 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        var verificationCode, identifier;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/identifiers"), {
                            json: payload
                        })
                    ];
                case 1:
                    _state.sent();
                    verificationCode = payload.verificationCode, identifier = (0, $487369748a2c1c33$export$69fdd232f62cde60)(payload, [
                        "verificationCode"
                    ]);
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/profile"), {
                            json: identifier
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function addProfileWithVerificationCodeIdentifier(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$df60c504f9d9103e = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/identifiers"), {
                            json: payload
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function verifyForgotPasswordVerificationCodeIdentifier(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$85e251dbbdeeea73 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).delete("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/profile"))
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/event"), {
                            json: {
                                event: (0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).SignIn
                            }
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function signInWithVerifiedIdentifier() {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$ec172577cee1ef2a = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/event"), {
                            json: {
                                event: (0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).Register
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/profile"), {
                            json: payload
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function registerWithVerifiedIdentifier(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$32da561ec87acb84 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/profile"), {
                            json: payload
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function addProfile(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$58837cdda1b658ed = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId, state, redirectUri) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305), {
                            json: {
                                event: (0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).SignIn
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/").concat($bc69946dbbb06dd3$var$verificationPath, "/social-authorization-uri"), {
                            json: {
                                connectorId: connectorId,
                                state: state,
                                redirectUri: redirectUri
                            }
                        }).json()
                    ];
            }
        });
    });
    return function getSocialAuthorizationUrl(connectorId, state, redirectUri) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$90917f4878ed116a = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/identifiers"), {
                            json: payload
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function signInWithSocial(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$ae2a9e5eae510a93 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/event"), {
                            json: {
                                event: (0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).Register
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/profile"), {
                            json: {
                                connectorId: connectorId
                            }
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function registerWithVerifiedSocial(connectorId) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$bd9511c461958ea7 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/event"), {
                            json: {
                                event: (0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).SignIn
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/identifiers"), {
                            json: payload
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).patch("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/profile"), {
                            json: {
                                connectorId: payload.connectorId
                            }
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function bindSocialRelatedUser(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$75b0bae8270ba103 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Sign-in with pre-verified email/phone identifier instead and replace the email/phone profile with connectorId.
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/event"), {
                            json: {
                                event: (0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).SignIn
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/profile"), {
                            json: {
                                connectorId: connectorId
                            }
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function linkWithSocial(connectorId) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$ed04f454e58389a8 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/").concat($bc69946dbbb06dd3$var$verificationPath, "/totp")).json()
            ];
        });
    });
    return function createTotpSecret() {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$4a7a1c8b5ba74d74 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/").concat($bc69946dbbb06dd3$var$verificationPath, "/webauthn-registration")).json()
            ];
        });
    });
    return function createWebAuthnRegistrationOptions() {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$dddc1626e5376ab0 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/").concat($bc69946dbbb06dd3$var$verificationPath, "/webauthn-authentication")).json()
            ];
        });
    });
    return function generateWebAuthnAuthnOptions() {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$8a7ec544b861c507 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/bind-mfa"), {
                            json: payload
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function bindMfa(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$f34dd6a11cbbbf5c = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/mfa"), {
                            json: payload
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function verifyMfa(payload) {
        return _ref.apply(this, arguments);
    };
}();
var $bc69946dbbb06dd3$export$19773ff1b0ccf87f = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/mfa-skipped"), {
                            json: {
                                mfaSkipped: true
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($bc69946dbbb06dd3$export$9dd6b5912a64e305, "/submit")).json()
                    ];
            }
        });
    });
    return function skipMfa() {
        return _ref.apply(this, arguments);
    };
}();


var $9324e24164181712$export$6443fa89a66c693a = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(type, payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(type === (0, $14a274f0b6caba9a$export$12e44e23ec720850).ForgotPassword)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $bc69946dbbb06dd3$export$b8e11e1a71f798c)((0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).ForgotPassword)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    if (!(type === (0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $bc69946dbbb06dd3$export$b8e11e1a71f798c)((0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).SignIn)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    if (!(type === (0, $14a274f0b6caba9a$export$12e44e23ec720850).Register)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        (0, $bc69946dbbb06dd3$export$b8e11e1a71f798c)((0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).Register)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        (0, $bc69946dbbb06dd3$export$fa789d461ee63605)(payload)
                    ];
            }
        });
    });
    return function sendVerificationCodeApi(type, payload) {
        return _ref.apply(this, arguments);
    };
}();




var $10722ee4e324da1c$var$useSendVerificationCode = function(flow, replaceCurrentPage) {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var asyncSendVerificationCode = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $9324e24164181712$export$6443fa89a66c693a));
    var clearErrorMessage = (0, $kVN77.useCallback)(function() {
        setErrorMessage("");
    }, []);
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
            var identifier, value, _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        identifier = param.identifier, value = param.value;
                        return [
                            4,
                            asyncSendVerificationCode(flow, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, identifier, value))
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, {
                                "guard.invalid_input": function() {
                                    setErrorMessage(identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? "invalid_email" : "invalid_phone");
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        if (result) navigate({
                            pathname: "/".concat(flow, "/verification-code"),
                            search: location.search
                        }, {
                            state: {
                                identifier: identifier,
                                value: value
                            },
                            replace: replaceCurrentPage
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncSendVerificationCode,
        flow,
        handleError,
        navigate,
        replaceCurrentPage
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $10722ee4e324da1c$export$2e2bcd8739ae039 = $10722ee4e324da1c$var$useSendVerificationCode;










var $kVN77 = parcelRequire("kVN77");









var $kVN77 = parcelRequire("kVN77");
var $d461588cfcd3c0f7$var$isCheckBoxInput = function(element) {
    return element.type === "checkbox";
};
var $d461588cfcd3c0f7$var$isDateObject = function(value1) {
    return value1 instanceof Date;
};
var $d461588cfcd3c0f7$var$isNullOrUndefined = function(value1) {
    return value1 == null;
};
var $d461588cfcd3c0f7$var$isObjectType = function(value1) {
    return typeof value1 === "object";
};
var $d461588cfcd3c0f7$var$isObject = function(value1) {
    return !$d461588cfcd3c0f7$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $d461588cfcd3c0f7$var$isObjectType(value1) && !$d461588cfcd3c0f7$var$isDateObject(value1);
};
var $d461588cfcd3c0f7$var$getEventValue = function(event) {
    return $d461588cfcd3c0f7$var$isObject(event) && event.target ? $d461588cfcd3c0f7$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
};
var $d461588cfcd3c0f7$var$getNodeParentName = function(name) {
    return name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
};
var $d461588cfcd3c0f7$var$isNameInFieldArray = function(names, name) {
    return names.has($d461588cfcd3c0f7$var$getNodeParentName(name));
};
var $d461588cfcd3c0f7$var$compact = function(value1) {
    return Array.isArray(value1) ? value1.filter(Boolean) : [];
};
var $d461588cfcd3c0f7$var$isUndefined = function(val) {
    return val === undefined;
};
var $d461588cfcd3c0f7$export$3988ae62b71be9a3 = function(obj, path, defaultValue) {
    if (!path || !$d461588cfcd3c0f7$var$isObject(obj)) return defaultValue;
    var result = $d461588cfcd3c0f7$var$compact(path.split(/[,[\].]+?/)).reduce(function(result, key) {
        return $d461588cfcd3c0f7$var$isNullOrUndefined(result) ? result : result[key];
    }, obj);
    return $d461588cfcd3c0f7$var$isUndefined(result) || result === obj ? $d461588cfcd3c0f7$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var $d461588cfcd3c0f7$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
var $d461588cfcd3c0f7$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
var $d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
var $d461588cfcd3c0f7$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ var $d461588cfcd3c0f7$export$4d957a5e1be13b03 = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useContext($d461588cfcd3c0f7$var$HookFormContext);
};
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ var $d461588cfcd3c0f7$export$8ce1ff4f94d08846 = function(props) {
    var children = props.children, data = (0, $487369748a2c1c33$export$69fdd232f62cde60)(props, [
        "children"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).createElement($d461588cfcd3c0f7$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $d461588cfcd3c0f7$var$getProxyFormState = function(formState, _proxyFormState, localProxyFormState) {
    var _loop = function(key) {
        Object.defineProperty(result, key, {
            get: function() {
                var _key = key;
                if (_proxyFormState[_key] !== $d461588cfcd3c0f7$var$VALIDATION_MODE.all) _proxyFormState[_key] = !isRoot || $d461588cfcd3c0f7$var$VALIDATION_MODE.all;
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            }
        });
    };
    var isRoot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var result = {};
    for(var key in formState)_loop(key);
    return result;
};
var $d461588cfcd3c0f7$var$isEmptyObject = function(value1) {
    return $d461588cfcd3c0f7$var$isObject(value1) && !Object.keys(value1).length;
};
var $d461588cfcd3c0f7$var$shouldRenderFormState = function(formStateData, _proxyFormState, isRoot) {
    var name = formStateData.name, formState = (0, $487369748a2c1c33$export$69fdd232f62cde60)(formStateData, [
        "name"
    ]);
    return $d461588cfcd3c0f7$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find(function(key) {
        return _proxyFormState[key] === (!isRoot || $d461588cfcd3c0f7$var$VALIDATION_MODE.all);
    });
};
var $d461588cfcd3c0f7$var$convertToArrayPayload = function(value1) {
    return Array.isArray(value1) ? value1 : [
        value1
    ];
};
var $d461588cfcd3c0f7$var$shouldSubscribeByName = function(name, signalName, exact) {
    return exact && signalName ? name === signalName : !name || !signalName || name === signalName || $d461588cfcd3c0f7$var$convertToArrayPayload(name).some(function(currentName) {
        return currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName));
    });
};
function $d461588cfcd3c0f7$var$useSubscribe(props) {
    var _props = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useEffect(function() {
        var tearDown = function(subscription) {
            if (subscription) subscription.unsubscribe();
        };
        var subscription = !props.disabled && _props.current.subject.subscribe({
            next: _props.current.callback
        });
        return function() {
            return tearDown(subscription);
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $d461588cfcd3c0f7$export$606f11b2eb45ecc6(props) {
    var methods = $d461588cfcd3c0f7$export$4d957a5e1be13b03();
    var _ref = props || {}, _ref_control = _ref.control, control = _ref_control === void 0 ? methods.control : _ref_control, disabled = _ref.disabled, name = _ref.name, exact = _ref.exact;
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useState(control._formState), 2), formState = _React_useState[0], updateFormState = _React_useState[1];
    var _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    var _name = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef(name);
    var _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef(true);
    _name.current = name;
    var callback = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(function(value1) {
        return _mounted.current && $d461588cfcd3c0f7$var$shouldSubscribeByName(_name.current, value1.name, exact) && $d461588cfcd3c0f7$var$shouldRenderFormState(value1, _localProxyFormState.current) && updateFormState((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, control._formState, value1));
    }, [
        control,
        exact
    ]);
    $d461588cfcd3c0f7$var$useSubscribe({
        disabled: disabled,
        callback: callback,
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useEffect(function() {
        _mounted.current = true;
        return function() {
            _mounted.current = false;
        };
    }, []);
    return $d461588cfcd3c0f7$var$getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}
var $d461588cfcd3c0f7$var$isString = function(value1) {
    return typeof value1 === "string";
};
var $d461588cfcd3c0f7$var$generateWatchOutput = function(names, _names, formValues, isGlobal) {
    var isArray = Array.isArray(names);
    if ($d461588cfcd3c0f7$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $d461588cfcd3c0f7$export$3988ae62b71be9a3(formValues, names);
    }
    if (isArray) return names.map(function(fieldName) {
        return isGlobal && _names.watch.add(fieldName), $d461588cfcd3c0f7$export$3988ae62b71be9a3(formValues, fieldName);
    });
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $d461588cfcd3c0f7$var$isFunction = function(value1) {
    return typeof value1 === "function";
};
var $d461588cfcd3c0f7$var$objectHasFunction = function(data) {
    for(var key in data){
        if ($d461588cfcd3c0f7$var$isFunction(data[key])) return true;
    }
    return false;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $d461588cfcd3c0f7$export$3c773aa2b84f29e0(props) {
    var methods = $d461588cfcd3c0f7$export$4d957a5e1be13b03();
    var _ref = props || {}, _ref_control = _ref.control, control = _ref_control === void 0 ? methods.control : _ref_control, name = _ref.name, defaultValue = _ref.defaultValue, disabled = _ref.disabled, exact = _ref.exact;
    var _name = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef(name);
    _name.current = name;
    var callback = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(function(formState) {
        if ($d461588cfcd3c0f7$var$shouldSubscribeByName(_name.current, formState.name, exact)) {
            var fieldValues = $d461588cfcd3c0f7$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
            updateValue($d461588cfcd3c0f7$var$isUndefined(_name.current) || $d461588cfcd3c0f7$var$isObject(fieldValues) && !$d461588cfcd3c0f7$var$objectHasFunction(fieldValues) ? (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, fieldValues) : Array.isArray(fieldValues) ? (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(fieldValues) : $d461588cfcd3c0f7$var$isUndefined(fieldValues) ? defaultValue : fieldValues);
        }
    }, [
        control,
        exact,
        defaultValue
    ]);
    $d461588cfcd3c0f7$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.watch,
        callback: callback
    });
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useState($d461588cfcd3c0f7$var$isUndefined(defaultValue) ? control._getWatch(name) : defaultValue), 2), value1 = _React_useState[0], updateValue = _React_useState[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useEffect(function() {
        control._removeUnmounted();
    });
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $d461588cfcd3c0f7$export$e8c786024a2b0a79(props) {
    var methods = $d461588cfcd3c0f7$export$4d957a5e1be13b03();
    var name = props.name, _props_control = props.control, control = _props_control === void 0 ? methods.control : _props_control, shouldUnregister = props.shouldUnregister;
    var isArrayField = $d461588cfcd3c0f7$var$isNameInFieldArray(control._names.array, name);
    var value1 = $d461588cfcd3c0f7$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $d461588cfcd3c0f7$export$3988ae62b71be9a3(control._formValues, name, $d461588cfcd3c0f7$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    var formState = $d461588cfcd3c0f7$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    var _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef(control.register(name, (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, props.rules), {
        value: value1
    })));
    (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useEffect(function() {
        var updateMounted = function(name, value1) {
            var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        return function() {
            var _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField ? _shouldUnregisterField && !control._stateFlags.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    return {
        field: {
            name: name,
            value: value1,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(function(event) {
                _registerProps.current.onChange({
                    target: {
                        value: $d461588cfcd3c0f7$var$getEventValue(event),
                        name: name
                    },
                    type: $d461588cfcd3c0f7$var$EVENTS.CHANGE
                });
            }, [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(function() {
                _registerProps.current.onBlur({
                    target: {
                        value: $d461588cfcd3c0f7$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $d461588cfcd3c0f7$var$EVENTS.BLUR
                });
            }, [
                name,
                control
            ]),
            ref: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(function(elm) {
                var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(control._fields, name);
                if (elm && field && elm.focus) field._f.ref = {
                    focus: function() {
                        return elm.focus();
                    },
                    select: function() {
                        return elm.select();
                    },
                    setCustomValidity: function(message) {
                        return elm.setCustomValidity(message);
                    },
                    reportValidity: function() {
                        return elm.reportValidity();
                    }
                };
            }, [
                name,
                control._fields
            ])
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                get: function() {
                    return !!$d461588cfcd3c0f7$export$3988ae62b71be9a3(formState.errors, name);
                }
            },
            isDirty: {
                get: function() {
                    return !!$d461588cfcd3c0f7$export$3988ae62b71be9a3(formState.dirtyFields, name);
                }
            },
            isTouched: {
                get: function() {
                    return !!$d461588cfcd3c0f7$export$3988ae62b71be9a3(formState.touchedFields, name);
                }
            },
            error: {
                get: function() {
                    return $d461588cfcd3c0f7$export$3988ae62b71be9a3(formState.errors, name);
                }
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ var $d461588cfcd3c0f7$export$bd0bf19f25da8474 = function(props) {
    return props.render($d461588cfcd3c0f7$export$e8c786024a2b0a79(props));
};
var $d461588cfcd3c0f7$export$b196c2a4f765bd30 = function(name, validateAllFieldCriteria, errors, type, message) {
    return validateAllFieldCriteria ? (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, errors[name]), {
        types: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, errors[name] && errors[name].types ? errors[name].types : {}), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, type, message || true))
    }) : {};
};
var $d461588cfcd3c0f7$var$isKey = function(value1) {
    return /^\w*$/.test(value1);
};
var $d461588cfcd3c0f7$var$stringToPath = function(input) {
    return $d461588cfcd3c0f7$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
};
function $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(object, path, value1) {
    var index = -1;
    var tempPath = $d461588cfcd3c0f7$var$isKey(path) ? [
        path
    ] : $d461588cfcd3c0f7$var$stringToPath(path);
    var length = tempPath.length;
    var lastIndex = length - 1;
    while(++index < length){
        var key = tempPath[index];
        var newValue = value1;
        if (index !== lastIndex) {
            var objValue = object[key];
            newValue = $d461588cfcd3c0f7$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
var $d461588cfcd3c0f7$var$focusFieldBy = function(fields, callback, fieldsNames) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (fieldsNames || Object.keys(fields))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ref = _step.value;
            var key = _ref;
            var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(fields, key);
            if (field) {
                var _f = field._f, currentField = (0, $487369748a2c1c33$export$69fdd232f62cde60)(field, [
                    "_f"
                ]);
                if (_f && callback(_f.name)) {
                    if (_f.ref.focus && $d461588cfcd3c0f7$var$isUndefined(_f.ref.focus())) break;
                    else if (_f.refs) {
                        _f.refs[0].focus();
                        break;
                    }
                } else if ($d461588cfcd3c0f7$var$isObject(currentField)) $d461588cfcd3c0f7$var$focusFieldBy(currentField, callback);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var $d461588cfcd3c0f7$var$generateId = function() {
    var d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $d461588cfcd3c0f7$var$getFocusFieldName = function(name, index) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return options.shouldFocus || $d461588cfcd3c0f7$var$isUndefined(options.shouldFocus) ? options.focusName || "".concat(name, ".").concat($d461588cfcd3c0f7$var$isUndefined(options.focusIndex) ? index : options.focusIndex, ".") : "";
};
var $d461588cfcd3c0f7$var$isWatched = function(name, _names, isBlurEvent) {
    return !isBlurEvent && (_names.watchAll || _names.watch.has(name) || (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(_names.watch).some(function(watchName) {
        return name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length));
    }));
};
var $d461588cfcd3c0f7$var$updateFieldArrayRootError = function(errors, error, name) {
    var fieldArrayErrors = $d461588cfcd3c0f7$var$compact($d461588cfcd3c0f7$export$3988ae62b71be9a3(errors, name));
    $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $d461588cfcd3c0f7$var$isBoolean = function(value1) {
    return typeof value1 === "boolean";
};
var $d461588cfcd3c0f7$var$isFileInput = function(element) {
    return element.type === "file";
};
var $d461588cfcd3c0f7$var$isMessage = function(value1) {
    return $d461588cfcd3c0f7$var$isString(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).isValidElement(value1);
};
var $d461588cfcd3c0f7$var$isRadioInput = function(element) {
    return element.type === "radio";
};
var $d461588cfcd3c0f7$var$isRegex = function(value1) {
    return value1 instanceof RegExp;
};
var $d461588cfcd3c0f7$var$defaultResult = {
    value: false,
    isValid: false
};
var $d461588cfcd3c0f7$var$validResult = {
    value: true,
    isValid: true
};
var $d461588cfcd3c0f7$var$getCheckboxValue = function(options) {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            var values = options.filter(function(option) {
                return option && option.checked && !option.disabled;
            }).map(function(option) {
                return option.value;
            });
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$d461588cfcd3c0f7$var$isUndefined(options[0].attributes.value) ? $d461588cfcd3c0f7$var$isUndefined(options[0].value) || options[0].value === "" ? $d461588cfcd3c0f7$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $d461588cfcd3c0f7$var$validResult : $d461588cfcd3c0f7$var$defaultResult;
    }
    return $d461588cfcd3c0f7$var$defaultResult;
};
var $d461588cfcd3c0f7$var$defaultReturn = {
    isValid: false,
    value: null
};
var $d461588cfcd3c0f7$var$getRadioValue = function(options) {
    return Array.isArray(options) ? options.reduce(function(previous, option) {
        return option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous;
    }, $d461588cfcd3c0f7$var$defaultReturn) : $d461588cfcd3c0f7$var$defaultReturn;
};
function $d461588cfcd3c0f7$var$getValidateError(result, ref) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "validate";
    if ($d461588cfcd3c0f7$var$isMessage(result) || Array.isArray(result) && result.every($d461588cfcd3c0f7$var$isMessage) || $d461588cfcd3c0f7$var$isBoolean(result) && !result) return {
        type: type,
        message: $d461588cfcd3c0f7$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $d461588cfcd3c0f7$var$getValueAndMessage = function(validationData) {
    return $d461588cfcd3c0f7$var$isObject(validationData) && !$d461588cfcd3c0f7$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
};
var $d461588cfcd3c0f7$var$validateField = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) {
        var _field__f, ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, inputRef, setCustomValidity, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref, value1, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, maxLengthOutput, minLengthOutput, exceedMax1, exceedMin1, _getValueAndMessage, patternValue, message1, result, validateError, validationResult, _tmp, _tmp1, _i, key, validateError1;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _field__f = field._f, ref = _field__f.ref, refs = _field__f.refs, required = _field__f.required, maxLength = _field__f.maxLength, minLength = _field__f.minLength, min = _field__f.min, max = _field__f.max, pattern = _field__f.pattern, validate = _field__f.validate, name = _field__f.name, valueAsNumber = _field__f.valueAsNumber, mount = _field__f.mount, disabled = _field__f.disabled;
                    if (!mount || disabled) return [
                        2,
                        {}
                    ];
                    inputRef = refs ? refs[0] : ref;
                    setCustomValidity = function(message) {
                        if (shouldUseNativeValidation && inputRef.reportValidity) {
                            inputRef.setCustomValidity($d461588cfcd3c0f7$var$isBoolean(message) ? "" : message || " ");
                            inputRef.reportValidity();
                        }
                    };
                    error = {};
                    isRadio = $d461588cfcd3c0f7$var$isRadioInput(ref);
                    isCheckBox = $d461588cfcd3c0f7$var$isCheckBoxInput(ref);
                    isRadioOrCheckbox = isRadio || isCheckBox;
                    isEmpty = (valueAsNumber || $d461588cfcd3c0f7$var$isFileInput(ref)) && !ref.value || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
                    appendErrorsCurry = $d461588cfcd3c0f7$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
                    getMinMaxMessage = function(exceedMax, maxLengthMessage, minLengthMessage) {
                        var maxType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES.maxLength, minType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES.minLength;
                        var message = exceedMax ? maxLengthMessage : minLengthMessage;
                        error[name] = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                            type: exceedMax ? maxType : minType,
                            message: message,
                            ref: ref
                        }, appendErrorsCurry(exceedMax ? maxType : minType, message));
                    };
                    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $d461588cfcd3c0f7$var$isNullOrUndefined(inputValue)) || $d461588cfcd3c0f7$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$d461588cfcd3c0f7$var$getCheckboxValue(refs).isValid || isRadio && !$d461588cfcd3c0f7$var$getRadioValue(refs).isValid)) {
                        _ref = $d461588cfcd3c0f7$var$isMessage(required) ? {
                            value: !!required,
                            message: required
                        } : $d461588cfcd3c0f7$var$getValueAndMessage(required), value1 = _ref.value, message = _ref.message;
                        if (value1) {
                            error[name] = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                                type: $d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES.required,
                                message: message,
                                ref: inputRef
                            }, appendErrorsCurry($d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES.required, message));
                            if (!validateAllFieldCriteria) {
                                setCustomValidity(message);
                                return [
                                    2,
                                    error
                                ];
                            }
                        }
                    }
                    if (!isEmpty && (!$d461588cfcd3c0f7$var$isNullOrUndefined(min) || !$d461588cfcd3c0f7$var$isNullOrUndefined(max))) {
                        ;
                        ;
                        maxOutput = $d461588cfcd3c0f7$var$getValueAndMessage(max);
                        minOutput = $d461588cfcd3c0f7$var$getValueAndMessage(min);
                        if (!$d461588cfcd3c0f7$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
                            valueNumber = ref.valueAsNumber || +inputValue;
                            if (!$d461588cfcd3c0f7$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
                            if (!$d461588cfcd3c0f7$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
                        } else {
                            valueDate = ref.valueAsDate || new Date(inputValue);
                            if ($d461588cfcd3c0f7$var$isString(maxOutput.value)) exceedMax = valueDate > new Date(maxOutput.value);
                            if ($d461588cfcd3c0f7$var$isString(minOutput.value)) exceedMin = valueDate < new Date(minOutput.value);
                        }
                        if (exceedMax || exceedMin) {
                            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES.max, $d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES.min);
                            if (!validateAllFieldCriteria) {
                                setCustomValidity(error[name].message);
                                return [
                                    2,
                                    error
                                ];
                            }
                        }
                    }
                    if ((maxLength || minLength) && !isEmpty && ($d461588cfcd3c0f7$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
                        maxLengthOutput = $d461588cfcd3c0f7$var$getValueAndMessage(maxLength);
                        minLengthOutput = $d461588cfcd3c0f7$var$getValueAndMessage(minLength);
                        exceedMax1 = !$d461588cfcd3c0f7$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > maxLengthOutput.value;
                        exceedMin1 = !$d461588cfcd3c0f7$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < minLengthOutput.value;
                        if (exceedMax1 || exceedMin1) {
                            getMinMaxMessage(exceedMax1, maxLengthOutput.message, minLengthOutput.message);
                            if (!validateAllFieldCriteria) {
                                setCustomValidity(error[name].message);
                                return [
                                    2,
                                    error
                                ];
                            }
                        }
                    }
                    if (pattern && !isEmpty && $d461588cfcd3c0f7$var$isString(inputValue)) {
                        _getValueAndMessage = $d461588cfcd3c0f7$var$getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, message1 = _getValueAndMessage.message;
                        if ($d461588cfcd3c0f7$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
                            error[name] = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                                type: $d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES.pattern,
                                message: message1,
                                ref: ref
                            }, appendErrorsCurry($d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES.pattern, message1));
                            if (!validateAllFieldCriteria) {
                                setCustomValidity(message1);
                                return [
                                    2,
                                    error
                                ];
                            }
                        }
                    }
                    if (!validate) return [
                        3,
                        7
                    ];
                    if (!$d461588cfcd3c0f7$var$isFunction(validate)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        validate(inputValue)
                    ];
                case 1:
                    result = _state.sent();
                    validateError = $d461588cfcd3c0f7$var$getValidateError(result, inputRef);
                    if (validateError) {
                        error[name] = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, validateError, appendErrorsCurry($d461588cfcd3c0f7$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                        if (!validateAllFieldCriteria) {
                            setCustomValidity(validateError.message);
                            return [
                                2,
                                error
                            ];
                        }
                    }
                    return [
                        3,
                        7
                    ];
                case 2:
                    if (!$d461588cfcd3c0f7$var$isObject(validate)) return [
                        3,
                        7
                    ];
                    validationResult = {};
                    _tmp = [];
                    for(_tmp1 in validate)_tmp.push(_tmp1);
                    _i = 0;
                    _state.label = 3;
                case 3:
                    if (!(_i < _tmp.length)) return [
                        3,
                        6
                    ];
                    key = _tmp[_i];
                    if (!$d461588cfcd3c0f7$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        validate[key](inputValue)
                    ];
                case 4:
                    validateError1 = $d461588cfcd3c0f7$var$getValidateError.apply(void 0, [
                        _state.sent(),
                        inputRef,
                        key
                    ]);
                    if (validateError1) {
                        validationResult = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, validateError1, appendErrorsCurry(key, validateError1.message));
                        setCustomValidity(validateError1.message);
                        if (validateAllFieldCriteria) error[name] = validationResult;
                    }
                    _state.label = 5;
                case 5:
                    _i++;
                    return [
                        3,
                        3
                    ];
                case 6:
                    if (!$d461588cfcd3c0f7$var$isEmptyObject(validationResult)) {
                        error[name] = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                            ref: inputRef
                        }, validationResult);
                        if (!validateAllFieldCriteria) return [
                            2,
                            error
                        ];
                    }
                    _state.label = 7;
                case 7:
                    setCustomValidity(true);
                    return [
                        2,
                        error
                    ];
            }
        });
    });
    return function validateField(field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) {
        return _ref.apply(this, arguments);
    };
}();
function $d461588cfcd3c0f7$var$append(data, value1) {
    return (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(data).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)($d461588cfcd3c0f7$var$convertToArrayPayload(value1)));
}
var $d461588cfcd3c0f7$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $d461588cfcd3c0f7$var$cloneObject(data) {
    var copy;
    var isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($d461588cfcd3c0f7$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $d461588cfcd3c0f7$var$isObject(data))) {
        copy = isArray ? [] : {};
        for(var key in data){
            if ($d461588cfcd3c0f7$var$isFunction(data[key])) {
                copy = data;
                break;
            }
            copy[key] = $d461588cfcd3c0f7$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $d461588cfcd3c0f7$var$fillEmptyArray = function(value1) {
    return Array.isArray(value1) ? value1.map(function() {
        return undefined;
    }) : undefined;
};
var $d461588cfcd3c0f7$var$getValidationModes = function(mode) {
    return {
        isOnSubmit: !mode || mode === $d461588cfcd3c0f7$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $d461588cfcd3c0f7$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $d461588cfcd3c0f7$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $d461588cfcd3c0f7$var$VALIDATION_MODE.all,
        isOnTouch: mode === $d461588cfcd3c0f7$var$VALIDATION_MODE.onTouched
    };
};
function $d461588cfcd3c0f7$var$insert(data, index, value1) {
    return (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(data.slice(0, index)).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)($d461588cfcd3c0f7$var$convertToArrayPayload(value1)), (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(data.slice(index)));
}
var $d461588cfcd3c0f7$var$moveArrayAt = function(data, from, to) {
    if (!Array.isArray(data)) return [];
    if ($d461588cfcd3c0f7$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $d461588cfcd3c0f7$var$prepend(data, value1) {
    return (0, $15f021a0fca28358$export$1b5e630bc3aea29f)($d461588cfcd3c0f7$var$convertToArrayPayload(value1)).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)($d461588cfcd3c0f7$var$convertToArrayPayload(data)));
}
function $d461588cfcd3c0f7$var$removeAtIndexes(data, indexes) {
    var i = 0;
    var temp = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(data);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            temp.splice(index - i, 1);
            i++;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $d461588cfcd3c0f7$var$compact(temp).length ? temp : [];
}
var $d461588cfcd3c0f7$var$removeArrayAt = function(data, index) {
    return $d461588cfcd3c0f7$var$isUndefined(index) ? [] : $d461588cfcd3c0f7$var$removeAtIndexes(data, $d461588cfcd3c0f7$var$convertToArrayPayload(index).sort(function(a, b) {
        return a - b;
    }));
};
var $d461588cfcd3c0f7$var$swapArrayAt = function(data, indexA, indexB) {
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $d461588cfcd3c0f7$var$baseGet(object, updatePath) {
    var length = updatePath.slice(0, -1).length;
    var index = 0;
    while(index < length)object = $d461588cfcd3c0f7$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $d461588cfcd3c0f7$var$isEmptyArray(obj) {
    for(var key in obj){
        if (!$d461588cfcd3c0f7$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $d461588cfcd3c0f7$var$unset(object, path) {
    var updatePath = $d461588cfcd3c0f7$var$isKey(path) ? [
        path
    ] : $d461588cfcd3c0f7$var$stringToPath(path);
    var childObject = updatePath.length == 1 ? object : $d461588cfcd3c0f7$var$baseGet(object, updatePath);
    var key = updatePath[updatePath.length - 1];
    var previousObjRef;
    if (childObject) delete childObject[key];
    for(var k = 0; k < updatePath.slice(0, -1).length; k++){
        var index = -1;
        var objectRef = void 0;
        var currentPaths = updatePath.slice(0, -(k + 1));
        var currentPathsLength = currentPaths.length - 1;
        if (k > 0) previousObjRef = object;
        while(++index < currentPaths.length){
            var item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index && ($d461588cfcd3c0f7$var$isObject(objectRef) && $d461588cfcd3c0f7$var$isEmptyObject(objectRef) || Array.isArray(objectRef) && $d461588cfcd3c0f7$var$isEmptyArray(objectRef))) previousObjRef ? delete previousObjRef[item] : delete object[item];
            previousObjRef = objectRef;
        }
    }
    return object;
}
var $d461588cfcd3c0f7$var$updateAt = function(fieldValues, index, value1) {
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $d461588cfcd3c0f7$export$310131896651d559(props) {
    var methods = $d461588cfcd3c0f7$export$4d957a5e1be13b03();
    var _props_control = props.control, control = _props_control === void 0 ? methods.control : _props_control, name = props.name, _props_keyName = props.keyName, keyName = _props_keyName === void 0 ? "id" : _props_keyName, shouldUnregister = props.shouldUnregister;
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useState(control._getFieldArray(name)), 2), fields = _React_useState[0], setFields = _React_useState[1];
    var ids = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef(control._getFieldArray(name).map($d461588cfcd3c0f7$var$generateId));
    var _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef(fields);
    var _name = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef(name);
    var _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    var callback = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(function(param) {
        var values = param.values, fieldArrayName = param.name;
        if (fieldArrayName === _name.current || !fieldArrayName) {
            var fieldValues = $d461588cfcd3c0f7$export$3988ae62b71be9a3(values, _name.current, []);
            setFields(fieldValues);
            ids.current = fieldValues.map($d461588cfcd3c0f7$var$generateId);
        }
    }, []);
    $d461588cfcd3c0f7$var$useSubscribe({
        callback: callback,
        subject: control._subjects.array
    });
    var updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(function(updatedFieldArrayValues) {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    var append$1 = function(value1, options) {
        var appendValue = $d461588cfcd3c0f7$var$convertToArrayPayload($d461588cfcd3c0f7$var$cloneObject(value1));
        var updatedFieldArrayValues = $d461588cfcd3c0f7$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $d461588cfcd3c0f7$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $d461588cfcd3c0f7$var$append(ids.current, appendValue.map($d461588cfcd3c0f7$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $d461588cfcd3c0f7$var$append, {
            argA: $d461588cfcd3c0f7$var$fillEmptyArray(value1)
        });
    };
    var prepend$1 = function(value1, options) {
        var prependValue = $d461588cfcd3c0f7$var$convertToArrayPayload($d461588cfcd3c0f7$var$cloneObject(value1));
        var updatedFieldArrayValues = $d461588cfcd3c0f7$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $d461588cfcd3c0f7$var$getFocusFieldName(name, 0, options);
        ids.current = $d461588cfcd3c0f7$var$prepend(ids.current, prependValue.map($d461588cfcd3c0f7$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $d461588cfcd3c0f7$var$prepend, {
            argA: $d461588cfcd3c0f7$var$fillEmptyArray(value1)
        });
    };
    var remove = function(index) {
        var updatedFieldArrayValues = $d461588cfcd3c0f7$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $d461588cfcd3c0f7$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $d461588cfcd3c0f7$var$removeArrayAt, {
            argA: index
        });
    };
    var insert$1 = function(index, value1, options) {
        var insertValue = $d461588cfcd3c0f7$var$convertToArrayPayload($d461588cfcd3c0f7$var$cloneObject(value1));
        var updatedFieldArrayValues = $d461588cfcd3c0f7$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $d461588cfcd3c0f7$var$getFocusFieldName(name, index, options);
        ids.current = $d461588cfcd3c0f7$var$insert(ids.current, index, insertValue.map($d461588cfcd3c0f7$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $d461588cfcd3c0f7$var$insert, {
            argA: index,
            argB: $d461588cfcd3c0f7$var$fillEmptyArray(value1)
        });
    };
    var swap = function(indexA, indexB) {
        var updatedFieldArrayValues = control._getFieldArray(name);
        $d461588cfcd3c0f7$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $d461588cfcd3c0f7$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $d461588cfcd3c0f7$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    var move = function(from, to) {
        var updatedFieldArrayValues = control._getFieldArray(name);
        $d461588cfcd3c0f7$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $d461588cfcd3c0f7$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $d461588cfcd3c0f7$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    var update = function(index, value1) {
        var updateValue = $d461588cfcd3c0f7$var$cloneObject(value1);
        var updatedFieldArrayValues = $d461588cfcd3c0f7$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(updatedFieldArrayValues).map(function(item, i) {
            return !item || i === index ? $d461588cfcd3c0f7$var$generateId() : ids.current[i];
        });
        updateValues(updatedFieldArrayValues);
        setFields((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(updatedFieldArrayValues));
        control._updateFieldArray(name, updatedFieldArrayValues, $d461588cfcd3c0f7$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    var replace = function(value1) {
        var updatedFieldArrayValues = $d461588cfcd3c0f7$var$convertToArrayPayload($d461588cfcd3c0f7$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($d461588cfcd3c0f7$var$generateId);
        updateValues((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(updatedFieldArrayValues));
        setFields((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(updatedFieldArrayValues));
        control._updateFieldArray(name, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(updatedFieldArrayValues), function(data) {
            return data;
        }, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useEffect(function() {
        control._stateFlags.action = false;
        $d461588cfcd3c0f7$var$isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then(function(result) {
                var error = $d461588cfcd3c0f7$export$3988ae62b71be9a3(result.errors, name);
                var existingError = $d461588cfcd3c0f7$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type : error && error.type) {
                    error ? $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $d461588cfcd3c0f7$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(control._fields, name);
                var validationModeBeforeSubmit = $d461588cfcd3c0f7$var$getValidationModes(control._options.mode);
                if ((!validationModeBeforeSubmit.isOnSubmit || control._formState.isSubmitted) && field && field._f) $d461588cfcd3c0f7$var$validateField(field, $d461588cfcd3c0f7$export$3988ae62b71be9a3(control._formValues, name), control._options.criteriaMode === $d461588cfcd3c0f7$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then(function(error) {
                    return !$d461588cfcd3c0f7$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $d461588cfcd3c0f7$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    });
                });
            }
        }
        control._subjects.watch.next({
            name: name,
            values: control._formValues
        });
        control._names.focus && $d461588cfcd3c0f7$var$focusFieldBy(control._fields, function(key) {
            return key.startsWith(control._names.focus);
        });
        control._names.focus = "";
        control._proxyFormState.isValid && control._updateValid();
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useEffect(function() {
        !$d461588cfcd3c0f7$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return function() {
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useMemo(function() {
            return fields.map(function(field, index) {
                return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, field), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, keyName, ids.current[index] || $d461588cfcd3c0f7$var$generateId()));
            });
        }, [
            fields,
            keyName
        ])
    };
}
function $d461588cfcd3c0f7$var$createSubject() {
    var _observers = [];
    var next = function(value1) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _observers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var observer = _step.value;
                observer.next(value1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var subscribe = function(observer) {
        _observers.push(observer);
        return {
            unsubscribe: function() {
                _observers = _observers.filter(function(o) {
                    return o !== observer;
                });
            }
        };
    };
    var unsubscribe = function() {
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $d461588cfcd3c0f7$var$isPrimitive = function(value1) {
    return $d461588cfcd3c0f7$var$isNullOrUndefined(value1) || !$d461588cfcd3c0f7$var$isObjectType(value1);
};
function $d461588cfcd3c0f7$var$deepEqual(object1, object2) {
    if ($d461588cfcd3c0f7$var$isPrimitive(object1) || $d461588cfcd3c0f7$var$isPrimitive(object2)) return object1 === object2;
    if ($d461588cfcd3c0f7$var$isDateObject(object1) && $d461588cfcd3c0f7$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    var keys1 = Object.keys(object1);
    var keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var val1 = object1[key];
            if (!keys2.includes(key)) return false;
            if (key !== "ref") {
                var val2 = object2[key];
                if ($d461588cfcd3c0f7$var$isDateObject(val1) && $d461588cfcd3c0f7$var$isDateObject(val2) || $d461588cfcd3c0f7$var$isObject(val1) && $d461588cfcd3c0f7$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$d461588cfcd3c0f7$var$deepEqual(val1, val2) : val1 !== val2) return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
var $d461588cfcd3c0f7$var$isHTMLElement = function(value1) {
    var owner = value1 ? value1.ownerDocument : 0;
    var ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
    return value1 instanceof ElementClass;
};
var $d461588cfcd3c0f7$var$isMultipleSelect = function(element) {
    return element.type === "select-multiple";
};
var $d461588cfcd3c0f7$var$isRadioOrCheckbox = function(ref) {
    return $d461588cfcd3c0f7$var$isRadioInput(ref) || $d461588cfcd3c0f7$var$isCheckBoxInput(ref);
};
var $d461588cfcd3c0f7$var$live = function(ref) {
    return $d461588cfcd3c0f7$var$isHTMLElement(ref) && ref.isConnected;
};
function $d461588cfcd3c0f7$var$markFieldsDirty(data) {
    var fields = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var isParentNodeArray = Array.isArray(data);
    if ($d461588cfcd3c0f7$var$isObject(data) || isParentNodeArray) for(var key in data){
        if (Array.isArray(data[key]) || $d461588cfcd3c0f7$var$isObject(data[key]) && !$d461588cfcd3c0f7$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $d461588cfcd3c0f7$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$d461588cfcd3c0f7$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $d461588cfcd3c0f7$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    var isParentNodeArray = Array.isArray(data);
    if ($d461588cfcd3c0f7$var$isObject(data) || isParentNodeArray) {
        for(var key in data)if (Array.isArray(data[key]) || $d461588cfcd3c0f7$var$isObject(data[key]) && !$d461588cfcd3c0f7$var$objectHasFunction(data[key])) {
            if ($d461588cfcd3c0f7$var$isUndefined(formValues) || $d461588cfcd3c0f7$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $d461588cfcd3c0f7$var$markFieldsDirty(data[key], []) : (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $d461588cfcd3c0f7$var$markFieldsDirty(data[key]));
            else $d461588cfcd3c0f7$var$getDirtyFieldsFromDefaultValues(data[key], $d461588cfcd3c0f7$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$d461588cfcd3c0f7$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $d461588cfcd3c0f7$var$getDirtyFields = function(defaultValues, formValues) {
    return $d461588cfcd3c0f7$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $d461588cfcd3c0f7$var$markFieldsDirty(formValues));
};
var $d461588cfcd3c0f7$var$getFieldValueAs = function(value1, param) {
    var valueAsNumber = param.valueAsNumber, valueAsDate = param.valueAsDate, setValueAs = param.setValueAs;
    return $d461588cfcd3c0f7$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" || $d461588cfcd3c0f7$var$isNullOrUndefined(value1) ? NaN : +value1 : valueAsDate && $d461588cfcd3c0f7$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
};
function $d461588cfcd3c0f7$var$getFieldValue(_f) {
    var ref = _f.ref;
    if (_f.refs ? _f.refs.every(function(ref) {
        return ref.disabled;
    }) : ref.disabled) return;
    if ($d461588cfcd3c0f7$var$isFileInput(ref)) return ref.files;
    if ($d461588cfcd3c0f7$var$isRadioInput(ref)) return $d461588cfcd3c0f7$var$getRadioValue(_f.refs).value;
    if ($d461588cfcd3c0f7$var$isMultipleSelect(ref)) return (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(ref.selectedOptions).map(function(param) {
        var value1 = param.value;
        return value1;
    });
    if ($d461588cfcd3c0f7$var$isCheckBoxInput(ref)) return $d461588cfcd3c0f7$var$getCheckboxValue(_f.refs).value;
    return $d461588cfcd3c0f7$var$getFieldValueAs($d461588cfcd3c0f7$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $d461588cfcd3c0f7$var$getResolverOptions = function(fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) {
    var fields = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = fieldsNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name);
            field && $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(fields, name, field._f);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        criteriaMode: criteriaMode,
        names: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(fieldsNames),
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $d461588cfcd3c0f7$var$getRuleValue = function(rule) {
    return $d461588cfcd3c0f7$var$isUndefined(rule) ? undefined : $d461588cfcd3c0f7$var$isRegex(rule) ? rule.source : $d461588cfcd3c0f7$var$isObject(rule) ? $d461588cfcd3c0f7$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
};
var $d461588cfcd3c0f7$var$hasValidation = function(options) {
    return options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
};
function $d461588cfcd3c0f7$var$schemaErrorLookup(errors, _fields, name) {
    var error = $d461588cfcd3c0f7$export$3988ae62b71be9a3(errors, name);
    if (error || $d461588cfcd3c0f7$var$isKey(name)) return {
        error: error,
        name: name
    };
    var names = name.split(".");
    while(names.length){
        var fieldName = names.join(".");
        var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, fieldName);
        var foundError = $d461588cfcd3c0f7$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $d461588cfcd3c0f7$var$skipValidation = function(isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) {
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $d461588cfcd3c0f7$var$unsetEmptyArray = function(ref, name) {
    return !$d461588cfcd3c0f7$var$compact($d461588cfcd3c0f7$export$3988ae62b71be9a3(ref, name)).length && $d461588cfcd3c0f7$var$unset(ref, name);
};
var $d461588cfcd3c0f7$var$defaultOptions = {
    mode: $d461588cfcd3c0f7$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $d461588cfcd3c0f7$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $d461588cfcd3c0f7$var$createFormControl() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $d461588cfcd3c0f7$var$defaultOptions, props);
    var _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {}
    };
    var _fields = {};
    var _defaultValues = $d461588cfcd3c0f7$var$cloneObject(_options.defaultValues) || {};
    var _formValues = _options.shouldUnregister ? {} : $d461588cfcd3c0f7$var$cloneObject(_defaultValues);
    var _stateFlags = {
        action: false,
        mount: false,
        watch: false
    };
    var _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    var delayErrorCallback;
    var timer = 0;
    var validateFields = {};
    var _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    var _subjects = {
        watch: $d461588cfcd3c0f7$var$createSubject(),
        array: $d461588cfcd3c0f7$var$createSubject(),
        state: $d461588cfcd3c0f7$var$createSubject()
    };
    var validationModeBeforeSubmit = $d461588cfcd3c0f7$var$getValidationModes(_options.mode);
    var validationModeAfterSubmit = $d461588cfcd3c0f7$var$getValidationModes(_options.reValidateMode);
    var shouldDisplayAllAssociatedErrors = _options.criteriaMode === $d461588cfcd3c0f7$var$VALIDATION_MODE.all;
    var debounce = function(callback) {
        return function(wait) {
            clearTimeout(timer);
            timer = window.setTimeout(callback, wait);
        };
    };
    var _updateValid = function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(shouldSkipRender) {
            var isValid, _tmp;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isValid = false;
                        if (!_proxyFormState.isValid) return [
                            3,
                            5
                        ];
                        if (!_options.resolver) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _executeSchema()
                        ];
                    case 1:
                        _tmp = $d461588cfcd3c0f7$var$isEmptyObject.apply(void 0, [
                            _state.sent().errors
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            executeBuiltInValidation(_fields, true)
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        isValid = _tmp;
                        if (!shouldSkipRender && isValid !== _formState.isValid) {
                            _formState.isValid = isValid;
                            _subjects.state.next({
                                isValid: isValid
                            });
                        }
                        _state.label = 5;
                    case 5:
                        return [
                            2,
                            isValid
                        ];
                }
            });
        });
        return function _updateValid(shouldSkipRender) {
            return _ref.apply(this, arguments);
        };
    }();
    var _updateFieldArray = function(name) {
        var values = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], method = arguments.length > 2 ? arguments[2] : void 0, args = arguments.length > 3 ? arguments[3] : void 0, shouldSetValues = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, shouldUpdateFieldsAndState = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true;
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name))) {
                var fieldValues = method($d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (_proxyFormState.errors && shouldUpdateFieldsAndState && Array.isArray($d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.errors, name))) {
                var errors = method($d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $d461588cfcd3c0f7$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                var touchedFields = method($d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $d461588cfcd3c0f7$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    var updateErrors = function(name, error) {
        $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    var updateValidAndValue = function(name, shouldSkipSetValueAs, value1, ref) {
        var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            var defaultValue = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formValues, name, $d461588cfcd3c0f7$var$isUndefined(value1) ? $d461588cfcd3c0f7$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $d461588cfcd3c0f7$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $d461588cfcd3c0f7$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    var updateTouchAndDirty = function(name, fieldValue, isBlurEvent, shouldDirty, shouldRender) {
        var isFieldDirty = false;
        var output = {
            name: name
        };
        var isPreviousFieldTouched = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.touchedFields, name);
        if (_proxyFormState.isDirty) {
            var isPreviousFormDirty = _formState.isDirty;
            _formState.isDirty = output.isDirty = _getDirty();
            isFieldDirty = isPreviousFormDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
            var isPreviousFieldDirty = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            var isCurrentFieldPristine = $d461588cfcd3c0f7$var$deepEqual($d461588cfcd3c0f7$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isCurrentFieldPristine ? $d461588cfcd3c0f7$var$unset(_formState.dirtyFields, name) : $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            isFieldDirty = isFieldDirty || isPreviousFieldDirty !== $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.dirtyFields, name);
        }
        if (isBlurEvent && !isPreviousFieldTouched) {
            $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
            output.touchedFields = _formState.touchedFields;
            isFieldDirty = isFieldDirty || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
        }
        isFieldDirty && shouldRender && _subjects.state.next(output);
        return isFieldDirty ? output : {};
    };
    var shouldRenderByError = function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(name, isValid, error, fieldState) {
            var previousFieldError, shouldUpdateValid, updatedFormState;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                previousFieldError = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.errors, name);
                shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
                if (props.delayError && error) {
                    delayErrorCallback = debounce(function() {
                        return updateErrors(name, error);
                    });
                    delayErrorCallback(props.delayError);
                } else {
                    clearTimeout(timer);
                    delayErrorCallback = null;
                    error ? $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $d461588cfcd3c0f7$var$unset(_formState.errors, name);
                }
                if ((error ? !$d461588cfcd3c0f7$var$deepEqual(previousFieldError, error) : previousFieldError) || !$d461588cfcd3c0f7$var$isEmptyObject(fieldState) || shouldUpdateValid) {
                    updatedFormState = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, fieldState, shouldUpdateValid ? {
                        isValid: isValid
                    } : {}), {
                        errors: _formState.errors,
                        name: name
                    });
                    _formState = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _formState, updatedFormState);
                    _subjects.state.next(updatedFormState);
                }
                validateFields[name]--;
                if (_proxyFormState.isValidating && !Object.values(validateFields).some(function(v) {
                    return v;
                })) {
                    _subjects.state.next({
                        isValidating: false
                    });
                    validateFields = {};
                }
                return [
                    2
                ];
            });
        });
        return function shouldRenderByError(name, isValid, error, fieldState) {
            return _ref.apply(this, arguments);
        };
    }();
    var _executeSchema = function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(name) {
            var _tmp;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_options.resolver) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _options.resolver((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _formValues), _options.context, $d461588cfcd3c0f7$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation))
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = {};
                        _state.label = 3;
                    case 3:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        });
        return function _executeSchema(name) {
            return _ref.apply(this, arguments);
        };
    }();
    var executeSchemaAndUpdateState = function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(names) {
            var errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, name, error;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _executeSchema()
                        ];
                    case 1:
                        errors = _state.sent().errors;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (names) try {
                            for(_iterator = names[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                name = _step.value;
                                error = $d461588cfcd3c0f7$export$3988ae62b71be9a3(errors, name);
                                error ? $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $d461588cfcd3c0f7$var$unset(_formState.errors, name);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        else _formState.errors = errors;
                        return [
                            2,
                            errors
                        ];
                }
            });
        });
        return function executeSchemaAndUpdateState(names) {
            return _ref.apply(this, arguments);
        };
    }();
    var executeBuiltInValidation = function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(fields, shouldOnlyCheckValid) {
            var context, _tmp, _tmp1, _i, _ref, name, field, _f, fieldValue, isFieldArrayRoot, fieldError, _tmp2;
            var _arguments = arguments;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        context = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {
                            valid: true
                        };
                        _tmp = [];
                        for(_tmp1 in fields)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            7
                        ];
                        _ref = _tmp[_i];
                        name = _ref;
                        field = fields[name];
                        if (!field) return [
                            3,
                            6
                        ];
                        _f = field._f, fieldValue = (0, $487369748a2c1c33$export$69fdd232f62cde60)(field, [
                            "_f"
                        ]);
                        if (!_f) return [
                            3,
                            3
                        ];
                        isFieldArrayRoot = _names.array.has(_f.name);
                        return [
                            4,
                            $d461588cfcd3c0f7$var$validateField(field, $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formValues, _f.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot)
                        ];
                    case 2:
                        fieldError = _state.sent();
                        if (fieldError[_f.name]) {
                            context.valid = false;
                            if (shouldOnlyCheckValid) return [
                                3,
                                7
                            ];
                        }
                        !shouldOnlyCheckValid && ($d461588cfcd3c0f7$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $d461588cfcd3c0f7$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $d461588cfcd3c0f7$var$unset(_formState.errors, _f.name));
                        _state.label = 3;
                    case 3:
                        _tmp2 = fieldValue;
                        if (!_tmp2) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context)
                        ];
                    case 4:
                        _tmp2 = _state.sent();
                        _state.label = 5;
                    case 5:
                        _tmp2;
                        _state.label = 6;
                    case 6:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 7:
                        return [
                            2,
                            context.valid
                        ];
                }
            });
        });
        return function executeBuiltInValidation(fields, shouldOnlyCheckValid) {
            return _ref.apply(this, arguments);
        };
    }();
    var _removeUnmounted = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _names.unMount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name);
                field && (field._f.refs ? field._f.refs.every(function(ref) {
                    return !$d461588cfcd3c0f7$var$live(ref);
                }) : !$d461588cfcd3c0f7$var$live(field._f.ref)) && unregister(name);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _names.unMount = new Set();
    };
    var _getDirty = function(name, data) {
        return name && data && $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formValues, name, data), !$d461588cfcd3c0f7$var$deepEqual(getValues(), _defaultValues);
    };
    var _getWatch = function(names, defaultValue, isGlobal) {
        var fieldValues = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _stateFlags.mount ? _formValues : $d461588cfcd3c0f7$var$isUndefined(defaultValue) ? _defaultValues : $d461588cfcd3c0f7$var$isString(names) ? (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, names, defaultValue) : defaultValue);
        return $d461588cfcd3c0f7$var$generateWatchOutput(names, _names, fieldValues, isGlobal);
    };
    var _getFieldArray = function(name) {
        return $d461588cfcd3c0f7$var$compact($d461588cfcd3c0f7$export$3988ae62b71be9a3(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $d461588cfcd3c0f7$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    };
    var setFieldValue = function(name, value1) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name);
        var fieldValue = value1;
        if (field) {
            var fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formValues, name, $d461588cfcd3c0f7$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $d461588cfcd3c0f7$var$isWeb && $d461588cfcd3c0f7$var$isHTMLElement(fieldReference.ref) && $d461588cfcd3c0f7$var$isNullOrUndefined(value1) ? "" : value1;
                if ($d461588cfcd3c0f7$var$isMultipleSelect(fieldReference.ref)) (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(fieldReference.ref.options).forEach(function(selectRef) {
                    return selectRef.selected = fieldValue.includes(selectRef.value);
                });
                else if (fieldReference.refs) {
                    if ($d461588cfcd3c0f7$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach(function(checkboxRef) {
                        return !checkboxRef.disabled && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find(function(data) {
                            return data === checkboxRef.value;
                        }) : fieldValue === checkboxRef.value);
                    }) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach(function(radioRef) {
                        return radioRef.checked = radioRef.value === fieldValue;
                    });
                } else if ($d461588cfcd3c0f7$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.watch.next({
                        name: name
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    var setValues = function(name, value1, options) {
        for(var fieldKey in value1){
            var fieldValue = value1[fieldKey];
            var fieldName = "".concat(name, ".").concat(fieldKey);
            var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$d461588cfcd3c0f7$var$isPrimitive(fieldValue) || field && !field._f) && !$d461588cfcd3c0f7$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    var setValue = function(name, value1) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name);
        var isFieldArray = _names.array.has(name);
        var cloneValue = $d461588cfcd3c0f7$var$cloneObject(value1);
        $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: _formValues
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
                _formState.dirtyFields = $d461588cfcd3c0f7$var$getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name: name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue)
                });
            }
        } else field && !field._f && !$d461588cfcd3c0f7$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $d461588cfcd3c0f7$var$isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name: name
        });
    };
    var onChange = function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
            var target, name, field, error, isValid, fieldValue, isBlurEvent, shouldSkipValidation, watched, fieldState, shouldRender, errors, previousErrorLookupResult, errorLookupResult;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = event.target;
                        name = target.name;
                        field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name);
                        if (!field) return [
                            3,
                            6
                        ];
                        fieldValue = target.type ? $d461588cfcd3c0f7$var$getFieldValue(field._f) : $d461588cfcd3c0f7$var$getEventValue(event);
                        isBlurEvent = event.type === $d461588cfcd3c0f7$var$EVENTS.BLUR || event.type === $d461588cfcd3c0f7$var$EVENTS.FOCUS_OUT;
                        shouldSkipValidation = !$d461588cfcd3c0f7$var$hasValidation(field._f) && !_options.resolver && !$d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $d461588cfcd3c0f7$var$skipValidation(isBlurEvent, $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
                        watched = $d461588cfcd3c0f7$var$isWatched(name, _names, isBlurEvent);
                        $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
                        if (isBlurEvent) {
                            field._f.onBlur && field._f.onBlur(event);
                            delayErrorCallback && delayErrorCallback(0);
                        } else if (field._f.onChange) field._f.onChange(event);
                        fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
                        shouldRender = !$d461588cfcd3c0f7$var$isEmptyObject(fieldState) || watched;
                        !isBlurEvent && _subjects.watch.next({
                            name: name,
                            type: event.type
                        });
                        if (shouldSkipValidation) return [
                            2,
                            shouldRender && _subjects.state.next((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                                name: name
                            }, watched ? {} : fieldState))
                        ];
                        !isBlurEvent && watched && _subjects.state.next({});
                        validateFields[name] = validateFields[name] ? 1 : 1;
                        _subjects.state.next({
                            isValidating: true
                        });
                        if (!_options.resolver) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _executeSchema([
                                name
                            ])
                        ];
                    case 1:
                        errors = _state.sent().errors;
                        previousErrorLookupResult = $d461588cfcd3c0f7$var$schemaErrorLookup(_formState.errors, _fields, name);
                        errorLookupResult = $d461588cfcd3c0f7$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                        error = errorLookupResult.error;
                        name = errorLookupResult.name;
                        isValid = $d461588cfcd3c0f7$var$isEmptyObject(errors);
                        return [
                            3,
                            5
                        ];
                    case 2:
                        return [
                            4,
                            $d461588cfcd3c0f7$var$validateField(field, $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation)
                        ];
                    case 3:
                        error = _state.sent()[name];
                        return [
                            4,
                            _updateValid(true)
                        ];
                    case 4:
                        isValid = _state.sent();
                        _state.label = 5;
                    case 5:
                        field._f.deps && trigger(field._f.deps);
                        shouldRenderByError(name, isValid, error, fieldState);
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var trigger = function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(name) {
            var options, isValid, validationResult, fieldNames, errors;
            var _arguments = arguments;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        fieldNames = $d461588cfcd3c0f7$var$convertToArrayPayload(name);
                        _subjects.state.next({
                            isValidating: true
                        });
                        if (!_options.resolver) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            executeSchemaAndUpdateState($d461588cfcd3c0f7$var$isUndefined(name) ? name : fieldNames)
                        ];
                    case 1:
                        errors = _state.sent();
                        isValid = $d461588cfcd3c0f7$var$isEmptyObject(errors);
                        validationResult = name ? !fieldNames.some(function(name) {
                            return $d461588cfcd3c0f7$export$3988ae62b71be9a3(errors, name);
                        }) : isValid;
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!name) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            Promise.all(fieldNames.map(function() {
                                var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(fieldName) {
                                    var field;
                                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, fieldName);
                                                return [
                                                    4,
                                                    executeBuiltInValidation(field && field._f ? (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, fieldName, field) : field)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                });
                                return function(fieldName) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 3:
                        validationResult = _state.sent().every(Boolean);
                        !(!validationResult && !_formState.isValid) && _updateValid();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            executeBuiltInValidation(_fields)
                        ];
                    case 5:
                        validationResult = isValid = _state.sent();
                        _state.label = 6;
                    case 6:
                        _subjects.state.next((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, !$d461588cfcd3c0f7$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                            name: name
                        }, _options.resolver ? {
                            isValid: isValid
                        } : {}), {
                            errors: _formState.errors,
                            isValidating: false
                        }));
                        options.shouldFocus && !validationResult && $d461588cfcd3c0f7$var$focusFieldBy(_fields, function(key) {
                            return $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.errors, key);
                        }, name ? fieldNames : _names.mount);
                        return [
                            2,
                            validationResult
                        ];
                }
            });
        });
        return function trigger(name) {
            return _ref.apply(this, arguments);
        };
    }();
    var getValues = function(fieldNames) {
        var values = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _defaultValues, _stateFlags.mount ? _formValues : {});
        return $d461588cfcd3c0f7$var$isUndefined(fieldNames) ? values : $d461588cfcd3c0f7$var$isString(fieldNames) ? $d461588cfcd3c0f7$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map(function(name) {
            return $d461588cfcd3c0f7$export$3988ae62b71be9a3(values, name);
        });
    };
    var getFieldState = function(name, formState) {
        return {
            invalid: !!$d461588cfcd3c0f7$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$d461588cfcd3c0f7$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$d461588cfcd3c0f7$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $d461588cfcd3c0f7$export$3988ae62b71be9a3((formState || _formState).errors, name)
        };
    };
    var clearErrors = function(name) {
        name ? $d461588cfcd3c0f7$var$convertToArrayPayload(name).forEach(function(inputName) {
            return $d461588cfcd3c0f7$var$unset(_formState.errors, inputName);
        }) : _formState.errors = {};
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    var setError = function(name, error, options) {
        var ref = ($d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formState.errors, name, (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, error), {
            ref: ref
        }));
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    var watch = function(name, defaultValue) {
        return $d461588cfcd3c0f7$var$isFunction(name) ? _subjects.watch.subscribe({
            next: function(info) {
                return name(_getWatch(undefined, defaultValue), info);
            }
        }) : _getWatch(name, defaultValue, true);
    };
    var unregister = function(name) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (name ? $d461588cfcd3c0f7$var$convertToArrayPayload(name) : _names.mount)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fieldName = _step.value;
                _names.mount.delete(fieldName);
                _names.array.delete(fieldName);
                if ($d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, fieldName)) {
                    if (!options.keepValue) {
                        $d461588cfcd3c0f7$var$unset(_fields, fieldName);
                        $d461588cfcd3c0f7$var$unset(_formValues, fieldName);
                    }
                    !options.keepError && $d461588cfcd3c0f7$var$unset(_formState.errors, fieldName);
                    !options.keepDirty && $d461588cfcd3c0f7$var$unset(_formState.dirtyFields, fieldName);
                    !options.keepTouched && $d461588cfcd3c0f7$var$unset(_formState.touchedFields, fieldName);
                    !_options.shouldUnregister && !options.keepDefaultValue && $d461588cfcd3c0f7$var$unset(_defaultValues, fieldName);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _subjects.watch.next({});
        _subjects.state.next((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _formState, !options.keepDirty ? {} : {
            isDirty: _getDirty()
        }));
        !options.keepIsValid && _updateValid();
    };
    var register = function(name) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name);
        var disabledIsDefined = $d461588cfcd3c0f7$var$isBoolean(options.disabled);
        $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_fields, name, {
            _f: (0, $79de63f6394f39c4$export$581ff339ea0ba762)((0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, field && field._f ? field._f : {
                ref: {
                    name: name
                }
            }), {
                name: name,
                mount: true
            }), options)
        });
        _names.mount.add(name);
        field ? disabledIsDefined && $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_formValues, name, options.disabled ? undefined : $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formValues, name, $d461588cfcd3c0f7$var$getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
        return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, disabledIsDefined ? {
            disabled: options.disabled
        } : {}, _options.shouldUseNativeValidation ? {
            required: !!options.required,
            min: $d461588cfcd3c0f7$var$getRuleValue(options.min),
            max: $d461588cfcd3c0f7$var$getRuleValue(options.max),
            minLength: $d461588cfcd3c0f7$var$getRuleValue(options.minLength),
            maxLength: $d461588cfcd3c0f7$var$getRuleValue(options.maxLength),
            pattern: $d461588cfcd3c0f7$var$getRuleValue(options.pattern)
        } : {}), {
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: function(ref) {
                if (ref) {
                    register(name, options);
                    field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name);
                    var fieldRef = $d461588cfcd3c0f7$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    var radioOrCheckbox = $d461588cfcd3c0f7$var$isRadioOrCheckbox(fieldRef);
                    var refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find(function(option) {
                        return option === fieldRef;
                    }) : fieldRef === field._f.ref) return;
                    $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, field._f, radioOrCheckbox ? {
                            refs: (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(refs.filter($d461588cfcd3c0f7$var$live)).concat([
                                fieldRef
                            ], (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(!!Array.isArray($d461588cfcd3c0f7$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                {}
                            ] : [])),
                            ref: {
                                type: fieldRef.type,
                                name: name
                            }
                        } : {
                            ref: fieldRef
                        })
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($d461588cfcd3c0f7$var$isNameInFieldArray(_names.array, name) && _stateFlags.action) && _names.unMount.add(name);
                }
            }
        });
    };
    var handleSubmit = function(onValid, onInvalid) {
        return function() {
            var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(e) {
                var hasNoPromiseError, fieldValues, _ref, errors, values, err;
                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (e) {
                                e.preventDefault && e.preventDefault();
                                e.persist && e.persist();
                            }
                            hasNoPromiseError = true;
                            fieldValues = $d461588cfcd3c0f7$var$cloneObject(_formValues);
                            _subjects.state.next({
                                isSubmitting: true
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                11,
                                12,
                                13
                            ]);
                            if (!_options.resolver) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                _executeSchema()
                            ];
                        case 2:
                            _ref = _state.sent(), errors = _ref.errors, values = _ref.values;
                            _formState.errors = errors;
                            fieldValues = values;
                            return [
                                3,
                                5
                            ];
                        case 3:
                            return [
                                4,
                                executeBuiltInValidation(_fields)
                            ];
                        case 4:
                            _state.sent();
                            _state.label = 5;
                        case 5:
                            if (!$d461588cfcd3c0f7$var$isEmptyObject(_formState.errors)) return [
                                3,
                                7
                            ];
                            _subjects.state.next({
                                errors: {},
                                isSubmitting: true
                            });
                            return [
                                4,
                                onValid(fieldValues, e)
                            ];
                        case 6:
                            _state.sent();
                            return [
                                3,
                                10
                            ];
                        case 7:
                            if (!onInvalid) return [
                                3,
                                9
                            ];
                            return [
                                4,
                                onInvalid((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _formState.errors), e)
                            ];
                        case 8:
                            _state.sent();
                            _state.label = 9;
                        case 9:
                            _options.shouldFocusError && $d461588cfcd3c0f7$var$focusFieldBy(_fields, function(key) {
                                return $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.errors, key);
                            }, _names.mount);
                            _state.label = 10;
                        case 10:
                            return [
                                3,
                                13
                            ];
                        case 11:
                            err = _state.sent();
                            hasNoPromiseError = false;
                            throw err;
                        case 12:
                            _formState.isSubmitted = true;
                            _subjects.state.next({
                                isSubmitted: true,
                                isSubmitting: false,
                                isSubmitSuccessful: $d461588cfcd3c0f7$var$isEmptyObject(_formState.errors) && hasNoPromiseError,
                                submitCount: _formState.submitCount + 1,
                                errors: _formState.errors
                            });
                            return [
                                7
                            ];
                        case 13:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }();
    };
    var resetField = function(name) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if ($d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name)) {
            if ($d461588cfcd3c0f7$var$isUndefined(options.defaultValue)) setValue(name, $d461588cfcd3c0f7$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $d461588cfcd3c0f7$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $d461588cfcd3c0f7$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $d461588cfcd3c0f7$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $d461588cfcd3c0f7$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _formState));
        }
    };
    var reset = function(formValues) {
        var keepStateOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var updatedValues = formValues || _defaultValues;
        var cloneUpdatedValues = $d461588cfcd3c0f7$var$cloneObject(updatedValues);
        var values = formValues && !$d461588cfcd3c0f7$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (keepStateOptions.keepDirtyValues) try {
                for(var _iterator = _names.mount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var fieldName = _step.value;
                    $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $d461588cfcd3c0f7$export$adaa4cf7ef1b65be(values, fieldName, $d461588cfcd3c0f7$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $d461588cfcd3c0f7$export$3988ae62b71be9a3(values, fieldName));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if ($d461588cfcd3c0f7$var$isWeb && $d461588cfcd3c0f7$var$isUndefined(formValues)) try {
                    for(var _iterator1 = _names.mount[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var name = _step1.value;
                        var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name);
                        if (field && field._f) {
                            var fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                            try {
                                if ($d461588cfcd3c0f7$var$isHTMLElement(fieldReference)) {
                                    fieldReference.closest("form").reset();
                                    break;
                                }
                            } catch (_a) {}
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $d461588cfcd3c0f7$var$cloneObject(_defaultValues) : {} : cloneUpdatedValues;
            _subjects.array.next({
                values: values
            });
            _subjects.watch.next({
                values: values
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _stateFlags.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$d461588cfcd3c0f7$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $d461588cfcd3c0f7$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    var setFocus = function(name) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var field = $d461588cfcd3c0f7$export$3988ae62b71be9a3(_fields, name)._f;
        var fieldRef = field.refs ? field.refs[0] : field.ref;
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
    };
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _getFieldArray: _getFieldArray,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _stateFlags () {
                return _stateFlags;
            },
            set _stateFlags (value){
                _stateFlags = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, _options, value);
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $d461588cfcd3c0f7$export$87c0cf8eb5a167e0() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useRef();
    var _React_useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {}
    }), 2), formState = _React_useState[0], updateFormState = _React_useState[1];
    if (_formControl.current) _formControl.current.control._options = props;
    else _formControl.current = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $d461588cfcd3c0f7$var$createFormControl(props)), {
        formState: formState
    });
    var control = _formControl.current.control;
    var callback = (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useCallback(function(value1) {
        if ($d461588cfcd3c0f7$var$shouldRenderFormState(value1, control._proxyFormState, true)) {
            control._formState = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, control._formState, value1);
            updateFormState((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, control._formState));
        }
    }, [
        control
    ]);
    $d461588cfcd3c0f7$var$useSubscribe({
        subject: control._subjects.state,
        callback: callback
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kVN77))).useEffect(function() {
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $d461588cfcd3c0f7$var$getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
}








var $f4ab752c25625227$export$a3bc9b8ed74fc;
$f4ab752c25625227$export$a3bc9b8ed74fc = "_55yO2a_error";


var $0bfe97723266c272$var$ErrorMessage = function(param) {
    var error = param.error, className = param.className, children = param.children;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)(undefined, {
        keyPrefix: "error"
    }).t;
    var getMessage = function() {
        if (!error) return children;
        if (typeof error === "string") return t(error);
        return t(error.code, (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, error.data));
    };
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        role: "alert",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($f4ab752c25625227$export$a3bc9b8ed74fc, className),
        children: getMessage()
    });
};
var $0bfe97723266c272$export$2e2bcd8739ae039 = $0bfe97723266c272$var$ErrorMessage;








var $kVN77 = parcelRequire("kVN77");

var $e4af8d821435a6d7$export$7c4df8d735fa2705;
var $e4af8d821435a6d7$export$493b5823483d2c4e;
var $e4af8d821435a6d7$export$6f2f4d5c38fc8e55;
var $e4af8d821435a6d7$export$f2996ff41e4216ef;
var $e4af8d821435a6d7$export$559d1204393b53b9;
$e4af8d821435a6d7$export$7c4df8d735fa2705 = "jUeeQa_danger";
$e4af8d821435a6d7$export$493b5823483d2c4e = "jUeeQa_errorMessage";
$e4af8d821435a6d7$export$6f2f4d5c38fc8e55 = "jUeeQa_inputField";
$e4af8d821435a6d7$export$f2996ff41e4216ef = "jUeeQa_isSuffixFocusVisible";
$e4af8d821435a6d7$export$559d1204393b53b9 = "jUeeQa_suffix";


var $c6a92419d85488b3$var$InputField = function(_param, reference) {
    var className = _param.className, errorMessage = _param.errorMessage, isDanger = _param.isDanger, prefix = _param.prefix, suffix = _param.suffix, isSuffixFocusVisible = _param.isSuffixFocusVisible, props = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_param, [
        "className",
        "errorMessage",
        "isDanger",
        "prefix",
        "suffix",
        "isSuffixFocusVisible"
    ]);
    var errorMessages = errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.split("\n");
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($e4af8d821435a6d7$export$6f2f4d5c38fc8e55, isDanger && $e4af8d821435a6d7$export$7c4df8d735fa2705, isSuffixFocusVisible && $e4af8d821435a6d7$export$f2996ff41e4216ef),
                children: [
                    prefix,
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, props), {
                        ref: reference
                    })),
                    suffix && /*#__PURE__*/ (0, $kVN77.cloneElement)(suffix, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))([
                            suffix.props.className,
                            $e4af8d821435a6d7$export$559d1204393b53b9
                        ])
                    })
                ]
            }),
            errorMessages && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $e4af8d821435a6d7$export$493b5823483d2c4e,
                children: errorMessages.length > 1 ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("ul", {
                    children: errorMessages.map(function(message) {
                        return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("li", {
                            children: message
                        }, message);
                    })
                }) : errorMessages[0]
            })
        ]
    });
};
var $c6a92419d85488b3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kVN77.forwardRef)($c6a92419d85488b3$var$InputField);







var $kVN77 = parcelRequire("kVN77");



parcelRequire("kVN77");
var $a6698ddc47c4f539$var$SvgPasswordHideIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.929 3.929a1 1 0 0 0 0 1.414L6.505 6.92C3.791 8.797 2 11.452 2 12c0 .866 4.477 7 10 7 1.82 0 3.526-.666 4.996-1.59l.66.661a1 1 0 0 0 1.415-1.414L6.343 3.929a1 1 0 0 0-1.414 0Zm9.685 11.099L8.972 9.386a4 4 0 0 0 5.642 5.642Zm-1.057-6.714a4.014 4.014 0 0 1 2.129 2.13l4.39 4.389C21.285 13.533 22 12.346 22 12c0-.866-4.477-7-10-7-.542 0-1.073.059-1.591.166l3.148 3.148Z",
            fill: "currentcolor"
        })
    }));
};
var $a6698ddc47c4f539$export$2e2bcd8739ae039 = $a6698ddc47c4f539$var$SvgPasswordHideIcon;





parcelRequire("kVN77");
var $3f88812fd907fac1$var$SvgPasswordShowIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12c0 .866-4.477 7-10 7S2 12.866 2 12c0-.866 4.477-7 10-7s10 6.134 10 7Zm-6 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            fill: "currentcolor"
        })
    }));
};
var $3f88812fd907fac1$export$2e2bcd8739ae039 = $3f88812fd907fac1$var$SvgPasswordShowIcon;





var $kVN77 = parcelRequire("kVN77");
var $408fb6b023ab814b$var$useToggle = function() {
    var defaultValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(defaultValue), 2), value = _useState[0], setValue = _useState[1];
    var toggle = function() {
        setValue(function(previous) {
            return !previous;
        });
    };
    return [
        value,
        toggle
    ];
};
var $408fb6b023ab814b$export$2e2bcd8739ae039 = $408fb6b023ab814b$var$useToggle;



var $a4c4e0bafbc43fa7$var$PasswordInputField = function(props, forwardRef) {
    var _useToggle = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $408fb6b023ab814b$export$2e2bcd8739ae039)(false), 2), showPassword = _useToggle[0], toggleShowPassword = _useToggle[1];
    var innerRef = (0, $kVN77.useRef)(null);
    (0, $kVN77.useImperativeHandle)(forwardRef, function() {
        return innerRef.current;
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c6a92419d85488b3$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        isSuffixFocusVisible: true,
        type: showPassword ? "text" : "password",
        suffix: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $072ec55e67ff9777$export$2e2bcd8739ae039), {
            onMouseDown: function(event) {
                event.preventDefault();
                toggleShowPassword();
            },
            children: showPassword ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3f88812fd907fac1$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $a6698ddc47c4f539$export$2e2bcd8739ae039), {})
        })
    }, props), {
        ref: innerRef
    }));
};
var $a4c4e0bafbc43fa7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kVN77.forwardRef)($a4c4e0bafbc43fa7$var$PasswordInputField);

















function $ebded5dcd8ef1c3c$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $2d3ab33c4b11796a$export$f09211a7d3c496a1)(object);
        if (object === null) break;
    }
    return object;
}


function $86d3ec05538b325a$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $86d3ec05538b325a$export$afb3516d9d608401 = Reflect.get;
    else $86d3ec05538b325a$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $ebded5dcd8ef1c3c$export$e4187255aefbc259)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $86d3ec05538b325a$export$afb3516d9d608401(target, property, receiver || target);
}













var $28f4a53fbe635233$var$updateQueue = $28f4a53fbe635233$var$makeQueue();
var $28f4a53fbe635233$export$27f233d61a9e2fa4 = function(fn) {
    return $28f4a53fbe635233$var$schedule(fn, $28f4a53fbe635233$var$updateQueue);
};
var $28f4a53fbe635233$var$writeQueue = $28f4a53fbe635233$var$makeQueue();
$28f4a53fbe635233$export$27f233d61a9e2fa4.write = function(fn) {
    return $28f4a53fbe635233$var$schedule(fn, $28f4a53fbe635233$var$writeQueue);
};
var $28f4a53fbe635233$var$onStartQueue = $28f4a53fbe635233$var$makeQueue();
$28f4a53fbe635233$export$27f233d61a9e2fa4.onStart = function(fn) {
    return $28f4a53fbe635233$var$schedule(fn, $28f4a53fbe635233$var$onStartQueue);
};
var $28f4a53fbe635233$var$onFrameQueue = $28f4a53fbe635233$var$makeQueue();
$28f4a53fbe635233$export$27f233d61a9e2fa4.onFrame = function(fn) {
    return $28f4a53fbe635233$var$schedule(fn, $28f4a53fbe635233$var$onFrameQueue);
};
var $28f4a53fbe635233$var$onFinishQueue = $28f4a53fbe635233$var$makeQueue();
$28f4a53fbe635233$export$27f233d61a9e2fa4.onFinish = function(fn) {
    return $28f4a53fbe635233$var$schedule(fn, $28f4a53fbe635233$var$onFinishQueue);
};
var $28f4a53fbe635233$var$timeouts = [];
$28f4a53fbe635233$export$27f233d61a9e2fa4.setTimeout = function(handler, ms) {
    var time = $28f4a53fbe635233$export$27f233d61a9e2fa4.now() + ms;
    var cancel = function() {
        var i = $28f4a53fbe635233$var$timeouts.findIndex(function(t) {
            return t.cancel == cancel;
        });
        if (~i) $28f4a53fbe635233$var$timeouts.splice(i, 1);
        $28f4a53fbe635233$var$pendingCount -= ~i ? 1 : 0;
    };
    var timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $28f4a53fbe635233$var$timeouts.splice($28f4a53fbe635233$var$findTimeout(time), 0, timeout);
    $28f4a53fbe635233$var$pendingCount += 1;
    $28f4a53fbe635233$var$start();
    return timeout;
};
var $28f4a53fbe635233$var$findTimeout = function(time) {
    return ~(~$28f4a53fbe635233$var$timeouts.findIndex(function(t) {
        return t.time > time;
    }) || ~$28f4a53fbe635233$var$timeouts.length);
};
$28f4a53fbe635233$export$27f233d61a9e2fa4.cancel = function(fn) {
    $28f4a53fbe635233$var$onStartQueue.delete(fn);
    $28f4a53fbe635233$var$onFrameQueue.delete(fn);
    $28f4a53fbe635233$var$onFinishQueue.delete(fn);
    $28f4a53fbe635233$var$updateQueue.delete(fn);
    $28f4a53fbe635233$var$writeQueue.delete(fn);
};
$28f4a53fbe635233$export$27f233d61a9e2fa4.sync = function(fn) {
    $28f4a53fbe635233$var$sync = true;
    $28f4a53fbe635233$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $28f4a53fbe635233$var$sync = false;
};
$28f4a53fbe635233$export$27f233d61a9e2fa4.throttle = function(fn) {
    var lastArgs;
    function queuedFn() {
        try {
            fn.apply(void 0, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(lastArgs));
        } finally{
            lastArgs = null;
        }
    }
    function throttled() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        lastArgs = args;
        $28f4a53fbe635233$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = function() {
        $28f4a53fbe635233$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $28f4a53fbe635233$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : function() {};
$28f4a53fbe635233$export$27f233d61a9e2fa4.use = function(impl) {
    return $28f4a53fbe635233$var$nativeRaf = impl;
};
$28f4a53fbe635233$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? function() {
    return performance.now();
} : Date.now;
$28f4a53fbe635233$export$27f233d61a9e2fa4.batchedUpdates = function(fn) {
    return fn();
};
$28f4a53fbe635233$export$27f233d61a9e2fa4.catch = console.error;
$28f4a53fbe635233$export$27f233d61a9e2fa4.frameLoop = "always";
$28f4a53fbe635233$export$27f233d61a9e2fa4.advance = function() {
    if ($28f4a53fbe635233$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $28f4a53fbe635233$var$update();
};
var $28f4a53fbe635233$var$ts = -1;
var $28f4a53fbe635233$var$pendingCount = 0;
var $28f4a53fbe635233$var$sync = false;
function $28f4a53fbe635233$var$schedule(fn, queue) {
    if ($28f4a53fbe635233$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $28f4a53fbe635233$var$start();
    }
}
function $28f4a53fbe635233$var$start() {
    if ($28f4a53fbe635233$var$ts < 0) {
        $28f4a53fbe635233$var$ts = 0;
        if ($28f4a53fbe635233$export$27f233d61a9e2fa4.frameLoop !== "demand") $28f4a53fbe635233$var$nativeRaf($28f4a53fbe635233$var$loop);
    }
}
function $28f4a53fbe635233$var$stop() {
    $28f4a53fbe635233$var$ts = -1;
}
function $28f4a53fbe635233$var$loop() {
    if (~$28f4a53fbe635233$var$ts) {
        $28f4a53fbe635233$var$nativeRaf($28f4a53fbe635233$var$loop);
        $28f4a53fbe635233$export$27f233d61a9e2fa4.batchedUpdates($28f4a53fbe635233$var$update);
    }
}
function $28f4a53fbe635233$var$update() {
    var prevTs = $28f4a53fbe635233$var$ts;
    $28f4a53fbe635233$var$ts = $28f4a53fbe635233$export$27f233d61a9e2fa4.now();
    var count = $28f4a53fbe635233$var$findTimeout($28f4a53fbe635233$var$ts);
    if (count) {
        $28f4a53fbe635233$var$eachSafely($28f4a53fbe635233$var$timeouts.splice(0, count), function(t) {
            return t.handler();
        });
        $28f4a53fbe635233$var$pendingCount -= count;
    }
    if (!$28f4a53fbe635233$var$pendingCount) {
        $28f4a53fbe635233$var$stop();
        return;
    }
    $28f4a53fbe635233$var$onStartQueue.flush();
    $28f4a53fbe635233$var$updateQueue.flush(prevTs ? Math.min(64, $28f4a53fbe635233$var$ts - prevTs) : 16.667);
    $28f4a53fbe635233$var$onFrameQueue.flush();
    $28f4a53fbe635233$var$writeQueue.flush();
    $28f4a53fbe635233$var$onFinishQueue.flush();
}
function $28f4a53fbe635233$var$makeQueue() {
    var next = new Set();
    var current = next;
    return {
        add: function(fn) {
            $28f4a53fbe635233$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete: function(fn) {
            $28f4a53fbe635233$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush: function(arg) {
            if (current.size) {
                next = new Set();
                $28f4a53fbe635233$var$pendingCount -= current.size;
                $28f4a53fbe635233$var$eachSafely(current, function(fn) {
                    return fn(arg) && next.add(fn);
                });
                $28f4a53fbe635233$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $28f4a53fbe635233$var$eachSafely(values, each) {
    values.forEach(function(value) {
        try {
            each(value);
        } catch (e) {
            $28f4a53fbe635233$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $28f4a53fbe635233$export$ef91a23fc803e177 = {
    count: function() {
        return $28f4a53fbe635233$var$pendingCount;
    },
    isRunning: function() {
        return $28f4a53fbe635233$var$ts >= 0;
    },
    clear: function() {
        $28f4a53fbe635233$var$ts = -1;
        $28f4a53fbe635233$var$timeouts = [];
        $28f4a53fbe635233$var$onStartQueue = $28f4a53fbe635233$var$makeQueue();
        $28f4a53fbe635233$var$updateQueue = $28f4a53fbe635233$var$makeQueue();
        $28f4a53fbe635233$var$onFrameQueue = $28f4a53fbe635233$var$makeQueue();
        $28f4a53fbe635233$var$writeQueue = $28f4a53fbe635233$var$makeQueue();
        $28f4a53fbe635233$var$onFinishQueue = $28f4a53fbe635233$var$makeQueue();
        $28f4a53fbe635233$var$pendingCount = 0;
    }
};



var $kVN77 = parcelRequire("kVN77");
function $ffdb8e9de05aa517$export$8793edee2d425525() {}
var $ffdb8e9de05aa517$export$5c74248ea0e35446 = function(obj, key, value) {
    return Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
};
var $ffdb8e9de05aa517$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: function(a) {
        return !!a && a.constructor.name === "Object";
    },
    fun: function(a) {
        return typeof a === "function";
    },
    str: function(a) {
        return typeof a === "string";
    },
    num: function(a) {
        return typeof a === "number";
    },
    und: function(a) {
        return a === undefined;
    }
};
function $ffdb8e9de05aa517$export$248d38f6296296c5(a, b) {
    if ($ffdb8e9de05aa517$export$226b3eccf92c9ed9.arr(a)) {
        if (!$ffdb8e9de05aa517$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $ffdb8e9de05aa517$export$79b2f7037acddd43 = function(obj, fn) {
    return obj.forEach(fn);
};
function $ffdb8e9de05aa517$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($ffdb8e9de05aa517$export$226b3eccf92c9ed9.arr(obj)) {
        for(var i = 0; i < obj.length; i++)fn.call(ctx, obj[i], "".concat(i));
        return;
    }
    for(var key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $ffdb8e9de05aa517$export$45b10814cc054894 = function(a) {
    return $ffdb8e9de05aa517$export$226b3eccf92c9ed9.und(a) ? [] : $ffdb8e9de05aa517$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
};
function $ffdb8e9de05aa517$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        var items = Array.from(queue);
        queue.clear();
        $ffdb8e9de05aa517$export$79b2f7037acddd43(items, iterator);
    }
}
var $ffdb8e9de05aa517$export$7ba486852759e806 = function(queue) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return $ffdb8e9de05aa517$export$4909b86c8034bf73(queue, function(fn) {
        return fn.apply(void 0, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(args));
    });
};
var $ffdb8e9de05aa517$export$48d7c418edadb60c = function() {
    return typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
};
var $ffdb8e9de05aa517$var$createStringInterpolator$1;
var $ffdb8e9de05aa517$var$to;
var $ffdb8e9de05aa517$var$colors$1 = null;
var $ffdb8e9de05aa517$var$skipAnimation = false;
var $ffdb8e9de05aa517$var$willAdvance = $ffdb8e9de05aa517$export$8793edee2d425525;
var $ffdb8e9de05aa517$var$assign = function(globals) {
    if (globals.to) $ffdb8e9de05aa517$var$to = globals.to;
    if (globals.now) (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== undefined) $ffdb8e9de05aa517$var$colors$1 = globals.colors;
    if (globals.skipAnimation != null) $ffdb8e9de05aa517$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $ffdb8e9de05aa517$var$createStringInterpolator$1 = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $ffdb8e9de05aa517$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $ffdb8e9de05aa517$export$cceeabf822b64fc0 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    get createStringInterpolator () {
        return $ffdb8e9de05aa517$var$createStringInterpolator$1;
    },
    get to () {
        return $ffdb8e9de05aa517$var$to;
    },
    get colors () {
        return $ffdb8e9de05aa517$var$colors$1;
    },
    get skipAnimation () {
        return $ffdb8e9de05aa517$var$skipAnimation;
    },
    get willAdvance () {
        return $ffdb8e9de05aa517$var$willAdvance;
    },
    assign: $ffdb8e9de05aa517$var$assign
});
var $ffdb8e9de05aa517$var$startQueue = new Set();
var $ffdb8e9de05aa517$var$currentFrame = [];
var $ffdb8e9de05aa517$var$prevFrame = [];
var $ffdb8e9de05aa517$var$priority = 0;
var $ffdb8e9de05aa517$export$a57f5080a3bcc90a = {
    get idle () {
        return !$ffdb8e9de05aa517$var$startQueue.size && !$ffdb8e9de05aa517$var$currentFrame.length;
    },
    start: function(animation) {
        if ($ffdb8e9de05aa517$var$priority > animation.priority) {
            $ffdb8e9de05aa517$var$startQueue.add(animation);
            (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).onStart($ffdb8e9de05aa517$var$flushStartQueue);
        } else {
            $ffdb8e9de05aa517$var$startSafely(animation);
            (0, $28f4a53fbe635233$export$27f233d61a9e2fa4)($ffdb8e9de05aa517$var$advance);
        }
    },
    advance: $ffdb8e9de05aa517$var$advance,
    sort: function(animation) {
        if ($ffdb8e9de05aa517$var$priority) (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).onFrame(function() {
            return $ffdb8e9de05aa517$export$a57f5080a3bcc90a.sort(animation);
        });
        else {
            var prevIndex = $ffdb8e9de05aa517$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $ffdb8e9de05aa517$var$currentFrame.splice(prevIndex, 1);
                $ffdb8e9de05aa517$var$startUnsafely(animation);
            }
        }
    },
    clear: function() {
        $ffdb8e9de05aa517$var$currentFrame = [];
        $ffdb8e9de05aa517$var$startQueue.clear();
    }
};
function $ffdb8e9de05aa517$var$flushStartQueue() {
    $ffdb8e9de05aa517$var$startQueue.forEach($ffdb8e9de05aa517$var$startSafely);
    $ffdb8e9de05aa517$var$startQueue.clear();
    (0, $28f4a53fbe635233$export$27f233d61a9e2fa4)($ffdb8e9de05aa517$var$advance);
}
function $ffdb8e9de05aa517$var$startSafely(animation) {
    if (!$ffdb8e9de05aa517$var$currentFrame.includes(animation)) $ffdb8e9de05aa517$var$startUnsafely(animation);
}
function $ffdb8e9de05aa517$var$startUnsafely(animation) {
    $ffdb8e9de05aa517$var$currentFrame.splice($ffdb8e9de05aa517$var$findIndex($ffdb8e9de05aa517$var$currentFrame, function(other) {
        return other.priority > animation.priority;
    }), 0, animation);
}
function $ffdb8e9de05aa517$var$advance(dt) {
    var nextFrame = $ffdb8e9de05aa517$var$prevFrame;
    for(var i = 0; i < $ffdb8e9de05aa517$var$currentFrame.length; i++){
        var animation = $ffdb8e9de05aa517$var$currentFrame[i];
        $ffdb8e9de05aa517$var$priority = animation.priority;
        if (!animation.idle) {
            $ffdb8e9de05aa517$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $ffdb8e9de05aa517$var$priority = 0;
    $ffdb8e9de05aa517$var$prevFrame = $ffdb8e9de05aa517$var$currentFrame;
    $ffdb8e9de05aa517$var$prevFrame.length = 0;
    $ffdb8e9de05aa517$var$currentFrame = nextFrame;
    return $ffdb8e9de05aa517$var$currentFrame.length > 0;
}
function $ffdb8e9de05aa517$var$findIndex(arr, test) {
    var index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
var $ffdb8e9de05aa517$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    return Math.min(Math.max(v, min), max);
};
var $ffdb8e9de05aa517$export$8f45430ccf837300 = {
    transparent: 0x00000000,
    aliceblue: 0xf0f8ffff,
    antiquewhite: 0xfaebd7ff,
    aqua: 0x00ffffff,
    aquamarine: 0x7fffd4ff,
    azure: 0xf0ffffff,
    beige: 0xf5f5dcff,
    bisque: 0xffe4c4ff,
    black: 0x000000ff,
    blanchedalmond: 0xffebcdff,
    blue: 0x0000ffff,
    blueviolet: 0x8a2be2ff,
    brown: 0xa52a2aff,
    burlywood: 0xdeb887ff,
    burntsienna: 0xea7e5dff,
    cadetblue: 0x5f9ea0ff,
    chartreuse: 0x7fff00ff,
    chocolate: 0xd2691eff,
    coral: 0xff7f50ff,
    cornflowerblue: 0x6495edff,
    cornsilk: 0xfff8dcff,
    crimson: 0xdc143cff,
    cyan: 0x00ffffff,
    darkblue: 0x00008bff,
    darkcyan: 0x008b8bff,
    darkgoldenrod: 0xb8860bff,
    darkgray: 0xa9a9a9ff,
    darkgreen: 0x006400ff,
    darkgrey: 0xa9a9a9ff,
    darkkhaki: 0xbdb76bff,
    darkmagenta: 0x8b008bff,
    darkolivegreen: 0x556b2fff,
    darkorange: 0xff8c00ff,
    darkorchid: 0x9932ccff,
    darkred: 0x8b0000ff,
    darksalmon: 0xe9967aff,
    darkseagreen: 0x8fbc8fff,
    darkslateblue: 0x483d8bff,
    darkslategray: 0x2f4f4fff,
    darkslategrey: 0x2f4f4fff,
    darkturquoise: 0x00ced1ff,
    darkviolet: 0x9400d3ff,
    deeppink: 0xff1493ff,
    deepskyblue: 0x00bfffff,
    dimgray: 0x696969ff,
    dimgrey: 0x696969ff,
    dodgerblue: 0x1e90ffff,
    firebrick: 0xb22222ff,
    floralwhite: 0xfffaf0ff,
    forestgreen: 0x228b22ff,
    fuchsia: 0xff00ffff,
    gainsboro: 0xdcdcdcff,
    ghostwhite: 0xf8f8ffff,
    gold: 0xffd700ff,
    goldenrod: 0xdaa520ff,
    gray: 0x808080ff,
    green: 0x008000ff,
    greenyellow: 0xadff2fff,
    grey: 0x808080ff,
    honeydew: 0xf0fff0ff,
    hotpink: 0xff69b4ff,
    indianred: 0xcd5c5cff,
    indigo: 0x4b0082ff,
    ivory: 0xfffff0ff,
    khaki: 0xf0e68cff,
    lavender: 0xe6e6faff,
    lavenderblush: 0xfff0f5ff,
    lawngreen: 0x7cfc00ff,
    lemonchiffon: 0xfffacdff,
    lightblue: 0xadd8e6ff,
    lightcoral: 0xf08080ff,
    lightcyan: 0xe0ffffff,
    lightgoldenrodyellow: 0xfafad2ff,
    lightgray: 0xd3d3d3ff,
    lightgreen: 0x90ee90ff,
    lightgrey: 0xd3d3d3ff,
    lightpink: 0xffb6c1ff,
    lightsalmon: 0xffa07aff,
    lightseagreen: 0x20b2aaff,
    lightskyblue: 0x87cefaff,
    lightslategray: 0x778899ff,
    lightslategrey: 0x778899ff,
    lightsteelblue: 0xb0c4deff,
    lightyellow: 0xffffe0ff,
    lime: 0x00ff00ff,
    limegreen: 0x32cd32ff,
    linen: 0xfaf0e6ff,
    magenta: 0xff00ffff,
    maroon: 0x800000ff,
    mediumaquamarine: 0x66cdaaff,
    mediumblue: 0x0000cdff,
    mediumorchid: 0xba55d3ff,
    mediumpurple: 0x9370dbff,
    mediumseagreen: 0x3cb371ff,
    mediumslateblue: 0x7b68eeff,
    mediumspringgreen: 0x00fa9aff,
    mediumturquoise: 0x48d1ccff,
    mediumvioletred: 0xc71585ff,
    midnightblue: 0x191970ff,
    mintcream: 0xf5fffaff,
    mistyrose: 0xffe4e1ff,
    moccasin: 0xffe4b5ff,
    navajowhite: 0xffdeadff,
    navy: 0x000080ff,
    oldlace: 0xfdf5e6ff,
    olive: 0x808000ff,
    olivedrab: 0x6b8e23ff,
    orange: 0xffa500ff,
    orangered: 0xff4500ff,
    orchid: 0xda70d6ff,
    palegoldenrod: 0xeee8aaff,
    palegreen: 0x98fb98ff,
    paleturquoise: 0xafeeeeff,
    palevioletred: 0xdb7093ff,
    papayawhip: 0xffefd5ff,
    peachpuff: 0xffdab9ff,
    peru: 0xcd853fff,
    pink: 0xffc0cbff,
    plum: 0xdda0ddff,
    powderblue: 0xb0e0e6ff,
    purple: 0x800080ff,
    rebeccapurple: 0x663399ff,
    red: 0xff0000ff,
    rosybrown: 0xbc8f8fff,
    royalblue: 0x4169e1ff,
    saddlebrown: 0x8b4513ff,
    salmon: 0xfa8072ff,
    sandybrown: 0xf4a460ff,
    seagreen: 0x2e8b57ff,
    seashell: 0xfff5eeff,
    sienna: 0xa0522dff,
    silver: 0xc0c0c0ff,
    skyblue: 0x87ceebff,
    slateblue: 0x6a5acdff,
    slategray: 0x708090ff,
    slategrey: 0x708090ff,
    snow: 0xfffafaff,
    springgreen: 0x00ff7fff,
    steelblue: 0x4682b4ff,
    tan: 0xd2b48cff,
    teal: 0x008080ff,
    thistle: 0xd8bfd8ff,
    tomato: 0xff6347ff,
    turquoise: 0x40e0d0ff,
    violet: 0xee82eeff,
    wheat: 0xf5deb3ff,
    white: 0xffffffff,
    whitesmoke: 0xf5f5f5ff,
    yellow: 0xffff00ff,
    yellowgreen: 0x9acd32ff
};
var $ffdb8e9de05aa517$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $ffdb8e9de05aa517$var$PERCENTAGE = $ffdb8e9de05aa517$var$NUMBER + "%";
function $ffdb8e9de05aa517$var$call() {
    for(var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++){
        parts[_key] = arguments[_key];
    }
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $ffdb8e9de05aa517$export$8972dc0e6ad9238f = new RegExp("rgb" + $ffdb8e9de05aa517$var$call($ffdb8e9de05aa517$var$NUMBER, $ffdb8e9de05aa517$var$NUMBER, $ffdb8e9de05aa517$var$NUMBER));
var $ffdb8e9de05aa517$export$4e46ac54fc82cf3b = new RegExp("rgba" + $ffdb8e9de05aa517$var$call($ffdb8e9de05aa517$var$NUMBER, $ffdb8e9de05aa517$var$NUMBER, $ffdb8e9de05aa517$var$NUMBER, $ffdb8e9de05aa517$var$NUMBER));
var $ffdb8e9de05aa517$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $ffdb8e9de05aa517$var$call($ffdb8e9de05aa517$var$NUMBER, $ffdb8e9de05aa517$var$PERCENTAGE, $ffdb8e9de05aa517$var$PERCENTAGE));
var $ffdb8e9de05aa517$export$810b04175080204c = new RegExp("hsla" + $ffdb8e9de05aa517$var$call($ffdb8e9de05aa517$var$NUMBER, $ffdb8e9de05aa517$var$PERCENTAGE, $ffdb8e9de05aa517$var$PERCENTAGE, $ffdb8e9de05aa517$var$NUMBER));
var $ffdb8e9de05aa517$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $ffdb8e9de05aa517$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $ffdb8e9de05aa517$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $ffdb8e9de05aa517$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
function $ffdb8e9de05aa517$var$normalizeColor(color) {
    var match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
    if (match = $ffdb8e9de05aa517$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($ffdb8e9de05aa517$var$colors$1 && $ffdb8e9de05aa517$var$colors$1[color] !== undefined) return $ffdb8e9de05aa517$var$colors$1[color];
    if (match = $ffdb8e9de05aa517$export$8972dc0e6ad9238f.exec(color)) return ($ffdb8e9de05aa517$var$parse255(match[1]) << 24 | $ffdb8e9de05aa517$var$parse255(match[2]) << 16 | $ffdb8e9de05aa517$var$parse255(match[3]) << 8 | 0x000000ff) >>> 0;
    if (match = $ffdb8e9de05aa517$export$4e46ac54fc82cf3b.exec(color)) return ($ffdb8e9de05aa517$var$parse255(match[1]) << 24 | $ffdb8e9de05aa517$var$parse255(match[2]) << 16 | $ffdb8e9de05aa517$var$parse255(match[3]) << 8 | $ffdb8e9de05aa517$var$parse1(match[4])) >>> 0;
    if (match = $ffdb8e9de05aa517$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
    if (match = $ffdb8e9de05aa517$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $ffdb8e9de05aa517$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    if (match = $ffdb8e9de05aa517$export$8f4a7c0bb78e6ea8.exec(color)) return ($ffdb8e9de05aa517$var$hslToRgb($ffdb8e9de05aa517$var$parse360(match[1]), $ffdb8e9de05aa517$var$parsePercentage(match[2]), $ffdb8e9de05aa517$var$parsePercentage(match[3])) | 0x000000ff) >>> 0;
    if (match = $ffdb8e9de05aa517$export$810b04175080204c.exec(color)) return ($ffdb8e9de05aa517$var$hslToRgb($ffdb8e9de05aa517$var$parse360(match[1]), $ffdb8e9de05aa517$var$parsePercentage(match[2]), $ffdb8e9de05aa517$var$parsePercentage(match[3])) | $ffdb8e9de05aa517$var$parse1(match[4])) >>> 0;
    return null;
}
function $ffdb8e9de05aa517$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $ffdb8e9de05aa517$var$hslToRgb(h, s, l) {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    var r = $ffdb8e9de05aa517$var$hue2rgb(p, q, h + 1 / 3);
    var g = $ffdb8e9de05aa517$var$hue2rgb(p, q, h);
    var b = $ffdb8e9de05aa517$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $ffdb8e9de05aa517$var$parse255(str) {
    var int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $ffdb8e9de05aa517$var$parse360(str) {
    var int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $ffdb8e9de05aa517$var$parse1(str) {
    var num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $ffdb8e9de05aa517$var$parsePercentage(str) {
    var int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
function $ffdb8e9de05aa517$export$61db176b839af1f(input) {
    var int32Color = $ffdb8e9de05aa517$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    var r = (int32Color & 0xff000000) >>> 24;
    var g = (int32Color & 0x00ff0000) >>> 16;
    var b = (int32Color & 0x0000ff00) >>> 8;
    var a = (int32Color & 0x000000ff) / 255;
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
var $ffdb8e9de05aa517$export$b12af43b97697ef5 = function(range, output, extrapolate) {
    if ($ffdb8e9de05aa517$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($ffdb8e9de05aa517$export$226b3eccf92c9ed9.arr(range)) return $ffdb8e9de05aa517$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($ffdb8e9de05aa517$export$226b3eccf92c9ed9.str(range.output[0])) return $ffdb8e9de05aa517$var$createStringInterpolator$1(range);
    var config = range;
    var outputRange = config.output;
    var inputRange = config.range || [
        0,
        1
    ];
    var extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    var extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    var easing = config.easing || function(t) {
        return t;
    };
    return function(input) {
        var _$range = $ffdb8e9de05aa517$var$findRange(input, inputRange);
        return $ffdb8e9de05aa517$var$interpolate(input, inputRange[_$range], inputRange[_$range + 1], outputRange[_$range], outputRange[_$range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $ffdb8e9de05aa517$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    var result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $ffdb8e9de05aa517$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
var $ffdb8e9de05aa517$var$steps = function(steps) {
    var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "end";
    return function(progress) {
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        var expanded = progress * steps;
        var rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $ffdb8e9de05aa517$export$7d15b64cf5a3a4c4(0, 1, rounded / steps);
    };
};
var $ffdb8e9de05aa517$var$c1 = 1.70158;
var $ffdb8e9de05aa517$var$c2 = $ffdb8e9de05aa517$var$c1 * 1.525;
var $ffdb8e9de05aa517$var$c3 = $ffdb8e9de05aa517$var$c1 + 1;
var $ffdb8e9de05aa517$var$c4 = 2 * Math.PI / 3;
var $ffdb8e9de05aa517$var$c5 = 2 * Math.PI / 4.5;
var $ffdb8e9de05aa517$var$bounceOut = function(x) {
    var n1 = 7.5625;
    var d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $ffdb8e9de05aa517$export$15a0bf1b4bbacad8 = {
    linear: function(x) {
        return x;
    },
    easeInQuad: function(x) {
        return x * x;
    },
    easeOutQuad: function(x) {
        return 1 - (1 - x) * (1 - x);
    },
    easeInOutQuad: function(x) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    },
    easeInCubic: function(x) {
        return x * x * x;
    },
    easeOutCubic: function(x) {
        return 1 - Math.pow(1 - x, 3);
    },
    easeInOutCubic: function(x) {
        return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    },
    easeInQuart: function(x) {
        return x * x * x * x;
    },
    easeOutQuart: function(x) {
        return 1 - Math.pow(1 - x, 4);
    },
    easeInOutQuart: function(x) {
        return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
    },
    easeInQuint: function(x) {
        return x * x * x * x * x;
    },
    easeOutQuint: function(x) {
        return 1 - Math.pow(1 - x, 5);
    },
    easeInOutQuint: function(x) {
        return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
    },
    easeInSine: function(x) {
        return 1 - Math.cos(x * Math.PI / 2);
    },
    easeOutSine: function(x) {
        return Math.sin(x * Math.PI / 2);
    },
    easeInOutSine: function(x) {
        return -(Math.cos(Math.PI * x) - 1) / 2;
    },
    easeInExpo: function(x) {
        return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
    },
    easeOutExpo: function(x) {
        return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
    },
    easeInOutExpo: function(x) {
        return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2;
    },
    easeInCirc: function(x) {
        return 1 - Math.sqrt(1 - Math.pow(x, 2));
    },
    easeOutCirc: function(x) {
        return Math.sqrt(1 - Math.pow(x - 1, 2));
    },
    easeInOutCirc: function(x) {
        return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
    },
    easeInBack: function(x) {
        return $ffdb8e9de05aa517$var$c3 * x * x * x - $ffdb8e9de05aa517$var$c1 * x * x;
    },
    easeOutBack: function(x) {
        return 1 + $ffdb8e9de05aa517$var$c3 * Math.pow(x - 1, 3) + $ffdb8e9de05aa517$var$c1 * Math.pow(x - 1, 2);
    },
    easeInOutBack: function(x) {
        return x < 0.5 ? Math.pow(2 * x, 2) * (($ffdb8e9de05aa517$var$c2 + 1) * 2 * x - $ffdb8e9de05aa517$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($ffdb8e9de05aa517$var$c2 + 1) * (x * 2 - 2) + $ffdb8e9de05aa517$var$c2) + 2) / 2;
    },
    easeInElastic: function(x) {
        return x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $ffdb8e9de05aa517$var$c4);
    },
    easeOutElastic: function(x) {
        return x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $ffdb8e9de05aa517$var$c4) + 1;
    },
    easeInOutElastic: function(x) {
        return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $ffdb8e9de05aa517$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $ffdb8e9de05aa517$var$c5) / 2 + 1;
    },
    easeInBounce: function(x) {
        return 1 - $ffdb8e9de05aa517$var$bounceOut(1 - x);
    },
    easeOutBounce: $ffdb8e9de05aa517$var$bounceOut,
    easeInOutBounce: function(x) {
        return x < 0.5 ? (1 - $ffdb8e9de05aa517$var$bounceOut(1 - 2 * x)) / 2 : (1 + $ffdb8e9de05aa517$var$bounceOut(2 * x - 1)) / 2;
    },
    steps: $ffdb8e9de05aa517$var$steps
};
function $ffdb8e9de05aa517$var$_extends() {
    $ffdb8e9de05aa517$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ffdb8e9de05aa517$var$_extends.apply(this, arguments);
}
var $ffdb8e9de05aa517$var$$get = Symbol.for("FluidValue.get");
var $ffdb8e9de05aa517$var$$observers = Symbol.for("FluidValue.observers");
var $ffdb8e9de05aa517$export$57ea7e3a7f6280c7 = function(arg) {
    return Boolean(arg && arg[$ffdb8e9de05aa517$var$$get]);
};
var $ffdb8e9de05aa517$export$e37b7520edd66839 = function(arg) {
    return arg && arg[$ffdb8e9de05aa517$var$$get] ? arg[$ffdb8e9de05aa517$var$$get]() : arg;
};
var $ffdb8e9de05aa517$export$133f54e9f7cf1796 = function(target) {
    return target[$ffdb8e9de05aa517$var$$observers] || null;
};
function $ffdb8e9de05aa517$export$8cbca1207adce0c0(observer, event) {
    if (observer.eventObserved) observer.eventObserved(event);
    else observer(event);
}
function $ffdb8e9de05aa517$export$31752c40a5fab62a(target, event) {
    var observers = target[$ffdb8e9de05aa517$var$$observers];
    if (observers) observers.forEach(function(observer) {
        $ffdb8e9de05aa517$export$8cbca1207adce0c0(observer, event);
    });
}
var $ffdb8e9de05aa517$export$aff8e1ac1a016a2 = function FluidValue(get) {
    "use strict";
    (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, FluidValue);
    this[$ffdb8e9de05aa517$var$$get] = void 0;
    this[$ffdb8e9de05aa517$var$$observers] = void 0;
    if (!get && !(get = this.get)) throw Error("Unknown getter");
    $ffdb8e9de05aa517$export$a3b4618659637aa3(this, get);
};
var $ffdb8e9de05aa517$export$a3b4618659637aa3 = function(target, get) {
    return $ffdb8e9de05aa517$var$setHidden(target, $ffdb8e9de05aa517$var$$get, get);
};
function $ffdb8e9de05aa517$export$72d604e3f8d000a5(target, observer) {
    if (target[$ffdb8e9de05aa517$var$$get]) {
        var observers = target[$ffdb8e9de05aa517$var$$observers];
        if (!observers) $ffdb8e9de05aa517$var$setHidden(target, $ffdb8e9de05aa517$var$$observers, observers = new Set());
        if (!observers.has(observer)) {
            observers.add(observer);
            if (target.observerAdded) target.observerAdded(observers.size, observer);
        }
    }
    return observer;
}
function $ffdb8e9de05aa517$export$7a0eb830d336339b(target, observer) {
    var observers = target[$ffdb8e9de05aa517$var$$observers];
    if (observers && observers.has(observer)) {
        var count = observers.size - 1;
        if (count) observers.delete(observer);
        else target[$ffdb8e9de05aa517$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer);
    }
}
var $ffdb8e9de05aa517$var$setHidden = function(target, key, value) {
    return Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
};
var $ffdb8e9de05aa517$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $ffdb8e9de05aa517$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $ffdb8e9de05aa517$var$unitRegex = new RegExp("(".concat($ffdb8e9de05aa517$var$numberRegex.source, ")(%|[a-z]+)"), "i");
var $ffdb8e9de05aa517$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $ffdb8e9de05aa517$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
var $ffdb8e9de05aa517$var$variableToRgba = function(input) {
    var _parseCSSVariable = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($ffdb8e9de05aa517$var$parseCSSVariable(input), 2), token = _parseCSSVariable[0], fallback = _parseCSSVariable[1];
    if (!token || $ffdb8e9de05aa517$export$48d7c418edadb60c()) return input;
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        var _value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (_value) return _value;
        else return input;
    } else if (fallback && $ffdb8e9de05aa517$var$cssVariableRegex.test(fallback)) return $ffdb8e9de05aa517$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $ffdb8e9de05aa517$var$parseCSSVariable = function(current) {
    var match = $ffdb8e9de05aa517$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    var _match = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(match, 3), token = _match[1], fallback = _match[2];
    return [
        token,
        fallback
    ];
};
var $ffdb8e9de05aa517$var$namedColorRegex;
var $ffdb8e9de05aa517$var$rgbaRound = function(_, p1, p2, p3, p4) {
    return "rgba(".concat(Math.round(p1), ", ").concat(Math.round(p2), ", ").concat(Math.round(p3), ", ").concat(p4, ")");
};
var $ffdb8e9de05aa517$export$4759a013d387347a = function(config) {
    if (!$ffdb8e9de05aa517$var$namedColorRegex) $ffdb8e9de05aa517$var$namedColorRegex = $ffdb8e9de05aa517$var$colors$1 ? new RegExp("(".concat(Object.keys($ffdb8e9de05aa517$var$colors$1).join("|"), ")(?!\\w)"), "g") : /^\b$/;
    var output = config.output.map(function(value) {
        return $ffdb8e9de05aa517$export$e37b7520edd66839(value).replace($ffdb8e9de05aa517$var$cssVariableRegex, $ffdb8e9de05aa517$var$variableToRgba).replace($ffdb8e9de05aa517$var$colorRegex, $ffdb8e9de05aa517$export$61db176b839af1f).replace($ffdb8e9de05aa517$var$namedColorRegex, $ffdb8e9de05aa517$export$61db176b839af1f);
    });
    var keyframes = output.map(function(value) {
        return value.match($ffdb8e9de05aa517$var$numberRegex).map(Number);
    });
    var outputRanges = keyframes[0].map(function(_, i) {
        return keyframes.map(function(values) {
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        });
    });
    var interpolators = outputRanges.map(function(output) {
        return $ffdb8e9de05aa517$export$b12af43b97697ef5($ffdb8e9de05aa517$var$_extends({}, config, {
            output: output
        }));
    });
    return function(input) {
        var _output$find;
        var missingUnit = !$ffdb8e9de05aa517$var$unitRegex.test(output[0]) && ((_output$find = output.find(function(value) {
            return $ffdb8e9de05aa517$var$unitRegex.test(value);
        })) == null ? void 0 : _output$find.replace($ffdb8e9de05aa517$var$numberRegex, ""));
        var i = 0;
        return output[0].replace($ffdb8e9de05aa517$var$numberRegex, function() {
            return "".concat(interpolators[i++](input)).concat(missingUnit || "");
        }).replace($ffdb8e9de05aa517$var$rgbaRegex, $ffdb8e9de05aa517$var$rgbaRound);
    };
};
var $ffdb8e9de05aa517$export$82e9f45cca5ba907 = "react-spring: ";
var $ffdb8e9de05aa517$export$d2de3aaeafa91619 = function(fn) {
    var func = fn;
    var called = false;
    if (typeof func != "function") throw new TypeError("".concat($ffdb8e9de05aa517$export$82e9f45cca5ba907, "once requires a function parameter"));
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!called) {
            func.apply(void 0, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(args));
            called = true;
        }
    };
};
var $ffdb8e9de05aa517$var$warnInterpolate = $ffdb8e9de05aa517$export$d2de3aaeafa91619(console.warn);
function $ffdb8e9de05aa517$export$2abfcde8ae218ba8() {
    $ffdb8e9de05aa517$var$warnInterpolate("".concat($ffdb8e9de05aa517$export$82e9f45cca5ba907, 'The "interpolate" function is deprecated in v9 (use "to" instead)'));
}
var $ffdb8e9de05aa517$var$warnDirectCall = $ffdb8e9de05aa517$export$d2de3aaeafa91619(console.warn);
function $ffdb8e9de05aa517$export$d99d974913ad3b12() {
    $ffdb8e9de05aa517$var$warnDirectCall("".concat($ffdb8e9de05aa517$export$82e9f45cca5ba907, 'Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions'));
}
function $ffdb8e9de05aa517$export$75bed621f62abfa9(value) {
    return $ffdb8e9de05aa517$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || !$ffdb8e9de05aa517$export$48d7c418edadb60c() && $ffdb8e9de05aa517$var$cssVariableRegex.test(value) || value in ($ffdb8e9de05aa517$var$colors$1 || {}));
}
var $ffdb8e9de05aa517$var$observer;
var $ffdb8e9de05aa517$var$resizeHandlers = new WeakMap();
var $ffdb8e9de05aa517$var$handleObservation = function(entries) {
    return entries.forEach(function(param) {
        var target = param.target, contentRect = param.contentRect;
        var _resizeHandlers$get;
        return (_resizeHandlers$get = $ffdb8e9de05aa517$var$resizeHandlers.get(target)) == null ? void 0 : _resizeHandlers$get.forEach(function(handler) {
            return handler(contentRect);
        });
    });
};
function $ffdb8e9de05aa517$var$resizeElement(handler, target) {
    if (!$ffdb8e9de05aa517$var$observer) {
        if (typeof ResizeObserver !== "undefined") $ffdb8e9de05aa517$var$observer = new ResizeObserver($ffdb8e9de05aa517$var$handleObservation);
    }
    var elementHandlers = $ffdb8e9de05aa517$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = new Set();
        $ffdb8e9de05aa517$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($ffdb8e9de05aa517$var$observer) $ffdb8e9de05aa517$var$observer.observe(target);
    return function() {
        var elementHandlers = $ffdb8e9de05aa517$var$resizeHandlers.get(target);
        if (!elementHandlers) return;
        elementHandlers.delete(handler);
        if (!elementHandlers.size && $ffdb8e9de05aa517$var$observer) $ffdb8e9de05aa517$var$observer.unobserve(target);
    };
}
var $ffdb8e9de05aa517$var$listeners = new Set();
var $ffdb8e9de05aa517$var$cleanupWindowResizeHandler;
var $ffdb8e9de05aa517$var$createResizeHandler = function() {
    var handleResize = function() {
        $ffdb8e9de05aa517$var$listeners.forEach(function(callback) {
            return callback({
                width: window.innerWidth,
                height: window.innerHeight
            });
        });
    };
    window.addEventListener("resize", handleResize);
    return function() {
        window.removeEventListener("resize", handleResize);
    };
};
var $ffdb8e9de05aa517$var$resizeWindow = function(callback) {
    $ffdb8e9de05aa517$var$listeners.add(callback);
    if (!$ffdb8e9de05aa517$var$cleanupWindowResizeHandler) $ffdb8e9de05aa517$var$cleanupWindowResizeHandler = $ffdb8e9de05aa517$var$createResizeHandler();
    return function() {
        $ffdb8e9de05aa517$var$listeners.delete(callback);
        if (!$ffdb8e9de05aa517$var$listeners.size && $ffdb8e9de05aa517$var$cleanupWindowResizeHandler) {
            $ffdb8e9de05aa517$var$cleanupWindowResizeHandler();
            $ffdb8e9de05aa517$var$cleanupWindowResizeHandler = undefined;
        }
    };
};
var $ffdb8e9de05aa517$export$45b39e67d4ce4921 = function(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.container, _container = tmp === void 0 ? document.documentElement : tmp;
    if (_container === document.documentElement) return $ffdb8e9de05aa517$var$resizeWindow(callback);
    else return $ffdb8e9de05aa517$var$resizeElement(callback, _container);
};
var $ffdb8e9de05aa517$var$progress = function(min, max, value) {
    return max - min === 0 ? 1 : (value - min) / (max - min);
};
var $ffdb8e9de05aa517$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $ffdb8e9de05aa517$var$ScrollHandler = function ScrollHandler(callback, container) {
    "use strict";
    var _this = this;
    (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, ScrollHandler);
    this.callback = void 0;
    this.container = void 0;
    this.info = void 0;
    this.createAxis = function() {
        return {
            current: 0,
            progress: 0,
            scrollLength: 0
        };
    };
    this.updateAxis = function(axisName) {
        var axis = _this.info[axisName];
        var _SCROLL_KEYS_axisName = $ffdb8e9de05aa517$var$SCROLL_KEYS[axisName], length = _SCROLL_KEYS_axisName.length, position = _SCROLL_KEYS_axisName.position;
        axis.current = _this.container["scroll".concat(position)];
        axis.scrollLength = _this.container["scroll" + length] - _this.container["client" + length];
        axis.progress = $ffdb8e9de05aa517$var$progress(0, axis.scrollLength, axis.current);
    };
    this.update = function() {
        _this.updateAxis("x");
        _this.updateAxis("y");
    };
    this.sendEvent = function() {
        _this.callback(_this.info);
    };
    this.advance = function() {
        _this.update();
        _this.sendEvent();
    };
    this.callback = callback;
    this.container = container;
    this.info = {
        time: 0,
        x: this.createAxis(),
        y: this.createAxis()
    };
};
var $ffdb8e9de05aa517$var$scrollListeners = new WeakMap();
var $ffdb8e9de05aa517$var$resizeListeners = new WeakMap();
var $ffdb8e9de05aa517$var$onScrollHandlers = new WeakMap();
var $ffdb8e9de05aa517$var$getTarget = function(container) {
    return container === document.documentElement ? window : container;
};
var $ffdb8e9de05aa517$export$d4d89fd61e5416ee = function(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.container, _container = tmp === void 0 ? document.documentElement : tmp;
    var containerHandlers = $ffdb8e9de05aa517$var$onScrollHandlers.get(_container);
    if (!containerHandlers) {
        containerHandlers = new Set();
        $ffdb8e9de05aa517$var$onScrollHandlers.set(_container, containerHandlers);
    }
    var containerHandler = new $ffdb8e9de05aa517$var$ScrollHandler(callback, _container);
    containerHandlers.add(containerHandler);
    if (!$ffdb8e9de05aa517$var$scrollListeners.has(_container)) {
        var listener = function() {
            var _containerHandlers;
            (_containerHandlers = containerHandlers) == null || _containerHandlers.forEach(function(handler) {
                return handler.advance();
            });
            return true;
        };
        $ffdb8e9de05aa517$var$scrollListeners.set(_container, listener);
        var target = $ffdb8e9de05aa517$var$getTarget(_container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (_container !== document.documentElement) $ffdb8e9de05aa517$var$resizeListeners.set(_container, $ffdb8e9de05aa517$export$45b39e67d4ce4921(listener, {
            container: _container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    var animateScroll = $ffdb8e9de05aa517$var$scrollListeners.get(_container);
    (0, $28f4a53fbe635233$export$27f233d61a9e2fa4)(animateScroll);
    return function() {
        (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).cancel(animateScroll);
        var containerHandlers = $ffdb8e9de05aa517$var$onScrollHandlers.get(_container);
        if (!containerHandlers) return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size) return;
        var listener = $ffdb8e9de05aa517$var$scrollListeners.get(_container);
        $ffdb8e9de05aa517$var$scrollListeners.delete(_container);
        if (listener) {
            var _resizeListeners$get;
            $ffdb8e9de05aa517$var$getTarget(_container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            (_resizeListeners$get = $ffdb8e9de05aa517$var$resizeListeners.get(_container)) == null || _resizeListeners$get();
        }
    };
};
function $ffdb8e9de05aa517$export$fe4300aa8eebea86(init) {
    var ref = (0, $kVN77.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $ffdb8e9de05aa517$export$700979bc83e7db82 = $ffdb8e9de05aa517$export$48d7c418edadb60c() ? (0, $kVN77.useEffect) : (0, $kVN77.useLayoutEffect);
var $ffdb8e9de05aa517$var$useIsMounted = function() {
    var isMounted = (0, $kVN77.useRef)(false);
    $ffdb8e9de05aa517$export$700979bc83e7db82(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
function $ffdb8e9de05aa517$export$91db9bc4f8ac944a() {
    var update = (0, $kVN77.useState)()[1];
    var isMounted = $ffdb8e9de05aa517$var$useIsMounted();
    return function() {
        if (isMounted.current) update(Math.random());
    };
}
function $ffdb8e9de05aa517$export$b6feb8998cd9b342(getResult, inputs) {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    }), 1), initial = _useState[0];
    var committed = (0, $kVN77.useRef)();
    var prevCache = committed.current;
    var cache = prevCache;
    if (cache) {
        var useCache = Boolean(inputs && cache.inputs && $ffdb8e9de05aa517$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $kVN77.useEffect)(function() {
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = undefined;
    }, [
        cache
    ]);
    return cache.result;
}
function $ffdb8e9de05aa517$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(var i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $ffdb8e9de05aa517$export$392544347a18b6ea = function(effect) {
    return (0, $kVN77.useEffect)(effect, $ffdb8e9de05aa517$var$emptyDeps);
};
var $ffdb8e9de05aa517$var$emptyDeps = [];
function $ffdb8e9de05aa517$export$ef7ad0c4e19d7fbf(value) {
    var prevRef = (0, $kVN77.useRef)();
    (0, $kVN77.useEffect)(function() {
        prevRef.current = value;
    });
    return prevRef.current;
}
var $ffdb8e9de05aa517$export$6a42007cf1e7b6f8 = function() {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(null), 2), reducedMotion = _useState[0], setReducedMotion = _useState[1];
    $ffdb8e9de05aa517$export$700979bc83e7db82(function() {
        var mql = window.matchMedia("(prefers-reduced-motion)");
        var handleMediaChange = function(e) {
            setReducedMotion(e.matches);
            $ffdb8e9de05aa517$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        mql.addEventListener("change", handleMediaChange);
        return function() {
            mql.removeEventListener("change", handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $kVN77 = parcelRequire("kVN77");









var $kVN77 = parcelRequire("kVN77");
var $2279bb79667a7ed1$var$$node = Symbol.for("Animated:node");
var $2279bb79667a7ed1$export$3df5e165e801a70f = function(value) {
    return !!value && value[$2279bb79667a7ed1$var$$node] === value;
};
var $2279bb79667a7ed1$export$6b63995194a3a9e4 = function(owner) {
    return owner && owner[$2279bb79667a7ed1$var$$node];
};
var $2279bb79667a7ed1$export$b553cb5b22b81b04 = function(owner, node) {
    return (0, $ffdb8e9de05aa517$export$5c74248ea0e35446)(owner, $2279bb79667a7ed1$var$$node, node);
};
var $2279bb79667a7ed1$export$ccab2b64c5d440 = function(owner) {
    return owner && owner[$2279bb79667a7ed1$var$$node] && owner[$2279bb79667a7ed1$var$$node].getPayload();
};
var $2279bb79667a7ed1$export$31627395a3b18e54 = /*#__PURE__*/ function() {
    "use strict";
    function Animated() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, Animated);
        this.payload = void 0;
        $2279bb79667a7ed1$export$b553cb5b22b81b04(this, this);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(Animated, [
        {
            key: "getPayload",
            value: function getPayload() {
                return this.payload || [];
            }
        }
    ]);
    return Animated;
}();
var $2279bb79667a7ed1$export$cb1e8f3c05d37ad5 = /*#__PURE__*/ function(Animated) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(AnimatedValue, Animated);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(AnimatedValue);
    function AnimatedValue(_value) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, AnimatedValue);
        var _this;
        _this = _super.call(this);
        _this.done = true;
        _this.elapsedTime = void 0;
        _this.lastPosition = void 0;
        _this.lastVelocity = void 0;
        _this.v0 = void 0;
        _this.durationProgress = 0;
        _this._value = _value;
        if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).num(_this._value)) _this.lastPosition = _this._value;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(AnimatedValue, [
        {
            key: "getPayload",
            value: function getPayload() {
                return [
                    this
                ];
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this._value;
            }
        },
        {
            key: "setValue",
            value: function setValue(value, step) {
                if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).num(value)) {
                    this.lastPosition = value;
                    if (step) {
                        value = Math.round(value / step) * step;
                        if (this.done) this.lastPosition = value;
                    }
                }
                if (this._value === value) return false;
                this._value = value;
                return true;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var done = this.done;
                this.done = false;
                if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).num(this._value)) {
                    this.elapsedTime = 0;
                    this.durationProgress = 0;
                    this.lastPosition = this._value;
                    if (done) this.lastVelocity = null;
                    this.v0 = null;
                }
            }
        }
    ], [
        {
            key: "create",
            value: function create(value) {
                return new AnimatedValue(value);
            }
        }
    ]);
    return AnimatedValue;
}($2279bb79667a7ed1$export$31627395a3b18e54);
var $2279bb79667a7ed1$export$f6c6c4cbd7fa5b93 = /*#__PURE__*/ function(AnimatedValue) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(AnimatedString, AnimatedValue);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(AnimatedString);
    function AnimatedString(value) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, AnimatedString);
        var _this;
        _this = _super.call(this, 0);
        _this._string = null;
        _this._toString = void 0;
        _this._toString = (0, $ffdb8e9de05aa517$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(AnimatedString, [
        {
            key: "getValue",
            value: function getValue() {
                var value = this._string;
                return value == null ? this._string = this._toString(this._value) : value;
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).str(value)) {
                    if (value == this._string) return false;
                    this._string = value;
                    this._value = 1;
                } else if ((0, $86d3ec05538b325a$export$afb3516d9d608401)((0, $2d3ab33c4b11796a$export$f09211a7d3c496a1)(AnimatedString.prototype), "setValue", this).call(this, value)) this._string = null;
                else return false;
                return true;
            }
        },
        {
            key: "reset",
            value: function reset(goal) {
                if (goal) this._toString = (0, $ffdb8e9de05aa517$export$b12af43b97697ef5)({
                    output: [
                        this.getValue(),
                        goal
                    ]
                });
                this._value = 0;
                (0, $86d3ec05538b325a$export$afb3516d9d608401)((0, $2d3ab33c4b11796a$export$f09211a7d3c496a1)(AnimatedString.prototype), "reset", this).call(this);
            }
        }
    ], [
        {
            key: "create",
            value: function create(value) {
                return new AnimatedString(value);
            }
        }
    ]);
    return AnimatedString;
}($2279bb79667a7ed1$export$cb1e8f3c05d37ad5);
var $2279bb79667a7ed1$var$TreeContext = {
    dependencies: null
};
var $2279bb79667a7ed1$export$f1b0b9e366a6e2d4 = /*#__PURE__*/ function(Animated) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(AnimatedObject, Animated);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(AnimatedObject);
    function AnimatedObject(source) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, AnimatedObject);
        var _this;
        _this = _super.call(this);
        _this.source = source;
        _this.setValue(source);
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(AnimatedObject, [
        {
            key: "getValue",
            value: function getValue(animated) {
                var values = {};
                (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(this.source, function(source, key) {
                    if ($2279bb79667a7ed1$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
                    else if ((0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $ffdb8e9de05aa517$export$e37b7520edd66839)(source);
                    else if (!animated) values[key] = source;
                });
                return values;
            }
        },
        {
            key: "setValue",
            value: function setValue(source) {
                this.source = source;
                this.payload = this._makePayload(source);
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.payload) (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(this.payload, function(node) {
                    return node.reset();
                });
            }
        },
        {
            key: "_makePayload",
            value: function _makePayload(source) {
                if (source) {
                    var payload = new Set();
                    (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
                    return Array.from(payload);
                }
            }
        },
        {
            key: "_addToPayload",
            value: function _addToPayload(source) {
                var _this = this;
                if ($2279bb79667a7ed1$var$TreeContext.dependencies && (0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(source)) $2279bb79667a7ed1$var$TreeContext.dependencies.add(source);
                var payload = $2279bb79667a7ed1$export$ccab2b64c5d440(source);
                if (payload) (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(payload, function(node) {
                    return _this.add(node);
                });
            }
        }
    ]);
    return AnimatedObject;
}($2279bb79667a7ed1$export$31627395a3b18e54);
var $2279bb79667a7ed1$export$ede394683406942d = /*#__PURE__*/ function(AnimatedObject) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(AnimatedArray, AnimatedObject);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(AnimatedArray);
    function AnimatedArray(source) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, AnimatedArray);
        return _super.call(this, source);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(AnimatedArray, [
        {
            key: "getValue",
            value: function getValue() {
                return this.source.map(function(node) {
                    return node.getValue();
                });
            }
        },
        {
            key: "setValue",
            value: function setValue(source) {
                var payload = this.getPayload();
                if (source.length == payload.length) return payload.map(function(node, i) {
                    return node.setValue(source[i]);
                }).some(Boolean);
                (0, $86d3ec05538b325a$export$afb3516d9d608401)((0, $2d3ab33c4b11796a$export$f09211a7d3c496a1)(AnimatedArray.prototype), "setValue", this).call(this, source.map($2279bb79667a7ed1$var$makeAnimated));
                return true;
            }
        }
    ], [
        {
            key: "create",
            value: function create(source) {
                return new AnimatedArray(source);
            }
        }
    ]);
    return AnimatedArray;
}($2279bb79667a7ed1$export$f1b0b9e366a6e2d4);
function $2279bb79667a7ed1$var$makeAnimated(value) {
    var nodeType = (0, $ffdb8e9de05aa517$export$75bed621f62abfa9)(value) ? $2279bb79667a7ed1$export$f6c6c4cbd7fa5b93 : $2279bb79667a7ed1$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $2279bb79667a7ed1$export$e6b77ddbe47b132e(value) {
    var parentNode = $2279bb79667a7ed1$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(value) ? $2279bb79667a7ed1$export$ede394683406942d : (0, $ffdb8e9de05aa517$export$75bed621f62abfa9)(value) ? $2279bb79667a7ed1$export$f6c6c4cbd7fa5b93 : $2279bb79667a7ed1$export$cb1e8f3c05d37ad5;
}
function $2279bb79667a7ed1$var$_extends() {
    $2279bb79667a7ed1$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2279bb79667a7ed1$var$_extends.apply(this, arguments);
}
var $2279bb79667a7ed1$var$withAnimated = function(Component, host) {
    var hasInstance = !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $kVN77.forwardRef)(function(givenProps, givenRef) {
        var instanceRef = (0, $kVN77.useRef)(null);
        var ref = hasInstance && (0, $kVN77.useCallback)(function(value) {
            instanceRef.current = $2279bb79667a7ed1$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        var _getAnimatedState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($2279bb79667a7ed1$var$getAnimatedState(givenProps, host), 2), props = _getAnimatedState[0], deps = _getAnimatedState[1];
        var forceUpdate = (0, $ffdb8e9de05aa517$export$91db9bc4f8ac944a)();
        var callback = function() {
            var instance = instanceRef.current;
            if (hasInstance && !instance) return;
            var didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        var observer = new $2279bb79667a7ed1$var$PropsObserver(callback, deps);
        var observerRef = (0, $kVN77.useRef)();
        (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
            observerRef.current = observer;
            (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(deps, function(dep) {
                return (0, $ffdb8e9de05aa517$export$72d604e3f8d000a5)(dep, observer);
            });
            return function() {
                if (observerRef.current) {
                    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(observerRef.current.deps, function(dep) {
                        return (0, $ffdb8e9de05aa517$export$7a0eb830d336339b)(dep, observerRef.current);
                    });
                    (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $kVN77.useEffect)(callback, []);
        (0, $ffdb8e9de05aa517$export$392544347a18b6ea)(function() {
            return function() {
                var observer = observerRef.current;
                (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(observer.deps, function(dep) {
                    return (0, $ffdb8e9de05aa517$export$7a0eb830d336339b)(dep, observer);
                });
            };
        });
        var usedProps = host.getComponentProps(props.getValue());
        return $kVN77.createElement(Component, $2279bb79667a7ed1$var$_extends({}, usedProps, {
            ref: ref
        }));
    });
};
var $2279bb79667a7ed1$var$PropsObserver = /*#__PURE__*/ function() {
    "use strict";
    function PropsObserver(update, deps) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, PropsObserver);
        this.update = update;
        this.deps = deps;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(PropsObserver, [
        {
            key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).write(this.update);
            }
        }
    ]);
    return PropsObserver;
}();
function $2279bb79667a7ed1$var$getAnimatedState(props, host) {
    var dependencies = new Set();
    $2279bb79667a7ed1$var$TreeContext.dependencies = dependencies;
    if (props.style) props = $2279bb79667a7ed1$var$_extends({}, props, {
        style: host.createAnimatedStyle(props.style)
    });
    props = new $2279bb79667a7ed1$export$f1b0b9e366a6e2d4(props);
    $2279bb79667a7ed1$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $2279bb79667a7ed1$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
var $2279bb79667a7ed1$var$cacheKey = Symbol.for("AnimatedComponent");
var $2279bb79667a7ed1$export$4ee5c78f6dcbcef = function(components) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.applyAnimatedValues, _applyAnimatedValues = tmp === void 0 ? function() {
        return false;
    } : tmp, tmp1 = _ref.createAnimatedStyle, _createAnimatedStyle = tmp1 === void 0 ? function(style) {
        return new $2279bb79667a7ed1$export$f1b0b9e366a6e2d4(style);
    } : tmp1, tmp2 = _ref.getComponentProps, _getComponentProps = tmp2 === void 0 ? function(props) {
        return props;
    } : tmp2;
    var hostConfig = {
        applyAnimatedValues: _applyAnimatedValues,
        createAnimatedStyle: _createAnimatedStyle,
        getComponentProps: _getComponentProps
    };
    var animated = function(Component) {
        var displayName = $2279bb79667a7ed1$var$getDisplayName(Component) || "Anonymous";
        if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $2279bb79667a7ed1$var$withAnimated(Component, hostConfig));
        else Component = Component[$2279bb79667a7ed1$var$cacheKey] || (Component[$2279bb79667a7ed1$var$cacheKey] = $2279bb79667a7ed1$var$withAnimated(Component, hostConfig));
        Component.displayName = "Animated(".concat(displayName, ")");
        return Component;
    };
    (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(components, function(Component, key) {
        if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(components)) key = $2279bb79667a7ed1$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $2279bb79667a7ed1$var$getDisplayName = function(arg) {
    return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;
};






function $e593c995dca2acdf$var$_extends() {
    $e593c995dca2acdf$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e593c995dca2acdf$var$_extends.apply(this, arguments);
}
function $e593c995dca2acdf$var$callProp(value) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(value) ? value.apply(void 0, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(args)) : value;
}
var $e593c995dca2acdf$var$matchProp = function(value, key) {
    return value === true || !!(key && value && ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $ffdb8e9de05aa517$export$45b10814cc054894)(value).includes(key)));
};
var $e593c995dca2acdf$var$resolveProp = function(prop, key) {
    return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
};
var $e593c995dca2acdf$var$getDefaultProp = function(props, key) {
    return props.default === true ? props[key] : props.default ? props.default[key] : undefined;
};
var $e593c995dca2acdf$var$noopTransform = function(value) {
    return value;
};
var $e593c995dca2acdf$var$getDefaultProps = function(props) {
    var transform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e593c995dca2acdf$var$noopTransform;
    var keys = $e593c995dca2acdf$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    var defaults = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var value = transform(props[key], key);
            if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(value)) defaults[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return defaults;
};
var $e593c995dca2acdf$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $e593c995dca2acdf$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    keys: 1,
    callId: 1,
    parentId: 1
};
function $e593c995dca2acdf$var$getForwardProps(props) {
    var forward = {};
    var count = 0;
    (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(props, function(value, prop) {
        if (!$e593c995dca2acdf$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $e593c995dca2acdf$export$b971039a739bf227(props) {
    var to = $e593c995dca2acdf$var$getForwardProps(props);
    if (to) {
        var out = {
            to: to
        };
        (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(props, function(val, key) {
            return key in to || (out[key] = val);
        });
        return out;
    }
    return $e593c995dca2acdf$var$_extends({}, props);
}
function $e593c995dca2acdf$var$computeGoal(value) {
    value = (0, $ffdb8e9de05aa517$export$e37b7520edd66839)(value);
    return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(value) ? value.map($e593c995dca2acdf$var$computeGoal) : (0, $ffdb8e9de05aa517$export$75bed621f62abfa9)(value) ? (0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $e593c995dca2acdf$var$hasProps(props) {
    for(var _ in props)return true;
    return false;
}
function $e593c995dca2acdf$var$isAsyncTo(to) {
    return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(to) || (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(to) && (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(to[0]);
}
function $e593c995dca2acdf$var$detachRefs(ctrl, ref) {
    var _ctrl$ref;
    (_ctrl$ref = ctrl.ref) == null || _ctrl$ref.delete(ctrl);
    ref == null || ref.delete(ctrl);
}
function $e593c995dca2acdf$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        var _ctrl$ref2;
        (_ctrl$ref2 = ctrl.ref) == null || _ctrl$ref2.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
function $e593c995dca2acdf$export$a4a17273dffcc09c(refs, timeSteps) {
    var timeFrame = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        if (timeSteps) {
            var prevDelay = 0;
            (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(refs, function(ref, i) {
                var controllers = ref.current;
                if (controllers.length) {
                    var delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(controllers, function(ctrl) {
                        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(ctrl.queue, function(props) {
                            var memoizedDelayProp = props.delay;
                            props.delay = function(key) {
                                return delay + $e593c995dca2acdf$var$callProp(memoizedDelayProp || 0, key);
                            };
                        });
                    });
                    ref.start();
                }
            });
        } else {
            var p = Promise.resolve();
            (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(refs, function(ref) {
                var controllers = ref.current;
                if (controllers.length) {
                    var queues = controllers.map(function(ctrl) {
                        var q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(function() {
                        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(controllers, function(ctrl, i) {
                            return (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(queues[i] || [], function(update) {
                                return ctrl.queue.push(update);
                            });
                        });
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
var $e593c995dca2acdf$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
var $e593c995dca2acdf$var$defaults = $e593c995dca2acdf$var$_extends({}, $e593c995dca2acdf$export$e506a1d27d1eaa20.default, {
    mass: 1,
    damping: 1,
    easing: (0, $ffdb8e9de05aa517$export$15a0bf1b4bbacad8).linear,
    clamp: false
});
var $e593c995dca2acdf$var$AnimationConfig = function AnimationConfig() {
    "use strict";
    (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, AnimationConfig);
    this.tension = void 0;
    this.friction = void 0;
    this.frequency = void 0;
    this.damping = void 0;
    this.mass = void 0;
    this.velocity = 0;
    this.restVelocity = void 0;
    this.precision = void 0;
    this.progress = void 0;
    this.duration = void 0;
    this.easing = void 0;
    this.clamp = void 0;
    this.bounce = void 0;
    this.decay = void 0;
    this.round = void 0;
    Object.assign(this, $e593c995dca2acdf$var$defaults);
};
function $e593c995dca2acdf$var$mergeConfig(config, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = $e593c995dca2acdf$var$_extends({}, defaultConfig);
        $e593c995dca2acdf$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = $e593c995dca2acdf$var$_extends({}, defaultConfig, newConfig);
    }
    $e593c995dca2acdf$var$sanitizeConfig(config, newConfig);
    Object.assign(config, newConfig);
    for(var key in $e593c995dca2acdf$var$defaults)if (config[key] == null) config[key] = $e593c995dca2acdf$var$defaults[key];
    var mass = config.mass, frequency = config.frequency, damping = config.damping;
    if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config;
}
function $e593c995dca2acdf$var$sanitizeConfig(config, props) {
    if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.decay)) config.duration = undefined;
    else {
        var isTensionConfig = !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.tension) || !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.damping) || !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.mass)) {
            config.duration = undefined;
            config.decay = undefined;
        }
        if (isTensionConfig) config.frequency = undefined;
    }
}
var $e593c995dca2acdf$var$emptyArray = [];
var $e593c995dca2acdf$var$Animation = function Animation() {
    "use strict";
    (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, Animation);
    this.changed = false;
    this.values = $e593c995dca2acdf$var$emptyArray;
    this.toValues = null;
    this.fromValues = $e593c995dca2acdf$var$emptyArray;
    this.to = void 0;
    this.from = void 0;
    this.config = new $e593c995dca2acdf$var$AnimationConfig();
    this.immediate = false;
};
function $e593c995dca2acdf$var$scheduleProps(callId, param) {
    var key = param.key, props = param.props, defaultProps = param.defaultProps, state = param.state, actions = param.actions;
    return new Promise(function(resolve, reject) {
        var _props$cancel;
        var delay;
        var timeout;
        var cancel = $e593c995dca2acdf$var$matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $e593c995dca2acdf$var$matchProp(props.pause, key);
            var pause = defaultProps == null ? void 0 : defaultProps.pause;
            if (pause !== true) pause = state.paused || $e593c995dca2acdf$var$matchProp(pause, key);
            delay = $e593c995dca2acdf$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start($e593c995dca2acdf$var$_extends({}, props, {
                    callId: callId,
                    cancel: cancel
                }), resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
var $e593c995dca2acdf$var$getCombinedResult = function(target, results) {
    return results.length == 1 ? results[0] : results.some(function(result) {
        return result.cancelled;
    }) ? $e593c995dca2acdf$var$getCancelledResult(target.get()) : results.every(function(result) {
        return result.noop;
    }) ? $e593c995dca2acdf$var$getNoopResult(target.get()) : $e593c995dca2acdf$var$getFinishedResult(target.get(), results.every(function(result) {
        return result.finished;
    }));
};
var $e593c995dca2acdf$var$getNoopResult = function(value) {
    return {
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    };
};
var $e593c995dca2acdf$var$getFinishedResult = function(value, finished) {
    var cancelled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return {
        value: value,
        finished: finished,
        cancelled: cancelled
    };
};
var $e593c995dca2acdf$var$getCancelledResult = function(value) {
    return {
        value: value,
        cancelled: true,
        finished: false
    };
};
function $e593c995dca2acdf$var$runAsync(to, props, state, target) {
    var callId = props.callId, parentId = props.parentId, onRest = props.onRest;
    var prevTo = state.asyncTo, prevPromise = state.promise;
    if (!parentId && to === prevTo && !props.reset) return prevPromise;
    return state.promise = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var defaultProps, preventBail, bail, bailPromise, bailIfEnded, animate, result, animating, err1;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    state.asyncId = callId;
                    state.asyncTo = to;
                    defaultProps = $e593c995dca2acdf$var$getDefaultProps(props, function(value, key) {
                        return key === "onRest" ? undefined : value;
                    });
                    bailPromise = new Promise(function(resolve, reject) {
                        return preventBail = resolve, bail = reject;
                    });
                    bailIfEnded = function(bailSignal) {
                        var bailResult = callId <= (state.cancelId || 0) && $e593c995dca2acdf$var$getCancelledResult(target) || callId !== state.asyncId && $e593c995dca2acdf$var$getFinishedResult(target, false);
                        if (bailResult) {
                            bailSignal.result = bailResult;
                            bail(bailSignal);
                            throw bailSignal;
                        }
                    };
                    animate = function(arg1, arg2) {
                        var bailSignal = new $e593c995dca2acdf$export$d362d093fa99dc7();
                        var skipAnimationSignal = new $e593c995dca2acdf$var$SkipAnimationSignal();
                        return (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                            var _$props, result;
                            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if ((0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).skipAnimation) {
                                            $e593c995dca2acdf$var$stopAsync(state);
                                            skipAnimationSignal.result = $e593c995dca2acdf$var$getFinishedResult(target, false);
                                            bail(skipAnimationSignal);
                                            throw skipAnimationSignal;
                                        }
                                        bailIfEnded(bailSignal);
                                        _$props = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(arg1) ? $e593c995dca2acdf$var$_extends({}, arg1) : $e593c995dca2acdf$var$_extends({}, arg2, {
                                            to: arg1
                                        });
                                        _$props.parentId = callId;
                                        (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(defaultProps, function(value, key) {
                                            if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(_$props[key])) _$props[key] = value;
                                        });
                                        return [
                                            4,
                                            target.start(_$props)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        bailIfEnded(bailSignal);
                                        if (!state.paused) return [
                                            3,
                                            3
                                        ];
                                        return [
                                            4,
                                            new Promise(function(resume) {
                                                state.resumeQueue.add(resume);
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        _state.label = 3;
                                    case 3:
                                        return [
                                            2,
                                            result
                                        ];
                                }
                            });
                        })();
                    };
                    if ((0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).skipAnimation) {
                        $e593c995dca2acdf$var$stopAsync(state);
                        return [
                            2,
                            $e593c995dca2acdf$var$getFinishedResult(target, false)
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(to)) animating = (function() {
                        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(queue) {
                            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$props, err;
                            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            7,
                                            8
                                        ]);
                                        _iterator = queue[Symbol.iterator]();
                                        _state.label = 2;
                                    case 2:
                                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                            3,
                                            5
                                        ];
                                        _$props = _step.value;
                                        return [
                                            4,
                                            animate(_$props)
                                        ];
                                    case 3:
                                        _state.sent();
                                        _state.label = 4;
                                    case 4:
                                        _iteratorNormalCompletion = true;
                                        return [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 6:
                                        err = _state.sent();
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                        return [
                                            3,
                                            8
                                        ];
                                    case 7:
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                        return [
                                            7
                                        ];
                                    case 8:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(queue) {
                            return _ref.apply(this, arguments);
                        };
                    })()(to);
                    else animating = Promise.resolve(to(animate, target.stop.bind(target)));
                    return [
                        4,
                        Promise.all([
                            animating.then(preventBail),
                            bailPromise
                        ])
                    ];
                case 2:
                    _state.sent();
                    result = $e593c995dca2acdf$var$getFinishedResult(target.get(), true, false);
                    return [
                        3,
                        5
                    ];
                case 3:
                    err1 = _state.sent();
                    if (err1 instanceof $e593c995dca2acdf$export$d362d093fa99dc7) result = err1.result;
                    else if (err1 instanceof $e593c995dca2acdf$var$SkipAnimationSignal) result = err1.result;
                    else throw err1;
                    return [
                        3,
                        5
                    ];
                case 4:
                    if (callId == state.asyncId) {
                        state.asyncId = parentId;
                        state.asyncTo = parentId ? prevTo : undefined;
                        state.promise = parentId ? prevPromise : undefined;
                    }
                    return [
                        7
                    ];
                case 5:
                    if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(onRest)) (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).batchedUpdates(function() {
                        onRest(result, target, target.item);
                    });
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function $e593c995dca2acdf$var$stopAsync(state, cancelId) {
    (0, $ffdb8e9de05aa517$export$4909b86c8034bf73)(state.timeouts, function(t) {
        return t.cancel();
    });
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = undefined;
    if (cancelId) state.cancelId = cancelId;
}
var $e593c995dca2acdf$export$d362d093fa99dc7 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(BailSignal, Error1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(BailSignal);
    function BailSignal() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, BailSignal);
        var _this;
        _this = _super.call(this, "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
        _this.result = void 0;
        return _this;
    }
    return BailSignal;
}((0, $efec3851c979cc44$export$2466d533fda16e33)(Error));
var $e593c995dca2acdf$var$SkipAnimationSignal = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(SkipAnimationSignal, Error1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(SkipAnimationSignal);
    function SkipAnimationSignal() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, SkipAnimationSignal);
        var _this;
        _this = _super.call(this, "SkipAnimationSignal");
        _this.result = void 0;
        return _this;
    }
    return SkipAnimationSignal;
}((0, $efec3851c979cc44$export$2466d533fda16e33)(Error));
var $e593c995dca2acdf$var$isFrameValue = function(value) {
    return value instanceof $e593c995dca2acdf$export$8229896f80e2495e;
};
var $e593c995dca2acdf$var$nextId$1 = 1;
var $e593c995dca2acdf$export$8229896f80e2495e = /*#__PURE__*/ function(FluidValue) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(FrameValue, FluidValue);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(FrameValue);
    function FrameValue() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, FrameValue);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(args)));
        _this.id = $e593c995dca2acdf$var$nextId$1++;
        _this.key = void 0;
        _this._priority = 0;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(FrameValue, [
        {
            key: "priority",
            get: function get() {
                return this._priority;
            },
            set: function set(priority) {
                if (this._priority != priority) {
                    this._priority = priority;
                    this._onPriorityChange(priority);
                }
            }
        },
        {
            key: "get",
            value: function get() {
                var node = (0, $2279bb79667a7ed1$export$6b63995194a3a9e4)(this);
                return node && node.getValue();
            }
        },
        {
            key: "to",
            value: function to() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).to(this, args);
            }
        },
        {
            key: "interpolate",
            value: function interpolate() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                (0, $ffdb8e9de05aa517$export$2abfcde8ae218ba8)();
                return (0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).to(this, args);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.get();
            }
        },
        {
            key: "observerAdded",
            value: function observerAdded(count) {
                if (count == 1) this._attach();
            }
        },
        {
            key: "observerRemoved",
            value: function observerRemoved(count) {
                if (count == 0) this._detach();
            }
        },
        {
            key: "_attach",
            value: function _attach() {}
        },
        {
            key: "_detach",
            value: function _detach() {}
        },
        {
            key: "_onChange",
            value: function _onChange(value) {
                var idle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                (0, $ffdb8e9de05aa517$export$31752c40a5fab62a)(this, {
                    type: "change",
                    parent: this,
                    value: value,
                    idle: idle
                });
            }
        },
        {
            key: "_onPriorityChange",
            value: function _onPriorityChange(priority) {
                if (!this.idle) (0, $ffdb8e9de05aa517$export$a57f5080a3bcc90a).sort(this);
                (0, $ffdb8e9de05aa517$export$31752c40a5fab62a)(this, {
                    type: "priority",
                    parent: this,
                    priority: priority
                });
            }
        }
    ]);
    return FrameValue;
}((0, $ffdb8e9de05aa517$export$aff8e1ac1a016a2));
var $e593c995dca2acdf$var$$P = Symbol.for("SpringPhase");
var $e593c995dca2acdf$var$HAS_ANIMATED = 1;
var $e593c995dca2acdf$var$IS_ANIMATING = 2;
var $e593c995dca2acdf$var$IS_PAUSED = 4;
var $e593c995dca2acdf$var$hasAnimated = function(target) {
    return (target[$e593c995dca2acdf$var$$P] & $e593c995dca2acdf$var$HAS_ANIMATED) > 0;
};
var $e593c995dca2acdf$var$isAnimating = function(target) {
    return (target[$e593c995dca2acdf$var$$P] & $e593c995dca2acdf$var$IS_ANIMATING) > 0;
};
var $e593c995dca2acdf$var$isPaused = function(target) {
    return (target[$e593c995dca2acdf$var$$P] & $e593c995dca2acdf$var$IS_PAUSED) > 0;
};
var $e593c995dca2acdf$var$setActiveBit = function(target, active) {
    return active ? target[$e593c995dca2acdf$var$$P] |= $e593c995dca2acdf$var$IS_ANIMATING | $e593c995dca2acdf$var$HAS_ANIMATED : target[$e593c995dca2acdf$var$$P] &= ~$e593c995dca2acdf$var$IS_ANIMATING;
};
var $e593c995dca2acdf$var$setPausedBit = function(target, paused) {
    return paused ? target[$e593c995dca2acdf$var$$P] |= $e593c995dca2acdf$var$IS_PAUSED : target[$e593c995dca2acdf$var$$P] &= ~$e593c995dca2acdf$var$IS_PAUSED;
};
var $e593c995dca2acdf$export$5854d13427d5a954 = /*#__PURE__*/ function(FrameValue) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(SpringValue, FrameValue);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(SpringValue);
    function SpringValue(arg1, arg2) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, SpringValue);
        var _this;
        _this = _super.call(this);
        _this.key = void 0;
        _this.animation = new $e593c995dca2acdf$var$Animation();
        _this.queue = void 0;
        _this.defaultProps = {};
        _this._state = {
            paused: false,
            delayed: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        _this._pendingCalls = new Set();
        _this._lastCallId = 0;
        _this._lastToId = 0;
        _this._memoizedDuration = 0;
        if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(arg1) || !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(arg2)) {
            var props = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(arg1) ? $e593c995dca2acdf$var$_extends({}, arg1) : $e593c995dca2acdf$var$_extends({}, arg2, {
                from: arg1
            });
            if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            _this.start(props);
        }
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(SpringValue, [
        {
            key: "idle",
            get: function get() {
                return !($e593c995dca2acdf$var$isAnimating(this) || this._state.asyncTo) || $e593c995dca2acdf$var$isPaused(this);
            }
        },
        {
            key: "goal",
            get: function get() {
                return (0, $ffdb8e9de05aa517$export$e37b7520edd66839)(this.animation.to);
            }
        },
        {
            key: "velocity",
            get: function get() {
                var node = (0, $2279bb79667a7ed1$export$6b63995194a3a9e4)(this);
                return node instanceof (0, $2279bb79667a7ed1$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map(function(node) {
                    return node.lastVelocity || 0;
                });
            }
        },
        {
            key: "hasAnimated",
            get: function get() {
                return $e593c995dca2acdf$var$hasAnimated(this);
            }
        },
        {
            key: "isAnimating",
            get: function get() {
                return $e593c995dca2acdf$var$isAnimating(this);
            }
        },
        {
            key: "isPaused",
            get: function get() {
                return $e593c995dca2acdf$var$isPaused(this);
            }
        },
        {
            key: "isDelayed",
            get: function get() {
                return this._state.delayed;
            }
        },
        {
            key: "advance",
            value: function advance(dt) {
                var _this = this;
                var idle = true;
                var changed = false;
                var anim = this.animation;
                var config = anim.config, toValues = anim.toValues;
                var payload = (0, $2279bb79667a7ed1$export$ccab2b64c5d440)(anim.to);
                if (!payload && (0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $ffdb8e9de05aa517$export$45b10814cc054894)((0, $ffdb8e9de05aa517$export$e37b7520edd66839)(anim.to));
                anim.values.forEach(function(node, i) {
                    if (node.done) return;
                    var to = node.constructor == (0, $2279bb79667a7ed1$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
                    var finished = anim.immediate;
                    var position = to;
                    if (!finished) {
                        position = node.lastPosition;
                        if (config.tension <= 0) {
                            node.done = true;
                            return;
                        }
                        var elapsed = node.elapsedTime += dt;
                        var from = anim.fromValues[i];
                        var v0 = node.v0 != null ? node.v0 : node.v0 = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(config.velocity) ? config.velocity[i] : config.velocity;
                        var velocity;
                        var precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));
                        if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(config.duration)) {
                            var p = 1;
                            if (config.duration > 0) {
                                if (_this._memoizedDuration !== config.duration) {
                                    _this._memoizedDuration = config.duration;
                                    if (node.durationProgress > 0) {
                                        node.elapsedTime = config.duration * node.durationProgress;
                                        elapsed = node.elapsedTime += dt;
                                    }
                                }
                                p = (config.progress || 0) + elapsed / _this._memoizedDuration;
                                p = p > 1 ? 1 : p < 0 ? 0 : p;
                                node.durationProgress = p;
                            }
                            position = from + config.easing(p) * (to - from);
                            velocity = (position - node.lastPosition) / dt;
                            finished = p == 1;
                        } else if (config.decay) {
                            var decay = config.decay === true ? 0.998 : config.decay;
                            var e = Math.exp(-(1 - decay) * elapsed);
                            position = from + v0 / (1 - decay) * (1 - e);
                            finished = Math.abs(node.lastPosition - position) <= precision;
                            velocity = v0 * e;
                        } else {
                            velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
                            var restVelocity = config.restVelocity || precision / 10;
                            var bounceFactor = config.clamp ? 0 : config.bounce;
                            var canBounce = !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(bounceFactor);
                            var isGrowing = from == to ? node.v0 > 0 : from < to;
                            var isMoving;
                            var isBouncing = false;
                            var step = 1;
                            var numSteps = Math.ceil(dt / step);
                            for(var n = 0; n < numSteps; ++n){
                                isMoving = Math.abs(velocity) > restVelocity;
                                if (!isMoving) {
                                    finished = Math.abs(to - position) <= precision;
                                    if (finished) break;
                                }
                                if (canBounce) {
                                    isBouncing = position == to || position > to == isGrowing;
                                    if (isBouncing) {
                                        velocity = -velocity * bounceFactor;
                                        position = to;
                                    }
                                }
                                var springForce = -config.tension * 0.000001 * (position - to);
                                var dampingForce = -config.friction * 0.001 * velocity;
                                var acceleration = (springForce + dampingForce) / config.mass;
                                velocity = velocity + acceleration * step;
                                position = position + velocity * step;
                            }
                        }
                        node.lastVelocity = velocity;
                        if (Number.isNaN(position)) {
                            console.warn("Got NaN while animating:", _this);
                            finished = true;
                        }
                    }
                    if (payload && !payload[i].done) finished = false;
                    if (finished) node.done = true;
                    else idle = false;
                    if (node.setValue(position, config.round)) changed = true;
                });
                var node = (0, $2279bb79667a7ed1$export$6b63995194a3a9e4)(this);
                var currVal = node.getValue();
                if (idle) {
                    var finalVal = (0, $ffdb8e9de05aa517$export$e37b7520edd66839)(anim.to);
                    if ((currVal !== finalVal || changed) && !config.decay) {
                        node.setValue(finalVal);
                        this._onChange(finalVal);
                    } else if (changed && config.decay) this._onChange(currVal);
                    this._stop();
                } else if (changed) this._onChange(currVal);
            }
        },
        {
            key: "set",
            value: function set(value) {
                var _this = this;
                (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).batchedUpdates(function() {
                    _this._stop();
                    _this._focus(value);
                    _this._set(value);
                });
                return this;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._update({
                    pause: true
                });
            }
        },
        {
            key: "resume",
            value: function resume() {
                this._update({
                    pause: false
                });
            }
        },
        {
            key: "finish",
            value: function finish() {
                var _this = this;
                if ($e593c995dca2acdf$var$isAnimating(this)) {
                    var _this_animation = this.animation, to = _this_animation.to, config = _this_animation.config;
                    (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).batchedUpdates(function() {
                        _this._onStart();
                        if (!config.decay) _this._set(to, false);
                        _this._stop();
                    });
                }
                return this;
            }
        },
        {
            key: "update",
            value: function update(props) {
                var queue = this.queue || (this.queue = []);
                queue.push(props);
                return this;
            }
        },
        {
            key: "start",
            value: function start(to, arg2) {
                var _this = this;
                var queue;
                if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(to)) queue = [
                    (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(to) ? to : $e593c995dca2acdf$var$_extends({}, arg2, {
                        to: to
                    })
                ];
                else {
                    queue = this.queue || [];
                    this.queue = [];
                }
                return Promise.all(queue.map(function(props) {
                    var up = _this._update(props);
                    return up;
                })).then(function(results) {
                    return $e593c995dca2acdf$var$getCombinedResult(_this, results);
                });
            }
        },
        {
            key: "stop",
            value: function stop(cancel) {
                var _this = this;
                var to = this.animation.to;
                this._focus(this.get());
                $e593c995dca2acdf$var$stopAsync(this._state, cancel && this._lastCallId);
                (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).batchedUpdates(function() {
                    return _this._stop(to, cancel);
                });
                return this;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._update({
                    reset: true
                });
            }
        },
        {
            key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") this._start();
                else if (event.type == "priority") this.priority = event.priority + 1;
            }
        },
        {
            key: "_prepareNode",
            value: function _prepareNode(props) {
                var key = this.key || "";
                var to = props.to, from = props.from;
                to = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(to) ? to[key] : to;
                if (to == null || $e593c995dca2acdf$var$isAsyncTo(to)) to = undefined;
                from = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
                if (from == null) from = undefined;
                var range = {
                    to: to,
                    from: from
                };
                if (!$e593c995dca2acdf$var$hasAnimated(this)) {
                    var ref;
                    if (props.reverse) ref = [
                        from,
                        to
                    ], to = ref[0], from = ref[1], ref;
                    from = (0, $ffdb8e9de05aa517$export$e37b7520edd66839)(from);
                    if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(from)) this._set(from);
                    else if (!(0, $2279bb79667a7ed1$export$6b63995194a3a9e4)(this)) this._set(to);
                }
                return range;
            }
        },
        {
            key: "_update",
            value: function _update(_ref, isLoop) {
                var _this = this;
                var props = $e593c995dca2acdf$var$_extends({}, _ref);
                var _this1 = this, key = _this1.key, defaultProps = _this1.defaultProps;
                if (props.default) Object.assign(defaultProps, $e593c995dca2acdf$var$getDefaultProps(props, function(value, prop) {
                    return /^on/.test(prop) ? $e593c995dca2acdf$var$resolveProp(value, key) : value;
                }));
                $e593c995dca2acdf$var$mergeActiveFn(this, props, "onProps");
                $e593c995dca2acdf$var$sendEvent(this, "onProps", props, this);
                var range = this._prepareNode(props);
                if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
                var state = this._state;
                return $e593c995dca2acdf$var$scheduleProps(++this._lastCallId, {
                    key: key,
                    props: props,
                    defaultProps: defaultProps,
                    state: state,
                    actions: {
                        pause: function() {
                            if (!$e593c995dca2acdf$var$isPaused(_this)) {
                                $e593c995dca2acdf$var$setPausedBit(_this, true);
                                (0, $ffdb8e9de05aa517$export$7ba486852759e806)(state.pauseQueue);
                                $e593c995dca2acdf$var$sendEvent(_this, "onPause", $e593c995dca2acdf$var$getFinishedResult(_this, $e593c995dca2acdf$var$checkFinished(_this, _this.animation.to)), _this);
                            }
                        },
                        resume: function() {
                            if ($e593c995dca2acdf$var$isPaused(_this)) {
                                $e593c995dca2acdf$var$setPausedBit(_this, false);
                                if ($e593c995dca2acdf$var$isAnimating(_this)) _this._resume();
                                (0, $ffdb8e9de05aa517$export$7ba486852759e806)(state.resumeQueue);
                                $e593c995dca2acdf$var$sendEvent(_this, "onResume", $e593c995dca2acdf$var$getFinishedResult(_this, $e593c995dca2acdf$var$checkFinished(_this, _this.animation.to)), _this);
                            }
                        },
                        start: this._merge.bind(this, range)
                    }
                }).then(function(result) {
                    if (props.loop && result.finished && !(isLoop && result.noop)) {
                        var nextProps = $e593c995dca2acdf$var$createLoopUpdate(props);
                        if (nextProps) return _this._update(nextProps, true);
                    }
                    return result;
                });
            }
        },
        {
            key: "_merge",
            value: function _merge(range, props, resolve) {
                var _this = this;
                if (props.cancel) {
                    this.stop(true);
                    return resolve($e593c995dca2acdf$var$getCancelledResult(this));
                }
                var hasToProp = !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(range.to);
                var hasFromProp = !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(range.from);
                if (hasToProp || hasFromProp) {
                    if (props.callId > this._lastToId) this._lastToId = props.callId;
                    else return resolve($e593c995dca2acdf$var$getCancelledResult(this));
                }
                var _this1 = this, key = _this1.key, defaultProps = _this1.defaultProps, anim = _this1.animation;
                var prevTo = anim.to, prevFrom = anim.from;
                var _range_to = range.to, to = _range_to === void 0 ? prevTo : _range_to, _range_from = range.from, from = _range_from === void 0 ? prevFrom : _range_from;
                if (hasFromProp && !hasToProp && (!props.default || (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(to))) to = from;
                var ref;
                if (props.reverse) ref = [
                    from,
                    to
                ], to = ref[0], from = ref[1], ref;
                var hasFromChanged = !(0, $ffdb8e9de05aa517$export$248d38f6296296c5)(from, prevFrom);
                if (hasFromChanged) anim.from = from;
                from = (0, $ffdb8e9de05aa517$export$e37b7520edd66839)(from);
                var hasToChanged = !(0, $ffdb8e9de05aa517$export$248d38f6296296c5)(to, prevTo);
                if (hasToChanged) this._focus(to);
                var hasAsyncTo = $e593c995dca2acdf$var$isAsyncTo(props.to);
                var config = anim.config;
                var decay = config.decay, velocity = config.velocity;
                if (hasToProp || hasFromProp) config.velocity = 0;
                if (props.config && !hasAsyncTo) $e593c995dca2acdf$var$mergeConfig(config, $e593c995dca2acdf$var$callProp(props.config, key), props.config !== defaultProps.config ? $e593c995dca2acdf$var$callProp(defaultProps.config, key) : void 0);
                var node = (0, $2279bb79667a7ed1$export$6b63995194a3a9e4)(this);
                if (!node || (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(to)) return resolve($e593c995dca2acdf$var$getFinishedResult(this, true));
                var reset = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(from) && $e593c995dca2acdf$var$matchProp(props.reset, key);
                var value = reset ? from : this.get();
                var goal = $e593c995dca2acdf$var$computeGoal(to);
                var isAnimatable = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).num(goal) || (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(goal) || (0, $ffdb8e9de05aa517$export$75bed621f62abfa9)(goal);
                var immediate = !hasAsyncTo && (!isAnimatable || $e593c995dca2acdf$var$matchProp(defaultProps.immediate || props.immediate, key));
                if (hasToChanged) {
                    var nodeType = (0, $2279bb79667a7ed1$export$e6b77ddbe47b132e)(to);
                    if (nodeType !== node.constructor) {
                        if (immediate) node = this._set(goal);
                        else throw Error("Cannot animate between ".concat(node.constructor.name, " and ").concat(nodeType.name, ', as the "to" prop suggests'));
                    }
                }
                var goalType = node.constructor;
                var started = (0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(to);
                var finished = false;
                if (!started) {
                    var hasValueChanged = reset || !$e593c995dca2acdf$var$hasAnimated(this) && hasFromChanged;
                    if (hasToChanged || hasValueChanged) {
                        finished = (0, $ffdb8e9de05aa517$export$248d38f6296296c5)($e593c995dca2acdf$var$computeGoal(value), goal);
                        started = !finished;
                    }
                    if (!(0, $ffdb8e9de05aa517$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $ffdb8e9de05aa517$export$248d38f6296296c5)(config.decay, decay) || !(0, $ffdb8e9de05aa517$export$248d38f6296296c5)(config.velocity, velocity)) started = true;
                }
                if (finished && $e593c995dca2acdf$var$isAnimating(this)) {
                    if (anim.changed && !reset) started = true;
                    else if (!started) this._stop(prevTo);
                }
                if (!hasAsyncTo) {
                    if (started || (0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(prevTo)) {
                        anim.values = node.getPayload();
                        anim.toValues = (0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(to) ? null : goalType == (0, $2279bb79667a7ed1$export$f6c6c4cbd7fa5b93) ? [
                            1
                        ] : (0, $ffdb8e9de05aa517$export$45b10814cc054894)(goal);
                    }
                    if (anim.immediate != immediate) {
                        anim.immediate = immediate;
                        if (!immediate && !reset) this._set(prevTo);
                    }
                    if (started) {
                        var onRest = anim.onRest;
                        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)($e593c995dca2acdf$var$ACTIVE_EVENTS, function(type) {
                            return $e593c995dca2acdf$var$mergeActiveFn(_this, props, type);
                        });
                        var result = $e593c995dca2acdf$var$getFinishedResult(this, $e593c995dca2acdf$var$checkFinished(this, prevTo));
                        (0, $ffdb8e9de05aa517$export$7ba486852759e806)(this._pendingCalls, result);
                        this._pendingCalls.add(resolve);
                        if (anim.changed) (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).batchedUpdates(function() {
                            anim.changed = !reset;
                            onRest == null || onRest(result, _this);
                            if (reset) $e593c995dca2acdf$var$callProp(defaultProps.onRest, result);
                            else anim.onStart == null || anim.onStart(result, _this);
                        });
                    }
                }
                if (reset) this._set(value);
                if (hasAsyncTo) resolve($e593c995dca2acdf$var$runAsync(props.to, props, this._state, this));
                else if (started) this._start();
                else if ($e593c995dca2acdf$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
                else resolve($e593c995dca2acdf$var$getNoopResult(value));
            }
        },
        {
            key: "_focus",
            value: function _focus(value) {
                var anim = this.animation;
                if (value !== anim.to) {
                    if ((0, $ffdb8e9de05aa517$export$133f54e9f7cf1796)(this)) this._detach();
                    anim.to = value;
                    if ((0, $ffdb8e9de05aa517$export$133f54e9f7cf1796)(this)) this._attach();
                }
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var priority = 0;
                var to = this.animation.to;
                if ((0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(to)) {
                    (0, $ffdb8e9de05aa517$export$72d604e3f8d000a5)(to, this);
                    if ($e593c995dca2acdf$var$isFrameValue(to)) priority = to.priority + 1;
                }
                this.priority = priority;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                var to = this.animation.to;
                if ((0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(to)) (0, $ffdb8e9de05aa517$export$7a0eb830d336339b)(to, this);
            }
        },
        {
            key: "_set",
            value: function _set(arg) {
                var idle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var _this = this;
                var value = (0, $ffdb8e9de05aa517$export$e37b7520edd66839)(arg);
                if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(value)) {
                    var oldNode = (0, $2279bb79667a7ed1$export$6b63995194a3a9e4)(this);
                    if (!oldNode || !(0, $ffdb8e9de05aa517$export$248d38f6296296c5)(value, oldNode.getValue())) {
                        var nodeType = (0, $2279bb79667a7ed1$export$e6b77ddbe47b132e)(value);
                        if (!oldNode || oldNode.constructor != nodeType) (0, $2279bb79667a7ed1$export$b553cb5b22b81b04)(this, nodeType.create(value));
                        else oldNode.setValue(value);
                        if (oldNode) (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).batchedUpdates(function() {
                            _this._onChange(value, idle);
                        });
                    }
                }
                return (0, $2279bb79667a7ed1$export$6b63995194a3a9e4)(this);
            }
        },
        {
            key: "_onStart",
            value: function _onStart() {
                var anim = this.animation;
                if (!anim.changed) {
                    anim.changed = true;
                    $e593c995dca2acdf$var$sendEvent(this, "onStart", $e593c995dca2acdf$var$getFinishedResult(this, $e593c995dca2acdf$var$checkFinished(this, anim.to)), this);
                }
            }
        },
        {
            key: "_onChange",
            value: function _onChange(value, idle) {
                if (!idle) {
                    this._onStart();
                    $e593c995dca2acdf$var$callProp(this.animation.onChange, value, this);
                }
                $e593c995dca2acdf$var$callProp(this.defaultProps.onChange, value, this);
                (0, $86d3ec05538b325a$export$afb3516d9d608401)((0, $2d3ab33c4b11796a$export$f09211a7d3c496a1)(SpringValue.prototype), "_onChange", this).call(this, value, idle);
            }
        },
        {
            key: "_start",
            value: function _start() {
                var anim = this.animation;
                (0, $2279bb79667a7ed1$export$6b63995194a3a9e4)(this).reset((0, $ffdb8e9de05aa517$export$e37b7520edd66839)(anim.to));
                if (!anim.immediate) anim.fromValues = anim.values.map(function(node) {
                    return node.lastPosition;
                });
                if (!$e593c995dca2acdf$var$isAnimating(this)) {
                    $e593c995dca2acdf$var$setActiveBit(this, true);
                    if (!$e593c995dca2acdf$var$isPaused(this)) this._resume();
                }
            }
        },
        {
            key: "_resume",
            value: function _resume() {
                if ((0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).skipAnimation) this.finish();
                else (0, $ffdb8e9de05aa517$export$a57f5080a3bcc90a).start(this);
            }
        },
        {
            key: "_stop",
            value: function _stop(goal, cancel) {
                if ($e593c995dca2acdf$var$isAnimating(this)) {
                    $e593c995dca2acdf$var$setActiveBit(this, false);
                    var anim = this.animation;
                    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(anim.values, function(node) {
                        node.done = true;
                    });
                    if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = undefined;
                    (0, $ffdb8e9de05aa517$export$31752c40a5fab62a)(this, {
                        type: "idle",
                        parent: this
                    });
                    var result = cancel ? $e593c995dca2acdf$var$getCancelledResult(this.get()) : $e593c995dca2acdf$var$getFinishedResult(this.get(), $e593c995dca2acdf$var$checkFinished(this, goal != null ? goal : anim.to));
                    (0, $ffdb8e9de05aa517$export$7ba486852759e806)(this._pendingCalls, result);
                    if (anim.changed) {
                        anim.changed = false;
                        $e593c995dca2acdf$var$sendEvent(this, "onRest", result, this);
                    }
                }
            }
        }
    ]);
    return SpringValue;
}($e593c995dca2acdf$export$8229896f80e2495e);
function $e593c995dca2acdf$var$checkFinished(target, to) {
    var goal = $e593c995dca2acdf$var$computeGoal(to);
    var value = $e593c995dca2acdf$var$computeGoal(target.get());
    return (0, $ffdb8e9de05aa517$export$248d38f6296296c5)(value, goal);
}
function $e593c995dca2acdf$var$createLoopUpdate(props) {
    var loop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : props.loop, to = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : props.to;
    var loopRet = $e593c995dca2acdf$var$callProp(loop);
    if (loopRet) {
        var overrides = loopRet !== true && $e593c995dca2acdf$export$b971039a739bf227(loopRet);
        var reverse = (overrides || props).reverse;
        var reset = !overrides || overrides.reset;
        return $e593c995dca2acdf$var$createUpdate($e593c995dca2acdf$var$_extends({}, props, {
            loop: loop,
            default: false,
            pause: undefined,
            to: !reverse || $e593c995dca2acdf$var$isAsyncTo(to) ? to : undefined,
            from: reset ? props.from : undefined,
            reset: reset
        }, overrides));
    }
}
function $e593c995dca2acdf$var$createUpdate(props) {
    var _ref = props = $e593c995dca2acdf$export$b971039a739bf227(props), to = _ref.to, from = _ref.from;
    var keys = new Set();
    if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(to)) $e593c995dca2acdf$var$findDefined(to, keys);
    if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(from)) $e593c995dca2acdf$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $e593c995dca2acdf$var$declareUpdate(props) {
    var update = $e593c995dca2acdf$var$createUpdate(props);
    if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(update.default)) update.default = $e593c995dca2acdf$var$getDefaultProps(update);
    return update;
}
function $e593c995dca2acdf$var$findDefined(values, keys) {
    (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(values, function(value, key) {
        return value != null && keys.add(key);
    });
}
var $e593c995dca2acdf$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $e593c995dca2acdf$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $e593c995dca2acdf$var$getDefaultProp(props, type) ? $e593c995dca2acdf$var$resolveProp(props[type], target.key) : undefined;
}
function $e593c995dca2acdf$var$sendEvent(target, type) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var _target$animation$typ, _target$defaultProps$;
    var _target$animation$typ1, _target$animation, _target$defaultProps$1, _target$defaultProps;
    (_target$animation$typ1 = (_target$animation = target.animation)[type]) == null || (_target$animation$typ = _target$animation$typ1).call.apply(_target$animation$typ, [
        _target$animation
    ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(args)));
    (_target$defaultProps$1 = (_target$defaultProps = target.defaultProps)[type]) == null || (_target$defaultProps$ = _target$defaultProps$1).call.apply(_target$defaultProps$, [
        _target$defaultProps
    ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(args)));
}
var $e593c995dca2acdf$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $e593c995dca2acdf$var$nextId = 1;
var $e593c995dca2acdf$export$bd0bf19f25da8474 = /*#__PURE__*/ function() {
    "use strict";
    function Controller(props, flush) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, Controller);
        this.id = $e593c995dca2acdf$var$nextId++;
        this.springs = {};
        this.queue = [];
        this.ref = void 0;
        this._flush = void 0;
        this._initialProps = void 0;
        this._lastAsyncId = 0;
        this._active = new Set();
        this._changed = new Set();
        this._started = false;
        this._item = void 0;
        this._state = {
            paused: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        this._events = {
            onStart: new Map(),
            onChange: new Map(),
            onRest: new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush) this._flush = flush;
        if (props) this.start($e593c995dca2acdf$var$_extends({
            default: true
        }, props));
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(Controller, [
        {
            key: "idle",
            get: function get() {
                return !this._state.asyncTo && Object.values(this.springs).every(function(spring) {
                    return spring.idle && !spring.isDelayed && !spring.isPaused;
                });
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(item) {
                this._item = item;
            }
        },
        {
            key: "get",
            value: function get() {
                var values = {};
                this.each(function(spring, key) {
                    return values[key] = spring.get();
                });
                return values;
            }
        },
        {
            key: "set",
            value: function set(values) {
                for(var key in values){
                    var value = values[key];
                    if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
                }
            }
        },
        {
            key: "update",
            value: function update(props) {
                if (props) this.queue.push($e593c995dca2acdf$var$createUpdate(props));
                return this;
            }
        },
        {
            key: "start",
            value: function start(props) {
                var queue = this.queue;
                if (props) queue = (0, $ffdb8e9de05aa517$export$45b10814cc054894)(props).map($e593c995dca2acdf$var$createUpdate);
                else this.queue = [];
                if (this._flush) return this._flush(this, queue);
                $e593c995dca2acdf$var$prepareKeys(this, queue);
                return $e593c995dca2acdf$var$flushUpdateQueue(this, queue);
            }
        },
        {
            key: "stop",
            value: function stop(arg, keys) {
                if (arg !== !!arg) keys = arg;
                if (keys) {
                    var springs = this.springs;
                    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)((0, $ffdb8e9de05aa517$export$45b10814cc054894)(keys), function(key) {
                        return springs[key].stop(!!arg);
                    });
                } else {
                    $e593c995dca2acdf$var$stopAsync(this._state, this._lastAsyncId);
                    this.each(function(spring) {
                        return spring.stop(!!arg);
                    });
                }
                return this;
            }
        },
        {
            key: "pause",
            value: function pause(keys) {
                if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(keys)) this.start({
                    pause: true
                });
                else {
                    var springs = this.springs;
                    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)((0, $ffdb8e9de05aa517$export$45b10814cc054894)(keys), function(key) {
                        return springs[key].pause();
                    });
                }
                return this;
            }
        },
        {
            key: "resume",
            value: function resume(keys) {
                if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(keys)) this.start({
                    pause: false
                });
                else {
                    var springs = this.springs;
                    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)((0, $ffdb8e9de05aa517$export$45b10814cc054894)(keys), function(key) {
                        return springs[key].resume();
                    });
                }
                return this;
            }
        },
        {
            key: "each",
            value: function each(iterator) {
                (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(this.springs, iterator);
            }
        },
        {
            key: "_onFrame",
            value: function _onFrame() {
                var _this = this;
                var _this__events = this._events, onStart = _this__events.onStart, onChange = _this__events.onChange, onRest = _this__events.onRest;
                var active = this._active.size > 0;
                var changed = this._changed.size > 0;
                if (active && !this._started || changed && !this._started) {
                    this._started = true;
                    (0, $ffdb8e9de05aa517$export$4909b86c8034bf73)(onStart, function(param) {
                        var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 2), onStart = _param[0], result = _param[1];
                        result.value = _this.get();
                        onStart(result, _this, _this._item);
                    });
                }
                var idle = !active && this._started;
                var values = changed || idle && onRest.size ? this.get() : null;
                if (changed && onChange.size) (0, $ffdb8e9de05aa517$export$4909b86c8034bf73)(onChange, function(param) {
                    var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 2), onChange = _param[0], result = _param[1];
                    result.value = values;
                    onChange(result, _this, _this._item);
                });
                if (idle) {
                    this._started = false;
                    (0, $ffdb8e9de05aa517$export$4909b86c8034bf73)(onRest, function(param) {
                        var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 2), onRest = _param[0], result = _param[1];
                        result.value = values;
                        onRest(result, _this, _this._item);
                    });
                }
            }
        },
        {
            key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") {
                    this._changed.add(event.parent);
                    if (!event.idle) this._active.add(event.parent);
                } else if (event.type == "idle") this._active.delete(event.parent);
                else return;
                (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).onFrame(this._onFrame);
            }
        }
    ]);
    return Controller;
}();
function $e593c995dca2acdf$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map(function(props) {
        return $e593c995dca2acdf$var$flushUpdate(ctrl, props);
    })).then(function(results) {
        return $e593c995dca2acdf$var$getCombinedResult(ctrl, results);
    });
}
function $e593c995dca2acdf$var$flushUpdate(ctrl, props, isLoop) {
    return $e593c995dca2acdf$var$_flushUpdate.apply(this, arguments);
}
function $e593c995dca2acdf$var$_flushUpdate() {
    $e593c995dca2acdf$var$_flushUpdate = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(ctrl, props, isLoop) {
        var keys, to, from, loop, onRest, onResolve, defaults, asyncTo, state, promises, cancel, result, _tmp, nextProps;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    keys = props.keys, to = props.to, from = props.from, loop = props.loop, onRest = props.onRest, onResolve = props.onResolve;
                    defaults = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(props.default) && props.default;
                    if (loop) props.loop = false;
                    if (to === false) props.to = null;
                    if (from === false) props.from = null;
                    asyncTo = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(to) || (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(to) ? to : undefined;
                    if (asyncTo) {
                        props.to = undefined;
                        props.onRest = undefined;
                        if (defaults) defaults.onRest = undefined;
                    } else (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)($e593c995dca2acdf$var$BATCHED_EVENTS, function(key) {
                        var handler = props[key];
                        if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(handler)) {
                            var queue = ctrl["_events"][key];
                            props[key] = function(param) {
                                var finished = param.finished, cancelled = param.cancelled;
                                var result = queue.get(handler);
                                if (result) {
                                    if (!finished) result.finished = false;
                                    if (cancelled) result.cancelled = true;
                                } else queue.set(handler, {
                                    value: null,
                                    finished: finished || false,
                                    cancelled: cancelled || false
                                });
                            };
                            if (defaults) defaults[key] = props[key];
                        }
                    });
                    state = ctrl["_state"];
                    if (props.pause === !state.paused) {
                        state.paused = props.pause;
                        (0, $ffdb8e9de05aa517$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
                    } else if (state.paused) props.pause = true;
                    promises = (keys || Object.keys(ctrl.springs)).map(function(key) {
                        return ctrl.springs[key].start(props);
                    });
                    cancel = props.cancel === true || $e593c995dca2acdf$var$getDefaultProp(props, "cancel") === true;
                    if (asyncTo || cancel && state.asyncId) promises.push($e593c995dca2acdf$var$scheduleProps(++ctrl["_lastAsyncId"], {
                        props: props,
                        state: state,
                        actions: {
                            pause: (0, $ffdb8e9de05aa517$export$8793edee2d425525),
                            resume: (0, $ffdb8e9de05aa517$export$8793edee2d425525),
                            start: function(props, resolve) {
                                if (cancel) {
                                    $e593c995dca2acdf$var$stopAsync(state, ctrl["_lastAsyncId"]);
                                    resolve($e593c995dca2acdf$var$getCancelledResult(ctrl));
                                } else {
                                    props.onRest = onRest;
                                    resolve($e593c995dca2acdf$var$runAsync(asyncTo, props, state, ctrl));
                                }
                            }
                        }
                    }));
                    if (!state.paused) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new Promise(function(resume) {
                            state.resumeQueue.add(resume);
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp = [
                        ctrl
                    ];
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 3:
                    result = $e593c995dca2acdf$var$getCombinedResult.apply(void 0, _tmp.concat([
                        _state.sent()
                    ]));
                    if (loop && result.finished && !(isLoop && result.noop)) {
                        nextProps = $e593c995dca2acdf$var$createLoopUpdate(props, loop, to);
                        if (nextProps) {
                            $e593c995dca2acdf$var$prepareKeys(ctrl, [
                                nextProps
                            ]);
                            return [
                                2,
                                $e593c995dca2acdf$var$flushUpdate(ctrl, nextProps, true)
                            ];
                        }
                    }
                    if (onResolve) (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).batchedUpdates(function() {
                        return onResolve(result, ctrl, ctrl.item);
                    });
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $e593c995dca2acdf$var$_flushUpdate.apply(this, arguments);
}
function $e593c995dca2acdf$var$getSprings(ctrl, props) {
    var springs = $e593c995dca2acdf$var$_extends({}, ctrl.springs);
    if (props) (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)((0, $ffdb8e9de05aa517$export$45b10814cc054894)(props), function(props) {
        if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props.keys)) props = $e593c995dca2acdf$var$createUpdate(props);
        if (!(0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(props.to)) props = $e593c995dca2acdf$var$_extends({}, props, {
            to: undefined
        });
        $e593c995dca2acdf$var$prepareSprings(springs, props, function(key) {
            return $e593c995dca2acdf$var$createSpring(key);
        });
    });
    $e593c995dca2acdf$var$setSprings(ctrl, springs);
    return springs;
}
function $e593c995dca2acdf$var$setSprings(ctrl, springs) {
    (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(springs, function(spring, key) {
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $ffdb8e9de05aa517$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $e593c995dca2acdf$var$createSpring(key, observer) {
    var spring = new $e593c995dca2acdf$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $ffdb8e9de05aa517$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $e593c995dca2acdf$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(props.keys, function(key) {
        var spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $e593c995dca2acdf$var$prepareKeys(ctrl, queue) {
    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(queue, function(props) {
        $e593c995dca2acdf$var$prepareSprings(ctrl.springs, props, function(key) {
            return $e593c995dca2acdf$var$createSpring(key, ctrl);
        });
    });
}
function $e593c995dca2acdf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e593c995dca2acdf$var$_excluded$6 = [
    "children"
];
var $e593c995dca2acdf$export$f12a216ec50d2cf1 = function(_ref) {
    var children = _ref.children, props = $e593c995dca2acdf$var$_objectWithoutPropertiesLoose(_ref, $e593c995dca2acdf$var$_excluded$6);
    var inherited = (0, $kVN77.useContext)($e593c995dca2acdf$var$ctx);
    var pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $ffdb8e9de05aa517$export$b6feb8998cd9b342)(function() {
        return {
            pause: pause,
            immediate: immediate
        };
    }, [
        pause,
        immediate
    ]);
    var Provider = $e593c995dca2acdf$var$ctx.Provider;
    return $kVN77.createElement(Provider, {
        value: props
    }, children);
};
var $e593c995dca2acdf$var$ctx = $e593c995dca2acdf$var$makeContext($e593c995dca2acdf$export$f12a216ec50d2cf1, {});
$e593c995dca2acdf$export$f12a216ec50d2cf1.Provider = $e593c995dca2acdf$var$ctx.Provider;
$e593c995dca2acdf$export$f12a216ec50d2cf1.Consumer = $e593c995dca2acdf$var$ctx.Consumer;
function $e593c995dca2acdf$var$makeContext(target, init) {
    Object.assign(target, $kVN77.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $e593c995dca2acdf$export$2471ae76e2946684 = function() {
    var current = [];
    var SpringRef = function SpringRef(props) {
        (0, $ffdb8e9de05aa517$export$d99d974913ad3b12)();
        var results = [];
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(current, function(ctrl, i) {
            if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                var update = _getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.current = current;
    SpringRef.add = function SpringRef(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef.delete = function(ctrl) {
        var i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef.pause = function() {
        var _ctrl;
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(current, function(ctrl) {
            return (_ctrl = ctrl).pause.apply(_ctrl, arguments);
        });
        return this;
    };
    SpringRef.resume = function() {
        var _ctrl;
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(current, function(ctrl) {
            return (_ctrl = ctrl).resume.apply(_ctrl, arguments);
        });
        return this;
    };
    SpringRef.set = function(values) {
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(current, function(ctrl) {
            return ctrl.set(values);
        });
    };
    SpringRef.start = function(props) {
        var _this = this;
        var results = [];
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(current, function(ctrl, i) {
            if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                var update = _this._getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.stop = function() {
        var _ctrl;
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(current, function(ctrl) {
            return (_ctrl = ctrl).stop.apply(_ctrl, arguments);
        });
        return this;
    };
    SpringRef.update = function(props) {
        var _this = this;
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(current, function(ctrl, i) {
            return ctrl.update(_this._getProps(props, ctrl, i));
        });
        return this;
    };
    var _getProps = function _getProps(arg, ctrl, index) {
        return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef._getProps = _getProps;
    return SpringRef;
};
function $e593c995dca2acdf$export$15786d483ab9f469(length, props, deps) {
    var propsFn = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    var ref = (0, $kVN77.useMemo)(function() {
        return propsFn || arguments.length == 3 ? $e593c995dca2acdf$export$2471ae76e2946684() : void 0;
    }, []);
    var layoutId = (0, $kVN77.useRef)(0);
    var forceUpdate = (0, $ffdb8e9de05aa517$export$91db9bc4f8ac944a)();
    var state = (0, $kVN77.useMemo)(function() {
        return {
            ctrls: [],
            queue: [],
            flush: function(ctrl, updates) {
                var springs = $e593c995dca2acdf$var$getSprings(ctrl, updates);
                var canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some(function(key) {
                    return !ctrl.springs[key];
                });
                return canFlushSync ? $e593c995dca2acdf$var$flushUpdateQueue(ctrl, updates) : new Promise(function(resolve) {
                    $e593c995dca2acdf$var$setSprings(ctrl, springs);
                    state.queue.push(function() {
                        resolve($e593c995dca2acdf$var$flushUpdateQueue(ctrl, updates));
                    });
                    forceUpdate();
                });
            }
        };
    }, []);
    var ctrls = (0, $kVN77.useRef)((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(state.ctrls));
    var updates = [];
    var prevLength = (0, $ffdb8e9de05aa517$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $kVN77.useMemo)(function() {
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), function(ctrl) {
            $e593c995dca2acdf$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $kVN77.useMemo)(function() {
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(var i = startIndex; i < endIndex; i++){
            var ctrl = ctrls.current[i] || (ctrls.current[i] = new $e593c995dca2acdf$export$bd0bf19f25da8474(null, state.flush));
            var update = propsFn ? propsFn(i, ctrl) : props[i];
            if (update) updates[i] = $e593c995dca2acdf$var$declareUpdate(update);
        }
    }
    var springs = ctrls.current.map(function(ctrl, i) {
        return $e593c995dca2acdf$var$getSprings(ctrl, updates[i]);
    });
    var context = (0, $kVN77.useContext)($e593c995dca2acdf$export$f12a216ec50d2cf1);
    var prevContext = (0, $ffdb8e9de05aa517$export$ef7ad0c4e19d7fbf)(context);
    var hasContext = context !== prevContext && $e593c995dca2acdf$var$hasProps(context);
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        layoutId.current++;
        state.ctrls = ctrls.current;
        var queue = state.queue;
        if (queue.length) {
            state.queue = [];
            (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(queue, function(cb) {
                return cb();
            });
        }
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(ctrls.current, function(ctrl, i) {
            ref == null || ref.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            var update = updates[i];
            if (update) {
                $e593c995dca2acdf$var$replaceRef(ctrl, update.ref);
                if (ctrl.ref) ctrl.queue.push(update);
                else ctrl.start(update);
            }
        });
    });
    (0, $ffdb8e9de05aa517$export$392544347a18b6ea)(function() {
        return function() {
            (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(state.ctrls, function(ctrl) {
                return ctrl.stop(true);
            });
        };
    });
    var values = springs.map(function(x) {
        return $e593c995dca2acdf$var$_extends({}, x);
    });
    return ref ? [
        values,
        ref
    ] : values;
}
function $e593c995dca2acdf$export$c4af9125706c4d30(props, deps) {
    var isFn = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(props);
    var _useSprings = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($e593c995dca2acdf$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps), 2), _useSprings_ = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_useSprings[0], 1), values = _useSprings_[0], ref = _useSprings[1];
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $e593c995dca2acdf$var$initSpringRef = function() {
    return $e593c995dca2acdf$export$2471ae76e2946684();
};
var $e593c995dca2acdf$export$564bff9c23cad2ca = function() {
    return (0, $kVN77.useState)($e593c995dca2acdf$var$initSpringRef)[0];
};
var $e593c995dca2acdf$export$ab73804b080feffc = function(initial, props) {
    var springValue = (0, $ffdb8e9de05aa517$export$fe4300aa8eebea86)(function() {
        return new $e593c995dca2acdf$export$5854d13427d5a954(initial, props);
    });
    (0, $ffdb8e9de05aa517$export$392544347a18b6ea)(function() {
        return function() {
            springValue.stop();
        };
    });
    return springValue;
};
function $e593c995dca2acdf$export$250279104b4672ed(length, propsArg, deps) {
    var propsFn = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    var reverse = true;
    var passedRef = undefined;
    var result = $e593c995dca2acdf$export$15786d483ab9f469(length, function(i, ctrl) {
        var props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, deps || [
        {}
    ]);
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(result[1].current, function(ctrl, i) {
            var parent = result[1].current[i + (reverse ? 1 : -1)];
            $e593c995dca2acdf$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        var _passedRef;
        var ref = (_passedRef = passedRef) != null ? _passedRef : result[1];
        ref["_getProps"] = function(propsArg, ctrl, i) {
            var props = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(propsArg) ? propsArg(i, ctrl) : propsArg;
            if (props) {
                var parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
var $e593c995dca2acdf$var$TransitionPhase;
(function(TransitionPhase) {
    TransitionPhase["MOUNT"] = "mount";
    TransitionPhase["ENTER"] = "enter";
    TransitionPhase["UPDATE"] = "update";
    TransitionPhase["LEAVE"] = "leave";
})($e593c995dca2acdf$var$TransitionPhase || ($e593c995dca2acdf$var$TransitionPhase = {}));
function $e593c995dca2acdf$export$7b286972b8d8ccbf(data, props, deps) {
    var propsFn = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(props) && props;
    var _ref = propsFn ? propsFn() : props, reset = _ref.reset, sort = _ref.sort, _ref_trail = _ref.trail, trail = _ref_trail === void 0 ? 0 : _ref_trail, _ref_expires = _ref.expires, expires = _ref_expires === void 0 ? true : _ref_expires, _ref_exitBeforeEnter = _ref.exitBeforeEnter, exitBeforeEnter = _ref_exitBeforeEnter === void 0 ? false : _ref_exitBeforeEnter, onDestroyed = _ref.onDestroyed, propsRef = _ref.ref, propsConfig = _ref.config;
    var ref = (0, $kVN77.useMemo)(function() {
        return propsFn || arguments.length == 3 ? $e593c995dca2acdf$export$2471ae76e2946684() : void 0;
    }, []);
    var items = (0, $ffdb8e9de05aa517$export$45b10814cc054894)(data);
    var transitions = [];
    var usedTransitions = (0, $kVN77.useRef)(null);
    var prevTransitions = reset ? null : usedTransitions.current;
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        usedTransitions.current = transitions;
    });
    (0, $ffdb8e9de05aa517$export$392544347a18b6ea)(function() {
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(transitions, function(t) {
            ref == null || ref.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return function() {
            (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(usedTransitions.current, function(t) {
                if (t.expired) clearTimeout(t.expirationId);
                $e593c995dca2acdf$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    var keys = $e593c995dca2acdf$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    var expired = reset && usedTransitions.current || [];
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        return (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(expired, function(param) {
            var ctrl = param.ctrl, item = param.item, key = param.key;
            $e593c995dca2acdf$var$detachRefs(ctrl, ref);
            $e593c995dca2acdf$var$callProp(onDestroyed, item, key);
        });
    });
    var reused = [];
    if (prevTransitions) (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(prevTransitions, function(t, i) {
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(items, function(item, i) {
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: $e593c995dca2acdf$var$TransitionPhase.MOUNT,
                ctrl: new $e593c995dca2acdf$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        var i = -1;
        var leave = (propsFn ? propsFn() : props).leave;
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(reused, function(keyIndex, prevIndex) {
            var t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = $e593c995dca2acdf$var$_extends({}, t, {
                    item: items[keyIndex]
                });
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(sort)) transitions.sort(function(a, b) {
        return sort(a.item, b.item);
    });
    var delay = -trail;
    var forceUpdate = (0, $ffdb8e9de05aa517$export$91db9bc4f8ac944a)();
    var defaultProps = $e593c995dca2acdf$var$getDefaultProps(props);
    var changes = new Map();
    var exitingTransitions = (0, $kVN77.useRef)(new Map());
    var forceChange = (0, $kVN77.useRef)(false);
    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(transitions, function(t, i) {
        var key = t.key;
        var prevPhase = t.phase;
        var p = propsFn ? propsFn() : props;
        var to;
        var phase;
        var propsDelay = $e593c995dca2acdf$var$callProp(p.delay || 0, key);
        if (prevPhase == $e593c995dca2acdf$var$TransitionPhase.MOUNT) {
            to = p.enter;
            phase = $e593c995dca2acdf$var$TransitionPhase.ENTER;
        } else {
            var isLeave = keys.indexOf(key) < 0;
            if (prevPhase != $e593c995dca2acdf$var$TransitionPhase.LEAVE) {
                if (isLeave) {
                    to = p.leave;
                    phase = $e593c995dca2acdf$var$TransitionPhase.LEAVE;
                } else if (to = p.update) phase = $e593c995dca2acdf$var$TransitionPhase.UPDATE;
                else return;
            } else if (!isLeave) {
                to = p.enter;
                phase = $e593c995dca2acdf$var$TransitionPhase.ENTER;
            } else return;
        }
        to = $e593c995dca2acdf$var$callProp(to, t.item, i);
        to = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).obj(to) ? $e593c995dca2acdf$export$b971039a739bf227(to) : {
            to: to
        };
        if (!to.config) {
            var config = propsConfig || defaultProps.config;
            to.config = $e593c995dca2acdf$var$callProp(config, t.item, i, phase);
        }
        delay += trail;
        var payload = $e593c995dca2acdf$var$_extends({}, defaultProps, {
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            reset: false
        }, to);
        if (phase == $e593c995dca2acdf$var$TransitionPhase.ENTER && (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(payload.from)) {
            var _p = propsFn ? propsFn() : props;
            var from = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(_p.initial) || prevTransitions ? _p.from : _p.initial;
            payload.from = $e593c995dca2acdf$var$callProp(from, t.item, i);
        }
        var onResolve = payload.onResolve;
        payload.onResolve = function(result) {
            $e593c995dca2acdf$var$callProp(onResolve, result);
            var transitions = usedTransitions.current;
            var _$t = transitions.find(function(t) {
                return t.key === key;
            });
            if (!_$t) return;
            if (result.cancelled && _$t.phase != $e593c995dca2acdf$var$TransitionPhase.UPDATE) return;
            if (_$t.ctrl.idle) {
                var idle = transitions.every(function(t) {
                    return t.ctrl.idle;
                });
                if (_$t.phase == $e593c995dca2acdf$var$TransitionPhase.LEAVE) {
                    var expiry = $e593c995dca2acdf$var$callProp(expires, _$t.item);
                    if (expiry !== false) {
                        var expiryMs = expiry === true ? 0 : expiry;
                        _$t.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 0x7fffffff) _$t.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions.some(function(t) {
                    return t.expired;
                })) {
                    exitingTransitions.current.delete(_$t);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        var springs = $e593c995dca2acdf$var$getSprings(t.ctrl, payload);
        if (phase === $e593c995dca2acdf$var$TransitionPhase.LEAVE && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    var context = (0, $kVN77.useContext)($e593c995dca2acdf$export$f12a216ec50d2cf1);
    var prevContext = (0, $ffdb8e9de05aa517$export$ef7ad0c4e19d7fbf)(context);
    var hasContext = context !== prevContext && $e593c995dca2acdf$var$hasProps(context);
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        if (hasContext) (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(transitions, function(t) {
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(changes, function(_, t) {
        if (exitingTransitions.current.size) {
            var ind = transitions.findIndex(function(state) {
                return state.key === t.key;
            });
            transitions.splice(ind, 1);
        }
    });
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, function(param, t) {
            var phase = param.phase, payload = param.payload;
            var ctrl = t.ctrl;
            t.phase = phase;
            ref == null || ref.add(ctrl);
            if (hasContext && phase == $e593c995dca2acdf$var$TransitionPhase.ENTER) ctrl.start({
                default: context
            });
            if (payload) {
                $e593c995dca2acdf$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    var renderTransitions = function(render) {
        return $kVN77.createElement($kVN77.Fragment, null, transitions.map(function(t, i) {
            var springs = (changes.get(t) || t.ctrl).springs;
            var elem = render($e593c995dca2acdf$var$_extends({}, springs), t.item, t, i);
            return elem && elem.type ? $kVN77.createElement(elem.type, $e593c995dca2acdf$var$_extends({}, elem.props, {
                key: (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).str(t.key) || (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            })) : elem;
        }));
    };
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $e593c995dca2acdf$var$nextKey = 1;
function $e593c995dca2acdf$var$getKeys(items, param, prevTransitions) {
    var key = param.key, _param_keys = param.keys, keys = _param_keys === void 0 ? key : _param_keys;
    if (keys === null) {
        var reused = new Set();
        return items.map(function(item) {
            var t = prevTransitions && prevTransitions.find(function(t) {
                return t.item === item && t.phase !== $e593c995dca2acdf$var$TransitionPhase.LEAVE && !reused.has(t);
            });
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $e593c995dca2acdf$var$nextKey++;
        });
    }
    return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(keys) ? items : (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $ffdb8e9de05aa517$export$45b10814cc054894)(keys);
}
var $e593c995dca2acdf$var$_excluded$5 = [
    "container"
];
var $e593c995dca2acdf$export$d928051c8cd740b = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var container = _ref.container, springOptions = $e593c995dca2acdf$var$_objectWithoutPropertiesLoose(_ref, $e593c995dca2acdf$var$_excluded$5);
    var _useSpring = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($e593c995dca2acdf$export$c4af9125706c4d30(function() {
        return $e593c995dca2acdf$var$_extends({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0
        }, springOptions);
    }, []), 2), scrollValues = _useSpring[0], api = _useSpring[1];
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        var cleanupScroll = (0, $ffdb8e9de05aa517$export$d4d89fd61e5416ee)(function(param) {
            var x = param.x, y = param.y;
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: (container == null ? void 0 : container.current) || undefined
        });
        return function() {
            (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(Object.values(scrollValues), function(value) {
                return value.stop();
            });
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $e593c995dca2acdf$var$_excluded$4 = [
    "container"
];
var $e593c995dca2acdf$export$e8b771555dc4a003 = function(_ref) {
    var container = _ref.container, springOptions = $e593c995dca2acdf$var$_objectWithoutPropertiesLoose(_ref, $e593c995dca2acdf$var$_excluded$4);
    var _useSpring = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($e593c995dca2acdf$export$c4af9125706c4d30(function() {
        return $e593c995dca2acdf$var$_extends({
            width: 0,
            height: 0
        }, springOptions);
    }, []), 2), sizeValues = _useSpring[0], api = _useSpring[1];
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        var cleanupScroll = (0, $ffdb8e9de05aa517$export$45b39e67d4ce4921)(function(param) {
            var width = param.width, height = param.height;
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: (container == null ? void 0 : container.current) || undefined
        });
        return function() {
            (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(Object.values(sizeValues), function(value) {
                return value.stop();
            });
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $e593c995dca2acdf$var$_excluded$3 = [
    "to",
    "from"
], $e593c995dca2acdf$var$_excluded2 = [
    "root",
    "once",
    "amount"
];
var $e593c995dca2acdf$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $e593c995dca2acdf$export$2f62ee6831462844(props, args) {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(false), 2), isInView = _useState[0], setIsInView = _useState[1];
    var ref = (0, $kVN77.useRef)();
    var propsFn = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(props) && props;
    var springsProps = propsFn ? propsFn() : {};
    var _springsProps_to = springsProps.to, to = _springsProps_to === void 0 ? {} : _springsProps_to, _springsProps_from = springsProps.from, from = _springsProps_from === void 0 ? {} : _springsProps_from, restSpringProps = $e593c995dca2acdf$var$_objectWithoutPropertiesLoose(springsProps, $e593c995dca2acdf$var$_excluded$3);
    var intersectionArguments = propsFn ? args : props;
    var _useSpring = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)($e593c995dca2acdf$export$c4af9125706c4d30(function() {
        return $e593c995dca2acdf$var$_extends({
            from: from
        }, restSpringProps);
    }, []), 2), springs = _useSpring[0], api = _useSpring[1];
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        var element = ref.current;
        var _ref = intersectionArguments != null ? intersectionArguments : {}, root = _ref.root, once = _ref.once, _ref_amount = _ref.amount, amount = _ref_amount === void 0 ? "any" : _ref_amount, restArgs = $e593c995dca2acdf$var$_objectWithoutPropertiesLoose(_ref, $e593c995dca2acdf$var$_excluded2);
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        var activeIntersections = new WeakMap();
        var onEnter = function() {
            if (to) api.start(to);
            setIsInView(true);
            var cleanup = function() {
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? undefined : cleanup;
        };
        var handleIntersection = function(entries) {
            entries.forEach(function(entry) {
                var onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    var newOnLeave = onEnter();
                    if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        var observer = new IntersectionObserver(handleIntersection, $e593c995dca2acdf$var$_extends({
            root: root && root.current || undefined,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $e593c995dca2acdf$var$defaultThresholdOptions[amount]
        }, restArgs));
        observer.observe(element);
        return function() {
            return observer.unobserve(element);
        };
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
var $e593c995dca2acdf$var$_excluded$2 = [
    "children"
];
function $e593c995dca2acdf$export$a500e5b516cedfc(_ref) {
    var children = _ref.children, props = $e593c995dca2acdf$var$_objectWithoutPropertiesLoose(_ref, $e593c995dca2acdf$var$_excluded$2);
    return children($e593c995dca2acdf$export$c4af9125706c4d30(props));
}
var $e593c995dca2acdf$var$_excluded$1 = [
    "items",
    "children"
];
function $e593c995dca2acdf$export$3b8b9d47fbf8fd2b(_ref) {
    var items = _ref.items, children = _ref.children, props = $e593c995dca2acdf$var$_objectWithoutPropertiesLoose(_ref, $e593c995dca2acdf$var$_excluded$1);
    var trails = $e593c995dca2acdf$export$250279104b4672ed(items.length, props);
    return items.map(function(item, index) {
        var result = children(item, index);
        return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
var $e593c995dca2acdf$var$_excluded = [
    "items",
    "children"
];
function $e593c995dca2acdf$export$be58926105124dd4(_ref) {
    var items = _ref.items, children = _ref.children, props = $e593c995dca2acdf$var$_objectWithoutPropertiesLoose(_ref, $e593c995dca2acdf$var$_excluded);
    return $e593c995dca2acdf$export$7b286972b8d8ccbf(items, props)(children);
}
var $e593c995dca2acdf$export$b0cc4f9860136880 = /*#__PURE__*/ function(FrameValue) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(Interpolation, FrameValue);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(Interpolation);
    function Interpolation(source, args) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, Interpolation);
        var _this;
        _this = _super.call(this);
        _this.key = void 0;
        _this.idle = true;
        _this.calc = void 0;
        _this._active = new Set();
        _this.source = source;
        _this.calc = (0, $ffdb8e9de05aa517$export$b12af43b97697ef5).apply(void 0, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(args));
        var value = _this._get();
        var nodeType = (0, $2279bb79667a7ed1$export$e6b77ddbe47b132e)(value);
        (0, $2279bb79667a7ed1$export$b553cb5b22b81b04)((0, $883161a1efd6c88e$export$f3b8ed2e4a5d10b8)(_this), nodeType.create(value));
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(Interpolation, [
        {
            key: "advance",
            value: function advance(_dt) {
                var value = this._get();
                var oldValue = this.get();
                if (!(0, $ffdb8e9de05aa517$export$248d38f6296296c5)(value, oldValue)) {
                    (0, $2279bb79667a7ed1$export$6b63995194a3a9e4)(this).setValue(value);
                    this._onChange(value, this.idle);
                }
                if (!this.idle && $e593c995dca2acdf$var$checkIdle(this._active)) $e593c995dca2acdf$var$becomeIdle(this);
            }
        },
        {
            key: "_get",
            value: function _get() {
                var inputs = (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $ffdb8e9de05aa517$export$e37b7520edd66839)) : (0, $ffdb8e9de05aa517$export$45b10814cc054894)((0, $ffdb8e9de05aa517$export$e37b7520edd66839)(this.source));
                return this.calc.apply(this, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(inputs));
            }
        },
        {
            key: "_start",
            value: function _start() {
                var _this = this;
                if (this.idle && !$e593c995dca2acdf$var$checkIdle(this._active)) {
                    this.idle = false;
                    (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)((0, $2279bb79667a7ed1$export$ccab2b64c5d440)(this), function(node) {
                        node.done = false;
                    });
                    if ((0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).skipAnimation) {
                        (0, $28f4a53fbe635233$export$27f233d61a9e2fa4).batchedUpdates(function() {
                            return _this.advance();
                        });
                        $e593c995dca2acdf$var$becomeIdle(this);
                    } else (0, $ffdb8e9de05aa517$export$a57f5080a3bcc90a).start(this);
                }
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                var priority = 1;
                (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)((0, $ffdb8e9de05aa517$export$45b10814cc054894)(this.source), function(source) {
                    if ((0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(source)) (0, $ffdb8e9de05aa517$export$72d604e3f8d000a5)(source, _this);
                    if ($e593c995dca2acdf$var$isFrameValue(source)) {
                        if (!source.idle) _this._active.add(source);
                        priority = Math.max(priority, source.priority + 1);
                    }
                });
                this.priority = priority;
                this._start();
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                var _this = this;
                (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)((0, $ffdb8e9de05aa517$export$45b10814cc054894)(this.source), function(source) {
                    if ((0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(source)) (0, $ffdb8e9de05aa517$export$7a0eb830d336339b)(source, _this);
                });
                this._active.clear();
                $e593c995dca2acdf$var$becomeIdle(this);
            }
        },
        {
            key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") {
                    if (event.idle) this.advance();
                    else {
                        this._active.add(event.parent);
                        this._start();
                    }
                } else if (event.type == "idle") this._active.delete(event.parent);
                else if (event.type == "priority") this.priority = (0, $ffdb8e9de05aa517$export$45b10814cc054894)(this.source).reduce(function(highest, parent) {
                    return Math.max(highest, ($e593c995dca2acdf$var$isFrameValue(parent) ? parent.priority : 0) + 1);
                }, 0);
            }
        }
    ]);
    return Interpolation;
}($e593c995dca2acdf$export$8229896f80e2495e);
function $e593c995dca2acdf$var$isIdle(source) {
    return source.idle !== false;
}
function $e593c995dca2acdf$var$checkIdle(active) {
    return !active.size || Array.from(active).every($e593c995dca2acdf$var$isIdle);
}
function $e593c995dca2acdf$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)((0, $2279bb79667a7ed1$export$ccab2b64c5d440)(self), function(node) {
            node.done = true;
        });
        (0, $ffdb8e9de05aa517$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
var $e593c995dca2acdf$export$2c618a4308a30424 = function(source) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return new $e593c995dca2acdf$export$b0cc4f9860136880(source, args);
};
var $e593c995dca2acdf$export$89e29e4ab65e70a9 = function(source) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $ffdb8e9de05aa517$export$2abfcde8ae218ba8)(), new $e593c995dca2acdf$export$b0cc4f9860136880(source, args);
};
(0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).assign({
    createStringInterpolator: (0, $ffdb8e9de05aa517$export$4759a013d387347a),
    to: function(source, args) {
        return new $e593c995dca2acdf$export$b0cc4f9860136880(source, args);
    }
});
var $e593c995dca2acdf$export$722fbec263ad908a = (0, $ffdb8e9de05aa517$export$a57f5080a3bcc90a).advance;





function $0eee13c1ec6a941c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0eee13c1ec6a941c$var$_excluded$2 = [
    "style",
    "children",
    "scrollTop",
    "scrollLeft",
    "viewBox"
];
var $0eee13c1ec6a941c$var$isCustomPropRE = /^--/;
function $0eee13c1ec6a941c$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$0eee13c1ec6a941c$var$isCustomPropRE.test(name) && !($0eee13c1ec6a941c$var$isUnitlessNumber.hasOwnProperty(name) && $0eee13c1ec6a941c$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $0eee13c1ec6a941c$var$attributeCache = {};
function $0eee13c1ec6a941c$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    var isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    var _ref = props, style = _ref.style, children = _ref.children, scrollTop = _ref.scrollTop, scrollLeft = _ref.scrollLeft, viewBox = _ref.viewBox, attributes = $0eee13c1ec6a941c$var$_objectWithoutPropertiesLoose(_ref, $0eee13c1ec6a941c$var$_excluded$2);
    var values = Object.values(attributes);
    var names = Object.keys(attributes).map(function(name) {
        return isFilterElement || instance.hasAttribute(name) ? name : $0eee13c1ec6a941c$var$attributeCache[name] || ($0eee13c1ec6a941c$var$attributeCache[name] = name.replace(/([A-Z])/g, function(n) {
            return "-" + n.toLowerCase();
        }));
    });
    if (children !== void 0) instance.textContent = children;
    for(var name in style)if (style.hasOwnProperty(name)) {
        var value = $0eee13c1ec6a941c$var$dangerousStyleValue(name, style[name]);
        if ($0eee13c1ec6a941c$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach(function(name, i) {
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $0eee13c1ec6a941c$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $0eee13c1ec6a941c$var$prefixKey = function(prefix, key) {
    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};
var $0eee13c1ec6a941c$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$0eee13c1ec6a941c$var$isUnitlessNumber = Object.keys($0eee13c1ec6a941c$var$isUnitlessNumber).reduce(function(acc, prop) {
    $0eee13c1ec6a941c$var$prefixes.forEach(function(prefix) {
        return acc[$0eee13c1ec6a941c$var$prefixKey(prefix, prop)] = acc[prop];
    });
    return acc;
}, $0eee13c1ec6a941c$var$isUnitlessNumber);
var $0eee13c1ec6a941c$var$_excluded$1 = [
    "x",
    "y",
    "z"
];
var $0eee13c1ec6a941c$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $0eee13c1ec6a941c$var$pxTransforms = /^(translate)/;
var $0eee13c1ec6a941c$var$degTransforms = /^(rotate|skew)/;
var $0eee13c1ec6a941c$var$addUnit = function(value, unit) {
    return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
};
var $0eee13c1ec6a941c$var$isValueIdentity = function(value, id) {
    return (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(value) ? value.every(function(v) {
        return $0eee13c1ec6a941c$var$isValueIdentity(v, id);
    }) : (0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
};
var $0eee13c1ec6a941c$var$AnimatedStyle = /*#__PURE__*/ function(AnimatedObject) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(AnimatedStyle, AnimatedObject);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(AnimatedStyle);
    function AnimatedStyle(_ref) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, AnimatedStyle);
        var x = _ref.x, y = _ref.y, z = _ref.z, style = $0eee13c1ec6a941c$var$_objectWithoutPropertiesLoose(_ref, $0eee13c1ec6a941c$var$_excluded$1);
        var inputs = [];
        var transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push(function(xyz) {
                return [
                    "translate3d(".concat(xyz.map(function(v) {
                        return $0eee13c1ec6a941c$var$addUnit(v, "px");
                    }).join(","), ")"),
                    $0eee13c1ec6a941c$var$isValueIdentity(xyz, 0)
                ];
            });
        }
        (0, $ffdb8e9de05aa517$export$f4c6fe153f5a944e)(style, function(value, key) {
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push(function(transform) {
                    return [
                        transform,
                        transform === ""
                    ];
                });
            } else if ($0eee13c1ec6a941c$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).und(value)) return;
                var unit = $0eee13c1ec6a941c$var$pxTransforms.test(key) ? "px" : $0eee13c1ec6a941c$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $ffdb8e9de05aa517$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? function(param) {
                    var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 4), x = _param[0], y = _param[1], z = _param[2], deg = _param[3];
                    return [
                        "rotate3d(".concat(x, ",").concat(y, ",").concat(z, ",").concat($0eee13c1ec6a941c$var$addUnit(deg, unit), ")"),
                        $0eee13c1ec6a941c$var$isValueIdentity(deg, 0)
                    ];
                } : function(input) {
                    return [
                        "".concat(key, "(").concat(input.map(function(v) {
                            return $0eee13c1ec6a941c$var$addUnit(v, unit);
                        }).join(","), ")"),
                        $0eee13c1ec6a941c$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ];
                });
            }
        });
        if (inputs.length) style.transform = new $0eee13c1ec6a941c$var$FluidTransform(inputs, transforms);
        return _super.call(this, style);
    }
    return AnimatedStyle;
}((0, $2279bb79667a7ed1$export$f1b0b9e366a6e2d4));
var $0eee13c1ec6a941c$var$FluidTransform = /*#__PURE__*/ function(FluidValue) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(FluidTransform, FluidValue);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(FluidTransform);
    function FluidTransform(inputs, transforms) {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, FluidTransform);
        var _this;
        _this = _super.call(this);
        _this._value = null;
        _this.inputs = inputs;
        _this.transforms = transforms;
        return _this;
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(FluidTransform, [
        {
            key: "get",
            value: function get() {
                return this._value || (this._value = this._get());
            }
        },
        {
            key: "_get",
            value: function _get() {
                var _this = this;
                var transform = "";
                var identity = true;
                (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(this.inputs, function(input, i) {
                    var arg1 = (0, $ffdb8e9de05aa517$export$e37b7520edd66839)(input[0]);
                    var _this_transforms_i = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(_this.transforms[i]((0, $ffdb8e9de05aa517$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $ffdb8e9de05aa517$export$e37b7520edd66839))), 2), t = _this_transforms_i[0], id = _this_transforms_i[1];
                    transform += " " + t;
                    identity = identity && id;
                });
                return identity ? "none" : transform;
            }
        },
        {
            key: "observerAdded",
            value: function observerAdded(count) {
                var _this = this;
                if (count == 1) (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(this.inputs, function(input) {
                    return (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(input, function(value) {
                        return (0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(value) && (0, $ffdb8e9de05aa517$export$72d604e3f8d000a5)(value, _this);
                    });
                });
            }
        },
        {
            key: "observerRemoved",
            value: function observerRemoved(count) {
                var _this = this;
                if (count == 0) (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(this.inputs, function(input) {
                    return (0, $ffdb8e9de05aa517$export$79b2f7037acddd43)(input, function(value) {
                        return (0, $ffdb8e9de05aa517$export$57ea7e3a7f6280c7)(value) && (0, $ffdb8e9de05aa517$export$7a0eb830d336339b)(value, _this);
                    });
                });
            }
        },
        {
            key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") this._value = null;
                (0, $ffdb8e9de05aa517$export$31752c40a5fab62a)(this, event);
            }
        }
    ]);
    return FluidTransform;
}((0, $ffdb8e9de05aa517$export$aff8e1ac1a016a2));
var $0eee13c1ec6a941c$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $0eee13c1ec6a941c$var$_excluded = [
    "scrollTop",
    "scrollLeft"
];
(0, $ffdb8e9de05aa517$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $f7ecce75fdbc5756$exports.unstable_batchedUpdates),
    createStringInterpolator: (0, $ffdb8e9de05aa517$export$4759a013d387347a),
    colors: (0, $ffdb8e9de05aa517$export$8f45430ccf837300)
});
var $0eee13c1ec6a941c$var$host = (0, $2279bb79667a7ed1$export$4ee5c78f6dcbcef)($0eee13c1ec6a941c$var$primitives, {
    applyAnimatedValues: $0eee13c1ec6a941c$var$applyAnimatedValues,
    createAnimatedStyle: function(style) {
        return new $0eee13c1ec6a941c$var$AnimatedStyle(style);
    },
    getComponentProps: function(_ref) {
        var props = $0eee13c1ec6a941c$var$_objectWithoutPropertiesLoose(_ref, $0eee13c1ec6a941c$var$_excluded);
        return props;
    }
});
var $0eee13c1ec6a941c$export$407448d2b89b1813 = $0eee13c1ec6a941c$var$host.animated;



var $kVN77 = parcelRequire("kVN77");



parcelRequire("kVN77");
var $3245b462dc65bad3$var$SvgClearIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM8.464 9.879A1 1 0 1 1 9.88 8.464L12 10.586l2.121-2.122a1 1 0 1 1 1.415 1.415L13.414 12l2.122 2.121a1 1 0 1 1-1.415 1.415L12 13.414l-2.121 2.122a1 1 0 1 1-1.415-1.415L10.586 12 8.464 9.879Z",
            fill: "currentcolor"
        })
    }));
};
var $3245b462dc65bad3$export$2e2bcd8739ae039 = $3245b462dc65bad3$var$SvgClearIcon;











var $kVN77 = parcelRequire("kVN77");
var $5440938c0bb2daaf$export$82e9f45cca5ba907;
$5440938c0bb2daaf$export$82e9f45cca5ba907 = "_3Ci-sW_prefix";


var $3e7bd8f0f1133f5c$var$AnimatedPrefix = function(param) {
    var children = param.children, isVisible = param.isVisible;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(false), 2), domReady = _useState[0], setDomReady = _useState[1];
    var elementRef = (0, $kVN77.useRef)(null);
    // Get target width for the children
    var getTargetWidth = (0, $kVN77.useCallback)(function() {
        var _elementRef_current;
        return isVisible ? (_elementRef_current = elementRef.current) === null || _elementRef_current === void 0 ? void 0 : _elementRef_current.getBoundingClientRect().width : 0;
    }, [
        isVisible
    ]);
    var _useSpring = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $e593c995dca2acdf$export$c4af9125706c4d30)(function() {
        return {
            width: getTargetWidth(),
            config: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, (0, $e593c995dca2acdf$export$e506a1d27d1eaa20).default), {
                clamp: true
            })
        };
    }, [
        getTargetWidth,
        domReady
    ]), 2), animation = _useSpring[0], api = _useSpring[1];
    (0, $ffdb8e9de05aa517$export$700979bc83e7db82)(function() {
        var current = elementRef.current;
        setDomReady(true);
        var cleanup = current && (0, $ffdb8e9de05aa517$export$45b39e67d4ce4921)(function() {
            api.start({
                width: getTargetWidth()
            });
        }, {
            container: current
        });
        return function() {
            // Stop animation before cleanup
            api.stop();
            cleanup === null || cleanup === void 0 ? void 0 : cleanup();
        };
    }, [
        api,
        getTargetWidth
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0eee13c1ec6a941c$export$407448d2b89b1813).div, {
        className: $5440938c0bb2daaf$export$82e9f45cca5ba907,
        style: animation,
        "data-testid": "prefix",
        children: /*#__PURE__*/ (0, $kVN77.cloneElement)(children, {
            ref: elementRef,
            isVisible: isVisible
        })
    });
};
var $3e7bd8f0f1133f5c$export$2e2bcd8739ae039 = $3e7bd8f0f1133f5c$var$AnimatedPrefix;






var $kVN77 = parcelRequire("kVN77");





// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $86e785f2d13920a4$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4\\d{4}",
                    [
                        5
                    ]
                ]
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "690\\d{6}|[356]\\d{5}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5[024-68]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7\\d{8}"
                ]
            ]
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268",
            [
                0,
                [
                    "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"
                ]
            ]
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264",
            [
                0,
                [
                    "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"
                ]
            ]
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[78][2-9]|9\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"
                ]
            ]
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-59]\\d{7}"
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1",
            0,
            0,
            [
                0,
                [
                    "93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"
                ]
            ]
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684",
            [
                0,
                [
                    "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"
                ]
            ]
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",
                    [
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13
                    ]
                ]
            ]
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                0,
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            [
                0,
                [
                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ]
            ],
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"
                ]
            ]
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"
                ]
            ]
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246",
            [
                0,
                [
                    "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"
                ]
            ]
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4[5-9]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}"
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}"
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:29|[67][125-9])\\d{6}"
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4[0-6]|[56]\\d|9[013-9])\\d{6}"
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441",
            [
                0,
                [
                    "441(?:[2378]\\d|5[0-39]|92)\\d{5}"
                ]
            ]
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:22[89]|[78]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?",
            0,
            0,
            0,
            [
                0,
                [
                    "[67]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]",
            [
                0,
                [
                    "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"
                ]
            ]
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2",
            0,
            0,
            [
                0,
                [
                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                    [
                        10,
                        11
                    ]
                ]
            ]
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242",
            [
                0,
                [
                    "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}"
                ]
            ]
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[67]|77)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:321|7[1-8]\\d)\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6[0-35-7]\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                0,
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}"
                ]
            ]
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[024-7]\\d{6}"
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[35-9]\\d{7}"
                ]
            ]
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "0[157]\\d{8}"
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[578]\\d{4}"
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:24[23]|6[25-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            [
                0,
                [
                    "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
                    [
                        11
                    ]
                ]
            ],
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?",
            0,
            0,
            0,
            [
                0,
                [
                    "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5\\d|63)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:36|5[1-389]|9\\d)\\d{5}"
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]",
            [
                0,
                [
                    "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"
                ]
            ]
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                0,
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:10|[4-79]\\d)\\d{5}"
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",
                    [
                        10,
                        11
                    ]
                ]
            ]
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "77\\d{6}"
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767",
            [
                0,
                [
                    "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"
                ]
            ]
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9",
            [
                0,
                [
                    "8[024]9[2-9]\\d{6}"
                ]
            ]
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                    [
                        7,
                        8
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "1[0-25]\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]",
            [
                0,
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ]
            ]
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:17[1-3]|7\\d\\d)\\d{4}"
                ]
            ]
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"
                ]
            ]
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            [
                0,
                [
                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ]
            ],
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                    [
                        7
                    ]
                ]
            ],
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[56]\\d{4}"
                ]
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[27][1-9]|5\\d|9[16])\\d{4}"
                ]
            ]
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"
                ]
            ]
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1",
            0,
            0,
            [
                0,
                [
                    "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"
                ]
            ]
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473",
            [
                0,
                [
                    "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}"
                ]
            ]
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|11|22|33|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}"
                ]
            ]
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "694(?:[0-249]\\d|3[0-8])\\d{4}"
                ]
            ]
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                0,
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[245]\\d{5}"
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[23679]\\d|5[0-489])\\d{5}"
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6[0-356]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:222|55\\d)\\d{6}"
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671",
            [
                0,
                [
                    "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"
                ]
            ]
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:5\\d|6[569]|77)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:510|6\\d\\d|7(?:0\\d|1[0-8]|25|49))\\d{4}"
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4(?:44[5-9]|6(?:1[0-7]|4[0-57-9]|6[0-4]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-6]|8[0-4])|848[0-25-9]|9(?:29[013-9]|59[0-4]|899))\\d{4}|(?:4(?:4[015]|6[02357-9])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[37-9]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[5-7])))\\d{4}|98\\d{6}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[34]\\d|55)\\d{6}"
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[257]0|3[01])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8[1-35-9]\\d{7,10}",
                    [
                        9,
                        10,
                        11,
                        12
                    ]
                ]
            ]
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8(?:22|[35-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24",
            [
                0,
                [
                    "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"
                ]
            ]
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "38\\d{5}"
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[3-9]\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"
                ]
            ],
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                0,
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876",
            [
                0,
                [
                    "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"
                ]
            ]
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:[78][0-25-9]|9\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1",
            0,
            0,
            [
                0,
                [
                    "[7-9]0[1-9]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[34]\\d{6}"
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869",
            [
                0,
                [
                    "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"
                ]
            ]
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "19[1-3]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?",
            0,
            0,
            0,
            [
                0,
                [
                    "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345",
            [
                0,
                [
                    "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"
                ]
            ]
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            [
                0,
                [
                    "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                    [
                        10
                    ]
                ]
            ],
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"
                ]
            ]
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758",
            [
                0,
                [
                    "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"
                ]
            ]
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"
                ]
            ]
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:[0-25-8]\\d|4[0-4])\\d{6}"
                ]
            ]
        ],
        "LR": [
            "231",
            "00",
            "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",
                    [
                        7,
                        9
                    ]
                ]
            ]
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[56]\\d{7}"
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]",
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{7}"
                ]
            ]
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}"
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-6]\\d{7}"
                ]
            ]
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"
                ]
            ]
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "562\\d{5}|(?:6\\d|7[16-9])\\d{6}"
                ]
            ]
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1",
            0,
            0,
            [
                0,
                [
                    "3[2-47-9]\\d{7}"
                ]
            ]
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:23|54)5|329|45[356])\\d{4}"
                ]
            ]
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"
                ]
            ]
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}"
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                    [
                        7,
                        8,
                        9,
                        10
                    ]
                ]
            ]
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670",
            [
                0,
                [
                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"
                ]
            ]
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}"
                ]
            ]
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[2-4][0-46-9]\\d{6}"
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664",
            [
                0,
                [
                    "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"
                ]
            ]
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-3]|3[013]))\\d{5}",
                    [
                        8
                    ]
                ]
            ],
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:46[46]|[79]\\d\\d)\\d{4}",
                    [
                        7
                    ]
                ]
            ],
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "111\\d{6}|(?:31|77|[89][89])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            [
                0,
                [
                    "657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}"
                ]
            ],
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8[2-79]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:60|8[1245])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:23|7[047]|[89]\\d)\\d{6}"
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1",
            0,
            0,
            [
                0,
                [
                    "(?:14|3[58])\\d{4}"
                ]
            ]
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6[1-58]|970\\d)\\d{7}",
                    [
                        9,
                        11
                    ]
                ]
            ]
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]",
            [
                0,
                [
                    "(?:4[015-8]|9\\d)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:55[3-9]|666|8\\d\\d)\\d{4}"
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[56]|888[1-9])\\d{3}"
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
                    [
                        8,
                        9,
                        10
                    ]
                ]
            ],
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "1505\\d{4}|(?:7(?:[1289]\\d|6[89]|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
                    [
                        7,
                        8
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9\\d{8}",
                    [
                        9
                    ]
                ]
            ],
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8[7-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7\\d|8[128])\\d{6}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}"
                ]
            ]
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939",
            [
                0,
                [
                    "(?:787|939)[2-9]\\d{6}"
                ]
            ]
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5[69]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}"
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[35-7]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7020\\d{5}|(?:62\\d|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[0-689]|7\\d)\\d{6,7}",
                    [
                        8,
                        9,
                        10
                    ]
                ]
            ]
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            [
                0,
                [
                    "9\\d{9}",
                    [
                        10
                    ]
                ]
            ],
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[237-9]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2[125-8]\\d{5}"
                ]
            ],
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[0-2]|9[0-3569])\\d{7}"
                ]
            ]
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[02369]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8(?:08[013]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]",
            [
                0,
                [
                    "[56]\\d{4}",
                    [
                        5
                    ]
                ]
            ]
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79",
            [
                0,
                [
                    "(?:4[015-8]|9\\d)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}"
                ]
            ]
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1",
            0,
            0,
            [
                0,
                [
                    "6[16]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}"
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
                    [
                        7,
                        8,
                        9
                    ]
                ]
            ]
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[124-7]|8[124-9])\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:12|9[1257-9])\\d{7}"
                ]
            ]
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[67]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721",
            [
                0,
                [
                    "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"
                ]
            ]
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-689]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[6-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649",
            [
                0,
                [
                    "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"
                ]
            ]
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6[0235689]|77|9\\d)\\d{6}"
                ]
            ],
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[019]|9[0-36-9])\\d{6}"
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}"
                ]
            ],
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[2-4]\\d{2,5}"
                ]
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[2-8]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{7}"
                ]
            ],
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868",
            [
                0,
                [
                    "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"
                ]
            ]
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[01]\\d|90)\\d{4}",
                    [
                        6,
                        7
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                    [
                        9
                    ]
                ]
            ],
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}"
                ]
            ]
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}",
                    [
                        9
                    ]
                ]
            ],
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "726[01]\\d{5}|7(?:[015-8]\\d|20|36|4[0-4]|9[89])\\d{6}"
                ]
            ]
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ],
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"
                ]
            ],
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698",
            [
                0,
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784",
            [
                0,
                [
                    "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"
                ]
            ]
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4(?:1[24-8]|2[46])\\d{7}"
                ]
            ]
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284",
            [
                0,
                [
                    "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"
                ]
            ]
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340",
            [
                0,
                [
                    "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"
                ]
            ]
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[58]\\d|7[013-7])\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:72|8[23])\\d{4}",
                    [
                        6
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",
                    [
                        7,
                        10
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4[3-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[01378]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ]
            ]
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[5-79]|9[5-8])\\d{7}"
                ]
            ]
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:[178]\\d|3[1-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $5369786ab174e217$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $86e785f2d13920a4$export$2e2bcd8739ae039));
    return func.apply(this, args);
}



function $5658c78bc245cec6$export$2e2bcd8739ae039(metadata) {
    return new (0, $81668d0b6c6437f8$export$2e2bcd8739ae039)(metadata).getCountries();
}


function $81ac01b92a3711bd$export$44f7508c6c352cc6() {
    return (0, $5369786ab174e217$export$2e2bcd8739ae039)((0, $5658c78bc245cec6$export$2e2bcd8739ae039), arguments);
}



function $5414bc3d00a70094$export$32876ca2f1919cf0() {
    return (0, $5369786ab174e217$export$2e2bcd8739ae039)((0, $81668d0b6c6437f8$export$32876ca2f1919cf0), arguments);
}



function $fc762b3c65644a5e$export$176bb591929cc9a8() {
    return (0, $5369786ab174e217$export$2e2bcd8739ae039)((0, $08f1334dbe770d52$export$2e2bcd8739ae039), arguments);
}


var $f9ff7d4c659fed5c$export$4154d15e6abcdc1 = "US";
var $f9ff7d4c659fed5c$export$f69fd5b458c8e2d = {
    zh: "CN",
    en: "US"
};
var $f9ff7d4c659fed5c$export$3c2105ee38ea5c77 = function(countryCode) {
    try {
        // Use getCountryCallingCode method to guard the input's value is in CountryCode union type, if type not match exceptions are expected
        // eslint-disable-next-line no-restricted-syntax
        (0, $5414bc3d00a70094$export$32876ca2f1919cf0)(countryCode);
        return true;
    } catch (e) {
        return false;
    }
};
var $f9ff7d4c659fed5c$export$4e6096437c36f4c2 = function() {
    var language = (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).language;
    // Extract the country code from language tag suffix
    var _language_split = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(language.split("-"), 2), languageCode = _language_split[0], countryCode = _language_split[1];
    if (countryCode && $f9ff7d4c659fed5c$export$3c2105ee38ea5c77(countryCode)) return countryCode;
    var upperCaseLanguageCode = languageCode === null || languageCode === void 0 ? void 0 : languageCode.toUpperCase();
    if (upperCaseLanguageCode && $f9ff7d4c659fed5c$export$3c2105ee38ea5c77(upperCaseLanguageCode)) return upperCaseLanguageCode;
    var _countryCallingCodeMap_language;
    return (_countryCallingCodeMap_language = $f9ff7d4c659fed5c$export$f69fd5b458c8e2d[language]) !== null && _countryCallingCodeMap_language !== void 0 ? _countryCallingCodeMap_language : $f9ff7d4c659fed5c$export$4154d15e6abcdc1;
};
var $f9ff7d4c659fed5c$export$93cb54c01a2c1072 = function() {
    return (0, $5414bc3d00a70094$export$32876ca2f1919cf0)($f9ff7d4c659fed5c$export$4e6096437c36f4c2());
};
var $f9ff7d4c659fed5c$export$4fa5c00ca385a5d = function() {
    var defaultCountryCode = $f9ff7d4c659fed5c$export$4e6096437c36f4c2();
    var defaultCountryCallingCode = (0, $5414bc3d00a70094$export$32876ca2f1919cf0)(defaultCountryCode);
    var countryList = (0, $81ac01b92a3711bd$export$44f7508c6c352cc6)().map(function(code) {
        return {
            countryCode: code,
            countryCallingCode: (0, $5414bc3d00a70094$export$32876ca2f1919cf0)(code)
        };
    })// Filter the detected default countryCode & duplicates
    .filter(function(param, index, self) {
        var countryCallingCode = param.countryCallingCode;
        if (countryCallingCode === defaultCountryCallingCode) return false;
        return self.findIndex(function(element) {
            return element.countryCallingCode === countryCallingCode;
        }) === index;
    }).slice()// Sort by countryCallingCode
    .sort(function(previous, next) {
        return next.countryCallingCode > previous.countryCallingCode ? -1 : 1;
    });
    return [
        {
            countryCode: defaultCountryCode,
            countryCallingCode: defaultCountryCallingCode
        }
    ].concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(countryList));
};
var $f9ff7d4c659fed5c$export$9974d4de222cbb3a = function(value) {
    if (!value || value.startsWith("+")) return value;
    return "+".concat(value);
};
var $f9ff7d4c659fed5c$export$79abe912f70ec8f5 = function(number) {
    try {
        var phoneNumber = (0, $fc762b3c65644a5e$export$176bb591929cc9a8)($f9ff7d4c659fed5c$export$9974d4de222cbb3a(number));
        return "+".concat(phoneNumber.countryCallingCode, " ").concat(phoneNumber.nationalNumber);
    } catch (e) {
        return number;
    }
};
var $f9ff7d4c659fed5c$export$da44e4eaa54bc82e = function(value) {
    try {
        var phoneNumber = (0, $fc762b3c65644a5e$export$176bb591929cc9a8)($f9ff7d4c659fed5c$export$9974d4de222cbb3a(value));
        return {
            countryCallingCode: phoneNumber.countryCallingCode,
            nationalNumber: phoneNumber.nationalNumber
        };
    } catch (e) {}
};








var $kVN77 = parcelRequire("kVN77");






parcelRequire("kVN77");
var $085e8b8dfdd45419$var$SvgSearchIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 16,
        height: 17,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 10.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm9.707 4.293-4.82-4.82A5.968 5.968 0 0 0 12 6.5a6 6 0 0 0-12 0 6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414Z",
            fill: "currentcolor"
        })
    }));
};
var $085e8b8dfdd45419$export$2e2bcd8739ae039 = $085e8b8dfdd45419$var$SvgSearchIcon;




/**
 * Original Reference: https://github.com/juliencrn/usehooks-ts/blob/master/src/useDebounce/useDebounce.ts
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2020 Julien CARON
 *Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 

var $kVN77 = parcelRequire("kVN77");
function $6e4bf1ac7768c678$var$useDebounce(value, delay) {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(value), 2), debouncedValue = _useState[0], setDebouncedValue = _useState[1];
    (0, $kVN77.useEffect)(function() {
        var timer = setTimeout(function() {
            setDebouncedValue(value);
        }, delay !== null && delay !== void 0 ? delay : 500);
        return function() {
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
var $6e4bf1ac7768c678$export$2e2bcd8739ae039 = $6e4bf1ac7768c678$var$useDebounce;




var $def7e9ba65acd6d9$export$955245c47f738f8a;
var $def7e9ba65acd6d9$export$ec06ab6513f0c8c6;
var $def7e9ba65acd6d9$export$2c192705e93dd8a6;
var $def7e9ba65acd6d9$export$1c1680d5365f3f93;
var $def7e9ba65acd6d9$export$d4fb61928174ef64;
var $def7e9ba65acd6d9$export$89da14300d534261;
var $def7e9ba65acd6d9$export$d90250155de6d7e7;
var $def7e9ba65acd6d9$export$a33e918cb4258370;
$def7e9ba65acd6d9$export$955245c47f738f8a = "dropdownOverlay_ec29ff";
$def7e9ba65acd6d9$export$ec06ab6513f0c8c6 = "dropdownModal_ec29ff";
$def7e9ba65acd6d9$export$2c192705e93dd8a6 = "dropdownContent_ec29ff";
$def7e9ba65acd6d9$export$1c1680d5365f3f93 = "searchInputField_ec29ff";
$def7e9ba65acd6d9$export$d4fb61928174ef64 = "countryList_ec29ff";
$def7e9ba65acd6d9$export$89da14300d534261 = "active_ec29ff";
$def7e9ba65acd6d9$export$d90250155de6d7e7 = "selected_ec29ff";
$def7e9ba65acd6d9$export$a33e918cb4258370 = "notFound_ec29ff";


var $53e25a45e116a2ee$var$CountryCodeDropdown = function(param) {
    var isOpen = param.isOpen, countryCode = param.countryCode, countryList = param.countryList, inputRef = param.inputRef, onClose = param.onClose, onChange = param.onChange;
    var isMobile = (0, $c732d3c3053b4284$export$2e2bcd8739ae039)().isMobile;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(""), 2), searchValue = _useState[0], setSearchValue = _useState[1];
    var _useState1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)({}), 2), position = _useState1[0], setPosition = _useState1[1];
    var _useState2 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(""), 2), selectedCountryCode = _useState2[0], setSelectedCountryCode = _useState2[1];
    var debouncedSearchValue = (0, $6e4bf1ac7768c678$export$2e2bcd8739ae039)(searchValue, 100);
    var onSearchChange = (0, $kVN77.useCallback)(function(param) {
        var target = param.target;
        setSearchValue(target.value);
    }, []);
    var onDestroy = (0, $kVN77.useCallback)(function() {
        setSearchValue("");
        onClose();
    }, [
        onClose
    ]);
    var onCodeChange = (0, $kVN77.useCallback)(function(value) {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
        onDestroy();
    }, [
        onChange,
        onDestroy
    ]);
    var updatePosition = (0, $kVN77.useCallback)(function() {
        var parent = inputRef === null || inputRef === void 0 ? void 0 : inputRef.parentElement;
        var offset = 8;
        if (!isMobile && parent) {
            var _parent_getBoundingClientRect = parent.getBoundingClientRect(), top = _parent_getBoundingClientRect.top, left = _parent_getBoundingClientRect.left, height = _parent_getBoundingClientRect.height, width = _parent_getBoundingClientRect.width;
            setPosition({
                top: top + height + offset,
                left: left,
                width: width
            });
            return;
        }
        setPosition({});
    }, [
        inputRef === null || inputRef === void 0 ? void 0 : inputRef.parentElement,
        isMobile
    ]);
    (0, $kVN77.useLayoutEffect)(function() {
        updatePosition();
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition);
        return function() {
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition);
        };
    }, [
        updatePosition
    ]);
    var filteredCountryList = (0, $kVN77.useMemo)(function() {
        return countryList.filter(function(param) {
            var countryCallingCode = param.countryCallingCode;
            var searchValue = debouncedSearchValue.startsWith("+") ? debouncedSearchValue.slice(1) : debouncedSearchValue;
            return countryCallingCode.startsWith(searchValue);
        });
    }, [
        countryList,
        debouncedSearchValue
    ]);
    (0, $kVN77.useLayoutEffect)(function() {
        var _filteredCountryList_;
        if (!debouncedSearchValue) {
            setSelectedCountryCode("");
            return;
        }
        // Auto Focus on the first available element
        var firstCountryCode = (_filteredCountryList_ = filteredCountryList[0]) === null || _filteredCountryList_ === void 0 ? void 0 : _filteredCountryList_.countryCallingCode;
        setSelectedCountryCode(firstCountryCode !== null && firstCountryCode !== void 0 ? firstCountryCode : "");
    }, [
        filteredCountryList,
        debouncedSearchValue
    ]);
    var onInputKeyDown = (0, $kVN77.useCallback)(function(event) {
        var key = event.key;
        switch(key){
            case "Enter":
            case " ":
                event.preventDefault();
                event.stopPropagation();
                if (selectedCountryCode) onCodeChange(selectedCountryCode);
                break;
            case "Escape":
                event.preventDefault();
                event.stopPropagation();
                onDestroy();
                break;
            case "ArrowUp":
            case "ArrowLeft":
                {
                    event.preventDefault();
                    event.stopPropagation();
                    var currentSelectedIndex = filteredCountryList.findIndex(function(param) {
                        var countryCallingCode = param.countryCallingCode;
                        return countryCallingCode === selectedCountryCode;
                    });
                    if (currentSelectedIndex <= 0) return;
                    var nextSelectedCountryCode = filteredCountryList[currentSelectedIndex - 1];
                    var _nextSelectedCountryCode_countryCallingCode;
                    setSelectedCountryCode((_nextSelectedCountryCode_countryCallingCode = nextSelectedCountryCode === null || nextSelectedCountryCode === void 0 ? void 0 : nextSelectedCountryCode.countryCallingCode) !== null && _nextSelectedCountryCode_countryCallingCode !== void 0 ? _nextSelectedCountryCode_countryCallingCode : "");
                    break;
                }
            case "-":
            case "e":
            case ".":
                event.preventDefault();
                event.stopPropagation();
                break;
            case "ArrowRight":
            case "ArrowDown":
                {
                    event.preventDefault();
                    event.stopPropagation();
                    var currentSelectedIndex1 = filteredCountryList.findIndex(function(param) {
                        var countryCallingCode = param.countryCallingCode;
                        return countryCallingCode === selectedCountryCode;
                    });
                    if (currentSelectedIndex1 >= filteredCountryList.length - 1) return;
                    var nextSelectedCountryCode1 = filteredCountryList[currentSelectedIndex1 + 1];
                    var _nextSelectedCountryCode_countryCallingCode1;
                    setSelectedCountryCode((_nextSelectedCountryCode_countryCallingCode1 = nextSelectedCountryCode1 === null || nextSelectedCountryCode1 === void 0 ? void 0 : nextSelectedCountryCode1.countryCallingCode) !== null && _nextSelectedCountryCode_countryCallingCode1 !== void 0 ? _nextSelectedCountryCode_countryCallingCode1 : "");
                    break;
                }
            default:
                break;
        }
    }, [
        filteredCountryList,
        onCodeChange,
        onDestroy,
        selectedCountryCode
    ]);
    (0, $kVN77.useLayoutEffect)(function() {
        var selectedItemDom = document.querySelector('li[data-id="'.concat(selectedCountryCode, '"]'));
        if (selectedItemDom) selectedItemDom.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }, [
        selectedCountryCode
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f4531ebf250f6fa$exports))), {
        id: "country-code-dropdown",
        isOpen: isOpen,
        overlayClassName: $def7e9ba65acd6d9$export$955245c47f738f8a,
        className: $def7e9ba65acd6d9$export$ec06ab6513f0c8c6,
        style: {
            content: (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, position)
        },
        closeTimeoutMS: 200,
        onRequestClose: function(event) {
            event.stopPropagation();
            onDestroy();
        },
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
            className: $def7e9ba65acd6d9$export$2c192705e93dd8a6,
            role: "button",
            tabIndex: 0,
            onClick: function(event) {
                // Prevent parent node trigger onClick show modal event
                event.stopPropagation();
            },
            onKeyDown: function(event) {
                // Prevent parent node trigger onClick show modal event
                event.stopPropagation();
            },
            children: [
                isMobile && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3dbbd783a5debe63$export$2e2bcd8739ae039), {
                    type: "back",
                    title: t("input.search_region_code"),
                    onClose: onDestroy
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c6a92419d85488b3$export$2e2bcd8739ae039), {
                    autoFocus: true,
                    name: "country-code-search",
                    type: "number",
                    min: 0,
                    prefix: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $085e8b8dfdd45419$export$2e2bcd8739ae039), {}),
                    value: searchValue,
                    className: $def7e9ba65acd6d9$export$1c1680d5365f3f93,
                    placeholder: t("input.search_region_code"),
                    onChange: onSearchChange,
                    onKeyDown: onInputKeyDown
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("ul", {
                    className: $def7e9ba65acd6d9$export$d4fb61928174ef64,
                    children: filteredCountryList.map(function(param) {
                        var countryCallingCode = param.countryCallingCode, countryKeyCode = param.countryCode;
                        var isActive = countryCallingCode === countryCode;
                        var isSelected = countryCallingCode === selectedCountryCode;
                        return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("li", {
                            tabIndex: 0,
                            "data-id": countryCallingCode,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))((0, $3539bd14a37ab7f4$export$c327da55a124987a)(isActive && $def7e9ba65acd6d9$export$89da14300d534261), (0, $3539bd14a37ab7f4$export$c327da55a124987a)(isSelected && $def7e9ba65acd6d9$export$d90250155de6d7e7)),
                            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                            role: "button",
                            onKeyDown: (0, $63d9e266638a38b7$export$c2c388d6a668999e)({
                                Enter: function() {
                                    onCodeChange(countryCallingCode);
                                }
                            }),
                            onClick: function() {
                                onCodeChange(countryCallingCode);
                            },
                            onMouseEnter: function() {
                                setSelectedCountryCode(countryCallingCode);
                            },
                            onMouseLeave: function() {
                                setSelectedCountryCode("");
                            },
                            children: [
                                isActive && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4b8c4593f0852a72$export$2e2bcd8739ae039), {}),
                                "+".concat(countryCallingCode)
                            ]
                        }, countryKeyCode);
                    })
                }),
                filteredCountryList.length === 0 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                    className: $def7e9ba65acd6d9$export$a33e918cb4258370,
                    children: t("description.no_region_code_found")
                })
            ]
        })
    });
};
var $53e25a45e116a2ee$export$2e2bcd8739ae039 = $53e25a45e116a2ee$var$CountryCodeDropdown;


var $06105756b01cc6ef$export$cb3d6e18dd82ab60;
$06105756b01cc6ef$export$cb3d6e18dd82ab60 = "Q8dYkq_countryCodeSelector";


var $3979bf42ca9e4cd2$var$CountryCodeSelector = function(param, ref) {
    var className = param.className, value = param.value, inputRef = param.inputRef, _param_isVisible = param.isVisible, isVisible = _param_isVisible === void 0 ? true : _param_isVisible, onChange = param.onChange;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(false), 2), isDropdownOpen = _useState[0], setIsDropdownOpen = _useState[1];
    var countryList = (0, $kVN77.useMemo)((0, $f9ff7d4c659fed5c$export$4fa5c00ca385a5d), []);
    var defaultCountCode = (0, $kVN77.useMemo)((0, $f9ff7d4c659fed5c$export$93cb54c01a2c1072), []);
    var showDropDown = function() {
        setIsDropdownOpen(true);
    };
    var hideDropDown = function() {
        setIsDropdownOpen(false);
    };
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    var countryCode = value || defaultCountCode;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($06105756b01cc6ef$export$cb3d6e18dd82ab60, className),
        role: "button",
        tabIndex: isVisible ? 0 : -1,
        onClick: showDropDown,
        onKeyDown: (0, $63d9e266638a38b7$export$c2c388d6a668999e)({
            Enter: showDropDown
        }),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
                children: "+".concat(countryCode)
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $40226f06eca87ae6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $53e25a45e116a2ee$export$2e2bcd8739ae039), {
                inputRef: inputRef,
                isOpen: isDropdownOpen,
                countryCode: countryCode,
                countryList: countryList,
                onClose: hideDropDown,
                onChange: onChange
            })
        ]
    });
};
var $3979bf42ca9e4cd2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kVN77.forwardRef)($3979bf42ca9e4cd2$var$CountryCodeSelector);






var $kVN77 = parcelRequire("kVN77");


var $kVN77 = parcelRequire("kVN77");
var $c4c7aaed0320d9dd$var$useUpdateEffect = function(effect) {
    var dependencies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var isMounted = (0, $kVN77.useRef)(false);
    (0, $kVN77.useEffect)(function() {
        if (!isMounted.current) {
            // eslint-disable-next-line @silverhand/fp/no-mutation
            isMounted.current = true;
            return;
        }
        return effect();
    }, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(dependencies));
};
var $c4c7aaed0320d9dd$export$2e2bcd8739ae039 = $c4c7aaed0320d9dd$var$useUpdateEffect;









var $f5597cda736a411e$var$t = (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).t;
var $f5597cda736a411e$export$729c1ad6a2d5e1a2 = function(username) {
    if (!username) return "username_required";
    if (/^\d/.test(username)) return "username_should_not_start_with_number";
    if (!(0, $9f2f5d16fced0798$export$221be9ce6b96eec3).test(username)) return "username_invalid_charset";
};
var $f5597cda736a411e$export$18148d12c805c5b0 = function(email) {
    if (!(0, $9f2f5d16fced0798$export$bdb23a0789f9885e).test(email)) return "invalid_email";
};
var $f5597cda736a411e$export$375cde19889b052f = function(value) {
    try {
        var phoneNumber = (0, $fc762b3c65644a5e$export$176bb591929cc9a8)((0, $f9ff7d4c659fed5c$export$9974d4de222cbb3a)(value));
        if (!phoneNumber.isValid()) return "invalid_phone";
    } catch (error) {
        if (error instanceof (0, $2f7663dc47f36728$export$2e2bcd8739ae039)) return "invalid_phone";
        throw error;
    }
};
var $f5597cda736a411e$export$1222f18ddc446c49 = function(type, value) {
    switch(type){
        case (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username:
            return $f5597cda736a411e$export$729c1ad6a2d5e1a2(value);
        case (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email:
            return $f5597cda736a411e$export$18148d12c805c5b0(value);
        case (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone:
            return $f5597cda736a411e$export$375cde19889b052f(value);
    }
};
var $f5597cda736a411e$var$_obj;
var $f5597cda736a411e$export$d13aed56243e4d = ($f5597cda736a411e$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f5597cda736a411e$var$_obj, (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone, "input.phone_number"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f5597cda736a411e$var$_obj, (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email, "input.email"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f5597cda736a411e$var$_obj, (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username, "input.username"), $f5597cda736a411e$var$_obj);
var $f5597cda736a411e$var$_obj1;
var $f5597cda736a411e$export$71b8592ba731d4b5 = ($f5597cda736a411e$var$_obj1 = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f5597cda736a411e$var$_obj1, (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone, "description.phone_number"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f5597cda736a411e$var$_obj1, (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email, "description.email"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($f5597cda736a411e$var$_obj1, (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username, "description.username"), $f5597cda736a411e$var$_obj1);
var $f5597cda736a411e$export$87161604d0c960f6 = function(enabledFields, type) {
    var data = {
        types: enabledFields.map(function(field) {
            return $f5597cda736a411e$var$t($f5597cda736a411e$export$71b8592ba731d4b5[field]);
        })
    };
    var code = type === "required" ? "error.general_required" : "error.general_invalid";
    return $f5597cda736a411e$var$t(code, data);
};
var $f5597cda736a411e$export$7778466abc57125c = function(type, value) {
    if (type === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone && value) {
        var validPhoneNumber = (0, $f9ff7d4c659fed5c$export$da44e4eaa54bc82e)(value);
        if (validPhoneNumber) return {
            countryCode: validPhoneNumber.countryCallingCode,
            inputValue: validPhoneNumber.nationalNumber
        };
    }
    return {
        inputValue: value
    };
};


var $0205daae48f547dd$var$digitsRegex = /^\d*$/;
var $0205daae48f547dd$var$useSmartInputField = function(param) {
    var _defaultType = param._defaultType, defaultValue = param.defaultValue, enabledTypes = param.enabledTypes;
    var enabledTypeSet = (0, $kVN77.useMemo)(function() {
        return new Set(enabledTypes);
    }, [
        enabledTypes
    ]);
    (0, $82d1ca91f7c283ca$export$a7a9523472993e97)(!_defaultType || enabledTypeSet.has(_defaultType), new Error("Invalid input type. Current inputType ".concat(_defaultType !== null && _defaultType !== void 0 ? _defaultType : "", " is detected but missing in enabledTypes")));
    // Parse default type from enabled types if default type is not provided and only one type is enabled
    var defaultType = (0, $kVN77.useMemo)(function() {
        return _defaultType !== null && _defaultType !== void 0 ? _defaultType : enabledTypes.length === 1 ? enabledTypes[0] : undefined;
    }, [
        _defaultType,
        enabledTypes
    ]);
    // Parse default value if provided
    var _useMemo = (0, $kVN77.useMemo)(function() {
        return (0, $f5597cda736a411e$export$7778466abc57125c)(defaultType, defaultValue);
    }, [
        defaultType,
        defaultValue
    ]), defaultCountryCode = _useMemo.countryCode, defaultInputValue = _useMemo.inputValue;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(defaultType), 2), currentType = _useState[0], setCurrentType = _useState[1];
    var _useState1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(defaultCountryCode !== null && defaultCountryCode !== void 0 ? defaultCountryCode : (0, $f9ff7d4c659fed5c$export$93cb54c01a2c1072)()), 2), countryCode = _useState1[0], setCountryCode = _useState1[1];
    var _useState2 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : ""), 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var detectInputType = (0, $kVN77.useCallback)(function(value) {
        // Reset InputType
        if (!value && enabledTypeSet.size > 1) return;
        if (enabledTypeSet.size === 1) return defaultType;
        var hasAtSymbol = value.includes("@");
        var isAllDigits = $0205daae48f547dd$var$digitsRegex.test(value);
        if (enabledTypeSet.has((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone) && value.length >= 3 && isAllDigits) return (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone;
        if (enabledTypeSet.has((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email) && hasAtSymbol) return (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email;
        if (currentType === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone && isAllDigits) return (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone;
        if (enabledTypeSet.has((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username)) return (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username;
        if (enabledTypeSet.has((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email)) return (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email;
        return currentType;
    }, [
        defaultType,
        currentType,
        enabledTypeSet
    ]);
    var onCountryCodeChange = (0, $kVN77.useCallback)(function(value) {
        if (currentType === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone) {
            var code = value.replace(/\D/g, "");
            setCountryCode(code);
        }
    }, [
        currentType
    ]);
    var onInputValueChange = (0, $kVN77.useCallback)(function(param) {
        var value = param.target.value;
        var trimValue = value.trim();
        setInputValue(trimValue);
        var type = detectInputType(trimValue);
        setCurrentType(type);
    }, [
        detectInputType
    ]);
    var onInputValueClear = (0, $kVN77.useCallback)(function() {
        setInputValue("");
        setCurrentType(enabledTypeSet.size === 1 ? defaultType : undefined);
    }, [
        defaultType,
        enabledTypeSet.size
    ]);
    // CAUTION: For preview use only, enabledTypes and defaultType should not be changed after component mounted
    (0, $c4c7aaed0320d9dd$export$2e2bcd8739ae039)(function() {
        setInputValue("");
        setCurrentType(defaultType);
    }, [
        defaultType
    ]);
    return {
        countryCode: countryCode,
        onCountryCodeChange: onCountryCodeChange,
        inputValue: inputValue,
        onInputValueChange: onInputValueChange,
        onInputValueClear: onInputValueClear,
        identifierType: currentType
    };
};
var $0205daae48f547dd$export$2e2bcd8739ae039 = $0205daae48f547dd$var$useSmartInputField;





var $2e73818d3df383cc$export$88bf6311e069f4ec = function(enabledTypes, currentType) {
    if (currentType === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone && enabledTypes.length === 1) return {
        type: "tel",
        pattern: "[0-9]*",
        inputMode: "numeric",
        autoComplete: "tel",
        placeholder: (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).t("input.phone_number")
    };
    if (currentType === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email && enabledTypes.length === 1) return {
        type: "email",
        inputMode: "email",
        autoComplete: "email",
        placeholder: (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).t("input.email")
    };
    return {
        type: "text",
        autoComplete: enabledTypes.map(function(type) {
            return type === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone ? "tel" : type;
        }).join(" "),
        placeholder: enabledTypes.map(function(type) {
            return (0, $e55f3bd5a75ab76b$export$2e2bcd8739ae039).t((0, $f5597cda736a411e$export$d13aed56243e4d)[type]);
        }).join(" / ")
    };
};


var $9deb5e2f2bcc140e$var$AnimatedInputField = (0, $0eee13c1ec6a941c$export$407448d2b89b1813)((0, $c6a92419d85488b3$export$2e2bcd8739ae039));
var $9deb5e2f2bcc140e$var$SmartInputField = function(_param, ref) {
    var defaultValue = _param.defaultValue, defaultType = _param.defaultType, _param_enabledTypes = _param.enabledTypes, enabledTypes = _param_enabledTypes === void 0 ? [] : _param_enabledTypes, onChange = _param.onChange, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_param, [
        "defaultValue",
        "defaultType",
        "enabledTypes",
        "onChange"
    ]);
    var innerRef = (0, $kVN77.useRef)(null);
    (0, $kVN77.useImperativeHandle)(ref, function() {
        return innerRef.current;
    });
    var _useSmartInputField = (0, $0205daae48f547dd$export$2e2bcd8739ae039)({
        _defaultType: defaultType,
        defaultValue: defaultValue,
        enabledTypes: enabledTypes
    }), countryCode = _useSmartInputField.countryCode, onCountryCodeChange = _useSmartInputField.onCountryCodeChange, inputValue = _useSmartInputField.inputValue, onInputValueChange = _useSmartInputField.onInputValueChange, onInputValueClear = _useSmartInputField.onInputValueClear, identifierType = _useSmartInputField.identifierType;
    var isPrefixVisible = identifierType === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone;
    var paddingLeft = (0, $e593c995dca2acdf$export$c4af9125706c4d30)({
        paddingLeft: isPrefixVisible ? 4 : 16,
        config: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, (0, $e593c995dca2acdf$export$e506a1d27d1eaa20).default), {
            clamp: true
        })
    }).paddingLeft;
    (0, $kVN77.useEffect)(function() {
        onChange === null || onChange === void 0 ? void 0 : onChange({
            type: identifierType,
            value: isPrefixVisible && inputValue ? "".concat(countryCode).concat(inputValue) : inputValue
        });
    }, [
        countryCode,
        identifierType,
        inputValue,
        isPrefixVisible,
        onChange
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)($9deb5e2f2bcc140e$var$AnimatedInputField, (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, (0, $2e73818d3df383cc$export$88bf6311e069f4ec)(enabledTypes, identifierType), rest), {
        ref: innerRef,
        isSuffixFocusVisible: Boolean(inputValue),
        style: {
            zIndex: 1,
            paddingLeft: paddingLeft
        },
        value: inputValue,
        prefix: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3e7bd8f0f1133f5c$export$2e2bcd8739ae039), {
            isVisible: isPrefixVisible,
            children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3979bf42ca9e4cd2$export$2e2bcd8739ae039), {
                value: countryCode,
                inputRef: innerRef.current,
                onChange: function(value) {
                    var _innerRef_current;
                    onCountryCodeChange(value);
                    (_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.focus();
                }
            })
        }),
        suffix: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $072ec55e67ff9777$export$2e2bcd8739ae039), {
            onMouseDown: function(event) {
                event.preventDefault();
            },
            onClick: onInputValueClear,
            children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3245b462dc65bad3$export$2e2bcd8739ae039), {})
        }),
        onChange: onInputValueChange
    }));
};
var $9deb5e2f2bcc140e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kVN77.forwardRef)($9deb5e2f2bcc140e$var$SmartInputField);





var $416a35a3b18736ca$export$6210fa4921d2a466;
var $416a35a3b18736ca$export$ce85b9b1fe34d6d3;
var $416a35a3b18736ca$export$6f2f4d5c38fc8e55;
$416a35a3b18736ca$export$6210fa4921d2a466 = "uRK25q_form";
$416a35a3b18736ca$export$ce85b9b1fe34d6d3 = "uRK25q_formErrors";
$416a35a3b18736ca$export$6f2f4d5c38fc8e55 = "uRK25q_inputField";


var $c43308a3a308b3fa$var$IdentifierProfileForm = function(param) {
    var className = param.className, autoFocus = param.autoFocus, defaultType = param.defaultType, enabledTypes = param.enabledTypes, onSubmit = param.onSubmit, errorMessage = param.errorMessage, clearErrorMessage = param.clearErrorMessage;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            identifier: {
                type: defaultType,
                value: ""
            }
        }
    }), handleSubmit = _useForm.handleSubmit, control = _useForm.control, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isValid = _useForm_formState.isValid;
    (0, $kVN77.useEffect)(function() {
        if (!isValid) clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    var onSubmitHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
                handleSubmit(function() {
                    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
                        var _param_identifier, type, value;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _param_identifier = param.identifier, type = _param_identifier.type, value = _param_identifier.value;
                                    if (!type) return [
                                        2
                                    ];
                                    return [
                                        4,
                                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(type, value)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }())(event);
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($416a35a3b18736ca$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d461588cfcd3c0f7$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                rules: {
                    validate: function(identifier) {
                        var type = identifier.type, value = identifier.value;
                        if (!type || !value) return (0, $f5597cda736a411e$export$87161604d0c960f6)(enabledTypes, "required");
                        var errorMessage = (0, $f5597cda736a411e$export$1222f18ddc446c49)(type, value);
                        var _errorMessage_data;
                        if (errorMessage) return typeof errorMessage === "string" ? t("error.".concat(errorMessage)) : t("error.".concat(errorMessage.code), (_errorMessage_data = errorMessage.data) !== null && _errorMessage_data !== void 0 ? _errorMessage_data : {});
                        return true;
                    }
                },
                render: function(param) {
                    var field = param.field;
                    var _errors_identifier;
                    /*#__PURE__*/ return (0, $d67ee09f839f930f$exports.jsx)((0, $9deb5e2f2bcc140e$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                        autoComplete: "off",
                        autoFocus: autoFocus,
                        className: $416a35a3b18736ca$export$6f2f4d5c38fc8e55
                    }, field), {
                        defaultType: defaultType,
                        isDanger: !!errors.identifier,
                        errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                        enabledTypes: enabledTypes
                    }));
                }
            }),
            errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $416a35a3b18736ca$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                title: "action.continue",
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $c43308a3a308b3fa$export$2e2bcd8739ae039 = $c43308a3a308b3fa$var$IdentifierProfileForm;









var $b942b7c103f41f15$export$2a51ca354add32e1 = function(email) {
    var _email_split = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(email.split("@"), 2), tmp = _email_split[0], name = tmp === void 0 ? "" : tmp, tmp1 = _email_split[1], domain = tmp1 === void 0 ? "" : tmp1;
    var preview = name.length > 4 ? "".concat(name.slice(0, 4)) : "";
    return "".concat(preview, "****@").concat(domain);
};
var $b942b7c103f41f15$export$1f64b92865689d0d = function(phone) {
    return "****".concat(phone.slice(-4));
};


var $088d93c285c71446$export$6d59db4903f20f7d;
$088d93c285c71446$export$6d59db4903f20f7d = "KdxC9G_description";


var $cf1e4ff0a2aa6e5b$var$SocialIdentityNotification = function(param) {
    var missingProfileTypes = param.missingProfileTypes;
    var _state_registeredSocialIdentity, _state_registeredSocialIdentity1;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var hasSocialIdentity = (0, $9ca557716949399a$export$226b3eccf92c9ed9)(state, (0, $fc4a7cd559bffd34$export$184f9f29032ada80));
    if (!hasSocialIdentity) return null;
    if (missingProfileTypes.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email) && ((_state_registeredSocialIdentity = state.registeredSocialIdentity) === null || _state_registeredSocialIdentity === void 0 ? void 0 : _state_registeredSocialIdentity.email)) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: $088d93c285c71446$export$6d59db4903f20f7d,
        children: t("description.social_identity_exist", {
            type: t("description.email"),
            value: (0, $b942b7c103f41f15$export$2a51ca354add32e1)(state.registeredSocialIdentity.email)
        })
    });
    if (missingProfileTypes.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone) && ((_state_registeredSocialIdentity1 = state.registeredSocialIdentity) === null || _state_registeredSocialIdentity1 === void 0 ? void 0 : _state_registeredSocialIdentity1.phone)) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: $088d93c285c71446$export$6d59db4903f20f7d,
        children: t("description.social_identity_exist", {
            type: t("description.phone_number"),
            value: state.registeredSocialIdentity.phone
        })
    });
    return null;
};
var $cf1e4ff0a2aa6e5b$export$2e2bcd8739ae039 = $cf1e4ff0a2aa6e5b$var$SocialIdentityNotification;


var $9a8695a8d8809418$export$b2c1506c6ba891d6 = {
    email: {
        title: "description.link_email",
        description: "description.link_email_description"
    },
    phone: {
        title: "description.link_phone",
        description: "description.link_phone_description"
    },
    emailOrPhone: {
        title: "description.link_email_or_phone",
        description: "description.link_email_or_phone_description"
    }
};
var $9a8695a8d8809418$var$formSettings = {
    email: {
        defaultType: (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email,
        enabledTypes: [
            (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email
        ]
    },
    phone: {
        defaultType: (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone,
        enabledTypes: [
            (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone
        ]
    },
    emailOrPhone: {
        defaultType: (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email,
        enabledTypes: [
            (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email,
            (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone
        ]
    }
};
var $9a8695a8d8809418$var$SetEmailOrPhone = function(param) {
    var missingProfile = param.missingProfile, notification = param.notification;
    var _useSendVerificationCode = (0, $10722ee4e324da1c$export$2e2bcd8739ae039)((0, $14a274f0b6caba9a$export$12e44e23ec720850).Continue), onSubmit = _useSendVerificationCode.onSubmit, errorMessage = _useSendVerificationCode.errorMessage, clearErrorMessage = _useSendVerificationCode.clearErrorMessage;
    var handleSubmit = function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(identifier, value) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                // Only handles email and phone
                if (identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username) return [
                    2
                ];
                return [
                    2,
                    onSubmit({
                        identifier: identifier,
                        value: value
                    })
                ];
            });
        });
        return function handleSubmit(identifier, value) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, $9a8695a8d8809418$export$b2c1506c6ba891d6[missingProfile]), {
        notification: notification,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c43308a3a308b3fa$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                autoFocus: true,
                errorMessage: errorMessage,
                clearErrorMessage: clearErrorMessage
            }, $9a8695a8d8809418$var$formSettings[missingProfile]), {
                onSubmit: handleSubmit
            })),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $cf1e4ff0a2aa6e5b$export$2e2bcd8739ae039), {
                missingProfileTypes: $9a8695a8d8809418$var$formSettings[missingProfile].enabledTypes
            })
        ]
    }));
};
var $9a8695a8d8809418$export$2e2bcd8739ae039 = $9a8695a8d8809418$var$SetEmailOrPhone;








var $kVN77 = parcelRequire("kVN77");










var $kVN77 = parcelRequire("kVN77");





var $8c0bf5e54483067e$export$b07e517d22efa1ca;
var $8c0bf5e54483067e$export$6210fa4921d2a466;
var $8c0bf5e54483067e$export$ce85b9b1fe34d6d3;
var $8c0bf5e54483067e$export$6f2f4d5c38fc8e55;
var $8c0bf5e54483067e$export$b408996a1ca2a1d7;
$8c0bf5e54483067e$export$b07e517d22efa1ca = "i0vptW_checkbox";
$8c0bf5e54483067e$export$6210fa4921d2a466 = "i0vptW_form";
$8c0bf5e54483067e$export$ce85b9b1fe34d6d3 = "i0vptW_formErrors";
$8c0bf5e54483067e$export$6f2f4d5c38fc8e55 = "i0vptW_inputField";
$8c0bf5e54483067e$export$b408996a1ca2a1d7 = "i0vptW_passwordSwitch";


var $043f70130eacf8aa$var$Lite = function(param) {
    var className = param.className, autoFocus = param.autoFocus, onSubmit = param.onSubmit, errorMessage = param.errorMessage, clearErrorMessage = param.clearErrorMessage;
    var _errors_newPassword;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            newPassword: ""
        }
    }), register = _useForm.register, handleSubmit = _useForm.handleSubmit, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isValid = _useForm_formState.isValid;
    (0, $kVN77.useEffect)(function() {
        if (!isValid) clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    var onSubmitHandler = (0, $kVN77.useCallback)(function(event) {
        clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
        handleSubmit(function(data, event) {
            onSubmit(data.newPassword);
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($8c0bf5e54483067e$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $a4c4e0bafbc43fa7$export$2e2bcd8739ae039), (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                className: $8c0bf5e54483067e$export$6f2f4d5c38fc8e55,
                autoComplete: "new-password",
                placeholder: t("input.password"),
                autoFocus: autoFocus,
                isDanger: !!errors.newPassword,
                errorMessage: (_errors_newPassword = errors.newPassword) === null || _errors_newPassword === void 0 ? void 0 : _errors_newPassword.message,
                "aria-invalid": !!errors.newPassword
            }, register("newPassword", {
                required: t("error.password_required")
            }))),
            errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $8c0bf5e54483067e$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                name: "submit",
                title: "action.save_password",
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $043f70130eacf8aa$export$2e2bcd8739ae039 = $043f70130eacf8aa$var$Lite;








var $kVN77 = parcelRequire("kVN77");















var $kVN77 = parcelRequire("kVN77");



parcelRequire("kVN77");
var $14b65e9677ee94a5$var$SvgCheckboxIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.246 2.21H3.752c-.852 0-1.543.69-1.543 1.543v10.494c0 .852.691 1.543 1.543 1.543h10.494c.853 0 1.543-.69 1.543-1.543V3.753c0-.852-.69-1.543-1.543-1.543ZM3.752.667A3.086 3.086 0 0 0 .666 3.753v10.494a3.086 3.086 0 0 0 3.086 3.086h10.494a3.086 3.086 0 0 0 3.087-3.086V3.753A3.086 3.086 0 0 0 14.246.667H3.752Z",
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("rect", {
                width: 18,
                height: 18,
                rx: 4,
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.315 12.858 4.133 9.441a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.219 2.392 4.944-5.325a.437.437 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .682l-5.91 6.351a.437.437 0 0 1-.642 0Z",
                fill: "#fff"
            })
        ]
    }));
};
var $14b65e9677ee94a5$export$2e2bcd8739ae039 = $14b65e9677ee94a5$var$SvgCheckboxIcon;


var $d10ba8d91eded89c$export$b07e517d22efa1ca;
var $d10ba8d91eded89c$export$1ca1ec8b29a4ce27;
var $d10ba8d91eded89c$export$3c17b0e969a90510;
$d10ba8d91eded89c$export$b07e517d22efa1ca = "mYxYSW_checkbox";
$d10ba8d91eded89c$export$1ca1ec8b29a4ce27 = "mYxYSW_icon";
$d10ba8d91eded89c$export$3c17b0e969a90510 = "mYxYSW_small";


var $6eb3c16efc60a801$var$Checkbox = function(_param, ref) {
    var disabled = _param.disabled, _param_size = _param.size, size = _param_size === void 0 ? "default" : _param_size, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_param, [
        "disabled",
        "size"
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: $d10ba8d91eded89c$export$b07e517d22efa1ca,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                type: "checkbox",
                disabled: disabled
            }, rest), {
                ref: ref,
                readOnly: true
            })),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $14b65e9677ee94a5$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($d10ba8d91eded89c$export$1ca1ec8b29a4ce27, size === "small" && $d10ba8d91eded89c$export$3c17b0e969a90510)
            })
        ]
    });
};
var $6eb3c16efc60a801$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kVN77.forwardRef)($6eb3c16efc60a801$var$Checkbox);




var $0cd15cdc7efc9737$var$TogglePassword = function(param) {
    var isChecked = param.isChecked, onChange = param.onChange;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var toggle = function() {
        onChange(!isChecked);
    };
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        role: "radio",
        "aria-checked": isChecked,
        tabIndex: 0,
        className: $8c0bf5e54483067e$export$b408996a1ca2a1d7,
        onClick: toggle,
        onKeyDown: (0, $63d9e266638a38b7$export$c2c388d6a668999e)({
            Escape: function() {
                onChange(false);
            },
            Enter: toggle,
            " ": toggle
        }),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $6eb3c16efc60a801$export$2e2bcd8739ae039), {
                name: "toggle-password",
                checked: isChecked,
                className: $8c0bf5e54483067e$export$b07e517d22efa1ca
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                children: t("action.show_password")
            })
        ]
    });
};
var $0cd15cdc7efc9737$export$2e2bcd8739ae039 = $0cd15cdc7efc9737$var$TogglePassword;



var $fa9987384584caf9$var$SetPassword = function(param) {
    var className = param.className, autoFocus = param.autoFocus, onSubmit = param.onSubmit, errorMessage = param.errorMessage, clearErrorMessage = param.clearErrorMessage;
    var _errors_newPassword, _errors_confirmPassword;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(false), 2), showPassword = _useState[0], setShowPassword = _useState[1];
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            newPassword: "",
            confirmPassword: ""
        }
    }), register = _useForm.register, watch = _useForm.watch, resetField = _useForm.resetField, handleSubmit = _useForm.handleSubmit, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isValid = _useForm_formState.isValid;
    (0, $kVN77.useEffect)(function() {
        if (!isValid) clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    var onSubmitHandler = (0, $kVN77.useCallback)(function(event) {
        clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
        handleSubmit(function(data, event) {
            onSubmit(data.newPassword);
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($8c0bf5e54483067e$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c6a92419d85488b3$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                className: $8c0bf5e54483067e$export$6f2f4d5c38fc8e55,
                type: showPassword ? "text" : "password",
                autoComplete: "new-password",
                placeholder: t("input.password"),
                autoFocus: autoFocus,
                isDanger: !!errors.newPassword,
                errorMessage: (_errors_newPassword = errors.newPassword) === null || _errors_newPassword === void 0 ? void 0 : _errors_newPassword.message,
                "aria-invalid": !!errors.newPassword
            }, register("newPassword", {
                required: t("error.password_required")
            })), {
                isSuffixFocusVisible: !!watch("newPassword"),
                suffix: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $072ec55e67ff9777$export$2e2bcd8739ae039), {
                    onClick: function() {
                        resetField("newPassword");
                    },
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3245b462dc65bad3$export$2e2bcd8739ae039), {})
                })
            })),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c6a92419d85488b3$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                className: $8c0bf5e54483067e$export$6f2f4d5c38fc8e55,
                type: showPassword ? "text" : "password",
                autoComplete: "new-password",
                placeholder: t("input.confirm_password"),
                errorMessage: (_errors_confirmPassword = errors.confirmPassword) === null || _errors_confirmPassword === void 0 ? void 0 : _errors_confirmPassword.message,
                "aria-invalid": !!errors.confirmPassword
            }, register("confirmPassword", {
                validate: function(value) {
                    return value === watch("newPassword") || t("error.passwords_do_not_match");
                }
            })), {
                isSuffixFocusVisible: !!watch("confirmPassword"),
                suffix: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $072ec55e67ff9777$export$2e2bcd8739ae039), {
                    onClick: function() {
                        resetField("confirmPassword");
                    },
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3245b462dc65bad3$export$2e2bcd8739ae039), {})
                })
            })),
            errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $8c0bf5e54483067e$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0cd15cdc7efc9737$export$2e2bcd8739ae039), {
                isChecked: showPassword,
                onChange: setShowPassword
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                name: "submit",
                title: "action.save_password",
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $fa9987384584caf9$export$2e2bcd8739ae039 = $fa9987384584caf9$var$SetPassword;


var $349098e4154c59e7$var$SetPassword = function(props) {
    var isForgotPasswordEnabled = (0, $41e7159e4ecba97c$export$9418daf6fcecfff4)().isForgotPasswordEnabled;
    return isForgotPasswordEnabled ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $043f70130eacf8aa$export$2e2bcd8739ae039), (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, props)) : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $fa9987384584caf9$export$2e2bcd8739ae039), (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, props));
};
var $349098e4154c59e7$export$2e2bcd8739ae039 = $349098e4154c59e7$var$SetPassword;



var $kVN77 = parcelRequire("kVN77");

var $06e76e0bce8bb876$export$753980156bc86c10 = function() {
    return (0, $kVN77.useContext)((0, $c1fc8b4c328692df$export$48cb88dd95836c3a));
};








var $kVN77 = parcelRequire("kVN77");



var $kVN77 = parcelRequire("kVN77");

/**
 * Return an object with two functions for getting the error message from an array of {@link PasswordIssue} or a {@link RequestErrorBody}.
 */ var $4387ecd34ea7a8f1$var$usePasswordErrorMessage = function() {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var getErrorMessage = (0, $kVN77.useCallback)(function(issues) {
        // Errors that should be displayed first and alone
        var singleDisplayError = [
            "unsupported_characters",
            "too_short",
            "character_types",
            "too_long",
            "pwned"
        ].map(function(code) {
            return issues.find(function(issue) {
                return issue.code === "password_rejected.".concat(code);
            });
        }).find(Boolean);
        var _singleDisplayError_interpolation;
        if (singleDisplayError) return t("error.".concat(singleDisplayError.code), (_singleDisplayError_interpolation = singleDisplayError.interpolation) !== null && _singleDisplayError_interpolation !== void 0 ? _singleDisplayError_interpolation : {});
        // The `restricted` errors should be displayed together
        var restrictedErrors = issues.filter(function(issue) {
            return issue.code.startsWith("password_rejected.restricted.");
        }).map(function(issue) {
            return t("error.".concat(issue.code));
        });
        if (restrictedErrors.length > 0) return t("error.password_rejected.restricted_found", {
            list: restrictedErrors
        });
    }, [
        t
    ]);
    var getErrorMessageFromBody = (0, $kVN77.useCallback)(function(error) {
        var _getErrorMessage;
        if (error.code === "password.rejected") // eslint-disable-next-line no-restricted-syntax -- trust the type from the server if the code matches
        return (_getErrorMessage = getErrorMessage(error.data)) !== null && _getErrorMessage !== void 0 ? _getErrorMessage : error.message;
    }, [
        getErrorMessage
    ]);
    return {
        /**
     * Get the error message from an array of {@link PasswordIssue}.
     * If the array is empty or the error is not recognized, `undefined` is returned.
     */ getErrorMessage: getErrorMessage,
        /**
     * Get the error message from a {@link RequestErrorBody}.
     *
     * First, it will check if the error code is `password.rejected`:
     * - If so, it will assume `error.data` is an array of {@link PasswordIssue}, then it will call
     * {@link getErrorMessage} with the array;
     *   - If the result is `undefined`, it will directly return the error message from the body.
     * - Otherwise, it will return `undefined`.
     */ getErrorMessageFromBody: getErrorMessageFromBody
    };
};
var $4387ecd34ea7a8f1$export$2e2bcd8739ae039 = $4387ecd34ea7a8f1$var$usePasswordErrorMessage;



var $3bd7fa0ea81303e7$var$usePasswordAction = function(param) {
    var api = param.api, errorHandlers = param.errorHandlers, setErrorMessage = param.setErrorMessage, successHandler = param.successHandler;
    var asyncAction = (0, $57790173b1762f43$export$2e2bcd8739ae039)(api);
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var _usePasswordErrorMessage = (0, $4387ecd34ea7a8f1$export$2e2bcd8739ae039)(), getErrorMessage = _usePasswordErrorMessage.getErrorMessage, getErrorMessageFromBody = _usePasswordErrorMessage.getErrorMessageFromBody;
    var policyChecker = (0, $41e7159e4ecba97c$export$b03f85e37d353e63)().policyChecker;
    var passwordRejectionHandler = (0, $kVN77.useCallback)(function(error) {
        setErrorMessage(getErrorMessageFromBody(error));
    }, [
        getErrorMessageFromBody,
        setErrorMessage
    ]);
    var action = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(password) {
            var fastCheckErrorMessage, _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fastCheckErrorMessage = getErrorMessage(policyChecker.fastCheck(password));
                        if (fastCheckErrorMessage) {
                            setErrorMessage(fastCheckErrorMessage);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            asyncAction(password)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                                "password.rejected": passwordRejectionHandler
                            }, errorHandlers))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        successHandler(result);
                        return [
                            2
                        ];
                }
            });
        });
        return function(password) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncAction,
        errorHandlers,
        getErrorMessage,
        handleError,
        passwordRejectionHandler,
        policyChecker,
        setErrorMessage,
        successHandler
    ]);
    return [
        action
    ];
};
var $3bd7fa0ea81303e7$export$2e2bcd8739ae039 = $3bd7fa0ea81303e7$var$usePasswordAction;




var $kVN77 = parcelRequire("kVN77");





var $kVN77 = parcelRequire("kVN77");












var $kVN77 = parcelRequire("kVN77");





var $73d46563dd07074d$var$useStartTotpBinding = function() {
    var replace = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).replace;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var asyncCreateTotpSecret = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$ed04f454e58389a8));
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    return (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(flowState) {
            var _ref, error, result, _ref1, secret, secretQrCode, state;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            asyncCreateTotpSecret()
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        _ref1 = result !== null && result !== void 0 ? result : {}, secret = _ref1.secret, secretQrCode = _ref1.secretQrCode;
                        if (secret && secretQrCode) {
                            state = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                                secret: secret,
                                secretQrCode: secretQrCode
                            }, flowState);
                            navigate({
                                pathname: "/".concat((0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding, "/").concat((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP)
                            }, {
                                replace: replace,
                                state: state
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(flowState) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncCreateTotpSecret,
        handleError,
        navigate,
        replace
    ]);
};
var $73d46563dd07074d$export$2e2bcd8739ae039 = $73d46563dd07074d$var$useStartTotpBinding;








var $kVN77 = parcelRequire("kVN77");





var $adcfa61f2765f1c4$var$useStartWebAuthnProcessing = function() {
    var replace = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).replace;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var asyncCreateRegistrationOptions = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$4a7a1c8b5ba74d74));
    var asyncGenerateAuthnOptions = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$dddc1626e5376ab0));
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    return (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(flow, flowState) {
            var _ref, error, options, _tmp, state;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(flow === (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            asyncCreateRegistrationOptions()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            asyncGenerateAuthnOptions()
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _tmp,
                            2
                        ]), error = _ref[0], options = _ref[1];
                        if (!error) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            handleError(error)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if (options) {
                            state = (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                                options: options
                            }, flowState);
                            navigate({
                                pathname: "/".concat(flow, "/").concat((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn)
                            }, {
                                replace: replace,
                                state: state
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(flow, flowState) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncCreateRegistrationOptions,
        asyncGenerateAuthnOptions,
        handleError,
        navigate,
        replace
    ]);
};
var $adcfa61f2765f1c4$export$2e2bcd8739ae039 = $adcfa61f2765f1c4$var$useStartWebAuthnProcessing;



var $e2e28e183cb08e20$var$useMfaErrorHandler = function() {
    var replace = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).replace;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var startTotpBinding = (0, $73d46563dd07074d$export$2e2bcd8739ae039)({
        replace: replace
    });
    var startWebAuthnProcessing = (0, $adcfa61f2765f1c4$export$2e2bcd8739ae039)({
        replace: replace
    });
    /**
   * Redirect the user to the corresponding MFA page.
   *
   * Binding pages are hosted on following routes:
   * - /{@link UserMfaFlow.MfaBinding} List of available MFA factors for binding.
   * - /{@link UserMfaFlow.MfaBinding}/{@link MfaFactor} Binding page for the specific factor.
   *
   * Verification pages are hosted on following routes:
   * - /{@link UserMfaFlow.MfaVerification} List of available MFA factors for verification.
   * - /{@link UserMfaFlow.MfaVerification}/{@link MfaFactor} Verification page for the specific factor.
   *
   * Redirection rules:
   * - If there is only one available factor, redirect to the specific MFA factor page.
   * - If there are multiple available factors:
   *    - Binding: redirect to the available factors list page.
   *    - Verification: redirect to the last used specific factor page.
   */ var handleMfaRedirect = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(flow, state) {
            var availableFactors, factor;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                availableFactors = state.availableFactors;
                if (availableFactors.length > 1 && flow === (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding) {
                    /**
         * Redirect to the MFA binding page if there are multiple available factors.
         */ navigate({
                        pathname: "/".concat(flow)
                    }, {
                        replace: replace,
                        state: state
                    });
                    return [
                        2
                    ];
                }
                factor = availableFactors[0];
                if (!factor) {
                    /**
         * This should never happen since we check the available factors' length before handling the redirection.
         */ setToast(t("error.unknown"));
                    return [
                        2
                    ];
                }
                if (factor === (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP && flow === (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding) /**
         * Start TOTP binding process if only TOTP is available.
         */ return [
                    2,
                    startTotpBinding(state)
                ];
                if (factor === (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn) /**
         * Start WebAuthn processing if only TOTP is available.
         */ return [
                    2,
                    startWebAuthnProcessing(flow, state)
                ];
                /**
       * Redirect to the specific MFA factor page.
       */ navigate({
                    pathname: "/".concat(flow, "/").concat(factor)
                }, {
                    replace: replace,
                    state: state
                });
                return [
                    2
                ];
            });
        });
        return function(flow, state) {
            return _ref.apply(this, arguments);
        };
    }(), [
        navigate,
        replace,
        setToast,
        startTotpBinding,
        startWebAuthnProcessing,
        t
    ]);
    var handleMfaError = (0, $kVN77.useCallback)(function(flow) {
        return function() {
            var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error) {
                var _validate, _, data, _data_availableFactors, factors, skippable, availableFactors;
                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(error.data, (0, $fc4a7cd559bffd34$export$c098e744493f7349)), 2), _ = _validate[0], data = _validate[1];
                            factors = (_data_availableFactors = data === null || data === void 0 ? void 0 : data.availableFactors) !== null && _data_availableFactors !== void 0 ? _data_availableFactors : [];
                            skippable = data === null || data === void 0 ? void 0 : data.skippable;
                            if (factors.length === 0) {
                                setToast(error.message);
                                return [
                                    2
                                ];
                            }
                            availableFactors = // Hide the webauthn factor on native webview if the user has other options, since it's not supported.
                            (0, $77651ccac61c94e5$export$a38f4a317af23d71)() && factors.length > 1 ? factors.filter(function(factor) {
                                return factor !== (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn;
                            }) : factors;
                            return [
                                4,
                                handleMfaRedirect(flow, {
                                    availableFactors: availableFactors,
                                    skippable: skippable
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(error) {
                return _ref.apply(this, arguments);
            };
        }();
    }, [
        handleMfaRedirect,
        setToast
    ]);
    var handleBackupCodeError = (0, $kVN77.useCallback)(function(error) {
        var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(error.data, (0, $fc4a7cd559bffd34$export$4a47cfca3f992c62)), 2), _ = _validate[0], data = _validate[1];
        if (!data) {
            setToast(error.message);
            return;
        }
        navigate({
            pathname: "/".concat((0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding, "/").concat((0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode)
        }, {
            replace: replace,
            state: data
        });
    }, [
        navigate,
        replace,
        setToast
    ]);
    var mfaVerificationErrorHandler = (0, $kVN77.useMemo)(function() {
        return {
            "user.missing_mfa": handleMfaError((0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding),
            "session.mfa.require_mfa_verification": handleMfaError((0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaVerification),
            "session.mfa.backup_code_required": handleBackupCodeError
        };
    }, [
        handleBackupCodeError,
        handleMfaError
    ]);
    return mfaVerificationErrorHandler;
};
var $e2e28e183cb08e20$export$2e2bcd8739ae039 = $e2e28e183cb08e20$var$useMfaErrorHandler;






var $kVN77 = parcelRequire("kVN77");






var $9442fe60a26140ba$var$useRequiredProfileErrorHandler = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, replace = _ref.replace, linkSocial = _ref.linkSocial;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var requiredProfileErrorHandler = (0, $kVN77.useMemo)(function() {
        return {
            "user.missing_profile": function(error) {
                var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(error.data, (0, $fc4a7cd559bffd34$export$4563eb9e4106afd7)), 2), data = _validate[1];
                // Required as a sign up method but missing in the user profile
                var missingProfile = data === null || data === void 0 ? void 0 : data.missingProfile[0];
                // Required as a sign up method, verified email or phone can be found in Social Identity, but registered with a different account
                var registeredSocialIdentity = data === null || data === void 0 ? void 0 : data.registeredSocialIdentity;
                var linkSocialQueryString = linkSocial ? "?".concat((0, $300f68c6e84b0fc8$export$160057b430cb5a30)((0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, (0, $14a274f0b6caba9a$export$c4eb3ba4f04fab5).LinkSocial, linkSocial))) : undefined;
                switch(missingProfile){
                    case (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).password:
                    case (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).username:
                        navigate({
                            pathname: "/".concat((0, $14a274f0b6caba9a$export$12e44e23ec720850).Continue, "/").concat(missingProfile)
                        }, {
                            replace: replace
                        });
                        break;
                    case (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).email:
                    case (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).phone:
                    case (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).emailOrPhone:
                        navigate({
                            pathname: "/".concat((0, $14a274f0b6caba9a$export$12e44e23ec720850).Continue, "/").concat(missingProfile),
                            search: linkSocialQueryString
                        }, {
                            replace: replace,
                            state: {
                                registeredSocialIdentity: registeredSocialIdentity
                            }
                        });
                        break;
                    default:
                        setToast(error.message);
                        break;
                }
            }
        };
    }, [
        linkSocial,
        navigate,
        replace,
        setToast
    ]);
    return requiredProfileErrorHandler;
};
var $9442fe60a26140ba$export$2e2bcd8739ae039 = $9442fe60a26140ba$var$useRequiredProfileErrorHandler;


var $0c0b1ed8434c67e9$var$usePreSignInErrorHandler = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, replace = _ref.replace, linkSocial = _ref.linkSocial;
    var requiredProfileErrorHandler = (0, $9442fe60a26140ba$export$2e2bcd8739ae039)({
        replace: replace,
        linkSocial: linkSocial
    });
    var mfaErrorHandler = (0, $e2e28e183cb08e20$export$2e2bcd8739ae039)({
        replace: replace
    });
    return (0, $kVN77.useMemo)(function() {
        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, requiredProfileErrorHandler, mfaErrorHandler);
    }, [
        mfaErrorHandler,
        requiredProfileErrorHandler
    ]);
};
var $0c0b1ed8434c67e9$export$2e2bcd8739ae039 = $0c0b1ed8434c67e9$var$usePreSignInErrorHandler;



var $6e7c35fc3c7ba7c5$var$SetPassword = function() {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    var clearErrorMessage = (0, $kVN77.useCallback)(function() {
        setErrorMessage(undefined);
    }, []);
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var show = (0, $06e76e0bce8bb876$export$753980156bc86c10)().show;
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)();
    var errorHandlers = (0, $kVN77.useMemo)(function() {
        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            "user.password_exists_in_profile": function() {
                var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error) {
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    show({
                                        type: "alert",
                                        ModalContent: error.message,
                                        cancelText: "action.got_it"
                                    })
                                ];
                            case 1:
                                _state.sent();
                                navigate(-1);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(error) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, preSignInErrorHandler);
    }, [
        navigate,
        preSignInErrorHandler,
        show
    ]);
    var successHandler = (0, $kVN77.useCallback)(function(result) {
        if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
    }, [
        redirectTo
    ]);
    var _usePasswordAction = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $3bd7fa0ea81303e7$export$2e2bcd8739ae039)({
        api: function() {
            var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(password) {
                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                    return [
                        2,
                        (0, $bc69946dbbb06dd3$export$32da561ec87acb84)({
                            password: password
                        })
                    ];
                });
            });
            return function(password) {
                return _ref.apply(this, arguments);
            };
        }(),
        setErrorMessage: setErrorMessage,
        errorHandlers: errorHandlers,
        successHandler: successHandler
    }), 1), action = _usePasswordAction[0];
    var _usePasswordPolicy = (0, $41e7159e4ecba97c$export$b03f85e37d353e63)(), _usePasswordPolicy_policy = _usePasswordPolicy.policy, _usePasswordPolicy_policy_length = _usePasswordPolicy_policy.length, min = _usePasswordPolicy_policy_length.min, max = _usePasswordPolicy_policy_length.max, _usePasswordPolicy_policy_characterTypes = _usePasswordPolicy_policy.characterTypes, count = _usePasswordPolicy_policy_characterTypes.min, requirementsDescription = _usePasswordPolicy.requirementsDescription;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "description.set_password",
        description: requirementsDescription && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
            children: requirementsDescription
        }),
        descriptionProps: {
            min: min,
            count: count
        },
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $349098e4154c59e7$export$2e2bcd8739ae039), {
            autoFocus: true,
            errorMessage: errorMessage,
            maxLength: max,
            clearErrorMessage: clearErrorMessage,
            onSubmit: action
        })
    });
};
var $6e7c35fc3c7ba7c5$export$2e2bcd8739ae039 = $6e7c35fc3c7ba7c5$var$SetPassword;















var $kVN77 = parcelRequire("kVN77");





var $007504ee3827e740$var$useSetUsername = function() {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    var clearErrorMessage = (0, $kVN77.useCallback)(function() {
        setErrorMessage("");
    }, []);
    var asyncAddProfile = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$32da561ec87acb84));
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)();
    var errorHandlers = (0, $kVN77.useMemo)(function() {
        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            "user.username_already_in_use": function(error) {
                setErrorMessage(error.message);
            }
        }, preSignInErrorHandler);
    }, [
        preSignInErrorHandler
    ]);
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(username) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            asyncAddProfile({
                                username: username
                            })
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, errorHandlers)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(username) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncAddProfile,
        errorHandlers,
        handleError,
        redirectTo
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $007504ee3827e740$export$2e2bcd8739ae039 = $007504ee3827e740$var$useSetUsername;


var $32f372aae562c083$var$SetUsername = function(props) {
    var _useSetUsername = (0, $007504ee3827e740$export$2e2bcd8739ae039)(), onSubmit = _useSetUsername.onSubmit, errorMessage = _useSetUsername.errorMessage, clearErrorMessage = _useSetUsername.clearErrorMessage;
    var handleSubmit = function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(identifier, value) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                if (identifier !== (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username) return [
                    2
                ];
                return [
                    2,
                    onSubmit(value)
                ];
            });
        });
        return function handleSubmit(identifier, value) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        title: "description.enter_username",
        description: "description.enter_username_description"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c43308a3a308b3fa$export$2e2bcd8739ae039), {
            autoFocus: true,
            errorMessage: errorMessage,
            clearErrorMessage: clearErrorMessage,
            defaultType: (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username,
            enabledTypes: [
                (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username
            ],
            onSubmit: handleSubmit
        })
    }));
};
var $32f372aae562c083$export$2e2bcd8739ae039 = $32f372aae562c083$var$SetUsername;


var $61537c8153769054$var$Continue = function() {
    var _useParams = (0, $1c3a22059b479044$export$99eaa27ddbbb95ef)(), _useParams_method = _useParams.method, method = _useParams_method === void 0 ? "" : _useParams_method;
    if (method === (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).password) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $6e7c35fc3c7ba7c5$export$2e2bcd8739ae039), {});
    if (method === (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).username) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $32f372aae562c083$export$2e2bcd8739ae039), {});
    if (method === (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).email || method === (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).phone || method === (0, $23cc5c0bb86213bf$export$68a887ed3b61b98e).emailOrPhone) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $9a8695a8d8809418$export$2e2bcd8739ae039), {
        missingProfile: method
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {});
};
var $61537c8153769054$export$2e2bcd8739ae039 = $61537c8153769054$var$Continue;






var $kVN77 = parcelRequire("kVN77");







var $kVN77 = parcelRequire("kVN77");






var $b8a629ba0d2b2e81$var$useSocial = function() {
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), experienceSettings = _useContext.experienceSettings, theme = _useContext.theme;
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var asyncInvokeSocialSignIn = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$58837cdda1b658ed));
    var nativeSignInHandler = (0, $kVN77.useCallback)(function(redirectTo, connector) {
        var _getLogtoNativeSdk;
        var connectorId = connector.id, platform = connector.platform;
        var redirectUri = platform === (0, $dfa943a5a56dac4f$export$e2b8cfc001e78efb).Universal ? (0, $6f7af2e59a37a635$export$89813b95fc66aafa)("/social/landing/".concat(connectorId), redirectTo).toString() : redirectTo;
        (_getLogtoNativeSdk = (0, $77651ccac61c94e5$export$83ff207f4052eaad)()) === null || _getLogtoNativeSdk === void 0 ? void 0 : _getLogtoNativeSdk.getPostMessage()({
            callbackUri: "".concat(window.location.origin, "/callback/social/").concat(connectorId),
            redirectTo: redirectUri
        });
    }, []);
    var invokeSocialSignInHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connector) {
            var connectorId, state, _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        connectorId = connector.id;
                        state = (0, $6f7af2e59a37a635$export$9ccd2716e53a229b)();
                        (0, $6f7af2e59a37a635$export$ca97131192bad836)(state, connectorId);
                        return [
                            4,
                            asyncInvokeSocialSignIn(connectorId, state, "".concat(window.location.origin, "/callback/").concat(connectorId))
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        if (!(result === null || result === void 0 ? void 0 : result.redirectTo)) return [
                            2
                        ];
                        // Invoke native social sign-in flow
                        if ((0, $77651ccac61c94e5$export$a38f4a317af23d71)()) {
                            nativeSignInHandler(result.redirectTo, connector);
                            return [
                                2
                            ];
                        }
                        // Invoke web social sign-in flow
                        window.location.assign(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(connector) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncInvokeSocialSignIn,
        handleError,
        nativeSignInHandler
    ]);
    var _experienceSettings_socialConnectors;
    return {
        theme: theme,
        socialConnectors: (_experienceSettings_socialConnectors = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.socialConnectors) !== null && _experienceSettings_socialConnectors !== void 0 ? _experienceSettings_socialConnectors : [],
        invokeSocialSignIn: invokeSocialSignInHandler
    };
};
var $b8a629ba0d2b2e81$export$2e2bcd8739ae039 = $b8a629ba0d2b2e81$var$useSocial;







var $kVN77 = parcelRequire("kVN77");





var $000ef94005bc12f4$var$ssoPrefix = "".concat((0, $bc69946dbbb06dd3$export$9dd6b5912a64e305), "/single-sign-on");
var $000ef94005bc12f4$export$d4b3da5d4dacc637 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(email) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $fc2d839f2675643a$export$2e2bcd8739ae039).get("".concat($000ef94005bc12f4$var$ssoPrefix, "/connectors"), {
                    searchParams: {
                        email: email
                    }
                }).json()
            ];
        });
    });
    return function getSingleSignOnConnectors(email) {
        return _ref.apply(this, arguments);
    };
}();
var $000ef94005bc12f4$export$503f7663efe558b2 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId, state, redirectUri) {
        var redirectTo;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($000ef94005bc12f4$var$ssoPrefix, "/").concat(connectorId, "/authorization-url"), {
                            json: {
                                state: state,
                                redirectUri: redirectUri
                            }
                        }).json()
                    ];
                case 1:
                    redirectTo = _state.sent().redirectTo;
                    return [
                        2,
                        redirectTo
                    ];
            }
        });
    });
    return function getSingleSignOnUrl(connectorId, state, redirectUri) {
        return _ref.apply(this, arguments);
    };
}();
var $000ef94005bc12f4$export$c0aa2525151c2215 = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId, payload) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($000ef94005bc12f4$var$ssoPrefix, "/").concat(connectorId, "/authentication"), {
                    json: payload
                }).json()
            ];
        });
    });
    return function singleSignOnAuthorization(connectorId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var $000ef94005bc12f4$export$db343ec66e79e78a = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId) {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).put("".concat((0, $bc69946dbbb06dd3$export$9dd6b5912a64e305), "/event"), {
                            json: {
                                event: (0, $23cc5c0bb86213bf$export$5b6496a0e009b82d).Register
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0, $fc2d839f2675643a$export$2e2bcd8739ae039).post("".concat($000ef94005bc12f4$var$ssoPrefix, "/").concat(connectorId, "/registration")).json()
                    ];
            }
        });
    });
    return function singleSignOnRegistration(connectorId) {
        return _ref.apply(this, arguments);
    };
}();






var $2435299ccb0a6cc0$var$useSingleSignOn = function() {
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var asyncInvokeSingleSignOn = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $000ef94005bc12f4$export$503f7663efe558b2));
    /**
   * Native IdP Sign In Flow
   * @param redirectTo - The redirect uri to redirect after the IdP Sign In flow (Need for OIDC Code Flow)
   *
   * @remarks In Native we need to open a new window to invoke the IdP Sign In flow (safariViewController in iOS and Custom Tabs in Android)
   * Forked from @see `hooks/user-social.ts`
   *
   */ var nativeSignInHandler = (0, $kVN77.useCallback)(function(redirectTo, connectorId) {
        var _getLogtoNativeSdk;
        var redirectUri = (0, $6f7af2e59a37a635$export$89813b95fc66aafa)("/social/landing/".concat(connectorId), redirectTo).toString();
        (_getLogtoNativeSdk = (0, $77651ccac61c94e5$export$83ff207f4052eaad)()) === null || _getLogtoNativeSdk === void 0 ? void 0 : _getLogtoNativeSdk.getPostMessage()({
            callbackUri: "".concat(window.location.origin, "/callback/social/").concat(connectorId),
            redirectTo: redirectUri
        });
    }, []);
    /**
   * Invoke Single Sign On flow
   * Get the Single Sign On url from the backend and redirect to it
   */ return (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId) {
            var state, _ref, error, redirectTo;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = (0, $6f7af2e59a37a635$export$9ccd2716e53a229b)();
                        (0, $6f7af2e59a37a635$export$ca97131192bad836)(state, connectorId);
                        return [
                            4,
                            asyncInvokeSingleSignOn(connectorId, state, "".concat(window.location.origin, "/callback/").concat(connectorId))
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], redirectTo = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        if (!redirectTo) return [
                            2
                        ];
                        // Invoke Native Sign In flow
                        if ((0, $77651ccac61c94e5$export$a38f4a317af23d71)()) nativeSignInHandler(redirectTo, connectorId);
                        // Invoke Web Sign In flow
                        window.location.assign(redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(connectorId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncInvokeSingleSignOn,
        handleError,
        nativeSignInHandler
    ]);
};
var $2435299ccb0a6cc0$export$2e2bcd8739ae039 = $2435299ccb0a6cc0$var$useSingleSignOn;


var $01cd11d16d713fa3$var$DirectSignIn = function() {
    var _useParams = (0, $1c3a22059b479044$export$99eaa27ddbbb95ef)(), method = _useParams.method, target = _useParams.target;
    var _useSieMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)(), socialConnectors = _useSieMethods.socialConnectors, ssoConnectors = _useSieMethods.ssoConnectors;
    var invokeSocialSignIn = (0, $b8a629ba0d2b2e81$export$2e2bcd8739ae039)().invokeSocialSignIn;
    var invokeSso = (0, $2435299ccb0a6cc0$export$2e2bcd8739ae039)();
    var fallback = (0, $kVN77.useMemo)(function() {
        var _Object_entries_find;
        var fallbackKey = new URLSearchParams(window.location.search).get("fallback");
        var _Object_entries_find_;
        return (_Object_entries_find_ = (_Object_entries_find = Object.entries((0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes).find(function(param) {
            var _param = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)(param, 1), key = _param[0];
            return key === fallbackKey;
        })) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1]) !== null && _Object_entries_find_ !== void 0 ? _Object_entries_find_ : (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn;
    }, []);
    (0, $kVN77.useEffect)(function() {
        if (method === "social") {
            var social = socialConnectors.find(function(connector) {
                return connector.target === target;
            });
            if (social) {
                invokeSocialSignIn(social);
                return;
            }
        }
        if (method === "sso") {
            var sso = ssoConnectors.find(function(connector) {
                return connector.id === target;
            });
            if (sso) {
                invokeSso(sso.id);
                return;
            }
        }
        window.location.replace("/" + fallback);
    }, [
        fallback,
        invokeSocialSignIn,
        invokeSso,
        method,
        socialConnectors,
        ssoConnectors,
        target
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $fd8b596ccc1e1b22$export$2e2bcd8739ae039), {});
};
var $01cd11d16d713fa3$export$2e2bcd8739ae039 = $01cd11d16d713fa3$var$DirectSignIn;








var $kVN77 = parcelRequire("kVN77");















var $kVN77 = parcelRequire("kVN77");








var $ec26321c8231fea7$export$6210fa4921d2a466;
var $ec26321c8231fea7$export$ce85b9b1fe34d6d3;
var $ec26321c8231fea7$export$6f2f4d5c38fc8e55;
$ec26321c8231fea7$export$6210fa4921d2a466 = "jUsIwq_form";
$ec26321c8231fea7$export$ce85b9b1fe34d6d3 = "jUsIwq_formErrors";
$ec26321c8231fea7$export$6f2f4d5c38fc8e55 = "jUsIwq_inputField";


var $3535d268e058b460$var$ForgotPasswordForm = function(param) {
    var className = param.className, autoFocus = param.autoFocus, defaultType = param.defaultType, _param_defaultValue = param.defaultValue, defaultValue = _param_defaultValue === void 0 ? "" : _param_defaultValue, enabledTypes = param.enabledTypes;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _useSendVerificationCode = (0, $10722ee4e324da1c$export$2e2bcd8739ae039)((0, $14a274f0b6caba9a$export$12e44e23ec720850).ForgotPassword), errorMessage = _useSendVerificationCode.errorMessage, clearErrorMessage = _useSendVerificationCode.clearErrorMessage, onSubmit = _useSendVerificationCode.onSubmit;
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            identifier: {
                type: defaultType,
                value: defaultValue
            }
        }
    }), handleSubmit = _useForm.handleSubmit, control = _useForm.control, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isValid = _useForm_formState.isValid;
    (0, $kVN77.useEffect)(function() {
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    var onSubmitHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                clearErrorMessage();
                handleSubmit(function() {
                    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
                        var _param_identifier, type, value;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _param_identifier = param.identifier, type = _param_identifier.type, value = _param_identifier.value;
                                    if (!type) return [
                                        2
                                    ];
                                    return [
                                        4,
                                        onSubmit({
                                            identifier: type,
                                            value: value
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }())(event);
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($ec26321c8231fea7$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d461588cfcd3c0f7$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                rules: {
                    validate: function(identifier) {
                        var type = identifier.type, value = identifier.value;
                        if (!type || !value) return (0, $f5597cda736a411e$export$87161604d0c960f6)(enabledTypes, "required");
                        var errorMessage = (0, $f5597cda736a411e$export$1222f18ddc446c49)(type, value);
                        var _errorMessage_data;
                        if (errorMessage) return typeof errorMessage === "string" ? t("error.".concat(errorMessage)) : t("error.".concat(errorMessage.code), (_errorMessage_data = errorMessage.data) !== null && _errorMessage_data !== void 0 ? _errorMessage_data : {});
                        return true;
                    }
                },
                render: function(param) {
                    var field = param.field;
                    var _errors_identifier;
                    /*#__PURE__*/ return (0, $d67ee09f839f930f$exports.jsx)((0, $9deb5e2f2bcc140e$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                        autoFocus: autoFocus,
                        className: $ec26321c8231fea7$export$6f2f4d5c38fc8e55
                    }, field), {
                        defaultType: defaultType,
                        defaultValue: defaultValue,
                        isDanger: !!errors.identifier,
                        errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                        enabledTypes: enabledTypes
                    }));
                }
            }),
            errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $ec26321c8231fea7$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                title: "action.continue",
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $3535d268e058b460$export$2e2bcd8739ae039 = $3535d268e058b460$var$ForgotPasswordForm;


var $1925cbffb3acd848$var$ForgotPassword = function() {
    var _useForgotPasswordSettings = (0, $41e7159e4ecba97c$export$9418daf6fcecfff4)(), isForgotPasswordEnabled = _useForgotPasswordSettings.isForgotPasswordEnabled, enabledMethodSet = _useForgotPasswordSettings.enabledMethodSet;
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var enabledMethods = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(enabledMethodSet);
    var getDefaultIdentifierType = (0, $kVN77.useCallback)(function(identifier) {
        if (identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username || identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email || !identifier) return enabledMethodSet.has((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email) ? (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email : (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone;
        return enabledMethodSet.has((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone) ? (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone : (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email;
    }, [
        enabledMethodSet
    ]);
    if (!isForgotPasswordEnabled) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {});
    var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(state, (0, $fc4a7cd559bffd34$export$1e3360d68cdc393f)), 2), _ = _validate[0], identifierState = _validate[1];
    var defaultType = getDefaultIdentifierType(identifierState === null || identifierState === void 0 ? void 0 : identifierState.identifier);
    var defaultValue = (identifierState === null || identifierState === void 0 ? void 0 : identifierState.identifier) === defaultType && identifierState.value || "";
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "description.reset_password",
        description: "description.reset_password_description",
        descriptionProps: {
            types: enabledMethods.map(function(method) {
                return t((0, $f5597cda736a411e$export$71b8592ba731d4b5)[method]);
            })
        },
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3535d268e058b460$export$2e2bcd8739ae039), {
            autoFocus: true,
            defaultType: defaultType,
            defaultValue: defaultValue,
            enabledTypes: enabledMethods
        })
    });
};
var $1925cbffb3acd848$export$2e2bcd8739ae039 = $1925cbffb3acd848$var$ForgotPassword;










var $kVN77 = parcelRequire("kVN77");








parcelRequire("kVN77");
var $8036242c1df130b2$var$SvgArrowNext = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 22,
        height: 22,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "m14.245 10.349-5.188-5.18a.917.917 0 1 0-1.302 1.293l4.537 4.583-4.537 4.538a.917.917 0 0 0 .298 1.495.917.917 0 0 0 .353.072.917.917 0 0 0 .65-.275l5.189-5.179a.917.917 0 0 0 0-1.347Z",
            fill: "currentcolor"
        })
    }));
};
var $8036242c1df130b2$export$2e2bcd8739ae039 = $8036242c1df130b2$var$SvgArrowNext;





parcelRequire("kVN77");
var $b6e001412ae83316$var$SvgFactorBackupCode = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "M10 16.667H4.167a.833.833 0 0 1-.834-.834V4.167a.833.833 0 0 1 .834-.834h4.166v2.5a2.5 2.5 0 0 0 2.5 2.5h2.5v.834a.833.833 0 1 0 1.667 0V7.45a1.09 1.09 0 0 0-.05-.225V7.15a.893.893 0 0 0-.158-.233l-5-5a.892.892 0 0 0-.234-.159.267.267 0 0 0-.075 0 .733.733 0 0 0-.275-.091H4.167a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5H10a.833.833 0 0 0 0-1.666Zm0-12.159 2.158 2.159h-1.325A.833.833 0 0 1 10 5.833V4.508ZM5.833 6.667a.833.833 0 1 0 0 1.666h.834a.833.833 0 1 0 0-1.666h-.834Zm12.259 10.241-.975-.966a2.867 2.867 0 0 0-.45-3.442 2.908 2.908 0 0 0-5 2.075 2.883 2.883 0 0 0 4.275 2.542l.966.975a.834.834 0 0 0 1.366-.272.833.833 0 0 0-.182-.912ZM15.45 15.45a1.283 1.283 0 0 1-1.758 0 1.25 1.25 0 0 1 .008-1.758c.222-.221.52-.35.833-.359a1.223 1.223 0 0 1 1.3 1.242 1.25 1.25 0 0 1-.383.875ZM10.833 10h-5a.834.834 0 0 0 0 1.667h5a.833.833 0 0 0 0-1.667Zm-1.666 5a.833.833 0 1 0 0-1.667H5.833a.833.833 0 1 0 0 1.667h3.334Z",
            fill: "currentColor"
        })
    }));
};
var $b6e001412ae83316$export$2e2bcd8739ae039 = $b6e001412ae83316$var$SvgFactorBackupCode;





parcelRequire("kVN77");
var $bfd84cea89c5dd4d$var$SvgFactorTotp = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "M17.5 1.667h-5a.833.833 0 0 0 0 1.666h4.167V7.5a.833.833 0 0 0 1.666 0v-5a.833.833 0 0 0-.833-.833Zm0 10a.833.833 0 0 0-.833.833v4.167H12.5a.833.833 0 0 0 0 1.666h5a.833.833 0 0 0 .833-.833v-5a.833.833 0 0 0-.833-.833ZM10 5a2.5 2.5 0 0 0-2.5 2.5v.833A1.667 1.667 0 0 0 5.833 10v3.333A1.667 1.667 0 0 0 7.5 15h5a1.667 1.667 0 0 0 1.667-1.667V10A1.666 1.666 0 0 0 12.5 8.333V7.5A2.5 2.5 0 0 0 10 5Zm-.833 2.5a.833.833 0 0 1 1.666 0v.833H9.167V7.5Zm3.333 5.833h-5V10h5v3.333Zm-10-5a.833.833 0 0 0 .833-.833V3.333H7.5a.833.833 0 1 0 0-1.666h-5a.833.833 0 0 0-.833.833v5a.833.833 0 0 0 .833.833Zm5 8.334H3.333V12.5a.833.833 0 1 0-1.666 0v5a.833.833 0 0 0 .833.833h5a.833.833 0 1 0 0-1.666Z",
            fill: "currentColor"
        })
    }));
};
var $bfd84cea89c5dd4d$export$2e2bcd8739ae039 = $bfd84cea89c5dd4d$var$SvgFactorTotp;





parcelRequire("kVN77");
var $ca95201fdae74863$var$SvgFactorWebauthn = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("g", {
                clipPath: "url(#factor-webauthn_svg__a)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        d: "M10 2.917a.417.417 0 0 0-.417-.417h-5a.417.417 0 0 0-.416.417v2.916H10V2.917ZM4.167.833C3.247.833 2.5 1.58 2.5 2.5v3.333c0 .92.746.834 1.667.834H10c.92 0 1.667.087 1.667-.834V2.5c0-.92-.746-1.667-1.667-1.667H4.167Z"
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        d: "M.833 7.5c0-.92.747-1.667 1.667-1.667h9.167c.92 0 1.666.746 1.666 1.667H2.917a.417.417 0 0 0-.417.417v9.166c0 .23.187.417.417.417H5a.833.833 0 0 1 0 1.667H2.5c-.92 0-1.667-.747-1.667-1.667v-10ZM5.833 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667ZM8.333 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        d: "M13.75 10C11.602 10 10 11.565 10 13.333v5a.833.833 0 0 1-1.667 0v-5c0-2.834 2.502-5 5.417-5s5.417 2.166 5.417 5V15a.833.833 0 1 1-1.667 0v-1.667c0-1.768-1.602-3.333-3.75-3.333Z"
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        d: "M13.75 12.5c.767 0 1.25.548 1.25 1.06v4.773a.833.833 0 0 0 1.667 0v-4.772c0-1.58-1.383-2.728-2.917-2.728-1.534 0-2.917 1.148-2.917 2.727v.758a.833.833 0 0 0 1.667 0v-.758c0-.512.483-1.06 1.25-1.06ZM18.333 16.666c.46 0 .834.374.834.834v.833a.833.833 0 0 1-1.667 0V17.5c0-.46.373-.834.833-.834Z"
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        d: "M13.75 16.666c.46 0 .833.374.833.834v.833a.833.833 0 0 1-1.666 0V17.5c0-.46.373-.834.833-.834ZM11.667 15.833c.46 0 .833.373.833.834v1.666a.833.833 0 0 1-1.667 0v-1.666c0-.46.373-.834.834-.834ZM13.75 13.333c.46 0 .833.373.833.834V15a.833.833 0 1 1-1.666 0v-.833c0-.46.373-.834.833-.834Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("clipPath", {
                    id: "factor-webauthn_svg__a",
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }));
};
var $ca95201fdae74863$export$2e2bcd8739ae039 = $ca95201fdae74863$var$SvgFactorWebauthn;



var $d02cb41d2c08c005$export$6d59db4903f20f7d;
var $d02cb41d2c08c005$export$1ca1ec8b29a4ce27;
var $d02cb41d2c08c005$export$c4590d09863419f6;
var $d02cb41d2c08c005$export$a8ff84c12d48cfa6;
var $d02cb41d2c08c005$export$fb184b623420d9be;
$d02cb41d2c08c005$export$6d59db4903f20f7d = "lgmZXW_description";
$d02cb41d2c08c005$export$1ca1ec8b29a4ce27 = "lgmZXW_icon";
$d02cb41d2c08c005$export$c4590d09863419f6 = "lgmZXW_mfaFactorButton";
$d02cb41d2c08c005$export$a8ff84c12d48cfa6 = "lgmZXW_name";
$d02cb41d2c08c005$export$fb184b623420d9be = "lgmZXW_title";



var $2aeba39c267c8d72$var$_obj;
var $2aeba39c267c8d72$var$factorIcon = ($2aeba39c267c8d72$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP, (0, $bfd84cea89c5dd4d$export$2e2bcd8739ae039)), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn, (0, $ca95201fdae74863$export$2e2bcd8739ae039)), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode, (0, $b6e001412ae83316$export$2e2bcd8739ae039)), $2aeba39c267c8d72$var$_obj);
var $2aeba39c267c8d72$var$_obj1;
var $2aeba39c267c8d72$var$factorName = ($2aeba39c267c8d72$var$_obj1 = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj1, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP, "mfa.totp"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj1, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn, "mfa.webauthn"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj1, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode, "mfa.backup_code"), $2aeba39c267c8d72$var$_obj1);
var $2aeba39c267c8d72$var$_obj2;
var $2aeba39c267c8d72$var$factorDescription = ($2aeba39c267c8d72$var$_obj2 = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj2, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP, "mfa.verify_totp_description"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj2, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn, "mfa.verify_webauthn_description"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj2, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode, "mfa.verify_backup_code_description"), $2aeba39c267c8d72$var$_obj2);
var $2aeba39c267c8d72$var$_obj3;
var $2aeba39c267c8d72$var$linkFactorDescription = ($2aeba39c267c8d72$var$_obj3 = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj3, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP, "mfa.link_totp_description"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj3, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn, "mfa.link_webauthn_description"), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($2aeba39c267c8d72$var$_obj3, (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode, "mfa.link_backup_code_description"), $2aeba39c267c8d72$var$_obj3);
var $2aeba39c267c8d72$var$MfaFactorButton = function(param) {
    var factor = param.factor, isBinding = param.isBinding, onClick = param.onClick;
    var Icon = $2aeba39c267c8d72$var$factorIcon[factor];
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($33189750e7c5f569$export$2ba01fb71ed41cb6, $33189750e7c5f569$export$745c6f71a1e0e6f7, $33189750e7c5f569$export$f09585a853dddd32, $d02cb41d2c08c005$export$c4590d09863419f6),
        type: "button",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)(Icon, {
                className: $d02cb41d2c08c005$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $d02cb41d2c08c005$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                        className: $d02cb41d2c08c005$export$a8ff84c12d48cfa6,
                        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                            forKey: $2aeba39c267c8d72$var$factorName[factor]
                        })
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                        className: $d02cb41d2c08c005$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                            forKey: (isBinding ? $2aeba39c267c8d72$var$linkFactorDescription : $2aeba39c267c8d72$var$factorDescription)[factor]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8036242c1df130b2$export$2e2bcd8739ae039), {
                className: $d02cb41d2c08c005$export$1ca1ec8b29a4ce27
            })
        ]
    });
};
var $2aeba39c267c8d72$export$2e2bcd8739ae039 = $2aeba39c267c8d72$var$MfaFactorButton;





var $4f34e90a2bda9915$export$de1e4d7d21c95b75;
$4f34e90a2bda9915$export$de1e4d7d21c95b75 = "uWV7sG_factorList";


var $268a6092d4853b42$var$MfaFactorList = function(param) {
    var flow = param.flow, flowState = param.flowState;
    var startTotpBinding = (0, $73d46563dd07074d$export$2e2bcd8739ae039)();
    var startWebAuthnProcessing = (0, $adcfa61f2765f1c4$export$2e2bcd8739ae039)();
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var availableFactors = flowState.availableFactors;
    var handleSelectFactor = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(factor) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                if (factor === (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP && flow === (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding) return [
                    2,
                    startTotpBinding(flowState)
                ];
                if (factor === (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn) return [
                    2,
                    startWebAuthnProcessing(flow, flowState)
                ];
                navigate("/".concat(flow, "/").concat(factor), {
                    state: flowState
                });
                return [
                    2
                ];
            });
        });
        return function(factor) {
            return _ref.apply(this, arguments);
        };
    }(), [
        flow,
        flowState,
        navigate,
        startTotpBinding,
        startWebAuthnProcessing
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: $4f34e90a2bda9915$export$de1e4d7d21c95b75,
        children: availableFactors.map(function(factor) {
            return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $2aeba39c267c8d72$export$2e2bcd8739ae039), {
                factor: factor,
                isBinding: flow === (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding,
                onClick: /*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    handleSelectFactor(factor)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })
            }, factor);
        })
    });
};
var $268a6092d4853b42$export$2e2bcd8739ae039 = $268a6092d4853b42$var$MfaFactorList;






var $6b134d71e825ae84$var$useMfaFlowState = function() {
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(state, (0, $fc4a7cd559bffd34$export$5b8a6b67ca446381)), 2), mfaFlowState = _validate[1];
    return mfaFlowState;
};
var $6b134d71e825ae84$export$2e2bcd8739ae039 = $6b134d71e825ae84$var$useMfaFlowState;






var $kVN77 = parcelRequire("kVN77");





var $9f465c93765e72bf$var$useSkipMfa = function() {
    var asyncSkipMfa = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$19773ff1b0ccf87f));
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)({
        replace: true
    });
    return (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var _ref, error, result;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        asyncSkipMfa()
                    ];
                case 1:
                    _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                        _state.sent(),
                        2
                    ]), error = _ref[0], result = _ref[1];
                    if (!error) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handleError(error, preSignInErrorHandler)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    if (result) redirectTo(result.redirectTo);
                    return [
                        2
                    ];
            }
        });
    }), [
        asyncSkipMfa,
        handleError,
        preSignInErrorHandler,
        redirectTo
    ]);
};
var $9f465c93765e72bf$export$2e2bcd8739ae039 = $9f465c93765e72bf$var$useSkipMfa;




var $8a03e523b1241944$var$MfaBinding = function() {
    var flowState = (0, $6b134d71e825ae84$export$2e2bcd8739ae039)();
    var skipMfa = (0, $9f465c93765e72bf$export$2e2bcd8739ae039)();
    if (!flowState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "mfa.add_mfa_factors",
        description: "mfa.add_mfa_description",
        onSkip: (0, $3539bd14a37ab7f4$export$c327da55a124987a)(flowState.skippable && skipMfa),
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $268a6092d4853b42$export$2e2bcd8739ae039), {
            flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding,
            flowState: flowState
        })
    });
};
var $8a03e523b1241944$export$2e2bcd8739ae039 = $8a03e523b1241944$var$MfaBinding;
















var $kVN77 = parcelRequire("kVN77");






var $c9821f8b0d3e4ec3$var$sendMfaPayloadApi = function() {
    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
        var flow, payload;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            flow = param.flow, payload = param.payload;
            if (flow === (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding) return [
                2,
                (0, $bc69946dbbb06dd3$export$8a7ec544b861c507)(payload)
            ];
            return [
                2,
                (0, $bc69946dbbb06dd3$export$f34dd6a11cbbbf5c)(payload)
            ];
        });
    });
    return function sendMfaPayloadApi(_) {
        return _ref.apply(this, arguments);
    };
}();
var $c9821f8b0d3e4ec3$var$useSendMfaPayload = function() {
    var asyncSendMfaPayload = (0, $57790173b1762f43$export$2e2bcd8739ae039)($c9821f8b0d3e4ec3$var$sendMfaPayloadApi);
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)({
        replace: true
    });
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    return (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(apiOptions, errorHandlers, errorCallback) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            asyncSendMfaPayload(apiOptions)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, errorHandlers, preSignInErrorHandler))
                        ];
                    case 2:
                        _state.sent();
                        errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback();
                        return [
                            2
                        ];
                    case 3:
                        if (result) redirectTo(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(apiOptions, errorHandlers, errorCallback) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncSendMfaPayload,
        handleError,
        preSignInErrorHandler,
        redirectTo
    ]);
};
var $c9821f8b0d3e4ec3$export$2e2bcd8739ae039 = $c9821f8b0d3e4ec3$var$useSendMfaPayload;





var $kVN77 = parcelRequire("kVN77");

var $4a6bd317e405317f$var$useTextHandler = function() {
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var copyText = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(text, successMessage) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            navigator.clipboard.writeText(text)
                        ];
                    case 1:
                        _state.sent();
                        setToast(successMessage);
                        return [
                            2
                        ];
                }
            });
        });
        return function(text, successMessage) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setToast
    ]);
    var downloadText = (0, $kVN77.useCallback)(function(text, filename) {
        var blob = new Blob([
            text
        ], {
            type: "text/plain"
        });
        var downloadLink = document.createElement("a");
        // eslint-disable-next-line @silverhand/fp/no-mutation
        downloadLink.href = URL.createObjectURL(blob);
        // eslint-disable-next-line @silverhand/fp/no-mutation
        downloadLink.download = filename;
        downloadLink.click();
    }, []);
    return {
        copyText: copyText,
        downloadText: downloadText
    };
};
var $4a6bd317e405317f$export$2e2bcd8739ae039 = $4a6bd317e405317f$var$useTextHandler;






var $49c77616879233a3$export$e324594224ef24da;
var $49c77616879233a3$export$d948f76ad23c84aa;
var $49c77616879233a3$export$34e0f9847d4c02dd;
var $49c77616879233a3$export$464c821cd4347539;
$49c77616879233a3$export$e324594224ef24da = "-6MASG_actions";
$49c77616879233a3$export$d948f76ad23c84aa = "-6MASG_backupCodes";
$49c77616879233a3$export$34e0f9847d4c02dd = "-6MASG_container";
$49c77616879233a3$export$464c821cd4347539 = "-6MASG_hint";


var $a1ff2a8f761137e8$var$BackupCodeBinding = function() {
    var _useTextHandler = (0, $4a6bd317e405317f$export$2e2bcd8739ae039)(), copyText = _useTextHandler.copyText, downloadText = _useTextHandler.downloadText;
    var sendMfaPayload = (0, $c9821f8b0d3e4ec3$export$2e2bcd8739ae039)();
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(state, (0, $fc4a7cd559bffd34$export$8572183290edea8b)), 2), backupCodeBindingState = _validate[1];
    if (!backupCodeBindingState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    var codes = backupCodeBindingState.codes;
    var backupCodeTextContent = codes.join("\n");
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        isNavBarHidden: true,
        title: "mfa.save_backup_code",
        description: "mfa.save_backup_code_description",
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
            className: $49c77616879233a3$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                    className: $49c77616879233a3$export$d948f76ad23c84aa,
                    children: codes.map(function(code) {
                        return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
                            children: code
                        }, code);
                    })
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                    className: $49c77616879233a3$export$e324594224ef24da,
                    children: [
                        !(0, $77651ccac61c94e5$export$a38f4a317af23d71)() && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                            title: "action.download",
                            type: "secondary",
                            onClick: function() {
                                downloadText(backupCodeTextContent, "backup_code.txt");
                            }
                        }),
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                            title: "action.copy",
                            type: "secondary",
                            onClick: function() {
                                copyText(backupCodeTextContent, (0, $e55f3bd5a75ab76b$export$625550452a3fa3ec)("mfa.backup_code_copied"));
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                    className: $49c77616879233a3$export$464c821cd4347539,
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                        forKey: "mfa.backup_code_hint"
                    })
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                    title: "action.continue",
                    onClick: function() {
                        sendMfaPayload({
                            flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding,
                            payload: {
                                type: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode
                            }
                        });
                    }
                })
            ]
        })
    });
};
var $a1ff2a8f761137e8$export$2e2bcd8739ae039 = $a1ff2a8f761137e8$var$BackupCodeBinding;












var $b87128b6b9eada3e$export$e8c9778bf415dd08;
var $b87128b6b9eada3e$export$53f1d5ea8de3d7c;
var $b87128b6b9eada3e$export$f0e8bbb074e276d6;
$b87128b6b9eada3e$export$e8c9778bf415dd08 = "xfK4vq_divider";
$b87128b6b9eada3e$export$53f1d5ea8de3d7c = "xfK4vq_line";
$b87128b6b9eada3e$export$f0e8bbb074e276d6 = "xfK4vq_withLabel";


var $3ce0417d4477b862$var$Divider = function(param) {
    var className = param.className, label = param.label;
    var lineStyle = (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($b87128b6b9eada3e$export$53f1d5ea8de3d7c, label && $b87128b6b9eada3e$export$f0e8bbb074e276d6);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($b87128b6b9eada3e$export$e8c9778bf415dd08, className),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("i", {
                className: lineStyle
            }),
            label && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                        forKey: label
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("i", {
                        className: lineStyle
                    })
                ]
            })
        ]
    });
};
var $3ce0417d4477b862$export$2e2bcd8739ae039 = $3ce0417d4477b862$var$Divider;






parcelRequire("kVN77");
var $4d039f1ef841f974$var$SvgSwitchIcon = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 18,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "m16.282 6.713-3-3a.753.753 0 0 0-1.065 1.065l1.726 1.718H5.25a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 .69-.465.75.75 0 0 0-.158-.818Zm-3.532 3.783H2.25a.75.75 0 0 0-.69.465.75.75 0 0 0 .157.817l3 3a.752.752 0 0 0 1.23-.82.75.75 0 0 0-.165-.245l-1.725-1.717h8.693a.75.75 0 0 0 0-1.5Z",
            fill: "currentcolor"
        })
    }));
};
var $4d039f1ef841f974$export$2e2bcd8739ae039 = $4d039f1ef841f974$var$SvgSwitchIcon;




var $0f2c4ba52ba30a23$var$SwitchMfaFactorsLink = function(param) {
    var flow = param.flow, flowState = param.flowState, className = param.className;
    var availableFactors = flowState.availableFactors;
    if (availableFactors.length < 2) return null;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
        to: "/".concat(flow),
        text: flow === (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding ? "mfa.link_another_mfa_factor" : "mfa.try_another_verification_method",
        className: className,
        icon: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4d039f1ef841f974$export$2e2bcd8739ae039), {}),
        state: flowState
    });
};
var $0f2c4ba52ba30a23$export$2e2bcd8739ae039 = $0f2c4ba52ba30a23$var$SwitchMfaFactorsLink;









var $kVN77 = parcelRequire("kVN77");



var $4034987d69250b4c$export$6d59db4903f20f7d;
var $4034987d69250b4c$export$fb184b623420d9be;
$4034987d69250b4c$export$6d59db4903f20f7d = "jP7_6G_description";
$4034987d69250b4c$export$fb184b623420d9be = "jP7_6G_title";


var $d73526ff12af063a$var$SectionLayout = function(param) {
    var title = param.title, description = param.description, titleProps = param.titleProps, descriptionProps = param.descriptionProps, children = param.children;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $4034987d69250b4c$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                    forKey: title,
                    interpolation: titleProps
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $4034987d69250b4c$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                    forKey: description,
                    interpolation: descriptionProps
                })
            }),
            children
        ]
    });
};
var $d73526ff12af063a$export$2e2bcd8739ae039 = $d73526ff12af063a$var$SectionLayout;






var $3317c25989566b1b$export$4e64a6b8369675a7;
var $3317c25989566b1b$export$b60d6dac5af5488;
var $3317c25989566b1b$export$16e41c2d67dd1b0e;
var $3317c25989566b1b$export$5835540ef8b17ae6;
$3317c25989566b1b$export$4e64a6b8369675a7 = "aeeO8G_copySecret";
$3317c25989566b1b$export$b60d6dac5af5488 = "aeeO8G_qrCode";
$3317c25989566b1b$export$16e41c2d67dd1b0e = "aeeO8G_rawSecret";
$3317c25989566b1b$export$5835540ef8b17ae6 = "aeeO8G_secretContent";


var $c93b1daae1898b41$var$SecretSection = function(param) {
    var secret = param.secret, secretQrCode = param.secretQrCode;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var isMobile = (0, $c732d3c3053b4284$export$2e2bcd8739ae039)().isMobile;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(!isMobile), 2), isQrCodeFormat = _useState[0], setIsQrCodeFormat = _useState[1];
    var copyText = (0, $4a6bd317e405317f$export$2e2bcd8739ae039)().copyText;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d73526ff12af063a$export$2e2bcd8739ae039), {
        title: "mfa.step",
        titleProps: {
            step: 1,
            content: t(isQrCodeFormat ? "mfa.scan_qr_code" : "mfa.copy_and_paste_key")
        },
        description: isQrCodeFormat ? "mfa.scan_qr_code_description" : "mfa.copy_and_paste_key_description",
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
            className: $3317c25989566b1b$export$5835540ef8b17ae6,
            children: [
                isQrCodeFormat && secretQrCode && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                    className: $3317c25989566b1b$export$b60d6dac5af5488,
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("img", {
                        src: secretQrCode,
                        alt: "QR code"
                    })
                }),
                !isQrCodeFormat && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                    className: $3317c25989566b1b$export$4e64a6b8369675a7,
                    children: [
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                            className: $3317c25989566b1b$export$16e41c2d67dd1b0e,
                            children: secret
                        }),
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                            title: "action.copy",
                            type: "secondary",
                            onClick: function() {
                                copyText(secret, t("mfa.secret_key_copied"));
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                    text: isQrCodeFormat ? "mfa.qr_code_not_available" : "mfa.want_to_scan_qr_code",
                    onClick: function() {
                        setIsQrCodeFormat(!isQrCodeFormat);
                    }
                })
            ]
        })
    });
};
var $c93b1daae1898b41$export$2e2bcd8739ae039 = $c93b1daae1898b41$var$SecretSection;








var $kVN77 = parcelRequire("kVN77");




var $kVN77 = parcelRequire("kVN77");

var $95cb407e32c3feb2$export$493b5823483d2c4e;
var $95cb407e32c3feb2$export$b3b71c1d4dc5616d;
$95cb407e32c3feb2$export$493b5823483d2c4e = "Ndr59a_errorMessage";
$95cb407e32c3feb2$export$b3b71c1d4dc5616d = "Ndr59a_passcode";


var $ad155fd3c4be76b7$export$439d7c9fdf7148d2 = 6;
var $ad155fd3c4be76b7$var$isNumeric = function(char) {
    return /^\d+$/.test(char);
};
var $ad155fd3c4be76b7$var$normalize = function(value, length) {
    if (value.length > length) return value.slice(0, length);
    if (value.length < length) // Undefined will not overwrite the original input displays, need to pass in empty string instead
    return value.concat(Array.from({
        length: length - value.length
    }).fill(""));
    return value;
};
var $ad155fd3c4be76b7$var$VerificationCode = function(param) {
    var name = param.name, className = param.className, value = param.value, _param_length = param.length, length = _param_length === void 0 ? $ad155fd3c4be76b7$export$439d7c9fdf7148d2 : _param_length, error = param.error, onChange = param.onChange;
    /* eslint-disable @typescript-eslint/ban-types */ var inputReferences = (0, $kVN77.useRef)(Array.from({
        length: length
    }).fill(null));
    /* eslint-enable @typescript-eslint/ban-types */ var codes = (0, $kVN77.useMemo)(function() {
        return $ad155fd3c4be76b7$var$normalize(value, length);
    }, [
        length,
        value
    ]);
    var updateValue = (0, $kVN77.useCallback)(function(data, targetId) {
        // Filter non-numeric input
        if (!$ad155fd3c4be76b7$var$isNumeric(data)) return;
        var chars = data.split("");
        var trimmedChars = chars.slice(0, Math.min(chars.length, codes.length - targetId));
        var value = (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(codes.slice(0, targetId)).concat((0, $15f021a0fca28358$export$1b5e630bc3aea29f)(trimmedChars), (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(codes.slice(targetId + trimmedChars.length, codes.length)));
        onChange(value);
        // Move to the next target
        var nextTarget = inputReferences.current[Math.min(targetId + trimmedChars.length, codes.length - 1)];
        nextTarget === null || nextTarget === void 0 ? void 0 : nextTarget.focus();
    }, [
        codes,
        onChange
    ]);
    var onInputHandler = (0, $kVN77.useCallback)(function(event) {
        var target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        var value = target.value, dataset = target.dataset;
        // Unrecognized target input field
        if (!dataset.id) return;
        event.preventDefault();
        updateValue(value, Number(dataset.id));
    }, [
        updateValue
    ]);
    var onPasteHandler = (0, $kVN77.useCallback)(function(event) {
        var _clipboardData_getData_match;
        if (!(event.target instanceof HTMLInputElement)) return;
        var dataset = event.target.dataset, clipboardData = event.clipboardData;
        var _clipboardData_getData_match_join;
        var data = (_clipboardData_getData_match_join = (_clipboardData_getData_match = clipboardData.getData("text").match(/\d/g)) === null || _clipboardData_getData_match === void 0 ? void 0 : _clipboardData_getData_match.join("")) !== null && _clipboardData_getData_match_join !== void 0 ? _clipboardData_getData_match_join : "";
        // Unrecognized target input field
        if (!dataset.id) return;
        event.preventDefault();
        updateValue(data, Number(dataset.id));
    }, [
        updateValue
    ]);
    var onKeyDownHandler = (0, $kVN77.useCallback)(function(event) {
        var key = event.key, target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        var value = target.value, dataset = target.dataset;
        if (!dataset.id) return;
        var targetId = Number(dataset.id);
        var nextTarget = inputReferences.current[targetId + 1];
        var previousTarget = inputReferences.current[targetId - 1];
        switch(key){
            case "Backspace":
                event.preventDefault();
                if (value) {
                    onChange(Object.assign([], codes, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, targetId, "")));
                    break;
                }
                if (previousTarget) {
                    previousTarget.focus();
                    onChange(Object.assign([], codes, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)({}, targetId - 1, "")));
                }
                break;
            case "ArrowLeft":
                event.preventDefault();
                previousTarget === null || previousTarget === void 0 ? void 0 : previousTarget.focus();
                break;
            case "ArrowRight":
                event.preventDefault();
                nextTarget === null || nextTarget === void 0 ? void 0 : nextTarget.focus();
                break;
            case "+":
            case "-":
            case "e":
            case ".":
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [
        codes,
        onChange
    ]);
    (0, $kVN77.useEffect)(function() {
        var _inputReferences_current_;
        if (value.length === 0) (_inputReferences_current_ = inputReferences.current[0]) === null || _inputReferences_current_ === void 0 ? void 0 : _inputReferences_current_.focus();
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $95cb407e32c3feb2$export$b3b71c1d4dc5616d,
                children: Array.from({
                    length: length
                }).map(function(_, index) {
                    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                        ref: function(element) {
                            // eslint-disable-next-line @silverhand/fp/no-mutation
                            inputReferences.current[index] = element;
                        },
                        name: "".concat(name, "_").concat(index),
                        "data-id": index,
                        value: codes[index],
                        type: "number",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        autoComplete: "off",
                        onPaste: onPasteHandler,
                        onInput: onInputHandler,
                        onKeyDown: onKeyDownHandler
                    }, "".concat(name, "_").concat(index));
                })
            }),
            error && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $95cb407e32c3feb2$export$493b5823483d2c4e,
                children: error
            })
        ]
    });
};
var $ad155fd3c4be76b7$export$2e2bcd8739ae039 = $ad155fd3c4be76b7$var$VerificationCode;


var $e4874d509a6b61e5$export$6bfe5f8f78a52905;
$e4874d509a6b61e5$export$6bfe5f8f78a52905 = "UnDi8G_totpCodeInput";





var $kVN77 = parcelRequire("kVN77");

var $4b97d150abacf50a$var$useTotpCodeVerification = function(flow, errorCallback) {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    var sendMfaPayload = (0, $c9821f8b0d3e4ec3$export$2e2bcd8739ae039)();
    var invalidCodeErrorHandlers = (0, $kVN77.useMemo)(function() {
        return {
            "session.mfa.invalid_totp_code": function(error) {
                setErrorMessage(error.message);
            }
        };
    }, []);
    var onSubmit = (0, $kVN77.useCallback)(function(code) {
        sendMfaPayload({
            flow: flow,
            payload: {
                type: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP,
                code: code
            }
        }, invalidCodeErrorHandlers, errorCallback);
    }, [
        errorCallback,
        flow,
        invalidCodeErrorHandlers,
        sendMfaPayload
    ]);
    return {
        errorMessage: errorMessage,
        onSubmit: onSubmit
    };
};
var $4b97d150abacf50a$export$2e2bcd8739ae039 = $4b97d150abacf50a$var$useTotpCodeVerification;


var $800edaeb20b61d66$var$totpCodeLength = 6;
var $800edaeb20b61d66$var$TotpCodeVerification = function(param) {
    var flow = param.flow;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)([]), 2), code = _useState[0], setCode = _useState[1];
    var errorCallback = (0, $kVN77.useCallback)(function() {
        setCode([]);
    }, []);
    var _useTotpCodeVerification = (0, $4b97d150abacf50a$export$2e2bcd8739ae039)(flow, errorCallback), errorMessage = _useTotpCodeVerification.errorMessage, onSubmit = _useTotpCodeVerification.onSubmit;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ad155fd3c4be76b7$export$2e2bcd8739ae039), {
        name: "totpCode",
        value: code,
        className: $e4874d509a6b61e5$export$6bfe5f8f78a52905,
        error: errorMessage,
        onChange: function(code) {
            setCode(code);
            if (code.length === $800edaeb20b61d66$var$totpCodeLength && code.every(Boolean)) onSubmit(code.join(""));
        }
    });
};
var $800edaeb20b61d66$export$2e2bcd8739ae039 = $800edaeb20b61d66$var$TotpCodeVerification;



var $bbfc281b5ad18a03$var$VerificationSection = function() {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d73526ff12af063a$export$2e2bcd8739ae039), {
        title: "mfa.step",
        titleProps: {
            step: 2,
            content: t("mfa.enter_one_time_code")
        },
        description: "mfa.enter_one_time_code_link_description",
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $800edaeb20b61d66$export$2e2bcd8739ae039), {
            flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding
        })
    });
};
var $bbfc281b5ad18a03$export$2e2bcd8739ae039 = $bbfc281b5ad18a03$var$VerificationSection;


var $f9256bf96ada973c$export$34e0f9847d4c02dd;
var $f9256bf96ada973c$export$a7420864310200cb;
$f9256bf96ada973c$export$34e0f9847d4c02dd = "_2QrTXW_container";
$f9256bf96ada973c$export$a7420864310200cb = "_2QrTXW_switchLink";


var $8656a256aed51012$var$TotpBinding = function() {
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(state, (0, $fc4a7cd559bffd34$export$8014a7293b97852c)), 2), totpBindingState = _validate[1];
    var skipMfa = (0, $9f465c93765e72bf$export$2e2bcd8739ae039)();
    if (!totpBindingState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    var availableFactors = totpBindingState.availableFactors, skippable = totpBindingState.skippable;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "mfa.add_authenticator_app",
        onSkip: (0, $3539bd14a37ab7f4$export$c327da55a124987a)(skippable && skipMfa),
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
            className: $f9256bf96ada973c$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c93b1daae1898b41$export$2e2bcd8739ae039), (0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, totpBindingState)),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3ce0417d4477b862$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $bbfc281b5ad18a03$export$2e2bcd8739ae039), {}),
                availableFactors.length > 1 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3ce0417d4477b862$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0f2c4ba52ba30a23$export$2e2bcd8739ae039), {
                            flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding,
                            flowState: {
                                availableFactors: availableFactors,
                                skippable: skippable
                            },
                            className: $f9256bf96ada973c$export$a7420864310200cb
                        })
                    ]
                })
            ]
        })
    });
};
var $8656a256aed51012$export$2e2bcd8739ae039 = $8656a256aed51012$var$TotpBinding;

















/* [@simplewebauthn/browser@10.0.0] */ 








function $7300ff2632161984$export$a2e0e37897ea77dc(buffer) {
    var bytes = new Uint8Array(buffer);
    var str = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = bytes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var charCode = _step.value;
            str += String.fromCharCode(charCode);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var base64String = btoa(str);
    return base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $7300ff2632161984$export$5fed9f4baa53df29(base64URLString) {
    var base64 = base64URLString.replace(/-/g, "+").replace(/_/g, "/");
    var padLength = (4 - base64.length % 4) % 4;
    var padded = base64.padEnd(base64.length + padLength, "=");
    var binary = atob(padded);
    var buffer = new ArrayBuffer(binary.length);
    var bytes = new Uint8Array(buffer);
    for(var i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return buffer;
}
function $7300ff2632161984$export$21f8045e1be8a25d() {
    return (window === null || window === void 0 ? void 0 : window.PublicKeyCredential) !== undefined && typeof window.PublicKeyCredential === "function";
}
function $7300ff2632161984$var$toPublicKeyCredentialDescriptor(descriptor) {
    var id = descriptor.id;
    return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, descriptor), {
        id: $7300ff2632161984$export$5fed9f4baa53df29(id),
        transports: descriptor.transports
    });
}
function $7300ff2632161984$var$isValidDomain(hostname) {
    return hostname === "localhost" || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname);
}
var $7300ff2632161984$export$90f0c14a652de832 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $e2f3b9f65e5a5430$export$7e4530ad35d3bb8)(WebAuthnError, Error1);
    var _super = (0, $cc66cd13885188db$export$8dd05c13f5255580)(WebAuthnError);
    function WebAuthnError(param) {
        var message = param.message, code = param.code, cause = param.cause, name = param.name;
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, WebAuthnError);
        var _this;
        _this = _super.call(this, message, {
            cause: cause
        });
        _this.name = name !== null && name !== void 0 ? name : cause.name;
        _this.code = code;
        return _this;
    }
    return WebAuthnError;
}((0, $efec3851c979cc44$export$2466d533fda16e33)(Error));
function $7300ff2632161984$var$identifyRegistrationError(param) {
    var error = param.error, options = param.options;
    var publicKey = options.publicKey;
    if (!publicKey) throw Error("options was missing required publicKey property");
    if (error.name === "AbortError") {
        if (options.signal instanceof AbortSignal) return new $7300ff2632161984$export$90f0c14a652de832({
            message: "Registration ceremony was sent an abort signal",
            code: "ERROR_CEREMONY_ABORTED",
            cause: error
        });
    } else if (error.name === "ConstraintError") {
        var _publicKey_authenticatorSelection, _publicKey_authenticatorSelection1;
        if (((_publicKey_authenticatorSelection = publicKey.authenticatorSelection) === null || _publicKey_authenticatorSelection === void 0 ? void 0 : _publicKey_authenticatorSelection.requireResidentKey) === true) return new $7300ff2632161984$export$90f0c14a652de832({
            message: "Discoverable credentials were required but no available authenticator supported it",
            code: "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT",
            cause: error
        });
        else if (((_publicKey_authenticatorSelection1 = publicKey.authenticatorSelection) === null || _publicKey_authenticatorSelection1 === void 0 ? void 0 : _publicKey_authenticatorSelection1.userVerification) === "required") return new $7300ff2632161984$export$90f0c14a652de832({
            message: "User verification was required but no available authenticator supported it",
            code: "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT",
            cause: error
        });
    } else if (error.name === "InvalidStateError") return new $7300ff2632161984$export$90f0c14a652de832({
        message: "The authenticator was previously registered",
        code: "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED",
        cause: error
    });
    else if (error.name === "NotAllowedError") return new $7300ff2632161984$export$90f0c14a652de832({
        message: error.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
    else if (error.name === "NotSupportedError") {
        var validPubKeyCredParams = publicKey.pubKeyCredParams.filter(function(param) {
            return param.type === "public-key";
        });
        if (validPubKeyCredParams.length === 0) return new $7300ff2632161984$export$90f0c14a652de832({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: "ERROR_MALFORMED_PUBKEYCREDPARAMS",
            cause: error
        });
        return new $7300ff2632161984$export$90f0c14a652de832({
            message: "No available authenticator supported any of the specified pubKeyCredParams algorithms",
            code: "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG",
            cause: error
        });
    } else if (error.name === "SecurityError") {
        var effectiveDomain = window.location.hostname;
        if (!$7300ff2632161984$var$isValidDomain(effectiveDomain)) return new $7300ff2632161984$export$90f0c14a652de832({
            message: "".concat(window.location.hostname, " is an invalid domain"),
            code: "ERROR_INVALID_DOMAIN",
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) return new $7300ff2632161984$export$90f0c14a652de832({
            message: 'The RP ID "'.concat(publicKey.rp.id, '" is invalid for this domain'),
            code: "ERROR_INVALID_RP_ID",
            cause: error
        });
    } else if (error.name === "TypeError") {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) return new $7300ff2632161984$export$90f0c14a652de832({
            message: "User ID was not between 1 and 64 characters",
            code: "ERROR_INVALID_USER_ID_LENGTH",
            cause: error
        });
    } else if (error.name === "UnknownError") return new $7300ff2632161984$export$90f0c14a652de832({
        message: "The authenticator was unable to process the specified options, or could not create a new credential",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: error
    });
    return error;
}
var $7300ff2632161984$var$BaseWebAuthnAbortService = /*#__PURE__*/ function() {
    "use strict";
    function BaseWebAuthnAbortService() {
        (0, $f9910f6ec45fc48d$export$2996f80ef42b8419)(this, BaseWebAuthnAbortService);
    }
    (0, $d11724f4df760fe4$export$d60067ff2358eee8)(BaseWebAuthnAbortService, [
        {
            key: "createNewAbortSignal",
            value: function createNewAbortSignal() {
                if (this.controller) {
                    var abortError = new Error("Cancelling existing WebAuthn API call for new one");
                    abortError.name = "AbortError";
                    this.controller.abort(abortError);
                }
                var newController = new AbortController();
                this.controller = newController;
                return newController.signal;
            }
        },
        {
            key: "cancelCeremony",
            value: function cancelCeremony() {
                if (this.controller) {
                    var abortError = new Error("Manually cancelling existing WebAuthn API call");
                    abortError.name = "AbortError";
                    this.controller.abort(abortError);
                    this.controller = undefined;
                }
            }
        }
    ]);
    return BaseWebAuthnAbortService;
}();
var $7300ff2632161984$export$442ada5d34ca6e87 = new $7300ff2632161984$var$BaseWebAuthnAbortService();
var $7300ff2632161984$var$attachments = [
    "cross-platform",
    "platform"
];
function $7300ff2632161984$var$toAuthenticatorAttachment(attachment) {
    if (!attachment) return;
    if ($7300ff2632161984$var$attachments.indexOf(attachment) < 0) return;
    return attachment;
}
function $7300ff2632161984$export$20d6f277a113c2ce(optionsJSON) {
    return $7300ff2632161984$var$_startRegistration.apply(this, arguments);
}
function $7300ff2632161984$var$_startRegistration() {
    $7300ff2632161984$var$_startRegistration = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(optionsJSON) {
        var _optionsJSON_excludeCredentials, publicKey, options, credential, err, id, rawId, response, type, transports, responsePublicKeyAlgorithm, responsePublicKey, _publicKey, responseAuthenticatorData;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$7300ff2632161984$export$21f8045e1be8a25d()) throw new Error("WebAuthn is not supported in this browser");
                    publicKey = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, optionsJSON), {
                        challenge: $7300ff2632161984$export$5fed9f4baa53df29(optionsJSON.challenge),
                        user: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, optionsJSON.user), {
                            id: $7300ff2632161984$export$5fed9f4baa53df29(optionsJSON.user.id)
                        }),
                        excludeCredentials: (_optionsJSON_excludeCredentials = optionsJSON.excludeCredentials) === null || _optionsJSON_excludeCredentials === void 0 ? void 0 : _optionsJSON_excludeCredentials.map($7300ff2632161984$var$toPublicKeyCredentialDescriptor)
                    });
                    options = {
                        publicKey: publicKey
                    };
                    options.signal = $7300ff2632161984$export$442ada5d34ca6e87.createNewAbortSignal();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        navigator.credentials.create(options)
                    ];
                case 2:
                    credential = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    throw $7300ff2632161984$var$identifyRegistrationError({
                        error: err,
                        options: options
                    });
                case 4:
                    if (!credential) throw new Error("Registration was not completed");
                    id = credential.id, rawId = credential.rawId, response = credential.response, type = credential.type;
                    transports = undefined;
                    if (typeof response.getTransports === "function") transports = response.getTransports();
                    responsePublicKeyAlgorithm = undefined;
                    if (typeof response.getPublicKeyAlgorithm === "function") try {
                        responsePublicKeyAlgorithm = response.getPublicKeyAlgorithm();
                    } catch (error) {
                        $7300ff2632161984$var$warnOnBrokenImplementation("getPublicKeyAlgorithm()", error);
                    }
                    responsePublicKey = undefined;
                    if (typeof response.getPublicKey === "function") try {
                        _publicKey = response.getPublicKey();
                        if (_publicKey !== null) responsePublicKey = $7300ff2632161984$export$a2e0e37897ea77dc(_publicKey);
                    } catch (error) {
                        $7300ff2632161984$var$warnOnBrokenImplementation("getPublicKey()", error);
                    }
                    if (typeof response.getAuthenticatorData === "function") try {
                        responseAuthenticatorData = $7300ff2632161984$export$a2e0e37897ea77dc(response.getAuthenticatorData());
                    } catch (error) {
                        $7300ff2632161984$var$warnOnBrokenImplementation("getAuthenticatorData()", error);
                    }
                    return [
                        2,
                        {
                            id: id,
                            rawId: $7300ff2632161984$export$a2e0e37897ea77dc(rawId),
                            response: {
                                attestationObject: $7300ff2632161984$export$a2e0e37897ea77dc(response.attestationObject),
                                clientDataJSON: $7300ff2632161984$export$a2e0e37897ea77dc(response.clientDataJSON),
                                transports: transports,
                                publicKeyAlgorithm: responsePublicKeyAlgorithm,
                                publicKey: responsePublicKey,
                                authenticatorData: responseAuthenticatorData
                            },
                            type: type,
                            clientExtensionResults: credential.getClientExtensionResults(),
                            authenticatorAttachment: $7300ff2632161984$var$toAuthenticatorAttachment(credential.authenticatorAttachment)
                        }
                    ];
            }
        });
    });
    return $7300ff2632161984$var$_startRegistration.apply(this, arguments);
}
function $7300ff2632161984$var$warnOnBrokenImplementation(methodName, cause) {
    console.warn("The browser extension that intercepted this WebAuthn API call incorrectly implemented ".concat(methodName, ". You should report this error to them.\n"), cause);
}
function $7300ff2632161984$export$18d4f667a5042852() {
    if (!$7300ff2632161984$export$21f8045e1be8a25d()) return new Promise(function(resolve) {
        return resolve(false);
    });
    var globalPublicKeyCredential = window.PublicKeyCredential;
    if (globalPublicKeyCredential.isConditionalMediationAvailable === undefined) return new Promise(function(resolve) {
        return resolve(false);
    });
    return globalPublicKeyCredential.isConditionalMediationAvailable();
}
function $7300ff2632161984$var$identifyAuthenticationError(param) {
    var error = param.error, options = param.options;
    var publicKey = options.publicKey;
    if (!publicKey) throw Error("options was missing required publicKey property");
    if (error.name === "AbortError") {
        if (options.signal instanceof AbortSignal) return new $7300ff2632161984$export$90f0c14a652de832({
            message: "Authentication ceremony was sent an abort signal",
            code: "ERROR_CEREMONY_ABORTED",
            cause: error
        });
    } else if (error.name === "NotAllowedError") return new $7300ff2632161984$export$90f0c14a652de832({
        message: error.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
    else if (error.name === "SecurityError") {
        var effectiveDomain = window.location.hostname;
        if (!$7300ff2632161984$var$isValidDomain(effectiveDomain)) return new $7300ff2632161984$export$90f0c14a652de832({
            message: "".concat(window.location.hostname, " is an invalid domain"),
            code: "ERROR_INVALID_DOMAIN",
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) return new $7300ff2632161984$export$90f0c14a652de832({
            message: 'The RP ID "'.concat(publicKey.rpId, '" is invalid for this domain'),
            code: "ERROR_INVALID_RP_ID",
            cause: error
        });
    } else if (error.name === "UnknownError") return new $7300ff2632161984$export$90f0c14a652de832({
        message: "The authenticator was unable to process the specified options, or could not create a new assertion signature",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: error
    });
    return error;
}
function $7300ff2632161984$export$c4f13730a14de143(optionsJSON) {
    return $7300ff2632161984$var$_startAuthentication.apply(this, arguments);
}
function $7300ff2632161984$var$_startAuthentication() {
    $7300ff2632161984$var$_startAuthentication = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(optionsJSON) {
        var useBrowserAutofill, _optionsJSON_allowCredentials, _optionsJSON_allowCredentials1, allowCredentials, publicKey, options, eligibleInputs, credential, err, id, rawId, response, type, userHandle;
        var _arguments = arguments;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    useBrowserAutofill = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    if (!$7300ff2632161984$export$21f8045e1be8a25d()) throw new Error("WebAuthn is not supported in this browser");
                    if (((_optionsJSON_allowCredentials = optionsJSON.allowCredentials) === null || _optionsJSON_allowCredentials === void 0 ? void 0 : _optionsJSON_allowCredentials.length) !== 0) allowCredentials = (_optionsJSON_allowCredentials1 = optionsJSON.allowCredentials) === null || _optionsJSON_allowCredentials1 === void 0 ? void 0 : _optionsJSON_allowCredentials1.map($7300ff2632161984$var$toPublicKeyCredentialDescriptor);
                    publicKey = (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, optionsJSON), {
                        challenge: $7300ff2632161984$export$5fed9f4baa53df29(optionsJSON.challenge),
                        allowCredentials: allowCredentials
                    });
                    options = {};
                    if (!useBrowserAutofill) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $7300ff2632161984$export$18d4f667a5042852()
                    ];
                case 1:
                    if (!_state.sent()) throw Error("Browser does not support WebAuthn autofill");
                    eligibleInputs = document.querySelectorAll("input[autocomplete$='webauthn']");
                    if (eligibleInputs.length < 1) throw Error('No <input> with "webauthn" as the only or last value in its `autocomplete` attribute was detected');
                    options.mediation = "conditional";
                    publicKey.allowCredentials = [];
                    _state.label = 2;
                case 2:
                    options.publicKey = publicKey;
                    options.signal = $7300ff2632161984$export$442ada5d34ca6e87.createNewAbortSignal();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        navigator.credentials.get(options)
                    ];
                case 4:
                    credential = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    err = _state.sent();
                    throw $7300ff2632161984$var$identifyAuthenticationError({
                        error: err,
                        options: options
                    });
                case 6:
                    if (!credential) throw new Error("Authentication was not completed");
                    id = credential.id, rawId = credential.rawId, response = credential.response, type = credential.type;
                    userHandle = undefined;
                    if (response.userHandle) userHandle = $7300ff2632161984$export$a2e0e37897ea77dc(response.userHandle);
                    return [
                        2,
                        {
                            id: id,
                            rawId: $7300ff2632161984$export$a2e0e37897ea77dc(rawId),
                            response: {
                                authenticatorData: $7300ff2632161984$export$a2e0e37897ea77dc(response.authenticatorData),
                                clientDataJSON: $7300ff2632161984$export$a2e0e37897ea77dc(response.clientDataJSON),
                                signature: $7300ff2632161984$export$a2e0e37897ea77dc(response.signature),
                                userHandle: userHandle
                            },
                            type: type,
                            clientExtensionResults: credential.getClientExtensionResults(),
                            authenticatorAttachment: $7300ff2632161984$var$toAuthenticatorAttachment(credential.authenticatorAttachment)
                        }
                    ];
            }
        });
    });
    return $7300ff2632161984$var$_startAuthentication.apply(this, arguments);
}
function $7300ff2632161984$export$d2e10ee5223ea44b() {
    if (!$7300ff2632161984$export$21f8045e1be8a25d()) return new Promise(function(resolve) {
        return resolve(false);
    });
    return PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
}



var $kVN77 = parcelRequire("kVN77");




var $f9ee293cbf1c78eb$var$isAuthenticationResponseJSON = function(responseJson) {
    return "signature" in responseJson.response;
};
var $f9ee293cbf1c78eb$var$useWebAuthnOperation = function() {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var sendMfaPayload = (0, $c9821f8b0d3e4ec3$export$2e2bcd8739ae039)();
    return (0, $kVN77.useCallback)(function() {
        var _ref = /**
     * Note:
     * Due to limitations in the iOS system, user interaction is required for the use of the WebAuthn API.
     * Therefore, we should avoid asynchronous operations before invoking the WebAuthn API or the os may consider the WebAuthn authorization is not initiated by the user.
     * So, we need to prepare the necessary WebAuthn options before calling the WebAuthn API, this is why we don't generate the options in this function.
     */ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(options) {
            var parsedRegistrationOptions, response;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(0, $7300ff2632161984$export$21f8045e1be8a25d)()) {
                            setToast(t("mfa.webauthn_not_supported"));
                            return [
                                2
                            ];
                        }
                        parsedRegistrationOptions = (0, $969ce540c86cdf11$export$2334438dedb2ca6f).safeParse(options);
                        return [
                            4,
                            (0, $71d6ce9e3e366d69$export$a3a27526e073307)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                    return [
                                        2,
                                        parsedRegistrationOptions.success ? (0, $7300ff2632161984$export$20d6f277a113c2ce)(parsedRegistrationOptions.data) : (0, $7300ff2632161984$export$c4f13730a14de143)(options)
                                    ];
                                });
                            }), function() {
                                setToast(t(parsedRegistrationOptions.success ? "mfa.webauthn_failed_to_create" : "mfa.webauthn_failed_to_verify"));
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response) sendMfaPayload($f9ee293cbf1c78eb$var$isAuthenticationResponseJSON(response) ? {
                            flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaVerification,
                            payload: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, response), {
                                type: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn
                            })
                        } : {
                            flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding,
                            payload: (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, response), {
                                type: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn
                            })
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(options) {
            return _ref.apply(this, arguments);
        };
    }(), [
        sendMfaPayload,
        setToast,
        t
    ]);
};
var $f9ee293cbf1c78eb$export$2e2bcd8739ae039 = $f9ee293cbf1c78eb$var$useWebAuthnOperation;






var $b82b654e51621829$export$7734b820bb2d3474 = function(options) {
    return (0, $969ce540c86cdf11$export$2334438dedb2ca6f).safeParse(options).success || (0, $969ce540c86cdf11$export$e849189769e7ddda).safeParse(options).success;
};


var $1755237970291993$export$a7420864310200cb;
$1755237970291993$export$a7420864310200cb = "dUJVga_switchLink";


var $2642a14958d25c63$var$WebAuthnBinding = function() {
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(state, (0, $fc4a7cd559bffd34$export$491937bf2814b26)), 2), webAuthnState = _validate[1];
    var handleWebAuthn = (0, $f9ee293cbf1c78eb$export$2e2bcd8739ae039)();
    var skipMfa = (0, $9f465c93765e72bf$export$2e2bcd8739ae039)();
    if (!webAuthnState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    var options = webAuthnState.options, availableFactors = webAuthnState.availableFactors, skippable = webAuthnState.skippable;
    if (!(0, $b82b654e51621829$export$7734b820bb2d3474)(options)) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "mfa.create_a_passkey",
        description: "mfa.create_passkey_description",
        onSkip: (0, $3539bd14a37ab7f4$export$c327da55a124987a)(skippable && skipMfa),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                title: "mfa.create_a_passkey",
                onClick: function() {
                    handleWebAuthn(options);
                }
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0f2c4ba52ba30a23$export$2e2bcd8739ae039), {
                flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding,
                flowState: {
                    availableFactors: availableFactors,
                    skippable: skippable
                },
                className: $1755237970291993$export$a7420864310200cb
            })
        ]
    });
};
var $2642a14958d25c63$export$2e2bcd8739ae039 = $2642a14958d25c63$var$WebAuthnBinding;








var $7f969b52341b251c$var$MfaVerification = function() {
    var flowState = (0, $6b134d71e825ae84$export$2e2bcd8739ae039)();
    if (!flowState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "mfa.verify_mfa_factors",
        description: "mfa.verify_mfa_description",
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $268a6092d4853b42$export$2e2bcd8739ae039), {
            flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaVerification,
            flowState: flowState
        })
    });
};
var $7f969b52341b251c$export$2e2bcd8739ae039 = $7f969b52341b251c$var$MfaVerification;









var $kVN77 = parcelRequire("kVN77");










var $d2f2d8d2514fc691$export$c2850a7f00aa86ec;
var $d2f2d8d2514fc691$export$b2c4be835e9aed68;
$d2f2d8d2514fc691$export$c2850a7f00aa86ec = "tQPvAq_backupCodeInput";
$d2f2d8d2514fc691$export$b2c4be835e9aed68 = "tQPvAq_switchFactorLink";


var $a714acf42399fce0$var$BackupCodeVerification = function() {
    var flowState = (0, $6b134d71e825ae84$export$2e2bcd8739ae039)();
    var sendMfaPayload = (0, $c9821f8b0d3e4ec3$export$2e2bcd8739ae039)();
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        defaultValues: {
            code: ""
        }
    }), register = _useForm.register, handleSubmit = _useForm.handleSubmit;
    var onSubmitHandler = (0, $kVN77.useCallback)(function(event) {
        handleSubmit(function() {
            var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
                var code;
                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                    code = param.code;
                    sendMfaPayload({
                        flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaVerification,
                        payload: {
                            type: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode,
                            code: code
                        }
                    });
                    return [
                        2
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }())(event);
    }, [
        handleSubmit,
        sendMfaPayload
    ]);
    if (!flowState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "mfa.verify_mfa_factors",
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d73526ff12af063a$export$2e2bcd8739ae039), {
                title: "mfa.enter_a_backup_code",
                description: "mfa.enter_backup_code_description",
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
                    onSubmit: onSubmitHandler,
                    children: [
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c6a92419d85488b3$export$2e2bcd8739ae039), (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                            autoComplete: "off",
                            placeholder: (0, $e55f3bd5a75ab76b$export$625550452a3fa3ec)("input.backup_code"),
                            className: $d2f2d8d2514fc691$export$c2850a7f00aa86ec
                        }, register("code"))),
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                            title: "action.continue",
                            htmlType: "submit"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0f2c4ba52ba30a23$export$2e2bcd8739ae039), {
                flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaVerification,
                flowState: flowState,
                className: $d2f2d8d2514fc691$export$b2c4be835e9aed68
            })
        ]
    });
};
var $a714acf42399fce0$export$2e2bcd8739ae039 = $a714acf42399fce0$var$BackupCodeVerification;










var $77222f4b8d85183d$export$b2c4be835e9aed68;
$77222f4b8d85183d$export$b2c4be835e9aed68 = "uqcIpq_switchFactorLink";


var $1d0281dcf13ce627$var$TotpVerification = function() {
    var flowState = (0, $6b134d71e825ae84$export$2e2bcd8739ae039)();
    if (!flowState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "mfa.verify_mfa_factors",
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d73526ff12af063a$export$2e2bcd8739ae039), {
                title: "mfa.enter_one_time_code",
                description: "mfa.enter_one_time_code_description",
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $800edaeb20b61d66$export$2e2bcd8739ae039), {
                    flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaVerification
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0f2c4ba52ba30a23$export$2e2bcd8739ae039), {
                flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaVerification,
                flowState: flowState,
                className: $77222f4b8d85183d$export$b2c4be835e9aed68
            })
        ]
    });
};
var $1d0281dcf13ce627$export$2e2bcd8739ae039 = $1d0281dcf13ce627$var$TotpVerification;















var $4e8c56469625b9c2$export$30f015e46281c810;
$4e8c56469625b9c2$export$30f015e46281c810 = "KMS2Oa_verifyButton";


var $2ffdfdfa07aa3a79$var$WebAuthnVerification = function() {
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(state, (0, $fc4a7cd559bffd34$export$491937bf2814b26)), 2), webAuthnState = _validate[1];
    var handleWebAuthn = (0, $f9ee293cbf1c78eb$export$2e2bcd8739ae039)();
    if (!webAuthnState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    var options = webAuthnState.options, availableFactors = webAuthnState.availableFactors, skippable = webAuthnState.skippable;
    if (!(0, $b82b654e51621829$export$7734b820bb2d3474)(options)) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "mfa.verify_mfa_factors",
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d73526ff12af063a$export$2e2bcd8739ae039), {
                title: "mfa.verify_via_passkey",
                description: "mfa.verify_via_passkey_description",
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                    title: "action.verify_via_passkey",
                    className: $4e8c56469625b9c2$export$30f015e46281c810,
                    onClick: function() {
                        handleWebAuthn(options);
                    }
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0f2c4ba52ba30a23$export$2e2bcd8739ae039), {
                flow: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaVerification,
                flowState: {
                    availableFactors: availableFactors,
                    skippable: skippable
                }
            })
        ]
    });
};
var $2ffdfdfa07aa3a79$export$2e2bcd8739ae039 = $2ffdfdfa07aa3a79$var$WebAuthnVerification;





var $kVN77 = parcelRequire("kVN77");






var $kVN77 = parcelRequire("kVN77");


var $kVN77 = parcelRequire("kVN77");
/**
 * This context is used to share the single sign on identifier status cross the page and form components.
 * If the user has entered an identifier that is associated with a single sign on method, we will show the single sign on form.
 */ var $ac4ee07ce14e681b$var$SingleSignOnFormModeContext = /*#__PURE__*/ (0, $kVN77.createContext)({
    showSingleSignOnForm: false,
    setShowSingleSignOnForm: (0, $71d6ce9e3e366d69$export$8793edee2d425525)
});
var $ac4ee07ce14e681b$export$2e2bcd8739ae039 = $ac4ee07ce14e681b$var$SingleSignOnFormModeContext;


var $3ded0681b3d0014c$var$SingleSignOnFormModeContextProvider = function(param) {
    var children = param.children;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(false), 2), showSingleSignOnForm = _useState[0], setShowSingleSignOnForm = _useState[1];
    var contextValue = (0, $kVN77.useMemo)(function() {
        return {
            showSingleSignOnForm: showSingleSignOnForm,
            setShowSingleSignOnForm: setShowSingleSignOnForm
        };
    }, [
        showSingleSignOnForm
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ac4ee07ce14e681b$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: children
    });
};
var $3ded0681b3d0014c$export$2e2bcd8739ae039 = $3ded0681b3d0014c$var$SingleSignOnFormModeContextProvider;










var $ef6872c43ebab212$export$1ca1ec8b29a4ce27;
var $ef6872c43ebab212$export$a8ff84c12d48cfa6;
var $ef6872c43ebab212$export$86d0200e957dbda1;
var $ef6872c43ebab212$export$e046c82eba182184;
$ef6872c43ebab212$export$1ca1ec8b29a4ce27 = "yRYpXa_icon";
$ef6872c43ebab212$export$a8ff84c12d48cfa6 = "yRYpXa_name";
$ef6872c43ebab212$export$86d0200e957dbda1 = "yRYpXa_placeHolder";
$ef6872c43ebab212$export$e046c82eba182184 = "yRYpXa_socialButton";



var $36d6af7b5513c7b4$var$SocialLinkButton = function(param) {
    var isDisabled = param.isDisabled, className = param.className, target = param.target, name = param.name, logo = param.logo, onClick = param.onClick;
    var _useTranslation = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)(), t = _useTranslation.t, language = _useTranslation.i18n.language;
    var _name_language;
    var localName = (_name_language = name[language]) !== null && _name_language !== void 0 ? _name_language : name.en;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("button", {
        disabled: isDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($33189750e7c5f569$export$2ba01fb71ed41cb6, $33189750e7c5f569$export$745c6f71a1e0e6f7, $33189750e7c5f569$export$f09585a853dddd32, $ef6872c43ebab212$export$e046c82eba182184, isDisabled && $33189750e7c5f569$export$683472f6198a076e, className),
        type: "button",
        onClick: onClick,
        children: [
            logo && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("img", {
                src: logo,
                alt: target,
                className: $ef6872c43ebab212$export$1ca1ec8b29a4ce27,
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $ef6872c43ebab212$export$a8ff84c12d48cfa6,
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                        className: $ef6872c43ebab212$export$86d0200e957dbda1
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
                        children: t("action.sign_in_with", {
                            name: localName
                        })
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                        className: $ef6872c43ebab212$export$86d0200e957dbda1
                    })
                ]
            })
        ]
    });
};
var $36d6af7b5513c7b4$export$2e2bcd8739ae039 = $36d6af7b5513c7b4$var$SocialLinkButton;




var $kVN77 = parcelRequire("kVN77");


/**
 * UseNativeMessageListener
 *
 * Used to monitor native error message.
 * If native error message is sent, it will be displayed as toast.
 * Add a bypass parameter to bypass the native error message listener.
 *
 * @param {boolean} bypass (default: false)
 */ var $fdc496d361a23c1c$var$useNativeMessageListener = function() {
    var bypass = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    // Monitor Native Error Message
    (0, $kVN77.useEffect)(function() {
        if (!(0, $77651ccac61c94e5$export$a38f4a317af23d71)() || bypass) return;
        var nativeMessageHandler = function(event) {
            // In the `WKWebView` of new iOS versions, some script will constantly post messages to the
            // window object with increasing numbers as the message content ("1", "2", "3", ...).
            //
            // Ideally, we should check the source of the message with Logto-specific identifier in the
            // `event.data`; however, this change will result a breaking change for the existing
            // native SDK implementations. Add the `isObject` check to prevent the crazy messages while
            // keeping the backward compatibility.
            if (event.origin === window.location.origin && (0, $6ff5599663801664$export$a6cdc56e425d0d0a)(event.data)) try {
                setToast(JSON.stringify(event.data));
            } catch (e) {}
        };
        window.addEventListener("message", nativeMessageHandler);
        return function() {
            window.removeEventListener("message", nativeMessageHandler);
        };
    }, [
        bypass,
        setToast
    ]);
};
var $fdc496d361a23c1c$export$2e2bcd8739ae039 = $fdc496d361a23c1c$var$useNativeMessageListener;



var $80e7b314a5eeea70$export$54999fc00c2d01e0;
var $80e7b314a5eeea70$export$11b6045879ed3994;
$80e7b314a5eeea70$export$54999fc00c2d01e0 = "_1lnZ2a_socialLinkButton";
$80e7b314a5eeea70$export$11b6045879ed3994 = "_1lnZ2a_socialLinkList";



var $8b617984d1d5ff25$var$SocialSignInList = function(param) {
    var className = param.className, _param_socialConnectors = param.socialConnectors, socialConnectors = _param_socialConnectors === void 0 ? [] : _param_socialConnectors;
    var _useSocial = (0, $b8a629ba0d2b2e81$export$2e2bcd8739ae039)(), invokeSocialSignIn = _useSocial.invokeSocialSignIn, theme = _useSocial.theme;
    (0, $fdc496d361a23c1c$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($80e7b314a5eeea70$export$11b6045879ed3994, className),
        children: socialConnectors.map(function(connector) {
            var id = connector.id, name = connector.name, logoUrl = connector.logo, darkLogoUrl = connector.logoDark, target = connector.target;
            return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $36d6af7b5513c7b4$export$2e2bcd8739ae039), {
                className: $80e7b314a5eeea70$export$54999fc00c2d01e0,
                name: name,
                logo: (0, $7a7feeb62f2ee9c7$export$976f80239b15365)({
                    theme: theme,
                    logoUrl: logoUrl,
                    darkLogoUrl: darkLogoUrl
                }),
                target: target,
                onClick: function() {
                    invokeSocialSignIn(connector);
                }
            }, id);
        })
    });
};
var $8b617984d1d5ff25$export$2e2bcd8739ae039 = $8b617984d1d5ff25$var$SocialSignInList;





var $kVN77 = parcelRequire("kVN77");








var $kVN77 = parcelRequire("kVN77");




var $kVN77 = parcelRequire("kVN77");



// Used by useTerms hook to display the terms and privacy policy confirmation modal
// This component should be used as the ModalContent prop in the useConfirmModal hook
var $c69b5bf802eaf4f8$var$TermsAndPrivacyConfirmModalContent = function() {
    var experienceSettings = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).experienceSettings;
    var _ref = experienceSettings !== null && experienceSettings !== void 0 ? experienceSettings : {}, termsOfUseUrl = _ref.termsOfUseUrl, privacyPolicyUrl = _ref.privacyPolicyUrl;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $056babc663998f62$export$8d6a9236f2e3f2ce), {
        components: {
            link: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $92a809d54e7cd2ca$export$2e2bcd8739ae039), {
                inline: true,
                linkType: "primary",
                termsOfUseUrl: (0, $3539bd14a37ab7f4$export$c327da55a124987a)(termsOfUseUrl),
                privacyPolicyUrl: (0, $3539bd14a37ab7f4$export$c327da55a124987a)(privacyPolicyUrl)
            })
        },
        children: t("description.agree_with_terms_modal")
    });
};
var $c69b5bf802eaf4f8$export$2e2bcd8739ae039 = $c69b5bf802eaf4f8$var$TermsAndPrivacyConfirmModalContent;



var $f33f2e1937033a56$var$useTerms = function() {
    var _useContext = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)), termsAgreement = _useContext.termsAgreement, setTermsAgreement = _useContext.setTermsAgreement, experienceSettings = _useContext.experienceSettings;
    var show = (0, $06e76e0bce8bb876$export$753980156bc86c10)().show;
    var _useMemo = (0, $kVN77.useMemo)(function() {
        var _ref = experienceSettings !== null && experienceSettings !== void 0 ? experienceSettings : {}, termsOfUseUrl = _ref.termsOfUseUrl, privacyPolicyUrl = _ref.privacyPolicyUrl;
        var isTermsDisabled = !termsOfUseUrl && !privacyPolicyUrl;
        return {
            termsOfUseUrl: (0, $3539bd14a37ab7f4$export$c327da55a124987a)(termsOfUseUrl),
            privacyPolicyUrl: (0, $3539bd14a37ab7f4$export$c327da55a124987a)(privacyPolicyUrl),
            isTermsDisabled: isTermsDisabled
        };
    }, [
        experienceSettings
    ]), termsOfUseUrl = _useMemo.termsOfUseUrl, privacyPolicyUrl = _useMemo.privacyPolicyUrl, isTermsDisabled = _useMemo.isTermsDisabled;
    var termsAndPrivacyConfirmModalHandler = (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var _ref, result;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        show({
                            ModalContent: (0, $c69b5bf802eaf4f8$export$2e2bcd8739ae039),
                            confirmText: "action.agree"
                        })
                    ];
                case 1:
                    _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                        _state.sent(),
                        1
                    ]), result = _ref[0];
                    // Update the local terms status
                    if (result) setTermsAgreement(true);
                    return [
                        2,
                        result
                    ];
            }
        });
    }), [
        setTermsAgreement,
        show
    ]);
    var termsValidation = (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            if (termsAgreement || isTermsDisabled) return [
                2,
                true
            ];
            return [
                2,
                termsAndPrivacyConfirmModalHandler()
            ];
        });
    }), [
        termsAgreement,
        isTermsDisabled,
        termsAndPrivacyConfirmModalHandler
    ]);
    return {
        termsOfUseUrl: termsOfUseUrl,
        privacyPolicyUrl: privacyPolicyUrl,
        termsAgreement: termsAgreement,
        isTermsDisabled: isTermsDisabled,
        termsValidation: termsValidation,
        setTermsAgreement: setTermsAgreement,
        termsAndPrivacyConfirmModalHandler: termsAndPrivacyConfirmModalHandler
    };
};
var $f33f2e1937033a56$export$2e2bcd8739ae039 = $f33f2e1937033a56$var$useTerms;



var $f1a8ee65bffef2e1$export$b07e517d22efa1ca;
var $f1a8ee65bffef2e1$export$a7db06668cad9adb;
var $f1a8ee65bffef2e1$export$493b5823483d2c4e;
var $f1a8ee65bffef2e1$export$8a21ba990ca4a7cb;
$f1a8ee65bffef2e1$export$b07e517d22efa1ca = "TxH7-q_checkbox";
$f1a8ee65bffef2e1$export$a7db06668cad9adb = "TxH7-q_content";
$f1a8ee65bffef2e1$export$493b5823483d2c4e = "TxH7-q_errorMessage";
$f1a8ee65bffef2e1$export$8a21ba990ca4a7cb = "TxH7-q_terms";


var $15a93ea3a899119f$var$TermsAndPrivacyCheckbox = function(param) {
    var className = param.className;
    var _useTerms = (0, $f33f2e1937033a56$export$2e2bcd8739ae039)(), termsAgreement = _useTerms.termsAgreement, setTermsAgreement = _useTerms.setTermsAgreement, termsOfUseUrl = _useTerms.termsOfUseUrl, privacyPolicyUrl = _useTerms.privacyPolicyUrl, isTermsDisabled = _useTerms.isTermsDisabled;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var prefix = t("description.agree_with_terms");
    var toggle = (0, $kVN77.useCallback)(function() {
        setTermsAgreement(function(termsAgreement) {
            return !termsAgreement;
        });
    }, [
        setTermsAgreement
    ]);
    if (isTermsDisabled) return null;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        role: "radio",
        "aria-checked": termsAgreement,
        tabIndex: 0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($f1a8ee65bffef2e1$export$8a21ba990ca4a7cb, className),
        onClick: toggle,
        onKeyDown: (0, $63d9e266638a38b7$export$c2c388d6a668999e)({
            Escape: function() {
                setTermsAgreement(false);
            },
            Enter: toggle,
            " ": toggle
        }),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $6eb3c16efc60a801$export$2e2bcd8739ae039), {
                name: "termsAgreement",
                checked: termsAgreement,
                className: $f1a8ee65bffef2e1$export$b07e517d22efa1ca,
                size: "small"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $f1a8ee65bffef2e1$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
                        children: prefix
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $92a809d54e7cd2ca$export$2e2bcd8739ae039), {
                        inline: true,
                        termsOfUseUrl: termsOfUseUrl,
                        privacyPolicyUrl: privacyPolicyUrl
                    })
                ]
            })
        ]
    });
};
var $15a93ea3a899119f$export$2e2bcd8739ae039 = $15a93ea3a899119f$var$TermsAndPrivacyCheckbox;











var $kVN77 = parcelRequire("kVN77");





parcelRequire("kVN77");
var $2e9fcd39eb5e0170$var$SvgLock = function(props) {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("svg", (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
        width: 21,
        height: 20,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("path", {
            d: "M10.5 10.833a1.241 1.241 0 0 0-.833 2.175v1.159a.833.833 0 0 0 1.667 0v-1.159a1.242 1.242 0 0 0-.833-2.175ZM14.668 7.5V5.833a4.167 4.167 0 0 0-8.333 0V7.5a2.5 2.5 0 0 0-2.5 2.5v5.833a2.5 2.5 0 0 0 2.5 2.5h8.333a2.5 2.5 0 0 0 2.5-2.5V10a2.5 2.5 0 0 0-2.5-2.5ZM8.001 5.833a2.5 2.5 0 1 1 5 0V7.5H8V5.833Zm7.5 10a.833.833 0 0 1-.834.833H6.334a.833.833 0 0 1-.833-.833V10a.833.833 0 0 1 .833-.834h8.333a.833.833 0 0 1 .834.834v5.833Z",
            fill: "#fff",
            fillOpacity: 0.7
        })
    }));
};
var $2e9fcd39eb5e0170$export$2e2bcd8739ae039 = $2e9fcd39eb5e0170$var$SvgLock;











var $kVN77 = parcelRequire("kVN77");








var $da692b4a59d82789$var$useSingleSignOnWatch = function(identifierInput) {
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var singleSignOnEnabled = (0, $41e7159e4ecba97c$export$317715a729435b35)().singleSignOnEnabled;
    var _useContext = (0, $kVN77.useContext)((0, $292f0b9481a802e6$export$2e2bcd8739ae039)), setEmail = _useContext.setEmail, setSsoConnectors = _useContext.setSsoConnectors, ssoConnectors = _useContext.ssoConnectors, availableSsoConnectorsMap = _useContext.availableSsoConnectorsMap;
    var _useContext1 = (0, $kVN77.useContext)((0, $ac4ee07ce14e681b$export$2e2bcd8739ae039)), showSingleSignOnForm = _useContext1.showSingleSignOnForm, setShowSingleSignOnForm = _useContext1.setShowSingleSignOnForm;
    var request = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $000ef94005bc12f4$export$d4b3da5d4dacc637), {
        silent: true
    });
    var singleSignOn = (0, $2435299ccb0a6cc0$export$2e2bcd8739ae039)();
    // Silently check if the email is registered with any SSO connectors
    var fetchSsoConnectors = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(email) {
            var _ref, result, connectors;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request(email)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), result = _ref[1];
                        if (!result) return [
                            2,
                            false
                        ];
                        connectors = result.map(function(connectorId) {
                            return availableSsoConnectorsMap.get(connectorId);
                        })// eslint-disable-next-line unicorn/prefer-native-coercion-functions -- make the type more specific
                        .filter(function(connector) {
                            return Boolean(connector);
                        });
                        if (connectors.length === 0) return [
                            2,
                            false
                        ];
                        setSsoConnectors(connectors);
                        setEmail(email);
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }(), [
        availableSsoConnectorsMap,
        request,
        setEmail,
        setSsoConnectors
    ]);
    // Reset the ssoContext
    (0, $kVN77.useEffect)(function() {
        if (!showSingleSignOnForm) {
            setSsoConnectors([]);
            setEmail(undefined);
        }
    }, [
        setEmail,
        setSsoConnectors,
        showSingleSignOnForm
    ]);
    var navigateToSingleSignOn = (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var _ssoConnectors_;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!showSingleSignOnForm) return [
                        2
                    ];
                    if (!(ssoConnectors.length === 1 && ((_ssoConnectors_ = ssoConnectors[0]) === null || _ssoConnectors_ === void 0 ? void 0 : _ssoConnectors_.id))) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        singleSignOn(ssoConnectors[0].id)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    navigate("/".concat((0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.sso, "/connectors"));
                    return [
                        2
                    ];
            }
        });
    }), [
        navigate,
        showSingleSignOnForm,
        singleSignOn,
        ssoConnectors
    ]);
    (0, $kVN77.useEffect)(function() {
        if (!singleSignOnEnabled) return;
        // Input is undefined if no user interaction has happened
        if (!identifierInput) {
            setShowSingleSignOnForm(false);
            return;
        }
        var type = identifierInput.type, value = identifierInput.value;
        if (type !== (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email) {
            setShowSingleSignOnForm(false);
            return;
        }
        // Will throw an error if the value is not a valid email
        if ((0, $f5597cda736a411e$export$18148d12c805c5b0)(value)) {
            setShowSingleSignOnForm(false);
            return;
        }
        // Add a debouncing delay to avoid unnecessary API calls
        var handler = setTimeout(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchSsoConnectors(value)
                        ];
                    case 1:
                        setShowSingleSignOnForm.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            2
                        ];
                }
            });
        }), 300);
        return function() {
            clearTimeout(handler);
        };
    }, [
        fetchSsoConnectors,
        identifierInput,
        setShowSingleSignOnForm,
        singleSignOnEnabled
    ]);
    return {
        showSingleSignOnForm: showSingleSignOnForm,
        navigateToSingleSignOn: navigateToSingleSignOn
    };
};
var $da692b4a59d82789$export$2e2bcd8739ae039 = $da692b4a59d82789$var$useSingleSignOnWatch;




var $6818a04c68e0853a$export$6210fa4921d2a466;
var $6818a04c68e0853a$export$ce85b9b1fe34d6d3;
var $6818a04c68e0853a$export$73920f18ca706874;
var $6818a04c68e0853a$export$6f2f4d5c38fc8e55;
var $6818a04c68e0853a$export$a8ecead220dd38a6;
var $6818a04c68e0853a$export$8a21ba990ca4a7cb;
$6818a04c68e0853a$export$6210fa4921d2a466 = "_0W0Rda_form";
$6818a04c68e0853a$export$ce85b9b1fe34d6d3 = "_0W0Rda_formErrors";
$6818a04c68e0853a$export$73920f18ca706874 = "_0W0Rda_hidden";
$6818a04c68e0853a$export$6f2f4d5c38fc8e55 = "_0W0Rda_inputField";
$6818a04c68e0853a$export$a8ecead220dd38a6 = "_0W0Rda_message";
$6818a04c68e0853a$export$8a21ba990ca4a7cb = "_0W0Rda_terms";






var $kVN77 = parcelRequire("kVN77");





var $kVN77 = parcelRequire("kVN77");







var $d4496af0e0d247b2$var$useCheckSingleSignOn = function() {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var request = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $000ef94005bc12f4$export$d4b3da5d4dacc637));
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    var _useContext = (0, $kVN77.useContext)((0, $292f0b9481a802e6$export$2e2bcd8739ae039)), setEmail = _useContext.setEmail, setSsoConnectors = _useContext.setSsoConnectors, availableSsoConnectorsMap = _useContext.availableSsoConnectorsMap;
    var singleSignOn = (0, $2435299ccb0a6cc0$export$2e2bcd8739ae039)();
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var clearErrorMessage = (0, $kVN77.useCallback)(function() {
        setErrorMessage(undefined);
    }, [
        setErrorMessage
    ]);
    // Should clear the context and storage if the user trying to resubmit the form
    var clearContext = (0, $kVN77.useCallback)(function() {
        setEmail(undefined);
        setSsoConnectors([]);
    }, [
        setEmail,
        setSsoConnectors
    ]);
    /**
   * Check if the email is registered with any SSO connectors
   * @param {string} email
   * @param {boolean} continueSignIn - whether to continue the single sign-on flow if the email is registered with any SSO connectors
   * @returns {Promise<boolean>} - true if the email is registered with any SSO connectors
   */ var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(email) {
            var continueSignIn, _connectors_, _ref, error, result, connectors;
            var _arguments = arguments;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        continueSignIn = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                        clearContext();
                        return [
                            4,
                            request(email)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            4
                        ];
                        if (!continueSignIn) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, {
                                "guard.invalid_input": function() {
                                    setErrorMessage(t("error.invalid_email"));
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                    case 4:
                        connectors = result === null || result === void 0 ? void 0 : result.map(function(connectorId) {
                            return availableSsoConnectorsMap.get(connectorId);
                        })// eslint-disable-next-line unicorn/prefer-native-coercion-functions -- make the type more specific
                        .filter(function(connector) {
                            return Boolean(connector);
                        });
                        if (!connectors || connectors.length === 0) {
                            setErrorMessage(t("error.sso_not_enabled"));
                            return [
                                2
                            ];
                        }
                        setSsoConnectors(connectors);
                        setEmail(email);
                        if (!continueSignIn) return [
                            2,
                            true
                        ];
                        if (!(connectors.length === 1 && ((_connectors_ = connectors[0]) === null || _connectors_ === void 0 ? void 0 : _connectors_.id))) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            singleSignOn(connectors[0].id)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                    case 6:
                        navigate("/".concat((0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.sso, "/connectors"));
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }(), [
        availableSsoConnectorsMap,
        clearContext,
        handleError,
        navigate,
        request,
        setEmail,
        setSsoConnectors,
        singleSignOn,
        t
    ]);
    return {
        onSubmit: onSubmit,
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage
    };
};
var $d4496af0e0d247b2$export$2e2bcd8739ae039 = $d4496af0e0d247b2$var$useCheckSingleSignOn;









var $kVN77 = parcelRequire("kVN77");




var $c7dadbfb0347cd6f$var$useRegisterWithUsername = function() {
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    var clearErrorMessage = (0, $kVN77.useCallback)(function() {
        setErrorMessage("");
    }, []);
    var errorHandlers = (0, $kVN77.useMemo)(function() {
        return {
            "user.username_already_in_use": function(error) {
                setErrorMessage(error.message);
            },
            "user.missing_profile": function() {
                navigate("password");
            }
        };
    }, [
        navigate
    ]);
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var asyncRegister = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$3053dcea78a60348));
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(username) {
            var _ref, error;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            asyncRegister(username)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            1
                        ]), error = _ref[0];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, errorHandlers)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(username) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncRegister,
        errorHandlers,
        handleError
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $c7dadbfb0347cd6f$export$2e2bcd8739ae039 = $c7dadbfb0347cd6f$var$useRegisterWithUsername;


var $757ee94a7b2ebe64$var$useOnSubmit = function() {
    var ssoConnectors = (0, $41e7159e4ecba97c$export$317715a729435b35)().ssoConnectors;
    var _useCheckSingleSignOn = (0, $d4496af0e0d247b2$export$2e2bcd8739ae039)(), checkSingleSignOn = _useCheckSingleSignOn.onSubmit;
    var _useRegisterWithUsername = (0, $c7dadbfb0347cd6f$export$2e2bcd8739ae039)(), usernameRegisterErrorMessage = _useRegisterWithUsername.errorMessage, clearUsernameRegisterErrorMessage = _useRegisterWithUsername.clearErrorMessage, registerWithUsername = _useRegisterWithUsername.onSubmit;
    var _useSendVerificationCode = (0, $10722ee4e324da1c$export$2e2bcd8739ae039)((0, $14a274f0b6caba9a$export$12e44e23ec720850).Register), sendVerificationCodeErrorMessage = _useSendVerificationCode.errorMessage, clearSendVerificationCodeErrorMessage = _useSendVerificationCode.clearErrorMessage, sendVerificationCode = _useSendVerificationCode.onSubmit;
    var clearErrorMessage = (0, $kVN77.useCallback)(function() {
        clearUsernameRegisterErrorMessage();
        clearSendVerificationCodeErrorMessage();
    }, [
        clearSendVerificationCodeErrorMessage,
        clearUsernameRegisterErrorMessage
    ]);
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(identifier, value) {
            var result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            registerWithUsername(value)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        if (!(identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email && ssoConnectors.length > 0)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            checkSingleSignOn(value)
                        ];
                    case 3:
                        result = _state.sent();
                        if (result) return [
                            2
                        ];
                        _state.label = 4;
                    case 4:
                        return [
                            4,
                            sendVerificationCode({
                                identifier: identifier,
                                value: value
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(identifier, value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        checkSingleSignOn,
        registerWithUsername,
        sendVerificationCode,
        ssoConnectors.length
    ]);
    return {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        errorMessage: usernameRegisterErrorMessage || sendVerificationCodeErrorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $757ee94a7b2ebe64$export$2e2bcd8739ae039 = $757ee94a7b2ebe64$var$useOnSubmit;


var $114b868f18c1a9b5$var$IdentifierRegisterForm = function(param) {
    var className = param.className, autoFocus = param.autoFocus, signUpMethods = param.signUpMethods;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var termsValidation = (0, $f33f2e1937033a56$export$2e2bcd8739ae039)().termsValidation;
    var _useOnSubmit = (0, $757ee94a7b2ebe64$export$2e2bcd8739ae039)(), errorMessage = _useOnSubmit.errorMessage, clearErrorMessage = _useOnSubmit.clearErrorMessage, onSubmit = _useOnSubmit.onSubmit;
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur"
    }), watch = _useForm.watch, handleSubmit = _useForm.handleSubmit, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isValid = _useForm_formState.isValid, control = _useForm.control;
    // Watch identifier field and check single sign on method availability
    var _useSingleSignOnWatch = (0, $da692b4a59d82789$export$2e2bcd8739ae039)(watch("id")), showSingleSignOnForm = _useSingleSignOnWatch.showSingleSignOnForm, navigateToSingleSignOn = _useSingleSignOnWatch.navigateToSingleSignOn;
    (0, $kVN77.useEffect)(function() {
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    var onSubmitHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                clearErrorMessage();
                handleSubmit(function() {
                    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
                        var _param_id, type, value;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _param_id = param.id, type = _param_id.type, value = _param_id.value;
                                    if (!type) return [
                                        2
                                    ];
                                    if (!showSingleSignOnForm) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        navigateToSingleSignOn()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                                case 2:
                                    return [
                                        4,
                                        termsValidation()
                                    ];
                                case 3:
                                    if (!_state.sent()) return [
                                        2
                                    ];
                                    return [
                                        4,
                                        onSubmit(type, value)
                                    ];
                                case 4:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }())(event);
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clearErrorMessage,
        handleSubmit,
        navigateToSingleSignOn,
        onSubmit,
        showSingleSignOnForm,
        termsValidation
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($6818a04c68e0853a$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d461588cfcd3c0f7$export$bd0bf19f25da8474), {
                control: control,
                name: "id",
                rules: {
                    validate: function(param) {
                        var type = param.type, value = param.value;
                        if (!type || !value) return (0, $f5597cda736a411e$export$87161604d0c960f6)(signUpMethods, "required");
                        var errorMessage = (0, $f5597cda736a411e$export$1222f18ddc446c49)(type, value);
                        var _errorMessage_data;
                        if (errorMessage) return typeof errorMessage === "string" ? t("error.".concat(errorMessage)) : t("error.".concat(errorMessage.code), (_errorMessage_data = errorMessage.data) !== null && _errorMessage_data !== void 0 ? _errorMessage_data : {});
                        return true;
                    }
                },
                render: function(param) {
                    var field = param.field;
                    var _errors_id;
                    /*#__PURE__*/ return (0, $d67ee09f839f930f$exports.jsx)((0, $9deb5e2f2bcc140e$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                        autoComplete: "off",
                        autoFocus: autoFocus,
                        className: $6818a04c68e0853a$export$6f2f4d5c38fc8e55
                    }, field), {
                        isDanger: !!errors.id || !!errorMessage,
                        errorMessage: (_errors_id = errors.id) === null || _errors_id === void 0 ? void 0 : _errors_id.message,
                        enabledTypes: signUpMethods
                    }));
                }
            }),
            errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $6818a04c68e0853a$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            showSingleSignOnForm && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $6818a04c68e0853a$export$a8ecead220dd38a6,
                children: t("description.single_sign_on_enabled")
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $15a93ea3a899119f$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($6818a04c68e0853a$export$8a21ba990ca4a7cb, showSingleSignOnForm && $6818a04c68e0853a$export$73920f18ca706874)
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                name: "submit",
                title: showSingleSignOnForm ? "action.single_sign_on" : "action.create_account",
                icon: showSingleSignOnForm ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $2e9fcd39eb5e0170$export$2e2bcd8739ae039), {}) : undefined,
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $114b868f18c1a9b5$export$2e2bcd8739ae039 = $114b868f18c1a9b5$var$IdentifierRegisterForm;


var $cc802e081370f99e$export$6f5378aa3397b877;
var $cc802e081370f99e$export$e8c9778bf415dd08;
var $cc802e081370f99e$export$f22da7240b7add18;
var $cc802e081370f99e$export$70284e70a748b99d;
var $cc802e081370f99e$export$86d0200e957dbda1;
var $cc802e081370f99e$export$a865beef2b207e4c;
var $cc802e081370f99e$export$8a21ba990ca4a7cb;
$cc802e081370f99e$export$6f5378aa3397b877 = "l0GcaG_createAccount";
$cc802e081370f99e$export$e8c9778bf415dd08 = "l0GcaG_divider";
$cc802e081370f99e$export$f22da7240b7add18 = "l0GcaG_main";
$cc802e081370f99e$export$70284e70a748b99d = "l0GcaG_otherMethods";
$cc802e081370f99e$export$86d0200e957dbda1 = "l0GcaG_placeHolder";
$cc802e081370f99e$export$a865beef2b207e4c = "l0GcaG_singleSignOn";
$cc802e081370f99e$export$8a21ba990ca4a7cb = "l0GcaG_terms";


var $437676ab3a84abbd$var$RegisterFooter = function() {
    var _useSieMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)(), signUpMethods = _useSieMethods.signUpMethods, socialConnectors = _useSieMethods.socialConnectors, signInMode = _useSieMethods.signInMode, signInMethods = _useSieMethods.signInMethods, singleSignOnEnabled = _useSieMethods.singleSignOnEnabled;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var showSingleSignOnForm = (0, $kVN77.useContext)((0, $ac4ee07ce14e681b$export$2e2bcd8739ae039)).showSingleSignOnForm;
    /* Hide footers when showing Single Sign On form */ if (showSingleSignOnForm) return null;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
        children: [
            // Single Sign On footer
            singleSignOnEnabled && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $cc802e081370f99e$export$a865beef2b207e4c,
                children: [
                    t("description.use"),
                    " ",
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                        to: "/single-sign-on/email",
                        text: "action.single_sign_on"
                    })
                ]
            }),
            // SignIn footer
            signInMode === (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).SignInAndRegister && signInMethods.length > 0 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $cc802e081370f99e$export$6f5378aa3397b877,
                children: [
                    t("description.have_account"),
                    " ",
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                        replace: true,
                        to: "/sign-in",
                        text: "action.sign_in"
                    })
                ]
            }),
            // Social sign-in methods
            signUpMethods.length > 0 && socialConnectors.length > 0 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3ce0417d4477b862$export$2e2bcd8739ae039), {
                        label: "description.or",
                        className: $cc802e081370f99e$export$e8c9778bf415dd08
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8b617984d1d5ff25$export$2e2bcd8739ae039), {
                        socialConnectors: socialConnectors,
                        className: $cc802e081370f99e$export$f22da7240b7add18
                    })
                ]
            })
        ]
    });
};
var $437676ab3a84abbd$var$Register = function() {
    var _useSieMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)(), signUpMethods = _useSieMethods.signUpMethods, socialConnectors = _useSieMethods.socialConnectors, signInMode = _useSieMethods.signInMode;
    if (!signInMode) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {});
    if (signInMode === (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).SignIn) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$444b3ab0cb9aec40), {
        to: "/sign-in"
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1b7e9c0f93e4c544$export$2e2bcd8739ae039), {
        title: "description.create_your_account",
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $3ded0681b3d0014c$export$2e2bcd8739ae039), {
            children: [
                signUpMethods.length > 0 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $114b868f18c1a9b5$export$2e2bcd8739ae039), {
                    signUpMethods: signUpMethods,
                    className: $cc802e081370f99e$export$f22da7240b7add18
                }),
                signUpMethods.length === 0 && socialConnectors.length > 0 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $15a93ea3a899119f$export$2e2bcd8739ae039), {
                            className: $cc802e081370f99e$export$8a21ba990ca4a7cb
                        }),
                        /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8b617984d1d5ff25$export$2e2bcd8739ae039), {
                            className: $cc802e081370f99e$export$f22da7240b7add18,
                            socialConnectors: socialConnectors
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)($437676ab3a84abbd$var$RegisterFooter, {})
            ]
        })
    });
};
var $437676ab3a84abbd$export$2e2bcd8739ae039 = $437676ab3a84abbd$var$Register;









var $kVN77 = parcelRequire("kVN77");










var $ce2bf3765c4bc72f$var$RegisterPassword = function() {
    var signUpMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)().signUpMethods;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var show = (0, $06e76e0bce8bb876$export$753980156bc86c10)().show;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    var clearErrorMessage = (0, $kVN77.useCallback)(function() {
        setErrorMessage(undefined);
    }, []);
    var mfaErrorHandler = (0, $e2e28e183cb08e20$export$2e2bcd8739ae039)({
        replace: true
    });
    var errorHandlers = (0, $kVN77.useMemo)(function() {
        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            // Incase previous page submitted username has been taken
            "user.username_already_in_use": function() {
                var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error) {
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    show({
                                        type: "alert",
                                        ModalContent: error.message,
                                        cancelText: "action.got_it"
                                    })
                                ];
                            case 1:
                                _state.sent();
                                navigate(-1);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(error) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, mfaErrorHandler);
    }, [
        navigate,
        mfaErrorHandler,
        show
    ]);
    var successHandler = (0, $kVN77.useCallback)(function(result) {
        if (result && "redirectTo" in result) redirectTo(result.redirectTo);
    }, [
        redirectTo
    ]);
    var _usePasswordAction = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $3bd7fa0ea81303e7$export$2e2bcd8739ae039)({
        api: (0, $bc69946dbbb06dd3$export$bc3a34d5df3015fe),
        setErrorMessage: setErrorMessage,
        errorHandlers: errorHandlers,
        successHandler: successHandler
    }), 1), action = _usePasswordAction[0];
    var _usePasswordPolicy = (0, $41e7159e4ecba97c$export$b03f85e37d353e63)(), _usePasswordPolicy_policy = _usePasswordPolicy.policy, _usePasswordPolicy_policy_length = _usePasswordPolicy_policy.length, min = _usePasswordPolicy_policy_length.min, max = _usePasswordPolicy_policy_length.max, _usePasswordPolicy_policy_characterTypes = _usePasswordPolicy_policy.characterTypes, count = _usePasswordPolicy_policy_characterTypes.min, requirementsDescription = _usePasswordPolicy.requirementsDescription;
    if (!signUpMethods.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username)) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "description.new_password",
        description: requirementsDescription && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
            children: requirementsDescription
        }),
        descriptionProps: {
            min: min,
            count: count
        },
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $349098e4154c59e7$export$2e2bcd8739ae039), {
            autoFocus: true,
            errorMessage: errorMessage,
            maxLength: max,
            clearErrorMessage: clearErrorMessage,
            onSubmit: action
        })
    });
};
var $ce2bf3765c4bc72f$export$2e2bcd8739ae039 = $ce2bf3765c4bc72f$var$RegisterPassword;







var $kVN77 = parcelRequire("kVN77");









var $b6f273c9dfb21c2f$var$ResetPassword = function() {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    var clearErrorMessage = (0, $kVN77.useCallback)(function() {
        setErrorMessage(undefined);
    }, []);
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var show = (0, $06e76e0bce8bb876$export$753980156bc86c10)().show;
    var errorHandlers = (0, $kVN77.useMemo)(function() {
        return {
            "session.verification_session_not_found": function() {
                var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error) {
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    show({
                                        type: "alert",
                                        ModalContent: error.message,
                                        cancelText: "action.got_it"
                                    })
                                ];
                            case 1:
                                _state.sent();
                                navigate(-2);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(error) {
                    return _ref.apply(this, arguments);
                };
            }(),
            "user.same_password": function(error) {
                setErrorMessage(error.message);
            }
        };
    }, [
        navigate,
        setErrorMessage,
        show
    ]);
    var successHandler = (0, $kVN77.useCallback)(function(result) {
        if (result) {
            setToast(t("description.password_changed"));
            navigate("/sign-in", {
                replace: true
            });
        }
    }, [
        navigate,
        setToast,
        t
    ]);
    var _usePasswordAction = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $3bd7fa0ea81303e7$export$2e2bcd8739ae039)({
        api: (0, $bc69946dbbb06dd3$export$bc3a34d5df3015fe),
        setErrorMessage: setErrorMessage,
        errorHandlers: errorHandlers,
        successHandler: successHandler
    }), 1), action = _usePasswordAction[0];
    var _usePasswordPolicy = (0, $41e7159e4ecba97c$export$b03f85e37d353e63)(), _usePasswordPolicy_policy = _usePasswordPolicy.policy, _usePasswordPolicy_policy_length = _usePasswordPolicy_policy.length, min = _usePasswordPolicy_policy_length.min, max = _usePasswordPolicy_policy_length.max, _usePasswordPolicy_policy_characterTypes = _usePasswordPolicy_policy.characterTypes, count = _usePasswordPolicy_policy_characterTypes.min, requirementsDescription = _usePasswordPolicy.requirementsDescription;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "description.new_password",
        description: requirementsDescription && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {
            children: requirementsDescription
        }),
        descriptionProps: {
            min: min,
            count: count
        },
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $349098e4154c59e7$export$2e2bcd8739ae039), {
            autoFocus: true,
            errorMessage: errorMessage,
            maxLength: max,
            clearErrorMessage: clearErrorMessage,
            onSubmit: action
        })
    });
};
var $b6f273c9dfb21c2f$export$2e2bcd8739ae039 = $b6f273c9dfb21c2f$var$ResetPassword;





var $kVN77 = parcelRequire("kVN77");











// For sign-in page displaying terms and privacy links use only. No user interaction is needed.
var $5c01e9aa744ae4a5$var$TermsAndPrivacyLinks = function(param) {
    var className = param.className;
    var _useTerms = (0, $f33f2e1937033a56$export$2e2bcd8739ae039)(), termsOfUseUrl = _useTerms.termsOfUseUrl, privacyPolicyUrl = _useTerms.privacyPolicyUrl, isTermsDisabled = _useTerms.isTermsDisabled;
    if (isTermsDisabled) return null;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $92a809d54e7cd2ca$export$2e2bcd8739ae039), {
            termsOfUseUrl: termsOfUseUrl,
            privacyPolicyUrl: privacyPolicyUrl
        })
    });
};
var $5c01e9aa744ae4a5$export$2e2bcd8739ae039 = $5c01e9aa744ae4a5$var$TermsAndPrivacyLinks;













var $kVN77 = parcelRequire("kVN77");








var $c0a678e837e8af2e$export$6210fa4921d2a466;
var $c0a678e837e8af2e$export$ce85b9b1fe34d6d3;
var $c0a678e837e8af2e$export$6f2f4d5c38fc8e55;
var $c0a678e837e8af2e$export$a8ecead220dd38a6;
$c0a678e837e8af2e$export$6210fa4921d2a466 = "idrqUa_form";
$c0a678e837e8af2e$export$ce85b9b1fe34d6d3 = "idrqUa_formErrors";
$c0a678e837e8af2e$export$6f2f4d5c38fc8e55 = "idrqUa_inputField";
$c0a678e837e8af2e$export$a8ecead220dd38a6 = "idrqUa_message";






var $kVN77 = parcelRequire("kVN77");





var $646f7534cc726083$var$useOnSubmit = function(signInMethods) {
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var ssoConnectors = (0, $41e7159e4ecba97c$export$317715a729435b35)().ssoConnectors;
    var _useCheckSingleSignOn = (0, $d4496af0e0d247b2$export$2e2bcd8739ae039)(), checkSingleSignOn = _useCheckSingleSignOn.onSubmit;
    var signInWithPassword = (0, $kVN77.useCallback)(function(identifier, value) {
        navigate({
            pathname: "/".concat((0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn, "/password")
        }, {
            state: {
                identifier: identifier,
                value: value
            }
        });
    }, [
        navigate
    ]);
    var _useSendVerificationCode = (0, $10722ee4e324da1c$export$2e2bcd8739ae039)((0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn), errorMessage = _useSendVerificationCode.errorMessage, clearErrorMessage = _useSendVerificationCode.clearErrorMessage, sendVerificationCode = _useSendVerificationCode.onSubmit;
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(identifier, value) {
            var method, password, isPasswordPrimary, verificationCode, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        method = signInMethods.find(function(method) {
                            return method.identifier === identifier;
                        });
                        if (!method) throw new Error("Cannot find method with identifier type ".concat(identifier));
                        password = method.password, isPasswordPrimary = method.isPasswordPrimary, verificationCode = method.verificationCode;
                        if (identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username) {
                            signInWithPassword(identifier, value);
                            return [
                                2
                            ];
                        }
                        if (!(identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email && ssoConnectors.length > 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            checkSingleSignOn(value)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result) return [
                            2
                        ];
                        _state.label = 2;
                    case 2:
                        if (password && (isPasswordPrimary || !verificationCode)) {
                            signInWithPassword(identifier, value);
                            return [
                                2
                            ];
                        }
                        if (!verificationCode) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            sendVerificationCode({
                                identifier: identifier,
                                value: value
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(identifier, value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        checkSingleSignOn,
        sendVerificationCode,
        signInMethods,
        signInWithPassword,
        ssoConnectors.length
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $646f7534cc726083$export$2e2bcd8739ae039 = $646f7534cc726083$var$useOnSubmit;


var $baacc3c25caf1d0e$var$IdentifierSignInForm = function(param) {
    var className = param.className, autoFocus = param.autoFocus, signInMethods = param.signInMethods;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _useOnSubmit = (0, $646f7534cc726083$export$2e2bcd8739ae039)(signInMethods), errorMessage = _useOnSubmit.errorMessage, clearErrorMessage = _useOnSubmit.clearErrorMessage, onSubmit = _useOnSubmit.onSubmit;
    var enabledSignInMethods = (0, $kVN77.useMemo)(function() {
        return signInMethods.map(function(param) {
            var identifier = param.identifier;
            return identifier;
        });
    }, [
        signInMethods
    ]);
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur"
    }), watch = _useForm.watch, handleSubmit = _useForm.handleSubmit, control = _useForm.control, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isValid = _useForm_formState.isValid;
    // Watch identifier field and check single sign on method availability
    var _useSingleSignOnWatch = (0, $da692b4a59d82789$export$2e2bcd8739ae039)(watch("identifier")), showSingleSignOnForm = _useSingleSignOnWatch.showSingleSignOnForm, navigateToSingleSignOn = _useSingleSignOnWatch.navigateToSingleSignOn;
    (0, $kVN77.useEffect)(function() {
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    var onSubmitHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                clearErrorMessage();
                handleSubmit(function() {
                    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
                        var _param_identifier, type, value;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _param_identifier = param.identifier, type = _param_identifier.type, value = _param_identifier.value;
                                    if (!type) return [
                                        2
                                    ];
                                    if (!showSingleSignOnForm) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        navigateToSingleSignOn()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                                case 2:
                                    return [
                                        4,
                                        onSubmit(type, value)
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }())(event);
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clearErrorMessage,
        handleSubmit,
        navigateToSingleSignOn,
        onSubmit,
        showSingleSignOnForm
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($c0a678e837e8af2e$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d461588cfcd3c0f7$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                rules: {
                    validate: function(param) {
                        var type = param.type, value = param.value;
                        if (!type || !value) return (0, $f5597cda736a411e$export$87161604d0c960f6)(enabledSignInMethods, "required");
                        var errorMessage = (0, $f5597cda736a411e$export$1222f18ddc446c49)(type, value);
                        return errorMessage ? (0, $f5597cda736a411e$export$87161604d0c960f6)(enabledSignInMethods, "invalid") : true;
                    }
                },
                render: function(param) {
                    var field = param.field;
                    var _errors_identifier;
                    /*#__PURE__*/ return (0, $d67ee09f839f930f$exports.jsx)((0, $9deb5e2f2bcc140e$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                        autoFocus: autoFocus,
                        className: $c0a678e837e8af2e$export$6f2f4d5c38fc8e55
                    }, field), {
                        isDanger: !!errors.identifier || !!errorMessage,
                        errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                        enabledTypes: enabledSignInMethods
                    }));
                }
            }),
            errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $c0a678e837e8af2e$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            showSingleSignOnForm && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $c0a678e837e8af2e$export$a8ecead220dd38a6,
                children: t("description.single_sign_on_enabled")
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                name: "submit",
                title: showSingleSignOnForm ? "action.single_sign_on" : "action.sign_in",
                icon: showSingleSignOnForm ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $2e9fcd39eb5e0170$export$2e2bcd8739ae039), {}) : undefined,
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $baacc3c25caf1d0e$export$2e2bcd8739ae039 = $baacc3c25caf1d0e$var$IdentifierSignInForm;










var $kVN77 = parcelRequire("kVN77");










var $c0e0b38960d0d93b$var$ForgotPasswordLink = function(_param) /*#__PURE__*/ {
    var className = _param.className, identifierData = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
        className: className,
        to: {
            pathname: "/".concat((0, $14a274f0b6caba9a$export$12e44e23ec720850).ForgotPassword)
        },
        state: identifierData,
        text: "action.forgot_password"
    });
};
var $c0e0b38960d0d93b$export$2e2bcd8739ae039 = $c0e0b38960d0d93b$var$ForgotPasswordLink;







var $kVN77 = parcelRequire("kVN77");






var $4c7bbbe00a65abda$var$usePasswordSignIn = function() {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    var _useCheckSingleSignOn = (0, $d4496af0e0d247b2$export$2e2bcd8739ae039)(), checkSingleSignOn = _useCheckSingleSignOn.onSubmit;
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var clearErrorMessage = (0, $kVN77.useCallback)(function() {
        setErrorMessage("");
    }, []);
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var asyncSignIn = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$9e0f2ad532e0b36f));
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)();
    var errorHandlers = (0, $kVN77.useMemo)(function() {
        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            "session.invalid_credentials": function(error) {
                setErrorMessage(error.message);
            }
        }, preSignInErrorHandler);
    }, [
        preSignInErrorHandler
    ]);
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
            var result, _ref, error, result1;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!payload.email) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            checkSingleSignOn(payload.email)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result) return [
                            2
                        ];
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            asyncSignIn(payload)
                        ];
                    case 3:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result1 = _ref[1];
                        if (!error) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            handleError(error, errorHandlers)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        if (result1 === null || result1 === void 0 ? void 0 : result1.redirectTo) redirectTo(result1.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(payload) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncSignIn,
        checkSingleSignOn,
        errorHandlers,
        handleError,
        redirectTo
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $4c7bbbe00a65abda$export$2e2bcd8739ae039 = $4c7bbbe00a65abda$var$usePasswordSignIn;





var $50e0db12ff09b603$export$6210fa4921d2a466;
var $50e0db12ff09b603$export$ce85b9b1fe34d6d3;
var $50e0db12ff09b603$export$6f2f4d5c38fc8e55;
var $50e0db12ff09b603$export$9c30223ca0a664fb;
var $50e0db12ff09b603$export$a8ecead220dd38a6;
var $50e0db12ff09b603$export$8a21ba990ca4a7cb;
$50e0db12ff09b603$export$6210fa4921d2a466 = "H0bY_G_form";
$50e0db12ff09b603$export$ce85b9b1fe34d6d3 = "H0bY_G_formErrors";
$50e0db12ff09b603$export$6f2f4d5c38fc8e55 = "H0bY_G_inputField";
$50e0db12ff09b603$export$9c30223ca0a664fb = "H0bY_G_link";
$50e0db12ff09b603$export$a8ecead220dd38a6 = "H0bY_G_message";
$50e0db12ff09b603$export$8a21ba990ca4a7cb = "H0bY_G_terms";


var $8d416c5cab9c16ff$var$PasswordSignInForm = function(param) {
    var className = param.className, autoFocus = param.autoFocus, signInMethods = param.signInMethods;
    var _errors_password;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _usePasswordSignIn = (0, $4c7bbbe00a65abda$export$2e2bcd8739ae039)(), errorMessage = _usePasswordSignIn.errorMessage, clearErrorMessage = _usePasswordSignIn.clearErrorMessage, onSubmit = _usePasswordSignIn.onSubmit;
    var isForgotPasswordEnabled = (0, $41e7159e4ecba97c$export$9418daf6fcecfff4)().isForgotPasswordEnabled;
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            identifier: {},
            password: ""
        }
    }), watch = _useForm.watch, register = _useForm.register, handleSubmit = _useForm.handleSubmit, control = _useForm.control, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isValid = _useForm_formState.isValid;
    var _useSingleSignOnWatch = (0, $da692b4a59d82789$export$2e2bcd8739ae039)(watch("identifier")), showSingleSignOnForm = _useSingleSignOnWatch.showSingleSignOnForm, navigateToSingleSignOn = _useSingleSignOnWatch.navigateToSingleSignOn;
    var onSubmitHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        clearErrorMessage();
                        return [
                            4,
                            handleSubmit(function() {
                                var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
                                    var _param_identifier, type, value, password, _obj;
                                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _param_identifier = param.identifier, type = _param_identifier.type, value = _param_identifier.value, password = param.password;
                                                if (!type) return [
                                                    2
                                                ];
                                                if (!showSingleSignOnForm) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    navigateToSingleSignOn()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    onSubmit((_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, type, value), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "password", password), _obj))
                                                ];
                                            case 3:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }())(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clearErrorMessage,
        handleSubmit,
        navigateToSingleSignOn,
        onSubmit,
        showSingleSignOnForm
    ]);
    (0, $kVN77.useEffect)(function() {
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($50e0db12ff09b603$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d461588cfcd3c0f7$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                rules: {
                    validate: function(param) {
                        var type = param.type, value = param.value;
                        if (!type || !value) return (0, $f5597cda736a411e$export$87161604d0c960f6)(signInMethods, "required");
                        var errorMessage = (0, $f5597cda736a411e$export$1222f18ddc446c49)(type, value);
                        return errorMessage ? (0, $f5597cda736a411e$export$87161604d0c960f6)(signInMethods, "invalid") : true;
                    }
                },
                render: function(param) {
                    var field = param.field;
                    var _errors_identifier;
                    /*#__PURE__*/ return (0, $d67ee09f839f930f$exports.jsx)((0, $9deb5e2f2bcc140e$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                        autoFocus: autoFocus,
                        className: $50e0db12ff09b603$export$6f2f4d5c38fc8e55
                    }, field), {
                        isDanger: !!errors.identifier,
                        errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                        enabledTypes: signInMethods
                    }));
                }
            }),
            showSingleSignOnForm && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $50e0db12ff09b603$export$a8ecead220dd38a6,
                children: t("description.single_sign_on_enabled")
            }),
            !showSingleSignOnForm && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $a4c4e0bafbc43fa7$export$2e2bcd8739ae039), (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                className: $50e0db12ff09b603$export$6f2f4d5c38fc8e55,
                autoComplete: "current-password",
                placeholder: t("input.password"),
                isDanger: !!errors.password,
                errorMessage: (_errors_password = errors.password) === null || _errors_password === void 0 ? void 0 : _errors_password.message
            }, register("password", {
                required: t("error.password_required")
            }))),
            errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $50e0db12ff09b603$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            isForgotPasswordEnabled && !showSingleSignOnForm && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c0e0b38960d0d93b$export$2e2bcd8739ae039), {
                className: $50e0db12ff09b603$export$9c30223ca0a664fb,
                identifier: watch("identifier").type,
                value: watch("identifier").value
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                name: "submit",
                title: showSingleSignOnForm ? "action.single_sign_on" : "action.sign_in",
                icon: showSingleSignOnForm ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $2e9fcd39eb5e0170$export$2e2bcd8739ae039), {}) : undefined,
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $8d416c5cab9c16ff$export$2e2bcd8739ae039 = $8d416c5cab9c16ff$var$PasswordSignInForm;


var $cc87563308e315a0$export$6f5378aa3397b877;
var $cc87563308e315a0$export$e8c9778bf415dd08;
var $cc87563308e315a0$export$f22da7240b7add18;
var $cc87563308e315a0$export$70284e70a748b99d;
var $cc87563308e315a0$export$86d0200e957dbda1;
var $cc87563308e315a0$export$a865beef2b207e4c;
var $cc87563308e315a0$export$8a21ba990ca4a7cb;
$cc87563308e315a0$export$6f5378aa3397b877 = "ZAqXAW_createAccount";
$cc87563308e315a0$export$e8c9778bf415dd08 = "ZAqXAW_divider";
$cc87563308e315a0$export$f22da7240b7add18 = "ZAqXAW_main";
$cc87563308e315a0$export$70284e70a748b99d = "ZAqXAW_otherMethods";
$cc87563308e315a0$export$86d0200e957dbda1 = "ZAqXAW_placeHolder";
$cc87563308e315a0$export$a865beef2b207e4c = "ZAqXAW_singleSignOn";
$cc87563308e315a0$export$8a21ba990ca4a7cb = "ZAqXAW_terms";


var $caf463a5a130ea64$var$Main = function(param) {
    var signInMethods = param.signInMethods, socialConnectors = param.socialConnectors;
    if (signInMethods.length === 0 && socialConnectors.length > 0) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8b617984d1d5ff25$export$2e2bcd8739ae039), {
        className: $cc87563308e315a0$export$f22da7240b7add18,
        socialConnectors: socialConnectors
    });
    var isPasswordOnly = signInMethods.length > 0 && signInMethods.every(function(param) {
        var password = param.password, verificationCode = param.verificationCode;
        return password && !verificationCode;
    });
    if (isPasswordOnly) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8d416c5cab9c16ff$export$2e2bcd8739ae039), {
        className: $cc87563308e315a0$export$f22da7240b7add18,
        signInMethods: signInMethods.map(function(param) {
            var identifier = param.identifier;
            return identifier;
        })
    });
    if (signInMethods.length > 0) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $baacc3c25caf1d0e$export$2e2bcd8739ae039), {
        className: $cc87563308e315a0$export$f22da7240b7add18,
        signInMethods: signInMethods
    });
    return null;
};
var $caf463a5a130ea64$export$2e2bcd8739ae039 = $caf463a5a130ea64$var$Main;



var $c64e8fd85122b526$var$SignInFooters = function() {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _useSieMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)(), signInMethods = _useSieMethods.signInMethods, signUpMethods = _useSieMethods.signUpMethods, socialConnectors = _useSieMethods.socialConnectors, signInMode = _useSieMethods.signInMode, singleSignOnEnabled = _useSieMethods.singleSignOnEnabled;
    var showSingleSignOnForm = (0, $kVN77.useContext)((0, $ac4ee07ce14e681b$export$2e2bcd8739ae039)).showSingleSignOnForm;
    /* Hide footers when showing Single Sign On form */ if (showSingleSignOnForm) return null;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
        children: [
            // Single Sign On footer
            singleSignOnEnabled && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $cc87563308e315a0$export$a865beef2b207e4c,
                children: [
                    t("description.use"),
                    " ",
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                        to: "/single-sign-on/email",
                        text: "action.single_sign_on"
                    })
                ]
            }),
            // Create Account footer
            signInMode === (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).SignInAndRegister && signUpMethods.length > 0 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
                className: $cc87563308e315a0$export$6f5378aa3397b877,
                children: [
                    t("description.no_account"),
                    " ",
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                        replace: true,
                        to: "/register",
                        text: "action.create_account"
                    })
                ]
            }),
            // Social sign-in methods
            signInMethods.length > 0 && socialConnectors.length > 0 && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $d67ee09f839f930f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3ce0417d4477b862$export$2e2bcd8739ae039), {
                        label: "description.or",
                        className: $cc87563308e315a0$export$e8c9778bf415dd08
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8b617984d1d5ff25$export$2e2bcd8739ae039), {
                        socialConnectors: socialConnectors,
                        className: $cc87563308e315a0$export$f22da7240b7add18
                    })
                ]
            })
        ]
    });
};
var $c64e8fd85122b526$var$SignIn = function() {
    var _useSieMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)(), signInMethods = _useSieMethods.signInMethods, socialConnectors = _useSieMethods.socialConnectors, signInMode = _useSieMethods.signInMode;
    if (!signInMode) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {});
    if (signInMode === (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).Register) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$444b3ab0cb9aec40), {
        to: "/register"
    });
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1b7e9c0f93e4c544$export$2e2bcd8739ae039), {
        title: "description.sign_in_to_your_account",
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $3ded0681b3d0014c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $caf463a5a130ea64$export$2e2bcd8739ae039), {
                        signInMethods: signInMethods,
                        socialConnectors: socialConnectors
                    }),
                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)($c64e8fd85122b526$var$SignInFooters, {})
                ]
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $5c01e9aa744ae4a5$export$2e2bcd8739ae039), {
                className: $cc87563308e315a0$export$8a21ba990ca4a7cb
            })
        ]
    });
};
var $c64e8fd85122b526$export$2e2bcd8739ae039 = $c64e8fd85122b526$var$SignIn;






















var $kVN77 = parcelRequire("kVN77");








var $bff954dd303e01ca$export$6210fa4921d2a466;
var $bff954dd303e01ca$export$ce85b9b1fe34d6d3;
var $bff954dd303e01ca$export$6f2f4d5c38fc8e55;
var $bff954dd303e01ca$export$9c30223ca0a664fb;
var $bff954dd303e01ca$export$52002a3975269b5d;
$bff954dd303e01ca$export$6210fa4921d2a466 = "jWjpkG_form";
$bff954dd303e01ca$export$ce85b9b1fe34d6d3 = "jWjpkG_formErrors";
$bff954dd303e01ca$export$6f2f4d5c38fc8e55 = "jWjpkG_inputField";
$bff954dd303e01ca$export$9c30223ca0a664fb = "jWjpkG_link";
$bff954dd303e01ca$export$52002a3975269b5d = "jWjpkG_switch";




var $kVN77 = parcelRequire("kVN77");





var $aa0fc3f8b627c38c$var$VerificationCodeLink = function(param) {
    var className = param.className, identifier = param.identifier, value = param.value;
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var _useSendVerificationCode = (0, $10722ee4e324da1c$export$2e2bcd8739ae039)((0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn, true), errorMessage = _useSendVerificationCode.errorMessage, clearErrorMessage = _useSendVerificationCode.clearErrorMessage, onSubmit = _useSendVerificationCode.onSubmit;
    (0, $kVN77.useEffect)(function() {
        if (errorMessage) setToast(errorMessage);
    }, [
        errorMessage,
        setToast
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
        className: className,
        text: "action.sign_in_via_passcode",
        icon: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4d039f1ef841f974$export$2e2bcd8739ae039), {}),
        onClick: function() {
            clearErrorMessage();
            onSubmit({
                identifier: identifier,
                value: value
            });
        }
    });
};
var $aa0fc3f8b627c38c$export$2e2bcd8739ae039 = $aa0fc3f8b627c38c$var$VerificationCodeLink;


var $9d87967f84098ee3$var$PasswordForm = function(param) {
    var className = param.className, autoFocus = param.autoFocus, _param_isVerificationCodeEnabled = param.isVerificationCodeEnabled, isVerificationCodeEnabled = _param_isVerificationCodeEnabled === void 0 ? false : _param_isVerificationCodeEnabled, identifier = param.identifier, value = param.value;
    var _errors_password;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _usePasswordSignIn = (0, $4c7bbbe00a65abda$export$2e2bcd8739ae039)(), errorMessage = _usePasswordSignIn.errorMessage, clearErrorMessage = _usePasswordSignIn.clearErrorMessage, onSubmit = _usePasswordSignIn.onSubmit;
    var isForgotPasswordEnabled = (0, $41e7159e4ecba97c$export$9418daf6fcecfff4)().isForgotPasswordEnabled;
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            identifier: {
                type: identifier,
                value: value
            },
            password: ""
        }
    }), register = _useForm.register, handleSubmit = _useForm.handleSubmit, control = _useForm.control, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isValid = _useForm_formState.isValid;
    (0, $kVN77.useEffect)(function() {
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    var onSubmitHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                clearErrorMessage();
                handleSubmit(function() {
                    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
                        var _param_identifier, type, value, password, _obj;
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _param_identifier = param.identifier, type = _param_identifier.type, value = _param_identifier.value, password = param.password;
                                    if (!type) return [
                                        2
                                    ];
                                    return [
                                        4,
                                        onSubmit((_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, type, value), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)(_obj, "password", password), _obj))
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }())(event);
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($bff954dd303e01ca$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d461588cfcd3c0f7$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                render: function(param) {
                    var _param_field = param.field, name = _param_field.name, _param_field_value = _param_field.value, type = _param_field_value.type, value = _param_field_value.value;
                    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                        readOnly: true,
                        hidden: true,
                        name: name,
                        value: value,
                        autoComplete: type
                    });
                }
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $a4c4e0bafbc43fa7$export$2e2bcd8739ae039), (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                autoFocus: autoFocus,
                className: $bff954dd303e01ca$export$6f2f4d5c38fc8e55,
                autoComplete: "current-password",
                placeholder: t("input.password"),
                isDanger: !!errors.password,
                errorMessage: (_errors_password = errors.password) === null || _errors_password === void 0 ? void 0 : _errors_password.message
            }, register("password", {
                required: t("error.password_required")
            }))),
            errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                className: $bff954dd303e01ca$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            isForgotPasswordEnabled && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c0e0b38960d0d93b$export$2e2bcd8739ae039), {
                className: $bff954dd303e01ca$export$9c30223ca0a664fb,
                identifier: identifier,
                value: value
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                title: "action.continue",
                name: "submit",
                htmlType: "submit"
            }),
            identifier !== (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Username && isVerificationCodeEnabled && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $aa0fc3f8b627c38c$export$2e2bcd8739ae039), {
                className: $bff954dd303e01ca$export$52002a3975269b5d,
                identifier: identifier,
                value: value
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $9d87967f84098ee3$export$2e2bcd8739ae039 = $9d87967f84098ee3$var$PasswordForm;


var $ddf6e3e20bd91abc$var$SignInPassword = function() {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var signInMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)().signInMethods;
    var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(state, (0, $fc4a7cd559bffd34$export$1e3360d68cdc393f)), 2), _ = _validate[0], identifierState = _validate[1];
    if (!identifierState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    var identifier = identifierState.identifier, value = identifierState.value;
    var methodSetting = signInMethods.find(function(method) {
        return method.identifier === identifier;
    });
    // Sign-in method not enabled
    if (!(methodSetting === null || methodSetting === void 0 ? void 0 : methodSetting.password)) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "description.enter_password",
        description: "description.enter_password_for",
        descriptionProps: {
            method: t((0, $f5597cda736a411e$export$71b8592ba731d4b5)[identifier]),
            value: identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone ? (0, $f9ff7d4c659fed5c$export$79abe912f70ec8f5)(value) : value
        },
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $9d87967f84098ee3$export$2e2bcd8739ae039), {
            autoFocus: true,
            identifier: methodSetting.identifier,
            value: value,
            isVerificationCodeEnabled: methodSetting.verificationCode
        })
    });
};
var $ddf6e3e20bd91abc$export$2e2bcd8739ae039 = $ddf6e3e20bd91abc$var$SignInPassword;






var $kVN77 = parcelRequire("kVN77");








var $4357af59d2051d7d$export$160bd65cfa324065;
var $4357af59d2051d7d$export$abccc2d7327871f5;
$4357af59d2051d7d$export$160bd65cfa324065 = "RkFnmq_ssoLinkButton";
$4357af59d2051d7d$export$abccc2d7327871f5 = "RkFnmq_ssoLinkList";


var $e9ab66f91f9fcd2b$var$SingleSignOnConnectors = function() {
    var theme = (0, $kVN77.useContext)((0, $0125155968220dbd$export$2e2bcd8739ae039)).theme;
    var _useContext = (0, $kVN77.useContext)((0, $292f0b9481a802e6$export$2e2bcd8739ae039)), email = _useContext.email, ssoConnectors = _useContext.ssoConnectors;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var onSubmit = (0, $2435299ccb0a6cc0$export$2e2bcd8739ae039)();
    // Listen to native message
    (0, $fdc496d361a23c1c$export$2e2bcd8739ae039)();
    (0, $kVN77.useEffect)(function() {
        // Return to the previous page if no email and no connectors are available in the context
        if (!email || ssoConnectors.length === 0) navigate("../email", {
            replace: true
        });
    }, [
        email,
        navigate,
        ssoConnectors.length
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "action.single_sign_on",
        description: "description.single_sign_on_connectors_list",
        descriptionProps: {
            email: email
        },
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
            className: $4357af59d2051d7d$export$abccc2d7327871f5,
            children: ssoConnectors.map(function(connector) {
                var id = connector.id, connectorName = connector.connectorName, logoUrl = connector.logo, darkLogoUrl = connector.darkLogo;
                return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $36d6af7b5513c7b4$export$2e2bcd8739ae039), {
                    className: $4357af59d2051d7d$export$160bd65cfa324065,
                    name: {
                        en: connectorName
                    },
                    logo: (0, $7a7feeb62f2ee9c7$export$976f80239b15365)({
                        theme: theme,
                        logoUrl: logoUrl,
                        darkLogoUrl: darkLogoUrl
                    }),
                    target: connectorName,
                    onClick: /*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                            return [
                                2,
                                onSubmit(id)
                            ];
                        });
                    })
                }, id);
            })
        })
    });
};
var $e9ab66f91f9fcd2b$export$2e2bcd8739ae039 = $e9ab66f91f9fcd2b$var$SingleSignOnConnectors;









var $kVN77 = parcelRequire("kVN77");









var $7c747d85b024f06d$export$6210fa4921d2a466;
var $7c747d85b024f06d$export$ce85b9b1fe34d6d3;
var $7c747d85b024f06d$export$6f2f4d5c38fc8e55;
$7c747d85b024f06d$export$6210fa4921d2a466 = "d4_jQq_form";
$7c747d85b024f06d$export$ce85b9b1fe34d6d3 = "d4_jQq_formErrors";
$7c747d85b024f06d$export$6f2f4d5c38fc8e55 = "d4_jQq_inputField";


var $c67be02a1ee815be$var$SingleSignOnEmail = function() {
    var _useOnSubmit = (0, $d4496af0e0d247b2$export$2e2bcd8739ae039)(), errorMessage = _useOnSubmit.errorMessage, clearErrorMessage = _useOnSubmit.clearErrorMessage, onSubmit = _useOnSubmit.onSubmit;
    var email = (0, $kVN77.useContext)((0, $292f0b9481a802e6$export$2e2bcd8739ae039)).email;
    var _useForm = (0, $d461588cfcd3c0f7$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur"
    }), handleSubmit = _useForm.handleSubmit, control = _useForm.control, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isValid = _useForm_formState.isValid;
    (0, $kVN77.useEffect)(function() {
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    var onSubmitHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(event) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        clearErrorMessage();
                        return [
                            4,
                            handleSubmit(function() {
                                var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(param) {
                                    var value;
                                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                        value = param.identifier.value;
                                        return [
                                            2,
                                            onSubmit(value, true)
                                        ];
                                    });
                                });
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }())(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "action.single_sign_on",
        description: "description.single_sign_on_email_form",
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
            className: $7c747d85b024f06d$export$6210fa4921d2a466,
            onSubmit: onSubmitHandler,
            children: [
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d461588cfcd3c0f7$export$bd0bf19f25da8474), {
                    control: control,
                    name: "identifier",
                    rules: {
                        validate: function(param) {
                            var value = param.value;
                            if (!value) return (0, $f5597cda736a411e$export$87161604d0c960f6)([
                                (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email
                            ], "required");
                            var errorMessage = (0, $f5597cda736a411e$export$1222f18ddc446c49)((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email, value);
                            return errorMessage ? (0, $f5597cda736a411e$export$87161604d0c960f6)([
                                (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email
                            ], "invalid") : true;
                        }
                    },
                    render: function(param) {
                        var field = param.field;
                        var _errors_identifier;
                        /*#__PURE__*/ return (0, $d67ee09f839f930f$exports.jsx)((0, $9deb5e2f2bcc140e$export$2e2bcd8739ae039), (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                            autoFocus: true,
                            className: $7c747d85b024f06d$export$6f2f4d5c38fc8e55
                        }, field), {
                            isDanger: !!errors.identifier,
                            defaultValue: email,
                            errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                            enabledTypes: [
                                (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email
                            ]
                        }));
                    }
                }),
                errorMessage && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $0bfe97723266c272$export$2e2bcd8739ae039), {
                    className: $7c747d85b024f06d$export$ce85b9b1fe34d6d3,
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                    title: "action.single_sign_on",
                    htmlType: "submit",
                    icon: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $2e9fcd39eb5e0170$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("input", {
                    hidden: true,
                    type: "submit"
                })
            ]
        })
    });
};
var $c67be02a1ee815be$export$2e2bcd8739ae039 = $c67be02a1ee815be$var$SingleSignOnEmail;




var $kVN77 = parcelRequire("kVN77");



var $de53bcf378880d9c$export$bd05d1c161235462;
$de53bcf378880d9c$export$bd05d1c161235462 = "HgNuBq_connectorContainer";




var $kVN77 = parcelRequire("kVN77");





var $5cd973bd51314642$var$useSocialLandingHandler = function() {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var search = window.location.search;
    var socialLandingHandler = (0, $kVN77.useCallback)(function(connectorId) {
        var redirectUri = (0, $300f68c6e84b0fc8$export$6bcd65cae0372ddf)(search, (0, $14a274f0b6caba9a$export$c4eb3ba4f04fab5).RedirectTo);
        if (!redirectUri) {
            setLoading(false);
            setToast(t("error.invalid_connector_request"));
            return;
        }
        var nativeCallbackLink = (0, $300f68c6e84b0fc8$export$6bcd65cae0372ddf)(search, (0, $14a274f0b6caba9a$export$c4eb3ba4f04fab5).NativeCallbackLink);
        if (nativeCallbackLink) (0, $6f7af2e59a37a635$export$1532ee36eebdb77d)(connectorId, nativeCallbackLink);
        window.location.replace(new URL(redirectUri));
    }, [
        search,
        setToast,
        t
    ]);
    return {
        loading: loading,
        socialLandingHandler: socialLandingHandler
    };
};
var $5cd973bd51314642$export$2e2bcd8739ae039 = $5cd973bd51314642$var$useSocialLandingHandler;


/**
 * SocialLanding page
 * Used for both SocialSignIn and SingleSignOn
 * Only used for native app out of the app webview sign-in flow
 * Store the native callback url in the session storage before redirect to the IdP
 */ var $dfa3f8c75420909a$var$SocialLanding = function() {
    var connectorId = (0, $1c3a22059b479044$export$99eaa27ddbbb95ef)().connectorId;
    var _useSocialLandingHandler = (0, $5cd973bd51314642$export$2e2bcd8739ae039)(), loading = _useSocialLandingHandler.loading, socialLandingHandler = _useSocialLandingHandler.socialLandingHandler;
    // SocialSignIn Callback Handler
    (0, $kVN77.useEffect)(function() {
        if (!connectorId) return;
        socialLandingHandler(connectorId);
    }, [
        connectorId,
        socialLandingHandler
    ]);
    if (!connectorId) return null;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $bc289486222dabf4$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $125e686934f710b5$export$2e2bcd8739ae039), {
            className: $de53bcf378880d9c$export$bd05d1c161235462,
            connectorId: connectorId,
            isLoading: loading
        })
    });
};
var $dfa3f8c75420909a$export$2e2bcd8739ae039 = $dfa3f8c75420909a$var$SocialLanding;




















var $kVN77 = parcelRequire("kVN77");





var $2b1de8d7f9c7a0e9$var$useSocialRegister = function(connectorId, replace) {
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var asyncRegisterWithSocial = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$ae2a9e5eae510a93));
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)({
        linkSocial: connectorId,
        replace: replace
    });
    return (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            asyncRegisterWithSocial(connectorId)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, preSignInErrorHandler)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(connectorId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncRegisterWithSocial,
        handleError,
        preSignInErrorHandler,
        redirectTo
    ]);
};
var $2b1de8d7f9c7a0e9$export$2e2bcd8739ae039 = $2b1de8d7f9c7a0e9$var$useSocialRegister;



var $dcf2e40b7c2aac9a$export$34e0f9847d4c02dd;
var $dcf2e40b7c2aac9a$export$51987bb50e1f6752;
var $dcf2e40b7c2aac9a$export$e8c9778bf415dd08;
$dcf2e40b7c2aac9a$export$34e0f9847d4c02dd = "jPOtVa_container";
$dcf2e40b7c2aac9a$export$51987bb50e1f6752 = "jPOtVa_desc";
$dcf2e40b7c2aac9a$export$e8c9778bf415dd08 = "jPOtVa_divider";







var $kVN77 = parcelRequire("kVN77");





var $a995234f307c271f$var$useBindSocialRelatedUser = function() {
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)();
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var asyncBindSocialRelatedUser = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$bd9511c461958ea7));
    return (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var _len, payload, _key, _ref, error, result;
        var _arguments = arguments;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, payload = new Array(_len), _key = 0; _key < _len; _key++){
                        payload[_key] = _arguments[_key];
                    }
                    return [
                        4,
                        asyncBindSocialRelatedUser.apply(void 0, (0, $15f021a0fca28358$export$1b5e630bc3aea29f)(payload))
                    ];
                case 1:
                    _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                        _state.sent(),
                        2
                    ]), error = _ref[0], result = _ref[1];
                    if (!error) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handleError(error, preSignInErrorHandler)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                    return [
                        2
                    ];
            }
        });
    }), [
        asyncBindSocialRelatedUser,
        handleError,
        preSignInErrorHandler,
        redirectTo
    ]);
};
var $a995234f307c271f$export$2e2bcd8739ae039 = $a995234f307c271f$var$useBindSocialRelatedUser;


var $5b6e7a5e4d0d3bd0$var$getCreateAccountContent = function(signUpMethods) {
    if (signUpMethods.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email) && signUpMethods.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone)) return {
        desc: "description.social_link_email_or_phone",
        buttonText: "action.link_another_email_or_phone"
    };
    if (signUpMethods.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email)) return {
        desc: "description.social_link_email",
        buttonText: "action.link_another_email"
    };
    if (signUpMethods.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone)) return {
        desc: "description.social_link_phone",
        buttonText: "action.link_another_phone"
    };
    return {
        desc: "description.social_create_account",
        buttonText: "action.create_account_without_linking"
    };
};
var $5b6e7a5e4d0d3bd0$var$SocialLinkAccount = function(param) {
    var connectorId = param.connectorId, className = param.className, relatedUser = param.relatedUser;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var signUpMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)().signUpMethods;
    var bindSocialRelatedUser = (0, $a995234f307c271f$export$2e2bcd8739ae039)();
    var registerWithSocial = (0, $2b1de8d7f9c7a0e9$export$2e2bcd8739ae039)(connectorId);
    var content = $5b6e7a5e4d0d3bd0$var$getCreateAccountContent(signUpMethods);
    var type = relatedUser.type, value = relatedUser.value;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($dcf2e40b7c2aac9a$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $dcf2e40b7c2aac9a$export$51987bb50e1f6752,
                children: t("description.social_bind_with_existing")
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                title: "action.bind",
                i18nProps: {
                    address: type === "email" ? (0, $b942b7c103f41f15$export$2a51ca354add32e1)(value) : (0, $b942b7c103f41f15$export$1f64b92865689d0d)(value)
                },
                onClick: function() {
                    bindSocialRelatedUser((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                        connectorId: connectorId
                    }, type === "email" ? {
                        email: value
                    } : {
                        phone: value
                    }));
                }
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3ce0417d4477b862$export$2e2bcd8739ae039), {
                label: "description.or",
                className: $dcf2e40b7c2aac9a$export$e8c9778bf415dd08
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $dcf2e40b7c2aac9a$export$51987bb50e1f6752,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4f0e9068c17de251$export$2e2bcd8739ae039), {
                    forKey: content.desc
                })
            }),
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $41b320aeeb388826$export$2e2bcd8739ae039), {
                title: content.buttonText,
                type: "secondary",
                onClick: function() {
                    registerWithSocial(connectorId);
                }
            })
        ]
    });
};
var $5b6e7a5e4d0d3bd0$export$2e2bcd8739ae039 = $5b6e7a5e4d0d3bd0$var$SocialLinkAccount;





var $6b33a1ba6c520e4d$var$getPageTitle = function(signUpMethods) {
    if (signUpMethods.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email) && signUpMethods.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone)) return "description.link_email_or_phone";
    if (signUpMethods.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email)) return "description.link_email";
    if (signUpMethods.includes((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone)) return "description.link_phone";
    return "description.bind_account_title";
};
var $6b33a1ba6c520e4d$var$SocialLinkAccount = function() {
    var connectorId = (0, $1c3a22059b479044$export$99eaa27ddbbb95ef)().connectorId;
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var signUpMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)().signUpMethods;
    if (!(0, $9ca557716949399a$export$226b3eccf92c9ed9)(state, (0, $fc4a7cd559bffd34$export$d3035cdec99fb931))) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        rawMessage: "Missing relate account info"
    });
    if (!connectorId) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        rawMessage: "Connector not found"
    });
    var relatedUser = state.relatedUser;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: $6b33a1ba6c520e4d$var$getPageTitle(signUpMethods),
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $5b6e7a5e4d0d3bd0$export$2e2bcd8739ae039), {
            connectorId: connectorId,
            relatedUser: relatedUser
        })
    });
};
var $6b33a1ba6c520e4d$export$2e2bcd8739ae039 = $6b33a1ba6c520e4d$var$SocialLinkAccount;


















var $kVN77 = parcelRequire("kVN77");











var $8c06059d792f5cda$var$useSingleSignOnRegister = function() {
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var request = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $000ef94005bc12f4$export$db343ec66e79e78a));
    var termsValidation = (0, $f33f2e1937033a56$export$2e2bcd8739ae039)().termsValidation;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    return (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            termsValidation()
                        ];
                    case 1:
                        // Agree to terms and conditions first before proceeding
                        if (!_state.sent()) {
                            navigate("/" + (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            request(connectorId)
                        ];
                    case 2:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            handleError(error)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                    case 4:
                        if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(connectorId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleError,
        navigate,
        redirectTo,
        request,
        termsValidation
    ]);
};
/**
 * Single Sign On authentication callback handler.
 *
 * @remark This hook is used by the Single Sign On authentication sign-in callback page.
 * Read the IdP parameters from the URL and call the Single Sign On authentication API.
 * Forked from @see `useSocialSignInListener`.
 * - SingleSignOn has different API endpoints.
 * - SingleSignOn has different error handling logic.
 */ var $8c06059d792f5cda$var$useSingleSignOnListener = function(connectorId) {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(false), 2), isConsumed = _useState1[0], setIsConsumed = _useState1[1];
    var _useSearchParams = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $d03cd69b331d3258$export$f1a78c17382fe22a)(), 2), searchParameters = _useSearchParams[0], setSearchParameters = _useSearchParams[1];
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var signInMode = (0, $41e7159e4ecba97c$export$317715a729435b35)().signInMode;
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var singleSignOnAuthorizationRequest = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $000ef94005bc12f4$export$c0aa2525151c2215));
    var registerSingleSignOnIdentity = $8c06059d792f5cda$var$useSingleSignOnRegister();
    var singleSignOnHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId, data) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            singleSignOnAuthorizationRequest(connectorId, (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({}, data), {
                                // For connector validation use
                                redirectUri: "".concat(window.location.origin, "/callback/").concat(connectorId)
                            }))
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        setLoading(false);
                        return [
                            4,
                            handleError(error, {
                                "user.identity_not_exist": function() {
                                    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error) {
                                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    // Should not let user register new social account under sign-in only mode
                                                    if (signInMode === (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).SignIn) {
                                                        setToast(error.message);
                                                        navigate("/" + (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn);
                                                        return [
                                                            2
                                                        ];
                                                    }
                                                    return [
                                                        4,
                                                        registerSingleSignOnIdentity(connectorId)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(error) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                // Redirect to sign-in page if error is not handled by the error handlers
                                global: function() {
                                    var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error) {
                                        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                                            setToast(error.message);
                                            navigate("/" + (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn);
                                            return [
                                                2
                                            ];
                                        });
                                    });
                                    return function(error) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(connectorId, data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleError,
        navigate,
        redirectTo,
        registerSingleSignOnIdentity,
        setToast,
        signInMode,
        singleSignOnAuthorizationRequest
    ]);
    // Single Sign On Callback Handler
    (0, $kVN77.useEffect)(function() {
        if (isConsumed) return;
        setIsConsumed(true);
        var _parseQueryParameters = (0, $300f68c6e84b0fc8$export$2469638cb19f7e00)(searchParameters), state = _parseQueryParameters.state, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_parseQueryParameters, [
            "state"
        ]);
        // Cleanup the search parameters once it's consumed
        setSearchParameters({}, {
            replace: true
        });
        // Validate the state parameter
        if (!state || !(0, $6f7af2e59a37a635$export$cd0e7726290ef99e)(state, connectorId)) {
            setToast(t("error.invalid_connector_auth"));
            navigate("/" + (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn);
            return;
        }
        singleSignOnHandler(connectorId, rest);
    }, [
        connectorId,
        isConsumed,
        navigate,
        searchParameters,
        setSearchParameters,
        setToast,
        singleSignOnHandler,
        t
    ]);
    return {
        loading: loading
    };
};
var $8c06059d792f5cda$export$2e2bcd8739ae039 = $8c06059d792f5cda$var$useSingleSignOnListener;


var $c73617af1d495452$var$SingleSignOn = function(param) {
    var connectorId = param.connectorId;
    var socialConnectors = (0, $41e7159e4ecba97c$export$317715a729435b35)().socialConnectors;
    /* To avoid register duplicated native message listeners,
    we only add the native message listener if there are no social connectors.
    Set the bypass flag to true if there are social connectors.
  */ (0, $fdc496d361a23c1c$export$2e2bcd8739ae039)(socialConnectors.length > 0);
    var loading = (0, $8c06059d792f5cda$export$2e2bcd8739ae039)(connectorId).loading;
    return loading ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $fd8b596ccc1e1b22$export$2e2bcd8739ae039), {}) : null;
};
var $c73617af1d495452$export$2e2bcd8739ae039 = $c73617af1d495452$var$SingleSignOn;












var $kVN77 = parcelRequire("kVN77");














var $635e6716d54de3f3$var$useSocialSignInListener = function(connectorId) {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var signInMode = (0, $41e7159e4ecba97c$export$317715a729435b35)().signInMode;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var termsValidation = (0, $f33f2e1937033a56$export$2e2bcd8739ae039)().termsValidation;
    var _useState1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(false), 2), isConsumed = _useState1[0], setIsConsumed = _useState1[1];
    var _useSearchParams = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $d03cd69b331d3258$export$f1a78c17382fe22a)(), 2), searchParameters = _useSearchParams[0], setSearchParameters = _useSearchParams[1];
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var registerWithSocial = (0, $2b1de8d7f9c7a0e9$export$2e2bcd8739ae039)(connectorId, true);
    var asyncSignInWithSocial = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$90917f4878ed116a));
    var accountNotExistErrorHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error) {
            var _validate, data, relatedUser;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(error.data, (0, $fc4a7cd559bffd34$export$d3035cdec99fb931)), 2), data = _validate[1];
                        relatedUser = (data !== null && data !== void 0 ? data : {}).relatedUser;
                        if (relatedUser) {
                            navigate("/social/link/".concat(connectorId), {
                                replace: true,
                                state: {
                                    relatedUser: relatedUser
                                }
                            });
                            return [
                                2
                            ];
                        }
                        // Register with social
                        return [
                            4,
                            registerWithSocial(connectorId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }(), [
        connectorId,
        navigate,
        registerWithSocial
    ]);
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)({
        replace: true
    });
    var signInWithSocialErrorHandlers = (0, $kVN77.useMemo)(function() {
        return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            "user.identity_not_exist": function() {
                var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error) {
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Should not let user register new social account under sign-in only mode
                                if (signInMode === (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).SignIn) {
                                    setToast(error.message);
                                    navigate("/" + (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    termsValidation()
                                ];
                            case 1:
                                // Agree to terms and conditions first before proceeding
                                if (!_state.sent()) {
                                    navigate("/" + (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    accountNotExistErrorHandler(error)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(error) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, preSignInErrorHandler), {
            // Redirect to sign-in page if error is not handled by the error handlers
            global: function() {
                var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(error) {
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        setToast(error.message);
                        navigate("/" + (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn);
                        return [
                            2
                        ];
                    });
                });
                return function(error) {
                    return _ref.apply(this, arguments);
                };
            }()
        });
    }, [
        preSignInErrorHandler,
        signInMode,
        termsValidation,
        accountNotExistErrorHandler,
        setToast,
        navigate
    ]);
    var signInWithSocialHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId, data) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            asyncSignInWithSocial({
                                connectorId: connectorId,
                                connectorData: (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
                                    // For validation use only
                                    redirectUri: "".concat(window.location.origin, "/callback/").concat(connectorId)
                                }, data)
                            })
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        setLoading(false);
                        return [
                            4,
                            handleError(error, signInWithSocialErrorHandlers)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(connectorId, data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncSignInWithSocial,
        handleError,
        signInWithSocialErrorHandlers
    ]);
    // Social Sign-in Callback Handler
    (0, $kVN77.useEffect)(function() {
        if (isConsumed) return;
        setIsConsumed(true);
        var _parseQueryParameters = (0, $300f68c6e84b0fc8$export$2469638cb19f7e00)(searchParameters), state = _parseQueryParameters.state, rest = (0, $487369748a2c1c33$export$69fdd232f62cde60)(_parseQueryParameters, [
            "state"
        ]);
        // Cleanup the search parameters once it's consumed
        setSearchParameters({}, {
            replace: true
        });
        if (!state || !(0, $6f7af2e59a37a635$export$cd0e7726290ef99e)(state, connectorId)) {
            setToast(t("error.invalid_connector_auth"));
            navigate("/" + (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn);
            return;
        }
        signInWithSocialHandler(connectorId, rest);
    }, [
        connectorId,
        isConsumed,
        navigate,
        searchParameters,
        setSearchParameters,
        setToast,
        signInWithSocialHandler,
        t
    ]);
    return {
        loading: loading
    };
};
var $635e6716d54de3f3$export$2e2bcd8739ae039 = $635e6716d54de3f3$var$useSocialSignInListener;


var $55bc013aec16ab46$var$SocialSignIn = function(param) {
    var connectorId = param.connectorId;
    var loading = (0, $635e6716d54de3f3$export$2e2bcd8739ae039)(connectorId).loading;
    return loading ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $fd8b596ccc1e1b22$export$2e2bcd8739ae039), {}) : null;
};
var $55bc013aec16ab46$export$2e2bcd8739ae039 = $55bc013aec16ab46$var$SocialSignIn;


/** The real callback page for social sign-in in web browsers. */ var $de337e6a588060ec$var$SocialSignInWebCallback = function() {
    var parameters = (0, $1c3a22059b479044$export$99eaa27ddbbb95ef)();
    var findConnectorById = (0, $63d42c0a1a1c817c$export$2e2bcd8739ae039)().findConnectorById;
    var result = findConnectorById(parameters.connectorId);
    if ((result === null || result === void 0 ? void 0 : result.type) === "social") return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $55bc013aec16ab46$export$2e2bcd8739ae039), {
        connectorId: result.connector.id
    });
    if ((result === null || result === void 0 ? void 0 : result.type) === "sso") return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c73617af1d495452$export$2e2bcd8739ae039), {
        connectorId: result.connector.id
    });
    // Connector not found, return sign in page
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$444b3ab0cb9aec40), {
        to: "/" + (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn
    });
};
var $de337e6a588060ec$export$2e2bcd8739ae039 = $de337e6a588060ec$var$SocialSignInWebCallback;





var $kVN77 = parcelRequire("kVN77");



var $03c1315f0b2143e0$var$Springboard = function() {
    var _useSearchParams = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $d03cd69b331d3258$export$f1a78c17382fe22a)(), 1), searchParameters = _useSearchParams[0];
    (0, $kVN77.useEffect)(function() {
        var state = searchParameters.get("state");
        var connectorId = searchParameters.get("connectorId");
        var callback = searchParameters.get("callback");
        var redirectTo = searchParameters.get("redirectTo");
        if (callback && connectorId) (0, $6f7af2e59a37a635$export$1532ee36eebdb77d)(connectorId, callback);
        if (state && connectorId) (0, $6f7af2e59a37a635$export$ca97131192bad836)(state, connectorId);
        if (redirectTo) window.location.assign(redirectTo);
    }, [
        searchParameters
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $fd8b596ccc1e1b22$export$2e2bcd8739ae039), {});
};
var $03c1315f0b2143e0$export$2e2bcd8739ae039 = $03c1315f0b2143e0$var$Springboard;
















var $kVN77 = parcelRequire("kVN77");








var $b71cc1ebc2daf8b2$var$PasswordSignInLink = function(param) {
    var className = param.className, method = param.method, target = param.target;
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
        replace: true,
        className: className,
        icon: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4d039f1ef841f974$export$2e2bcd8739ae039), {}),
        text: "action.sign_in_via_password",
        to: "/".concat((0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn, "/password"),
        state: {
            identifier: method,
            value: target
        }
    });
};
var $b71cc1ebc2daf8b2$export$2e2bcd8739ae039 = $b71cc1ebc2daf8b2$var$PasswordSignInLink;


var $40d9417b65a80fcc$export$6210fa4921d2a466;
var $40d9417b65a80fcc$export$6f2f4d5c38fc8e55;
var $40d9417b65a80fcc$export$9c30223ca0a664fb;
var $40d9417b65a80fcc$export$a8ecead220dd38a6;
var $40d9417b65a80fcc$export$52002a3975269b5d;
var $40d9417b65a80fcc$export$60e9e0884ce12b55;
$40d9417b65a80fcc$export$6210fa4921d2a466 = "_8gzYyG_form";
$40d9417b65a80fcc$export$6f2f4d5c38fc8e55 = "_8gzYyG_inputField";
$40d9417b65a80fcc$export$9c30223ca0a664fb = "_8gzYyG_link";
$40d9417b65a80fcc$export$a8ecead220dd38a6 = "_8gzYyG_message";
$40d9417b65a80fcc$export$52002a3975269b5d = "_8gzYyG_switch";
$40d9417b65a80fcc$export$60e9e0884ce12b55 = "_8gzYyG_withError";








var $kVN77 = parcelRequire("kVN77");
var $f0eb6c9c63079317$exports = {};

!function(e, t) {
    $f0eb6c9c63079317$exports = t((parcelRequire("kVN77")));
}("undefined" != typeof self ? self : $f0eb6c9c63079317$exports, function(e) {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var o = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)r.d(n, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function t() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 3);
    }([
        function(t, r) {
            t.exports = e;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Validate = t.Time = void 0;
            var n = u(r(5)), o = u(r(6));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.Time = n.default, t.Validate = o.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useInterval = void 0;
            var n = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(r(7));
            t.useInterval = n.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useTime = t.useStopwatch = t.useTimer = void 0;
            var n = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$r = arguments[_$t];
                    for(var n in _$r)Object.prototype.hasOwnProperty.call(_$r, n) && (e[n] = _$r[n]);
                }
                return e;
            };
            t.default = function(e) {
                if ((0, o.useEffect)(function() {
                    console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
                }, []), e.expiryTimestamp) {
                    var _$t = (0, u.default)(e);
                    return n({}, _$t, {
                        startTimer: _$t.start,
                        stopTimer: _$t.pause,
                        resetTimer: function resetTimer() {}
                    });
                }
                var _$r = (0, i.default)(e);
                return n({}, _$r, {
                    startTimer: _$r.start,
                    stopTimer: _$r.pause,
                    resetTimer: _$r.reset
                });
            };
            var o = r(0), u = c(r(4)), i = c(r(8)), a = c(r(9));
            function c(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.useTimer = u.default, t.useStopwatch = i.default, t.useTime = a.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$r = arguments[_$t];
                    for(var n in _$r)Object.prototype.hasOwnProperty.call(_$r, n) && (e[n] = _$r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var _$r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (_$r.push(i.value), !t || _$r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return _$r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var _$t = e.expiryTimestamp, _$r = e.onExpire, s = e.autoStart, l = void 0 === s || s, d = (0, u.useState)(_$t), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(i.Time.getSecondsFromExpiry(v)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(l), S = o(h, 2), w = S[0], O = S[1], j = (0, u.useState)(l), x = o(j, 2), _ = x[0], M = x[1], P = (0, u.useState)(f(v)), F = o(P, 2), E = F[0], k = F[1];
                function I(e) {
                    var _$t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    k(f(e)), M(_$t), O(_$t), p(e), b(i.Time.getSecondsFromExpiry(e));
                }
                function D() {
                    var _$e = new Date;
                    _$e.setMilliseconds(_$e.getMilliseconds() + 1e3 * g), I(_$e);
                }
                return (0, a.useInterval)(function() {
                    E !== c && k(c);
                    var _$e = i.Time.getSecondsFromExpiry(v);
                    b(_$e), _$e <= 0 && (i.Validate.onExpire(_$r) && _$r(), O(!1), k(null));
                }, w ? E : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function start() {
                        _ ? (b(i.Time.getSecondsFromExpiry(v)), O(!0)) : D();
                    },
                    pause: function pause() {
                        O(!1);
                    },
                    resume: D,
                    restart: I,
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2), c = 1e3;
            function f(e) {
                if (!i.Validate.expiryTimestamp(e)) return null;
                var _$t = i.Time.getSecondsFromExpiry(e), _$r = Math.floor(1e3 * (_$t - Math.floor(_$t)));
                return _$r > 0 ? _$r : c;
            }
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "getTimeFromSeconds",
                        value: function value(e) {
                            var _$t = Math.ceil(e), r = Math.floor(_$t / 86400), n = Math.floor(_$t % 86400 / 3600), o = Math.floor(_$t % 3600 / 60);
                            return {
                                seconds: Math.floor(_$t % 60),
                                minutes: o,
                                hours: n,
                                days: r
                            };
                        }
                    },
                    {
                        key: "getSecondsFromExpiry",
                        value: function value(e, t) {
                            var r = e - (new Date).getTime();
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromPrevTime",
                        value: function value(e, t) {
                            var r = (new Date).getTime() - e;
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromTimeNow",
                        value: function value() {
                            var _$e = new Date;
                            return _$e.getTime() / 1e3 - 60 * _$e.getTimezoneOffset();
                        }
                    },
                    {
                        key: "getFormattedTimeFromSeconds",
                        value: function value(t, r) {
                            var n = e.getTimeFromSeconds(t), o = n.seconds, u = n.minutes, i = n.hours, a = "", c = i;
                            return "12-hour" === r && (a = i >= 12 ? "pm" : "am", c = i % 12), {
                                seconds: o,
                                minutes: u,
                                hours: c,
                                ampm: a
                            };
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "expiryTimestamp",
                        value: function value(e) {
                            var _$t = new Date(e).getTime() > 0;
                            return _$t || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", e), _$t;
                        }
                    },
                    {
                        key: "onExpire",
                        value: function value(e) {
                            var _$t = e && "function" == typeof e;
                            return e && !_$t && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", e), _$t;
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = function(e, t) {
                var _$r = (0, n.useRef)();
                (0, n.useEffect)(function() {
                    _$r.current = e;
                }), (0, n.useEffect)(function() {
                    if (!t) return function() {};
                    var e = setInterval(function() {
                        _$r.current && _$r.current();
                    }, t);
                    return function() {
                        return clearInterval(e);
                    };
                }, [
                    t
                ]);
            };
            var n = r(0);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$r = arguments[_$t];
                    for(var n in _$r)Object.prototype.hasOwnProperty.call(_$r, n) && (e[n] = _$r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var _$r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (_$r.push(i.value), !t || _$r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return _$r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var _$t = e.autoStart, _$r = e.offsetTimestamp, c = (0, u.useState)(i.Time.getSecondsFromExpiry(_$r, !0) || 0), f = o(c, 2), s = f[0], l = f[1], d = (0, u.useState)(new Date), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(s + i.Time.getSecondsFromPrevTime(v || 0, !0)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(_$t), S = o(h, 2), w = S[0], O = S[1];
                return (0, a.useInterval)(function() {
                    b(s + i.Time.getSecondsFromPrevTime(v, !0));
                }, w ? 1e3 : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function start() {
                        var _$e = new Date;
                        p(_$e), O(!0), b(s + i.Time.getSecondsFromPrevTime(_$e, !0));
                    },
                    pause: function pause() {
                        l(g), O(!1);
                    },
                    reset: function reset() {
                        var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, _$t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], _$r = i.Time.getSecondsFromExpiry(_$e, !0) || 0, n = new Date;
                        p(n), l(_$r), O(_$t), b(_$r + i.Time.getSecondsFromPrevTime(n, !0));
                    },
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$r = arguments[_$t];
                    for(var n in _$r)Object.prototype.hasOwnProperty.call(_$r, n) && (e[n] = _$r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var _$r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (_$r.push(i.value), !t || _$r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return _$r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var _$t = e.format, _$r = (0, u.useState)(i.Time.getSecondsFromTimeNow()), c = o(_$r, 2), f = c[0], s = c[1];
                return (0, a.useInterval)(function() {
                    s(i.Time.getSecondsFromTimeNow());
                }, 1e3), n({}, i.Time.getFormattedTimeFromSeconds(f, _$t));
            };
            var u = r(0), i = r(1), a = r(2);
        }
    ]);
});






var $0c1a74e6c9002f65$export$4748a2e3a6d34ca5 = 59;
var $0c1a74e6c9002f65$var$getTimeout = function() {
    var now = new Date();
    now.setSeconds(now.getSeconds() + $0c1a74e6c9002f65$export$4748a2e3a6d34ca5);
    return now;
};
var $0c1a74e6c9002f65$var$useResendVerificationCode = function(type, method, target) {
    var setToast = (0, $9a3c35ddfdc94481$export$2e2bcd8739ae039)().setToast;
    var _useTimer = (0, $f0eb6c9c63079317$exports.useTimer)({
        autoStart: true,
        expiryTimestamp: $0c1a74e6c9002f65$var$getTimeout()
    }), seconds = _useTimer.seconds, isRunning = _useTimer.isRunning, restart = _useTimer.restart;
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var sendVerificationCode = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $9324e24164181712$export$6443fa89a66c693a));
    var onResendVerificationCode = (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var payload, _ref, error, result;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    payload = method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? {
                        email: target
                    } : {
                        phone: target
                    };
                    return [
                        4,
                        sendVerificationCode(type, payload)
                    ];
                case 1:
                    _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                        _state.sent(),
                        2
                    ]), error = _ref[0], result = _ref[1];
                    if (!error) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handleError(error)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    if (result) {
                        setToast((0, $e55f3bd5a75ab76b$export$625550452a3fa3ec)("description.passcode_sent"));
                        restart($0c1a74e6c9002f65$var$getTimeout(), true);
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        handleError,
        method,
        restart,
        sendVerificationCode,
        setToast,
        target,
        type
    ]);
    return {
        seconds: seconds,
        isRunning: isRunning,
        onResendVerificationCode: onResendVerificationCode
    };
};
var $0c1a74e6c9002f65$export$2e2bcd8739ae039 = $0c1a74e6c9002f65$var$useResendVerificationCode;










var $kVN77 = parcelRequire("kVN77");









var $kVN77 = parcelRequire("kVN77");
var $d0114fbc9b03e9e6$var$useGeneralVerificationCodeErrorHandler = function() {
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)(), 2), errorMessage = _useState[0], setErrorMessage = _useState[1];
    // Have to wrap up in a useMemo hook otherwise the handler updates on every cycle
    var generalVerificationCodeErrorHandlers = (0, $kVN77.useMemo)(function() {
        return {
            "verification_code.expired": function(error) {
                setErrorMessage(error.message);
            },
            "verification_code.code_mismatch": function(error) {
                setErrorMessage(error.message);
            }
        };
    }, []);
    return {
        errorMessage: errorMessage,
        generalVerificationCodeErrorHandlers: generalVerificationCodeErrorHandlers,
        clearErrorMessage: function() {
            setErrorMessage("");
        }
    };
};
var $d0114fbc9b03e9e6$export$2e2bcd8739ae039 = $d0114fbc9b03e9e6$var$useGeneralVerificationCodeErrorHandler;






var $kVN77 = parcelRequire("kVN77");




var $60e25f5671dbbdd7$export$7ba9b85da6ef21b1;
(function(IdentifierErrorType) {
    IdentifierErrorType["IdentifierNotExist"] = "IdentifierNotExist";
    IdentifierErrorType["IdentifierAlreadyExists"] = "IdentifierAlreadyExists";
})($60e25f5671dbbdd7$export$7ba9b85da6ef21b1 || ($60e25f5671dbbdd7$export$7ba9b85da6ef21b1 = {}));
var $60e25f5671dbbdd7$var$useIdentifierErrorAlert = function() {
    var show = (0, $06e76e0bce8bb876$export$753980156bc86c10)().show;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    // Have to wrap up in a useCallback hook otherwise the handler updates on every cycle
    return (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(errorType, method, value) {
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            show({
                                type: "alert",
                                ModalContent: t(errorType === $60e25f5671dbbdd7$export$7ba9b85da6ef21b1.IdentifierAlreadyExists ? "description.create_account_id_exists_alert" : "description.sign_in_id_does_not_exist_alert", {
                                    type: t("description.".concat(method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? "email" : "phone_number")),
                                    value: method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone ? (0, $f9ff7d4c659fed5c$export$79abe912f70ec8f5)(value) : value
                                }),
                                cancelText: "action.change",
                                cancelTextI18nProps: {
                                    method: t("description.".concat(method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? "email" : "phone_number"))
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        navigate(-1);
                        return [
                            2
                        ];
                }
            });
        });
        return function(errorType, method, value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        navigate,
        show,
        t
    ]);
};
var $60e25f5671dbbdd7$export$2e2bcd8739ae039 = $60e25f5671dbbdd7$var$useIdentifierErrorAlert;







var $kVN77 = parcelRequire("kVN77");







var $kVN77 = parcelRequire("kVN77");




var $e52b5ee306848237$var$useLinkSocial = function() {
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var asyncLinkWithSocial = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$75b0bae8270ba103));
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    return (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(connectorId) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            asyncLinkWithSocial(connectorId)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(connectorId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncLinkWithSocial,
        handleError,
        redirectTo
    ]);
};
var $e52b5ee306848237$export$2e2bcd8739ae039 = $e52b5ee306848237$var$useLinkSocial;



var $902a3f634e19f572$var$useLinkSocialConfirmModal = function() {
    var show = (0, $06e76e0bce8bb876$export$753980156bc86c10)().show;
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var linkWithSocial = (0, $e52b5ee306848237$export$2e2bcd8739ae039)();
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    return (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(method, target, connectorId) {
            var _ref, confirm;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            show({
                                confirmText: "action.bind_and_continue",
                                cancelText: "action.change",
                                cancelTextI18nProps: {
                                    method: t("description.".concat(method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? "email" : "phone_number"))
                                },
                                ModalContent: t("description.link_account_id_exists", {
                                    type: t("description.".concat(method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? "email" : "phone_number")),
                                    value: method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone ? (0, $f9ff7d4c659fed5c$export$79abe912f70ec8f5)(target) : target
                                })
                            })
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            1
                        ]), confirm = _ref[0];
                        if (!confirm) {
                            navigate(-1);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            linkWithSocial(connectorId)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(method, target, connectorId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        linkWithSocial,
        navigate,
        show,
        t
    ]);
};
var $902a3f634e19f572$export$2e2bcd8739ae039 = $902a3f634e19f572$var$useLinkSocialConfirmModal;


var $e8263884d45e74cf$var$useContinueFlowCodeVerification = function(_method, target, errorCallback) {
    var _useSearchParams = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $d03cd69b331d3258$export$f1a78c17382fe22a)(), 1), searchParameters = _useSearchParams[0];
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var verifyVerificationCode = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$1f2cf4d85f14ded7));
    var _useGeneralVerificationCodeErrorHandler = (0, $d0114fbc9b03e9e6$export$2e2bcd8739ae039)(), generalVerificationCodeErrorHandlers = _useGeneralVerificationCodeErrorHandler.generalVerificationCodeErrorHandlers, errorMessage = _useGeneralVerificationCodeErrorHandler.errorMessage, clearErrorMessage = _useGeneralVerificationCodeErrorHandler.clearErrorMessage;
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)({
        replace: true
    });
    var showIdentifierErrorAlert = (0, $60e25f5671dbbdd7$export$2e2bcd8739ae039)();
    var showLinkSocialConfirmModal = (0, $902a3f634e19f572$export$2e2bcd8739ae039)();
    var identifierExistErrorHandler = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(method, target) {
            var linkSocial;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        linkSocial = searchParameters.get((0, $14a274f0b6caba9a$export$c4eb3ba4f04fab5).LinkSocial);
                        if (!linkSocial) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            showLinkSocialConfirmModal(method, target, linkSocial)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        return [
                            4,
                            showIdentifierErrorAlert((0, $60e25f5671dbbdd7$export$7ba9b85da6ef21b1).IdentifierAlreadyExists, method, target)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(method, target) {
            return _ref.apply(this, arguments);
        };
    }(), [
        searchParameters,
        showIdentifierErrorAlert,
        showLinkSocialConfirmModal
    ]);
    var verifyVerificationCodeErrorHandlers = (0, $kVN77.useMemo)(function() {
        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            "user.phone_already_in_use": /*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                    return [
                        2,
                        identifierExistErrorHandler((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone, target)
                    ];
                });
            }),
            "user.email_already_in_use": /*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                    return [
                        2,
                        identifierExistErrorHandler((0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email, target)
                    ];
                });
            })
        }, preSignInErrorHandler, generalVerificationCodeErrorHandlers);
    }, [
        preSignInErrorHandler,
        generalVerificationCodeErrorHandlers,
        identifierExistErrorHandler,
        target
    ]);
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            verifyVerificationCode(payload)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, verifyVerificationCodeErrorHandlers)
                        ];
                    case 2:
                        _state.sent();
                        errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback();
                        return [
                            2
                        ];
                    case 3:
                        if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(payload) {
            return _ref.apply(this, arguments);
        };
    }(), [
        errorCallback,
        handleError,
        redirectTo,
        verifyVerificationCode,
        verifyVerificationCodeErrorHandlers
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $e8263884d45e74cf$export$2e2bcd8739ae039 = $e8263884d45e74cf$var$useContinueFlowCodeVerification;







var $kVN77 = parcelRequire("kVN77");







var $b080d7e6c56a78a0$var$useForgotPasswordFlowCodeVerification = function(method, target, errorCallback) {
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var verifyVerificationCode = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$df60c504f9d9103e));
    var _useGeneralVerificationCodeErrorHandler = (0, $d0114fbc9b03e9e6$export$2e2bcd8739ae039)(), generalVerificationCodeErrorHandlers = _useGeneralVerificationCodeErrorHandler.generalVerificationCodeErrorHandlers, errorMessage = _useGeneralVerificationCodeErrorHandler.errorMessage, clearErrorMessage = _useGeneralVerificationCodeErrorHandler.clearErrorMessage;
    var identifierErrorHandler = (0, $60e25f5671dbbdd7$export$2e2bcd8739ae039)();
    var errorHandlers = (0, $kVN77.useMemo)(function() {
        return (0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            "user.user_not_exist": /*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                    return [
                        2,
                        identifierErrorHandler((0, $60e25f5671dbbdd7$export$7ba9b85da6ef21b1).IdentifierNotExist, method, target)
                    ];
                });
            }),
            "user.new_password_required_in_profile": function() {
                navigate("/".concat((0, $14a274f0b6caba9a$export$12e44e23ec720850).ForgotPassword, "/reset"), {
                    replace: true
                });
            }
        }, generalVerificationCodeErrorHandlers);
    }, [
        generalVerificationCodeErrorHandlers,
        identifierErrorHandler,
        method,
        target,
        navigate
    ]);
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            verifyVerificationCode(payload)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, errorHandlers)
                        ];
                    case 2:
                        _state.sent();
                        errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback();
                        return [
                            2
                        ];
                    case 3:
                        if (result) navigate("/".concat((0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn), {
                            replace: true
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(payload) {
            return _ref.apply(this, arguments);
        };
    }(), [
        errorCallback,
        errorHandlers,
        handleError,
        navigate,
        verifyVerificationCode
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $b080d7e6c56a78a0$export$2e2bcd8739ae039 = $b080d7e6c56a78a0$var$useForgotPasswordFlowCodeVerification;









var $kVN77 = parcelRequire("kVN77");












var $e0e9db394a20a0fb$var$useRegisterFlowCodeVerification = function(method, target, errorCallback) {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var show = (0, $06e76e0bce8bb876$export$753980156bc86c10)().show;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var signInMode = (0, $41e7159e4ecba97c$export$317715a729435b35)().signInMode;
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var signInWithIdentifierAsync = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$85e251dbbdeeea73));
    var verifyVerificationCode = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$1f2cf4d85f14ded7));
    var _useGeneralVerificationCodeErrorHandler = (0, $d0114fbc9b03e9e6$export$2e2bcd8739ae039)(), errorMessage = _useGeneralVerificationCodeErrorHandler.errorMessage, clearErrorMessage = _useGeneralVerificationCodeErrorHandler.clearErrorMessage, generalVerificationCodeErrorHandlers = _useGeneralVerificationCodeErrorHandler.generalVerificationCodeErrorHandlers;
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)({
        replace: true
    });
    var showIdentifierErrorAlert = (0, $60e25f5671dbbdd7$export$2e2bcd8739ae039)();
    var identifierExistErrorHandler = (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var _ref, confirm, _ref1, error, result;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Should not redirect user to sign-in if is register-only mode
                    if (signInMode === (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).Register) {
                        showIdentifierErrorAlert((0, $60e25f5671dbbdd7$export$7ba9b85da6ef21b1).IdentifierAlreadyExists, method, target);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        show({
                            confirmText: "action.sign_in",
                            ModalContent: t("description.create_account_id_exists", {
                                type: t("description.".concat(method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? "email" : "phone_number")),
                                value: method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone ? (0, $f9ff7d4c659fed5c$export$79abe912f70ec8f5)(target) : target
                            })
                        })
                    ];
                case 1:
                    _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                        _state.sent(),
                        1
                    ]), confirm = _ref[0];
                    if (!confirm) {
                        navigate(-1);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        signInWithIdentifierAsync()
                    ];
                case 2:
                    _ref1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                        _state.sent(),
                        2
                    ]), error = _ref1[0], result = _ref1[1];
                    if (!error) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        handleError(error, preSignInErrorHandler)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
                case 4:
                    if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                    return [
                        2
                    ];
            }
        });
    }), [
        handleError,
        method,
        navigate,
        preSignInErrorHandler,
        redirectTo,
        show,
        showIdentifierErrorAlert,
        signInMode,
        signInWithIdentifierAsync,
        t,
        target
    ]);
    var errorHandlers = (0, $kVN77.useMemo)(function() {
        return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            "user.email_already_in_use": identifierExistErrorHandler,
            "user.phone_already_in_use": identifierExistErrorHandler
        }, generalVerificationCodeErrorHandlers, preSignInErrorHandler), {
            callback: errorCallback
        });
    }, [
        identifierExistErrorHandler,
        generalVerificationCodeErrorHandlers,
        preSignInErrorHandler,
        errorCallback
    ]);
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            verifyVerificationCode(payload)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, errorHandlers)
                        ];
                    case 2:
                        _state.sent();
                        errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback();
                        return [
                            2
                        ];
                    case 3:
                        if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(payload) {
            return _ref.apply(this, arguments);
        };
    }(), [
        errorCallback,
        errorHandlers,
        handleError,
        redirectTo,
        verifyVerificationCode
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $e0e9db394a20a0fb$export$2e2bcd8739ae039 = $e0e9db394a20a0fb$var$useRegisterFlowCodeVerification;









var $kVN77 = parcelRequire("kVN77");












var $d31d5bd7d6ef79eb$var$useSignInFlowCodeVerification = function(method, target, errorCallback) {
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var show = (0, $06e76e0bce8bb876$export$753980156bc86c10)().show;
    var navigate = (0, $1c3a22059b479044$export$9770f232ac06a008)();
    var redirectTo = (0, $74b08314cd062cbb$export$2e2bcd8739ae039)();
    var signInMode = (0, $41e7159e4ecba97c$export$317715a729435b35)().signInMode;
    var handleError = (0, $09dc68536e5e270c$export$2e2bcd8739ae039)();
    var registerWithIdentifierAsync = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$ec172577cee1ef2a));
    var asyncSignInWithVerificationCodeIdentifier = (0, $57790173b1762f43$export$2e2bcd8739ae039)((0, $bc69946dbbb06dd3$export$e01e93c3ae4f0e08));
    var _useGeneralVerificationCodeErrorHandler = (0, $d0114fbc9b03e9e6$export$2e2bcd8739ae039)(), errorMessage = _useGeneralVerificationCodeErrorHandler.errorMessage, clearErrorMessage = _useGeneralVerificationCodeErrorHandler.clearErrorMessage, generalVerificationCodeErrorHandlers = _useGeneralVerificationCodeErrorHandler.generalVerificationCodeErrorHandlers;
    var preSignInErrorHandler = (0, $0c0b1ed8434c67e9$export$2e2bcd8739ae039)({
        replace: true
    });
    var showIdentifierErrorAlert = (0, $60e25f5671dbbdd7$export$2e2bcd8739ae039)();
    var identifierNotExistErrorHandler = (0, $kVN77.useCallback)(/*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
        var _ref, confirm, _ref1, error, result;
        return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Should not redirect user to register if is sign-in only mode or bind social flow
                    if (signInMode === (0, $0adae18f63600c2d$export$f927bbb3d448dc2b).SignIn) {
                        showIdentifierErrorAlert((0, $60e25f5671dbbdd7$export$7ba9b85da6ef21b1).IdentifierNotExist, method, target);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        show({
                            confirmText: "action.create",
                            ModalContent: t("description.sign_in_id_does_not_exist", {
                                type: t("description.".concat(method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? "email" : "phone_number")),
                                value: method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone ? (0, $f9ff7d4c659fed5c$export$79abe912f70ec8f5)(target) : target
                            })
                        })
                    ];
                case 1:
                    _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                        _state.sent(),
                        1
                    ]), confirm = _ref[0];
                    if (!confirm) {
                        navigate(-1);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        registerWithIdentifierAsync(method === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? {
                            email: target
                        } : {
                            phone: target
                        })
                    ];
                case 2:
                    _ref1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                        _state.sent(),
                        2
                    ]), error = _ref1[0], result = _ref1[1];
                    if (!error) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        handleError(error, preSignInErrorHandler)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
                case 4:
                    if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                    return [
                        2
                    ];
            }
        });
    }), [
        signInMode,
        show,
        t,
        method,
        target,
        registerWithIdentifierAsync,
        showIdentifierErrorAlert,
        navigate,
        handleError,
        preSignInErrorHandler,
        redirectTo
    ]);
    var errorHandlers = (0, $kVN77.useMemo)(function() {
        return (0, $671b362f9d9fcab2$export$4fa2f4023c9cbda5)((0, $79de63f6394f39c4$export$581ff339ea0ba762)({
            "user.user_not_exist": identifierNotExistErrorHandler
        }, generalVerificationCodeErrorHandlers, preSignInErrorHandler), {
            callback: errorCallback
        });
    }, [
        errorCallback,
        identifierNotExistErrorHandler,
        preSignInErrorHandler,
        generalVerificationCodeErrorHandlers
    ]);
    var onSubmit = (0, $kVN77.useCallback)(function() {
        var _ref = (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function(payload) {
            var _ref, error, result;
            return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            asyncSignInWithVerificationCodeIdentifier(payload)
                        ];
                    case 1:
                        _ref = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf).apply(void 0, [
                            _state.sent(),
                            2
                        ]), error = _ref[0], result = _ref[1];
                        if (!error) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleError(error, errorHandlers)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        if (result === null || result === void 0 ? void 0 : result.redirectTo) redirectTo(result.redirectTo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(payload) {
            return _ref.apply(this, arguments);
        };
    }(), [
        asyncSignInWithVerificationCodeIdentifier,
        errorHandlers,
        handleError,
        redirectTo
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $d31d5bd7d6ef79eb$export$2e2bcd8739ae039 = $d31d5bd7d6ef79eb$var$useSignInFlowCodeVerification;


var $a46711ab557aab67$var$_obj;
var $a46711ab557aab67$export$31c188ca419e053a = Object.freeze(($a46711ab557aab67$var$_obj = {}, (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($a46711ab557aab67$var$_obj, (0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn, (0, $d31d5bd7d6ef79eb$export$2e2bcd8739ae039)), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($a46711ab557aab67$var$_obj, (0, $14a274f0b6caba9a$export$12e44e23ec720850).Register, (0, $e0e9db394a20a0fb$export$2e2bcd8739ae039)), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($a46711ab557aab67$var$_obj, (0, $14a274f0b6caba9a$export$12e44e23ec720850).ForgotPassword, (0, $b080d7e6c56a78a0$export$2e2bcd8739ae039)), (0, $9907ed469d84fffe$export$1e71eb4bef00f6b0)($a46711ab557aab67$var$_obj, (0, $14a274f0b6caba9a$export$12e44e23ec720850).Continue, (0, $e8263884d45e74cf$export$2e2bcd8739ae039)), $a46711ab557aab67$var$_obj));
var $a46711ab557aab67$export$89feea6263bb6663 = function(flow) {
    return $a46711ab557aab67$export$31c188ca419e053a[flow];
};


var $a19c0627d6ca7fff$var$VerificationCode = function(param) {
    var flow = param.flow, identifier = param.identifier, className = param.className, hasPasswordButton = param.hasPasswordButton, target = param.target;
    var _useState = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $kVN77.useState)([]), 2), code = _useState[0], setCode = _useState[1];
    var t = (0, $700154fdcf4dc05d$export$9fc83ad70ead8663)().t;
    var useVerificationCode = (0, $a46711ab557aab67$export$89feea6263bb6663)(flow);
    var errorCallback = (0, $kVN77.useCallback)(function() {
        setCode([]);
    }, []);
    var _useVerificationCode = useVerificationCode(identifier, target, errorCallback), errorMessage = _useVerificationCode.errorMessage, clearErrorMessage = _useVerificationCode.clearErrorMessage, onSubmit = _useVerificationCode.onSubmit;
    var _useResendVerificationCode = (0, $0c1a74e6c9002f65$export$2e2bcd8739ae039)(flow, identifier, target), seconds = _useResendVerificationCode.seconds, isRunning = _useResendVerificationCode.isRunning, onResendVerificationCode = _useResendVerificationCode.onResendVerificationCode;
    (0, $kVN77.useEffect)(function() {
        if (code.length === (0, $ad155fd3c4be76b7$export$439d7c9fdf7148d2) && code.every(Boolean)) {
            var payload = identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? {
                email: target,
                verificationCode: code.join("")
            } : {
                phone: target,
                verificationCode: code.join("")
            };
            onSubmit(payload);
        }
    }, [
        code,
        identifier,
        onSubmit,
        target
    ]);
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($40d9417b65a80fcc$export$6210fa4921d2a466, className),
        children: [
            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ad155fd3c4be76b7$export$2e2bcd8739ae039), {
                name: "passcode",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adce05c96e8d4258$exports)))($40d9417b65a80fcc$export$6f2f4d5c38fc8e55, errorMessage && $40d9417b65a80fcc$export$60e9e0884ce12b55),
                value: code,
                error: errorMessage,
                onChange: setCode
            }),
            isRunning ? /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("div", {
                className: $40d9417b65a80fcc$export$a8ecead220dd38a6,
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $056babc663998f62$export$8d6a9236f2e3f2ce), {
                    components: {
                        span: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)("span", {}, "counter")
                    },
                    children: t("description.resend_after_seconds", {
                        seconds: seconds
                    })
                })
            }) : /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $4cbbfa6dbb472410$export$2e2bcd8739ae039), {
                className: $40d9417b65a80fcc$export$9c30223ca0a664fb,
                text: "description.resend_passcode",
                onClick: /*#__PURE__*/ (0, $04946c8c10a5ce4e$export$7c398597f8905a1)(function() {
                    return (0, $1a5e16f717d29077$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                clearErrorMessage();
                                return [
                                    4,
                                    onResendVerificationCode()
                                ];
                            case 1:
                                _state.sent();
                                setCode([]);
                                return [
                                    2
                                ];
                        }
                    });
                })
            }),
            flow === (0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn && hasPasswordButton && /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b71cc1ebc2daf8b2$export$2e2bcd8739ae039), {
                method: identifier,
                target: target,
                className: $40d9417b65a80fcc$export$52002a3975269b5d
            })
        ]
    });
};
var $a19c0627d6ca7fff$export$2e2bcd8739ae039 = $a19c0627d6ca7fff$var$VerificationCode;







var $fd151896541ee064$var$VerificationCode = function() {
    var flow = (0, $1c3a22059b479044$export$99eaa27ddbbb95ef)().flow;
    var signInMethods = (0, $41e7159e4ecba97c$export$317715a729435b35)().signInMethods;
    var state = (0, $1c3a22059b479044$export$45d76561a5302f2b)().state;
    var _validate = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(state, (0, $fc4a7cd559bffd34$export$1e0c25ccbe67b008)), 2), identifierState = _validate[1];
    var _validate1 = (0, $21d7c00a954d6239$export$fdf2a89c76341bbf)((0, $9ca557716949399a$export$a22775fa5e2eebd9)(flow, (0, $fc4a7cd559bffd34$export$76ad0037102e2eeb)), 2), useFlow = _validate1[1];
    if (!useFlow) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {});
    if (!identifierState) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    var identifier = identifierState.identifier, value = identifierState.value;
    var methodSettings = signInMethods.find(function(method) {
        return method.identifier === identifier;
    });
    // SignIn Method not enabled
    if (!methodSettings && flow !== (0, $14a274f0b6caba9a$export$12e44e23ec720850).ForgotPassword) return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b5ebb61f0176ceed$export$2e2bcd8739ae039), {
        title: "description.verify_".concat(identifier),
        description: "description.enter_passcode",
        descriptionProps: {
            address: (0, $e55f3bd5a75ab76b$export$625550452a3fa3ec)("description.".concat(identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Email ? "email" : "phone_number")),
            target: identifier === (0, $6ae7ce06f09cd84a$export$f2322d76aef584c7).Phone ? (0, $f9ff7d4c659fed5c$export$79abe912f70ec8f5)(value) : value
        },
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $a19c0627d6ca7fff$export$2e2bcd8739ae039), {
            flow: useFlow,
            identifier: identifier,
            target: value,
            hasPasswordButton: useFlow === (0, $14a274f0b6caba9a$export$12e44e23ec720850).SignIn && (methodSettings === null || methodSettings === void 0 ? void 0 : methodSettings.password)
        })
    });
};
var $fd151896541ee064$export$2e2bcd8739ae039 = $fd151896541ee064$var$VerificationCode;





(0, $9f37205a8c53f1c7$export$24c2f7fddd6751e5)();
var $fb9a6913ad30c8ee$var$App = function() {
    return /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d03cd69b331d3258$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3f272dd8685efc71$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $d8c42a2180dab720$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $68a14edeef3806c5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $3093c4cbf0bc0c38$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$3565eb3d00ca5a74), {
                            children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8da9bb0819deeb08$export$2e2bcd8739ae039), {}),
                                children: [
                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                        path: "springboard",
                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $03c1315f0b2143e0$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                        path: "callback/:connectorId",
                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $283877bb773fa6c0$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                        path: "callback/social/:connectorId",
                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $de337e6a588060ec$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                        path: "direct/:method/:target?",
                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $01cd11d16d713fa3$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ea9c8ef10380da96$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: "unknown-session",
                                                element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {
                                                    message: "error.invalid_session"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.signIn,
                                                children: [
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        index: true,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c64e8fd85122b526$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: "password",
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ddf6e3e20bd91abc$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.register,
                                                children: [
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        index: true,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $437676ab3a84abbd$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: "password",
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $ce2bf3765c4bc72f$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: "forgot-password",
                                                children: [
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        index: true,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1925cbffb3acd848$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: "reset",
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $b6f273c9dfb21c2f$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: ":flow/verification-code",
                                                element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $fd151896541ee064$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaBinding,
                                                children: [
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        index: true,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8a03e523b1241944$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8656a256aed51012$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $2642a14958d25c63$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $a1ff2a8f761137e8$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: (0, $14a274f0b6caba9a$export$6a49be5b3307a2d).MfaVerification,
                                                children: [
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        index: true,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $7f969b52341b251c$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).TOTP,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1d0281dcf13ce627$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).WebAuthn,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $2ffdfdfa07aa3a79$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: (0, $6ae7ce06f09cd84a$export$c62e7669a75c5961).BackupCode,
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $a714acf42399fce0$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: "continue",
                                                children: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                    path: ":method",
                                                    element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $61537c8153769054$export$2e2bcd8739ae039), {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: "social",
                                                children: [
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: "link/:connectorId",
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $6b33a1ba6c520e4d$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: "landing/:connectorId",
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $dfa3f8c75420909a$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsxs)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: (0, $02d5c091c91c4f6f$export$45794d16c9d83fe2).routes.sso,
                                                element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $8da9bb0819deeb08$export$2e2bcd8739ae039), {}),
                                                children: [
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: "email",
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $c67be02a1ee815be$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                        path: "connectors",
                                                        element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $e9ab66f91f9fcd2b$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: "consent",
                                                element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $a32ac716ba310ce9$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $1c3a22059b479044$export$e7b0ac011bb776c6), {
                                                path: "*",
                                                element: /*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $58ebb1359bf01f2d$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
};
var $fb9a6913ad30c8ee$export$2e2bcd8739ae039 = $fb9a6913ad30c8ee$var$App;


var $94c519dbfeb602bb$var$app = document.querySelector("#app");
var $94c519dbfeb602bb$var$root = $94c519dbfeb602bb$var$app && (0, $7f9f21f33879fbd4$export$882461b6382ed46c)($94c519dbfeb602bb$var$app);
(0, (/*@__PURE__*/$parcel$interopDefault($1f4531ebf250f6fa$exports))).setAppElement("#app");
$94c519dbfeb602bb$var$root === null || $94c519dbfeb602bb$var$root === void 0 ? void 0 : $94c519dbfeb602bb$var$root.render(/*#__PURE__*/ (0, $d67ee09f839f930f$exports.jsx)((0, $fb9a6913ad30c8ee$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.288fe91f.js.map
